/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1);
	
	__webpack_require__(5);
	
	__webpack_require__(157);
	
	__webpack_require__(158);
	
	__webpack_require__(159);
	
	__webpack_require__(160);
	
	__webpack_require__(162);
	
	__webpack_require__(164);
	
	__webpack_require__(165);
	
	__webpack_require__(167);
	
	__webpack_require__(168);
	
	__webpack_require__(169);
	
	__webpack_require__(171);
	
	__webpack_require__(172);
	
	__webpack_require__(174);
	
	__webpack_require__(176);
	
	__webpack_require__(177);
	
	__webpack_require__(178);
	
	__webpack_require__(179);
	
	__webpack_require__(180);
	
	__webpack_require__(181);
	
	__webpack_require__(182);
	
	__webpack_require__(189);
	
	__webpack_require__(197);
	
	__webpack_require__(198);
	
	__webpack_require__(199);
	
	__webpack_require__(200);
	
	__webpack_require__(201);
	
	__webpack_require__(202);
	
	__webpack_require__(203);
	
	__webpack_require__(207);
	
	__webpack_require__(211);
	
	__webpack_require__(212);
	
	__webpack_require__(213);
	
	__webpack_require__(221);
	
	__webpack_require__(222);
	
	__webpack_require__(223);
	
	__webpack_require__(224);
	
	__webpack_require__(225);
	
	__webpack_require__(226);
	
	__webpack_require__(227);
	
	__webpack_require__(228);
	
	__webpack_require__(229);
	
	__webpack_require__(230);
	
	__webpack_require__(233);
	
	__webpack_require__(236);
	
	__webpack_require__(239);
	
	__webpack_require__(240);
	
	__webpack_require__(241);
	
	__webpack_require__(244);
	
	__webpack_require__(247);
	
	__webpack_require__(248);
	
	__webpack_require__(251);
	
	__webpack_require__(252);
	
	__webpack_require__(253);
	
	__webpack_require__(254);
	
	__webpack_require__(255);
	
	__webpack_require__(256);
	
	__webpack_require__(257);
	
	__webpack_require__(258);
	
	__webpack_require__(259);
	
	__webpack_require__(260);
	
	__webpack_require__(261);
	
	__webpack_require__(264);
	
	__webpack_require__(265);
	
	__webpack_require__(278);
	
	__webpack_require__(279);

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(6);
	
	__webpack_require__(7);
	
	__webpack_require__(8);
	
	__webpack_require__(9);
	
	__webpack_require__(10);
	
	__webpack_require__(16);
	
	__webpack_require__(18);
	
	__webpack_require__(156);
	
	/*
	 * Licensed to the Apache Software Foundation (ASF) under one or more
	 * contributor license agreements.  See the NOTICE file distributed with
	 * this work for additional information regarding copyright ownership.
	 * The ASF licenses this file to You under the Apache License, Version 2.0
	 * (the "License"); you may not use this file except in compliance with
	 * the License.  You may obtain a copy of the License at
	 *
	 *    http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	var requiredModules = ['ngCookies', 'ngAnimate', 'ngRoute', 'ngSanitize', 'angular-websocket', 'ui.ace', 'ui.bootstrap', 'as.sortable', 'ngTouch', 'ngDragDrop', 'angular.filter', 'monospaced.elastic', 'puElasticInput', 'xeditable', 'ngToast', 'focus-if', 'ngResource', 'ngclipboard', 'angularViewportWatch', 'infinite-scroll', 'ui.grid', 'ui.grid.exporter', 'ui.grid.selection', 'ui.grid.emptyBaseLayer', 'ui.grid.resizeColumns', 'ui.grid.saveState',
	// SILECTIS
	'magpieDisplay', 'jsonFormatter'];
	
	// headroom should not be used for CI, since we have to execute some integration tests.
	// otherwise, they will fail.
	if (true) {
	  requiredModules.push('headroom');
	}
	
	var zeppelinWebApp = angular.module('zeppelinWebApp', requiredModules).filter('breakFilter', function () {
	  return function (text) {
	    // eslint-disable-next-line no-extra-boolean-cast
	    if (!!text) {
	      return text.replace(/\n/g, '<br />');
	    }
	  };
	}).config(["$httpProvider", "$routeProvider", "ngToastProvider", function ($httpProvider, $routeProvider, ngToastProvider) {
	  // withCredentials when running locally via grunt
	  $httpProvider.defaults.withCredentials = true;
	
	  var visBundleLoad = {
	    load: ['heliumService', function (heliumService) {
	      return heliumService.load;
	    }]
	  };
	
	  $routeProvider.when('/', {
	    templateUrl: 'app/home/home.html'
	  }).when('/account', {
	    templateUrl: 'app/account/account.html',
	    controller: 'AccountCtrl'
	  }).when('/clusters', {
	    templateUrl: 'app/clusters/cluster-manager.html',
	    controller: 'ClusterManagerCtrl'
	  }).when('/password-reset/:token', {
	    templateUrl: 'app/password-reset/password-reset.html',
	    controller: 'PasswordResetCtrl',
	    publicAccess: true
	  }).when('/notebook/:noteId', {
	    templateUrl: 'app/notebook/notebook.html',
	    controller: 'NotebookCtrl',
	    resolve: visBundleLoad
	  }).when('/notebook/:noteId/paragraph?=:paragraphId', {
	    templateUrl: 'app/notebook/notebook.html',
	    controller: 'NotebookCtrl',
	    resolve: visBundleLoad
	  }).when('/notebook/:noteId/paragraph/:paragraphId?', {
	    templateUrl: 'app/notebook/notebook.html',
	    controller: 'NotebookCtrl',
	    resolve: visBundleLoad
	  }).when('/notebook/:noteId/revision/:revisionId', {
	    templateUrl: 'app/notebook/notebook.html',
	    controller: 'NotebookCtrl',
	    resolve: visBundleLoad
	  }).when('/interpreter', {
	    templateUrl: 'app/interpreter/interpreter.html',
	    controller: 'InterpreterCtrl',
	    validateAccess: function validateAccess($rootScope) {
	      return $rootScope.hasAnyGlobalRole(['SuperAdmin']);
	    }
	  }).when('/revision-control', {
	    templateUrl: 'app/notebook-repository/notebook-repository.html',
	    controller: 'NotebookRepositoryCtrl',
	    controllerAs: 'noterepo',
	    validateAccess: function validateAccess($rootScope) {
	      return $rootScope.hasMagpieRole('OrganizationAdmin') || $rootScope.hasGlobalRole('SuperAdmin');
	    }
	  }).when('/credential', {
	    templateUrl: 'app/credential/credential.html',
	    controller: 'CredentialCtrl',
	    validateAccess: function validateAccess($rootScope) {
	      return $rootScope.hasGlobalRole('SuperAdmin');
	    }
	  }).when('/helium', {
	    templateUrl: 'app/helium/helium.html',
	    controller: 'HeliumCtrl',
	    validateAccess: function validateAccess($rootScope) {
	      return $rootScope.hasGlobalRole('SuperAdmin');
	    }
	  }).when('/configuration', {
	    templateUrl: 'app/configuration/configuration.html',
	    controller: 'ConfigurationCtrl',
	    validateAccess: function validateAccess($rootScope) {
	      return $rootScope.hasGlobalRole('SuperAdmin');
	    }
	  }).when('/search/:searchTerm', {
	    templateUrl: 'app/search/result-list.html',
	    controller: 'SearchResultCtrl'
	  }).when('/sso/error', {
	    templateUrl: 'app/error/sso-error.html',
	    publicAccess: true
	  }).otherwise({
	    redirectTo: '/'
	  });
	
	  ngToastProvider.configure({
	    dismissButton: true,
	    dismissOnClick: false,
	    combineDuplications: true,
	    timeout: 6000
	  });
	}])
	
	// handle logout on API failure
	.config(["$httpProvider", "$provide", function ($httpProvider, $provide) {
	  if (true) {
	    $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
	  }
	  $provide.factory('httpInterceptor', ["$q", "$rootScope", function ($q, $rootScope) {
	    return {
	      'responseError': function responseError(rejection) {
	        if (rejection.status === 405) {
	          var data = {};
	          data.info = '';
	          $rootScope.$broadcast('session_logout', data);
	        }
	        $rootScope.$broadcast('httpResponseError', rejection);
	        return $q.reject(rejection);
	      }
	    };
	  }]);
	  $httpProvider.interceptors.push('httpInterceptor');
	}]).constant('TRASH_FOLDER_ID', '~Trash');
	
	function auth() {
	  var $http = angular.injector(['ng']).get('$http');
	  var baseUrlSrv = angular.injector(['zeppelinWebApp']).get('baseUrlSrv');
	  angular.injector(['zeppelinWebApp']).get('loaderSrv').hideLoader();
	  // withCredentials when running locally via grunt
	  $http.defaults.withCredentials = true;
	  jQuery.ajaxSetup({
	    dataType: 'json',
	    xhrFields: {
	      withCredentials: true
	    },
	    crossDomain: true
	  });
	  var config =  true ? { headers: { 'X-Requested-With': 'XMLHttpRequest' } } : {};
	  return $http.get(baseUrlSrv.getRestApiBase() + '/security/ticket', config).then(function (response) {
	    zeppelinWebApp.run(["$rootScope", function ($rootScope) {
	      var res = angular.fromJson(response.data).body;
	      if (res['redirectURL']) {
	        window.location.href = res['redirectURL'] + window.location.href;
	      } else {
	        $rootScope.ticket = res;
	        $rootScope.ticket.screenUsername = $rootScope.ticket.principal;
	        if ($rootScope.ticket.principal.indexOf('#Pac4j') === 0) {
	          var re = ', name=(.*?),';
	          $rootScope.ticket.screenUsername = $rootScope.ticket.principal.match(re)[1];
	        }
	      }
	    }]);
	  }, function (errorResponse) {
	    // Handle error case
	    var redirect = errorResponse.headers('Location');
	    if (errorResponse.status === 401 && redirect !== undefined && redirect !== null) {
	      // Handle page redirect
	      window.location.href = redirect;
	    }
	  });
	}
	
	function bootstrapApplication() {
	  zeppelinWebApp.run(["$rootScope", "$location", "$http", "baseUrlSrv", function ($rootScope, $location, $http, baseUrlSrv) {
	    // get magpie config
	    $rootScope.magpieConfig = {};
	    $http.get(baseUrlSrv.getRestApiBase() + '/magpie/config').then(function (response) {
	      $rootScope.magpieConfig = response.data;
	      $rootScope.$broadcast('magpieConfig');
	    });
	
	    // SILECTIS -> detecting whether the user has a role
	    $rootScope.hasRole = function (role) {
	      if (!$rootScope.parsedRoles) {
	        if ($rootScope.ticket && $rootScope.ticket.roles) {
	          $rootScope.parsedRoles = JSON.parse($rootScope.ticket.roles);
	        }
	      }
	
	      if ($rootScope.parsedRoles) {
	        var roles = JSON.parse($rootScope.ticket.roles);
	        return roles.indexOf(role) > -1;
	      } else {
	        return false;
	      }
	    };
	
	    $rootScope.hasGlobalRole = function (role) {
	      return $rootScope.hasRole('global.' + role);
	    };
	    $rootScope.hasMagpieRole = function (role) {
	      return $rootScope.hasRole('magpie.' + role);
	    };
	
	    $rootScope.hasAnyRole = function (roles) {
	      return _.some(roles, $rootScope.hasRole);
	    };
	    $rootScope.hasAnyGlobalRole = function (roles) {
	      return _.some(roles, $rootScope.hasGlobalRole);
	    };
	    $rootScope.hasAnyMagpieRole = function (roles) {
	      return _.some(roles, $rootScope.hasMagpieRole);
	    };
	
	    $rootScope.$on('$routeChangeStart', function (event, next, current) {
	      $rootScope.pageTitle = 'Silectis | Magpie';
	      if (next.$$route && (next.$$route.originalPath === '/' || next.$$route.redirectTo === '/')) {
	        /* Do not do anything.  This use case is when the user puts the root url in the browser
	           ie. magpie.silect.is and it gets redirected to magpie.silect.is/#/.  Two calls will be made
	           to this $on function for that scenario.  The first call will be for the redirectTo '/' value
	           and the second will be the originalPath value of '/'.  We want to have this step
	           so that subsequent else if statement are easier to read. */
	      } else if (!$rootScope.ticket && next.$$route && !next.$$route.publicAccess) {
	        /* Here we want to rebuild the url as a ref query param so that we can redirect
	           back to the page after the user successfully logins. */
	        var ref = next.$$route.originalPath.split('/').map(function (p) {
	          if (!next.params[p.replace(':', '')]) {
	            return p;
	          } else {
	            return next.params[p.replace(':', '')];
	          }
	        }).join('/');
	
	        $location.replaceState('/', 'ref=' + ref);
	      } else if (next.$$route && next.$$route.validateAccess && !next.$$route.validateAccess($rootScope)) {
	        // has an access validation function and the function returned false
	        $location.path('/');
	      }
	    });
	  }]);
	  angular.bootstrap(document, ['zeppelinWebApp']);
	}
	
	angular.element(document).ready(function () {
	  auth().then(bootstrapApplication);
	});

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	(function() {
	var define = false;
	var exports = false;
	
	/*!
	 * headroom.js v0.12.0 - Give your page some headroom. Hide your header until you need it
	 * Copyright (c) 2020 Nick Williams - http://wicky.nillia.ms/headroom.js
	 * License: MIT
	 */
	
	(function (global, factory) {
	  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global = global || self, global.Headroom = factory());
	}(this, function () { 'use strict';
	
	  function isBrowser() {
	    return typeof window !== "undefined";
	  }
	
	  /**
	   * Used to detect browser support for adding an event listener with options
	   * Credit: https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
	   */
	  function passiveEventsSupported() {
	    var supported = false;
	
	    try {
	      var options = {
	        // eslint-disable-next-line getter-return
	        get passive() {
	          supported = true;
	        }
	      };
	      window.addEventListener("test", options, options);
	      window.removeEventListener("test", options, options);
	    } catch (err) {
	      supported = false;
	    }
	
	    return supported;
	  }
	
	  function isSupported() {
	    return !!(
	      isBrowser() &&
	      function() {}.bind &&
	      "classList" in document.documentElement &&
	      Object.assign &&
	      Object.keys &&
	      requestAnimationFrame
	    );
	  }
	
	  function isDocument(obj) {
	    return obj.nodeType === 9; // Node.DOCUMENT_NODE === 9
	  }
	
	  function isWindow(obj) {
	    // `obj === window` or `obj instanceof Window` is not sufficient,
	    // as the obj may be the window of an iframe.
	    return obj && obj.document && isDocument(obj.document);
	  }
	
	  function windowScroller(win) {
	    var doc = win.document;
	    var body = doc.body;
	    var html = doc.documentElement;
	
	    return {
	      /**
	       * @see http://james.padolsey.com/javascript/get-document-height-cross-browser/
	       * @return {Number} the scroll height of the document in pixels
	       */
	      scrollHeight: function() {
	        return Math.max(
	          body.scrollHeight,
	          html.scrollHeight,
	          body.offsetHeight,
	          html.offsetHeight,
	          body.clientHeight,
	          html.clientHeight
	        );
	      },
	
	      /**
	       * @see http://andylangton.co.uk/blog/development/get-viewport-size-width-and-height-javascript
	       * @return {Number} the height of the viewport in pixels
	       */
	      height: function() {
	        return win.innerHeight || html.clientHeight || body.clientHeight;
	      },
	
	      /**
	       * Gets the Y scroll position
	       * @return {Number} pixels the page has scrolled along the Y-axis
	       */
	      scrollY: function() {
	        if (win.pageYOffset !== undefined) {
	          return win.pageYOffset;
	        }
	
	        return (html || body.parentNode || body).scrollTop;
	      }
	    };
	  }
	
	  function elementScroller(element) {
	    return {
	      /**
	       * @return {Number} the scroll height of the element in pixels
	       */
	      scrollHeight: function() {
	        return Math.max(
	          element.scrollHeight,
	          element.offsetHeight,
	          element.clientHeight
	        );
	      },
	
	      /**
	       * @return {Number} the height of the element in pixels
	       */
	      height: function() {
	        return Math.max(element.offsetHeight, element.clientHeight);
	      },
	
	      /**
	       * Gets the Y scroll position
	       * @return {Number} pixels the element has scrolled along the Y-axis
	       */
	      scrollY: function() {
	        return element.scrollTop;
	      }
	    };
	  }
	
	  function createScroller(element) {
	    return isWindow(element) ? windowScroller(element) : elementScroller(element);
	  }
	
	  /**
	   * @param element EventTarget
	   */
	  function trackScroll(element, options, callback) {
	    var isPassiveSupported = passiveEventsSupported();
	    var rafId;
	    var scrolled = false;
	    var scroller = createScroller(element);
	    var lastScrollY = scroller.scrollY();
	    var details = {};
	
	    function update() {
	      var scrollY = Math.round(scroller.scrollY());
	      var height = scroller.height();
	      var scrollHeight = scroller.scrollHeight();
	
	      // reuse object for less memory churn
	      details.scrollY = scrollY;
	      details.lastScrollY = lastScrollY;
	      details.direction = scrollY > lastScrollY ? "down" : "up";
	      details.distance = Math.abs(scrollY - lastScrollY);
	      details.isOutOfBounds = scrollY < 0 || scrollY + height > scrollHeight;
	      details.top = scrollY <= options.offset[details.direction];
	      details.bottom = scrollY + height >= scrollHeight;
	      details.toleranceExceeded =
	        details.distance > options.tolerance[details.direction];
	
	      callback(details);
	
	      lastScrollY = scrollY;
	      scrolled = false;
	    }
	
	    function handleScroll() {
	      if (!scrolled) {
	        scrolled = true;
	        rafId = requestAnimationFrame(update);
	      }
	    }
	
	    var eventOptions = isPassiveSupported
	      ? { passive: true, capture: false }
	      : false;
	
	    element.addEventListener("scroll", handleScroll, eventOptions);
	    update();
	
	    return {
	      destroy: function() {
	        cancelAnimationFrame(rafId);
	        element.removeEventListener("scroll", handleScroll, eventOptions);
	      }
	    };
	  }
	
	  function normalizeUpDown(t) {
	    return t === Object(t) ? t : { down: t, up: t };
	  }
	
	  /**
	   * UI enhancement for fixed headers.
	   * Hides header when scrolling down
	   * Shows header when scrolling up
	   * @constructor
	   * @param {DOMElement} elem the header element
	   * @param {Object} options options for the widget
	   */
	  function Headroom(elem, options) {
	    options = options || {};
	    Object.assign(this, Headroom.options, options);
	    this.classes = Object.assign({}, Headroom.options.classes, options.classes);
	
	    this.elem = elem;
	    this.tolerance = normalizeUpDown(this.tolerance);
	    this.offset = normalizeUpDown(this.offset);
	    this.initialised = false;
	    this.frozen = false;
	  }
	  Headroom.prototype = {
	    constructor: Headroom,
	
	    /**
	     * Start listening to scrolling
	     * @public
	     */
	    init: function() {
	      if (Headroom.cutsTheMustard && !this.initialised) {
	        this.addClass("initial");
	        this.initialised = true;
	
	        // defer event registration to handle browser
	        // potentially restoring previous scroll position
	        setTimeout(
	          function(self) {
	            self.scrollTracker = trackScroll(
	              self.scroller,
	              { offset: self.offset, tolerance: self.tolerance },
	              self.update.bind(self)
	            );
	          },
	          100,
	          this
	        );
	      }
	
	      return this;
	    },
	
	    /**
	     * Destroy the widget, clearing up after itself
	     * @public
	     */
	    destroy: function() {
	      this.initialised = false;
	      Object.keys(this.classes).forEach(this.removeClass, this);
	      this.scrollTracker.destroy();
	    },
	
	    /**
	     * Unpin the element
	     * @public
	     */
	    unpin: function() {
	      if (this.hasClass("pinned") || !this.hasClass("unpinned")) {
	        this.addClass("unpinned");
	        this.removeClass("pinned");
	
	        if (this.onUnpin) {
	          this.onUnpin.call(this);
	        }
	      }
	    },
	
	    /**
	     * Pin the element
	     * @public
	     */
	    pin: function() {
	      if (this.hasClass("unpinned")) {
	        this.addClass("pinned");
	        this.removeClass("unpinned");
	
	        if (this.onPin) {
	          this.onPin.call(this);
	        }
	      }
	    },
	
	    /**
	     * Freezes the current state of the widget
	     * @public
	     */
	    freeze: function() {
	      this.frozen = true;
	      this.addClass("frozen");
	    },
	
	    /**
	     * Re-enables the default behaviour of the widget
	     * @public
	     */
	    unfreeze: function() {
	      this.frozen = false;
	      this.removeClass("frozen");
	    },
	
	    top: function() {
	      if (!this.hasClass("top")) {
	        this.addClass("top");
	        this.removeClass("notTop");
	
	        if (this.onTop) {
	          this.onTop.call(this);
	        }
	      }
	    },
	
	    notTop: function() {
	      if (!this.hasClass("notTop")) {
	        this.addClass("notTop");
	        this.removeClass("top");
	
	        if (this.onNotTop) {
	          this.onNotTop.call(this);
	        }
	      }
	    },
	
	    bottom: function() {
	      if (!this.hasClass("bottom")) {
	        this.addClass("bottom");
	        this.removeClass("notBottom");
	
	        if (this.onBottom) {
	          this.onBottom.call(this);
	        }
	      }
	    },
	
	    notBottom: function() {
	      if (!this.hasClass("notBottom")) {
	        this.addClass("notBottom");
	        this.removeClass("bottom");
	
	        if (this.onNotBottom) {
	          this.onNotBottom.call(this);
	        }
	      }
	    },
	
	    shouldUnpin: function(details) {
	      var scrollingDown = details.direction === "down";
	
	      return scrollingDown && !details.top && details.toleranceExceeded;
	    },
	
	    shouldPin: function(details) {
	      var scrollingUp = details.direction === "up";
	
	      return (scrollingUp && details.toleranceExceeded) || details.top;
	    },
	
	    addClass: function(className) {
	      this.elem.classList.add.apply(
	        this.elem.classList,
	        this.classes[className].split(" ")
	      );
	    },
	
	    removeClass: function(className) {
	      this.elem.classList.remove.apply(
	        this.elem.classList,
	        this.classes[className].split(" ")
	      );
	    },
	
	    hasClass: function(className) {
	      return this.classes[className].split(" ").every(function(cls) {
	        return this.classList.contains(cls);
	      }, this.elem);
	    },
	
	    update: function(details) {
	      if (details.isOutOfBounds) {
	        // Ignore bouncy scrolling in OSX
	        return;
	      }
	
	      if (this.frozen === true) {
	        return;
	      }
	
	      if (details.top) {
	        this.top();
	      } else {
	        this.notTop();
	      }
	
	      if (details.bottom) {
	        this.bottom();
	      } else {
	        this.notBottom();
	      }
	
	      if (this.shouldUnpin(details)) {
	        this.unpin();
	      } else if (this.shouldPin(details)) {
	        this.pin();
	      }
	    }
	  };
	
	  /**
	   * Default options
	   * @type {Object}
	   */
	  Headroom.options = {
	    tolerance: {
	      up: 0,
	      down: 0
	    },
	    offset: 0,
	    scroller: isBrowser() ? window : null,
	    classes: {
	      frozen: "headroom--frozen",
	      pinned: "headroom--pinned",
	      unpinned: "headroom--unpinned",
	      top: "headroom--top",
	      notTop: "headroom--not-top",
	      bottom: "headroom--bottom",
	      notBottom: "headroom--not-bottom",
	      initial: "headroom"
	    }
	  };
	
	  Headroom.cutsTheMustard = isSupported();
	
	  return Headroom;
	
	}));
	
	}.call(window));

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	/*!
	 * headroom.js v0.9.4 - Give your page some headroom. Hide your header until you need it
	 * Copyright (c) 2017 Nick Williams - http://wicky.nillia.ms/headroom.js
	 * License: MIT
	 */
	
	(function(angular, Headroom) {
	  if (!angular) {
	    return;
	  }
	
	  function headroom(HeadroomService) {
	    return {
	      scope: {
	        tolerance: "=",
	        offset: "=",
	        classes: "=",
	        scroller: "@"
	      },
	      link: function($scope, $element) {
	        var options = {};
	        var opts = HeadroomService.options;
	        for (var prop in opts) {
	          options[prop] = $scope[prop] || opts[prop];
	        }
	        if ($scope.scroller) {
	          options.scroller = document.querySelector($scope.scroller);
	        }
	        var headroom = new HeadroomService($element[0], options).init();
	        $scope.$on("$destroy", function() {
	          headroom.destroy();
	        });
	      }
	    };
	  }
	
	  headroom.$inject = ["HeadroomService"];
	
	  function HeadroomService() {
	    return Headroom;
	  }
	
	  angular
	    .module("headroom", [])
	    .directive("headroom", headroom)
	    .factory("HeadroomService", HeadroomService);
	})(window.angular, window.Headroom);


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define("scrollMonitor",[],e):"object"==typeof exports?exports.scrollMonitor=e():t.scrollMonitor=e()}(this,function(){return function(t){function e(o){if(i[o])return i[o].exports;var s=i[o]={exports:{},id:o,loaded:!1};return t[o].call(s.exports,s,s.exports,e),s.loaded=!0,s.exports}var i={};return e.m=t,e.c=i,e.p="",e(0)}([function(t,e,i){"use strict";var o=i(1),s=o.isInBrowser,n=i(2),r=new n(s?document.body:null);r.setStateFromDOM(null),r.listenToDOM(),s&&(window.scrollMonitor=r),t.exports=r},function(t,e){"use strict";e.VISIBILITYCHANGE="visibilityChange",e.ENTERVIEWPORT="enterViewport",e.FULLYENTERVIEWPORT="fullyEnterViewport",e.EXITVIEWPORT="exitViewport",e.PARTIALLYEXITVIEWPORT="partiallyExitViewport",e.LOCATIONCHANGE="locationChange",e.STATECHANGE="stateChange",e.eventTypes=[e.VISIBILITYCHANGE,e.ENTERVIEWPORT,e.FULLYENTERVIEWPORT,e.EXITVIEWPORT,e.PARTIALLYEXITVIEWPORT,e.LOCATIONCHANGE,e.STATECHANGE],e.isOnServer="undefined"==typeof window,e.isInBrowser=!e.isOnServer,e.defaultOffsets={top:0,bottom:0}},function(t,e,i){"use strict";function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function s(t){return c?0:t===document.body?window.innerHeight||document.documentElement.clientHeight:t.clientHeight}function n(t){return c?0:t===document.body?Math.max(document.body.scrollHeight,document.documentElement.scrollHeight,document.body.offsetHeight,document.documentElement.offsetHeight,document.documentElement.clientHeight):t.scrollHeight}function r(t){return c?0:t===document.body?window.pageYOffset||document.documentElement&&document.documentElement.scrollTop||document.body.scrollTop:t.scrollTop}var h=i(1),c=h.isOnServer,a=h.isInBrowser,l=h.eventTypes,p=i(3),u=!1;if(a)try{var w=Object.defineProperty({},"passive",{get:function(){u=!0}});window.addEventListener("test",null,w)}catch(t){}var d=!!u&&{capture:!1,passive:!0},f=function(){function t(e,i){function h(){if(a.viewportTop=r(e),a.viewportBottom=a.viewportTop+a.viewportHeight,a.documentHeight=n(e),a.documentHeight!==p){for(u=a.watchers.length;u--;)a.watchers[u].recalculateLocation();p=a.documentHeight}}function c(){for(w=a.watchers.length;w--;)a.watchers[w].update();for(w=a.watchers.length;w--;)a.watchers[w].triggerCallbacks()}o(this,t);var a=this;this.item=e,this.watchers=[],this.viewportTop=null,this.viewportBottom=null,this.documentHeight=n(e),this.viewportHeight=s(e),this.DOMListener=function(){t.prototype.DOMListener.apply(a,arguments)},this.eventTypes=l,i&&(this.containerWatcher=i.create(e));var p,u,w;this.update=function(){h(),c()},this.recalculateLocations=function(){this.documentHeight=0,this.update()}}return t.prototype.listenToDOM=function(){a&&(window.addEventListener?(this.item===document.body?window.addEventListener("scroll",this.DOMListener,d):this.item.addEventListener("scroll",this.DOMListener,d),window.addEventListener("resize",this.DOMListener)):(this.item===document.body?window.attachEvent("onscroll",this.DOMListener):this.item.attachEvent("onscroll",this.DOMListener),window.attachEvent("onresize",this.DOMListener)),this.destroy=function(){window.addEventListener?(this.item===document.body?(window.removeEventListener("scroll",this.DOMListener,d),this.containerWatcher.destroy()):this.item.removeEventListener("scroll",this.DOMListener,d),window.removeEventListener("resize",this.DOMListener)):(this.item===document.body?(window.detachEvent("onscroll",this.DOMListener),this.containerWatcher.destroy()):this.item.detachEvent("onscroll",this.DOMListener),window.detachEvent("onresize",this.DOMListener))})},t.prototype.destroy=function(){},t.prototype.DOMListener=function(t){this.setStateFromDOM(t)},t.prototype.setStateFromDOM=function(t){var e=r(this.item),i=s(this.item),o=n(this.item);this.setState(e,i,o,t)},t.prototype.setState=function(t,e,i,o){var s=e!==this.viewportHeight||i!==this.contentHeight;if(this.latestEvent=o,this.viewportTop=t,this.viewportHeight=e,this.viewportBottom=t+e,this.contentHeight=i,s)for(var n=this.watchers.length;n--;)this.watchers[n].recalculateLocation();this.updateAndTriggerWatchers(o)},t.prototype.updateAndTriggerWatchers=function(t){for(var e=this.watchers.length;e--;)this.watchers[e].update();for(e=this.watchers.length;e--;)this.watchers[e].triggerCallbacks(t)},t.prototype.createCustomContainer=function(){return new t},t.prototype.createContainer=function(e){"string"==typeof e?e=document.querySelector(e):e&&e.length>0&&(e=e[0]);var i=new t(e,this);return i.setStateFromDOM(),i.listenToDOM(),i},t.prototype.create=function(t,e){"string"==typeof t?t=document.querySelector(t):t&&t.length>0&&(t=t[0]);var i=new p(this,t,e);return this.watchers.push(i),i},t.prototype.beget=function(t,e){return this.create(t,e)},t}();t.exports=f},function(t,e,i){"use strict";function o(t,e,i){function o(t,e){if(0!==t.length)for(E=t.length;E--;)y=t[E],y.callback.call(s,e,s),y.isOne&&t.splice(E,1)}var s=this;this.watchItem=e,this.container=t,i?i===+i?this.offsets={top:i,bottom:i}:this.offsets={top:i.top||w.top,bottom:i.bottom||w.bottom}:this.offsets=w,this.callbacks={};for(var d=0,f=u.length;d<f;d++)s.callbacks[u[d]]=[];this.locked=!1;var m,v,b,I,E,y;this.triggerCallbacks=function(t){switch(this.isInViewport&&!m&&o(this.callbacks[r],t),this.isFullyInViewport&&!v&&o(this.callbacks[h],t),this.isAboveViewport!==b&&this.isBelowViewport!==I&&(o(this.callbacks[n],t),v||this.isFullyInViewport||(o(this.callbacks[h],t),o(this.callbacks[a],t)),m||this.isInViewport||(o(this.callbacks[r],t),o(this.callbacks[c],t))),!this.isFullyInViewport&&v&&o(this.callbacks[a],t),!this.isInViewport&&m&&o(this.callbacks[c],t),this.isInViewport!==m&&o(this.callbacks[n],t),!0){case m!==this.isInViewport:case v!==this.isFullyInViewport:case b!==this.isAboveViewport:case I!==this.isBelowViewport:o(this.callbacks[p],t)}m=this.isInViewport,v=this.isFullyInViewport,b=this.isAboveViewport,I=this.isBelowViewport},this.recalculateLocation=function(){if(!this.locked){var t=this.top,e=this.bottom;if(this.watchItem.nodeName){var i=this.watchItem.style.display;"none"===i&&(this.watchItem.style.display="");for(var s=0,n=this.container;n.containerWatcher;)s+=n.containerWatcher.top-n.containerWatcher.container.viewportTop,n=n.containerWatcher.container;var r=this.watchItem.getBoundingClientRect();this.top=r.top+this.container.viewportTop-s,this.bottom=r.bottom+this.container.viewportTop-s,"none"===i&&(this.watchItem.style.display=i)}else this.watchItem===+this.watchItem?this.watchItem>0?this.top=this.bottom=this.watchItem:this.top=this.bottom=this.container.documentHeight-this.watchItem:(this.top=this.watchItem.top,this.bottom=this.watchItem.bottom);this.top-=this.offsets.top,this.bottom+=this.offsets.bottom,this.height=this.bottom-this.top,void 0===t&&void 0===e||this.top===t&&this.bottom===e||o(this.callbacks[l],null)}},this.recalculateLocation(),this.update(),m=this.isInViewport,v=this.isFullyInViewport,b=this.isAboveViewport,I=this.isBelowViewport}var s=i(1),n=s.VISIBILITYCHANGE,r=s.ENTERVIEWPORT,h=s.FULLYENTERVIEWPORT,c=s.EXITVIEWPORT,a=s.PARTIALLYEXITVIEWPORT,l=s.LOCATIONCHANGE,p=s.STATECHANGE,u=s.eventTypes,w=s.defaultOffsets;o.prototype={on:function(t,e,i){switch(!0){case t===n&&!this.isInViewport&&this.isAboveViewport:case t===r&&this.isInViewport:case t===h&&this.isFullyInViewport:case t===c&&this.isAboveViewport&&!this.isInViewport:case t===a&&this.isInViewport&&this.isAboveViewport:if(e.call(this,this.container.latestEvent,this),i)return}if(!this.callbacks[t])throw new Error("Tried to add a scroll monitor listener of type "+t+". Your options are: "+u.join(", "));this.callbacks[t].push({callback:e,isOne:i||!1})},off:function(t,e){if(!this.callbacks[t])throw new Error("Tried to remove a scroll monitor listener of type "+t+". Your options are: "+u.join(", "));for(var i,o=0;i=this.callbacks[t][o];o++)if(i.callback===e){this.callbacks[t].splice(o,1);break}},one:function(t,e){this.on(t,e,!0)},recalculateSize:function(){this.height=this.watchItem.offsetHeight+this.offsets.top+this.offsets.bottom,this.bottom=this.top+this.height},update:function(){this.isAboveViewport=this.top<this.container.viewportTop,this.isBelowViewport=this.bottom>this.container.viewportBottom,this.isInViewport=this.top<this.container.viewportBottom&&this.bottom>this.container.viewportTop,this.isFullyInViewport=this.top>=this.container.viewportTop&&this.bottom<=this.container.viewportBottom||this.isAboveViewport&&this.isBelowViewport},destroy:function(){var t=this.container.watchers.indexOf(this),e=this;this.container.watchers.splice(t,1);for(var i=0,o=u.length;i<o;i++)e.callbacks[u[i]].length=0},lock:function(){this.locked=!0},unlock:function(){this.locked=!1}};for(var d=function(t){return function(e,i){this.on.call(this,t,e,i)}},f=0,m=u.length;f<m;f++){var v=u[f];o.prototype[v]=d(v)}t.exports=o}])});
	//# sourceMappingURL=scrollMonitor.js.map

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	"use strict";
	
	(function() {
	    viewportWatch.$inject = [ "scrollMonitor", "$timeout" ];
	    function viewportWatch(scrollMonitor, $timeout) {
	        var viewportUpdateTimeout;
	        function debouncedViewportUpdate() {
	            $timeout.cancel(viewportUpdateTimeout);
	            viewportUpdateTimeout = $timeout(function() {
	                scrollMonitor.update();
	            }, 10);
	        }
	        return {
	            restrict: "AE",
	            link: function(scope, element, attr) {
	                var elementWatcher = scrollMonitor.create(element, scope.$eval(attr.viewportWatch || "0"));
	                function watchDuringDisable() {
	                    this.$$watchersBackup = this.$$watchersBackup || [];
	                    this.$$watchers = this.$$watchersBackup;
	                    var unwatch = this.constructor.prototype.$watch.apply(this, arguments);
	                    this.$$watchers = null;
	                    return unwatch;
	                }
	                function toggleWatchers(scope, enable) {
	                    var digest, current, next = scope;
	                    do {
	                        current = next;
	                        if (enable) {
	                            if (current.hasOwnProperty("$$watchersBackup")) {
	                                current.$$watchers = current.$$watchersBackup;
	                                delete current.$$watchersBackup;
	                                delete current.$watch;
	                                digest = !scope.$root.$$phase;
	                            }
	                        } else {
	                            if (!current.hasOwnProperty("$$watchersBackup")) {
	                                current.$$watchersBackup = current.$$watchers;
	                                current.$$watchers = null;
	                                current.$watch = watchDuringDisable;
	                            }
	                        }
	                        next = current.$$childHead;
	                        while (!next && current !== scope) {
	                            if (current.$$nextSibling) {
	                                next = current.$$nextSibling;
	                            } else {
	                                current = current.$parent;
	                            }
	                        }
	                    } while (next);
	                    if (digest) {
	                        scope.$digest();
	                    }
	                }
	                function disableDigest() {
	                    toggleWatchers(scope, false);
	                }
	                function enableDigest() {
	                    toggleWatchers(scope, true);
	                }
	                if (!elementWatcher.isInViewport) {
	                    scope.$evalAsync(disableDigest);
	                    debouncedViewportUpdate();
	                }
	                elementWatcher.enterViewport(enableDigest);
	                elementWatcher.exitViewport(disableDigest);
	                scope.$on("toggleWatchers", function(event, enable) {
	                    toggleWatchers(scope, enable);
	                });
	                scope.$on("$destroy", function() {
	                    elementWatcher.destroy();
	                    debouncedViewportUpdate();
	                });
	            }
	        };
	    }
	    angular.module("angularViewportWatch", []).directive("viewportWatch", viewportWatch).value("scrollMonitor", window.scrollMonitor);
	})();

/***/ }),
/* 10 */
1,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(17);
	module.exports = 'ui.grid';


/***/ }),
/* 17 */
/***/ (function(module, exports) {

	/*!
	 * ui-grid - v4.4.6 - 2018-04-06
	 * Copyright (c) 2018 ; License: MIT 
	 */
	
	(function () {
	  'use strict';
	  angular.module('ui.grid.i18n', []);
	  angular.module('ui.grid', ['ui.grid.i18n']);
	})();
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc object
	   * @name ui.grid.service:uiGridConstants
	   * @description Constants for use across many grid features
	   *
	   */
	
	
	  angular.module('ui.grid').constant('uiGridConstants', {
	    LOG_DEBUG_MESSAGES: true,
	    LOG_WARN_MESSAGES: true,
	    LOG_ERROR_MESSAGES: true,
	    CUSTOM_FILTERS: /CUSTOM_FILTERS/g,
	    COL_FIELD: /COL_FIELD/g,
	    MODEL_COL_FIELD: /MODEL_COL_FIELD/g,
	    TOOLTIP: /title=\"TOOLTIP\"/g,
	    DISPLAY_CELL_TEMPLATE: /DISPLAY_CELL_TEMPLATE/g,
	    TEMPLATE_REGEXP: /<.+>/,
	    FUNC_REGEXP: /(\([^)]*\))?$/,
	    DOT_REGEXP: /\./g,
	    APOS_REGEXP: /'/g,
	    BRACKET_REGEXP: /^(.*)((?:\s*\[\s*\d+\s*\]\s*)|(?:\s*\[\s*"(?:[^"\\]|\\.)*"\s*\]\s*)|(?:\s*\[\s*'(?:[^'\\]|\\.)*'\s*\]\s*))(.*)$/,
	    COL_CLASS_PREFIX: 'ui-grid-col',
	    ENTITY_BINDING: '$$this',
	    events: {
	      GRID_SCROLL: 'uiGridScroll',
	      COLUMN_MENU_SHOWN: 'uiGridColMenuShown',
	      ITEM_DRAGGING: 'uiGridItemDragStart', // For any item being dragged
	      COLUMN_HEADER_CLICK: 'uiGridColumnHeaderClick'
	    },
	    // copied from http://www.lsauer.com/2011/08/javascript-keymap-keycodes-in-json.html
	    keymap: {
	      TAB: 9,
	      STRG: 17,
	      CAPSLOCK: 20,
	      CTRL: 17,
	      CTRLRIGHT: 18,
	      CTRLR: 18,
	      SHIFT: 16,
	      RETURN: 13,
	      ENTER: 13,
	      BACKSPACE: 8,
	      BCKSP: 8,
	      ALT: 18,
	      ALTR: 17,
	      ALTRIGHT: 17,
	      SPACE: 32,
	      WIN: 91,
	      MAC: 91,
	      FN: null,
	      PG_UP: 33,
	      PG_DOWN: 34,
	      UP: 38,
	      DOWN: 40,
	      LEFT: 37,
	      RIGHT: 39,
	      ESC: 27,
	      DEL: 46,
	      F1: 112,
	      F2: 113,
	      F3: 114,
	      F4: 115,
	      F5: 116,
	      F6: 117,
	      F7: 118,
	      F8: 119,
	      F9: 120,
	      F10: 121,
	      F11: 122,
	      F12: 123
	    },
	     /**
	     * @ngdoc object
	     * @name ASC
	     * @propertyOf ui.grid.service:uiGridConstants
	     * @description Used in {@link ui.grid.class:GridOptions.columnDef#properties_sort columnDef.sort} and
	     * {@link ui.grid.class:GridOptions.columnDef#properties_sortDirectionCycle columnDef.sortDirectionCycle}
	     * to configure the sorting direction of the column
	     */
	    ASC: 'asc',
	     /**
	     * @ngdoc object
	     * @name DESC
	     * @propertyOf ui.grid.service:uiGridConstants
	     * @description Used in {@link ui.grid.class:GridOptions.columnDef#properties_sort columnDef.sort} and
	     * {@link ui.grid.class:GridOptions.columnDef#properties_sortDirectionCycle columnDef.sortDirectionCycle}
	     * to configure the sorting direction of the column
	     */
	    DESC: 'desc',
	
	
	     /**
	     * @ngdoc object
	     * @name filter
	     * @propertyOf ui.grid.service:uiGridConstants
	     * @description Used in {@link ui.grid.class:GridOptions.columnDef#properties_filter columnDef.filter}
	     * to configure filtering on the column
	     *
	     * `SELECT` and `INPUT` are used with the `type` property of the filter, the rest are used to specify
	     * one of the built-in conditions.
	     *
	     * Available `condition` options are:
	     * - `uiGridConstants.filter.STARTS_WITH`
	     * - `uiGridConstants.filter.ENDS_WITH`
	     * - `uiGridConstants.filter.CONTAINS`
	     * - `uiGridConstants.filter.GREATER_THAN`
	     * - `uiGridConstants.filter.GREATER_THAN_OR_EQUAL`
	     * - `uiGridConstants.filter.LESS_THAN`
	     * - `uiGridConstants.filter.LESS_THAN_OR_EQUAL`
	     * - `uiGridConstants.filter.NOT_EQUAL`
	     *
	     *
	     * Available `type` options are:
	     * - `uiGridConstants.filter.SELECT` - use a dropdown box for the cell header filter field
	     * - `uiGridConstants.filter.INPUT` - use a text box for the cell header filter field
	     */
	    filter: {
	      STARTS_WITH: 2,
	      ENDS_WITH: 4,
	      EXACT: 8,
	      CONTAINS: 16,
	      GREATER_THAN: 32,
	      GREATER_THAN_OR_EQUAL: 64,
	      LESS_THAN: 128,
	      LESS_THAN_OR_EQUAL: 256,
	      NOT_EQUAL: 512,
	      SELECT: 'select',
	      INPUT: 'input'
	    },
	
	    /**
	     * @ngdoc object
	     * @name aggregationTypes
	     * @propertyOf ui.grid.service:uiGridConstants
	     * @description Used in {@link ui.grid.class:GridOptions.columnDef#properties_aggregationType columnDef.aggregationType}
	     * to specify the type of built-in aggregation the column should use.
	     *
	     * Available options are:
	     * - `uiGridConstants.aggregationTypes.sum` - add the values in this column to produce the aggregated value
	     * - `uiGridConstants.aggregationTypes.count` - count the number of rows to produce the aggregated value
	     * - `uiGridConstants.aggregationTypes.avg` - average the values in this column to produce the aggregated value
	     * - `uiGridConstants.aggregationTypes.min` - use the minimum value in this column as the aggregated value
	     * - `uiGridConstants.aggregationTypes.max` - use the maximum value in this column as the aggregated value
	     */
	    aggregationTypes: {
	      sum: 2,
	      count: 4,
	      avg: 8,
	      min: 16,
	      max: 32
	    },
	
	    /**
	     * @ngdoc array
	     * @name CURRENCY_SYMBOLS
	     * @propertyOf ui.grid.service:uiGridConstants
	     * @description A list of all presently circulating currency symbols that was copied from
	     * https://en.wikipedia.org/wiki/Currency_symbol#List_of_presently-circulating_currency_symbols
	     *
	     * Can be used on {@link ui.grid.class:rowSorter} to create a number string regex that ignores currency symbols.
	     */
	    CURRENCY_SYMBOLS: ['¤', '؋', 'Ar', 'Ƀ', '฿', 'B/.', 'Br', 'Bs.', 'Bs.F.', 'GH₵', '¢', 'c', 'Ch.', '₡', 'C$', 'D', 'ден',
	      'دج', '.د.ب', 'د.ع', 'JD', 'د.ك', 'ل.د', 'дин', 'د.ت', 'د.م.', 'د.إ', 'Db', '$', '₫', 'Esc', '€', 'ƒ', 'Ft', 'FBu',
	      'FCFA', 'CFA', 'Fr', 'FRw', 'G', 'gr', '₲', 'h', '₴', '₭', 'Kč', 'kr', 'kn', 'MK', 'ZK', 'Kz', 'K', 'L', 'Le', 'лв',
	      'E', 'lp', 'M', 'KM', 'MT', '₥', 'Nfk', '₦', 'Nu.', 'UM', 'T$', 'MOP$', '₱', 'Pt.', '£', 'ج.م.', 'LL', 'LS', 'P', 'Q',
	      'q', 'R', 'R$', 'ر.ع.', 'ر.ق', 'ر.س', '៛', 'RM', 'p', 'Rf.', '₹', '₨', 'SRe', 'Rp', '₪', 'Ksh', 'Sh.So.', 'USh', 'S/',
	      'SDR', 'сом', '৳	', 'WS$', '₮', 'VT', '₩', '¥', 'zł'],
	
	    /**
	     * @ngdoc object
	     * @name scrollDirection
	     * @propertyOf ui.grid.service:uiGridConstants
	     * @description Set on {@link ui.grid.class:Grid#properties_scrollDirection Grid.scrollDirection},
	     * to indicate the direction the grid is currently scrolling in
	     *
	     * Available options are:
	     * - `uiGridConstants.scrollDirection.UP` - set when the grid is scrolling up
	     * - `uiGridConstants.scrollDirection.DOWN` - set when the grid is scrolling down
	     * - `uiGridConstants.scrollDirection.LEFT` - set when the grid is scrolling left
	     * - `uiGridConstants.scrollDirection.RIGHT` - set when the grid is scrolling right
	     * - `uiGridConstants.scrollDirection.NONE` - set when the grid is not scrolling, this is the default
	     */
	    scrollDirection: {
	      UP: 'up',
	      DOWN: 'down',
	      LEFT: 'left',
	      RIGHT: 'right',
	      NONE: 'none'
	
	    },
	
	    /**
	     * @ngdoc object
	     * @name dataChange
	     * @propertyOf ui.grid.service:uiGridConstants
	     * @description Used with {@link ui.grid.core.api:PublicApi#methods_notifyDataChange PublicApi.notifyDataChange},
	     * {@link ui.grid.class:Grid#methods_callDataChangeCallbacks Grid.callDataChangeCallbacks},
	     * and {@link ui.grid.class:Grid#methods_registerDataChangeCallback Grid.registerDataChangeCallback}
	     * to specify the type of the event(s).
	     *
	     * Available options are:
	     * - `uiGridConstants.dataChange.ALL` - listeners fired on any of these events, fires listeners on all events.
	     * - `uiGridConstants.dataChange.EDIT` - fired when the data in a cell is edited
	     * - `uiGridConstants.dataChange.ROW` - fired when a row is added or removed
	     * - `uiGridConstants.dataChange.COLUMN` - fired when the column definitions are modified
	     * - `uiGridConstants.dataChange.OPTIONS` - fired when the grid options are modified
	     */
	    dataChange: {
	      ALL: 'all',
	      EDIT: 'edit',
	      ROW: 'row',
	      COLUMN: 'column',
	      OPTIONS: 'options'
	    },
	
	    /**
	     * @ngdoc object
	     * @name scrollbars
	     * @propertyOf ui.grid.service:uiGridConstants
	     * @description Used with {@link ui.grid.class:GridOptions#properties_enableHorizontalScrollbar GridOptions.enableHorizontalScrollbar}
	     * and {@link ui.grid.class:GridOptions#properties_enableVerticalScrollbar GridOptions.enableVerticalScrollbar}
	     * to specify the scrollbar policy for that direction.
	     *
	     * Available options are:
	     * - `uiGridConstants.scrollbars.NEVER` - never show scrollbars in this direction
	     * - `uiGridConstants.scrollbars.ALWAYS` - always show scrollbars in this direction
	     * - `uiGridConstants.scrollbars.WHEN_NEEDED` - shows scrollbars in this direction when needed
	     */
	
	    scrollbars: {
	      NEVER: 0,
	      ALWAYS: 1,
	      WHEN_NEEDED: 2
	    }
	  });
	
	})();
	
	angular.module('ui.grid').directive('uiGridCell', ['$compile', '$parse', 'gridUtil', 'uiGridConstants', function ($compile, $parse, gridUtil, uiGridConstants) {
	  var uiGridCell = {
	    priority: 0,
	    scope: false,
	    require: '?^uiGrid',
	    compile: function() {
	      return {
	        pre: function($scope, $elm, $attrs, uiGridCtrl) {
	          function compileTemplate() {
	            var compiledElementFn = $scope.col.compiledElementFn;
	
	            compiledElementFn($scope, function(clonedElement, scope) {
	              $elm.append(clonedElement);
	            });
	          }
	
	          // If the grid controller is present, use it to get the compiled cell template function
	          if (uiGridCtrl && $scope.col.compiledElementFn) {
	             compileTemplate();
	          }
	          // No controller, compile the element manually (for unit tests)
	          else {
	            if ( uiGridCtrl && !$scope.col.compiledElementFn ){
	              // gridUtil.logError('Render has been called before precompile.  Please log a ui-grid issue');  
	
	              $scope.col.getCompiledElementFn()
	                .then(function (compiledElementFn) {
	                  compiledElementFn($scope, function(clonedElement, scope) {
	                    $elm.append(clonedElement);
	                  });
	                }).catch(angular.noop);
	            }
	            else {
	              var html = $scope.col.cellTemplate
	                .replace(uiGridConstants.MODEL_COL_FIELD, 'row.entity.' + gridUtil.preEval($scope.col.field))
	                .replace(uiGridConstants.COL_FIELD, 'grid.getCellValue(row, col)');
	
	              var cellElement = $compile(html)($scope);
	              $elm.append(cellElement);
	            }
	          }
	        },
	        post: function($scope, $elm, $attrs, uiGridCtrl) {
	          var initColClass = $scope.col.getColClass(false);
	          $elm.addClass(initColClass);
	
	          var classAdded;
	          var updateClass = function( grid ){
	            var contents = $elm;
	            if ( classAdded ){
	              contents.removeClass( classAdded );
	              classAdded = null;
	            }
	
	            if (angular.isFunction($scope.col.cellClass)) {
	              classAdded = $scope.col.cellClass($scope.grid, $scope.row, $scope.col, $scope.rowRenderIndex, $scope.colRenderIndex);
	            }
	            else {
	              classAdded = $scope.col.cellClass;
	            }
	            contents.addClass(classAdded);
	          };
	
	          if ($scope.col.cellClass) {
	            updateClass();
	          }
	          
	          // Register a data change watch that would get triggered whenever someone edits a cell or modifies column defs
	          var dataChangeDereg = $scope.grid.registerDataChangeCallback( updateClass, [uiGridConstants.dataChange.COLUMN, uiGridConstants.dataChange.EDIT]);
	          
	          // watch the col and row to see if they change - which would indicate that we've scrolled or sorted or otherwise
	          // changed the row/col that this cell relates to, and we need to re-evaluate cell classes and maybe other things
	          var cellChangeFunction = function( n, o ){
	            if ( n !== o ) {
	              if ( classAdded || $scope.col.cellClass ){
	                updateClass();
	              }
	
	              // See if the column's internal class has changed
	              var newColClass = $scope.col.getColClass(false);
	              if (newColClass !== initColClass) {
	                $elm.removeClass(initColClass);
	                $elm.addClass(newColClass);
	                initColClass = newColClass;
	              }
	            }
	          };
	
	          // TODO(c0bra): Turn this into a deep array watch
	/*        shouldn't be needed any more given track by col.name
	          var colWatchDereg = $scope.$watch( 'col', cellChangeFunction );
	*/
	          var rowWatchDereg = $scope.$watch( 'row', cellChangeFunction );
	          
	          
	          var deregisterFunction = function() {
	            dataChangeDereg();
	//            colWatchDereg();
	            rowWatchDereg(); 
	          };
	          
	          $scope.$on( '$destroy', deregisterFunction );
	          $elm.on( '$destroy', deregisterFunction );
	        }
	      };
	    }
	  };
	
	  return uiGridCell;
	}]);
	
	
	(function(){
	
	angular.module('ui.grid')
	.service('uiGridColumnMenuService', [ 'i18nService', 'uiGridConstants', 'gridUtil',
	function ( i18nService, uiGridConstants, gridUtil ) {
	/**
	 *  @ngdoc service
	 *  @name ui.grid.service:uiGridColumnMenuService
	 *
	 *  @description Services for working with column menus, factored out
	 *  to make the code easier to understand
	 */
	
	  var service = {
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:uiGridColumnMenuService
	     * @name initialize
	     * @description  Sets defaults, puts a reference to the $scope on
	     * the uiGridController
	     * @param {$scope} $scope the $scope from the uiGridColumnMenu
	     * @param {controller} uiGridCtrl the uiGridController for the grid
	     * we're on
	     *
	     */
	    initialize: function( $scope, uiGridCtrl ){
	      $scope.grid = uiGridCtrl.grid;
	
	      // Store a reference to this link/controller in the main uiGrid controller
	      // to allow showMenu later
	      uiGridCtrl.columnMenuScope = $scope;
	
	      // Save whether we're shown or not so the columns can check
	      $scope.menuShown = false;
	    },
	
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:uiGridColumnMenuService
	     * @name setColMenuItemWatch
	     * @description  Setup a watch on $scope.col.menuItems, and update
	     * menuItems based on this.  $scope.col needs to be set by the column
	     * before calling the menu.
	     * @param {$scope} $scope the $scope from the uiGridColumnMenu
	     * @param {controller} uiGridCtrl the uiGridController for the grid
	     * we're on
	     *
	     */
	    setColMenuItemWatch: function ( $scope ){
	      var deregFunction = $scope.$watch('col.menuItems', function (n) {
	        if (typeof(n) !== 'undefined' && n && angular.isArray(n)) {
	          n.forEach(function (item) {
	            if (typeof(item.context) === 'undefined' || !item.context) {
	              item.context = {};
	            }
	            item.context.col = $scope.col;
	          });
	
	          $scope.menuItems = $scope.defaultMenuItems.concat(n);
	        }
	        else {
	          $scope.menuItems = $scope.defaultMenuItems;
	        }
	      });
	
	      $scope.$on( '$destroy', deregFunction );
	    },
	
	
	    /**
	     * @ngdoc boolean
	     * @name enableSorting
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description (optional) True by default. When enabled, this setting adds sort
	     * widgets to the column header, allowing sorting of the data in the individual column.
	     */
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:uiGridColumnMenuService
	     * @name sortable
	     * @description  determines whether this column is sortable
	     * @param {$scope} $scope the $scope from the uiGridColumnMenu
	     *
	     */
	    sortable: function( $scope ) {
	      if ( $scope.grid.options.enableSorting && typeof($scope.col) !== 'undefined' && $scope.col && $scope.col.enableSorting) {
	        return true;
	      }
	      else {
	        return false;
	      }
	    },
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:uiGridColumnMenuService
	     * @name isActiveSort
	     * @description  determines whether the requested sort direction is current active, to
	     * allow highlighting in the menu
	     * @param {$scope} $scope the $scope from the uiGridColumnMenu
	     * @param {string} direction the direction that we'd have selected for us to be active
	     *
	     */
	    isActiveSort: function( $scope, direction ){
	      return (typeof($scope.col) !== 'undefined' && typeof($scope.col.sort) !== 'undefined' &&
	              typeof($scope.col.sort.direction) !== 'undefined' && $scope.col.sort.direction === direction);
	
	    },
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:uiGridColumnMenuService
	     * @name suppressRemoveSort
	     * @description  determines whether we should suppress the removeSort option
	     * @param {$scope} $scope the $scope from the uiGridColumnMenu
	     *
	     */
	    suppressRemoveSort: function( $scope ) {
	      if ($scope.col && $scope.col.suppressRemoveSort) {
	        return true;
	      }
	      else {
	        return false;
	      }
	    },
	
	
	    /**
	     * @ngdoc boolean
	     * @name enableHiding
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description (optional) True by default. When set to false, this setting prevents a user from hiding the column
	     * using the column menu or the grid menu.
	     */
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:uiGridColumnMenuService
	     * @name hideable
	     * @description  determines whether a column can be hidden, by checking the enableHiding columnDef option
	     * @param {$scope} $scope the $scope from the uiGridColumnMenu
	     *
	     */
	    hideable: function( $scope ) {
	      if (typeof($scope.col) !== 'undefined' && $scope.col && $scope.col.colDef && $scope.col.colDef.enableHiding === false ) {
	        return false;
	      }
	      else {
	        return true;
	      }
	    },
	
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:uiGridColumnMenuService
	     * @name getDefaultMenuItems
	     * @description  returns the default menu items for a column menu
	     * @param {$scope} $scope the $scope from the uiGridColumnMenu
	     *
	     */
	    getDefaultMenuItems: function( $scope ){
	      return [
	        {
	          title: function(){return i18nService.getSafeText('sort.ascending');},
	          icon: 'ui-grid-icon-sort-alt-up',
	          action: function($event) {
	            $event.stopPropagation();
	            $scope.sortColumn($event, uiGridConstants.ASC);
	          },
	          shown: function () {
	            return service.sortable( $scope );
	          },
	          active: function() {
	            return service.isActiveSort( $scope, uiGridConstants.ASC);
	          }
	        },
	        {
	          title: function(){return i18nService.getSafeText('sort.descending');},
	          icon: 'ui-grid-icon-sort-alt-down',
	          action: function($event) {
	            $event.stopPropagation();
	            $scope.sortColumn($event, uiGridConstants.DESC);
	          },
	          shown: function() {
	            return service.sortable( $scope );
	          },
	          active: function() {
	            return service.isActiveSort( $scope, uiGridConstants.DESC);
	          }
	        },
	        {
	          title: function(){return i18nService.getSafeText('sort.remove');},
	          icon: 'ui-grid-icon-cancel',
	          action: function ($event) {
	            $event.stopPropagation();
	            $scope.unsortColumn();
	          },
	          shown: function() {
	            return service.sortable( $scope ) &&
	                   typeof($scope.col) !== 'undefined' && (typeof($scope.col.sort) !== 'undefined' &&
	                   typeof($scope.col.sort.direction) !== 'undefined') && $scope.col.sort.direction !== null &&
	                  !service.suppressRemoveSort( $scope );
	          }
	        },
	        {
	          title: function(){return i18nService.getSafeText('column.hide');},
	          icon: 'ui-grid-icon-cancel',
	          shown: function() {
	            return service.hideable( $scope );
	          },
	          action: function ($event) {
	            $event.stopPropagation();
	            $scope.hideColumn();
	          }
	        }
	      ];
	    },
	
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:uiGridColumnMenuService
	     * @name getColumnElementPosition
	     * @description  gets the position information needed to place the column
	     * menu below the column header
	     * @param {$scope} $scope the $scope from the uiGridColumnMenu
	     * @param {GridCol} column the column we want to position below
	     * @param {element} $columnElement the column element we want to position below
	     * @returns {hash} containing left, top, offset, height, width
	     *
	     */
	    getColumnElementPosition: function( $scope, column, $columnElement ){
	      var positionData = {};
	      positionData.left = $columnElement[0].offsetLeft;
	      positionData.top = $columnElement[0].offsetTop;
	      positionData.parentLeft = $columnElement[0].offsetParent.offsetLeft;
	
	      // Get the grid scrollLeft
	      positionData.offset = 0;
	      if (column.grid.options.offsetLeft) {
	        positionData.offset = column.grid.options.offsetLeft;
	      }
	
	      positionData.height = gridUtil.elementHeight($columnElement, true);
	      positionData.width = gridUtil.elementWidth($columnElement, true);
	
	      return positionData;
	    },
	
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:uiGridColumnMenuService
	     * @name repositionMenu
	     * @description  Reposition the menu below the new column.  If the menu has no child nodes
	     * (i.e. it's not currently visible) then we guess it's width at 100, we'll be called again
	     * later to fix it
	     * @param {$scope} $scope the $scope from the uiGridColumnMenu
	     * @param {GridCol} column the column we want to position below
	     * @param {hash} positionData a hash containing left, top, offset, height, width
	     * @param {element} $elm the column menu element that we want to reposition
	     * @param {element} $columnElement the column element that we want to reposition underneath
	     *
	     */
	    repositionMenu: function( $scope, column, positionData, $elm, $columnElement ) {
	      var menu = $elm[0].querySelectorAll('.ui-grid-menu');
	
	      // It's possible that the render container of the column we're attaching to is
	      // offset from the grid (i.e. pinned containers), we need to get the difference in the offsetLeft
	      // between the render container and the grid
	      var renderContainerElm = gridUtil.closestElm($columnElement, '.ui-grid-render-container');
	      var renderContainerOffset = renderContainerElm.getBoundingClientRect().left - $scope.grid.element[0].getBoundingClientRect().left;
	
	      var containerScrollLeft = renderContainerElm.querySelectorAll('.ui-grid-viewport')[0].scrollLeft;
	
	      // repositionMenu is now always called after it's visible in the DOM,
	      // allowing us to simply get the width every time the menu is opened
	      var myWidth = gridUtil.elementWidth(menu, true);
	      var paddingRight = column.lastMenuPaddingRight ? column.lastMenuPaddingRight : ( $scope.lastMenuPaddingRight ? $scope.lastMenuPaddingRight : 10);
	
	      if ( menu.length !== 0 ){
	        var mid = menu[0].querySelectorAll('.ui-grid-menu-mid');
	        if ( mid.length !== 0 ) {
	          // TODO(c0bra): use padding-left/padding-right based on document direction (ltr/rtl), place menu on proper side
	          // Get the column menu right padding
	          paddingRight = parseInt(gridUtil.getStyles(angular.element(menu)[0])['paddingRight'], 10);
	          $scope.lastMenuPaddingRight = paddingRight;
	          column.lastMenuPaddingRight = paddingRight;
	        }
	      }
	
	      var left = positionData.left + renderContainerOffset - containerScrollLeft + positionData.parentLeft + positionData.width + paddingRight;
	
	      if (left < positionData.offset + myWidth) {
	        left = Math.max(positionData.left - containerScrollLeft + positionData.parentLeft - paddingRight + myWidth, positionData.offset + myWidth);
	      }
	
	      $elm.css('left', left + 'px');
	      $elm.css('top', (positionData.top + positionData.height) + 'px');
	    }
	
	  };
	
	  return service;
	}])
	
	
	.directive('uiGridColumnMenu', ['$timeout', 'gridUtil', 'uiGridConstants', 'uiGridColumnMenuService', '$document',
	function ($timeout, gridUtil, uiGridConstants, uiGridColumnMenuService, $document) {
	/**
	 * @ngdoc directive
	 * @name ui.grid.directive:uiGridColumnMenu
	 * @description  Provides the column menu framework, leverages uiGridMenu underneath
	 *
	 */
	
	  var uiGridColumnMenu = {
	    priority: 0,
	    scope: true,
	    require: '^uiGrid',
	    templateUrl: 'ui-grid/uiGridColumnMenu',
	    replace: true,
	    link: function ($scope, $elm, $attrs, uiGridCtrl) {
	      uiGridColumnMenuService.initialize( $scope, uiGridCtrl );
	
	      $scope.defaultMenuItems = uiGridColumnMenuService.getDefaultMenuItems( $scope );
	
	      // Set the menu items for use with the column menu. The user can later add additional items via the watch
	      $scope.menuItems = $scope.defaultMenuItems;
	      uiGridColumnMenuService.setColMenuItemWatch( $scope );
	
	
	      /**
	       * @ngdoc method
	       * @methodOf ui.grid.directive:uiGridColumnMenu
	       * @name showMenu
	       * @description Shows the column menu.  If the menu is already displayed it
	       * calls the menu to ask it to hide (it will animate), then it repositions the menu
	       * to the right place whilst hidden (it will make an assumption on menu width),
	       * then it asks the menu to show (it will animate), then it repositions the menu again
	       * once we can calculate it's size.
	       * @param {GridCol} column the column we want to position below
	       * @param {element} $columnElement the column element we want to position below
	       */
	      $scope.showMenu = function(column, $columnElement, event) {
	        // Swap to this column
	        $scope.col = column;
	
	        // Get the position information for the column element
	        var colElementPosition = uiGridColumnMenuService.getColumnElementPosition( $scope, column, $columnElement );
	
	        if ($scope.menuShown) {
	          // we want to hide, then reposition, then show, but we want to wait for animations
	          // we set a variable, and then rely on the menu-hidden event to call the reposition and show
	          $scope.colElement = $columnElement;
	          $scope.colElementPosition = colElementPosition;
	          $scope.hideThenShow = true;
	
	          $scope.$broadcast('hide-menu', { originalEvent: event });
	        } else {
	          $scope.menuShown = true;
	
	          $scope.colElement = $columnElement;
	          $scope.colElementPosition = colElementPosition;
	          $scope.$broadcast('show-menu', { originalEvent: event });
	
	        }
	      };
	
	
	      /**
	       * @ngdoc method
	       * @methodOf ui.grid.directive:uiGridColumnMenu
	       * @name hideMenu
	       * @description Hides the column menu.
	       * @param {boolean} broadcastTrigger true if we were triggered by a broadcast
	       * from the menu itself - in which case don't broadcast again as we'll get
	       * an infinite loop
	       */
	      $scope.hideMenu = function( broadcastTrigger ) {
	        $scope.menuShown = false;
	        if ( !broadcastTrigger ){
	          $scope.$broadcast('hide-menu');
	        }
	      };
	
	
	      $scope.$on('menu-hidden', function() {
	        var menuItems = angular.element($elm[0].querySelector('.ui-grid-menu-items'))[0];
	
	        $elm[0].removeAttribute('style');
	
	        if ( $scope.hideThenShow ){
	          delete $scope.hideThenShow;
	
	          $scope.$broadcast('show-menu');
	
	          $scope.menuShown = true;
	        } else {
	          $scope.hideMenu( true );
	
	          if ($scope.col) {
	            //Focus on the menu button
	            gridUtil.focus.bySelector($document, '.ui-grid-header-cell.' + $scope.col.getColClass()+ ' .ui-grid-column-menu-button', $scope.col.grid, false);
	          }
	        }
	
	        if (menuItems) {
	          menuItems.onkeydown = null;
	          angular.forEach(menuItems.children, function removeHandlers(item) {
	            item.onkeydown = null;
	          });
	        }
	      });
	
	      $scope.$on('menu-shown', function() {
	        $timeout( function() {
	          uiGridColumnMenuService.repositionMenu( $scope, $scope.col, $scope.colElementPosition, $elm, $scope.colElement );
	
	          //automatically set the focus to the first button element in the now open menu.
	          gridUtil.focus.bySelector($document, '.ui-grid-menu-items .ui-grid-menu-item:not(.ng-hide)', true);
	          delete $scope.colElementPosition;
	          delete $scope.columnElement;
	          addKeydownHandlersToMenu();
	        });
	      });
	
	
	      /* Column methods */
	      $scope.sortColumn = function (event, dir) {
	        event.stopPropagation();
	
	        $scope.grid.sortColumn($scope.col, dir, true)
	          .then(function () {
	            $scope.grid.refresh();
	            $scope.hideMenu();
	          }).catch(angular.noop);
	      };
	
	      $scope.unsortColumn = function () {
	        $scope.col.unsort();
	
	        $scope.grid.refresh();
	        $scope.hideMenu();
	      };
	
	      function addKeydownHandlersToMenu() {
	        var menu = angular.element($elm[0].querySelector('.ui-grid-menu-items'))[0],
	          menuItems,
	          visibleMenuItems = [];
	
	        if (menu) {
	          menu.onkeydown = function closeMenu(event) {
	            if (event.keyCode === uiGridConstants.keymap.ESC) {
	              event.preventDefault();
	              $scope.hideMenu();
	            }
	          };
	
	          menuItems = menu.querySelectorAll('.ui-grid-menu-item:not(.ng-hide)');
	          angular.forEach(menuItems, function filterVisibleItems(item) {
	            if (item.offsetParent !== null) {
	              this.push(item);
	            }
	          }, visibleMenuItems);
	
	          if (visibleMenuItems.length) {
	            if (visibleMenuItems.length === 1) {
	              visibleMenuItems[0].onkeydown = function singleItemHandler(event) {
	                circularFocusHandler(event, true);
	              };
	            } else {
	              visibleMenuItems[0].onkeydown = function firstItemHandler(event) {
	                circularFocusHandler(event, false, event.shiftKey, visibleMenuItems.length - 1);
	              };
	              visibleMenuItems[visibleMenuItems.length - 1].onkeydown = function lastItemHandler(event) {
	                circularFocusHandler(event, false, !event.shiftKey, 0);
	              };
	            }
	          }
	        }
	
	        function circularFocusHandler(event, isSingleItem, shiftKeyStatus, index) {
	          if (event.keyCode === uiGridConstants.keymap.TAB) {
	            if (isSingleItem) {
	              event.preventDefault();
	            } else if (shiftKeyStatus) {
	              event.preventDefault();
	              visibleMenuItems[index].focus();
	            }
	          }
	        }
	      }
	
	      // Since we are hiding this column the default hide action will fail so we need to focus somewhere else.
	      var setFocusOnHideColumn = function(){
	        $timeout(function() {
	          // Get the UID of the first
	          var focusToGridMenu = function(){
	            return gridUtil.focus.byId('grid-menu', $scope.grid);
	          };
	
	          var thisIndex;
	          $scope.grid.columns.some(function(element, index){
	            if (angular.equals(element, $scope.col)) {
	              thisIndex = index;
	              return true;
	            }
	          });
	
	          var previousVisibleCol;
	          // Try and find the next lower or nearest column to focus on
	          $scope.grid.columns.some(function(element, index){
	            if (!element.visible){
	              return false;
	            } // This columns index is below the current column index
	            else if ( index < thisIndex){
	              previousVisibleCol = element;
	            } // This elements index is above this column index and we haven't found one that is lower
	            else if ( index > thisIndex && !previousVisibleCol) {
	              // This is the next best thing
	              previousVisibleCol = element;
	              // We've found one so use it.
	              return true;
	            } // We've reached an element with an index above this column and the previousVisibleCol variable has been set
	            else if (index > thisIndex && previousVisibleCol) {
	              // We are done.
	              return true;
	            }
	          });
	          // If found then focus on it
	          if (previousVisibleCol){
	            var colClass = previousVisibleCol.getColClass();
	            gridUtil.focus.bySelector($document, '.ui-grid-header-cell.' + colClass+ ' .ui-grid-header-cell-primary-focus', true).then(angular.noop, function(reason){
	              if (reason !== 'canceled'){ // If this is canceled then don't perform the action
	                //The fallback action is to focus on the grid menu
	                return focusToGridMenu();
	              }
	            }).catch(angular.noop);
	          } else {
	            // Fallback action to focus on the grid menu
	            focusToGridMenu();
	          }
	        });
	      };
	
	      $scope.hideColumn = function () {
	        $scope.col.colDef.visible = false;
	        $scope.col.visible = false;
	
	        $scope.grid.queueGridRefresh();
	        $scope.hideMenu();
	        $scope.grid.api.core.notifyDataChange( uiGridConstants.dataChange.COLUMN );
	        $scope.grid.api.core.raise.columnVisibilityChanged( $scope.col );
	
	        // We are hiding so the default action of focusing on the button that opened this menu will fail.
	        setFocusOnHideColumn();
	      };
	    },
	
	
	
	    controller: ['$scope', function ($scope) {
	      var self = this;
	
	      $scope.$watch('menuItems', function (n) {
	        self.menuItems = n;
	      });
	    }]
	  };
	
	  return uiGridColumnMenu;
	
	}]);
	
	})();
	
	(function(){
	  'use strict';
	
	  angular.module('ui.grid').directive('uiGridFilter', ['$compile', '$templateCache', 'i18nService', 'gridUtil', function ($compile, $templateCache, i18nService, gridUtil) {
	
	    return {
	      compile: function() {
	        return {
	          pre: function ($scope, $elm, $attrs, controllers) {
	            $scope.col.updateFilters = function( filterable ){
	              $elm.children().remove();
	              if ( filterable ) {
	                var template = $scope.col.filterHeaderTemplate;
	                if (template === undefined && $scope.col.providedFilterHeaderTemplate !== '') {
	                  if ($scope.col.filterHeaderTemplatePromise) {
	                    $scope.col.filterHeaderTemplatePromise.then(function () {
	                      template = $scope.col.filterHeaderTemplate;
	                      $elm.append($compile(template)($scope));
	                    });
	                  }
	                }
	                else {
	                  $elm.append($compile(template)($scope));
	                }
	              }
	            };
	
	            $scope.$on( '$destroy', function() {
	              delete $scope.col.updateFilters;
	            });
	          },
	          post: function ($scope, $elm, $attrs, controllers){
	            $scope.aria = i18nService.getSafeText('headerCell.aria');
	            $scope.removeFilter = function(colFilter, index){
	              colFilter.term = null;
	              //Set the focus to the filter input after the action disables the button
	              gridUtil.focus.bySelector($elm, '.ui-grid-filter-input-' + index);
	            };
	          }
	        };
	      }
	    };
	  }]);
	})();
	
	(function () {
	  'use strict';
	
	  angular.module('ui.grid').directive('uiGridFooterCell', ['$timeout', 'gridUtil', 'uiGridConstants', '$compile',
	  function ($timeout, gridUtil, uiGridConstants, $compile) {
	    var uiGridFooterCell = {
	      priority: 0,
	      scope: {
	        col: '=',
	        row: '=',
	        renderIndex: '='
	      },
	      replace: true,
	      require: '^uiGrid',
	      compile: function compile(tElement, tAttrs, transclude) {
	        return {
	          pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	            var template = $scope.col.footerCellTemplate;
	            if (template === undefined && $scope.col.providedFooterCellTemplate !== '') {
	              if ($scope.col.footerCellTemplatePromise) {
	                $scope.col.footerCellTemplatePromise.then(function () {
	                  template = $scope.col.footerCellTemplate;
	                  $elm.append($compile(template)($scope));
	                });
	              }
	            }
	            else {
	              $elm.append($compile(template)($scope));
	            }
	          },
	          post: function ($scope, $elm, $attrs, uiGridCtrl) {
	            //$elm.addClass($scope.col.getColClass(false));
	            $scope.grid = uiGridCtrl.grid;
	
	            var initColClass = $scope.col.getColClass(false);
	            $elm.addClass(initColClass);
	
	            // apply any footerCellClass
	            var classAdded;
	            var updateClass = function( grid ){
	              var contents = $elm;
	              if ( classAdded ){
	                contents.removeClass( classAdded );
	                classAdded = null;
	              }
	  
	              if (angular.isFunction($scope.col.footerCellClass)) {
	                classAdded = $scope.col.footerCellClass($scope.grid, $scope.row, $scope.col, $scope.rowRenderIndex, $scope.colRenderIndex);
	              }
	              else {
	                classAdded = $scope.col.footerCellClass;
	              }
	              contents.addClass(classAdded);
	            };
	  
	            if ($scope.col.footerCellClass) {
	              updateClass();
	            }
	
	            $scope.col.updateAggregationValue();
	
	            // Watch for column changes so we can alter the col cell class properly
	/* shouldn't be needed any more, given track by col.name
	            $scope.$watch('col', function (n, o) {
	              if (n !== o) {
	                // See if the column's internal class has changed
	                var newColClass = $scope.col.getColClass(false);
	                if (newColClass !== initColClass) {
	                  $elm.removeClass(initColClass);
	                  $elm.addClass(newColClass);
	                  initColClass = newColClass;
	                }
	              }
	            });
	*/
	
	
	            // Register a data change watch that would get triggered whenever someone edits a cell or modifies column defs
	            var dataChangeDereg = $scope.grid.registerDataChangeCallback( updateClass, [uiGridConstants.dataChange.COLUMN]);
	            // listen for visible rows change and update aggregation values
	            $scope.grid.api.core.on.rowsRendered( $scope, $scope.col.updateAggregationValue );
	            $scope.grid.api.core.on.rowsRendered( $scope, updateClass );
	            $scope.$on( '$destroy', dataChangeDereg );
	          }
	        };
	      }
	    };
	
	    return uiGridFooterCell;
	  }]);
	
	})();
	
	(function () {
	  'use strict';
	
	  angular.module('ui.grid').directive('uiGridFooter', ['$templateCache', '$compile', 'uiGridConstants', 'gridUtil', '$timeout', function ($templateCache, $compile, uiGridConstants, gridUtil, $timeout) {
	
	    return {
	      restrict: 'EA',
	      replace: true,
	      // priority: 1000,
	      require: ['^uiGrid', '^uiGridRenderContainer'],
	      scope: true,
	      compile: function ($elm, $attrs) {
	        return {
	          pre: function ($scope, $elm, $attrs, controllers) {
	            var uiGridCtrl = controllers[0];
	            var containerCtrl = controllers[1];
	
	            $scope.grid = uiGridCtrl.grid;
	            $scope.colContainer = containerCtrl.colContainer;
	
	            containerCtrl.footer = $elm;
	
	            var footerTemplate = $scope.grid.options.footerTemplate;
	            gridUtil.getTemplate(footerTemplate)
	              .then(function (contents) {
	                var template = angular.element(contents);
	
	                var newElm = $compile(template)($scope);
	                $elm.append(newElm);
	
	                if (containerCtrl) {
	                  // Inject a reference to the footer viewport (if it exists) into the grid controller for use in the horizontal scroll handler below
	                  var footerViewport = $elm[0].getElementsByClassName('ui-grid-footer-viewport')[0];
	
	                  if (footerViewport) {
	                    containerCtrl.footerViewport = footerViewport;
	                  }
	                }
	              }).catch(angular.noop);
	          },
	
	          post: function ($scope, $elm, $attrs, controllers) {
	            var uiGridCtrl = controllers[0];
	            var containerCtrl = controllers[1];
	
	            // gridUtil.logDebug('ui-grid-footer link');
	
	            var grid = uiGridCtrl.grid;
	
	            // Don't animate footer cells
	            gridUtil.disableAnimations($elm);
	
	            containerCtrl.footer = $elm;
	
	            var footerViewport = $elm[0].getElementsByClassName('ui-grid-footer-viewport')[0];
	            if (footerViewport) {
	              containerCtrl.footerViewport = footerViewport;
	            }
	          }
	        };
	      }
	    };
	  }]);
	
	})();
	
	(function () {
	  'use strict';
	
	  angular.module('ui.grid').directive('uiGridGridFooter', ['$templateCache', '$compile', 'uiGridConstants', 'gridUtil', '$timeout', function ($templateCache, $compile, uiGridConstants, gridUtil, $timeout) {
	
	    return {
	      restrict: 'EA',
	      replace: true,
	      // priority: 1000,
	      require: '^uiGrid',
	      scope: true,
	      compile: function ($elm, $attrs) {
	        return {
	          pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	
	            $scope.grid = uiGridCtrl.grid;
	
	
	
	            var footerTemplate = $scope.grid.options.gridFooterTemplate;
	            gridUtil.getTemplate(footerTemplate)
	              .then(function (contents) {
	                var template = angular.element(contents);
	
	                var newElm = $compile(template)($scope);
	                $elm.append(newElm);
	              }).catch(angular.noop);
	          },
	
	          post: function ($scope, $elm, $attrs, controllers) {
	
	          }
	        };
	      }
	    };
	  }]);
	
	})();
	
	(function(){
	  'use strict';
	
	  angular.module('ui.grid').directive('uiGridHeaderCell', ['$compile', '$timeout', '$window', '$document', 'gridUtil', 'uiGridConstants', 'ScrollEvent', 'i18nService',
	  function ($compile, $timeout, $window, $document, gridUtil, uiGridConstants, ScrollEvent, i18nService) {
	    // Do stuff after mouse has been down this many ms on the header cell
	    var mousedownTimeout = 500;
	    var changeModeTimeout = 500;    // length of time between a touch event and a mouse event being recognised again, and vice versa
	
	    var uiGridHeaderCell = {
	      priority: 0,
	      scope: {
	        col: '=',
	        row: '=',
	        renderIndex: '='
	      },
	      require: ['^uiGrid', '^uiGridRenderContainer'],
	      replace: true,
	      compile: function() {
	        return {
	          pre: function ($scope, $elm, $attrs) {
	            var template = $scope.col.headerCellTemplate;
	            if (template === undefined && $scope.col.providedHeaderCellTemplate !== '') {
	              if ($scope.col.headerCellTemplatePromise) {
	                $scope.col.headerCellTemplatePromise.then(function () {
	                  template = $scope.col.headerCellTemplate;
	                  $elm.append($compile(template)($scope));
	                });
	              }
	            }
	            else {
	              $elm.append($compile(template)($scope));
	            }
	          },
	
	          post: function ($scope, $elm, $attrs, controllers) {
	            var uiGridCtrl = controllers[0];
	            var renderContainerCtrl = controllers[1];
	
	            $scope.i18n = {
	              headerCell: i18nService.getSafeText('headerCell'),
	              sort: i18nService.getSafeText('sort')
	            };
	            $scope.isSortPriorityVisible = function() {
	              //show sort priority if column is sorted and there is at least one other sorted column
	              return angular.isNumber($scope.col.sort.priority) && $scope.grid.columns.some(function(element, index){
	                  return angular.isNumber(element.sort.priority) && element !== $scope.col;
	                });
	            };
	            $scope.getSortDirectionAriaLabel = function(){
	              var col = $scope.col;
	              //Trying to recreate this sort of thing but it was getting messy having it in the template.
	              //Sort direction {{col.sort.direction == asc ? 'ascending' : ( col.sort.direction == desc ? 'descending':'none')}}. {{col.sort.priority ? {{columnPriorityText}} {{col.sort.priority}} : ''}
	              var sortDirectionText = col.sort.direction === uiGridConstants.ASC ? $scope.i18n.sort.ascending : ( col.sort.direction === uiGridConstants.DESC ? $scope.i18n.sort.descending : $scope.i18n.sort.none);
	              var label = sortDirectionText;
	
	              if ($scope.isSortPriorityVisible()) {
	                label = label + '. ' + $scope.i18n.headerCell.priority + ' ' + (col.sort.priority + 1);
	              }
	              return label;
	            };
	
	            $scope.grid = uiGridCtrl.grid;
	
	            $scope.renderContainer = uiGridCtrl.grid.renderContainers[renderContainerCtrl.containerId];
	
	            var initColClass = $scope.col.getColClass(false);
	            $elm.addClass(initColClass);
	
	            // Hide the menu by default
	            $scope.menuShown = false;
	
	            // Put asc and desc sort directions in scope
	            $scope.asc = uiGridConstants.ASC;
	            $scope.desc = uiGridConstants.DESC;
	
	            // Store a reference to menu element
	            var $colMenu = angular.element( $elm[0].querySelectorAll('.ui-grid-header-cell-menu') );
	
	            var $contentsElm = angular.element( $elm[0].querySelectorAll('.ui-grid-cell-contents') );
	
	
	            // apply any headerCellClass
	            var classAdded;
	            var previousMouseX;
	
	            // filter watchers
	            var filterDeregisters = [];
	
	
	            /*
	             * Our basic approach here for event handlers is that we listen for a down event (mousedown or touchstart).
	             * Once we have a down event, we need to work out whether we have a click, a drag, or a
	             * hold.  A click would sort the grid (if sortable).  A drag would be used by moveable, so
	             * we ignore it.  A hold would open the menu.
	             *
	             * So, on down event, we put in place handlers for move and up events, and a timer.  If the
	             * timer expires before we see a move or up, then we have a long press and hence a column menu open.
	             * If the up happens before the timer, then we have a click, and we sort if the column is sortable.
	             * If a move happens before the timer, then we are doing column move, so we do nothing, the moveable feature
	             * will handle it.
	             *
	             * To deal with touch enabled devices that also have mice, we only create our handlers when
	             * we get the down event, and we create the corresponding handlers - if we're touchstart then
	             * we get touchmove and touchend, if we're mousedown then we get mousemove and mouseup.
	             *
	             * We also suppress the click action whilst this is happening - otherwise after the mouseup there
	             * will be a click event and that can cause the column menu to close
	             *
	             */
	
	            $scope.downFn = function( event ){
	              event.stopPropagation();
	
	              if (typeof(event.originalEvent) !== 'undefined' && event.originalEvent !== undefined) {
	                event = event.originalEvent;
	              }
	
	              // Don't show the menu if it's not the left button
	              if (event.button && event.button !== 0) {
	                return;
	              }
	              previousMouseX = event.pageX;
	
	              $scope.mousedownStartTime = (new Date()).getTime();
	              $scope.mousedownTimeout = $timeout(function() { }, mousedownTimeout);
	
	              $scope.mousedownTimeout.then(function () {
	                if ( $scope.colMenu ) {
	                  uiGridCtrl.columnMenuScope.showMenu($scope.col, $elm, event);
	                }
	              }).catch(angular.noop);
	
	              uiGridCtrl.fireEvent(uiGridConstants.events.COLUMN_HEADER_CLICK, {event: event, columnName: $scope.col.colDef.name});
	
	              $scope.offAllEvents();
	              if ( event.type === 'touchstart'){
	                $document.on('touchend', $scope.upFn);
	                $document.on('touchmove', $scope.moveFn);
	              } else if ( event.type === 'mousedown' ){
	                $document.on('mouseup', $scope.upFn);
	                $document.on('mousemove', $scope.moveFn);
	              }
	            };
	
	            $scope.upFn = function( event ){
	              event.stopPropagation();
	              $timeout.cancel($scope.mousedownTimeout);
	              $scope.offAllEvents();
	              $scope.onDownEvents(event.type);
	
	              var mousedownEndTime = (new Date()).getTime();
	              var mousedownTime = mousedownEndTime - $scope.mousedownStartTime;
	
	              if (mousedownTime > mousedownTimeout) {
	                // long click, handled above with mousedown
	              }
	              else {
	                // short click
	                if ( $scope.sortable ){
	                  $scope.handleClick(event);
	                }
	              }
	            };
	
	            $scope.handleKeyDown = function(event) {
	              if (event.keyCode === 32) {
	                event.preventDefault();
	              }
	            };
	
	            $scope.moveFn = function( event ){
	              // Chrome is known to fire some bogus move events.
	              var changeValue = event.pageX - previousMouseX;
	              if ( changeValue === 0 ){ return; }
	
	              // we're a move, so do nothing and leave for column move (if enabled) to take over
	              $timeout.cancel($scope.mousedownTimeout);
	              $scope.offAllEvents();
	              $scope.onDownEvents(event.type);
	            };
	
	            $scope.clickFn = function ( event ){
	              event.stopPropagation();
	              $contentsElm.off('click', $scope.clickFn);
	            };
	
	
	            $scope.offAllEvents = function(){
	              $contentsElm.off('touchstart', $scope.downFn);
	              $contentsElm.off('mousedown', $scope.downFn);
	
	              $document.off('touchend', $scope.upFn);
	              $document.off('mouseup', $scope.upFn);
	
	              $document.off('touchmove', $scope.moveFn);
	              $document.off('mousemove', $scope.moveFn);
	
	              $contentsElm.off('click', $scope.clickFn);
	            };
	
	            $scope.onDownEvents = function( type ){
	              // If there is a previous event, then wait a while before
	              // activating the other mode - i.e. if the last event was a touch event then
	              // don't enable mouse events for a wee while (500ms or so)
	              // Avoids problems with devices that emulate mouse events when you have touch events
	
	              switch (type){
	                case 'touchmove':
	                case 'touchend':
	                  $contentsElm.on('click', $scope.clickFn);
	                  $contentsElm.on('touchstart', $scope.downFn);
	                  $timeout(function(){
	                    $contentsElm.on('mousedown', $scope.downFn);
	                  }, changeModeTimeout);
	                  break;
	                case 'mousemove':
	                case 'mouseup':
	                  $contentsElm.on('click', $scope.clickFn);
	                  $contentsElm.on('mousedown', $scope.downFn);
	                  $timeout(function(){
	                    $contentsElm.on('touchstart', $scope.downFn);
	                  }, changeModeTimeout);
	                  break;
	                default:
	                  $contentsElm.on('click', $scope.clickFn);
	                  $contentsElm.on('touchstart', $scope.downFn);
	                  $contentsElm.on('mousedown', $scope.downFn);
	              }
	            };
	
	
	            var updateHeaderOptions = function( grid ){
	              var contents = $elm;
	              if ( classAdded ){
	                contents.removeClass( classAdded );
	                classAdded = null;
	              }
	
	              if (angular.isFunction($scope.col.headerCellClass)) {
	                classAdded = $scope.col.headerCellClass($scope.grid, $scope.row, $scope.col, $scope.rowRenderIndex, $scope.colRenderIndex);
	              }
	              else {
	                classAdded = $scope.col.headerCellClass;
	              }
	              contents.addClass(classAdded);
	
	              $scope.$applyAsync(function() {
	                var rightMostContainer = $scope.grid.renderContainers['right'] && $scope.grid.renderContainers['right'].visibleColumnCache.length ?
	                $scope.grid.renderContainers['right'] : $scope.grid.renderContainers['body'];
	                $scope.isLastCol = uiGridCtrl.grid.options && uiGridCtrl.grid.options.enableGridMenu &&
	                  $scope.col === rightMostContainer.visibleColumnCache[ rightMostContainer.visibleColumnCache.length - 1 ];
	              });
	
	              // Figure out whether this column is sortable or not
	              $scope.sortable = Boolean($scope.col.enableSorting);
	
	              // Figure out whether this column is filterable or not
	              var oldFilterable = $scope.filterable;
	              $scope.filterable = Boolean(uiGridCtrl.grid.options.enableFiltering && $scope.col.enableFiltering);
	
	              if ( oldFilterable !== $scope.filterable){
	                if ( typeof($scope.col.updateFilters) !== 'undefined' ){
	                  $scope.col.updateFilters($scope.filterable);
	                }
	
	                // if column is filterable add a filter watcher
	                if ($scope.filterable) {
	                  $scope.col.filters.forEach( function(filter, i) {
	                    filterDeregisters.push($scope.$watch('col.filters[' + i + '].term', function(n, o) {
	                      if (n !== o) {
	                        uiGridCtrl.grid.api.core.raise.filterChanged();
	                        uiGridCtrl.grid.api.core.notifyDataChange( uiGridConstants.dataChange.COLUMN );
	                        uiGridCtrl.grid.queueGridRefresh();
	                      }
	                    }));
	                  });
	                  $scope.$on('$destroy', function() {
	                    filterDeregisters.forEach( function(filterDeregister) {
	                      filterDeregister();
	                    });
	                  });
	                } else {
	                  filterDeregisters.forEach( function(filterDeregister) {
	                    filterDeregister();
	                  });
	                }
	
	              }
	
	              // figure out whether we support column menus
	              if ($scope.col.grid.options && $scope.col.grid.options.enableColumnMenus !== false &&
	                      $scope.col.colDef && $scope.col.colDef.enableColumnMenu !== false){
	                $scope.colMenu = true;
	              } else {
	                $scope.colMenu = false;
	              }
	
	              /**
	               * @ngdoc property
	               * @name enableColumnMenu
	               * @propertyOf ui.grid.class:GridOptions.columnDef
	               * @description if column menus are enabled, controls the column menus for this specific
	               * column (i.e. if gridOptions.enableColumnMenus, then you can control column menus
	               * using this option. If gridOptions.enableColumnMenus === false then you get no column
	               * menus irrespective of the value of this option ).  Defaults to true.
	               *
	               * By default column menu's trigger is hidden before mouse over, but you can always force it to be visible with CSS:
	               *
	               * <pre>
	               *  .ui-grid-column-menu-button {
	               *    display: block;
	               *  }
	               * </pre>
	               */
	              /**
	              * @ngdoc property
	              * @name enableColumnMenus
	              * @propertyOf ui.grid.class:GridOptions.columnDef
	              * @description Override for column menus everywhere - if set to false then you get no
	              * column menus.  Defaults to true.
	              *
	              */
	
	              $scope.offAllEvents();
	
	              if ($scope.sortable || $scope.colMenu) {
	                $scope.onDownEvents();
	
	                $scope.$on('$destroy', function () {
	                  $scope.offAllEvents();
	                });
	              }
	            };
	
	/*
	            $scope.$watch('col', function (n, o) {
	              if (n !== o) {
	                // See if the column's internal class has changed
	                var newColClass = $scope.col.getColClass(false);
	                if (newColClass !== initColClass) {
	                  $elm.removeClass(initColClass);
	                  $elm.addClass(newColClass);
	                  initColClass = newColClass;
	                }
	              }
	            });
	*/
	            updateHeaderOptions();
	
	            // Register a data change watch that would get triggered whenever someone edits a cell or modifies column defs
	            var dataChangeDereg = $scope.grid.registerDataChangeCallback( updateHeaderOptions, [uiGridConstants.dataChange.COLUMN]);
	
	            $scope.$on( '$destroy', dataChangeDereg );
	
	            $scope.handleClick = function(event) {
	              // If the shift key is being held down, add this column to the sort
	              var add = false;
	              if (event.shiftKey) {
	                add = true;
	              }
	
	              // Sort this column then rebuild the grid's rows
	              uiGridCtrl.grid.sortColumn($scope.col, add)
	                .then(function () {
	                  if (uiGridCtrl.columnMenuScope) { uiGridCtrl.columnMenuScope.hideMenu(); }
	                  uiGridCtrl.grid.refresh();
	                }).catch(angular.noop);
	            };
	
	            $scope.headerCellArrowKeyDown = function(event) {
	              if (event.keyCode === 32 || event.keyCode === 13) {
	                event.preventDefault();
	                $scope.toggleMenu(event);
	              }
	            };
	
	            $scope.toggleMenu = function(event) {
	
	              event.stopPropagation();
	
	              // If the menu is already showing...
	              if (uiGridCtrl.columnMenuScope.menuShown) {
	                // ... and we're the column the menu is on...
	                if (uiGridCtrl.columnMenuScope.col === $scope.col) {
	                  // ... hide it
	                  uiGridCtrl.columnMenuScope.hideMenu();
	                }
	                // ... and we're NOT the column the menu is on
	                else {
	                  // ... move the menu to our column
	                  uiGridCtrl.columnMenuScope.showMenu($scope.col, $elm);
	                }
	              }
	              // If the menu is NOT showing
	              else {
	                // ... show it on our column
	                uiGridCtrl.columnMenuScope.showMenu($scope.col, $elm);
	              }
	            };
	          }
	        };
	      }
	    };
	
	    return uiGridHeaderCell;
	  }]);
	
	})();
	
	(function(){
	  'use strict';
	
	  angular.module('ui.grid').directive('uiGridHeader', ['$templateCache', '$compile', 'uiGridConstants', 'gridUtil', '$timeout', 'ScrollEvent',
	    function($templateCache, $compile, uiGridConstants, gridUtil, $timeout, ScrollEvent) {
	    var defaultTemplate = 'ui-grid/ui-grid-header';
	    var emptyTemplate = 'ui-grid/ui-grid-no-header';
	
	    return {
	      restrict: 'EA',
	      // templateUrl: 'ui-grid/ui-grid-header',
	      replace: true,
	      // priority: 1000,
	      require: ['^uiGrid', '^uiGridRenderContainer'],
	      scope: true,
	      compile: function($elm, $attrs) {
	        return {
	          pre: function ($scope, $elm, $attrs, controllers) {
	            var uiGridCtrl = controllers[0];
	            var containerCtrl = controllers[1];
	
	            $scope.grid = uiGridCtrl.grid;
	            $scope.colContainer = containerCtrl.colContainer;
	
	            updateHeaderReferences();
	            
	            var headerTemplate;
	            if (!$scope.grid.options.showHeader) {
	              headerTemplate = emptyTemplate;
	            }
	            else {
	              headerTemplate = ($scope.grid.options.headerTemplate) ? $scope.grid.options.headerTemplate : defaultTemplate;            
	            }
	
	            gridUtil.getTemplate(headerTemplate)
	              .then(function (contents) {
	                var template = angular.element(contents);
	                
	                var newElm = $compile(template)($scope);
	                $elm.replaceWith(newElm);
	
	                // And update $elm to be the new element
	                $elm = newElm;
	
	                updateHeaderReferences();
	
	                if (containerCtrl) {
	                  // Inject a reference to the header viewport (if it exists) into the grid controller for use in the horizontal scroll handler below
	                  var headerViewport = $elm[0].getElementsByClassName('ui-grid-header-viewport')[0];
	
	
	                  if (headerViewport) {
	                    containerCtrl.headerViewport = headerViewport;
	                    angular.element(headerViewport).on('scroll', scrollHandler);
	                    $scope.$on('$destroy', function () {
	                      angular.element(headerViewport).off('scroll', scrollHandler);
	                    });
	                  }
	                }
	
	                $scope.grid.queueRefresh();
	              }).catch(angular.noop);
	
	            function updateHeaderReferences() {
	              containerCtrl.header = containerCtrl.colContainer.header = $elm;
	
	              var headerCanvases = $elm[0].getElementsByClassName('ui-grid-header-canvas');
	
	              if (headerCanvases.length > 0) {
	                containerCtrl.headerCanvas = containerCtrl.colContainer.headerCanvas = headerCanvases[0];
	              }
	              else {
	                containerCtrl.headerCanvas = null;
	              }
	            }
	
	            function scrollHandler(evt) {
	              if (uiGridCtrl.grid.isScrollingHorizontally) {
	                return;
	              }
	              var newScrollLeft = gridUtil.normalizeScrollLeft(containerCtrl.headerViewport, uiGridCtrl.grid);
	              var horizScrollPercentage = containerCtrl.colContainer.scrollHorizontal(newScrollLeft);
	
	              var scrollEvent = new ScrollEvent(uiGridCtrl.grid, null, containerCtrl.colContainer, ScrollEvent.Sources.ViewPortScroll);
	              scrollEvent.newScrollLeft = newScrollLeft;
	              if ( horizScrollPercentage > -1 ){
	                scrollEvent.x = { percentage: horizScrollPercentage };
	              }
	
	              uiGridCtrl.grid.scrollContainers(null, scrollEvent);
	            }
	          },
	
	          post: function ($scope, $elm, $attrs, controllers) {
	            var uiGridCtrl = controllers[0];
	            var containerCtrl = controllers[1];
	
	            // gridUtil.logDebug('ui-grid-header link');
	
	            var grid = uiGridCtrl.grid;
	
	            // Don't animate header cells
	            gridUtil.disableAnimations($elm);
	
	            function updateColumnWidths() {
	              // this styleBuilder always runs after the renderContainer, so we can rely on the column widths
	              // already being populated correctly
	
	              var columnCache = containerCtrl.colContainer.visibleColumnCache;
	              
	              // Build the CSS
	              // uiGridCtrl.grid.columns.forEach(function (column) {
	              var ret = '';
	              var canvasWidth = 0;
	              columnCache.forEach(function (column) {
	                ret = ret + column.getColClassDefinition();
	                canvasWidth += column.drawnWidth;
	              });
	
	              containerCtrl.colContainer.canvasWidth = canvasWidth;
	              
	              // Return the styles back to buildStyles which pops them into the `customStyles` scope variable
	              return ret;
	            }
	            
	            containerCtrl.header = $elm;
	            
	            var headerViewport = $elm[0].getElementsByClassName('ui-grid-header-viewport')[0];
	            if (headerViewport) {
	              containerCtrl.headerViewport = headerViewport;
	            }
	
	            //todo: remove this if by injecting gridCtrl into unit tests
	            if (uiGridCtrl) {
	              uiGridCtrl.grid.registerStyleComputation({
	                priority: 15,
	                func: updateColumnWidths
	              });
	            }
	          }
	        };
	      }
	    };
	  }]);
	
	})();
	
	(function(){
	
	angular.module('ui.grid')
	.service('uiGridGridMenuService', [ 'gridUtil', 'i18nService', 'uiGridConstants', function( gridUtil, i18nService, uiGridConstants ) {
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.uiGridGridMenuService
	   *
	   *  @description Methods for working with the grid menu
	   */
	
	  var service = {
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.uiGridGridMenuService
	     * @name initialize
	     * @description Sets up the gridMenu. Most importantly, sets our
	     * scope onto the grid object as grid.gridMenuScope, allowing us
	     * to operate when passed only the grid.  Second most importantly,
	     * we register the 'addToGridMenu' and 'removeFromGridMenu' methods
	     * on the core api.
	     * @param {$scope} $scope the scope of this gridMenu
	     * @param {Grid} grid the grid to which this gridMenu is associated
	     */
	    initialize: function( $scope, grid ){
	      grid.gridMenuScope = $scope;
	      $scope.grid = grid;
	      $scope.registeredMenuItems = [];
	
	      // not certain this is needed, but would be bad to create a memory leak
	      $scope.$on('$destroy', function() {
	        if ( $scope.grid && $scope.grid.gridMenuScope ){
	          $scope.grid.gridMenuScope = null;
	        }
	        if ( $scope.grid ){
	          $scope.grid = null;
	        }
	        if ( $scope.registeredMenuItems ){
	          $scope.registeredMenuItems = null;
	        }
	      });
	
	      $scope.registeredMenuItems = [];
	
	      /**
	       * @ngdoc function
	       * @name addToGridMenu
	       * @methodOf ui.grid.core.api:PublicApi
	       * @description add items to the grid menu.  Used by features
	       * to add their menu items if they are enabled, can also be used by
	       * end users to add menu items.  This method has the advantage of allowing
	       * remove again, which can simplify management of which items are included
	       * in the menu when.  (Noting that in most cases the shown and active functions
	       * provide a better way to handle visibility of menu items)
	       * @param {Grid} grid the grid on which we are acting
	       * @param {array} items menu items in the format as described in the tutorial, with
	       * the added note that if you want to use remove you must also specify an `id` field,
	       * which is provided when you want to remove an item.  The id should be unique.
	       *
	       */
	      grid.api.registerMethod( 'core', 'addToGridMenu', service.addToGridMenu );
	
	      /**
	       * @ngdoc function
	       * @name removeFromGridMenu
	       * @methodOf ui.grid.core.api:PublicApi
	       * @description Remove an item from the grid menu based on a provided id. Assumes
	       * that the id is unique, removes only the last instance of that id. Does nothing if
	       * the specified id is not found
	       * @param {Grid} grid the grid on which we are acting
	       * @param {string} id the id we'd like to remove from the menu
	       *
	       */
	      grid.api.registerMethod( 'core', 'removeFromGridMenu', service.removeFromGridMenu );
	    },
	
	
	    /**
	     * @ngdoc function
	     * @name addToGridMenu
	     * @propertyOf ui.grid.uiGridGridMenuService
	     * @description add items to the grid menu.  Used by features
	     * to add their menu items if they are enabled, can also be used by
	     * end users to add menu items.  This method has the advantage of allowing
	     * remove again, which can simplify management of which items are included
	     * in the menu when.  (Noting that in most cases the shown and active functions
	     * provide a better way to handle visibility of menu items)
	     * @param {Grid} grid the grid on which we are acting
	     * @param {array} menuItems menu items in the format as described in the tutorial, with
	     * the added note that if you want to use remove you must also specify an `id` field,
	     * which is provided when you want to remove an item.  The id should be unique.
	     *
	     */
	    addToGridMenu: function( grid, menuItems ) {
	      if ( !angular.isArray( menuItems ) ) {
	        gridUtil.logError( 'addToGridMenu: menuItems must be an array, and is not, not adding any items');
	      } else {
	        if ( grid.gridMenuScope ){
	          grid.gridMenuScope.registeredMenuItems = grid.gridMenuScope.registeredMenuItems ? grid.gridMenuScope.registeredMenuItems : [];
	          grid.gridMenuScope.registeredMenuItems = grid.gridMenuScope.registeredMenuItems.concat( menuItems );
	        } else {
	          gridUtil.logError( 'Asked to addToGridMenu, but gridMenuScope not present.  Timing issue?  Please log issue with ui-grid');
	        }
	      }
	    },
	
	
	    /**
	     * @ngdoc function
	     * @name removeFromGridMenu
	     * @methodOf ui.grid.uiGridGridMenuService
	     * @description Remove an item from the grid menu based on a provided id.  Assumes
	     * that the id is unique, removes only the last instance of that id.  Does nothing if
	     * the specified id is not found.  If there is no gridMenuScope or registeredMenuItems
	     * then do nothing silently - the desired result is those menu items not be present and they
	     * aren't.
	     * @param {Grid} grid the grid on which we are acting
	     * @param {string} id the id we'd like to remove from the menu
	     *
	     */
	    removeFromGridMenu: function( grid, id ){
	      var foundIndex = -1;
	
	      if ( grid && grid.gridMenuScope ){
	        grid.gridMenuScope.registeredMenuItems.forEach( function( value, index ) {
	          if ( value.id === id ){
	            if (foundIndex > -1) {
	              gridUtil.logError( 'removeFromGridMenu: found multiple items with the same id, removing only the last' );
	            } else {
	
	              foundIndex = index;
	            }
	          }
	        });
	      }
	
	      if ( foundIndex > -1 ){
	        grid.gridMenuScope.registeredMenuItems.splice( foundIndex, 1 );
	      }
	    },
	
	
	    /**
	     * @ngdoc array
	     * @name gridMenuCustomItems
	     * @propertyOf ui.grid.class:GridOptions
	     * @description (optional) An array of menu items that should be added to
	     * the gridMenu.  Follow the format documented in the tutorial for column
	     * menu customisation.  The context provided to the action function will
	     * include context.grid.  An alternative if working with dynamic menus is to use the
	     * provided api - core.addToGridMenu and core.removeFromGridMenu, which handles
	     * some of the management of items for you.
	     *
	     */
	    /**
	     * @ngdoc boolean
	     * @name gridMenuShowHideColumns
	     * @propertyOf ui.grid.class:GridOptions
	     * @description true by default, whether the grid menu should allow hide/show
	     * of columns
	     *
	     */
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.uiGridGridMenuService
	     * @name getMenuItems
	     * @description Decides the menu items to show in the menu.  This is a
	     * combination of:
	     *
	     * - the default menu items that are always included,
	     * - any menu items that have been provided through the addMenuItem api. These
	     *   are typically added by features within the grid
	     * - any menu items included in grid.options.gridMenuCustomItems.  These can be
	     *   changed dynamically, as they're always recalculated whenever we show the
	     *   menu
	     * @param {$scope} $scope the scope of this gridMenu, from which we can find all
	     * the information that we need
	     * @returns {Array} an array of menu items that can be shown
	     */
	    getMenuItems: function( $scope ) {
	      var menuItems = [
	        // this is where we add any menu items we want to always include
	      ];
	
	      if ( $scope.grid.options.gridMenuCustomItems ){
	        if ( !angular.isArray( $scope.grid.options.gridMenuCustomItems ) ){
	          gridUtil.logError( 'gridOptions.gridMenuCustomItems must be an array, and is not');
	        } else {
	          menuItems = menuItems.concat( $scope.grid.options.gridMenuCustomItems );
	        }
	      }
	
	      var clearFilters = [{
	        title: i18nService.getSafeText('gridMenu.clearAllFilters'),
	        action: function ($event) {
	          $scope.grid.clearAllFilters();
	        },
	        shown: function() {
	          return $scope.grid.options.enableFiltering;
	        },
	        order: 100
	      }];
	      menuItems = menuItems.concat( clearFilters );
	
	      menuItems = menuItems.concat( $scope.registeredMenuItems );
	
	      if ( $scope.grid.options.gridMenuShowHideColumns !== false ){
	        menuItems = menuItems.concat( service.showHideColumns( $scope ) );
	      }
	
	      menuItems.sort(function(a, b){
	        return a.order - b.order;
	      });
	
	      return menuItems;
	    },
	
	
	    /**
	     * @ngdoc array
	     * @name gridMenuTitleFilter
	     * @propertyOf ui.grid.class:GridOptions
	     * @description (optional) A function that takes a title string
	     * (usually the col.displayName), and converts it into a display value.  The function
	     * must return either a string or a promise.
	     *
	     * Used for internationalization of the grid menu column names - for angular-translate
	     * you can pass $translate as the function, for i18nService you can pass getSafeText as the
	     * function
	     * @example
	     * <pre>
	     *   gridOptions = {
	     *     gridMenuTitleFilter: $translate
	     *   }
	     * </pre>
	     */
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.uiGridGridMenuService
	     * @name showHideColumns
	     * @description Adds two menu items for each of the columns in columnDefs.  One
	     * menu item for hide, one menu item for show.  Each is visible when appropriate
	     * (show when column is not visible, hide when column is visible).  Each toggles
	     * the visible property on the columnDef using toggleColumnVisibility
	     * @param {$scope} $scope of a gridMenu, which contains a reference to the grid
	     */
	    showHideColumns: function( $scope ){
	      var showHideColumns = [];
	      if ( !$scope.grid.options.columnDefs || $scope.grid.options.columnDefs.length === 0 || $scope.grid.columns.length === 0 ) {
	        return showHideColumns;
	      }
	
	      function isColumnVisible(colDef) {
	        return colDef.visible === true || colDef.visible === undefined;
	      }
	
	      // add header for columns
	      showHideColumns.push({
	        title: i18nService.getSafeText('gridMenu.columns'),
	        order: 300
	      });
	
	      $scope.grid.options.gridMenuTitleFilter = $scope.grid.options.gridMenuTitleFilter ? $scope.grid.options.gridMenuTitleFilter : function( title ) { return title; };
	
	      $scope.grid.options.columnDefs.forEach( function( colDef, index ){
	        if ( colDef.enableHiding !== false ){
	          // add hide menu item - shows an OK icon as we only show when column is already visible
	          var menuItem = {
	            icon: isColumnVisible(colDef) ? 'ui-grid-icon-ok' : 'ui-grid-icon-cancel',
	            action: function($event) {
	              $event.stopPropagation();
	
	              service.toggleColumnVisibility( this.context.gridCol );
	
	              if ($event.target && $event.target.firstChild) {
	                $event.target.firstChild.className = isColumnVisible(this.context.gridCol.colDef) ?
	                  'ui-grid-icon-ok' : 'ui-grid-icon-cancel';
	              }
	            },
	            shown: function() {
	              return this.context.gridCol.colDef.enableHiding !== false;
	            },
	            context: { gridCol: $scope.grid.getColumn(colDef.name || colDef.field) },
	            leaveOpen: true,
	            order: 301 + index
	          };
	          service.setMenuItemTitle( menuItem, colDef, $scope.grid );
	          showHideColumns.push( menuItem );
	        }
	      });
	      return showHideColumns;
	    },
	
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.uiGridGridMenuService
	     * @name setMenuItemTitle
	     * @description Handles the response from gridMenuTitleFilter, adding it directly to the menu
	     * item if it returns a string, otherwise waiting for the promise to resolve or reject then
	     * putting the result into the title
	     * @param {object} menuItem the menuItem we want to put the title on
	     * @param {object} colDef the colDef from which we can get displayName, name or field
	     * @param {Grid} grid the grid, from which we can get the options.gridMenuTitleFilter
	     *
	     */
	    setMenuItemTitle: function( menuItem, colDef, grid ){
	      var title = grid.options.gridMenuTitleFilter( colDef.displayName || gridUtil.readableColumnName(colDef.name) || colDef.field );
	
	      if ( typeof(title) === 'string' ){
	        menuItem.title = title;
	      } else if ( title.then ){
	        // must be a promise
	        menuItem.title = "";
	        title.then( function( successValue ) {
	          menuItem.title = successValue;
	        }, function( errorValue ) {
	          menuItem.title = errorValue;
	        }).catch(angular.noop);
	      } else {
	        gridUtil.logError('Expected gridMenuTitleFilter to return a string or a promise, it has returned neither, bad config');
	        menuItem.title = 'badconfig';
	      }
	    },
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.uiGridGridMenuService
	     * @name toggleColumnVisibility
	     * @description Toggles the visibility of an individual column.  Expects to be
	     * provided a context that has on it a gridColumn, which is the column that
	     * we'll operate upon.  We change the visibility, and refresh the grid as appropriate
	     * @param {GridColumn} gridCol the column that we want to toggle
	     *
	     */
	    toggleColumnVisibility: function( gridCol ) {
	      gridCol.colDef.visible = !( gridCol.colDef.visible === true || gridCol.colDef.visible === undefined );
	
	      gridCol.grid.refresh();
	      gridCol.grid.api.core.notifyDataChange( uiGridConstants.dataChange.COLUMN );
	      gridCol.grid.api.core.raise.columnVisibilityChanged( gridCol );
	    }
	  };
	
	  return service;
	}])
	
	
	
	.directive('uiGridMenuButton', ['gridUtil', 'uiGridConstants', 'uiGridGridMenuService', 'i18nService',
	function (gridUtil, uiGridConstants, uiGridGridMenuService, i18nService) {
	
	  return {
	    priority: 0,
	    scope: true,
	    require: ['^uiGrid'],
	    templateUrl: 'ui-grid/ui-grid-menu-button',
	    replace: true,
	
	    link: function ($scope, $elm, $attrs, controllers) {
	      var uiGridCtrl = controllers[0];
	
	      // For the aria label
	      $scope.i18n = {
	        aria: i18nService.getSafeText('gridMenu.aria')
	      };
	
	      uiGridGridMenuService.initialize($scope, uiGridCtrl.grid);
	
	      $scope.shown = false;
	
	      $scope.toggleMenu = function () {
	        if ( $scope.shown ){
	          $scope.$broadcast('hide-menu');
	          $scope.shown = false;
	        } else {
	          $scope.menuItems = uiGridGridMenuService.getMenuItems( $scope );
	          $scope.$broadcast('show-menu');
	          $scope.shown = true;
	        }
	      };
	
	      $scope.$on('menu-hidden', function() {
	        $scope.shown = false;
	        gridUtil.focus.bySelector($elm, '.ui-grid-icon-container');
	      });
	    }
	  };
	
	}]);
	
	})();
	
	(function(){
	
	/**
	 * @ngdoc directive
	 * @name ui.grid.directive:uiGridMenu
	 * @element style
	 * @restrict A
	 *
	 * @description
	 * Allows us to interpolate expressions in `<style>` elements. Angular doesn't do this by default as it can/will/might? break in IE8.
	 *
	 * @example
	 <doc:example module="app">
	 <doc:source>
	 <script>
	 var app = angular.module('app', ['ui.grid']);
	
	 app.controller('MainCtrl', ['$scope', function ($scope) {
	
	 }]);
	 </script>
	
	 <div ng-controller="MainCtrl">
	   <div ui-grid-menu shown="true"  ></div>
	 </div>
	 </doc:source>
	 <doc:scenario>
	 </doc:scenario>
	 </doc:example>
	 */
	angular.module('ui.grid')
	
	.directive('uiGridMenu', ['$compile', '$timeout', '$window', '$document', 'gridUtil', 'uiGridConstants', 'i18nService',
	function ($compile, $timeout, $window, $document, gridUtil, uiGridConstants, i18nService) {
	  var uiGridMenu = {
	    priority: 0,
	    scope: {
	      // shown: '&',
	      menuItems: '=',
	      autoHide: '=?'
	    },
	    require: '?^uiGrid',
	    templateUrl: 'ui-grid/uiGridMenu',
	    replace: false,
	    link: function ($scope, $elm, $attrs, uiGridCtrl) {
	      $scope.dynamicStyles = '';
	      if (uiGridCtrl && uiGridCtrl.grid && uiGridCtrl.grid.options && uiGridCtrl.grid.options.gridMenuTemplate) {
	        var gridMenuTemplate = uiGridCtrl.grid.options.gridMenuTemplate;
	        gridUtil.getTemplate(gridMenuTemplate).then(function (contents) {
	          var template = angular.element(contents);
	          var newElm = $compile(template)($scope);
	          $elm.replaceWith(newElm);
	        }).catch(angular.noop);
	      }
	
	      var setupHeightStyle = function(gridHeight) {
	        //menu appears under header row, so substract that height from it's total
	        // additional 20px for general padding
	        var gridMenuMaxHeight = gridHeight - uiGridCtrl.grid.headerHeight - 20;
	        $scope.dynamicStyles = [
	          '.grid' + uiGridCtrl.grid.id + ' .ui-grid-menu-mid {',
	          'max-height: ' + gridMenuMaxHeight + 'px;',
	          '}'
	        ].join(' ');
	      };
	
	      if (uiGridCtrl) {
	        setupHeightStyle(uiGridCtrl.grid.gridHeight);
	        uiGridCtrl.grid.api.core.on.gridDimensionChanged($scope, function(oldGridHeight, oldGridWidth, newGridHeight, newGridWidth) {
	          setupHeightStyle(newGridHeight);
	        });
	      }
	
	      $scope.i18n = {
	        close: i18nService.getSafeText('columnMenu.close')
	      };
	
	    // *** Show/Hide functions ******
	      $scope.showMenu = function(event, args) {
	        if ( !$scope.shown ){
	
	          /*
	           * In order to animate cleanly we remove the ng-if, wait a digest cycle, then
	           * animate the removal of the ng-hide.  We can't successfully (so far as I can tell)
	           * animate removal of the ng-if, as the menu items aren't there yet.  And we don't want
	           * to rely on ng-show only, as that leaves elements in the DOM that are needlessly evaluated
	           * on scroll events.
	           *
	           * Note when testing animation that animations don't run on the tutorials.  When debugging it looks
	           * like they do, but angular has a default $animate provider that is just a stub, and that's what's
	           * being called.  ALso don't be fooled by the fact that your browser has actually loaded the
	           * angular-translate.js, it's not using it.  You need to test animations in an external application.
	           */
	          $scope.shown = true;
	
	          // Must be a timeout in order to work properly in Firefox. Issue #6533
	          $timeout(function() {
	            $scope.shownMid = true;
	            $scope.$emit('menu-shown');
	          });
	        } else if ( !$scope.shownMid ) {
	          // we're probably doing a hide then show, so we don't need to wait for ng-if
	          $scope.shownMid = true;
	          $scope.$emit('menu-shown');
	        }
	
	        var docEventType = 'click';
	        if (args && args.originalEvent && args.originalEvent.type && args.originalEvent.type === 'touchstart') {
	          docEventType = args.originalEvent.type;
	        }
	
	        // Turn off an existing document click handler
	        angular.element(document).off('click touchstart', applyHideMenu);
	        $elm.off('keyup', checkKeyUp);
	        $elm.off('keydown', checkKeyDown);
	
	        // Turn on the document click handler, but in a timeout so it doesn't apply to THIS click if there is one
	        $timeout(function() {
	          angular.element(document).on(docEventType, applyHideMenu);
	          $elm.on('keyup', checkKeyUp);
	          $elm.on('keydown', checkKeyDown);
	        });
	      };
	
	
	      $scope.hideMenu = function(event) {
	        if ( $scope.shown ){
	          /*
	           * In order to animate cleanly we animate the addition of ng-hide, then use a $timeout to
	           * set the ng-if (shown = false) after the animation runs.  In theory we can cascade off the
	           * callback on the addClass method, but it is very unreliable with unit tests for no discernable reason.
	           *
	           * The user may have clicked on the menu again whilst
	           * we're waiting, so we check that the mid isn't shown before applying the ng-if.
	           */
	          $scope.shownMid = false;
	          $timeout( function() {
	            if ( !$scope.shownMid ){
	              $scope.shown = false;
	              $scope.$emit('menu-hidden');
	            }
	          }, 40);
	        }
	
	        angular.element(document).off('click touchstart', applyHideMenu);
	        $elm.off('keyup', checkKeyUp);
	        $elm.off('keydown', checkKeyDown);
	      };
	
	      $scope.$on('hide-menu', function (event, args) {
	        $scope.hideMenu(event, args);
	      });
	
	      $scope.$on('show-menu', function (event, args) {
	        $scope.showMenu(event, args);
	      });
	
	
	    // *** Auto hide when click elsewhere ******
	      var applyHideMenu = function(){
	        if ($scope.shown) {
	          $scope.$apply(function () {
	            $scope.hideMenu();
	          });
	        }
	      };
	
	      // close menu on ESC and keep tab cyclical
	      var checkKeyUp = function(event) {
	        if (event.keyCode === 27) {
	          $scope.hideMenu();
	        }
	      };
	
	      var checkKeyDown = function(event) {
	        var setFocus = function(elm) {
	          elm.focus();
	          event.preventDefault();
	          return false;
	        };
	        if (event.keyCode === 9) {
	          var firstMenuItem, lastMenuItem;
	          var menuItemButtons = $elm[0].querySelectorAll('button:not(.ng-hide)');
	          if (menuItemButtons.length > 0) {
	            firstMenuItem = menuItemButtons[0];
	            lastMenuItem = menuItemButtons[menuItemButtons.length - 1];
	            if (event.target === lastMenuItem && !event.shiftKey) {
	              setFocus(firstMenuItem);
	            } else if (event.target === firstMenuItem && event.shiftKey) {
	              setFocus(lastMenuItem);
	            }
	          }
	        }
	      };
	
	      if (typeof($scope.autoHide) === 'undefined' || $scope.autoHide === undefined) {
	        $scope.autoHide = true;
	      }
	
	      if ($scope.autoHide) {
	        angular.element($window).on('resize', applyHideMenu);
	      }
	
	      $scope.$on('$destroy', function unbindEvents() {
	        angular.element($window).off('resize', applyHideMenu);
	        angular.element(document).off('click touchstart', applyHideMenu);
	        $elm.off('keyup', checkKeyUp);
	        $elm.off('keydown', checkKeyDown);
	      });
	
	      if (uiGridCtrl) {
	       $scope.$on('$destroy', uiGridCtrl.grid.api.core.on.scrollBegin($scope, applyHideMenu ));
	      }
	
	      $scope.$on('$destroy', $scope.$on(uiGridConstants.events.ITEM_DRAGGING, applyHideMenu ));
	    }
	  };
	
	  return uiGridMenu;
	}])
	
	.directive('uiGridMenuItem', ['gridUtil', '$compile', 'i18nService', function (gridUtil, $compile, i18nService) {
	  var uiGridMenuItem = {
	    priority: 0,
	    scope: {
	      name: '=',
	      active: '=',
	      action: '=',
	      icon: '=',
	      shown: '=',
	      context: '=',
	      templateUrl: '=',
	      leaveOpen: '=',
	      screenReaderOnly: '='
	    },
	    require: ['?^uiGrid'],
	    templateUrl: 'ui-grid/uiGridMenuItem',
	    replace: false,
	    compile: function() {
	      return {
	        pre: function ($scope, $elm) {
	          if ($scope.templateUrl) {
	            gridUtil.getTemplate($scope.templateUrl)
	                .then(function (contents) {
	                  var template = angular.element(contents);
	
	                  var newElm = $compile(template)($scope);
	                  $elm.replaceWith(newElm);
	                }).catch(angular.noop);
	          }
	        },
	        post: function ($scope, $elm, $attrs, controllers) {
	          var uiGridCtrl = controllers[0];
	
	          // TODO(c0bra): validate that shown and active are functions if they're defined. An exception is already thrown above this though
	          // if (typeof($scope.shown) !== 'undefined' && $scope.shown && typeof($scope.shown) !== 'function') {
	          //   throw new TypeError("$scope.shown is defined but not a function");
	          // }
	          if (typeof($scope.shown) === 'undefined' || $scope.shown === null) {
	            $scope.shown = function() { return true; };
	          }
	
	          $scope.itemShown = function () {
	            var context = {};
	            if ($scope.context) {
	              context.context = $scope.context;
	            }
	
	            if (typeof(uiGridCtrl) !== 'undefined' && uiGridCtrl) {
	              context.grid = uiGridCtrl.grid;
	            }
	
	            return $scope.shown.call(context);
	          };
	
	          $scope.itemAction = function($event,title) {
	            $event.stopPropagation();
	
	            if (typeof($scope.action) === 'function') {
	              var context = {};
	
	              if ($scope.context) {
	                context.context = $scope.context;
	              }
	
	              // Add the grid to the function call context if the uiGrid controller is present
	              if (typeof(uiGridCtrl) !== 'undefined' && uiGridCtrl) {
	                context.grid = uiGridCtrl.grid;
	              }
	
	              $scope.action.call(context, $event, title);
	
	              if ( !$scope.leaveOpen ){
	                $scope.$emit('hide-menu');
	              } else {
	                // Maintain focus on the selected item
	                var correctParent = $event.target.parentElement;
	
	                // nodeName of 'I' means target is i element, need the next parent
	                if (angular.element($event.target)[0].nodeName === 'I') {
	                  correctParent = correctParent.parentElement;
	                }
	
	                gridUtil.focus.bySelector(correctParent, 'button[type=button]', true);
	              }
	            }
	          };
	
	          $scope.label = function(){
	            var toBeDisplayed = $scope.name;
	
	            if (typeof($scope.name) === 'function'){
	              toBeDisplayed = $scope.name.call();
	            }
	
	            return toBeDisplayed;
	          };
	
	          $scope.i18n = i18nService.get();
	        }
	      };
	    }
	  };
	
	  return uiGridMenuItem;
	}]);
	
	})();
	
	(function(){
	  'use strict';
	  /**
	   * @ngdoc overview
	   * @name ui.grid.directive:uiGridOneBind
	   * @summary A group of directives that provide a one time bind to a dom element.
	   * @description A group of directives that provide a one time bind to a dom element.
	   * As one time bindings are not supported in Angular 1.2.* this directive provdes this capability.
	   * This is done to reduce the number of watchers on the dom.
	   * <br/>
	   * <h2>Short Example ({@link ui.grid.directive:uiGridOneBindSrc ui-grid-one-bind-src})</h2>
	   * <pre>
	        <div ng-init="imageName = 'myImageDir.jpg'">
	          <img ui-grid-one-bind-src="imageName"></img>
	        </div>
	     </pre>
	   * Will become:
	   * <pre>
	       <div ng-init="imageName = 'myImageDir.jpg'">
	         <img ui-grid-one-bind-src="imageName" src="myImageDir.jpg"></img>
	       </div>
	     </pre>
	     </br>
	     <h2>Short Example ({@link ui.grid.directive:uiGridOneBindText ui-grid-one-bind-text})</h2>
	   * <pre>
	        <div ng-init="text='Add this text'" ui-grid-one-bind-text="text"></div>
	     </pre>
	   * Will become:
	   * <pre>
	   <div ng-init="text='Add this text'" ui-grid-one-bind-text="text">Add this text</div>
	     </pre>
	     </br>
	   * <b>Note:</b> This behavior is slightly different for the {@link ui.grid.directive:uiGridOneBindIdGrid uiGridOneBindIdGrid}
	   * and {@link ui.grid.directive:uiGridOneBindAriaLabelledbyGrid uiGridOneBindAriaLabelledbyGrid} directives.
	   *
	   */
	  //https://github.com/joshkurz/Black-Belt-AngularJS-Directives/blob/master/directives/Optimization/oneBind.js
	  var oneBinders = angular.module('ui.grid');
	  angular.forEach([
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindSrc
	       * @memberof ui.grid.directive:uiGridOneBind
	       * @element img
	       * @restrict A
	       * @param {String} uiGridOneBindSrc The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the src dom tag.
	       *
	       */
	      {tag: 'Src', method: 'attr'},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindText
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindText The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the text dom tag.
	       */
	      {tag: 'Text', method: 'text'},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindHref
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindHref The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the href dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       */
	      {tag: 'Href', method: 'attr'},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindClass
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindClass The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @param {Object} uiGridOneBindClass The object that you want to bind. At least one of the values in the object must be something other than null or undefined for the watcher to be removed.
	       *                                    this is to prevent the watcher from being removed before the scope is initialized.
	       * @param {Array} uiGridOneBindClass An array of classes to bind to this element.
	       * @description One time binding for the class dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       */
	      {tag: 'Class', method: 'addClass'},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindHtml
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindHtml The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the html method on a dom element. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       */
	      {tag: 'Html', method: 'html'},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindAlt
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindAlt The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the alt dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       */
	      {tag: 'Alt', method: 'attr'},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindStyle
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindStyle The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the style dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       */
	      {tag: 'Style', method: 'css'},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindValue
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindValue The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the value dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       */
	      {tag: 'Value', method: 'attr'},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindId
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindId The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the value dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       */
	      {tag: 'Id', method: 'attr'},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindIdGrid
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindIdGrid The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the id dom tag.
	       * <h1>Important Note!</h1>
	       * If the id tag passed as a parameter does <b>not</b> contain the grid id as a substring
	       * then the directive will search the scope and the parent controller (if it is a uiGridController) for the grid.id value.
	       * If this value is found then it is appended to the begining of the id tag. If the grid is not found then the directive throws an error.
	       * This is done in order to ensure uniqueness of id tags across the grid.
	       * This is to prevent two grids in the same document having duplicate id tags.
	       */
	      {tag: 'Id', directiveName:'IdGrid', method: 'attr', appendGridId: true},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindTitle
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindTitle The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the title dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       */
	      {tag: 'Title', method: 'attr'},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindAriaLabel
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindAriaLabel The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the aria-label dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       *<br/>
	       * <pre>
	            <div ng-init="text='Add this text'" ui-grid-one-bind-aria-label="text"></div>
	         </pre>
	       * Will become:
	       * <pre>
	            <div ng-init="text='Add this text'" ui-grid-one-bind-aria-label="text" aria-label="Add this text"></div>
	         </pre>
	       */
	      {tag: 'Label', method: 'attr', aria:true},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindAriaLabelledby
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindAriaLabelledby The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the aria-labelledby dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       *<br/>
	       * <pre>
	            <div ng-init="anId = 'gridID32'" ui-grid-one-bind-aria-labelledby="anId"></div>
	         </pre>
	       * Will become:
	       * <pre>
	            <div ng-init="anId = 'gridID32'" ui-grid-one-bind-aria-labelledby="anId" aria-labelledby="gridID32"></div>
	         </pre>
	       */
	      {tag: 'Labelledby', method: 'attr', aria:true},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindAriaLabelledbyGrid
	       * @element div
	       * @restrict A
	       * @param {String} uiGridOneBindAriaLabelledbyGrid The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the aria-labelledby dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       * Works somewhat like {@link ui.grid.directive:uiGridOneBindIdGrid} however this one supports a list of ids (seperated by a space) and will dynamically add the
	       * grid id to each one.
	       *<br/>
	       * <pre>
	            <div ng-init="anId = 'gridID32'" ui-grid-one-bind-aria-labelledby-grid="anId"></div>
	         </pre>
	       * Will become ([grid.id] will be replaced by the actual grid id):
	       * <pre>
	            <div ng-init="anId = 'gridID32'" ui-grid-one-bind-aria-labelledby-grid="anId" aria-labelledby-Grid="[grid.id]-gridID32"></div>
	         </pre>
	       */
	      {tag: 'Labelledby', directiveName:'LabelledbyGrid', appendGridId:true, method: 'attr', aria:true},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindAriaDescribedby
	       * @element ANY
	       * @restrict A
	       * @param {String} uiGridOneBindAriaDescribedby The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the aria-describedby dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       *<br/>
	       * <pre>
	            <div ng-init="anId = 'gridID32'" ui-grid-one-bind-aria-describedby="anId"></div>
	         </pre>
	       * Will become:
	       * <pre>
	            <div ng-init="anId = 'gridID32'" ui-grid-one-bind-aria-describedby="anId" aria-describedby="gridID32"></div>
	         </pre>
	       */
	      {tag: 'Describedby', method: 'attr', aria:true},
	      /**
	       * @ngdoc directive
	       * @name ui.grid.directive:uiGridOneBindAriaDescribedbyGrid
	       * @element ANY
	       * @restrict A
	       * @param {String} uiGridOneBindAriaDescribedbyGrid The angular string you want to bind. Does not support interpolation. Don't use <code>{{scopeElt}}</code> instead use <code>scopeElt</code>.
	       * @description One time binding for the aria-labelledby dom tag. For more information see {@link ui.grid.directive:uiGridOneBind}.
	       * Works somewhat like {@link ui.grid.directive:uiGridOneBindIdGrid} however this one supports a list of ids (seperated by a space) and will dynamically add the
	       * grid id to each one.
	       *<br/>
	       * <pre>
	            <div ng-init="anId = 'gridID32'" ui-grid-one-bind-aria-describedby-grid="anId"></div>
	         </pre>
	       * Will become ([grid.id] will be replaced by the actual grid id):
	       * <pre>
	            <div ng-init="anId = 'gridID32'" ui-grid-one-bind-aria-describedby-grid="anId" aria-describedby="[grid.id]-gridID32"></div>
	         </pre>
	       */
	      {tag: 'Describedby', directiveName:'DescribedbyGrid', appendGridId:true, method: 'attr', aria:true}],
	    function(v){
	
	      var baseDirectiveName = 'uiGridOneBind';
	      //If it is an aria tag then append the aria label seperately
	      //This is done because the aria tags are formatted aria-* and the directive name can't have a '-' character in it.
	      //If the diretiveName has to be overridden then it does so here. This is because the tag being modified and the directive sometimes don't match up.
	      var directiveName = (v.aria ? baseDirectiveName + 'Aria' : baseDirectiveName) + (v.directiveName ? v.directiveName : v.tag);
	      oneBinders.directive(directiveName, ['gridUtil', function(gridUtil){
	        return {
	          restrict: 'A',
	          require: ['?uiGrid','?^uiGrid'],
	          link: function(scope, iElement, iAttrs, controllers){
	            /* Appends the grid id to the beginnig of the value. */
	            var appendGridId = function(val){
	              var grid; //Get an instance of the grid if its available
	              //If its available in the scope then we don't need to try to find it elsewhere
	              if (scope.grid) {
	                grid = scope.grid;
	              }
	              //Another possible location to try to find the grid
	              else if (scope.col && scope.col.grid){
	                grid = scope.col.grid;
	              }
	              //Last ditch effort: Search through the provided controllers.
	              else if (!controllers.some( //Go through the controllers till one has the element we need
	                function(controller){
	                  if (controller && controller.grid) {
	                    grid = controller.grid;
	                    return true; //We've found the grid
	                  }
	              })){
	                //We tried our best to find it for you
	                gridUtil.logError("["+directiveName+"] A valid grid could not be found to bind id. Are you using this directive " +
	                                 "within the correct scope? Trying to generate id: [gridID]-" + val);
	                throw new Error("No valid grid could be found");
	              }
	
	              if (grid){
	                var idRegex = new RegExp(grid.id.toString());
	                //If the grid id hasn't been appended already in the template declaration
	                if (!idRegex.test(val)){
	                  val = grid.id.toString() + '-' + val;
	                }
	              }
	              return val;
	            };
	
	            // The watch returns a function to remove itself.
	            var rmWatcher = scope.$watch(iAttrs[directiveName], function(newV){
	              if (newV){
	                //If we are trying to add an id element then we also apply the grid id if it isn't already there
	                if (v.appendGridId) {
	                  var newIdString = null;
	                  //Append the id to all of the new ids.
	                  angular.forEach( newV.split(' '), function(s){
	                    newIdString = (newIdString ? (newIdString + ' ') : '') +  appendGridId(s);
	                  });
	                  newV = newIdString;
	                }
	
	                // Append this newValue to the dom element.
	                switch (v.method) {
	                  case 'attr': //The attr method takes two paraams the tag and the value
	                    if (v.aria) {
	                      //If it is an aria element then append the aria prefix
	                      iElement[v.method]('aria-' + v.tag.toLowerCase(),newV);
	                    } else {
	                      iElement[v.method](v.tag.toLowerCase(),newV);
	                    }
	                    break;
	                  case 'addClass':
	                    //Pulled from https://github.com/Pasvaz/bindonce/blob/master/bindonce.js
	                    if (angular.isObject(newV) && !angular.isArray(newV)) {
	                      var results = [];
	                      var nonNullFound = false; //We don't want to remove the binding unless the key is actually defined
	                      angular.forEach(newV, function (value, index) {
	                        if (value !== null && typeof(value) !== "undefined"){
	                          nonNullFound = true; //A non null value for a key was found so the object must have been initialized
	                          if (value) {results.push(index);}
	                        }
	                      });
	                      //A non null value for a key wasn't found so assume that the scope values haven't been fully initialized
	                      if (!nonNullFound){
	                        return; // If not initialized then the watcher should not be removed yet.
	                      }
	                      newV = results;
	                    }
	
	                    if (newV) {
	                      iElement.addClass(angular.isArray(newV) ? newV.join(' ') : newV);
	                    } else {
	                      return;
	                    }
	                    break;
	                  default:
	                    iElement[v.method](newV);
	                    break;
	                }
	
	                //Removes the watcher on itself after the bind
	                rmWatcher();
	              }
	            // True ensures that equality is determined using angular.equals instead of ===
	            }, true); //End rm watchers
	          } //End compile function
	        }; //End directive return
	      } // End directive function
	    ]); //End directive
	  }); // End angular foreach
	})();
	
	(function () {
	  'use strict';
	
	  var module = angular.module('ui.grid');
	
	  module.directive('uiGridRenderContainer', ['$timeout', '$document', 'uiGridConstants', 'gridUtil', 'ScrollEvent',
	    function($timeout, $document, uiGridConstants, gridUtil, ScrollEvent) {
	    return {
	      replace: true,
	      transclude: true,
	      templateUrl: 'ui-grid/uiGridRenderContainer',
	      require: ['^uiGrid', 'uiGridRenderContainer'],
	      scope: {
	        containerId: '=',
	        rowContainerName: '=',
	        colContainerName: '=',
	        bindScrollHorizontal: '=',
	        bindScrollVertical: '=',
	        enableVerticalScrollbar: '=',
	        enableHorizontalScrollbar: '='
	      },
	      controller: 'uiGridRenderContainer as RenderContainer',
	      compile: function () {
	        return {
	          pre: function prelink($scope, $elm, $attrs, controllers) {
	
	            var uiGridCtrl = controllers[0];
	            var containerCtrl = controllers[1];
	            var grid = $scope.grid = uiGridCtrl.grid;
	
	            // Verify that the render container for this element exists
	            if (!$scope.rowContainerName) {
	              throw new Error("No row render container name specified");
	            }
	            if (!$scope.colContainerName) {
	              throw new Error("No column render container name specified");
	            }
	
	            if (!grid.renderContainers[$scope.rowContainerName]) {
	              throw new Error("Row render container '" + $scope.rowContainerName + "' is not registered.");
	            }
	            if (!grid.renderContainers[$scope.colContainerName]) {
	              throw new Error("Column render container '" + $scope.colContainerName + "' is not registered.");
	            }
	
	            var rowContainer = $scope.rowContainer = grid.renderContainers[$scope.rowContainerName];
	            var colContainer = $scope.colContainer = grid.renderContainers[$scope.colContainerName];
	
	            containerCtrl.containerId = $scope.containerId;
	            containerCtrl.rowContainer = rowContainer;
	            containerCtrl.colContainer = colContainer;
	          },
	          post: function postlink($scope, $elm, $attrs, controllers) {
	
	            var uiGridCtrl = controllers[0];
	            var containerCtrl = controllers[1];
	
	            var grid = uiGridCtrl.grid;
	            var rowContainer = containerCtrl.rowContainer;
	            var colContainer = containerCtrl.colContainer;
	            var scrollTop = null;
	            var scrollLeft = null;
	
	
	            var renderContainer = grid.renderContainers[$scope.containerId];
	
	            // Put the container name on this element as a class
	            $elm.addClass('ui-grid-render-container-' + $scope.containerId);
	
	            // Scroll the render container viewport when the mousewheel is used
	            gridUtil.on.mousewheel($elm, function (event) {
	              var scrollEvent = new ScrollEvent(grid, rowContainer, colContainer, ScrollEvent.Sources.RenderContainerMouseWheel);
	              if (event.deltaY !== 0) {
	                var scrollYAmount = event.deltaY * -1 * event.deltaFactor;
	
	                scrollTop = containerCtrl.viewport[0].scrollTop;
	
	                // Get the scroll percentage
	                scrollEvent.verticalScrollLength = rowContainer.getVerticalScrollLength();
	                var scrollYPercentage = (scrollTop + scrollYAmount) / scrollEvent.verticalScrollLength;
	
	                // If we should be scrolled 100%, make sure the scrollTop matches the maximum scroll length
	                //   Viewports that have "overflow: hidden" don't let the mousewheel scroll all the way to the bottom without this check
	                if (scrollYPercentage >= 1 && scrollTop < scrollEvent.verticalScrollLength) {
	                  containerCtrl.viewport[0].scrollTop = scrollEvent.verticalScrollLength;
	                }
	
	                // Keep scrollPercentage within the range 0-1.
	                if (scrollYPercentage < 0) { scrollYPercentage = 0; }
	                else if (scrollYPercentage > 1) { scrollYPercentage = 1; }
	
	                scrollEvent.y = { percentage: scrollYPercentage, pixels: scrollYAmount };
	              }
	              if (event.deltaX !== 0) {
	                var scrollXAmount = event.deltaX * event.deltaFactor;
	
	                // Get the scroll percentage
	                scrollLeft = gridUtil.normalizeScrollLeft(containerCtrl.viewport, grid);
	                scrollEvent.horizontalScrollLength = (colContainer.getCanvasWidth() - colContainer.getViewportWidth());
	                var scrollXPercentage = (scrollLeft + scrollXAmount) / scrollEvent.horizontalScrollLength;
	
	                // Keep scrollPercentage within the range 0-1.
	                if (scrollXPercentage < 0) { scrollXPercentage = 0; }
	                else if (scrollXPercentage > 1) { scrollXPercentage = 1; }
	
	                scrollEvent.x = { percentage: scrollXPercentage, pixels: scrollXAmount };
	              }
	
	              // Let the parent container scroll if the grid is already at the top/bottom
	              if ((event.deltaY !== 0 && (scrollEvent.atTop(scrollTop) || scrollEvent.atBottom(scrollTop))) ||
	                  (event.deltaX !== 0 && (scrollEvent.atLeft(scrollLeft) || scrollEvent.atRight(scrollLeft)))) {
	                //parent controller scrolls
	              }
	              else {
	                event.preventDefault();
	                event.stopPropagation();
	                scrollEvent.fireThrottledScrollingEvent('', scrollEvent);
	              }
	
	            });
	
	            $elm.bind('$destroy', function() {
	              $elm.unbind('keydown');
	
	              ['touchstart', 'touchmove', 'touchend','keydown', 'wheel', 'mousewheel', 'DomMouseScroll', 'MozMousePixelScroll'].forEach(function (eventName) {
	                $elm.unbind(eventName);
	              });
	            });
	
	            // TODO(c0bra): Handle resizing the inner canvas based on the number of elements
	            function update() {
	              var ret = '';
	
	              var canvasWidth = colContainer.canvasWidth;
	              var viewportWidth = colContainer.getViewportWidth();
	
	              var canvasHeight = rowContainer.getCanvasHeight();
	
	              //add additional height for scrollbar on left and right container
	              //if ($scope.containerId !== 'body') {
	              //  canvasHeight -= grid.scrollbarHeight;
	              //}
	
	              var viewportHeight = rowContainer.getViewportHeight();
	              //shorten the height to make room for a scrollbar placeholder
	              if (colContainer.needsHScrollbarPlaceholder()) {
	                viewportHeight -= grid.scrollbarHeight;
	              }
	
	              var headerViewportWidth,
	                  footerViewportWidth;
	              headerViewportWidth = footerViewportWidth = colContainer.getHeaderViewportWidth();
	
	              // Set canvas dimensions
	              ret += '\n .grid' + uiGridCtrl.grid.id + ' .ui-grid-render-container-' + $scope.containerId + ' .ui-grid-canvas { width: ' + canvasWidth + 'px; height: ' + canvasHeight + 'px; }';
	
	              ret += '\n .grid' + uiGridCtrl.grid.id + ' .ui-grid-render-container-' + $scope.containerId + ' .ui-grid-header-canvas { width: ' + (canvasWidth + grid.scrollbarWidth) + 'px; }';
	
	              if (renderContainer.explicitHeaderCanvasHeight) {
	                // get height from body container
	                var reHCHeight = document.querySelector(
	                  '.grid' + uiGridCtrl.grid.id + ' .ui-grid-render-container-body .ui-grid-header-canvas');
	
	                if (reHCHeight) {
	                  renderContainer.explicitHeaderCanvasHeight = reHCHeight.offsetHeight;
	                }
	
	                ret += '\n .grid' + uiGridCtrl.grid.id + ' .ui-grid-render-container-' + $scope.containerId +
	                  ' .ui-grid-header-canvas { height: ' + renderContainer.explicitHeaderCanvasHeight + 'px; }';
	              }
	              else {
	                ret += '\n .grid' + uiGridCtrl.grid.id + ' .ui-grid-render-container-' + $scope.containerId + ' .ui-grid-header-canvas { height: inherit; }';
	              }
	  
	              ret += '\n .grid' + uiGridCtrl.grid.id + ' .ui-grid-render-container-' + $scope.containerId +
	                ' .ui-grid-viewport { width: ' + viewportWidth + 'px; height: ' + viewportHeight + 'px; }';
	              ret += '\n .grid' + uiGridCtrl.grid.id + ' .ui-grid-render-container-' + $scope.containerId +
	                ' .ui-grid-header-viewport { width: ' + headerViewportWidth + 'px; }';
	
	              ret += '\n .grid' + uiGridCtrl.grid.id + ' .ui-grid-render-container-' + $scope.containerId +
	                ' .ui-grid-footer-canvas { width: ' + (canvasWidth + grid.scrollbarWidth) + 'px; }';
	              ret += '\n .grid' + uiGridCtrl.grid.id + ' .ui-grid-render-container-' + $scope.containerId +
	                ' .ui-grid-footer-viewport { width: ' + footerViewportWidth + 'px; }';
	
	              return ret;
	            }
	
	            uiGridCtrl.grid.registerStyleComputation({
	              priority: 6,
	              func: update
	            });
	          }
	        };
	      }
	    };
	
	  }]);
	
	  module.controller('uiGridRenderContainer', ['$scope', 'gridUtil', function ($scope, gridUtil) {
	
	  }]);
	
	})();
	
	(function(){
	  'use strict';
	
	  angular.module('ui.grid').directive('uiGridRow', ['gridUtil', function(gridUtil) {
	    return {
	      replace: true,
	      // priority: 2001,
	      // templateUrl: 'ui-grid/ui-grid-row',
	      require: ['^uiGrid', '^uiGridRenderContainer'],
	      scope: {
	         row: '=uiGridRow',
	         //rowRenderIndex is added to scope to give the true visual index of the row to any directives that need it
	         rowRenderIndex: '='
	      },
	      compile: function() {
	        return {
	          pre: function($scope, $elm, $attrs, controllers) {
	            var uiGridCtrl = controllers[0];
	            var containerCtrl = controllers[1];
	
	            var grid = uiGridCtrl.grid;
	
	            $scope.grid = uiGridCtrl.grid;
	            $scope.colContainer = containerCtrl.colContainer;
	
	            // Function for attaching the template to this scope
	            var clonedElement, cloneScope;
	            function compileTemplate() {
	              $scope.row.getRowTemplateFn.then(function (compiledElementFn) {
	                // var compiledElementFn = $scope.row.compiledElementFn;
	
	                // Create a new scope for the contents of this row, so we can destroy it later if need be
	                var newScope = $scope.$new();
	
	                compiledElementFn(newScope, function (newElm, scope) {
	                  // If we already have a cloned element, we need to remove it and destroy its scope
	                  if (clonedElement) {
	                    clonedElement.remove();
	                    cloneScope.$destroy();
	                  }
	
	                  // Empty the row and append the new element
	                  $elm.empty().append(newElm);
	
	                  // Save the new cloned element and scope
	                  clonedElement = newElm;
	                  cloneScope = newScope;
	                });
	              }).catch(angular.noop);
	            }
	
	            // Initially attach the compiled template to this scope
	            compileTemplate();
	
	            // If the row's compiled element function changes, we need to replace this element's contents with the new compiled template
	            $scope.$watch('row.getRowTemplateFn', function (newFunc, oldFunc) {
	              if (newFunc !== oldFunc) {
	                compileTemplate();
	              }
	            });
	          },
	          post: function($scope, $elm, $attrs, controllers) {
	
	          }
	        };
	      }
	    };
	  }]);
	
	})();
	
	(function(){
	// 'use strict';
	
	  /**
	   * @ngdoc directive
	   * @name ui.grid.directive:uiGridStyle
	   * @element style
	   * @restrict A
	   *
	   * @description
	   * Allows us to interpolate expressions in `<style>` elements. Angular doesn't do this by default as it can/will/might? break in IE8.
	   *
	   * @example
	   <doc:example module="app">
	   <doc:source>
	   <script>
	   var app = angular.module('app', ['ui.grid']);
	
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	          $scope.myStyle = '.blah { border: 1px solid }';
	        }]);
	   </script>
	
	   <div ng-controller="MainCtrl">
	   <style ui-grid-style>{{ myStyle }}</style>
	   <span class="blah">I am in a box.</span>
	   </div>
	   </doc:source>
	   <doc:scenario>
	      it('should apply the right class to the element', function () {
	        element(by.css('.blah')).getCssValue('border-top-width')
	          .then(function(c) {
	            expect(c).toContain('1px');
	          });
	      });
	   </doc:scenario>
	   </doc:example>
	   */
	
	
	  angular.module('ui.grid').directive('uiGridStyle', ['gridUtil', '$interpolate', function(gridUtil, $interpolate) {
	    return {
	      // restrict: 'A',
	      // priority: 1000,
	      // require: '?^uiGrid',
	      link: function($scope, $elm, $attrs, uiGridCtrl) {
	        // gridUtil.logDebug('ui-grid-style link');
	        // if (uiGridCtrl === undefined) {
	        //    gridUtil.logWarn('[ui-grid-style link] uiGridCtrl is undefined!');
	        // }
	
	        var interpolateFn = $interpolate($elm.text(), true);
	
	        if (interpolateFn) {
	          $scope.$watch(interpolateFn, function(value) {
	            $elm.text(value);
	          });
	        }
	
	          // uiGridCtrl.recalcRowStyles = function() {
	          //   var offset = (scope.options.offsetTop || 0) - (scope.options.excessRows * scope.options.rowHeight);
	          //   var rowHeight = scope.options.rowHeight;
	
	          //   var ret = '';
	          //   var rowStyleCount = uiGridCtrl.minRowsToRender() + (scope.options.excessRows * 2);
	          //   for (var i = 1; i <= rowStyleCount; i++) {
	          //     ret = ret + ' .grid' + scope.gridId + ' .ui-grid-row:nth-child(' + i + ') { top: ' + offset + 'px; }';
	          //     offset = offset + rowHeight;
	          //   }
	
	          //   scope.rowStyles = ret;
	          // };
	
	          // uiGridCtrl.styleComputions.push(uiGridCtrl.recalcRowStyles);
	
	      }
	    };
	  }]);
	
	})();
	
	(function(){
	  'use strict';
	
	  angular.module('ui.grid').directive('uiGridViewport', ['gridUtil','ScrollEvent','uiGridConstants', '$log',
	    function(gridUtil, ScrollEvent, uiGridConstants, $log) {
	      return {
	        replace: true,
	        scope: {},
	        controllerAs: 'Viewport',
	        templateUrl: 'ui-grid/uiGridViewport',
	        require: ['^uiGrid', '^uiGridRenderContainer'],
	        link: function($scope, $elm, $attrs, controllers) {
	          // gridUtil.logDebug('viewport post-link');
	
	          var uiGridCtrl = controllers[0];
	          var containerCtrl = controllers[1];
	
	          $scope.containerCtrl = containerCtrl;
	
	          var rowContainer = containerCtrl.rowContainer;
	          var colContainer = containerCtrl.colContainer;
	
	          var grid = uiGridCtrl.grid;
	
	          $scope.grid = uiGridCtrl.grid;
	
	          // Put the containers in scope so we can get rows and columns from them
	          $scope.rowContainer = containerCtrl.rowContainer;
	          $scope.colContainer = containerCtrl.colContainer;
	
	          // Register this viewport with its container
	          containerCtrl.viewport = $elm;
	
	          /**
	           * @ngdoc function
	           * @name customScroller
	           * @methodOf ui.grid.class:GridOptions
	           * @description (optional) uiGridViewport.on('scroll', scrollHandler) by default.
	           * A function that allows you to provide your own scroller function. It is particularly helpful if you want to use third party scrollers
	           * as this allows you to do that.
	           *
	           * <div class="alert alert-info" role="alert"> <strong>NOTE:</strong> It is important to remember to always pass in an event object to
	           * the scrollHandler as the grid scrolling behavior will break without it.</div>
	           * <h5>Example</h5>
	           * <pre>
	           *   $scope.gridOptions = {
	           *       customScroller: function myScrolling(uiGridViewport, scrollHandler) {
	           *           uiGridViewport.on('scroll', function myScrollingOverride(event) {
	           *               // Do something here
	           *
	           *               scrollHandler(event);
	           *           });
	           *       }
	           *   };
	           * </pre>
	           * @param {object} uiGridViewport Element being scrolled. (this gets passed in by the grid).
	           * @param {function} scrollHandler Function that needs to be called when scrolling happens. (this gets passed in by the grid).
	           */
	          if (grid && grid.options && grid.options.customScroller) {
	            grid.options.customScroller($elm, scrollHandler);
	          } else {
	            $elm.on('scroll', scrollHandler);
	          }
	
	          var ignoreScroll = false;
	
	          function scrollHandler(evt) {
	            //Leaving in this commented code in case it can someday be used
	            //It does improve performance, but because the horizontal scroll is normalized,
	            //  using this code will lead to the column header getting slightly out of line with columns
	            //
	            //if (ignoreScroll && (grid.isScrollingHorizontally || grid.isScrollingHorizontally)) {
	            //  //don't ask for scrollTop if we just set it
	            //  ignoreScroll = false;
	            //  return;
	            //}
	            //ignoreScroll = true;
	
	            var newScrollTop = $elm[0].scrollTop;
	            var newScrollLeft = gridUtil.normalizeScrollLeft($elm, grid);
	
	            var vertScrollPercentage = rowContainer.scrollVertical(newScrollTop);
	            var horizScrollPercentage = colContainer.scrollHorizontal(newScrollLeft);
	
	            var scrollEvent = new ScrollEvent(grid, rowContainer, colContainer, ScrollEvent.Sources.ViewPortScroll);
	            scrollEvent.newScrollLeft = newScrollLeft;
	            scrollEvent.newScrollTop = newScrollTop;
	            if ( horizScrollPercentage > -1 ){
	              scrollEvent.x = { percentage: horizScrollPercentage };
	            }
	
	            if ( vertScrollPercentage > -1 ){
	              scrollEvent.y = { percentage: vertScrollPercentage };
	            }
	
	            grid.scrollContainers($scope.$parent.containerId, scrollEvent);
	          }
	
	          if ($scope.$parent.bindScrollVertical) {
	            grid.addVerticalScrollSync($scope.$parent.containerId, syncVerticalScroll);
	          }
	
	          if ($scope.$parent.bindScrollHorizontal) {
	            grid.addHorizontalScrollSync($scope.$parent.containerId, syncHorizontalScroll);
	            grid.addHorizontalScrollSync($scope.$parent.containerId + 'header', syncHorizontalHeader);
	            grid.addHorizontalScrollSync($scope.$parent.containerId + 'footer', syncHorizontalFooter);
	          }
	
	          function syncVerticalScroll(scrollEvent){
	            containerCtrl.prevScrollArgs = scrollEvent;
	            var newScrollTop = scrollEvent.getNewScrollTop(rowContainer,containerCtrl.viewport);
	            $elm[0].scrollTop = newScrollTop;
	
	          }
	
	          function syncHorizontalScroll(scrollEvent){
	            containerCtrl.prevScrollArgs = scrollEvent;
	            var newScrollLeft = scrollEvent.getNewScrollLeft(colContainer, containerCtrl.viewport);
	            $elm[0].scrollLeft =  gridUtil.denormalizeScrollLeft(containerCtrl.viewport,newScrollLeft, grid);
	          }
	
	          function syncHorizontalHeader(scrollEvent){
	            var newScrollLeft = scrollEvent.getNewScrollLeft(colContainer, containerCtrl.viewport);
	            if (containerCtrl.headerViewport) {
	              containerCtrl.headerViewport.scrollLeft = gridUtil.denormalizeScrollLeft(containerCtrl.viewport,newScrollLeft, grid);
	            }
	          }
	
	          function syncHorizontalFooter(scrollEvent){
	            var newScrollLeft = scrollEvent.getNewScrollLeft(colContainer, containerCtrl.viewport);
	            if (containerCtrl.footerViewport) {
	              containerCtrl.footerViewport.scrollLeft =  gridUtil.denormalizeScrollLeft(containerCtrl.viewport,newScrollLeft, grid);
	            }
	          }
	
	          $scope.$on('$destroy', function unbindEvents() {
	            $elm.off();
	          });
	        },
	        controller: ['$scope', function ($scope) {
	          this.rowStyle = function (index) {
	            var rowContainer = $scope.rowContainer;
	            var colContainer = $scope.colContainer;
	
	            var styles = {};
	
	            if (rowContainer.currentTopRow !== 0){
	              //top offset based on hidden rows count
	              var translateY = "translateY("+ (rowContainer.currentTopRow * rowContainer.grid.options.rowHeight)  +"px)";
	              styles['transform'] = translateY;
	              styles['-webkit-transform'] = translateY;
	              styles['-ms-transform'] = translateY;
	            }
	
	            if (colContainer.currentFirstColumn !== 0) {
	              if (colContainer.grid.isRTL()) {
	                styles['margin-right'] = colContainer.columnOffset + 'px';
	              }
	              else {
	                styles['margin-left'] = colContainer.columnOffset + 'px';
	              }
	            }
	
	            return styles;
	          };
	        }]
	      };
	    }
	  ]);
	
	})();
	
	(function() {
	
	angular.module('ui.grid')
	.directive('uiGridVisible', function uiGridVisibleAction() {
	  return function ($scope, $elm, $attr) {
	    $scope.$watch($attr.uiGridVisible, function (visible) {
	        // $elm.css('visibility', visible ? 'visible' : 'hidden');
	        $elm[visible ? 'removeClass' : 'addClass']('ui-grid-invisible');
	    });
	  };
	});
	
	})();
	(function () {
	  'use strict';
	
	  angular.module('ui.grid').controller('uiGridController', ['$scope', '$element', '$attrs', 'gridUtil', '$q', 'uiGridConstants',
	                    'gridClassFactory', '$parse', '$compile',
	    function ($scope, $elm, $attrs, gridUtil, $q, uiGridConstants,
	              gridClassFactory, $parse, $compile) {
	      // gridUtil.logDebug('ui-grid controller');
	      var self = this;
	      var deregFunctions = [];
	
	      self.grid = gridClassFactory.createGrid($scope.uiGrid);
	
	      //assign $scope.$parent if appScope not already assigned
	      self.grid.appScope = self.grid.appScope || $scope.$parent;
	
	      $elm.addClass('grid' + self.grid.id);
	      self.grid.rtl = gridUtil.getStyles($elm[0])['direction'] === 'rtl';
	
	
	      // angular.extend(self.grid.options, );
	
	      //all properties of grid are available on scope
	      $scope.grid = self.grid;
	
	      if ($attrs.uiGridColumns) {
	        deregFunctions.push( $attrs.$observe('uiGridColumns', function(value) {
	          self.grid.options.columnDefs = angular.isString(value) ? angular.fromJson(value) : value;
	          self.grid.buildColumns()
	            .then(function(){
	              self.grid.preCompileCellTemplates();
	
	              self.grid.refreshCanvas(true);
	            }).catch(angular.noop);
	        }) );
	      }
	
	      // prevents an error from being thrown when the array is not defined yet and fastWatch is on
	      function getSize(array) {
	        return array ? array.length : 0;
	      }
	
	      // if fastWatch is set we watch only the length and the reference, not every individual object
	      if (self.grid.options.fastWatch) {
	        self.uiGrid = $scope.uiGrid;
	        if (angular.isString($scope.uiGrid.data)) {
	          deregFunctions.push( $scope.$parent.$watch($scope.uiGrid.data, dataWatchFunction) );
	          deregFunctions.push( $scope.$parent.$watch(function() {
	            if ( self.grid.appScope[$scope.uiGrid.data] ){
	              return self.grid.appScope[$scope.uiGrid.data].length;
	            } else {
	              return undefined;
	            }
	          }, dataWatchFunction) );
	        } else {
	          deregFunctions.push( $scope.$parent.$watch(function() { return $scope.uiGrid.data; }, dataWatchFunction) );
	          deregFunctions.push( $scope.$parent.$watch(function() { return getSize($scope.uiGrid.data); }, function(){ dataWatchFunction($scope.uiGrid.data); }) );
	        }
	        deregFunctions.push( $scope.$parent.$watch(function() { return $scope.uiGrid.columnDefs; }, columnDefsWatchFunction) );
	        deregFunctions.push( $scope.$parent.$watch(function() { return getSize($scope.uiGrid.columnDefs); }, function(){ columnDefsWatchFunction($scope.uiGrid.columnDefs); }) );
	      } else {
	        if (angular.isString($scope.uiGrid.data)) {
	          deregFunctions.push( $scope.$parent.$watchCollection($scope.uiGrid.data, dataWatchFunction) );
	        } else {
	          deregFunctions.push( $scope.$parent.$watchCollection(function() { return $scope.uiGrid.data; }, dataWatchFunction) );
	        }
	        deregFunctions.push( $scope.$parent.$watchCollection(function() { return $scope.uiGrid.columnDefs; }, columnDefsWatchFunction) );
	      }
	
	
	      function columnDefsWatchFunction(n, o) {
	        if (n && n !== o) {
	          self.grid.options.columnDefs = $scope.uiGrid.columnDefs;
	          self.grid.callDataChangeCallbacks(uiGridConstants.dataChange.COLUMN, {
	            orderByColumnDefs: true,
	            preCompileCellTemplates: true
	          });
	        }
	      }
	
	      var mostRecentData;
	
	      function dataWatchFunction(newData) {
	        // gridUtil.logDebug('dataWatch fired');
	        var promises = [];
	
	        if ( self.grid.options.fastWatch ) {
	          if (angular.isString($scope.uiGrid.data)) {
	            newData = self.grid.appScope.$eval($scope.uiGrid.data);
	          } else {
	            newData = $scope.uiGrid.data;
	          }
	        }
	
	        mostRecentData = newData;
	
	        if (newData) {
	          // columns length is greater than the number of row header columns, which don't count because they're created automatically
	          var hasColumns = self.grid.columns.length > (self.grid.rowHeaderColumns ? self.grid.rowHeaderColumns.length : 0);
	
	          if (
	            // If we have no columns
	            !hasColumns &&
	            // ... and we don't have a ui-grid-columns attribute, which would define columns for us
	            !$attrs.uiGridColumns &&
	            // ... and we have no pre-defined columns
	            self.grid.options.columnDefs.length === 0 &&
	            // ... but we DO have data
	            newData.length > 0
	          ) {
	            // ... then build the column definitions from the data that we have
	            self.grid.buildColumnDefsFromData(newData);
	          }
	
	          // If we haven't built columns before and either have some columns defined or some data defined
	          if (!hasColumns && (self.grid.options.columnDefs.length > 0 || newData.length > 0)) {
	            // Build the column set, then pre-compile the column cell templates
	            promises.push(self.grid.buildColumns()
	              .then(function() {
	                self.grid.preCompileCellTemplates();
	              }).catch(angular.noop));
	          }
	
	          $q.all(promises).then(function() {
	            // use most recent data, rather than the potentially outdated data passed into watcher handler
	            self.grid.modifyRows(mostRecentData)
	              .then(function () {
	                // if (self.viewport) {
	                  self.grid.redrawInPlace(true);
	                // }
	
	                $scope.$evalAsync(function() {
	                  self.grid.refreshCanvas(true);
	                  self.grid.callDataChangeCallbacks(uiGridConstants.dataChange.ROW);
	                });
	              }).catch(angular.noop);
	          }).catch(angular.noop);
	        }
	      }
	
	      var styleWatchDereg = $scope.$watch(function () { return self.grid.styleComputations; }, function() {
	        self.grid.refreshCanvas(true);
	      });
	
	      $scope.$on('$destroy', function() {
	        deregFunctions.forEach( function( deregFn ){ deregFn(); });
	        styleWatchDereg();
	      });
	
	      self.fireEvent = function(eventName, args) {
	        args = args || {};
	
	        // Add the grid to the event arguments if it's not there
	        if (angular.isUndefined(args.grid)) {
	          args.grid = self.grid;
	        }
	
	        $scope.$broadcast(eventName, args);
	      };
	
	      self.innerCompile = function innerCompile(elm) {
	        $compile(elm)($scope);
	      };
	    }]);
	
	/**
	 *  @ngdoc directive
	 *  @name ui.grid.directive:uiGrid
	 *  @element div
	 *  @restrict EA
	 *  @param {Object} uiGrid Options for the grid to use
	 *
	 *  @description Create a very basic grid.
	 *
	 *  @example
	    <example module="app">
	      <file name="app.js">
	        var app = angular.module('app', ['ui.grid']);
	
	        app.controller('MainCtrl', ['$scope', function ($scope) {
	          $scope.data = [
	            { name: 'Bob', title: 'CEO' },
	            { name: 'Frank', title: 'Lowly Developer' }
	          ];
	        }]);
	      </file>
	      <file name="index.html">
	        <div ng-controller="MainCtrl">
	          <div ui-grid="{ data: data }"></div>
	        </div>
	      </file>
	    </example>
	 */
	angular.module('ui.grid').directive('uiGrid', uiGridDirective);
	
	uiGridDirective.$inject = ['$window', 'gridUtil', 'uiGridConstants'];
	function uiGridDirective($window, gridUtil, uiGridConstants) {
	  return {
	    templateUrl: 'ui-grid/ui-grid',
	    scope: {
	      uiGrid: '='
	    },
	    replace: true,
	    transclude: true,
	    controller: 'uiGridController',
	    compile: function () {
	      return {
	        post: function ($scope, $elm, $attrs, uiGridCtrl) {
	          var grid = uiGridCtrl.grid;
	          // Initialize scrollbars (TODO: move to controller??)
	          uiGridCtrl.scrollbars = [];
	          grid.element = $elm;
	
	
	          // See if the grid has a rendered width, if not, wait a bit and try again
	          var sizeCheckInterval = 100; // ms
	          var maxSizeChecks = 20; // 2 seconds total
	          var sizeChecks = 0;
	
	          // Setup (event listeners) the grid
	          setup();
	
	          // And initialize it
	          init();
	
	          // Mark rendering complete so API events can happen
	          grid.renderingComplete();
	
	          // If the grid doesn't have size currently, wait for a bit to see if it gets size
	          checkSize();
	
	          /*-- Methods --*/
	
	          function checkSize() {
	            // If the grid has no width and we haven't checked more than <maxSizeChecks> times, check again in <sizeCheckInterval> milliseconds
	            if ($elm[0].offsetWidth <= 0 && sizeChecks < maxSizeChecks) {
	              setTimeout(checkSize, sizeCheckInterval);
	              sizeChecks++;
	            } else {
	              $scope.$applyAsync(init);
	            }
	          }
	
	          // Setup event listeners and watchers
	          function setup() {
	            var deregisterLeftWatcher, deregisterRightWatcher;
	
	            // Bind to window resize events
	            angular.element($window).on('resize', gridResize);
	
	            // Unbind from window resize events when the grid is destroyed
	            $elm.on('$destroy', function () {
	              angular.element($window).off('resize', gridResize);
	              deregisterLeftWatcher();
	              deregisterRightWatcher();
	            });
	
	            // If we add a left container after render, we need to watch and react
	            deregisterLeftWatcher = $scope.$watch(function () { return grid.hasLeftContainer();}, function (newValue, oldValue) {
	              if (newValue === oldValue) {
	                return;
	              }
	              grid.refreshCanvas(true);
	            });
	
	            // If we add a right container after render, we need to watch and react
	            deregisterRightWatcher = $scope.$watch(function () { return grid.hasRightContainer();}, function (newValue, oldValue) {
	              if (newValue === oldValue) {
	                return;
	              }
	              grid.refreshCanvas(true);
	            });
	          }
	
	          // Initialize the directive
	          function init() {
	            grid.gridWidth = $scope.gridWidth = gridUtil.elementWidth($elm);
	
	            // Default canvasWidth to the grid width, in case we don't get any column definitions to calculate it from
	            grid.canvasWidth = uiGridCtrl.grid.gridWidth;
	
	            grid.gridHeight = $scope.gridHeight = gridUtil.elementHeight($elm);
	
	            // If the grid isn't tall enough to fit a single row, it's kind of useless. Resize it to fit a minimum number of rows
	            if (grid.gridHeight - grid.scrollbarHeight <= grid.options.rowHeight && grid.options.enableMinHeightCheck) {
	              autoAdjustHeight();
	            }
	
	            // Run initial canvas refresh
	            grid.refreshCanvas(true);
	          }
	
	          // Set the grid's height ourselves in the case that its height would be unusably small
	          function autoAdjustHeight() {
	            // Figure out the new height
	            var contentHeight = grid.options.minRowsToShow * grid.options.rowHeight;
	            var headerHeight = grid.options.showHeader ? grid.options.headerRowHeight : 0;
	            var footerHeight = grid.calcFooterHeight();
	
	            var scrollbarHeight = 0;
	            if (grid.options.enableHorizontalScrollbar === uiGridConstants.scrollbars.ALWAYS) {
	              scrollbarHeight = gridUtil.getScrollbarWidth();
	            }
	
	            var maxNumberOfFilters = 0;
	            // Calculates the maximum number of filters in the columns
	            angular.forEach(grid.options.columnDefs, function(col) {
	              if (col.hasOwnProperty('filter')) {
	                if (maxNumberOfFilters < 1) {
	                    maxNumberOfFilters = 1;
	                }
	              }
	              else if (col.hasOwnProperty('filters')) {
	                if (maxNumberOfFilters < col.filters.length) {
	                    maxNumberOfFilters = col.filters.length;
	                }
	              }
	            });
	
	            if (grid.options.enableFiltering  && !maxNumberOfFilters) {
	              var allColumnsHaveFilteringTurnedOff = grid.options.columnDefs.length && grid.options.columnDefs.every(function(col) {
	                return col.enableFiltering === false;
	              });
	
	              if (!allColumnsHaveFilteringTurnedOff) {
	                maxNumberOfFilters = 1;
	              }
	            }
	
	            var filterHeight = maxNumberOfFilters * headerHeight;
	
	            var newHeight = headerHeight + contentHeight + footerHeight + scrollbarHeight + filterHeight;
	
	            $elm.css('height', newHeight + 'px');
	
	            grid.gridHeight = $scope.gridHeight = gridUtil.elementHeight($elm);
	          }
	
	          // Resize the grid on window resize events
	          function gridResize() {
	            grid.gridWidth = $scope.gridWidth = gridUtil.elementWidth($elm);
	            grid.gridHeight = $scope.gridHeight = gridUtil.elementHeight($elm);
	
	            grid.refreshCanvas(true);
	          }
	        }
	      };
	    }
	  };
	}
	})();
	
	(function(){
	  'use strict';
	
	  // TODO: rename this file to ui-grid-pinned-container.js
	
	  angular.module('ui.grid').directive('uiGridPinnedContainer', ['gridUtil', function (gridUtil) {
	    return {
	      restrict: 'EA',
	      replace: true,
	      template: '<div class="ui-grid-pinned-container"><div ui-grid-render-container container-id="side" row-container-name="\'body\'" col-container-name="side" bind-scroll-vertical="true" class="{{ side }} ui-grid-render-container-{{ side }}"></div></div>',
	      scope: {
	        side: '=uiGridPinnedContainer'
	      },
	      require: '^uiGrid',
	      compile: function compile() {
	        return {
	          post: function ($scope, $elm, $attrs, uiGridCtrl) {
	            // gridUtil.logDebug('ui-grid-pinned-container ' + $scope.side + ' link');
	
	            var grid = uiGridCtrl.grid;
	
	            var myWidth = 0;
	
	            $elm.addClass('ui-grid-pinned-container-' + $scope.side);
	
	            // Monkey-patch the viewport width function
	            if ($scope.side === 'left' || $scope.side === 'right') {
	              grid.renderContainers[$scope.side].getViewportWidth = monkeyPatchedGetViewportWidth;
	            }
	
	            function monkeyPatchedGetViewportWidth() {
	              /*jshint validthis: true */
	              var self = this;
	
	              var viewportWidth = 0;
	              self.visibleColumnCache.forEach(function (column) {
	                viewportWidth += column.drawnWidth;
	              });
	
	              var adjustment = self.getViewportAdjustment();
	
	              viewportWidth = viewportWidth + adjustment.width;
	
	              return viewportWidth;
	            }
	
	            function updateContainerWidth() {
	              if ($scope.side === 'left' || $scope.side === 'right') {
	                var cols = grid.renderContainers[$scope.side].visibleColumnCache;
	                var width = 0;
	                for (var i = 0; i < cols.length; i++) {
	                  var col = cols[i];
	                  width += col.drawnWidth || col.width || 0;
	                }
	
	                return width;
	              }
	            }
	
	            function updateContainerDimensions() {
	              var ret = '';
	
	              // Column containers
	              if ($scope.side === 'left' || $scope.side === 'right') {
	                myWidth = updateContainerWidth();
	
	                // gridUtil.logDebug('myWidth', myWidth);
	
	                // TODO(c0bra): Subtract sum of col widths from grid viewport width and update it
	                $elm.attr('style', null);
	
	             //   var myHeight = grid.renderContainers.body.getViewportHeight(); // + grid.horizontalScrollbarHeight;
	
	                ret += '.grid' + grid.id + ' .ui-grid-pinned-container-' + $scope.side + ', .grid' + grid.id + ' .ui-grid-pinned-container-' + $scope.side + ' .ui-grid-render-container-' + $scope.side + ' .ui-grid-viewport { width: ' + myWidth + 'px; } ';
	              }
	
	              return ret;
	            }
	
	            grid.renderContainers.body.registerViewportAdjuster(function (adjustment) {
	              myWidth = updateContainerWidth();
	
	              // Subtract our own width
	              adjustment.width -= myWidth;
	              adjustment.side = $scope.side;
	
	              return adjustment;
	            });
	
	            // Register style computation to adjust for columns in `side`'s render container
	            grid.registerStyleComputation({
	              priority: 15,
	              func: updateContainerDimensions
	            });
	          }
	        };
	      }
	    };
	  }]);
	})();
	
	(function(){
	
	angular.module('ui.grid')
	.factory('Grid', ['$q', '$compile', '$parse', 'gridUtil', 'uiGridConstants', 'GridOptions', 'GridColumn', 'GridRow', 'GridApi', 'rowSorter', 'rowSearcher', 'GridRenderContainer', '$timeout','ScrollEvent',
	    function($q, $compile, $parse, gridUtil, uiGridConstants, GridOptions, GridColumn, GridRow, GridApi, rowSorter, rowSearcher, GridRenderContainer, $timeout, ScrollEvent) {
	
	  /**
	   * @ngdoc object
	   * @name ui.grid.core.api:PublicApi
	   * @description Public Api for the core grid features
	   *
	   */
	
	  /**
	   * @ngdoc function
	   * @name ui.grid.class:Grid
	   * @description Grid is the main viewModel.  Any properties or methods needed to maintain state are defined in
	   * this prototype.  One instance of Grid is created per Grid directive instance.
	   * @param {object} options Object map of options to pass into the grid. An 'id' property is expected.
	   */
	  var Grid = function Grid(options) {
	    var self = this;
	    // Get the id out of the options, then remove it
	    if (options !== undefined && typeof(options.id) !== 'undefined' && options.id) {
	      if (!/^[_a-zA-Z0-9-]+$/.test(options.id)) {
	        throw new Error("Grid id '" + options.id + '" is invalid. It must follow CSS selector syntax rules.');
	      }
	    }
	    else {
	      throw new Error('No ID provided. An ID must be given when creating a grid.');
	    }
	
	    self.id = options.id;
	    delete options.id;
	
	    // Get default options
	    self.options = GridOptions.initialize( options );
	
	    /**
	     * @ngdoc object
	     * @name appScope
	     * @propertyOf ui.grid.class:Grid
	     * @description reference to the application scope (the parent scope of the ui-grid element).  Assigned in ui-grid controller
	     * <br/>
	     * use gridOptions.appScopeProvider to override the default assignment of $scope.$parent with any reference
	     */
	    self.appScope = self.options.appScopeProvider;
	
	    self.headerHeight = self.options.headerRowHeight;
	
	
	    /**
	     * @ngdoc object
	     * @name footerHeight
	     * @propertyOf ui.grid.class:Grid
	     * @description returns the total footer height gridFooter + columnFooter
	     */
	    self.footerHeight = self.calcFooterHeight();
	
	
	    /**
	     * @ngdoc object
	     * @name columnFooterHeight
	     * @propertyOf ui.grid.class:Grid
	     * @description returns the total column footer height
	     */
	    self.columnFooterHeight = self.calcColumnFooterHeight();
	
	    self.rtl = false;
	    self.gridHeight = 0;
	    self.gridWidth = 0;
	    self.columnBuilders = [];
	    self.rowBuilders = [];
	    self.rowsProcessors = [];
	    self.columnsProcessors = [];
	    self.styleComputations = [];
	    self.viewportAdjusters = [];
	    self.rowHeaderColumns = [];
	    self.dataChangeCallbacks = {};
	    self.verticalScrollSyncCallBackFns = {};
	    self.horizontalScrollSyncCallBackFns = {};
	
	    // self.visibleRowCache = [];
	
	    // Set of 'render' containers for self grid, which can render sets of rows
	    self.renderContainers = {};
	
	    // Create a
	    self.renderContainers.body = new GridRenderContainer('body', self);
	
	    self.cellValueGetterCache = {};
	
	    // Cached function to use with custom row templates
	    self.getRowTemplateFn = null;
	
	
	    //representation of the rows on the grid.
	    //these are wrapped references to the actual data rows (options.data)
	    self.rows = [];
	
	    //represents the columns on the grid
	    self.columns = [];
	
	    /**
	     * @ngdoc boolean
	     * @name isScrollingVertically
	     * @propertyOf ui.grid.class:Grid
	     * @description set to true when Grid is scrolling vertically. Set to false via debounced method
	     */
	    self.isScrollingVertically = false;
	
	    /**
	     * @ngdoc boolean
	     * @name isScrollingHorizontally
	     * @propertyOf ui.grid.class:Grid
	     * @description set to true when Grid is scrolling horizontally. Set to false via debounced method
	     */
	    self.isScrollingHorizontally = false;
	
	    /**
	     * @ngdoc property
	     * @name scrollDirection
	     * @propertyOf ui.grid.class:Grid
	     * @description set one of the {@link ui.grid.service:uiGridConstants#properties_scrollDirection uiGridConstants.scrollDirection}
	     *  values (UP, DOWN, LEFT, RIGHT, NONE), which tells us which direction we are scrolling.
	     * Set to NONE via debounced method
	     */
	    self.scrollDirection = uiGridConstants.scrollDirection.NONE;
	
	    //if true, grid will not respond to any scroll events
	    self.disableScrolling = false;
	
	
	    function vertical (scrollEvent) {
	      self.isScrollingVertically = false;
	      self.api.core.raise.scrollEnd(scrollEvent);
	      self.scrollDirection = uiGridConstants.scrollDirection.NONE;
	    }
	
	    var debouncedVertical = gridUtil.debounce(vertical, self.options.scrollDebounce);
	    var debouncedVerticalMinDelay = gridUtil.debounce(vertical, 0);
	
	    function horizontal (scrollEvent) {
	      self.isScrollingHorizontally = false;
	      self.api.core.raise.scrollEnd(scrollEvent);
	      self.scrollDirection = uiGridConstants.scrollDirection.NONE;
	    }
	
	    var debouncedHorizontal = gridUtil.debounce(horizontal, self.options.scrollDebounce);
	    var debouncedHorizontalMinDelay = gridUtil.debounce(horizontal, 0);
	
	
	    /**
	     * @ngdoc function
	     * @name flagScrollingVertically
	     * @methodOf ui.grid.class:Grid
	     * @description sets isScrollingVertically to true and sets it to false in a debounced function
	     */
	    self.flagScrollingVertically = function(scrollEvent) {
	      if (!self.isScrollingVertically && !self.isScrollingHorizontally) {
	        self.api.core.raise.scrollBegin(scrollEvent);
	      }
	      self.isScrollingVertically = true;
	      if (self.options.scrollDebounce === 0 || !scrollEvent.withDelay) {
	        debouncedVerticalMinDelay(scrollEvent);
	      }
	      else {
	        debouncedVertical(scrollEvent);
	      }
	    };
	
	    /**
	     * @ngdoc function
	     * @name flagScrollingHorizontally
	     * @methodOf ui.grid.class:Grid
	     * @description sets isScrollingHorizontally to true and sets it to false in a debounced function
	     */
	    self.flagScrollingHorizontally = function(scrollEvent) {
	      if (!self.isScrollingVertically && !self.isScrollingHorizontally) {
	        self.api.core.raise.scrollBegin(scrollEvent);
	      }
	      self.isScrollingHorizontally = true;
	      if (self.options.scrollDebounce === 0 || !scrollEvent.withDelay) {
	        debouncedHorizontalMinDelay(scrollEvent);
	      }
	      else {
	        debouncedHorizontal(scrollEvent);
	      }
	    };
	
	    self.scrollbarHeight = 0;
	    self.scrollbarWidth = 0;
	    if (self.options.enableHorizontalScrollbar !== uiGridConstants.scrollbars.NEVER) {
	      self.scrollbarHeight = gridUtil.getScrollbarWidth();
	    }
	
	    if (self.options.enableVerticalScrollbar !== uiGridConstants.scrollbars.NEVER) {
	      self.scrollbarWidth = gridUtil.getScrollbarWidth();
	    }
	
	
	
	    self.api = new GridApi(self);
	
	    /**
	     * @ngdoc function
	     * @name refresh
	     * @methodOf ui.grid.core.api:PublicApi
	     * @description Refresh the rendered grid on screen.
	     * The refresh method re-runs both the columnProcessors and the
	     * rowProcessors, as well as calling refreshCanvas to update all
	     * the grid sizing.  In general you should prefer to use queueGridRefresh
	     * instead, which is basically a debounced version of refresh.
	     *
	     * If you only want to resize the grid, not regenerate all the rows
	     * and columns, you should consider directly calling refreshCanvas instead.
	     *
	     * @param {boolean} [rowsAltered] Optional flag for refreshing when the number of rows has changed
	     */
	    self.api.registerMethod( 'core', 'refresh', this.refresh );
	
	    /**
	     * @ngdoc function
	     * @name queueGridRefresh
	     * @methodOf ui.grid.core.api:PublicApi
	     * @description Request a refresh of the rendered grid on screen, if multiple
	     * calls to queueGridRefresh are made within a digest cycle only one will execute.
	     * The refresh method re-runs both the columnProcessors and the
	     * rowProcessors, as well as calling refreshCanvas to update all
	     * the grid sizing.  In general you should prefer to use queueGridRefresh
	     * instead, which is basically a debounced version of refresh.
	     *
	     */
	    self.api.registerMethod( 'core', 'queueGridRefresh', this.queueGridRefresh );
	
	    /**
	     * @ngdoc function
	     * @name refreshRows
	     * @methodOf ui.grid.core.api:PublicApi
	     * @description Runs only the rowProcessors, columns remain as they were.
	     * It then calls redrawInPlace and refreshCanvas, which adjust the grid sizing.
	     * @returns {promise} promise that is resolved when render completes?
	     *
	     */
	    self.api.registerMethod( 'core', 'refreshRows', this.refreshRows );
	
	    /**
	     * @ngdoc function
	     * @name queueRefresh
	     * @methodOf ui.grid.core.api:PublicApi
	     * @description Requests execution of refreshCanvas, if multiple requests are made
	     * during a digest cycle only one will run.  RefreshCanvas updates the grid sizing.
	     * @returns {promise} promise that is resolved when render completes?
	     *
	     */
	    self.api.registerMethod( 'core', 'queueRefresh', this.queueRefresh );
	
	    /**
	     * @ngdoc function
	     * @name handleWindowResize
	     * @methodOf ui.grid.core.api:PublicApi
	     * @description Trigger a grid resize, normally this would be picked
	     * up by a watch on window size, but in some circumstances it is necessary
	     * to call this manually
	     * @returns {promise} promise that is resolved when render completes?
	     *
	     */
	    self.api.registerMethod( 'core', 'handleWindowResize', this.handleWindowResize );
	
	
	    /**
	     * @ngdoc function
	     * @name addRowHeaderColumn
	     * @methodOf ui.grid.core.api:PublicApi
	     * @description adds a row header column to the grid
	     * @param {object} column def
	     * @param {number} order Determines order of header column on grid.  Lower order means header
	     * is positioned to the left of higher order headers
	     *
	     */
	    self.api.registerMethod( 'core', 'addRowHeaderColumn', this.addRowHeaderColumn );
	
	    /**
	     * @ngdoc function
	     * @name scrollToIfNecessary
	     * @methodOf ui.grid.core.api:PublicApi
	     * @description Scrolls the grid to make a certain row and column combo visible,
	     *   in the case that it is not completely visible on the screen already.
	     * @param {GridRow} gridRow row to make visible
	     * @param {GridColumn} gridCol column to make visible
	     * @returns {promise} a promise that is resolved when scrolling is complete
	     *
	     */
	    self.api.registerMethod( 'core', 'scrollToIfNecessary', function(gridRow, gridCol) { return self.scrollToIfNecessary(gridRow, gridCol);} );
	
	    /**
	     * @ngdoc function
	     * @name scrollTo
	     * @methodOf ui.grid.core.api:PublicApi
	     * @description Scroll the grid such that the specified
	     * row and column is in view
	     * @param {object} rowEntity gridOptions.data[] array instance to make visible
	     * @param {object} colDef to make visible
	     * @returns {promise} a promise that is resolved after any scrolling is finished
	     */
	    self.api.registerMethod( 'core', 'scrollTo', function (rowEntity, colDef) { return self.scrollTo(rowEntity, colDef);}  );
	
	    /**
	     * @ngdoc function
	     * @name registerRowsProcessor
	     * @methodOf ui.grid.core.api:PublicApi
	     * @description
	     * Register a "rows processor" function. When the rows are updated,
	     * the grid calls each registered "rows processor", which has a chance
	     * to alter the set of rows (sorting, etc) as long as the count is not
	     * modified.
	     *
	     * @param {function(renderedRowsToProcess, columns )} processorFunction rows processor function, which
	     * is run in the context of the grid (i.e. this for the function will be the grid), and must
	     * return the updated rows list, which is passed to the next processor in the chain
	     * @param {number} priority the priority of this processor.  In general we try to do them in 100s to leave room
	     * for other people to inject rows processors at intermediate priorities.  Lower priority rowsProcessors run earlier.
	     *
	     * At present allRowsVisible is running at 50, sort manipulations running at 60-65, filter is running at 100,
	     * sort is at 200, grouping and treeview at 400-410, selectable rows at 500, pagination at 900 (pagination will generally want to be last)
	     */
	    self.api.registerMethod( 'core', 'registerRowsProcessor', this.registerRowsProcessor  );
	
	    /**
	     * @ngdoc function
	     * @name registerColumnsProcessor
	     * @methodOf ui.grid.core.api:PublicApi
	     * @description
	     * Register a "columns processor" function. When the columns are updated,
	     * the grid calls each registered "columns processor", which has a chance
	     * to alter the set of columns as long as the count is not
	     * modified.
	     *
	     * @param {function(renderedColumnsToProcess, rows )} processorFunction columns processor function, which
	     * is run in the context of the grid (i.e. this for the function will be the grid), and must
	     * return the updated columns list, which is passed to the next processor in the chain
	     * @param {number} priority the priority of this processor.  In general we try to do them in 100s to leave room
	     * for other people to inject columns processors at intermediate priorities.  Lower priority columnsProcessors run earlier.
	     *
	     * At present allRowsVisible is running at 50, filter is running at 100, sort is at 200, grouping at 400, selectable rows at 500, pagination at 900 (pagination will generally want to be last)
	     */
	    self.api.registerMethod( 'core', 'registerColumnsProcessor', this.registerColumnsProcessor  );
	
	
	
	    /**
	     * @ngdoc function
	     * @name sortHandleNulls
	     * @methodOf ui.grid.core.api:PublicApi
	     * @description A null handling method that can be used when building custom sort
	     * functions
	     * @example
	     * <pre>
	     *   mySortFn = function(a, b) {
	     *   var nulls = $scope.gridApi.core.sortHandleNulls(a, b);
	     *   if ( nulls !== null ){
	     *     return nulls;
	     *   } else {
	     *     // your code for sorting here
	     *   };
	     * </pre>
	     * @param {object} a sort value a
	     * @param {object} b sort value b
	     * @returns {number} null if there were no nulls/undefineds, otherwise returns
	     * a sort value that should be passed back from the sort function
	     *
	     */
	    self.api.registerMethod( 'core', 'sortHandleNulls', rowSorter.handleNulls );
	
	
	    /**
	     * @ngdoc function
	     * @name sortChanged
	     * @methodOf  ui.grid.core.api:PublicApi
	     * @description The sort criteria on one or more columns has
	     * changed.  Provides as parameters the grid and the output of
	     * getColumnSorting, which is an array of gridColumns
	     * that have sorting on them, sorted in priority order.
	     *
	     * @param {$scope} scope The scope of the controller. This is used to deregister this event when the scope is destroyed.
	     * @param {Function} callBack Will be called when the event is emited. The function passes back the grid and an array of
	     * columns with sorts on them, in priority order.
	     *
	     * @example
	     * <pre>
	     *      gridApi.core.on.sortChanged( $scope, function(grid, sortColumns){
	     *        // do something
	     *      });
	     * </pre>
	     */
	    self.api.registerEvent( 'core', 'sortChanged' );
	
	      /**
	     * @ngdoc function
	     * @name columnVisibilityChanged
	     * @methodOf  ui.grid.core.api:PublicApi
	     * @description The visibility of a column has changed,
	     * the column itself is passed out as a parameter of the event.
	     *
	     * @param {$scope} scope The scope of the controller. This is used to deregister this event when the scope is destroyed.
	     * @param {Function} callBack Will be called when the event is emited. The function passes back the GridCol that has changed.
	     *
	     * @example
	     * <pre>
	     *      gridApi.core.on.columnVisibilityChanged( $scope, function (column) {
	     *        // do something
	     *      } );
	     * </pre>
	     */
	    self.api.registerEvent( 'core', 'columnVisibilityChanged' );
	
	    /**
	     * @ngdoc method
	     * @name notifyDataChange
	     * @methodOf ui.grid.core.api:PublicApi
	     * @description Notify the grid that a data or config change has occurred,
	     * where that change isn't something the grid was otherwise noticing.  This
	     * might be particularly relevant where you've changed values within the data
	     * and you'd like cell classes to be re-evaluated, or changed config within
	     * the columnDef and you'd like headerCellClasses to be re-evaluated.
	     * @param {string} type one of the
	     * {@link ui.grid.service:uiGridConstants#properties_dataChange uiGridConstants.dataChange}
	     * values (ALL, ROW, EDIT, COLUMN, OPTIONS), which tells us which refreshes to fire.
	     *
	     * - ALL: listeners fired on any of these events, fires listeners on all events.
	     * - ROW: fired when a row is added or removed.
	     * - EDIT: fired when the data in a cell is edited.
	     * - COLUMN: fired when the column definitions are modified.
	     * - OPTIONS: fired when the grid options are modified.
	     */
	    self.api.registerMethod( 'core', 'notifyDataChange', this.notifyDataChange );
	
	    /**
	     * @ngdoc method
	     * @name clearAllFilters
	     * @methodOf ui.grid.core.api:PublicApi
	     * @description Clears all filters and optionally refreshes the visible rows.
	     * @param {object} refreshRows Defaults to true.
	     * @param {object} clearConditions Defaults to false.
	     * @param {object} clearFlags Defaults to false.
	     * @returns {promise} If `refreshRows` is true, returns a promise of the rows refreshing.
	     */
	    self.api.registerMethod('core', 'clearAllFilters', this.clearAllFilters);
	
	    self.registerDataChangeCallback( self.columnRefreshCallback, [uiGridConstants.dataChange.COLUMN]);
	    self.registerDataChangeCallback( self.processRowsCallback, [uiGridConstants.dataChange.EDIT]);
	    self.registerDataChangeCallback( self.updateFooterHeightCallback, [uiGridConstants.dataChange.OPTIONS]);
	
	    self.registerStyleComputation({
	      priority: 10,
	      func: self.getFooterStyles
	    });
	  };
	
	   Grid.prototype.calcFooterHeight = function () {
	     if (!this.hasFooter()) {
	       return 0;
	     }
	
	     var height = 0;
	     if (this.options.showGridFooter) {
	       height += this.options.gridFooterHeight;
	     }
	
	     height += this.calcColumnFooterHeight();
	
	     return height;
	   };
	
	   Grid.prototype.calcColumnFooterHeight = function () {
	     var height = 0;
	
	     if (this.options.showColumnFooter) {
	       height += this.options.columnFooterHeight;
	     }
	
	     return height;
	   };
	
	   Grid.prototype.getFooterStyles = function () {
	     var style = '.grid' + this.id + ' .ui-grid-footer-aggregates-row { height: ' + this.options.columnFooterHeight + 'px; }';
	     style += ' .grid' + this.id + ' .ui-grid-footer-info { height: ' + this.options.gridFooterHeight + 'px; }';
	     return style;
	   };
	
	  Grid.prototype.hasFooter = function () {
	   return this.options.showGridFooter || this.options.showColumnFooter;
	  };
	
	  /**
	   * @ngdoc function
	   * @name isRTL
	   * @methodOf ui.grid.class:Grid
	   * @description Returns true if grid is RightToLeft
	   */
	  Grid.prototype.isRTL = function () {
	    return this.rtl;
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name registerColumnBuilder
	   * @methodOf ui.grid.class:Grid
	   * @description When the build creates columns from column definitions, the columnbuilders will be called to add
	   * additional properties to the column.
	   * @param {function(colDef, col, gridOptions)} columnBuilder function to be called
	   */
	  Grid.prototype.registerColumnBuilder = function registerColumnBuilder(columnBuilder) {
	    this.columnBuilders.push(columnBuilder);
	  };
	
	  /**
	   * @ngdoc function
	   * @name buildColumnDefsFromData
	   * @methodOf ui.grid.class:Grid
	   * @description Populates columnDefs from the provided data
	   * @param {function(colDef, col, gridOptions)} rowBuilder function to be called
	   */
	  Grid.prototype.buildColumnDefsFromData = function (dataRows){
	    this.options.columnDefs =  gridUtil.getColumnsFromData(dataRows, this.options.excludeProperties);
	  };
	
	  /**
	   * @ngdoc function
	   * @name registerRowBuilder
	   * @methodOf ui.grid.class:Grid
	   * @description When the build creates rows from gridOptions.data, the rowBuilders will be called to add
	   * additional properties to the row.
	   * @param {function(row, gridOptions)} rowBuilder function to be called
	   */
	  Grid.prototype.registerRowBuilder = function registerRowBuilder(rowBuilder) {
	    this.rowBuilders.push(rowBuilder);
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name registerDataChangeCallback
	   * @methodOf ui.grid.class:Grid
	   * @description When a data change occurs, the data change callbacks of the specified type
	   * will be called.  The rules are:
	   *
	   * - when the data watch fires, that is considered a ROW change (the data watch only notices
	   *   added or removed rows)
	   * - when the api is called to inform us of a change, the declared type of that change is used
	   * - when a cell edit completes, the EDIT callbacks are triggered
	   * - when the columnDef watch fires, the COLUMN callbacks are triggered
	   * - when the options watch fires, the OPTIONS callbacks are triggered
	   *
	   * For a given event:
	   * - ALL calls ROW, EDIT, COLUMN, OPTIONS and ALL callbacks
	   * - ROW calls ROW and ALL callbacks
	   * - EDIT calls EDIT and ALL callbacks
	   * - COLUMN calls COLUMN and ALL callbacks
	   * - OPTIONS calls OPTIONS and ALL callbacks
	   *
	   * @param {function(grid)} callback function to be called
	   * @param {array} types the types of data change you want to be informed of.  Values from
	   * the {@link ui.grid.service:uiGridConstants#properties_dataChange uiGridConstants.dataChange}
	   *  values ( ALL, EDIT, ROW, COLUMN, OPTIONS ).  Optional and defaults to ALL
	   * @returns {function} deregister function - a function that can be called to deregister this callback
	   */
	  Grid.prototype.registerDataChangeCallback = function registerDataChangeCallback(callback, types, _this) {
	    var uid = gridUtil.nextUid();
	    if ( !types ){
	      types = [uiGridConstants.dataChange.ALL];
	    }
	    if ( !Array.isArray(types)){
	      gridUtil.logError("Expected types to be an array or null in registerDataChangeCallback, value passed was: " + types );
	    }
	    this.dataChangeCallbacks[uid] = { callback: callback, types: types, _this:_this };
	
	    var self = this;
	    var deregisterFunction = function() {
	      delete self.dataChangeCallbacks[uid];
	    };
	    return deregisterFunction;
	  };
	
	  /**
	   * @ngdoc function
	   * @name callDataChangeCallbacks
	   * @methodOf ui.grid.class:Grid
	   * @description Calls the callbacks based on the type of data change that
	   * has occurred. Always calls the ALL callbacks, calls the ROW, EDIT, COLUMN and OPTIONS callbacks if the
	   * event type is matching, or if the type is ALL.
	   * @param {string} type the type of event that occurred - one of the
	   * {@link ui.grid.service:uiGridConstants#properties_dataChange uiGridConstants.dataChange}
	   *  values (ALL, ROW, EDIT, COLUMN, OPTIONS)
	   */
	  Grid.prototype.callDataChangeCallbacks = function callDataChangeCallbacks(type, options) {
	    angular.forEach( this.dataChangeCallbacks, function( callback, uid ){
	      if ( callback.types.indexOf( uiGridConstants.dataChange.ALL ) !== -1 ||
	           callback.types.indexOf( type ) !== -1 ||
	           type === uiGridConstants.dataChange.ALL ) {
	        if (callback._this) {
	           callback.callback.apply(callback._this, this, options);
	        }
	        else {
	          callback.callback(this, options);
	        }
	      }
	    }, this);
	  };
	
	  /**
	   * @ngdoc function
	   * @name notifyDataChange
	   * @methodOf ui.grid.class:Grid
	   * @description Notifies us that a data change has occurred, used in the public
	   * api for users to tell us when they've changed data or some other event that
	   * our watches cannot pick up
	   * @param {string} type the type of event that occurred - one of the
	   * uiGridConstants.dataChange values (ALL, ROW, EDIT, COLUMN, OPTIONS)
	   *
	   * - ALL: listeners fired on any of these events, fires listeners on all events.
	   * - ROW: fired when a row is added or removed.
	   * - EDIT: fired when the data in a cell is edited.
	   * - COLUMN: fired when the column definitions are modified.
	   * - OPTIONS: fired when the grid options are modified.
	   */
	  Grid.prototype.notifyDataChange = function notifyDataChange(type) {
	    var constants = uiGridConstants.dataChange;
	    if ( type === constants.ALL ||
	         type === constants.COLUMN ||
	         type === constants.EDIT ||
	         type === constants.ROW ||
	         type === constants.OPTIONS ){
	      this.callDataChangeCallbacks( type );
	    } else {
	      gridUtil.logError("Notified of a data change, but the type was not recognised, so no action taken, type was: " + type);
	    }
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name columnRefreshCallback
	   * @methodOf ui.grid.class:Grid
	   * @description refreshes the grid when a column refresh
	   * is notified, which triggers handling of the visible flag.
	   * This is called on uiGridConstants.dataChange.COLUMN, and is
	   * registered as a dataChangeCallback in grid.js
	   * @param {object} grid The grid object.
	   * @param {object} options Any options passed into the callback.
	   */
	  Grid.prototype.columnRefreshCallback = function columnRefreshCallback(grid, options){
	    grid.buildColumns(options);
	    grid.queueGridRefresh();
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name processRowsCallback
	   * @methodOf ui.grid.class:Grid
	   * @description calls the row processors, specifically
	   * intended to reset the sorting when an edit is called,
	   * registered as a dataChangeCallback on uiGridConstants.dataChange.EDIT
	   * @param {string} name column name
	   */
	  Grid.prototype.processRowsCallback = function processRowsCallback( grid ){
	    grid.queueGridRefresh();
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name updateFooterHeightCallback
	   * @methodOf ui.grid.class:Grid
	   * @description recalculates the footer height,
	   * registered as a dataChangeCallback on uiGridConstants.dataChange.OPTIONS
	   * @param {string} name column name
	   */
	  Grid.prototype.updateFooterHeightCallback = function updateFooterHeightCallback( grid ){
	    grid.footerHeight = grid.calcFooterHeight();
	    grid.columnFooterHeight = grid.calcColumnFooterHeight();
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name getColumn
	   * @methodOf ui.grid.class:Grid
	   * @description returns a grid column for the column name
	   * @param {string} name column name
	   */
	  Grid.prototype.getColumn = function getColumn(name) {
	    var columns = this.columns.filter(function (column) {
	      return column.colDef.name === name;
	    });
	    return columns.length > 0 ? columns[0] : null;
	  };
	
	  /**
	   * @ngdoc function
	   * @name getColDef
	   * @methodOf ui.grid.class:Grid
	   * @description returns a grid colDef for the column name
	   * @param {string} name column.field
	   */
	  Grid.prototype.getColDef = function getColDef(name) {
	    var colDefs = this.options.columnDefs.filter(function (colDef) {
	      return colDef.name === name;
	    });
	    return colDefs.length > 0 ? colDefs[0] : null;
	  };
	
	  /**
	   * @ngdoc function
	   * @name assignTypes
	   * @methodOf ui.grid.class:Grid
	   * @description uses the first row of data to assign colDef.type for any types not defined.
	   */
	  /**
	   * @ngdoc property
	   * @name type
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description the type of the column, used in sorting.  If not provided then the
	   * grid will guess the type.  Add this only if the grid guessing is not to your
	   * satisfaction.  One of:
	   * - 'string'
	   * - 'boolean'
	   * - 'number'
	   * - 'date'
	   * - 'object'
	   * - 'numberStr'
	   * Note that if you choose date, your dates should be in a javascript date type
	   *
	   */
	  Grid.prototype.assignTypes = function(){
	    var self = this;
	    self.options.columnDefs.forEach(function (colDef, index) {
	
	      //Assign colDef type if not specified
	      if (!colDef.type) {
	        var col = new GridColumn(colDef, index, self);
	        var firstRow = self.rows.length > 0 ? self.rows[0] : null;
	        if (firstRow) {
	          colDef.type = gridUtil.guessType(self.getCellValue(firstRow, col));
	        }
	        else {
	          colDef.type = 'string';
	        }
	      }
	    });
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name isRowHeaderColumn
	   * @methodOf ui.grid.class:Grid
	   * @description returns true if the column is a row Header
	   * @param {object} column column
	   */
	  Grid.prototype.isRowHeaderColumn = function isRowHeaderColumn(column) {
	    return this.rowHeaderColumns.indexOf(column) !== -1;
	  };
	
	  /**
	  * @ngdoc function
	  * @name addRowHeaderColumn
	  * @methodOf ui.grid.class:Grid
	  * @description adds a row header column to the grid
	  * @param {object} colDef Column definition object.
	  * @param {float} order Number that indicates where the column should be placed in the grid.
	  * @param {boolean} stopColumnBuild Prevents the buildColumn callback from being triggered. This is useful to improve
	  * performance of the grid during initial load.
	  */
	  Grid.prototype.addRowHeaderColumn = function addRowHeaderColumn(colDef, order, stopColumnBuild) {
	    var self = this;
	
	    //default order
	    if (order === undefined) {
	      order = 0;
	    }
	
	    var rowHeaderCol = new GridColumn(colDef, gridUtil.nextUid(), self);
	    rowHeaderCol.isRowHeader = true;
	    if (self.isRTL()) {
	      self.createRightContainer();
	      rowHeaderCol.renderContainer = 'right';
	    }
	    else {
	      self.createLeftContainer();
	      rowHeaderCol.renderContainer = 'left';
	    }
	
	    // relies on the default column builder being first in array, as it is instantiated
	    // as part of grid creation
	    self.columnBuilders[0](colDef,rowHeaderCol,self.options)
	      .then(function(){
	        rowHeaderCol.enableFiltering = false;
	        rowHeaderCol.enableSorting = false;
	        rowHeaderCol.enableHiding = false;
	        rowHeaderCol.headerPriority = order;
	        self.rowHeaderColumns.push(rowHeaderCol);
	        self.rowHeaderColumns = self.rowHeaderColumns.sort(function (a, b) {
	          return a.headerPriority - b.headerPriority;
	        });
	
	        if (!stopColumnBuild) {
	          self.buildColumns()
	            .then(function() {
	              self.preCompileCellTemplates();
	              self.queueGridRefresh();
	            }).catch(angular.noop);
	        }
	      }).catch(angular.noop);
	  };
	
	  /**
	   * @ngdoc function
	   * @name getOnlyDataColumns
	   * @methodOf ui.grid.class:Grid
	   * @description returns all columns except for rowHeader columns
	   */
	  Grid.prototype.getOnlyDataColumns = function getOnlyDataColumns() {
	    var self = this;
	    var cols = [];
	    self.columns.forEach(function (col) {
	      if (self.rowHeaderColumns.indexOf(col) === -1) {
	        cols.push(col);
	      }
	    });
	    return cols;
	  };
	
	  /**
	   * @ngdoc function
	   * @name buildColumns
	   * @methodOf ui.grid.class:Grid
	   * @description creates GridColumn objects from the columnDefinition.  Calls each registered
	   * columnBuilder to further process the column
	   * @param {object} options  An object contains options to use when building columns
	   *
	   * * **orderByColumnDefs**: defaults to **false**. When true, `buildColumns` will reorder existing columns according to the order within the column definitions.
	   *
	   * @returns {Promise} a promise to load any needed column resources
	   */
	  Grid.prototype.buildColumns = function buildColumns(opts) {
	    var options = {
	      orderByColumnDefs: false
	    };
	
	    angular.extend(options, opts);
	
	    // gridUtil.logDebug('buildColumns');
	    var self = this;
	    var builderPromises = [];
	    var headerOffset = self.rowHeaderColumns.length;
	    var i;
	
	    // Remove any columns for which a columnDef cannot be found
	    // Deliberately don't use forEach, as it doesn't like splice being called in the middle
	    // Also don't cache columns.length, as it will change during this operation
	    for (i = 0; i < self.columns.length; i++){
	      if (!self.getColDef(self.columns[i].name)) {
	        self.columns.splice(i, 1);
	        i--;
	      }
	    }
	
	    //add row header columns to the grid columns array _after_ columns without columnDefs have been removed
	    //rowHeaderColumns is ordered by priority so insert in reverse
	    for (var j = self.rowHeaderColumns.length - 1; j >= 0; j--) {
	      self.columns.unshift(self.rowHeaderColumns[j]);
	    }
	
	
	
	    // look at each column def, and update column properties to match.  If the column def
	    // doesn't have a column, then splice in a new gridCol
	    self.options.columnDefs.forEach(function (colDef, index) {
	      self.preprocessColDef(colDef);
	      var col = self.getColumn(colDef.name);
	
	      if (!col) {
	        col = new GridColumn(colDef, gridUtil.nextUid(), self);
	        self.columns.splice(index + headerOffset, 0, col);
	      }
	      else {
	        // tell updateColumnDef that the column was pre-existing
	        col.updateColumnDef(colDef, false);
	      }
	
	      self.columnBuilders.forEach(function (builder) {
	        builderPromises.push(builder.call(self, colDef, col, self.options));
	      });
	    });
	
	    /*** Reorder columns if necessary ***/
	    if (!!options.orderByColumnDefs) {
	      // Create a shallow copy of the columns as a cache
	      var columnCache = self.columns.slice(0);
	
	      // We need to allow for the "row headers" when mapping from the column defs array to the columns array
	      //   If we have a row header in columns[0] and don't account for it   we'll overwrite it with the column in columnDefs[0]
	
	      // Go through all the column defs, use the shorter of columns length and colDefs.length because if a user has given two columns the same name then
	      // columns will be shorter than columnDefs.  In this situation we'll avoid an error, but the user will still get an unexpected result
	      var len = Math.min(self.options.columnDefs.length, self.columns.length);
	      for (i = 0; i < len; i++) {
	        // If the column at this index has a different name than the column at the same index in the column defs...
	        if (self.columns[i + headerOffset].name !== self.options.columnDefs[i].name) {
	          // Replace the one in the cache with the appropriate column
	          columnCache[i + headerOffset] = self.getColumn(self.options.columnDefs[i].name);
	        }
	        else {
	          // Otherwise just copy over the one from the initial columns
	          columnCache[i + headerOffset] = self.columns[i + headerOffset];
	        }
	      }
	
	      // Empty out the columns array, non-destructively
	      self.columns.length = 0;
	
	      // And splice in the updated, ordered columns from the cache
	      Array.prototype.splice.apply(self.columns, [0, 0].concat(columnCache));
	    }
	
	    return $q.all(builderPromises).then(function(){
	      if (self.rows.length > 0){
	        self.assignTypes();
	      }
	      if (options.preCompileCellTemplates) {
	        self.preCompileCellTemplates();
	      }
	    }).catch(angular.noop);
	  };
	
	  Grid.prototype.preCompileCellTemplate = function(col) {
	    var self = this;
	    var html = col.cellTemplate.replace(uiGridConstants.MODEL_COL_FIELD, self.getQualifiedColField(col));
	    html = html.replace(uiGridConstants.COL_FIELD, 'grid.getCellValue(row, col)');
	
	    col.compiledElementFn = $compile(html);
	
	    if (col.compiledElementFnDefer) {
	      col.compiledElementFnDefer.resolve(col.compiledElementFn);
	    }
	  };
	
	/**
	 * @ngdoc function
	 * @name preCompileCellTemplates
	 * @methodOf ui.grid.class:Grid
	 * @description precompiles all cell templates
	 */
	  Grid.prototype.preCompileCellTemplates = function() {
	    var self = this;
	    self.columns.forEach(function (col) {
	      if ( col.cellTemplate ){
	        self.preCompileCellTemplate( col );
	      } else if ( col.cellTemplatePromise ){
	        col.cellTemplatePromise.then( function() {
	          self.preCompileCellTemplate( col );
	        }).catch(angular.noop);
	      }
	    });
	  };
	
	  /**
	   * @ngdoc function
	   * @name getGridQualifiedColField
	   * @methodOf ui.grid.class:Grid
	   * @description Returns the $parse-able accessor for a column within its $scope
	   * @param {GridColumn} col col object
	   */
	  Grid.prototype.getQualifiedColField = function (col) {
	    var base = 'row.entity';
	    if ( col.field === uiGridConstants.ENTITY_BINDING ) {
	      return base;
	    }
	    return gridUtil.preEval(base + '.' + col.field);
	  };
	
	  /**
	   * @ngdoc function
	   * @name createLeftContainer
	   * @methodOf ui.grid.class:Grid
	   * @description creates the left render container if it doesn't already exist
	   */
	  Grid.prototype.createLeftContainer = function() {
	    if (!this.hasLeftContainer()) {
	      this.renderContainers.left = new GridRenderContainer('left', this, { disableColumnOffset: true });
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name createRightContainer
	   * @methodOf ui.grid.class:Grid
	   * @description creates the right render container if it doesn't already exist
	   */
	  Grid.prototype.createRightContainer = function() {
	    if (!this.hasRightContainer()) {
	      this.renderContainers.right = new GridRenderContainer('right', this, { disableColumnOffset: true });
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name hasLeftContainer
	   * @methodOf ui.grid.class:Grid
	   * @description returns true if leftContainer exists
	   */
	  Grid.prototype.hasLeftContainer = function() {
	    return this.renderContainers.left !== undefined;
	  };
	
	  /**
	   * @ngdoc function
	   * @name hasRightContainer
	   * @methodOf ui.grid.class:Grid
	   * @description returns true if rightContainer exists
	   */
	  Grid.prototype.hasRightContainer = function() {
	    return this.renderContainers.right !== undefined;
	  };
	
	
	      /**
	   * undocumented function
	   * @name preprocessColDef
	   * @methodOf ui.grid.class:Grid
	   * @description defaults the name property from field to maintain backwards compatibility with 2.x
	   * validates that name or field is present
	   */
	  Grid.prototype.preprocessColDef = function preprocessColDef(colDef) {
	    var self = this;
	
	    if (!colDef.field && !colDef.name) {
	      throw new Error('colDef.name or colDef.field property is required');
	    }
	
	    //maintain backwards compatibility with 2.x
	    //field was required in 2.x.  now name is required
	    if (colDef.name === undefined && colDef.field !== undefined) {
	      // See if the column name already exists:
	      var newName = colDef.field,
	        counter = 2;
	      while (self.getColumn(newName)) {
	        newName = colDef.field + counter.toString();
	        counter++;
	      }
	      colDef.name = newName;
	    }
	  };
	
	  // Return a list of items that exist in the `n` array but not the `o` array. Uses optional property accessors passed as third & fourth parameters
	  Grid.prototype.newInN = function newInN(o, n, oAccessor, nAccessor) {
	    var self = this;
	
	    var t = [];
	    for (var i = 0; i < n.length; i++) {
	      var nV = nAccessor ? n[i][nAccessor] : n[i];
	
	      var found = false;
	      for (var j = 0; j < o.length; j++) {
	        var oV = oAccessor ? o[j][oAccessor] : o[j];
	        if (self.options.rowEquality(nV, oV)) {
	          found = true;
	          break;
	        }
	      }
	      if (!found) {
	        t.push(nV);
	      }
	    }
	
	    return t;
	  };
	
	  /**
	   * @ngdoc function
	   * @name getRow
	   * @methodOf ui.grid.class:Grid
	   * @description returns the GridRow that contains the rowEntity
	   * @param {object} rowEntity the gridOptions.data array element instance
	   * @param {array} lookInRows [optional] the rows to look in - if not provided then
	   * looks in grid.rows
	   */
	  Grid.prototype.getRow = function getRow(rowEntity, lookInRows) {
	    var self = this;
	
	    lookInRows = typeof(lookInRows) === 'undefined' ? self.rows : lookInRows;
	
	    var rows = lookInRows.filter(function (row) {
	      return self.options.rowEquality(row.entity, rowEntity);
	    });
	    return rows.length > 0 ? rows[0] : null;
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name modifyRows
	   * @methodOf ui.grid.class:Grid
	   * @description creates or removes GridRow objects from the newRawData array.  Calls each registered
	   * rowBuilder to further process the row
	   * @param {array} newRawData Modified set of data
	   *
	   * This method aims to achieve three things:
	   * 1. the resulting rows array is in the same order as the newRawData, we'll call
	   * rowsProcessors immediately after to sort the data anyway
	   * 2. if we have row hashing available, we try to use the rowHash to find the row
	   * 3. no memory leaks - rows that are no longer in newRawData need to be garbage collected
	   *
	   * The basic logic flow makes use of the newRawData, oldRows and oldHash, and creates
	   * the newRows and newHash
	   *
	   * ```
	   * newRawData.forEach newEntity
	   *   if (hashing enabled)
	   *     check oldHash for newEntity
	   *   else
	   *     look for old row directly in oldRows
	   *   if !oldRowFound     // must be a new row
	   *     create newRow
	   *   append to the newRows and add to newHash
	   *   run the processors
	   * ```
	   *
	   * Rows are identified using the hashKey if configured.  If not configured, then rows
	   * are identified using the gridOptions.rowEquality function
	   *
	   * This method is useful when trying to select rows immediately after loading data without
	   * using a $timeout/$interval, e.g.:
	   *
	   *   $scope.gridOptions.data =  someData;
	   *   $scope.gridApi.grid.modifyRows($scope.gridOptions.data);
	   *   $scope.gridApi.selection.selectRow($scope.gridOptions.data[0]);
	   *
	   * OR to persist row selection after data update (e.g. rows selected, new data loaded, want
	   * originally selected rows to be re-selected))
	   */
	  Grid.prototype.modifyRows = function modifyRows(newRawData) {
	    var self = this;
	    var oldRows = self.rows.slice(0);
	    var oldRowHash = self.rowHashMap || self.createRowHashMap();
	    var allRowsSelected = true;
	    self.rowHashMap = self.createRowHashMap();
	    self.rows.length = 0;
	
	    newRawData.forEach( function( newEntity, i ) {
	      var newRow, oldRow;
	
	      if ( self.options.enableRowHashing ){
	        // if hashing is enabled, then this row will be in the hash if we already know about it
	        oldRow = oldRowHash.get( newEntity );
	      } else {
	        // otherwise, manually search the oldRows to see if we can find this row
	        oldRow = self.getRow(newEntity, oldRows);
	      }
	
	      // update newRow to have an entity
	      if ( oldRow ) {
	        newRow = oldRow;
	        newRow.entity = newEntity;
	      }
	
	      // if we didn't find the row, it must be new, so create it
	      if ( !newRow ){
	        newRow = self.processRowBuilders(new GridRow(newEntity, i, self));
	      }
	
	      self.rows.push( newRow );
	      self.rowHashMap.put( newEntity, newRow );
	      if (!newRow.isSelected) {
	        allRowsSelected = false;
	      }
	    });
	
	    if (self.selection && self.rows.length) {
	      self.selection.selectAll = allRowsSelected;
	    }
	
	    self.assignTypes();
	
	    var p1 = $q.when(self.processRowsProcessors(self.rows))
	      .then(function (renderableRows) {
	        return self.setVisibleRows(renderableRows);
	      }).catch(angular.noop);
	
	    var p2 = $q.when(self.processColumnsProcessors(self.columns))
	      .then(function (renderableColumns) {
	        return self.setVisibleColumns(renderableColumns);
	      }).catch(angular.noop);
	
	    return $q.all([p1, p2]);
	  };
	
	
	  /**
	   * Private Undocumented Method
	   * @name addRows
	   * @methodOf ui.grid.class:Grid
	   * @description adds the newRawData array of rows to the grid and calls all registered
	   * rowBuilders. this keyword will reference the grid
	   */
	  Grid.prototype.addRows = function addRows(newRawData) {
	    var self = this;
	
	    var existingRowCount = self.rows.length;
	    for (var i = 0; i < newRawData.length; i++) {
	      var newRow = self.processRowBuilders(new GridRow(newRawData[i], i + existingRowCount, self));
	
	      if (self.options.enableRowHashing) {
	        var found = self.rowHashMap.get(newRow.entity);
	        if (found) {
	          found.row = newRow;
	        }
	      }
	
	      self.rows.push(newRow);
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name processRowBuilders
	   * @methodOf ui.grid.class:Grid
	   * @description processes all RowBuilders for the gridRow
	   * @param {GridRow} gridRow reference to gridRow
	   * @returns {GridRow} the gridRow with all additional behavior added
	   */
	  Grid.prototype.processRowBuilders = function processRowBuilders(gridRow) {
	    var self = this;
	
	    self.rowBuilders.forEach(function (builder) {
	      builder.call(self, gridRow, self.options);
	    });
	
	    return gridRow;
	  };
	
	  /**
	   * @ngdoc function
	   * @name registerStyleComputation
	   * @methodOf ui.grid.class:Grid
	   * @description registered a styleComputation function
	   *
	   * If the function returns a value it will be appended into the grid's `<style>` block
	   * @param {function($scope)} styleComputationInfo function
	   */
	  Grid.prototype.registerStyleComputation = function registerStyleComputation(styleComputationInfo) {
	    this.styleComputations.push(styleComputationInfo);
	  };
	
	
	  // NOTE (c0bra): We already have rowBuilders. I think these do exactly the same thing...
	  // Grid.prototype.registerRowFilter = function(filter) {
	  //   // TODO(c0bra): validate filter?
	
	  //   this.rowFilters.push(filter);
	  // };
	
	  // Grid.prototype.removeRowFilter = function(filter) {
	  //   var idx = this.rowFilters.indexOf(filter);
	
	  //   if (typeof(idx) !== 'undefined' && idx !== undefined) {
	  //     this.rowFilters.slice(idx, 1);
	  //   }
	  // };
	
	  // Grid.prototype.processRowFilters = function(rows) {
	  //   var self = this;
	  //   self.rowFilters.forEach(function (filter) {
	  //     filter.call(self, rows);
	  //   });
	  // };
	
	
	  /**
	   * @ngdoc function
	   * @name registerRowsProcessor
	   * @methodOf ui.grid.class:Grid
	   * @description
	   *
	   * Register a "rows processor" function. When the rows are updated,
	   * the grid calls each registered "rows processor", which has a chance
	   * to alter the set of rows (sorting, etc) as long as the count is not
	   * modified.
	   *
	   * @param {function(renderedRowsToProcess, columns )} processor rows processor function, which
	   * is run in the context of the grid (i.e. this for the function will be the grid), and must
	   * return the updated rows list, which is passed to the next processor in the chain
	   * @param {number} priority the priority of this processor.  In general we try to do them in 100s to leave room
	   * for other people to inject rows processors at intermediate priorities.  Lower priority rowsProcessors run earlier.
	   *
	   * At present all rows visible is running at 50, filter is running at 100, sort is at 200, grouping at 400, selectable rows at 500, pagination at 900 (pagination will generally want to be last)
	   *
	   */
	  Grid.prototype.registerRowsProcessor = function registerRowsProcessor(processor, priority) {
	    if (!angular.isFunction(processor)) {
	      throw 'Attempt to register non-function rows processor: ' + processor;
	    }
	
	    this.rowsProcessors.push({processor: processor, priority: priority});
	    this.rowsProcessors.sort(function sortByPriority( a, b ){
	      return a.priority - b.priority;
	    });
	  };
	
	  /**
	   * @ngdoc function
	   * @name removeRowsProcessor
	   * @methodOf ui.grid.class:Grid
	   * @param {function(renderableRows)} processor processor function
	   * @description Remove a registered rows processor
	   */
	  Grid.prototype.removeRowsProcessor = function removeRowsProcessor(processor) {
	    var idx = -1;
	    this.rowsProcessors.forEach(function(rowsProcessor, index){
	      if ( rowsProcessor.processor === processor ){
	        idx = index;
	      }
	    });
	
	    if ( idx !== -1 ) {
	      this.rowsProcessors.splice(idx, 1);
	    }
	  };
	
	  /**
	   * Private Undocumented Method
	   * @name processRowsProcessors
	   * @methodOf ui.grid.class:Grid
	   * @param {Array[GridRow]} renderableRows The array of "renderable" rows
	   * @description Run all the registered rows processors on the array of renderable rows
	   */
	  Grid.prototype.processRowsProcessors = function processRowsProcessors(renderableRows) {
	    var self = this;
	
	    // Create a shallow copy of the rows so that we can safely sort them without altering the original grid.rows sort order
	    var myRenderableRows = renderableRows.slice(0);
	
	    // Return myRenderableRows with no processing if we have no rows processors
	    if (self.rowsProcessors.length === 0) {
	      return $q.when(myRenderableRows);
	    }
	
	    // Counter for iterating through rows processors
	    var i = 0;
	
	    // Promise for when we're done with all the processors
	    var finished = $q.defer();
	
	    // This function will call the processor in self.rowsProcessors at index 'i', and then
	    //   when done will call the next processor in the list, using the output from the processor
	    //   at i as the argument for 'renderedRowsToProcess' on the next iteration.
	    //
	    //   If we're at the end of the list of processors, we resolve our 'finished' callback with
	    //   the result.
	    function startProcessor(i, renderedRowsToProcess) {
	      // Get the processor at 'i'
	      var processor = self.rowsProcessors[i].processor;
	
	      // Call the processor, passing in the rows to process and the current columns
	      //   (note: it's wrapped in $q.when() in case the processor does not return a promise)
	      return $q.when( processor.call(self, renderedRowsToProcess, self.columns) )
	        .then(function handleProcessedRows(processedRows) {
	          // Check for errors
	          if (!processedRows) {
	            throw "Processor at index " + i + " did not return a set of renderable rows";
	          }
	
	          if (!angular.isArray(processedRows)) {
	            throw "Processor at index " + i + " did not return an array";
	          }
	
	          // Processor is done, increment the counter
	          i++;
	
	          // If we're not done with the processors, call the next one
	          if (i <= self.rowsProcessors.length - 1) {
	            return startProcessor(i, processedRows);
	          }
	          // We're done! Resolve the 'finished' promise
	          else {
	            finished.resolve(processedRows);
	          }
	        }).catch(function(error) {
	          throw error;
	        });
	    }
	
	    // Start on the first processor
	    startProcessor(0, myRenderableRows);
	
	    return finished.promise;
	  };
	
	  Grid.prototype.setVisibleRows = function setVisibleRows(rows) {
	    var self = this;
	
	    // Reset all the render container row caches
	    for (var i in self.renderContainers) {
	      var container = self.renderContainers[i];
	
	      container.canvasHeightShouldUpdate = true;
	
	      if ( typeof(container.visibleRowCache) === 'undefined' ){
	        container.visibleRowCache = [];
	      } else {
	        container.visibleRowCache.length = 0;
	      }
	    }
	
	    // rows.forEach(function (row) {
	    for (var ri = 0; ri < rows.length; ri++) {
	      var row = rows[ri];
	
	      var targetContainer = (typeof(row.renderContainer) !== 'undefined' && row.renderContainer) ? row.renderContainer : 'body';
	
	      // If the row is visible
	      if (row.visible) {
	        self.renderContainers[targetContainer].visibleRowCache.push(row);
	      }
	    }
	    self.api.core.raise.rowsVisibleChanged(this.api);
	    self.api.core.raise.rowsRendered(this.api);
	  };
	
	  /**
	   * @ngdoc function
	   * @name registerColumnsProcessor
	   * @methodOf ui.grid.class:Grid
	   * @param {function(renderedColumnsToProcess, rows)} processor column processor function, which
	   * is run in the context of the grid (i.e. this for the function will be the grid), and
	   * which must return an updated renderedColumnsToProcess which can be passed to the next processor
	   * in the chain
	   * @param {number} priority the priority of this processor.  In general we try to do them in 100s to leave room
	   * for other people to inject columns processors at intermediate priorities.  Lower priority columnsProcessors run earlier.
	   *
	   * At present all rows visible is running at 50, filter is running at 100, sort is at 200, grouping at 400, selectable rows at 500, pagination at 900 (pagination will generally want to be last)
	   * @description
	
	     Register a "columns processor" function. When the columns are updated,
	     the grid calls each registered "columns processor", which has a chance
	     to alter the set of columns, as long as the count is not modified.
	   */
	  Grid.prototype.registerColumnsProcessor = function registerColumnsProcessor(processor, priority) {
	    if (!angular.isFunction(processor)) {
	      throw 'Attempt to register non-function rows processor: ' + processor;
	    }
	
	    this.columnsProcessors.push({processor: processor, priority: priority});
	    this.columnsProcessors.sort(function sortByPriority( a, b ){
	      return a.priority - b.priority;
	    });
	  };
	
	  Grid.prototype.removeColumnsProcessor = function removeColumnsProcessor(processor) {
	    var idx = this.columnsProcessors.indexOf(processor);
	
	    if (typeof(idx) !== 'undefined' && idx !== undefined) {
	      this.columnsProcessors.splice(idx, 1);
	    }
	  };
	
	  Grid.prototype.processColumnsProcessors = function processColumnsProcessors(renderableColumns) {
	    var self = this;
	
	    // Create a shallow copy of the rows so that we can safely sort them without altering the original grid.rows sort order
	    var myRenderableColumns = renderableColumns.slice(0);
	
	    // Return myRenderableRows with no processing if we have no rows processors
	    if (self.columnsProcessors.length === 0) {
	      return $q.when(myRenderableColumns);
	    }
	
	    // Counter for iterating through rows processors
	    var i = 0;
	
	    // Promise for when we're done with all the processors
	    var finished = $q.defer();
	
	    // This function will call the processor in self.rowsProcessors at index 'i', and then
	    //   when done will call the next processor in the list, using the output from the processor
	    //   at i as the argument for 'renderedRowsToProcess' on the next iteration.
	    //
	    //   If we're at the end of the list of processors, we resolve our 'finished' callback with
	    //   the result.
	    function startProcessor(i, renderedColumnsToProcess) {
	      // Get the processor at 'i'
	      var processor = self.columnsProcessors[i].processor;
	
	      // Call the processor, passing in the rows to process and the current columns
	      //   (note: it's wrapped in $q.when() in case the processor does not return a promise)
	      return $q.when( processor.call(self, renderedColumnsToProcess, self.rows) )
	        .then(function handleProcessedRows(processedColumns) {
	          // Check for errors
	          if (!processedColumns) {
	            throw "Processor at index " + i + " did not return a set of renderable rows";
	          }
	
	          if (!angular.isArray(processedColumns)) {
	            throw "Processor at index " + i + " did not return an array";
	          }
	
	          // Processor is done, increment the counter
	          i++;
	
	          // If we're not done with the processors, call the next one
	          if (i <= self.columnsProcessors.length - 1) {
	            return startProcessor(i, myRenderableColumns);
	          }
	          // We're done! Resolve the 'finished' promise
	          else {
	            finished.resolve(myRenderableColumns);
	          }
	        }).catch(angular.noop);
	    }
	
	    // Start on the first processor
	    startProcessor(0, myRenderableColumns);
	
	    return finished.promise;
	  };
	
	  Grid.prototype.setVisibleColumns = function setVisibleColumns(columns) {
	    // gridUtil.logDebug('setVisibleColumns');
	
	    var self = this;
	
	    // Reset all the render container row caches
	    for (var i in self.renderContainers) {
	      var container = self.renderContainers[i];
	
	      container.visibleColumnCache.length = 0;
	    }
	
	    for (var ci = 0; ci < columns.length; ci++) {
	      var column = columns[ci];
	
	      // If the column is visible
	      if (column.visible) {
	        // If the column has a container specified
	        if (typeof(column.renderContainer) !== 'undefined' && column.renderContainer) {
	          self.renderContainers[column.renderContainer].visibleColumnCache.push(column);
	        }
	        // If not, put it into the body container
	        else {
	          self.renderContainers.body.visibleColumnCache.push(column);
	        }
	      }
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name handleWindowResize
	   * @methodOf ui.grid.class:Grid
	   * @description Triggered when the browser window resizes; automatically resizes the grid
	   * @returns {Promise} A resolved promise once the window resize has completed.
	   */
	  Grid.prototype.handleWindowResize = function handleWindowResize($event) {
	    var self = this;
	
	    self.gridWidth = gridUtil.elementWidth(self.element);
	    self.gridHeight = gridUtil.elementHeight(self.element);
	
	    return self.queueRefresh();
	  };
	
	  /**
	   * @ngdoc function
	   * @name queueRefresh
	   * @methodOf ui.grid.class:Grid
	   * @description queues a grid refreshCanvas, a way of debouncing all the refreshes we might otherwise issue
	   */
	  Grid.prototype.queueRefresh = function queueRefresh() {
	    var self = this;
	
	    if (self.refreshCanceller) {
	      $timeout.cancel(self.refreshCanceller);
	    }
	
	    self.refreshCanceller = $timeout(function () {
	      self.refreshCanvas(true);
	    });
	
	    self.refreshCanceller.then(function () {
	      self.refreshCanceller = null;
	    }).catch(angular.noop);
	
	    return self.refreshCanceller;
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name queueGridRefresh
	   * @methodOf ui.grid.class:Grid
	   * @description queues a grid refresh, a way of debouncing all the refreshes we might otherwise issue
	   */
	  Grid.prototype.queueGridRefresh = function queueGridRefresh() {
	    var self = this;
	
	    if (self.gridRefreshCanceller) {
	      $timeout.cancel(self.gridRefreshCanceller);
	    }
	
	    self.gridRefreshCanceller = $timeout(function () {
	      self.refresh(true);
	    });
	
	    self.gridRefreshCanceller.then(function () {
	      self.gridRefreshCanceller = null;
	    }).catch(angular.noop);
	
	    return self.gridRefreshCanceller;
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name updateCanvasHeight
	   * @methodOf ui.grid.class:Grid
	   * @description flags all render containers to update their canvas height
	   */
	  Grid.prototype.updateCanvasHeight = function updateCanvasHeight() {
	    var self = this;
	
	    for (var containerId in self.renderContainers) {
	      if (self.renderContainers.hasOwnProperty(containerId)) {
	        var container = self.renderContainers[containerId];
	        container.canvasHeightShouldUpdate = true;
	      }
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name buildStyles
	   * @methodOf ui.grid.class:Grid
	   * @description calls each styleComputation function
	   */
	  Grid.prototype.buildStyles = function buildStyles() {
	    var self = this;
	
	    // gridUtil.logDebug('buildStyles');
	
	    self.customStyles = '';
	
	    self.styleComputations
	      .sort(function(a, b) {
	        if (a.priority === null) { return 1; }
	        if (b.priority === null) { return -1; }
	        if (a.priority === null && b.priority === null) { return 0; }
	        return a.priority - b.priority;
	      })
	      .forEach(function (compInfo) {
	        // this used to provide $scope as a second parameter, but I couldn't find any
	        // style builders that used it, so removed it as part of moving to grid from controller
	        var ret = compInfo.func.call(self);
	
	        if (angular.isString(ret)) {
	          self.customStyles += '\n' + ret;
	        }
	      });
	  };
	
	
	  Grid.prototype.minColumnsToRender = function minColumnsToRender() {
	    var self = this;
	    var viewport = this.getViewportWidth();
	
	    var min = 0;
	    var totalWidth = 0;
	    self.columns.forEach(function(col, i) {
	      if (totalWidth < viewport) {
	        totalWidth += col.drawnWidth;
	        min++;
	      }
	      else {
	        var currWidth = 0;
	        for (var j = i; j >= i - min; j--) {
	          currWidth += self.columns[j].drawnWidth;
	        }
	        if (currWidth < viewport) {
	          min++;
	        }
	      }
	    });
	
	    return min;
	  };
	
	  Grid.prototype.getBodyHeight = function getBodyHeight() {
	    // Start with the viewportHeight
	    var bodyHeight = this.getViewportHeight();
	
	    // Add the horizontal scrollbar height if there is one
	    //if (typeof(this.horizontalScrollbarHeight) !== 'undefined' && this.horizontalScrollbarHeight !== undefined && this.horizontalScrollbarHeight > 0) {
	    //  bodyHeight = bodyHeight + this.horizontalScrollbarHeight;
	    //}
	
	    return bodyHeight;
	  };
	
	  // NOTE: viewport drawable height is the height of the grid minus the header row height (including any border)
	  // TODO(c0bra): account for footer height
	  Grid.prototype.getViewportHeight = function getViewportHeight() {
	    var self = this;
	
	    var viewPortHeight = this.gridHeight - this.headerHeight - this.footerHeight;
	
	    // Account for native horizontal scrollbar, if present
	    //if (typeof(this.horizontalScrollbarHeight) !== 'undefined' && this.horizontalScrollbarHeight !== undefined && this.horizontalScrollbarHeight > 0) {
	    //  viewPortHeight = viewPortHeight - this.horizontalScrollbarHeight;
	    //}
	
	    var adjustment = self.getViewportAdjustment();
	
	    viewPortHeight = viewPortHeight + adjustment.height;
	
	    //gridUtil.logDebug('viewPortHeight', viewPortHeight);
	
	    return viewPortHeight;
	  };
	
	  Grid.prototype.getViewportWidth = function getViewportWidth() {
	    var self = this;
	
	    var viewPortWidth = this.gridWidth;
	
	    //if (typeof(this.verticalScrollbarWidth) !== 'undefined' && this.verticalScrollbarWidth !== undefined && this.verticalScrollbarWidth > 0) {
	    //  viewPortWidth = viewPortWidth - this.verticalScrollbarWidth;
	    //}
	
	    var adjustment = self.getViewportAdjustment();
	
	    viewPortWidth = viewPortWidth + adjustment.width;
	
	    //gridUtil.logDebug('getviewPortWidth', viewPortWidth);
	
	    return viewPortWidth;
	  };
	
	  Grid.prototype.getHeaderViewportWidth = function getHeaderViewportWidth() {
	    var viewPortWidth = this.getViewportWidth();
	
	    //if (typeof(this.verticalScrollbarWidth) !== 'undefined' && this.verticalScrollbarWidth !== undefined && this.verticalScrollbarWidth > 0) {
	    //  viewPortWidth = viewPortWidth + this.verticalScrollbarWidth;
	    //}
	
	    return viewPortWidth;
	  };
	
	  Grid.prototype.addVerticalScrollSync = function (containerId, callBackFn) {
	    this.verticalScrollSyncCallBackFns[containerId] = callBackFn;
	  };
	
	  Grid.prototype.addHorizontalScrollSync = function (containerId, callBackFn) {
	    this.horizontalScrollSyncCallBackFns[containerId] = callBackFn;
	  };
	
	/**
	 * Scroll needed containers by calling their ScrollSyncs
	 * @param sourceContainerId the containerId that has already set it's top/left.
	 *         can be empty string which means all containers need to set top/left
	 * @param scrollEvent
	 */
	  Grid.prototype.scrollContainers = function (sourceContainerId, scrollEvent) {
	
	    if (scrollEvent.y) {
	      //default for no container Id (ex. mousewheel means that all containers must set scrollTop/Left)
	      var verts = ['body','left', 'right'];
	
	      this.flagScrollingVertically(scrollEvent);
	
	      if (sourceContainerId === 'body') {
	        verts = ['left', 'right'];
	      }
	      else if (sourceContainerId === 'left') {
	        verts = ['body', 'right'];
	      }
	      else if (sourceContainerId === 'right') {
	        verts = ['body', 'left'];
	      }
	
	      for (var i = 0; i < verts.length; i++) {
	        var id = verts[i];
	        if (this.verticalScrollSyncCallBackFns[id]) {
	          this.verticalScrollSyncCallBackFns[id](scrollEvent);
	        }
	      }
	
	    }
	
	    if (scrollEvent.x) {
	      //default for no container Id (ex. mousewheel means that all containers must set scrollTop/Left)
	      var horizs = ['body','bodyheader', 'bodyfooter'];
	
	      this.flagScrollingHorizontally(scrollEvent);
	      if (sourceContainerId === 'body') {
	        horizs = ['bodyheader', 'bodyfooter'];
	      }
	
	      for (var j = 0; j < horizs.length; j++) {
	        var idh = horizs[j];
	        if (this.horizontalScrollSyncCallBackFns[idh]) {
	          this.horizontalScrollSyncCallBackFns[idh](scrollEvent);
	        }
	      }
	
	    }
	
	  };
	
	  Grid.prototype.registerViewportAdjuster = function registerViewportAdjuster(func) {
	    this.viewportAdjusters.push(func);
	  };
	
	  Grid.prototype.removeViewportAdjuster = function registerViewportAdjuster(func) {
	    var idx = this.viewportAdjusters.indexOf(func);
	
	    if (typeof(idx) !== 'undefined' && idx !== undefined) {
	      this.viewportAdjusters.splice(idx, 1);
	    }
	  };
	
	  Grid.prototype.getViewportAdjustment = function getViewportAdjustment() {
	    var self = this;
	
	    var adjustment = { height: 0, width: 0 };
	
	    self.viewportAdjusters.forEach(function (func) {
	      adjustment = func.call(this, adjustment);
	    });
	
	    return adjustment;
	  };
	
	  Grid.prototype.getVisibleRowCount = function getVisibleRowCount() {
	    // var count = 0;
	
	    // this.rows.forEach(function (row) {
	    //   if (row.visible) {
	    //     count++;
	    //   }
	    // });
	
	    // return this.visibleRowCache.length;
	    return this.renderContainers.body.visibleRowCache.length;
	  };
	
	   Grid.prototype.getVisibleRows = function getVisibleRows() {
	    return this.renderContainers.body.visibleRowCache;
	   };
	
	  Grid.prototype.getVisibleColumnCount = function getVisibleColumnCount() {
	    // var count = 0;
	
	    // this.rows.forEach(function (row) {
	    //   if (row.visible) {
	    //     count++;
	    //   }
	    // });
	
	    // return this.visibleRowCache.length;
	    return this.renderContainers.body.visibleColumnCache.length;
	  };
	
	
	  Grid.prototype.searchRows = function searchRows(renderableRows) {
	    return rowSearcher.search(this, renderableRows, this.columns);
	  };
	
	  Grid.prototype.sortByColumn = function sortByColumn(renderableRows) {
	    return rowSorter.sort(this, renderableRows, this.columns);
	  };
	
	  /**
	   * @ngdoc function
	   * @name getCellValue
	   * @methodOf ui.grid.class:Grid
	   * @description Gets the value of a cell for a particular row and column
	   * @param {GridRow} row Row to access
	   * @param {GridColumn} col Column to access
	   */
	  Grid.prototype.getCellValue = function getCellValue(row, col){
	    if ( typeof(row.entity[ '$$' + col.uid ]) !== 'undefined' ) {
	      return row.entity[ '$$' + col.uid].rendered;
	    } else if (this.options.flatEntityAccess && typeof(col.field) !== 'undefined' ){
	      return row.entity[col.field];
	    } else {
	      if (!col.cellValueGetterCache) {
	        col.cellValueGetterCache = $parse(row.getEntityQualifiedColField(col));
	      }
	
	      return col.cellValueGetterCache(row);
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name getCellDisplayValue
	   * @methodOf ui.grid.class:Grid
	   * @description Gets the displayed value of a cell after applying any the `cellFilter`
	   * @param {GridRow} row Row to access
	   * @param {GridColumn} col Column to access
	   */
	  Grid.prototype.getCellDisplayValue = function getCellDisplayValue(row, col) {
	    if ( !col.cellDisplayGetterCache ) {
	      var custom_filter = col.cellFilter ? " | " + col.cellFilter : "";
	
	      if (typeof(row.entity['$$' + col.uid]) !== 'undefined') {
	        col.cellDisplayGetterCache = $parse(row.entity['$$' + col.uid].rendered + custom_filter);
	      } else if (this.options.flatEntityAccess && typeof(col.field) !== 'undefined') {
	        var colField = col.field.replace(/(')|(\\)/g, "\\$&");
	        col.cellDisplayGetterCache = $parse('entity[\'' + colField + '\']' + custom_filter);
	      } else {
	        col.cellDisplayGetterCache = $parse(row.getEntityQualifiedColField(col) + custom_filter);
	      }
	    }
	
	    var rowWithCol = angular.extend({}, row, {col: col});
	    return col.cellDisplayGetterCache(rowWithCol);
	  };
	
	
	  Grid.prototype.getNextColumnSortPriority = function getNextColumnSortPriority() {
	    var self = this,
	        p = 0;
	
	    self.columns.forEach(function (col) {
	      if (col.sort && col.sort.priority !== undefined && col.sort.priority >= p) {
	        p = col.sort.priority + 1;
	      }
	    });
	
	    return p;
	  };
	
	  /**
	   * @ngdoc function
	   * @name resetColumnSorting
	   * @methodOf ui.grid.class:Grid
	   * @description Return the columns that the grid is currently being sorted by
	   * @param {GridColumn} [excludedColumn] Optional GridColumn to exclude from having its sorting reset
	   */
	  Grid.prototype.resetColumnSorting = function resetColumnSorting(excludeCol) {
	    var self = this;
	
	    self.columns.forEach(function (col) {
	      if (col !== excludeCol && !col.suppressRemoveSort) {
	        col.sort = {};
	      }
	    });
	  };
	
	  /**
	   * @ngdoc function
	   * @name getColumnSorting
	   * @methodOf ui.grid.class:Grid
	   * @description Return the columns that the grid is currently being sorted by
	   * @returns {Array[GridColumn]} An array of GridColumn objects
	   */
	  Grid.prototype.getColumnSorting = function getColumnSorting() {
	    var self = this;
	
	    var sortedCols = [], myCols;
	
	    // Iterate through all the columns, sorted by priority
	    // Make local copy of column list, because sorting is in-place and we do not want to
	    // change the original sequence of columns
	    myCols = self.columns.slice(0);
	    myCols.sort(rowSorter.prioritySort).forEach(function (col) {
	      if (col.sort && typeof(col.sort.direction) !== 'undefined' && col.sort.direction && (col.sort.direction === uiGridConstants.ASC || col.sort.direction === uiGridConstants.DESC)) {
	        sortedCols.push(col);
	      }
	    });
	
	    return sortedCols;
	  };
	
	  /**
	   * @ngdoc function
	   * @name sortColumn
	   * @methodOf ui.grid.class:Grid
	   * @description Set the sorting on a given column, optionally resetting any existing sorting on the Grid.
	   * Emits the sortChanged event whenever the sort criteria are changed.
	   * @param {GridColumn} column Column to set the sorting on
	   * @param {uiGridConstants.ASC|uiGridConstants.DESC} [direction] Direction to sort by, either descending or ascending.
	   *   If not provided, the column will iterate through the sort directions
	   *   specified in the {@link ui.grid.class:GridOptions.columnDef#sortDirectionCycle sortDirectionCycle} attribute.
	   * @param {boolean} [add] Add this column to the sorting. If not provided or set to `false`, the Grid will reset any existing sorting and sort
	   *   by this column only
	   * @returns {Promise} A resolved promise that supplies the column.
	   */
	
	  Grid.prototype.sortColumn = function sortColumn(column, directionOrAdd, add) {
	    var self = this,
	        direction = null;
	
	    if (typeof(column) === 'undefined' || !column) {
	      throw new Error('No column parameter provided');
	    }
	
	    // Second argument can either be a direction or whether to add this column to the existing sort.
	    //   If it's a boolean, it's an add, otherwise, it's a direction
	    if (typeof(directionOrAdd) === 'boolean') {
	      add = directionOrAdd;
	    }
	    else {
	      direction = directionOrAdd;
	    }
	
	    if (!add) {
	      self.resetColumnSorting(column);
	      column.sort.priority = undefined;
	      // Get the actual priority since there may be columns which have suppressRemoveSort set
	      column.sort.priority = self.getNextColumnSortPriority();
	    }
	    else if (column.sort.priority === undefined){
	      column.sort.priority = self.getNextColumnSortPriority();
	    }
	
	    if (!direction) {
	      // Find the current position in the cycle (or -1).
	      var i = column.sortDirectionCycle.indexOf(column.sort.direction ? column.sort.direction : null);
	      // Proceed to the next position in the cycle (or start at the beginning).
	      i = (i+1) % column.sortDirectionCycle.length;
	      // If suppressRemoveSort is set, and the next position in the cycle would
	      // remove the sort, skip it.
	      if (column.colDef && column.suppressRemoveSort && !column.sortDirectionCycle[i]) {
	        i = (i+1) % column.sortDirectionCycle.length;
	      }
	
	      if (column.sortDirectionCycle[i]) {
	        column.sort.direction = column.sortDirectionCycle[i];
	      } else {
	        removeSortOfColumn(column, self);
	      }
	    }
	    else {
	      column.sort.direction = direction;
	    }
	
	    self.api.core.raise.sortChanged( self, self.getColumnSorting() );
	
	    return $q.when(column);
	  };
	
	  var removeSortOfColumn = function removeSortOfColumn(column, grid) {
	    //Decrease priority for every col where priority is higher than the removed sort's priority.
	    grid.columns.forEach(function (col) {
	      if (col.sort && col.sort.priority !== undefined && col.sort.priority > column.sort.priority) {
	        col.sort.priority -= 1;
	      }
	    });
	
	    //Remove sort
	    column.sort = {};
	  };
	
	  /**
	   * communicate to outside world that we are done with initial rendering
	   */
	  Grid.prototype.renderingComplete = function(){
	    if (angular.isFunction(this.options.onRegisterApi)) {
	      this.options.onRegisterApi(this.api);
	    }
	    this.api.core.raise.renderingComplete( this.api );
	  };
	
	  Grid.prototype.createRowHashMap = function createRowHashMap() {
	    var self = this;
	
	    var hashMap = new RowHashMap();
	    hashMap.grid = self;
	
	    return hashMap;
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name refresh
	   * @methodOf ui.grid.class:Grid
	   * @description Refresh the rendered grid on screen.
	   * @param {boolean} [rowsAltered] Optional flag for refreshing when the number of rows has changed.
	   */
	  Grid.prototype.refresh = function refresh(rowsAltered) {
	    var self = this;
	
	    var p1 = self.processRowsProcessors(self.rows).then(function (renderableRows) {
	      self.setVisibleRows(renderableRows);
	    }).catch(angular.noop);
	
	    var p2 = self.processColumnsProcessors(self.columns).then(function (renderableColumns) {
	      self.setVisibleColumns(renderableColumns);
	    }).catch(angular.noop);
	
	    return $q.all([p1, p2]).then(function () {
	      self.refreshCanvas(true);
	      self.redrawInPlace(rowsAltered);
	    }).catch(angular.noop);
	  };
	
	  /**
	   * @ngdoc function
	   * @name refreshRows
	   * @methodOf ui.grid.class:Grid
	   * @description Refresh the rendered rows on screen?  Note: not functional at present
	   * @returns {promise} promise that is resolved when render completes?
	   *
	   */
	  Grid.prototype.refreshRows = function refreshRows() {
	    var self = this;
	
	    return self.processRowsProcessors(self.rows)
	      .then(function (renderableRows) {
	        self.setVisibleRows(renderableRows);
	
	        self.redrawInPlace();
	
	        self.refreshCanvas( true );
	      }).catch(angular.noop);
	  };
	
	  /**
	   * @ngdoc function
	   * @name refreshCanvas
	   * @methodOf ui.grid.class:Grid
	   * @description Builds all styles and recalculates much of the grid sizing
	   * @param {object} buildStyles optional parameter.  Use TBD
	   * @returns {promise} promise that is resolved when the canvas
	   * has been refreshed
	   *
	   */
	  Grid.prototype.refreshCanvas = function(buildStyles) {
	    var self = this;
	
	    // gridUtil.logDebug('refreshCanvas');
	
	    var p = $q.defer();
	
	    // Get all the header heights
	    var containerHeadersToRecalc = [];
	    for (var containerId in self.renderContainers) {
	      if (self.renderContainers.hasOwnProperty(containerId)) {
	        var container = self.renderContainers[containerId];
	
	        // Skip containers that have no canvasWidth set yet
	        if (container.canvasWidth === null || isNaN(container.canvasWidth)) {
	          continue;
	        }
	
	        if (container.header || container.headerCanvas) {
	          container.explicitHeaderHeight = container.explicitHeaderHeight || null;
	          container.explicitHeaderCanvasHeight = container.explicitHeaderCanvasHeight || null;
	
	          containerHeadersToRecalc.push(container);
	        }
	      }
	    }
	
	    // Build the styles without the explicit header heights
	    if (buildStyles) {
	      self.buildStyles();
	    }
	
	    /*
	     *
	     * Here we loop through the headers, measuring each element as well as any header "canvas" it has within it.
	     *
	     * If any header is less than the largest header height, it will be resized to that so that we don't have headers
	     * with different heights, which looks like a rendering problem
	     *
	     * We'll do the same thing with the header canvases, and give the header CELLS an explicit height if their canvas
	     * is smaller than the largest canvas height. That was header cells without extra controls like filtering don't
	     * appear shorter than other cells.
	     *
	     */
	    if (containerHeadersToRecalc.length > 0) {
	      // Putting in a timeout as it's not calculating after the grid element is rendered and filled out
	      $timeout(function() {
	        // var oldHeaderHeight = self.grid.headerHeight;
	        // self.grid.headerHeight = gridUtil.outerElementHeight(self.header);
	
	        var rebuildStyles = false;
	
	        // Get all the header heights
	        var maxHeaderHeight = 0;
	        var maxHeaderCanvasHeight = 0;
	        var i, container;
	        var getHeight = function(oldVal, newVal){
	          if ( oldVal !== newVal){
	            rebuildStyles = true;
	          }
	          return newVal;
	        };
	        for (i = 0; i < containerHeadersToRecalc.length; i++) {
	          container = containerHeadersToRecalc[i];
	
	          // Skip containers that have no canvasWidth set yet
	          if (container.canvasWidth === null || isNaN(container.canvasWidth)) {
	            continue;
	          }
	
	          if (container.header) {
	            var headerHeight = container.headerHeight = getHeight(container.headerHeight, gridUtil.outerElementHeight(container.header));
	
	            // Get the "inner" header height, that is the height minus the top and bottom borders, if present. We'll use it to make sure all the headers have a consistent height
	            var topBorder = gridUtil.getBorderSize(container.header, 'top');
	            var bottomBorder = gridUtil.getBorderSize(container.header, 'bottom');
	            var innerHeaderHeight = parseInt(headerHeight - topBorder - bottomBorder, 10);
	
	            innerHeaderHeight  = innerHeaderHeight < 0 ? 0 : innerHeaderHeight;
	
	            container.innerHeaderHeight = innerHeaderHeight;
	
	            // If the header doesn't have an explicit height set, save the largest header height for use later
	            //   Explicit header heights are based off of the max we are calculating here. We never want to base the max on something we're setting explicitly
	            if (!container.explicitHeaderHeight && innerHeaderHeight > maxHeaderHeight) {
	              maxHeaderHeight = innerHeaderHeight;
	            }
	          }
	
	          if (container.headerCanvas) {
	            var headerCanvasHeight = container.headerCanvasHeight = getHeight(container.headerCanvasHeight, parseInt(gridUtil.outerElementHeight(container.headerCanvas), 10));
	
	
	            // If the header doesn't have an explicit canvas height, save the largest header canvas height for use later
	            //   Explicit header heights are based off of the max we are calculating here. We never want to base the max on something we're setting explicitly
	            if (!container.explicitHeaderCanvasHeight && headerCanvasHeight > maxHeaderCanvasHeight) {
	              maxHeaderCanvasHeight = headerCanvasHeight;
	            }
	          }
	        }
	
	        // Go through all the headers
	        for (i = 0; i < containerHeadersToRecalc.length; i++) {
	          container = containerHeadersToRecalc[i];
	
	          /* If:
	              1. We have a max header height
	              2. This container has a header height defined
	              3. And either this container has an explicit header height set, OR its header height is less than the max
	
	              then:
	
	              Give this container's header an explicit height so it will line up with the tallest header
	          */
	          if (
	            maxHeaderHeight > 0 && typeof(container.headerHeight) !== 'undefined' && container.headerHeight !== null &&
	            (container.explicitHeaderHeight || container.headerHeight < maxHeaderHeight)
	          ) {
	            container.explicitHeaderHeight = getHeight(container.explicitHeaderHeight, maxHeaderHeight);
	          }
	
	          // Do the same as above except for the header canvas
	          if (
	            maxHeaderCanvasHeight > 0 && typeof(container.headerCanvasHeight) !== 'undefined' && container.headerCanvasHeight !== null &&
	            (container.explicitHeaderCanvasHeight || container.headerCanvasHeight < maxHeaderCanvasHeight)
	          ) {
	            container.explicitHeaderCanvasHeight = getHeight(container.explicitHeaderCanvasHeight, maxHeaderCanvasHeight);
	          }
	        }
	
	        // Rebuild styles if the header height has changed
	        //   The header height is used in body/viewport calculations and those are then used in other styles so we need it to be available
	        if (buildStyles && rebuildStyles) {
	          self.buildStyles();
	        }
	
	        p.resolve();
	      });
	    }
	    else {
	      // Timeout still needs to be here to trigger digest after styles have been rebuilt
	      $timeout(function() {
	        p.resolve();
	      });
	    }
	
	    return p.promise;
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name redrawInPlace
	   * @methodOf ui.grid.class:Grid
	   * @description Redraw the rows and columns based on our current scroll position
	   * @param {boolean} [rowsAdded] Optional to indicate rows are added and the scroll percentage must be recalculated
	   *
	   */
	  Grid.prototype.redrawInPlace = function redrawInPlace(rowsAdded) {
	    // gridUtil.logDebug('redrawInPlace');
	
	    var self = this;
	
	    for (var i in self.renderContainers) {
	      var container = self.renderContainers[i];
	
	      // gridUtil.logDebug('redrawing container', i);
	
	      if (rowsAdded) {
	        container.adjustRows(container.prevScrollTop, null);
	        container.adjustColumns(container.prevScrollLeft, null);
	      }
	      else {
	        container.adjustRows(null, container.prevScrolltopPercentage);
	        container.adjustColumns(null, container.prevScrollleftPercentage);
	      }
	    }
	  };
	
	    /**
	     * @ngdoc function
	     * @name hasLeftContainerColumns
	     * @methodOf ui.grid.class:Grid
	     * @description returns true if leftContainer has columns
	     */
	    Grid.prototype.hasLeftContainerColumns = function () {
	      return this.hasLeftContainer() && this.renderContainers.left.renderedColumns.length > 0;
	    };
	
	    /**
	     * @ngdoc function
	     * @name hasRightContainerColumns
	     * @methodOf ui.grid.class:Grid
	     * @description returns true if rightContainer has columns
	     */
	    Grid.prototype.hasRightContainerColumns = function () {
	      return this.hasRightContainer() && this.renderContainers.right.renderedColumns.length > 0;
	    };
	
	    // Turn the scroll position into a percentage and make it an argument for a scroll event
	    function getScrollPercentage(scrollPixels, scrollLength) {
	      var percentage = scrollPixels / scrollLength;
	
	      // if the percentage is greater than 1, set it to 1
	      return percentage <= 1 ? percentage : 1;
	    }
	
	    // Only returns the scroll Y position if the percentage is different from the previous
	    function getScrollY(scrollPixels, scrollLength, prevScrolltopPercentage) {
	      var scrollPercentage = getScrollPercentage(scrollPixels, scrollLength);
	
	      if (scrollPercentage !== prevScrolltopPercentage) {
	        return { percentage: getScrollPercentage(scrollPixels, scrollLength) };
	      }
	
	      return undefined;
	    }
	
	    // Only returns the scroll X position if the percentage is different from the previous
	    function getScrollX(horizScrollPixels, horizScrollLength, prevScrollleftPercentage) {
	      var horizPercentage = horizScrollPixels / horizScrollLength;
	      horizPercentage = (horizPercentage > 1) ? 1 : horizPercentage;
	
	      if (horizPercentage !== prevScrollleftPercentage) {
	        return { percentage: horizPercentage  };
	      }
	
	      return undefined;
	    }
	
	    /**
	     * @ngdoc method
	     * @methodOf  ui.grid.class:Grid
	     * @name scrollToIfNecessary
	     * @description Scrolls the grid to make a certain row and column combo visible,
	     *   in the case that it is not completely visible on the screen already.
	     * @param {GridRow} gridRow row to make visible
	     * @param {GridColumn} gridCol column to make visible
	     * @returns {promise} a promise that is resolved when scrolling is complete
	     */
	    Grid.prototype.scrollToIfNecessary = function (gridRow, gridCol) {
	      var self = this;
	
	      var scrollEvent = new ScrollEvent(self, 'uiGrid.scrollToIfNecessary');
	
	      // Alias the visible row and column caches
	      var visRowCache = self.renderContainers.body.visibleRowCache;
	      var visColCache = self.renderContainers.body.visibleColumnCache;
	
	      /*-- Get the top, left, right, and bottom "scrolled" edges of the grid --*/
	
	      // The top boundary is the current Y scroll position PLUS the header height, because the header can obscure rows when the grid is scrolled downwards
	      var topBound = self.renderContainers.body.prevScrollTop + self.headerHeight;
	
	      // Don't the let top boundary be less than 0
	      topBound = (topBound < 0) ? 0 : topBound;
	
	      // The left boundary is the current X scroll position
	      var leftBound = self.renderContainers.body.prevScrollLeft;
	
	      // The bottom boundary is the current Y scroll position, plus the height of the grid, but minus the header height.
	      //   Basically this is the viewport height added on to the scroll position
	      var bottomBound = self.renderContainers.body.prevScrollTop + self.gridHeight - self.renderContainers.body.headerHeight - self.footerHeight -  self.scrollbarWidth;
	
	      // If there's a horizontal scrollbar, remove its height from the bottom boundary, otherwise we'll be letting it obscure rows
	      //if (self.horizontalScrollbarHeight) {
	      //  bottomBound = bottomBound - self.horizontalScrollbarHeight;
	      //}
	
	      // The right position is the current X scroll position minus the grid width
	      var rightBound = self.renderContainers.body.prevScrollLeft + Math.ceil(self.renderContainers.body.getViewportWidth());
	
	      // If there's a vertical scrollbar, subtract it from the right boundary or we'll allow it to obscure cells
	      //if (self.verticalScrollbarWidth) {
	      //  rightBound = rightBound - self.verticalScrollbarWidth;
	      //}
	
	      // We were given a row to scroll to
	      if (gridRow !== null) {
	        // This is the index of the row we want to scroll to, within the list of rows that can be visible
	        var seekRowIndex = visRowCache.indexOf(gridRow);
	
	        // Total vertical scroll length of the grid
	        var scrollLength = (self.renderContainers.body.getCanvasHeight() - self.renderContainers.body.getViewportHeight());
	
	        // Add the height of the native horizontal scrollbar to the scroll length, if it's there. Otherwise it will mask over the final row
	        //if (self.horizontalScrollbarHeight && self.horizontalScrollbarHeight > 0) {
	        //  scrollLength = scrollLength + self.horizontalScrollbarHeight;
	        //}
	
	        // This is the minimum amount of pixels we need to scroll vertical in order to see this row.
	        var pixelsToSeeRow = (seekRowIndex * self.options.rowHeight + self.headerHeight);
	
	        // Don't let the pixels required to see the row be less than zero
	        pixelsToSeeRow = (pixelsToSeeRow < 0) ? 0 : pixelsToSeeRow;
	
	        var scrollPixels;
	
	        // If the scroll position we need to see the row is LESS than the top boundary, i.e. obscured above the top of the self...
	        if (pixelsToSeeRow < topBound) {
	          // Get the different between the top boundary and the required scroll position and subtract it from the current scroll position\
	          //   to get the full position we need
	          scrollPixels = self.renderContainers.body.prevScrollTop - (topBound - pixelsToSeeRow);
	
	          scrollEvent.y = getScrollY(scrollPixels, scrollLength, self.renderContainers.body.prevScrolltopPercentage);
	        }
	        // Otherwise if the scroll position we need to see the row is MORE than the bottom boundary, i.e. obscured below the bottom of the self...
	        else if (pixelsToSeeRow > bottomBound) {
	          // Get the different between the bottom boundary and the required scroll position and add it to the current scroll position
	          //   to get the full position we need
	          scrollPixels = pixelsToSeeRow - bottomBound + self.renderContainers.body.prevScrollTop;
	
	          scrollEvent.y = getScrollY(scrollPixels, scrollLength,self.renderContainers.body.prevScrolltopPercentage);
	        }
	      }
	
	      // We were given a column to scroll to
	      if (gridCol !== null) {
	        // This is the index of the column we want to scroll to, within the list of columns that can be visible
	        var seekColumnIndex = visColCache.indexOf(gridCol);
	
	        // Total horizontal scroll length of the grid
	        var horizScrollLength = (self.renderContainers.body.getCanvasWidth() - self.renderContainers.body.getViewportWidth());
	
	        // This is the minimum amount of pixels we need to scroll horizontal in order to see this column
	        var columnLeftEdge = 0;
	        for (var i = 0; i < seekColumnIndex; i++) {
	          var col = visColCache[i];
	          columnLeftEdge += col.drawnWidth;
	        }
	        columnLeftEdge = (columnLeftEdge < 0) ? 0 : columnLeftEdge;
	
	        var columnRightEdge = columnLeftEdge + gridCol.drawnWidth;
	
	        // Don't let the pixels required to see the column be less than zero
	        columnRightEdge = (columnRightEdge < 0) ? 0 : columnRightEdge;
	
	        var horizScrollPixels;
	
	        // If the scroll position we need to see the column is LESS than the left boundary, i.e. obscured before the left of the self...
	        if (columnLeftEdge < leftBound) {
	          // Get the different between the left boundary and the required scroll position and subtract it from the current scroll position\
	          //   to get the full position we need
	          horizScrollPixels = self.renderContainers.body.prevScrollLeft - (leftBound - columnLeftEdge);
	
	          // Turn the scroll position into a percentage and make it an argument for a scroll event
	          scrollEvent.x = getScrollX(horizScrollPixels, horizScrollLength, self.renderContainers.body.prevScrollleftPercentage);
	        }
	        // Otherwise if the scroll position we need to see the column is MORE than the right boundary, i.e. obscured after the right of the self...
	        else if (columnRightEdge > rightBound) {
	          // Get the different between the right boundary and the required scroll position and add it to the current scroll position
	          //   to get the full position we need
	          horizScrollPixels = columnRightEdge - rightBound + self.renderContainers.body.prevScrollLeft;
	
	          // Turn the scroll position into a percentage and make it an argument for a scroll event
	          scrollEvent.x = getScrollX(horizScrollPixels, horizScrollLength, self.renderContainers.body.prevScrollleftPercentage);
	        }
	      }
	
	      var deferred = $q.defer();
	
	      // If we need to scroll on either the x or y axes, fire a scroll event
	      if (scrollEvent.y || scrollEvent.x) {
	        scrollEvent.withDelay = false;
	        self.scrollContainers('',scrollEvent);
	        var dereg = self.api.core.on.scrollEnd(null,function() {
	          deferred.resolve(scrollEvent);
	          dereg();
	        });
	      }
	      else {
	        deferred.resolve();
	      }
	
	      return deferred.promise;
	    };
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.class:Grid
	     * @name scrollTo
	     * @description Scroll the grid such that the specified
	     * row and column is in view
	     * @param {object} rowEntity gridOptions.data[] array instance to make visible
	     * @param {object} colDef to make visible
	     * @returns {promise} a promise that is resolved after any scrolling is finished
	     */
	    Grid.prototype.scrollTo = function (rowEntity, colDef) {
	      var gridRow = null, gridCol = null;
	
	      if (rowEntity !== null && typeof(rowEntity) !== 'undefined' ) {
	        gridRow = this.getRow(rowEntity);
	      }
	
	      if (colDef !== null && typeof(colDef) !== 'undefined' ) {
	        gridCol = this.getColumn(colDef.name ? colDef.name : colDef.field);
	      }
	      return this.scrollToIfNecessary(gridRow, gridCol);
	    };
	
	  /**
	   * @ngdoc function
	   * @name clearAllFilters
	   * @methodOf ui.grid.class:Grid
	   * @description Clears all filters and optionally refreshes the visible rows.
	   * @param {object} refreshRows Defaults to true.
	   * @param {object} clearConditions Defaults to false.
	   * @param {object} clearFlags Defaults to false.
	   * @returns {promise} If `refreshRows` is true, returns a promise of the rows refreshing.
	   */
	  Grid.prototype.clearAllFilters = function clearAllFilters(refreshRows, clearConditions, clearFlags) {
	    // Default `refreshRows` to true because it will be the most commonly desired behaviour.
	    if (refreshRows === undefined) {
	      refreshRows = true;
	    }
	    if (clearConditions === undefined) {
	      clearConditions = false;
	    }
	    if (clearFlags === undefined) {
	      clearFlags = false;
	    }
	
	    this.columns.forEach(function(column) {
	      column.filters.forEach(function(filter) {
	        filter.term = undefined;
	
	        if (clearConditions) {
	          filter.condition = undefined;
	        }
	
	        if (clearFlags) {
	          filter.flags = undefined;
	        }
	      });
	    });
	
	    if (refreshRows) {
	      return this.refreshRows();
	    }
	  };
	
	
	      // Blatantly stolen from Angular as it isn't exposed (yet? 2.0?)
	  function RowHashMap() {}
	
	  RowHashMap.prototype = {
	    /**
	     * Store key value pair
	     * @param key key to store can be any type
	     * @param value value to store can be any type
	     */
	    put: function(key, value) {
	      this[this.grid.options.rowIdentity(key)] = value;
	    },
	
	    /**
	     * @param key
	     * @returns {Object} the value for the key
	     */
	    get: function(key) {
	      return this[this.grid.options.rowIdentity(key)];
	    },
	
	    /**
	     * Remove the key/value pair
	     * @param key
	     */
	    remove: function(key) {
	      var value = this[key = this.grid.options.rowIdentity(key)];
	      delete this[key];
	      return value;
	    }
	  };
	
	
	
	  return Grid;
	
	}]);
	
	})();
	
	(function () {
	
	  angular.module('ui.grid')
	    .factory('GridApi', ['$q', '$rootScope', 'gridUtil', 'uiGridConstants', 'GridRow', 'uiGridGridMenuService',
	      function ($q, $rootScope, gridUtil, uiGridConstants, GridRow, uiGridGridMenuService) {
	        /**
	         * @ngdoc function
	         * @name ui.grid.class:GridApi
	         * @description GridApi provides the ability to register public methods events inside the grid and allow
	         * for other components to use the api via featureName.raise.methodName and featureName.on.eventName(function(args){}.
	         * <br/>
	         * To listen to events, you must add a callback to gridOptions.onRegisterApi
	         * <pre>
	         *   $scope.gridOptions.onRegisterApi = function(gridApi){
	         *      gridApi.cellNav.on.navigate($scope,function(newRowCol, oldRowCol){
	         *          $log.log('navigation event');
	         *      });
	         *   };
	         * </pre>
	         * @param {object} grid grid that owns api
	         */
	        var GridApi = function GridApi(grid) {
	          this.grid = grid;
	          this.listeners = [];
	
	          /**
	           * @ngdoc function
	           * @name renderingComplete
	           * @methodOf  ui.grid.core.api:PublicApi
	           * @description Rendering is complete, called at the same
	           * time as `onRegisterApi`, but provides a way to obtain
	           * that same event within features without stopping end
	           * users from getting at the onRegisterApi method.
	           *
	           * Included in gridApi so that it's always there - otherwise
	           * there is still a timing problem with when a feature can
	           * call this.
	           *
	           * @param {GridApi} gridApi the grid api, as normally
	           * returned in the onRegisterApi method
	           *
	           * @example
	           * <pre>
	           *      gridApi.core.on.renderingComplete( grid );
	           * </pre>
	           */
	          this.registerEvent( 'core', 'renderingComplete' );
	
	          /**
	           * @ngdoc event
	           * @name filterChanged
	           * @eventOf  ui.grid.core.api:PublicApi
	           * @description  is raised after the filter is changed.  The nature
	           * of the watch expression doesn't allow notification of what changed,
	           * so the receiver of this event will need to re-extract the filter
	           * conditions from the columns.
	           *
	           */
	          this.registerEvent( 'core', 'filterChanged' );
	
	          /**
	           * @ngdoc function
	           * @name setRowInvisible
	           * @methodOf  ui.grid.core.api:PublicApi
	           * @description Sets an override on the row to make it always invisible,
	           * which will override any filtering or other visibility calculations.
	           * If the row is currently visible then sets it to invisible and calls
	           * both grid refresh and emits the rowsVisibleChanged event
	           * @param {GridRow} row the row we want to make invisible
	           */
	          this.registerMethod( 'core', 'setRowInvisible', GridRow.prototype.setRowInvisible );
	
	          /**
	           * @ngdoc function
	           * @name clearRowInvisible
	           * @methodOf  ui.grid.core.api:PublicApi
	           * @description Clears any override on visibility for the row so that it returns to
	           * using normal filtering and other visibility calculations.
	           * If the row is currently invisible then sets it to visible and calls
	           * both grid refresh and emits the rowsVisibleChanged event
	           * TODO: if a filter is active then we can't just set it to visible?
	           * @param {GridRow} row the row we want to make visible
	           */
	          this.registerMethod( 'core', 'clearRowInvisible', GridRow.prototype.clearRowInvisible );
	
	          /**
	           * @ngdoc function
	           * @name getVisibleRows
	           * @methodOf  ui.grid.core.api:PublicApi
	           * @description Returns all visible rows
	           * @param {Grid} grid the grid you want to get visible rows from
	           * @returns {array} an array of gridRow
	           */
	          this.registerMethod( 'core', 'getVisibleRows', this.grid.getVisibleRows );
	
	          /**
	           * @ngdoc event
	           * @name rowsVisibleChanged
	           * @eventOf  ui.grid.core.api:PublicApi
	           * @description  is raised after the rows that are visible
	           * change.  The filtering is zero-based, so it isn't possible
	           * to say which rows changed (unlike in the selection feature).
	           * We can plausibly know which row was changed when setRowInvisible
	           * is called, but in that situation the user already knows which row
	           * they changed.  When a filter runs we don't know what changed,
	           * and that is the one that would have been useful.
	           *
	           */
	          this.registerEvent( 'core', 'rowsVisibleChanged' );
	
	          /**
	           * @ngdoc event
	           * @name rowsRendered
	           * @eventOf  ui.grid.core.api:PublicApi
	           * @description  is raised after the cache of visible rows is changed.
	           */
	          this.registerEvent( 'core', 'rowsRendered' );
	
	
	          /**
	           * @ngdoc event
	           * @name scrollBegin
	           * @eventOf  ui.grid.core.api:PublicApi
	           * @description  is raised when scroll begins.  Is throttled, so won't be raised too frequently
	           */
	          this.registerEvent( 'core', 'scrollBegin' );
	
	          /**
	           * @ngdoc event
	           * @name scrollEnd
	           * @eventOf  ui.grid.core.api:PublicApi
	           * @description  is raised when scroll has finished.  Is throttled, so won't be raised too frequently
	           */
	          this.registerEvent( 'core', 'scrollEnd' );
	
	          /**
	           * @ngdoc event
	           * @name canvasHeightChanged
	           * @eventOf  ui.grid.core.api:PublicApi
	           * @description  is raised when the canvas height has changed
	           * <br/>
	           * arguments: oldHeight, newHeight
	           */
	          this.registerEvent( 'core', 'canvasHeightChanged');
	
	          /**
	           * @ngdoc event
	           * @name gridDimensionChanged
	           * @eventOf  ui.grid.core.api:PublicApi
	           * @description  is raised when the grid dimensions have changed (when autoResize is on)
	           * <br/>
	           * arguments: oldGridHeight, oldGridWidth, newGridHeight, newGridWidth
	           */
	          this.registerEvent( 'core', 'gridDimensionChanged');
	        };
	
	        /**
	         * @ngdoc function
	         * @name ui.grid.class:suppressEvents
	         * @methodOf ui.grid.class:GridApi
	         * @description Used to execute a function while disabling the specified event listeners.
	         * Disables the listenerFunctions, executes the callbackFn, and then enables
	         * the listenerFunctions again
	         * @param {object} listenerFuncs listenerFunc or array of listenerFuncs to suppress. These must be the same
	         * functions that were used in the .on.eventName method
	         * @param {object} callBackFn function to execute
	         * @example
	         * <pre>
	         *    var navigate = function (newRowCol, oldRowCol){
	         *       //do something on navigate
	         *    }
	         *
	         *    gridApi.cellNav.on.navigate(scope,navigate);
	         *
	         *
	         *    //call the scrollTo event and suppress our navigate listener
	         *    //scrollTo will still raise the event for other listeners
	         *    gridApi.suppressEvents(navigate, function(){
	         *       gridApi.cellNav.scrollTo(aRow, aCol);
	         *    });
	         *
	         * </pre>
	         */
	        GridApi.prototype.suppressEvents = function (listenerFuncs, callBackFn) {
	          var self = this;
	          var listeners = angular.isArray(listenerFuncs) ? listenerFuncs : [listenerFuncs];
	
	          //find all registered listeners
	          var foundListeners = self.listeners.filter(function(listener) {
	            return listeners.some(function(l) {
	              return listener.handler === l;
	            });
	          });
	
	          //deregister all the listeners
	          foundListeners.forEach(function(l){
	            l.dereg();
	          });
	
	          callBackFn();
	
	          //reregister all the listeners
	          foundListeners.forEach(function(l){
	              l.dereg = registerEventWithAngular(l.eventId, l.handler, self.grid, l._this);
	          });
	
	        };
	
	        /**
	         * @ngdoc function
	         * @name registerEvent
	         * @methodOf ui.grid.class:GridApi
	         * @description Registers a new event for the given feature.  The event will get a
	         * .raise and .on prepended to it
	         * <br>
	         * .raise.eventName() - takes no arguments
	         * <br/>
	         * <br/>
	         * .on.eventName(scope, callBackFn, _this)
	         * <br/>
	         * scope - a scope reference to add a deregister call to the scopes .$on('destroy').  Scope is optional and can be a null value,
	         * but in this case you must deregister it yourself via the returned deregister function
	         * <br/>
	         * callBackFn - The function to call
	         * <br/>
	         * _this - optional this context variable for callbackFn. If omitted, grid.api will be used for the context
	         * <br/>
	         * .on.eventName returns a dereg funtion that will remove the listener.  It's not necessary to use it as the listener
	         * will be removed when the scope is destroyed.
	         * @param {string} featureName name of the feature that raises the event
	         * @param {string} eventName  name of the event
	         */
	        GridApi.prototype.registerEvent = function (featureName, eventName) {
	          var self = this;
	          if (!self[featureName]) {
	            self[featureName] = {};
	          }
	
	          var feature = self[featureName];
	          if (!feature.on) {
	            feature.on = {};
	            feature.raise = {};
	          }
	
	          var eventId = self.grid.id + featureName + eventName;
	
	          // gridUtil.logDebug('Creating raise event method ' + featureName + '.raise.' + eventName);
	          feature.raise[eventName] = function () {
	            $rootScope.$emit.apply($rootScope, [eventId].concat(Array.prototype.slice.call(arguments)));
	          };
	
	          // gridUtil.logDebug('Creating on event method ' + featureName + '.on.' + eventName);
	          feature.on[eventName] = function (scope, handler, _this) {
	            if ( scope !== null && typeof(scope.$on) === 'undefined' ){
	              gridUtil.logError('asked to listen on ' + featureName + '.on.' + eventName + ' but scope wasn\'t passed in the input parameters.  It is legitimate to pass null, but you\'ve passed something else, so you probably forgot to provide scope rather than did it deliberately, not registering');
	              return;
	            }
	            var deregAngularOn = registerEventWithAngular(eventId, handler, self.grid, _this);
	
	            //track our listener so we can turn off and on
	            var listener = {handler: handler, dereg: deregAngularOn, eventId: eventId, scope: scope, _this:_this};
	            self.listeners.push(listener);
	
	            var removeListener = function(){
	              listener.dereg();
	              var index = self.listeners.indexOf(listener);
	              self.listeners.splice(index,1);
	            };
	
	            //destroy tracking when scope is destroyed
	            if (scope) {
	              scope.$on('$destroy', function() {
	                removeListener();
	              });
	            }
	
	
	            return removeListener;
	          };
	        };
	
	        function registerEventWithAngular(eventId, handler, grid, _this) {
	          return $rootScope.$on(eventId, function (event) {
	            var args = Array.prototype.slice.call(arguments);
	            args.splice(0, 1); //remove evt argument
	            handler.apply(_this ? _this : grid.api, args);
	          });
	        }
	
	        /**
	         * @ngdoc function
	         * @name registerEventsFromObject
	         * @methodOf ui.grid.class:GridApi
	         * @description Registers features and events from a simple objectMap.
	         * eventObjectMap must be in this format (multiple features allowed)
	         * <pre>
	         * {featureName:
	         *        {
	         *          eventNameOne:function(args){},
	         *          eventNameTwo:function(args){}
	         *        }
	         *  }
	         * </pre>
	         * @param {object} eventObjectMap map of feature/event names
	         */
	        GridApi.prototype.registerEventsFromObject = function (eventObjectMap) {
	          var self = this;
	          var features = [];
	          angular.forEach(eventObjectMap, function (featProp, featPropName) {
	            var feature = {name: featPropName, events: []};
	            angular.forEach(featProp, function (prop, propName) {
	              feature.events.push(propName);
	            });
	            features.push(feature);
	          });
	
	          features.forEach(function (feature) {
	            feature.events.forEach(function (event) {
	              self.registerEvent(feature.name, event);
	            });
	          });
	
	        };
	
	        /**
	         * @ngdoc function
	         * @name registerMethod
	         * @methodOf ui.grid.class:GridApi
	         * @description Registers a new event for the given feature
	         * @param {string} featureName name of the feature
	         * @param {string} methodName  name of the method
	         * @param {object} callBackFn function to execute
	         * @param {object} _this binds callBackFn 'this' to _this.  Defaults to gridApi.grid
	         */
	        GridApi.prototype.registerMethod = function (featureName, methodName, callBackFn, _this) {
	          if (!this[featureName]) {
	            this[featureName] = {};
	          }
	
	          var feature = this[featureName];
	
	          feature[methodName] = gridUtil.createBoundedWrapper(_this || this.grid, callBackFn);
	        };
	
	        /**
	         * @ngdoc function
	         * @name registerMethodsFromObject
	         * @methodOf ui.grid.class:GridApi
	         * @description Registers features and methods from a simple objectMap.
	         * eventObjectMap must be in this format (multiple features allowed)
	         * <br>
	         * {featureName:
	         *        {
	         *          methodNameOne:function(args){},
	         *          methodNameTwo:function(args){}
	         *        }
	         * @param {object} eventObjectMap map of feature/event names
	         * @param {object} _this binds this to _this for all functions.  Defaults to gridApi.grid
	         */
	        GridApi.prototype.registerMethodsFromObject = function (methodMap, _this) {
	          var self = this;
	          var features = [];
	          angular.forEach(methodMap, function (featProp, featPropName) {
	            var feature = {name: featPropName, methods: []};
	            angular.forEach(featProp, function (prop, propName) {
	              feature.methods.push({name: propName, fn: prop});
	            });
	            features.push(feature);
	          });
	
	          features.forEach(function (feature) {
	            feature.methods.forEach(function (method) {
	              self.registerMethod(feature.name, method.name, method.fn, _this);
	            });
	          });
	
	        };
	
	        return GridApi;
	
	      }]);
	
	})();
	
	(function(){
	
	angular.module('ui.grid')
	.factory('GridColumn', ['gridUtil', 'uiGridConstants', 'i18nService', function(gridUtil, uiGridConstants, i18nService) {
	
	  /**
	   * ******************************************************************************************
	   * PaulL1: Ugly hack here in documentation.  These properties are clearly properties of GridColumn,
	   * and need to be noted as such for those extending and building ui-grid itself.
	   * However, from an end-developer perspective, they interact with all these through columnDefs,
	   * and they really need to be documented there.  I feel like they're relatively static, and
	   * I can't find an elegant way for ngDoc to reference to both....so I've duplicated each
	   * comment block.  Ugh.
	   *
	   */
	
	  /**
	   * @ngdoc property
	   * @name name
	   * @propertyOf ui.grid.class:GridColumn
	   * @description (mandatory) Each column should have a name, although for backward
	   * compatibility with 2.x name can be omitted if field is present.
	   *
	   * Important - This must be unique to each column on a web page since it can
	   * be used as a key for retrieving information such as custom sort algorithms.
	   *
	   */
	
	  /**
	   * @ngdoc property
	   * @name name
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description (mandatory) Each column should have a name, although for backward
	   * compatibility with 2.x name can be omitted if field is present.
	   *
	   * Important - This must be unique to each column on a web page since it can
	   * be used as a key for retrieving information such as custom sort algorithms.
	   *
	   */
	
	  /**
	   * @ngdoc property
	   * @name displayName
	   * @propertyOf ui.grid.class:GridColumn
	   * @description Column name that will be shown in the header.  If displayName is not
	   * provided then one is generated using the name.
	   *
	   */
	
	  /**
	   * @ngdoc property
	   * @name displayName
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description Column name that will be shown in the header.  If displayName is not
	   * provided then one is generated using the name.
	   *
	   */
	
	  /**
	   * @ngdoc property
	   * @name field
	   * @propertyOf ui.grid.class:GridColumn
	   * @description field must be provided if you wish to bind to a
	   * property in the data source.  Should be an angular expression that evaluates against grid.options.data
	   * array element.  Can be a complex expression: <code>employee.address.city</code>, or can be a function: <code>employee.getFullAddress()</code>.
	   * See the angular docs on binding expressions.
	   *
	   */
	
	  /**
	   * @ngdoc property
	   * @name field
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description field must be provided if you wish to bind to a
	   * property in the data source.  Should be an angular expression that evaluates against grid.options.data
	   * array element.  Can be a complex expression: <code>employee.address.city</code>, or can be a function: <code>employee.getFullAddress()</code>.    * See the angular docs on binding expressions.    *
	   */
	
	  /**
	   * @ngdoc property
	   * @name filter
	   * @propertyOf ui.grid.class:GridColumn
	   * @description Filter on this column.
	   *
	   * Available built-in conditions and types are listed under {@link jui.grid.service:uiGridConstants#properties_filter uiGridOptions.filter}
	   * @example
	   * <pre>{ term: 'text', condition: uiGridConstants.filter.STARTS_WITH, placeholder: 'type to filter...', ariaLabel: 'Filter for text', flags: { caseSensitive: false }, type: uiGridConstants.filter.SELECT, [ { value: 1, label: 'male' }, { value: 2, label: 'female' } ] }</pre>
	   *
	   */
	
	  /**
	   * @ngdoc property
	   * @name extraStyle
	   * @propertyOf ui.grid.class:GridColumn
	   * @description additional on this column.
	   * @example
	   * <pre>{extraStyle: {display:'table-cell'}}</pre>
	   *
	   */
	
	  /**
	   * @ngdoc object
	   * @name ui.grid.class:GridColumn
	   * @description Represents the viewModel for each column.  Any state or methods needed for a Grid Column
	   * are defined on this prototype
	   * @param {ColumnDef} colDef the column def to associate with this column
	   * @param {number} uid the unique and immutable uid we'd like to allocate to this column
	   * @param {Grid} grid the grid we'd like to create this column in
	   */
	  function GridColumn(colDef, uid, grid) {
	    var self = this;
	
	    self.grid = grid;
	    self.uid = uid;
	
	    self.updateColumnDef(colDef, true);
	
	    self.aggregationValue = undefined;
	
	    // The footer cell registers to listen for the rowsRendered event, and calls this.  Needed to be
	    // in something with a scope so that the dereg would get called
	    self.updateAggregationValue = function() {
	
	     // gridUtil.logDebug('getAggregationValue for Column ' + self.colDef.name);
	
	      /**
	       * @ngdoc property
	       * @name aggregationType
	       * @propertyOf ui.grid.class:GridOptions.columnDef
	       * @description The aggregation that you'd like to show in the columnFooter for this
	       * column.  Valid values are in
	       * {@link ui.grid.service:uiGridConstants#properties_aggregationTypes uiGridConstants.aggregationTypes},
	       * and currently include `uiGridConstants.aggregationTypes.count`,
	       * `uiGridConstants.aggregationTypes.sum`, `uiGridConstants.aggregationTypes.avg`, `uiGridConstants.aggregationTypes.min`,
	       * `uiGridConstants.aggregationTypes.max`.
	       *
	       * You can also provide a function as the aggregation type, in this case your function needs to accept the full
	       * set of visible rows, and return a value that should be shown
	       */
	      if (!self.aggregationType) {
	        self.aggregationValue = undefined;
	        return;
	      }
	
	      var result = 0;
	      var visibleRows = self.grid.getVisibleRows();
	
	      var cellValues = function(){
	        var values = [];
	        visibleRows.forEach(function (row) {
	          var cellValue = self.grid.getCellValue(row, self);
	          var cellNumber = Number(cellValue);
	          if (!isNaN(cellNumber)) {
	            values.push(cellNumber);
	          }
	        });
	        return values;
	      };
	
	      if (angular.isFunction(self.aggregationType)) {
	        self.aggregationValue = self.aggregationType(visibleRows, self);
	      }
	      else if (self.aggregationType === uiGridConstants.aggregationTypes.count) {
	        self.aggregationValue = self.grid.getVisibleRowCount();
	      }
	      else if (self.aggregationType === uiGridConstants.aggregationTypes.sum) {
	        cellValues().forEach(function (value) {
	          result += value;
	        });
	        self.aggregationValue = result;
	      }
	      else if (self.aggregationType === uiGridConstants.aggregationTypes.avg) {
	        cellValues().forEach(function (value) {
	          result += value;
	        });
	        result = result / cellValues().length;
	        self.aggregationValue = result;
	      }
	      else if (self.aggregationType === uiGridConstants.aggregationTypes.min) {
	        self.aggregationValue = Math.min.apply(null, cellValues());
	      }
	      else if (self.aggregationType === uiGridConstants.aggregationTypes.max) {
	        self.aggregationValue = Math.max.apply(null, cellValues());
	      }
	      else {
	        self.aggregationValue = '\u00A0';
	      }
	    };
	
	//     var throttledUpdateAggregationValue = gridUtil.throttle(updateAggregationValue, self.grid.options.aggregationCalcThrottle, { trailing: true, context: self.name });
	
	    /**
	     * @ngdoc function
	     * @name getAggregationValue
	     * @methodOf ui.grid.class:GridColumn
	     * @description gets the aggregation value based on the aggregation type for this column.
	     * Debounced using scrollDebounce option setting
	     */
	    this.getAggregationValue =  function() {
	//      if (!self.grid.isScrollingVertically && !self.grid.isScrollingHorizontally) {
	//        throttledUpdateAggregationValue();
	//      }
	
	      return self.aggregationValue;
	    };
	  }
	
	  /**
	   * @ngdoc function
	   * @name hideColumn
	   * @methodOf ui.grid.class:GridColumn
	   * @description Hides the column by setting colDef.visible = false
	   */
	  GridColumn.prototype.hideColumn = function() {
	    this.colDef.visible = false;
	  };
	
	
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:GridColumn
	   * @name setPropertyOrDefault
	   * @description Sets a property on the column using the passed in columnDef, and
	   * setting the defaultValue if the value cannot be found on the colDef
	   * @param {ColumnDef} colDef the column def to look in for the property value
	   * @param {string} propName the property name we'd like to set
	   * @param {object} defaultValue the value to use if the colDef doesn't provide the setting
	   */
	  GridColumn.prototype.setPropertyOrDefault = function (colDef, propName, defaultValue) {
	    var self = this;
	
	    // Use the column definition filter if we were passed it
	    if (typeof(colDef[propName]) !== 'undefined' && colDef[propName]) {
	      self[propName] = colDef[propName];
	    }
	    // Otherwise use our own if it's set
	    else if (typeof(self[propName]) !== 'undefined') {
	      self[propName] = self[propName];
	    }
	    // Default to empty object for the filter
	    else {
	      self[propName] = defaultValue ? defaultValue : {};
	    }
	  };
	
	
	
	  /**
	   * @ngdoc property
	   * @name width
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description sets the column width.  Can be either
	   * a number or a percentage, or an * for auto.
	   * @example
	   * <pre>  $scope.gridOptions.columnDefs = [ { field: 'field1', width: 100},
	   *                                          { field: 'field2', width: '20%'},
	   *                                          { field: 'field3', width: '*' }]; </pre>
	   *
	   */
	
	  /**
	   * @ngdoc property
	   * @name minWidth
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description Sets the minimum column width.  Should be a number.
	   * Defaults to gridOptions.minimumColumnSize if minWidth is not provided.
	   * @example
	   * <pre>  $scope.gridOptions.columnDefs = [ { field: 'field1', minWidth: 100}]; </pre>
	   *
	   */
	
	  /**
	   * @ngdoc property
	   * @name maxWidth
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description sets the maximum column width.  Should be a number.
	   * @example
	   * <pre>  $scope.gridOptions.columnDefs = [ { field: 'field1', maxWidth: 100}]; </pre>
	   *
	   */
	
	  /**
	   * @ngdoc property
	   * @name visible
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description sets whether or not the column is visible
	   * </br>Default is true
	   * @example
	   * <pre>  $scope.gridOptions.columnDefs = [
	   *     { field: 'field1', visible: true},
	   *     { field: 'field2', visible: false }
	   *   ]; </pre>
	   *
	   */
	
	 /**
	  * @ngdoc property
	  * @name sort
	  * @propertyOf ui.grid.class:GridOptions.columnDef
	  * @description An object of sort information, attributes are:
	  *
	  * - direction: values are {@link ui.grid.service:uiGridConstants#properties_ASC uiGridConstants.ASC}
	  *  or {@link ui.grid.service:uiGridConstants#properties_DESC uiGridConstants.DESC}
	  * - ignoreSort: if set to true this sort is ignored (used by tree to manipulate the sort functionality)
	  * - priority: says what order to sort the columns in (lower priority gets sorted first).
	  * @example
	  * <pre>
	  *   $scope.gridOptions.columnDefs = [{
	  *     field: 'field1',
	  *     sort: {
	  *       direction: uiGridConstants.ASC,
	  *       ignoreSort: true,
	  *       priority: 0
	  *      }
	  *   }];
	  * </pre>
	  */
	
	
	  /**
	   * @ngdoc property
	   * @name sortingAlgorithm
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description Algorithm to use for sorting this column. Takes 'a' and 'b' parameters
	   * like any normal sorting function with additional 'rowA', 'rowB', and 'direction' parameters
	   * that are the row objects and the current direction of the sort respectively.
	   *
	   */
	
	   /**
	    * @ngdoc property
	    * @name defaultSort
	    * @propertyOf ui.grid.class:GridOptions.columnDef
	    * @description An object of sort information, provides a hidden default ordering of the data
	    * when no user sorts are applied, or when a user-provided sort deems two rows to be equal.
	    *
	    * May be combined with a regular {@link ui.grid.class:GridOptions.columnDef#properties_sort columnDef.sort}
	    * to explicitly sort by that column by default.
	    *
	    * Shares the same object format as {@link ui.grid.class:GridOptions.columnDef#properties_sort columnDef.sort}.
	    *
	    * Note that a defaultSort can never take priority over an explicit sort.
	    * @example
	    * <pre>
	    *   $scope.gridOptions.columnDefs = [{
	    *     field: 'field1',
	    *     defaultSort: {
	    *       direction: uiGridConstants.ASC,
	    *       priority: 0
	    *      }
	    *   }];
	    * </pre>
	    */
	
	  /**
	   * @ngdoc array
	   * @name filters
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description Specify multiple filter fields.
	   * @example
	   * <pre>$scope.gridOptions.columnDefs = [
	   *   {
	   *     field: 'field1', filters: [
	   *       {
	   *         term: 'aa',
	   *         condition: uiGridConstants.filter.STARTS_WITH,
	   *         placeholder: 'starts with...',
	   *         ariaLabel: 'Filter for field1',
	   *         flags: { caseSensitive: false },
	   *         type: uiGridConstants.filter.SELECT,
	   *         selectOptions: [ { value: 1, label: 'male' }, { value: 2, label: 'female' } ]
	   *       },
	   *       {
	   *         condition: uiGridConstants.filter.ENDS_WITH,
	   *         placeholder: 'ends with...'
	   *       }
	   *     ]
	   *   }
	   * ]; </pre>
	   *
	   *
	   */
	
	  /**
	   * @ngdoc array
	   * @name filters
	   * @propertyOf ui.grid.class:GridColumn
	   * @description Filters for this column. Includes 'term' property bound to filter input elements.
	   * @example
	   * <pre>[
	   *   {
	   *     term: 'foo', // ngModel for <input>
	   *     condition: uiGridConstants.filter.STARTS_WITH,
	   *     placeholder: 'starts with...',
	   *     ariaLabel: 'Filter for foo',
	   *     flags: { caseSensitive: false },
	   *     type: uiGridConstants.filter.SELECT,
	   *     selectOptions: [ { value: 1, label: 'male' }, { value: 2, label: 'female' } ]
	   *   },
	   *   {
	   *     term: 'baz',
	   *     condition: uiGridConstants.filter.ENDS_WITH,
	   *     placeholder: 'ends with...'
	   *   }
	   * ] </pre>
	   *
	   *
	   */
	
	  /**
	   * @ngdoc array
	   * @name menuItems
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description used to add menu items to a column.  Refer to the tutorial on this
	   * functionality.  A number of settings are supported:
	   *
	   * - title: controls the title that is displayed in the menu
	   * - icon: the icon shown alongside that title
	   * - action: the method to call when the menu is clicked
	   * - shown: a function to evaluate to determine whether or not to show the item
	   * - active: a function to evaluate to determine whether or not the item is currently selected
	   * - context: context to pass to the action function, available in this.context in your handler
	   * - leaveOpen: if set to true, the menu should stay open after the action, defaults to false
	   * @example
	   * <pre>  $scope.gridOptions.columnDefs = [
	   *   { field: 'field1', menuItems: [
	   *     {
	   *       title: 'Outer Scope Alert',
	   *       icon: 'ui-grid-icon-info-circled',
	   *       action: function($event) {
	   *         this.context.blargh(); // $scope.blargh() would work too, this is just an example
	   *       },
	   *       shown: function() { return true; },
	   *       active: function() { return true; },
	   *       context: $scope
	   *     },
	   *     {
	   *       title: 'Grid ID',
	   *       action: function() {
	   *         alert('Grid ID: ' + this.grid.id);
	   *       }
	   *     }
	   *   ] }]; </pre>
	   *
	   */
	
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:GridColumn
	   * @name updateColumnDef
	   * @description Moves settings from the columnDef down onto the column,
	   * and sets properties as appropriate
	   * @param {ColumnDef} colDef the column def to look in for the property value
	   * @param {boolean} isNew whether the column is being newly created, if not
	   * we're updating an existing column, and some items such as the sort shouldn't
	   * be copied down
	   */
	  GridColumn.prototype.updateColumnDef = function(colDef, isNew) {
	    var self = this;
	
	    self.colDef = colDef;
	
	    if (colDef.name === undefined) {
	      throw new Error('colDef.name is required for column at index ' + self.grid.options.columnDefs.indexOf(colDef));
	    }
	
	    self.displayName = (colDef.displayName === undefined) ? gridUtil.readableColumnName(colDef.name) : colDef.displayName;
	
	    if (!angular.isNumber(self.width) || !self.hasCustomWidth || colDef.allowCustomWidthOverride) {
	      var colDefWidth = colDef.width;
	      var parseErrorMsg = "Cannot parse column width '" + colDefWidth + "' for column named '" + colDef.name + "'";
	      self.hasCustomWidth = false;
	
	      if (!angular.isString(colDefWidth) && !angular.isNumber(colDefWidth)) {
	        self.width = '*';
	      } else if (angular.isString(colDefWidth)) {
	        // See if it ends with a percent
	        if (gridUtil.endsWith(colDefWidth, '%')) {
	          // If so we should be able to parse the non-percent-sign part to a number
	          var percentStr = colDefWidth.replace(/%/g, '');
	          var percent = parseInt(percentStr, 10);
	          if (isNaN(percent)) {
	            throw new Error(parseErrorMsg);
	          }
	          self.width = colDefWidth;
	        }
	        // And see if it's a number string
	        else if (colDefWidth.match(/^(\d+)$/)) {
	          self.width = parseInt(colDefWidth.match(/^(\d+)$/)[1], 10);
	        }
	        // Otherwise it should be a string of asterisks
	        else if (colDefWidth.match(/^\*+$/)) {
	          self.width = colDefWidth;
	        }
	        // No idea, throw an Error
	        else {
	          throw new Error(parseErrorMsg);
	        }
	      }
	      // Is a number, use it as the width
	      else {
	        self.width = colDefWidth;
	      }
	    }
	
	    function isValidWidthValue(value) {
	      return angular.isString(value) || angular.isNumber(value);
	    }
	
	    ['minWidth', 'maxWidth'].forEach(function (name) {
	      var minOrMaxWidth = colDef[name];
	      var parseErrorMsg = "Cannot parse column " + name + " '" + minOrMaxWidth + "' for column named '" + colDef.name + "'";
	
	      // default minWidth to the minimumColumnSize
	      if (name === 'minWidth' && !isValidWidthValue(minOrMaxWidth) && angular.isDefined(self.grid.options.minimumColumnSize)) {
	        minOrMaxWidth = self.grid.options.minimumColumnSize;
	      }
	
	      if (!isValidWidthValue(minOrMaxWidth)) {
	        // Sets default minWidth and maxWidth values
	        self[name] = ((name === 'minWidth') ? 30 : 9000);
	      } else if (angular.isString(minOrMaxWidth)) {
	        if (minOrMaxWidth.match(/^(\d+)$/)) {
	          self[name] = parseInt(minOrMaxWidth.match(/^(\d+)$/)[1], 10);
	        } else {
	          throw new Error(parseErrorMsg);
	        }
	      } else {
	        self[name] = minOrMaxWidth;
	      }
	    });
	
	    //use field if it is defined; name if it is not
	    self.field = (colDef.field === undefined) ? colDef.name : colDef.field;
	
	    if ( typeof( self.field ) !== 'string' ){
	      gridUtil.logError( 'Field is not a string, this is likely to break the code, Field is: ' + self.field );
	    }
	
	    self.name = colDef.name;
	
	    // Use colDef.displayName as long as it's not undefined, otherwise default to the field name
	    self.displayName = (colDef.displayName === undefined) ? gridUtil.readableColumnName(colDef.name) : colDef.displayName;
	
	    //self.originalIndex = index;
	
	    self.aggregationType = angular.isDefined(colDef.aggregationType) ? colDef.aggregationType : null;
	    self.footerCellTemplate = angular.isDefined(colDef.footerCellTemplate) ? colDef.footerCellTemplate : null;
	
	    /**
	     * @ngdoc property
	     * @name cellTooltip
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description Whether or not to show a tooltip when a user hovers over the cell.
	     * If set to false, no tooltip.  If true, the cell value is shown in the tooltip (useful
	     * if you have long values in your cells), if a function then that function is called
	     * passing in the row and the col `cellTooltip( row, col )`, and the return value is shown in the tooltip,
	     * if it is a static string then displays that static string.
	     *
	     * Defaults to false
	     *
	     */
	    if ( typeof(colDef.cellTooltip) === 'undefined' || colDef.cellTooltip === false ) {
	      self.cellTooltip = false;
	    } else if ( colDef.cellTooltip === true ){
	      self.cellTooltip = function(row, col) {
	        return self.grid.getCellValue( row, col );
	      };
	    } else if (typeof(colDef.cellTooltip) === 'function' ){
	      self.cellTooltip = colDef.cellTooltip;
	    } else {
	      self.cellTooltip = function ( row, col ){
	        return col.colDef.cellTooltip;
	      };
	    }
	
	    /**
	     * @ngdoc property
	     * @name headerTooltip
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description Whether or not to show a tooltip when a user hovers over the header cell.
	     * If set to false, no tooltip.  If true, the displayName is shown in the tooltip (useful
	     * if you have long values in your headers), if a function then that function is called
	     * passing in the row and the col `headerTooltip( col )`, and the return value is shown in the tooltip,
	     * if a static string then shows that static string.
	     *
	     * Defaults to false
	     *
	     */
	    if ( typeof(colDef.headerTooltip) === 'undefined' || colDef.headerTooltip === false ) {
	      self.headerTooltip = false;
	    } else if ( colDef.headerTooltip === true ){
	      self.headerTooltip = function(col) {
	        return col.displayName;
	      };
	    } else if (typeof(colDef.headerTooltip) === 'function' ){
	      self.headerTooltip = colDef.headerTooltip;
	    } else {
	      self.headerTooltip = function ( col ) {
	        return col.colDef.headerTooltip;
	      };
	    }
	
	
	    /**
	     * @ngdoc property
	     * @name footerCellClass
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description footerCellClass can be a string specifying the class to append to a cell
	     * or it can be a function(grid, row, col, rowRenderIndex, colRenderIndex) that returns a class name
	     *
	     */
	    self.footerCellClass = colDef.footerCellClass;
	
	    /**
	     * @ngdoc property
	     * @name cellClass
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description cellClass can be a string specifying the class to append to a cell
	     * or it can be a function(grid, row, col, rowRenderIndex, colRenderIndex) that returns a class name
	     *
	     */
	    self.cellClass = colDef.cellClass;
	
	    /**
	     * @ngdoc property
	     * @name headerCellClass
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description headerCellClass can be a string specifying the class to append to a cell
	     * or it can be a function(grid, row, col, rowRenderIndex, colRenderIndex) that returns a class name
	     *
	     */
	    self.headerCellClass = colDef.headerCellClass;
	
	    /**
	     * @ngdoc property
	     * @name cellFilter
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description cellFilter is a filter to apply to the content of each cell
	     * @example
	     * <pre>
	     *   gridOptions.columnDefs[0].cellFilter = 'date'
	     *
	     */
	    self.cellFilter = colDef.cellFilter ? colDef.cellFilter : "";
	
	    /**
	     * @ngdoc boolean
	     * @name sortCellFiltered
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description (optional) False by default. When `true` uiGrid will apply the cellFilter before
	     * sorting the data. Note that when using this option uiGrid will assume that the displayed value is
	     * a string, and use the {@link ui.grid.class:RowSorter#sortAlpha sortAlpha} `sortFn`. It is possible
	     * to return a non-string value from an angularjs filter, in which case you should define a {@link ui.grid.class:GridOptions.columnDef#sortingAlgorithm sortingAlgorithm}
	     * for the column which hanldes the returned type. You may specify one of the `sortingAlgorithms`
	     * found in the {@link ui.grid.RowSorter rowSorter} service.
	     */
	    self.sortCellFiltered = colDef.sortCellFiltered ? true : false;
	
	    /**
	     * @ngdoc boolean
	     * @name filterCellFiltered
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description (optional) False by default. When `true` uiGrid will apply the cellFilter before
	     * applying "search" `filters`.
	     */
	    self.filterCellFiltered = colDef.filterCellFiltered ? true : false;
	
	    /**
	     * @ngdoc property
	     * @name headerCellFilter
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description headerCellFilter is a filter to apply to the content of the column header
	     * @example
	     * <pre>
	     *   gridOptions.columnDefs[0].headerCellFilter = 'translate'
	     *
	     */
	    self.headerCellFilter = colDef.headerCellFilter ? colDef.headerCellFilter : "";
	
	    /**
	     * @ngdoc property
	     * @name footerCellFilter
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description footerCellFilter is a filter to apply to the content of the column footer
	     * @example
	     * <pre>
	     *   gridOptions.columnDefs[0].footerCellFilter = 'date'
	     *
	     */
	    self.footerCellFilter = colDef.footerCellFilter ? colDef.footerCellFilter : "";
	
	    self.visible = gridUtil.isNullOrUndefined(colDef.visible) || colDef.visible;
	
	    self.headerClass = colDef.headerClass;
	    //self.cursor = self.sortable ? 'pointer' : 'default';
	
	    // Turn on sorting by default
	    self.enableSorting = typeof(colDef.enableSorting) !== 'undefined' ? colDef.enableSorting : self.grid.options.enableSorting;
	    self.sortingAlgorithm = colDef.sortingAlgorithm;
	
	    /**
	     * @ngdoc property
	     * @name sortDirectionCycle
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description (optional) An array of {@link ui.grid.service:uiGridConstants#properties_ASC sort directions},
	     * specifying the order that they should cycle through as the user repeatedly clicks on the column heading.
	     * The default is `[null, uiGridConstants.ASC, uiGridConstants.DESC]`. Null
	     * refers to the unsorted state. This does not affect the initial sort
	     * direction; use the {@link ui.grid.class:GridOptions.columnDef#sort sort}
	     * property for that. If
	     * {@link ui.grid.class:GridOptions.columnDef#suppressRemoveSort suppressRemoveSort}
	     * is also set, the unsorted state will be skipped even if it is listed here.
	     * Each direction may not appear in the list more than once (e.g. `[ASC,
	     * DESC, DESC]` is not allowed), and the list may not be empty.
	     */
	    self.sortDirectionCycle = typeof(colDef.sortDirectionCycle) !== 'undefined' ?
	      colDef.sortDirectionCycle :
	      [null, uiGridConstants.ASC, uiGridConstants.DESC];
	
	    /**
	     * @ngdoc boolean
	     * @name suppressRemoveSort
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description (optional) False by default. When enabled, this setting hides the removeSort option
	     * in the menu, and prevents users from manually removing the sort
	     */
	    if ( typeof(self.suppressRemoveSort) === 'undefined'){
	      self.suppressRemoveSort = typeof(colDef.suppressRemoveSort) !== 'undefined' ? colDef.suppressRemoveSort : false;
	    }
	
	    /**
	     * @ngdoc property
	     * @name enableFiltering
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description turn off filtering for an individual column, where
	     * you've turned on filtering for the overall grid
	     * @example
	     * <pre>
	     *   gridOptions.columnDefs[0].enableFiltering = false;
	     *
	     */
	    // Turn on filtering by default (it's disabled by default at the Grid level)
	    self.enableFiltering = typeof(colDef.enableFiltering) !== 'undefined' ? colDef.enableFiltering : true;
	
	    // self.menuItems = colDef.menuItems;
	    self.setPropertyOrDefault(colDef, 'menuItems', []);
	
	    // Use the column definition sort if we were passed it, but only if this is a newly added column
	    if ( isNew ){
	      self.setPropertyOrDefault(colDef, 'sort');
	    }
	
	    // Use the column definition defaultSort always, unlike normal sort
	    self.setPropertyOrDefault(colDef, 'defaultSort');
	
	    // Set up default filters array for when one is not provided.
	    //   In other words, this (in column def):
	    //
	    //       filter: { term: 'something', flags: {}, condition: [CONDITION] }
	    //
	    //   is just shorthand for this:
	    //
	    //       filters: [{ term: 'something', flags: {}, condition: [CONDITION] }]
	    //
	    var defaultFilters = [];
	    if (colDef.filter) {
	      defaultFilters.push(colDef.filter);
	    }
	    else if ( colDef.filters ){
	      defaultFilters = colDef.filters;
	    } else {
	      // Add an empty filter definition object, which will
	      // translate to a guessed condition and no pre-populated
	      // value for the filter <input>.
	      defaultFilters.push({});
	    }
	
	    /**
	     * @ngdoc property
	     * @name filter
	     * @propertyOf ui.grid.class:GridOptions.columnDef
	     * @description Specify a single filter field on this column.
	     *
	     * A filter consists of a condition, a term, and a placeholder:
	     *
	     * - condition defines how rows are chosen as matching the filter term. This can be set to
	     * one of the constants in {@link ui.grid.service:uiGridConstants#properties_filter uiGridConstants.filter},
	     * or you can supply a custom filter function
	     * that gets passed the following arguments: [searchTerm, cellValue, row, column].
	     * - term: If set, the filter field will be pre-populated
	     * with this value.
	     * - placeholder: String that will be set to the `<input>.placeholder` attribute.
	     * - ariaLabel: String that will be set to the `<input>.ariaLabel` attribute. This is what is read as a label to screen reader users.
	     * - noTerm: set this to true if you have defined a custom function in condition, and
	     * your custom function doesn't require a term (so it can run even when the term is null)
	     * - rawTerm: set this to true if you have defined a custom function in condition, and
	     * your custom function requires access to the raw unmodified search term that was entered
	     * - flags: only flag currently available is `caseSensitive`, set to false if you don't want
	     * case sensitive matching
	     * - type: defaults to {@link ui.grid.service:uiGridConstants#properties_filter uiGridConstants.filter.INPUT},
	     * which gives a text box.  If set to {@link ui.grid.service:uiGridConstants#properties_filter uiGridConstants.filter.SELECT}
	     * then a select box will be shown with options selectOptions
	     * - selectOptions: options in the format `[ { value: 1, label: 'male' }]`.  No i18n filter is provided, you need
	     * to perform the i18n on the values before you provide them
	     * - disableCancelFilterButton: defaults to false. If set to true then the 'x' button that cancels/clears the filter
	     * will not be shown.
	     * @example
	     * <pre>$scope.gridOptions.columnDefs = [
	     *   {
	     *     field: 'field1',
	     *     filter: {
	     *       term: 'xx',
	     *       condition: uiGridConstants.filter.STARTS_WITH,
	     *       placeholder: 'starts with...',
	     *       ariaLabel: 'Starts with filter for field1',
	     *       flags: { caseSensitive: false },
	     *       type: uiGridConstants.filter.SELECT,
	     *       selectOptions: [ { value: 1, label: 'male' }, { value: 2, label: 'female' } ],
	     *       disableCancelFilterButton: true
	     *     }
	     *   }
	     * ]; </pre>
	     *
	     */
	
	    /*
	
	
	    /*
	
	      self.filters = [
	        {
	          term: 'search term'
	          condition: uiGridConstants.filter.CONTAINS,
	          placeholder: 'my placeholder',
	          ariaLabel: 'Starts with filter for field1',
	          flags: {
	            caseSensitive: true
	          }
	        }
	      ]
	
	    */
	
	    // Only set filter if this is a newly added column, if we're updating an existing
	    // column then we don't want to put the default filter back if the user may have already
	    // removed it.
	    // However, we do want to keep the settings if they change, just not the term
	    if ( isNew ) {
	      self.setPropertyOrDefault(colDef, 'filter');
	      self.setPropertyOrDefault(colDef, 'extraStyle');
	      self.setPropertyOrDefault(colDef, 'filters', defaultFilters);
	    } else if ( self.filters.length === defaultFilters.length ) {
	      self.filters.forEach( function( filter, index ){
	        if (typeof(defaultFilters[index].placeholder) !== 'undefined') {
	          filter.placeholder = defaultFilters[index].placeholder;
	        }
	        if (typeof(defaultFilters[index].ariaLabel) !== 'undefined') {
	          filter.ariaLabel = defaultFilters[index].ariaLabel;
	        }
	        if (typeof(defaultFilters[index].flags) !== 'undefined') {
	          filter.flags = defaultFilters[index].flags;
	        }
	        if (typeof(defaultFilters[index].type) !== 'undefined') {
	          filter.type = defaultFilters[index].type;
	        }
	        if (typeof(defaultFilters[index].selectOptions) !== 'undefined') {
	          filter.selectOptions = defaultFilters[index].selectOptions;
	        }
	      });
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name unsort
	   * @methodOf ui.grid.class:GridColumn
	   * @description Removes column from the grid sorting
	   */
	  GridColumn.prototype.unsort = function () {
	    //Decrease priority for every col where priority is higher than the removed sort's priority.
	    var thisPriority = this.sort.priority;
	
	    this.grid.columns.forEach(function (col) {
	      if (col.sort && col.sort.priority !== undefined && col.sort.priority > thisPriority) {
	        col.sort.priority -= 1;
	      }
	    });
	
	    this.sort = {};
	    this.grid.api.core.raise.sortChanged( this.grid, this.grid.getColumnSorting() );
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name getColClass
	   * @methodOf ui.grid.class:GridColumn
	   * @description Returns the class name for the column
	   * @param {bool} prefixDot  if true, will return .className instead of className
	   */
	  GridColumn.prototype.getColClass = function (prefixDot) {
	    var cls = uiGridConstants.COL_CLASS_PREFIX + this.uid;
	
	    return prefixDot ? '.' + cls : cls;
	  };
	
	    /**
	     * @ngdoc function
	     * @name isPinnedLeft
	     * @methodOf ui.grid.class:GridColumn
	     * @description Returns true if column is in the left render container
	     */
	    GridColumn.prototype.isPinnedLeft = function () {
	      return this.renderContainer === 'left';
	    };
	
	    /**
	     * @ngdoc function
	     * @name isPinnedRight
	     * @methodOf ui.grid.class:GridColumn
	     * @description Returns true if column is in the right render container
	     */
	    GridColumn.prototype.isPinnedRight = function () {
	      return this.renderContainer === 'right';
	    };
	
	
	    /**
	   * @ngdoc function
	   * @name getColClassDefinition
	   * @methodOf ui.grid.class:GridColumn
	   * @description Returns the class definition for th column
	   */
	  GridColumn.prototype.getColClassDefinition = function () {
	    return ' .grid' + this.grid.id + ' ' + this.getColClass(true) + ' { min-width: ' + this.drawnWidth + 'px; max-width: ' + this.drawnWidth + 'px; }';
	  };
	
	  /**
	   * @ngdoc function
	   * @name getRenderContainer
	   * @methodOf ui.grid.class:GridColumn
	   * @description Returns the render container object that this column belongs to.
	   *
	   * Columns will be default be in the `body` render container if they aren't allocated to one specifically.
	   */
	  GridColumn.prototype.getRenderContainer = function getRenderContainer() {
	    var self = this;
	
	    var containerId = self.renderContainer;
	
	    if (containerId === null || containerId === '' || containerId === undefined) {
	      containerId = 'body';
	    }
	
	    return self.grid.renderContainers[containerId];
	  };
	
	  /**
	   * @ngdoc function
	   * @name showColumn
	   * @methodOf ui.grid.class:GridColumn
	   * @description Makes the column visible by setting colDef.visible = true
	   */
	  GridColumn.prototype.showColumn = function() {
	      this.colDef.visible = true;
	  };
	
	
	  /**
	   * @ngdoc property
	   * @name aggregationHideLabel
	   * @propertyOf ui.grid.class:GridOptions.columnDef
	   * @description defaults to false, if set to true hides the label text
	   * in the aggregation footer, so only the value is displayed.
	   *
	   */
	  /**
	   * @ngdoc function
	   * @name getAggregationText
	   * @methodOf ui.grid.class:GridColumn
	   * @description Gets the aggregation label from colDef.aggregationLabel if
	   * specified or by using i18n, including deciding whether or not to display
	   * based on colDef.aggregationHideLabel.
	   *
	   * @param {string} label the i18n lookup value to use for the column label
	   *
	   */
	  GridColumn.prototype.getAggregationText = function () {
	    var self = this;
	    if ( self.colDef.aggregationHideLabel ){
	      return '';
	    }
	    else if ( self.colDef.aggregationLabel ) {
	      return self.colDef.aggregationLabel;
	    }
	    else {
	      switch ( self.colDef.aggregationType ){
	        case uiGridConstants.aggregationTypes.count:
	          return i18nService.getSafeText('aggregation.count');
	        case uiGridConstants.aggregationTypes.sum:
	          return i18nService.getSafeText('aggregation.sum');
	        case uiGridConstants.aggregationTypes.avg:
	          return i18nService.getSafeText('aggregation.avg');
	        case uiGridConstants.aggregationTypes.min:
	          return i18nService.getSafeText('aggregation.min');
	        case uiGridConstants.aggregationTypes.max:
	          return i18nService.getSafeText('aggregation.max');
	        default:
	          return '';
	      }
	    }
	  };
	
	  GridColumn.prototype.getCellTemplate = function () {
	    var self = this;
	
	    return self.cellTemplatePromise;
	  };
	
	  GridColumn.prototype.getCompiledElementFn = function () {
	    var self = this;
	
	    return self.compiledElementFnDefer.promise;
	  };
	
	  return GridColumn;
	}]);
	
	})();
	
	  (function(){
	
	angular.module('ui.grid')
	.factory('GridOptions', ['gridUtil','uiGridConstants', function(gridUtil,uiGridConstants) {
	
	  /**
	   * @ngdoc function
	   * @name ui.grid.class:GridOptions
	   * @description Default GridOptions class.  GridOptions are defined by the application developer and overlaid
	   * over this object.  Setting gridOptions within your controller is the most common method for an application
	   * developer to configure the behaviour of their ui-grid
	   *
	   * @example To define your gridOptions within your controller:
	   * <pre>$scope.gridOptions = {
	   *   data: $scope.myData,
	   *   columnDefs: [
	   *     { name: 'field1', displayName: 'pretty display name' },
	   *     { name: 'field2', visible: false }
	   *  ]
	   * };</pre>
	   *
	   * You can then use this within your html template, when you define your grid:
	   * <pre>&lt;div ui-grid="gridOptions"&gt;&lt;/div&gt;</pre>
	   *
	   * To provide default options for all of the grids within your application, use an angular
	   * decorator to modify the GridOptions factory.
	   * <pre>
	   * app.config(function($provide){
	   *   $provide.decorator('GridOptions',function($delegate){
	   *     var gridOptions;
	   *     gridOptions = angular.copy($delegate);
	   *     gridOptions.initialize = function(options) {
	   *       var initOptions;
	   *       initOptions = $delegate.initialize(options);
	   *       initOptions.enableColumnMenus = false;
	   *       return initOptions;
	   *     };
	   *     return gridOptions;
	   *   });
	   * });
	   * </pre>
	   */
	  return {
	    initialize: function( baseOptions ){
	      /**
	       * @ngdoc function
	       * @name onRegisterApi
	       * @propertyOf ui.grid.class:GridOptions
	       * @description A callback that returns the gridApi once the grid is instantiated, which is
	       * then used to interact with the grid programatically.
	       *
	       * Note that the gridApi.core.renderingComplete event is identical to this
	       * callback, but has the advantage that it can be called from multiple places
	       * if needed
	       *
	       * @example
	       * <pre>
	       *   $scope.gridOptions.onRegisterApi = function ( gridApi ) {
	       *     $scope.gridApi = gridApi;
	       *     $scope.gridApi.selection.selectAllRows( $scope.gridApi.grid );
	       *   };
	       * </pre>
	       *
	       */
	      baseOptions.onRegisterApi = baseOptions.onRegisterApi || angular.noop();
	
	      /**
	       * @ngdoc object
	       * @name data
	       * @propertyOf ui.grid.class:GridOptions
	       * @description (mandatory) Array of data to be rendered into the grid, providing the data source or data binding for
	       * the grid.
	       *
	       * Most commonly the data is an array of objects, where each object has a number of attributes.
	       * Each attribute automatically becomes a column in your grid.  This array could, for example, be sourced from
	       * an angularJS $resource query request.  The array can also contain complex objects, refer the binding tutorial
	       * for examples of that.
	       *
	       * The most flexible usage is to set your data on $scope:
	       *
	       * `$scope.data = data;`
	       *
	       * And then direct the grid to resolve whatever is in $scope.data:
	       *
	       * `$scope.gridOptions.data = 'data';`
	       *
	       * This is the most flexible approach as it allows you to replace $scope.data whenever you feel like it without
	       * getting pointer issues.
	       *
	       * Alternatively you can directly set the data array:
	       *
	       * `$scope.gridOptions.data = [ ];`
	       * or
	       *
	       * `$http.get('/data/100.json')
	       * .success(function(data) {
	       *   $scope.myData = data;
	       *   $scope.gridOptions.data = $scope.myData;
	       *  });`
	       *
	       * Where you do this, you need to take care in updating the data - you can't just update `$scope.myData` to some other
	       * array, you need to update $scope.gridOptions.data to point to that new array as well.
	       *
	       */
	      baseOptions.data = baseOptions.data || [];
	
	      /**
	       * @ngdoc array
	       * @name columnDefs
	       * @propertyOf  ui.grid.class:GridOptions
	       * @description Array of columnDef objects.  Only required property is name.
	       * The individual options available in columnDefs are documented in the
	       * {@link ui.grid.class:GridOptions.columnDef columnDef} section
	       * </br>_field property can be used in place of name for backwards compatibility with 2.x_
	       *  @example
	       *
	       * <pre>var columnDefs = [{name:'field1'}, {name:'field2'}];</pre>
	       *
	       */
	      baseOptions.columnDefs = baseOptions.columnDefs || [];
	
	      /**
	       * @ngdoc object
	       * @name ui.grid.class:GridOptions.columnDef
	       * @description Definition / configuration of an individual column, which would typically be
	       * one of many column definitions within the gridOptions.columnDefs array
	       * @example
	       * <pre>{name:'field1', field: 'field1', filter: { term: 'xxx' }}</pre>
	       *
	       */
	
	      /**
	       * @ngdoc object
	       * @name enableGridMenu
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Takes a boolean that adds a settings icon in the top right of the grid, which floats above
	       * the column header, when true. The menu by default gives access to show/hide columns, but can be
	       * customised to show additional actions.
	       *
	       * See the {@link #!/tutorial/121_grid_menu Grid Menu tutorial} for more detailed information.
	       */
	
	      /**
	       * @ngdoc array
	       * @name excludeProperties
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Array of property names in data to ignore when auto-generating column names.  Provides the
	       * inverse of columnDefs - columnDefs is a list of columns to include, excludeProperties is a list of columns
	       * to exclude.
	       *
	       * If columnDefs is defined, this will be ignored.
	       *
	       * Defaults to ['$$hashKey']
	       */
	
	      baseOptions.excludeProperties = baseOptions.excludeProperties || ['$$hashKey'];
	
	      /**
	       * @ngdoc boolean
	       * @name enableRowHashing
	       * @propertyOf ui.grid.class:GridOptions
	       * @description True by default. When enabled, this setting allows uiGrid to add
	       * `$$hashKey`-type properties (similar to Angular) to elements in the `data` array. This allows
	       * the grid to maintain state while vastly speeding up the process of altering `data` by adding/moving/removing rows.
	       *
	       * Note that this DOES add properties to your data that you may not want, but they are stripped out when using `angular.toJson()`. IF
	       * you do not want this at all you can disable this setting but you will take a performance hit if you are using large numbers of rows
	       * and are altering the data set often.
	       */
	      baseOptions.enableRowHashing = baseOptions.enableRowHashing !== false;
	
	      /**
	       * @ngdoc function
	       * @name rowIdentity
	       * @methodOf ui.grid.class:GridOptions
	       * @description This function is used to get and, if necessary, set the value uniquely identifying this row (i.e. if an identity is not present it will set one).
	       *
	       * By default it returns the `$$hashKey` property if it exists. If it doesn't it uses gridUtil.nextUid() to generate one
	       */
	      baseOptions.rowIdentity = baseOptions.rowIdentity || function rowIdentity(row) {
	        return gridUtil.hashKey(row);
	      };
	
	      /**
	       * @ngdoc function
	       * @name getRowIdentity
	       * @methodOf ui.grid.class:GridOptions
	       * @description This function returns the identity value uniquely identifying this row, if one is not present it does not set it.
	       *
	       * By default it returns the `$$hashKey` property but can be overridden to use any property or set of properties you want.
	       */
	      baseOptions.getRowIdentity = baseOptions.getRowIdentity || function getRowIdentity(row) {
	        return row.$$hashKey;
	      };
	
	      /**
	       * @ngdoc property
	       * @name flatEntityAccess
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Set to true if your columns are all related directly to fields in a flat object structure - i.e.
	       * each of your columns associate directly with a property on each of the entities in your data array.
	       *
	       * In that situation we can avoid all the logic associated with complex binding to functions or to properties of sub-objects,
	       * which can provide a significant speed improvement with large data sets when filtering or sorting.
	       *
	       * By default false
	       */
	      baseOptions.flatEntityAccess = baseOptions.flatEntityAccess === true;
	
	      /**
	       * @ngdoc property
	       * @name showHeader
	       * @propertyOf ui.grid.class:GridOptions
	       * @description True by default. When set to false, this setting will replace the
	       * standard header template with '<div></div>', resulting in no header being shown.
	       */
	      baseOptions.showHeader = typeof(baseOptions.showHeader) !== "undefined" ? baseOptions.showHeader : true;
	
	      /* (NOTE): Don't show this in the docs. We only use it internally
	       * @ngdoc property
	       * @name headerRowHeight
	       * @propertyOf ui.grid.class:GridOptions
	       * @description The height of the header in pixels, defaults to 30
	       *
	       */
	      if (!baseOptions.showHeader) {
	        baseOptions.headerRowHeight = 0;
	      }
	      else {
	        baseOptions.headerRowHeight = typeof(baseOptions.headerRowHeight) !== "undefined" ? baseOptions.headerRowHeight : 30;
	      }
	
	      /**
	       * @ngdoc property
	       * @name rowHeight
	       * @propertyOf ui.grid.class:GridOptions
	       * @description The height of the row in pixels,  Can be passed as integer or string. defaults to 30.
	       *
	       */
	
	      if (typeof baseOptions.rowHeight === "string") {
	        baseOptions.rowHeight = parseInt(baseOptions.rowHeight) || 30;
	      }
	
	      else {
	        baseOptions.rowHeight = baseOptions.rowHeight || 30;
	      }
	
	      /**
	       * @ngdoc integer
	       * @name minRowsToShow
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Minimum number of rows to show when the grid doesn't have a defined height. Defaults to "10".
	       */
	      baseOptions.minRowsToShow = typeof(baseOptions.minRowsToShow) !== "undefined" ? baseOptions.minRowsToShow : 10;
	
	      /**
	       * @ngdoc property
	       * @name showGridFooter
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Whether or not to show the footer, defaults to false
	       * The footer display Total Rows and Visible Rows (filtered rows)
	       */
	      baseOptions.showGridFooter = baseOptions.showGridFooter === true;
	
	      /**
	       * @ngdoc property
	       * @name showColumnFooter
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Whether or not to show the column footer, defaults to false
	       * The column footer displays column aggregates
	       */
	      baseOptions.showColumnFooter = baseOptions.showColumnFooter === true;
	
	      /**
	       * @ngdoc property
	       * @name columnFooterHeight
	       * @propertyOf ui.grid.class:GridOptions
	       * @description The height of the footer rows (column footer and grid footer) in pixels
	       *
	       */
	      baseOptions.columnFooterHeight = typeof(baseOptions.columnFooterHeight) !== "undefined" ? baseOptions.columnFooterHeight : 30;
	      baseOptions.gridFooterHeight = typeof(baseOptions.gridFooterHeight) !== "undefined" ? baseOptions.gridFooterHeight : 30;
	
	      baseOptions.columnWidth = typeof(baseOptions.columnWidth) !== "undefined" ? baseOptions.columnWidth : 50;
	
	      /**
	       * @ngdoc property
	       * @name maxVisibleColumnCount
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Defaults to 200
	       *
	       */
	      baseOptions.maxVisibleColumnCount = typeof(baseOptions.maxVisibleColumnCount) !== "undefined" ? baseOptions.maxVisibleColumnCount : 200;
	
	      /**
	       * @ngdoc property
	       * @name virtualizationThreshold
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Turn virtualization on when number of data elements goes over this number, defaults to 20
	       */
	      baseOptions.virtualizationThreshold = typeof(baseOptions.virtualizationThreshold) !== "undefined" ? baseOptions.virtualizationThreshold : 20;
	
	      /**
	       * @ngdoc property
	       * @name columnVirtualizationThreshold
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Turn virtualization on when number of columns goes over this number, defaults to 10
	       */
	      baseOptions.columnVirtualizationThreshold = typeof(baseOptions.columnVirtualizationThreshold) !== "undefined" ? baseOptions.columnVirtualizationThreshold : 10;
	
	      /**
	       * @ngdoc property
	       * @name excessRows
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Extra rows to to render outside of the viewport, which helps with smoothness of scrolling.
	       * Defaults to 4
	       */
	      baseOptions.excessRows = typeof(baseOptions.excessRows) !== "undefined" ? baseOptions.excessRows : 4;
	      /**
	       * @ngdoc property
	       * @name scrollThreshold
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Defaults to 4
	       */
	      baseOptions.scrollThreshold = typeof(baseOptions.scrollThreshold) !== "undefined" ? baseOptions.scrollThreshold : 4;
	
	      /**
	       * @ngdoc property
	       * @name excessColumns
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Extra columns to to render outside of the viewport, which helps with smoothness of scrolling.
	       * Defaults to 4
	       */
	      baseOptions.excessColumns = typeof(baseOptions.excessColumns) !== "undefined" ? baseOptions.excessColumns : 4;
	      /**
	       * @ngdoc property
	       * @name horizontalScrollThreshold
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Defaults to 4
	       */
	      baseOptions.horizontalScrollThreshold = typeof(baseOptions.horizontalScrollThreshold) !== "undefined" ? baseOptions.horizontalScrollThreshold : 2;
	
	
	      /**
	       * @ngdoc property
	       * @name aggregationCalcThrottle
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Default time in milliseconds to throttle aggregation calcuations, defaults to 500ms
	       */
	      baseOptions.aggregationCalcThrottle = typeof(baseOptions.aggregationCalcThrottle) !== "undefined" ? baseOptions.aggregationCalcThrottle : 500;
	
	      /**
	       * @ngdoc property
	       * @name wheelScrollThrottle
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Default time in milliseconds to throttle scroll events to, defaults to 70ms
	       */
	      baseOptions.wheelScrollThrottle = typeof(baseOptions.wheelScrollThrottle) !== "undefined" ? baseOptions.wheelScrollThrottle : 70;
	
	
	      /**
	       * @ngdoc property
	       * @name scrollDebounce
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Default time in milliseconds to debounce scroll events, defaults to 300ms
	       */
	      baseOptions.scrollDebounce = typeof(baseOptions.scrollDebounce) !== "undefined" ? baseOptions.scrollDebounce : 300;
	
	      /**
	       * @ngdoc boolean
	       * @name enableSorting
	       * @propertyOf ui.grid.class:GridOptions
	       * @description True by default. When enabled, this setting adds sort
	       * widgets to the column headers, allowing sorting of the data for the entire grid.
	       * Sorting can then be disabled / enabled on individual columns using the columnDefs,
	       * if it set, it will override GridOptions enableSorting setting.
	       */
	      baseOptions.enableSorting = baseOptions.enableSorting !== false;
	
	      /**
	       * @ngdoc boolean
	       * @name enableFiltering
	       * @propertyOf ui.grid.class:GridOptions
	       * @description False by default. When enabled, this setting adds filter
	       * boxes to each column header, allowing filtering within the column for the entire grid.
	       * Filtering can then be disabled on individual columns using the columnDefs.
	       */
	      baseOptions.enableFiltering = baseOptions.enableFiltering === true;
	
	      /**
	       * @ngdoc boolean
	       * @name enableColumnMenus
	       * @propertyOf ui.grid.class:GridOptions
	       * @description True by default. When enabled, this setting displays a column
	       * menu within each column.
	       * By default column menu's trigger is hidden before mouse over, but you can always force it to be visible with CSS:
	       *
	       * <pre>
	       *  .ui-grid-column-menu-button {
	       *    display: block;
	       *  }
	       * </pre>
	       */
	      baseOptions.enableColumnMenus = baseOptions.enableColumnMenus !== false;
	
	      /**
	       * @ngdoc boolean
	       * @name enableVerticalScrollbar
	       * @propertyOf ui.grid.class:GridOptions
	       * @description {@link ui.grid.service:uiGridConstants#properties_scrollbars uiGridConstants.scrollbars.ALWAYS} by default.
	       * This settings controls the vertical scrollbar for the grid.
	       * Supported values: uiGridConstants.scrollbars.ALWAYS, uiGridConstants.scrollbars.NEVER, uiGridConstants.scrollbars.WHEN_NEEDED
	       */
	      baseOptions.enableVerticalScrollbar = typeof(baseOptions.enableVerticalScrollbar) !== "undefined" ? baseOptions.enableVerticalScrollbar : uiGridConstants.scrollbars.ALWAYS;
	
	      /**
	       * @ngdoc boolean
	       * @name enableHorizontalScrollbar
	       * @propertyOf ui.grid.class:GridOptions
	       * @description {@link ui.grid.service:uiGridConstants#properties_scrollbars uiGridConstants.scrollbars.ALWAYS} by default.
	       * This settings controls the horizontal scrollbar for the grid.
	       * Supported values: uiGridConstants.scrollbars.ALWAYS, uiGridConstants.scrollbars.NEVER, uiGridConstants.scrollbars.WHEN_NEEDED
	       */
	      baseOptions.enableHorizontalScrollbar = typeof(baseOptions.enableHorizontalScrollbar) !== "undefined" ? baseOptions.enableHorizontalScrollbar : uiGridConstants.scrollbars.ALWAYS;
	
	      /**
	       * @ngdoc boolean
	       * @name enableMinHeightCheck
	       * @propertyOf ui.grid.class:GridOptions
	       * @description True by default. When enabled, a newly initialized grid will check to see if it is tall enough to display
	       * at least one row of data.  If the grid is not tall enough, it will resize the DOM element to display minRowsToShow number
	       * of rows.
	       */
	       baseOptions.enableMinHeightCheck = baseOptions.enableMinHeightCheck !== false;
	
	      /**
	       * @ngdoc boolean
	       * @name minimumColumnSize
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Sets the default minimum column width, in other words,
	       * it defines the default value for a column minWidth attribute if that is not otherwise specified.
	       * Should be a number. Defaults to 30 pixels.
	       */
	      baseOptions.minimumColumnSize = typeof(baseOptions.minimumColumnSize) !== "undefined" ? baseOptions.minimumColumnSize : 30;
	
	      /**
	       * @ngdoc function
	       * @name rowEquality
	       * @methodOf ui.grid.class:GridOptions
	       * @description By default, rows are compared using object equality.  This option can be overridden
	       * to compare on any data item property or function
	       * @param {object} entityA First Data Item to compare
	       * @param {object} entityB Second Data Item to compare
	       */
	      baseOptions.rowEquality = baseOptions.rowEquality || function(entityA, entityB) {
	        return entityA === entityB;
	      };
	
	      /**
	       * @ngdoc string
	       * @name headerTemplate
	       * @propertyOf ui.grid.class:GridOptions
	       * @description Null by default. When provided, this setting uses a custom header
	       * template, rather than the default template. Can be set to either the name of a template file:
	       * <pre>  $scope.gridOptions.headerTemplate = 'header_template.html';</pre>
	       * inline html
	       * <pre>  $scope.gridOptions.headerTemplate = '<div class="ui-grid-top-panel" style="text-align: center">I am a Custom Grid Header</div>'</pre>
	       * or the id of a precompiled template (TBD how to use this).
	       * </br>Refer to the custom header tutorial for more information.
	       * If you want no header at all, you can set to an empty div:
	       * <pre>  $scope.gridOptions.headerTemplate = '<div></div>';</pre>
	       *
	       * If you want to only have a static header, then you can set to static content.  If
	       * you want to tailor the existing column headers, then you should look at the
	       * current 'ui-grid-header.html' template in github as your starting point.
	       *
	       */
	      baseOptions.headerTemplate = baseOptions.headerTemplate || null;
	
	      /**
	       * @ngdoc string
	       * @name footerTemplate
	       * @propertyOf ui.grid.class:GridOptions
	       * @description (optional) ui-grid/ui-grid-footer by default.  This footer shows the per-column
	       * aggregation totals.
	       * When provided, this setting uses a custom footer template. Can be set to either the name of a template file 'footer_template.html', inline html
	       * <pre>'<div class="ui-grid-bottom-panel" style="text-align: center">I am a Custom Grid Footer</div>'</pre>, or the id
	       * of a precompiled template (TBD how to use this).  Refer to the custom footer tutorial for more information.
	       */
	      baseOptions.footerTemplate = baseOptions.footerTemplate || 'ui-grid/ui-grid-footer';
	
	      /**
	       * @ngdoc string
	       * @name gridFooterTemplate
	       * @propertyOf ui.grid.class:GridOptions
	       * @description (optional) ui-grid/ui-grid-grid-footer by default. This template by default shows the
	       * total items at the bottom of the grid, and the selected items if selection is enabled.
	       */
	      baseOptions.gridFooterTemplate = baseOptions.gridFooterTemplate || 'ui-grid/ui-grid-grid-footer';
	
	      /**
	       * @ngdoc string
	       * @name rowTemplate
	       * @propertyOf ui.grid.class:GridOptions
	       * @description 'ui-grid/ui-grid-row' by default. When provided, this setting uses a
	       * custom row template.  Can be set to either the name of a template file:
	       * <pre> $scope.gridOptions.rowTemplate = 'row_template.html';</pre>
	       * inline html
	       * <pre>  $scope.gridOptions.rowTemplate = '<div style="background-color: aquamarine" ng-click="grid.appScope.fnOne(row)" ng-repeat="col in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell></div>';</pre>
	       * or the id of a precompiled template (TBD how to use this) can be provided.
	       * </br>Refer to the custom row template tutorial for more information.
	       */
	      baseOptions.rowTemplate = baseOptions.rowTemplate || 'ui-grid/ui-grid-row';
	
	      /**
	      * @ngdoc string
	      * @name gridMenuTemplate
	      * @propertyOf ui.grid.class:GridOptions
	      * @description 'ui-grid/uiGridMenu' by default. When provided, this setting uses a
	      * custom grid menu template.
	      */
	      baseOptions.gridMenuTemplate = baseOptions.gridMenuTemplate || 'ui-grid/uiGridMenu';
	
	      /**
	       * @ngdoc object
	       * @name appScopeProvider
	       * @propertyOf ui.grid.class:GridOptions
	       * @description by default, the parent scope of the ui-grid element will be assigned to grid.appScope
	       * this property allows you to assign any reference you want to grid.appScope
	       */
	      baseOptions.appScopeProvider = baseOptions.appScopeProvider || null;
	
	      return baseOptions;
	    }
	  };
	
	
	}]);
	
	})();
	
	(function(){
	
	angular.module('ui.grid')
	
	  /**
	   * @ngdoc function
	   * @name ui.grid.class:GridRenderContainer
	   * @description The grid has render containers, allowing the ability to have pinned columns.  If the grid
	   * is right-to-left then there may be a right render container, if left-to-right then there may
	   * be a left render container.  There is always a body render container.
	   * @param {string} name The name of the render container ('body', 'left', or 'right')
	   * @param {Grid} grid the grid the render container is in
	   * @param {object} options the render container options
	   */
	.factory('GridRenderContainer', ['gridUtil', 'uiGridConstants', function(gridUtil, uiGridConstants) {
	  function GridRenderContainer(name, grid, options) {
	    var self = this;
	
	    // if (gridUtil.type(grid) !== 'Grid') {
	    //   throw new Error('Grid argument is not a Grid object');
	    // }
	
	    self.name = name;
	
	    self.grid = grid;
	
	    // self.rowCache = [];
	    // self.columnCache = [];
	
	    self.visibleRowCache = [];
	    self.visibleColumnCache = [];
	
	    self.renderedRows = [];
	    self.renderedColumns = [];
	
	    self.prevScrollTop = 0;
	    self.prevScrolltopPercentage = 0;
	    self.prevRowScrollIndex = 0;
	
	    self.prevScrollLeft = 0;
	    self.prevScrollleftPercentage = 0;
	    self.prevColumnScrollIndex = 0;
	
	    self.columnStyles = '';
	
	    self.viewportAdjusters = [];
	
	    /**
	     *  @ngdoc boolean
	     *  @name hasHScrollbar
	     *  @propertyOf  ui.grid.class:GridRenderContainer
	     *  @description flag to signal that container has a horizontal scrollbar
	     */
	    self.hasHScrollbar = false;
	
	    /**
	     *  @ngdoc boolean
	     *  @name hasVScrollbar
	     *  @propertyOf  ui.grid.class:GridRenderContainer
	     *  @description flag to signal that container has a vertical scrollbar
	     */
	    self.hasVScrollbar = false;
	
	    /**
	     *  @ngdoc boolean
	     *  @name canvasHeightShouldUpdate
	     *  @propertyOf  ui.grid.class:GridRenderContainer
	     *  @description flag to signal that container should recalculate the canvas size
	     */
	    self.canvasHeightShouldUpdate = true;
	
	    /**
	     *  @ngdoc boolean
	     *  @name canvasHeight
	     *  @propertyOf  ui.grid.class:GridRenderContainer
	     *  @description last calculated canvas height value
	     */
	    self.$$canvasHeight = 0;
	
	    if (options && angular.isObject(options)) {
	      angular.extend(self, options);
	    }
	
	    grid.registerStyleComputation({
	      priority: 5,
	      func: function () {
	        self.updateColumnWidths();
	        return self.columnStyles;
	      }
	    });
	  }
	
	
	  GridRenderContainer.prototype.reset = function reset() {
	    // this.rowCache.length = 0;
	    // this.columnCache.length = 0;
	
	    this.visibleColumnCache.length = 0;
	    this.visibleRowCache.length = 0;
	
	    this.renderedRows.length = 0;
	    this.renderedColumns.length = 0;
	  };
	
	  // TODO(c0bra): calculate size?? Should this be in a stackable directive?
	
	
	  GridRenderContainer.prototype.containsColumn = function (col) {
	     return this.visibleColumnCache.indexOf(col) !== -1;
	  };
	
	  GridRenderContainer.prototype.minRowsToRender = function minRowsToRender() {
	    var self = this;
	    var minRows = 0;
	    var rowAddedHeight = 0;
	    var viewPortHeight = self.getViewportHeight();
	    for (var i = self.visibleRowCache.length - 1; rowAddedHeight < viewPortHeight && i >= 0; i--) {
	      rowAddedHeight += self.visibleRowCache[i].height;
	      minRows++;
	    }
	    return minRows;
	  };
	
	  GridRenderContainer.prototype.minColumnsToRender = function minColumnsToRender() {
	    var self = this;
	    var viewportWidth = this.getViewportWidth();
	
	    var min = 0;
	    var totalWidth = 0;
	
	    for (var i = 0; i < self.visibleColumnCache.length; i++) {
	      var col = self.visibleColumnCache[i];
	
	      if (totalWidth < viewportWidth) {
	        totalWidth += col.drawnWidth ? col.drawnWidth : 0;
	        min++;
	      }
	      else {
	        var currWidth = 0;
	        for (var j = i; j >= i - min; j--) {
	          currWidth += self.visibleColumnCache[j].drawnWidth ? self.visibleColumnCache[j].drawnWidth : 0;
	        }
	        if (currWidth < viewportWidth) {
	          min++;
	        }
	      }
	    }
	
	    return min;
	  };
	
	  GridRenderContainer.prototype.getVisibleRowCount = function getVisibleRowCount() {
	    return this.visibleRowCache.length;
	  };
	
	  /**
	   * @ngdoc function
	   * @name registerViewportAdjuster
	   * @methodOf ui.grid.class:GridRenderContainer
	   * @description Registers an adjuster to the render container's available width or height.  Adjusters are used
	   * to tell the render container that there is something else consuming space, and to adjust it's size
	   * appropriately.
	   * @param {function} func the adjuster function we want to register
	   */
	
	  GridRenderContainer.prototype.registerViewportAdjuster = function registerViewportAdjuster(func) {
	    this.viewportAdjusters.push(func);
	  };
	
	  /**
	   * @ngdoc function
	   * @name removeViewportAdjuster
	   * @methodOf ui.grid.class:GridRenderContainer
	   * @description Removes an adjuster, should be used when your element is destroyed
	   * @param {function} func the adjuster function we want to remove
	   */
	  GridRenderContainer.prototype.removeViewportAdjuster = function removeViewportAdjuster(func) {
	    var idx = this.viewportAdjusters.indexOf(func);
	
	    if (idx > -1) {
	      this.viewportAdjusters.splice(idx, 1);
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name getViewportAdjustment
	   * @methodOf ui.grid.class:GridRenderContainer
	   * @description Gets the adjustment based on the viewportAdjusters.
	   * @returns {object} a hash of { height: x, width: y }.  Usually the values will be negative
	   */
	  GridRenderContainer.prototype.getViewportAdjustment = function getViewportAdjustment() {
	    var self = this;
	
	    var adjustment = { height: 0, width: 0 };
	
	    self.viewportAdjusters.forEach(function (func) {
	      adjustment = func.call(this, adjustment);
	    });
	
	    return adjustment;
	  };
	
	  GridRenderContainer.prototype.getMargin = function getMargin(side) {
	    var self = this;
	
	    var amount = 0;
	
	    self.viewportAdjusters.forEach(function (func) {
	      var adjustment = func.call(this, { height: 0, width: 0 });
	
	      if (adjustment.side && adjustment.side === side) {
	        amount += adjustment.width * -1;
	      }
	    });
	
	    return amount;
	  };
	
	  GridRenderContainer.prototype.getViewportHeight = function getViewportHeight() {
	    var self = this;
	
	    var headerHeight = (self.headerHeight) ? self.headerHeight : self.grid.headerHeight;
	
	    var viewPortHeight = self.grid.gridHeight - headerHeight - self.grid.footerHeight;
	
	
	    var adjustment = self.getViewportAdjustment();
	
	    viewPortHeight = viewPortHeight + adjustment.height;
	
	    return viewPortHeight;
	  };
	
	  GridRenderContainer.prototype.getViewportWidth = function getViewportWidth() {
	    var self = this;
	
	    var viewportWidth = self.grid.gridWidth;
	
	    //if (typeof(self.grid.verticalScrollbarWidth) !== 'undefined' && self.grid.verticalScrollbarWidth !== undefined && self.grid.verticalScrollbarWidth > 0) {
	    //  viewPortWidth = viewPortWidth - self.grid.verticalScrollbarWidth;
	    //}
	
	    // var viewportWidth = 0;\
	    // self.visibleColumnCache.forEach(function (column) {
	    //   viewportWidth += column.drawnWidth;
	    // });
	
	    var adjustment = self.getViewportAdjustment();
	
	    viewportWidth = viewportWidth + adjustment.width;
	
	    return viewportWidth;
	  };
	
	  GridRenderContainer.prototype.getHeaderViewportWidth = function getHeaderViewportWidth() {
	    var self = this;
	
	    var viewportWidth = this.getViewportWidth();
	
	    //if (typeof(self.grid.verticalScrollbarWidth) !== 'undefined' && self.grid.verticalScrollbarWidth !== undefined && self.grid.verticalScrollbarWidth > 0) {
	    //  viewPortWidth = viewPortWidth + self.grid.verticalScrollbarWidth;
	    //}
	
	    // var adjustment = self.getViewportAdjustment();
	    // viewPortWidth = viewPortWidth + adjustment.width;
	
	    return viewportWidth;
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name getCanvasHeight
	   * @methodOf ui.grid.class:GridRenderContainer
	   * @description Returns the total canvas height.   Only recalculates if canvasHeightShouldUpdate = false
	   * @returns {number} total height of all the visible rows in the container
	   */
	  GridRenderContainer.prototype.getCanvasHeight = function getCanvasHeight() {
	    var self = this;
	
	    if (!self.canvasHeightShouldUpdate) {
	      return self.$$canvasHeight;
	    }
	
	    var oldCanvasHeight = self.$$canvasHeight;
	
	    self.$$canvasHeight = 0;
	
	    self.visibleRowCache.forEach(function(row){
	      self.$$canvasHeight += row.height;
	    });
	
	
	    self.canvasHeightShouldUpdate = false;
	
	    self.grid.api.core.raise.canvasHeightChanged(oldCanvasHeight, self.$$canvasHeight);
	
	    return self.$$canvasHeight;
	  };
	
	  GridRenderContainer.prototype.getVerticalScrollLength = function getVerticalScrollLength() {
	    return this.getCanvasHeight() - this.getViewportHeight() + this.grid.scrollbarHeight !== 0 ? this.getCanvasHeight() - this.getViewportHeight() + this.grid.scrollbarHeight : -1;
	  };
	
	  GridRenderContainer.prototype.getHorizontalScrollLength = function getHorizontalScrollLength() {
	    return this.getCanvasWidth() - this.getViewportWidth() + this.grid.scrollbarWidth !== 0 ? this.getCanvasWidth() - this.getViewportWidth() + this.grid.scrollbarWidth : -1;
	  };
	
	  GridRenderContainer.prototype.getCanvasWidth = function getCanvasWidth() {
	    var self = this;
	
	    return self.canvasWidth;
	  };
	
	  GridRenderContainer.prototype.setRenderedRows = function setRenderedRows(newRows) {
	    this.renderedRows.length = newRows.length;
	    for (var i = 0; i < newRows.length; i++) {
	      this.renderedRows[i] = newRows[i];
	    }
	  };
	
	  GridRenderContainer.prototype.setRenderedColumns = function setRenderedColumns(newColumns) {
	    var self = this;
	
	    // OLD:
	    this.renderedColumns.length = newColumns.length;
	    for (var i = 0; i < newColumns.length; i++) {
	      this.renderedColumns[i] = newColumns[i];
	    }
	
	    this.updateColumnOffset();
	  };
	
	  GridRenderContainer.prototype.updateColumnOffset = function updateColumnOffset() {
	    // Calculate the width of the columns on the left side that are no longer rendered.
	    //  That will be the offset for the columns as we scroll horizontally.
	    var hiddenColumnsWidth = 0;
	    for (var i = 0; i < this.currentFirstColumn; i++) {
	      hiddenColumnsWidth += this.visibleColumnCache[i].drawnWidth;
	    }
	
	    this.columnOffset = hiddenColumnsWidth;
	  };
	
	  GridRenderContainer.prototype.scrollVertical = function (newScrollTop) {
	    var vertScrollPercentage = -1;
	
	    if (newScrollTop !== this.prevScrollTop) {
	      var yDiff = newScrollTop - this.prevScrollTop;
	
	      if (yDiff > 0 ) { this.grid.scrollDirection = uiGridConstants.scrollDirection.DOWN; }
	      if (yDiff < 0 ) { this.grid.scrollDirection = uiGridConstants.scrollDirection.UP; }
	
	      var vertScrollLength = this.getVerticalScrollLength();
	
	      vertScrollPercentage = newScrollTop / vertScrollLength;
	
	      // console.log('vert', vertScrollPercentage, newScrollTop, vertScrollLength);
	
	      if (vertScrollPercentage > 1) { vertScrollPercentage = 1; }
	      if (vertScrollPercentage < 0) { vertScrollPercentage = 0; }
	
	      this.adjustScrollVertical(newScrollTop, vertScrollPercentage);
	      return vertScrollPercentage;
	    }
	  };
	
	  GridRenderContainer.prototype.scrollHorizontal = function(newScrollLeft){
	    var horizScrollPercentage = -1;
	
	    // Handle RTL here
	    if (newScrollLeft !== this.prevScrollLeft) {
	      var xDiff = newScrollLeft - this.prevScrollLeft;
	
	      if (xDiff > 0) { this.grid.scrollDirection = uiGridConstants.scrollDirection.RIGHT; }
	      if (xDiff < 0) { this.grid.scrollDirection = uiGridConstants.scrollDirection.LEFT; }
	
	      var horizScrollLength = this.getHorizontalScrollLength();
	      if (horizScrollLength !== 0) {
	        horizScrollPercentage = newScrollLeft / horizScrollLength;
	      }
	      else {
	        horizScrollPercentage = 0;
	      }
	
	      this.adjustScrollHorizontal(newScrollLeft, horizScrollPercentage);
	      return horizScrollPercentage;
	    }
	  };
	
	  GridRenderContainer.prototype.adjustScrollVertical = function adjustScrollVertical(scrollTop, scrollPercentage, force) {
	    if (this.prevScrollTop === scrollTop && !force) {
	      return;
	    }
	
	    if (typeof(scrollTop) === 'undefined' || scrollTop === undefined || scrollTop === null) {
	      scrollTop = (this.getCanvasHeight() - this.getViewportHeight()) * scrollPercentage;
	    }
	
	    this.adjustRows(scrollTop, scrollPercentage, false);
	
	    this.prevScrollTop = scrollTop;
	    this.prevScrolltopPercentage = scrollPercentage;
	
	    this.grid.queueRefresh();
	  };
	
	  GridRenderContainer.prototype.adjustScrollHorizontal = function adjustScrollHorizontal(scrollLeft, scrollPercentage, force) {
	    if (this.prevScrollLeft === scrollLeft && !force) {
	      return;
	    }
	
	    if (typeof(scrollLeft) === 'undefined' || scrollLeft === undefined || scrollLeft === null) {
	      scrollLeft = (this.getCanvasWidth() - this.getViewportWidth()) * scrollPercentage;
	    }
	
	    this.adjustColumns(scrollLeft, scrollPercentage);
	
	    this.prevScrollLeft = scrollLeft;
	    this.prevScrollleftPercentage = scrollPercentage;
	
	    this.grid.queueRefresh();
	  };
	
	  GridRenderContainer.prototype.adjustRows = function adjustRows(scrollTop, scrollPercentage, postDataLoaded) {
	    var self = this;
	
	    var minRows = self.minRowsToRender();
	
	    var rowCache = self.visibleRowCache;
	
	    var maxRowIndex = rowCache.length - minRows;
	
	    // console.log('scroll%1', scrollPercentage);
	
	    // Calculate the scroll percentage according to the scrollTop location, if no percentage was provided
	    if ((typeof(scrollPercentage) === 'undefined' || scrollPercentage === null) && scrollTop) {
	      scrollPercentage = scrollTop / self.getVerticalScrollLength();
	    }
	
	    var rowIndex = Math.ceil(Math.min(maxRowIndex, maxRowIndex * scrollPercentage));
	
	    // console.log('maxRowIndex / scroll%', maxRowIndex, scrollPercentage, rowIndex);
	
	    // Define a max row index that we can't scroll past
	    if (rowIndex > maxRowIndex) {
	      rowIndex = maxRowIndex;
	    }
	
	    var newRange = [];
	    if (rowCache.length > self.grid.options.virtualizationThreshold) {
	      if (!(typeof(scrollTop) === 'undefined' || scrollTop === null)) {
	        // Have we hit the threshold going down?
	        if ( !self.grid.suppressParentScrollDown && self.prevScrollTop < scrollTop && rowIndex < self.prevRowScrollIndex + self.grid.options.scrollThreshold && rowIndex < maxRowIndex) {
	          return;
	        }
	        //Have we hit the threshold going up?
	        if ( !self.grid.suppressParentScrollUp && self.prevScrollTop > scrollTop && rowIndex > self.prevRowScrollIndex - self.grid.options.scrollThreshold && rowIndex < maxRowIndex) {
	          return;
	        }
	      }
	
	      var rangeStart = Math.max(0, rowIndex - self.grid.options.excessRows);
	      var rangeEnd = Math.min(rowCache.length, rowIndex + minRows + self.grid.options.excessRows);
	
	      newRange = [rangeStart, rangeEnd];
	    }
	    else {
	      var maxLen = self.visibleRowCache.length;
	      newRange = [0, Math.max(maxLen, minRows + self.grid.options.excessRows)];
	    }
	
	    self.updateViewableRowRange(newRange);
	
	    self.prevRowScrollIndex = rowIndex;
	  };
	
	  GridRenderContainer.prototype.adjustColumns = function adjustColumns(scrollLeft, scrollPercentage) {
	    var self = this;
	
	    var minCols = self.minColumnsToRender();
	
	    var columnCache = self.visibleColumnCache;
	    var maxColumnIndex = columnCache.length - minCols;
	
	    // Calculate the scroll percentage according to the scrollLeft location, if no percentage was provided
	    if ((typeof(scrollPercentage) === 'undefined' || scrollPercentage === null) && scrollLeft) {
	      scrollPercentage = scrollLeft / self.getHorizontalScrollLength();
	    }
	
	    var colIndex = Math.ceil(Math.min(maxColumnIndex, maxColumnIndex * scrollPercentage));
	
	    // Define a max row index that we can't scroll past
	    if (colIndex > maxColumnIndex) {
	      colIndex = maxColumnIndex;
	    }
	
	    var newRange = [];
	    if (columnCache.length > self.grid.options.columnVirtualizationThreshold && self.getCanvasWidth() > self.getViewportWidth()) {
	      /* Commented the following lines because otherwise the moved column wasn't visible immediately on the new position
	       * in the case of many columns with horizontal scroll, one had to scroll left or right and then return in order to see it
	      // Have we hit the threshold going down?
	      if (self.prevScrollLeft < scrollLeft && colIndex < self.prevColumnScrollIndex + self.grid.options.horizontalScrollThreshold && colIndex < maxColumnIndex) {
	        return;
	      }
	      //Have we hit the threshold going up?
	      if (self.prevScrollLeft > scrollLeft && colIndex > self.prevColumnScrollIndex - self.grid.options.horizontalScrollThreshold && colIndex < maxColumnIndex) {
	        return;
	      }*/
	
	      var rangeStart = Math.max(0, colIndex - self.grid.options.excessColumns);
	      var rangeEnd = Math.min(columnCache.length, colIndex + minCols + self.grid.options.excessColumns);
	
	      newRange = [rangeStart, rangeEnd];
	    }
	    else {
	      var maxLen = self.visibleColumnCache.length;
	
	      newRange = [0, Math.max(maxLen, minCols + self.grid.options.excessColumns)];
	    }
	
	    self.updateViewableColumnRange(newRange);
	
	    self.prevColumnScrollIndex = colIndex;
	  };
	
	  // Method for updating the visible rows
	  GridRenderContainer.prototype.updateViewableRowRange = function updateViewableRowRange(renderedRange) {
	    // Slice out the range of rows from the data
	    // var rowArr = uiGridCtrl.grid.rows.slice(renderedRange[0], renderedRange[1]);
	    var rowArr = this.visibleRowCache.slice(renderedRange[0], renderedRange[1]);
	
	    // Define the top-most rendered row
	    this.currentTopRow = renderedRange[0];
	
	    this.setRenderedRows(rowArr);
	  };
	
	  // Method for updating the visible columns
	  GridRenderContainer.prototype.updateViewableColumnRange = function updateViewableColumnRange(renderedRange) {
	    // Slice out the range of rows from the data
	    // var columnArr = uiGridCtrl.grid.columns.slice(renderedRange[0], renderedRange[1]);
	    var columnArr = this.visibleColumnCache.slice(renderedRange[0], renderedRange[1]);
	
	    // Define the left-most rendered columns
	    this.currentFirstColumn = renderedRange[0];
	
	    this.setRenderedColumns(columnArr);
	  };
	
	  GridRenderContainer.prototype.headerCellWrapperStyle = function () {
	    var self = this;
	
	    if (self.currentFirstColumn !== 0) {
	      var offset = self.columnOffset;
	
	      if (self.grid.isRTL()) {
	        return { 'margin-right': offset + 'px' };
	      }
	      else {
	        return { 'margin-left': offset + 'px' };
	      }
	    }
	
	    return null;
	  };
	
	    /**
	     *  @ngdoc boolean
	     *  @name updateColumnWidths
	     *  @propertyOf  ui.grid.class:GridRenderContainer
	     *  @description Determine the appropriate column width of each column across all render containers.
	     *
	     *  Column width is easy when each column has a specified width.  When columns are variable width (i.e.
	     *  have an * or % of the viewport) then we try to calculate so that things fit in.  The problem is that
	     *  we have multiple render containers, and we don't want one render container to just take the whole viewport
	     *  when it doesn't need to - we want things to balance out across the render containers.
	     *
	     *  To do this, we use this method to calculate all the renderContainers, recognising that in a given render
	     *  cycle it'll get called once per render container, so it needs to return the same values each time.
	     *
	     *  The constraints on this method are therefore:
	     *  - must return the same value when called multiple times, to do this it needs to rely on properties of the
	     *    columns, but not properties that change when this is called (so it shouldn't rely on drawnWidth)
	     *
	     *  The general logic of this method is:
	     *  - calculate our total available width
	     *  - look at all the columns across all render containers, and work out which have widths and which have
	     *    constraints such as % or * or something else
	     *  - for those with *, count the total number of * we see and add it onto a running total, add this column to an * array
	     *  - for those with a %, allocate the % as a percentage of the viewport, having consideration of min and max
	     *  - for those with manual width (in pixels) we set the drawnWidth to the specified width
	     *  - we end up with an asterisks array still to process
	     *  - we look at our remaining width.  If it's greater than zero, we divide it up among the asterisk columns, then process
	     *    them for min and max width constraints
	     *  - if it's zero or less, we set the asterisk columns to their minimum widths
	     *  - we use parseInt quite a bit, as we try to make all our column widths integers
	     */
	  GridRenderContainer.prototype.updateColumnWidths = function () {
	    var self = this;
	
	    var asterisksArray = [],
	        asteriskNum = 0,
	        usedWidthSum = 0,
	        ret = '',
	        pinRightColumn = false,
	        fixedNumberArray = [],
	        percentageArray = [],
	        totalPercentage = 0;
	
	    // Get the width of the viewport
	    var availableWidth = self.grid.getViewportWidth() - self.grid.scrollbarWidth;
	
	    // get all the columns across all render containers, we have to calculate them all or one render container
	    // could consume the whole viewport
	    var columnCache = [];
	    angular.forEach(self.grid.renderContainers, function (container) {
	      columnCache = columnCache.concat(container.visibleColumnCache);
	    });
	
	    // look at each column, process any manual values or %, put the * into an array to look at later
	    columnCache.forEach(function (column) {
	      var width = 0;
	      // Skip hidden columns
	      if (!column.visible) { return; }
	
	      if (pinRightColumn) {
	        availableWidth += self.grid.scrollbarWidth;
	      }
	
	      if (!pinRightColumn && column.colDef.pinnedRight) {
	        pinRightColumn = true;
	      }
	
	      if (angular.isNumber(column.width)) {
	        // pixel width, set to this value
	        width = parseInt(column.width, 10);
	        usedWidthSum = usedWidthSum + width;
	        column.drawnWidth = width;
	
	        fixedNumberArray.push(column);
	      } else if (gridUtil.endsWith(column.width, '%')) {
	        // percentage width, set to percentage of the viewport
	        // round down to int - some browsers don't play nice with float maxWidth
	        var percentageIntegerValue = parseInt(column.width.replace(/%/g, ''), 10);
	        width = parseInt(percentageIntegerValue / 100 * availableWidth);
	
	        if (width > column.maxWidth) {
	          width = column.maxWidth;
	        }
	
	        if (width < column.minWidth) {
	          width = column.minWidth;
	        }
	
	        usedWidthSum = usedWidthSum + width;
	        column.drawnWidth = width;
	
	        totalPercentage = totalPercentage + percentageIntegerValue;
	        percentageArray.push(column);
	      } else if (angular.isString(column.width) && column.width.indexOf('*') !== -1) {
	        // is an asterisk column, the gridColumn already checked the string consists only of '****'
	        asteriskNum = asteriskNum + column.width.length;
	        asterisksArray.push(column);
	      }
	    });
	
	    // Get the remaining width (available width subtracted by the used widths sum)
	    var remainingWidth = availableWidth - usedWidthSum;
	
	    if (asterisksArray.length > 0) {
	      // the width that each asterisk value would be assigned (this can be negative)
	      var asteriskVal = remainingWidth / asteriskNum;
	
	      asterisksArray.forEach(function (column) {
	        var width = parseInt(column.width.length * asteriskVal, 10);
	
	        if (width > column.maxWidth) {
	            width = column.maxWidth;
	        }
	
	        if (width < column.minWidth) {
	            width = column.minWidth;
	        }
	
	        usedWidthSum = usedWidthSum + width;
	        column.drawnWidth = width;
	      });
	    }
	
	    // If there are no columns with asterisk widths then check if there are any with % widths and
	    // use them as a fallback for adjusting column widths up or down if we have remaining grid width
	    // or need to claw some width back
	    var variableWidthColumnArray;
	    if (asterisksArray.length > 0) {
	      variableWidthColumnArray = asterisksArray;
	    } else if (percentageArray.length > 0 && fixedNumberArray.length === 0 && totalPercentage === 100) {
	      variableWidthColumnArray = percentageArray;
	    }
	
	    if (!angular.isUndefined(variableWidthColumnArray)) {
	      // If the grid width didn't divide evenly into the column widths and we have pixels left over, or our
	      // calculated widths would have the grid narrower than the available space,
	      // dole the remainder out one by one to make everything fit
	      var processColumnUpwards = function (column) {
	        if (column.drawnWidth < column.maxWidth && leftoverWidth > 0) {
	          column.drawnWidth++;
	          usedWidthSum++;
	          leftoverWidth--;
	          columnsToChange = true;
	        }
	      };
	
	      var leftoverWidth = availableWidth - usedWidthSum;
	      var columnsToChange = true;
	
	      while (leftoverWidth > 0 && columnsToChange) {
	        columnsToChange = false;
	        variableWidthColumnArray.forEach(processColumnUpwards);
	      }
	
	      // We can end up with too much width even though some columns aren't at their max width, in this situation
	      // we can trim the columns a little
	      var processColumnDownwards = function (column) {
	        if (column.drawnWidth > column.minWidth && excessWidth > 0) {
	          column.drawnWidth--;
	          usedWidthSum--;
	          excessWidth--;
	          columnsToChange = true;
	        }
	      };
	
	      var excessWidth = usedWidthSum - availableWidth;
	      columnsToChange = true;
	
	      while (excessWidth > 0 && columnsToChange) {
	        columnsToChange = false;
	        variableWidthColumnArray.forEach(processColumnDownwards);
	      }
	    }
	
	    // all that was across all the renderContainers, now we need to work out what that calculation decided for
	    // our renderContainer
	    var canvasWidth = 0;
	    self.visibleColumnCache.forEach(function(column){
	      if ( column.visible ){
	        canvasWidth = canvasWidth + column.drawnWidth;
	      }
	    });
	
	    // Build the CSS
	    columnCache.forEach(function (column) {
	      ret = ret + column.getColClassDefinition();
	    });
	
	    self.canvasWidth = canvasWidth;
	
	    // Return the styles back to buildStyles which pops them into the `customStyles` scope variable
	    // return ret;
	
	    // Set this render container's column styles so they can be used in style computation
	    this.columnStyles = ret;
	  };
	
	  GridRenderContainer.prototype.needsHScrollbarPlaceholder = function () {
	    var self = this,
	      containerBody;
	
	    if (self.name === 'left' || self.name === 'right' && !this.hasHScrollbar && !this.grid.disableScrolling) {
	      if (self.grid.options.enableHorizontalScrollbar === uiGridConstants.scrollbars.ALWAYS) {
	        return true;
	      }
	      containerBody = this.grid.element[0].querySelector('.ui-grid-render-container-body .ui-grid-viewport');
	      return containerBody.scrollWidth > containerBody.offsetWidth;
	    }
	    return false;
	  };
	
	  GridRenderContainer.prototype.getViewportStyle = function () {
	    var self = this;
	    var styles = {};
	    var scrollbarVisibility = {};
	
	    scrollbarVisibility[uiGridConstants.scrollbars.ALWAYS] = 'scroll';
	    scrollbarVisibility[uiGridConstants.scrollbars.WHEN_NEEDED] = 'auto';
	
	    self.hasHScrollbar = false;
	    self.hasVScrollbar = false;
	
	    if (self.grid.disableScrolling) {
	      styles['overflow-x'] = 'hidden';
	      styles['overflow-y'] = 'hidden';
	      return styles;
	    }
	
	    if (self.name === 'body') {
	      self.hasHScrollbar = self.grid.options.enableHorizontalScrollbar !== uiGridConstants.scrollbars.NEVER;
	      if (!self.grid.isRTL()) {
	        if (!self.grid.hasRightContainerColumns()) {
	          self.hasVScrollbar = self.grid.options.enableVerticalScrollbar !== uiGridConstants.scrollbars.NEVER;
	        }
	      }
	      else {
	        if (!self.grid.hasLeftContainerColumns()) {
	          self.hasVScrollbar = self.grid.options.enableVerticalScrollbar !== uiGridConstants.scrollbars.NEVER;
	        }
	      }
	    }
	    else if (self.name === 'left') {
	      self.hasVScrollbar = self.grid.isRTL() ? self.grid.options.enableVerticalScrollbar !== uiGridConstants.scrollbars.NEVER : false;
	    }
	    else {
	      self.hasVScrollbar = !self.grid.isRTL() ? self.grid.options.enableVerticalScrollbar !== uiGridConstants.scrollbars.NEVER : false;
	    }
	
	    styles['overflow-x'] = self.hasHScrollbar ? scrollbarVisibility[self.grid.options.enableHorizontalScrollbar] : 'hidden';
	    styles['overflow-y'] = self.hasVScrollbar ? scrollbarVisibility[self.grid.options.enableVerticalScrollbar] : 'hidden';
	
	    return styles;
	  };
	
	  return GridRenderContainer;
	}]);
	
	})();
	
	(function(){
	
	angular.module('ui.grid')
	.factory('GridRow', ['gridUtil', 'uiGridConstants', function(gridUtil, uiGridConstants) {
	
	   /**
	   * @class GridRow
	   * @ngdoc function
	   * @name ui.grid.class:GridRow
	   * @description GridRow is the viewModel for one logical row on the grid.  A grid Row is not necessarily a one-to-one
	   * relation to gridOptions.data.
	   * @param {object} entity the array item from GridOptions.data
	   * @param {number} index the current position of the row in the array
	   * @param {Grid} grid reference to the parent grid
	   */
	  function GridRow(entity, index, grid) {
	
	     /**
	      *  @ngdoc object
	      *  @name grid
	      *  @propertyOf  ui.grid.class:GridRow
	      *  @description A reference back to the grid
	      */
	     this.grid = grid;
	
	     /**
	      *  @ngdoc object
	      *  @name entity
	      *  @propertyOf  ui.grid.class:GridRow
	      *  @description A reference to an item in gridOptions.data[]
	      */
	    this.entity = entity;
	
	     /**
	      *  @ngdoc object
	      *  @name uid
	      *  @propertyOf  ui.grid.class:GridRow
	      *  @description  UniqueId of row
	      */
	     this.uid = gridUtil.nextUid();
	
	     /**
	      *  @ngdoc object
	      *  @name visible
	      *  @propertyOf  ui.grid.class:GridRow
	      *  @description If true, the row will be rendered
	      */
	    // Default to true
	    this.visible = true;
	
	     /**
	      *  @ngdoc object
	      *  @name isSelected
	      *  @propertyOf  ui.grid.class:GridRow
	      *  @description Marks if the row has been selected
	      */
	     // Default to false
	     this.isSelected = false;
	
	
	    this.$$height = grid.options.rowHeight;
	
	  }
	
	    /**
	     *  @ngdoc object
	     *  @name height
	     *  @propertyOf ui.grid.class:GridRow
	     *  @description height of each individual row. changing the height will flag all
	     *  row renderContainers to recalculate their canvas height
	     */
	    Object.defineProperty(GridRow.prototype, 'height', {
	      get: function() {
	        return this.$$height;
	      },
	      set: function(height) {
	        if (height !== this.$$height) {
	          this.grid.updateCanvasHeight();
	          this.$$height = height;
	        }
	      }
	    });
	
	  /**
	   * @ngdoc function
	   * @name getQualifiedColField
	   * @methodOf ui.grid.class:GridRow
	   * @description returns the qualified field name as it exists on scope
	   * ie: row.entity.fieldA
	   * @param {GridColumn} col column instance
	   * @returns {string} resulting name that can be evaluated on scope
	   */
	    GridRow.prototype.getQualifiedColField = function(col) {
	      return 'row.' + this.getEntityQualifiedColField(col);
	    };
	
	    /**
	     * @ngdoc function
	     * @name getEntityQualifiedColField
	     * @methodOf ui.grid.class:GridRow
	     * @description returns the qualified field name minus the row path
	     * ie: entity.fieldA
	     * @param {GridColumn} col column instance
	     * @returns {string} resulting name that can be evaluated against a row
	     */
	  GridRow.prototype.getEntityQualifiedColField = function(col) {
	    var base = 'entity';
	    if ( col.field === uiGridConstants.ENTITY_BINDING ) {
	      return base;
	    }
	    return gridUtil.preEval(base + '.' + col.field);
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name setRowInvisible
	   * @methodOf  ui.grid.class:GridRow
	   * @description Sets an override on the row that forces it to always
	   * be invisible. Emits the rowsVisibleChanged event if it changed the row visibility.
	   *
	   * This method can be called from the api, passing in the gridRow we want
	   * altered.  It should really work by calling gridRow.setRowInvisible, but that's
	   * not the way I coded it, and too late to change now.  Changed to just call
	   * the internal function row.setThisRowInvisible().
	   *
	   * @param {GridRow} row the row we want to set to invisible
	   *
	   */
	  GridRow.prototype.setRowInvisible = function ( row ) {
	    if (row && row.setThisRowInvisible){
	      row.setThisRowInvisible( 'user' );
	    }
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name clearRowInvisible
	   * @methodOf  ui.grid.class:GridRow
	   * @description Clears an override on the row that forces it to always
	   * be invisible. Emits the rowsVisibleChanged event if it changed the row visibility.
	   *
	   * This method can be called from the api, passing in the gridRow we want
	   * altered.  It should really work by calling gridRow.clearRowInvisible, but that's
	   * not the way I coded it, and too late to change now.  Changed to just call
	   * the internal function row.clearThisRowInvisible().
	   *
	   * @param {GridRow} row the row we want to clear the invisible flag
	   *
	   */
	  GridRow.prototype.clearRowInvisible = function ( row ) {
	    if (row && row.clearThisRowInvisible){
	      row.clearThisRowInvisible( 'user' );
	    }
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name setThisRowInvisible
	   * @methodOf  ui.grid.class:GridRow
	   * @description Sets an override on the row that forces it to always
	   * be invisible. Emits the rowsVisibleChanged event if it changed the row visibility
	   *
	   * @param {string} reason the reason (usually the module) for the row to be invisible.
	   * E.g. grouping, user, filter
	   * @param {boolean} fromRowsProcessor whether we were called from a rowsProcessor, passed through to evaluateRowVisibility
	   */
	  GridRow.prototype.setThisRowInvisible = function ( reason, fromRowsProcessor ) {
	    if ( !this.invisibleReason ){
	      this.invisibleReason = {};
	    }
	    this.invisibleReason[reason] = true;
	    this.evaluateRowVisibility( fromRowsProcessor);
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name clearRowInvisible
	   * @methodOf ui.grid.class:GridRow
	   * @description Clears any override on the row visibility, returning it
	   * to normal visibility calculations.  Emits the rowsVisibleChanged
	   * event
	   *
	   * @param {string} reason the reason (usually the module) for the row to be invisible.
	   * E.g. grouping, user, filter
	   * @param {boolean} fromRowsProcessor whether we were called from a rowsProcessor, passed through to evaluateRowVisibility
	   */
	  GridRow.prototype.clearThisRowInvisible = function ( reason, fromRowsProcessor ) {
	    if (typeof(this.invisibleReason) !== 'undefined' ) {
	      delete this.invisibleReason[reason];
	    }
	    this.evaluateRowVisibility( fromRowsProcessor );
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name evaluateRowVisibility
	   * @methodOf ui.grid.class:GridRow
	   * @description Determines whether the row should be visible based on invisibleReason,
	   * and if it changes the row visibility, then emits the rowsVisibleChanged event.
	   *
	   * Queues a grid refresh, but doesn't call it directly to avoid hitting lots of grid refreshes.
	   * @param {boolean} fromRowProcessor if true, then it won't raise events or queue the refresh, the
	   * row processor does that already
	   */
	  GridRow.prototype.evaluateRowVisibility = function ( fromRowProcessor ) {
	    var newVisibility = true;
	    if ( typeof(this.invisibleReason) !== 'undefined' ){
	      angular.forEach(this.invisibleReason, function( value, key ){
	        if ( value ){
	          newVisibility = false;
	        }
	      });
	    }
	
	    if ( typeof(this.visible) === 'undefined' || this.visible !== newVisibility ){
	      this.visible = newVisibility;
	      if ( !fromRowProcessor ){
	        this.grid.queueGridRefresh();
	        this.grid.api.core.raise.rowsVisibleChanged(this);
	      }
	    }
	  };
	
	
	  return GridRow;
	}]);
	
	})();
	
	(function(){
	  'use strict';
	  /**
	   * @ngdoc object
	   * @name ui.grid.class:GridRowColumn
	   * @param {GridRow} row The row for this pair
	   * @param {GridColumn} column The column for this pair
	   * @description A row and column pair that represents the intersection of these two entities.
	   * Must be instantiated as a constructor using the `new` keyword.
	   */
	  angular.module('ui.grid')
	  .factory('GridRowColumn', ['$parse', '$filter',
	    function GridRowColumnFactory($parse, $filter){
	      var GridRowColumn = function GridRowColumn(row, col) {
	        if ( !(this instanceof GridRowColumn)){
	          throw "Using GridRowColumn as a function insead of as a constructor. Must be called with `new` keyword";
	        }
	
	        /**
	         * @ngdoc object
	         * @name row
	         * @propertyOf ui.grid.class:GridRowColumn
	         * @description {@link ui.grid.class:GridRow }
	         */
	        this.row = row;
	        /**
	         * @ngdoc object
	         * @name col
	         * @propertyOf ui.grid.class:GridRowColumn
	         * @description {@link ui.grid.class:GridColumn }
	         */
	        this.col = col;
	      };
	
	      /**
	       * @ngdoc function
	       * @name getIntersectionValueRaw
	       * @methodOf ui.grid.class:GridRowColumn
	       * @description Gets the intersection of where the row and column meet.
	       * @returns {String|Number|Object} The value from the grid data that this GridRowColumn points too.
	       *          If the column has a cellFilter this will NOT return the filtered value.
	       */
	      GridRowColumn.prototype.getIntersectionValueRaw = function(){
	        var getter = $parse(this.row.getEntityQualifiedColField(this.col));
	        var context = this.row;
	        return getter(context);
	      };
	      return GridRowColumn;
	    }
	  ]);
	})();
	
	(function () {
	  angular.module('ui.grid')
	    .factory('ScrollEvent', ['gridUtil', function (gridUtil) {
	
	      /**
	       * @ngdoc function
	       * @name ui.grid.class:ScrollEvent
	       * @description Model for all scrollEvents
	       * @param {Grid} grid that owns the scroll event
	       * @param {GridRenderContainer} sourceRowContainer that owns the scroll event. Can be null
	       * @param {GridRenderContainer} sourceColContainer that owns the scroll event. Can be null
	       * @param {string} source the source of the event - from uiGridConstants.scrollEventSources or a string value of directive/service/factory.functionName
	       */
	      function ScrollEvent(grid, sourceRowContainer, sourceColContainer, source) {
	        var self = this;
	        if (!grid) {
	          throw new Error("grid argument is required");
	        }
	
	        /**
	         *  @ngdoc object
	         *  @name grid
	         *  @propertyOf  ui.grid.class:ScrollEvent
	         *  @description A reference back to the grid
	         */
	         self.grid = grid;
	
	
	
	        /**
	         *  @ngdoc object
	         *  @name source
	         *  @propertyOf  ui.grid.class:ScrollEvent
	         *  @description the source of the scroll event. limited to values from uiGridConstants.scrollEventSources
	         */
	        self.source = source;
	
	
	        /**
	         *  @ngdoc object
	         *  @name noDelay
	         *  @propertyOf  ui.grid.class:ScrollEvent
	         *  @description most scroll events from the mouse or trackpad require delay to operate properly
	         *  set to false to eliminate delay.  Useful for scroll events that the grid causes, such as scrolling to make a row visible.
	         */
	        self.withDelay = true;
	
	        self.sourceRowContainer = sourceRowContainer;
	        self.sourceColContainer = sourceColContainer;
	
	        self.newScrollLeft = null;
	        self.newScrollTop = null;
	        self.x = null;
	        self.y = null;
	
	        self.verticalScrollLength = -9999999;
	        self.horizontalScrollLength = -999999;
	
	
	        /**
	         *  @ngdoc function
	         *  @name fireThrottledScrollingEvent
	         *  @methodOf  ui.grid.class:ScrollEvent
	         *  @description fires a throttled event using grid.api.core.raise.scrollEvent
	         */
	        self.fireThrottledScrollingEvent = gridUtil.throttle(function(sourceContainerId) {
	          self.grid.scrollContainers(sourceContainerId, self);
	        }, self.grid.options.wheelScrollThrottle, {trailing: true});
	
	      }
	
	
	      /**
	       *  @ngdoc function
	       *  @name getNewScrollLeft
	       *  @methodOf  ui.grid.class:ScrollEvent
	       *  @description returns newScrollLeft property if available; calculates a new value if it isn't
	       */
	      ScrollEvent.prototype.getNewScrollLeft = function(colContainer, viewport){
	        var self = this;
	
	        if (!self.newScrollLeft){
	          var scrollWidth = (colContainer.getCanvasWidth() - colContainer.getViewportWidth());
	
	          var oldScrollLeft = gridUtil.normalizeScrollLeft(viewport, self.grid);
	
	          var scrollXPercentage;
	          if (typeof(self.x.percentage) !== 'undefined' && self.x.percentage !== undefined) {
	            scrollXPercentage = self.x.percentage;
	          }
	          else if (typeof(self.x.pixels) !== 'undefined' && self.x.pixels !== undefined) {
	            scrollXPercentage = self.x.percentage = (oldScrollLeft + self.x.pixels) / scrollWidth;
	          }
	          else {
	            throw new Error("No percentage or pixel value provided for scroll event X axis");
	          }
	
	          return Math.max(0, scrollXPercentage * scrollWidth);
	        }
	
	        return self.newScrollLeft;
	      };
	
	
	      /**
	       *  @ngdoc function
	       *  @name getNewScrollTop
	       *  @methodOf  ui.grid.class:ScrollEvent
	       *  @description returns newScrollTop property if available; calculates a new value if it isn't
	       */
	      ScrollEvent.prototype.getNewScrollTop = function(rowContainer, viewport){
	        var self = this;
	
	
	        if (!self.newScrollTop){
	          var scrollLength = rowContainer.getVerticalScrollLength();
	
	          var oldScrollTop = viewport[0].scrollTop;
	
	          var scrollYPercentage;
	          if (typeof(self.y.percentage) !== 'undefined' && self.y.percentage !== undefined) {
	            scrollYPercentage = self.y.percentage;
	          }
	          else if (typeof(self.y.pixels) !== 'undefined' && self.y.pixels !== undefined) {
	            scrollYPercentage = self.y.percentage = (oldScrollTop + self.y.pixels) / scrollLength;
	          }
	          else {
	            throw new Error("No percentage or pixel value provided for scroll event Y axis");
	          }
	
	          return Math.max(0, scrollYPercentage * scrollLength);
	        }
	
	        return self.newScrollTop;
	      };
	
	      ScrollEvent.prototype.atTop = function(scrollTop) {
	        return (this.y && (this.y.percentage === 0 || this.verticalScrollLength < 0) && scrollTop === 0);
	      };
	
	      ScrollEvent.prototype.atBottom = function(scrollTop) {
	        return (this.y && (this.y.percentage === 1 || this.verticalScrollLength === 0) && scrollTop > 0);
	      };
	
	      ScrollEvent.prototype.atLeft = function(scrollLeft) {
	        return (this.x && (this.x.percentage === 0 || this.horizontalScrollLength < 0) && scrollLeft === 0);
	      };
	
	      ScrollEvent.prototype.atRight = function(scrollLeft) {
	        return (this.x && (this.x.percentage === 1 || this.horizontalScrollLength ===0) && scrollLeft > 0);
	      };
	
	
	      ScrollEvent.Sources = {
	        ViewPortScroll: 'ViewPortScroll',
	        RenderContainerMouseWheel: 'RenderContainerMouseWheel',
	        RenderContainerTouchMove: 'RenderContainerTouchMove',
	        Other: 99
	      };
	
	      return ScrollEvent;
	    }]);
	
	
	
	})();
	
	(function () {
	  'use strict';
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.service:gridClassFactory
	   *
	   *  @description factory to return dom specific instances of a grid
	   *
	   */
	  angular.module('ui.grid').service('gridClassFactory', ['gridUtil', '$q', '$compile', '$templateCache', 'uiGridConstants', 'Grid', 'GridColumn', 'GridRow',
	    function (gridUtil, $q, $compile, $templateCache, uiGridConstants, Grid, GridColumn, GridRow) {
	
	      var service = {
	        /**
	         * @ngdoc method
	         * @name createGrid
	         * @methodOf ui.grid.service:gridClassFactory
	         * @description Creates a new grid instance. Each instance will have a unique id
	         * @param {object} options An object map of options to pass into the created grid instance.
	         * @returns {Grid} grid
	         */
	        createGrid : function(options) {
	          options = (typeof(options) !== 'undefined') ? options : {};
	          options.id = gridUtil.newId();
	          var grid = new Grid(options);
	
	          // NOTE/TODO: rowTemplate should always be defined...
	          if (grid.options.rowTemplate) {
	            var rowTemplateFnPromise = $q.defer();
	            grid.getRowTemplateFn = rowTemplateFnPromise.promise;
	            
	            gridUtil.getTemplate(grid.options.rowTemplate)
	              .then(
	                function (template) {
	                  var rowTemplateFn = $compile(template);
	                  rowTemplateFnPromise.resolve(rowTemplateFn);
	                },
	                function (res) {
	                  // Todo handle response error here?
	                  throw new Error("Couldn't fetch/use row template '" + grid.options.rowTemplate + "'");
	                }).catch(angular.noop);
	          }
	
	          grid.registerColumnBuilder(service.defaultColumnBuilder);
	
	          // Row builder for custom row templates
	          grid.registerRowBuilder(service.rowTemplateAssigner);
	
	          // Reset all rows to visible initially
	          grid.registerRowsProcessor(function allRowsVisible(rows) {
	            rows.forEach(function (row) {
	              row.evaluateRowVisibility( true );
	            });
	
	            return rows;
	          }, 50);
	
	          grid.registerColumnsProcessor(function applyColumnVisibility(columns) {
	            columns.forEach(function (column) {
	              column.visible = angular.isDefined(column.colDef.visible) ? column.colDef.visible : true;
	            });
	
	            return columns;
	          }, 50);
	
	          grid.registerRowsProcessor(grid.searchRows, 100);
	
	          // Register the default row processor, it sorts rows by selected columns
	          if (grid.options.externalSort && angular.isFunction(grid.options.externalSort)) {
	            grid.registerRowsProcessor(grid.options.externalSort, 200);
	          }
	          else {
	            grid.registerRowsProcessor(grid.sortByColumn, 200);
	          }
	
	          return grid;
	        },
	
	        /**
	         * @ngdoc function
	         * @name defaultColumnBuilder
	         * @methodOf ui.grid.service:gridClassFactory
	         * @description Processes designTime column definitions and applies them to col for the
	         *              core grid features
	         * @param {object} colDef reference to column definition
	         * @param {GridColumn} col reference to gridCol
	         * @param {object} gridOptions reference to grid options
	         */
	        defaultColumnBuilder: function (colDef, col, gridOptions) {
	
	          var templateGetPromises = [];
	
	          // Abstracts the standard template processing we do for every template type.
	          var processTemplate = function( templateType, providedType, defaultTemplate, filterType, tooltipType ) {
	            if ( !colDef[templateType] ){
	              col[providedType] = defaultTemplate;
	            } else {
	              col[providedType] = colDef[templateType];
	            }
	
	            var templatePromise = gridUtil.getTemplate(col[providedType])
	              .then(
	                function (template) {
	                  if ( angular.isFunction(template) ) { template = template(); }
	                  var tooltipCall = ( tooltipType === 'cellTooltip' ) ? 'col.cellTooltip(row,col)' : 'col.headerTooltip(col)';
	                  if ( tooltipType && col[tooltipType] === false ){
	                    template = template.replace(uiGridConstants.TOOLTIP, '');
	                  } else if ( tooltipType && col[tooltipType] ){
	                    template = template.replace(uiGridConstants.TOOLTIP, 'title="{{' + tooltipCall + ' CUSTOM_FILTERS }}"');
	                  }
	
	                  if ( filterType ){
	                    col[templateType] = template.replace(uiGridConstants.CUSTOM_FILTERS, function() {
	                      return col[filterType] ? "|" + col[filterType] : "";
	                    });
	                  } else {
	                    col[templateType] = template;
	                  }
	                },
	                function (res) {
	                  throw new Error("Couldn't fetch/use colDef." + templateType + " '" + colDef[templateType] + "'");
	                }).catch(angular.noop);
	
	            templateGetPromises.push(templatePromise);
	
	            return templatePromise;
	          };
	
	
	          /**
	           * @ngdoc property
	           * @name cellTemplate
	           * @propertyOf ui.grid.class:GridOptions.columnDef
	           * @description a custom template for each cell in this column.  The default
	           * is ui-grid/uiGridCell.  If you are using the cellNav feature, this template
	           * must contain a div that can receive focus.
	           *
	           */
	          col.cellTemplatePromise = processTemplate( 'cellTemplate', 'providedCellTemplate', 'ui-grid/uiGridCell', 'cellFilter', 'cellTooltip' );
	
	          /**
	           * @ngdoc property
	           * @name headerCellTemplate
	           * @propertyOf ui.grid.class:GridOptions.columnDef
	           * @description a custom template for the header for this column.  The default
	           * is ui-grid/uiGridHeaderCell
	           *
	           */
	          col.headerCellTemplatePromise = processTemplate( 'headerCellTemplate', 'providedHeaderCellTemplate', 'ui-grid/uiGridHeaderCell', 'headerCellFilter', 'headerTooltip' );
	
	          /**
	           * @ngdoc property
	           * @name footerCellTemplate
	           * @propertyOf ui.grid.class:GridOptions.columnDef
	           * @description a custom template for the footer for this column.  The default
	           * is ui-grid/uiGridFooterCell
	           *
	           */
	          col.footerCellTemplatePromise = processTemplate( 'footerCellTemplate', 'providedFooterCellTemplate', 'ui-grid/uiGridFooterCell', 'footerCellFilter' );
	
	          /**
	           * @ngdoc property
	           * @name filterHeaderTemplate
	           * @propertyOf ui.grid.class:GridOptions.columnDef
	           * @description a custom template for the filter input.  The default is ui-grid/ui-grid-filter
	           *
	           */
	          col.filterHeaderTemplatePromise = processTemplate( 'filterHeaderTemplate', 'providedFilterHeaderTemplate', 'ui-grid/ui-grid-filter' );
	
	          // Create a promise for the compiled element function
	          col.compiledElementFnDefer = $q.defer();
	
	          return $q.all(templateGetPromises);
	        },
	
	        rowTemplateAssigner: function rowTemplateAssigner(row) {
	          var grid = this;
	
	          // Row has no template assigned to it
	          if (!row.rowTemplate) {
	            // Use the default row template from the grid
	            row.rowTemplate = grid.options.rowTemplate;
	
	            // Use the grid's function for fetching the compiled row template function
	            row.getRowTemplateFn = grid.getRowTemplateFn;
	          }
	          // Row has its own template assigned
	          else {
	            // Create a promise for the compiled row template function
	            var perRowTemplateFnPromise = $q.defer();
	            row.getRowTemplateFn = perRowTemplateFnPromise.promise;
	
	            // Get the row template
	            gridUtil.getTemplate(row.rowTemplate)
	              .then(function (template) {
	                // Compile the template
	                var rowTemplateFn = $compile(template);
	                
	                // Resolve the compiled template function promise
	                perRowTemplateFnPromise.resolve(rowTemplateFn);
	              },
	              function (res) {
	                // Todo handle response error here?
	                throw new Error("Couldn't fetch/use row template '" + row.rowTemplate + "'");
	              });
	          }
	
	          return row.getRowTemplateFn;
	        }
	      };
	
	      //class definitions (moved to separate factories)
	
	      return service;
	    }]);
	
	})();
	
	(function() {
	
	var module = angular.module('ui.grid');
	
	function escapeRegExp(str) {
	  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
	}
	
	
	/**
	 *  @ngdoc service
	 *  @name ui.grid.service:rowSearcher
	 *
	 *  @description Service for searching/filtering rows based on column value conditions.
	 */
	module.service('rowSearcher', ['gridUtil', 'uiGridConstants', function (gridUtil, uiGridConstants) {
	  var defaultCondition = uiGridConstants.filter.CONTAINS;
	
	  var rowSearcher = {};
	
	  /**
	   * @ngdoc function
	   * @name getTerm
	   * @methodOf ui.grid.service:rowSearcher
	   * @description Get the term from a filter
	   * Trims leading and trailing whitespace
	   * @param {object} filter object to use
	   * @returns {object} Parsed term
	   */
	  rowSearcher.getTerm = function getTerm(filter) {
	    if (typeof(filter.term) === 'undefined') { return filter.term; }
	
	    var term = filter.term;
	
	    // Strip leading and trailing whitespace if the term is a string
	    if (typeof(term) === 'string') {
	      term = term.trim();
	    }
	
	    return term;
	  };
	
	  /**
	   * @ngdoc function
	   * @name stripTerm
	   * @methodOf ui.grid.service:rowSearcher
	   * @description Remove leading and trailing asterisk (*) from the filter's term
	   * @param {object} filter object to use
	   * @returns {uiGridConstants.filter<int>} Value representing the condition constant value
	   */
	  rowSearcher.stripTerm = function stripTerm(filter) {
	    var term = rowSearcher.getTerm(filter);
	
	    if (typeof(term) === 'string') {
	      return escapeRegExp(term.replace(/(^\*|\*$)/g, ''));
	    }
	    else {
	      return term;
	    }
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name guessCondition
	   * @methodOf ui.grid.service:rowSearcher
	   * @description Guess the condition for a filter based on its term
	   * <br>
	   * Defaults to STARTS_WITH. Uses CONTAINS for strings beginning and ending with *s (*bob*).
	   * Uses STARTS_WITH for strings ending with * (bo*). Uses ENDS_WITH for strings starting with * (*ob).
	   * @param {object} filter object to use
	   * @returns {uiGridConstants.filter<int>} Value representing the condition constant value
	   */
	  rowSearcher.guessCondition = function guessCondition(filter) {
	    if (typeof(filter.term) === 'undefined' || !filter.term) {
	      return defaultCondition;
	    }
	
	    var term = rowSearcher.getTerm(filter);
	
	    if (/\*/.test(term)) {
	      var regexpFlags = '';
	      if (!filter.flags || !filter.flags.caseSensitive) {
	        regexpFlags += 'i';
	      }
	
	      var reText = term.replace(/(\\)?\*/g, function ($0, $1) { return $1 ? $0 : '[\\s\\S]*?'; });
	      return new RegExp('^' + reText + '$', regexpFlags);
	    }
	    // Otherwise default to default condition
	    else {
	      return defaultCondition;
	    }
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name setupFilters
	   * @methodOf ui.grid.service:rowSearcher
	   * @description For a given columns filters (either col.filters, or [col.filter] can be passed in),
	   * do all the parsing and pre-processing and store that data into a new filters object.  The object
	   * has the condition, the flags, the stripped term, and a parsed reg exp if there was one.
	   *
	   * We could use a forEach in here, since it's much less performance sensitive, but since we're using
	   * for loops everywhere else in this module...
	   *
	   * @param {array} filters the filters from the column (col.filters or [col.filter])
	   * @returns {array} An array of parsed/preprocessed filters
	   */
	  rowSearcher.setupFilters = function setupFilters( filters ){
	    var newFilters = [];
	
	    var filtersLength = filters.length;
	    for ( var i = 0; i < filtersLength; i++ ){
	      var filter = filters[i];
	
	      if ( filter.noTerm || !gridUtil.isNullOrUndefined(filter.term) ){
	        var newFilter = {};
	
	        var regexpFlags = '';
	        if (!filter.flags || !filter.flags.caseSensitive) {
	          regexpFlags += 'i';
	        }
	
	        if ( !gridUtil.isNullOrUndefined(filter.term) ){
	          // it is possible to have noTerm.
	          if ( filter.rawTerm ){
	            newFilter.term = filter.term;
	          } else {
	            newFilter.term = rowSearcher.stripTerm(filter);
	          }
	        }
	        newFilter.noTerm = filter.noTerm;
	
	        if ( filter.condition ){
	          newFilter.condition = filter.condition;
	        } else {
	          newFilter.condition = rowSearcher.guessCondition(filter);
	        }
	
	        newFilter.flags = angular.extend( { caseSensitive: false, date: false }, filter.flags );
	
	        if (newFilter.condition === uiGridConstants.filter.STARTS_WITH) {
	          newFilter.startswithRE = new RegExp('^' + newFilter.term, regexpFlags);
	        }
	
	         if (newFilter.condition === uiGridConstants.filter.ENDS_WITH) {
	          newFilter.endswithRE = new RegExp(newFilter.term + '$', regexpFlags);
	        }
	
	        if (newFilter.condition === uiGridConstants.filter.CONTAINS) {
	          newFilter.containsRE = new RegExp(newFilter.term, regexpFlags);
	        }
	
	        if (newFilter.condition === uiGridConstants.filter.EXACT) {
	          newFilter.exactRE = new RegExp('^' + newFilter.term + '$', regexpFlags);
	        }
	
	        newFilters.push(newFilter);
	      }
	    }
	    return newFilters;
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name runColumnFilter
	   * @methodOf ui.grid.service:rowSearcher
	   * @description Runs a single pre-parsed filter against a cell, returning true
	   * if the cell matches that one filter.
	   *
	   * @param {Grid} grid the grid we're working against
	   * @param {GridRow} row the row we're matching against
	   * @param {GridColumn} column the column that we're working against
	   * @param {object} filter the specific, preparsed, filter that we want to test
	   * @returns {boolean} true if we match (row stays visible)
	   */
	  rowSearcher.runColumnFilter = function runColumnFilter(grid, row, column, filter) {
	    // Cache typeof condition
	    var conditionType = typeof(filter.condition);
	
	    // Term to search for.
	    var term = filter.term;
	
	    // Get the column value for this row
	    var value;
	    if ( column.filterCellFiltered ){
	      value = grid.getCellDisplayValue(row, column);
	    } else {
	      value = grid.getCellValue(row, column);
	    }
	
	
	    // If the filter's condition is a RegExp, then use it
	    if (filter.condition instanceof RegExp) {
	      return filter.condition.test(value);
	    }
	
	    // If the filter's condition is a function, run it
	    if (conditionType === 'function') {
	      return filter.condition(term, value, row, column);
	    }
	
	    if (filter.startswithRE) {
	      return filter.startswithRE.test(value);
	    }
	
	    if (filter.endswithRE) {
	      return filter.endswithRE.test(value);
	    }
	
	    if (filter.containsRE) {
	      return filter.containsRE.test(value);
	    }
	
	    if (filter.exactRE) {
	      return filter.exactRE.test(value);
	    }
	
	    if (filter.condition === uiGridConstants.filter.NOT_EQUAL) {
	      var regex = new RegExp('^' + term + '$');
	      return !regex.exec(value);
	    }
	
	    if (typeof(value) === 'number' && typeof(term) === 'string' ){
	      // if the term has a decimal in it, it comes through as '9\.4', we need to take out the \
	      // the same for negative numbers
	      // TODO: I suspect the right answer is to look at escapeRegExp at the top of this code file, maybe it's not needed?
	      var tempFloat = parseFloat(term.replace(/\\\./,'.').replace(/\\\-/,'-'));
	      if (!isNaN(tempFloat)) {
	        term = tempFloat;
	      }
	    }
	
	    if (filter.flags.date === true) {
	      value = new Date(value);
	      // If the term has a dash in it, it comes through as '\-' -- we need to take out the '\'.
	      term = new Date(term.replace(/\\/g, ''));
	    }
	
	    if (filter.condition === uiGridConstants.filter.GREATER_THAN) {
	      return (value > term);
	    }
	
	    if (filter.condition === uiGridConstants.filter.GREATER_THAN_OR_EQUAL) {
	      return (value >= term);
	    }
	
	    if (filter.condition === uiGridConstants.filter.LESS_THAN) {
	      return (value < term);
	    }
	
	    if (filter.condition === uiGridConstants.filter.LESS_THAN_OR_EQUAL) {
	      return (value <= term);
	    }
	
	    return true;
	  };
	
	
	  /**
	   * @ngdoc boolean
	   * @name useExternalFiltering
	   * @propertyOf ui.grid.class:GridOptions
	   * @description False by default. When enabled, this setting suppresses the internal filtering.
	   * All UI logic will still operate, allowing filter conditions to be set and modified.
	   *
	   * The external filter logic can listen for the `filterChange` event, which fires whenever
	   * a filter has been adjusted.
	   */
	  /**
	   * @ngdoc function
	   * @name searchColumn
	   * @methodOf ui.grid.service:rowSearcher
	   * @description Process provided filters on provided column against a given row. If the row meets
	   * the conditions on all the filters, return true.
	   * @param {Grid} grid Grid to search in
	   * @param {GridRow} row Row to search on
	   * @param {GridColumn} column Column with the filters to use
	   * @param {array} filters array of pre-parsed/preprocessed filters to apply
	   * @returns {boolean} Whether the column matches or not.
	   */
	  rowSearcher.searchColumn = function searchColumn(grid, row, column, filters) {
	    if (grid.options.useExternalFiltering) {
	      return true;
	    }
	
	    var filtersLength = filters.length;
	    for (var i = 0; i < filtersLength; i++) {
	      var filter = filters[i];
	
	      if ( !gridUtil.isNullOrUndefined(filter.term) && filter.term !== '' || filter.noTerm ){
	        var ret = rowSearcher.runColumnFilter(grid, row, column, filter);
	        if (!ret) {
	          return false;
	        }
	      }
	    }
	
	    return true;
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name search
	   * @methodOf ui.grid.service:rowSearcher
	   * @description Run a search across the given rows and columns, marking any rows that don't
	   * match the stored col.filters or col.filter as invisible.
	   * @param {Grid} grid Grid instance to search inside
	   * @param {Array[GridRow]} rows GridRows to filter
	   * @param {Array[GridColumn]} columns GridColumns with filters to process
	   */
	  rowSearcher.search = function search(grid, rows, columns) {
	    /*
	     * Added performance optimisations into this code base, as this logic creates deeply nested
	     * loops and is therefore very performance sensitive.  In particular, avoiding forEach as
	     * this impacts some browser optimisers (particularly Chrome), using iterators instead
	     */
	
	    // Don't do anything if we weren't passed any rows
	    if (!rows) {
	      return;
	    }
	
	    // don't filter if filtering currently disabled
	    if (!grid.options.enableFiltering){
	      return rows;
	    }
	
	    // Build list of filters to apply
	    var filterData = [];
	
	    var colsLength = columns.length;
	
	    var hasTerm = function( filters ) {
	      var hasTerm = false;
	
	      filters.forEach( function (filter) {
	        if ( !gridUtil.isNullOrUndefined(filter.term) && filter.term !== '' || filter.noTerm ){
	          hasTerm = true;
	        }
	      });
	
	      return hasTerm;
	    };
	
	    for (var i = 0; i < colsLength; i++) {
	      var col = columns[i];
	
	      if (typeof(col.filters) !== 'undefined' && hasTerm(col.filters) ) {
	        filterData.push( { col: col, filters: rowSearcher.setupFilters(col.filters) } );
	      }
	    }
	
	    if (filterData.length > 0) {
	      // define functions outside the loop, performance optimisation
	      var foreachRow = function(grid, row, col, filters){
	        if ( row.visible && !rowSearcher.searchColumn(grid, row, col, filters) ) {
	          row.visible = false;
	        }
	      };
	
	      var foreachFilterCol = function(grid, filterData){
	        var rowsLength = rows.length;
	        for ( var i = 0; i < rowsLength; i++){
	          foreachRow(grid, rows[i], filterData.col, filterData.filters);
	        }
	      };
	
	      // nested loop itself - foreachFilterCol, which in turn calls foreachRow
	      var filterDataLength = filterData.length;
	      for ( var j = 0; j < filterDataLength; j++){
	        foreachFilterCol( grid, filterData[j] );
	      }
	
	      if (grid.api.core.raise.rowsVisibleChanged) {
	        grid.api.core.raise.rowsVisibleChanged();
	      }
	
	      // drop any invisible rows
	      // keeping these, as needed with filtering for trees - we have to come back and make parent nodes visible if child nodes are selected in the filter
	      // rows = rows.filter(function(row){ return row.visible; });
	
	    }
	
	    return rows;
	  };
	
	  return rowSearcher;
	}]);
	
	})();
	
	(function() {
	
	var module = angular.module('ui.grid');
	
	/**
	 * @ngdoc object
	 * @name ui.grid.class:rowSorter
	 * @description rowSorter provides the default sorting mechanisms,
	 * including guessing column types and applying appropriate sort
	 * algorithms
	 *
	 */
	
	module.service('rowSorter', ['$parse', 'uiGridConstants', function ($parse, uiGridConstants) {
	  var currencyRegexStr =
	    '(' +
	    uiGridConstants.CURRENCY_SYMBOLS
	      .map(function (a) { return '\\' + a; }) // Escape all the currency symbols ($ at least will jack up this regex)
	      .join('|') + // Join all the symbols together with |s
	    ')?';
	
	  // /^[-+]?[£$¤¥]?[\d,.]+%?$/
	  var numberStrRegex = new RegExp('^[-+]?' + currencyRegexStr + '[\\d,.]+' + currencyRegexStr + '%?$');
	
	  var rowSorter = {
	    // Cache of sorting functions. Once we create them, we don't want to keep re-doing it
	    //   this takes a piece of data from the cell and tries to determine its type and what sorting
	    //   function to use for it
	    colSortFnCache: {}
	  };
	
	
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:rowSorter
	   * @name guessSortFn
	   * @description Assigns a sort function to use based on the itemType in the column
	   * @param {string} itemType one of 'number', 'boolean', 'string', 'date', 'object'.  And
	   * error will be thrown for any other type.
	   * @returns {function} a sort function that will sort that type
	   */
	  rowSorter.guessSortFn = function guessSortFn(itemType) {
	    switch (itemType) {
	      case "number":
	        return rowSorter.sortNumber;
	      case "numberStr":
	        return rowSorter.sortNumberStr;
	      case "boolean":
	        return rowSorter.sortBool;
	      case "string":
	        return rowSorter.sortAlpha;
	      case "date":
	        return rowSorter.sortDate;
	      case "object":
	        return rowSorter.basicSort;
	      default:
	        throw new Error('No sorting function found for type:' + itemType);
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:rowSorter
	   * @name handleNulls
	   * @description Sorts nulls and undefined to the bottom (top when
	   * descending).  Called by each of the internal sorters before
	   * attempting to sort.  Note that this method is available on the core api
	   * via gridApi.core.sortHandleNulls
	   * @param {object} a sort value a
	   * @param {object} b sort value b
	   * @returns {number} null if there were no nulls/undefineds, otherwise returns
	   * a sort value that should be passed back from the sort function
	   */
	  rowSorter.handleNulls = function handleNulls(a, b) {
	    // We want to allow zero values and false values to be evaluated in the sort function
	    if ((!a && a !== 0 && a !== false) || (!b && b !== 0 && b !== false)) {
	      // We want to force nulls and such to the bottom when we sort... which effectively is "greater than"
	      if ((!a && a !== 0 && a !== false) && (!b && b !== 0 && b !== false)) {
	        return 0;
	      }
	      else if (!a && a !== 0 && a !== false) {
	        return 1;
	      }
	      else if (!b && b !== 0 && b !== false) {
	        return -1;
	      }
	    }
	    return null;
	  };
	
	
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:rowSorter
	   * @name basicSort
	   * @description Sorts any values that provide the < method, including strings
	   * or numbers.  Handles nulls and undefined through calling handleNulls
	   * @param {object} a sort value a
	   * @param {object} b sort value b
	   * @returns {number} normal sort function, returns -ve, 0, +ve
	   */
	  rowSorter.basicSort = function basicSort(a, b) {
	    var nulls = rowSorter.handleNulls(a, b);
	    if ( nulls !== null ){
	      return nulls;
	    } else {
	      if (a === b) {
	        return 0;
	      }
	      if (a < b) {
	        return -1;
	      }
	      return 1;
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:rowSorter
	   * @name sortNumber
	   * @description Sorts numerical values.  Handles nulls and undefined through calling handleNulls
	   * @param {object} a sort value a
	   * @param {object} b sort value b
	   * @returns {number} normal sort function, returns -ve, 0, +ve
	   */
	  rowSorter.sortNumber = function sortNumber(a, b) {
	    var nulls = rowSorter.handleNulls(a, b);
	    if ( nulls !== null ){
	      return nulls;
	    } else {
	      return a - b;
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:rowSorter
	   * @name sortNumberStr
	   * @description Sorts numerical values that are stored in a string (i.e. parses them to numbers first).
	   * Handles nulls and undefined through calling handleNulls
	   * @param {object} a sort value a
	   * @param {object} b sort value b
	   * @returns {number} normal sort function, returns -ve, 0, +ve
	   */
	  rowSorter.sortNumberStr = function sortNumberStr(a, b) {
	    var nulls = rowSorter.handleNulls(a, b);
	    if ( nulls !== null ){
	      return nulls;
	    } else {
	      var numA, // The parsed number form of 'a'
	          numB, // The parsed number form of 'b'
	          badA = false,
	          badB = false;
	
	      // Try to parse 'a' to a float
	      numA = parseFloat(a.replace(/[^0-9.-]/g, ''));
	
	      // If 'a' couldn't be parsed to float, flag it as bad
	      if (isNaN(numA)) {
	          badA = true;
	      }
	
	      // Try to parse 'b' to a float
	      numB = parseFloat(b.replace(/[^0-9.-]/g, ''));
	
	      // If 'b' couldn't be parsed to float, flag it as bad
	      if (isNaN(numB)) {
	          badB = true;
	      }
	
	      // We want bad ones to get pushed to the bottom... which effectively is "greater than"
	      if (badA && badB) {
	          return 0;
	      }
	
	      if (badA) {
	          return 1;
	      }
	
	      if (badB) {
	          return -1;
	      }
	
	      return numA - numB;
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:rowSorter
	   * @name sortAlpha
	   * @description Sorts string values. Handles nulls and undefined through calling handleNulls
	   * @param {object} a sort value a
	   * @param {object} b sort value b
	   * @returns {number} normal sort function, returns -ve, 0, +ve
	   */
	  rowSorter.sortAlpha = function sortAlpha(a, b) {
	    var nulls = rowSorter.handleNulls(a, b);
	    if ( nulls !== null ){
	      return nulls;
	    } else {
	      var strA = a.toString().toLowerCase(),
	          strB = b.toString().toLowerCase();
	
	      return strA === strB ? 0 : strA.localeCompare(strB);
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:rowSorter
	   * @name sortDate
	   * @description Sorts date values. Handles nulls and undefined through calling handleNulls.
	   * Handles date strings by converting to Date object if not already an instance of Date
	   * @param {object} a sort value a
	   * @param {object} b sort value b
	   * @returns {number} normal sort function, returns -ve, 0, +ve
	   */
	  rowSorter.sortDate = function sortDate(a, b) {
	    var nulls = rowSorter.handleNulls(a, b);
	    if ( nulls !== null ){
	      return nulls;
	    } else {
	      if (!(a instanceof Date)) {
	        a = new Date(a);
	      }
	      if (!(b instanceof Date)){
	        b = new Date(b);
	      }
	      var timeA = a.getTime(),
	          timeB = b.getTime();
	
	      return timeA === timeB ? 0 : (timeA < timeB ? -1 : 1);
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:rowSorter
	   * @name sortBool
	   * @description Sorts boolean values, true is considered larger than false.
	   * Handles nulls and undefined through calling handleNulls
	   * @param {object} a sort value a
	   * @param {object} b sort value b
	   * @returns {number} normal sort function, returns -ve, 0, +ve
	   */
	  rowSorter.sortBool = function sortBool(a, b) {
	    var nulls = rowSorter.handleNulls(a, b);
	    if ( nulls !== null ){
	      return nulls;
	    } else {
	      if (a && b) {
	        return 0;
	      }
	
	      if (!a && !b) {
	        return 0;
	      }
	      else {
	        return a ? 1 : -1;
	      }
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:rowSorter
	   * @name getSortFn
	   * @description Get the sort function for the column.  Looks first in
	   * rowSorter.colSortFnCache using the column name, failing that it
	   * looks at col.sortingAlgorithm (and puts it in the cache), failing that
	   * it guesses the sort algorithm based on the data type.
	   *
	   * The cache currently seems a bit pointless, as none of the work we do is
	   * processor intensive enough to need caching.  Presumably in future we might
	   * inspect the row data itself to guess the sort function, and in that case
	   * it would make sense to have a cache, the infrastructure is in place to allow
	   * that.
	   *
	   * @param {Grid} grid the grid to consider
	   * @param {GridColumn} col the column to find a function for
	   * @param {array} rows an array of grid rows.  Currently unused, but presumably in future
	   * we might inspect the rows themselves to decide what sort of data might be there
	   * @returns {function} the sort function chosen for the column
	   */
	  rowSorter.getSortFn = function getSortFn(grid, col, rows) {
	    var sortFn, item;
	
	    // See if we already figured out what to use to sort the column and have it in the cache
	    if (rowSorter.colSortFnCache[col.colDef.name]) {
	      sortFn = rowSorter.colSortFnCache[col.colDef.name];
	    }
	    // If the column has its OWN sorting algorithm, use that
	    else if (col.sortingAlgorithm !== undefined) {
	      sortFn = col.sortingAlgorithm;
	      rowSorter.colSortFnCache[col.colDef.name] = col.sortingAlgorithm;
	    }
	    // Always default to sortAlpha when sorting after a cellFilter
	    else if ( col.sortCellFiltered && col.cellFilter ){
	      sortFn = rowSorter.sortAlpha;
	      rowSorter.colSortFnCache[col.colDef.name] = sortFn;
	    }
	    // Try and guess what sort function to use
	    else {
	      // Guess the sort function
	      sortFn = rowSorter.guessSortFn(col.colDef.type);
	
	      // If we found a sort function, cache it
	      if (sortFn) {
	        rowSorter.colSortFnCache[col.colDef.name] = sortFn;
	      }
	      else {
	        // We assign the alpha sort because anything that is null/undefined will never get passed to
	        // the actual sorting function. It will get caught in our null check and returned to be sorted
	        // down to the bottom
	        sortFn = rowSorter.sortAlpha;
	      }
	    }
	
	    return sortFn;
	  };
	
	
	
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:rowSorter
	   * @name prioritySort
	   * @description Used where multiple columns are present in the sort criteria,
	   * we determine which column should take precedence in the sort by sorting
	   * the columns based on their sort.priority
	   *
	   * @param {gridColumn} a column a
	   * @param {gridColumn} b column b
	   * @returns {number} normal sort function, returns -ve, 0, +ve
	   */
	  rowSorter.prioritySort = function (a, b) {
	    // Both columns have a sort priority
	    if (a.sort.priority !== undefined && b.sort.priority !== undefined) {
	      // A is higher priority
	      if (a.sort.priority < b.sort.priority) {
	        return -1;
	      }
	      // Equal
	      else if (a.sort.priority === b.sort.priority) {
	        return 0;
	      }
	      // B is higher
	      else {
	        return 1;
	      }
	    }
	    // Only A has a priority
	    else if (a.sort.priority !== undefined) {
	      return -1;
	    }
	    // Only B has a priority
	    else if (b.sort.priority !== undefined) {
	      return 1;
	    }
	    // Neither has a priority
	    else {
	      return 0;
	    }
	  };
	
	
	  /**
	   * @ngdoc object
	   * @name useExternalSorting
	   * @propertyOf ui.grid.class:GridOptions
	   * @description Prevents the internal sorting from executing.  Events will
	   * still be fired when the sort changes, and the sort information on
	   * the columns will be updated, allowing an external sorter (for example,
	   * server sorting) to be implemented.  Defaults to false.
	   *
	   */
	  /**
	   * @ngdoc method
	   * @methodOf ui.grid.class:rowSorter
	   * @name sort
	   * @description sorts the grid
	   * @param {Object} grid the grid itself
	   * @param {array} rows the rows to be sorted
	   * @param {array} columns the columns in which to look
	   * for sort criteria
	   * @returns {array} sorted rows
	   */
	  rowSorter.sort = function rowSorterSort(grid, rows, columns) {
	    // first make sure we are even supposed to do work
	    if (!rows) {
	      return;
	    }
	
	    if (grid.options.useExternalSorting){
	      return rows;
	    }
	
	    // Build the list of columns to sort by
	    var sortCols = [];
	    var defaultSortCols = [];
	    columns.forEach(function (col) {
	      if (col.sort && !col.sort.ignoreSort && col.sort.direction && (col.sort.direction === uiGridConstants.ASC || col.sort.direction === uiGridConstants.DESC)) {
	        sortCols.push({
	          col: col,
	          sort: col.sort
	        });
	      } else if ( col.defaultSort && col.defaultSort.direction && (col.defaultSort.direction === uiGridConstants.ASC || col.defaultSort.direction === uiGridConstants.DESC) ) {
	        defaultSortCols.push({
	          col: col,
	          sort: col.defaultSort
	        });
	      }
	    });
	
	    // Sort the "sort columns" by their sort priority
	    sortCols = sortCols.sort(rowSorter.prioritySort);
	    defaultSortCols = defaultSortCols.sort(rowSorter.prioritySort);
	    sortCols = sortCols.concat(defaultSortCols);
	
	    // Now rows to sort by, maintain original order
	    if (sortCols.length === 0) {
	      return rows;
	    }
	
	    // Re-usable variables
	    var col, direction;
	
	    // put a custom index field on each row, used to make a stable sort out of unstable sorts (e.g. Chrome)
	    var setIndex = function( row, idx ){
	      row.entity.$$uiGridIndex = idx;
	    };
	    rows.forEach(setIndex);
	
	    // IE9-11 HACK.... the 'rows' variable would be empty where we call rowSorter.getSortFn(...) below. We have to use a separate reference
	    // var d = data.slice(0);
	    var r = rows.slice(0);
	
	    // Now actually sort the data
	    var rowSortFn = function (rowA, rowB) {
	      var tem = 0,
	          idx = 0,
	          sortFn;
	
	      while (tem === 0 && idx < sortCols.length) {
	        // grab the metadata for the rest of the logic
	        col = sortCols[idx].col;
	        direction = sortCols[idx].sort.direction;
	
	        sortFn = rowSorter.getSortFn(grid, col, r);
	
	        var propA, propB;
	
	        if ( col.sortCellFiltered ){
	          propA = grid.getCellDisplayValue(rowA, col);
	          propB = grid.getCellDisplayValue(rowB, col);
	        } else {
	          propA = grid.getCellValue(rowA, col);
	          propB = grid.getCellValue(rowB, col);
	        }
	
	        tem = sortFn(propA, propB, rowA, rowB, direction, col);
	
	        idx++;
	      }
	
	      // Chrome doesn't implement a stable sort function.  If our sort returns 0
	      // (i.e. the items are equal), and we're at the last sort column in the list,
	      // then return the previous order using our custom
	      // index variable
	      if (tem === 0 ) {
	        return rowA.entity.$$uiGridIndex - rowB.entity.$$uiGridIndex;
	      }
	
	      // Made it this far, we don't have to worry about null & undefined
	      if (direction === uiGridConstants.ASC) {
	        return tem;
	      } else {
	        return 0 - tem;
	      }
	    };
	
	    var newRows = rows.sort(rowSortFn);
	
	    // remove the custom index field on each row, used to make a stable sort out of unstable sorts (e.g. Chrome)
	    var clearIndex = function( row, idx ){
	       delete row.entity.$$uiGridIndex;
	    };
	    rows.forEach(clearIndex);
	
	    return newRows;
	  };
	
	  return rowSorter;
	}]);
	
	})();
	
	(function() {
	
	var module = angular.module('ui.grid');
	
	var bindPolyfill;
	if (typeof Function.prototype.bind !== "function") {
	  bindPolyfill = function() {
	    var slice = Array.prototype.slice;
	    return function(context) {
	      var fn = this,
	        args = slice.call(arguments, 1);
	      if (args.length) {
	        return function() {
	          return arguments.length ? fn.apply(context, args.concat(slice.call(arguments))) : fn.apply(context, args);
	        };
	      }
	      return function() {
	        return arguments.length ? fn.apply(context, arguments) : fn.call(context);
	      };
	    };
	  };
	}
	
	function  getStyles (elem) {
	  var e = elem;
	  if (typeof(e.length) !== 'undefined' && e.length) {
	    e = elem[0];
	  }
	
	  return e.ownerDocument.defaultView.getComputedStyle(e, null);
	}
	
	var rnumnonpx = new RegExp( "^(" + (/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/).source + ")(?!px)[a-z%]+$", "i" ),
	    // swappable if display is none or starts with table except "table", "table-cell", or "table-caption"
	    // see here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	    rdisplayswap = /^(block|none|table(?!-c[ea]).+)/,
	    cssShow = { position: "absolute", visibility: "hidden", display: "block" };
	
	function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
	  var i = extra === ( isBorderBox ? 'border' : 'content' ) ?
	          // If we already have the right measurement, avoid augmentation
	          4 :
	          // Otherwise initialize for horizontal or vertical properties
	          name === 'width' ? 1 : 0,
	
	          val = 0;
	
	  var sides = ['Top', 'Right', 'Bottom', 'Left'];
	
	  for ( ; i < 4; i += 2 ) {
	    var side = sides[i];
	    // dump('side', side);
	
	    // both box models exclude margin, so add it if we want it
	    if ( extra === 'margin' ) {
	      var marg = parseFloat(styles[extra + side]);
	      if (!isNaN(marg)) {
	        val += marg;
	      }
	    }
	    // dump('val1', val);
	
	    if ( isBorderBox ) {
	      // border-box includes padding, so remove it if we want content
	      if ( extra === 'content' ) {
	        var padd = parseFloat(styles['padding' + side]);
	        if (!isNaN(padd)) {
	          val -= padd;
	          // dump('val2', val);
	        }
	      }
	
	      // at this point, extra isn't border nor margin, so remove border
	      if ( extra !== 'margin' ) {
	        var bordermarg = parseFloat(styles['border' + side + 'Width']);
	        if (!isNaN(bordermarg)) {
	          val -= bordermarg;
	          // dump('val3', val);
	        }
	      }
	    }
	    else {
	      // at this point, extra isn't content, so add padding
	      var nocontentPad = parseFloat(styles['padding' + side]);
	      if (!isNaN(nocontentPad)) {
	        val += nocontentPad;
	        // dump('val4', val);
	      }
	
	      // at this point, extra isn't content nor padding, so add border
	      if ( extra !== 'padding') {
	        var nocontentnopad = parseFloat(styles['border' + side + 'Width']);
	        if (!isNaN(nocontentnopad)) {
	          val += nocontentnopad;
	          // dump('val5', val);
	        }
	      }
	    }
	  }
	
	  // dump('augVal', val);
	
	  return val;
	}
	
	function getWidthOrHeight( elem, name, extra ) {
	  // Start with offset property, which is equivalent to the border-box value
	  var valueIsBorderBox = true,
	          val, // = name === 'width' ? elem.offsetWidth : elem.offsetHeight,
	          styles = getStyles(elem),
	          isBorderBox = styles['boxSizing'] === 'border-box';
	
	  // some non-html elements return undefined for offsetWidth, so check for null/undefined
	  // svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
	  // MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
	  if ( val <= 0 || val == null ) {
	    // Fall back to computed then uncomputed css if necessary
	    val = styles[name];
	    if ( val < 0 || val == null ) {
	      val = elem.style[ name ];
	    }
	
	    // Computed unit is not pixels. Stop here and return.
	    if ( rnumnonpx.test(val) ) {
	      return val;
	    }
	
	    // we need the check for style in case a browser which returns unreliable values
	    // for getComputedStyle silently falls back to the reliable elem.style
	    valueIsBorderBox = isBorderBox &&
	            ( true || val === elem.style[ name ] ); // use 'true' instead of 'support.boxSizingReliable()'
	
	    // Normalize "", auto, and prepare for extra
	    val = parseFloat( val ) || 0;
	  }
	
	  // use the active box-sizing model to add/subtract irrelevant styles
	  var ret = ( val +
	    augmentWidthOrHeight(
	      elem,
	      name,
	      extra || ( isBorderBox ? "border" : "content" ),
	      valueIsBorderBox,
	      styles
	    )
	  );
	
	  // dump('ret', ret, val);
	  return ret;
	}
	
	function getLineHeight(elm) {
	  elm = angular.element(elm)[0];
	  var parent = elm.parentElement;
	
	  if (!parent) {
	    parent = document.getElementsByTagName('body')[0];
	  }
	
	  return parseInt( getStyles(parent).fontSize ) || parseInt( getStyles(elm).fontSize ) || 16;
	}
	
	var uid = ['0', '0', '0', '0'];
	var uidPrefix = 'uiGrid-';
	
	/**
	 *  @ngdoc service
	 *  @name ui.grid.service:GridUtil
	 *
	 *  @description Grid utility functions
	 */
	module.service('gridUtil', ['$log', '$window', '$document', '$http', '$templateCache', '$timeout', '$interval', '$injector', '$q', '$interpolate', 'uiGridConstants',
	  function ($log, $window, $document, $http, $templateCache, $timeout, $interval, $injector, $q, $interpolate, uiGridConstants) {
	  var s = {
	
	    augmentWidthOrHeight: augmentWidthOrHeight,
	
	    getStyles: getStyles,
	
	    /**
	     * @ngdoc method
	     * @name createBoundedWrapper
	     * @methodOf ui.grid.service:GridUtil
	     *
	     * @param {object} Object to bind 'this' to
	     * @param {method} Method to bind
	     * @returns {Function} The wrapper that performs the binding
	     *
	     * @description
	     * Binds given method to given object.
	     *
	     * By means of a wrapper, ensures that ``method`` is always bound to
	     * ``object`` regardless of its calling environment.
	     * Iow, inside ``method``, ``this`` always points to ``object``.
	     *
	     * See http://alistapart.com/article/getoutbindingsituations
	     *
	     */
	    createBoundedWrapper: function(object, method) {
	        return function() {
	            return method.apply(object, arguments);
	        };
	    },
	
	
	    /**
	     * @ngdoc method
	     * @name readableColumnName
	     * @methodOf ui.grid.service:GridUtil
	     *
	     * @param {string} columnName Column name as a string
	     * @returns {string} Column name appropriately capitalized and split apart
	     *
	       @example
	       <example module="app">
	        <file name="app.js">
	          var app = angular.module('app', ['ui.grid']);
	
	          app.controller('MainCtrl', ['$scope', 'gridUtil', function ($scope, gridUtil) {
	            $scope.name = 'firstName';
	            $scope.columnName = function(name) {
	              return gridUtil.readableColumnName(name);
	            };
	          }]);
	        </file>
	        <file name="index.html">
	          <div ng-controller="MainCtrl">
	            <strong>Column name:</strong> <input ng-model="name" />
	            <br>
	            <strong>Output:</strong> <span ng-bind="columnName(name)"></span>
	          </div>
	        </file>
	      </example>
	     */
	    readableColumnName: function (columnName) {
	      // Convert underscores to spaces
	      if (typeof(columnName) === 'undefined' || columnName === undefined || columnName === null) { return columnName; }
	
	      if (typeof(columnName) !== 'string') {
	        columnName = String(columnName);
	      }
	
	      return columnName.replace(/_+/g, ' ')
	        // Replace a completely all-capsed word with a first-letter-capitalized version
	        .replace(/^[A-Z]+$/, function (match) {
	          return angular.lowercase(angular.uppercase(match.charAt(0)) + match.slice(1));
	        })
	        // Capitalize the first letter of words
	        .replace(/([\w\u00C0-\u017F]+)/g, function (match) {
	          return angular.uppercase(match.charAt(0)) + match.slice(1);
	        })
	        // Put a space in between words that have partial capilizations (i.e. 'firstName' becomes 'First Name')
	        // .replace(/([A-Z]|[A-Z]\w+)([A-Z])/g, "$1 $2");
	        // .replace(/(\w+?|\w)([A-Z])/g, "$1 $2");
	        .replace(/(\w+?(?=[A-Z]))/g, '$1 ');
	    },
	
	    /**
	     * @ngdoc method
	     * @name getColumnsFromData
	     * @methodOf ui.grid.service:GridUtil
	     * @description Return a list of column names, given a data set
	     *
	     * @param {string} data Data array for grid
	     * @returns {Object} Column definitions with field accessor and column name
	     *
	     * @example
	       <pre>
	         var data = [
	           { firstName: 'Bob', lastName: 'Jones' },
	           { firstName: 'Frank', lastName: 'Smith' }
	         ];
	
	         var columnDefs = GridUtil.getColumnsFromData(data, excludeProperties);
	
	         columnDefs == [
	          {
	            field: 'firstName',
	            name: 'First Name'
	          },
	          {
	            field: 'lastName',
	            name: 'Last Name'
	          }
	         ];
	       </pre>
	     */
	    getColumnsFromData: function (data, excludeProperties) {
	      var columnDefs = [];
	
	      if (!data || typeof(data[0]) === 'undefined' || data[0] === undefined) { return []; }
	      if (angular.isUndefined(excludeProperties)) { excludeProperties = []; }
	
	      var item = data[0];
	
	      angular.forEach(item,function (prop, propName) {
	        if ( excludeProperties.indexOf(propName) === -1){
	          columnDefs.push({
	            name: propName
	          });
	        }
	      });
	
	      return columnDefs;
	    },
	
	    /**
	     * @ngdoc method
	     * @name newId
	     * @methodOf ui.grid.service:GridUtil
	     * @description Return a unique ID string
	     *
	     * @returns {string} Unique string
	     *
	     * @example
	       <pre>
	        var id = GridUtil.newId();
	
	        # 1387305700482;
	       </pre>
	     */
	    newId: (function() {
	      var seedId = new Date().getTime();
	      return function() {
	          return seedId += 1;
	      };
	    })(),
	
	
	    /**
	     * @ngdoc method
	     * @name getTemplate
	     * @methodOf ui.grid.service:GridUtil
	     * @description Get's template from cache / element / url
	     *
	     * @param {string|element|promise} Either a string representing the template id, a string representing the template url,
	     *   an jQuery/Angualr element, or a promise that returns the template contents to use.
	     * @returns {object} a promise resolving to template contents
	     *
	     * @example
	     <pre>
	     GridUtil.getTemplate(url).then(function (contents) {
	          alert(contents);
	        })
	     </pre>
	     */
	    getTemplate: function (template) {
	      // Try to fetch the template out of the templateCache
	      if ($templateCache.get(template)) {
	        return s.postProcessTemplate($templateCache.get(template));
	      }
	
	      // See if the template is itself a promise
	      if (angular.isFunction(template.then)) {
	        return template.then(s.postProcessTemplate).catch(angular.noop);
	      }
	
	      // If the template is an element, return the element
	      try {
	        if (angular.element(template).length > 0) {
	          return $q.when(template).then(s.postProcessTemplate).catch(angular.noop);
	        }
	      }
	      catch (err){
	        //do nothing; not valid html
	      }
	
	      // s.logDebug('fetching url', template);
	
	      // Default to trying to fetch the template as a url with $http
	      return $http({ method: 'GET', url: template})
	        .then(
	          function (result) {
	            var templateHtml = result.data.trim();
	            //put in templateCache for next call
	            $templateCache.put(template, templateHtml);
	            return templateHtml;
	          },
	          function (err) {
	            throw new Error("Could not get template " + template + ": " + err);
	          }
	        )
	        .then(s.postProcessTemplate).catch(angular.noop);
	    },
	
	    //
	    postProcessTemplate: function (template) {
	      var startSym = $interpolate.startSymbol(),
	          endSym = $interpolate.endSymbol();
	
	      // If either of the interpolation symbols have been changed, we need to alter this template
	      if (startSym !== '{{' || endSym !== '}}') {
	        template = template.replace(/\{\{/g, startSym);
	        template = template.replace(/\}\}/g, endSym);
	      }
	
	      return $q.when(template);
	    },
	
	    /**
	     * @ngdoc method
	     * @name guessType
	     * @methodOf ui.grid.service:GridUtil
	     * @description guesses the type of an argument
	     *
	     * @param {string/number/bool/object} item variable to examine
	     * @returns {string} one of the following
	     * - 'string'
	     * - 'boolean'
	     * - 'number'
	     * - 'date'
	     * - 'object'
	     */
	    guessType : function (item) {
	      var itemType = typeof(item);
	
	      // Check for numbers and booleans
	      switch (itemType) {
	        case "number":
	        case "boolean":
	        case "string":
	          return itemType;
	        default:
	          if (angular.isDate(item)) {
	            return "date";
	          }
	          return "object";
	      }
	    },
	
	
	  /**
	    * @ngdoc method
	    * @name elementWidth
	    * @methodOf ui.grid.service:GridUtil
	    *
	    * @param {element} element DOM element
	    * @param {string} [extra] Optional modifier for calculation. Use 'margin' to account for margins on element
	    *
	    * @returns {number} Element width in pixels, accounting for any borders, etc.
	    */
	    elementWidth: function (elem) {
	
	    },
	
	    /**
	    * @ngdoc method
	    * @name elementHeight
	    * @methodOf ui.grid.service:GridUtil
	    *
	    * @param {element} element DOM element
	    * @param {string} [extra] Optional modifier for calculation. Use 'margin' to account for margins on element
	    *
	    * @returns {number} Element height in pixels, accounting for any borders, etc.
	    */
	    elementHeight: function (elem) {
	
	    },
	
	    // Thanks to http://stackoverflow.com/a/13382873/888165
	    getScrollbarWidth: function() {
	        var outer = document.createElement("div");
	        outer.style.visibility = "hidden";
	        outer.style.width = "100px";
	        outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps
	
	        document.body.appendChild(outer);
	
	        var widthNoScroll = outer.offsetWidth;
	        // force scrollbars
	        outer.style.overflow = "scroll";
	
	        // add innerdiv
	        var inner = document.createElement("div");
	        inner.style.width = "100%";
	        outer.appendChild(inner);
	
	        var widthWithScroll = inner.offsetWidth;
	
	        // remove divs
	        outer.parentNode.removeChild(outer);
	
	        return widthNoScroll - widthWithScroll;
	    },
	
	    swap: function( elem, options, callback, args ) {
	      var ret, name,
	              old = {};
	
	      // Remember the old values, and insert the new ones
	      for ( name in options ) {
	        old[ name ] = elem.style[ name ];
	        elem.style[ name ] = options[ name ];
	      }
	
	      ret = callback.apply( elem, args || [] );
	
	      // Revert the old values
	      for ( name in options ) {
	        elem.style[ name ] = old[ name ];
	      }
	
	      return ret;
	    },
	
	    fakeElement: function( elem, options, callback, args ) {
	      var ret, name,
	          newElement = angular.element(elem).clone()[0];
	
	      for ( name in options ) {
	        newElement.style[ name ] = options[ name ];
	      }
	
	      angular.element(document.body).append(newElement);
	
	      ret = callback.call( newElement, newElement );
	
	      angular.element(newElement).remove();
	
	      return ret;
	    },
	
	    /**
	    * @ngdoc method
	    * @name normalizeWheelEvent
	    * @methodOf ui.grid.service:GridUtil
	    *
	    * @param {event} event A mouse wheel event
	    *
	    * @returns {event} A normalized event
	    *
	    * @description
	    * Given an event from this list:
	    *
	    * `wheel, mousewheel, DomMouseScroll, MozMousePixelScroll`
	    *
	    * "normalize" it
	    * so that it stays consistent no matter what browser it comes from (i.e. scale it correctly and make sure the direction is right.)
	    */
	    normalizeWheelEvent: function (event) {
	      // var toFix = ['wheel', 'mousewheel', 'DOMMouseScroll', 'MozMousePixelScroll'];
	      // var toBind = 'onwheel' in document || document.documentMode >= 9 ? ['wheel'] : ['mousewheel', 'DomMouseScroll', 'MozMousePixelScroll'];
	      var lowestDelta, lowestDeltaXY;
	
	      var orgEvent   = event || window.event,
	          args       = [].slice.call(arguments, 1),
	          delta      = 0,
	          deltaX     = 0,
	          deltaY     = 0,
	          absDelta   = 0,
	          absDeltaXY = 0,
	          fn;
	
	      // event = $.event.fix(orgEvent);
	      // event.type = 'mousewheel';
	
	      // NOTE: jQuery masks the event and stores it in the event as originalEvent
	      if (orgEvent.originalEvent) {
	        orgEvent = orgEvent.originalEvent;
	      }
	
	      // Old school scrollwheel delta
	      if ( orgEvent.wheelDelta ) { delta = orgEvent.wheelDelta; }
	      if ( orgEvent.detail )     { delta = orgEvent.detail * -1; }
	
	      // At a minimum, setup the deltaY to be delta
	      deltaY = delta;
	
	      // Firefox < 17 related to DOMMouseScroll event
	      if ( orgEvent.axis !== undefined && orgEvent.axis === orgEvent.HORIZONTAL_AXIS ) {
	          deltaY = 0;
	          deltaX = delta * -1;
	      }
	
	      // New school wheel delta (wheel event)
	      if ( orgEvent.deltaY ) {
	          deltaY = orgEvent.deltaY * -1;
	          delta  = deltaY;
	      }
	      if ( orgEvent.deltaX ) {
	          deltaX = orgEvent.deltaX;
	          delta  = deltaX * -1;
	      }
	
	      // Webkit
	      if ( orgEvent.wheelDeltaY !== undefined ) { deltaY = orgEvent.wheelDeltaY; }
	      if ( orgEvent.wheelDeltaX !== undefined ) { deltaX = orgEvent.wheelDeltaX; }
	
	      // Look for lowest delta to normalize the delta values
	      absDelta = Math.abs(delta);
	      if ( !lowestDelta || absDelta < lowestDelta ) { lowestDelta = absDelta; }
	      absDeltaXY = Math.max(Math.abs(deltaY), Math.abs(deltaX));
	      if ( !lowestDeltaXY || absDeltaXY < lowestDeltaXY ) { lowestDeltaXY = absDeltaXY; }
	
	      // Get a whole value for the deltas
	      fn     = delta > 0 ? 'floor' : 'ceil';
	      delta  = Math[fn](delta  / lowestDelta);
	      deltaX = Math[fn](deltaX / lowestDeltaXY);
	      deltaY = Math[fn](deltaY / lowestDeltaXY);
	
	      return {
	        delta: delta,
	        deltaX: deltaX,
	        deltaY: deltaY
	      };
	    },
	
	    // Stolen from Modernizr
	    // TODO: make this, and everythign that flows from it, robust
	    //http://www.stucox.com/blog/you-cant-detect-a-touchscreen/
	    isTouchEnabled: function() {
	      var bool;
	
	      if (('ontouchstart' in $window) || $window.DocumentTouch && $document instanceof DocumentTouch) {
	        bool = true;
	      }
	
	      return bool;
	    },
	
	    isNullOrUndefined: function(obj) {
	      return (obj === undefined || obj === null);
	    },
	
	    endsWith: function(str, suffix) {
	      if (!str || !suffix || typeof str !== "string") {
	        return false;
	      }
	      return str.indexOf(suffix, str.length - suffix.length) !== -1;
	    },
	
	    arrayContainsObjectWithProperty: function(array, propertyName, propertyValue) {
	        var found = false;
	        angular.forEach(array, function (object) {
	            if (object[propertyName] === propertyValue) {
	                found = true;
	            }
	        });
	        return found;
	    },
	
	    //// Shim requestAnimationFrame
	    //requestAnimationFrame: $window.requestAnimationFrame && $window.requestAnimationFrame.bind($window) ||
	    //                       $window.webkitRequestAnimationFrame && $window.webkitRequestAnimationFrame.bind($window) ||
	    //                       function(fn) {
	    //                         return $timeout(fn, 10, false);
	    //                       },
	
	    numericAndNullSort: function (a, b) {
	      if (a === null) { return 1; }
	      if (b === null) { return -1; }
	      if (a === null && b === null) { return 0; }
	      return a - b;
	    },
	
	    // Disable ngAnimate animations on an element
	    disableAnimations: function (element) {
	      var $animate;
	      try {
	        $animate = $injector.get('$animate');
	        // See: http://brianhann.com/angular-1-4-breaking-changes-to-be-aware-of/#animate
	        if (angular.version.major > 1 || (angular.version.major === 1 && angular.version.minor >= 4)) {
	          $animate.enabled(element, false);
	        } else {
	          $animate.enabled(false, element);
	        }
	      }
	      catch (e) {}
	    },
	
	    enableAnimations: function (element) {
	      var $animate;
	      try {
	        $animate = $injector.get('$animate');
	        // See: http://brianhann.com/angular-1-4-breaking-changes-to-be-aware-of/#animate
	        if (angular.version.major > 1 || (angular.version.major === 1 && angular.version.minor >= 4)) {
	          $animate.enabled(element, true);
	        } else {
	          $animate.enabled(true, element);
	        }
	        return $animate;
	      }
	      catch (e) {}
	    },
	
	    // Blatantly stolen from Angular as it isn't exposed (yet)
	    nextUid: function nextUid() {
	      var index = uid.length;
	      var digit;
	
	      while (index) {
	        index--;
	        digit = uid[index].charCodeAt(0);
	        if (digit === 57 /*'9'*/) {
	          uid[index] = 'A';
	          return uidPrefix + uid.join('');
	        }
	        if (digit === 90  /*'Z'*/) {
	          uid[index] = '0';
	        } else {
	          uid[index] = String.fromCharCode(digit + 1);
	          return uidPrefix + uid.join('');
	        }
	      }
	      uid.unshift('0');
	
	      return uidPrefix + uid.join('');
	    },
	
	    // Blatantly stolen from Angular as it isn't exposed (yet)
	    hashKey: function hashKey(obj) {
	      var objType = typeof obj,
	          key;
	
	      if (objType === 'object' && obj !== null) {
	        if (typeof (key = obj.$$hashKey) === 'function') {
	          // must invoke on object to keep the right this
	          key = obj.$$hashKey();
	        }
	        else if (typeof(obj.$$hashKey) !== 'undefined' && obj.$$hashKey) {
	          key = obj.$$hashKey;
	        }
	        else if (key === undefined) {
	          key = obj.$$hashKey = s.nextUid();
	        }
	      }
	      else {
	        key = obj;
	      }
	
	      return objType + ':' + key;
	    },
	
	    resetUids: function () {
	      uid = ['0', '0', '0'];
	    },
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:GridUtil
	     * @name logError
	     * @description wraps the $log method, allowing us to choose different
	     * treatment within ui-grid if we so desired.  At present we only log
	     * error messages if uiGridConstants.LOG_ERROR_MESSAGES is set to true
	     * @param {string} logMessage message to be logged to the console
	     *
	     */
	    logError: function( logMessage ){
	      if ( uiGridConstants.LOG_ERROR_MESSAGES ){
	        $log.error( logMessage );
	      }
	    },
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:GridUtil
	     * @name logWarn
	     * @description wraps the $log method, allowing us to choose different
	     * treatment within ui-grid if we so desired.  At present we only log
	     * warning messages if uiGridConstants.LOG_WARN_MESSAGES is set to true
	     * @param {string} logMessage message to be logged to the console
	     *
	     */
	    logWarn: function( logMessage ){
	      if ( uiGridConstants.LOG_WARN_MESSAGES ){
	        $log.warn( logMessage );
	      }
	    },
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:GridUtil
	     * @name logDebug
	     * @description wraps the $log method, allowing us to choose different
	     * treatment within ui-grid if we so desired.  At present we only log
	     * debug messages if uiGridConstants.LOG_DEBUG_MESSAGES is set to true
	     *
	     */
	    logDebug: function() {
	      if ( uiGridConstants.LOG_DEBUG_MESSAGES ){
	        $log.debug.apply($log, arguments);
	      }
	    }
	
	  };
	
	  /**
	   * @ngdoc object
	   * @name focus
	   * @propertyOf ui.grid.service:GridUtil
	   * @description Provies a set of methods to set the document focus inside the grid.
	   * See {@link ui.grid.service:GridUtil.focus} for more information.
	   */
	
	  /**
	   * @ngdoc object
	   * @name ui.grid.service:GridUtil.focus
	   * @description Provies a set of methods to set the document focus inside the grid.
	   * Timeouts are utilized to ensure that the focus is invoked after any other event has been triggered.
	   * e.g. click events that need to run before the focus or
	   * inputs elements that are in a disabled state but are enabled when those events
	   * are triggered.
	   */
	  s.focus = {
	    queue: [],
	    //http://stackoverflow.com/questions/25596399/set-element-focus-in-angular-way
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:GridUtil.focus
	     * @name byId
	     * @description Sets the focus of the document to the given id value.
	     * If provided with the grid object it will automatically append the grid id.
	     * This is done to encourage unique dom id's as it allows for multiple grids on a
	     * page.
	     * @param {String} id the id of the dom element to set the focus on
	     * @param {Object=} Grid the grid object for this grid instance. See: {@link ui.grid.class:Grid}
	     * @param {Number} Grid.id the unique id for this grid. Already set on an initialized grid object.
	     * @returns {Promise} The `$timeout` promise that will be resolved once focus is set. If another focus is requested before this request is evaluated.
	     * then the promise will fail with the `'canceled'` reason.
	     */
	    byId: function (id, Grid) {
	      this._purgeQueue();
	      var promise = $timeout(function() {
	        var elementID = (Grid && Grid.id ? Grid.id + '-' : '') + id;
	        var element = $window.document.getElementById(elementID);
	        if (element) {
	          element.focus();
	        } else {
	          s.logWarn('[focus.byId] Element id ' + elementID + ' was not found.');
	        }
	      }, 0, false);
	      this.queue.push(promise);
	      return promise;
	    },
	
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:GridUtil.focus
	     * @name byElement
	     * @description Sets the focus of the document to the given dom element.
	     * @param {(element|angular.element)} element the DOM element to set the focus on
	     * @returns {Promise} The `$timeout` promise that will be resolved once focus is set. If another focus is requested before this request is evaluated.
	     * then the promise will fail with the `'canceled'` reason.
	     */
	    byElement: function(element){
	      if (!angular.isElement(element)){
	        s.logWarn("Trying to focus on an element that isn\'t an element.");
	        return $q.reject('not-element');
	      }
	      element = angular.element(element);
	      this._purgeQueue();
	      var promise = $timeout(function(){
	        if (element){
	          element[0].focus();
	        }
	      }, 0, false);
	      this.queue.push(promise);
	      return promise;
	    },
	    /**
	     * @ngdoc method
	     * @methodOf ui.grid.service:GridUtil.focus
	     * @name bySelector
	     * @description Sets the focus of the document to the given dom element.
	     * @param {(element|angular.element)} parentElement the parent/ancestor of the dom element that you are selecting using the query selector
	     * @param {String} querySelector finds the dom element using the {@link http://www.w3schools.com/jsref/met_document_queryselector.asp querySelector}
	     * @param {boolean} [aSync=false] If true then the selector will be querried inside of a timeout. Otherwise the selector will be querried imidately
	     * then the focus will be called.
	     * @returns {Promise} The `$timeout` promise that will be resolved once focus is set. If another focus is requested before this request is evaluated.
	     * then the promise will fail with the `'canceled'` reason.
	     */
	    bySelector: function(parentElement, querySelector, aSync){
	      var self = this;
	      if (!angular.isElement(parentElement)){
	        throw new Error("The parent element is not an element.");
	      }
	      // Ensure that this is an angular element.
	      // It is fine if this is already an angular element.
	      parentElement = angular.element(parentElement);
	      var focusBySelector = function(){
	        var element = parentElement[0].querySelector(querySelector);
	        return self.byElement(element);
	      };
	      this._purgeQueue();
	      if (aSync){ //Do this asynchronysly
	        var promise = $timeout(focusBySelector, 0, false);
	        this.queue.push(promise);
	        return promise;
	      } else {
	        return focusBySelector();
	      }
	    },
	    _purgeQueue: function(){
	      this.queue.forEach(function(element){
	        $timeout.cancel(element);
	      });
	      this.queue = [];
	    }
	  };
	
	
	  ['width', 'height'].forEach(function (name) {
	    var capsName = angular.uppercase(name.charAt(0)) + name.substr(1);
	    s['element' + capsName] = function (elem, extra) {
	      var e = elem;
	      if (e && typeof(e.length) !== 'undefined' && e.length) {
	        e = elem[0];
	      }
	
	      if (e && e !== null) {
	        var styles = getStyles(e);
	        return e.offsetWidth === 0 && rdisplayswap.test(styles.display) ?
	                  s.swap(e, cssShow, function() {
	                    return getWidthOrHeight(e, name, extra );
	                  }) :
	                  getWidthOrHeight( e, name, extra );
	      }
	      else {
	        return null;
	      }
	    };
	
	    s['outerElement' + capsName] = function (elem, margin) {
	      return elem ? s['element' + capsName].call(this, elem, margin ? 'margin' : 'border') : null;
	    };
	  });
	
	  // http://stackoverflow.com/a/24107550/888165
	  s.closestElm = function closestElm(el, selector) {
	    if (typeof(el.length) !== 'undefined' && el.length) {
	      el = el[0];
	    }
	
	    var matchesFn;
	
	    // find vendor prefix
	    ['matches','webkitMatchesSelector','mozMatchesSelector','msMatchesSelector','oMatchesSelector'].some(function(fn) {
	        if (typeof document.body[fn] === 'function') {
	            matchesFn = fn;
	            return true;
	        }
	        return false;
	    });
	
	    // traverse parents
	    var parent;
	    while (el !== null) {
	      parent = el.parentElement;
	      if (parent !== null && parent[matchesFn](selector)) {
	          return parent;
	      }
	      el = parent;
	    }
	
	    return null;
	  };
	
	  s.type = function (obj) {
	    var text = Function.prototype.toString.call(obj.constructor);
	    return text.match(/function (.*?)\(/)[1];
	  };
	
	  s.getBorderSize = function getBorderSize(elem, borderType) {
	    if (typeof(elem.length) !== 'undefined' && elem.length) {
	      elem = elem[0];
	    }
	
	    var styles = getStyles(elem);
	
	    // If a specific border is supplied, like 'top', read the 'borderTop' style property
	    if (borderType) {
	      borderType = 'border' + borderType.charAt(0).toUpperCase() + borderType.slice(1);
	    }
	    else {
	      borderType = 'border';
	    }
	
	    borderType += 'Width';
	
	    var val = parseInt(styles[borderType], 10);
	
	    if (isNaN(val)) {
	      return 0;
	    }
	    else {
	      return val;
	    }
	  };
	
	  // http://stackoverflow.com/a/22948274/888165
	  // TODO: Opera? Mobile?
	  s.detectBrowser = function detectBrowser() {
	    var userAgent = $window.navigator.userAgent;
	
	    var browsers = {chrome: /chrome/i, safari: /safari/i, firefox: /firefox/i, ie: /internet explorer|trident\//i};
	
	    for (var key in browsers) {
	      if (browsers[key].test(userAgent)) {
	        return key;
	      }
	    }
	
	    return 'unknown';
	  };
	
	  // Borrowed from https://github.com/othree/jquery.rtl-scroll-type
	  // Determine the scroll "type" this browser is using for RTL
	  s.rtlScrollType = function rtlScrollType() {
	    if (rtlScrollType.type) {
	      return rtlScrollType.type;
	    }
	
	    var definer = angular.element('<div dir="rtl" style="font-size: 14px; width: 1px; height: 1px; position: absolute; top: -1000px; overflow: scroll">A</div>')[0],
	        type = 'reverse';
	
	    document.body.appendChild(definer);
	
	    if (definer.scrollLeft > 0) {
	      type = 'default';
	    }
	    else {
	      definer.scrollLeft = 1;
	      if (definer.scrollLeft === 0) {
	        type = 'negative';
	      }
	    }
	
	    angular.element(definer).remove();
	    rtlScrollType.type = type;
	
	    return type;
	  };
	
	    /**
	     * @ngdoc method
	     * @name normalizeScrollLeft
	     * @methodOf ui.grid.service:GridUtil
	     *
	     * @param {element} element The element to get the `scrollLeft` from.
	     * @param {grid} grid -  grid used to normalize (uses the rtl property)
	     *
	     * @returns {number} A normalized scrollLeft value for the current browser.
	     *
	     * @description
	     * Browsers currently handle RTL in different ways, resulting in inconsistent scrollLeft values. This method normalizes them
	     */
	  s.normalizeScrollLeft = function normalizeScrollLeft(element, grid) {
	    if (typeof(element.length) !== 'undefined' && element.length) {
	      element = element[0];
	    }
	
	    var scrollLeft = element.scrollLeft;
	
	    if (grid.isRTL()) {
	      switch (s.rtlScrollType()) {
	        case 'default':
	          return element.scrollWidth - scrollLeft - element.clientWidth;
	        case 'negative':
	          return Math.abs(scrollLeft);
	        case 'reverse':
	          return scrollLeft;
	      }
	    }
	
	    return scrollLeft;
	  };
	
	  /**
	  * @ngdoc method
	  * @name denormalizeScrollLeft
	  * @methodOf ui.grid.service:GridUtil
	  *
	  * @param {element} element The element to normalize the `scrollLeft` value for
	  * @param {number} scrollLeft The `scrollLeft` value to denormalize.
	  * @param {grid} grid The grid that owns the scroll event.
	  *
	  * @returns {number} A normalized scrollLeft value for the current browser.
	  *
	  * @description
	  * Browsers currently handle RTL in different ways, resulting in inconsistent scrollLeft values. This method denormalizes a value for the current browser.
	  */
	  s.denormalizeScrollLeft = function denormalizeScrollLeft(element, scrollLeft, grid) {
	    if (typeof(element.length) !== 'undefined' && element.length) {
	      element = element[0];
	    }
	
	    if (grid.isRTL()) {
	      switch (s.rtlScrollType()) {
	        case 'default':
	          // Get the max scroll for the element
	          var maxScrollLeft = element.scrollWidth - element.clientWidth;
	
	          // Subtract the current scroll amount from the max scroll
	          return maxScrollLeft - scrollLeft;
	        case 'negative':
	          return scrollLeft * -1;
	        case 'reverse':
	          return scrollLeft;
	      }
	    }
	
	    return scrollLeft;
	  };
	
	    /**
	     * @ngdoc method
	     * @name preEval
	     * @methodOf ui.grid.service:GridUtil
	     *
	     * @param {string} path Path to evaluate
	     *
	     * @returns {string} A path that is normalized.
	     *
	     * @description
	     * Takes a field path and converts it to bracket notation to allow for special characters in path
	     * @example
	     * <pre>
	     * gridUtil.preEval('property') == 'property'
	     * gridUtil.preEval('nested.deep.prop-erty') = "nested['deep']['prop-erty']"
	     * </pre>
	     */
	  s.preEval = function (path) {
	    var m = uiGridConstants.BRACKET_REGEXP.exec(path);
	    if (m) {
	      return (m[1] ? s.preEval(m[1]) : m[1]) + m[2] + (m[3] ? s.preEval(m[3]) : m[3]);
	    } else {
	      path = path.replace(uiGridConstants.APOS_REGEXP, '\\\'');
	      var parts = path.split(uiGridConstants.DOT_REGEXP);
	      var preparsed = [parts.shift()];    // first item must be var notation, thus skip
	      angular.forEach(parts, function (part) {
	        preparsed.push(part.replace(uiGridConstants.FUNC_REGEXP, '\']$1'));
	      });
	      return preparsed.join('[\'');
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name debounce
	   * @methodOf ui.grid.service:GridUtil
	   *
	   * @param {function} func function to debounce
	   * @param {number} wait milliseconds to delay
	   * @param {boolean} immediate execute before delay
	   *
	   * @returns {function} A function that can be executed as debounced function
	   *
	   * @description
	   * Copied from https://github.com/shahata/angular-debounce
	   * Takes a function, decorates it to execute only 1 time after multiple calls, and returns the decorated function
	   * @example
	   * <pre>
	   * var debouncedFunc =  gridUtil.debounce(function(){alert('debounced');}, 500);
	   * debouncedFunc();
	   * debouncedFunc();
	   * debouncedFunc();
	   * </pre>
	   */
	  s.debounce =  function (func, wait, immediate) {
	    var timeout, args, context, result;
	    function debounce() {
	      /* jshint validthis:true */
	      context = this;
	      args = arguments;
	      var later = function () {
	        timeout = null;
	        if (!immediate) {
	          result = func.apply(context, args);
	        }
	      };
	      var callNow = immediate && !timeout;
	      if (timeout) {
	        $timeout.cancel(timeout);
	      }
	      timeout = $timeout(later, wait, false);
	      if (callNow) {
	        result = func.apply(context, args);
	      }
	      return result;
	    }
	    debounce.cancel = function () {
	      $timeout.cancel(timeout);
	      timeout = null;
	    };
	    return debounce;
	  };
	
	  /**
	   * @ngdoc method
	   * @name throttle
	   * @methodOf ui.grid.service:GridUtil
	   *
	   * @param {function} func function to throttle
	   * @param {number} wait milliseconds to delay after first trigger
	   * @param {Object} params to use in throttle.
	   *
	   * @returns {function} A function that can be executed as throttled function
	   *
	   * @description
	   * Adapted from debounce function (above)
	   * Potential keys for Params Object are:
	   *    trailing (bool) - whether to trigger after throttle time ends if called multiple times
	   * Updated to use $interval rather than $timeout, as protractor (e2e tests) is able to work with $interval,
	   * but not with $timeout
	   *
	   * Note that when using throttle, you need to use throttle to create a new function upfront, then use the function
	   * return from that call each time you need to call throttle.  If you call throttle itself repeatedly, the lastCall
	   * variable will get overwritten and the throttling won't work
	   *
	   * @example
	   * <pre>
	   * var throttledFunc =  gridUtil.throttle(function(){console.log('throttled');}, 500, {trailing: true});
	   * throttledFunc(); //=> logs throttled
	   * throttledFunc(); //=> queues attempt to log throttled for ~500ms (since trailing param is truthy)
	   * throttledFunc(); //=> updates arguments to keep most-recent request, but does not do anything else.
	   * </pre>
	   */
	  s.throttle = function(func, wait, options){
	    options = options || {};
	    var lastCall = 0, queued = null, context, args;
	
	    function runFunc(endDate){
	      lastCall = +new Date();
	      func.apply(context, args);
	      $interval(function(){queued = null; }, 0, 1, false);
	    }
	
	    return function(){
	      /* jshint validthis:true */
	      context = this;
	      args = arguments;
	      if (queued === null){
	        var sinceLast = +new Date() - lastCall;
	        if (sinceLast > wait){
	          runFunc();
	        }
	        else if (options.trailing){
	          queued = $interval(runFunc, wait - sinceLast, 1, false);
	        }
	      }
	    };
	  };
	
	  s.on = {};
	  s.off = {};
	  s._events = {};
	
	  s.addOff = function (eventName) {
	    s.off[eventName] = function (elm, fn) {
	      var idx = s._events[eventName].indexOf(fn);
	      if (idx > 0) {
	        s._events[eventName].removeAt(idx);
	      }
	    };
	  };
	
	  var mouseWheeltoBind = ( 'onwheel' in document || document.documentMode >= 9 ) ? ['wheel'] : ['mousewheel', 'DomMouseScroll', 'MozMousePixelScroll'],
	      nullLowestDeltaTimeout,
	      lowestDelta;
	
	  s.on.mousewheel = function (elm, fn) {
	    if (!elm || !fn) { return; }
	
	    var $elm = angular.element(elm);
	
	    // Store the line height and page height for this particular element
	    $elm.data('mousewheel-line-height', getLineHeight($elm));
	    $elm.data('mousewheel-page-height', s.elementHeight($elm));
	    if (!$elm.data('mousewheel-callbacks')) { $elm.data('mousewheel-callbacks', {}); }
	
	    var cbs = $elm.data('mousewheel-callbacks');
	    cbs[fn] = (Function.prototype.bind || bindPolyfill).call(mousewheelHandler, $elm[0], fn);
	
	    // Bind all the mousew heel events
	    for ( var i = mouseWheeltoBind.length; i; ) {
	      $elm.on(mouseWheeltoBind[--i], cbs[fn]);
	    }
	    $elm.on('$destroy', function unbindEvents() {
	      for ( var i = mouseWheeltoBind.length; i; ) {
	        $elm.off(mouseWheeltoBind[--i], cbs[fn]);
	      }
	    });
	  };
	  s.off.mousewheel = function (elm, fn) {
	    var $elm = angular.element(elm);
	
	    var cbs = $elm.data('mousewheel-callbacks');
	    var handler = cbs[fn];
	
	    if (handler) {
	      for ( var i = mouseWheeltoBind.length; i; ) {
	        $elm.off(mouseWheeltoBind[--i], handler);
	      }
	    }
	
	    delete cbs[fn];
	
	    if (Object.keys(cbs).length === 0) {
	      $elm.removeData('mousewheel-line-height');
	      $elm.removeData('mousewheel-page-height');
	      $elm.removeData('mousewheel-callbacks');
	    }
	  };
	
	  function mousewheelHandler(fn, event) {
	    var $elm = angular.element(this);
	
	    var delta      = 0,
	        deltaX     = 0,
	        deltaY     = 0,
	        absDelta   = 0,
	        offsetX    = 0,
	        offsetY    = 0;
	
	    // jQuery masks events
	    if (event.originalEvent) { event = event.originalEvent; }
	
	    if ( 'detail'      in event ) { deltaY = event.detail * -1;      }
	    if ( 'wheelDelta'  in event ) { deltaY = event.wheelDelta;       }
	    if ( 'wheelDeltaY' in event ) { deltaY = event.wheelDeltaY;      }
	    if ( 'wheelDeltaX' in event ) { deltaX = event.wheelDeltaX * -1; }
	
	    // Firefox < 17 horizontal scrolling related to DOMMouseScroll event
	    if ( 'axis' in event && event.axis === event.HORIZONTAL_AXIS ) {
	      deltaX = deltaY * -1;
	      deltaY = 0;
	    }
	
	    // Set delta to be deltaY or deltaX if deltaY is 0 for backwards compatabilitiy
	    delta = deltaY === 0 ? deltaX : deltaY;
	
	    // New school wheel delta (wheel event)
	    if ( 'deltaY' in event ) {
	      deltaY = event.deltaY * -1;
	      delta  = deltaY;
	    }
	    if ( 'deltaX' in event ) {
	      deltaX = event.deltaX;
	      if ( deltaY === 0 ) { delta  = deltaX * -1; }
	    }
	
	    // No change actually happened, no reason to go any further
	    if ( deltaY === 0 && deltaX === 0 ) { return; }
	
	    // Need to convert lines and pages to pixels if we aren't already in pixels
	    // There are three delta modes:
	    //   * deltaMode 0 is by pixels, nothing to do
	    //   * deltaMode 1 is by lines
	    //   * deltaMode 2 is by pages
	    if ( event.deltaMode === 1 ) {
	        var lineHeight = $elm.data('mousewheel-line-height');
	        delta  *= lineHeight;
	        deltaY *= lineHeight;
	        deltaX *= lineHeight;
	    }
	    else if ( event.deltaMode === 2 ) {
	        var pageHeight = $elm.data('mousewheel-page-height');
	        delta  *= pageHeight;
	        deltaY *= pageHeight;
	        deltaX *= pageHeight;
	    }
	
	    // Store lowest absolute delta to normalize the delta values
	    absDelta = Math.max( Math.abs(deltaY), Math.abs(deltaX) );
	
	    if ( !lowestDelta || absDelta < lowestDelta ) {
	      lowestDelta = absDelta;
	
	      // Adjust older deltas if necessary
	      if ( shouldAdjustOldDeltas(event, absDelta) ) {
	        lowestDelta /= 40;
	      }
	    }
	
	    // Get a whole, normalized value for the deltas
	    delta  = Math[ delta  >= 1 ? 'floor' : 'ceil' ](delta  / lowestDelta);
	    deltaX = Math[ deltaX >= 1 ? 'floor' : 'ceil' ](deltaX / lowestDelta);
	    deltaY = Math[ deltaY >= 1 ? 'floor' : 'ceil' ](deltaY / lowestDelta);
	
	    // Normalise offsetX and offsetY properties
	    // if ($elm[0].getBoundingClientRect ) {
	    //   var boundingRect = $(elm)[0].getBoundingClientRect();
	    //   offsetX = event.clientX - boundingRect.left;
	    //   offsetY = event.clientY - boundingRect.top;
	    // }
	
	    // event.deltaX = deltaX;
	    // event.deltaY = deltaY;
	    // event.deltaFactor = lowestDelta;
	
	    var newEvent = {
	      originalEvent: event,
	      deltaX: deltaX,
	      deltaY: deltaY,
	      deltaFactor: lowestDelta,
	      preventDefault: function () { event.preventDefault(); },
	      stopPropagation: function () { event.stopPropagation(); }
	    };
	
	    // Clearout lowestDelta after sometime to better
	    // handle multiple device types that give
	    // a different lowestDelta
	    // Ex: trackpad = 3 and mouse wheel = 120
	    if (nullLowestDeltaTimeout) { clearTimeout(nullLowestDeltaTimeout); }
	    nullLowestDeltaTimeout = setTimeout(nullLowestDelta, 200);
	
	    fn.call($elm[0], newEvent);
	  }
	
	  function nullLowestDelta() {
	    lowestDelta = null;
	  }
	
	  function shouldAdjustOldDeltas(orgEvent, absDelta) {
	    // If this is an older event and the delta is divisable by 120,
	    // then we are assuming that the browser is treating this as an
	    // older mouse wheel event and that we should divide the deltas
	    // by 40 to try and get a more usable deltaFactor.
	    // Side note, this actually impacts the reported scroll distance
	    // in older browsers and can cause scrolling to be slower than native.
	    // Turn this off by setting $.event.special.mousewheel.settings.adjustOldDeltas to false.
	    return orgEvent.type === 'mousewheel' && absDelta % 120 === 0;
	  }
	
	  return s;
	}]);
	
	// Add 'px' to the end of a number string if it doesn't have it already
	module.filter('px', function() {
	  return function(str) {
	    if (str.match(/^[\d\.]+$/)) {
	      return str + 'px';
	    }
	    else {
	      return str;
	    }
	  };
	});
	
	})();
	
	(function () {
	    angular.module('ui.grid').config(['$provide', function($provide) {
	      $provide.decorator('i18nService', ['$delegate', function($delegate) {
	        $delegate.add('ar', {
	            "headerCell": {
	              "aria": {
	                "defaultFilterLabel": "التصفيه بالعمود",
	                "removeFilter": "محو التصفيه",
	                "columnMenuButtonLabel": "قاءمه الاعمده"
	              },
	              "priority": "أولويه : ",
	              "filterLabel": "تصفيه بالاعمده :"
	            },
	            "aggregate": {
	              "label": "العناصر"
	            },
	            "groupPanel": {
	              "description": "اسحب رأس العمود هنا وأسقطه لإنشاء مجموعه"
	            },
	            "search": {
	              "placeholder": "بحث  ...",
	              "showingItems": "العناصر الظاهره :",
	              "selectedItems": "العناصر المحدده :",
	              "totalItems": "عدد العناصر :",
	              "size": "حجم الصفحه :",
	              "first": "اول صفحه",
	              "next": "الصفحه التاليه",
	              "previous": "الصفحه الصابقه",
	              "last": "الصفحه الاخيره"
	            },
	            "menu": {
	              "text": "اختيار العمود :"
	            },
	            "sort": {
	              "ascending": "ترتيب تصاعدى",
	              "descending": "ترتيب تنازلى",
	              "none": "عدم التحديد",
	              "remove": "حذف الترتيب"
	            },
	            "column": {
	              "hide": "إخفاء عمود"
	            },
	            "aggregation": {
	              "count": "عدد الصفوف: ",
	              "sum": "جمع: ",
	              "avg": "المتوسط الحسابى: ",
	              "min": "الادنى: ",
	              "max": "الاقصى: "
	            },
	            "pinning": {
	              "pinLeft": "تثبيت لليسار",
	              "pinRight": "تثبيت لليمين",
	              "unpin": "فك التثبيت"
	            },
	            "columnMenu": {
	              "close": "غلق"
	            },
	            "gridMenu": {
	              "aria": {
	                "buttonLabel": "قائمه الجدول"
	              },
	              "columns": "الاعمده:",
	              "importerTitle": "إدخال ملف",
	              "exporterAllAsCsv": "إخراج كل البيانات ك(csv)",
	              "exporterVisibleAsCsv": "إخراج كل البيانات الواضحه ك (csv)",
	              "exporterSelectedAsCsv": "إخراج كل البيانات المحدده ك (csv)",
	              "exporterAllAsPdf": "إخراج كل البيانات ك(pdf)",
	              "exporterVisibleAsPdf": "إخراج كل البيانات الواضحه ك (pdf)",
	              "exporterSelectedAsPdf": "إخراج كل البيانات المحدده ك (pdf)",
	              "clearAllFilters": "محو كل الترشيح"
	            },
	            "importer": {
	              "noHeaders": "اسماء هؤلاء الاعمده غير واضحه، هل يوجد رأس للملف؟",
	              "noObjects": "Objects were not able to be derived, was there data in the file other than headers?",
	              "invalidCsv": "الملف غير قادر على الاتمام ، هل ال (CSV) صحيح؟",
	              "invalidJson": "الملف غير قادر على الاتمام ، هل ال (JSON) صحيح؟",
	              "jsonNotArray": "Imported json file must contain an array, aborting."
	            },
	            "pagination": {
	              "aria": {
	                "pageToFirst": "الصفحه الاولى",
	                "pageBack": "الصفه السابقه",
	                "pageSelected": "الصفحه المحدده",
	                "pageForward": "الصفحه التاليه",
	                "pageToLast": "الصفحه الاخيره"
	              },
	              "sizes": "عدد العناصر فى الصفحه",
	              "totalItems": "عناصر",
	              "through": "إلى",
	              "of": "من"
	            },
	            "grouping": {
	              "group": "جمع",
	              "ungroup": "فك الجمع",
	              "aggregate_count": "جمله : العدد",
	              "aggregate_sum": "جمله : الحاصل",
	              "aggregate_max": "جمله : الاقصى",
	              "aggregate_min": "جمله : الاقل",
	              "aggregate_avg": "جمله :المتوسط ",
	              "aggregate_remove": "جمله : حذف"
	            },
	            "validate": {
	              "error": "خطأ :",
	              "minLength": "القيمه لابد ان لا تقل عن THRESHOLD حرف.",
	              "maxLength": "القيمه لابد ان لا تزيد عن THRESHOLD حرف.",
	              "required": "مطلوب قيمه"
	            }
	          });
	        return $delegate;
	      }]);
	    }]);
	  })();
	  
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('bg', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: 'Филттър за колоната',
	            removeFilter: 'Премахни филтър',
	            columnMenuButtonLabel: 'Меню на колоната'
	          },
	          priority: 'Приоритет:',
	          filterLabel: "Филтър за колоната: "
	        },
	        aggregate: {
	          label: 'обекти'
	        },
	        search: {
	          placeholder: 'Търсене...',
	          showingItems: 'Показани обекти:',
	          selectedItems: 'избрани обекти:',
	          totalItems: 'Общо:',
	          size: 'Размер на страницата:',
	          first: 'Първа страница',
	          next: 'Следваща страница',
	          previous: 'Предишна страница',
	          last: 'Последна страница'
	        },
	        menu: {
	          text: 'Избери колони:'
	        },
	        sort: {
	          ascending: 'Сортиране по възходящ ред',
	          descending: 'Сортиране по низходящ ред',
	          none: 'Без сортиране',
	          remove: 'Премахни сортирането'
	        },
	        column: {
	          hide: 'Скрий колоната'
	        },
	        aggregation: {
	          count: 'Общо редове: ',
	          sum: 'общо: ',
	          avg: 'средно: ',
	          min: 'най-малко: ',
	          max: 'най-много: '
	        },
	        pinning: {
	          pinLeft: 'Прикрепи вляво',
	          pinRight: 'Прикрепи вдясно',
	          unpin: 'Премахване'
	        },
	        columnMenu: {
	          close: 'Затвори'
	        },
	        gridMenu: {
	          aria: {
	            buttonLabel: 'Меню на таблицата'
	          },
	          columns: 'Колони:',
	          importerTitle: 'Импортиране на файл',
	          exporterAllAsCsv: 'Експортиране на данните като csv',
	          exporterVisibleAsCsv: 'Експортиране на видимите данни като csv',
	          exporterSelectedAsCsv: 'Експортиране на избраните данни като csv',
	          exporterAllAsPdf: 'Експортиране на данните като pdf',
	          exporterVisibleAsPdf: 'Експортиране на видимите данни като pdf',
	          exporterSelectedAsPdf: 'Експортиране на избраните данни като pdf',
	          clearAllFilters: 'Премахни всички филтри'
	        },
	        importer: {
	          noHeaders: 'Имената на колоните не успяха да бъдат извлечени, файлът има ли хедър?',
	          noObjects: 'Обектите не успяха да бъдат извлечени, файлът съдържа ли данни, различни от хедър?',
	          invalidCsv: 'Файлът не може да бъде обработеб, уверете се, че е валиден CSV файл',
	          invalidJson: 'Файлът не може да бъде обработеб, уверете се, че е валиден JSON файл',
	          jsonNotArray: 'Импортираният JSON файл трябва да съдържа масив, прекратяване.'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: 'Към първа страница',
	            pageBack: 'Страница назад',
	            pageSelected: 'Избрана страница',
	            pageForward: 'Страница напред',
	            pageToLast: 'Към последна страница'
	          },
	          sizes: 'обекта на страница',
	          totalItems: 'обекта',
	          through: 'до',
	          of: 'от'
	        },
	        grouping: {
	          group: 'Групиране',
	          ungroup: 'Премахване на групирането',
	          aggregate_count: 'Сбор: Брой',
	          aggregate_sum: 'Сбор: Сума',
	          aggregate_max: 'Сбор: Максимум',
	          aggregate_min: 'Сбор: Минимум',
	          aggregate_avg: 'Сбор: Средно',
	          aggregate_remove: 'Сбор: Премахване'
	        },
	        validate: {
	          error: 'Грешка:',
	          minLength: 'Стойността трябва да съдържа поне THRESHOLD символа.',
	          maxLength: 'Стойността не трябва да съдържа повече от THRESHOLD символа.',
	          required: 'Необходима е стойност.'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      var lang = {
	              aggregate: {
	                  label: 'položky'
	              },
	              groupPanel: {
	                  description: 'Přesuňte záhlaví zde pro vytvoření skupiny dle sloupce.'
	              },
	              search: {
	                  placeholder: 'Hledat...',
	                  showingItems: 'Zobrazuji položky:',
	                  selectedItems: 'Vybrané položky:',
	                  totalItems: 'Celkem položek:',
	                  size: 'Velikost strany:',
	                  first: 'První strana',
	                  next: 'Další strana',
	                  previous: 'Předchozí strana',
	                  last: 'Poslední strana'
	              },
	              menu: {
	                  text: 'Vyberte sloupec:'
	              },
	              sort: {
	                  ascending: 'Seřadit od A-Z',
	                  descending: 'Seřadit od Z-A',
	                  remove: 'Odebrat seřazení'
	              },
	              column: {
	                  hide: 'Schovat sloupec'
	              },
	              aggregation: {
	                  count: 'celkem řádků: ',
	                  sum: 'celkem: ',
	                  avg: 'avg: ',
	                  min: 'min.: ',
	                  max: 'max.: '
	              },
	              pinning: {
	                  pinLeft: 'Zamknout vlevo',
	                  pinRight: 'Zamknout vpravo',
	                  unpin: 'Odemknout'
	              },
	              gridMenu: {
	                  columns: 'Sloupce:',
	                  importerTitle: 'Importovat soubor',
	                  exporterAllAsCsv: 'Exportovat všechna data do csv',
	                  exporterVisibleAsCsv: 'Exportovat viditelná data do csv',
	                  exporterSelectedAsCsv: 'Exportovat vybraná data do csv',
	                  exporterAllAsPdf: 'Exportovat všechna data do pdf',
	                  exporterVisibleAsPdf: 'Exportovat viditelná data do pdf',
	                  exporterSelectedAsPdf: 'Exportovat vybraná data do pdf',
	                  exporterAllAsExcel: 'Exportovat všechna data do excel',
	                  exporterVisibleAsExcel: 'Exportovat viditelná data do excel',
	                  exporterSelectedAsExcel: 'Exportovat vybraná data do excel',
	                  clearAllFilters: 'Odstranit všechny filtry'
	              },
	              importer: {
	                  noHeaders: 'Názvy sloupců se nepodařilo získat, obsahuje soubor záhlaví?',
	                  noObjects: 'Data se nepodařilo zpracovat, obsahuje soubor řádky mimo záhlaví?',
	                  invalidCsv: 'Soubor nelze zpracovat, jedná se o CSV?',
	                  invalidJson: 'Soubor nelze zpracovat, je to JSON?',
	                  jsonNotArray: 'Soubor musí obsahovat json. Ukončuji..'
	              },
	              pagination: {
	                  sizes: 'položek na stránku',
	                  totalItems: 'položek'
	              },
	              grouping: {
	                  group: 'Seskupit',
	                  ungroup: 'Odebrat seskupení',
	                  aggregate_count: 'Agregace: Count',
	                  aggregate_sum: 'Agregace: Sum',
	                  aggregate_max: 'Agregace: Max',
	                  aggregate_min: 'Agregace: Min',
	                  aggregate_avg: 'Agregace: Avg',
	                  aggregate_remove: 'Agregace: Odebrat'
	              }
	          };
	
	          // support varianty of different czech keys.
	          $delegate.add('cs', lang);
	          $delegate.add('cz', lang);
	          $delegate.add('cs-cz', lang);
	          $delegate.add('cs-CZ', lang);
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function(){
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('da', {
	        aggregate:{
	          label: 'artikler'
	        },
	        groupPanel:{
	          description: 'Grupér rækker udfra en kolonne ved at trække dens overskift hertil.'
	        },
	        search:{
	          placeholder: 'Søg...',
	          showingItems: 'Viste rækker:',
	          selectedItems: 'Valgte rækker:',
	          totalItems: 'Rækker totalt:',
	          size: 'Side størrelse:',
	          first: 'Første side',
	          next: 'Næste side',
	          previous: 'Forrige side',
	          last: 'Sidste side'
	        },
	        menu:{
	          text: 'Vælg kolonner:'
	        },
	        sort: {
	          ascending: 'Sorter stigende',
	          descending: 'Sorter faldende',
	          none: 'Sorter ingen',
	          remove: 'Fjern sortering'
	        },
	        column: {
	          hide: 'Skjul kolonne'
	        },
	        aggregation: {
	          count: 'antal rækker: ',
	          sum: 'sum: ',
	          avg: 'gns: ',
	          min: 'min: ',
	          max: 'max: '
	        },
	        gridMenu: {
	          columns: 'Kolonner:',
	          importerTitle: 'Importer fil',
	          exporterAllAsCsv: 'Eksporter alle data som csv',
	          exporterVisibleAsCsv: 'Eksporter synlige data som csv',
	          exporterSelectedAsCsv: 'Eksporter markerede data som csv',
	          exporterAllAsPdf: 'Eksporter alle data som pdf',
	          exporterVisibleAsPdf: 'Eksporter synlige data som pdf',
	          exporterSelectedAsPdf: 'Eksporter markerede data som pdf',
	          exporterAllAsExcel: 'Eksporter alle data som excel',
	          exporterVisibleAsExcel: 'Eksporter synlige data som excel',
	          exporterSelectedAsExcel: 'Eksporter markerede data som excel',
	          clearAllFilters: 'Clear all filters'
	        },
	        importer: {
	          noHeaders: 'Column names were unable to be derived, does the file have a header?',
	          noObjects: 'Objects were not able to be derived, was there data in the file other than headers?',
	          invalidCsv: 'File was unable to be processed, is it valid CSV?',
	          invalidJson: 'File was unable to be processed, is it valid Json?',
	          jsonNotArray: 'Imported json file must contain an array, aborting.'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: 'Gå til første',
	            pageBack: 'Gå tilbage',
	            pageSelected: 'Valgte side',
	            pageForward: 'Gå frem',
	            pageToLast: 'Gå til sidste'
	          },
	          sizes: 'genstande per side',
	          totalItems: 'genstande',
	          through: 'gennem',
	          of: 'af'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function ($provide) {
	    $provide.decorator('i18nService', ['$delegate', function ($delegate) {
	      $delegate.add('de', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: 'Filter für Spalte',
	            removeFilter: 'Filter löschen',
	            columnMenuButtonLabel: 'Spaltenmenü',
	            column: 'Spalte'
	          },
	          priority: 'Priorität:',
	          filterLabel: "Filter für Spalte: "
	        },
	        aggregate: {
	          label: 'Eintrag'
	        },
	        groupPanel: {
	          description: 'Ziehen Sie eine Spaltenüberschrift hierhin, um nach dieser Spalte zu gruppieren.'
	        },
	        search: {
	          aria: {
	            selected: 'Zeile markiert',
	            notSelected: 'Zeile nicht markiert'
	          },
	          placeholder: 'Suche...',
	          showingItems: 'Zeige Einträge:',
	          selectedItems: 'Ausgewählte Einträge:',
	          totalItems: 'Einträge gesamt:',
	          size: 'Einträge pro Seite:',
	          first: 'Erste Seite',
	          next: 'Nächste Seite',
	          previous: 'Vorherige Seite',
	          last: 'Letzte Seite'
	        },
	        menu: {
	          text: 'Spalten auswählen:'
	        },
	        sort: {
	          ascending: 'aufsteigend sortieren',
	          descending: 'absteigend sortieren',
	          none: 'keine Sortierung',
	          remove: 'Sortierung zurücksetzen'
	        },
	        column: {
	          hide: 'Spalte ausblenden'
	        },
	        aggregation: {
	          count: 'Zeilen insgesamt: ',
	          sum: 'gesamt: ',
	          avg: 'Durchschnitt: ',
	          min: 'min: ',
	          max: 'max: '
	        },
	        pinning: {
	            pinLeft: 'Links anheften',
	            pinRight: 'Rechts anheften',
	            unpin: 'Lösen'
	        },
	        columnMenu: {
	          close: 'Schließen'
	        },
	        gridMenu: {
	          aria: {
	            buttonLabel: 'Tabellenmenü'
	          },
	          columns: 'Spalten:',
	          importerTitle: 'Datei importieren',
	          exporterAllAsCsv: 'Alle Daten als CSV exportieren',
	          exporterVisibleAsCsv: 'Sichtbare Daten als CSV exportieren',
	          exporterSelectedAsCsv: 'Markierte Daten als CSV exportieren',
	          exporterAllAsPdf: 'Alle Daten als PDF exportieren',
	          exporterVisibleAsPdf: 'Sichtbare Daten als PDF exportieren',
	          exporterSelectedAsPdf: 'Markierte Daten als PDF exportieren',
	          exporterAllAsExcel: 'Alle Daten als Excel exportieren',
	          exporterVisibleAsExcel: 'Sichtbare Daten als Excel exportieren',
	          exporterSelectedAsExcel: 'Markierte Daten als Excel exportieren',
	          clearAllFilters: 'Alle Filter zurücksetzen'
	        },
	        importer: {
	          noHeaders: 'Es konnten keine Spaltennamen ermittelt werden. Sind in der Datei Spaltendefinitionen enthalten?',
	          noObjects: 'Es konnten keine Zeileninformationen gelesen werden, Sind in der Datei außer den Spaltendefinitionen auch Daten enthalten?',
	          invalidCsv: 'Die Datei konnte nicht eingelesen werden, ist es eine gültige CSV-Datei?',
	          invalidJson: 'Die Datei konnte nicht eingelesen werden. Enthält sie gültiges JSON?',
	          jsonNotArray: 'Die importierte JSON-Datei muß ein Array enthalten. Breche Import ab.'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: 'Zum Anfang',
	            pageBack: 'Seite zurück',
	            pageSelected: 'Ausgewählte Seite',
	            pageForward: 'Seite vor',
	            pageToLast: 'Zum Ende'
	          },
	          sizes: 'Einträge pro Seite',
	          totalItems: 'Einträgen',
	          through: 'bis',
	          of: 'von'
	        },
	        grouping: {
	            group: 'Gruppieren',
	            ungroup: 'Gruppierung aufheben',
	            aggregate_count: 'Agg: Anzahl',
	            aggregate_sum: 'Agg: Summe',
	            aggregate_max: 'Agg: Maximum',
	            aggregate_min: 'Agg: Minimum',
	            aggregate_avg: 'Agg: Mittelwert',
	            aggregate_remove: 'Aggregation entfernen'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('en', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: 'Filter for column',
	            removeFilter: 'Remove Filter',
	            columnMenuButtonLabel: 'Column Menu',
	            column: 'Column'
	          },
	          priority: 'Priority:',
	          filterLabel: "Filter for column: "
	        },
	        aggregate: {
	          label: 'items'
	        },
	        groupPanel: {
	          description: 'Drag a column header here and drop it to group by that column.'
	        },
	        search: {
	          aria: {
	            selected: 'Row selected',
	            notSelected: 'Row not selected'
	          },
	          placeholder: 'Search...',
	          showingItems: 'Showing Items:',
	          selectedItems: 'Selected Items:',
	          totalItems: 'Total Items:',
	          size: 'Page Size:',
	          first: 'First Page',
	          next: 'Next Page',
	          previous: 'Previous Page',
	          last: 'Last Page'
	        },
	        menu: {
	          text: 'Choose Columns:'
	        },
	        sort: {
	          ascending: 'Sort Ascending',
	          descending: 'Sort Descending',
	          none: 'Sort None',
	          remove: 'Remove Sort'
	        },
	        column: {
	          hide: 'Hide Column'
	        },
	        aggregation: {
	          count: 'total rows: ',
	          sum: 'total: ',
	          avg: 'avg: ',
	          min: 'min: ',
	          max: 'max: '
	        },
	        pinning: {
	          pinLeft: 'Pin Left',
	          pinRight: 'Pin Right',
	          unpin: 'Unpin'
	        },
	        columnMenu: {
	          close: 'Close'
	        },
	        gridMenu: {
	          aria: {
	            buttonLabel: 'Grid Menu'
	          },
	          columns: 'Columns:',
	          importerTitle: 'Import file',
	          exporterAllAsCsv: 'Export all data as csv',
	          exporterVisibleAsCsv: 'Export visible data as csv',
	          exporterSelectedAsCsv: 'Export selected data as csv',
	          exporterAllAsPdf: 'Export all data as pdf',
	          exporterVisibleAsPdf: 'Export visible data as pdf',
	          exporterSelectedAsPdf: 'Export selected data as pdf',
	          exporterAllAsExcel: 'Export all data as excel',
	          exporterVisibleAsExcel: 'Export visible data as excel',
	          exporterSelectedAsExcel: 'Export selected data as excel',
	          clearAllFilters: 'Clear all filters'
	        },
	        importer: {
	          noHeaders: 'Column names were unable to be derived, does the file have a header?',
	          noObjects: 'Objects were not able to be derived, was there data in the file other than headers?',
	          invalidCsv: 'File was unable to be processed, is it valid CSV?',
	          invalidJson: 'File was unable to be processed, is it valid Json?',
	          jsonNotArray: 'Imported json file must contain an array, aborting.'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: 'Page to first',
	            pageBack: 'Page back',
	            pageSelected: 'Selected page',
	            pageForward: 'Page forward',
	            pageToLast: 'Page to last'
	          },
	          sizes: 'items per page',
	          totalItems: 'items',
	          through: 'through',
	          of: 'of'
	        },
	        grouping: {
	          group: 'Group',
	          ungroup: 'Ungroup',
	          aggregate_count: 'Agg: Count',
	          aggregate_sum: 'Agg: Sum',
	          aggregate_max: 'Agg: Max',
	          aggregate_min: 'Agg: Min',
	          aggregate_avg: 'Agg: Avg',
	          aggregate_remove: 'Agg: Remove'
	        },
	        validate: {
	          error: 'Error:',
	          minLength: 'Value should be at least THRESHOLD characters long.',
	          maxLength: 'Value should be at most THRESHOLD characters long.',
	          required: 'A value is needed.'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('es', {
	        aggregate: {
	          label: 'Artículos'
	        },
	        groupPanel: {
	          description: 'Arrastre un encabezado de columna aquí y suéltelo para agrupar por esa columna.'
	        },
	        search: {
	          placeholder: 'Buscar...',
	          showingItems: 'Artículos Mostrados:',
	          selectedItems: 'Artículos Seleccionados:',
	          totalItems: 'Artículos Totales:',
	          size: 'Tamaño de Página:',
	          first: 'Primera Página',
	          next: 'Página Siguiente',
	          previous: 'Página Anterior',
	          last: 'Última Página'
	        },
	        menu: {
	          text: 'Elegir columnas:'
	        },
	        sort: {
	          ascending: 'Orden Ascendente',
	          descending: 'Orden Descendente',
	          remove: 'Sin Ordenar'
	        },
	        column: {
	          hide: 'Ocultar la columna'
	        },
	        aggregation: {
	          count: 'filas totales: ',
	          sum: 'total: ',
	          avg: 'media: ',
	          min: 'min: ',
	          max: 'max: '
	        },
	        pinning: {
	          pinLeft: 'Fijar a la Izquierda',
	          pinRight: 'Fijar a la Derecha',
	          unpin: 'Quitar Fijación'
	        },
	        gridMenu: {
	          columns: 'Columnas:',
	          importerTitle: 'Importar archivo',
	          exporterAllAsCsv: 'Exportar todo como csv',
	          exporterVisibleAsCsv: 'Exportar vista como csv',
	          exporterSelectedAsCsv: 'Exportar selección como csv',
	          exporterAllAsPdf: 'Exportar todo como pdf',
	          exporterVisibleAsPdf: 'Exportar vista como pdf',
	          exporterSelectedAsPdf: 'Exportar selección como pdf',
	          exporterAllAsExcel: 'Exportar todo como excel',
	          exporterVisibleAsExcel: 'Exportar vista como excel',
	          exporterSelectedAsExcel: 'Exportar selección como excel',
	          clearAllFilters: 'Limpiar todos los filtros'
	        },
	        importer: {
	          noHeaders: 'No fue posible derivar los nombres de las columnas, ¿tiene encabezados el archivo?',
	          noObjects: 'No fue posible obtener registros, ¿contiene datos el archivo, aparte de los encabezados?',
	          invalidCsv: 'No fue posible procesar el archivo, ¿es un CSV válido?',
	          invalidJson: 'No fue posible procesar el archivo, ¿es un Json válido?',
	          jsonNotArray: 'El archivo json importado debe contener un array, abortando.'
	        },
	        pagination: {
	          sizes: 'registros por página',
	          totalItems: 'registros',
	          of: 'de'
	        },
	        grouping: {
	          group: 'Agrupar',
	          ungroup: 'Desagrupar',
	          aggregate_count: 'Agr: Cont',
	          aggregate_sum: 'Agr: Sum',
	          aggregate_max: 'Agr: Máx',
	          aggregate_min: 'Agr: Min',
	          aggregate_avg: 'Agr: Prom',
	          aggregate_remove: 'Agr: Quitar'
	        }
	      });
	      return $delegate;
	    }]);
	}]);
	})();
	
	/**
	 * Translated by: R. Salarmehr
	 *                M. Hosseynzade
	 *                Using Vajje.com online dictionary.
	 */
	(function () {
	  angular.module('ui.grid').config(['$provide', function ($provide) {
	    $provide.decorator('i18nService', ['$delegate', function ($delegate) {
	      $delegate.add('fa', {
	        aggregate: {
	          label: 'قلم'
	        },
	        groupPanel: {
	          description: 'عنوان یک ستون را بگیر و به گروهی از آن ستون رها کن.'
	        },
	        search: {
	          placeholder: 'جستجو...',
	          showingItems: 'نمایش اقلام:',
	          selectedItems: 'قلم\u200cهای انتخاب شده:',
	          totalItems: 'مجموع اقلام:',
	          size: 'اندازه\u200cی صفحه:',
	          first: 'اولین صفحه',
	          next: 'صفحه\u200cی\u200cبعدی',
	          previous: 'صفحه\u200cی\u200c قبلی',
	          last: 'آخرین صفحه'
	        },
	        menu: {
	          text: 'ستون\u200cهای انتخابی:'
	        },
	        sort: {
	          ascending: 'ترتیب صعودی',
	          descending: 'ترتیب نزولی',
	          remove: 'حذف مرتب کردن'
	        },
	        column: {
	          hide: 'پنهان\u200cکردن ستون'
	        },
	        aggregation: {
	          count: 'تعداد: ',
	          sum: 'مجموع: ',
	          avg: 'میانگین: ',
	          min: 'کمترین: ',
	          max: 'بیشترین: '
	        },
	        pinning: {
	          pinLeft: 'پین کردن سمت چپ',
	          pinRight: 'پین کردن سمت راست',
	          unpin: 'حذف پین'
	        },
	        gridMenu: {
	          columns: 'ستون\u200cها:',
	          importerTitle: 'وارد کردن فایل',
	          exporterAllAsCsv: 'خروجی تمام داده\u200cها در فایل csv',
	          exporterVisibleAsCsv: 'خروجی داده\u200cهای قابل مشاهده در فایل csv',
	          exporterSelectedAsCsv: 'خروجی داده\u200cهای انتخاب\u200cشده در فایل csv',
	          exporterAllAsPdf: 'خروجی تمام داده\u200cها در فایل pdf',
	          exporterVisibleAsPdf: 'خروجی داده\u200cهای قابل مشاهده در فایل pdf',
	          exporterSelectedAsPdf: 'خروجی داده\u200cهای انتخاب\u200cشده در فایل pdf',
	          clearAllFilters: 'پاک کردن تمام فیلتر'
	        },
	        importer: {
	          noHeaders: 'نام ستون قابل استخراج نیست. آیا فایل عنوان دارد؟',
	          noObjects: 'اشیا قابل استخراج نیستند. آیا به جز عنوان\u200cها در فایل داده وجود دارد؟',
	          invalidCsv: 'فایل قابل پردازش نیست. آیا فرمت  csv  معتبر است؟',
	          invalidJson: 'فایل قابل پردازش نیست. آیا فرمت json   معتبر است؟',
	          jsonNotArray: 'فایل json وارد شده باید حاوی آرایه باشد. عملیات ساقط شد.'
	        },
	        pagination: {
	          sizes: 'اقلام در هر صفحه',
	          totalItems: 'اقلام',
	          of: 'از'
	        },
	        grouping: {
	          group: 'گروه\u200cبندی',
	          ungroup: 'حذف گروه\u200cبندی',
	          aggregate_count: 'Agg: تعداد',
	          aggregate_sum: 'Agg: جمع',
	          aggregate_max: 'Agg: بیشینه',
	          aggregate_min: 'Agg: کمینه',
	          aggregate_avg: 'Agg: میانگین',
	          aggregate_remove: 'Agg: حذف'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('fi', {
	        aggregate: {
	          label: 'rivit'
	        },
	        groupPanel: {
	          description: 'Raahaa ja pudota otsikko tähän ryhmittääksesi sarakkeen mukaan.'
	        },
	        search: {
	          placeholder: 'Hae...',
	          showingItems: 'Näytetään rivejä:',
	          selectedItems: 'Valitut rivit:',
	          totalItems: 'Rivejä yht.:',
	          size: 'Näytä:',
	          first: 'Ensimmäinen sivu',
	          next: 'Seuraava sivu',
	          previous: 'Edellinen sivu',
	          last: 'Viimeinen sivu'
	        },
	        menu: {
	          text: 'Valitse sarakkeet:'
	        },
	        sort: {
	          ascending: 'Järjestä nouseva',
	          descending: 'Järjestä laskeva',
	          remove: 'Poista järjestys'
	        },
	        column: {
	          hide: 'Piilota sarake'
	        },
	        aggregation: {
	          count: 'Rivejä yht.: ',
	          sum: 'Summa: ',
	          avg: 'K.a.: ',
	          min: 'Min: ',
	          max: 'Max: '
	        },
	        pinning: {
	         pinLeft: 'Lukitse vasemmalle',
	          pinRight: 'Lukitse oikealle',
	          unpin: 'Poista lukitus'
	        },
	        gridMenu: {
	          columns: 'Sarakkeet:',
	          importerTitle: 'Tuo tiedosto',
	          exporterAllAsCsv: 'Vie tiedot csv-muodossa',
	          exporterVisibleAsCsv: 'Vie näkyvä tieto csv-muodossa',
	          exporterSelectedAsCsv: 'Vie valittu tieto csv-muodossa',
	          exporterAllAsPdf: 'Vie tiedot pdf-muodossa',
	          exporterVisibleAsPdf: 'Vie näkyvä tieto pdf-muodossa',
	          exporterSelectedAsPdf: 'Vie valittu tieto pdf-muodossa',
	          exporterAllAsExcel: 'Vie tiedot excel-muodossa',
	          exporterVisibleAsExcel: 'Vie näkyvä tieto excel-muodossa',
	          exporterSelectedAsExcel: 'Vie valittu tieto excel-muodossa',
	          clearAllFilters: 'Puhdista kaikki suodattimet'
	        },
	        importer: {
	          noHeaders: 'Sarakkeen nimiä ei voitu päätellä, onko tiedostossa otsikkoriviä?',
	          noObjects: 'Tietoja ei voitu lukea, onko tiedostossa muuta kuin otsikkot?',
	          invalidCsv: 'Tiedostoa ei voitu käsitellä, oliko se CSV-muodossa?',
	          invalidJson: 'Tiedostoa ei voitu käsitellä, oliko se JSON-muodossa?',
	          jsonNotArray: 'Tiedosto ei sisältänyt taulukkoa, lopetetaan.'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('fr', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: 'Filtre de la colonne',
	            removeFilter: 'Supprimer le filtre',
	            columnMenuButtonLabel: 'Menu de la colonne'
	          },
	          priority: 'Priorité:',
	          filterLabel: "Filtre de la colonne: "
	        },
	        aggregate: {
	          label: 'éléments'
	        },
	        groupPanel: {
	          description: 'Faites glisser une en-tête de colonne ici pour créer un groupe de colonnes.'
	        },
	        search: {
	          placeholder: 'Recherche...',
	          showingItems: 'Affichage des éléments :',
	          selectedItems: 'Éléments sélectionnés :',
	          totalItems: 'Nombre total d\'éléments:',
	          size: 'Taille de page:',
	          first: 'Première page',
	          next: 'Page Suivante',
	          previous: 'Page précédente',
	          last: 'Dernière page'
	        },
	        menu: {
	          text: 'Choisir des colonnes :'
	        },
	        sort: {
	          ascending: 'Trier par ordre croissant',
	          descending: 'Trier par ordre décroissant',
	          none: 'Aucun tri',
	          remove: 'Enlever le tri'
	        },
	        column: {
	          hide: 'Cacher la colonne'
	        },
	        aggregation: {
	          count: 'lignes totales: ',
	          sum: 'total: ',
	          avg: 'moy: ',
	          min: 'min: ',
	          max: 'max: '
	        },
	        pinning: {
	          pinLeft: 'Épingler à gauche',
	          pinRight: 'Épingler à droite',
	          unpin: 'Détacher'
	        },
	        columnMenu: {
	          close: 'Fermer'
	        },
	        gridMenu: {
	          aria: {
	            buttonLabel: 'Menu du tableau'
	          },
	          columns: 'Colonnes:',
	          importerTitle: 'Importer un fichier',
	          exporterAllAsCsv: 'Exporter toutes les données en CSV',
	          exporterVisibleAsCsv: 'Exporter les données visibles en CSV',
	          exporterSelectedAsCsv: 'Exporter les données sélectionnées en CSV',
	          exporterAllAsPdf: 'Exporter toutes les données en PDF',
	          exporterVisibleAsPdf: 'Exporter les données visibles en PDF',
	          exporterSelectedAsPdf: 'Exporter les données sélectionnées en PDF',
	          exporterAllAsExcel: 'Exporter toutes les données en Excel',
	          exporterVisibleAsExcel: 'Exporter les données visibles en Excel',
	          exporterSelectedAsExcel: 'Exporter les données sélectionnées en Excel',
	          clearAllFilters: 'Nettoyez tous les filtres'
	        },
	        importer: {
	          noHeaders: 'Impossible de déterminer le nom des colonnes, le fichier possède-t-il une en-tête ?',
	          noObjects: 'Aucun objet trouvé, le fichier possède-t-il des données autres que l\'en-tête ?',
	          invalidCsv: 'Le fichier n\'a pas pu être traité, le CSV est-il valide ?',
	          invalidJson: 'Le fichier n\'a pas pu être traité, le JSON est-il valide ?',
	          jsonNotArray: 'Le fichier JSON importé doit contenir un tableau, abandon.'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: 'Aller à la première page',
	            pageBack: 'Page précédente',
	            pageSelected: 'Page sélectionnée',
	            pageForward: 'Page suivante',
	            pageToLast: 'Aller à la dernière page'
	          },
	          sizes: 'éléments par page',
	          totalItems: 'éléments',
	          through: 'à',
	          of: 'sur'
	        },
	        grouping: {
	          group: 'Grouper',
	          ungroup: 'Dégrouper',
	          aggregate_count: 'Agg: Compter',
	          aggregate_sum: 'Agg: Somme',
	          aggregate_max: 'Agg: Max',
	          aggregate_min: 'Agg: Min',
	          aggregate_avg: 'Agg: Moy',
	          aggregate_remove: 'Agg: Retirer'
	        },
	        validate: {
	          error: 'Erreur:',
	          minLength: 'La valeur doit être supérieure ou égale à THRESHOLD caractères.',
	          maxLength: 'La valeur doit être inférieure ou égale à THRESHOLD caractères.',
	          required: 'Une valeur est nécéssaire.'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function ($provide) {
	    $provide.decorator('i18nService', ['$delegate', function ($delegate) {
	      $delegate.add('he', {
	        aggregate: {
	          label: 'items'
	        },
	        groupPanel: {
	          description: 'גרור עמודה לכאן ושחרר בכדי לקבץ עמודה זו.'
	        },
	        search: {
	          placeholder: 'חפש...',
	          showingItems: 'מציג:',
	          selectedItems: 'סה"כ נבחרו:',
	          totalItems: 'סה"כ רשומות:',
	          size: 'תוצאות בדף:',
	          first: 'דף ראשון',
	          next: 'דף הבא',
	          previous: 'דף קודם',
	          last: 'דף אחרון'
	        },
	        menu: {
	          text: 'בחר עמודות:'
	        },
	        sort: {
	          ascending: 'סדר עולה',
	          descending: 'סדר יורד',
	          remove: 'בטל'
	        },
	        column: {
	          hide: 'טור הסתר'
	        },
	        aggregation: {
	          count: 'total rows: ',
	          sum: 'total: ',
	          avg: 'avg: ',
	          min: 'min: ',
	          max: 'max: '
	        },
	        gridMenu: {
	          columns: 'Columns:',
	          importerTitle: 'Import file',
	          exporterAllAsCsv: 'Export all data as csv',
	          exporterVisibleAsCsv: 'Export visible data as csv',
	          exporterSelectedAsCsv: 'Export selected data as csv',
	          exporterAllAsPdf: 'Export all data as pdf',
	          exporterVisibleAsPdf: 'Export visible data as pdf',
	          exporterSelectedAsPdf: 'Export selected data as pdf',
	          exporterAllAsExcel: 'Export all data as excel',
	          exporterVisibleAsExcel: 'Export visible data as excel',
	          exporterSelectedAsExcel: 'Export selected data as excel',
	          clearAllFilters: 'Clean all filters'
	        },
	        importer: {
	          noHeaders: 'Column names were unable to be derived, does the file have a header?',
	          noObjects: 'Objects were not able to be derived, was there data in the file other than headers?',
	          invalidCsv: 'File was unable to be processed, is it valid CSV?',
	          invalidJson: 'File was unable to be processed, is it valid Json?',
	          jsonNotArray: 'Imported json file must contain an array, aborting.'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('hy', {
	        aggregate: {
	          label: 'տվյալներ'
	        },
	        groupPanel: {
	          description: 'Ըստ սյան խմբավորելու համար քաշեք և գցեք վերնագիրն այստեղ։'
	        },
	        search: {
	          placeholder: 'Փնտրում...',
	          showingItems: 'Ցուցադրված տվյալներ՝',
	          selectedItems: 'Ընտրված:',
	          totalItems: 'Ընդամենը՝',
	          size: 'Տողերի քանակը էջում՝',
	          first: 'Առաջին էջ',
	          next: 'Հաջորդ էջ',
	          previous: 'Նախորդ էջ',
	          last: 'Վերջին էջ'
	        },
	        menu: {
	          text: 'Ընտրել սյուները:'
	        },
	        sort: {
	          ascending: 'Աճման կարգով',
	          descending: 'Նվազման կարգով',
	          remove: 'Հանել '
	        },
	        column: {
	          hide: 'Թաքցնել սյունը'
	        },
	        aggregation: {
	          count: 'ընդամենը տող՝ ',
	          sum: 'ընդամենը՝ ',
	          avg: 'միջին՝ ',
	          min: 'մին՝ ',
	          max: 'մաքս՝ '
	        },
	        pinning: {
	          pinLeft: 'Կպցնել ձախ կողմում',
	          pinRight: 'Կպցնել աջ կողմում',
	          unpin: 'Արձակել'
	        },
	        gridMenu: {
	          columns: 'Սյուներ:',
	          importerTitle: 'Ներմուծել ֆայլ',
	          exporterAllAsCsv: 'Արտահանել ամբողջը CSV',
	          exporterVisibleAsCsv: 'Արտահանել երևացող տվյալները CSV',
	          exporterSelectedAsCsv: 'Արտահանել ընտրված տվյալները CSV',
	          exporterAllAsPdf: 'Արտահանել PDF',
	          exporterVisibleAsPdf: 'Արտահանել երևացող տվյալները PDF',
	          exporterSelectedAsPdf: 'Արտահանել ընտրված տվյալները PDF',
	          exporterAllAsExcel: 'Արտահանել excel',
	          exporterVisibleAsExcel: 'Արտահանել երևացող տվյալները excel',
	          exporterSelectedAsExcel: 'Արտահանել ընտրված տվյալները excel',
	          clearAllFilters: 'Մաքրել բոլոր ֆիլտրերը'
	        },
	        importer: {
	          noHeaders: 'Հնարավոր չեղավ որոշել սյան վերնագրերը։ Արդյո՞ք ֆայլը ունի վերնագրեր։',
	          noObjects: 'Հնարավոր չեղավ կարդալ տվյալները։ Արդյո՞ք ֆայլում կան տվյալներ։',
	          invalidCsv: 'Հնարավոր չեղավ մշակել ֆայլը։ Արդյո՞ք այն վավեր CSV է։',
	          invalidJson: 'Հնարավոր չեղավ մշակել ֆայլը։ Արդյո՞ք այն վավեր Json է։',
	          jsonNotArray: 'Ներմուծված json ֆայլը պետք է պարունակի զանգված, կասեցվում է։'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('is', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: 'Sía fyrir dálk',
	            removeFilter: 'Fjarlægja síu',
	            columnMenuButtonLabel: 'Dálkavalmynd'
	          },
	          priority: 'Forgangsröðun:',
	          filterLabel: "Sía fyrir dálka: "
	        },
	        aggregate: {
	          label: 'hlutir'
	        },
	        groupPanel: {
	          description: 'Dragðu dálkhaus hingað til að flokka saman eftir þeim dálki.'
	        },
	        search: {
	          placeholder: 'Leita...',
	          showingItems: 'Sýni hluti:',
	          selectedItems: 'Valdir hlutir:',
	          totalItems: 'Hlutir alls:',
	          size: 'Stærð síðu:',
	          first: 'Fyrsta síða',
	          next: 'Næsta síða',
	          previous: 'Fyrri síða',
	          last: 'Síðasta síða'
	        },
	        menu: {
	          text: 'Veldu dálka:'
	        },
	        sort: {
	          ascending: 'Raða hækkandi',
	          descending: 'Raða lækkandi',
	          none: 'Engin röðun',
	          remove: 'Fjarlægja röðun'
	        },
	        column: {
	          hide: 'Fela dálk'
	        },
	        aggregation: {
	          count: 'fjöldi raða: ',
	          sum: 'summa: ',
	          avg: 'meðaltal: ',
	          min: 'lágmark: ',
	          max: 'hámark: '
	        },
	        pinning: {
	          pinLeft: 'Festa til vinstri',
	          pinRight: 'Festa til hægri',
	          unpin: 'Losa'
	        },
	        columnMenu: {
	          close: 'Loka'
	        },
	        gridMenu: {
	          aria: {
	            buttonLabel: 'Töflu valmynd'
	          },
	          columns: 'Dálkar:',
	          importerTitle: 'Flytja inn skjal',
	          exporterAllAsCsv: 'Flytja út gögn sem csv',
	          exporterVisibleAsCsv: 'Flytja út sýnileg gögn sem csv',
	          exporterSelectedAsCsv: 'Flytja út valin gögn sem csv',
	          exporterAllAsPdf: 'Flytja út öll gögn sem pdf',
	          exporterVisibleAsPdf: 'Flytja út sýnileg gögn sem pdf',
	          exporterSelectedAsPdf: 'Flytja út valin gögn sem pdf',
	          clearAllFilters: 'Hreinsa allar síur'
	        },
	        importer: {
	          noHeaders: 'Ekki hægt að vinna dálkanöfn úr skjalinu, er skjalið örugglega með haus?',
	          noObjects: 'Ekki hægt að vinna hluti úr skjalinu, voru örugglega gögn í skjalinu önnur en hausinn?',
	          invalidCsv: 'Tókst ekki að vinna skjal, er það örggulega gilt CSV?',
	          invalidJson: 'Tókst ekki að vinna skjal, er það örugglega gilt Json?',
	          jsonNotArray: 'Innflutt json skjal verður að innihalda fylki, hætti við.'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: 'Fletta að fyrstu',
	            pageBack: 'Fletta til baka',
	            pageSelected: 'Valin síða',
	            pageForward: 'Fletta áfram',
	            pageToLast: 'Fletta að síðustu'
	          },
	          sizes: 'hlutir á síðu',
	          totalItems: 'hlutir',
	          through: 'gegnum',
	          of: 'af'
	        },
	        grouping: {
	          group: 'Flokka',
	          ungroup: 'Sundurliða',
	          aggregate_count: 'Fjöldi: ',
	          aggregate_sum: 'Summa: ',
	          aggregate_max: 'Hámark: ',
	          aggregate_min: 'Lágmark: ',
	          aggregate_avg: 'Meðaltal: ',
	          aggregate_remove: 'Fjarlægja: '
	        },
	        validate: {
	          error: 'Villa:',
	          minLength: 'Gildi ætti að vera a.m.k. THRESHOLD stafa langt.',
	          maxLength: 'Gildi ætti að vera í mesta lagi THRESHOLD stafa langt.',
	          required: 'Þarf að hafa gildi.'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('it', {
	        aggregate: {
	          label: 'elementi'
	        },
	        groupPanel: {
	          description: 'Trascina un\'intestazione all\'interno del gruppo della colonna.'
	        },
	        search: {
	          placeholder: 'Ricerca...',
	          showingItems: 'Mostra:',
	          selectedItems: 'Selezionati:',
	          totalItems: 'Totali:',
	          size: 'Tot Pagine:',
	          first: 'Prima',
	          next: 'Prossima',
	          previous: 'Precedente',
	          last: 'Ultima'
	        },
	        menu: {
	          text: 'Scegli le colonne:'
	        },
	        sort: {
	          ascending: 'Asc.',
	          descending: 'Desc.',
	          remove: 'Annulla ordinamento'
	        },
	        column: {
	          hide: 'Nascondi'
	        },
	        aggregation: {
	          count: 'righe totali: ',
	          sum: 'tot: ',
	          avg: 'media: ',
	          min: 'minimo: ',
	          max: 'massimo: '
	        },
	        pinning: {
	         pinLeft: 'Blocca a sx',
	          pinRight: 'Blocca a dx',
	          unpin: 'Blocca in alto'
	        },
	        gridMenu: {
	          columns: 'Colonne:',
	          importerTitle: 'Importa',
	          exporterAllAsCsv: 'Esporta tutti i dati in CSV',
	          exporterVisibleAsCsv: 'Esporta i dati visibili in CSV',
	          exporterSelectedAsCsv: 'Esporta i dati selezionati in CSV',
	          exporterAllAsPdf: 'Esporta tutti i dati in PDF',
	          exporterVisibleAsPdf: 'Esporta i dati visibili in PDF',
	          exporterSelectedAsPdf: 'Esporta i dati selezionati in PDF',
	          exporterAllAsExcel: 'Esporta tutti i dati in excel',
	          exporterVisibleAsExcel: 'Esporta i dati visibili in excel',
	          exporterSelectedAsExcel: 'Esporta i dati selezionati in excel',
	          clearAllFilters: 'Pulire tutti i filtri'
	        },
	        importer: {
	          noHeaders: 'Impossibile reperire i nomi delle colonne, sicuro che siano indicati all\'interno del file?',
	          noObjects: 'Impossibile reperire gli oggetti, sicuro che siano indicati all\'interno del file?',
	          invalidCsv: 'Impossibile elaborare il file, sicuro che sia un CSV?',
	          invalidJson: 'Impossibile elaborare il file, sicuro che sia un JSON valido?',
	          jsonNotArray: 'Errore! Il file JSON da importare deve contenere un array.'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: 'Prima',
	            pageBack: 'Indietro',
	            pageSelected: 'Pagina selezionata',
	            pageForward: 'Avanti',
	            pageToLast: 'Ultima'
	          },
	          sizes: 'elementi per pagina',
	          totalItems: 'elementi',
	          through: 'a',
	          of: 'di'
	        },
	        grouping: {
	          group: 'Raggruppa',
	          ungroup: 'Separa',
	          aggregate_count: 'Agg: N. Elem.',
	          aggregate_sum: 'Agg: Somma',
	          aggregate_max: 'Agg: Massimo',
	          aggregate_min: 'Agg: Minimo',
	          aggregate_avg: 'Agg: Media',
	          aggregate_remove: 'Agg: Rimuovi'
	        },
	        validate: {
	          error: 'Errore:',
	          minLength: 'Lunghezza minima pari a THRESHOLD caratteri.',
	          maxLength: 'Lunghezza massima pari a THRESHOLD caratteri.',
	          required: 'Necessario inserire un valore.'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function() {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('ja', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: '列のフィルター',
	            removeFilter: 'フィルターの解除',
	            columnMenuButtonLabel: '列のメニュー'
	          },
	          priority: '優先度:',
	          filterLabel: "列フィルター: "
	        },
	        aggregate: {
	          label: '項目'
	        },
	        groupPanel: {
	          description: 'ここに列ヘッダをドラッグアンドドロップして、その列でグループ化します。'
	        },
	        search: {
	          placeholder: '検索...',
	          showingItems: '表示中の項目:',
	          selectedItems: '選択した項目:',
	          totalItems: '項目の総数:',
	          size: 'ページサイズ:',
	          first: '最初のページ',
	          next: '次のページ',
	          previous: '前のページ',
	          last: '前のページ'
	        },
	        menu: {
	          text: '列の選択:'
	        },
	        sort: {
	          ascending: '昇順に並べ替え',
	          descending: '降順に並べ替え',
	          none: '並べ替え無し',
	          remove: '並べ替えの解除'
	        },
	        column: {
	          hide: '列の非表示'
	        },
	        aggregation: {
	          count: '行数: ',
	          sum: '合計: ',
	          avg: '平均: ',
	          min: '最小: ',
	          max: '最大: '
	        },
	        pinning: {
	          pinLeft: '左に固定',
	          pinRight: '右に固定',
	          unpin: '固定解除'
	        },
	        columnMenu: {
	          close: '閉じる'
	        },
	        gridMenu: {
	          aria: {
	            buttonLabel: 'グリッドメニュー'
	          },
	          columns: '列の表示/非表示:',
	          importerTitle: 'ファイルのインポート',
	          exporterAllAsCsv: 'すべてのデータをCSV形式でエクスポート',
	          exporterVisibleAsCsv: '表示中のデータをCSV形式でエクスポート',
	          exporterSelectedAsCsv: '選択したデータをCSV形式でエクスポート',
	          exporterAllAsPdf: 'すべてのデータをPDF形式でエクスポート',
	          exporterVisibleAsPdf: '表示中のデータをPDF形式でエクスポート',
	          exporterSelectedAsPdf: '選択したデータをPDF形式でエクスポート',
	          clearAllFilters: 'すべてのフィルタをクリア'
	        },
	        importer: {
	          noHeaders: '列名を取得できません。ファイルにヘッダが含まれていることを確認してください。',
	          noObjects: 'オブジェクトを取得できません。ファイルにヘッダ以外のデータが含まれていることを確認してください。',
	          invalidCsv: 'ファイルを処理できません。ファイルが有効なCSV形式であることを確認してください。',
	          invalidJson: 'ファイルを処理できません。ファイルが有効なJSON形式であることを確認してください。',
	          jsonNotArray: 'インポートしたJSONファイルには配列が含まれている必要があります。処理を中止します。'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: '最初のページ',
	            pageBack: '前のページ',
	            pageSelected: '現在のページ',
	            pageForward: '次のページ',
	            pageToLast: '最後のページ'
	          },
	          sizes: '項目/ページ',
	          totalItems: '項目',
	          through: 'から',
	          of: '項目/全'
	        },
	        grouping: {
	          group: 'グループ化',
	          ungroup: 'グループ化の解除',
	          aggregate_count: '集計表示: 行数',
	          aggregate_sum: '集計表示: 合計',
	          aggregate_max: '集計表示: 最大',
	          aggregate_min: '集計表示: 最小',
	          aggregate_avg: '集計表示: 平均',
	          aggregate_remove: '集計表示: 解除'
	        },
	        validate: {
	          error: 'Error:',
	          minLength: 'THRESHOLD 文字以上で入力してください。',
	          maxLength: 'THRESHOLD 文字以下で入力してください。',
	          required: '値が必要です。'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('ko', {
	        aggregate: {
	          label: '아이템'
	        },
	        groupPanel: {
	          description: '컬럼으로 그룹핑하기 위해서는 컬럼 헤더를 끌어 떨어뜨려 주세요.'
	        },
	        search: {
	          placeholder: '검색...',
	          showingItems: '항목 보여주기:',
	          selectedItems: '선택 항목:',
	          totalItems: '전체 항목:',
	          size: '페이지 크기:',
	          first: '첫번째 페이지',
	          next: '다음 페이지',
	          previous: '이전 페이지',
	          last: '마지막 페이지'
	        },
	        menu: {
	          text: '컬럼을 선택하세요:'
	        },
	        sort: {
	          ascending: '오름차순 정렬',
	          descending: '내림차순 정렬',
	          remove: '소팅 제거'
	        },
	        column: {
	          hide: '컬럼 제거'
	        },
	        aggregation: {
	          count: '전체 갯수: ',
	          sum: '전체: ',
	          avg: '평균: ',
	          min: '최소: ',
	          max: '최대: '
	        },
	        pinning: {
	         pinLeft: '왼쪽 핀',
	          pinRight: '오른쪽 핀',
	          unpin: '핀 제거'
	        },
	        gridMenu: {
	          columns: '컬럼:',
	          importerTitle: '파일 가져오기',
	          exporterAllAsCsv: 'csv로 모든 데이터 내보내기',
	          exporterVisibleAsCsv: 'csv로 보이는 데이터 내보내기',
	          exporterSelectedAsCsv: 'csv로 선택된 데이터 내보내기',
	          exporterAllAsPdf: 'pdf로 모든 데이터 내보내기',
	          exporterVisibleAsPdf: 'pdf로 보이는 데이터 내보내기',
	          exporterSelectedAsPdf: 'pdf로 선택 데이터 내보내기',
	          clearAllFilters: '모든 필터를 청소'
	        },
	        importer: {
	          noHeaders: '컬럼명이 지정되어 있지 않습니다. 파일에 헤더가 명시되어 있는지 확인해 주세요.',
	          noObjects: '데이터가 지정되어 있지 않습니다. 데이터가 파일에 있는지 확인해 주세요.',
	          invalidCsv: '파일을 처리할 수 없습니다. 올바른 csv인지 확인해 주세요.',
	          invalidJson: '파일을 처리할 수 없습니다. 올바른 json인지 확인해 주세요.',
	          jsonNotArray: 'json 파일은 배열을 포함해야 합니다.'
	        },
	        pagination: {
	          sizes: '페이지당 항목',
	          totalItems: '전체 항목'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('nl', {
	        aggregate: {
	          label: 'items'
	        },
	        groupPanel: {
	          description: 'Sleep hier een kolomnaam heen om op te groeperen.'
	        },
	        search: {
	          placeholder: 'Zoeken...',
	          showingItems: 'Getoonde items:',
	          selectedItems: 'Geselecteerde items:',
	          totalItems: 'Totaal aantal items:',
	          size: 'Items per pagina:',
	          first: 'Eerste pagina',
	          next: 'Volgende pagina',
	          previous: 'Vorige pagina',
	          last: 'Laatste pagina'
	        },
	        menu: {
	          text: 'Kies kolommen:'
	        },
	        sort: {
	          ascending: 'Sorteer oplopend',
	          descending: 'Sorteer aflopend',
	          remove: 'Verwijder sortering'
	        },
	        column: {
	          hide: 'Verberg kolom'
	        },
	        aggregation: {
	          count: 'Aantal rijen: ',
	          sum: 'Som: ',
	          avg: 'Gemiddelde: ',
	          min: 'Min: ',
	          max: 'Max: '
	        },
	        pinning: {
	          pinLeft: 'Zet links vast',
	          pinRight: 'Zet rechts vast',
	          unpin: 'Maak los'
	        },
	        gridMenu: {
	          columns: 'Kolommen:',
	          importerTitle: 'Importeer bestand',
	          exporterAllAsCsv: 'Exporteer alle data als csv',
	          exporterVisibleAsCsv: 'Exporteer zichtbare data als csv',
	          exporterSelectedAsCsv: 'Exporteer geselecteerde data als csv',
	          exporterAllAsPdf: 'Exporteer alle data als pdf',
	          exporterVisibleAsPdf: 'Exporteer zichtbare data als pdf',
	          exporterSelectedAsPdf: 'Exporteer geselecteerde data als pdf',
	          exporterAllAsExcel: 'Exporteer alle data als excel',
	          exporterVisibleAsExcel: 'Exporteer zichtbare data als excel',
	          exporterSelectedAsExcel: 'Exporteer alle data als excel',
	          clearAllFilters: 'Reinig alle filters'
	        },
	        importer: {
	          noHeaders: 'Kolomnamen kunnen niet worden afgeleid. Heeft het bestand een header?',
	          noObjects: 'Objecten kunnen niet worden afgeleid. Bevat het bestand data naast de headers?',
	          invalidCsv: 'Het bestand kan niet verwerkt worden. Is het een valide csv bestand?',
	          invalidJson: 'Het bestand kan niet verwerkt worden. Is het valide json?',
	          jsonNotArray: 'Het json bestand moet een array bevatten. De actie wordt geannuleerd.'
	        },
	        pagination: {
	            sizes: 'items per pagina',
	            totalItems: 'items',
	            of: 'van de'
	        },
	        grouping: {
	            group: 'Groepeer',
	            ungroup: 'Groepering opheffen',
	            aggregate_count: 'Agg: Aantal',
	            aggregate_sum: 'Agg: Som',
	            aggregate_max: 'Agg: Max',
	            aggregate_min: 'Agg: Min',
	            aggregate_avg: 'Agg: Gem',
	            aggregate_remove: 'Agg: Verwijder'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('no', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: 'Filter for kolonne',
	            removeFilter: 'Fjern filter',
	            columnMenuButtonLabel: 'Kolonnemeny'
	          },
	          priority: 'Prioritet:',
	          filterLabel: "Filter for kolonne: "
	        },
	        aggregate: {
	          label: 'elementer'
	        },
	        groupPanel: {
	          description: 'Trekk en kolonneoverskrift hit og slipp den for å gruppere etter den kolonnen.'
	        },
	        search: {
	          placeholder: 'Søk...',
	          showingItems: 'Viste elementer:',
	          selectedItems: 'Valgte elementer:',
	          totalItems: 'Antall elementer:',
	          size: 'Sidestørrelse:',
	          first: 'Første side',
	          next: 'Neste side',
	          previous: 'Forrige side',
	          last: 'Siste side'
	        },
	        menu: {
	          text: 'Velg kolonner:'
	        },
	        sort: {
	          ascending: 'Sortere stigende',
	          descending: 'Sortere fallende',
	          none: 'Ingen sortering',
	          remove: 'Fjern sortering'
	        },
	        column: {
	          hide: 'Skjul kolonne'
	        },
	        aggregation: {
	          count: 'antall rader: ',
	          sum: 'total: ',
	          avg: 'gjennomsnitt: ',
	          min: 'minimum: ',
	          max: 'maksimum: '
	        },
	        pinning: {
	          pinLeft: 'Fest til venstre',
	          pinRight: 'Fest til høyre',
	          unpin: 'Løsne'
	        },
	        columnMenu: {
	          close: 'Lukk'
	        },
	        gridMenu: {
	          aria: {
	            buttonLabel: 'Grid Menu'
	          },
	          columns: 'Kolonner:',
	          importerTitle: 'Importer fil',
	          exporterAllAsCsv: 'Eksporter alle data som csv',
	          exporterVisibleAsCsv: 'Eksporter synlige data som csv',
	          exporterSelectedAsCsv: 'Eksporter utvalgte data som csv',
	          exporterAllAsPdf: 'Eksporter alle data som pdf',
	          exporterVisibleAsPdf: 'Eksporter synlige data som pdf',
	          exporterSelectedAsPdf: 'Eksporter utvalgte data som pdf',
	          exporterAllAsExcel: 'Eksporter alle data som excel',
	          exporterVisibleAsExcel: 'Eksporter synlige data som excel',
	          exporterSelectedAsExcel: 'Eksporter utvalgte data som excel',
	          clearAllFilters: 'Clear all filters'
	        },
	        importer: {
	          noHeaders: 'Kolonnenavn kunne ikke avledes. Har filen en overskrift?',
	          noObjects: 'Objekter kunne ikke avledes. Er der andre data i filen enn overskriften?',
	          invalidCsv: 'Filen kunne ikke behandles. Er den gyldig CSV?',
	          invalidJson: 'Filen kunne ikke behandles. Er den gyldig JSON?',
	          jsonNotArray: 'Importert JSON-fil må inneholde en liste. Avbryter.'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: 'Gå til første side',
	            pageBack: 'Gå til forrige side',
	            pageSelected: 'Valgte side',
	            pageForward: 'Gå til neste side',
	            pageToLast: 'Gå til siste side'
	          },
	          sizes: 'elementer per side',
	          totalItems: 'elementer',
	          through: 'til',
	          of: 'av'
	        },
	        grouping: {
	          group: 'Gruppere',
	          ungroup: 'Fjerne gruppering',
	          aggregate_count: 'Agr: Antall',
	          aggregate_sum: 'Agr: Sum',
	          aggregate_max: 'Agr: Maksimum',
	          aggregate_min: 'Agr: Minimum',
	          aggregate_avg: 'Agr: Gjennomsnitt',
	          aggregate_remove: 'Agr: Fjern'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('pl', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: 'Filtr dla kolumny',
	            removeFilter: 'Usuń filtr',
	            columnMenuButtonLabel: 'Opcje kolumny',
	            column: 'Kolumna'
	          },
	          priority: 'Priorytet:',
	          filterLabel: "Filtr dla kolumny: "
	        },
	        aggregate: {
	          label: 'pozycji'
	        },
	        groupPanel: {
	          description: 'Przeciągnij nagłówek kolumny tutaj, aby pogrupować według niej.'
	        },
	        search: {
	          aria: {
	            selected: 'Wiersz zaznaczony',
	            notSelected: 'Wiersz niezaznaczony'
	          },
	          placeholder: 'Szukaj...',
	          showingItems: 'Widoczne pozycje:',
	          selectedItems: 'Zaznaczone pozycje:',
	          totalItems: 'Wszystkich pozycji:',
	          size: 'Rozmiar strony:',
	          first: 'Pierwsza strona',
	          next: 'Następna strona',
	          previous: 'Poprzednia strona',
	          last: 'Ostatnia strona'
	        },
	        menu: {
	          text: 'Wybierz kolumny:'
	        },
	        sort: {
	          ascending: 'Sortuj rosnąco',
	          descending: 'Sortuj malejąco',
	          none: 'Brak sortowania',
	          remove: 'Wyłącz sortowanie'
	        },
	        column: {
	          hide: 'Ukryj kolumnę'
	        },
	        aggregation: {
	          count: 'Razem pozycji: ',
	            sum: 'Razem: ',
	            avg: 'Średnia: ',
	            min: 'Min: ',
	            max: 'Max: '
	        },
	        pinning: {
	          pinLeft: 'Przypnij do lewej',
	          pinRight: 'Przypnij do prawej',
	          unpin: 'Odepnij'
	        },
	        columnMenu: {
	          close: 'Zamknij'
	        },
	        gridMenu: {
	          aria: {
	            buttonLabel: 'Opcje tabeli'
	          },
	          columns: 'Kolumny:',
	          importerTitle: 'Importuj plik',
	          exporterAllAsCsv: 'Eksportuj wszystkie dane do csv',
	          exporterVisibleAsCsv: 'Eksportuj widoczne dane do csv',
	          exporterSelectedAsCsv: 'Eksportuj zaznaczone dane do csv',
	          exporterAllAsPdf: 'Eksportuj wszystkie dane do pdf',
	          exporterVisibleAsPdf: 'Eksportuj widoczne dane do pdf',
	          exporterSelectedAsPdf: 'Eksportuj zaznaczone dane do pdf',
	          exporterAllAsExcel: 'Eksportuj wszystkie dane do excel',
	          exporterVisibleAsExcel: 'Eksportuj widoczne dane do excel',
	          exporterSelectedAsExcel: 'Eksportuj zaznaczone dane do excel',
	          clearAllFilters: 'Wyczyść filtry'
	        },
	        importer: {
	          noHeaders: 'Nie udało się wczytać nazw kolumn. Czy plik posiada nagłówek?',
	          noObjects: 'Nie udalo się wczytać pozycji. Czy plik zawiera dane?',
	          invalidCsv: 'Nie udało się przetworzyć pliku. Czy to prawidłowy plik CSV?',
	          invalidJson: 'Nie udało się przetworzyć pliku. Czy to prawidłowy plik JSON?',
	          jsonNotArray: 'Importowany plik JSON musi zawierać tablicę. Importowanie przerwane.'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: 'Pierwsza strona',
	            pageBack: 'Poprzednia strona',
	            pageSelected: 'Wybrana strona',
	            pageForward: 'Następna strona',
	            pageToLast: 'Ostatnia strona'
	          },
	          sizes: 'pozycji na stronę',
	          totalItems: 'pozycji',
	          through: 'do',
	          of: 'z'
	        },
	        grouping: {
	          group: 'Grupuj',
	          ungroup: 'Rozgrupuj',
	          aggregate_count: 'Zbiorczo: Razem',
	          aggregate_sum: 'Zbiorczo: Suma',
	          aggregate_max: 'Zbiorczo: Max',
	          aggregate_min: 'Zbiorczo: Min',
	          aggregate_avg: 'Zbiorczo: Średnia',
	          aggregate_remove: 'Zbiorczo: Usuń'
	        },
	        validate: {
	          error: 'Błąd:',
	          minLength: 'Wartość powinna składać się z co najmniej THRESHOLD znaków.',
	          maxLength: 'Wartość powinna składać się z przynajmniej THRESHOLD znaków.',
	          required: 'Wartość jest wymagana.'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('pt-br', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: 'Filtro por coluna',
	            removeFilter: 'Remover filtro',
	            columnMenuButtonLabel: 'Menu coluna'
	          },
	          priority: 'Prioridade:',
	          filterLabel: "Filtro por coluna: "
	        },
	        aggregate: {
	          label: 'itens'
	        },
	        groupPanel: {
	          description: 'Arraste e solte uma coluna aqui para agrupar por essa coluna'
	        },
	        search: {
	          placeholder: 'Procurar...',
	          showingItems: 'Mostrando os Itens:',
	          selectedItems: 'Items Selecionados:',
	          totalItems: 'Total de Itens:',
	          size: 'Tamanho da Página:',
	          first: 'Primeira Página',
	          next: 'Próxima Página',
	          previous: 'Página Anterior',
	          last: 'Última Página'
	        },
	        menu: {
	          text: 'Selecione as colunas:'
	        },
	        sort: {
	          ascending: 'Ordenar Ascendente',
	          descending: 'Ordenar Descendente',
	          none: 'Nenhuma Ordem',
	          remove: 'Remover Ordenação'
	        },
	        column: {
	          hide: 'Esconder coluna'
	        },
	        aggregation: {
	          count: 'total de linhas: ',
	          sum: 'total: ',
	          avg: 'med: ',
	          min: 'min: ',
	          max: 'max: '
	        },
	        pinning: {
	          pinLeft: 'Fixar Esquerda',
	          pinRight: 'Fixar Direita',
	          unpin: 'Desprender'
	        },
	        columnMenu: {
	          close: 'Fechar'
	        },
	        gridMenu: {
	          aria: {
	            buttonLabel: 'Menu Grid'
	          },
	          columns: 'Colunas:',
	          importerTitle: 'Importar arquivo',
	          exporterAllAsCsv: 'Exportar todos os dados como csv',
	          exporterVisibleAsCsv: 'Exportar dados visíveis como csv',
	          exporterSelectedAsCsv: 'Exportar dados selecionados como csv',
	          exporterAllAsPdf: 'Exportar todos os dados como pdf',
	          exporterVisibleAsPdf: 'Exportar dados visíveis como pdf',
	          exporterSelectedAsPdf: 'Exportar dados selecionados como pdf',
	          exporterAllAsExcel: 'Exportar todos os dados como excel',
	          exporterVisibleAsExcel: 'Exportar dados visíveis como excel',
	          clearAllFilters: 'Limpar todos os filtros'
	        },
	        importer: {
	          noHeaders: 'Nomes de colunas não puderam ser derivados. O arquivo tem um cabeçalho?',
	          noObjects: 'Objetos não puderam ser derivados. Havia dados no arquivo, além dos cabeçalhos?',
	          invalidCsv: 'Arquivo não pode ser processado. É um CSV válido?',
	          invalidJson: 'Arquivo não pode ser processado. É um Json válido?',
	          jsonNotArray: 'Arquivo json importado tem que conter um array. Abortando.'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: 'Primeira página',
	            pageBack: 'Página anterior',
	            pageSelected: 'Página Selecionada',
	            pageForward: 'Proxima',
	            pageToLast: 'Anterior'
	          },
	          sizes: 'itens por página',
	          totalItems: 'itens',
	          through: 'através dos',
	          of: 'de'
	        },
	        grouping: {
	          group: 'Agrupar',
	          ungroup: 'Desagrupar',
	          aggregate_count: 'Agr: Contar',
	          aggregate_sum: 'Agr: Soma',
	          aggregate_max: 'Agr: Max',
	          aggregate_min: 'Agr: Min',
	          aggregate_avg: 'Agr: Med',
	          aggregate_remove: 'Agr: Remover'
	        }
	      });
	      return $delegate;
	    }]);
	}]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('pt', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: 'Filtro por coluna',
	            removeFilter: 'Remover filtro',
	            columnMenuButtonLabel: 'Menu coluna'
	          },
	          priority: 'Prioridade:',
	          filterLabel: "Filtro por coluna: "
	        },
	        aggregate: {
	          label: 'itens'
	        },
	        groupPanel: {
	          description: 'Arraste e solte uma coluna aqui para agrupar por essa coluna'
	        },
	        search: {
	          placeholder: 'Procurar...',
	          showingItems: 'Mostrando os Itens:',
	          selectedItems: 'Itens Selecionados:',
	          totalItems: 'Total de Itens:',
	          size: 'Tamanho da Página:',
	          first: 'Primeira Página',
	          next: 'Próxima Página',
	          previous: 'Página Anterior',
	          last: 'Última Página'
	        },
	        menu: {
	          text: 'Selecione as colunas:'
	        },
	        sort: {
	          ascending: 'Ordenar Ascendente',
	          descending: 'Ordenar Descendente',
	          none: 'Nenhuma Ordem',
	          remove: 'Remover Ordenação'
	        },
	        column: {
	          hide: 'Esconder coluna'
	        },
	        aggregation: {
	          count: 'total de linhas: ',
	          sum: 'total: ',
	          avg: 'med: ',
	          min: 'min: ',
	          max: 'max: '
	        },
	        pinning: {
	          pinLeft: 'Fixar Esquerda',
	          pinRight: 'Fixar Direita',
	          unpin: 'Desprender'
	        },
	        columnMenu: {
	          close: 'Fechar'
	        },
	        gridMenu: {
	          aria: {
	            buttonLabel: 'Menu Grid'
	          },
	          columns: 'Colunas:',
	          importerTitle: 'Importar ficheiro',
	          exporterAllAsCsv: 'Exportar todos os dados como csv',
	          exporterVisibleAsCsv: 'Exportar dados visíveis como csv',
	          exporterSelectedAsCsv: 'Exportar dados selecionados como csv',
	          exporterAllAsPdf: 'Exportar todos os dados como pdf',
	          exporterVisibleAsPdf: 'Exportar dados visíveis como pdf',
	          exporterSelectedAsPdf: 'Exportar dados selecionados como pdf',
	          clearAllFilters: 'Limpar todos os filtros'
	        },
	        importer: {
	          noHeaders: 'Nomes de colunas não puderam ser derivados. O ficheiro tem um cabeçalho?',
	          noObjects: 'Objetos não puderam ser derivados. Havia dados no ficheiro, além dos cabeçalhos?',
	          invalidCsv: 'Ficheiro não pode ser processado. É um CSV válido?',
	          invalidJson: 'Ficheiro não pode ser processado. É um Json válido?',
	          jsonNotArray: 'Ficheiro json importado tem que conter um array. Interrompendo.'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: 'Primeira página',
	            pageBack: 'Página anterior',
	            pageSelected: 'Página Selecionada',
	            pageForward: 'Próxima',
	            pageToLast: 'Anterior'
	          },
	          sizes: 'itens por página',
	          totalItems: 'itens',
	          through: 'a',
	          of: 'de'
	        },
	        grouping: {
	          group: 'Agrupar',
	          ungroup: 'Desagrupar',
	          aggregate_count: 'Agr: Contar',
	          aggregate_sum: 'Agr: Soma',
	          aggregate_max: 'Agr: Max',
	          aggregate_min: 'Agr: Min',
	          aggregate_avg: 'Agr: Med',
	          aggregate_remove: 'Agr: Remover'
	        }
	      });
	      return $delegate;
	    }]);
	}]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('ro', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: 'Filtru pentru coloana',
	            removeFilter: 'Sterge filtru',
	            columnMenuButtonLabel: 'Column Menu'
	          },
	          priority: 'Prioritate:',
	          filterLabel: "Filtru pentru coloana:"
	        },
	        aggregate: {
	          label: 'Elemente'
	        },
	        groupPanel: {
	          description: 'Trage un cap de coloana aici pentru a grupa elementele dupa coloana respectiva'
	        },
	        search: {
	          placeholder: 'Cauta...',
	          showingItems: 'Arata elementele:',
	          selectedItems: 'Elementele selectate:',
	          totalItems: 'Total elemente:',
	          size: 'Marime pagina:',
	          first: 'Prima pagina',
	          next: 'Pagina urmatoare',
	          previous: 'Pagina anterioara',
	          last: 'Ultima pagina'
	        },
	        menu: {
	          text: 'Alege coloane:'
	        },
	        sort: {
	          ascending: 'Ordoneaza crescator',
	          descending: 'Ordoneaza descrescator',
	          none: 'Fara ordonare',
	          remove: 'Sterge ordonarea'
	        },
	        column: {
	          hide: 'Ascunde coloana'
	        },
	        aggregation: {
	          count: 'total linii: ',
	          sum: 'total: ',
	          avg: 'medie: ',
	          min: 'min: ',
	          max: 'max: '
	        },
	        pinning: {
	          pinLeft: 'Pin la stanga',
	          pinRight: 'Pin la dreapta',
	          unpin: 'Sterge pinul'
	        },
	        columnMenu: {
	          close: 'Inchide'
	        },
	        gridMenu: {
	          aria: {
	            buttonLabel: 'Grid Menu'
	          },
	          columns: 'Coloane:',
	          importerTitle: 'Incarca fisier',
	          exporterAllAsCsv: 'Exporta toate datele ca csv',
	          exporterVisibleAsCsv: 'Exporta datele vizibile ca csv',
	          exporterSelectedAsCsv: 'Exporta datele selectate ca csv',
	          exporterAllAsPdf: 'Exporta toate datele ca pdf',
	          exporterVisibleAsPdf: 'Exporta datele vizibile ca pdf',
	          exporterSelectedAsPdf: 'Exporta datele selectate ca csv pdf',
	          clearAllFilters: 'Sterge toate filtrele'
	        },
	        importer: {
	          noHeaders: 'Numele coloanelor nu a putut fi incarcat, acest fisier are un header?',
	          noObjects: 'Datele nu au putut fi incarcate, exista date in fisier in afara numelor de coloane?',
	          invalidCsv: 'Fisierul nu a putut fi procesat, ati incarcat un CSV valid ?',
	          invalidJson: 'Fisierul nu a putut fi procesat, ati incarcat un Json valid?',
	          jsonNotArray: 'Json-ul incarcat trebuie sa contina un array, inchidere.'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: 'Prima pagina',
	            pageBack: 'O pagina inapoi',
	            pageSelected: 'Pagina selectata',
	            pageForward: 'O pagina inainte',
	            pageToLast: 'Ultima pagina'
	          },
	          sizes: 'Elemente per pagina',
	          totalItems: 'elemente',
	          through: 'prin',
	          of: 'of'
	        },
	        grouping: {
	          group: 'Grupeaza',
	          ungroup: 'Opreste gruparea',
	          aggregate_count: 'Agg: Count',
	          aggregate_sum: 'Agg: Sum',
	          aggregate_max: 'Agg: Max',
	          aggregate_min: 'Agg: Min',
	          aggregate_avg: 'Agg: Avg',
	          aggregate_remove: 'Agg: Remove'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('ru', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: 'Фильтр столбца',
	            removeFilter: 'Удалить фильтр',
	            columnMenuButtonLabel: 'Меню столбца'
	          },
	          priority: 'Приоритет:',
	          filterLabel: "Фильтр столбца: "
	        },
	        aggregate: {
	          label: 'элементы'
	        },
	        groupPanel: {
	          description: 'Для группировки по столбцу перетащите сюда его название.'
	        },
	        search: {
	          placeholder: 'Поиск...',
	          showingItems: 'Показать элементы:',
	          selectedItems: 'Выбранные элементы:',
	          totalItems: 'Всего элементов:',
	          size: 'Размер страницы:',
	          first: 'Первая страница',
	          next: 'Следующая страница',
	          previous: 'Предыдущая страница',
	          last: 'Последняя страница'
	        },
	        menu: {
	          text: 'Выбрать столбцы:'
	        },
	        sort: {
	          ascending: 'По возрастанию',
	          descending: 'По убыванию',
	          none: 'Без сортировки',
	          remove: 'Убрать сортировку'
	        },
	        column: {
	          hide: 'Спрятать столбец'
	        },
	        aggregation: {
	          count: 'всего строк: ',
	          sum: 'итого: ',
	          avg: 'среднее: ',
	          min: 'мин: ',
	          max: 'макс: '
	        },
					pinning: {
						pinLeft: 'Закрепить слева',
						pinRight: 'Закрепить справа',
						unpin: 'Открепить'
					},
	        columnMenu: {
	          close: 'Закрыть'
	        },
	        gridMenu: {
	          aria: {
	            buttonLabel: 'Меню'
	          },
	          columns: 'Столбцы:',
	          importerTitle: 'Импортировать файл',
	          exporterAllAsCsv: 'Экспортировать всё в CSV',
	          exporterVisibleAsCsv: 'Экспортировать видимые данные в CSV',
	          exporterSelectedAsCsv: 'Экспортировать выбранные данные в CSV',
	          exporterAllAsPdf: 'Экспортировать всё в PDF',
	          exporterVisibleAsPdf: 'Экспортировать видимые данные в PDF',
	          exporterSelectedAsPdf: 'Экспортировать выбранные данные в PDF',
	          clearAllFilters: 'Очистите все фильтры'
	        },
	        importer: {
	          noHeaders: 'Не удалось получить названия столбцов, есть ли в файле заголовок?',
	          noObjects: 'Не удалось получить данные, есть ли в файле строки кроме заголовка?',
	          invalidCsv: 'Не удалось обработать файл, это правильный CSV-файл?',
	          invalidJson: 'Не удалось обработать файл, это правильный JSON?',
	          jsonNotArray: 'Импортируемый JSON-файл должен содержать массив, операция отменена.'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: 'Первая страница',
	            pageBack: 'Предыдущая страница',
	            pageSelected: 'Выбранная страница',
	            pageForward: 'Следующая страница',
	            pageToLast: 'Последняя страница'
	          },
	          sizes: 'строк на страницу',
	          totalItems: 'строк',
	          through: 'по',
	          of: 'из'
	        },
	        grouping: {
	          group: 'Группировать',
	          ungroup: 'Разгруппировать',
	          aggregate_count: 'Группировать: Count',
	          aggregate_sum: 'Для группы: Сумма',
	          aggregate_max: 'Для группы: Максимум',
	          aggregate_min: 'Для группы: Минимум',
	          aggregate_avg: 'Для группы: Среднее',
	          aggregate_remove: 'Для группы: Пусто'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('sk', {
	        aggregate: {
	          label: 'items'
	        },
	        groupPanel: {
	          description: 'Pretiahni sem názov stĺpca pre zoskupenie podľa toho stĺpca.'
	        },
	        search: {
	          placeholder: 'Hľadaj...',
	          showingItems: 'Zobrazujem položky:',
	          selectedItems: 'Vybraté položky:',
	          totalItems: 'Počet položiek:',
	          size: 'Počet:',
	          first: 'Prvá strana',
	          next: 'Ďalšia strana',
	          previous: 'Predchádzajúca strana',
	          last: 'Posledná strana'
	        },
	        menu: {
	          text: 'Vyberte stĺpce:'
	        },
	        sort: {
	          ascending: 'Zotriediť vzostupne',
	          descending: 'Zotriediť zostupne',
	          remove: 'Vymazať triedenie'
	        },
	        aggregation: {
	          count: 'total rows: ',
	          sum: 'total: ',
	          avg: 'avg: ',
	          min: 'min: ',
	          max: 'max: '
	        },
	        gridMenu: {
	          columns: 'Columns:',
	          importerTitle: 'Import file',
	          exporterAllAsCsv: 'Export all data as csv',
	          exporterVisibleAsCsv: 'Export visible data as csv',
	          exporterSelectedAsCsv: 'Export selected data as csv',
	          exporterAllAsPdf: 'Export all data as pdf',
	          exporterVisibleAsPdf: 'Export visible data as pdf',
	          exporterSelectedAsPdf: 'Export selected data as pdf',
	          exporterAllAsExcel: 'Export all data as excel',
	          exporterVisibleAsExcel: 'Export visible data as excel',
	          exporterSelectedAsExcel: 'Export selected data as excel',
	          clearAllFilters: 'Clear all filters'
	        },
	        importer: {
	          noHeaders: 'Column names were unable to be derived, does the file have a header?',
	          noObjects: 'Objects were not able to be derived, was there data in the file other than headers?',
	          invalidCsv: 'File was unable to be processed, is it valid CSV?',
	          invalidJson: 'File was unable to be processed, is it valid Json?',
	          jsonNotArray: 'Imported json file must contain an array, aborting.'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('sv', {
	        aggregate: {
	          label: 'Artiklar'
	        },
	        groupPanel: {
	          description: 'Dra en kolumnrubrik hit och släpp den för att gruppera efter den kolumnen.'
	        },
	        search: {
	          placeholder: 'Sök...',
	          showingItems: 'Visar artiklar:',
	          selectedItems: 'Valda artiklar:',
	          totalItems: 'Antal artiklar:',
	          size: 'Sidstorlek:',
	          first: 'Första sidan',
	          next: 'Nästa sida',
	          previous: 'Föregående sida',
	          last: 'Sista sidan'
	        },
	        menu: {
	          text: 'Välj kolumner:'
	        },
	        sort: {
	          ascending: 'Sortera stigande',
	          descending: 'Sortera fallande',
	          remove: 'Inaktivera sortering'
	        },
	        column: {
	          hide: 'Göm kolumn'
	        },
	        aggregation: {
	          count: 'Antal rader: ',
	          sum: 'Summa: ',
	          avg: 'Genomsnitt: ',
	          min: 'Min: ',
	          max: 'Max: '
	        },
	        pinning: {
	          pinLeft: 'Fäst vänster',
	          pinRight: 'Fäst höger',
	          unpin: 'Lösgör'
	        },
	        gridMenu: {
	          columns: 'Kolumner:',
	          importerTitle: 'Importera fil',
	          exporterAllAsCsv: 'Exportera all data som CSV',
	          exporterVisibleAsCsv: 'Exportera synlig data som CSV',
	          exporterSelectedAsCsv: 'Exportera markerad data som CSV',
	          exporterAllAsPdf: 'Exportera all data som PDF',
	          exporterVisibleAsPdf: 'Exportera synlig data som PDF',
	          exporterSelectedAsPdf: 'Exportera markerad data som PDF',
	          clearAllFilters: 'Rengör alla filter'
	        },
	        importer: {
	          noHeaders: 'Kolumnnamn kunde inte härledas. Har filen ett sidhuvud?',
	          noObjects: 'Objekt kunde inte härledas. Har filen data undantaget sidhuvud?',
	          invalidCsv: 'Filen kunde inte behandlas, är den en giltig CSV?',
	          invalidJson: 'Filen kunde inte behandlas, är den en giltig JSON?',
	          jsonNotArray: 'Importerad JSON-fil måste innehålla ett fält. Import avbruten.'
	        },
	        pagination: {
	          sizes: 'Artiklar per sida',
	          totalItems: 'Artiklar'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('ta', {
	        aggregate: {
	          label: 'உருப்படிகள்'
	        },
	        groupPanel: {
	          description: 'ஒரு பத்தியை குழுவாக அமைக்க அப்பத்தியின் தலைப்பை இங்கே  இழுத்து வரவும் '
	        },
	        search: {
	          placeholder: 'தேடல் ...',
	          showingItems: 'உருப்படிகளை காண்பித்தல்:',
	          selectedItems: 'தேர்ந்தெடுக்கப்பட்ட  உருப்படிகள்:',
	          totalItems: 'மொத்த உருப்படிகள்:',
	          size: 'பக்க அளவு: ',
	          first: 'முதல் பக்கம்',
	          next: 'அடுத்த பக்கம்',
	          previous: 'முந்தைய பக்கம் ',
	          last: 'இறுதி பக்கம்'
	        },
	        menu: {
	          text: 'பத்திகளை தேர்ந்தெடு:'
	        },
	        sort: {
	          ascending: 'மேலிருந்து கீழாக',
	          descending: 'கீழிருந்து மேலாக',
	          remove: 'வரிசையை நீக்கு'
	        },
	        column: {
	          hide: 'பத்தியை மறைத்து வை '
	        },
	        aggregation: {
	          count: 'மொத்த வரிகள்:',
	          sum: 'மொத்தம்: ',
	          avg: 'சராசரி: ',
	          min: 'குறைந்தபட்ச: ',
	          max: 'அதிகபட்ச: '
	        },
	        pinning: {
	         pinLeft: 'இடதுபுறமாக தைக்க ',
	          pinRight: 'வலதுபுறமாக தைக்க',
	          unpin: 'பிரி'
	        },
	        gridMenu: {
	          columns: 'பத்திகள்:',
	          importerTitle: 'கோப்பு : படித்தல்',
	          exporterAllAsCsv: 'எல்லா தரவுகளையும் கோப்பாக்கு: csv',
	          exporterVisibleAsCsv: 'இருக்கும் தரவுகளை கோப்பாக்கு: csv',
	          exporterSelectedAsCsv: 'தேர்ந்தெடுத்த தரவுகளை கோப்பாக்கு: csv',
	          exporterAllAsPdf: 'எல்லா தரவுகளையும் கோப்பாக்கு: pdf',
	          exporterVisibleAsPdf: 'இருக்கும் தரவுகளை கோப்பாக்கு: pdf',
	          exporterSelectedAsPdf: 'தேர்ந்தெடுத்த தரவுகளை கோப்பாக்கு: pdf',
	          clearAllFilters: 'Clear all filters'
	        },
	        importer: {
	          noHeaders: 'பத்தியின் தலைப்புகளை பெற இயலவில்லை, கோப்பிற்கு தலைப்பு உள்ளதா?',
	          noObjects: 'இலக்குகளை உருவாக்க முடியவில்லை, கோப்பில் தலைப்புகளை தவிர தரவு ஏதேனும் உள்ளதா? ',
	          invalidCsv:	'சரிவர நடைமுறை படுத்த இயலவில்லை, கோப்பு சரிதானா? - csv',
	          invalidJson: 'சரிவர நடைமுறை படுத்த இயலவில்லை, கோப்பு சரிதானா? - json',
	          jsonNotArray: 'படித்த கோப்பில் வரிசைகள் உள்ளது, நடைமுறை ரத்து செய் : json'
	        },
	        pagination: {
	          sizes		: 'உருப்படிகள் / பக்கம்',
	          totalItems	: 'உருப்படிகள் '
	        },
	        grouping: {
	          group	: 'குழு',
	          ungroup : 'பிரி',
	          aggregate_count	: 'மதிப்பீட்டு : எண்ணு',
	          aggregate_sum : 'மதிப்பீட்டு : கூட்டல்',
	          aggregate_max	: 'மதிப்பீட்டு : அதிகபட்சம்',
	          aggregate_min	: 'மதிப்பீட்டு : குறைந்தபட்சம்',
	          aggregate_avg	: 'மதிப்பீட்டு : சராசரி',
	          aggregate_remove : 'மதிப்பீட்டு : நீக்கு'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('tr', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: 'Sütun için filtre',
	            removeFilter: 'Filtreyi Kaldır',
	            columnMenuButtonLabel: 'Sütun Menüsü'
	          },
	          priority: 'Öncelik:',
	          filterLabel: "Sütun için filtre: "
	        },
	        aggregate: {
	          label: 'kayıtlar'
	        },
	        groupPanel: {
	          description: 'Sütuna göre gruplamak için sütun başlığını buraya sürükleyin ve bırakın.'
	        },
	        search: {
	          placeholder: 'Arama...',
	          showingItems: 'Gösterilen Kayıt:',
	          selectedItems: 'Seçili Kayıt:',
	          totalItems: 'Toplam Kayıt:',
	          size: 'Sayfa Boyutu:',
	          first: 'İlk Sayfa',
	          next: 'Sonraki Sayfa',
	          previous: 'Önceki Sayfa',
	          last: 'Son Sayfa'
	        },
	        menu: {
	          text: 'Sütunları Seç:'
	        },
	        sort: {
	          ascending: 'Artan Sırada Sırala',
	          descending: 'Azalan Sırada Sırala',
	          none: 'Sıralama Yapma',
	          remove: 'Sıralamayı Kaldır'
	        },
	        column: {
	          hide: 'Sütunu Gizle'
	        },
	        aggregation: {
	          count: 'toplam satır: ',
	          sum: 'toplam: ',
	          avg: 'ort: ',
	          min: 'min: ',
	          max: 'maks: '
	        },
	        pinning: {
	          pinLeft: 'Sola Sabitle',
	          pinRight: 'Sağa Sabitle',
	          unpin: 'Sabitlemeyi Kaldır'
	        },
	        columnMenu: {
	          close: 'Kapat'
	        },
	        gridMenu: {
	          aria: {
	            buttonLabel: 'Tablo Menü'
	          },
	          columns: 'Sütunlar:',
	          importerTitle: 'Dosya içeri aktar',
	          exporterAllAsCsv: 'Bütün veriyi CSV olarak dışarı aktar',
	          exporterVisibleAsCsv: 'Görünen veriyi CSV olarak dışarı aktar',
	          exporterSelectedAsCsv: 'Seçili veriyi CSV olarak dışarı aktar',
	          exporterAllAsPdf: 'Bütün veriyi PDF olarak dışarı aktar',
	          exporterVisibleAsPdf: 'Görünen veriyi PDF olarak dışarı aktar',
	          exporterSelectedAsPdf: 'Seçili veriyi PDF olarak dışarı aktar',
	          clearAllFilters: 'Bütün filtreleri kaldır'
	        },
	        importer: {
	          noHeaders: 'Sütun isimleri üretilemiyor, dosyanın bir başlığı var mı?',
	          noObjects: 'Nesneler üretilemiyor, dosyada başlıktan başka bir veri var mı?',
	          invalidCsv: 'Dosya işlenemedi, geçerli bir CSV dosyası mı?',
	          invalidJson: 'Dosya işlenemedi, geçerli bir Json dosyası mı?',
	          jsonNotArray: 'Alınan Json dosyasında bir dizi bulunmalıdır, işlem iptal ediliyor.'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: 'İlk sayfaya',
	            pageBack: 'Geri git',
	            pageSelected: 'Seçili sayfa',
	            pageForward: 'İleri git',
	            pageToLast: 'Sona git'
	          },
	          sizes: 'Sayfadaki nesne sayısı',
	          totalItems: 'kayıtlar',
	          through: '', //note(fsw) : turkish dont have this preposition 
	          of: '' //note(fsw) : turkish dont have this preposition
	        },
	        grouping: {
	          group: 'Grupla',
	          ungroup: 'Gruplama',
	          aggregate_count: 'Yekun: Sayı',
	          aggregate_sum: 'Yekun: Toplam',
	          aggregate_max: 'Yekun: Maks',
	          aggregate_min: 'Yekun: Min',
	          aggregate_avg: 'Yekun: Ort',
	          aggregate_remove: 'Yekun: Sil'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	(function () {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('ua', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: 'Фільтр стовпчика',
	            removeFilter: 'Видалити фільтр',
	            columnMenuButtonLabel: 'Меню ствпчика'
	          },
	          priority: 'Пріоритет:',
	          filterLabel: "Фільтр стовпчика: "
	        },
	        aggregate: {
	          label: 'елементи'
	        },
	        groupPanel: {
	          description: 'Для групування за стовпчиком перетягніть сюди його назву.'
	        },
	        search: {
	          placeholder: 'Пошук...',
	          showingItems: 'Показати елементи:',
	          selectedItems: 'Обрані елементи:',
	          totalItems: 'Усього елементів:',
	          size: 'Розмір сторінки:',
	          first: 'Перша сторінка',
	          next: 'Наступна сторінка',
	          previous: 'Попередня сторінка',
	          last: 'Остання сторінка'
	        },
	        menu: {
	          text: 'Обрати ствпчики:'
	        },
	        sort: {
	          ascending: 'За зростанням',
	          descending: 'За спаданням',
	          none: 'Без сортування',
	          remove: 'Прибрати сортування'
	        },
	        column: {
	          hide: 'Приховати стовпчик'
	        },
	        aggregation: {
	          count: 'усього рядків: ',
	          sum: 'ітого: ',
	          avg: 'середнє: ',
	          min: 'мін: ',
	          max: 'макс: '
	        },
					pinning: {
						pinLeft: 'Закріпити ліворуч',
						pinRight: 'Закріпити праворуч',
						unpin: 'Відкріпити'
					},
	        columnMenu: {
	          close: 'Закрити'
	        },
	        gridMenu: {
	          aria: {
	            buttonLabel: 'Меню'
	          },
	          columns: 'Стовпчики:',
	          importerTitle: 'Імпортувати файл',
	          exporterAllAsCsv: 'Експортувати все в CSV',
	          exporterVisibleAsCsv: 'Експортувати видимі дані в CSV',
	          exporterSelectedAsCsv: 'Експортувати обрані дані в CSV',
	          exporterAllAsPdf: 'Експортувати все в PDF',
	          exporterVisibleAsPdf: 'Експортувати видимі дані в PDF',
	          exporterSelectedAsPdf: 'Експортувати обрані дані в PDF',
	          clearAllFilters: 'Очистити всі фільтри'
	        },
	        importer: {
	          noHeaders: 'Не вдалося отримати назви стовпчиків, чи є в файлі заголовок?',
	          noObjects: 'Не вдалося отримати дані, чи є в файлі рядки окрім заголовка?',
	          invalidCsv: 'Не вдалося обробити файл, чи це коректний CSV-файл?',
	          invalidJson: 'Не вдалося обробити файл, чи це коректний JSON?',
	          jsonNotArray: 'JSON-файл що імпортується повинен містити масив, операцію скасовано.'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: 'Перша сторінка',
	            pageBack: 'Попередня сторінка',
	            pageSelected: 'Обрана сторінка',
	            pageForward: 'Наступна сторінка',
	            pageToLast: 'Остання сторінка'
	          },
	          sizes: 'рядків на сторінку',
	          totalItems: 'рядків',
	          through: 'по',
	          of: 'з'
	        },
	        grouping: {
	          group: 'Групувати',
	          ungroup: 'Розгрупувати',
	          aggregate_count: 'Групувати: Кількість',
	          aggregate_sum: 'Для групи: Сума',
	          aggregate_max: 'Для групи: Максимум',
	          aggregate_min: 'Для групи: Мінімум',
	          aggregate_avg: 'Для групи: Серднє',
	          aggregate_remove: 'Для групи: Пусто'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	/**
	 * @ngdoc overview
	 * @name ui.grid.i18n
	 * @description
	 *
	 *  # ui.grid.i18n
	 * This module provides i18n functions to ui.grid and any application that wants to use it
	
	 *
	 * <div doc-module-components="ui.grid.i18n"></div>
	 */
	
	(function () {
	  var DIRECTIVE_ALIASES = ['uiT', 'uiTranslate'];
	  var FILTER_ALIASES = ['t', 'uiTranslate'];
	
	  var module = angular.module('ui.grid.i18n');
	
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.i18n.constant:i18nConstants
	   *
	   *  @description constants available in i18n module
	   */
	  module.constant('i18nConstants', {
	    MISSING: '[MISSING]',
	    UPDATE_EVENT: '$uiI18n',
	
	    LOCALE_DIRECTIVE_ALIAS: 'uiI18n',
	    // default to english
	    DEFAULT_LANG: 'en'
	  });
	
	//    module.config(['$provide', function($provide) {
	//        $provide.decorator('i18nService', ['$delegate', function($delegate) {}])}]);
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.i18n.service:i18nService
	   *
	   *  @description Services for i18n
	   */
	  module.service('i18nService', ['$log', 'i18nConstants', '$rootScope',
	    function ($log, i18nConstants, $rootScope) {
	
	      var langCache = {
	        _langs: {},
	        current: null,
	        get: function (lang) {
	          return this._langs[lang.toLowerCase()];
	        },
	        add: function (lang, strings) {
	          var lower = lang.toLowerCase();
	          if (!this._langs[lower]) {
	            this._langs[lower] = {};
	          }
	          angular.extend(this._langs[lower], strings);
	        },
	        getAllLangs: function () {
	          var langs = [];
	          if (!this._langs) {
	            return langs;
	          }
	
	          for (var key in this._langs) {
	            langs.push(key);
	          }
	
	          return langs;
	        },
	        setCurrent: function (lang) {
	          this.current = lang.toLowerCase();
	        },
	        getCurrentLang: function () {
	          return this.current;
	        }
	      };
	
	      var service = {
	
	        /**
	         * @ngdoc service
	         * @name add
	         * @methodOf ui.grid.i18n.service:i18nService
	         * @description  Adds the languages and strings to the cache. Decorate this service to
	         * add more translation strings
	         * @param {string} lang language to add
	         * @param {object} stringMaps of strings to add grouped by property names
	         * @example
	         * <pre>
	         *      i18nService.add('en', {
	         *         aggregate: {
	         *                 label1: 'items',
	         *                 label2: 'some more items'
	         *                 }
	         *         },
	         *         groupPanel: {
	         *              description: 'Drag a column header here and drop it to group by that column.'
	         *           }
	         *      }
	         * </pre>
	         */
	        add: function (langs, stringMaps) {
	          if (typeof(langs) === 'object') {
	            angular.forEach(langs, function (lang) {
	              if (lang) {
	                langCache.add(lang, stringMaps);
	              }
	            });
	          } else {
	            langCache.add(langs, stringMaps);
	          }
	        },
	
	        /**
	         * @ngdoc service
	         * @name getAllLangs
	         * @methodOf ui.grid.i18n.service:i18nService
	         * @description  return all currently loaded languages
	         * @returns {array} string
	         */
	        getAllLangs: function () {
	          return langCache.getAllLangs();
	        },
	
	        /**
	         * @ngdoc service
	         * @name get
	         * @methodOf ui.grid.i18n.service:i18nService
	         * @description  return all currently loaded languages
	         * @param {string} lang to return.  If not specified, returns current language
	         * @returns {object} the translation string maps for the language
	         */
	        get: function (lang) {
	          var language = lang ? lang : service.getCurrentLang();
	          return langCache.get(language);
	        },
	
	        /**
	         * @ngdoc service
	         * @name getSafeText
	         * @methodOf ui.grid.i18n.service:i18nService
	         * @description  returns the text specified in the path or a Missing text if text is not found
	         * @param {String} path property path to use for retrieving text from string map
	         * @param {String} [lang] to return.  If not specified, returns current language
	         * @returns {object} the translation for the path
	         * @example
	         * <pre>
	         * i18nService.getSafeText('sort.ascending')
	         * </pre>
	         */
	        getSafeText: function (path, lang) {
	          var language = lang || service.getCurrentLang();
	          var trans = langCache.get(language);
	
	          if (!trans) {
	            return i18nConstants.MISSING;
	          }
	
	          var paths = path.split('.');
	          var current = trans;
	
	          for (var i = 0; i < paths.length; ++i) {
	            if (current[paths[i]] === undefined || current[paths[i]] === null) {
	              return i18nConstants.MISSING;
	            } else {
	              current = current[paths[i]];
	            }
	          }
	
	          return current;
	
	        },
	
	        /**
	         * @ngdoc service
	         * @name setCurrentLang
	         * @methodOf ui.grid.i18n.service:i18nService
	         * @description sets the current language to use in the application
	         * $broadcasts the i18nConstants.UPDATE_EVENT on the $rootScope
	         * @param {string} lang to set
	         * @example
	         * <pre>
	         * i18nService.setCurrentLang('fr');
	         * </pre>
	         */
	
	        setCurrentLang: function (lang) {
	          if (lang) {
	            langCache.setCurrent(lang);
	            $rootScope.$broadcast(i18nConstants.UPDATE_EVENT);
	          }
	        },
	
	        /**
	         * @ngdoc service
	         * @name getCurrentLang
	         * @methodOf ui.grid.i18n.service:i18nService
	         * @description returns the current language used in the application
	         */
	        getCurrentLang: function () {
	          var lang = langCache.getCurrentLang();
	          if (!lang) {
	            lang = i18nConstants.DEFAULT_LANG;
	            langCache.setCurrent(lang);
	          }
	          return lang;
	        }
	
	      };
	
	      return service;
	
	    }]);
	
	  var localeDirective = function (i18nService, i18nConstants) {
	    return {
	      compile: function () {
	        return {
	          pre: function ($scope, $elm, $attrs) {
	            var alias = i18nConstants.LOCALE_DIRECTIVE_ALIAS;
	            // check for watchable property
	            var lang = $scope.$eval($attrs[alias]);
	            if (lang) {
	              $scope.$watch($attrs[alias], function () {
	                i18nService.setCurrentLang(lang);
	              });
	            } else if ($attrs.$$observers) {
	              $attrs.$observe(alias, function () {
	                i18nService.setCurrentLang($attrs[alias] || i18nConstants.DEFAULT_LANG);
	              });
	            }
	          }
	        };
	      }
	    };
	  };
	
	  module.directive('uiI18n', ['i18nService', 'i18nConstants', localeDirective]);
	
	  // directive syntax
	  var uitDirective = function ($parse, i18nService, i18nConstants) {
	    return {
	      restrict: 'EA',
	      compile: function () {
	        return {
	          pre: function ($scope, $elm, $attrs) {
	            var alias1 = DIRECTIVE_ALIASES[0],
	              alias2 = DIRECTIVE_ALIASES[1];
	            var token = $attrs[alias1] || $attrs[alias2] || $elm.html();
	            var missing = i18nConstants.MISSING + token;
	            var observer;
	            if ($attrs.$$observers) {
	              var prop = $attrs[alias1] ? alias1 : alias2;
	              observer = $attrs.$observe(prop, function (result) {
	                if (result) {
	                  $elm.html($parse(result)(i18nService.getCurrentLang()) || missing);
	                }
	              });
	            }
	            var getter = $parse(token);
	            var listener = $scope.$on(i18nConstants.UPDATE_EVENT, function (evt) {
	              if (observer) {
	                observer($attrs[alias1] || $attrs[alias2]);
	              } else {
	                // set text based on i18n current language
	                $elm.html(getter(i18nService.get()) || missing);
	              }
	            });
	            $scope.$on('$destroy', listener);
	
	            $elm.html(getter(i18nService.get()) || missing);
	          }
	        };
	      }
	    };
	  };
	
	  angular.forEach( DIRECTIVE_ALIASES, function ( alias ) {
	    module.directive( alias, ['$parse', 'i18nService', 'i18nConstants', uitDirective] );
	  } );
	
	  // optional filter syntax
	  var uitFilter = function ($parse, i18nService, i18nConstants) {
	    return function (data) {
	      var getter = $parse(data);
	      // set text based on i18n current language
	      return getter(i18nService.get()) || i18nConstants.MISSING + data;
	    };
	  };
	
	  angular.forEach( FILTER_ALIASES, function ( alias ) {
	    module.filter( alias, ['$parse', 'i18nService', 'i18nConstants', uitFilter] );
	  } );
	
	
	})();
	(function() {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('zh-cn', {
	        headerCell: {
	          aria: {
	            defaultFilterLabel: '列过滤器',
	            removeFilter: '移除过滤器',
	            columnMenuButtonLabel: '列菜单'
	          },
	          priority: '优先级:',
	          filterLabel: "列过滤器: "
	        },
	        aggregate: {
	          label: '行'
	        },
	        groupPanel: {
	          description: '拖曳表头到此处进行分组'
	        },
	        search: {
	          placeholder: '查找',
	          showingItems: '已显示行数：',
	          selectedItems: '已选择行数：',
	          totalItems: '总行数：',
	          size: '每页显示行数：',
	          first: '首页',
	          next: '下一页',
	          previous: '上一页',
	          last: '末页'
	        },
	        menu: {
	          text: '选择列：'
	        },
	        sort: {
	          ascending: '升序',
	          descending: '降序',
	          none: '无序',
	          remove: '取消排序'
	        },
	        column: {
	          hide: '隐藏列'
	        },
	        aggregation: {
	          count: '计数：',
	          sum: '求和：',
	          avg: '均值：',
	          min: '最小值：',
	          max: '最大值：'
	        },
	        pinning: {
	          pinLeft: '左侧固定',
	          pinRight: '右侧固定',
	          unpin: '取消固定'
	        },
	        columnMenu: {
	          close: '关闭'
	        },
	        gridMenu: {
	          aria: {
	            buttonLabel: '表格菜单'
	          },
	          columns: '列：',
	          importerTitle: '导入文件',
	          exporterAllAsCsv: '导出全部数据到CSV',
	          exporterVisibleAsCsv: '导出可见数据到CSV',
	          exporterSelectedAsCsv: '导出已选数据到CSV',
	          exporterAllAsPdf: '导出全部数据到PDF',
	          exporterVisibleAsPdf: '导出可见数据到PDF',
	          exporterSelectedAsPdf: '导出已选数据到PDF',
	          clearAllFilters: '清除所有过滤器'
	        },
	        importer: {
	          noHeaders: '无法获取列名，确定文件包含表头？',
	          noObjects: '无法获取数据，确定文件包含数据？',
	          invalidCsv: '无法处理文件，确定是合法的CSV文件？',
	          invalidJson: '无法处理文件，确定是合法的JSON文件？',
	          jsonNotArray: '导入的文件不是JSON数组！'
	        },
	        pagination: {
	          aria: {
	            pageToFirst: '第一页',
	            pageBack: '上一页',
	            pageSelected: '当前页',
	            pageForward: '下一页',
	            pageToLast: '最后一页'
	          },
	          sizes: '行每页',
	          totalItems: '行',
	          through: '至',
	          of: '共'
	        },
	        grouping: {
	          group: '分组',
	          ungroup: '取消分组',
	          aggregate_count: '合计: 计数',
	          aggregate_sum: '合计: 求和',
	          aggregate_max: '合计: 最大',
	          aggregate_min: '合计: 最小',
	          aggregate_avg: '合计: 平均',
	          aggregate_remove: '合计: 移除'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function() {
	  angular.module('ui.grid').config(['$provide', function($provide) {
	    $provide.decorator('i18nService', ['$delegate', function($delegate) {
	      $delegate.add('zh-tw', {
	        aggregate: {
	          label: '行'
	        },
	        groupPanel: {
	          description: '拖曳表頭到此處進行分組'
	        },
	        search: {
	          placeholder: '查找',
	          showingItems: '已顯示行數：',
	          selectedItems: '已選擇行數：',
	          totalItems: '總行數：',
	          size: '每頁顯示行數：',
	          first: '首頁',
	          next: '下壹頁',
	          previous: '上壹頁',
	          last: '末頁'
	        },
	        menu: {
	          text: '選擇列：'
	        },
	        sort: {
	          ascending: '升序',
	          descending: '降序',
	          remove: '取消排序'
	        },
	        column: {
	          hide: '隱藏列'
	        },
	        aggregation: {
	          count: '計數：',
	          sum: '求和：',
	          avg: '均值：',
	          min: '最小值：',
	          max: '最大值：'
	        },
	        pinning: {
	          pinLeft: '左側固定',
	          pinRight: '右側固定',
	          unpin: '取消固定'
	        },
	        gridMenu: {
	          columns: '列：',
	          importerTitle: '導入文件',
	          exporterAllAsCsv: '導出全部數據到CSV',
	          exporterVisibleAsCsv: '導出可見數據到CSV',
	          exporterSelectedAsCsv: '導出已選數據到CSV',
	          exporterAllAsPdf: '導出全部數據到PDF',
	          exporterVisibleAsPdf: '導出可見數據到PDF',
	          exporterSelectedAsPdf: '導出已選數據到PDF',
	          clearAllFilters: '清除所有过滤器'
	        },
	        importer: {
	          noHeaders: '無法獲取列名，確定文件包含表頭？',
	          noObjects: '無法獲取數據，確定文件包含數據？',
	          invalidCsv: '無法處理文件，確定是合法的CSV文件？',
	          invalidJson: '無法處理文件，確定是合法的JSON文件？',
	          jsonNotArray: '導入的文件不是JSON數組！'
	        },
	        pagination: {
	          sizes: '行每頁',
	          totalItems: '行'
	        }
	      });
	      return $delegate;
	    }]);
	  }]);
	})();
	
	(function() {
	  'use strict';
	  /**
	   *  @ngdoc overview
	   *  @name ui.grid.autoResize
	   *
	   *  @description
	   *
	   *  #ui.grid.autoResize
	   *
	   *  <div class="alert alert-warning" role="alert"><strong>Beta</strong> This feature is ready for testing, but it either hasn't seen a lot of use or has some known bugs.</div>
	   *
	   *  This module provides auto-resizing functionality to UI-Grid.
	   */
	  var module = angular.module('ui.grid.autoResize', ['ui.grid']);
	
	  module.directive('uiGridAutoResize', ['gridUtil', function(gridUtil) {
	    return {
	      require: 'uiGrid',
	      scope: false,
	      link: function($scope, $elm, $attrs, uiGridCtrl) {
	        var elementWidth,
	          elementHeight;
	
	        var updateWidth = gridUtil.throttle(function() {
	          elementWidth = gridUtil.elementWidth($elm);
	        }, 200);
	
	        var updateHeight = gridUtil.throttle(function() {
	          elementHeight = gridUtil.elementHeight($elm);
	        }, 200);
	
	        var refresh = gridUtil.throttle(function(width, height) {
	          uiGridCtrl.grid.gridWidth = width;
	          uiGridCtrl.grid.gridHeight = height;
	          uiGridCtrl.grid.refresh();
	        }, 300);
	
	        $scope.$watchGroup([
	          function() {
	            updateWidth();
	            return elementWidth;
	          },
	          function() {
	            updateHeight();
	            return elementHeight;
	          }
	        ], function(newValues, oldValues, scope) {
	          if (!angular.equals(newValues, oldValues)) {
	            refresh(newValues[0], newValues[1]);
	          }
	        });
	      }
	    };
	  }]);
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   *  @ngdoc overview
	   *  @name ui.grid.cellNav
	   *
	   *  @description
	
	      #ui.grid.cellNav
	
	      <div class="alert alert-success" role="alert"><strong>Stable</strong> This feature is stable. There should no longer be breaking api changes without a deprecation warning.</div>
	
	      This module provides cell navigation functionality to UI-Grid.
	   */
	  var module = angular.module('ui.grid.cellNav', ['ui.grid']);
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.cellNav.constant:uiGridCellNavConstants
	   *
	   *  @description constants available in cellNav
	   */
	  module.constant('uiGridCellNavConstants', {
	    FEATURE_NAME: 'gridCellNav',
	    CELL_NAV_EVENT: 'cellNav',
	    direction: {LEFT: 0, RIGHT: 1, UP: 2, DOWN: 3, PG_UP: 4, PG_DOWN: 5},
	    EVENT_TYPE: {
	      KEYDOWN: 0,
	      CLICK: 1,
	      CLEAR: 2
	    }
	  });
	
	
	  module.factory('uiGridCellNavFactory', ['gridUtil', 'uiGridConstants', 'uiGridCellNavConstants', 'GridRowColumn', '$q',
	    function (gridUtil, uiGridConstants, uiGridCellNavConstants, GridRowColumn, $q) {
	      /**
	       *  @ngdoc object
	       *  @name ui.grid.cellNav.object:CellNav
	       *  @description returns a CellNav prototype function
	       *  @param {object} rowContainer container for rows
	       *  @param {object} colContainer parent column container
	       *  @param {object} leftColContainer column container to the left of parent
	       *  @param {object} rightColContainer column container to the right of parent
	       */
	      var UiGridCellNav = function UiGridCellNav(rowContainer, colContainer, leftColContainer, rightColContainer) {
	        this.rows = rowContainer.visibleRowCache;
	        this.columns = colContainer.visibleColumnCache;
	        this.leftColumns = leftColContainer ? leftColContainer.visibleColumnCache : [];
	        this.rightColumns = rightColContainer ? rightColContainer.visibleColumnCache : [];
	        this.bodyContainer = rowContainer;
	      };
	
	      /** returns focusable columns of all containers */
	      UiGridCellNav.prototype.getFocusableCols = function () {
	        var allColumns = this.leftColumns.concat(this.columns, this.rightColumns);
	
	        return allColumns.filter(function (col) {
	          return col.colDef.allowCellFocus;
	        });
	      };
	
	      /**
	       *  @ngdoc object
	       *  @name ui.grid.cellNav.api:GridRow
	       *
	       *  @description GridRow settings for cellNav feature, these are available to be
	       *  set only internally (for example, by other features)
	       */
	
	      /**
	       *  @ngdoc object
	       *  @name allowCellFocus
	       *  @propertyOf  ui.grid.cellNav.api:GridRow
	       *  @description Enable focus on a cell within this row.  If set to false then no cells
	       *  in this row can be focused - group header rows as an example would set this to false.
	       *  <br/>Defaults to true
	       */
	      /** returns focusable rows */
	      UiGridCellNav.prototype.getFocusableRows = function () {
	        return this.rows.filter(function(row) {
	          return row.allowCellFocus !== false;
	        });
	      };
	
	      UiGridCellNav.prototype.getNextRowCol = function (direction, curRow, curCol) {
	        switch (direction) {
	          case uiGridCellNavConstants.direction.LEFT:
	            return this.getRowColLeft(curRow, curCol);
	          case uiGridCellNavConstants.direction.RIGHT:
	            return this.getRowColRight(curRow, curCol);
	          case uiGridCellNavConstants.direction.UP:
	            return this.getRowColUp(curRow, curCol);
	          case uiGridCellNavConstants.direction.DOWN:
	            return this.getRowColDown(curRow, curCol);
	          case uiGridCellNavConstants.direction.PG_UP:
	            return this.getRowColPageUp(curRow, curCol);
	          case uiGridCellNavConstants.direction.PG_DOWN:
	            return this.getRowColPageDown(curRow, curCol);
	        }
	
	      };
	
	      UiGridCellNav.prototype.initializeSelection = function () {
	        var focusableCols = this.getFocusableCols();
	        var focusableRows = this.getFocusableRows();
	        if (focusableCols.length === 0 || focusableRows.length === 0) {
	          return null;
	        }
	
	        var curRowIndex = 0;
	        var curColIndex = 0;
	        return new GridRowColumn(focusableRows[0], focusableCols[0]); //return same row
	      };
	
	      UiGridCellNav.prototype.getRowColLeft = function (curRow, curCol) {
	        var focusableCols = this.getFocusableCols();
	        var focusableRows = this.getFocusableRows();
	        var curColIndex = focusableCols.indexOf(curCol);
	        var curRowIndex = focusableRows.indexOf(curRow);
	
	        //could not find column in focusable Columns so set it to 1
	        if (curColIndex === -1) {
	          curColIndex = 1;
	        }
	
	        var nextColIndex = curColIndex === 0 ? focusableCols.length - 1 : curColIndex - 1;
	
	        //get column to left
	        if (nextColIndex >= curColIndex) {
	          // On the first row
	          // if (curRowIndex === 0 && curColIndex === 0) {
	          //   return null;
	          // }
	          if (curRowIndex === 0) {
	            return new GridRowColumn(curRow, focusableCols[nextColIndex]); //return same row
	          }
	          else {
	            //up one row and far right column
	            return new GridRowColumn(focusableRows[curRowIndex - 1], focusableCols[nextColIndex]);
	          }
	        }
	        else {
	          return new GridRowColumn(curRow, focusableCols[nextColIndex]);
	        }
	      };
	
	
	
	      UiGridCellNav.prototype.getRowColRight = function (curRow, curCol) {
	        var focusableCols = this.getFocusableCols();
	        var focusableRows = this.getFocusableRows();
	        var curColIndex = focusableCols.indexOf(curCol);
	        var curRowIndex = focusableRows.indexOf(curRow);
	
	        //could not find column in focusable Columns so set it to 0
	        if (curColIndex === -1) {
	          curColIndex = 0;
	        }
	        var nextColIndex = curColIndex === focusableCols.length - 1 ? 0 : curColIndex + 1;
	
	        if (nextColIndex <= curColIndex) {
	          if (curRowIndex === focusableRows.length - 1) {
	            return new GridRowColumn(curRow, focusableCols[nextColIndex]); //return same row
	          }
	          else {
	            //down one row and far left column
	            return new GridRowColumn(focusableRows[curRowIndex + 1], focusableCols[nextColIndex]);
	          }
	        }
	        else {
	          return new GridRowColumn(curRow, focusableCols[nextColIndex]);
	        }
	      };
	
	      UiGridCellNav.prototype.getRowColDown = function (curRow, curCol) {
	        var focusableCols = this.getFocusableCols();
	        var focusableRows = this.getFocusableRows();
	        var curColIndex = focusableCols.indexOf(curCol);
	        var curRowIndex = focusableRows.indexOf(curRow);
	
	        //could not find column in focusable Columns so set it to 0
	        if (curColIndex === -1) {
	          curColIndex = 0;
	        }
	
	        if (curRowIndex === focusableRows.length - 1) {
	          return new GridRowColumn(curRow, focusableCols[curColIndex]); //return same row
	        }
	        else {
	          //down one row
	          return new GridRowColumn(focusableRows[curRowIndex + 1], focusableCols[curColIndex]);
	        }
	      };
	
	      UiGridCellNav.prototype.getRowColPageDown = function (curRow, curCol) {
	        var focusableCols = this.getFocusableCols();
	        var focusableRows = this.getFocusableRows();
	        var curColIndex = focusableCols.indexOf(curCol);
	        var curRowIndex = focusableRows.indexOf(curRow);
	
	        //could not find column in focusable Columns so set it to 0
	        if (curColIndex === -1) {
	          curColIndex = 0;
	        }
	
	        var pageSize = this.bodyContainer.minRowsToRender();
	        if (curRowIndex >= focusableRows.length - pageSize) {
	          return new GridRowColumn(focusableRows[focusableRows.length - 1], focusableCols[curColIndex]); //return last row
	        }
	        else {
	          //down one page
	          return new GridRowColumn(focusableRows[curRowIndex + pageSize], focusableCols[curColIndex]);
	        }
	      };
	
	      UiGridCellNav.prototype.getRowColUp = function (curRow, curCol) {
	        var focusableCols = this.getFocusableCols();
	        var focusableRows = this.getFocusableRows();
	        var curColIndex = focusableCols.indexOf(curCol);
	        var curRowIndex = focusableRows.indexOf(curRow);
	
	        //could not find column in focusable Columns so set it to 0
	        if (curColIndex === -1) {
	          curColIndex = 0;
	        }
	
	        if (curRowIndex === 0) {
	          return new GridRowColumn(curRow, focusableCols[curColIndex]); //return same row
	        }
	        else {
	          //up one row
	          return new GridRowColumn(focusableRows[curRowIndex - 1], focusableCols[curColIndex]);
	        }
	      };
	
	      UiGridCellNav.prototype.getRowColPageUp = function (curRow, curCol) {
	        var focusableCols = this.getFocusableCols();
	        var focusableRows = this.getFocusableRows();
	        var curColIndex = focusableCols.indexOf(curCol);
	        var curRowIndex = focusableRows.indexOf(curRow);
	
	        //could not find column in focusable Columns so set it to 0
	        if (curColIndex === -1) {
	          curColIndex = 0;
	        }
	
	        var pageSize = this.bodyContainer.minRowsToRender();
	        if (curRowIndex - pageSize < 0) {
	          return new GridRowColumn(focusableRows[0], focusableCols[curColIndex]); //return first row
	        }
	        else {
	          //up one page
	          return new GridRowColumn(focusableRows[curRowIndex - pageSize], focusableCols[curColIndex]);
	        }
	      };
	      return UiGridCellNav;
	    }]);
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.cellNav.service:uiGridCellNavService
	   *
	   *  @description Services for cell navigation features. If you don't like the key maps we use,
	   *  or the direction cells navigation, override with a service decorator (see angular docs)
	   */
	  module.service('uiGridCellNavService', ['gridUtil', 'uiGridConstants', 'uiGridCellNavConstants', '$q', 'uiGridCellNavFactory', 'GridRowColumn', 'ScrollEvent',
	    function (gridUtil, uiGridConstants, uiGridCellNavConstants, $q, UiGridCellNav, GridRowColumn, ScrollEvent) {
	
	      var service = {
	
	        initializeGrid: function (grid) {
	          grid.registerColumnBuilder(service.cellNavColumnBuilder);
	
	
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.cellNav:Grid.cellNav
	           * @description cellNav properties added to grid class
	           */
	          grid.cellNav = {};
	          grid.cellNav.lastRowCol = null;
	          grid.cellNav.focusedCells = [];
	
	          service.defaultGridOptions(grid.options);
	
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.cellNav.api:PublicApi
	           *
	           *  @description Public Api for cellNav feature
	           */
	          var publicApi = {
	            events: {
	              cellNav: {
	                /**
	                 * @ngdoc event
	                 * @name navigate
	                 * @eventOf  ui.grid.cellNav.api:PublicApi
	                 * @description raised when the active cell is changed
	                 * <pre>
	                 *      gridApi.cellNav.on.navigate(scope,function(newRowcol, oldRowCol){})
	                 * </pre>
	                 * @param {object} newRowCol new position
	                 * @param {object} oldRowCol old position
	                 */
	                navigate: function (newRowCol, oldRowCol) {},
	                /**
	                 * @ngdoc event
	                 * @name viewPortKeyDown
	                 * @eventOf  ui.grid.cellNav.api:PublicApi
	                 * @description  is raised when the viewPort receives a keyDown event. Cells never get focus in uiGrid
	                 * due to the difficulties of setting focus on a cell that is not visible in the viewport.  Use this
	                 * event whenever you need a keydown event on a cell
	                 * <br/>
	                 * @param {object} event keydown event
	                 * @param {object} rowCol current rowCol position
	                 */
	                viewPortKeyDown: function (event, rowCol) {},
	
	                /**
	                 * @ngdoc event
	                 * @name viewPortKeyPress
	                 * @eventOf  ui.grid.cellNav.api:PublicApi
	                 * @description  is raised when the viewPort receives a keyPress event. Cells never get focus in uiGrid
	                 * due to the difficulties of setting focus on a cell that is not visible in the viewport.  Use this
	                 * event whenever you need a keypress event on a cell
	                 * <br/>
	                 * @param {object} event keypress event
	                 * @param {object} rowCol current rowCol position
	                 */
	                viewPortKeyPress: function (event, rowCol) {}
	              }
	            },
	            methods: {
	              cellNav: {
	                /**
	                 * @ngdoc function
	                 * @name scrollToFocus
	                 * @methodOf  ui.grid.cellNav.api:PublicApi
	                 * @description brings the specified row and column into view, and sets focus
	                 * to that cell
	                 * @param {object} rowEntity gridOptions.data[] array instance to make visible and set focus
	                 * @param {object} colDef to make visible and set focus
	                 * @returns {promise} a promise that is resolved after any scrolling is finished
	                 */
	                scrollToFocus: function (rowEntity, colDef) {
	                  return service.scrollToFocus(grid, rowEntity, colDef);
	                },
	
	                /**
	                 * @ngdoc function
	                 * @name getFocusedCell
	                 * @methodOf  ui.grid.cellNav.api:PublicApi
	                 * @description returns the current (or last if Grid does not have focus) focused row and column
	                 * <br> value is null if no selection has occurred
	                 */
	                getFocusedCell: function () {
	                  return grid.cellNav.lastRowCol;
	                },
	
	                /**
	                 * @ngdoc function
	                 * @name getCurrentSelection
	                 * @methodOf  ui.grid.cellNav.api:PublicApi
	                 * @description returns an array containing the current selection
	                 * <br> array is empty if no selection has occurred
	                 */
	                getCurrentSelection: function () {
	                  return grid.cellNav.focusedCells;
	                },
	
	                /**
	                 * @ngdoc function
	                 * @name rowColSelectIndex
	                 * @methodOf  ui.grid.cellNav.api:PublicApi
	                 * @description returns the index in the order in which the GridRowColumn was selected, returns -1 if the GridRowColumn
	                 * isn't selected
	                 * @param {object} rowCol the rowCol to evaluate
	                 */
	                rowColSelectIndex: function (rowCol) {
	                  //return gridUtil.arrayContainsObjectWithProperty(grid.cellNav.focusedCells, 'col.uid', rowCol.col.uid) &&
	                  var index = -1;
	                  for (var i = 0; i < grid.cellNav.focusedCells.length; i++) {
	                    if (grid.cellNav.focusedCells[i].col.uid === rowCol.col.uid &&
	                      grid.cellNav.focusedCells[i].row.uid === rowCol.row.uid) {
	                      index = i;
	                      break;
	                    }
	                  }
	                  return index;
	                }
	              }
	            }
	          };
	
	          grid.api.registerEventsFromObject(publicApi.events);
	
	          grid.api.registerMethodsFromObject(publicApi.methods);
	
	        },
	
	        defaultGridOptions: function (gridOptions) {
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.cellNav.api:GridOptions
	           *
	           *  @description GridOptions for cellNav feature, these are available to be
	           *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	           */
	
	          /**
	           *  @ngdoc object
	           *  @name modifierKeysToMultiSelectCells
	           *  @propertyOf  ui.grid.cellNav.api:GridOptions
	           *  @description Enable multiple cell selection only when using the ctrlKey or shiftKey.
	           *  <br/>Defaults to false
	           */
	          gridOptions.modifierKeysToMultiSelectCells = gridOptions.modifierKeysToMultiSelectCells === true;
	
	          /**
	           *  @ngdoc array
	           *  @name keyDownOverrides
	           *  @propertyOf  ui.grid.cellNav.api:GridOptions
	           *  @description An array of event objects to override on keydown. If an event is overridden, the viewPortKeyDown event will
	           *               be raised with the overridden events, allowing custom keydown behavior.
	           *  <br/>Defaults to []
	           */
	          gridOptions.keyDownOverrides = gridOptions.keyDownOverrides || [];
	
	        },
	
	        /**
	         * @ngdoc service
	         * @name decorateRenderContainers
	         * @methodOf ui.grid.cellNav.service:uiGridCellNavService
	         * @description  decorates grid renderContainers with cellNav functions
	         */
	        decorateRenderContainers: function (grid) {
	
	          var rightContainer = grid.hasRightContainer() ? grid.renderContainers.right : null;
	          var leftContainer = grid.hasLeftContainer() ? grid.renderContainers.left : null;
	
	          if (leftContainer !== null) {
	            grid.renderContainers.left.cellNav = new UiGridCellNav(grid.renderContainers.body, leftContainer, rightContainer, grid.renderContainers.body);
	          }
	          if (rightContainer !== null) {
	            grid.renderContainers.right.cellNav = new UiGridCellNav(grid.renderContainers.body, rightContainer, grid.renderContainers.body, leftContainer);
	          }
	
	          grid.renderContainers.body.cellNav = new UiGridCellNav(grid.renderContainers.body, grid.renderContainers.body, leftContainer, rightContainer);
	        },
	
	        /**
	         * @ngdoc service
	         * @name getDirection
	         * @methodOf ui.grid.cellNav.service:uiGridCellNavService
	         * @description  determines which direction to for a given keyDown event
	         * @returns {uiGridCellNavConstants.direction} direction
	         */
	        getDirection: function (evt) {
	          if (evt.keyCode === uiGridConstants.keymap.LEFT ||
	            (evt.keyCode === uiGridConstants.keymap.TAB && evt.shiftKey)) {
	            return uiGridCellNavConstants.direction.LEFT;
	          }
	          if (evt.keyCode === uiGridConstants.keymap.RIGHT ||
	            evt.keyCode === uiGridConstants.keymap.TAB) {
	            return uiGridCellNavConstants.direction.RIGHT;
	          }
	
	          if (evt.keyCode === uiGridConstants.keymap.UP ||
	            (evt.keyCode === uiGridConstants.keymap.ENTER && evt.shiftKey) ) {
	            return uiGridCellNavConstants.direction.UP;
	          }
	
	          if (evt.keyCode === uiGridConstants.keymap.PG_UP){
	            return uiGridCellNavConstants.direction.PG_UP;
	          }
	
	          if (evt.keyCode === uiGridConstants.keymap.DOWN ||
	            evt.keyCode === uiGridConstants.keymap.ENTER && !(evt.ctrlKey || evt.altKey)) {
	            return uiGridCellNavConstants.direction.DOWN;
	          }
	
	          if (evt.keyCode === uiGridConstants.keymap.PG_DOWN){
	            return uiGridCellNavConstants.direction.PG_DOWN;
	          }
	
	          return null;
	        },
	
	        /**
	         * @ngdoc service
	         * @name cellNavColumnBuilder
	         * @methodOf ui.grid.cellNav.service:uiGridCellNavService
	         * @description columnBuilder function that adds cell navigation properties to grid column
	         * @returns {promise} promise that will load any needed templates when resolved
	         */
	        cellNavColumnBuilder: function (colDef, col, gridOptions) {
	          var promises = [];
	
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.cellNav.api:ColumnDef
	           *
	           *  @description Column Definitions for cellNav feature, these are available to be
	           *  set using the ui-grid {@link ui.grid.class:GridOptions.columnDef gridOptions.columnDefs}
	           */
	
	          /**
	           *  @ngdoc object
	           *  @name allowCellFocus
	           *  @propertyOf  ui.grid.cellNav.api:ColumnDef
	           *  @description Enable focus on a cell within this column.
	           *  <br/>Defaults to true
	           */
	          colDef.allowCellFocus = colDef.allowCellFocus === undefined ? true : colDef.allowCellFocus;
	
	          return $q.all(promises);
	        },
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.cellNav.service:uiGridCellNavService
	         * @name scrollToFocus
	         * @description Scroll the grid such that the specified
	         * row and column is in view, and set focus to the cell in that row and column
	         * @param {Grid} grid the grid you'd like to act upon, usually available
	         * from gridApi.grid
	         * @param {object} rowEntity gridOptions.data[] array instance to make visible and set focus to
	         * @param {object} colDef to make visible and set focus to
	         * @returns {promise} a promise that is resolved after any scrolling is finished
	         */
	        scrollToFocus: function (grid, rowEntity, colDef) {
	          var gridRow = null, gridCol = null;
	
	          if (typeof(rowEntity) !== 'undefined' && rowEntity !== null) {
	            gridRow = grid.getRow(rowEntity);
	          }
	
	          if (typeof(colDef) !== 'undefined' && colDef !== null) {
	            gridCol = grid.getColumn(colDef.name ? colDef.name : colDef.field);
	          }
	          return grid.api.core.scrollToIfNecessary(gridRow, gridCol).then(function () {
	            var rowCol = { row: gridRow, col: gridCol };
	
	            // Broadcast the navigation
	            if (gridRow !== null && gridCol !== null) {
	              grid.cellNav.broadcastCellNav(rowCol);
	            }
	          });
	
	
	
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.cellNav.service:uiGridCellNavService
	         * @name getLeftWidth
	         * @description Get the current drawn width of the columns in the
	         * grid up to the numbered column, and add an apportionment for the
	         * column that we're on.  So if we are on column 0, we want to scroll
	         * 0% (i.e. exclude this column from calc).  If we're on the last column
	         * we want to scroll to 100% (i.e. include this column in the calc). So
	         * we include (thisColIndex / totalNumberCols) % of this column width
	         * @param {Grid} grid the grid you'd like to act upon, usually available
	         * from gridApi.grid
	         * @param {GridColumn} upToCol the column to total up to and including
	         */
	        getLeftWidth: function (grid, upToCol) {
	          var width = 0;
	
	          if (!upToCol) {
	            return width;
	          }
	
	          var lastIndex = grid.renderContainers.body.visibleColumnCache.indexOf( upToCol );
	
	          // total column widths up-to but not including the passed in column
	          grid.renderContainers.body.visibleColumnCache.forEach( function( col, index ) {
	            if ( index < lastIndex ){
	              width += col.drawnWidth;
	            }
	          });
	
	          // pro-rata the final column based on % of total columns.
	          var percentage = lastIndex === 0 ? 0 : (lastIndex + 1) / grid.renderContainers.body.visibleColumnCache.length;
	          width += upToCol.drawnWidth * percentage;
	
	          return width;
	        }
	      };
	
	      return service;
	    }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.cellNav.directive:uiCellNav
	   *  @element div
	   *  @restrict EA
	   *
	   *  @description Adds cell navigation features to the grid columns
	   *
	   *  @example
	   <example module="app">
	   <file name="app.js">
	   var app = angular.module('app', ['ui.grid', 'ui.grid.cellNav']);
	
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	      $scope.data = [
	        { name: 'Bob', title: 'CEO' },
	            { name: 'Frank', title: 'Lowly Developer' }
	      ];
	
	      $scope.columnDefs = [
	        {name: 'name'},
	        {name: 'title'}
	      ];
	    }]);
	   </file>
	   <file name="index.html">
	   <div ng-controller="MainCtrl">
	   <div ui-grid="{ data: data, columnDefs: columnDefs }" ui-grid-cellnav></div>
	   </div>
	   </file>
	   </example>
	   */
	  module.directive('uiGridCellnav', ['gridUtil', 'uiGridCellNavService', 'uiGridCellNavConstants', 'uiGridConstants', 'GridRowColumn', '$timeout', '$compile', 'i18nService',
	    function (gridUtil, uiGridCellNavService, uiGridCellNavConstants, uiGridConstants, GridRowColumn, $timeout, $compile, i18nService) {
	      return {
	        replace: true,
	        priority: -150,
	        require: '^uiGrid',
	        scope: false,
	        controller: function () {},
	        compile: function () {
	          return {
	            pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	              var _scope = $scope;
	
	              var grid = uiGridCtrl.grid;
	              uiGridCellNavService.initializeGrid(grid);
	
	              uiGridCtrl.cellNav = {};
	
	              //Ensure that the object has all of the methods we expect it to
	              uiGridCtrl.cellNav.makeRowCol = function (obj) {
	                if (!(obj instanceof GridRowColumn)) {
	                  obj = new GridRowColumn(obj.row, obj.col);
	                }
	                return obj;
	              };
	
	              uiGridCtrl.cellNav.getActiveCell = function () {
	                var elms = $elm[0].getElementsByClassName('ui-grid-cell-focus');
	                if (elms.length > 0){
	                  return elms[0];
	                }
	
	                return undefined;
	              };
	
	              uiGridCtrl.cellNav.broadcastCellNav = grid.cellNav.broadcastCellNav = function (newRowCol, modifierDown, originEvt) {
	                modifierDown = !(modifierDown === undefined || !modifierDown);
	
	                newRowCol = uiGridCtrl.cellNav.makeRowCol(newRowCol);
	
	                uiGridCtrl.cellNav.broadcastFocus(newRowCol, modifierDown, originEvt);
	                _scope.$broadcast(uiGridCellNavConstants.CELL_NAV_EVENT, newRowCol, modifierDown, originEvt);
	              };
	
	              uiGridCtrl.cellNav.clearFocus = grid.cellNav.clearFocus = function () {
	                grid.cellNav.focusedCells = [];
	                _scope.$broadcast(uiGridCellNavConstants.CELL_NAV_EVENT);
	              };
	
	              uiGridCtrl.cellNav.broadcastFocus = function (rowCol, modifierDown, originEvt) {
	                modifierDown = !(modifierDown === undefined || !modifierDown);
	
	                rowCol = uiGridCtrl.cellNav.makeRowCol(rowCol);
	
	                var row = rowCol.row,
	                  col = rowCol.col;
	
	                var rowColSelectIndex = uiGridCtrl.grid.api.cellNav.rowColSelectIndex(rowCol);
	
	                if (grid.cellNav.lastRowCol === null || rowColSelectIndex === -1 || (grid.cellNav.lastRowCol.col === col && grid.cellNav.lastRowCol.row === row)) {
	                  var newRowCol = new GridRowColumn(row, col);
	
	                  if (grid.cellNav.lastRowCol === null || grid.cellNav.lastRowCol.row !== newRowCol.row || grid.cellNav.lastRowCol.col !== newRowCol.col || grid.options.enableCellEditOnFocus){
	                    grid.api.cellNav.raise.navigate(newRowCol, grid.cellNav.lastRowCol, originEvt);
	                    grid.cellNav.lastRowCol = newRowCol;
	                  }
	                  if (uiGridCtrl.grid.options.modifierKeysToMultiSelectCells && modifierDown) {
	                    grid.cellNav.focusedCells.push(rowCol);
	                  } else {
	                    grid.cellNav.focusedCells = [rowCol];
	                  }
	                } else if (grid.options.modifierKeysToMultiSelectCells && modifierDown &&
	                  rowColSelectIndex >= 0) {
	
	                  grid.cellNav.focusedCells.splice(rowColSelectIndex, 1);
	                }
	              };
	
	              uiGridCtrl.cellNav.handleKeyDown = function (evt) {
	                var direction = uiGridCellNavService.getDirection(evt);
	                if (direction === null) {
	                  return null;
	                }
	
	                var containerId = 'body';
	                if (evt.uiGridTargetRenderContainerId) {
	                  containerId = evt.uiGridTargetRenderContainerId;
	                }
	
	                // Get the last-focused row+col combo
	                var lastRowCol = uiGridCtrl.grid.api.cellNav.getFocusedCell();
	                if (lastRowCol) {
	                  // Figure out which new row+combo we're navigating to
	                  var rowCol = uiGridCtrl.grid.renderContainers[containerId].cellNav.getNextRowCol(direction, lastRowCol.row, lastRowCol.col);
	                  var focusableCols = uiGridCtrl.grid.renderContainers[containerId].cellNav.getFocusableCols();
	                  var rowColSelectIndex = uiGridCtrl.grid.api.cellNav.rowColSelectIndex(rowCol);
	                  // Shift+tab on top-left cell should exit cellnav on render container
	                  if (
	                    // Navigating left
	                    direction === uiGridCellNavConstants.direction.LEFT &&
	                    // New col is last col (i.e. wrap around)
	                    rowCol.col === focusableCols[focusableCols.length - 1] &&
	                    // Staying on same row, which means we're at first row
	                    rowCol.row === lastRowCol.row &&
	                    evt.keyCode === uiGridConstants.keymap.TAB &&
	                    evt.shiftKey
	                  ) {
	                    grid.cellNav.focusedCells.splice(rowColSelectIndex, 1);
	                    uiGridCtrl.cellNav.clearFocus();
	                    return true;
	                  }
	                  // Tab on bottom-right cell should exit cellnav on render container
	                  else if (
	                    direction === uiGridCellNavConstants.direction.RIGHT &&
	                    // New col is first col (i.e. wrap around)
	                    rowCol.col === focusableCols[0] &&
	                    // Staying on same row, which means we're at first row
	                    rowCol.row === lastRowCol.row &&
	                    evt.keyCode === uiGridConstants.keymap.TAB &&
	                    !evt.shiftKey
	                  ) {
	                    grid.cellNav.focusedCells.splice(rowColSelectIndex, 1);
	                    uiGridCtrl.cellNav.clearFocus();
	                    return true;
	                  }
	
	                  // Scroll to the new cell, if it's not completely visible within the render container's viewport
	                  grid.scrollToIfNecessary(rowCol.row, rowCol.col).then(function () {
	                    uiGridCtrl.cellNav.broadcastCellNav(rowCol, null, evt);
	                  });
	
	
	                  evt.stopPropagation();
	                  evt.preventDefault();
	
	                  return false;
	                }
	              };
	            },
	            post: function ($scope, $elm, $attrs, uiGridCtrl) {
	              var _scope = $scope;
	              var grid = uiGridCtrl.grid;
	              var usesAria = true;
	
	              // Detect whether we are using ngAria
	              // (if ngAria module is not used then the stuff inside addAriaLiveRegion
	              // is not used and provides extra fluff)
	              try {
	                angular.module('ngAria');
	              }
	              catch (err) {
	                usesAria = false;
	              }
	
	              function addAriaLiveRegion(){
	                // Thanks to google docs for the inspiration behind how to do this
	                // XXX: Why is this entire mess nessasary?
	                // Because browsers take a lot of coercing to get them to read out live regions
	                //http://www.paciellogroup.com/blog/2012/06/html5-accessibility-chops-aria-rolealert-browser-support/
	                var ariaNotifierDomElt = '<div ' +
	                                           'id="' + grid.id +'-aria-speakable" ' +
	                                           'class="ui-grid-a11y-ariascreenreader-speakable ui-grid-offscreen" ' +
	                                           'aria-live="assertive" ' +
	                                           'role="alert" ' +
	                                           'aria-atomic="true" ' +
	                                           'aria-hidden="false" ' +
	                                           'aria-relevant="additions" ' +
	                                           '>' +
	                                           '&nbsp;' +
	                                         '</div>';
	
	                var ariaNotifier = $compile(ariaNotifierDomElt)($scope);
	                $elm.prepend(ariaNotifier);
	                $scope.$on(uiGridCellNavConstants.CELL_NAV_EVENT, function (evt, rowCol, modifierDown, originEvt) {
	                  /*
	                   * If the cell nav event was because of a focus event then we don't want to
	                   * change the notifier text.
	                   * Reasoning: Voice Over fires a focus events when moving arround the grid.
	                   * If the screen reader is handing the grid nav properly then we don't need to
	                   * use the alert to notify the user of the movement.
	                   * In all other cases we do want a notification event.
	                   */
	                  if (originEvt && originEvt.type === 'focus'){return;}
	
	                  function setNotifyText(text){
	                    if (text === ariaNotifier.text().trim()){return;}
	                    ariaNotifier[0].style.clip = 'rect(0px,0px,0px,0px)';
	                    /*
	                     * This is how google docs handles clearing the div. Seems to work better than setting the text of the div to ''
	                     */
	                    ariaNotifier[0].innerHTML = "";
	                    ariaNotifier[0].style.visibility = 'hidden';
	                    ariaNotifier[0].style.visibility = 'visible';
	                    if (text !== ''){
	                      ariaNotifier[0].style.clip = 'auto';
	                      /*
	                       * The space after the text is something that google docs does.
	                       */
	                      ariaNotifier[0].appendChild(document.createTextNode(text + " "));
	                      ariaNotifier[0].style.visibility = 'hidden';
	                      ariaNotifier[0].style.visibility = 'visible';
	                    }
	                  }
	
	                  function getAppendedColumnHeaderText(col) {
	                    return ', ' + i18nService.getSafeText('headerCell.aria.column') + ' ' + col.displayName;
	                  }
	
	                  function getCellDisplayValue(currentRowColumn) {
	                    if (currentRowColumn.col.field === 'selectionRowHeaderCol') {
	                      // This is the case when the 'selection' feature is used in the grid and the user has moved
	                      // to or inside of the left grid container which holds the checkboxes for selecting rows.
	                      // This is necessary for Accessibility. Without this a screen reader cannot determine if the row
	                      // is or is not currently selected.
	                        return currentRowColumn.row.isSelected ? i18nService.getSafeText('search.aria.selected') : i18nService.getSafeText('search.aria.notSelected');
	                      } else {
	                        return grid.getCellDisplayValue(currentRowColumn.row, currentRowColumn.col);
	                      }
	                    }
	
	                  var values = [];
	                  var currentSelection = grid.api.cellNav.getCurrentSelection();
	                  for (var i = 0; i < currentSelection.length; i++) {
	                    var cellDisplayValue = getCellDisplayValue(currentSelection[i]) + getAppendedColumnHeaderText(currentSelection[i].col);
	                    values.push(cellDisplayValue);
	                  }
	                  var cellText = values.toString();
	                  setNotifyText(cellText);
	
	                });
	              }
	              // Only add the ngAria stuff it will be used
	              if (usesAria) {
	                addAriaLiveRegion();
	              }
	            }
	          };
	        }
	      };
	    }]);
	
	  module.directive('uiGridRenderContainer', ['$timeout', '$document', 'gridUtil', 'uiGridConstants', 'uiGridCellNavService', '$compile','uiGridCellNavConstants',
	    function ($timeout, $document, gridUtil, uiGridConstants, uiGridCellNavService, $compile, uiGridCellNavConstants) {
	      return {
	        replace: true,
	        priority: -99999, //this needs to run very last
	        require: ['^uiGrid', 'uiGridRenderContainer', '?^uiGridCellnav'],
	        scope: false,
	        compile: function () {
	          return {
	            post: function ($scope, $elm, $attrs, controllers) {
	              var uiGridCtrl = controllers[0],
	                 renderContainerCtrl = controllers[1],
	                 uiGridCellnavCtrl = controllers[2];
	
	              // Skip attaching cell-nav specific logic if the directive is not attached above us
	              if (!uiGridCtrl.grid.api.cellNav) { return; }
	
	              var containerId = renderContainerCtrl.containerId;
	
	              var grid = uiGridCtrl.grid;
	
	              //run each time a render container is created
	              uiGridCellNavService.decorateRenderContainers(grid);
	
	              // focusser only created for body
	              if (containerId !== 'body') {
	                return;
	              }
	
	
	
	              if (uiGridCtrl.grid.options.modifierKeysToMultiSelectCells){
	                $elm.attr('aria-multiselectable', true);
	              } else {
	                $elm.attr('aria-multiselectable', false);
	              }
	
	              //add an element with no dimensions that can be used to set focus and capture keystrokes
	              var focuser = $compile('<div class="ui-grid-focuser" role="region" aria-live="assertive" aria-atomic="false" tabindex="0" aria-controls="' + grid.id +'-aria-speakable '+ grid.id + '-grid-container' +'" aria-owns="' + grid.id + '-grid-container' + '"></div>')($scope);
	              $elm.append(focuser);
	
	              focuser.on('focus', function (evt) {
	                evt.uiGridTargetRenderContainerId = containerId;
	                var rowCol = uiGridCtrl.grid.api.cellNav.getFocusedCell();
	                if (rowCol === null) {
	                  rowCol = uiGridCtrl.grid.renderContainers[containerId].cellNav.getNextRowCol(uiGridCellNavConstants.direction.DOWN, null, null);
	                  if (rowCol.row && rowCol.col) {
	                    uiGridCtrl.cellNav.broadcastCellNav(rowCol);
	                  }
	                }
	              });
	
	              uiGridCellnavCtrl.setAriaActivedescendant = function(id){
	                $elm.attr('aria-activedescendant', id);
	              };
	
	              uiGridCellnavCtrl.removeAriaActivedescendant = function(id){
	                if ($elm.attr('aria-activedescendant') === id){
	                  $elm.attr('aria-activedescendant', '');
	                }
	              };
	
	
	              uiGridCtrl.focus = function () {
	                gridUtil.focus.byElement(focuser[0]);
	                //allow for first time grid focus
	              };
	
	              var viewPortKeyDownWasRaisedForRowCol = null;
	              // Bind to keydown events in the render container
	              focuser.on('keydown', function (evt) {
	                evt.uiGridTargetRenderContainerId = containerId;
	                var rowCol = uiGridCtrl.grid.api.cellNav.getFocusedCell();
	                var raiseViewPortKeyDown = uiGridCtrl.grid.options.keyDownOverrides.some(function (override) {
	                    return Object.keys(override).every( function (property) {
	                        return override[property] === evt[property];
	                    });
	                });
	                var result = raiseViewPortKeyDown ? null : uiGridCtrl.cellNav.handleKeyDown(evt);
	                if (result === null) {
	                  uiGridCtrl.grid.api.cellNav.raise.viewPortKeyDown(evt, rowCol, uiGridCtrl.cellNav.handleKeyDown);
	                  viewPortKeyDownWasRaisedForRowCol = rowCol;
	                }
	              });
	              //Bind to keypress events in the render container
	              //keypress events are needed by edit function so the key press
	              //that initiated an edit is not lost
	              //must fire the event in a timeout so the editor can
	              //initialize and subscribe to the event on another event loop
	              focuser.on('keypress', function (evt) {
	                if (viewPortKeyDownWasRaisedForRowCol) {
	                  $timeout(function () {
	                    uiGridCtrl.grid.api.cellNav.raise.viewPortKeyPress(evt, viewPortKeyDownWasRaisedForRowCol);
	                  },4);
	
	                  viewPortKeyDownWasRaisedForRowCol = null;
	                }
	              });
	
	              $scope.$on('$destroy', function(){
	                //Remove all event handlers associated with this focuser.
	                focuser.off();
	              });
	
	            }
	          };
	        }
	      };
	    }]);
	
	  module.directive('uiGridViewport', ['$timeout', '$document', 'gridUtil', 'uiGridConstants', 'uiGridCellNavService', 'uiGridCellNavConstants','$log','$compile',
	    function ($timeout, $document, gridUtil, uiGridConstants, uiGridCellNavService, uiGridCellNavConstants, $log, $compile) {
	      return {
	        replace: true,
	        priority: -99999, //this needs to run very last
	        require: ['^uiGrid', '^uiGridRenderContainer', '?^uiGridCellnav'],
	        scope: false,
	        compile: function () {
	          return {
	            pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	            },
	            post: function ($scope, $elm, $attrs, controllers) {
	              var uiGridCtrl = controllers[0],
	                renderContainerCtrl = controllers[1];
	
	              // Skip attaching cell-nav specific logic if the directive is not attached above us
	              if (!uiGridCtrl.grid.api.cellNav) { return; }
	
	              var containerId = renderContainerCtrl.containerId;
	              //no need to process for other containers
	              if (containerId !== 'body') {
	                return;
	              }
	
	              var grid = uiGridCtrl.grid;
	
	              grid.api.core.on.scrollBegin($scope, function (args) {
	
	                // Skip if there's no currently-focused cell
	                var lastRowCol = uiGridCtrl.grid.api.cellNav.getFocusedCell();
	                if (lastRowCol === null) {
	                  return;
	                }
	
	                //if not in my container, move on
	                //todo: worry about horiz scroll
	                if (!renderContainerCtrl.colContainer.containsColumn(lastRowCol.col)) {
	                  return;
	                }
	
	                uiGridCtrl.cellNav.clearFocus();
	
	              });
	
	              grid.api.core.on.scrollEnd($scope, function (args) {
	                // Skip if there's no currently-focused cell
	                var lastRowCol = uiGridCtrl.grid.api.cellNav.getFocusedCell();
	                if (lastRowCol === null) {
	                  return;
	                }
	
	                //if not in my container, move on
	                //todo: worry about horiz scroll
	                if (!renderContainerCtrl.colContainer.containsColumn(lastRowCol.col)) {
	                  return;
	                }
	
	                uiGridCtrl.cellNav.broadcastCellNav(lastRowCol);
	
	              });
	
	              grid.api.cellNav.on.navigate($scope, function () {
	                //focus again because it can be lost
	                 uiGridCtrl.focus();
	              });
	
	            }
	          };
	        }
	      };
	    }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.cellNav.directive:uiGridCell
	   *  @element div
	   *  @restrict A
	   *  @description Stacks on top of ui.grid.uiGridCell to provide cell navigation
	   */
	  module.directive('uiGridCell', ['$timeout', '$document', 'uiGridCellNavService', 'gridUtil', 'uiGridCellNavConstants', 'uiGridConstants', 'GridRowColumn',
	    function ($timeout, $document, uiGridCellNavService, gridUtil, uiGridCellNavConstants, uiGridConstants, GridRowColumn) {
	      return {
	        priority: -150, // run after default uiGridCell directive and ui.grid.edit uiGridCell
	        restrict: 'A',
	        require: ['^uiGrid', '?^uiGridCellnav'],
	        scope: false,
	        link: function ($scope, $elm, $attrs, controllers) {
	          var uiGridCtrl = controllers[0],
	              uiGridCellnavCtrl = controllers[1];
	          // Skip attaching cell-nav specific logic if the directive is not attached above us
	          if (!uiGridCtrl.grid.api.cellNav) { return; }
	
	          if (!$scope.col.colDef.allowCellFocus) {
	            return;
	          }
	
	          //Convinience local variables
	          var grid = uiGridCtrl.grid;
	          $scope.focused = false;
	
	          // Make this cell focusable but only with javascript/a mouse click
	          $elm.attr('tabindex', -1);
	
	          // When a cell is clicked, broadcast a cellNav event saying that this row+col combo is now focused
	          $elm.find('div').on('click', function (evt) {
	            uiGridCtrl.cellNav.broadcastCellNav(new GridRowColumn($scope.row, $scope.col), evt.ctrlKey || evt.metaKey, evt);
	
	            evt.stopPropagation();
	            $scope.$apply();
	          });
	
	
	          /*
	           * XXX Hack for screen readers.
	           * This allows the grid to focus using only the screen reader cursor.
	           * Since the focus event doesn't include key press information we can't use it
	           * as our primary source of the event.
	           */
	          $elm.on('mousedown', preventMouseDown);
	
	          //turn on and off for edit events
	          if (uiGridCtrl.grid.api.edit) {
	            uiGridCtrl.grid.api.edit.on.beginCellEdit($scope, function () {
	              $elm.off('mousedown', preventMouseDown);
	            });
	
	            uiGridCtrl.grid.api.edit.on.afterCellEdit($scope, function () {
	              $elm.on('mousedown', preventMouseDown);
	            });
	
	            uiGridCtrl.grid.api.edit.on.cancelCellEdit($scope, function () {
	              $elm.on('mousedown', preventMouseDown);
	            });
	          }
	
	          // In case we created a new row, and we are the new created row by ngRepeat
	          // then this cell content might have been selected previously
	          refreshCellFocus();
	
	          function preventMouseDown(evt) {
	            //Prevents the foucus event from firing if the click event is already going to fire.
	            //If both events fire it will cause bouncing behavior.
	            evt.preventDefault();
	          }
	
	          //You can only focus on elements with a tabindex value
	          $elm.on('focus', function (evt) {
	            uiGridCtrl.cellNav.broadcastCellNav(new GridRowColumn($scope.row, $scope.col), false, evt);
	            evt.stopPropagation();
	            $scope.$apply();
	          });
	
	          // This event is fired for all cells.  If the cell matches, then focus is set
	          $scope.$on(uiGridCellNavConstants.CELL_NAV_EVENT, refreshCellFocus);
	
	          // Refresh cell focus when a new row id added to the grid
	          var dataChangeDereg = uiGridCtrl.grid.registerDataChangeCallback(function (grid) {
	            // Clear the focus if it's set to avoid the wrong cell getting focused during
	            // a short period of time (from now until $timeout function executed)
	            clearFocus();
	
	            $scope.$applyAsync(refreshCellFocus);
	          }, [uiGridConstants.dataChange.ROW]);
	
	          function refreshCellFocus() {
	            var isFocused = grid.cellNav.focusedCells.some(function (focusedRowCol, index) {
	              return (focusedRowCol.row === $scope.row && focusedRowCol.col === $scope.col);
	            });
	            if (isFocused) {
	              setFocused();
	            } else {
	              clearFocus();
	            }
	          }
	
	          function setFocused() {
	            if (!$scope.focused){
	              var div = $elm.find('div');
	              div.addClass('ui-grid-cell-focus');
	              $elm.attr('aria-selected', true);
	              uiGridCellnavCtrl.setAriaActivedescendant($elm.attr('id'));
	              $scope.focused = true;
	            }
	          }
	
	          function clearFocus() {
	            if ($scope.focused){
	              var div = $elm.find('div');
	              div.removeClass('ui-grid-cell-focus');
	              $elm.attr('aria-selected', false);
	              uiGridCellnavCtrl.removeAriaActivedescendant($elm.attr('id'));
	              $scope.focused = false;
	            }
	          }
	
	          $scope.$on('$destroy', function () {
	            dataChangeDereg();
	
	            //.off withouth paramaters removes all handlers
	            $elm.find('div').off();
	            $elm.off();
	          });
	        }
	      };
	    }]);
	
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.edit
	   * @description
	   *
	   * # ui.grid.edit
	   *
	   * <div class="alert alert-success" role="alert"><strong>Stable</strong> This feature is stable. There should no longer be breaking api changes without a deprecation warning.</div>
	   *
	   * This module provides cell editing capability to ui.grid. The goal was to emulate keying data in a spreadsheet via
	   * a keyboard.
	   * <br/>
	   * <br/>
	   * To really get the full spreadsheet-like data entry, the ui.grid.cellNav module should be used. This will allow the
	   * user to key data and then tab, arrow, or enter to the cells beside or below.
	   *
	   * <div doc-module-components="ui.grid.edit"></div>
	   */
	
	  var module = angular.module('ui.grid.edit', ['ui.grid']);
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.edit.constant:uiGridEditConstants
	   *
	   *  @description constants available in edit module
	   */
	  module.constant('uiGridEditConstants', {
	    EDITABLE_CELL_TEMPLATE: /EDITABLE_CELL_TEMPLATE/g,
	    //must be lowercase because template bulder converts to lower
	    EDITABLE_CELL_DIRECTIVE: /editable_cell_directive/g,
	    events: {
	      BEGIN_CELL_EDIT: 'uiGridEventBeginCellEdit',
	      END_CELL_EDIT: 'uiGridEventEndCellEdit',
	      CANCEL_CELL_EDIT: 'uiGridEventCancelCellEdit'
	    }
	  });
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.edit.service:uiGridEditService
	   *
	   *  @description Services for editing features
	   */
	  module.service('uiGridEditService', ['$q', 'uiGridConstants', 'gridUtil',
	    function ($q, uiGridConstants, gridUtil) {
	
	      var service = {
	
	        initializeGrid: function (grid) {
	
	          service.defaultGridOptions(grid.options);
	
	          grid.registerColumnBuilder(service.editColumnBuilder);
	          grid.edit = {};
	
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.edit.api:PublicApi
	           *
	           *  @description Public Api for edit feature
	           */
	          var publicApi = {
	            events: {
	              edit: {
	                /**
	                 * @ngdoc event
	                 * @name afterCellEdit
	                 * @eventOf  ui.grid.edit.api:PublicApi
	                 * @description raised when cell editing is complete
	                 * <pre>
	                 *      gridApi.edit.on.afterCellEdit(scope,function(rowEntity, colDef){})
	                 * </pre>
	                 * @param {object} rowEntity the options.data element that was edited
	                 * @param {object} colDef the column that was edited
	                 * @param {object} newValue new value
	                 * @param {object} oldValue old value
	                 */
	                afterCellEdit: function (rowEntity, colDef, newValue, oldValue) {
	                },
	                /**
	                 * @ngdoc event
	                 * @name beginCellEdit
	                 * @eventOf  ui.grid.edit.api:PublicApi
	                 * @description raised when cell editing starts on a cell
	                 * <pre>
	                 *      gridApi.edit.on.beginCellEdit(scope,function(rowEntity, colDef){})
	                 * </pre>
	                 * @param {object} rowEntity the options.data element that was edited
	                 * @param {object} colDef the column that was edited
	                 * @param {object} triggerEvent the event that triggered the edit.  Useful to prevent losing keystrokes on some
	                 *                 complex editors
	                 */
	                beginCellEdit: function (rowEntity, colDef, triggerEvent) {
	                },
	                /**
	                 * @ngdoc event
	                 * @name cancelCellEdit
	                 * @eventOf  ui.grid.edit.api:PublicApi
	                 * @description raised when cell editing is cancelled on a cell
	                 * <pre>
	                 *      gridApi.edit.on.cancelCellEdit(scope,function(rowEntity, colDef){})
	                 * </pre>
	                 * @param {object} rowEntity the options.data element that was edited
	                 * @param {object} colDef the column that was edited
	                 */
	                cancelCellEdit: function (rowEntity, colDef) {
	                }
	              }
	            },
	            methods: {
	              edit: { }
	            }
	          };
	
	          grid.api.registerEventsFromObject(publicApi.events);
	          //grid.api.registerMethodsFromObject(publicApi.methods);
	
	        },
	
	        defaultGridOptions: function (gridOptions) {
	
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.edit.api:GridOptions
	           *
	           *  @description Options for configuring the edit feature, these are available to be
	           *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	           */
	
	          /**
	           *  @ngdoc object
	           *  @name enableCellEdit
	           *  @propertyOf  ui.grid.edit.api:GridOptions
	           *  @description If defined, sets the default value for the editable flag on each individual colDefs
	           *  if their individual enableCellEdit configuration is not defined. Defaults to undefined.
	           */
	
	          /**
	           *  @ngdoc object
	           *  @name cellEditableCondition
	           *  @propertyOf  ui.grid.edit.api:GridOptions
	           *  @description If specified, either a value or function to be used by all columns before editing.
	           *  If false, then editing of cell is not allowed.
	           *  @example
	           *  <pre>
	           *  function($scope, triggerEvent){
	           *    //use $scope.row.entity, $scope.col.colDef and triggerEvent to determine if editing is allowed
	           *    return true;
	           *  }
	           *  </pre>
	           */
	          gridOptions.cellEditableCondition = gridOptions.cellEditableCondition === undefined ? true : gridOptions.cellEditableCondition;
	
	          /**
	           *  @ngdoc object
	           *  @name editableCellTemplate
	           *  @propertyOf  ui.grid.edit.api:GridOptions
	           *  @description If specified, cellTemplate to use as the editor for all columns.
	           *  <br/> defaults to 'ui-grid/cellTextEditor'
	           */
	
	          /**
	           *  @ngdoc object
	           *  @name enableCellEditOnFocus
	           *  @propertyOf  ui.grid.edit.api:GridOptions
	           *  @description If true, then editor is invoked as soon as cell receives focus. Default false.
	           *  <br/>_requires cellNav feature and the edit feature to be enabled_
	           */
	            //enableCellEditOnFocus can only be used if cellnav module is used
	          gridOptions.enableCellEditOnFocus = gridOptions.enableCellEditOnFocus === undefined ? false : gridOptions.enableCellEditOnFocus;
	        },
	
	        /**
	         * @ngdoc service
	         * @name editColumnBuilder
	         * @methodOf ui.grid.edit.service:uiGridEditService
	         * @description columnBuilder function that adds edit properties to grid column
	         * @returns {promise} promise that will load any needed templates when resolved
	         */
	        editColumnBuilder: function (colDef, col, gridOptions) {
	
	          var promises = [];
	
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.edit.api:ColumnDef
	           *
	           *  @description Column Definition for edit feature, these are available to be
	           *  set using the ui-grid {@link ui.grid.class:GridOptions.columnDef gridOptions.columnDefs}
	           */
	
	          /**
	           *  @ngdoc object
	           *  @name enableCellEdit
	           *  @propertyOf  ui.grid.edit.api:ColumnDef
	           *  @description enable editing on column
	           */
	          colDef.enableCellEdit = colDef.enableCellEdit === undefined ? (gridOptions.enableCellEdit === undefined ?
	            (colDef.type !== 'object') : gridOptions.enableCellEdit) : colDef.enableCellEdit;
	
	          /**
	           *  @ngdoc object
	           *  @name cellEditableCondition
	           *  @propertyOf  ui.grid.edit.api:ColumnDef
	           *  @description If specified, either a value or function evaluated before editing cell.  If falsy, then editing of cell is not allowed.
	           *  @example
	           *  <pre>
	           *  function($scope, triggerEvent){
	           *    //use $scope.row.entity, $scope.col.colDef and triggerEvent to determine if editing is allowed
	           *    return true;
	           *  }
	           *  </pre>
	           */
	          colDef.cellEditableCondition = colDef.cellEditableCondition === undefined ? gridOptions.cellEditableCondition :  colDef.cellEditableCondition;
	
	          /**
	           *  @ngdoc object
	           *  @name editableCellTemplate
	           *  @propertyOf  ui.grid.edit.api:ColumnDef
	           *  @description cell template to be used when editing this column. Can be Url or text template
	           *  <br/>Defaults to gridOptions.editableCellTemplate
	           */
	          if (colDef.enableCellEdit) {
	            colDef.editableCellTemplate = colDef.editableCellTemplate || gridOptions.editableCellTemplate || 'ui-grid/cellEditor';
	
	            promises.push(gridUtil.getTemplate(colDef.editableCellTemplate)
	              .then(
	              function (template) {
	                col.editableCellTemplate = template;
	              },
	              function (res) {
	                // Todo handle response error here?
	                throw new Error("Couldn't fetch/use colDef.editableCellTemplate '" + colDef.editableCellTemplate + "'");
	              }));
	          }
	
	          /**
	           *  @ngdoc object
	           *  @name enableCellEditOnFocus
	           *  @propertyOf  ui.grid.edit.api:ColumnDef
	           *  @requires ui.grid.cellNav
	           *  @description If true, then editor is invoked as soon as cell receives focus. Default false.
	           *  <br>_requires both the cellNav feature and the edit feature to be enabled_
	           */
	            //enableCellEditOnFocus can only be used if cellnav module is used
	          colDef.enableCellEditOnFocus = colDef.enableCellEditOnFocus === undefined ? gridOptions.enableCellEditOnFocus : colDef.enableCellEditOnFocus;
	
	
	          /**
	           *  @ngdoc string
	           *  @name editModelField
	           *  @propertyOf  ui.grid.edit.api:ColumnDef
	           *  @description a bindable string value that is used when binding to edit controls instead of colDef.field
	           *  <br/> example: You have a complex property on and object like state:{abbrev:'MS',name:'Mississippi'}.  The
	           *  grid should display state.name in the cell and sort/filter based on the state.name property but the editor
	           *  requires the full state object.
	           *  <br/>colDef.field = 'state.name'
	           *  <br/>colDef.editModelField = 'state'
	           */
	          //colDef.editModelField
	
	          return $q.all(promises);
	        },
	
	        /**
	         * @ngdoc service
	         * @name isStartEditKey
	         * @methodOf ui.grid.edit.service:uiGridEditService
	         * @description  Determines if a keypress should start editing.  Decorate this service to override with your
	         * own key events.  See service decorator in angular docs.
	         * @param {Event} evt keydown event
	         * @returns {boolean} true if an edit should start
	         */
	        isStartEditKey: function (evt) {
	          if (evt.metaKey ||
	              evt.keyCode === uiGridConstants.keymap.ESC ||
	              evt.keyCode === uiGridConstants.keymap.SHIFT ||
	              evt.keyCode === uiGridConstants.keymap.CTRL ||
	              evt.keyCode === uiGridConstants.keymap.ALT ||
	              evt.keyCode === uiGridConstants.keymap.WIN ||
	              evt.keyCode === uiGridConstants.keymap.CAPSLOCK ||
	
	             evt.keyCode === uiGridConstants.keymap.LEFT ||
	            (evt.keyCode === uiGridConstants.keymap.TAB && evt.shiftKey) ||
	
	            evt.keyCode === uiGridConstants.keymap.RIGHT ||
	            evt.keyCode === uiGridConstants.keymap.TAB ||
	
	            evt.keyCode === uiGridConstants.keymap.UP ||
	            (evt.keyCode === uiGridConstants.keymap.ENTER && evt.shiftKey) ||
	
	            evt.keyCode === uiGridConstants.keymap.DOWN ||
	            evt.keyCode === uiGridConstants.keymap.ENTER) {
	            return false;
	
	          }
	          return true;
	        }
	
	
	      };
	
	      return service;
	
	    }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.edit.directive:uiGridEdit
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Adds editing features to the ui-grid directive.
	   *
	   *  @example
	   <example module="app">
	   <file name="app.js">
	   var app = angular.module('app', ['ui.grid', 'ui.grid.edit']);
	
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	      $scope.data = [
	        { name: 'Bob', title: 'CEO' },
	            { name: 'Frank', title: 'Lowly Developer' }
	      ];
	
	      $scope.columnDefs = [
	        {name: 'name', enableCellEdit: true},
	        {name: 'title', enableCellEdit: true}
	      ];
	    }]);
	   </file>
	   <file name="index.html">
	   <div ng-controller="MainCtrl">
	   <div ui-grid="{ data: data, columnDefs: columnDefs }" ui-grid-edit></div>
	   </div>
	   </file>
	   </example>
	   */
	  module.directive('uiGridEdit', ['gridUtil', 'uiGridEditService', function (gridUtil, uiGridEditService) {
	    return {
	      replace: true,
	      priority: 0,
	      require: '^uiGrid',
	      scope: false,
	      compile: function () {
	        return {
	          pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	            uiGridEditService.initializeGrid(uiGridCtrl.grid);
	          },
	          post: function ($scope, $elm, $attrs, uiGridCtrl) {
	          }
	        };
	      }
	    };
	  }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.edit.directive:uiGridRenderContainer
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Adds keydown listeners to renderContainer element so we can capture when to begin edits
	   *
	   */
	  module.directive('uiGridViewport', [ 'uiGridEditConstants',
	    function ( uiGridEditConstants) {
	      return {
	        replace: true,
	        priority: -99998, //run before cellNav
	        require: ['^uiGrid', '^uiGridRenderContainer'],
	        scope: false,
	        compile: function () {
	          return {
	            post: function ($scope, $elm, $attrs, controllers) {
	              var uiGridCtrl = controllers[0];
	
	              // Skip attaching if edit and cellNav is not enabled
	              if (!uiGridCtrl.grid.api.edit || !uiGridCtrl.grid.api.cellNav) { return; }
	
	              var containerId =  controllers[1].containerId;
	              //no need to process for other containers
	              if (containerId !== 'body') {
	                return;
	              }
	
	              //refocus on the grid
	              $scope.$on(uiGridEditConstants.events.CANCEL_CELL_EDIT, function () {
	                uiGridCtrl.focus();
	              });
	              $scope.$on(uiGridEditConstants.events.END_CELL_EDIT, function () {
	                uiGridCtrl.focus();
	              });
	
	            }
	          };
	        }
	      };
	    }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.edit.directive:uiGridCell
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Stacks on top of ui.grid.uiGridCell to provide in-line editing capabilities to the cell
	   *  Editing Actions.
	   *
	   *  Binds edit start events to the uiGridCell element.  When the events fire, the gridCell element is appended
	   *  with the columnDef.editableCellTemplate element ('cellEditor.html' by default).
	   *
	   *  The editableCellTemplate should respond to uiGridEditConstants.events.BEGIN\_CELL\_EDIT angular event
	   *  and do the initial steps needed to edit the cell (setfocus on input element, etc).
	   *
	   *  When the editableCellTemplate recognizes that the editing is ended (blur event, Enter key, etc.)
	   *  it should emit the uiGridEditConstants.events.END\_CELL\_EDIT event.
	   *
	   *  If editableCellTemplate recognizes that the editing has been cancelled (esc key)
	   *  it should emit the uiGridEditConstants.events.CANCEL\_CELL\_EDIT event.  The original value
	   *  will be set back on the model by the uiGridCell directive.
	   *
	   *  Events that invoke editing:
	   *    - dblclick
	   *    - F2 keydown (when using cell selection)
	   *
	   *  Events that end editing:
	   *    - Dependent on the specific editableCellTemplate
	   *    - Standards should be blur and enter keydown
	   *
	   *  Events that cancel editing:
	   *    - Dependent on the specific editableCellTemplate
	   *    - Standards should be Esc keydown
	   *
	   *  Grid Events that end editing:
	   *    - uiGridConstants.events.GRID_SCROLL
	   *
	   */
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.edit.api:GridRow
	   *
	   *  @description GridRow options for edit feature, these are available to be
	   *  set internally only, by other features
	   */
	
	  /**
	   *  @ngdoc object
	   *  @name enableCellEdit
	   *  @propertyOf  ui.grid.edit.api:GridRow
	   *  @description enable editing on row, grouping for example might disable editing on group header rows
	   */
	
	  module.directive('uiGridCell',
	    ['$compile', '$injector', '$timeout', 'uiGridConstants', 'uiGridEditConstants', 'gridUtil', '$parse', 'uiGridEditService', '$rootScope', '$q',
	      function ($compile, $injector, $timeout, uiGridConstants, uiGridEditConstants, gridUtil, $parse, uiGridEditService, $rootScope, $q) {
	        var touchstartTimeout = 500;
	        if ($injector.has('uiGridCellNavService')) {
	          var uiGridCellNavService = $injector.get('uiGridCellNavService');
	        }
	
	        return {
	          priority: -100, // run after default uiGridCell directive
	          restrict: 'A',
	          scope: false,
	          require: '?^uiGrid',
	          link: function ($scope, $elm, $attrs, uiGridCtrl) {
	            var html;
	            var origCellValue;
	            var inEdit = false;
	            var cellModel;
	            var cancelTouchstartTimeout;
	
	            var editCellScope;
	
	            if (!$scope.col.colDef.enableCellEdit) {
	              return;
	            }
	
	            var cellNavNavigateDereg = function() {};
	            var viewPortKeyDownDereg = function() {};
	
	
	            var setEditable = function() {
	              if ($scope.col.colDef.enableCellEdit && $scope.row.enableCellEdit !== false) {
	                if (!$scope.beginEditEventsWired) { //prevent multiple attachments
	                  registerBeginEditEvents();
	                }
	              } else {
	                if ($scope.beginEditEventsWired) {
	                  cancelBeginEditEvents();
	                }
	              }
	            };
	
	            setEditable();
	
	            var rowWatchDereg = $scope.$watch('row', function (n, o) {
	              if (n !== o) {
	                setEditable();
	              }
	            });
	
	
	            $scope.$on('$destroy', function destroyEvents() {
	              rowWatchDereg();
	              // unbind all jquery events in order to avoid memory leaks
	              $elm.off();
	            });
	
	            function registerBeginEditEvents() {
	              $elm.on('dblclick', beginEdit);
	
	              // Add touchstart handling. If the users starts a touch and it doesn't end after X milliseconds, then start the edit
	              $elm.on('touchstart', touchStart);
	
	              if (uiGridCtrl && uiGridCtrl.grid.api.cellNav) {
	
	                viewPortKeyDownDereg = uiGridCtrl.grid.api.cellNav.on.viewPortKeyDown($scope, function (evt, rowCol) {
	                  if (rowCol === null) {
	                    return;
	                  }
	
	                  if (rowCol.row === $scope.row && rowCol.col === $scope.col && !$scope.col.colDef.enableCellEditOnFocus) {
	                    //important to do this before scrollToIfNecessary
	                    beginEditKeyDown(evt);
	                  }
	                });
	
	                cellNavNavigateDereg = uiGridCtrl.grid.api.cellNav.on.navigate($scope, function (newRowCol, oldRowCol, evt) {
	                  if ($scope.col.colDef.enableCellEditOnFocus) {
	                    // Don't begin edit if the cell hasn't changed
	                    if (newRowCol.row === $scope.row && newRowCol.col === $scope.col &&
	                      (!evt || (evt && (evt.type === 'click' || evt.type === 'keydown')))) {
	                      $timeout(function() {
	                        beginEdit(evt);
	                      });
	                    }
	                  }
	                });
	              }
	
	              $scope.beginEditEventsWired = true;
	            }
	
	            function touchStart(event) {
	              // jQuery masks events
	              if (typeof(event.originalEvent) !== 'undefined' && event.originalEvent !== undefined) {
	                event = event.originalEvent;
	              }
	
	              // Bind touchend handler
	              $elm.on('touchend', touchEnd);
	
	              // Start a timeout
	              cancelTouchstartTimeout = $timeout(function() { }, touchstartTimeout);
	
	              // Timeout's done! Start the edit
	              cancelTouchstartTimeout.then(function () {
	                // Use setTimeout to start the edit because beginEdit expects to be outside of $digest
	                setTimeout(beginEdit, 0);
	
	                // Undbind the touchend handler, we don't need it anymore
	                $elm.off('touchend', touchEnd);
	              });
	            }
	
	            // Cancel any touchstart timeout
	            function touchEnd(event) {
	              $timeout.cancel(cancelTouchstartTimeout);
	              $elm.off('touchend', touchEnd);
	            }
	
	            function cancelBeginEditEvents() {
	              $elm.off('dblclick', beginEdit);
	              $elm.off('keydown', beginEditKeyDown);
	              $elm.off('touchstart', touchStart);
	              cellNavNavigateDereg();
	              viewPortKeyDownDereg();
	              $scope.beginEditEventsWired = false;
	            }
	
	            function beginEditKeyDown(evt) {
	              if (uiGridEditService.isStartEditKey(evt)) {
	                beginEdit(evt);
	              }
	            }
	
	            function shouldEdit(col, row, triggerEvent) {
	              return !row.isSaving &&
	                ( angular.isFunction(col.colDef.cellEditableCondition) ?
	                    col.colDef.cellEditableCondition($scope, triggerEvent) :
	                    col.colDef.cellEditableCondition );
	            }
	
	
	            function beginEdit(triggerEvent) {
	              //we need to scroll the cell into focus before invoking the editor
	              $scope.grid.api.core.scrollToIfNecessary($scope.row, $scope.col)
	                .then(function () {
	                  beginEditAfterScroll(triggerEvent);
	                });
	            }
	
	            /**
	             *  @ngdoc property
	             *  @name editDropdownOptionsArray
	             *  @propertyOf ui.grid.edit.api:ColumnDef
	             *  @description an array of values in the format
	             *  [ {id: xxx, value: xxx} ], which is populated
	             *  into the edit dropdown
	             *
	             */
	            /**
	             *  @ngdoc property
	             *  @name editDropdownIdLabel
	             *  @propertyOf ui.grid.edit.api:ColumnDef
	             *  @description the label for the "id" field
	             *  in the editDropdownOptionsArray.  Defaults
	             *  to 'id'
	             *  @example
	             *  <pre>
	             *    $scope.gridOptions = {
	             *      columnDefs: [
	             *        {name: 'status', editableCellTemplate: 'ui-grid/dropdownEditor',
	             *          editDropdownOptionsArray: [{code: 1, status: 'active'}, {code: 2, status: 'inactive'}],
	             *          editDropdownIdLabel: 'code', editDropdownValueLabel: 'status' }
	             *      ],
	             *  </pre>
	             *
	             */
	            /**
	             *  @ngdoc property
	             *  @name editDropdownRowEntityOptionsArrayPath
	             *  @propertyOf ui.grid.edit.api:ColumnDef
	             *  @description a path to a property on row.entity containing an
	             *  array of values in the format
	             *  [ {id: xxx, value: xxx} ], which will be used to populate
	             *  the edit dropdown.  This can be used when the dropdown values are dependent on
	             *  the backing row entity.
	             *  If this property is set then editDropdownOptionsArray will be ignored.
	             *  @example
	             *  <pre>
	             *    $scope.gridOptions = {
	             *      columnDefs: [
	             *        {name: 'status', editableCellTemplate: 'ui-grid/dropdownEditor',
	             *          editDropdownRowEntityOptionsArrayPath: 'foo.bars[0].baz',
	             *          editDropdownIdLabel: 'code', editDropdownValueLabel: 'status' }
	             *      ],
	             *  </pre>
	             *
	             */
	            /**
	             *  @ngdoc service
	             *  @name editDropdownOptionsFunction
	             *  @methodOf ui.grid.edit.api:ColumnDef
	             *  @description a function returning an array of values in the format
	             *  [ {id: xxx, value: xxx} ], which will be used to populate
	             *  the edit dropdown.  This can be used when the dropdown values are dependent on
	             *  the backing row entity with some kind of algorithm.
	             *  If this property is set then both editDropdownOptionsArray and
	             *  editDropdownRowEntityOptionsArrayPath will be ignored.
	             *  @param {object} rowEntity the options.data element that the returned array refers to
	             *  @param {object} colDef the column that implements this dropdown
	             *  @returns {object} an array of values in the format
	             *  [ {id: xxx, value: xxx} ] used to populate the edit dropdown
	             *  @example
	             *  <pre>
	             *    $scope.gridOptions = {
	             *      columnDefs: [
	             *        {name: 'status', editableCellTemplate: 'ui-grid/dropdownEditor',
	             *          editDropdownOptionsFunction: function(rowEntity, colDef) {
	             *            if (rowEntity.foo === 'bar') {
	             *              return [{id: 'bar1', value: 'BAR 1'},
	             *                      {id: 'bar2', value: 'BAR 2'},
	             *                      {id: 'bar3', value: 'BAR 3'}];
	             *            } else {
	             *              return [{id: 'foo1', value: 'FOO 1'},
	             *                      {id: 'foo2', value: 'FOO 2'}];
	             *            }
	             *          },
	             *          editDropdownIdLabel: 'code', editDropdownValueLabel: 'status' }
	             *      ],
	             *  </pre>
	             *
	             */
	            /**
	             *  @ngdoc property
	             *  @name editDropdownValueLabel
	             *  @propertyOf ui.grid.edit.api:ColumnDef
	             *  @description the label for the "value" field
	             *  in the editDropdownOptionsArray.  Defaults
	             *  to 'value'
	             *  @example
	             *  <pre>
	             *    $scope.gridOptions = {
	             *      columnDefs: [
	             *        {name: 'status', editableCellTemplate: 'ui-grid/dropdownEditor',
	             *          editDropdownOptionsArray: [{code: 1, status: 'active'}, {code: 2, status: 'inactive'}],
	             *          editDropdownIdLabel: 'code', editDropdownValueLabel: 'status' }
	             *      ],
	             *  </pre>
	             *
	             */
	            /**
	             *  @ngdoc property
	             *  @name editDropdownFilter
	             *  @propertyOf ui.grid.edit.api:ColumnDef
	             *  @description A filter that you would like to apply to the values in the options list
	             *  of the dropdown.  For example if you were using angular-translate you might set this
	             *  to `'translate'`
	             *  @example
	             *  <pre>
	             *    $scope.gridOptions = {
	             *      columnDefs: [
	             *        {name: 'status', editableCellTemplate: 'ui-grid/dropdownEditor',
	             *          editDropdownOptionsArray: [{code: 1, status: 'active'}, {code: 2, status: 'inactive'}],
	             *          editDropdownIdLabel: 'code', editDropdownValueLabel: 'status', editDropdownFilter: 'translate' }
	             *      ],
	             *  </pre>
	             *
	             */
	            function beginEditAfterScroll(triggerEvent) {
	              // If we are already editing, then just skip this so we don't try editing twice...
	              if (inEdit) {
	                return;
	              }
	
	              if (!shouldEdit($scope.col, $scope.row, triggerEvent)) {
	                return;
	              }
	
	              var modelField = $scope.row.getQualifiedColField($scope.col);
	              if ($scope.col.colDef.editModelField) {
	                modelField = gridUtil.preEval('row.entity.' + $scope.col.colDef.editModelField);
	              }
	
	              cellModel = $parse(modelField);
	
	              //get original value from the cell
	              origCellValue = cellModel($scope);
	
	              html = $scope.col.editableCellTemplate;
	              html = html.replace(uiGridConstants.MODEL_COL_FIELD, modelField);
	              html = html.replace(uiGridConstants.COL_FIELD, 'grid.getCellValue(row, col)');
	
	              var optionFilter = $scope.col.colDef.editDropdownFilter ? '|' + $scope.col.colDef.editDropdownFilter : '';
	              html = html.replace(uiGridConstants.CUSTOM_FILTERS, optionFilter);
	
	              var inputType = 'text';
	              switch ($scope.col.colDef.type){
	                case 'boolean':
	                  inputType = 'checkbox';
	                  break;
	                case 'number':
	                  inputType = 'number';
	                  break;
	                case 'date':
	                  inputType = 'date';
	                  break;
	              }
	              html = html.replace('INPUT_TYPE', inputType);
	
	              // In order to fill dropdown options we use:
	              // - A function/promise or
	              // - An array inside of row entity if no function exists or
	              // - A single array for the whole column if none of the previous exists.
	              var editDropdownOptionsFunction = $scope.col.colDef.editDropdownOptionsFunction;
	              if (editDropdownOptionsFunction) {
	                $q.when(editDropdownOptionsFunction($scope.row.entity, $scope.col.colDef))
	                        .then(function(result) {
	                  $scope.editDropdownOptionsArray = result;
	                });
	              } else {
	                var editDropdownRowEntityOptionsArrayPath = $scope.col.colDef.editDropdownRowEntityOptionsArrayPath;
	                if (editDropdownRowEntityOptionsArrayPath) {
	                  $scope.editDropdownOptionsArray =  resolveObjectFromPath($scope.row.entity, editDropdownRowEntityOptionsArrayPath);
	                }
	                else {
	                  $scope.editDropdownOptionsArray = $scope.col.colDef.editDropdownOptionsArray;
	                }
	              }
	              $scope.editDropdownIdLabel = $scope.col.colDef.editDropdownIdLabel ? $scope.col.colDef.editDropdownIdLabel : 'id';
	              $scope.editDropdownValueLabel = $scope.col.colDef.editDropdownValueLabel ? $scope.col.colDef.editDropdownValueLabel : 'value';
	
	              var cellElement;
	              var createEditor = function(){
	                inEdit = true;
	                cancelBeginEditEvents();
	                var cellElement = angular.element(html);
	                $elm.append(cellElement);
	                editCellScope = $scope.$new();
	                $compile(cellElement)(editCellScope);
	                var gridCellContentsEl = angular.element($elm.children()[0]);
	                gridCellContentsEl.addClass('ui-grid-cell-contents-hidden');
	              };
	              if (!$rootScope.$$phase) {
	                $scope.$apply(createEditor);
	              } else {
	                createEditor();
	              }
	
	              //stop editing when grid is scrolled
	              var deregOnGridScroll = $scope.col.grid.api.core.on.scrollBegin($scope, function () {
	                if ($scope.grid.disableScrolling) {
	                  return;
	                }
	                endEdit();
	                $scope.grid.api.edit.raise.afterCellEdit($scope.row.entity, $scope.col.colDef, cellModel($scope), origCellValue);
	                deregOnGridScroll();
	                deregOnEndCellEdit();
	                deregOnCancelCellEdit();
	              });
	
	              //end editing
	              var deregOnEndCellEdit = $scope.$on(uiGridEditConstants.events.END_CELL_EDIT, function () {
	                endEdit();
	                $scope.grid.api.edit.raise.afterCellEdit($scope.row.entity, $scope.col.colDef, cellModel($scope), origCellValue);
	                deregOnEndCellEdit();
	                deregOnGridScroll();
	                deregOnCancelCellEdit();
	              });
	
	              //cancel editing
	              var deregOnCancelCellEdit = $scope.$on(uiGridEditConstants.events.CANCEL_CELL_EDIT, function () {
	                cancelEdit();
	                deregOnCancelCellEdit();
	                deregOnGridScroll();
	                deregOnEndCellEdit();
	              });
	
	              $scope.$broadcast(uiGridEditConstants.events.BEGIN_CELL_EDIT, triggerEvent);
	              $timeout(function () {
	                // execute in a timeout to give any complex editor templates a cycle to completely render
	                $scope.grid.api.edit.raise.beginCellEdit($scope.row.entity, $scope.col.colDef, triggerEvent);
	              });
	            }
	
	            function endEdit() {
	              $scope.grid.disableScrolling = false;
	              if (!inEdit) {
	                return;
	              }
	
	              //sometimes the events can't keep up with the keyboard and grid focus is lost, so always focus
	              //back to grid here. The focus call needs to be before the $destroy and removal of the control,
	              //otherwise ng-model-options of UpdateOn: 'blur' will not work.
	              if (uiGridCtrl && uiGridCtrl.grid.api.cellNav) {
	                uiGridCtrl.focus();
	              }
	
	              var gridCellContentsEl = angular.element($elm.children()[0]);
	              //remove edit element
	              editCellScope.$destroy();
	              var children = $elm.children();
	              for (var i = 1; i < children.length; i++) {
	                angular.element(children[i]).remove();
	              }
	              gridCellContentsEl.removeClass('ui-grid-cell-contents-hidden');
	              inEdit = false;
	              registerBeginEditEvents();
	              $scope.grid.api.core.notifyDataChange( uiGridConstants.dataChange.EDIT );
	            }
	
	            function cancelEdit() {
	              $scope.grid.disableScrolling = false;
	              if (!inEdit) {
	                return;
	              }
	              cellModel.assign($scope, origCellValue);
	              $scope.$apply();
	
	              $scope.grid.api.edit.raise.cancelCellEdit($scope.row.entity, $scope.col.colDef);
	              endEdit();
	            }
	
	            // resolves a string path against the given object
	            // shamelessly borrowed from
	            // http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key
	            function resolveObjectFromPath(object, path) {
	              path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
	              path = path.replace(/^\./, '');           // strip a leading dot
	              var a = path.split('.');
	              while (a.length) {
	                  var n = a.shift();
	                  if (n in object) {
	                      object = object[n];
	                  } else {
	                      return;
	                  }
	              }
	              return object;
	            }
	          }
	        };
	      }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.edit.directive:uiGridEditor
	   *  @element div
	   *  @restrict A
	   *
	   *  @description input editor directive for editable fields.
	   *  Provides EndEdit and CancelEdit events
	   *
	   *  Events that end editing:
	   *     blur and enter keydown
	   *
	   *  Events that cancel editing:
	   *    - Esc keydown
	   *
	   */
	  module.directive('uiGridEditor',
	    ['gridUtil', 'uiGridConstants', 'uiGridEditConstants','$timeout', 'uiGridEditService',
	      function (gridUtil, uiGridConstants, uiGridEditConstants, $timeout, uiGridEditService) {
	        return {
	          scope: true,
	          require: ['?^uiGrid', '?^uiGridRenderContainer', 'ngModel'],
	          compile: function () {
	            return {
	              pre: function ($scope, $elm, $attrs) {
	
	              },
	              post: function ($scope, $elm, $attrs, controllers) {
	                var uiGridCtrl, renderContainerCtrl, ngModel;
	                if (controllers[0]) { uiGridCtrl = controllers[0]; }
	                if (controllers[1]) { renderContainerCtrl = controllers[1]; }
	                if (controllers[2]) { ngModel = controllers[2]; }
	
	                //set focus at start of edit
	                $scope.$on(uiGridEditConstants.events.BEGIN_CELL_EDIT, function (evt,triggerEvent) {
	                  // must be in a timeout since it requires a new digest cycle
	                  $timeout(function () {
	                    $elm[0].focus();
	                    //only select text if it is not being replaced below in the cellNav viewPortKeyPress
	                    if ($elm[0].select && ($scope.col.colDef.enableCellEditOnFocus || !(uiGridCtrl && uiGridCtrl.grid.api.cellNav))) {
	                      $elm[0].select();
	                    }
	                    else {
	                      //some browsers (Chrome) stupidly, imo, support the w3 standard that number, email, ...
	                      //fields should not allow setSelectionRange.  We ignore the error for those browsers
	                      //https://www.w3.org/Bugs/Public/show_bug.cgi?id=24796
	                      try {
	                        $elm[0].setSelectionRange($elm[0].value.length, $elm[0].value.length);
	                      }
	                      catch (ex) {
	                        //ignore
	                      }
	                    }
	                  });
	
	                  //set the keystroke that started the edit event
	                  //we must do this because the BeginEdit is done in a different event loop than the intitial
	                  //keydown event
	                  //fire this event for the keypress that is received
	                  if (uiGridCtrl && uiGridCtrl.grid.api.cellNav) {
	                    var viewPortKeyDownUnregister = uiGridCtrl.grid.api.cellNav.on.viewPortKeyPress($scope, function (evt, rowCol) {
	                      if (uiGridEditService.isStartEditKey(evt)) {
	                        var code = typeof evt.which === 'number' ? evt.which : evt.keyCode;
	                        if (code > 0) {
	                          ngModel.$setViewValue(String.fromCharCode(code), evt);
	                          ngModel.$render();
	                        }
	                      }
	                      viewPortKeyDownUnregister();
	                    });
	                  }
	
	                  // macOS will blur the checkbox when clicked in Safari and Firefox,
	                  // to get around this, we disable the blur handler on mousedown,
	                  // and then focus the checkbox and re-enable the blur handler after $timeout
	                  $elm.on('mousedown', function(evt) {
	                    if ($elm[0].type === 'checkbox') {
	                      $elm.off('blur', $scope.stopEdit);
	                      $timeout(function() {
	                        $elm[0].focus();
	                        $elm.on('blur', $scope.stopEdit);
	                      });
	                    }
	                  });
	
	                  $elm.on('blur', $scope.stopEdit);
	                });
	
	
	                $scope.deepEdit = false;
	
	                $scope.stopEdit = function (evt) {
	                  if ($scope.inputForm && !$scope.inputForm.$valid) {
	                    evt.stopPropagation();
	                    $scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
	                  }
	                  else {
	                    $scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
	                  }
	                  $scope.deepEdit = false;
	                };
	
	
	                $elm.on('click', function (evt) {
	                  if ($elm[0].type !== 'checkbox') {
	                    $scope.deepEdit = true;
	                    $scope.$applyAsync(function () {
	                      $scope.grid.disableScrolling = true;
	                    });
	                  }
	                });
	
	                $elm.on('keydown', function (evt) {
	                  switch (evt.keyCode) {
	                    case uiGridConstants.keymap.ESC:
	                      evt.stopPropagation();
	                      $scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
	                      break;
	                  }
	
	                  if ($scope.deepEdit &&
	                    (evt.keyCode === uiGridConstants.keymap.LEFT ||
	                     evt.keyCode === uiGridConstants.keymap.RIGHT ||
	                     evt.keyCode === uiGridConstants.keymap.UP ||
	                     evt.keyCode === uiGridConstants.keymap.DOWN)) {
	                    evt.stopPropagation();
	                  }
	                  // Pass the keydown event off to the cellNav service, if it exists
	                  else if (uiGridCtrl && uiGridCtrl.grid.api.cellNav) {
	                    evt.uiGridTargetRenderContainerId = renderContainerCtrl.containerId;
	                    if (uiGridCtrl.cellNav.handleKeyDown(evt) !== null) {
	                      $scope.stopEdit(evt);
	                    }
	                  }
	                  else {
	                    //handle enter and tab for editing not using cellNav
	                    switch (evt.keyCode) {
	                      case uiGridConstants.keymap.ENTER: // Enter (Leave Field)
	                      case uiGridConstants.keymap.TAB:
	                        evt.stopPropagation();
	                        evt.preventDefault();
	                        $scope.stopEdit(evt);
	                        break;
	                    }
	                  }
	
	                  return true;
	                });
	
	                $scope.$on('$destroy', function unbindEvents() {
	                  // unbind all jquery events in order to avoid memory leaks
	                  $elm.off();
	                });
	              }
	            };
	          }
	        };
	      }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.edit.directive:input
	   *  @element input
	   *  @restrict E
	   *
	   *  @description directive to provide binding between input[date] value and ng-model for angular 1.2
	   *  It is similar to input[date] directive of angular 1.3
	   *
	   *  Supported date format for input is 'yyyy-MM-dd'
	   *  The directive will set the $valid property of input element and the enclosing form to false if
	   *  model is invalid date or value of input is entered wrong.
	   *
	   */
	    module.directive('uiGridEditor', ['$filter', function ($filter) {
	      function parseDateString(dateString) {
	        if (typeof(dateString) === 'undefined' || dateString === '') {
	          return null;
	        }
	        var parts = dateString.split('-');
	        if (parts.length !== 3) {
	          return null;
	        }
	        var year = parseInt(parts[0], 10);
	        var month = parseInt(parts[1], 10);
	        var day = parseInt(parts[2], 10);
	
	        if (month < 1 || year < 1 || day < 1) {
	          return null;
	        }
	        return new Date(year, (month - 1), day);
	      }
	      return {
	        priority: -100, // run after default uiGridEditor directive
	        require: '?ngModel',
	        link: function (scope, element, attrs, ngModel) {
	
	          if (angular.version.minor === 2 && attrs.type && attrs.type === 'date' && ngModel) {
	
	            ngModel.$formatters.push(function (modelValue) {
	              ngModel.$setValidity(null,(!modelValue || !isNaN(modelValue.getTime())));
	              return $filter('date')(modelValue, 'yyyy-MM-dd');
	            });
	
	            ngModel.$parsers.push(function (viewValue) {
	              if (viewValue && viewValue.length > 0) {
	                var dateValue = parseDateString(viewValue);
	                ngModel.$setValidity(null, (dateValue && !isNaN(dateValue.getTime())));
	                return dateValue;
	              }
	              else {
	                ngModel.$setValidity(null, true);
	                return null;
	              }
	            });
	          }
	        }
	      };
	    }]);
	
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.edit.directive:uiGridEditDropdown
	   *  @element div
	   *  @restrict A
	   *
	   *  @description dropdown editor for editable fields.
	   *  Provides EndEdit and CancelEdit events
	   *
	   *  Events that end editing:
	   *     blur and enter keydown, and any left/right nav
	   *
	   *  Events that cancel editing:
	   *    - Esc keydown
	   *
	   */
	  module.directive('uiGridEditDropdown',
	    ['uiGridConstants', 'uiGridEditConstants', '$timeout',
	      function (uiGridConstants, uiGridEditConstants, $timeout) {
	        return {
	          require: ['?^uiGrid', '?^uiGridRenderContainer'],
	          scope: true,
	          compile: function () {
	            return {
	              pre: function ($scope, $elm, $attrs) {
	
	              },
	              post: function ($scope, $elm, $attrs, controllers) {
	                var uiGridCtrl = controllers[0];
	                var renderContainerCtrl = controllers[1];
	
	                //set focus at start of edit
	                $scope.$on(uiGridEditConstants.events.BEGIN_CELL_EDIT, function () {
	                  $timeout(function(){
	                    $elm[0].focus();
	                  });
	
	                  $elm[0].style.width = ($elm[0].parentElement.offsetWidth - 1) + 'px';
	                  $elm.on('blur', function (evt) {
	                    $scope.stopEdit(evt);
	                  });
	                });
	
	
	                $scope.stopEdit = function (evt) {
	                  // no need to validate a dropdown - invalid values shouldn't be
	                  // available in the list
	                  $scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
	                };
	
	                $elm.on('keydown', function (evt) {
	                  switch (evt.keyCode) {
	                    case uiGridConstants.keymap.ESC:
	                      evt.stopPropagation();
	                      $scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
	                      break;
	                  }
	                  if (uiGridCtrl && uiGridCtrl.grid.api.cellNav) {
	                    evt.uiGridTargetRenderContainerId = renderContainerCtrl.containerId;
	                    if (uiGridCtrl.cellNav.handleKeyDown(evt) !== null) {
	                      $scope.stopEdit(evt);
	                    }
	                  }
	                  else {
	                    //handle enter and tab for editing not using cellNav
	                    switch (evt.keyCode) {
	                      case uiGridConstants.keymap.ENTER: // Enter (Leave Field)
	                      case uiGridConstants.keymap.TAB:
	                        evt.stopPropagation();
	                        evt.preventDefault();
	                        $scope.stopEdit(evt);
	                        break;
	                    }
	                  }
	                  return true;
	                });
	
	                $scope.$on('$destroy', function unbindEvents() {
	                  // unbind jquery events to prevent memory leaks
	                  $elm.off();
	                });
	              }
	            };
	          }
	        };
	      }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.edit.directive:uiGridEditFileChooser
	   *  @element div
	   *  @restrict A
	   *
	   *  @description input editor directive for editable fields.
	   *  Provides EndEdit and CancelEdit events
	   *
	   *  Events that end editing:
	   *     blur and enter keydown
	   *
	   *  Events that cancel editing:
	   *    - Esc keydown
	   *
	   */
	  module.directive('uiGridEditFileChooser',
	    ['gridUtil', 'uiGridConstants', 'uiGridEditConstants',
	      function (gridUtil, uiGridConstants, uiGridEditConstants) {
	        return {
	          scope: true,
	          require: ['?^uiGrid', '?^uiGridRenderContainer'],
	          compile: function () {
	            return {
	              pre: function ($scope, $elm, $attrs) {
	
	              },
	              post: function ($scope, $elm) {
	                function handleFileSelect(event) {
	                  var target = event.srcElement || event.target;
	
	                  if (target && target.files && target.files.length > 0) {
	                    /**
	                     *  @ngdoc property
	                     *  @name editFileChooserCallback
	                     *  @propertyOf  ui.grid.edit.api:ColumnDef
	                     *  @description A function that should be called when any files have been chosen
	                     *  by the user.  You should use this to process the files appropriately for your
	                     *  application.
	                     *
	                     *  It passes the gridCol, the gridRow (from which you can get gridRow.entity),
	                     *  and the files.  The files are in the format as returned from the file chooser,
	                     *  an array of files, with each having useful information such as:
	                     *  - `files[0].lastModifiedDate`
	                     *  - `files[0].name`
	                     *  - `files[0].size`  (appears to be in bytes)
	                     *  - `files[0].type`  (MIME type by the looks)
	                     *
	                     *  Typically you would do something with these files - most commonly you would
	                     *  use the filename or read the file itself in.  The example function does both.
	                     *
	                     *  @example
	                     *  <pre>
	                     *  editFileChooserCallBack: function(gridRow, gridCol, files ){
	                     *    // ignore all but the first file, it can only choose one anyway
	                     *    // set the filename into this column
	                     *    gridRow.entity.filename = file[0].name;
	                     *
	                     *    // read the file and set it into a hidden column, which we may do stuff with later
	                     *    var setFile = function(fileContent){
	                     *      gridRow.entity.file = fileContent.currentTarget.result;
	                     *    };
	                     *    var reader = new FileReader();
	                     *    reader.onload = setFile;
	                     *    reader.readAsText( files[0] );
	                     *  }
	                     *  </pre>
	                     */
	                    if ( typeof($scope.col.colDef.editFileChooserCallback) === 'function' ) {
	                      $scope.col.colDef.editFileChooserCallback($scope.row, $scope.col, target.files);
	                    } else {
	                      gridUtil.logError('You need to set colDef.editFileChooserCallback to use the file chooser');
	                    }
	
	                    target.form.reset();
	                    $scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
	                  } else {
	                    $scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
	                  }
	                  $elm[0].removeEventListener('change', handleFileSelect, false);
	                }
	
	                $elm[0].addEventListener('change', handleFileSelect, false);
	
	                $scope.$on(uiGridEditConstants.events.BEGIN_CELL_EDIT, function () {
	                  $elm[0].focus();
	                  $elm[0].select();
	
	                  $elm.on('blur', function () {
	                    $scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
	                    $elm.off();
	                  });
	                });
	              }
	            };
	          }
	        };
	      }]);
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.emptyBaseLayer
	   * @description
	   *
	   * # ui.grid.emptyBaseLayer
	   *
	   * <div class="alert alert-warning" role="alert"><strong>Alpha</strong> This feature is in development. There will almost certainly be breaking api changes, or there are major outstanding bugs.</div>
	   *
	   * This module provides the ability to have the background of the ui-grid be empty rows, this would be displayed in the case were
	   * the grid height is greater then the amount of rows displayed.
	   *
	   * <div doc-module-components="ui.grid.emptyBaseLayer"></div>
	   */
	  var module = angular.module('ui.grid.emptyBaseLayer', ['ui.grid']);
	
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.emptyBaseLayer.service:uiGridBaseLayerService
	   *
	   *  @description Services for the empty base layer grid
	   */
	  module.service('uiGridBaseLayerService', ['gridUtil', '$compile', function (gridUtil, $compile) {
	    var service = {
	      initializeGrid: function (grid, disableEmptyBaseLayer) {
	
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.emptyBaseLayer.api:GridOptions
	         *
	         *  @description GridOptions for emptyBaseLayer feature, these are available to be
	         *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	         */
	        grid.baseLayer = {
	          emptyRows: []
	        };
	
	        /**
	         *  @ngdoc object
	         *  @name enableEmptyGridBaseLayer
	         *  @propertyOf  ui.grid.emptyBaseLayer.api:GridOptions
	         *  @description Enable empty base layer, which shows empty rows as background on the entire grid
	         *  <br/>Defaults to true, if the directive is used.
	         *  <br/>Set to false either by setting this attribute or passing false to the directive.
	         */
	        //default option to true unless it was explicitly set to false
	        if (grid.options.enableEmptyGridBaseLayer !== false) {
	          grid.options.enableEmptyGridBaseLayer = !disableEmptyBaseLayer;
	        }
	      },
	
	      setNumberOfEmptyRows: function(viewportHeight, grid) {
	        var rowHeight = grid.options.rowHeight,
	          rows = Math.ceil(viewportHeight / rowHeight);
	        if (rows > 0) {
	          grid.baseLayer.emptyRows = [];
	          for (var i = 0; i < rows; i++) {
	            grid.baseLayer.emptyRows.push({});
	          }
	        }
	      }
	    };
	    return service;
	  }]);
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.emptyBaseLayer.directive:uiGridEmptyBaseLayer
	   *  @description Shows empty rows in the background of the ui-grid, these span
	   *  the full height of the ui-grid, so that there won't be blank space below the shown rows.
	   *  @example
	   *  <pre>
	   *  <div ui-grid="gridOptions" class="grid" ui-grid-empty-base-layer></div>
	   *  </pre>
	   *  Or you can enable/disable it dynamically by passing in true or false. It doesn't
	   *  the value, so it would only be set on initial render.
	   *  <pre>
	   *  <div ui-grid="gridOptions" class="grid" ui-grid-empty-base-layer="false"></div>
	   *  </pre>
	   */
	  module.directive('uiGridEmptyBaseLayer', ['gridUtil', 'uiGridBaseLayerService',
	      '$parse',
	    function (gridUtil, uiGridBaseLayerService, $parse) {
	      return {
	        require: '^uiGrid',
	        scope: false,
	        compile: function ($elm, $attrs) {
	          return {
	            pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	              var disableEmptyBaseLayer = $parse($attrs.uiGridEmptyBaseLayer)($scope) === false;
	              uiGridBaseLayerService.initializeGrid(uiGridCtrl.grid, disableEmptyBaseLayer);
	            },
	            post: function ($scope, $elm, $attrs, uiGridCtrl) {
	              if (!uiGridCtrl.grid.options.enableEmptyGridBaseLayer) {
	                return;
	              }
	
	              var renderBodyContainer = uiGridCtrl.grid.renderContainers.body,
	                viewportHeight = renderBodyContainer.getViewportHeight();
	
	              function heightHasChanged() {
	                var newViewPortHeight = renderBodyContainer.getViewportHeight();
	
	                if (newViewPortHeight !== viewportHeight) {
	                  viewportHeight = newViewPortHeight;
	                  return true;
	                }
	                return false;
	              }
	
	              function getEmptyBaseLayerCss(viewportHeight) {
	                // Set ui-grid-empty-base-layer height
	                return '.grid' + uiGridCtrl.grid.id +
	                  ' .ui-grid-render-container ' +
	                  '.ui-grid-empty-base-layer-container.ui-grid-canvas ' +
	                  '{ height: ' + viewportHeight + 'px; }';
	              }
	
	              uiGridCtrl.grid.registerStyleComputation({
	                func: function() {
	                  if (heightHasChanged()) {
	                    uiGridBaseLayerService.setNumberOfEmptyRows(viewportHeight, uiGridCtrl.grid);
	                  }
	                  return getEmptyBaseLayerCss(viewportHeight);
	                }
	              });
	            }
	          };
	        }
	      };
	    }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.emptyBaseLayer.directive:uiGridViewport
	   *  @description stacks on the uiGridViewport directive to append the empty grid base layer html elements to the
	   *  default gridRow template
	   */
	  module.directive('uiGridViewport',
	    ['$compile', 'gridUtil', '$templateCache',
	      function ($compile, gridUtil, $templateCache) {
	        return {
	          priority: -200,
	          scope: false,
	          compile: function ($elm, $attrs) {
	            var emptyBaseLayerContainer = $templateCache.get('ui-grid/emptyBaseLayerContainer');
	            $elm.prepend(emptyBaseLayerContainer);
	            return {
	              pre: function ($scope, $elm, $attrs, controllers) {
	              },
	              post: function ($scope, $elm, $attrs, controllers) {
	              }
	            };
	          }
	        };
	      }]);
	
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.expandable
	   * @description
	   *
	   * # ui.grid.expandable
	   *
	   * <div class="alert alert-warning" role="alert"><strong>Alpha</strong> This feature is in development. There will almost certainly be breaking api changes, or there are major outstanding bugs.</div>
	   *
	   * This module provides the ability to create subgrids with the ability to expand a row
	   * to show the subgrid.
	   *
	   * <div doc-module-components="ui.grid.expandable"></div>
	   */
	  var module = angular.module('ui.grid.expandable', ['ui.grid']);
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.expandable.service:uiGridExpandableService
	   *
	   *  @description Services for the expandable grid
	   */
	  module.service('uiGridExpandableService', ['gridUtil', '$compile', function (gridUtil, $compile) {
	    var service = {
	      initializeGrid: function (grid) {
	
	        grid.expandable = {};
	        grid.expandable.expandedAll = false;
	
	        /**
	         *  @ngdoc object
	         *  @name enableExpandable
	         *  @propertyOf  ui.grid.expandable.api:GridOptions
	         *  @description Whether or not to use expandable feature, allows you to turn off expandable on specific grids
	         *  within your application, or in specific modes on _this_ grid. Defaults to true.
	         *  @example
	         *  <pre>
	         *    $scope.gridOptions = {
	         *      enableExpandable: false
	         *    }
	         *  </pre>
	         */
	        grid.options.enableExpandable = grid.options.enableExpandable !== false;
	
	        /**
	         *  @ngdoc object
	         *  @name showExpandAllButton
	         *  @propertyOf  ui.grid.expandable.api:GridOptions
	         *  @description Whether or not to display the expand all button, allows you to hide expand all button on specific grids
	         *  within your application, or in specific modes on _this_ grid. Defaults to true.
	         *  @example
	         *  <pre>
	         *    $scope.gridOptions = {
	         *      showExpandAllButton: false
	         *    }
	         *  </pre>
	         */
	        grid.options.showExpandAllButton = grid.options.showExpandAllButton !== false;
	
	        /**
	         *  @ngdoc object
	         *  @name expandableRowHeight
	         *  @propertyOf  ui.grid.expandable.api:GridOptions
	         *  @description Height in pixels of the expanded subgrid.  Defaults to
	         *  150
	         *  @example
	         *  <pre>
	         *    $scope.gridOptions = {
	         *      expandableRowHeight: 150
	         *    }
	         *  </pre>
	         */
	        grid.options.expandableRowHeight = grid.options.expandableRowHeight || 150;
	
	        /**
	         *  @ngdoc object
	         *  @name expandableRowHeaderWidth
	         *  @propertyOf  ui.grid.expandable.api:GridOptions
	         *  @description Width in pixels of the expandable column. Defaults to 40
	         *  @example
	         *  <pre>
	         *    $scope.gridOptions = {
	         *      expandableRowHeaderWidth: 40
	         *    }
	         *  </pre>
	         */
	        grid.options.expandableRowHeaderWidth = grid.options.expandableRowHeaderWidth || 40;
	
	        /**
	         *  @ngdoc object
	         *  @name expandableRowTemplate
	         *  @propertyOf  ui.grid.expandable.api:GridOptions
	         *  @description Mandatory. The template for your expanded row
	         *  @example
	         *  <pre>
	         *    $scope.gridOptions = {
	         *      expandableRowTemplate: 'expandableRowTemplate.html'
	         *    }
	         *  </pre>
	         */
	        if ( grid.options.enableExpandable && !grid.options.expandableRowTemplate ){
	          gridUtil.logError( 'You have not set the expandableRowTemplate, disabling expandable module' );
	          grid.options.enableExpandable = false;
	        }
	
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.expandable.api:PublicApi
	         *
	         *  @description Public Api for expandable feature
	         */
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.expandable.api:GridRow
	         *
	         *  @description Additional properties added to GridRow when using the expandable module
	         */
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.expandable.api:GridOptions
	         *
	         *  @description Options for configuring the expandable feature, these are available to be
	         *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	         */
	        var publicApi = {
	          events: {
	            expandable: {
	              /**
	               * @ngdoc event
	               * @name rowExpandedBeforeStateChanged
	               * @eventOf  ui.grid.expandable.api:PublicApi
	               * @description raised when row is expanding or collapsing
	               * <pre>
	               *      gridApi.expandable.on.rowExpandedBeforeStateChanged(scope,function(row){})
	               * </pre>
	               * @param {scope} scope the application scope
	               * @param {GridRow} row the row that was expanded
	               */
	              rowExpandedBeforeStateChanged: function(scope, row){
	              },
	              /**
	               * @ngdoc event
	               * @name rowExpandedStateChanged
	               * @eventOf  ui.grid.expandable.api:PublicApi
	               * @description raised when row expanded or collapsed
	               * <pre>
	               *      gridApi.expandable.on.rowExpandedStateChanged(scope,function(row){})
	               * </pre>
	               * @param {scope} scope the application scope
	               * @param {GridRow} row the row that was expanded
	               */
	              rowExpandedStateChanged: function (scope, row) {
	              }
	            }
	          },
	
	          methods: {
	            expandable: {
	              /**
	               * @ngdoc method
	               * @name toggleRowExpansion
	               * @methodOf  ui.grid.expandable.api:PublicApi
	               * @description Toggle a specific row
	               * <pre>
	               *      gridApi.expandable.toggleRowExpansion(rowEntity);
	               * </pre>
	               * @param {object} rowEntity the data entity for the row you want to expand
	               */
	              toggleRowExpansion: function (rowEntity) {
	                var row = grid.getRow(rowEntity);
	                if (row !== null) {
	                  service.toggleRowExpansion(grid, row);
	                }
	              },
	
	              /**
	               * @ngdoc method
	               * @name expandAllRows
	               * @methodOf  ui.grid.expandable.api:PublicApi
	               * @description Expand all subgrids.
	               * <pre>
	               *      gridApi.expandable.expandAllRows();
	               * </pre>
	               */
	              expandAllRows: function() {
	                service.expandAllRows(grid);
	              },
	
	              /**
	               * @ngdoc method
	               * @name collapseAllRows
	               * @methodOf  ui.grid.expandable.api:PublicApi
	               * @description Collapse all subgrids.
	               * <pre>
	               *      gridApi.expandable.collapseAllRows();
	               * </pre>
	               */
	              collapseAllRows: function() {
	                service.collapseAllRows(grid);
	              },
	
	              /**
	               * @ngdoc method
	               * @name toggleAllRows
	               * @methodOf  ui.grid.expandable.api:PublicApi
	               * @description Toggle all subgrids.
	               * <pre>
	               *      gridApi.expandable.toggleAllRows();
	               * </pre>
	               */
	              toggleAllRows: function() {
	                service.toggleAllRows(grid);
	              },
	              /**
	               * @ngdoc function
	               * @name expandRow
	               * @methodOf  ui.grid.expandable.api:PublicApi
	               * @description Expand the data row
	               * @param {object} rowEntity gridOptions.data[] array instance
	               */
	              expandRow: function (rowEntity) {
	                var row = grid.getRow(rowEntity);
	                if (row !== null && !row.isExpanded) {
	                  service.toggleRowExpansion(grid, row);
	                }
	              },
	              /**
	               * @ngdoc function
	               * @name collapseRow
	               * @methodOf  ui.grid.expandable.api:PublicApi
	               * @description Collapse the data row
	               * @param {object} rowEntity gridOptions.data[] array instance
	               */
	              collapseRow: function (rowEntity) {
	                var row = grid.getRow(rowEntity);
	                if (row !== null && row.isExpanded) {
	                  service.toggleRowExpansion(grid, row);
	                }
	              },
	              /**
	               * @ngdoc function
	               * @name getExpandedRows
	               * @methodOf  ui.grid.expandable.api:PublicApi
	               * @description returns all expandedRow's entity references
	               */
	              getExpandedRows: function () {
	                return service.getExpandedRows(grid).map(function (gridRow) {
	                  return gridRow.entity;
	                });
	              }
	            }
	          }
	        };
	        grid.api.registerEventsFromObject(publicApi.events);
	        grid.api.registerMethodsFromObject(publicApi.methods);
	      },
	
	      toggleRowExpansion: function (grid, row) {
	        // trigger the "before change" event. Can change row height dynamically this way.
	        grid.api.expandable.raise.rowExpandedBeforeStateChanged(row);
	        /**
	         *  @ngdoc object
	         *  @name isExpanded
	         *  @propertyOf  ui.grid.expandable.api:GridRow
	         *  @description Whether or not the row is currently expanded.
	         *  @example
	         *  <pre>
	         *    $scope.api.expandable.on.rowExpandedStateChanged($scope, function (row) {
	         *      if (row.isExpanded) {
	         *        //...
	         *      }
	         *    });
	         *  </pre>
	         */
	        row.isExpanded = !row.isExpanded;
	        if (angular.isUndefined(row.expandedRowHeight)){
	          row.expandedRowHeight = grid.options.expandableRowHeight;
	        }
	
	        if (row.isExpanded) {
	          row.height = row.grid.options.rowHeight + row.expandedRowHeight;
	          grid.expandable.expandedAll = service.getExpandedRows(grid).length === grid.rows.length;
	        } else {
	          row.height = row.grid.options.rowHeight;
	          grid.expandable.expandedAll = false;
	        }
	        grid.api.expandable.raise.rowExpandedStateChanged(row);
	      },
	
	      expandAllRows: function(grid) {
	        grid.renderContainers.body.visibleRowCache.forEach( function(row) {
	          if (!row.isExpanded && !(row.entity.subGridOptions && row.entity.subGridOptions.disableRowExpandable)) {
	            service.toggleRowExpansion(grid, row);
	          }
	        });
	        grid.expandable.expandedAll = true;
	        grid.queueGridRefresh();
	      },
	
	      collapseAllRows: function(grid) {
	        grid.renderContainers.body.visibleRowCache.forEach( function(row) {
	          if (row.isExpanded) {
	            service.toggleRowExpansion(grid, row);
	          }
	        });
	        grid.expandable.expandedAll = false;
	        grid.queueGridRefresh();
	      },
	
	      toggleAllRows: function(grid) {
	        if (grid.expandable.expandedAll) {
	          service.collapseAllRows(grid);
	        }
	        else {
	          service.expandAllRows(grid);
	        }
	      },
	
	      getExpandedRows: function (grid) {
	        return grid.rows.filter(function (row) {
	          return row.isExpanded;
	        });
	      }
	    };
	    return service;
	  }]);
	
	  /**
	   *  @ngdoc object
	   *  @name enableExpandableRowHeader
	   *  @propertyOf  ui.grid.expandable.api:GridOptions
	   *  @description Show a rowHeader to provide the expandable buttons.  If set to false then implies
	   *  you're going to use a custom method for expanding and collapsing the subgrids. Defaults to true.
	   *  @example
	   *  <pre>
	   *    $scope.gridOptions = {
	   *      enableExpandableRowHeader: false
	   *    }
	   *  </pre>
	   */
	  module.directive('uiGridExpandable', ['uiGridExpandableService', '$templateCache',
	    function (uiGridExpandableService, $templateCache) {
	      return {
	        replace: true,
	        priority: 0,
	        require: '^uiGrid',
	        scope: false,
	        compile: function () {
	          return {
	            pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	              uiGridExpandableService.initializeGrid(uiGridCtrl.grid);
	
	              if (!uiGridCtrl.grid.options.enableExpandable) {
	                return;
	              }
	
	              if (uiGridCtrl.grid.options.enableExpandableRowHeader !== false ) {
	                var expandableRowHeaderColDef = {
	                  name: 'expandableButtons',
	                  displayName: '',
	                  exporterSuppressExport: true,
	                  enableColumnResizing: false,
	                  enableColumnMenu: false,
	                  width: uiGridCtrl.grid.options.expandableRowHeaderWidth || 40
	                };
	                expandableRowHeaderColDef.cellTemplate = $templateCache.get('ui-grid/expandableRowHeader');
	                expandableRowHeaderColDef.headerCellTemplate = $templateCache.get('ui-grid/expandableTopRowHeader');
	                uiGridCtrl.grid.addRowHeaderColumn(expandableRowHeaderColDef, -90);
	              }
	
	            },
	            post: function ($scope, $elm, $attrs, uiGridCtrl) {
	            }
	          };
	        }
	      };
	    }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.expandable.directive:uiGrid
	   *  @description stacks on the uiGrid directive to register child grid with parent row when child is created
	   */
	  module.directive('uiGrid', ['uiGridExpandableService', '$templateCache',
	    function (uiGridExpandableService, $templateCache) {
	      return {
	        replace: true,
	        priority: 599,
	        require: '^uiGrid',
	        scope: false,
	        compile: function () {
	          return {
	            pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	
	              uiGridCtrl.grid.api.core.on.renderingComplete($scope, function() {
	                //if a parent grid row is on the scope, then add the parentRow property to this childGrid
	                if ($scope.row && $scope.row.grid && $scope.row.grid.options && $scope.row.grid.options.enableExpandable) {
	
	                  /**
	                   *  @ngdoc directive
	                   *  @name ui.grid.expandable.class:Grid
	                   *  @description Additional Grid properties added by expandable module
	                   */
	
	                  /**
	                   *  @ngdoc object
	                   *  @name parentRow
	                   *  @propertyOf ui.grid.expandable.class:Grid
	                   *  @description reference to the expanded parent row that owns this grid
	                   */
	                  uiGridCtrl.grid.parentRow = $scope.row;
	
	                  //todo: adjust height on parent row when child grid height changes. we need some sort of gridHeightChanged event
	                 // uiGridCtrl.grid.core.on.canvasHeightChanged($scope, function(oldHeight, newHeight) {
	                 //   uiGridCtrl.grid.parentRow = newHeight;
	                 // });
	                }
	
	              });
	            },
	            post: function ($scope, $elm, $attrs, uiGridCtrl) {
	
	            }
	          };
	        }
	      };
	    }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.expandable.directive:uiGridExpandableRow
	   *  @description directive to render the expandable row template
	   */
	  module.directive('uiGridExpandableRow',
	  ['uiGridExpandableService', '$timeout', '$compile', 'uiGridConstants','gridUtil','$interval', '$log',
	    function (uiGridExpandableService, $timeout, $compile, uiGridConstants, gridUtil, $interval, $log) {
	
	      return {
	        replace: false,
	        priority: 0,
	        scope: false,
	
	        compile: function () {
	          return {
	            pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	              gridUtil.getTemplate($scope.grid.options.expandableRowTemplate).then(
	                function (template) {
	                  if ($scope.grid.options.expandableRowScope) {
	                    /**
	                     *  @ngdoc object
	                     *  @name expandableRowScope
	                     *  @propertyOf  ui.grid.expandable.api:GridOptions
	                     *  @description  Variables of object expandableScope will be available in the scope of the expanded subgrid
	                     *  @example
	                     *  <pre>
	                     *    $scope.gridOptions = {
	                     *      expandableRowScope: expandableScope
	                     *    }
	                     *  </pre>
	                     */
	                    var expandableRowScope = $scope.grid.options.expandableRowScope;
	                    for (var property in expandableRowScope) {
	                      if (expandableRowScope.hasOwnProperty(property)) {
	                        $scope[property] = expandableRowScope[property];
	                      }
	                    }
	                  }
	                  var expandedRowElement = angular.element(template);
	                  $elm.append(expandedRowElement);
	                  expandedRowElement = $compile(expandedRowElement)($scope);
	                  $scope.row.expandedRendered = true;
	              });
	            },
	
	            post: function ($scope, $elm, $attrs, uiGridCtrl) {
	              $scope.$on('$destroy', function() {
	                $scope.row.expandedRendered = false;
	              });
	            }
	          };
	        }
	      };
	    }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.expandable.directive:uiGridRow
	   *  @description stacks on the uiGridRow directive to add support for expandable rows
	   */
	  module.directive('uiGridRow',
	    ['$compile', 'gridUtil', '$templateCache',
	      function ($compile, gridUtil, $templateCache) {
	        return {
	          priority: -200,
	          scope: false,
	          compile: function ($elm, $attrs) {
	            return {
	              pre: function ($scope, $elm, $attrs, controllers) {
	
	                if (!$scope.grid.options.enableExpandable) {
	                  return;
	                }
	
	                $scope.expandableRow = {};
	
	                $scope.expandableRow.shouldRenderExpand = function () {
	                  var ret = $scope.colContainer.name === 'body' &&  $scope.grid.options.enableExpandable !== false && $scope.row.isExpanded && (!$scope.grid.isScrollingVertically || $scope.row.expandedRendered);
	                  return ret;
	                };
	
	                $scope.expandableRow.shouldRenderFiller = function () {
	                  var ret = $scope.row.isExpanded && ( $scope.colContainer.name !== 'body' || ($scope.grid.isScrollingVertically && !$scope.row.expandedRendered));
	                  return ret;
	                };
	
	 /*
	  * Commented out @PaulL1.  This has no purpose that I can see, and causes #2964.  If this code needs to be reinstated for some
	  * reason it needs to use drawnWidth, not width, and needs to check column visibility.  It should really use render container
	  * visible column cache also instead of checking column.renderContainer.
	                  function updateRowContainerWidth() {
	                      var grid = $scope.grid;
	                      var colWidth = 0;
	                      grid.columns.forEach( function (column) {
	                          if (column.renderContainer === 'left') {
	                            colWidth += column.width;
	                          }
	                      });
	                      colWidth = Math.floor(colWidth);
	                      return '.grid' + grid.id + ' .ui-grid-pinned-container-' + $scope.colContainer.name + ', .grid' + grid.id +
	                          ' .ui-grid-pinned-container-' + $scope.colContainer.name + ' .ui-grid-render-container-' + $scope.colContainer.name +
	                          ' .ui-grid-viewport .ui-grid-canvas .ui-grid-row { width: ' + colWidth + 'px; }';
	                  }
	
	                  if ($scope.colContainer.name === 'left') {
	                      $scope.grid.registerStyleComputation({
	                          priority: 15,
	                          func: updateRowContainerWidth
	                      });
	                  }*/
	
	              },
	              post: function ($scope, $elm, $attrs, controllers) {
	              }
	            };
	          }
	        };
	      }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.expandable.directive:uiGridViewport
	   *  @description stacks on the uiGridViewport directive to append the expandable row html elements to the
	   *  default gridRow template
	   */
	  module.directive('uiGridViewport',
	    ['$compile', 'gridUtil', '$templateCache',
	      function ($compile, gridUtil, $templateCache) {
	        return {
	          priority: -200,
	          scope: false,
	          compile: function ($elm, $attrs) {
	
	             //todo: this adds ng-if watchers to each row even if the grid is not using expandable directive
	             //      or options.enableExpandable == false
	             //      The alternative is to compile the template and append to each row in a uiGridRow directive
	
	            var rowRepeatDiv = angular.element($elm.children().children()[0]);
	            var expandedRowFillerElement = $templateCache.get('ui-grid/expandableScrollFiller');
	            var expandedRowElement = $templateCache.get('ui-grid/expandableRow');
	            rowRepeatDiv.append(expandedRowElement);
	            rowRepeatDiv.append(expandedRowFillerElement);
	            return {
	              pre: function ($scope, $elm, $attrs, controllers) {
	              },
	              post: function ($scope, $elm, $attrs, controllers) {
	              }
	            };
	          }
	        };
	      }]);
	
	})();
	
	/* global ExcelBuilder */
	/* global console */
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.exporter
	   * @description
	   *
	   * # ui.grid.exporter
	   *
	   * <div class="alert alert-success" role="alert"><strong>Stable</strong> This feature is stable. There should no longer be breaking api changes without a deprecation warning.</div>
	   *
	   * This module provides the ability to export data from the grid.
	   *
	   * Data can be exported in a range of formats, and all data, visible
	   * data, or selected rows can be exported, with all columns or visible
	   * columns.
	   *
	   * No UI is provided, the caller should provide their own UI/buttons
	   * as appropriate, or enable the gridMenu
	   *
	   * <br/>
	   * <br/>
	   *
	   * <div doc-module-components="ui.grid.exporter"></div>
	   */
	
	  var module = angular.module('ui.grid.exporter', ['ui.grid']);
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.exporter.constant:uiGridExporterConstants
	   *
	   *  @description constants available in exporter module
	   */
	  /**
	   * @ngdoc property
	   * @propertyOf ui.grid.exporter.constant:uiGridExporterConstants
	   * @name ALL
	   * @description export all data, including data not visible.  Can
	   * be set for either rowTypes or colTypes
	   */
	  /**
	   * @ngdoc property
	   * @propertyOf ui.grid.exporter.constant:uiGridExporterConstants
	   * @name VISIBLE
	   * @description export only visible data, including data not visible.  Can
	   * be set for either rowTypes or colTypes
	   */
	  /**
	   * @ngdoc property
	   * @propertyOf ui.grid.exporter.constant:uiGridExporterConstants
	   * @name SELECTED
	   * @description export all data, including data not visible.  Can
	   * be set only for rowTypes, selection of only some columns is
	   * not supported
	   */
	  module.constant('uiGridExporterConstants', {
	    featureName: 'exporter',
	    ALL: 'all',
	    VISIBLE: 'visible',
	    SELECTED: 'selected',
	    CSV_CONTENT: 'CSV_CONTENT',
	    BUTTON_LABEL: 'BUTTON_LABEL',
	    FILE_NAME: 'FILE_NAME'
	  });
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.exporter.service:uiGridExporterService
	   *
	   *  @description Services for exporter feature
	   */
	  module.service('uiGridExporterService', ['$filter', '$q', 'uiGridExporterConstants', 'gridUtil', '$compile', '$interval', 'i18nService',
	    function ($filter, $q, uiGridExporterConstants, gridUtil, $compile, $interval, i18nService) {
	      var service = {
	
	        delay: 100,
	
	        initializeGrid: function (grid) {
	
	          //add feature namespace and any properties to grid for needed state
	          grid.exporter = {};
	          this.defaultGridOptions(grid.options);
	
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.exporter.api:PublicApi
	           *
	           *  @description Public Api for exporter feature
	           */
	          var publicApi = {
	            events: {
	              exporter: {
	              }
	            },
	            methods: {
	              exporter: {
	                /**
	                 * @ngdoc function
	                 * @name csvExport
	                 * @methodOf  ui.grid.exporter.api:PublicApi
	                 * @description Exports rows from the grid in csv format,
	                 * the data exported is selected based on the provided options
	                 * @param {string} rowTypes which rows to export, valid values are
	                 * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	                 * uiGridExporterConstants.SELECTED
	                 * @param {string} colTypes which columns to export, valid values are
	                 * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE
	                 */
	                csvExport: function (rowTypes, colTypes) {
	                  service.csvExport(grid, rowTypes, colTypes);
	                },
	                /**
	                 * @ngdoc function
	                 * @name pdfExport
	                 * @methodOf  ui.grid.exporter.api:PublicApi
	                 * @description Exports rows from the grid in pdf format,
	                 * the data exported is selected based on the provided options
	                 * Note that this function has a dependency on pdfMake, all
	                 * going well this has been installed for you.
	                 * The resulting pdf opens in a new browser window.
	                 * @param {string} rowTypes which rows to export, valid values are
	                 * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	                 * uiGridExporterConstants.SELECTED
	                 * @param {string} colTypes which columns to export, valid values are
	                 * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE
	                 */
	                pdfExport: function (rowTypes, colTypes) {
	                  service.pdfExport(grid, rowTypes, colTypes);
	                },
	                /**
	                 * @ngdoc function
	                 * @name excelExport
	                 * @methodOf  ui.grid.exporter.api:PublicApi
	                 * @description Exports rows from the grid in excel format,
	                 * the data exported is selected based on the provided options
	                 * @param {string} rowTypes which rows to export, valid values are
	                 * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	                 * uiGridExporterConstants.SELECTED
	                 * @param {string} colTypes which columns to export, valid values are
	                 * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE
	                 */
	                excelExport: function (rowTypes, colTypes) {
	                  service.excelExport(grid, rowTypes, colTypes);
	                }
	              }
	            }
	          };
	
	          grid.api.registerEventsFromObject(publicApi.events);
	
	          grid.api.registerMethodsFromObject(publicApi.methods);
	
	          if (grid.api.core.addToGridMenu){
	            service.addToMenu( grid );
	          } else {
	            // order of registration is not guaranteed, register in a little while
	            $interval( function() {
	              if (grid.api.core.addToGridMenu){
	                service.addToMenu( grid );
	              }
	            }, this.delay, 1);
	          }
	
	        },
	
	        defaultGridOptions: function (gridOptions) {
	          //default option to true unless it was explicitly set to false
	          /**
	           * @ngdoc object
	           * @name ui.grid.exporter.api:GridOptions
	           *
	           * @description GridOptions for exporter feature, these are available to be
	           * set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	           */
	          /**
	           * @ngdoc object
	           * @name ui.grid.exporter.api:ColumnDef
	           * @description ColumnDef settings for exporter
	           */
	          /**
	           * @ngdoc object
	           * @name exporterSuppressMenu
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description Don't show the export menu button, implying the user
	           * will roll their own UI for calling the exporter
	           * <br/>Defaults to false
	           */
	          gridOptions.exporterSuppressMenu = gridOptions.exporterSuppressMenu === true;
	          /**
	           * @ngdoc object
	           * @name exporterMenuLabel
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The text to show on the exporter menu button
	           * link
	           * <br/>Defaults to 'Export'
	           */
	          gridOptions.exporterMenuLabel = gridOptions.exporterMenuLabel ? gridOptions.exporterMenuLabel : 'Export';
	          /**
	           * @ngdoc object
	           * @name exporterSuppressColumns
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description Columns that should not be exported.  The selectionRowHeader is already automatically
	           * suppressed, but if you had a button column or some other "system" column that shouldn't be shown in the
	           * output then add it in this list.  You should provide an array of column names.
	           * <br/>Defaults to: []
	           * <pre>
	           *   gridOptions.exporterSuppressColumns = [ 'buttons' ];
	           * </pre>
	           */
	          gridOptions.exporterSuppressColumns = gridOptions.exporterSuppressColumns ? gridOptions.exporterSuppressColumns : [];
	          /**
	           * @ngdoc object
	           * @name exporterCsvColumnSeparator
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The character to use as column separator
	           * link
	           * <br/>Defaults to ','
	           */
	          gridOptions.exporterCsvColumnSeparator = gridOptions.exporterCsvColumnSeparator ? gridOptions.exporterCsvColumnSeparator : ',';
	          /**
	           * @ngdoc object
	           * @name exporterCsvFilename
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The default filename to use when saving the downloaded csv.
	           * This will only work in some browsers.
	           * <br/>Defaults to 'download.csv'
	           */
	          gridOptions.exporterCsvFilename = gridOptions.exporterCsvFilename ? gridOptions.exporterCsvFilename : 'download.csv';
	          /**
	           * @ngdoc object
	           * @name exporterPdfFilename
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The default filename to use when saving the downloaded pdf, only used in IE (other browsers open pdfs in a new window)
	           * <br/>Defaults to 'download.pdf'
	           */
	          gridOptions.exporterPdfFilename = gridOptions.exporterPdfFilename ? gridOptions.exporterPdfFilename : 'download.pdf';
	          /**
	           * @ngdoc object
	           * @name exporterOlderExcelCompatibility
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description Some versions of excel don't like the utf-16 BOM on the front, and it comes
	           * through as ï»¿ in the first column header.  Setting this option to false will suppress this, at the
	           * expense of proper utf-16 handling in applications that do recognise the BOM
	           * <br/>Defaults to false
	           */
	          gridOptions.exporterOlderExcelCompatibility = gridOptions.exporterOlderExcelCompatibility === true;
	          /**
	           * @ngdoc object
	           * @name exporterIsExcelCompatible
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description Separator header, used to set a custom column separator in a csv file, only works on MS Excel.
	           * Used it on other programs will make csv content display unproperly. Setting this option to false won't add this header.
	           * <br/>Defaults to false
	           */
	          gridOptions.exporterIsExcelCompatible = gridOptions.exporterIsExcelCompatible === true;
	          /**
	           * @ngdoc object
	           * @name exporterMenuItemOrder
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description An option to determine the starting point for the menu items created by the exporter
	           * <br/>Defaults to 200
	           */
	          gridOptions.exporterMenuItemOrder = gridOptions.exporterMenuItemOrder ? gridOptions.exporterMenuItemOrder : 200;
	          /**
	           * @ngdoc object
	           * @name exporterPdfDefaultStyle
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The default style in pdfMake format
	           * <br/>Defaults to:
	           * <pre>
	           *   {
	           *     fontSize: 11
	           *   }
	           * </pre>
	           */
	          gridOptions.exporterPdfDefaultStyle = gridOptions.exporterPdfDefaultStyle ? gridOptions.exporterPdfDefaultStyle : { fontSize: 11 };
	          /**
	           * @ngdoc object
	           * @name exporterPdfTableStyle
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The table style in pdfMake format
	           * <br/>Defaults to:
	           * <pre>
	           *   {
	           *     margin: [0, 5, 0, 15]
	           *   }
	           * </pre>
	           */
	          gridOptions.exporterPdfTableStyle = gridOptions.exporterPdfTableStyle ? gridOptions.exporterPdfTableStyle : { margin: [0, 5, 0, 15] };
	          /**
	           * @ngdoc object
	           * @name exporterPdfTableHeaderStyle
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The tableHeader style in pdfMake format
	           * <br/>Defaults to:
	           * <pre>
	           *   {
	           *     bold: true,
	           *     fontSize: 12,
	           *     color: 'black'
	           *   }
	           * </pre>
	           */
	          gridOptions.exporterPdfTableHeaderStyle = gridOptions.exporterPdfTableHeaderStyle ? gridOptions.exporterPdfTableHeaderStyle : { bold: true, fontSize: 12, color: 'black' };
	          /**
	           * @ngdoc object
	           * @name exporterPdfHeader
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The header section for pdf exports.  Can be
	           * simple text:
	           * <pre>
	           *   gridOptions.exporterPdfHeader = 'My Header';
	           * </pre>
	           * Can be a more complex object in pdfMake format:
	           * <pre>
	           *   gridOptions.exporterPdfHeader = {
	           *     columns: [
	           *       'Left part',
	           *       { text: 'Right part', alignment: 'right' }
	           *     ]
	           *   };
	           * </pre>
	           * Or can be a function, allowing page numbers and the like
	           * <pre>
	           *   gridOptions.exporterPdfHeader: function(currentPage, pageCount) { return currentPage.toString() + ' of ' + pageCount; };
	           * </pre>
	           */
	          gridOptions.exporterPdfHeader = gridOptions.exporterPdfHeader ? gridOptions.exporterPdfHeader : null;
	          /**
	           * @ngdoc object
	           * @name exporterPdfFooter
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The header section for pdf exports.  Can be
	           * simple text:
	           * <pre>
	           *   gridOptions.exporterPdfFooter = 'My Footer';
	           * </pre>
	           * Can be a more complex object in pdfMake format:
	           * <pre>
	           *   gridOptions.exporterPdfFooter = {
	           *     columns: [
	           *       'Left part',
	           *       { text: 'Right part', alignment: 'right' }
	           *     ]
	           *   };
	           * </pre>
	           * Or can be a function, allowing page numbers and the like
	           * <pre>
	           *   gridOptions.exporterPdfFooter: function(currentPage, pageCount) { return currentPage.toString() + ' of ' + pageCount; };
	           * </pre>
	           */
	          gridOptions.exporterPdfFooter = gridOptions.exporterPdfFooter ? gridOptions.exporterPdfFooter : null;
	          /**
	           * @ngdoc object
	           * @name exporterPdfOrientation
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The orientation, should be a valid pdfMake value,
	           * 'landscape' or 'portrait'
	           * <br/>Defaults to landscape
	           */
	          gridOptions.exporterPdfOrientation = gridOptions.exporterPdfOrientation ? gridOptions.exporterPdfOrientation : 'landscape';
	          /**
	           * @ngdoc object
	           * @name exporterPdfPageSize
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The orientation, should be a valid pdfMake
	           * paper size, usually 'A4' or 'LETTER'
	           * {@link https://github.com/bpampuch/pdfmake/blob/master/src/standardPageSizes.js pdfMake page sizes}
	           * <br/>Defaults to A4
	           */
	          gridOptions.exporterPdfPageSize = gridOptions.exporterPdfPageSize ? gridOptions.exporterPdfPageSize : 'A4';
	          /**
	           * @ngdoc object
	           * @name exporterPdfMaxGridWidth
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description The maxium grid width - the current grid width
	           * will be scaled to match this, with any fixed width columns
	           * being adjusted accordingly.
	           * <br/>Defaults to 720 (for A4 landscape), use 670 for LETTER
	           */
	          gridOptions.exporterPdfMaxGridWidth = gridOptions.exporterPdfMaxGridWidth ? gridOptions.exporterPdfMaxGridWidth : 720;
	          /**
	           * @ngdoc object
	           * @name exporterPdfTableLayout
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description A tableLayout in pdfMake format,
	           * controls gridlines and the like.  We use the default
	           * layout usually.
	           * <br/>Defaults to null, which means no layout
	           */
	
	          /**
	           * @ngdoc object
	           * @name exporterMenuAllData
	           * @porpertyOf  ui.grid.exporter.api:GridOptions
	           * @description Add export all data as cvs/pdf menu items to the ui-grid grid menu, if it's present.  Defaults to true.
	           */
	          gridOptions.exporterMenuAllData = gridOptions.exporterMenuAllData !== undefined ? gridOptions.exporterMenuAllData : true;
	
	          /**
	           * @ngdoc object
	           * @name exporterMenuVisibleData
	           * @porpertyOf  ui.grid.exporter.api:GridOptions
	           * @description Add export visible data as cvs/pdf menu items to the ui-grid grid menu, if it's present.  Defaults to true.
	           */
	          gridOptions.exporterMenuVisibleData = gridOptions.exporterMenuVisibleData !== undefined ? gridOptions.exporterMenuVisibleData : true;
	
	          /**
	           * @ngdoc object
	           * @name exporterMenuSelectedData
	           * @porpertyOf  ui.grid.exporter.api:GridOptions
	           * @description Add export selected data as cvs/pdf menu items to the ui-grid grid menu, if it's present.  Defaults to true.
	           */
	          gridOptions.exporterMenuSelectedData = gridOptions.exporterMenuSelectedData !== undefined ? gridOptions.exporterMenuSelectedData : true;
	
	          /**
	           * @ngdoc object
	           * @name exporterMenuCsv
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description Add csv export menu items to the ui-grid grid menu, if it's present.  Defaults to true.
	           */
	          gridOptions.exporterMenuCsv = gridOptions.exporterMenuCsv !== undefined ? gridOptions.exporterMenuCsv : true;
	
	          /**
	           * @ngdoc object
	           * @name exporterMenuPdf
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description Add pdf export menu items to the ui-grid grid menu, if it's present.  Defaults to true.
	           */
	          gridOptions.exporterMenuPdf = gridOptions.exporterMenuPdf !== undefined ? gridOptions.exporterMenuPdf : true;
	
	          /**
	           * @ngdoc object
	           * @name exporterMenuExcel
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description Add excel export menu items to the ui-grid grid menu, if it's present.  Defaults to true.
	           */
	          gridOptions.exporterMenuExcel = gridOptions.exporterMenuExcel !== undefined ? gridOptions.exporterMenuExcel : true;
	
	          /**
	           * @ngdoc object
	           * @name exporterPdfCustomFormatter
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description A custom callback routine that changes the pdf document, adding any
	           * custom styling or content that is supported by pdfMake.  Takes in the complete docDefinition, and
	           * must return an updated docDefinition ready for pdfMake.
	           * @example
	           * In this example we add a style to the style array, so that we can use it in our
	           * footer definition.
	           * <pre>
	           *   gridOptions.exporterPdfCustomFormatter = function ( docDefinition ) {
	           *     docDefinition.styles.footerStyle = { bold: true, fontSize: 10 };
	           *     return docDefinition;
	           *   }
	           *
	           *   gridOptions.exporterPdfFooter = { text: 'My footer', style: 'footerStyle' }
	           * </pre>
	           */
	          gridOptions.exporterPdfCustomFormatter = ( gridOptions.exporterPdfCustomFormatter && typeof( gridOptions.exporterPdfCustomFormatter ) === 'function' ) ? gridOptions.exporterPdfCustomFormatter : function ( docDef ) { return docDef; };
	
	          /**
	           * @ngdoc object
	           * @name exporterHeaderFilterUseName
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description Defaults to false, which leads to `displayName` being passed into the headerFilter.
	           * If set to true, then will pass `name` instead.
	           *
	           *
	           * @example
	           * <pre>
	           *   gridOptions.exporterHeaderFilterUseName = true;
	           * </pre>
	           */
	          gridOptions.exporterHeaderFilterUseName = gridOptions.exporterHeaderFilterUseName === true;
	
	          /**
	           * @ngdoc object
	           * @name exporterHeaderFilter
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description A function to apply to the header displayNames before exporting.  Useful for internationalisation,
	           * for example if you were using angular-translate you'd set this to `$translate.instant`.  Note that this
	           * call must be synchronous, it cannot be a call that returns a promise.
	           *
	           * Behaviour can be changed to pass in `name` instead of `displayName` through use of `exporterHeaderFilterUseName: true`.
	           *
	           * @example
	           * <pre>
	           *   gridOptions.exporterHeaderFilter = function( displayName ){ return 'col: ' + name; };
	           * </pre>
	           * OR
	           * <pre>
	           *   gridOptions.exporterHeaderFilter = $translate.instant;
	           * </pre>
	           */
	
	          /**
	           * @ngdoc function
	           * @name exporterFieldCallback
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description A function to call for each field before exporting it.  Allows
	           * massaging of raw data into a display format, for example if you have applied
	           * filters to convert codes into decodes, or you require
	           * a specific date format in the exported content.
	           *
	           * The method is called once for each field exported, and provides the grid, the
	           * gridCol and the GridRow for you to use as context in massaging the data.
	           *
	           * @param {Grid} grid provides the grid in case you have need of it
	           * @param {GridRow} row the row from which the data comes
	           * @param {GridColumn} col the column from which the data comes
	           * @param {object} value the value for your massaging
	           * @returns {object} you must return the massaged value ready for exporting
	           *
	           * @example
	           * <pre>
	           *   gridOptions.exporterFieldCallback = function ( grid, row, col, value ){
	           *     if ( col.name === 'status' ){
	           *       value = decodeStatus( value );
	           *     }
	           *     return value;
	           *   }
	           * </pre>
	           */
	          gridOptions.exporterFieldCallback = gridOptions.exporterFieldCallback ? gridOptions.exporterFieldCallback : defaultExporterFieldCallback;
	
	          /**
	           * @ngdoc function
	           * @name exporterFieldFormatCallback
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description A function to call for each field before exporting it.  Allows
	           * general object to be return to modify the format of a cell in the case of
	           * excel exports
	           *
	           * The method is called once for each field exported, and provides the grid, the
	           * gridCol and the GridRow for you to use as context in massaging the data.
	           *
	           * @param {Grid} grid provides the grid in case you have need of it
	           * @param {GridRow} row the row from which the data comes
	           * @param {GridColumn} col the column from which the data comes
	           * @param {object} value the value for your massaging
	           * @returns {object} you must return the massaged value ready for exporting
	           *
	           * @example
	           * <pre>
	           *   gridOptions.exporterFieldCallback = function ( grid, row, col, value ){
	           *     if ( col.name === 'status' ){
	           *       value = decodeStatus( value );
	           *     }
	           *     return value;
	           *   }
	           * </pre>
	           */
	          gridOptions.exporterFieldFormatCallback = gridOptions.exporterFieldFormatCallback ? gridOptions.exporterFieldFormatCallback : function( grid, row, col, value ) { return null; };
	
	          /**
	           * @ngdoc object
	           * @name exporterFieldApplyFilters
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description Defaults to false, which leads to filters being evaluated on export           *
	           *
	           * @example
	           * <pre>
	           *   gridOptions.exporterFieldApplyFilters = true;
	           * </pre>
	           */
	          gridOptions.exporterFieldApplyFilters = gridOptions.exporterFieldApplyFilters === true;
	
	          /**
	           * @ngdoc function
	           * @name exporterAllDataFn
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description This promise is needed when exporting all rows,
	           * and the data need to be provided by server side. Default is null.
	           * @returns {Promise} a promise to load all data from server
	           *
	           * @example
	           * <pre>
	           *   gridOptions.exporterAllDataFn = function () {
	           *     return $http.get('/data/100.json')
	           *   }
	           * </pre>
	           */
	          gridOptions.exporterAllDataFn = gridOptions.exporterAllDataFn ? gridOptions.exporterAllDataFn : null;
	
	          /**
	           * @ngdoc function
	           * @name exporterAllDataPromise
	           * @propertyOf  ui.grid.exporter.api:GridOptions
	           * @description DEPRECATED - exporterAllDataFn used to be
	           * called this, but it wasn't a promise, it was a function that returned
	           * a promise.  Deprecated, but supported for backward compatibility, use
	           * exporterAllDataFn instead.
	           * @returns {Promise} a promise to load all data from server
	           *
	           * @example
	           * <pre>
	           *   gridOptions.exporterAllDataFn = function () {
	           *     return $http.get('/data/100.json')
	           *   }
	           * </pre>
	           */
	          if ( gridOptions.exporterAllDataFn === null && gridOptions.exporterAllDataPromise ) {
	            gridOptions.exporterAllDataFn = gridOptions.exporterAllDataPromise;
	          }
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name addToMenu
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Adds export items to the grid menu,
	         * allowing the user to select export options
	         * @param {Grid} grid the grid from which data should be exported
	         */
	        addToMenu: function ( grid ) {
	          grid.api.core.addToGridMenu( grid, [
	            {
	              title: i18nService.getSafeText('gridMenu.exporterAllAsCsv'),
	              action: function ($event) {
	                grid.api.exporter.csvExport( uiGridExporterConstants.ALL, uiGridExporterConstants.ALL );
	              },
	              shown: function() {
	                return grid.options.exporterMenuCsv && grid.options.exporterMenuAllData;
	              },
	              order: grid.options.exporterMenuItemOrder
	            },
	            {
	              title: i18nService.getSafeText('gridMenu.exporterVisibleAsCsv'),
	              action: function ($event) {
	                grid.api.exporter.csvExport( uiGridExporterConstants.VISIBLE, uiGridExporterConstants.VISIBLE );
	              },
	              shown: function() {
	                return grid.options.exporterMenuCsv && grid.options.exporterMenuVisibleData;
	              },
	              order: grid.options.exporterMenuItemOrder + 1
	            },
	            {
	              title: i18nService.getSafeText('gridMenu.exporterSelectedAsCsv'),
	              action: function ($event) {
	                grid.api.exporter.csvExport( uiGridExporterConstants.SELECTED, uiGridExporterConstants.VISIBLE );
	              },
	              shown: function() {
	                return grid.options.exporterMenuCsv && grid.options.exporterMenuSelectedData &&
	                       ( grid.api.selection && grid.api.selection.getSelectedRows().length > 0 );
	              },
	              order: grid.options.exporterMenuItemOrder + 2
	            },
	            {
	              title: i18nService.getSafeText('gridMenu.exporterAllAsPdf'),
	              action: function ($event) {
	                grid.api.exporter.pdfExport( uiGridExporterConstants.ALL, uiGridExporterConstants.ALL );
	              },
	              shown: function() {
	                return grid.options.exporterMenuPdf && grid.options.exporterMenuAllData;
	              },
	              order: grid.options.exporterMenuItemOrder + 3
	            },
	            {
	              title: i18nService.getSafeText('gridMenu.exporterVisibleAsPdf'),
	              action: function ($event) {
	                grid.api.exporter.pdfExport( uiGridExporterConstants.VISIBLE, uiGridExporterConstants.VISIBLE );
	              },
	              shown: function() {
	                return grid.options.exporterMenuPdf && grid.options.exporterMenuVisibleData;
	              },
	              order: grid.options.exporterMenuItemOrder + 4
	            },
	            {
	              title: i18nService.getSafeText('gridMenu.exporterSelectedAsPdf'),
	              action: function ($event) {
	                grid.api.exporter.pdfExport( uiGridExporterConstants.SELECTED, uiGridExporterConstants.VISIBLE );
	              },
	              shown: function() {
	                return grid.options.exporterMenuPdf && grid.options.exporterMenuSelectedData &&
	                       ( grid.api.selection && grid.api.selection.getSelectedRows().length > 0 );
	              },
	              order: grid.options.exporterMenuItemOrder + 5
	            },
	            {
	              title: i18nService.getSafeText('gridMenu.exporterAllAsExcel'),
	              action: function ($event) {
	                grid.api.exporter.excelExport( uiGridExporterConstants.ALL, uiGridExporterConstants.ALL );
	              },
	              shown: function() {
	                return grid.options.exporterMenuExcel && grid.options.exporterMenuAllData;
	              },
	              order: grid.options.exporterMenuItemOrder + 6
	            },
	            {
	              title: i18nService.getSafeText('gridMenu.exporterVisibleAsExcel'),
	              action: function ($event) {
	                grid.api.exporter.excelExport( uiGridExporterConstants.VISIBLE, uiGridExporterConstants.VISIBLE );
	              },
	              shown: function() {
	                return grid.options.exporterMenuExcel && grid.options.exporterMenuVisibleData;
	              },
	              order: grid.options.exporterMenuItemOrder + 7
	            },
	            {
	              title: i18nService.getSafeText('gridMenu.exporterSelectedAsExcel'),
	              action: function ($event) {
	                grid.api.exporter.excelExport( uiGridExporterConstants.SELECTED, uiGridExporterConstants.VISIBLE );
	              },
	              shown: function() {
	                return grid.options.exporterMenuExcel && grid.options.exporterMenuSelectedData &&
	                  ( grid.api.selection && grid.api.selection.getSelectedRows().length > 0 );
	              },
	              order: grid.options.exporterMenuItemOrder + 8
	            }
	          ]);
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name csvExport
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Exports rows from the grid in csv format,
	         * the data exported is selected based on the provided options
	         * @param {Grid} grid the grid from which data should be exported
	         * @param {string} rowTypes which rows to export, valid values are
	         * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	         * uiGridExporterConstants.SELECTED
	         * @param {string} colTypes which columns to export, valid values are
	         * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	         * uiGridExporterConstants.SELECTED
	         */
	        csvExport: function (grid, rowTypes, colTypes) {
	          var self = this;
	          this.loadAllDataIfNeeded(grid, rowTypes, colTypes).then(function() {
	            var exportColumnHeaders = grid.options.showHeader ? self.getColumnHeaders(grid, colTypes) : [];
	            var exportData = self.getData(grid, rowTypes, colTypes);
	            var csvContent = self.formatAsCsv(exportColumnHeaders, exportData, grid.options.exporterCsvColumnSeparator);
	
	            self.downloadFile (grid.options.exporterCsvFilename, csvContent, grid.options.exporterCsvColumnSeparator, grid.options.exporterOlderExcelCompatibility, grid.options.exporterIsExcelCompatible);
	          });
	        },
	
	        /**
	         * @ngdoc function
	         * @name loadAllDataIfNeeded
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description When using server side pagination, use exporterAllDataFn to
	         * load all data before continuing processing.
	         * When using client side pagination, return a resolved promise so processing
	         * continues immediately
	         * @param {Grid} grid the grid from which data should be exported
	         * @param {string} rowTypes which rows to export, valid values are
	         * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	         * uiGridExporterConstants.SELECTED
	         * @param {string} colTypes which columns to export, valid values are
	         * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	         * uiGridExporterConstants.SELECTED
	         */
	        loadAllDataIfNeeded: function (grid, rowTypes, colTypes) {
	          if ( rowTypes === uiGridExporterConstants.ALL && grid.rows.length !== grid.options.totalItems && grid.options.exporterAllDataFn) {
	            return grid.options.exporterAllDataFn()
	              .then(function(allData) {
	                grid.modifyRows(allData);
	              });
	          } else {
	            var deferred = $q.defer();
	            deferred.resolve();
	            return deferred.promise;
	          }
	        },
	
	        /**
	         * @ngdoc property
	         * @propertyOf ui.grid.exporter.api:ColumnDef
	         * @name exporterSuppressExport
	         * @description Suppresses export for this column.  Used by selection and expandable.
	         */
	
	        /**
	         * @ngdoc function
	         * @name getColumnHeaders
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Gets the column headers from the grid to use
	         * as a title row for the exported file, all headers have
	         * headerCellFilters applied as appropriate.
	         *
	         * Column headers are an array of objects, each object has
	         * name, displayName, width and align attributes.  Only name is
	         * used for csv, all attributes are used for pdf.
	         *
	         * @param {Grid} grid the grid from which data should be exported
	         * @param {string} colTypes which columns to export, valid values are
	         * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	         * uiGridExporterConstants.SELECTED
	         */
	        getColumnHeaders: function (grid, colTypes) {
	          var headers = [];
	          var columns;
	
	          if ( colTypes === uiGridExporterConstants.ALL ){
	            columns = grid.columns;
	          } else {
	            var leftColumns = grid.renderContainers.left ? grid.renderContainers.left.visibleColumnCache.filter( function( column ){ return column.visible; } ) : [];
	            var bodyColumns = grid.renderContainers.body ? grid.renderContainers.body.visibleColumnCache.filter( function( column ){ return column.visible; } ) : [];
	            var rightColumns = grid.renderContainers.right ? grid.renderContainers.right.visibleColumnCache.filter( function( column ){ return column.visible; } ) : [];
	
	            columns = leftColumns.concat(bodyColumns,rightColumns);
	          }
	
	          columns.forEach( function( gridCol ) {
	            // $$hashKey check since when grouping and sorting pragmatically this ends up in export. Filtering it out
	            if ( gridCol.colDef.exporterSuppressExport !== true  && gridCol.field !== '$$hashKey' &&
	                 grid.options.exporterSuppressColumns.indexOf( gridCol.name ) === -1 ){
	              var headerEntry = {
	                name: gridCol.field,
	                displayName: getDisplayName(grid, gridCol),
	                width: gridCol.drawnWidth ? gridCol.drawnWidth : gridCol.width,
	                align: gridCol.colDef.align ? gridCol.colDef.align : (gridCol.colDef.type === 'number' ? 'right' : 'left')
	              };
	              headers.push(headerEntry);
	            }
	          });
	
	          return headers;
	        },
	
	
	        /**
	         * @ngdoc property
	         * @propertyOf ui.grid.exporter.api:ColumnDef
	         * @name exporterPdfAlign
	         * @description the alignment you'd like for this specific column when
	         * exported into a pdf.  Can be 'left', 'right', 'center' or any other
	         * valid pdfMake alignment option.
	         */
	
	
	        /**
	         * @ngdoc object
	         * @name ui.grid.exporter.api:GridRow
	         * @description GridRow settings for exporter
	         */
	        /**
	         * @ngdoc object
	         * @name exporterEnableExporting
	         * @propertyOf  ui.grid.exporter.api:GridRow
	         * @description If set to false, then don't export this row, notwithstanding visible or
	         * other settings
	         * <br/>Defaults to true
	         */
	
	
	        /**
	         * @ngdoc function
	         * @name getRowsFromNode
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Gets rows from a node. If the node is grouped it will
	         * recurse down into the children to get to the raw data element
	         * which is a row without children (a leaf).
	         * @param {Node} aNode the tree node on the grid
	         * @returns {Array} an array of leaf nodes
	         */
	        getRowsFromNode: function(aNode) {
	          var rows = [];
	          for (var i = 0; i<aNode.children.length; i++) {
	            if (aNode.children[i].children && aNode.children[i].children.length === 0) {
	              rows.push(aNode.children[i]);
	            } else {
	              var nodeRows = this.getRowsFromNode(aNode.children[i]);
	              rows = rows.concat(nodeRows);
	            }
	          }
	          return rows;
	        },
	
	        /**
	         * @ngdoc function
	         * @name getDataSorted
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Gets rows from a node. If the node is grouped it will
	         * recurse down into the children to get to the raw data element
	         * which is a row without children (a leaf). If the grid is not
	         * grouped this will return just the raw rows
	         * @param {Grid} grid the grid from which data should be exported
	         * @param {string} rowTypes which rows to export, valid values are
	         * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	         * uiGridExporterConstants.SELECTED
	         * @param {string} colTypes which columns to export, valid values are
	         * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	         * uiGridExporterConstants.SELECTED
	         * @param {boolean} applyCellFilters whether or not to get the display value or the raw value of the data
	         * @returns {Array} an array of leaf nodes
	         */
	        getDataSorted: function (grid, rowTypes, colTypes, applyCellFilters) {
	          if (!grid.treeBase || grid.treeBase.numberLevels === 0) {
	            return grid.rows;
	          }
	          var rows = [];
	
	          for (var i = 0; i< grid.treeBase.tree.length; i++) {
	            var nodeRows = this.getRowsFromNode(grid.treeBase.tree[i]);
	            for (var j = 0; j<nodeRows.length; j++) {
	              rows.push(nodeRows[j].row);
	            }
	          }
	          return rows;
	        },
	
	        /**
	         * @ngdoc function
	         * @name getData
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Gets data from the grid based on the provided options,
	         * all cells have cellFilters applied as appropriate.  Any rows marked
	         * `exporterEnableExporting: false` will not be exported
	         * @param {Grid} grid the grid from which data should be exported
	         * @param {string} rowTypes which rows to export, valid values are
	         * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	         * uiGridExporterConstants.SELECTED
	         * @param {string} colTypes which columns to export, valid values are
	         * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	         * uiGridExporterConstants.SELECTED
	         * @param {boolean} applyCellFilters whether or not to get the display value or the raw value of the data
	         */
	        getData: function (grid, rowTypes, colTypes, applyCellFilters) {
	          var data = [];
	          var rows;
	          var columns;
	
	          switch ( rowTypes ) {
	            case uiGridExporterConstants.ALL:
	              rows = this.getDataSorted(grid, rowTypes, colTypes, applyCellFilters);
	              break;
	            case uiGridExporterConstants.VISIBLE:
	              rows = grid.getVisibleRows();
	              break;
	            case uiGridExporterConstants.SELECTED:
	              if ( grid.api.selection ){
	                rows = grid.api.selection.getSelectedGridRows();
	              } else {
	                gridUtil.logError('selection feature must be enabled to allow selected rows to be exported');
	              }
	              break;
	          }
	
	          if ( colTypes === uiGridExporterConstants.ALL ){
	            columns = grid.columns;
	          } else {
	            var leftColumns = grid.renderContainers.left ? grid.renderContainers.left.visibleColumnCache.filter( function( column ){ return column.visible; } ) : [];
	            var bodyColumns = grid.renderContainers.body ? grid.renderContainers.body.visibleColumnCache.filter( function( column ){ return column.visible; } ) : [];
	            var rightColumns = grid.renderContainers.right ? grid.renderContainers.right.visibleColumnCache.filter( function( column ){ return column.visible; } ) : [];
	
	            columns = leftColumns.concat(bodyColumns,rightColumns);
	          }
	
	          rows.forEach( function( row, index ) {
	
	            if (row.exporterEnableExporting !== false) {
	              var extractedRow = [];
	
	
	              columns.forEach( function( gridCol, index ) {
	              // $$hashKey check since when grouping and sorting programmatically this ends up in export. Filtering it out
	              if ( (gridCol.visible || colTypes === uiGridExporterConstants.ALL ) &&
	                   gridCol.colDef.exporterSuppressExport !== true && gridCol.field !== '$$hashKey' &&
	                   grid.options.exporterSuppressColumns.indexOf( gridCol.name ) === -1 ){
	                  var cellValue = applyCellFilters ? grid.getCellDisplayValue( row, gridCol ) : grid.getCellValue( row, gridCol );
	                  var extractedField = { value: grid.options.exporterFieldCallback( grid, row, gridCol, cellValue ) };
	                  var extension = grid.options.exporterFieldFormatCallback( grid, row, gridCol, cellValue );
	                  if (extension) {
	                    Object.assign(extractedField, extension);
	                  }
	                  if ( gridCol.colDef.exporterPdfAlign ) {
	                    extractedField.alignment = gridCol.colDef.exporterPdfAlign;
	                  }
	                  extractedRow.push(extractedField);
	                }
	              });
	
	              data.push(extractedRow);
	            }
	          });
	
	          return data;
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name formatAsCsv
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Formats the column headers and data as a CSV,
	         * and sends that data to the user
	         * @param {array} exportColumnHeaders an array of column headers,
	         * where each header is an object with name, width and maybe alignment
	         * @param {array} exportData an array of rows, where each row is
	         * an array of column data
	         * @param {string} separator a string that represents the separator to be used in the csv file
	         * @returns {string} csv the formatted csv as a string
	         */
	        formatAsCsv: function (exportColumnHeaders, exportData, separator) {
	          var self = this;
	
	          var bareHeaders = exportColumnHeaders.map(function(header){return { value: header.displayName };});
	
	          var csv = bareHeaders.length > 0 ? (self.formatRowAsCsv(this, separator)(bareHeaders) + '\n') : '';
	
	          csv += exportData.map(this.formatRowAsCsv(this, separator)).join('\n');
	
	          return csv;
	        },
	
	        /**
	         * @ngdoc function
	         * @name formatRowAsCsv
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Renders a single field as a csv field, including
	         * quotes around the value
	         * @param {exporterService} exporter pass in exporter
	         * @param {array} row the row to be turned into a csv string
	         * @returns {string} a csv-ified version of the row
	         */
	        formatRowAsCsv: function (exporter, separator) {
	          return function (row) {
	            return row.map(exporter.formatFieldAsCsv).join(separator);
	          };
	        },
	
	        /**
	         * @ngdoc function
	         * @name formatFieldAsCsv
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Renders a single field as a csv field, including
	         * quotes around the value
	         * @param {field} field the field to be turned into a csv string,
	         * may be of any type
	         * @returns {string} a csv-ified version of the field
	         */
	        formatFieldAsCsv: function (field) {
	          if (field.value == null) { // we want to catch anything null-ish, hence just == not ===
	            return '';
	          }
	          if (typeof(field.value) === 'number') {
	            return field.value;
	          }
	          if (typeof(field.value) === 'boolean') {
	            return (field.value ? 'TRUE' : 'FALSE') ;
	          }
	          if (typeof(field.value) === 'string') {
	            return '"' + field.value.replace(/"/g,'""') + '"';
	          }
	
	          return JSON.stringify(field.value);
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name isIE
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Checks whether current browser is IE and returns it's version if it is
	        */
	        isIE: function () {
	          var match = navigator.userAgent.search(/(?:Edge|MSIE|Trident\/.*; rv:)/);
	          var isIE = false;
	
	          if (match !== -1) {
	            isIE = true;
	          }
	
	          return isIE;
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name downloadFile
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Triggers download of a csv file.  Logic provided
	         * by @cssensei (from his colleagues at https://github.com/ifeelgoods) in issue #2391
	         * @param {string} fileName the filename we'd like our file to be
	         * given
	         * @param {string} csvContent the csv content that we'd like to
	         * download as a file
	         * @param {boolean} exporterOlderExcelCompatibility whether or not we put a utf-16 BOM on the from (\uFEFF)
	          * @param {boolean} exporterIsExcelCompatible whether or not we add separator header ('sep=X')
	         */
	        downloadFile: function (fileName, csvContent, columnSeparator, exporterOlderExcelCompatibility, exporterIsExcelCompatible) {
	          var D = document;
	          var a = D.createElement('a');
	          var strMimeType = 'application/octet-stream;charset=utf-8';
	          var rawFile;
	          var ieVersion = this.isIE();
	
	          if (exporterIsExcelCompatible) {
	              csvContent = 'sep=' + columnSeparator + '\r\n' + csvContent;
	          }
	
	          // IE10+
	          if (navigator.msSaveBlob) {
	            return navigator.msSaveOrOpenBlob(
	              new Blob(
	                [exporterOlderExcelCompatibility ? "\uFEFF" : '', csvContent],
	                { type: strMimeType } ),
	              fileName
	            );
	          }
	
	          if (ieVersion) {
	            var frame = D.createElement('iframe');
	            document.body.appendChild(frame);
	
	            frame.contentWindow.document.open('text/html', 'replace');
	            frame.contentWindow.document.write(csvContent);
	            frame.contentWindow.document.close();
	            frame.contentWindow.focus();
	            frame.contentWindow.document.execCommand('SaveAs', true, fileName);
	
	            document.body.removeChild(frame);
	            return true;
	          }
	
	          //html5 A[download]
	          if ('download' in a) {
	            var blob = new Blob(
	              [exporterOlderExcelCompatibility ? "\uFEFF" : '', csvContent],
	              { type: strMimeType }
	            );
	            rawFile = URL.createObjectURL(blob);
	            a.setAttribute('download', fileName);
	          } else {
	            rawFile = 'data:' + strMimeType + ',' + encodeURIComponent(csvContent);
	            a.setAttribute('target', '_blank');
	          }
	
	          a.href = rawFile;
	          a.setAttribute('style', 'display:none;');
	          D.body.appendChild(a);
	          setTimeout(function() {
	            if (a.click) {
	              a.click();
	              // Workaround for Safari 5
	            } else if (document.createEvent) {
	              var eventObj = document.createEvent('MouseEvents');
	              eventObj.initEvent('click', true, true);
	              a.dispatchEvent(eventObj);
	            }
	            D.body.removeChild(a);
	
	          }, this.delay);
	        },
	
	        /**
	         * @ngdoc function
	         * @name pdfExport
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Exports rows from the grid in pdf format,
	         * the data exported is selected based on the provided options.
	         * Note that this function has a dependency on pdfMake, which must
	         * be installed.  The resulting pdf opens in a new
	         * browser window.
	         * @param {Grid} grid the grid from which data should be exported
	         * @param {string} rowTypes which rows to export, valid values are
	         * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	         * uiGridExporterConstants.SELECTED
	         * @param {string} colTypes which columns to export, valid values are
	         * uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE,
	         * uiGridExporterConstants.SELECTED
	         */
	        pdfExport: function (grid, rowTypes, colTypes) {
	          var self = this;
	          this.loadAllDataIfNeeded(grid, rowTypes, colTypes).then(function () {
	            var exportColumnHeaders = self.getColumnHeaders(grid, colTypes);
	            var exportData = self.getData(grid, rowTypes, colTypes);
	            var docDefinition = self.prepareAsPdf(grid, exportColumnHeaders, exportData);
	
	            if (self.isIE() || navigator.appVersion.indexOf("Edge") !== -1) {
	              self.downloadPDF(grid.options.exporterPdfFilename, docDefinition);
	            } else {
	              pdfMake.createPdf(docDefinition).open();
	            }
	          });
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name downloadPdf
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Generates and retrieves the pdf as a blob, then downloads
	         * it as a file.  Only used in IE, in all other browsers we use the native
	         * pdfMake.open function to just open the PDF
	         * @param {string} fileName the filename to give to the pdf, can be set
	         * through exporterPdfFilename
	         * @param {object} docDefinition a pdf docDefinition that we can generate
	         * and get a blob from
	         */
	        downloadPDF: function (fileName, docDefinition) {
	          var D = document;
	          var a = D.createElement('a');
	          var strMimeType = 'application/octet-stream;charset=utf-8';
	          var rawFile;
	          var ieVersion;
	
	          ieVersion = this.isIE(); // This is now a boolean value
	          var doc = pdfMake.createPdf(docDefinition);
	          var blob;
	
	          doc.getBuffer( function (buffer) {
	            blob = new Blob([buffer]);
	
	            // IE10+
	            if (navigator.msSaveBlob) {
	              return navigator.msSaveBlob(
	                blob, fileName
	              );
	            }
	
	            // Previously:  && ieVersion < 10
	            // ieVersion now returns a boolean for the
	            // sake of sanity. We just check `msSaveBlob` first.
	            if (ieVersion) {
	              var frame = D.createElement('iframe');
	              document.body.appendChild(frame);
	
	              frame.contentWindow.document.open("text/html", "replace");
	              frame.contentWindow.document.write(blob);
	              frame.contentWindow.document.close();
	              frame.contentWindow.focus();
	              frame.contentWindow.document.execCommand('SaveAs', true, fileName);
	
	              document.body.removeChild(frame);
	              return true;
	            }
	          });
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name renderAsPdf
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Renders the data into a pdf, and opens that pdf.
	         *
	         * @param {Grid} grid the grid from which data should be exported
	         * @param {array} exportColumnHeaders an array of column headers,
	         * where each header is an object with name, width and maybe alignment
	         * @param {array} exportData an array of rows, where each row is
	         * an array of column data
	         * @returns {object} a pdfMake format document definition, ready
	         * for generation
	         */
	        prepareAsPdf: function(grid, exportColumnHeaders, exportData) {
	          var headerWidths = this.calculatePdfHeaderWidths( grid, exportColumnHeaders );
	
	          var headerColumns = exportColumnHeaders.map( function( header ) {
	            return { text: header.displayName, style: 'tableHeader' };
	          });
	
	          var stringData = exportData.map(this.formatRowAsPdf(this));
	
	          var allData = [headerColumns].concat(stringData);
	
	          var docDefinition = {
	            pageOrientation: grid.options.exporterPdfOrientation,
	            pageSize: grid.options.exporterPdfPageSize,
	            content: [{
	              style: 'tableStyle',
	              table: {
	                headerRows: 1,
	                widths: headerWidths,
	                body: allData
	              }
	            }],
	            styles: {
	              tableStyle: grid.options.exporterPdfTableStyle,
	              tableHeader: grid.options.exporterPdfTableHeaderStyle
	            },
	            defaultStyle: grid.options.exporterPdfDefaultStyle
	          };
	
	          if ( grid.options.exporterPdfLayout ){
	            docDefinition.layout = grid.options.exporterPdfLayout;
	          }
	
	          if ( grid.options.exporterPdfHeader ){
	            docDefinition.header = grid.options.exporterPdfHeader;
	          }
	
	          if ( grid.options.exporterPdfFooter ){
	            docDefinition.footer = grid.options.exporterPdfFooter;
	          }
	
	          if ( grid.options.exporterPdfCustomFormatter ){
	            docDefinition = grid.options.exporterPdfCustomFormatter( docDefinition );
	          }
	          return docDefinition;
	
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name calculatePdfHeaderWidths
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Determines the column widths base on the
	         * widths we got from the grid.  If the column is drawn
	         * then we have a drawnWidth.  If the column is not visible
	         * then we have '*', 'x%' or a width.  When columns are
	         * not visible they don't contribute to the overall gridWidth,
	         * so we need to adjust to allow for extra columns
	         *
	         * Our basic heuristic is to take the current gridWidth, plus
	         * numeric columns and call this the base gridwidth.
	         *
	         * To that we add 100 for any '*' column, and x% of the base gridWidth
	         * for any column that is a %
	         *
	         * @param {Grid} grid the grid from which data should be exported
	         * @param {array} exportHeaders array of header information
	         * @returns {object} an array of header widths
	         */
	        calculatePdfHeaderWidths: function ( grid, exportHeaders ) {
	          var baseGridWidth = 0;
	          exportHeaders.forEach( function(value){
	            if (typeof(value.width) === 'number'){
	              baseGridWidth += value.width;
	            }
	          });
	
	          var extraColumns = 0;
	          exportHeaders.forEach( function(value){
	            if (value.width === '*'){
	              extraColumns += 100;
	            }
	            if (typeof(value.width) === 'string' && value.width.match(/(\d)*%/)) {
	              var percent = parseInt(value.width.match(/(\d)*%/)[0]);
	
	              value.width = baseGridWidth * percent / 100;
	              extraColumns += value.width;
	            }
	          });
	
	          var gridWidth = baseGridWidth + extraColumns;
	
	          return exportHeaders.map(function( header ) {
	            return header.width === '*' ? header.width : header.width * grid.options.exporterPdfMaxGridWidth / gridWidth;
	          });
	
	        },
	
	        /**
	         * @ngdoc function
	         * @name formatRowAsPdf
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Renders a row in a format consumable by PDF,
	         * mainly meaning casting everything to a string
	         * @param {exporterService} exporter pass in exporter
	         * @param {array} row the row to be turned into a csv string
	         * @returns {string} a csv-ified version of the row
	         */
	        formatRowAsPdf: function ( exporter ) {
	          return function( row ) {
	            return row.map(exporter.formatFieldAsPdfString);
	          };
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name formatFieldAsCsv
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Renders a single field as a pdf-able field, which
	         * is different from a csv field only in that strings don't have quotes
	         * around them
	         * @param {field} field the field to be turned into a pdf string,
	         * may be of any type
	         * @returns {string} a string-ified version of the field
	         */
	        formatFieldAsPdfString: function (field) {
	          var returnVal;
	          if (field.value == null) { // we want to catch anything null-ish, hence just == not ===
	            returnVal = '';
	          } else if (typeof(field.value) === 'number') {
	            returnVal = field.value.toString();
	          } else if (typeof(field.value) === 'boolean') {
	            returnVal = (field.value ? 'TRUE' : 'FALSE') ;
	          } else if (typeof(field.value) === 'string') {
	            returnVal = field.value.replace(/"/g,'""');
	          } else if (field.value instanceof Date) {
	            returnVal = JSON.stringify(field.value).replace(/^"/,'').replace(/"$/,'');
	          } else if (typeof(field.value) === 'object') {
	            returnVal = field.value;
	          } else {
	            returnVal = JSON.stringify(field.value).replace(/^"/,'').replace(/"$/,'');
	          }
	
	          if (field.alignment && typeof(field.alignment) === 'string' ){
	            returnVal = { text: returnVal, alignment: field.alignment };
	          }
	
	          return returnVal;
	        },
	
	        /**
	         * @ngdoc function
	         * @name formatAsExcel
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Formats the column headers and data as a excel,
	         * and sends that data to the user
	         * @param {array} exportColumnHeaders an array of column headers,
	         * where each header is an object with name, width and maybe alignment
	         * @param {array} exportData an array of rows, where each row is
	         * an array of column data
	         * @param {string} separator a string that represents the separator to be used in the csv file
	         * @returns {string} csv the formatted excel as a string
	         */
	        formatAsExcel: function (exportColumnHeaders, exportData, workbook, sheet, docDefinition) {
	          var self = this;
	
	          var bareHeaders = exportColumnHeaders.map(function(header){return { value: header.displayName };});
	
	          var sheetData = [];
	          var headerData = [];
	          for (var i = 0; i < bareHeaders.length; i++) {
	            // TODO - probably need callback to determine header value and header styling
	            var exportStyle = 'header';
	            switch (exportColumnHeaders[i].align) {
	              case 'center':
	                exportStyle = 'headerCenter';
	                break;
	              case 'right':
	                exportStyle = 'headerRight';
	                break;
	            }
	            var metadata = (docDefinition.styles && docDefinition.styles[exportStyle]) ? {style: docDefinition.styles[exportStyle].id} : null;
	            headerData.push({value: bareHeaders[i].value, metadata: metadata});
	          }
	          sheetData.push(headerData);
	
	          var result = exportData.map(this.formatRowAsExcel(this, workbook, sheet));
	          for (var j = 0; j<result.length; j++) {
	            sheetData.push(result[j]);
	          }
	          return sheetData;
	        },
	
	        /**
	         * @ngdoc function
	         * @name formatRowAsExcel
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Renders a single field as a csv field, including
	         * quotes around the value
	         * @param {exporterService} exporter pass in exporter
	         * @param {array} row the row to be turned into a excel string
	         * @returns {array} array of cell objects (i.e. {value: x, metadata: y})
	         */
	        formatRowAsExcel: function (exporter, workbook, sheet) {
	          return function (row) {
	            var values = [];
	            for (var i = 0; i<row.length; i++) {
	              var value = exporter.formatFieldAsExcel(row[i], workbook, sheet);
	              values.push({value: value, metadata: row[i].metadata});
	            }
	            return values;
	          };
	        },
	
	        /**
	         * @ngdoc function
	         * @name formatFieldAsExcel
	         * @methodOf  ui.grid.exporter.service:uiGridExporterService
	         * @description Renders a single field as a csv field, including
	         * quotes around the value
	         * @param {field} field the field to be turned into a csv string,
	         * may be of any type
	         * @returns {string} a excel-ified version of the field
	         */
	        formatFieldAsExcel: function (field, workbook, sheet, formatters) {
	          if (field.value == null) { // we want to catch anything null-ish, hence just == not ===
	            return '';
	          }
	          if (typeof(field.value) === 'number') {
	            return field.value;
	          }
	          if (typeof(field.value) === 'boolean') {
	            return (field.value ? 'TRUE' : 'FALSE') ;
	          }
	          if (typeof(field.value) === 'string') {
	            return field.value.replace(/"/g,'""');
	          }
	
	          return JSON.stringify(field.value);
	        },
	
	        prepareAsExcel: function(grid, workbook, sheet) {
	          var docDefinition = {
	            styles: {
	
	            }
	          };
	
	          if ( grid.options.exporterExcelCustomFormatters ){
	            docDefinition = grid.options.exporterExcelCustomFormatters( grid, workbook, docDefinition );
	          }
	          if ( grid.options.exporterExcelHeader ) {
	            if (angular.isFunction( grid.options.exporterExcelHeader )) {
	              grid.options.exporterExcelHeader(grid, workbook, sheet, docDefinition);
	            } else {
	              var headerText = grid.options.exporterExcelHeader.text;
	              var style = grid.options.exporterExcelHeader.style;
	              sheet.data.push([{value: headerText, metadata: {style: docDefinition.styles[style].id}}]);
	            }
	          }
	
	          return docDefinition;
	        },
	
	        excelExport: function (grid, rowTypes, colTypes) {
	          var self = this;
	          this.loadAllDataIfNeeded(grid, rowTypes, colTypes).then(function() {
	            var exportColumnHeaders = grid.options.showHeader ? self.getColumnHeaders(grid, colTypes) : [];
	
	            var workbook = new ExcelBuilder.Workbook();
	            var aName = grid.options.exporterExcelSheetName ? grid.options.exporterExcelSheetName : 'Sheet1';
	            var sheet = new ExcelBuilder.Worksheet({name: aName});
	            workbook.addWorksheet(sheet);
	            var docDefinition = self.prepareAsExcel(grid, workbook, sheet);
	
	            // The standard column width in Microsoft Excel 2000 is 8.43 characters based on fixed-width Courier font
	            // Width of 10 in excel is 75 pixels
	            var colWidths = [];
	            var startDataIndex = grid.treeBase ? grid.treeBase.numberLevels : (grid.enableRowSelection !== false ? 1 : 0);
	            for (var i = startDataIndex; i < grid.columns.length; i++) {
	              colWidths.push({width: (grid.columns[i].drawnWidth / 75) * 10});
	            }
	            sheet.setColumns(colWidths);
	
	            var exportData = self.getData(grid, rowTypes, colTypes, grid.options.exporterFieldApplyFilters);
	
	            // set column widhths. See function called from prepareAsExcel method
	            //sheet.setColumns(docDefinition.columnWidths);
	
	            //for (var i=0; i< grid.treeBase.tree.length; i++) {
	            //  console.log(grid.treeBase.tree[i]);
	            //}
	            var excelContent = self.formatAsExcel(exportColumnHeaders, exportData, workbook, sheet, docDefinition);
	            sheet.setData(sheet.data.concat(excelContent));
	
	            ExcelBuilder.Builder.createFile(workbook, {type:"blob"}).then(function(result) {
	              self.downloadFile (grid.options.exporterExcelFilename, result, grid.options.exporterCsvColumnSeparator, grid.options.exporterOlderExcelCompatibility);
	            });
	
	          });
	        }
	
	      };
	
	      function getDisplayName(grid, gridCol) {
	        if (grid.options.exporterHeaderFilter) {
	          return grid.options.exporterHeaderFilterUseName ?
	            grid.options.exporterHeaderFilter(gridCol.name) :
	            grid.options.exporterHeaderFilter(gridCol.displayName);
	        }
	
	        return gridCol.headerCellFilter ?
	          $filter(gridCol.headerCellFilter)(gridCol.displayName) :
	          gridCol.displayName;
	      }
	
	      function defaultExporterFieldCallback(grid, row, col, value) {
	        return col.cellFilter ? $filter(col.cellFilter)(value) : value;
	      }
	
	      return service;
	    }
	  ]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.exporter.directive:uiGridExporter
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Adds exporter features to grid
	   *
	   *  @example
	   <example module="app">
	   <file name="app.js">
	   var app = angular.module('app', ['ui.grid', 'ui.grid.exporter']);
	
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	      $scope.data = [
	        { name: 'Bob', title: 'CEO' },
	            { name: 'Frank', title: 'Lowly Developer' }
	      ];
	
	      $scope.gridOptions = {
	        enableGridMenu: true,
	        exporterMenuCsv: false,
	        columnDefs: [
	          {name: 'name', enableCellEdit: true},
	          {name: 'title', enableCellEdit: true}
	        ],
	        data: $scope.data
	      };
	    }]);
	   </file>
	   <file name="index.html">
	   <div ng-controller="MainCtrl">
	   <div ui-grid="gridOptions" ui-grid-exporter></div>
	   </div>
	   </file>
	   </example>
	   */
	  module.directive('uiGridExporter', ['uiGridExporterConstants', 'uiGridExporterService', 'gridUtil', '$compile',
	    function (uiGridExporterConstants, uiGridExporterService, gridUtil, $compile) {
	      return {
	        replace: true,
	        priority: 0,
	        require: '^uiGrid',
	        scope: false,
	        link: function ($scope, $elm, $attrs, uiGridCtrl) {
	          uiGridExporterService.initializeGrid(uiGridCtrl.grid);
	          uiGridCtrl.grid.exporter.$scope = $scope;
	        }
	      };
	    }
	  ]);
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.grouping
	   * @description
	   *
	   * # ui.grid.grouping
	   *
	   * <div class="alert alert-warning" role="alert"><strong>Beta</strong> This feature is ready for testing, but it either hasn't seen a lot of use or has some known bugs.</div>
	   *
	   * This module provides grouping of rows based on the data in them, similar
	   * in concept to excel grouping.  You can group multiple columns, resulting in
	   * nested grouping.
	   *
	   * In concept this feature is similar to sorting + grid footer/aggregation, it
	   * sorts the data based on the grouped columns, then creates group rows that
	   * reflect a break in the data.  Each of those group rows can have aggregations for
	   * the data within that group.
	   *
	   * This feature leverages treeBase to provide the tree functionality itself,
	   * the key thing this feature does therefore is to set treeLevels on the rows
	   * and insert the group headers.
	   *
	   * Design information:
	   * -------------------
	   *
	   * Each column will get new menu items - group by, and aggregate by.  Group by
	   * will cause this column to be sorted (if not already), and will move this column
	   * to the front of the sorted columns (i.e. grouped columns take precedence over
	   * sorted columns).  It will respect the sort order already set if there is one,
	   * and it will allow the sorting logic to change that sort order, it just forces
	   * the column to the front of the sorting.  You can group by multiple columns, the
	   * logic will add this column to the sorting after any already grouped columns.
	   *
	   * Once a grouping is defined, grouping logic is added to the rowsProcessors.  This
	   * will process the rows, identifying a break in the data value, and inserting a grouping row.
	   * Grouping rows have specific attributes on them:
	   *
	   *  - internalRow = true: tells us that this isn't a real row, so we can ignore it
	   *    from any processing that it looking at core data rows.  This is used by the core
	   *    logic (or will be one day), as it's not grouping specific
	   *  - groupHeader = true: tells us this is a groupHeader.  This is used by the grouping logic
	   *    to know if this is a groupHeader row or not
	   *
	   * Since the logic is baked into the rowsProcessors, it should get triggered whenever
	   * row order or filtering or anything like that is changed.  In order to avoid the row instantiation
	   * time, and to preserve state across invocations, we hold a cache of the rows that we created
	   * last time, and we use them again this time if we can.
	   *
	   * By default rows are collapsed, which means all data rows have their visible property
	   * set to false, and only level 0 group rows are set to visible.
	   *
	   * <br/>
	   * <br/>
	   *
	   * <div doc-module-components="ui.grid.grouping"></div>
	   */
	
	  var module = angular.module('ui.grid.grouping', ['ui.grid', 'ui.grid.treeBase']);
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.grouping.constant:uiGridGroupingConstants
	   *
	   *  @description constants available in grouping module, this includes
	   *  all the constants declared in the treeBase module (these are manually copied
	   *  as there isn't an easy way to include constants in another constants file, and
	   *  we don't want to make users include treeBase)
	   *
	   */
	  module.constant('uiGridGroupingConstants', {
	    featureName: "grouping",
	    rowHeaderColName: 'treeBaseRowHeaderCol',
	    EXPANDED: 'expanded',
	    COLLAPSED: 'collapsed',
	    aggregation: {
	      COUNT: 'count',
	      SUM: 'sum',
	      MAX: 'max',
	      MIN: 'min',
	      AVG: 'avg'
	    }
	  });
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.grouping.service:uiGridGroupingService
	   *
	   *  @description Services for grouping features
	   */
	  module.service('uiGridGroupingService', ['$q', 'uiGridGroupingConstants', 'gridUtil', 'rowSorter', 'GridRow', 'gridClassFactory', 'i18nService', 'uiGridConstants', 'uiGridTreeBaseService',
	  function ($q, uiGridGroupingConstants, gridUtil, rowSorter, GridRow, gridClassFactory, i18nService, uiGridConstants, uiGridTreeBaseService) {
	
	    var service = {
	
	      initializeGrid: function (grid, $scope) {
	        uiGridTreeBaseService.initializeGrid( grid, $scope );
	
	        //add feature namespace and any properties to grid for needed
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.grouping.grid:grouping
	         *
	         *  @description Grid properties and functions added for grouping
	         */
	        grid.grouping = {};
	
	        /**
	         *  @ngdoc property
	         *  @propertyOf ui.grid.grouping.grid:grouping
	         *  @name groupHeaderCache
	         *
	         *  @description Cache that holds the group header rows we created last time, we'll
	         *  reuse these next time, not least because they hold our expanded states.
	         *
	         *  We need to take care with these that they don't become a memory leak, we
	         *  create a new cache each time using the values from the old cache.  This works
	         *  so long as we're creating group rows for invisible rows as well.
	         *
	         *  The cache is a nested hash, indexed on the value we grouped by.  So if we
	         *  grouped by gender then age, we'd maybe have something like:
	         *  ```
	         *    {
	         *      male: {
	         *        row: <pointer to the old row>,
	         *        children: {
	         *          22: { row: <pointer to the old row> },
	         *          31: { row: <pointer to the old row> }
	         *      },
	         *      female: {
	         *        row: <pointer to the old row>,
	         *        children: {
	         *          28: { row: <pointer to the old row> },
	         *          55: { row: <pointer to the old row> }
	         *      }
	         *    }
	         *  ```
	         *
	         *  We create new rows for any missing rows, this means that they come in as collapsed.
	         *
	         */
	        grid.grouping.groupHeaderCache = {};
	
	        service.defaultGridOptions(grid.options);
	
	        grid.registerRowsProcessor(service.groupRows, 400);
	
	        grid.registerColumnBuilder( service.groupingColumnBuilder);
	
	        grid.registerColumnsProcessor(service.groupingColumnProcessor, 400);
	
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.grouping.api:PublicApi
	         *
	         *  @description Public Api for grouping feature
	         */
	        var publicApi = {
	          events: {
	            grouping: {
	              /**
	               * @ngdoc event
	               * @eventOf ui.grid.grouping.api:PublicApi
	               * @name aggregationChanged
	               * @description raised whenever aggregation is changed, added or removed from a column
	               *
	               * <pre>
	               *      gridApi.grouping.on.aggregationChanged(scope,function(col){})
	               * </pre>
	               * @param {GridColumn} col the column which on which aggregation changed. The aggregation
	               * type is available as `col.treeAggregation.type`
	               */
	              aggregationChanged: {},
	              /**
	               * @ngdoc event
	               * @eventOf ui.grid.grouping.api:PublicApi
	               * @name groupingChanged
	               * @description raised whenever the grouped columns changes
	               *
	               * <pre>
	               *      gridApi.grouping.on.groupingChanged(scope,function(col){})
	               * </pre>
	               * @param {GridColumn} col the column which on which grouping changed. The new grouping is
	               * available as `col.grouping`
	               */
	              groupingChanged: {}
	            }
	          },
	          methods: {
	            grouping: {
	              /**
	               * @ngdoc function
	               * @name getGrouping
	               * @methodOf  ui.grid.grouping.api:PublicApi
	               * @description Get the grouping configuration for this grid,
	               * used by the saveState feature.  Adds expandedState to the information
	               * provided by the internal getGrouping, and removes any aggregations that have a source
	               * of grouping (i.e. will be automatically reapplied when we regroup the column)
	               * Returned grouping is an object
	               *   `{ grouping: groupArray, treeAggregations: aggregateArray, expandedState: hash }`
	               * where grouping contains an array of objects:
	               *   `{ field: column.field, colName: column.name, groupPriority: column.grouping.groupPriority }`
	               * and aggregations contains an array of objects:
	               *   `{ field: column.field, colName: column.name, aggregation: column.grouping.aggregation }`
	               * and expandedState is a hash of the currently expanded nodes
	               *
	               * The groupArray will be sorted by groupPriority.
	               *
	               * @param {boolean} getExpanded whether or not to return the expanded state
	               * @returns {object} grouping configuration
	               */
	              getGrouping: function ( getExpanded ) {
	                var grouping = service.getGrouping(grid);
	
	                grouping.grouping.forEach( function( group ) {
	                  group.colName = group.col.name;
	                  delete group.col;
	                });
	
	                grouping.aggregations.forEach( function( aggregation ) {
	                  aggregation.colName = aggregation.col.name;
	                  delete aggregation.col;
	                });
	
	                grouping.aggregations = grouping.aggregations.filter( function( aggregation ){
	                  return !aggregation.aggregation.source || aggregation.aggregation.source !== 'grouping';
	                });
	
	                if ( getExpanded ){
	                  grouping.rowExpandedStates = service.getRowExpandedStates( grid.grouping.groupingHeaderCache );
	                }
	
	                return grouping;
	              },
	
	              /**
	               * @ngdoc function
	               * @name setGrouping
	               * @methodOf  ui.grid.grouping.api:PublicApi
	               * @description Set the grouping configuration for this grid,
	               * used by the saveState feature, but can also be used by any
	               * user to specify a combined grouping and aggregation configuration
	               * @param {object} config the config you want to apply, in the format
	               * provided out by getGrouping
	               */
	              setGrouping: function ( config ) {
	                service.setGrouping(grid, config);
	              },
	
	              /**
	               * @ngdoc function
	               * @name groupColumn
	               * @methodOf  ui.grid.grouping.api:PublicApi
	               * @description Adds this column to the existing grouping, at the end of the priority order.
	               * If the column doesn't have a sort, adds one, by default ASC
	               *
	               * This column will move to the left of any non-group columns, the
	               * move is handled in a columnProcessor, so gets called as part of refresh
	               *
	               * @param {string} columnName the name of the column we want to group
	               */
	              groupColumn: function( columnName ) {
	                var column = grid.getColumn(columnName);
	                service.groupColumn(grid, column);
	              },
	
	              /**
	               * @ngdoc function
	               * @name ungroupColumn
	               * @methodOf  ui.grid.grouping.api:PublicApi
	               * @description Removes the groupPriority from this column.  If the
	               * column was previously aggregated the aggregation will come back.
	               * The sort will remain.
	               *
	               * This column will move to the right of any other group columns, the
	               * move is handled in a columnProcessor, so gets called as part of refresh
	               *
	               * @param {string} columnName the name of the column we want to ungroup
	               */
	              ungroupColumn: function( columnName ) {
	                var column = grid.getColumn(columnName);
	                service.ungroupColumn(grid, column);
	              },
	
	              /**
	               * @ngdoc function
	               * @name clearGrouping
	               * @methodOf  ui.grid.grouping.api:PublicApi
	               * @description Clear any grouped columns and any aggregations.  Doesn't remove sorting,
	               * as we don't know whether that sorting was added by grouping or was there beforehand
	               *
	               */
	              clearGrouping: function() {
	                service.clearGrouping(grid);
	              },
	
	              /**
	               * @ngdoc function
	               * @name aggregateColumn
	               * @methodOf  ui.grid.grouping.api:PublicApi
	               * @description Sets the aggregation type on a column, if the
	               * column is currently grouped then it removes the grouping first.
	               * If the aggregationDef is null then will result in the aggregation
	               * being removed
	               *
	               * @param {string} columnName the column we want to aggregate
	               * @param {string} or {function} aggregationDef one of the recognised types
	               * from uiGridGroupingConstants or a custom aggregation function.
	               * @param {string} aggregationLabel (optional) The label to use for this aggregation.
	               */
	              aggregateColumn: function( columnName, aggregationDef, aggregationLabel){
	                var column = grid.getColumn(columnName);
	                service.aggregateColumn( grid, column, aggregationDef, aggregationLabel);
	              }
	
	            }
	          }
	        };
	
	        grid.api.registerEventsFromObject(publicApi.events);
	
	        grid.api.registerMethodsFromObject(publicApi.methods);
	
	        grid.api.core.on.sortChanged( $scope, service.tidyPriorities);
	
	      },
	
	      defaultGridOptions: function (gridOptions) {
	        //default option to true unless it was explicitly set to false
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.grouping.api:GridOptions
	         *
	         *  @description GridOptions for grouping feature, these are available to be
	         *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	         */
	
	        /**
	         *  @ngdoc object
	         *  @name enableGrouping
	         *  @propertyOf  ui.grid.grouping.api:GridOptions
	         *  @description Enable row grouping for entire grid.
	         *  <br/>Defaults to true
	         */
	        gridOptions.enableGrouping = gridOptions.enableGrouping !== false;
	
	        /**
	         *  @ngdoc object
	         *  @name groupingShowCounts
	         *  @propertyOf  ui.grid.grouping.api:GridOptions
	         *  @description shows counts on the groupHeader rows. Not that if you are using a cellFilter or a
	         *  sortingAlgorithm which relies on a specific format or data type, showing counts may cause that
	         *  to break, since the group header rows will always be a string with groupingShowCounts enabled.
	         *  <br/>Defaults to true except on columns of types 'date' and 'object'
	         */
	        gridOptions.groupingShowCounts = gridOptions.groupingShowCounts !== false;
	
	        /**
	         *  @ngdoc object
	         *  @name groupingNullLabel
	         *  @propertyOf  ui.grid.grouping.api:GridOptions
	         *  @description The string to use for the grouping header row label on rows which contain a null or undefined value in the grouped column.
	         *  <br/>Defaults to "Null"
	         */
	        gridOptions.groupingNullLabel = typeof(gridOptions.groupingNullLabel) === 'undefined' ? 'Null' : gridOptions.groupingNullLabel;
	
	        /**
	         *  @ngdoc object
	         *  @name enableGroupHeaderSelection
	         *  @propertyOf  ui.grid.grouping.api:GridOptions
	         *  @description Allows group header rows to be selected.
	         *  <br/>Defaults to false
	         */
	        gridOptions.enableGroupHeaderSelection = gridOptions.enableGroupHeaderSelection === true;
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name groupingColumnBuilder
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Sets the grouping defaults based on the columnDefs
	       *
	       * @param {object} colDef columnDef we're basing on
	       * @param {GridColumn} col the column we're to update
	       * @param {object} gridOptions the options we should use
	       * @returns {promise} promise for the builder - actually we do it all inline so it's immediately resolved
	       */
	      groupingColumnBuilder: function (colDef, col, gridOptions) {
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.grouping.api:ColumnDef
	         *
	         *  @description ColumnDef for grouping feature, these are available to be
	         *  set using the ui-grid {@link ui.grid.class:GridOptions.columnDef gridOptions.columnDefs}
	         */
	
	        /**
	         *  @ngdoc object
	         *  @name enableGrouping
	         *  @propertyOf  ui.grid.grouping.api:ColumnDef
	         *  @description Enable grouping on this column
	         *  <br/>Defaults to true.
	         */
	        if (colDef.enableGrouping === false){
	          return;
	        }
	
	        /**
	         *  @ngdoc object
	         *  @name grouping
	         *  @propertyOf  ui.grid.grouping.api:ColumnDef
	         *  @description Set the grouping for a column.  Format is:
	         *  ```
	         *    {
	         *      groupPriority: <number, starts at 0, if less than 0 or undefined then we're aggregating in this column>
	         *    }
	         *  ```
	         *
	         *  **Note that aggregation used to be included in grouping, but is now separately set on the column via treeAggregation
	         *  setting in treeBase**
	         *
	         *  We group in the priority order given, this will also put these columns to the high order of the sort irrespective
	         *  of the sort priority given them.  If there is no sort defined then we sort ascending, if there is a sort defined then
	         *  we use that sort.
	         *
	         *  If the groupPriority is undefined or less than 0, then we expect to be aggregating, and we look at the
	         *  aggregation types to determine what sort of aggregation we can do.  Values are in the constants file, but
	         *  include SUM, COUNT, MAX, MIN
	         *
	         *  groupPriorities should generally be sequential, if they're not then the next time getGrouping is called
	         *  we'll renumber them to be sequential.
	         *  <br/>Defaults to undefined.
	         */
	
	        if ( typeof(col.grouping) === 'undefined' && typeof(colDef.grouping) !== 'undefined') {
	          col.grouping = angular.copy(colDef.grouping);
	          if ( typeof(col.grouping.groupPriority) !== 'undefined' && col.grouping.groupPriority > -1 ){
	            col.treeAggregationFn = uiGridTreeBaseService.nativeAggregations()[uiGridGroupingConstants.aggregation.COUNT].aggregationFn;
	            col.treeAggregationFinalizerFn = service.groupedFinalizerFn;
	          }
	        } else if (typeof(col.grouping) === 'undefined'){
	          col.grouping = {};
	        }
	
	        if (typeof(col.grouping) !== 'undefined' && typeof(col.grouping.groupPriority) !== 'undefined' && col.grouping.groupPriority >= 0){
	          col.suppressRemoveSort = true;
	        }
	
	        var groupColumn = {
	          name: 'ui.grid.grouping.group',
	          title: i18nService.get().grouping.group,
	          icon: 'ui-grid-icon-indent-right',
	          shown: function () {
	            return typeof(this.context.col.grouping) === 'undefined' ||
	                   typeof(this.context.col.grouping.groupPriority) === 'undefined' ||
	                   this.context.col.grouping.groupPriority < 0;
	          },
	          action: function () {
	            service.groupColumn( this.context.col.grid, this.context.col );
	          }
	        };
	
	        var ungroupColumn = {
	          name: 'ui.grid.grouping.ungroup',
	          title: i18nService.get().grouping.ungroup,
	          icon: 'ui-grid-icon-indent-left',
	          shown: function () {
	            return typeof(this.context.col.grouping) !== 'undefined' &&
	                   typeof(this.context.col.grouping.groupPriority) !== 'undefined' &&
	                   this.context.col.grouping.groupPriority >= 0;
	          },
	          action: function () {
	            service.ungroupColumn( this.context.col.grid, this.context.col );
	          }
	        };
	
	        var aggregateRemove = {
	          name: 'ui.grid.grouping.aggregateRemove',
	          title: i18nService.get().grouping.aggregate_remove,
	          shown: function () {
	            return typeof(this.context.col.treeAggregationFn) !== 'undefined';
	          },
	          action: function () {
	            service.aggregateColumn( this.context.col.grid, this.context.col, null);
	          }
	        };
	
	        // generic adder for the aggregation menus, which follow a pattern
	        var addAggregationMenu = function(type, title){
	          title = title || i18nService.get().grouping['aggregate_' + type] || type;
	          var menuItem = {
	            name: 'ui.grid.grouping.aggregate' + type,
	            title: title,
	            shown: function () {
	              return typeof(this.context.col.treeAggregation) === 'undefined' ||
	                     typeof(this.context.col.treeAggregation.type) === 'undefined' ||
	                     this.context.col.treeAggregation.type !== type;
	            },
	            action: function () {
	              service.aggregateColumn( this.context.col.grid, this.context.col, type);
	            }
	          };
	
	          if (!gridUtil.arrayContainsObjectWithProperty(col.menuItems, 'name', 'ui.grid.grouping.aggregate' + type)) {
	            col.menuItems.push(menuItem);
	          }
	        };
	
	        /**
	         *  @ngdoc object
	         *  @name groupingShowGroupingMenu
	         *  @propertyOf  ui.grid.grouping.api:ColumnDef
	         *  @description Show the grouping (group and ungroup items) menu on this column
	         *  <br/>Defaults to true.
	         */
	        if ( col.colDef.groupingShowGroupingMenu !== false ){
	          if (!gridUtil.arrayContainsObjectWithProperty(col.menuItems, 'name', 'ui.grid.grouping.group')) {
	            col.menuItems.push(groupColumn);
	          }
	
	          if (!gridUtil.arrayContainsObjectWithProperty(col.menuItems, 'name', 'ui.grid.grouping.ungroup')) {
	            col.menuItems.push(ungroupColumn);
	          }
	        }
	
	
	        /**
	         *  @ngdoc object
	         *  @name groupingShowAggregationMenu
	         *  @propertyOf  ui.grid.grouping.api:ColumnDef
	         *  @description Show the aggregation menu on this column
	         *  <br/>Defaults to true.
	         */
	        if ( col.colDef.groupingShowAggregationMenu !== false ){
	          angular.forEach(uiGridTreeBaseService.nativeAggregations(), function(aggregationDef, name){
	            addAggregationMenu(name);
	          });
	          angular.forEach(gridOptions.treeCustomAggregations, function(aggregationDef, name){
	            addAggregationMenu(name, aggregationDef.menuTitle);
	          });
	
	          if (!gridUtil.arrayContainsObjectWithProperty(col.menuItems, 'name', 'ui.grid.grouping.aggregateRemove')) {
	            col.menuItems.push(aggregateRemove);
	          }
	        }
	      },
	
	
	
	
	      /**
	       * @ngdoc function
	       * @name groupingColumnProcessor
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Moves the columns around based on which are grouped
	       *
	       * @param {array} columns the columns to consider rendering
	       * @param {array} rows the grid rows, which we don't use but are passed to us
	       * @returns {array} updated columns array
	       */
	      groupingColumnProcessor: function( columns, rows ) {
	        var grid = this;
	
	        columns = service.moveGroupColumns(this, columns, rows);
	        return columns;
	      },
	
	      /**
	       * @ngdoc function
	       * @name groupedFinalizerFn
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Used on group columns to display the rendered value and optionally
	       * display the count of rows.
	       *
	       * @param {aggregation} the aggregation entity for a grouped column
	       */
	      groupedFinalizerFn: function( aggregation ){
	        var col = this;
	
	        if ( typeof(aggregation.groupVal) !== 'undefined') {
	          aggregation.rendered = aggregation.groupVal;
	          if ( col.grid.options.groupingShowCounts && col.colDef.type !== 'date' && col.colDef.type !== 'object' ){
	            aggregation.rendered += (' (' + aggregation.value + ')');
	          }
	        } else {
	          aggregation.rendered = null;
	        }
	      },
	
	      /**
	       * @ngdoc function
	       * @name moveGroupColumns
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Moves the column order so that the grouped columns are lined up
	       * to the left (well, unless you're RTL, then it's the right).  By doing this in
	       * the columnsProcessor, we make it transient - when the column is ungrouped it'll
	       * go back to where it was.
	       *
	       * Does nothing if the option `moveGroupColumns` is set to false.
	       *
	       * @param {Grid} grid grid object
	       * @param {array} columns the columns that we should process/move
	       * @param {array} rows the grid rows
	       * @returns {array} updated columns
	       */
	      moveGroupColumns: function( grid, columns, rows ){
	        if ( grid.options.moveGroupColumns === false){
	          return columns;
	        }
	
	        columns.forEach( function(column, index){
	          // position used to make stable sort in moveGroupColumns
	          column.groupingPosition = index;
	        });
	
	        columns.sort(function(a, b){
	          var a_group, b_group;
	          if (a.isRowHeader){
	            a_group = a.headerPriority;
	          }
	          else if ( typeof(a.grouping) === 'undefined' || typeof(a.grouping.groupPriority) === 'undefined' || a.grouping.groupPriority < 0){
	            a_group = null;
	          } else {
	            a_group = a.grouping.groupPriority;
	          }
	
	          if (b.isRowHeader){
	            b_group = b.headerPriority;
	          }
	          else if ( typeof(b.grouping) === 'undefined' || typeof(b.grouping.groupPriority) === 'undefined' || b.grouping.groupPriority < 0){
	            b_group = null;
	          } else {
	            b_group = b.grouping.groupPriority;
	          }
	
	          // groups get sorted to the top
	          if ( a_group !== null && b_group === null) { return -1; }
	          if ( b_group !== null && a_group === null) { return 1; }
	          if ( a_group !== null && b_group !== null) {return a_group - b_group; }
	
	          return a.groupingPosition - b.groupingPosition;
	        });
	
	        columns.forEach( function(column, index) {
	          delete column.groupingPosition;
	        });
	
	        return columns;
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name groupColumn
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Adds this column to the existing grouping, at the end of the priority order.
	       * If the column doesn't have a sort, adds one, by default ASC
	       *
	       * This column will move to the left of any non-group columns, the
	       * move is handled in a columnProcessor, so gets called as part of refresh
	       *
	       * @param {Grid} grid grid object
	       * @param {GridColumn} column the column we want to group
	       */
	      groupColumn: function( grid, column){
	        if ( typeof(column.grouping) === 'undefined' ){
	          column.grouping = {};
	        }
	
	        // set the group priority to the next number in the hierarchy
	        var existingGrouping = service.getGrouping( grid );
	        column.grouping.groupPriority = existingGrouping.grouping.length;
	
	        // save sort in order to restore it when column is ungrouped
	        column.previousSort = angular.copy(column.sort);
	
	        // add sort if not present
	        if ( !column.sort ){
	          column.sort = { direction: uiGridConstants.ASC };
	        } else if ( typeof(column.sort.direction) === 'undefined' || column.sort.direction === null ){
	          column.sort.direction = uiGridConstants.ASC;
	        }
	
	        column.treeAggregation = { type: uiGridGroupingConstants.aggregation.COUNT, source: 'grouping' };
	        column.treeAggregationFn = uiGridTreeBaseService.nativeAggregations()[uiGridGroupingConstants.aggregation.COUNT].aggregationFn;
	        column.treeAggregationFinalizerFn = service.groupedFinalizerFn;
	
	        grid.api.grouping.raise.groupingChanged(column);
	        // This indirectly calls service.tidyPriorities( grid );
	        grid.api.core.raise.sortChanged(grid, grid.getColumnSorting());
	
	        grid.queueGridRefresh();
	      },
	
	
	       /**
	       * @ngdoc function
	       * @name ungroupColumn
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Removes the groupPriority from this column.  If the
	       * column was previously aggregated the aggregation will come back.
	       * The sort will remain.
	       *
	       * This column will move to the right of any other group columns, the
	       * move is handled in a columnProcessor, so gets called as part of refresh
	       *
	       * @param {Grid} grid grid object
	       * @param {GridColumn} column the column we want to ungroup
	       */
	      ungroupColumn: function( grid, column){
	        if ( typeof(column.grouping) === 'undefined' ){
	          return;
	        }
	
	        delete column.grouping.groupPriority;
	        delete column.treeAggregation;
	        delete column.customTreeAggregationFinalizer;
	
	        if (column.previousSort) {
	          column.sort = column.previousSort;
	          delete column.previousSort;
	        }
	
	        service.tidyPriorities( grid );
	
	        grid.api.grouping.raise.groupingChanged(column);
	        grid.api.core.raise.sortChanged(grid, grid.getColumnSorting());
	
	        grid.queueGridRefresh();
	      },
	
	      /**
	       * @ngdoc function
	       * @name aggregateColumn
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Sets the aggregation type on a column, if the
	       * column is currently grouped then it removes the grouping first.
	       *
	       * @param {Grid} grid grid object
	       * @param {GridColumn} column the column we want to aggregate
	       * @param {string} aggregationType of the recognised types from uiGridGroupingConstants or one of the custom aggregations from gridOptions
	       */
	      aggregateColumn: function( grid, column, aggregationType){
	
	        if (typeof(column.grouping) !== 'undefined' && typeof(column.grouping.groupPriority) !== 'undefined' && column.grouping.groupPriority >= 0){
	          service.ungroupColumn( grid, column );
	        }
	
	        var aggregationDef = {};
	        if ( typeof(grid.options.treeCustomAggregations[aggregationType]) !== 'undefined' ){
	          aggregationDef = grid.options.treeCustomAggregations[aggregationType];
	        } else if ( typeof(uiGridTreeBaseService.nativeAggregations()[aggregationType]) !== 'undefined' ){
	          aggregationDef = uiGridTreeBaseService.nativeAggregations()[aggregationType];
	        }
	
	        column.treeAggregation = { type: aggregationType, label:  i18nService.get().aggregation[aggregationDef.label] || aggregationDef.label };
	        column.treeAggregationFn = aggregationDef.aggregationFn;
	        column.treeAggregationFinalizerFn = aggregationDef.finalizerFn;
	
	        grid.api.grouping.raise.aggregationChanged(column);
	
	        grid.queueGridRefresh();
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name setGrouping
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Set the grouping based on a config object, used by the save state feature
	       * (more specifically, by the restore function in that feature )
	       *
	       * @param {Grid} grid grid object
	       * @param {object} config the config we want to set, same format as that returned by getGrouping
	       */
	      setGrouping: function ( grid, config ){
	        if ( typeof(config) === 'undefined' ){
	          return;
	        }
	
	        // first remove any existing grouping
	        service.clearGrouping(grid);
	
	        if ( config.grouping && config.grouping.length && config.grouping.length > 0 ){
	          config.grouping.forEach( function( group ) {
	            var col = grid.getColumn(group.colName);
	
	            if ( col ) {
	              service.groupColumn( grid, col );
	            }
	          });
	        }
	
	        if ( config.aggregations && config.aggregations.length ){
	          config.aggregations.forEach( function( aggregation ) {
	            var col = grid.getColumn(aggregation.colName);
	
	            if ( col ) {
	              service.aggregateColumn( grid, col, aggregation.aggregation.type );
	            }
	          });
	        }
	
	        if ( config.rowExpandedStates ){
	          service.applyRowExpandedStates( grid.grouping.groupingHeaderCache, config.rowExpandedStates );
	        }
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name clearGrouping
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Clear any grouped columns and any aggregations.  Doesn't remove sorting,
	       * as we don't know whether that sorting was added by grouping or was there beforehand
	       *
	       * @param {Grid} grid grid object
	       */
	      clearGrouping: function( grid ) {
	        var currentGrouping = service.getGrouping(grid);
	
	        if ( currentGrouping.grouping.length > 0 ){
	          currentGrouping.grouping.forEach( function( group ) {
	            if (!group.col){
	              // should have a group.colName if there's no col
	              group.col = grid.getColumn(group.colName);
	            }
	            service.ungroupColumn(grid, group.col);
	          });
	        }
	
	        if ( currentGrouping.aggregations.length > 0 ){
	          currentGrouping.aggregations.forEach( function( aggregation ){
	            if (!aggregation.col){
	              // should have a group.colName if there's no col
	              aggregation.col = grid.getColumn(aggregation.colName);
	            }
	            service.aggregateColumn(grid, aggregation.col, null);
	          });
	        }
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name tidyPriorities
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Renumbers groupPriority and sortPriority such that
	       * groupPriority is contiguous, and sortPriority either matches
	       * groupPriority (for group columns), and otherwise is contiguous and
	       * higher than groupPriority.
	       *
	       * @param {Grid} grid grid object
	       */
	      tidyPriorities: function( grid ){
	        // if we're called from sortChanged, grid is in this, not passed as param, the param can be a column or undefined
	        if ( ( typeof(grid) === 'undefined' || typeof(grid.grid) !== 'undefined' ) && typeof(this.grid) !== 'undefined' ) {
	          grid = this.grid;
	        }
	
	        var groupArray = [];
	        var sortArray = [];
	
	        grid.columns.forEach( function(column, index){
	          if ( typeof(column.grouping) !== 'undefined' && typeof(column.grouping.groupPriority) !== 'undefined' && column.grouping.groupPriority >= 0){
	            groupArray.push(column);
	          } else if ( typeof(column.sort) !== 'undefined' && typeof(column.sort.priority) !== 'undefined' && column.sort.priority >= 0){
	            sortArray.push(column);
	          }
	        });
	
	        groupArray.sort(function(a, b){ return a.grouping.groupPriority - b.grouping.groupPriority; });
	        groupArray.forEach( function(column, index){
	          column.grouping.groupPriority = index;
	          column.suppressRemoveSort = true;
	          if ( typeof(column.sort) === 'undefined'){
	            column.sort = {};
	          }
	          column.sort.priority = index;
	        });
	
	        var i = groupArray.length;
	        sortArray.sort(function(a, b){ return a.sort.priority - b.sort.priority; });
	        sortArray.forEach( function(column, index){
	          column.sort.priority = i;
	          column.suppressRemoveSort = column.colDef.suppressRemoveSort;
	          i++;
	        });
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name groupRows
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description The rowProcessor that creates the groupHeaders (i.e. does
	       * the actual grouping).
	       *
	       * Assumes it is always called after the sorting processor, guaranteed by the priority setting
	       *
	       * Processes all the rows in order, inserting a groupHeader row whenever there is a change
	       * in value of a grouped row, based on the sortAlgorithm used for the column.  The group header row
	       * is looked up in the groupHeaderCache, and used from there if there is one. The entity is reset
	       * to {} if one is found.
	       *
	       * As it processes it maintains a `processingState` array. This records, for each level of grouping we're
	       * working with, the following information:
	       * ```
	       *   {
	       *     fieldName: name,
	       *     col: col,
	       *     initialised: boolean,
	       *     currentValue: value,
	       *     currentRow: gridRow,
	       *   }
	       * ```
	       * We look for changes in the currentValue at any of the levels.  Where we find a change we:
	       *
	       * - create a new groupHeader row in the array
	       *
	       * @param {array} renderableRows the rows we want to process, usually the output from the previous rowProcessor
	       * @returns {array} the updated rows, including our new group rows
	       */
	      groupRows: function( renderableRows ) {
	        if (renderableRows.length === 0){
	          return renderableRows;
	        }
	
	        var grid = this;
	        grid.grouping.oldGroupingHeaderCache = grid.grouping.groupingHeaderCache || {};
	        grid.grouping.groupingHeaderCache = {};
	
	        var processingState = service.initialiseProcessingState( grid );
	
	        // processes each of the fields we are grouping by, checks if the value has changed and inserts a groupHeader
	        // Broken out as shouldn't create functions in a loop.
	        var updateProcessingState = function( groupFieldState, stateIndex ) {
	          var fieldValue = grid.getCellValue(row, groupFieldState.col);
	
	          // look for change of value - and insert a header
	          if ( !groupFieldState.initialised || rowSorter.getSortFn(grid, groupFieldState.col, renderableRows)(fieldValue, groupFieldState.currentValue) !== 0 ){
	            service.insertGroupHeader( grid, renderableRows, i, processingState, stateIndex );
	            i++;
	          }
	        };
	
	        // use a for loop because it's tolerant of the array length changing whilst we go - we can
	        // manipulate the iterator when we insert groupHeader rows
	        for (var i = 0; i < renderableRows.length; i++ ){
	          var row = renderableRows[i];
	
	          if ( row.visible ){
	            processingState.forEach( updateProcessingState );
	          }
	        }
	
	        delete grid.grouping.oldGroupingHeaderCache;
	        return renderableRows;
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name initialiseProcessingState
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Creates the processing state array that is used
	       * for groupRows.
	       *
	       * @param {Grid} grid grid object
	       * @returns {array} an array in the format described in the groupRows method,
	       * initialised with blank values
	       */
	      initialiseProcessingState: function( grid ){
	        var processingState = [];
	        var columnSettings = service.getGrouping( grid );
	
	        columnSettings.grouping.forEach( function( groupItem, index){
	          processingState.push({
	            fieldName: groupItem.field,
	            col: groupItem.col,
	            initialised: false,
	            currentValue: null,
	            currentRow: null
	          });
	        });
	
	        return processingState;
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name getGrouping
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Get the grouping settings from the columns.  As a side effect
	       * this always renumbers the grouping starting at 0
	       * @param {Grid} grid grid object
	       * @returns {array} an array of the group fields, in order of priority
	       */
	      getGrouping: function( grid ){
	        var groupArray = [];
	        var aggregateArray = [];
	
	        // get all the grouping
	        grid.columns.forEach( function(column, columnIndex){
	          if ( column.grouping ){
	            if ( typeof(column.grouping.groupPriority) !== 'undefined' && column.grouping.groupPriority >= 0){
	              groupArray.push({ field: column.field, col: column, groupPriority: column.grouping.groupPriority, grouping: column.grouping });
	            }
	          }
	          if ( column.treeAggregation && column.treeAggregation.type ){
	            aggregateArray.push({ field: column.field, col: column, aggregation: column.treeAggregation });
	          }
	        });
	
	        // sort grouping into priority order
	        groupArray.sort( function(a, b){
	          return a.groupPriority - b.groupPriority;
	        });
	
	        // renumber the priority in case it was somewhat messed up, then remove the grouping reference
	        groupArray.forEach( function( group, index) {
	          group.grouping.groupPriority = index;
	          group.groupPriority = index;
	          delete group.grouping;
	        });
	
	        return { grouping: groupArray, aggregations: aggregateArray };
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name insertGroupHeader
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Create a group header row, and link it to the various configuration
	       * items that we use.
	       *
	       * Look for the row in the oldGroupingHeaderCache, write the row into the new groupingHeaderCache.
	       *
	       * @param {Grid} grid grid object
	       * @param {array} renderableRows the rows that we are processing
	       * @param {number} rowIndex the row we were up to processing
	       * @param {array} processingState the current processing state
	       * @param {number} stateIndex the processing state item that we were on when we triggered a new group header -
	       * i.e. the column that we want to create a header for
	       */
	      insertGroupHeader: function( grid, renderableRows, rowIndex, processingState, stateIndex ) {
	        // set the value that caused the end of a group into the header row and the processing state
	        var fieldName = processingState[stateIndex].fieldName;
	        var col = processingState[stateIndex].col;
	
	        var newValue = grid.getCellValue(renderableRows[rowIndex], col);
	        var newDisplayValue = newValue;
	        if ( typeof(newValue) === 'undefined' || newValue === null ) {
	          newDisplayValue = grid.options.groupingNullLabel;
	        }
	
	        var getKeyAsValueForCacheMap = function(key) {
	          if (angular.isObject(key)) {
	              return JSON.stringify(key);
	          } else {
	              return key;
	          }
	        };
	
	        var cacheItem = grid.grouping.oldGroupingHeaderCache;
	        for ( var i = 0; i < stateIndex; i++ ){
	          if ( cacheItem && cacheItem[getKeyAsValueForCacheMap(processingState[i].currentValue)] ){
	            cacheItem = cacheItem[getKeyAsValueForCacheMap(processingState[i].currentValue)].children;
	          }
	        }
	
	        var headerRow;
	        if ( cacheItem && cacheItem[getKeyAsValueForCacheMap(newValue)]){
	          headerRow = cacheItem[getKeyAsValueForCacheMap(newValue)].row;
	          headerRow.entity = {};
	        } else {
	          headerRow = new GridRow( {}, null, grid );
	          gridClassFactory.rowTemplateAssigner.call(grid, headerRow);
	        }
	
	        headerRow.entity['$$' + processingState[stateIndex].col.uid] = { groupVal: newDisplayValue };
	        headerRow.treeLevel = stateIndex;
	        headerRow.groupHeader = true;
	        headerRow.internalRow = true;
	        headerRow.enableCellEdit = false;
	        headerRow.enableSelection = grid.options.enableGroupHeaderSelection;
	        processingState[stateIndex].initialised = true;
	        processingState[stateIndex].currentValue = newValue;
	        processingState[stateIndex].currentRow = headerRow;
	
	        // set all processing states below this one to not be initialised - change of this state
	        // means all those need to start again
	        service.finaliseProcessingState( processingState, stateIndex + 1);
	
	        // insert our new header row
	        renderableRows.splice(rowIndex, 0, headerRow);
	
	        // add our new header row to the cache
	        cacheItem = grid.grouping.groupingHeaderCache;
	        for ( i = 0; i < stateIndex; i++ ){
	          cacheItem = cacheItem[getKeyAsValueForCacheMap(processingState[i].currentValue)].children;
	        }
	        cacheItem[getKeyAsValueForCacheMap(newValue)] = { row: headerRow, children: {} };
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name finaliseProcessingState
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Set all processing states lower than the one that had a break in value to
	       * no longer be initialised.  Render the counts into the entity ready for display.
	       *
	       * @param {array} processingState the current processing state
	       * @param {number} stateIndex the processing state item that we were on when we triggered a new group header, all
	       * processing states after this need to be finalised
	       */
	      finaliseProcessingState: function( processingState, stateIndex ){
	        for ( var i = stateIndex; i < processingState.length; i++){
	          processingState[i].initialised = false;
	          processingState[i].currentRow = null;
	          processingState[i].currentValue = null;
	        }
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name getRowExpandedStates
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Extract the groupHeaderCache hash, pulling out only the states.
	       *
	       * The example below shows a grid that is grouped by gender then age
	       *
	       * <pre>
	       *   {
	       *     male: {
	       *       state: 'expanded',
	       *       children: {
	       *         22: { state: 'expanded' },
	       *         30: { state: 'collapsed' }
	       *       }
	       *     },
	       *     female: {
	       *       state: 'expanded',
	       *       children: {
	       *         28: { state: 'expanded' },
	       *         55: { state: 'collapsed' }
	       *       }
	       *     }
	       *   }
	       * </pre>
	       *
	       * @param {object} treeChildren The tree children elements object
	       * @returns {object} the expanded states as an object
	       */
	      getRowExpandedStates: function(treeChildren){
	        if ( typeof(treeChildren) === 'undefined' ){
	          return {};
	        }
	
	        var newChildren = {};
	
	        angular.forEach( treeChildren, function( value, key ){
	          newChildren[key] = { state: value.row.treeNode.state };
	          if ( value.children ){
	            newChildren[key].children = service.getRowExpandedStates( value.children );
	          } else {
	            newChildren[key].children = {};
	          }
	        });
	
	        return newChildren;
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name applyRowExpandedStates
	       * @methodOf  ui.grid.grouping.service:uiGridGroupingService
	       * @description Take a hash in the format as created by getRowExpandedStates,
	       * and apply it to the grid.grouping.groupHeaderCache.
	       *
	       * Takes a treeSubset, and applies to a treeSubset - so can be called
	       * recursively.
	       *
	       * @param {object} currentNode can be grid.grouping.groupHeaderCache, or any of
	       * the children of that hash
	       * @param {object} expandedStates can be the full expanded states, or children
	       * of that expanded states (which hopefully matches the subset of the groupHeaderCache)
	       */
	      applyRowExpandedStates: function( currentNode, expandedStates ){
	        if ( typeof(expandedStates) === 'undefined' ){
	          return;
	        }
	
	        angular.forEach(expandedStates, function( value, key ) {
	          if ( currentNode[key] ){
	            currentNode[key].row.treeNode.state = value.state;
	
	            if (value.children && currentNode[key].children){
	              service.applyRowExpandedStates( currentNode[key].children, value.children );
	            }
	          }
	        });
	      }
	
	
	    };
	
	    return service;
	
	  }]);
	
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.grouping.directive:uiGridGrouping
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Adds grouping features to grid
	   *
	   *  @example
	   <example module="app">
	   <file name="app.js">
	   var app = angular.module('app', ['ui.grid', 'ui.grid.grouping']);
	
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	      $scope.data = [
	        { name: 'Bob', title: 'CEO' },
	            { name: 'Frank', title: 'Lowly Developer' }
	      ];
	
	      $scope.columnDefs = [
	        {name: 'name', enableCellEdit: true},
	        {name: 'title', enableCellEdit: true}
	      ];
	
	      $scope.gridOptions = { columnDefs: $scope.columnDefs, data: $scope.data };
	    }]);
	   </file>
	   <file name="index.html">
	   <div ng-controller="MainCtrl">
	   <div ui-grid="gridOptions" ui-grid-grouping></div>
	   </div>
	   </file>
	   </example>
	   */
	  module.directive('uiGridGrouping', ['uiGridGroupingConstants', 'uiGridGroupingService',
	  function (uiGridGroupingConstants, uiGridGroupingService) {
	    return {
	      replace: true,
	      priority: 0,
	      require: '^uiGrid',
	      scope: false,
	      compile: function () {
	        return {
	          pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	            if (uiGridCtrl.grid.options.enableGrouping !== false){
	              uiGridGroupingService.initializeGrid(uiGridCtrl.grid, $scope);
	            }
	          },
	          post: function ($scope, $elm, $attrs, uiGridCtrl) {
	          }
	        };
	      }
	    };
	  }]);
	
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.importer
	   * @description
	   *
	   * # ui.grid.importer
	   *
	   * <div class="alert alert-success" role="alert"><strong>Stable</strong> This feature is stable. There should no longer be breaking api changes without a deprecation warning.</div>
	   *
	   * This module provides the ability to import data into the grid. It
	   * uses the column defs to work out which data belongs in which column,
	   * and creates entities from a configured class (typically a $resource).
	   *
	   * If the rowEdit feature is enabled, it also calls save on those newly
	   * created objects, and then displays any errors in the imported data.
	   *
	   * Currently the importer imports only CSV and json files, although provision has been
	   * made to process other file formats, and these can be added over time.
	   *
	   * For json files, the properties within each object in the json must match the column names
	   * (to put it another way, the importer doesn't process the json, it just copies the objects
	   * within the json into a new instance of the specified object type)
	   *
	   * For CSV import, the default column identification relies on each column in the
	   * header row matching a column.name or column.displayName. Optionally, a column identification
	   * callback can be used.  This allows matching using other attributes, which is particularly
	   * useful if your application has internationalised column headings (i.e. the headings that
	   * the user sees don't match the column names).
	   *
	   * The importer makes use of the grid menu as the UI for requesting an
	   * import.
	   *
	   * <div ui-grid-importer></div>
	   */
	
	  var module = angular.module('ui.grid.importer', ['ui.grid']);
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.importer.constant:uiGridImporterConstants
	   *
	   *  @description constants available in importer module
	   */
	
	  module.constant('uiGridImporterConstants', {
	    featureName: 'importer'
	  });
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.importer.service:uiGridImporterService
	   *
	   *  @description Services for importer feature
	   */
	  module.service('uiGridImporterService', ['$q', 'uiGridConstants', 'uiGridImporterConstants', 'gridUtil', '$compile', '$interval', 'i18nService', '$window',
	    function ($q, uiGridConstants, uiGridImporterConstants, gridUtil, $compile, $interval, i18nService, $window) {
	
	      var service = {
	
	        initializeGrid: function ($scope, grid) {
	
	          //add feature namespace and any properties to grid for needed state
	          grid.importer = {
	            $scope: $scope
	          };
	
	          this.defaultGridOptions(grid.options);
	
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.importer.api:PublicApi
	           *
	           *  @description Public Api for importer feature
	           */
	          var publicApi = {
	            events: {
	              importer: {
	              }
	            },
	            methods: {
	              importer: {
	                /**
	                 * @ngdoc function
	                 * @name importFile
	                 * @methodOf  ui.grid.importer.api:PublicApi
	                 * @description Imports a file into the grid using the file object
	                 * provided.  Bypasses the grid menu
	                 * @param {File} fileObject the file we want to import, as a javascript
	                 * File object
	                 */
	                importFile: function ( fileObject ) {
	                  service.importThisFile( grid, fileObject );
	                }
	              }
	            }
	          };
	
	          grid.api.registerEventsFromObject(publicApi.events);
	
	          grid.api.registerMethodsFromObject(publicApi.methods);
	
	          if ( grid.options.enableImporter && grid.options.importerShowMenu ){
	            if ( grid.api.core.addToGridMenu ){
	              service.addToMenu( grid );
	            } else {
	              // order of registration is not guaranteed, register in a little while
	              $interval( function() {
	                if (grid.api.core.addToGridMenu){
	                  service.addToMenu( grid );
	                }
	              }, 100, 1);
	            }
	          }
	        },
	
	
	        defaultGridOptions: function (gridOptions) {
	          //default option to true unless it was explicitly set to false
	          /**
	           * @ngdoc object
	           * @name ui.grid.importer.api:GridOptions
	           *
	           * @description GridOptions for importer feature, these are available to be
	           * set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	           */
	
	          /**
	           * @ngdoc property
	           * @propertyOf ui.grid.importer.api:GridOptions
	           * @name enableImporter
	           * @description Whether or not importer is enabled.  Automatically set
	           * to false if the user's browser does not support the required fileApi.
	           * Otherwise defaults to true.
	           *
	           */
	          if (gridOptions.enableImporter  || gridOptions.enableImporter === undefined) {
	            if ( !($window.hasOwnProperty('File') && $window.hasOwnProperty('FileReader') && $window.hasOwnProperty('FileList') && $window.hasOwnProperty('Blob')) ) {
	              gridUtil.logError('The File APIs are not fully supported in this browser, grid importer cannot be used.');
	              gridOptions.enableImporter = false;
	            } else {
	              gridOptions.enableImporter = true;
	            }
	          } else {
	            gridOptions.enableImporter = false;
	          }
	
	          /**
	           * @ngdoc method
	           * @name importerProcessHeaders
	           * @methodOf ui.grid.importer.api:GridOptions
	           * @description A callback function that will process headers using custom
	           * logic.  Set this callback function if the headers that your user will provide in their
	           * import file don't necessarily match the grid header or field names.  This might commonly
	           * occur where your application is internationalised, and therefore the field names
	           * that the user recognises are in a different language than the field names that
	           * ui-grid knows about.
	           *
	           * Defaults to the internal `processHeaders` method, which seeks to match using both
	           * displayName and column.name.  Any non-matching columns are discarded.
	           *
	           * Your callback routine should respond by processing the header array, and returning an array
	           * of matching column names.  A null value in any given position means "don't import this column"
	           *
	           * <pre>
	           *      gridOptions.importerProcessHeaders: function( headerArray ) {
	           *        var myHeaderColumns = [];
	           *        var thisCol;
	           *        headerArray.forEach( function( value, index ) {
	           *          thisCol = mySpecialLookupFunction( value );
	           *          myHeaderColumns.push( thisCol.name );
	           *        });
	           *
	           *        return myHeaderCols;
	           *      })
	           * </pre>
	           * @param {Grid} grid the grid we're importing into
	           * @param {array} headerArray an array of the text from the first row of the csv file,
	           * which you need to match to column.names
	           * @returns {array} array of matching column names, in the same order as the headerArray
	           *
	           */
	          gridOptions.importerProcessHeaders = gridOptions.importerProcessHeaders || service.processHeaders;
	
	          /**
	           * @ngdoc method
	           * @name importerHeaderFilter
	           * @methodOf ui.grid.importer.api:GridOptions
	           * @description A callback function that will filter (usually translate) a single
	           * header.  Used when you want to match the passed in column names to the column
	           * displayName after the header filter.
	           *
	           * Your callback routine needs to return the filtered header value.
	           * <pre>
	           *      gridOptions.importerHeaderFilter: function( displayName ) {
	           *        return $translate.instant( displayName );
	           *      })
	           * </pre>
	           *
	           * or:
	           * <pre>
	           *      gridOptions.importerHeaderFilter: $translate.instant
	           * </pre>
	           * @param {string} displayName the displayName that we'd like to translate
	           * @returns {string} the translated name
	           *
	           */
	          gridOptions.importerHeaderFilter = gridOptions.importerHeaderFilter || function( displayName ) { return displayName; };
	
	          /**
	           * @ngdoc method
	           * @name importerErrorCallback
	           * @methodOf ui.grid.importer.api:GridOptions
	           * @description A callback function that provides custom error handling, rather
	           * than the standard grid behaviour of an alert box and a console message.  You
	           * might use this to internationalise the console log messages, or to write to a
	           * custom logging routine that returned errors to the server.
	           *
	           * <pre>
	           *      gridOptions.importerErrorCallback: function( grid, errorKey, consoleMessage, context ) {
	           *        myUserDisplayRoutine( errorKey );
	           *        myLoggingRoutine( consoleMessage, context );
	           *      })
	           * </pre>
	           * @param {Grid} grid the grid we're importing into, may be useful if you're positioning messages
	           * in some way
	           * @param {string} errorKey one of the i18n keys the importer can return - importer.noHeaders,
	           * importer.noObjects, importer.invalidCsv, importer.invalidJson, importer.jsonNotArray
	           * @param {string} consoleMessage the English console message that importer would have written
	           * @param {object} context the context data that importer would have appended to that console message,
	           * often the file content itself or the element that is in error
	           *
	           */
	          if ( !gridOptions.importerErrorCallback ||  typeof(gridOptions.importerErrorCallback) !== 'function' ){
	            delete gridOptions.importerErrorCallback;
	          }
	
	          /**
	           * @ngdoc method
	           * @name importerDataAddCallback
	           * @methodOf ui.grid.importer.api:GridOptions
	           * @description A mandatory callback function that adds data to the source data array.  The grid
	           * generally doesn't add rows to the source data array, it is tidier to handle this through a user
	           * callback.
	           *
	           * <pre>
	           *      gridOptions.importerDataAddCallback: function( grid, newObjects ) {
	           *        $scope.myData = $scope.myData.concat( newObjects );
	           *      })
	           * </pre>
	           * @param {Grid} grid the grid we're importing into, may be useful in some way
	           * @param {array} newObjects an array of new objects that you should add to your data
	           *
	           */
	          if ( gridOptions.enableImporter === true && !gridOptions.importerDataAddCallback ) {
	            gridUtil.logError("You have not set an importerDataAddCallback, importer is disabled");
	            gridOptions.enableImporter = false;
	          }
	
	          /**
	           * @ngdoc object
	           * @name importerNewObject
	           * @propertyOf  ui.grid.importer.api:GridOptions
	           * @description An object on which we call `new` to create each new row before inserting it into
	           * the data array.  Typically this would be a $resource entity, which means that if you're using
	           * the rowEdit feature, you can directly call save on this entity when the save event is triggered.
	           *
	           * Defaults to a vanilla javascript object
	           *
	           * @example
	           * <pre>
	           *   gridOptions.importerNewObject = MyRes;
	           * </pre>
	           *
	           */
	
	          /**
	           * @ngdoc property
	           * @propertyOf ui.grid.importer.api:GridOptions
	           * @name importerShowMenu
	           * @description Whether or not to show an item in the grid menu.  Defaults to true.
	           *
	           */
	          gridOptions.importerShowMenu = gridOptions.importerShowMenu !== false;
	
	          /**
	           * @ngdoc method
	           * @methodOf ui.grid.importer.api:GridOptions
	           * @name importerObjectCallback
	           * @description A callback that massages the data for each object.  For example,
	           * you might have data stored as a code value, but display the decode.  This callback
	           * can be used to change the decoded value back into a code.  Defaults to doing nothing.
	           * @param {Grid} grid in case you need it
	           * @param {object} newObject the new object as importer has created it, modify it
	           * then return the modified version
	           * @returns {object} the modified object
	           * @example
	           * <pre>
	           *   gridOptions.importerObjectCallback = function ( grid, newObject ) {
	           *     switch newObject.status {
	           *       case 'Active':
	           *         newObject.status = 1;
	           *         break;
	           *       case 'Inactive':
	           *         newObject.status = 2;
	           *         break;
	           *     }
	           *     return newObject;
	           *   };
	           * </pre>
	           */
	          gridOptions.importerObjectCallback = gridOptions.importerObjectCallback || function( grid, newObject ) { return newObject; };
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name addToMenu
	         * @methodOf  ui.grid.importer.service:uiGridImporterService
	         * @description Adds import menu item to the grid menu,
	         * allowing the user to request import of a file
	         * @param {Grid} grid the grid into which data should be imported
	         */
	        addToMenu: function ( grid ) {
	          grid.api.core.addToGridMenu( grid, [
	            {
	              title: i18nService.getSafeText('gridMenu.importerTitle'),
	              order: 150
	            },
	            {
	              templateUrl: 'ui-grid/importerMenuItemContainer',
	              action: function ($event) {
	                this.grid.api.importer.importAFile( grid );
	              },
	              order: 151
	            }
	          ]);
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name importThisFile
	         * @methodOf ui.grid.importer.service:uiGridImporterService
	         * @description Imports the provided file into the grid using the file object
	         * provided.  Bypasses the grid menu
	         * @param {Grid} grid the grid we're importing into
	         * @param {File} fileObject the file we want to import, as returned from the File
	         * javascript object
	         */
	        importThisFile: function ( grid, fileObject ) {
	          if (!fileObject){
	            gridUtil.logError( 'No file object provided to importThisFile, should be impossible, aborting');
	            return;
	          }
	
	          var reader = new FileReader();
	
	          switch ( fileObject.type ){
	            case 'application/json':
	              reader.onload = service.importJsonClosure( grid );
	              break;
	            default:
	              reader.onload = service.importCsvClosure( grid );
	              break;
	          }
	
	          reader.readAsText( fileObject );
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name importJson
	         * @methodOf ui.grid.importer.service:uiGridImporterService
	         * @description Creates a function that imports a json file into the grid.
	         * The json data is imported into new objects of type `gridOptions.importerNewObject`,
	         * and if the rowEdit feature is enabled the rows are marked as dirty
	         * @param {Grid} grid the grid we want to import into
	         * @param {FileObject} importFile the file that we want to import, as
	         * a FileObject
	         */
	        importJsonClosure: function( grid ) {
	          return function( importFile ){
	            var newObjects = [];
	            var newObject;
	
	            var importArray = service.parseJson( grid, importFile );
	            if (importArray === null){
	              return;
	            }
	            importArray.forEach(  function( value, index ) {
	              newObject = service.newObject( grid );
	              angular.extend( newObject, value );
	              newObject = grid.options.importerObjectCallback( grid, newObject );
	              newObjects.push( newObject );
	            });
	
	            service.addObjects( grid, newObjects );
	
	          };
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name parseJson
	         * @methodOf ui.grid.importer.service:uiGridImporterService
	         * @description Parses a json file, returns the parsed data.
	         * Displays an error if file doesn't parse
	         * @param {Grid} grid the grid that we want to import into
	         * @param {FileObject} importFile the file that we want to import, as
	         * a FileObject
	         * @returns {array} array of objects from the imported json
	         */
	        parseJson: function( grid, importFile ){
	          var loadedObjects;
	          try {
	            loadedObjects = JSON.parse( importFile.target.result );
	          } catch (e) {
	            service.alertError( grid, 'importer.invalidJson', 'File could not be processed, is it valid json? Content was: ', importFile.target.result );
	            return;
	          }
	
	          if ( !Array.isArray( loadedObjects ) ){
	            service.alertError( grid, 'importer.jsonNotarray', 'Import failed, file is not an array, file was: ', importFile.target.result );
	            return [];
	          } else {
	            return loadedObjects;
	          }
	        },
	
	
	
	        /**
	         * @ngdoc function
	         * @name importCsvClosure
	         * @methodOf ui.grid.importer.service:uiGridImporterService
	         * @description Creates a function that imports a csv file into the grid
	         * (allowing it to be used in the reader.onload event)
	         * @param {Grid} grid the grid that we want to import into
	         * @param {FileObject} importFile the file that we want to import, as
	         * a file object
	         */
	        importCsvClosure: function( grid ) {
	          return function( importFile ){
	            var importArray = service.parseCsv( importFile );
	            if ( !importArray || importArray.length < 1 ){
	              service.alertError( grid, 'importer.invalidCsv', 'File could not be processed, is it valid csv? Content was: ', importFile.target.result );
	              return;
	            }
	
	            var newObjects = service.createCsvObjects( grid, importArray );
	            if ( !newObjects || newObjects.length === 0 ){
	              service.alertError( grid, 'importer.noObjects', 'Objects were not able to be derived, content was: ', importFile.target.result );
	              return;
	            }
	
	            service.addObjects( grid, newObjects );
	          };
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name parseCsv
	         * @methodOf ui.grid.importer.service:uiGridImporterService
	         * @description Parses a csv file into an array of arrays, with the first
	         * array being the headers, and the remaining arrays being the data.
	         * The logic for this comes from https://github.com/thetalecrafter/excel.js/blob/master/src/csv.js,
	         * which is noted as being under the MIT license.  The code is modified to pass the jscs yoda condition
	         * checker
	         * @param {FileObject} importFile the file that we want to import, as a
	         * file object
	         */
	        parseCsv: function( importFile ) {
	          var csv = importFile.target.result;
	
	          // use the CSV-JS library to parse
	          return CSV.parse(csv);
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name createCsvObjects
	         * @methodOf ui.grid.importer.service:uiGridImporterService
	         * @description Converts an array of arrays (representing the csv file)
	         * into a set of objects.  Uses the provided `gridOptions.importerNewObject`
	         * to create the objects, and maps the header row into the individual columns
	         * using either `gridOptions.importerProcessHeaders`, or by using a native method
	         * of matching to either the displayName, column name or column field of
	         * the columns in the column defs.  The resulting objects will have attributes
	         * that are named based on the column.field or column.name, in that order.
	         * @param {Grid} grid the grid that we want to import into
	         * @param {Array} importArray the data that we want to import, as an array
	         */
	        createCsvObjects: function( grid, importArray ){
	          // pull off header row and turn into headers
	          var headerMapping = grid.options.importerProcessHeaders( grid, importArray.shift() );
	          if ( !headerMapping || headerMapping.length === 0 ){
	            service.alertError( grid, 'importer.noHeaders', 'Column names could not be derived, content was: ', importArray );
	            return [];
	          }
	
	          var newObjects = [];
	          var newObject;
	          importArray.forEach( function( row, index ) {
	            newObject = service.newObject( grid );
	            if ( row !== null ){
	              row.forEach( function( field, index ){
	                if ( headerMapping[index] !== null ){
	                  newObject[ headerMapping[index] ] = field;
	                }
	              });
	            }
	            newObject = grid.options.importerObjectCallback( grid, newObject );
	            newObjects.push( newObject );
	          });
	
	          return newObjects;
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name processHeaders
	         * @methodOf ui.grid.importer.service:uiGridImporterService
	         * @description Determines the columns that the header row from
	         * a csv (or other) file represents.
	         * @param {Grid} grid the grid we're importing into
	         * @param {array} headerRow the header row that we wish to match against
	         * the column definitions
	         * @returns {array} an array of the attribute names that should be used
	         * for that column, based on matching the headers or creating the headers
	         *
	         */
	        processHeaders: function( grid, headerRow ) {
	          var headers = [];
	          if ( !grid.options.columnDefs || grid.options.columnDefs.length === 0 ){
	            // we are going to create new columnDefs for all these columns, so just remove
	            // spaces from the names to create fields
	            headerRow.forEach( function( value, index ) {
	              headers.push( value.replace( /[^0-9a-zA-Z\-_]/g, '_' ) );
	            });
	            return headers;
	          } else {
	            var lookupHash = service.flattenColumnDefs( grid, grid.options.columnDefs );
	            headerRow.forEach(  function( value, index ) {
	              if ( lookupHash[value] ) {
	                headers.push( lookupHash[value] );
	              } else if ( lookupHash[ value.toLowerCase() ] ) {
	                headers.push( lookupHash[ value.toLowerCase() ] );
	              } else {
	                headers.push( null );
	              }
	            });
	            return headers;
	          }
	        },
	
	
	        /**
	         * @name flattenColumnDefs
	         * @methodOf ui.grid.importer.service:uiGridImporterService
	         * @description Runs through the column defs and creates a hash of
	         * the displayName, name and field, and of each of those values forced to lower case,
	         * with each pointing to the field or name
	         * (whichever is present).  Used to lookup column headers and decide what
	         * attribute name to give to the resulting field.
	         * @param {Grid} grid the grid we're importing into
	         * @param {array} columnDefs the columnDefs that we should flatten
	         * @returns {hash} the flattened version of the column def information, allowing
	         * us to look up a value by `flattenedHash[ headerValue ]`
	         */
	        flattenColumnDefs: function( grid, columnDefs ){
	          var flattenedHash = {};
	          columnDefs.forEach(  function( columnDef, index) {
	            if ( columnDef.name ){
	              flattenedHash[ columnDef.name ] = columnDef.field || columnDef.name;
	              flattenedHash[ columnDef.name.toLowerCase() ] = columnDef.field || columnDef.name;
	            }
	
	            if ( columnDef.field ){
	              flattenedHash[ columnDef.field ] = columnDef.field || columnDef.name;
	              flattenedHash[ columnDef.field.toLowerCase() ] = columnDef.field || columnDef.name;
	            }
	
	            if ( columnDef.displayName ){
	              flattenedHash[ columnDef.displayName ] = columnDef.field || columnDef.name;
	              flattenedHash[ columnDef.displayName.toLowerCase() ] = columnDef.field || columnDef.name;
	            }
	
	            if ( columnDef.displayName && grid.options.importerHeaderFilter ){
	              flattenedHash[ grid.options.importerHeaderFilter(columnDef.displayName) ] = columnDef.field || columnDef.name;
	              flattenedHash[ grid.options.importerHeaderFilter(columnDef.displayName).toLowerCase() ] = columnDef.field || columnDef.name;
	            }
	          });
	
	          return flattenedHash;
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name addObjects
	         * @methodOf ui.grid.importer.service:uiGridImporterService
	         * @description Inserts our new objects into the grid data, and
	         * sets the rows to dirty if the rowEdit feature is being used
	         *
	         * Does this by registering a watch on dataChanges, which essentially
	         * is waiting on the result of the grid data watch, and downstream processing.
	         *
	         * When the callback is called, it deregisters itself - we don't want to run
	         * again next time data is added.
	         *
	         * If we never get called, we deregister on destroy.
	         *
	         * @param {Grid} grid the grid we're importing into
	         * @param {array} newObjects the objects we want to insert into the grid data
	         * @returns {object} the new object
	         */
	        addObjects: function( grid, newObjects, $scope ){
	          if ( grid.api.rowEdit ){
	            var dataChangeDereg = grid.registerDataChangeCallback( function() {
	              grid.api.rowEdit.setRowsDirty( newObjects );
	              dataChangeDereg();
	            }, [uiGridConstants.dataChange.ROW] );
	
	            grid.importer.$scope.$on( '$destroy', dataChangeDereg );
	          }
	
	          grid.importer.$scope.$apply( grid.options.importerDataAddCallback( grid, newObjects ) );
	
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name newObject
	         * @methodOf ui.grid.importer.service:uiGridImporterService
	         * @description Makes a new object based on `gridOptions.importerNewObject`,
	         * or based on an empty object if not present
	         * @param {Grid} grid the grid we're importing into
	         * @returns {object} the new object
	         */
	        newObject: function( grid ){
	          if ( typeof(grid.options) !== "undefined" && typeof(grid.options.importerNewObject) !== "undefined" ){
	            return new grid.options.importerNewObject();
	          } else {
	            return {};
	          }
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name alertError
	         * @methodOf ui.grid.importer.service:uiGridImporterService
	         * @description Provides an internationalised user alert for the failure,
	         * and logs a console message including diagnostic content.
	         * Optionally, if the the `gridOptions.importerErrorCallback` routine
	         * is defined, then calls that instead, allowing user specified error routines
	         * @param {Grid} grid the grid we're importing into
	         * @param {array} headerRow the header row that we wish to match against
	         * the column definitions
	         */
	        alertError: function( grid, alertI18nToken, consoleMessage, context ){
	          if ( grid.options.importerErrorCallback ){
	            grid.options.importerErrorCallback( grid, alertI18nToken, consoleMessage, context );
	          } else {
	            $window.alert(i18nService.getSafeText( alertI18nToken ));
	            gridUtil.logError(consoleMessage + context );
	          }
	        }
	      };
	
	      return service;
	
	    }
	  ]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.importer.directive:uiGridImporter
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Adds importer features to grid
	   *
	   */
	  module.directive('uiGridImporter', ['uiGridImporterConstants', 'uiGridImporterService', 'gridUtil', '$compile',
	    function (uiGridImporterConstants, uiGridImporterService, gridUtil, $compile) {
	      return {
	        replace: true,
	        priority: 0,
	        require: '^uiGrid',
	        scope: false,
	        link: function ($scope, $elm, $attrs, uiGridCtrl) {
	          uiGridImporterService.initializeGrid($scope, uiGridCtrl.grid);
	        }
	      };
	    }
	  ]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.importer.directive:uiGridImporterMenuItem
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Handles the processing from the importer menu item - once a file is
	   *  selected
	   *
	   */
	  module.directive('uiGridImporterMenuItem', ['uiGridImporterConstants', 'uiGridImporterService', 'gridUtil', '$compile',
	    function (uiGridImporterConstants, uiGridImporterService, gridUtil, $compile) {
	      return {
	        replace: true,
	        priority: 0,
	        require: '?^uiGrid',
	        scope: false,
	        templateUrl: 'ui-grid/importerMenuItem',
	        link: function ($scope, $elm, $attrs, uiGridCtrl) {
	          var grid;
	
	          function handleFileSelect(event) {
	            var target = event.srcElement || event.target;
	
	            if (target && target.files && target.files.length === 1) {
	              var fileObject = target.files[0];
	
	              // Define grid if the uiGrid controller is present
	              if (typeof(uiGridCtrl) !== 'undefined' && uiGridCtrl) {
	                grid = uiGridCtrl.grid;
	
	                uiGridImporterService.importThisFile( grid, fileObject );
	                target.form.reset();
	              } else {
	                gridUtil.logError('Could not import file because UI Grid was not found.');
	              }
	            }
	          }
	
	          var fileChooser = $elm[0].querySelectorAll('.ui-grid-importer-file-chooser');
	
	          if ( fileChooser.length !== 1 ){
	            gridUtil.logError('Found > 1 or < 1 file choosers within the menu item, error, cannot continue');
	          } else {
	            fileChooser[0].addEventListener('change', handleFileSelect, false);
	          }
	        }
	      };
	    }
	  ]);
	})();
	
	(function() {
	  'use strict';
	  /**
	   *  @ngdoc overview
	   *  @name ui.grid.infiniteScroll
	   *
	   *  @description
	   *
	   * #ui.grid.infiniteScroll
	   *
	   * <div class="alert alert-warning" role="alert"><strong>Beta</strong> This feature is ready for testing, but it either hasn't seen a lot of use or has some known bugs.</div>
	   *
	   * This module provides infinite scroll functionality to ui-grid
	   *
	   */
	  var module = angular.module('ui.grid.infiniteScroll', ['ui.grid']);
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.infiniteScroll.service:uiGridInfiniteScrollService
	   *
	   *  @description Service for infinite scroll features
	   */
	  module.service('uiGridInfiniteScrollService', ['gridUtil', '$compile', '$rootScope', 'uiGridConstants', 'ScrollEvent', '$q', function (gridUtil, $compile, $rootScope, uiGridConstants, ScrollEvent, $q) {
	
	    var service = {
	
	      /**
	       * @ngdoc function
	       * @name initializeGrid
	       * @methodOf ui.grid.infiniteScroll.service:uiGridInfiniteScrollService
	       * @description This method register events and methods into grid public API
	       */
	
	      initializeGrid: function(grid, $scope) {
	        service.defaultGridOptions(grid.options);
	
	        if (!grid.options.enableInfiniteScroll){
	          return;
	        }
	
	        grid.infiniteScroll = { dataLoading: false };
	        service.setScrollDirections( grid, grid.options.infiniteScrollUp, grid.options.infiniteScrollDown );
	          grid.api.core.on.scrollEnd($scope, service.handleScroll);
	
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.infiniteScroll.api:PublicAPI
	         *
	         *  @description Public API for infinite scroll feature
	         */
	        var publicApi = {
	          events: {
	            infiniteScroll: {
	
	              /**
	               * @ngdoc event
	               * @name needLoadMoreData
	               * @eventOf ui.grid.infiniteScroll.api:PublicAPI
	               * @description This event fires when scroll reaches bottom percentage of grid
	               * and needs to load data
	               */
	
	              needLoadMoreData: function ($scope, fn) {
	              },
	
	              /**
	               * @ngdoc event
	               * @name needLoadMoreDataTop
	               * @eventOf ui.grid.infiniteScroll.api:PublicAPI
	               * @description This event fires when scroll reaches top percentage of grid
	               * and needs to load data
	               */
	
	              needLoadMoreDataTop: function ($scope, fn) {
	              }
	            }
	          },
	          methods: {
	            infiniteScroll: {
	
	              /**
	               * @ngdoc function
	               * @name dataLoaded
	               * @methodOf ui.grid.infiniteScroll.api:PublicAPI
	               * @description Call this function when you have loaded the additional data
	               * requested.  You should set scrollUp and scrollDown to indicate
	               * whether there are still more pages in each direction.
	               *
	               * If you call dataLoaded without first calling `saveScrollPercentage` then we will
	               * scroll the user to the start of the newly loaded data, which usually gives a smooth scroll
	               * experience, but can give a jumpy experience with large `infiniteScrollRowsFromEnd` values, and
	               * on variable speed internet connections.  Using `saveScrollPercentage` as demonstrated in the tutorial
	               * should give a smoother scrolling experience for users.
	               *
	               * See infinite_scroll tutorial for example of usage
	               * @param {boolean} scrollUp if set to false flags that there are no more pages upwards, so don't fire
	               * any more infinite scroll events upward
	               * @param {boolean} scrollDown if set to false flags that there are no more pages downwards, so don't
	               * fire any more infinite scroll events downward
	               * @returns {promise} a promise that is resolved when the grid scrolling is fully adjusted.  If you're
	               * planning to remove pages, you should wait on this promise first, or you'll break the scroll positioning
	               */
	              dataLoaded: function( scrollUp, scrollDown ) {
	                service.setScrollDirections(grid, scrollUp, scrollDown);
	
	                var promise = service.adjustScroll(grid).then(function() {
	                  grid.infiniteScroll.dataLoading = false;
	                });
	
	                return promise;
	              },
	
	              /**
	               * @ngdoc function
	               * @name resetScroll
	               * @methodOf ui.grid.infiniteScroll.api:PublicAPI
	               * @description Call this function when you have taken some action that makes the current
	               * scroll position invalid.  For example, if you're using external sorting and you've resorted
	               * then you might reset the scroll, or if you've otherwise substantially changed the data, perhaps
	               * you've reused an existing grid for a new data set
	               *
	               * You must tell us whether there is data upwards or downwards after the reset
	               *
	               * @param {boolean} scrollUp flag that there are pages upwards, fire
	               * infinite scroll events upward
	               * @param {boolean} scrollDown flag that there are pages downwards, so
	               * fire infinite scroll events downward
	               */
	              resetScroll: function( scrollUp, scrollDown ) {
	                service.setScrollDirections( grid, scrollUp, scrollDown);
	
	                service.adjustInfiniteScrollPosition(grid, 0);
	              },
	
	
	              /**
	               * @ngdoc function
	               * @name saveScrollPercentage
	               * @methodOf ui.grid.infiniteScroll.api:PublicAPI
	               * @description Saves the scroll percentage and number of visible rows before you adjust the data,
	               * used if you're subsequently going to call `dataRemovedTop` or `dataRemovedBottom`
	               */
	              saveScrollPercentage: function() {
	                grid.infiniteScroll.prevScrollTop = grid.renderContainers.body.prevScrollTop;
	                grid.infiniteScroll.previousVisibleRows = grid.getVisibleRowCount();
	              },
	
	
	              /**
	               * @ngdoc function
	               * @name dataRemovedTop
	               * @methodOf ui.grid.infiniteScroll.api:PublicAPI
	               * @description Adjusts the scroll position after you've removed data at the top
	               * @param {boolean} scrollUp flag that there are pages upwards, fire
	               * infinite scroll events upward
	               * @param {boolean} scrollDown flag that there are pages downwards, so
	               * fire infinite scroll events downward
	               */
	              dataRemovedTop: function( scrollUp, scrollDown ) {
	                service.dataRemovedTop( grid, scrollUp, scrollDown );
	              },
	
	              /**
	               * @ngdoc function
	               * @name dataRemovedBottom
	               * @methodOf ui.grid.infiniteScroll.api:PublicAPI
	               * @description Adjusts the scroll position after you've removed data at the bottom
	               * @param {boolean} scrollUp flag that there are pages upwards, fire
	               * infinite scroll events upward
	               * @param {boolean} scrollDown flag that there are pages downwards, so
	               * fire infinite scroll events downward
	               */
	              dataRemovedBottom: function( scrollUp, scrollDown ) {
	                service.dataRemovedBottom( grid, scrollUp, scrollDown );
	              },
	
	              /**
	               * @ngdoc function
	               * @name setScrollDirections
	               * @methodOf ui.grid.infiniteScroll.service:uiGridInfiniteScrollService
	               * @description Sets the scrollUp and scrollDown flags, handling nulls and undefined,
	               * and also sets the grid.suppressParentScroll
	               * @param {boolean} scrollUp whether there are pages available up - defaults to false
	               * @param {boolean} scrollDown whether there are pages available down - defaults to true
	               */
	              setScrollDirections:  function ( scrollUp, scrollDown ) {
	                service.setScrollDirections( grid, scrollUp, scrollDown );
	              }
	
	            }
	          }
	        };
	        grid.api.registerEventsFromObject(publicApi.events);
	        grid.api.registerMethodsFromObject(publicApi.methods);
	      },
	
	
	      defaultGridOptions: function (gridOptions) {
	        //default option to true unless it was explicitly set to false
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.infiniteScroll.api:GridOptions
	         *
	         *  @description GridOptions for infinite scroll feature, these are available to be
	         *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	         */
	
	        /**
	         *  @ngdoc object
	         *  @name enableInfiniteScroll
	         *  @propertyOf  ui.grid.infiniteScroll.api:GridOptions
	         *  @description Enable infinite scrolling for this grid
	         *  <br/>Defaults to true
	         */
	        gridOptions.enableInfiniteScroll = gridOptions.enableInfiniteScroll !== false;
	
	        /**
	         * @ngdoc property
	         * @name infiniteScrollRowsFromEnd
	         * @propertyOf ui.grid.class:GridOptions
	         * @description This setting controls how close to the end of the dataset a user gets before
	         * more data is requested by the infinite scroll, whether scrolling up or down.  This allows you to
	         * 'prefetch' rows before the user actually runs out of scrolling.
	         *
	         * Note that if you set this value too high it may give jumpy scrolling behaviour, if you're getting
	         * this behaviour you could use the `saveScrollPercentageMethod` right before loading your data, and we'll
	         * preserve that scroll position
	         *
	         * <br> Defaults to 20
	         */
	        gridOptions.infiniteScrollRowsFromEnd = gridOptions.infiniteScrollRowsFromEnd || 20;
	
	        /**
	         * @ngdoc property
	         * @name infiniteScrollUp
	         * @propertyOf ui.grid.class:GridOptions
	         * @description Whether you allow infinite scroll up, implying that the first page of data
	         * you have displayed is in the middle of your data set.  If set to true then we trigger the
	         * needMoreDataTop event when the user hits the top of the scrollbar.
	         * <br> Defaults to false
	         */
	        gridOptions.infiniteScrollUp = gridOptions.infiniteScrollUp === true;
	
	        /**
	         * @ngdoc property
	         * @name infiniteScrollDown
	         * @propertyOf ui.grid.class:GridOptions
	         * @description Whether you allow infinite scroll down, implying that the first page of data
	         * you have displayed is in the middle of your data set.  If set to true then we trigger the
	         * needMoreData event when the user hits the bottom of the scrollbar.
	         * <br> Defaults to true
	         */
	        gridOptions.infiniteScrollDown = gridOptions.infiniteScrollDown !== false;
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name setScrollDirections
	       * @methodOf ui.grid.infiniteScroll.service:uiGridInfiniteScrollService
	       * @description Sets the scrollUp and scrollDown flags, handling nulls and undefined,
	       * and also sets the grid.suppressParentScroll
	       * @param {grid} grid the grid we're operating on
	       * @param {boolean} scrollUp whether there are pages available up - defaults to false
	       * @param {boolean} scrollDown whether there are pages available down - defaults to true
	       */
	      setScrollDirections:  function ( grid, scrollUp, scrollDown ) {
	        grid.infiniteScroll.scrollUp = ( scrollUp === true );
	        grid.suppressParentScrollUp = ( scrollUp === true );
	
	        grid.infiniteScroll.scrollDown = ( scrollDown !== false);
	        grid.suppressParentScrollDown = ( scrollDown !== false);
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name handleScroll
	       * @methodOf ui.grid.infiniteScroll.service:uiGridInfiniteScrollService
	       * @description Called whenever the grid scrolls, determines whether the scroll should
	       * trigger an infinite scroll request for more data
	       * @param {object} args the args from the event
	       */
	      handleScroll:  function (args) {
	        // don't request data if already waiting for data, or if source is coming from ui.grid.adjustInfiniteScrollPosition() function
	        if ( args.grid.infiniteScroll && args.grid.infiniteScroll.dataLoading || args.source === 'ui.grid.adjustInfiniteScrollPosition' ){
	          return;
	        }
	
	        if (args.y) {
	
	          // If the user is scrolling very quickly all the way to the top/bottom, the scroll handler can get confused
	          // about the direction. First we check if they've gone all the way, and data always is loaded in this case.
	          if (args.y.percentage === 0) {
	            args.grid.scrollDirection = uiGridConstants.scrollDirection.UP;
	            service.loadData(args.grid);
	          } else if (args.y.percentage === 1) {
	            args.grid.scrollDirection = uiGridConstants.scrollDirection.DOWN;
	            service.loadData(args.grid);
	          } else { // Scroll position is somewhere in between top/bottom, so determine whether it's far enough to load more data.
	            var percentage;
	            var targetPercentage = args.grid.options.infiniteScrollRowsFromEnd / args.grid.renderContainers.body.visibleRowCache.length;
	            if (args.grid.scrollDirection === uiGridConstants.scrollDirection.UP ) {
	              percentage = args.y.percentage;
	              if (percentage <= targetPercentage){
	                service.loadData(args.grid);
	              }
	            } else if (args.grid.scrollDirection === uiGridConstants.scrollDirection.DOWN) {
	              percentage = 1 - args.y.percentage;
	              if (percentage <= targetPercentage){
	                service.loadData(args.grid);
	              }
	            }
	          }
	        }
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name loadData
	       * @methodOf ui.grid.infiniteScroll.service:uiGridInfiniteScrollService
	       * @description This function fires 'needLoadMoreData' or 'needLoadMoreDataTop' event based on scrollDirection
	       * and whether there are more pages upwards or downwards.  It also stores the number of rows that we had previously,
	       * and clears out any saved scroll position so that we know whether or not the user calls `saveScrollPercentage`
	       * @param {Grid} grid the grid we're working on
	       */
	      loadData: function (grid) {
	        // save number of currently visible rows to calculate new scroll position later - we know that we want
	        // to be at approximately the row we're currently at
	        grid.infiniteScroll.previousVisibleRows = grid.renderContainers.body.visibleRowCache.length;
	        grid.infiniteScroll.direction = grid.scrollDirection;
	        delete grid.infiniteScroll.prevScrollTop;
	
	        if (grid.scrollDirection === uiGridConstants.scrollDirection.UP && grid.infiniteScroll.scrollUp ) {
	          grid.infiniteScroll.dataLoading = true;
	          grid.api.infiniteScroll.raise.needLoadMoreDataTop();
	        } else if (grid.scrollDirection === uiGridConstants.scrollDirection.DOWN && grid.infiniteScroll.scrollDown ) {
	          grid.infiniteScroll.dataLoading = true;
	          grid.api.infiniteScroll.raise.needLoadMoreData();
	        }
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name adjustScroll
	       * @methodOf ui.grid.infiniteScroll.service:uiGridInfiniteScrollService
	       * @description Once we are informed that data has been loaded, adjust the scroll position to account for that
	       * addition and to make things look clean.
	       *
	       * If we're scrolling up we scroll to the first row of the old data set -
	       * so we're assuming that you would have gotten to the top of the grid (from the 20% need more data trigger) by
	       * the time the data comes back.  If we're scrolling down we scroll to the last row of the old data set - so we're
	       * assuming that you would have gotten to the bottom of the grid (from the 80% need more data trigger) by the time
	       * the data comes back.
	       *
	       * Neither of these are good assumptions, but making this a smoother experience really requires
	       * that trigger to not be a percentage, and to be much closer to the end of the data (say, 5 rows off the end).  Even then
	       * it'd be better still to actually run into the end.  But if the data takes a while to come back, they may have scrolled
	       * somewhere else in the mean-time, in which case they'll get a jump back to the new data.  Anyway, this will do for
	       * now, until someone wants to do better.
	       * @param {Grid} grid the grid we're working on
	       * @returns {promise} a promise that is resolved when scrolling has finished
	       */
	      adjustScroll: function(grid){
	        var promise = $q.defer();
	        $rootScope.$applyAsync(function () {
	          var newPercentage, viewportHeight, rowHeight, newVisibleRows, oldTop, newTop;
	
	          viewportHeight = grid.getViewportHeight() + grid.headerHeight - grid.renderContainers.body.headerHeight - grid.scrollbarHeight;
	          rowHeight = grid.options.rowHeight;
	
	          if ( grid.infiniteScroll.direction === undefined ){
	            // called from initialize, tweak our scroll up a little
	            service.adjustInfiniteScrollPosition(grid, 0);
	          }
	
	          newVisibleRows = grid.getVisibleRowCount();
	
	          // in case not enough data is loaded to enable scroller - load more data
	          var canvasHeight = rowHeight * newVisibleRows;
	          if (grid.infiniteScroll.scrollDown && (viewportHeight > canvasHeight)) {
	            grid.api.infiniteScroll.raise.needLoadMoreData();
	          }
	
	          if ( grid.infiniteScroll.direction === uiGridConstants.scrollDirection.UP ){
	            oldTop = grid.infiniteScroll.prevScrollTop || 0;
	            newTop = oldTop + (newVisibleRows - grid.infiniteScroll.previousVisibleRows)*rowHeight;
	            service.adjustInfiniteScrollPosition(grid, newTop);
	            $rootScope.$applyAsync( function() {
	              promise.resolve();
	            });
	          }
	
	          if ( grid.infiniteScroll.direction === uiGridConstants.scrollDirection.DOWN ){
	            newTop = grid.infiniteScroll.prevScrollTop || (grid.infiniteScroll.previousVisibleRows*rowHeight - viewportHeight);
	            service.adjustInfiniteScrollPosition(grid, newTop);
	            $rootScope.$applyAsync( function() {
	              promise.resolve();
	            });
	          }
	        }, 0);
	
	        return promise.promise;
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name adjustInfiniteScrollPosition
	       * @methodOf ui.grid.infiniteScroll.service:uiGridInfiniteScrollService
	       * @description This function fires 'needLoadMoreData' or 'needLoadMoreDataTop' event based on scrollDirection
	       * @param {Grid} grid the grid we're working on
	       * @param {number} scrollTop the position through the grid that we want to scroll to
	       */
	      adjustInfiniteScrollPosition: function (grid, scrollTop) {
	        var scrollEvent = new ScrollEvent(grid, null, null, 'ui.grid.adjustInfiniteScrollPosition'),
	          visibleRows = grid.getVisibleRowCount(),
	          viewportHeight = grid.getViewportHeight() + grid.headerHeight - grid.renderContainers.body.headerHeight - grid.scrollbarHeight,
	          rowHeight = grid.options.rowHeight,
	          scrollHeight = visibleRows*rowHeight-viewportHeight;
	
	        //for infinite scroll, if there are pages upwards then never allow it to be at the zero position so the up button can be active
	        if (scrollTop === 0 && grid.infiniteScroll.scrollUp) {
	          // using pixels results in a relative scroll, hence we have to use percentage
	          scrollEvent.y = {percentage: 1/scrollHeight};
	        }
	        else {
	          scrollEvent.y = {percentage: scrollTop/scrollHeight};
	        }
	        grid.scrollContainers('', scrollEvent);
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name dataRemovedTop
	       * @methodOf ui.grid.infiniteScroll.api:PublicAPI
	       * @description Adjusts the scroll position after you've removed data at the top. You should
	       * have called `saveScrollPercentage` before you remove the data, and if you're doing this in
	       * response to a `needMoreData` you should wait until the promise from `loadData` has resolved
	       * before you start removing data
	       * @param {Grid} grid the grid we're working on
	       * @param {boolean} scrollUp flag that there are pages upwards, fire
	       * infinite scroll events upward
	       * @param {boolean} scrollDown flag that there are pages downwards, so
	       * fire infinite scroll events downward
	       */
	      dataRemovedTop: function( grid, scrollUp, scrollDown ) {
	        var newVisibleRows, oldTop, newTop, rowHeight;
	        service.setScrollDirections( grid, scrollUp, scrollDown );
	
	        newVisibleRows = grid.renderContainers.body.visibleRowCache.length;
	        oldTop = grid.infiniteScroll.prevScrollTop;
	        rowHeight = grid.options.rowHeight;
	
	        // since we removed from the top, our new scroll row will be the old scroll row less the number
	        // of rows removed
	        newTop = oldTop - ( grid.infiniteScroll.previousVisibleRows - newVisibleRows )*rowHeight;
	
	        service.adjustInfiniteScrollPosition( grid, newTop );
	      },
	
	      /**
	       * @ngdoc function
	       * @name dataRemovedBottom
	       * @methodOf ui.grid.infiniteScroll.api:PublicAPI
	       * @description Adjusts the scroll position after you've removed data at the bottom.  You should
	       * have called `saveScrollPercentage` before you remove the data, and if you're doing this in
	       * response to a `needMoreData` you should wait until the promise from `loadData` has resolved
	       * before you start removing data
	       * @param {Grid} grid the grid we're working on
	       * @param {boolean} scrollUp flag that there are pages upwards, fire
	       * infinite scroll events upward
	       * @param {boolean} scrollDown flag that there are pages downwards, so
	       * fire infinite scroll events downward
	       */
	      dataRemovedBottom: function( grid, scrollUp, scrollDown ) {
	        var newTop;
	        service.setScrollDirections( grid, scrollUp, scrollDown );
	
	        newTop = grid.infiniteScroll.prevScrollTop;
	
	        service.adjustInfiniteScrollPosition( grid, newTop );
	      }
	    };
	    return service;
	  }]);
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.infiniteScroll.directive:uiGridInfiniteScroll
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Adds infinite scroll features to grid
	   *
	   *  @example
	   <example module="app">
	   <file name="app.js">
	   var app = angular.module('app', ['ui.grid', 'ui.grid.infiniteScroll']);
	
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	      $scope.data = [
	        { name: 'Alex', car: 'Toyota' },
	            { name: 'Sam', car: 'Lexus' }
	      ];
	
	      $scope.columnDefs = [
	        {name: 'name'},
	        {name: 'car'}
	      ];
	    }]);
	   </file>
	   <file name="index.html">
	   <div ng-controller="MainCtrl">
	   <div ui-grid="{ data: data, columnDefs: columnDefs }" ui-grid-infinite-scroll="20"></div>
	   </div>
	   </file>
	   </example>
	   */
	
	  module.directive('uiGridInfiniteScroll', ['uiGridInfiniteScrollService',
	    function (uiGridInfiniteScrollService) {
	      return {
	        priority: -200,
	        scope: false,
	        require: '^uiGrid',
	        compile: function($scope, $elm, $attr){
	          return {
	            pre: function($scope, $elm, $attr, uiGridCtrl) {
	              uiGridInfiniteScrollService.initializeGrid(uiGridCtrl.grid, $scope);
	            },
	            post: function($scope, $elm, $attr) {
	            }
	          };
	        }
	      };
	    }]);
	
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.moveColumns
	   * @description
	   *
	   * # ui.grid.moveColumns
	   *
	   * <div class="alert alert-warning" role="alert"><strong>Alpha</strong> This feature is in development. There will almost certainly be breaking api changes, or there are major outstanding bugs.</div>
	   *
	   * This module provides column moving capability to ui.grid. It enables to change the position of columns.
	   * <div doc-module-components="ui.grid.moveColumns"></div>
	   */
	  var module = angular.module('ui.grid.moveColumns', ['ui.grid']);
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.moveColumns.service:uiGridMoveColumnService
	   *  @description Service for column moving feature.
	   */
	  module.service('uiGridMoveColumnService', ['$q', '$rootScope', '$log', 'ScrollEvent', 'uiGridConstants', 'gridUtil', function ($q, $rootScope, $log, ScrollEvent, uiGridConstants, gridUtil) {
	
	    var service = {
	      initializeGrid: function (grid) {
	        var self = this;
	        this.registerPublicApi(grid);
	        this.defaultGridOptions(grid.options);
	        grid.moveColumns = {orderCache: []}; // Used to cache the order before columns are rebuilt
	        grid.registerColumnBuilder(self.movableColumnBuilder);
	        grid.registerDataChangeCallback(self.verifyColumnOrder, [uiGridConstants.dataChange.COLUMN]);
	      },
	      registerPublicApi: function (grid) {
	        var self = this;
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.moveColumns.api:PublicApi
	         *  @description Public Api for column moving feature.
	         */
	        var publicApi = {
	          events: {
	            /**
	             * @ngdoc event
	             * @name columnPositionChanged
	             * @eventOf  ui.grid.moveColumns.api:PublicApi
	             * @description raised when column is moved
	             * <pre>
	             *      gridApi.colMovable.on.columnPositionChanged(scope,function(colDef, originalPosition, newPosition){})
	             * </pre>
	             * @param {object} colDef the column that was moved
	             * @param {integer} originalPosition of the column
	             * @param {integer} finalPosition of the column
	             */
	            colMovable: {
	              columnPositionChanged: function (colDef, originalPosition, newPosition) {
	              }
	            }
	          },
	          methods: {
	            /**
	             * @ngdoc method
	             * @name moveColumn
	             * @methodOf  ui.grid.moveColumns.api:PublicApi
	             * @description Method can be used to change column position.
	             * <pre>
	             *      gridApi.colMovable.moveColumn(oldPosition, newPosition)
	             * </pre>
	             * @param {integer} originalPosition of the column
	             * @param {integer} finalPosition of the column
	             */
	            colMovable: {
	              moveColumn: function (originalPosition, finalPosition) {
	                var columns = grid.columns;
	                if (!angular.isNumber(originalPosition) || !angular.isNumber(finalPosition)) {
	                  gridUtil.logError('MoveColumn: Please provide valid values for originalPosition and finalPosition');
	                  return;
	                }
	                var nonMovableColumns = 0;
	                for (var i = 0; i < columns.length; i++) {
	                  if ((angular.isDefined(columns[i].colDef.visible) && columns[i].colDef.visible === false) || columns[i].isRowHeader === true) {
	                    nonMovableColumns++;
	                  }
	                }
	                if (originalPosition >= (columns.length - nonMovableColumns) || finalPosition >= (columns.length - nonMovableColumns)) {
	                  gridUtil.logError('MoveColumn: Invalid values for originalPosition, finalPosition');
	                  return;
	                }
	                var findPositionForRenderIndex = function (index) {
	                  var position = index;
	                  for (var i = 0; i <= position; i++) {
	                    if (angular.isDefined(columns[i]) && ((angular.isDefined(columns[i].colDef.visible) && columns[i].colDef.visible === false) || columns[i].isRowHeader === true)) {
	                      position++;
	                    }
	                  }
	                  return position;
	                };
	                self.redrawColumnAtPosition(grid, findPositionForRenderIndex(originalPosition), findPositionForRenderIndex(finalPosition));
	              }
	            }
	          }
	        };
	        grid.api.registerEventsFromObject(publicApi.events);
	        grid.api.registerMethodsFromObject(publicApi.methods);
	      },
	      defaultGridOptions: function (gridOptions) {
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.moveColumns.api:GridOptions
	         *
	         *  @description Options for configuring the move column feature, these are available to be
	         *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	         */
	        /**
	         *  @ngdoc object
	         *  @name enableColumnMoving
	         *  @propertyOf  ui.grid.moveColumns.api:GridOptions
	         *  @description If defined, sets the default value for the colMovable flag on each individual colDefs
	         *  if their individual enableColumnMoving configuration is not defined. Defaults to true.
	         */
	        gridOptions.enableColumnMoving = gridOptions.enableColumnMoving !== false;
	      },
	      movableColumnBuilder: function (colDef, col, gridOptions) {
	        var promises = [];
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.moveColumns.api:ColumnDef
	         *
	         *  @description Column Definition for move column feature, these are available to be
	         *  set using the ui-grid {@link ui.grid.class:GridOptions.columnDef gridOptions.columnDefs}
	         */
	        /**
	         *  @ngdoc object
	         *  @name enableColumnMoving
	         *  @propertyOf  ui.grid.moveColumns.api:ColumnDef
	         *  @description Enable column moving for the column.
	         */
	        colDef.enableColumnMoving = colDef.enableColumnMoving === undefined ? gridOptions.enableColumnMoving
	          : colDef.enableColumnMoving;
	        return $q.all(promises);
	      },
	      /**
	       * @ngdoc method
	       * @name updateColumnCache
	       * @methodOf  ui.grid.moveColumns
	       * @description Cache the current order of columns, so we can restore them after new columnDefs are defined
	       */
	      updateColumnCache: function(grid){
	        grid.moveColumns.orderCache = grid.getOnlyDataColumns();
	      },
	      /**
	       * @ngdoc method
	       * @name verifyColumnOrder
	       * @methodOf  ui.grid.moveColumns
	       * @description dataChangeCallback which uses the cached column order to restore the column order
	       * when it is reset by altering the columnDefs array.
	       */
	      verifyColumnOrder: function(grid){
	        var headerRowOffset = grid.rowHeaderColumns.length;
	        var newIndex;
	
	        angular.forEach(grid.moveColumns.orderCache, function(cacheCol, cacheIndex){
	          newIndex = grid.columns.indexOf(cacheCol);
	          if ( newIndex !== -1 && newIndex - headerRowOffset !== cacheIndex ){
	            var column = grid.columns.splice(newIndex, 1)[0];
	            grid.columns.splice(cacheIndex + headerRowOffset, 0, column);
	          }
	        });
	      },
	      redrawColumnAtPosition: function (grid, originalPosition, newPosition) {
	        var columns = grid.columns;
	
	        if (originalPosition === newPosition) {
	          return;
	        }
	
	        //check columns in between move-range to make sure they are visible columns
	        var pos = (originalPosition < newPosition) ? originalPosition + 1 : originalPosition - 1;
	        var i0 = Math.min(pos, newPosition);
	        for (i0; i0 <= Math.max(pos, newPosition); i0++) {
	          if (columns[i0].visible) {
	            break;
	          }
	        }
	        if (i0 > Math.max(pos, newPosition)) {
	          //no visible column found, column did not visibly move
	          return;
	        }
	
	        var originalColumn = columns[originalPosition];
	        if (originalColumn.colDef.enableColumnMoving) {
	          if (originalPosition > newPosition) {
	            for (var i1 = originalPosition; i1 > newPosition; i1--) {
	              columns[i1] = columns[i1 - 1];
	            }
	          }
	          else if (newPosition > originalPosition) {
	            for (var i2 = originalPosition; i2 < newPosition; i2++) {
	              columns[i2] = columns[i2 + 1];
	            }
	          }
	          columns[newPosition] = originalColumn;
	          service.updateColumnCache(grid);
	          grid.queueGridRefresh();
	          $rootScope.$applyAsync(function () {
	            grid.api.core.notifyDataChange( uiGridConstants.dataChange.COLUMN );
	            grid.api.colMovable.raise.columnPositionChanged(originalColumn.colDef, originalPosition, newPosition);
	          });
	        }
	      }
	    };
	    return service;
	  }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.moveColumns.directive:uiGridMoveColumns
	   *  @element div
	   *  @restrict A
	   *  @description Adds column moving features to the ui-grid directive.
	   *  @example
	   <example module="app">
	   <file name="app.js">
	   var app = angular.module('app', ['ui.grid', 'ui.grid.moveColumns']);
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	        $scope.data = [
	          { name: 'Bob', title: 'CEO', age: 45 },
	          { name: 'Frank', title: 'Lowly Developer', age: 25 },
	          { name: 'Jenny', title: 'Highly Developer', age: 35 }
	        ];
	        $scope.columnDefs = [
	          {name: 'name'},
	          {name: 'title'},
	          {name: 'age'}
	        ];
	      }]);
	   </file>
	   <file name="main.css">
	   .grid {
	      width: 100%;
	      height: 150px;
	    }
	   </file>
	   <file name="index.html">
	   <div ng-controller="MainCtrl">
	   <div class="grid" ui-grid="{ data: data, columnDefs: columnDefs }" ui-grid-move-columns></div>
	   </div>
	   </file>
	   </example>
	   */
	  module.directive('uiGridMoveColumns', ['uiGridMoveColumnService', function (uiGridMoveColumnService) {
	    return {
	      replace: true,
	      priority: 0,
	      require: '^uiGrid',
	      scope: false,
	      compile: function () {
	        return {
	          pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	            uiGridMoveColumnService.initializeGrid(uiGridCtrl.grid);
	          },
	          post: function ($scope, $elm, $attrs, uiGridCtrl) {
	          }
	        };
	      }
	    };
	  }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.moveColumns.directive:uiGridHeaderCell
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Stacks on top of ui.grid.uiGridHeaderCell to provide capability to be able to move it to reposition column.
	   *
	   *  On receiving mouseDown event headerCell is cloned, now as the mouse moves the cloned header cell also moved in the grid.
	   *  In case the moving cloned header cell reaches the left or right extreme of grid, grid scrolling is triggered (if horizontal scroll exists).
	   *  On mouseUp event column is repositioned at position where mouse is released and cloned header cell is removed.
	   *
	   *  Events that invoke cloning of header cell:
	   *    - mousedown
	   *
	   *  Events that invoke movement of cloned header cell:
	   *    - mousemove
	   *
	   *  Events that invoke repositioning of column:
	   *    - mouseup
	   */
	  module.directive('uiGridHeaderCell', ['$q', 'gridUtil', 'uiGridMoveColumnService', '$document', '$log', 'uiGridConstants', 'ScrollEvent',
	    function ($q, gridUtil, uiGridMoveColumnService, $document, $log, uiGridConstants, ScrollEvent) {
	      return {
	        priority: -10,
	        require: '^uiGrid',
	        compile: function () {
	          return {
	            post: function ($scope, $elm, $attrs, uiGridCtrl) {
	
	              if ($scope.col.colDef.enableColumnMoving) {
	
	                /*
	                 * Our general approach to column move is that we listen to a touchstart or mousedown
	                 * event over the column header.  When we hear one, then we wait for a move of the same type
	                 * - if we are a touchstart then we listen for a touchmove, if we are a mousedown we listen for
	                 * a mousemove (i.e. a drag) before we decide that there's a move underway.  If there's never a move,
	                 * and we instead get a mouseup or a touchend, then we just drop out again and do nothing.
	                 *
	                 */
	                var $contentsElm = angular.element( $elm[0].querySelectorAll('.ui-grid-cell-contents') );
	
	                var gridLeft;
	                var previousMouseX;
	                var totalMouseMovement;
	                var rightMoveLimit;
	                var elmCloned = false;
	                var movingElm;
	                var reducedWidth;
	                var moveOccurred = false;
	
	                var downFn = function( event ){
	                  //Setting some variables required for calculations.
	                  gridLeft = $scope.grid.element[0].getBoundingClientRect().left;
	                  if ( $scope.grid.hasLeftContainer() ){
	                    gridLeft += $scope.grid.renderContainers.left.header[0].getBoundingClientRect().width;
	                  }
	
	                  previousMouseX = event.pageX || (event.originalEvent ? event.originalEvent.pageX : 0);
	                  totalMouseMovement = 0;
	                  rightMoveLimit = gridLeft + $scope.grid.getViewportWidth();
	
	                  if ( event.type === 'mousedown' ){
	                    $document.on('mousemove', moveFn);
	                    $document.on('mouseup', upFn);
	                  } else if ( event.type === 'touchstart' ){
	                    $document.on('touchmove', moveFn);
	                    $document.on('touchend', upFn);
	                  }
	                };
	
	                var moveFn = function( event ) {
	                  var pageX = event.pageX || (event.originalEvent ? event.originalEvent.pageX : 0);
	                  var changeValue = pageX - previousMouseX;
	                  if ( changeValue === 0 ){ return; }
	                  //Disable text selection in Chrome during column move
	                  document.onselectstart = function() { return false; };
	
	                  moveOccurred = true;
	
	                  if (!elmCloned) {
	                    cloneElement();
	                  }
	                  else if (elmCloned) {
	                    moveElement(changeValue);
	                    previousMouseX = pageX;
	                  }
	                };
	
	                var upFn = function( event ){
	                  //Re-enable text selection after column move
	                  document.onselectstart = null;
	
	                  //Remove the cloned element on mouse up.
	                  if (movingElm) {
	                    movingElm.remove();
	                    elmCloned = false;
	                  }
	
	                  offAllEvents();
	                  onDownEvents();
	
	                  if (!moveOccurred){
	                    return;
	                  }
	
	                  var columns = $scope.grid.columns;
	                  var columnIndex = 0;
	                  for (var i = 0; i < columns.length; i++) {
	                    if (columns[i].colDef.name !== $scope.col.colDef.name) {
	                      columnIndex++;
	                    }
	                    else {
	                      break;
	                    }
	                  }
	
	                  var targetIndex;
	
	                  //Case where column should be moved to a position on its left
	                  if (totalMouseMovement < 0) {
	                    var totalColumnsLeftWidth = 0;
	                    var il;
	                    if ( $scope.grid.isRTL() ){
	                      for (il = columnIndex + 1; il < columns.length; il++) {
	                        if (angular.isUndefined(columns[il].colDef.visible) || columns[il].colDef.visible === true) {
	                          totalColumnsLeftWidth += columns[il].drawnWidth || columns[il].width || columns[il].colDef.width;
	                          if (totalColumnsLeftWidth > Math.abs(totalMouseMovement)) {
	                            uiGridMoveColumnService.redrawColumnAtPosition
	                            ($scope.grid, columnIndex, il - 1);
	                            break;
	                          }
	                        }
	                      }
	                    }
	                    else {
	                      for (il = columnIndex - 1; il >= 0; il--) {
	                        if (angular.isUndefined(columns[il].colDef.visible) || columns[il].colDef.visible === true) {
	                          totalColumnsLeftWidth += columns[il].drawnWidth || columns[il].width || columns[il].colDef.width;
	                          if (totalColumnsLeftWidth > Math.abs(totalMouseMovement)) {
	                            uiGridMoveColumnService.redrawColumnAtPosition
	                            ($scope.grid, columnIndex, il + 1);
	                            break;
	                          }
	                        }
	                      }
	                    }
	
	                    //Case where column should be moved to beginning (or end in RTL) of the grid.
	                    if (totalColumnsLeftWidth < Math.abs(totalMouseMovement)) {
	                      targetIndex = 0;
	                      if ( $scope.grid.isRTL() ){
	                        targetIndex = columns.length - 1;
	                      }
	                      uiGridMoveColumnService.redrawColumnAtPosition
	                      ($scope.grid, columnIndex, targetIndex);
	                    }
	                  }
	
	                  //Case where column should be moved to a position on its right
	                  else if (totalMouseMovement > 0) {
	                    var totalColumnsRightWidth = 0;
	                    var ir;
	                    if ( $scope.grid.isRTL() ){
	                      for (ir = columnIndex - 1; ir > 0; ir--) {
	                        if (angular.isUndefined(columns[ir].colDef.visible) || columns[ir].colDef.visible === true) {
	                          totalColumnsRightWidth += columns[ir].drawnWidth || columns[ir].width || columns[ir].colDef.width;
	                          if (totalColumnsRightWidth > totalMouseMovement) {
	                            uiGridMoveColumnService.redrawColumnAtPosition
	                            ($scope.grid, columnIndex, ir);
	                            break;
	                          }
	                        }
	                      }
	                    }
	                    else {
	                      for (ir = columnIndex + 1; ir < columns.length; ir++) {
	                        if (angular.isUndefined(columns[ir].colDef.visible) || columns[ir].colDef.visible === true) {
	                          totalColumnsRightWidth += columns[ir].drawnWidth || columns[ir].width || columns[ir].colDef.width;
	                          if (totalColumnsRightWidth > totalMouseMovement) {
	                            uiGridMoveColumnService.redrawColumnAtPosition
	                            ($scope.grid, columnIndex, ir - 1);
	                            break;
	                          }
	                        }
	                      }
	                    }
	
	
	                    //Case where column should be moved to end (or beginning in RTL) of the grid.
	                    if (totalColumnsRightWidth < totalMouseMovement) {
	                      targetIndex = columns.length - 1;
	                      if ( $scope.grid.isRTL() ){
	                        targetIndex = 0;
	                      }
	                      uiGridMoveColumnService.redrawColumnAtPosition
	                      ($scope.grid, columnIndex, targetIndex);
	                    }
	                  }
	
	
	
	                };
	
	                var onDownEvents = function(){
	                  $contentsElm.on('touchstart', downFn);
	                  $contentsElm.on('mousedown', downFn);
	                };
	
	                var offAllEvents = function() {
	                  $contentsElm.off('touchstart', downFn);
	                  $contentsElm.off('mousedown', downFn);
	
	                  $document.off('mousemove', moveFn);
	                  $document.off('touchmove', moveFn);
	
	                  $document.off('mouseup', upFn);
	                  $document.off('touchend', upFn);
	                };
	
	                onDownEvents();
	
	
	                var cloneElement = function () {
	                  elmCloned = true;
	
	                  //Cloning header cell and appending to current header cell.
	                  movingElm = $elm.clone();
	                  $elm.parent().append(movingElm);
	
	                  //Left of cloned element should be aligned to original header cell.
	                  movingElm.addClass('movingColumn');
	                  var movingElementStyles = {};
	                  movingElementStyles.left = $elm[0].offsetLeft + 'px';
	                  var gridRight = $scope.grid.element[0].getBoundingClientRect().right;
	                  var elmRight = $elm[0].getBoundingClientRect().right;
	                  if (elmRight > gridRight) {
	                    reducedWidth = $scope.col.drawnWidth + (gridRight - elmRight);
	                    movingElementStyles.width = reducedWidth + 'px';
	                  }
	                  movingElm.css(movingElementStyles);
	                };
	
	                var moveElement = function (changeValue) {
	                  //Calculate total column width
	                  var columns = $scope.grid.columns;
	                  var totalColumnWidth = 0;
	                  for (var i = 0; i < columns.length; i++) {
	                    if (angular.isUndefined(columns[i].colDef.visible) || columns[i].colDef.visible === true) {
	                      totalColumnWidth += columns[i].drawnWidth || columns[i].width || columns[i].colDef.width;
	                    }
	                  }
	
	                  //Calculate new position of left of column
	                  var currentElmLeft = movingElm[0].getBoundingClientRect().left - 1;
	                  var currentElmRight = movingElm[0].getBoundingClientRect().right;
	                  var newElementLeft;
	
	                  newElementLeft = currentElmLeft - gridLeft + changeValue;
	                  newElementLeft = newElementLeft < rightMoveLimit ? newElementLeft : rightMoveLimit;
	
	                  //Update css of moving column to adjust to new left value or fire scroll in case column has reached edge of grid
	                  if ((currentElmLeft >= gridLeft || changeValue > 0) && (currentElmRight <= rightMoveLimit || changeValue < 0)) {
	                    movingElm.css({visibility: 'visible', 'left': (movingElm[0].offsetLeft +
	                    (newElementLeft < rightMoveLimit ? changeValue : (rightMoveLimit - currentElmLeft))) + 'px'});
	                  }
	                  else if (totalColumnWidth > Math.ceil(uiGridCtrl.grid.gridWidth)) {
	                    changeValue *= 8;
	                    var scrollEvent = new ScrollEvent($scope.col.grid, null, null, 'uiGridHeaderCell.moveElement');
	                    scrollEvent.x = {pixels: changeValue};
	                    scrollEvent.grid.scrollContainers('',scrollEvent);
	                  }
	
	                  //Calculate total width of columns on the left of the moving column and the mouse movement
	                  var totalColumnsLeftWidth = 0;
	                  for (var il = 0; il < columns.length; il++) {
	                    if (angular.isUndefined(columns[il].colDef.visible) || columns[il].colDef.visible === true) {
	                      if (columns[il].colDef.name !== $scope.col.colDef.name) {
	                        totalColumnsLeftWidth += columns[il].drawnWidth || columns[il].width || columns[il].colDef.width;
	                      }
	                      else {
	                        break;
	                      }
	                    }
	                  }
	                  if ($scope.newScrollLeft === undefined) {
	                    totalMouseMovement += changeValue;
	                  }
	                  else {
	                    totalMouseMovement = $scope.newScrollLeft + newElementLeft - totalColumnsLeftWidth;
	                  }
	
	                  //Increase width of moving column, in case the rightmost column was moved and its width was
	                  //decreased because of overflow
	                  if (reducedWidth < $scope.col.drawnWidth) {
	                    reducedWidth += Math.abs(changeValue);
	                    movingElm.css({'width': reducedWidth + 'px'});
	                  }
	                };
	
	                $scope.$on('$destroy', offAllEvents);
	              }
	            }
	          };
	        }
	      };
	    }]);
	})();
	
	(function() {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.pagination
	   *
	   * @description
	   *
	   * # ui.grid.pagination
	   *
	   * <div class="alert alert-warning" role="alert"><strong>Alpha</strong> This feature is in development. There will almost certainly be breaking api changes, or there are major outstanding bugs.</div>
	   *
	   * This module provides pagination support to ui-grid
	   */
	  var module = angular.module('ui.grid.pagination', ['ng', 'ui.grid']);
	
	  /**
	   * @ngdoc service
	   * @name ui.grid.pagination.service:uiGridPaginationService
	   *
	   * @description Service for the pagination feature
	   */
	  module.service('uiGridPaginationService', ['gridUtil',
	    function (gridUtil) {
	      var service = {
	        /**
	         * @ngdoc method
	         * @name initializeGrid
	         * @methodOf ui.grid.pagination.service:uiGridPaginationService
	         * @description Attaches the service to a certain grid
	         * @param {Grid} grid The grid we want to work with
	         */
	        initializeGrid: function (grid) {
	          service.defaultGridOptions(grid.options);
	
	          /**
	          * @ngdoc object
	          * @name ui.grid.pagination.api:PublicAPI
	          *
	          * @description Public API for the pagination feature
	          */
	          var publicApi = {
	            events: {
	              pagination: {
	              /**
	               * @ngdoc event
	               * @name paginationChanged
	               * @eventOf ui.grid.pagination.api:PublicAPI
	               * @description This event fires when the pageSize or currentPage changes
	               * @param {int} currentPage requested page number
	               * @param {int} pageSize requested page size
	               */
	                paginationChanged: function (currentPage, pageSize) { }
	              }
	            },
	            methods: {
	              pagination: {
	                /**
	                 * @ngdoc method
	                 * @name getPage
	                 * @methodOf ui.grid.pagination.api:PublicAPI
	                 * @description Returns the number of the current page
	                 */
	                getPage: function () {
	                  return grid.options.enablePagination ? grid.options.paginationCurrentPage : null;
	                },
	                /**
	                 * @ngdoc method
	                 * @name getFirstRowIndex
	                 * @methodOf ui.grid.pagination.api:PublicAPI
	                 * @description Returns the index of the first row of the current page.
	                 */
	                getFirstRowIndex: function () {
	                  if (grid.options.useCustomPagination) {
	                    return grid.options.paginationPageSizes.reduce(function(result, size, index) {
	                      return index < grid.options.paginationCurrentPage - 1 ? result + size : result;
	                    }, 0);
	                  }
	                  return ((grid.options.paginationCurrentPage - 1) * grid.options.paginationPageSize);
	                },
	                /**
	                 * @ngdoc method
	                 * @name getLastRowIndex
	                 * @methodOf ui.grid.pagination.api:PublicAPI
	                 * @description Returns the index of the last row of the current page.
	                 */
	                getLastRowIndex: function () {
	                  if (grid.options.useCustomPagination) {
	                    return publicApi.methods.pagination.getFirstRowIndex() + grid.options.paginationPageSizes[grid.options.paginationCurrentPage - 1] - 1;
	                  }
	                  return Math.min(grid.options.paginationCurrentPage * grid.options.paginationPageSize, grid.options.totalItems) - 1;
	                },
	                /**
	                 * @ngdoc method
	                 * @name getTotalPages
	                 * @methodOf ui.grid.pagination.api:PublicAPI
	                 * @description Returns the total number of pages
	                 */
	                getTotalPages: function () {
	                  if (!grid.options.enablePagination) {
	                    return null;
	                  }
	
	                  if (grid.options.useCustomPagination) {
	                    return grid.options.paginationPageSizes.length;
	                  }
	
	                  return (grid.options.totalItems === 0) ? 1 : Math.ceil(grid.options.totalItems / grid.options.paginationPageSize);
	                },
	                /**
	                 * @ngdoc method
	                 * @name nextPage
	                 * @methodOf ui.grid.pagination.api:PublicAPI
	                 * @description Moves to the next page, if possible
	                 */
	                nextPage: function () {
	                  if (!grid.options.enablePagination) {
	                    return;
	                  }
	
	                  if (grid.options.totalItems > 0) {
	                    grid.options.paginationCurrentPage = Math.min(
	                      grid.options.paginationCurrentPage + 1,
	                      publicApi.methods.pagination.getTotalPages()
	                    );
	                  } else {
	                    grid.options.paginationCurrentPage++;
	                  }
	                },
	                /**
	                 * @ngdoc method
	                 * @name previousPage
	                 * @methodOf ui.grid.pagination.api:PublicAPI
	                 * @description Moves to the previous page, if we're not on the first page
	                 */
	                previousPage: function () {
	                  if (!grid.options.enablePagination) {
	                    return;
	                  }
	
	                  grid.options.paginationCurrentPage = Math.max(grid.options.paginationCurrentPage - 1, 1);
	                },
	                /**
	                 * @ngdoc method
	                 * @name seek
	                 * @methodOf ui.grid.pagination.api:PublicAPI
	                 * @description Moves to the requested page
	                 * @param {int} page The number of the page that should be displayed
	                 */
	                seek: function (page) {
	                  if (!grid.options.enablePagination) {
	                    return;
	                  }
	                  if (!angular.isNumber(page) || page < 1) {
	                    throw 'Invalid page number: ' + page;
	                  }
	
	                  grid.options.paginationCurrentPage = Math.min(page, publicApi.methods.pagination.getTotalPages());
	                }
	              }
	            }
	          };
	
	          grid.api.registerEventsFromObject(publicApi.events);
	          grid.api.registerMethodsFromObject(publicApi.methods);
	
	          var processPagination = function( renderableRows ){
	            if (grid.options.useExternalPagination || !grid.options.enablePagination) {
	              return renderableRows;
	            }
	            //client side pagination
	            var pageSize = parseInt(grid.options.paginationPageSize, 10);
	            var currentPage = parseInt(grid.options.paginationCurrentPage, 10);
	
	            var visibleRows = renderableRows.filter(function (row) { return row.visible; });
	            grid.options.totalItems = visibleRows.length;
	
	            var firstRow = publicApi.methods.pagination.getFirstRowIndex();
	            var lastRow  = publicApi.methods.pagination.getLastRowIndex();
	
	            if (firstRow > visibleRows.length) {
	              currentPage = grid.options.paginationCurrentPage = 1;
	              firstRow = (currentPage - 1) * pageSize;
	            }
	            return visibleRows.slice(firstRow, lastRow + 1);
	          };
	
	          grid.registerRowsProcessor(processPagination, 900 );
	
	        },
	        defaultGridOptions: function (gridOptions) {
	          /**
	           * @ngdoc object
	           * @name ui.grid.pagination.api:GridOptions
	           *
	           * @description GridOptions for the pagination feature, these are available to be
	           * set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	           */
	
	          /**
	           * @ngdoc property
	           * @name enablePagination
	           * @propertyOf ui.grid.pagination.api:GridOptions
	           * @description Enables pagination.  Defaults to true.
	           */
	          gridOptions.enablePagination = gridOptions.enablePagination !== false;
	          /**
	           * @ngdoc property
	           * @name enablePaginationControls
	           * @propertyOf ui.grid.pagination.api:GridOptions
	           * @description Enables the paginator at the bottom of the grid. Turn this off if you want to implement your
	           *              own controls outside the grid.
	           */
	          gridOptions.enablePaginationControls = gridOptions.enablePaginationControls !== false;
	          /**
	           * @ngdoc property
	           * @name useExternalPagination
	           * @propertyOf ui.grid.pagination.api:GridOptions
	           * @description Disables client side pagination. When true, handle the paginationChanged event and set data
	           *              and totalItems.  Defaults to `false`
	           */
	          gridOptions.useExternalPagination = gridOptions.useExternalPagination === true;
	
	          /**
	           * @ngdoc property
	           * @name useCustomPagination
	           * @propertyOf ui.grid.pagination.api:GridOptions
	           * @description Disables client-side pagination. When true, handle the `paginationChanged` event and set `data`,
	           *              `firstRowIndex`, `lastRowIndex`, and `totalItems`.  Defaults to `false`.
	           */
	          gridOptions.useCustomPagination = gridOptions.useCustomPagination === true;
	
	          /**
	           * @ngdoc property
	           * @name totalItems
	           * @propertyOf ui.grid.pagination.api:GridOptions
	           * @description Total number of items, set automatically when using client side pagination, but needs set by user
	           *              for server side pagination
	           */
	          if (gridUtil.isNullOrUndefined(gridOptions.totalItems)) {
	            gridOptions.totalItems = 0;
	          }
	          /**
	           * @ngdoc property
	           * @name paginationPageSizes
	           * @propertyOf ui.grid.pagination.api:GridOptions
	           * @description Array of page sizes, defaults to `[250, 500, 1000]`
	           */
	          if (gridUtil.isNullOrUndefined(gridOptions.paginationPageSizes)) {
	            gridOptions.paginationPageSizes = [250, 500, 1000];
	          }
	          /**
	           * @ngdoc property
	           * @name paginationPageSize
	           * @propertyOf ui.grid.pagination.api:GridOptions
	           * @description Page size, defaults to the first item in paginationPageSizes, or 0 if paginationPageSizes is empty
	           */
	          if (gridUtil.isNullOrUndefined(gridOptions.paginationPageSize)) {
	            if (gridOptions.paginationPageSizes.length > 0) {
	              gridOptions.paginationPageSize = gridOptions.paginationPageSizes[0];
	            } else {
	              gridOptions.paginationPageSize = 0;
	            }
	          }
	          /**
	           * @ngdoc property
	           * @name paginationCurrentPage
	           * @propertyOf ui.grid.pagination.api:GridOptions
	           * @description Current page number, defaults to 1
	           */
	          if (gridUtil.isNullOrUndefined(gridOptions.paginationCurrentPage)) {
	            gridOptions.paginationCurrentPage = 1;
	          }
	
	          /**
	           * @ngdoc property
	           * @name paginationTemplate
	           * @propertyOf ui.grid.pagination.api:GridOptions
	           * @description A custom template for the pager, defaults to `ui-grid/pagination`
	           */
	          if (gridUtil.isNullOrUndefined(gridOptions.paginationTemplate)) {
	            gridOptions.paginationTemplate = 'ui-grid/pagination';
	          }
	        },
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.pagination.service:uiGridPaginationService
	         * @name uiGridPaginationService
	         * @description  Raises paginationChanged and calls refresh for client side pagination
	         * @param {Grid} grid the grid for which the pagination changed
	         * @param {int} currentPage requested page number
	         * @param {int} pageSize requested page size
	         */
	        onPaginationChanged: function (grid, currentPage, pageSize) {
	            grid.api.pagination.raise.paginationChanged(currentPage, pageSize);
	            if (!grid.options.useExternalPagination) {
	              grid.queueGridRefresh(); //client side pagination
	            }
	        }
	      };
	
	      return service;
	    }
	  ]);
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.pagination.directive:uiGridPagination
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Adds pagination features to grid
	   *  @example
	   <example module="app">
	   <file name="app.js">
	   var app = angular.module('app', ['ui.grid', 'ui.grid.pagination']);
	
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	      $scope.data = [
	        { name: 'Alex', car: 'Toyota' },
	        { name: 'Sam', car: 'Lexus' },
	        { name: 'Joe', car: 'Dodge' },
	        { name: 'Bob', car: 'Buick' },
	        { name: 'Cindy', car: 'Ford' },
	        { name: 'Brian', car: 'Audi' },
	        { name: 'Malcom', car: 'Mercedes Benz' },
	        { name: 'Dave', car: 'Ford' },
	        { name: 'Stacey', car: 'Audi' },
	        { name: 'Amy', car: 'Acura' },
	        { name: 'Scott', car: 'Toyota' },
	        { name: 'Ryan', car: 'BMW' },
	      ];
	
	      $scope.gridOptions = {
	        data: 'data',
	        paginationPageSizes: [5, 10, 25],
	        paginationPageSize: 5,
	        columnDefs: [
	          {name: 'name'},
	          {name: 'car'}
	        ]
	       }
	    }]);
	   </file>
	   <file name="index.html">
	   <div ng-controller="MainCtrl">
	   <div ui-grid="gridOptions" ui-grid-pagination></div>
	   </div>
	   </file>
	   </example>
	   */
	  module.directive('uiGridPagination', ['gridUtil', 'uiGridPaginationService',
	    function (gridUtil, uiGridPaginationService) {
	      return {
	        priority: -200,
	        scope: false,
	        require: 'uiGrid',
	        link: {
	          pre: function ($scope, $elm, $attr, uiGridCtrl) {
	            uiGridPaginationService.initializeGrid(uiGridCtrl.grid);
	
	            gridUtil.getTemplate(uiGridCtrl.grid.options.paginationTemplate)
	              .then(function (contents) {
	                var template = angular.element(contents);
	                $elm.append(template);
	                uiGridCtrl.innerCompile(template);
	              });
	          }
	        }
	      };
	    }
	  ]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.pagination.directive:uiGridPager
	   *  @element div
	   *
	   *  @description Panel for handling pagination
	   */
	  module.directive('uiGridPager', ['uiGridPaginationService', 'uiGridConstants', 'gridUtil', 'i18nService', 'i18nConstants',
	    function (uiGridPaginationService, uiGridConstants, gridUtil, i18nService, i18nConstants) {
	      return {
	        priority: -200,
	        scope: true,
	        require: '^uiGrid',
	        link: function ($scope, $elm, $attr, uiGridCtrl) {
	          var defaultFocusElementSelector = '.ui-grid-pager-control-input';
	          $scope.aria = i18nService.getSafeText('pagination.aria'); //Returns an object with all of the aria labels
	
	          var updateLabels = function(){
	            $scope.paginationApi = uiGridCtrl.grid.api.pagination;
	            $scope.sizesLabel = i18nService.getSafeText('pagination.sizes');
	            $scope.totalItemsLabel = i18nService.getSafeText('pagination.totalItems');
	            $scope.paginationOf = i18nService.getSafeText('pagination.of');
	            $scope.paginationThrough = i18nService.getSafeText('pagination.through');
	          };
	
	
	          updateLabels();
	
	          $scope.$on(i18nConstants.UPDATE_EVENT, updateLabels);
	
	          var options = uiGridCtrl.grid.options;
	
	          
	          uiGridCtrl.grid.renderContainers.body.registerViewportAdjuster(function (adjustment) {
	            if (options.enablePaginationControls) {
	              adjustment.height = adjustment.height - gridUtil.elementHeight($elm, "padding");
	            }
	            return adjustment;
	          });
	
	          var dataChangeDereg = uiGridCtrl.grid.registerDataChangeCallback(function (grid) {
	            if (!grid.options.useExternalPagination) {
	              grid.options.totalItems = grid.rows.length;
	            }
	          }, [uiGridConstants.dataChange.ROW]);
	
	          $scope.$on('$destroy', dataChangeDereg);
	
	          var deregP = $scope.$watch('grid.options.paginationCurrentPage + grid.options.paginationPageSize', function (newValues, oldValues) {
	              if (newValues === oldValues || oldValues === undefined) {
	                return;
	              }
	
	              if (!angular.isNumber(options.paginationCurrentPage) || options.paginationCurrentPage < 1) {
	                options.paginationCurrentPage = 1;
	                return;
	              }
	
	              if (options.totalItems > 0 && options.paginationCurrentPage > $scope.paginationApi.getTotalPages()) {
	                options.paginationCurrentPage = $scope.paginationApi.getTotalPages();
	                return;
	              }
	
	              uiGridPaginationService.onPaginationChanged($scope.grid, options.paginationCurrentPage, options.paginationPageSize);
	            }
	          );
	
	          $scope.$on('$destroy', function() {
	            deregP();
	          });
	
	          $scope.cantPageForward = function () {
	            if ($scope.paginationApi.getTotalPages()) {
	              return $scope.cantPageToLast();
	            } else {
	              return options.data.length < 1;
	            }
	          };
	
	          $scope.cantPageToLast = function () {
	            var totalPages = $scope.paginationApi.getTotalPages();
	            return !totalPages || options.paginationCurrentPage >= totalPages;
	          };
	
	          $scope.cantPageBackward = function () {
	            return options.paginationCurrentPage <= 1;
	          };
	
	          var focusToInputIf = function(condition){
	            if (condition){
	              gridUtil.focus.bySelector($elm, defaultFocusElementSelector);
	            }
	          };
	
	          //Takes care of setting focus to the middle element when focus is lost
	          $scope.pageFirstPageClick = function () {
	            $scope.paginationApi.seek(1);
	            focusToInputIf($scope.cantPageBackward());
	          };
	
	          $scope.pagePreviousPageClick = function () {
	            $scope.paginationApi.previousPage();
	            focusToInputIf($scope.cantPageBackward());
	          };
	
	          $scope.pageNextPageClick = function () {
	            $scope.paginationApi.nextPage();
	            focusToInputIf($scope.cantPageForward());
	          };
	
	          $scope.pageLastPageClick = function () {
	            $scope.paginationApi.seek($scope.paginationApi.getTotalPages());
	            focusToInputIf($scope.cantPageToLast());
	          };
	
	        }
	      };
	    }
	  ]);
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.pinning
	   * @description
	   *
	   * # ui.grid.pinning
	   *
	   * <div class="alert alert-success" role="alert"><strong>Stable</strong> This feature is stable. There should no longer be breaking api changes without a deprecation warning.</div>
	   *
	   * This module provides column pinning to the end user via menu options in the column header
	   *
	   * <div doc-module-components="ui.grid.pinning"></div>
	   */
	
	  var module = angular.module('ui.grid.pinning', ['ui.grid']);
	
	  module.constant('uiGridPinningConstants', {
	    container: {
	      LEFT: 'left',
	      RIGHT: 'right',
	      NONE: ''
	    }
	  });
	
	  module.service('uiGridPinningService', ['gridUtil', 'GridRenderContainer', 'i18nService', 'uiGridPinningConstants', function (gridUtil, GridRenderContainer, i18nService, uiGridPinningConstants) {
	    var service = {
	
	      initializeGrid: function (grid) {
	        service.defaultGridOptions(grid.options);
	
	        // Register a column builder to add new menu items for pinning left and right
	        grid.registerColumnBuilder(service.pinningColumnBuilder);
	
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.pinning.api:PublicApi
	         *
	         *  @description Public Api for pinning feature
	         */
	        var publicApi = {
	          events: {
	            pinning: {
	              /**
	               * @ngdoc event
	               * @name columnPin
	               * @eventOf ui.grid.pinning.api:PublicApi
	               * @description raised when column pin state has changed
	               * <pre>
	               *   gridApi.pinning.on.columnPinned(scope, function(colDef){})
	               * </pre>
	               * @param {object} colDef the column that was changed
	               * @param {string} container the render container the column is in ('left', 'right', '')
	               */
	              columnPinned: function(colDef, container) {
	              }
	            }
	          },
	          methods: {
	            pinning: {
	              /**
	               * @ngdoc function
	               * @name pinColumn
	               * @methodOf ui.grid.pinning.api:PublicApi
	               * @description pin column left, right, or none
	               * <pre>
	               *   gridApi.pinning.pinColumn(col, uiGridPinningConstants.container.LEFT)
	               * </pre>
	               * @param {gridColumn} col the column being pinned
	               * @param {string} container one of the recognised types
	               * from uiGridPinningConstants
	               */
	              pinColumn: function(col, container) {
	                service.pinColumn(grid, col, container);
	              }
	            }
	          }
	        };
	
	        grid.api.registerEventsFromObject(publicApi.events);
	        grid.api.registerMethodsFromObject(publicApi.methods);
	      },
	
	      defaultGridOptions: function (gridOptions) {
	        //default option to true unless it was explicitly set to false
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.pinning.api:GridOptions
	         *
	         *  @description GridOptions for pinning feature, these are available to be
	           *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	         */
	
	        /**
	         *  @ngdoc object
	         *  @name enablePinning
	         *  @propertyOf  ui.grid.pinning.api:GridOptions
	         *  @description Enable pinning for the entire grid.
	         *  <br/>Defaults to true
	         */
	        gridOptions.enablePinning = gridOptions.enablePinning !== false;
	        /**
	         *  @ngdoc object
	         *  @name hidePinLeft
	         *  @propertyOf  ui.grid.pinning.api:GridOptions
	         *  @description Hide Pin Left for the entire grid.
	         *  <br/>Defaults to false
	         */
	        gridOptions.hidePinLeft = gridOptions.enablePinning && gridOptions.hidePinLeft;
	        /**
	         *  @ngdoc object
	         *  @name hidePinRight
	         *  @propertyOf  ui.grid.pinning.api:GridOptions
	         *  @description Hide Pin Right pinning for the entire grid.
	         *  <br/>Defaults to false
	         */
	        gridOptions.hidePinRight = gridOptions.enablePinning && gridOptions.hidePinRight;
	      },
	
	      pinningColumnBuilder: function (colDef, col, gridOptions) {
	        //default to true unless gridOptions or colDef is explicitly false
	
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.pinning.api:ColumnDef
	         *
	         *  @description ColumnDef for pinning feature, these are available to be
	         *  set using the ui-grid {@link ui.grid.class:GridOptions.columnDef gridOptions.columnDefs}
	         */
	
	        /**
	         *  @ngdoc object
	         *  @name enablePinning
	         *  @propertyOf  ui.grid.pinning.api:ColumnDef
	         *  @description Enable pinning for the individual column.
	         *  <br/>Defaults to true
	         */
	        colDef.enablePinning = colDef.enablePinning === undefined ? gridOptions.enablePinning : colDef.enablePinning;
	        /**
	         *  @ngdoc object
	         *  @name hidePinLeft
	         *  @propertyOf  ui.grid.pinning.api:ColumnDef
	         *  @description Hide Pin Left for the individual column.
	         *  <br/>Defaults to false
	         */
	        colDef.hidePinLeft = colDef.hidePinLeft === undefined ? gridOptions.hidePinLeft : colDef.hidePinLeft;
	        /**
	         *  @ngdoc object
	         *  @name hidePinRight
	         *  @propertyOf  ui.grid.pinning.api:ColumnDef
	         *  @description Hide Pin Right for the individual column.
	         *  <br/>Defaults to false
	         */
	        colDef.hidePinRight = colDef.hidePinRight === undefined ? gridOptions.hidePinRight : colDef.hidePinRight;
	
	        /**
	         *  @ngdoc object
	         *  @name pinnedLeft
	         *  @propertyOf  ui.grid.pinning.api:ColumnDef
	         *  @description Column is pinned left when grid is rendered
	         *  <br/>Defaults to false
	         */
	
	        /**
	         *  @ngdoc object
	         *  @name pinnedRight
	         *  @propertyOf  ui.grid.pinning.api:ColumnDef
	         *  @description Column is pinned right when grid is rendered
	         *  <br/>Defaults to false
	         */
	        if (colDef.pinnedLeft) {
	          col.renderContainer = 'left';
	          col.grid.createLeftContainer();
	        }
	        else if (colDef.pinnedRight) {
	          col.renderContainer = 'right';
	          col.grid.createRightContainer();
	        }
	
	        if (!colDef.enablePinning) {
	          return;
	        }
	
	        var pinColumnLeftAction = {
	          name: 'ui.grid.pinning.pinLeft',
	          title: i18nService.get().pinning.pinLeft,
	          icon: 'ui-grid-icon-left-open',
	          shown: function () {
	            return typeof(this.context.col.renderContainer) === 'undefined' || !this.context.col.renderContainer || this.context.col.renderContainer !== 'left';
	          },
	          action: function () {
	            service.pinColumn(this.context.col.grid, this.context.col, uiGridPinningConstants.container.LEFT);
	          }
	        };
	
	        var pinColumnRightAction = {
	          name: 'ui.grid.pinning.pinRight',
	          title: i18nService.get().pinning.pinRight,
	          icon: 'ui-grid-icon-right-open',
	          shown: function () {
	            return typeof(this.context.col.renderContainer) === 'undefined' || !this.context.col.renderContainer || this.context.col.renderContainer !== 'right';
	          },
	          action: function () {
	            service.pinColumn(this.context.col.grid, this.context.col, uiGridPinningConstants.container.RIGHT);
	          }
	        };
	
	        var removePinAction = {
	          name: 'ui.grid.pinning.unpin',
	          title: i18nService.get().pinning.unpin,
	          icon: 'ui-grid-icon-cancel',
	          shown: function () {
	            return typeof(this.context.col.renderContainer) !== 'undefined' && this.context.col.renderContainer !== null && this.context.col.renderContainer !== 'body';
	          },
	          action: function () {
	            service.pinColumn(this.context.col.grid, this.context.col, uiGridPinningConstants.container.NONE);
	          }
	        };
	
	        //// Skip from menu if hidePinLeft or hidePinRight is true
	        if (!colDef.hidePinLeft && !gridUtil.arrayContainsObjectWithProperty(col.menuItems, 'name', 'ui.grid.pinning.pinLeft')) {
	          col.menuItems.push(pinColumnLeftAction);
	        }
	        if (!colDef.hidePinRight && !gridUtil.arrayContainsObjectWithProperty(col.menuItems, 'name', 'ui.grid.pinning.pinRight')) {
	          col.menuItems.push(pinColumnRightAction);
	        }
	        if (!gridUtil.arrayContainsObjectWithProperty(col.menuItems, 'name', 'ui.grid.pinning.unpin')) {
	          col.menuItems.push(removePinAction);
	        }
	      },
	
	      pinColumn: function(grid, col, container) {
	        if (container === uiGridPinningConstants.container.NONE) {
	          col.renderContainer = null;
	          col.colDef.pinnedLeft = col.colDef.pinnedRight = false;
	        }
	        else {
	          col.renderContainer = container;
	          if (container === uiGridPinningConstants.container.LEFT) {
	            grid.createLeftContainer();
	          }
	          else if (container === uiGridPinningConstants.container.RIGHT) {
	            grid.createRightContainer();
	          }
	        }
	
	        grid.refresh()
	        .then(function() {
	          grid.api.pinning.raise.columnPinned( col.colDef, container );
	        });
	      }
	    };
	
	    return service;
	  }]);
	
	  module.directive('uiGridPinning', ['gridUtil', 'uiGridPinningService',
	    function (gridUtil, uiGridPinningService) {
	      return {
	        require: 'uiGrid',
	        scope: false,
	        compile: function () {
	          return {
	            pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	              uiGridPinningService.initializeGrid(uiGridCtrl.grid);
	            },
	            post: function ($scope, $elm, $attrs, uiGridCtrl) {
	            }
	          };
	        }
	      };
	    }]);
	
	
	})();
	
	(function(){
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.resizeColumns
	   * @description
	   *
	   * # ui.grid.resizeColumns
	   *
	   * <div class="alert alert-success" role="alert"><strong>Stable</strong> This feature is stable. There should no longer be breaking api changes without a deprecation warning.</div>
	   *
	   * This module allows columns to be resized.
	   */
	  var module = angular.module('ui.grid.resizeColumns', ['ui.grid']);
	
	  module.service('uiGridResizeColumnsService', ['gridUtil', '$q', '$rootScope',
	    function (gridUtil, $q, $rootScope) {
	
	      var service = {
	        defaultGridOptions: function(gridOptions){
	          //default option to true unless it was explicitly set to false
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.resizeColumns.api:GridOptions
	           *
	           *  @description GridOptions for resizeColumns feature, these are available to be
	           *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	           */
	
	          /**
	           *  @ngdoc object
	           *  @name enableColumnResizing
	           *  @propertyOf  ui.grid.resizeColumns.api:GridOptions
	           *  @description Enable column resizing on the entire grid
	           *  <br/>Defaults to true
	           */
	          gridOptions.enableColumnResizing = gridOptions.enableColumnResizing !== false;
	
	          //legacy support
	          //use old name if it is explicitly false
	          if (gridOptions.enableColumnResize === false){
	            gridOptions.enableColumnResizing = false;
	          }
	        },
	
	        colResizerColumnBuilder: function (colDef, col, gridOptions) {
	
	          var promises = [];
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.resizeColumns.api:ColumnDef
	           *
	           *  @description ColumnDef for resizeColumns feature, these are available to be
	           *  set using the ui-grid {@link ui.grid.class:GridOptions.columnDef gridOptions.columnDefs}
	           */
	
	          /**
	           *  @ngdoc object
	           *  @name enableColumnResizing
	           *  @propertyOf  ui.grid.resizeColumns.api:ColumnDef
	           *  @description Enable column resizing on an individual column
	           *  <br/>Defaults to GridOptions.enableColumnResizing
	           */
	          //default to true unless gridOptions or colDef is explicitly false
	          colDef.enableColumnResizing = colDef.enableColumnResizing === undefined ? gridOptions.enableColumnResizing : colDef.enableColumnResizing;
	
	
	          //legacy support of old option name
	          if (colDef.enableColumnResize === false){
	            colDef.enableColumnResizing = false;
	          }
	
	          return $q.all(promises);
	        },
	
	        registerPublicApi: function (grid) {
	            /**
	             *  @ngdoc object
	             *  @name ui.grid.resizeColumns.api:PublicApi
	             *  @description Public Api for column resize feature.
	             */
	            var publicApi = {
	              events: {
	                /**
	                 * @ngdoc event
	                 * @name columnSizeChanged
	                 * @eventOf  ui.grid.resizeColumns.api:PublicApi
	                 * @description raised when column is resized
	                 * <pre>
	                 *      gridApi.colResizable.on.columnSizeChanged(scope,function(colDef, deltaChange){})
	                 * </pre>
	                 * @param {object} colDef the column that was resized
	                 * @param {integer} delta of the column size change
	                 */
	                colResizable: {
	                  columnSizeChanged: function (colDef, deltaChange) {
	                  }
	                }
	              }
	            };
	            grid.api.registerEventsFromObject(publicApi.events);
	        },
	
	        fireColumnSizeChanged: function (grid, colDef, deltaChange) {
	          $rootScope.$applyAsync(function () {
	            if ( grid.api.colResizable ){
	              grid.api.colResizable.raise.columnSizeChanged(colDef, deltaChange);
	            } else {
	              gridUtil.logError("The resizeable api is not registered, this may indicate that you've included the module but not added the 'ui-grid-resize-columns' directive to your grid definition.  Cannot raise any events.");
	            }
	          });
	        },
	
	        // get either this column, or the column next to this column, to resize,
	        // returns the column we're going to resize
	        findTargetCol: function(col, position, rtlMultiplier){
	          var renderContainer = col.getRenderContainer();
	
	          if (position === 'left') {
	            // Get the column to the left of this one
	            var colIndex = renderContainer.visibleColumnCache.indexOf(col);
	            return renderContainer.visibleColumnCache[colIndex - 1 * rtlMultiplier];
	          } else {
	            return col;
	          }
	        }
	
	      };
	
	      return service;
	
	    }]);
	
	
	  /**
	   * @ngdoc directive
	   * @name ui.grid.resizeColumns.directive:uiGridResizeColumns
	   * @element div
	   * @restrict A
	   * @description
	   * Enables resizing for all columns on the grid. If, for some reason, you want to use the ui-grid-resize-columns directive, but not allow column resizing, you can explicitly set the
	   * option to false. This prevents resizing for the entire grid, regardless of individual columnDef options.
	   *
	   * @example
	   <doc:example module="app">
	   <doc:source>
	   <script>
	   var app = angular.module('app', ['ui.grid', 'ui.grid.resizeColumns']);
	
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	          $scope.gridOpts = {
	            data: [
	              { "name": "Ethel Price", "gender": "female", "company": "Enersol" },
	              { "name": "Claudine Neal", "gender": "female", "company": "Sealoud" },
	              { "name": "Beryl Rice", "gender": "female", "company": "Velity" },
	              { "name": "Wilder Gonzales", "gender": "male", "company": "Geekko" }
	            ]
	          };
	        }]);
	   </script>
	
	   <div ng-controller="MainCtrl">
	   <div class="testGrid" ui-grid="gridOpts" ui-grid-resize-columns ></div>
	   </div>
	   </doc:source>
	   <doc:scenario>
	
	   </doc:scenario>
	   </doc:example>
	   */
	  module.directive('uiGridResizeColumns', ['gridUtil', 'uiGridResizeColumnsService', function (gridUtil, uiGridResizeColumnsService) {
	    return {
	      replace: true,
	      priority: 0,
	      require: '^uiGrid',
	      scope: false,
	      compile: function () {
	        return {
	          pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	            uiGridResizeColumnsService.defaultGridOptions(uiGridCtrl.grid.options);
	            uiGridCtrl.grid.registerColumnBuilder( uiGridResizeColumnsService.colResizerColumnBuilder);
	            uiGridResizeColumnsService.registerPublicApi(uiGridCtrl.grid);
	          },
	          post: function ($scope, $elm, $attrs, uiGridCtrl) {
	          }
	        };
	      }
	    };
	  }]);
	
	  // Extend the uiGridHeaderCell directive
	  module.directive('uiGridHeaderCell', ['gridUtil', '$templateCache', '$compile', '$q', 'uiGridResizeColumnsService', 'uiGridConstants', function (gridUtil, $templateCache, $compile, $q, uiGridResizeColumnsService, uiGridConstants) {
	    return {
	      // Run after the original uiGridHeaderCell
	      priority: -10,
	      require: '^uiGrid',
	      // scope: false,
	      compile: function() {
	        return {
	          post: function ($scope, $elm, $attrs, uiGridCtrl) {
	            var grid = uiGridCtrl.grid;
	
	            if (grid.options.enableColumnResizing) {
	              var columnResizerElm = $templateCache.get('ui-grid/columnResizer');
	
	              var rtlMultiplier = 1;
	              //when in RTL mode reverse the direction using the rtlMultiplier and change the position to left
	              if (grid.isRTL()) {
	                $scope.position = 'left';
	                rtlMultiplier = -1;
	              }
	
	              var displayResizers = function(){
	
	                // remove any existing resizers.
	                var resizers = $elm[0].getElementsByClassName('ui-grid-column-resizer');
	                for ( var i = 0; i < resizers.length; i++ ){
	                  angular.element(resizers[i]).remove();
	                }
	
	                // get the target column for the left resizer
	                var otherCol = uiGridResizeColumnsService.findTargetCol($scope.col, 'left', rtlMultiplier);
	                var renderContainer = $scope.col.getRenderContainer();
	
	                // Don't append the left resizer if this is the first column or the column to the left of this one has resizing disabled
	                if (otherCol && renderContainer.visibleColumnCache.indexOf($scope.col) !== 0 && otherCol.colDef.enableColumnResizing !== false) {
	                  var resizerLeft = angular.element(columnResizerElm).clone();
	                  resizerLeft.attr('position', 'left');
	
	                  $elm.prepend(resizerLeft);
	                  $compile(resizerLeft)($scope);
	                }
	
	                // Don't append the right resizer if this column has resizing disabled
	                if ($scope.col.colDef.enableColumnResizing !== false) {
	                  var resizerRight = angular.element(columnResizerElm).clone();
	                  resizerRight.attr('position', 'right');
	
	                  $elm.append(resizerRight);
	                  $compile(resizerRight)($scope);
	                }
	              };
	
	              displayResizers();
	
	              var waitDisplay = function() {
	                $scope.$applyAsync(displayResizers);
	              };
	
	              var dataChangeDereg = grid.registerDataChangeCallback( waitDisplay, [uiGridConstants.dataChange.COLUMN] );
	
	              $scope.$on( '$destroy', dataChangeDereg );
	            }
	          }
	        };
	      }
	    };
	  }]);
	
	
	
	  /**
	   * @ngdoc directive
	   * @name ui.grid.resizeColumns.directive:uiGridColumnResizer
	   * @element div
	   * @restrict A
	   *
	   * @description
	   * Draggable handle that controls column resizing.
	   *
	   * @example
	   <doc:example module="app">
	     <doc:source>
	       <script>
	        var app = angular.module('app', ['ui.grid', 'ui.grid.resizeColumns']);
	
	        app.controller('MainCtrl', ['$scope', function ($scope) {
	          $scope.gridOpts = {
	            enableColumnResizing: true,
	            data: [
	              { "name": "Ethel Price", "gender": "female", "company": "Enersol" },
	              { "name": "Claudine Neal", "gender": "female", "company": "Sealoud" },
	              { "name": "Beryl Rice", "gender": "female", "company": "Velity" },
	              { "name": "Wilder Gonzales", "gender": "male", "company": "Geekko" }
	            ]
	          };
	        }]);
	       </script>
	
	       <div ng-controller="MainCtrl">
	        <div class="testGrid" ui-grid="gridOpts"></div>
	       </div>
	     </doc:source>
	     <doc:scenario>
	      // TODO: e2e specs?
	
	      // TODO: post-resize a horizontal scroll event should be fired
	     </doc:scenario>
	   </doc:example>
	   */
	  module.directive('uiGridColumnResizer', ['$document', 'gridUtil', 'uiGridConstants', 'uiGridResizeColumnsService', function ($document, gridUtil, uiGridConstants, uiGridResizeColumnsService) {
	    var resizeOverlay = angular.element('<div class="ui-grid-resize-overlay"></div>');
	
	    var resizer = {
	      priority: 0,
	      scope: {
	        col: '=',
	        position: '@',
	        renderIndex: '='
	      },
	      require: '?^uiGrid',
	      link: function ($scope, $elm, $attrs, uiGridCtrl) {
	        var startX = 0,
	            x = 0,
	            gridLeft = 0,
	            rtlMultiplier = 1;
	
	        //when in RTL mode reverse the direction using the rtlMultiplier and change the position to left
	        if (uiGridCtrl.grid.isRTL()) {
	          $scope.position = 'left';
	          rtlMultiplier = -1;
	        }
	
	        if ($scope.position === 'left') {
	          $elm.addClass('left');
	        }
	        else if ($scope.position === 'right') {
	          $elm.addClass('right');
	        }
	
	        // Refresh the grid canvas
	        //   takes an argument representing the diff along the X-axis that the resize had
	        function refreshCanvas(xDiff) {
	          // Then refresh the grid canvas, rebuilding the styles so that the scrollbar updates its size
	          uiGridCtrl.grid.refreshCanvas(true).then( function() {
	            uiGridCtrl.grid.queueGridRefresh();
	          });
	        }
	
	        // Check that the requested width isn't wider than the maxWidth, or narrower than the minWidth
	        // Returns the new recommended with, after constraints applied
	        function constrainWidth(col, width){
	          var newWidth = width;
	
	          // If the new width would be less than the column's allowably minimum width, don't allow it
	          if (col.minWidth && newWidth < col.minWidth) {
	            newWidth = col.minWidth;
	          }
	          else if (col.maxWidth && newWidth > col.maxWidth) {
	            newWidth = col.maxWidth;
	          }
	
	          return newWidth;
	        }
	
	
	        /*
	         * Our approach to event handling aims to deal with both touch devices and mouse devices
	         * We register down handlers on both touch and mouse.  When a touchstart or mousedown event
	         * occurs, we register the corresponding touchmove/touchend, or mousemove/mouseend events.
	         *
	         * This way we can listen for both without worrying about the fact many touch devices also emulate
	         * mouse events - basically whichever one we hear first is what we'll go with.
	         */
	        function moveFunction(event, args) {
	          if (event.originalEvent) { event = event.originalEvent; }
	          event.preventDefault();
	
	          x = (event.targetTouches ? event.targetTouches[0] : event).clientX - gridLeft;
	
	          if (x < 0) { x = 0; }
	          else if (x > uiGridCtrl.grid.gridWidth) { x = uiGridCtrl.grid.gridWidth; }
	
	          var col = uiGridResizeColumnsService.findTargetCol($scope.col, $scope.position, rtlMultiplier);
	
	          // Don't resize if it's disabled on this column
	          if (col.colDef.enableColumnResizing === false) {
	            return;
	          }
	
	          if (!uiGridCtrl.grid.element.hasClass('column-resizing')) {
	            uiGridCtrl.grid.element.addClass('column-resizing');
	          }
	
	          // Get the diff along the X axis
	          var xDiff = x - startX;
	
	          // Get the width that this mouse would give the column
	          var newWidth = parseInt(col.drawnWidth + xDiff * rtlMultiplier, 10);
	
	          // check we're not outside the allowable bounds for this column
	          x = x + ( constrainWidth(col, newWidth) - newWidth ) * rtlMultiplier;
	
	          resizeOverlay.css({ left: x + 'px' });
	
	          uiGridCtrl.fireEvent(uiGridConstants.events.ITEM_DRAGGING);
	        }
	
	
	        function upFunction(event, args) {
	          if (event.originalEvent) { event = event.originalEvent; }
	          event.preventDefault();
	
	          uiGridCtrl.grid.element.removeClass('column-resizing');
	
	          resizeOverlay.remove();
	
	          // Resize the column
	          x = (event.changedTouches ? event.changedTouches[0] : event).clientX - gridLeft;
	          var xDiff = x - startX;
	
	          if (xDiff === 0) {
	            // no movement, so just reset event handlers, including turning back on both
	            // down events - we turned one off when this event started
	            offAllEvents();
	            onDownEvents();
	            return;
	          }
	
	          var col = uiGridResizeColumnsService.findTargetCol($scope.col, $scope.position, rtlMultiplier);
	
	          // Don't resize if it's disabled on this column
	          if (col.colDef.enableColumnResizing === false) {
	            return;
	          }
	
	          // Get the new width
	          var newWidth = parseInt(col.drawnWidth + xDiff * rtlMultiplier, 10);
	
	          // check we're not outside the allowable bounds for this column
	          col.width = constrainWidth(col, newWidth);
	          col.hasCustomWidth = true;
	
	          refreshCanvas(xDiff);
	
	          uiGridResizeColumnsService.fireColumnSizeChanged(uiGridCtrl.grid, col.colDef, xDiff);
	
	          // stop listening of up and move events - wait for next down
	          // reset the down events - we will have turned one off when this event started
	          offAllEvents();
	          onDownEvents();
	        }
	
	
	        var downFunction = function(event, args) {
	          if (event.originalEvent) { event = event.originalEvent; }
	          event.stopPropagation();
	
	          // Get the left offset of the grid
	          // gridLeft = uiGridCtrl.grid.element[0].offsetLeft;
	          gridLeft = uiGridCtrl.grid.element[0].getBoundingClientRect().left;
	
	          // Get the starting X position, which is the X coordinate of the click minus the grid's offset
	          startX = (event.targetTouches ? event.targetTouches[0] : event).clientX - gridLeft;
	
	          // Append the resizer overlay
	          uiGridCtrl.grid.element.append(resizeOverlay);
	
	          // Place the resizer overlay at the start position
	          resizeOverlay.css({ left: startX });
	
	          // Add handlers for move and up events - if we were mousedown then we listen for mousemove and mouseup, if
	          // we were touchdown then we listen for touchmove and touchup.  Also remove the handler for the equivalent
	          // down event - so if we're touchdown, then remove the mousedown handler until this event is over, if we're
	          // mousedown then remove the touchdown handler until this event is over, this avoids processing duplicate events
	          if ( event.type === 'touchstart' ){
	            $document.on('touchend', upFunction);
	            $document.on('touchmove', moveFunction);
	            $elm.off('mousedown', downFunction);
	          } else {
	            $document.on('mouseup', upFunction);
	            $document.on('mousemove', moveFunction);
	            $elm.off('touchstart', downFunction);
	          }
	        };
	
	        var onDownEvents = function() {
	          $elm.on('mousedown', downFunction);
	          $elm.on('touchstart', downFunction);
	        };
	
	        var offAllEvents = function() {
	          $document.off('mouseup', upFunction);
	          $document.off('touchend', upFunction);
	          $document.off('mousemove', moveFunction);
	          $document.off('touchmove', moveFunction);
	          $elm.off('mousedown', downFunction);
	          $elm.off('touchstart', downFunction);
	        };
	
	        onDownEvents();
	
	
	        // On doubleclick, resize to fit all rendered cells
	        var dblClickFn = function(event, args){
	          event.stopPropagation();
	
	          var col = uiGridResizeColumnsService.findTargetCol($scope.col, $scope.position, rtlMultiplier);
	
	          // Don't resize if it's disabled on this column
	          if (col.colDef.enableColumnResizing === false) {
	            return;
	          }
	
	          // Go through the rendered rows and find out the max size for the data in this column
	          var maxWidth = 0;
	          var xDiff = 0;
	
	          // Get the parent render container element
	          var renderContainerElm = gridUtil.closestElm($elm, '.ui-grid-render-container');
	
	          // Get the cell contents so we measure correctly. For the header cell we have to account for the sort icon and the menu buttons, if present
	          var cells = renderContainerElm.querySelectorAll('.' + uiGridConstants.COL_CLASS_PREFIX + col.uid + ' .ui-grid-cell-contents');
	          Array.prototype.forEach.call(cells, function (cell) {
	              // Get the cell width
	              // gridUtil.logDebug('width', gridUtil.elementWidth(cell));
	
	              // Account for the menu button if it exists
	              var menuButton;
	              if (angular.element(cell).parent().hasClass('ui-grid-header-cell')) {
	                menuButton = angular.element(cell).parent()[0].querySelectorAll('.ui-grid-column-menu-button');
	              }
	
	              gridUtil.fakeElement(cell, {}, function(newElm) {
	                // Make the element float since it's a div and can expand to fill its container
	                var e = angular.element(newElm);
	                e.attr('style', 'float: left');
	
	                var width = gridUtil.elementWidth(e);
	
	                if (menuButton) {
	                  var menuButtonWidth = gridUtil.elementWidth(menuButton);
	                  width = width + menuButtonWidth;
	                }
	
	                if (width > maxWidth) {
	                  maxWidth = width;
	                }
	              });
	            });
	
	          // check we're not outside the allowable bounds for this column
	          var newWidth = constrainWidth(col, maxWidth);
	          xDiff = newWidth - col.drawnWidth;
	          col.width = newWidth;
	          col.hasCustomWidth = true;
	
	          refreshCanvas(xDiff);
	
	          uiGridResizeColumnsService.fireColumnSizeChanged(uiGridCtrl.grid, col.colDef, xDiff);        };
	        $elm.on('dblclick', dblClickFn);
	
	        $elm.on('$destroy', function() {
	          $elm.off('dblclick', dblClickFn);
	          offAllEvents();
	        });
	      }
	    };
	
	    return resizer;
	  }]);
	
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.rowEdit
	   * @description
	   *
	   * # ui.grid.rowEdit
	   *
	   * <div class="alert alert-success" role="alert"><strong>Stable</strong> This feature is stable. There should no longer be breaking api changes without a deprecation warning.</div>
	   *
	   * This module extends the edit feature to provide tracking and saving of rows
	   * of data.  The tutorial provides more information on how this feature is best
	   * used {@link tutorial/205_row_editable here}.
	   * <br/>
	   * This feature depends on usage of the ui-grid-edit feature, and also benefits
	   * from use of ui-grid-cellNav to provide the full spreadsheet-like editing
	   * experience
	   *
	   */
	
	  var module = angular.module('ui.grid.rowEdit', ['ui.grid', 'ui.grid.edit', 'ui.grid.cellNav']);
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.rowEdit.constant:uiGridRowEditConstants
	   *
	   *  @description constants available in row edit module
	   */
	  module.constant('uiGridRowEditConstants', {
	  });
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.rowEdit.service:uiGridRowEditService
	   *
	   *  @description Services for row editing features
	   */
	  module.service('uiGridRowEditService', ['$interval', '$q', 'uiGridConstants', 'uiGridRowEditConstants', 'gridUtil',
	    function ($interval, $q, uiGridConstants, uiGridRowEditConstants, gridUtil) {
	
	      var service = {
	
	        initializeGrid: function (scope, grid) {
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.rowEdit.api:PublicApi
	           *
	           *  @description Public Api for rowEdit feature
	           */
	
	          grid.rowEdit = {};
	
	          var publicApi = {
	            events: {
	              rowEdit: {
	                /**
	                 * @ngdoc event
	                 * @eventOf ui.grid.rowEdit.api:PublicApi
	                 * @name saveRow
	                 * @description raised when a row is ready for saving.  Once your
	                 * row has saved you may need to use angular.extend to update the
	                 * data entity with any changed data from your save (for example,
	                 * lock version information if you're using optimistic locking,
	                 * or last update time/user information).
	                 *
	                 * Your method should call setSavePromise somewhere in the body before
	                 * returning control.  The feature will then wait, with the gridRow greyed out
	                 * whilst this promise is being resolved.
	                 *
	                 * <pre>
	                 *      gridApi.rowEdit.on.saveRow(scope,function(rowEntity){})
	                 * </pre>
	                 * and somewhere within the event handler:
	                 * <pre>
	                 *      gridApi.rowEdit.setSavePromise( rowEntity, savePromise)
	                 * </pre>
	                 * @param {object} rowEntity the options.data element that was edited
	                 * @returns {promise} Your saveRow method should return a promise, the
	                 * promise should either be resolved (implying successful save), or
	                 * rejected (implying an error).
	                 */
	                saveRow: function (rowEntity) {
	                }
	              }
	            },
	            methods: {
	              rowEdit: {
	                /**
	                 * @ngdoc method
	                 * @methodOf ui.grid.rowEdit.api:PublicApi
	                 * @name setSavePromise
	                 * @description Sets the promise associated with the row save, mandatory that
	                 * the saveRow event handler calls this method somewhere before returning.
	                 * <pre>
	                 *      gridApi.rowEdit.setSavePromise(rowEntity, savePromise)
	                 * </pre>
	                 * @param {object} rowEntity a data row from the grid for which a save has
	                 * been initiated
	                 * @param {promise} savePromise the promise that will be resolved when the
	                 * save is successful, or rejected if the save fails
	                 *
	                 */
	                setSavePromise: function ( rowEntity, savePromise) {
	                  service.setSavePromise(grid, rowEntity, savePromise);
	                },
	                /**
	                 * @ngdoc method
	                 * @methodOf ui.grid.rowEdit.api:PublicApi
	                 * @name getDirtyRows
	                 * @description Returns all currently dirty rows
	                 * <pre>
	                 *      gridApi.rowEdit.getDirtyRows(grid)
	                 * </pre>
	                 * @returns {array} An array of gridRows that are currently dirty
	                 *
	                 */
	                getDirtyRows: function () {
	                  return grid.rowEdit.dirtyRows ? grid.rowEdit.dirtyRows : [];
	                },
	                /**
	                 * @ngdoc method
	                 * @methodOf ui.grid.rowEdit.api:PublicApi
	                 * @name getErrorRows
	                 * @description Returns all currently errored rows
	                 * <pre>
	                 *      gridApi.rowEdit.getErrorRows(grid)
	                 * </pre>
	                 * @returns {array} An array of gridRows that are currently in error
	                 *
	                 */
	                getErrorRows: function () {
	                  return grid.rowEdit.errorRows ? grid.rowEdit.errorRows : [];
	                },
	                /**
	                 * @ngdoc method
	                 * @methodOf ui.grid.rowEdit.api:PublicApi
	                 * @name flushDirtyRows
	                 * @description Triggers a save event for all currently dirty rows, could
	                 * be used where user presses a save button or navigates away from the page
	                 * <pre>
	                 *      gridApi.rowEdit.flushDirtyRows(grid)
	                 * </pre>
	                 * @returns {promise} a promise that represents the aggregate of all
	                 * of the individual save promises - i.e. it will be resolved when all
	                 * the individual save promises have been resolved.
	                 *
	                 */
	                flushDirtyRows: function () {
	                  return service.flushDirtyRows(grid);
	                },
	
	                /**
	                 * @ngdoc method
	                 * @methodOf ui.grid.rowEdit.api:PublicApi
	                 * @name setRowsDirty
	                 * @description Sets each of the rows passed in dataRows
	                 * to be dirty.  note that if you have only just inserted the
	                 * rows into your data you will need to wait for a $digest cycle
	                 * before the gridRows are present - so often you would wrap this
	                 * call in a $interval or $timeout
	                 * <pre>
	                 *      $interval( function() {
	                 *        gridApi.rowEdit.setRowsDirty(myDataRows);
	                 *      }, 0, 1);
	                 * </pre>
	                 * @param {array} dataRows the data entities for which the gridRows
	                 * should be set dirty.
	                 *
	                 */
	                setRowsDirty: function ( dataRows) {
	                  service.setRowsDirty(grid, dataRows);
	                },
	
	                /**
	                 * @ngdoc method
	                 * @methodOf ui.grid.rowEdit.api:PublicApi
	                 * @name setRowsClean
	                 * @description Sets each of the rows passed in dataRows
	                 * to be clean, removing them from the dirty cache and the error cache,
	                 * and clearing the error flag and the dirty flag
	                 * <pre>
	                 *      var gridRows = $scope.gridApi.rowEdit.getDirtyRows();
	                 *      var dataRows = gridRows.map( function( gridRow ) { return gridRow.entity; });
	                 *      $scope.gridApi.rowEdit.setRowsClean( dataRows );
	                 * </pre>
	                 * @param {array} dataRows the data entities for which the gridRows
	                 * should be set clean.
	                 *
	                 */
	                setRowsClean: function ( dataRows) {
	                  service.setRowsClean(grid, dataRows);
	                }
	              }
	            }
	          };
	
	          grid.api.registerEventsFromObject(publicApi.events);
	          grid.api.registerMethodsFromObject(publicApi.methods);
	
	          grid.api.core.on.renderingComplete( scope, function ( gridApi ) {
	            grid.api.edit.on.afterCellEdit( scope, service.endEditCell );
	            grid.api.edit.on.beginCellEdit( scope, service.beginEditCell );
	            grid.api.edit.on.cancelCellEdit( scope, service.cancelEditCell );
	
	            if ( grid.api.cellNav ) {
	              grid.api.cellNav.on.navigate( scope, service.navigate );
	            }
	          });
	
	        },
	
	        defaultGridOptions: function (gridOptions) {
	
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.rowEdit.api:GridOptions
	           *
	           *  @description Options for configuring the rowEdit feature, these are available to be
	           *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	           */
	
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name saveRow
	         * @description  Returns a function that saves the specified row from the grid,
	         * and returns a promise
	         * @param {object} grid the grid for which dirty rows should be flushed
	         * @param {GridRow} gridRow the row that should be saved
	         * @returns {function} the saveRow function returns a function.  That function
	         * in turn, when called, returns a promise relating to the save callback
	         */
	        saveRow: function ( grid, gridRow ) {
	          var self = this;
	
	          return function() {
	            gridRow.isSaving = true;
	
	            if ( gridRow.rowEditSavePromise ){
	              // don't save the row again if it's already saving - that causes stale object exceptions
	              return gridRow.rowEditSavePromise;
	            }
	
	            var promise = grid.api.rowEdit.raise.saveRow( gridRow.entity );
	
	            if ( gridRow.rowEditSavePromise ){
	              gridRow.rowEditSavePromise.then( self.processSuccessPromise( grid, gridRow ), self.processErrorPromise( grid, gridRow ));
	            } else {
	              gridUtil.logError( 'A promise was not returned when saveRow event was raised, either nobody is listening to event, or event handler did not return a promise' );
	            }
	            return promise;
	          };
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf  ui.grid.rowEdit.service:uiGridRowEditService
	         * @name setSavePromise
	         * @description Sets the promise associated with the row save, mandatory that
	         * the saveRow event handler calls this method somewhere before returning.
	         * <pre>
	         *      gridApi.rowEdit.setSavePromise(grid, rowEntity)
	         * </pre>
	         * @param {object} grid the grid for which dirty rows should be returned
	         * @param {object} rowEntity a data row from the grid for which a save has
	         * been initiated
	         * @param {promise} savePromise the promise that will be resolved when the
	         * save is successful, or rejected if the save fails
	         *
	         */
	        setSavePromise: function (grid, rowEntity, savePromise) {
	          var gridRow = grid.getRow( rowEntity );
	          gridRow.rowEditSavePromise = savePromise;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name processSuccessPromise
	         * @description  Returns a function that processes the successful
	         * resolution of a save promise
	         * @param {object} grid the grid for which the promise should be processed
	         * @param {GridRow} gridRow the row that has been saved
	         * @returns {function} the success handling function
	         */
	        processSuccessPromise: function ( grid, gridRow ) {
	          var self = this;
	
	          return function() {
	            delete gridRow.isSaving;
	            delete gridRow.isDirty;
	            delete gridRow.isError;
	            delete gridRow.rowEditSaveTimer;
	            delete gridRow.rowEditSavePromise;
	            self.removeRow( grid.rowEdit.errorRows, gridRow );
	            self.removeRow( grid.rowEdit.dirtyRows, gridRow );
	          };
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name processErrorPromise
	         * @description  Returns a function that processes the failed
	         * resolution of a save promise
	         * @param {object} grid the grid for which the promise should be processed
	         * @param {GridRow} gridRow the row that is now in error
	         * @returns {function} the error handling function
	         */
	        processErrorPromise: function ( grid, gridRow ) {
	          return function() {
	            delete gridRow.isSaving;
	            delete gridRow.rowEditSaveTimer;
	            delete gridRow.rowEditSavePromise;
	
	            gridRow.isError = true;
	
	            if (!grid.rowEdit.errorRows){
	              grid.rowEdit.errorRows = [];
	            }
	            if (!service.isRowPresent( grid.rowEdit.errorRows, gridRow ) ){
	              grid.rowEdit.errorRows.push( gridRow );
	            }
	          };
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name removeRow
	         * @description  Removes a row from a cache of rows - either
	         * grid.rowEdit.errorRows or grid.rowEdit.dirtyRows.  If the row
	         * is not present silently does nothing.
	         * @param {array} rowArray the array from which to remove the row
	         * @param {GridRow} gridRow the row that should be removed
	         */
	        removeRow: function( rowArray, removeGridRow ){
	          if (typeof(rowArray) === 'undefined' || rowArray === null){
	            return;
	          }
	
	          rowArray.forEach( function( gridRow, index ){
	            if ( gridRow.uid === removeGridRow.uid ){
	              rowArray.splice( index, 1);
	            }
	          });
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name isRowPresent
	         * @description  Checks whether a row is already present
	         * in the given array
	         * @param {array} rowArray the array in which to look for the row
	         * @param {GridRow} gridRow the row that should be looked for
	         */
	        isRowPresent: function( rowArray, removeGridRow ){
	          var present = false;
	          rowArray.forEach( function( gridRow, index ){
	            if ( gridRow.uid === removeGridRow.uid ){
	              present = true;
	            }
	          });
	          return present;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name flushDirtyRows
	         * @description Triggers a save event for all currently dirty rows, could
	         * be used where user presses a save button or navigates away from the page
	         * <pre>
	         *      gridApi.rowEdit.flushDirtyRows(grid)
	         * </pre>
	         * @param {object} grid the grid for which dirty rows should be flushed
	         * @returns {promise} a promise that represents the aggregate of all
	         * of the individual save promises - i.e. it will be resolved when all
	         * the individual save promises have been resolved.
	         *
	         */
	        flushDirtyRows: function(grid){
	          var promises = [];
	          grid.api.rowEdit.getDirtyRows().forEach( function( gridRow ){
	            service.cancelTimer( grid, gridRow );
	            service.saveRow( grid, gridRow )();
	            promises.push( gridRow.rowEditSavePromise );
	          });
	
	          return $q.all( promises );
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name endEditCell
	         * @description Receives an afterCellEdit event from the edit function,
	         * and sets flags as appropriate.  Only the rowEntity parameter
	         * is processed, although other params are available.  Grid
	         * is automatically provided by the gridApi.
	         * @param {object} rowEntity the data entity for which the cell
	         * was edited
	         */
	        endEditCell: function( rowEntity, colDef, newValue, previousValue ){
	          var grid = this.grid;
	          var gridRow = grid.getRow( rowEntity );
	          if ( !gridRow ){ gridUtil.logError( 'Unable to find rowEntity in grid data, dirty flag cannot be set' ); return; }
	
	          if ( newValue !== previousValue || gridRow.isDirty ){
	            if ( !grid.rowEdit.dirtyRows ){
	              grid.rowEdit.dirtyRows = [];
	            }
	
	            if ( !gridRow.isDirty ){
	              gridRow.isDirty = true;
	              grid.rowEdit.dirtyRows.push( gridRow );
	            }
	
	            delete gridRow.isError;
	
	            service.considerSetTimer( grid, gridRow );
	          }
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name beginEditCell
	         * @description Receives a beginCellEdit event from the edit function,
	         * and cancels any rowEditSaveTimers if present, as the user is still editing
	         * this row.  Only the rowEntity parameter
	         * is processed, although other params are available.  Grid
	         * is automatically provided by the gridApi.
	         * @param {object} rowEntity the data entity for which the cell
	         * editing has commenced
	         */
	        beginEditCell: function( rowEntity, colDef ){
	          var grid = this.grid;
	          var gridRow = grid.getRow( rowEntity );
	          if ( !gridRow ){ gridUtil.logError( 'Unable to find rowEntity in grid data, timer cannot be cancelled' ); return; }
	
	          service.cancelTimer( grid, gridRow );
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name cancelEditCell
	         * @description Receives a cancelCellEdit event from the edit function,
	         * and if the row was already dirty, restarts the save timer.  If the row
	         * was not already dirty, then it's not dirty now either and does nothing.
	         *
	         * Only the rowEntity parameter
	         * is processed, although other params are available.  Grid
	         * is automatically provided by the gridApi.
	         *
	         * @param {object} rowEntity the data entity for which the cell
	         * editing was cancelled
	         */
	        cancelEditCell: function( rowEntity, colDef ){
	          var grid = this.grid;
	          var gridRow = grid.getRow( rowEntity );
	          if ( !gridRow ){ gridUtil.logError( 'Unable to find rowEntity in grid data, timer cannot be set' ); return; }
	
	          service.considerSetTimer( grid, gridRow );
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name navigate
	         * @description cellNav tells us that the selected cell has changed.  If
	         * the new row had a timer running, then stop it similar to in a beginCellEdit
	         * call.  If the old row is dirty and not the same as the new row, then
	         * start a timer on it.
	         * @param {object} newRowCol the row and column that were selected
	         * @param {object} oldRowCol the row and column that was left
	         *
	         */
	        navigate: function( newRowCol, oldRowCol ){
	          var grid = this.grid;
	          if ( newRowCol.row.rowEditSaveTimer ){
	            service.cancelTimer( grid, newRowCol.row );
	          }
	
	          if ( oldRowCol && oldRowCol.row && oldRowCol.row !== newRowCol.row ){
	            service.considerSetTimer( grid, oldRowCol.row );
	          }
	        },
	
	
	        /**
	         * @ngdoc property
	         * @propertyOf ui.grid.rowEdit.api:GridOptions
	         * @name rowEditWaitInterval
	         * @description How long the grid should wait for another change on this row
	         * before triggering a save (in milliseconds).  If set to -1, then saves are
	         * never triggered by timer (implying that the user will call flushDirtyRows()
	         * manually)
	         *
	         * @example
	         * Setting the wait interval to 4 seconds
	         * <pre>
	         *   $scope.gridOptions = { rowEditWaitInterval: 4000 }
	         * </pre>
	         *
	         */
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name considerSetTimer
	         * @description Consider setting a timer on this row (if it is dirty).  if there is a timer running
	         * on the row and the row isn't currently saving, cancel it, using cancelTimer, then if the row is
	         * dirty and not currently saving then set a new timer
	         * @param {object} grid the grid for which we are processing
	         * @param {GridRow} gridRow the row for which the timer should be adjusted
	         *
	         */
	        considerSetTimer: function( grid, gridRow ){
	          service.cancelTimer( grid, gridRow );
	
	          if ( gridRow.isDirty && !gridRow.isSaving ){
	            if ( grid.options.rowEditWaitInterval !== -1 ){
	              var waitTime = grid.options.rowEditWaitInterval ? grid.options.rowEditWaitInterval : 2000;
	              gridRow.rowEditSaveTimer = $interval( service.saveRow( grid, gridRow ), waitTime, 1);
	            }
	          }
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name cancelTimer
	         * @description cancel the $interval for any timer running on this row
	         * then delete the timer itself
	         * @param {object} grid the grid for which we are processing
	         * @param {GridRow} gridRow the row for which the timer should be adjusted
	         *
	         */
	        cancelTimer: function( grid, gridRow ){
	          if ( gridRow.rowEditSaveTimer && !gridRow.isSaving ){
	            $interval.cancel(gridRow.rowEditSaveTimer);
	            delete gridRow.rowEditSaveTimer;
	          }
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name setRowsDirty
	         * @description Sets each of the rows passed in dataRows
	         * to be dirty.  note that if you have only just inserted the
	         * rows into your data you will need to wait for a $digest cycle
	         * before the gridRows are present - so often you would wrap this
	         * call in a $interval or $timeout
	         * <pre>
	         *      $interval( function() {
	         *        gridApi.rowEdit.setRowsDirty( myDataRows);
	         *      }, 0, 1);
	         * </pre>
	         * @param {object} grid the grid for which rows should be set dirty
	         * @param {array} dataRows the data entities for which the gridRows
	         * should be set dirty.
	         *
	         */
	        setRowsDirty: function( grid, myDataRows ) {
	          var gridRow;
	          myDataRows.forEach( function( value, index ){
	            gridRow = grid.getRow( value );
	            if ( gridRow ){
	              if ( !grid.rowEdit.dirtyRows ){
	                grid.rowEdit.dirtyRows = [];
	              }
	
	              if ( !gridRow.isDirty ){
	                gridRow.isDirty = true;
	                grid.rowEdit.dirtyRows.push( gridRow );
	              }
	
	              delete gridRow.isError;
	
	              service.considerSetTimer( grid, gridRow );
	            } else {
	              gridUtil.logError( "requested row not found in rowEdit.setRowsDirty, row was: " + value );
	            }
	          });
	        },
	
	
	        /**
	         * @ngdoc method
	         * @methodOf ui.grid.rowEdit.service:uiGridRowEditService
	         * @name setRowsClean
	         * @description Sets each of the rows passed in dataRows
	         * to be clean, clearing the dirty flag and the error flag, and removing
	         * the rows from the dirty and error caches.
	         * @param {object} grid the grid for which rows should be set clean
	         * @param {array} dataRows the data entities for which the gridRows
	         * should be set clean.
	         *
	         */
	        setRowsClean: function( grid, myDataRows ) {
	          var gridRow;
	
	          myDataRows.forEach( function( value, index ){
	            gridRow = grid.getRow( value );
	            if ( gridRow ){
	              delete gridRow.isDirty;
	              service.removeRow( grid.rowEdit.dirtyRows, gridRow );
	              service.cancelTimer( grid, gridRow );
	
	              delete gridRow.isError;
	              service.removeRow( grid.rowEdit.errorRows, gridRow );
	            } else {
	              gridUtil.logError( "requested row not found in rowEdit.setRowsClean, row was: " + value );
	            }
	          });
	        }
	
	      };
	
	      return service;
	
	    }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.rowEdit.directive:uiGridEdit
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Adds row editing features to the ui-grid-edit directive.
	   *
	   */
	  module.directive('uiGridRowEdit', ['gridUtil', 'uiGridRowEditService', 'uiGridEditConstants',
	  function (gridUtil, uiGridRowEditService, uiGridEditConstants) {
	    return {
	      replace: true,
	      priority: 0,
	      require: '^uiGrid',
	      scope: false,
	      compile: function () {
	        return {
	          pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	            uiGridRowEditService.initializeGrid($scope, uiGridCtrl.grid);
	          },
	          post: function ($scope, $elm, $attrs, uiGridCtrl) {
	          }
	        };
	      }
	    };
	  }]);
	
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.rowEdit.directive:uiGridViewport
	   *  @element div
	   *
	   *  @description Stacks on top of ui.grid.uiGridViewport to alter the attributes used
	   *  for the grid row to allow coloring of saving and error rows
	   */
	  module.directive('uiGridViewport',
	    ['$compile', 'uiGridConstants', 'gridUtil', '$parse',
	      function ($compile, uiGridConstants, gridUtil, $parse) {
	        return {
	          priority: -200, // run after default  directive
	          scope: false,
	          compile: function ($elm, $attrs) {
	            var rowRepeatDiv = angular.element($elm.children().children()[0]);
	
	            var existingNgClass = rowRepeatDiv.attr("ng-class");
	            var newNgClass = '';
	            if ( existingNgClass ) {
	              newNgClass = existingNgClass.slice(0, -1) + ", 'ui-grid-row-dirty': row.isDirty, 'ui-grid-row-saving': row.isSaving, 'ui-grid-row-error': row.isError}";
	            } else {
	              newNgClass = "{'ui-grid-row-dirty': row.isDirty, 'ui-grid-row-saving': row.isSaving, 'ui-grid-row-error': row.isError}";
	            }
	            rowRepeatDiv.attr("ng-class", newNgClass);
	
	            return {
	              pre: function ($scope, $elm, $attrs, controllers) {
	
	              },
	              post: function ($scope, $elm, $attrs, controllers) {
	              }
	            };
	          }
	        };
	      }]);
	
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.saveState
	   * @description
	   *
	   * # ui.grid.saveState
	   *
	   * <div class="alert alert-success" role="alert"><strong>Stable</strong> This feature is stable. There should no longer be breaking api changes without a deprecation warning.</div>
	   *
	   * This module provides the ability to save the grid state, and restore
	   * it when the user returns to the page.
	   *
	   * No UI is provided, the caller should provide their own UI/buttons
	   * as appropriate. Usually the navigate events would be used to save
	   * the grid state and restore it.
	   *
	   * <br/>
	   * <br/>
	   *
	   * <div doc-module-components="ui.grid.save-state"></div>
	   */
	
	  var module = angular.module('ui.grid.saveState', ['ui.grid', 'ui.grid.selection', 'ui.grid.cellNav', 'ui.grid.grouping', 'ui.grid.pinning', 'ui.grid.treeView']);
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.saveState.constant:uiGridSaveStateConstants
	   *
	   *  @description constants available in save state module
	   */
	
	  module.constant('uiGridSaveStateConstants', {
	    featureName: 'saveState'
	  });
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.saveState.service:uiGridSaveStateService
	   *
	   *  @description Services for saveState feature
	   */
	  module.service('uiGridSaveStateService', ['$q', 'uiGridSaveStateConstants', 'gridUtil', '$compile', '$interval', 'uiGridConstants',
	    function ($q, uiGridSaveStateConstants, gridUtil, $compile, $interval, uiGridConstants ) {
	
	      var service = {
	
	        initializeGrid: function (grid) {
	
	          //add feature namespace and any properties to grid for needed state
	          grid.saveState = {};
	          this.defaultGridOptions(grid.options);
	
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.saveState.api:PublicApi
	           *
	           *  @description Public Api for saveState feature
	           */
	          var publicApi = {
	            events: {
	              saveState: {
	              }
	            },
	            methods: {
	              saveState: {
	                /**
	                 * @ngdoc function
	                 * @name save
	                 * @methodOf  ui.grid.saveState.api:PublicApi
	                 * @description Packages the current state of the grid into
	                 * an object, and provides it to the user for saving
	                 * @returns {object} the state as a javascript object that can be saved
	                 */
	                save: function () {
	                  return service.save(grid);
	                },
	                /**
	                 * @ngdoc function
	                 * @name restore
	                 * @methodOf  ui.grid.saveState.api:PublicApi
	                 * @description Restores the provided state into the grid
	                 * @param {scope} $scope a scope that we can broadcast on
	                 * @param {object} state the state that should be restored into the grid
	                 * @returns {object} the promise created by refresh
	                 */
	                restore: function ( $scope, state) {
	                  return service.restore(grid, $scope, state);
	                }
	              }
	            }
	          };
	
	          grid.api.registerEventsFromObject(publicApi.events);
	
	          grid.api.registerMethodsFromObject(publicApi.methods);
	
	        },
	
	        defaultGridOptions: function (gridOptions) {
	          //default option to true unless it was explicitly set to false
	          /**
	           * @ngdoc object
	           * @name ui.grid.saveState.api:GridOptions
	           *
	           * @description GridOptions for saveState feature, these are available to be
	           * set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	           */
	          /**
	           * @ngdoc object
	           * @name saveWidths
	           * @propertyOf  ui.grid.saveState.api:GridOptions
	           * @description Save the current column widths.  Note that unless
	           * you've provided the user with some way to resize their columns (say
	           * the resize columns feature), then this makes little sense.
	           * <br/>Defaults to true
	           */
	          gridOptions.saveWidths = gridOptions.saveWidths !== false;
	          /**
	           * @ngdoc object
	           * @name saveOrder
	           * @propertyOf  ui.grid.saveState.api:GridOptions
	           * @description Restore the current column order.  Note that unless
	           * you've provided the user with some way to reorder their columns (for
	           * example the move columns feature), this makes little sense.
	           * <br/>Defaults to true
	           */
	          gridOptions.saveOrder = gridOptions.saveOrder !== false;
	          /**
	           * @ngdoc object
	           * @name saveScroll
	           * @propertyOf  ui.grid.saveState.api:GridOptions
	           * @description Save the current scroll position.  Note that this
	           * is saved as the percentage of the grid scrolled - so if your
	           * user returns to a grid with a significantly different number of
	           * rows (perhaps some data has been deleted) then the scroll won't
	           * actually show the same rows as before.  If you want to scroll to
	           * a specific row then you should instead use the saveFocus option, which
	           * is the default.
	           *
	           * Note that this element will only be saved if the cellNav feature is
	           * enabled
	           * <br/>Defaults to false
	           */
	          gridOptions.saveScroll = gridOptions.saveScroll === true;
	          /**
	           * @ngdoc object
	           * @name saveFocus
	           * @propertyOf  ui.grid.saveState.api:GridOptions
	           * @description Save the current focused cell.  On returning
	           * to this focused cell we'll also scroll.  This option is
	           * preferred to the saveScroll option, so is set to true by
	           * default.  If saveScroll is set to true then this option will
	           * be disabled.
	           *
	           * By default this option saves the current row number and column
	           * number, and returns to that row and column.  However, if you define
	           * a saveRowIdentity function, then it will return you to the currently
	           * selected column within that row (in a business sense - so if some
	           * rows have been deleted, it will still find the same data, presuming it
	           * still exists in the list.  If it isn't in the list then it will instead
	           * return to the same row number - i.e. scroll percentage)
	           *
	           * Note that this option will do nothing if the cellNav
	           * feature is not enabled.
	           *
	           * <br/>Defaults to true (unless saveScroll is true)
	           */
	          gridOptions.saveFocus = gridOptions.saveScroll !== true && gridOptions.saveFocus !== false;
	          /**
	           * @ngdoc object
	           * @name saveRowIdentity
	           * @propertyOf  ui.grid.saveState.api:GridOptions
	           * @description A function that can be called, passing in a rowEntity,
	           * and that will return a unique id for that row.  This might simply
	           * return the `id` field from that row (if you have one), or it might
	           * concatenate some fields within the row to make a unique value.
	           *
	           * This value will be used to find the same row again and set the focus
	           * to it, if it exists when we return.
	           *
	           * <br/>Defaults to undefined
	           */
	          /**
	           * @ngdoc object
	           * @name saveVisible
	           * @propertyOf  ui.grid.saveState.api:GridOptions
	           * @description Save whether or not columns are visible.
	           *
	           * <br/>Defaults to true
	           */
	          gridOptions.saveVisible = gridOptions.saveVisible !== false;
	          /**
	           * @ngdoc object
	           * @name saveSort
	           * @propertyOf  ui.grid.saveState.api:GridOptions
	           * @description Save the current sort state for each column
	           *
	           * <br/>Defaults to true
	           */
	          gridOptions.saveSort = gridOptions.saveSort !== false;
	          /**
	           * @ngdoc object
	           * @name saveFilter
	           * @propertyOf  ui.grid.saveState.api:GridOptions
	           * @description Save the current filter state for each column
	           *
	           * <br/>Defaults to true
	           */
	          gridOptions.saveFilter = gridOptions.saveFilter !== false;
	          /**
	           * @ngdoc object
	           * @name saveSelection
	           * @propertyOf  ui.grid.saveState.api:GridOptions
	           * @description Save the currently selected rows.  If the `saveRowIdentity` callback
	           * is defined, then it will save the id of the row and select that.  If not, then
	           * it will attempt to select the rows by row number, which will give the wrong results
	           * if the data set has changed in the mean-time.
	           *
	           * Note that this option only does anything
	           * if the selection feature is enabled.
	           *
	           * <br/>Defaults to true
	           */
	          gridOptions.saveSelection = gridOptions.saveSelection !== false;
	          /**
	           * @ngdoc object
	           * @name saveGrouping
	           * @propertyOf  ui.grid.saveState.api:GridOptions
	           * @description Save the grouping configuration.  If set to true and the
	           * grouping feature is not enabled then does nothing.
	           *
	           * <br/>Defaults to true
	           */
	          gridOptions.saveGrouping = gridOptions.saveGrouping !== false;
	          /**
	           * @ngdoc object
	           * @name saveGroupingExpandedStates
	           * @propertyOf  ui.grid.saveState.api:GridOptions
	           * @description Save the grouping row expanded states.  If set to true and the
	           * grouping feature is not enabled then does nothing.
	           *
	           * This can be quite a bit of data, in many cases you wouldn't want to save this
	           * information.
	           *
	           * <br/>Defaults to false
	           */
	          gridOptions.saveGroupingExpandedStates = gridOptions.saveGroupingExpandedStates === true;
	          /**
	           * @ngdoc object
	           * @name savePinning
	           * @propertyOf ui.grid.saveState.api:GridOptions
	           * @description Save pinning state for columns.
	           *
	           * <br/>Defaults to true
	           */
	          gridOptions.savePinning = gridOptions.savePinning !== false;
	          /**
	           * @ngdoc object
	           * @name saveTreeView
	           * @propertyOf  ui.grid.saveState.api:GridOptions
	           * @description Save the treeView configuration.  If set to true and the
	           * treeView feature is not enabled then does nothing.
	           *
	           * <br/>Defaults to true
	           */
	          gridOptions.saveTreeView = gridOptions.saveTreeView !== false;
	        },
	
	
	
	        /**
	         * @ngdoc function
	         * @name save
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Saves the current grid state into an object, and
	         * passes that object back to the caller
	         * @param {Grid} grid the grid whose state we'd like to save
	         * @returns {object} the state ready to be saved
	         */
	        save: function (grid) {
	          var savedState = {};
	
	          savedState.columns = service.saveColumns( grid );
	          savedState.scrollFocus = service.saveScrollFocus( grid );
	          savedState.selection = service.saveSelection( grid );
	          savedState.grouping = service.saveGrouping( grid );
	          savedState.treeView = service.saveTreeView( grid );
	          savedState.pagination = service.savePagination( grid );
	
	          return savedState;
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name restore
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Applies the provided state to the grid
	         *
	         * @param {Grid} grid the grid whose state we'd like to restore
	         * @param {scope} $scope a scope that we can broadcast on
	         * @param {object} state the state we'd like to restore
	         * @returns {object} the promise created by refresh
	         */
	        restore: function( grid, $scope, state ){
	          if ( state.columns ) {
	            service.restoreColumns( grid, state.columns );
	          }
	
	          if ( state.scrollFocus ){
	            service.restoreScrollFocus( grid, $scope, state.scrollFocus );
	          }
	
	          if ( state.selection ){
	            service.restoreSelection( grid, state.selection );
	          }
	
	          if ( state.grouping ){
	            service.restoreGrouping( grid, state.grouping );
	          }
	
	          if ( state.treeView ){
	            service.restoreTreeView( grid, state.treeView );
	          }
	
	          if ( state.pagination ){
	            service.restorePagination( grid, state.pagination );
	          }
	
	          return grid.refresh();
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name saveColumns
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Saves the column setup, including sort, filters, ordering,
	         * pinning and column widths.
	         *
	         * Works through the current columns, storing them in order.  Stores the
	         * column name, then the visible flag, width, sort and filters for each column.
	         *
	         * @param {Grid} grid the grid whose state we'd like to save
	         * @returns {array} the columns state ready to be saved
	         */
	        saveColumns: function( grid ) {
	          var columns = [];
	          grid.getOnlyDataColumns().forEach( function( column ) {
	            var savedColumn = {};
	            savedColumn.name = column.name;
	
	            if ( grid.options.saveVisible ){
	              savedColumn.visible = column.visible;
	            }
	
	            if ( grid.options.saveWidths ){
	              savedColumn.width = column.width;
	            }
	
	            // these two must be copied, not just pointed too - otherwise our saved state is pointing to the same object as current state
	            if ( grid.options.saveSort ){
	              savedColumn.sort = angular.copy( column.sort );
	            }
	
	            if ( grid.options.saveFilter ){
	              savedColumn.filters = [];
	              column.filters.forEach( function( filter ){
	                var copiedFilter = {};
	                angular.forEach( filter, function( value, key) {
	                  if ( key !== 'condition' && key !== '$$hashKey' && key !== 'placeholder'){
	                    copiedFilter[key] = value;
	                  }
	                });
	                savedColumn.filters.push(copiedFilter);
	              });
	            }
	
	            if ( !!grid.api.pinning && grid.options.savePinning ){
	              savedColumn.pinned = column.renderContainer ? column.renderContainer : '';
	            }
	
	            columns.push( savedColumn );
	          });
	
	          return columns;
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name saveScrollFocus
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Saves the currently scroll or focus.
	         *
	         * If cellNav isn't present then does nothing - we can't return
	         * to the scroll position without cellNav anyway.
	         *
	         * If the cellNav module is present, and saveFocus is true, then
	         * it saves the currently focused cell.  If rowIdentity is present
	         * then saves using rowIdentity, otherwise saves visibleRowNum.
	         *
	         * If the cellNav module is not present, and saveScroll is true, then
	         * it approximates the current scroll row and column, and saves that.
	         *
	         * @param {Grid} grid the grid whose state we'd like to save
	         * @returns {object} the selection state ready to be saved
	         */
	        saveScrollFocus: function( grid ){
	          if ( !grid.api.cellNav ){
	            return {};
	          }
	
	          var scrollFocus = {};
	          if ( grid.options.saveFocus ){
	            scrollFocus.focus = true;
	            var rowCol = grid.api.cellNav.getFocusedCell();
	            if ( rowCol !== null ) {
	              if ( rowCol.col !== null ){
	                scrollFocus.colName = rowCol.col.colDef.name;
	              }
	              if ( rowCol.row !== null ){
	                scrollFocus.rowVal = service.getRowVal( grid, rowCol.row );
	              }
	            }
	          }
	
	          if ( grid.options.saveScroll || grid.options.saveFocus && !scrollFocus.colName && !scrollFocus.rowVal ) {
	            scrollFocus.focus = false;
	            if ( grid.renderContainers.body.prevRowScrollIndex ){
	              scrollFocus.rowVal = service.getRowVal( grid, grid.renderContainers.body.visibleRowCache[ grid.renderContainers.body.prevRowScrollIndex ]);
	            }
	
	            if ( grid.renderContainers.body.prevColScrollIndex ){
	              scrollFocus.colName = grid.renderContainers.body.visibleColumnCache[ grid.renderContainers.body.prevColScrollIndex ].name;
	            }
	          }
	
	          return scrollFocus;
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name saveSelection
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Saves the currently selected rows, if the selection feature is enabled
	         * @param {Grid} grid the grid whose state we'd like to save
	         * @returns {array} the selection state ready to be saved
	         */
	        saveSelection: function( grid ){
	          if ( !grid.api.selection || !grid.options.saveSelection ){
	            return [];
	          }
	
	          var selection = grid.api.selection.getSelectedGridRows().map( function( gridRow ) {
	            return service.getRowVal( grid, gridRow );
	          });
	
	          return selection;
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name saveGrouping
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Saves the grouping state, if the grouping feature is enabled
	         * @param {Grid} grid the grid whose state we'd like to save
	         * @returns {object} the grouping state ready to be saved
	         */
	        saveGrouping: function( grid ){
	          if ( !grid.api.grouping || !grid.options.saveGrouping ){
	            return {};
	          }
	
	          return grid.api.grouping.getGrouping( grid.options.saveGroupingExpandedStates );
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name savePagination
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Saves the pagination state, if the pagination feature is enabled
	         * @param {Grid} grid the grid whose state we'd like to save
	         * @returns {object} the pagination state ready to be saved
	         */
	        savePagination: function( grid ) {
	          if ( !grid.api.pagination || !grid.options.paginationPageSize ){
	            return {};
	          }
	
	          return {
	            paginationCurrentPage: grid.options.paginationCurrentPage,
	            paginationPageSize: grid.options.paginationPageSize
	          };
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name saveTreeView
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Saves the tree view state, if the tree feature is enabled
	         * @param {Grid} grid the grid whose state we'd like to save
	         * @returns {object} the tree view state ready to be saved
	         */
	        saveTreeView: function( grid ){
	          if ( !grid.api.treeView || !grid.options.saveTreeView ){
	            return {};
	          }
	
	          return grid.api.treeView.getTreeView();
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name getRowVal
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Helper function that gets either the rowNum or
	         * the saveRowIdentity, given a gridRow
	         * @param {Grid} grid the grid the row is in
	         * @param {GridRow} gridRow the row we want the rowNum for
	         * @returns {object} an object containing { identity: true/false, row: rowNumber/rowIdentity }
	         *
	         */
	        getRowVal: function( grid, gridRow ){
	          if ( !gridRow ) {
	            return null;
	          }
	
	          var rowVal = {};
	          if ( grid.options.saveRowIdentity ){
	            rowVal.identity = true;
	            rowVal.row = grid.options.saveRowIdentity( gridRow.entity );
	          } else {
	            rowVal.identity = false;
	            rowVal.row = grid.renderContainers.body.visibleRowCache.indexOf( gridRow );
	          }
	          return rowVal;
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name restoreColumns
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Restores the columns, including order, visible, width,
	         * pinning, sort and filters.
	         *
	         * @param {Grid} grid the grid whose state we'd like to restore
	         * @param {object} columnsState the list of columns we had before, with their state
	         */
	        restoreColumns: function( grid, columnsState ){
	          var isSortChanged = false;
	
	          columnsState.forEach( function( columnState, index ) {
	            var currentCol = grid.getColumn( columnState.name );
	
	            if ( currentCol && !grid.isRowHeaderColumn(currentCol) ){
	              if ( grid.options.saveVisible &&
	                   ( currentCol.visible !== columnState.visible ||
	                     currentCol.colDef.visible !== columnState.visible ) ){
	                currentCol.visible = columnState.visible;
	                currentCol.colDef.visible = columnState.visible;
	                grid.api.core.raise.columnVisibilityChanged(currentCol);
	              }
	
	              if ( grid.options.saveWidths && currentCol.width !== columnState.width){
	                currentCol.width = columnState.width;
	                currentCol.hasCustomWidth = true;
	              }
	
	              if ( grid.options.saveSort &&
	                   !angular.equals(currentCol.sort, columnState.sort) &&
	                   !( currentCol.sort === undefined && angular.isEmpty(columnState.sort) ) ){
	                currentCol.sort = angular.copy( columnState.sort );
	                isSortChanged = true;
	              }
	
	              if ( grid.options.saveFilter &&
	                   !angular.equals(currentCol.filters, columnState.filters ) ){
	                columnState.filters.forEach( function( filter, index ){
	                  angular.extend( currentCol.filters[index], filter );
	                  if ( typeof(filter.term) === 'undefined' || filter.term === null ){
	                    delete currentCol.filters[index].term;
	                  }
	                });
	                grid.api.core.raise.filterChanged();
	              }
	
	              if ( !!grid.api.pinning && grid.options.savePinning && currentCol.renderContainer !== columnState.pinned ){
	                grid.api.pinning.pinColumn(currentCol, columnState.pinned);
	              }
	
	              var currentIndex = grid.getOnlyDataColumns().indexOf( currentCol );
	              if (currentIndex !== -1) {
	                if (grid.options.saveOrder && currentIndex !== index) {
	                  var column = grid.columns.splice(currentIndex + grid.rowHeaderColumns.length, 1)[0];
	                  grid.columns.splice(index + grid.rowHeaderColumns.length, 0, column);
	                }
	              }
	            }
	          });
	
	          if ( isSortChanged ) {
	            grid.api.core.raise.sortChanged( grid, grid.getColumnSorting() );
	          }
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name restoreScrollFocus
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Scrolls to the position that was saved.  If focus is true, then
	         * sets focus to the specified row/col.  If focus is false, then scrolls to the
	         * specified row/col.
	         *
	         * @param {Grid} grid the grid whose state we'd like to restore
	         * @param {scope} $scope a scope that we can broadcast on
	         * @param {object} scrollFocusState the scroll/focus state ready to be restored
	         */
	        restoreScrollFocus: function( grid, $scope, scrollFocusState ){
	          if ( !grid.api.cellNav ){
	            return;
	          }
	
	          var colDef, row;
	          if ( scrollFocusState.colName ){
	            var colDefs = grid.options.columnDefs.filter( function( colDef ) { return colDef.name === scrollFocusState.colName; });
	            if ( colDefs.length > 0 ){
	              colDef = colDefs[0];
	            }
	          }
	
	          if ( scrollFocusState.rowVal && scrollFocusState.rowVal.row ){
	            if ( scrollFocusState.rowVal.identity ){
	              row = service.findRowByIdentity( grid, scrollFocusState.rowVal );
	            } else {
	              row = grid.renderContainers.body.visibleRowCache[ scrollFocusState.rowVal.row ];
	            }
	          }
	
	          var entity = row && row.entity ? row.entity : null ;
	
	          if ( colDef || entity ) {
	            if (scrollFocusState.focus ){
	              grid.api.cellNav.scrollToFocus( entity, colDef );
	            } else {
	              grid.scrollTo( entity, colDef );
	            }
	          }
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name restoreSelection
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Selects the rows that are provided in the selection
	         * state.  If you are using `saveRowIdentity` and more than one row matches the identity
	         * function then only the first is selected.
	         * @param {Grid} grid the grid whose state we'd like to restore
	         * @param {object} selectionState the selection state ready to be restored
	         */
	        restoreSelection: function( grid, selectionState ){
	          if ( !grid.api.selection ){
	            return;
	          }
	
	          grid.api.selection.clearSelectedRows();
	
	          selectionState.forEach(  function( rowVal ) {
	            if ( rowVal.identity ){
	              var foundRow = service.findRowByIdentity( grid, rowVal );
	
	              if ( foundRow ){
	                grid.api.selection.selectRow( foundRow.entity );
	              }
	
	            } else {
	              grid.api.selection.selectRowByVisibleIndex( rowVal.row );
	            }
	          });
	        },
	
	
	        /**
	         * @ngdoc function
	         * @name restoreGrouping
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Restores the grouping configuration, if the grouping feature
	         * is enabled.
	         * @param {Grid} grid the grid whose state we'd like to restore
	         * @param {object} groupingState the grouping state ready to be restored
	         */
	        restoreGrouping: function( grid, groupingState ){
	          if ( !grid.api.grouping || typeof(groupingState) === 'undefined' || groupingState === null || angular.equals(groupingState, {}) ){
	            return;
	          }
	
	          grid.api.grouping.setGrouping( groupingState );
	        },
	
	        /**
	         * @ngdoc function
	         * @name restoreTreeView
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Restores the tree view configuration, if the tree view feature
	         * is enabled.
	         * @param {Grid} grid the grid whose state we'd like to restore
	         * @param {object} treeViewState the tree view state ready to be restored
	         */
	        restoreTreeView: function( grid, treeViewState ){
	          if ( !grid.api.treeView || typeof(treeViewState) === 'undefined' || treeViewState === null || angular.equals(treeViewState, {}) ){
	            return;
	          }
	
	          grid.api.treeView.setTreeView( treeViewState );
	        },
	
	        /**
	         * @ngdoc function
	         * @name restorePagination
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Restores the pagination information, if pagination is enabled.
	         * @param {Grid} grid the grid whose state we'd like to restore
	         * @param {object} pagination the pagination object to be restored
	         * @param {number} pagination.paginationCurrentPage the page number to restore
	         * @param {number} pagination.paginationPageSize the number of items displayed per page
	         */
	        restorePagination: function( grid, pagination ){
	          if ( !grid.api.pagination || !grid.options.paginationPageSize ){
	            return;
	          }
	
	          grid.options.paginationCurrentPage = pagination.paginationCurrentPage;
	          grid.options.paginationPageSize = pagination.paginationPageSize;
	        },
	
	        /**
	         * @ngdoc function
	         * @name findRowByIdentity
	         * @methodOf  ui.grid.saveState.service:uiGridSaveStateService
	         * @description Finds a row given it's identity value, returns the first found row
	         * if any are found, otherwise returns null if no rows are found.
	         * @param {Grid} grid the grid whose state we'd like to restore
	         * @param {object} rowVal the row we'd like to find
	         * @returns {gridRow} the found row, or null if none found
	         */
	        findRowByIdentity: function( grid, rowVal ){
	          if ( !grid.options.saveRowIdentity ){
	            return null;
	          }
	
	          var filteredRows = grid.rows.filter( function( gridRow ) {
	            if ( grid.options.saveRowIdentity( gridRow.entity ) === rowVal.row ){
	              return true;
	            } else {
	              return false;
	            }
	          });
	
	          if ( filteredRows.length > 0 ){
	            return filteredRows[0];
	          } else {
	            return null;
	          }
	        }
	      };
	
	      return service;
	
	    }
	  ]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.saveState.directive:uiGridSaveState
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Adds saveState features to grid
	   *
	   *  @example
	   <example module="app">
	   <file name="app.js">
	   var app = angular.module('app', ['ui.grid', 'ui.grid.saveState']);
	
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	      $scope.data = [
	        { name: 'Bob', title: 'CEO' },
	        { name: 'Frank', title: 'Lowly Developer' }
	      ];
	
	      $scope.gridOptions = {
	        columnDefs: [
	          {name: 'name'},
	          {name: 'title', enableCellEdit: true}
	        ],
	        data: $scope.data
	      };
	    }]);
	   </file>
	   <file name="index.html">
	   <div ng-controller="MainCtrl">
	   <div ui-grid="gridOptions" ui-grid-save-state></div>
	   </div>
	   </file>
	   </example>
	   */
	  module.directive('uiGridSaveState', ['uiGridSaveStateConstants', 'uiGridSaveStateService', 'gridUtil', '$compile',
	    function (uiGridSaveStateConstants, uiGridSaveStateService, gridUtil, $compile) {
	      return {
	        replace: true,
	        priority: 0,
	        require: '^uiGrid',
	        scope: false,
	        link: function ($scope, $elm, $attrs, uiGridCtrl) {
	          uiGridSaveStateService.initializeGrid(uiGridCtrl.grid);
	        }
	      };
	    }
	  ]);
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.selection
	   * @description
	   *
	   * # ui.grid.selection
	   * This module provides row selection
	   *
	   * <div class="alert alert-success" role="alert"><strong>Stable</strong> This feature is stable. There should no longer be breaking api changes without a deprecation warning.</div>
	   *
	   * <div doc-module-components="ui.grid.selection"></div>
	   */
	
	  var module = angular.module('ui.grid.selection', ['ui.grid']);
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.selection.constant:uiGridSelectionConstants
	   *
	   *  @description constants available in selection module
	   */
	  module.constant('uiGridSelectionConstants', {
	    featureName: "selection",
	    selectionRowHeaderColName: 'selectionRowHeaderCol'
	  });
	
	  //add methods to GridRow
	  angular.module('ui.grid').config(['$provide', function ($provide) {
	    $provide.decorator('GridRow', ['$delegate', function ($delegate) {
	
	      /**
	       *  @ngdoc object
	       *  @name ui.grid.selection.api:GridRow
	       *
	       *  @description GridRow prototype functions added for selection
	       */
	
	      /**
	       *  @ngdoc object
	       *  @name enableSelection
	       *  @propertyOf  ui.grid.selection.api:GridRow
	       *  @description Enable row selection for this row, only settable by internal code.
	       *
	       *  The grouping feature, for example, might set group header rows to not be selectable.
	       *  <br/>Defaults to true
	       */
	
	      /**
	       *  @ngdoc object
	       *  @name isSelected
	       *  @propertyOf  ui.grid.selection.api:GridRow
	       *  @description Selected state of row.  Should be readonly. Make any changes to selected state using setSelected().
	       *  <br/>Defaults to false
	       */
	
	
	      /**
	       * @ngdoc function
	       * @name setSelected
	       * @methodOf ui.grid.selection.api:GridRow
	       * @description Sets the isSelected property and updates the selectedCount
	       * Changes to isSelected state should only be made via this function
	       * @param {bool} selected value to set
	       */
	      $delegate.prototype.setSelected = function (selected) {
	        if (selected !== this.isSelected) {
	          this.isSelected = selected;
	          this.grid.selection.selectedCount += selected ? 1 : -1;
	        }
	      };
	
	      return $delegate;
	    }]);
	  }]);
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.selection.service:uiGridSelectionService
	   *
	   *  @description Services for selection features
	   */
	  module.service('uiGridSelectionService', ['$q', '$templateCache', 'uiGridSelectionConstants', 'gridUtil',
	    function ($q, $templateCache, uiGridSelectionConstants, gridUtil) {
	
	      var service = {
	
	        initializeGrid: function (grid) {
	
	          //add feature namespace and any properties to grid for needed
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.selection.grid:selection
	           *
	           *  @description Grid properties and functions added for selection
	           */
	          grid.selection = {};
	          grid.selection.lastSelectedRow = null;
	          grid.selection.selectAll = false;
	
	
	          /**
	           *  @ngdoc object
	           *  @name selectedCount
	           *  @propertyOf  ui.grid.selection.grid:selection
	           *  @description Current count of selected rows
	           *  @example
	           *  var count = grid.selection.selectedCount
	           */
	          grid.selection.selectedCount = 0;
	
	          service.defaultGridOptions(grid.options);
	
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.selection.api:PublicApi
	           *
	           *  @description Public Api for selection feature
	           */
	          var publicApi = {
	            events: {
	              selection: {
	                /**
	                 * @ngdoc event
	                 * @name rowSelectionChanged
	                 * @eventOf  ui.grid.selection.api:PublicApi
	                 * @description  is raised after the row.isSelected state is changed
	                 * @param {object} scope the scope associated with the grid
	                 * @param {GridRow} row the row that was selected/deselected
	                 * @param {Event} evt object if raised from an event
	                 */
	                rowSelectionChanged: function (scope, row, evt) {
	                },
	                /**
	                 * @ngdoc event
	                 * @name rowSelectionChangedBatch
	                 * @eventOf  ui.grid.selection.api:PublicApi
	                 * @description  is raised after the row.isSelected state is changed
	                 * in bulk, if the `enableSelectionBatchEvent` option is set to true
	                 * (which it is by default).  This allows more efficient processing
	                 * of bulk events.
	                 * @param {object} scope the scope associated with the grid
	                 * @param {array} rows the rows that were selected/deselected
	                 * @param {Event} evt object if raised from an event
	                 */
	                rowSelectionChangedBatch: function (scope, rows, evt) {
	                }
	              }
	            },
	            methods: {
	              selection: {
	                /**
	                 * @ngdoc function
	                 * @name toggleRowSelection
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description Toggles data row as selected or unselected
	                 * @param {object} rowEntity gridOptions.data[] array instance
	                 * @param {Event} evt object if raised from an event
	                 */
	                toggleRowSelection: function (rowEntity, evt) {
	                  var row = grid.getRow(rowEntity);
	                  if (row !== null) {
	                    service.toggleRowSelection(grid, row, evt, grid.options.multiSelect, grid.options.noUnselect);
	                  }
	                },
	                /**
	                 * @ngdoc function
	                 * @name selectRow
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description Select the data row
	                 * @param {object} rowEntity gridOptions.data[] array instance
	                 * @param {Event} evt object if raised from an event
	                 */
	                selectRow: function (rowEntity, evt) {
	                  var row = grid.getRow(rowEntity);
	                  if (row !== null && !row.isSelected) {
	                    service.toggleRowSelection(grid, row, evt, grid.options.multiSelect, grid.options.noUnselect);
	                  }
	                },
	                /**
	                 * @ngdoc function
	                 * @name selectRowByVisibleIndex
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description Select the specified row by visible index (i.e. if you
	                 * specify row 0 you'll get the first visible row selected).  In this context
	                 * visible means of those rows that are theoretically visible (i.e. not filtered),
	                 * rather than rows currently rendered on the screen.
	                 * @param {number} rowNum index within the rowsVisible array
	                 * @param {Event} evt object if raised from an event
	                 */
	                selectRowByVisibleIndex: function (rowNum, evt) {
	                  var row = grid.renderContainers.body.visibleRowCache[rowNum];
	                  if (row !== null && typeof (row) !== 'undefined' && !row.isSelected) {
	                    service.toggleRowSelection(grid, row, evt, grid.options.multiSelect, grid.options.noUnselect);
	                  }
	                },
	                /**
	                 * @ngdoc function
	                 * @name unSelectRow
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description UnSelect the data row
	                 * @param {object} rowEntity gridOptions.data[] array instance
	                 * @param {Event} evt object if raised from an event
	                 */
	                unSelectRow: function (rowEntity, evt) {
	                  var row = grid.getRow(rowEntity);
	                  if (row !== null && row.isSelected) {
	                    service.toggleRowSelection(grid, row, evt, grid.options.multiSelect, grid.options.noUnselect);
	                  }
	                },
	                /**
	                 * @ngdoc function
	                 * @name unSelectRowByVisibleIndex
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description Unselect the specified row by visible index (i.e. if you
	                 * specify row 0 you'll get the first visible row unselected).  In this context
	                 * visible means of those rows that are theoretically visible (i.e. not filtered),
	                 * rather than rows currently rendered on the screen.
	                 * @param {number} rowNum index within the rowsVisible array
	                 * @param {Event} evt object if raised from an event
	                 */
	                unSelectRowByVisibleIndex: function (rowNum, evt) {
	                  var row = grid.renderContainers.body.visibleRowCache[rowNum];
	                  if (row !== null && typeof (row) !== 'undefined' && row.isSelected) {
	                    service.toggleRowSelection(grid, row, evt, grid.options.multiSelect, grid.options.noUnselect);
	                  }
	                },
	                /**
	                 * @ngdoc function
	                 * @name selectAllRows
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description Selects all rows.  Does nothing if multiSelect = false
	                 * @param {Event} evt object if raised from an event
	                 */
	                selectAllRows: function (evt) {
	                  if (grid.options.multiSelect !== false) {
	                    var changedRows = [];
	                    grid.rows.forEach(function (row) {
	                      if (!row.isSelected && row.enableSelection !== false && grid.options.isRowSelectable(row) !== false) {
	                        row.setSelected(true);
	                        service.decideRaiseSelectionEvent(grid, row, changedRows, evt);
	                      }
	                    });
	                    service.decideRaiseSelectionBatchEvent(grid, changedRows, evt);
	                    grid.selection.selectAll = true;
	                  }
	                },
	                /**
	                 * @ngdoc function
	                 * @name selectAllVisibleRows
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description Selects all visible rows.  Does nothing if multiSelect = false
	                 * @param {Event} evt object if raised from an event
	                 */
	                selectAllVisibleRows: function (evt) {
	                  if (grid.options.multiSelect !== false) {
	                    var changedRows = [];
	                    grid.rows.forEach(function(row) {
	                      if (row.visible) {
	                        if (!row.isSelected && row.enableSelection !== false && grid.options.isRowSelectable(row) !== false) {
	                          row.setSelected(true);
	                          service.decideRaiseSelectionEvent(grid, row, changedRows, evt);
	                        }
	                      } else if (row.isSelected) {
	                        row.setSelected(false);
	                        service.decideRaiseSelectionEvent(grid, row, changedRows, evt);
	                      }
	                    });
	                    service.decideRaiseSelectionBatchEvent(grid, changedRows, evt);
	                    grid.selection.selectAll = true;
	                  }
	                },
	                /**
	                 * @ngdoc function
	                 * @name clearSelectedRows
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description Unselects all rows
	                 * @param {Event} evt object if raised from an event
	                 */
	                clearSelectedRows: function (evt) {
	                  service.clearSelectedRows(grid, evt);
	                },
	                /**
	                 * @ngdoc function
	                 * @name getSelectedRows
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description returns all selectedRow's entity references
	                 */
	                getSelectedRows: function () {
	                  return service.getSelectedRows(grid).map(function (gridRow) {
	                    return gridRow.entity;
	                  }).filter(function (entity) {
	                    return entity.hasOwnProperty('$$hashKey');
	                  });
	                },
	                /**
	                 * @ngdoc function
	                 * @name getSelectedGridRows
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description returns all selectedRow's as gridRows
	                 */
	                getSelectedGridRows: function () {
	                  return service.getSelectedRows(grid);
	                },
	                /**
	                 * @ngdoc function
	                 * @name getSelectedCount
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description returns the number of rows selected
	                 */
	                getSelectedCount: function () {
	                  return grid.selection.selectedCount;
	                },
	                /**
	                 * @ngdoc function
	                 * @name setMultiSelect
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description Sets the current gridOption.multiSelect to true or false
	                 * @param {bool} multiSelect true to allow multiple rows
	                 */
	                setMultiSelect: function (multiSelect) {
	                  grid.options.multiSelect = multiSelect;
	                },
	                /**
	                 * @ngdoc function
	                 * @name setModifierKeysToMultiSelect
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description Sets the current gridOption.modifierKeysToMultiSelect to true or false
	                 * @param {bool} modifierKeysToMultiSelect true to only allow multiple rows when using ctrlKey or shiftKey is used
	                 */
	                setModifierKeysToMultiSelect: function (modifierKeysToMultiSelect) {
	                  grid.options.modifierKeysToMultiSelect = modifierKeysToMultiSelect;
	                },
	                /**
	                 * @ngdoc function
	                 * @name getSelectAllState
	                 * @methodOf  ui.grid.selection.api:PublicApi
	                 * @description Returns whether or not the selectAll checkbox is currently ticked.  The
	                 * grid doesn't automatically select rows when you add extra data - so when you add data
	                 * you need to explicitly check whether the selectAll is set, and then call setVisible rows
	                 * if it is
	                 */
	                getSelectAllState: function () {
	                  return grid.selection.selectAll;
	                }
	
	              }
	            }
	          };
	
	          grid.api.registerEventsFromObject(publicApi.events);
	
	          grid.api.registerMethodsFromObject(publicApi.methods);
	
	        },
	
	        defaultGridOptions: function (gridOptions) {
	          //default option to true unless it was explicitly set to false
	          /**
	           *  @ngdoc object
	           *  @name ui.grid.selection.api:GridOptions
	           *
	           *  @description GridOptions for selection feature, these are available to be
	           *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	           */
	
	          /**
	           *  @ngdoc object
	           *  @name enableRowSelection
	           *  @propertyOf  ui.grid.selection.api:GridOptions
	           *  @description Enable row selection for entire grid.
	           *  <br/>Defaults to true
	           */
	          gridOptions.enableRowSelection = gridOptions.enableRowSelection !== false;
	          /**
	           *  @ngdoc object
	           *  @name multiSelect
	           *  @propertyOf  ui.grid.selection.api:GridOptions
	           *  @description Enable multiple row selection for entire grid
	           *  <br/>Defaults to true
	           */
	          gridOptions.multiSelect = gridOptions.multiSelect !== false;
	          /**
	           *  @ngdoc object
	           *  @name noUnselect
	           *  @propertyOf  ui.grid.selection.api:GridOptions
	           *  @description Prevent a row from being unselected.  Works in conjunction
	           *  with `multiselect = false` and `gridApi.selection.selectRow()` to allow
	           *  you to create a single selection only grid - a row is always selected, you
	           *  can only select different rows, you can't unselect the row.
	           *  <br/>Defaults to false
	           */
	          gridOptions.noUnselect = gridOptions.noUnselect === true;
	          /**
	           *  @ngdoc object
	           *  @name modifierKeysToMultiSelect
	           *  @propertyOf  ui.grid.selection.api:GridOptions
	           *  @description Enable multiple row selection only when using the ctrlKey or shiftKey. Requires multiSelect to be true.
	           *  <br/>Defaults to false
	           */
	          gridOptions.modifierKeysToMultiSelect = gridOptions.modifierKeysToMultiSelect === true;
	          /**
	           *  @ngdoc object
	           *  @name enableRowHeaderSelection
	           *  @propertyOf  ui.grid.selection.api:GridOptions
	           *  @description Enable a row header to be used for selection
	           *  <br/>Defaults to true
	           */
	          gridOptions.enableRowHeaderSelection = gridOptions.enableRowHeaderSelection !== false;
	          /**
	           *  @ngdoc object
	           *  @name enableFullRowSelection
	           *  @propertyOf  ui.grid.selection.api:GridOptions
	           *  @description Enable selection by clicking anywhere on the row.  Defaults to
	           *  false if `enableRowHeaderSelection` is true, otherwise defaults to false.
	           */
	          if (typeof (gridOptions.enableFullRowSelection) === 'undefined') {
	            gridOptions.enableFullRowSelection = !gridOptions.enableRowHeaderSelection;
	          }
	          /**
	           *  @ngdoc object
	           *  @name enableSelectAll
	           *  @propertyOf  ui.grid.selection.api:GridOptions
	           *  @description Enable the select all checkbox at the top of the selectionRowHeader
	           *  <br/>Defaults to true
	           */
	          gridOptions.enableSelectAll = gridOptions.enableSelectAll !== false;
	          /**
	           *  @ngdoc object
	           *  @name enableSelectionBatchEvent
	           *  @propertyOf  ui.grid.selection.api:GridOptions
	           *  @description If selected rows are changed in bulk, either via the API or
	           *  via the selectAll checkbox, then a separate event is fired.  Setting this
	           *  option to false will cause the rowSelectionChanged event to be called multiple times
	           *  instead
	           *  <br/>Defaults to true
	           */
	          gridOptions.enableSelectionBatchEvent = gridOptions.enableSelectionBatchEvent !== false;
	          /**
	           *  @ngdoc object
	           *  @name selectionRowHeaderWidth
	           *  @propertyOf  ui.grid.selection.api:GridOptions
	           *  @description can be used to set a custom width for the row header selection column
	           *  <br/>Defaults to 30px
	           */
	          gridOptions.selectionRowHeaderWidth = angular.isDefined(gridOptions.selectionRowHeaderWidth) ? gridOptions.selectionRowHeaderWidth : 30;
	
	          /**
	           *  @ngdoc object
	           *  @name enableFooterTotalSelected
	           *  @propertyOf  ui.grid.selection.api:GridOptions
	           *  @description Shows the total number of selected items in footer if true.
	           *  <br/>Defaults to true.
	           *  <br/>GridOptions.showGridFooter must also be set to true.
	           */
	          gridOptions.enableFooterTotalSelected = gridOptions.enableFooterTotalSelected !== false;
	
	          /**
	           *  @ngdoc object
	           *  @name isRowSelectable
	           *  @propertyOf  ui.grid.selection.api:GridOptions
	           *  @description Makes it possible to specify a method that evaluates for each row and sets its "enableSelection" property.
	           */
	
	          gridOptions.isRowSelectable = angular.isDefined(gridOptions.isRowSelectable) ? gridOptions.isRowSelectable : angular.noop;
	        },
	
	        /**
	         * @ngdoc function
	         * @name toggleRowSelection
	         * @methodOf  ui.grid.selection.service:uiGridSelectionService
	         * @description Toggles row as selected or unselected
	         * @param {Grid} grid grid object
	         * @param {GridRow} row row to select or deselect
	         * @param {Event} evt object if resulting from event
	         * @param {bool} multiSelect if false, only one row at time can be selected
	         * @param {bool} noUnselect if true then rows cannot be unselected
	         */
	        toggleRowSelection: function (grid, row, evt, multiSelect, noUnselect) {
	          var selected = row.isSelected;
	
	          if (row.enableSelection === false) {
	            return;
	          }
	
	          var selectedRows;
	          if (!multiSelect && !selected) {
	            service.clearSelectedRows(grid, evt);
	          } else if (!multiSelect && selected) {
	            selectedRows = service.getSelectedRows(grid);
	            if (selectedRows.length > 1) {
	              selected = false; // Enable reselect of the row
	              service.clearSelectedRows(grid, evt);
	            }
	          }
	
	          if (selected && noUnselect) {
	            // don't deselect the row
	          } else {
	            row.setSelected(!selected);
	            if (row.isSelected === true) {
	              grid.selection.lastSelectedRow = row;
	            }
	
	            selectedRows = service.getSelectedRows(grid);
	            grid.selection.selectAll = grid.rows.length === selectedRows.length;
	
	            grid.api.selection.raise.rowSelectionChanged(row, evt);
	          }
	        },
	        /**
	         * @ngdoc function
	         * @name shiftSelect
	         * @methodOf  ui.grid.selection.service:uiGridSelectionService
	         * @description selects a group of rows from the last selected row using the shift key
	         * @param {Grid} grid grid object
	         * @param {GridRow} row clicked row
	         * @param {Event} evt object if raised from an event
	         * @param {bool} multiSelect if false, does nothing this is for multiSelect only
	         */
	        shiftSelect: function (grid, row, evt, multiSelect) {
	          if (!multiSelect) {
	            return;
	          }
	          var selectedRows = service.getSelectedRows(grid);
	          var fromRow = selectedRows.length > 0 ? grid.renderContainers.body.visibleRowCache.indexOf(grid.selection.lastSelectedRow) : 0;
	          var toRow = grid.renderContainers.body.visibleRowCache.indexOf(row);
	          //reverse select direction
	          if (fromRow > toRow) {
	            var tmp = fromRow;
	            fromRow = toRow;
	            toRow = tmp;
	          }
	
	          var changedRows = [];
	          for (var i = fromRow; i <= toRow; i++) {
	            var rowToSelect = grid.renderContainers.body.visibleRowCache[i];
	            if (rowToSelect) {
	              if (!rowToSelect.isSelected && rowToSelect.enableSelection !== false) {
	                rowToSelect.setSelected(true);
	                grid.selection.lastSelectedRow = rowToSelect;
	                service.decideRaiseSelectionEvent(grid, rowToSelect, changedRows, evt);
	              }
	            }
	          }
	          service.decideRaiseSelectionBatchEvent(grid, changedRows, evt);
	        },
	        /**
	         * @ngdoc function
	         * @name getSelectedRows
	         * @methodOf  ui.grid.selection.service:uiGridSelectionService
	         * @description Returns all the selected rows
	         * @param {Grid} grid grid object
	         */
	        getSelectedRows: function (grid) {
	          return grid.rows.filter(function (row) {
	            return row.isSelected;
	          });
	        },
	
	        /**
	         * @ngdoc function
	         * @name clearSelectedRows
	         * @methodOf  ui.grid.selection.service:uiGridSelectionService
	         * @description Clears all selected rows
	         * @param {Grid} grid grid object
	         * @param {Event} evt object if raised from an event
	         */
	        clearSelectedRows: function (grid, evt) {
	          var changedRows = [];
	          service.getSelectedRows(grid).forEach(function (row) {
	            if (row.isSelected) {
	              row.setSelected(false);
	              service.decideRaiseSelectionEvent(grid, row, changedRows, evt);
	            }
	          });
	          service.decideRaiseSelectionBatchEvent(grid, changedRows, evt);
	          grid.selection.selectAll = false;
	          grid.selection.selectedCount = 0;
	        },
	
	        /**
	         * @ngdoc function
	         * @name decideRaiseSelectionEvent
	         * @methodOf  ui.grid.selection.service:uiGridSelectionService
	         * @description Decides whether to raise a single event or a batch event
	         * @param {Grid} grid grid object
	         * @param {GridRow} row row that has changed
	         * @param {array} changedRows an array to which we can append the changed
	         * @param {Event} evt object if raised from an event
	         * row if we're doing batch events
	         */
	        decideRaiseSelectionEvent: function (grid, row, changedRows, evt) {
	          if (!grid.options.enableSelectionBatchEvent) {
	            grid.api.selection.raise.rowSelectionChanged(row, evt);
	          } else {
	            changedRows.push(row);
	          }
	        },
	
	        /**
	         * @ngdoc function
	         * @name raiseSelectionEvent
	         * @methodOf  ui.grid.selection.service:uiGridSelectionService
	         * @description Decides whether we need to raise a batch event, and
	         * raises it if we do.
	         * @param {Grid} grid grid object
	         * @param {array} changedRows an array of changed rows, only populated
	         * @param {Event} evt object if raised from an event
	         * if we're doing batch events
	         */
	        decideRaiseSelectionBatchEvent: function (grid, changedRows, evt) {
	          if (changedRows.length > 0) {
	            grid.api.selection.raise.rowSelectionChangedBatch(changedRows, evt);
	          }
	        }
	      };
	
	      return service;
	
	    }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.selection.directive:uiGridSelection
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Adds selection features to grid
	   *
	   *  @example
	   <example module="app">
	   <file name="app.js">
	   var app = angular.module('app', ['ui.grid', 'ui.grid.selection']);
	
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	      $scope.data = [
	        { name: 'Bob', title: 'CEO' },
	            { name: 'Frank', title: 'Lowly Developer' }
	      ];
	
	      $scope.columnDefs = [
	        {name: 'name', enableCellEdit: true},
	        {name: 'title', enableCellEdit: true}
	      ];
	    }]);
	   </file>
	   <file name="index.html">
	   <div ng-controller="MainCtrl">
	   <div ui-grid="{ data: data, columnDefs: columnDefs }" ui-grid-selection></div>
	   </div>
	   </file>
	   </example>
	   */
	  module.directive('uiGridSelection', ['uiGridSelectionConstants', 'uiGridSelectionService', '$templateCache', 'uiGridConstants',
	    function (uiGridSelectionConstants, uiGridSelectionService, $templateCache, uiGridConstants) {
	      return {
	        replace: true,
	        priority: 0,
	        require: '^uiGrid',
	        scope: false,
	        compile: function () {
	          return {
	            pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	              uiGridSelectionService.initializeGrid(uiGridCtrl.grid);
	              if (uiGridCtrl.grid.options.enableRowHeaderSelection) {
	                var selectionRowHeaderDef = {
	                  name: uiGridSelectionConstants.selectionRowHeaderColName,
	                  displayName: '',
	                  width: uiGridCtrl.grid.options.selectionRowHeaderWidth,
	                  minWidth: 10,
	                  cellTemplate: 'ui-grid/selectionRowHeader',
	                  headerCellTemplate: 'ui-grid/selectionHeaderCell',
	                  enableColumnResizing: false,
	                  enableColumnMenu: false,
	                  exporterSuppressExport: true,
	                  allowCellFocus: true
	                };
	
	                uiGridCtrl.grid.addRowHeaderColumn(selectionRowHeaderDef, 0);
	              }
	
	              var processorSet = false;
	
	              var processSelectableRows = function (rows) {
	                rows.forEach(function (row) {
	                  row.enableSelection = uiGridCtrl.grid.options.isRowSelectable(row);
	                });
	                return rows;
	              };
	
	              var updateOptions = function () {
	                if (uiGridCtrl.grid.options.isRowSelectable !== angular.noop && processorSet !== true) {
	                  uiGridCtrl.grid.registerRowsProcessor(processSelectableRows, 500);
	                  processorSet = true;
	                }
	              };
	
	              updateOptions();
	
	              var dataChangeDereg = uiGridCtrl.grid.registerDataChangeCallback(updateOptions, [uiGridConstants.dataChange.OPTIONS]);
	
	              $scope.$on('$destroy', dataChangeDereg);
	            },
	            post: function ($scope, $elm, $attrs, uiGridCtrl) {
	
	            }
	          };
	        }
	      };
	    }]);
	
	  module.directive('uiGridSelectionRowHeaderButtons', ['$templateCache', 'uiGridSelectionService', 'gridUtil',
	    function ($templateCache, uiGridSelectionService, gridUtil) {
	      return {
	        replace: true,
	        restrict: 'E',
	        template: $templateCache.get('ui-grid/selectionRowHeaderButtons'),
	        scope: true,
	        require: '^uiGrid',
	        link: function ($scope, $elm, $attrs, uiGridCtrl) {
	          var self = uiGridCtrl.grid;
	          $scope.selectButtonClick = selectButtonClick;
	          $scope.selectButtonKeyDown = selectButtonKeyDown;
	
	          // On IE, prevent mousedowns on the select button from starting a selection.
	          //   If this is not done and you shift+click on another row, the browser will select a big chunk of text
	          if (gridUtil.detectBrowser() === 'ie') {
	            $elm.on('mousedown', selectButtonMouseDown);
	          }
	
	          function selectButtonKeyDown(row, evt) {
	            if (evt.keyCode === 32) {
	              evt.preventDefault();
	              selectButtonClick(row, evt);
	            }
	          }
	
	          function selectButtonClick(row, evt) {
	            evt.stopPropagation();
	
	            if (evt.shiftKey) {
	              uiGridSelectionService.shiftSelect(self, row, evt, self.options.multiSelect);
	            }
	            else if (evt.ctrlKey || evt.metaKey) {
	              uiGridSelectionService.toggleRowSelection(self, row, evt, self.options.multiSelect, self.options.noUnselect);
	            }
	            else if (row.groupHeader) {
	              for (var i = 0; i < row.treeNode.children.length; i++) {
	                uiGridSelectionService.toggleRowSelection(self, row.treeNode.children[i].row, evt, self.options.multiSelect, self.options.noUnselect);
	              }
	            }
	            else {
	              uiGridSelectionService.toggleRowSelection(self, row, evt, (self.options.multiSelect && !self.options.modifierKeysToMultiSelect), self.options.noUnselect);
	            }
	          }
	
	          function selectButtonMouseDown(evt) {
	            if (evt.ctrlKey || evt.shiftKey) {
	              evt.target.onselectstart = function () { return false; };
	              window.setTimeout(function () { evt.target.onselectstart = null; }, 0);
	            }
	          }
	
	          $scope.$on('$destroy', function unbindEvents() {
	            $elm.off();
	          });
	        }
	      };
	    }]);
	
	  module.directive('uiGridSelectionSelectAllButtons', ['$templateCache', 'uiGridSelectionService',
	    function ($templateCache, uiGridSelectionService) {
	      return {
	        replace: true,
	        restrict: 'E',
	        template: $templateCache.get('ui-grid/selectionSelectAllButtons'),
	        scope: false,
	        link: function ($scope, $elm, $attrs, uiGridCtrl) {
	          var self = $scope.col.grid;
	
	          $scope.headerButtonKeyDown = function (evt) {
	            if (evt.keyCode === 32 || evt.keyCode === 13) {
	              evt.preventDefault();
	              $scope.headerButtonClick(evt);
	            }
	          };
	
	          $scope.headerButtonClick = function (evt) {
	            if (self.selection.selectAll) {
	              uiGridSelectionService.clearSelectedRows(self, evt);
	              if (self.options.noUnselect) {
	                self.api.selection.selectRowByVisibleIndex(0, evt);
	              }
	              self.selection.selectAll = false;
	            } else if (self.options.multiSelect) {
	              self.api.selection.selectAllVisibleRows(evt);
	              self.selection.selectAll = true;
	            }
	          };
	        }
	      };
	    }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.selection.directive:uiGridViewport
	   *  @element div
	   *
	   *  @description Stacks on top of ui.grid.uiGridViewport to alter the attributes used
	   *  for the grid row
	   */
	  module.directive('uiGridViewport',
	    ['$compile', 'uiGridConstants', 'uiGridSelectionConstants', 'gridUtil', '$parse', 'uiGridSelectionService',
	      function ($compile, uiGridConstants, uiGridSelectionConstants, gridUtil, $parse, uiGridSelectionService) {
	        return {
	          priority: -200, // run after default  directive
	          scope: false,
	          compile: function ($elm, $attrs) {
	            var rowRepeatDiv = angular.element($elm[0].querySelector('.ui-grid-canvas:not(.ui-grid-empty-base-layer-container)').children[0]);
	
	            var existingNgClass = rowRepeatDiv.attr("ng-class");
	            var newNgClass = '';
	            if (existingNgClass) {
	              newNgClass = existingNgClass.slice(0, -1) + ",'ui-grid-row-selected': row.isSelected}";
	            } else {
	              newNgClass = "{'ui-grid-row-selected': row.isSelected}";
	            }
	            rowRepeatDiv.attr("ng-class", newNgClass);
	
	            return {
	              pre: function ($scope, $elm, $attrs, controllers) {
	
	              },
	              post: function ($scope, $elm, $attrs, controllers) {
	              }
	            };
	          }
	        };
	      }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.selection.directive:uiGridCell
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Stacks on top of ui.grid.uiGridCell to provide selection feature
	   */
	  module.directive('uiGridCell',
	    ['$compile', 'uiGridConstants', 'uiGridSelectionConstants', 'gridUtil', '$parse', 'uiGridSelectionService', '$timeout',
	      function ($compile, uiGridConstants, uiGridSelectionConstants, gridUtil, $parse, uiGridSelectionService, $timeout) {
	        return {
	          priority: -200, // run after default uiGridCell directive
	          restrict: 'A',
	          require: '?^uiGrid',
	          scope: false,
	          link: function ($scope, $elm, $attrs, uiGridCtrl) {
	
	            var touchStartTime = 0;
	            var touchTimeout = 300;
	
	            // Bind to keydown events in the render container
	            if (uiGridCtrl.grid.api.cellNav) {
	
	              uiGridCtrl.grid.api.cellNav.on.viewPortKeyDown($scope, function (evt, rowCol) {
	                if (rowCol === null ||
	                  rowCol.row !== $scope.row ||
	                  rowCol.col !== $scope.col) {
	                  return;
	                }
	
	                if (evt.keyCode === 32 && $scope.col.colDef.name === "selectionRowHeaderCol") {
	                  evt.preventDefault();
	                  uiGridSelectionService.toggleRowSelection($scope.grid, $scope.row, evt, ($scope.grid.options.multiSelect && !$scope.grid.options.modifierKeysToMultiSelect), $scope.grid.options.noUnselect);
	                  $scope.$apply();
	                }
	
	                //  uiGridCellNavService.scrollToIfNecessary(uiGridCtrl.grid, rowCol.row, rowCol.col);
	              });
	            }
	
	            //$elm.bind('keydown', function (evt) {
	            //  if (evt.keyCode === 32 && $scope.col.colDef.name === "selectionRowHeaderCol") {
	            //    uiGridSelectionService.toggleRowSelection($scope.grid, $scope.row, evt, ($scope.grid.options.multiSelect && !$scope.grid.options.modifierKeysToMultiSelect), $scope.grid.options.noUnselect);
	            //    $scope.$apply();
	            //  }
	            //});
	
	            var selectCells = function (evt) {
	              // if you click on expandable icon doesn't trigger selection
	              if (evt.target.className === "ui-grid-icon-minus-squared" || evt.target.className === "ui-grid-icon-plus-squared") {
	                return;
	              }
	
	              // if we get a click, then stop listening for touchend
	              $elm.off('touchend', touchEnd);
	
	              if (evt.shiftKey) {
	                uiGridSelectionService.shiftSelect($scope.grid, $scope.row, evt, $scope.grid.options.multiSelect);
	              }
	              else if (evt.ctrlKey || evt.metaKey) {
	                uiGridSelectionService.toggleRowSelection($scope.grid, $scope.row, evt, $scope.grid.options.multiSelect, $scope.grid.options.noUnselect);
	              }
	              else {
	                uiGridSelectionService.toggleRowSelection($scope.grid, $scope.row, evt, ($scope.grid.options.multiSelect && !$scope.grid.options.modifierKeysToMultiSelect), $scope.grid.options.noUnselect);
	              }
	              $scope.$apply();
	
	              // don't re-enable the touchend handler for a little while - some devices generate both, and it will
	              // take a little while to move your hand from the mouse to the screen if you have both modes of input
	              $timeout(function () {
	                $elm.on('touchend', touchEnd);
	              }, touchTimeout);
	            };
	
	            var touchStart = function (evt) {
	              touchStartTime = (new Date()).getTime();
	
	              // if we get a touch event, then stop listening for click
	              $elm.off('click', selectCells);
	            };
	
	            var touchEnd = function (evt) {
	              var touchEndTime = (new Date()).getTime();
	              var touchTime = touchEndTime - touchStartTime;
	
	              if (touchTime < touchTimeout) {
	                // short touch
	                selectCells(evt);
	              }
	
	              // don't re-enable the click handler for a little while - some devices generate both, and it will
	              // take a little while to move your hand from the screen to the mouse if you have both modes of input
	              $timeout(function () {
	                $elm.on('click', selectCells);
	              }, touchTimeout);
	            };
	
	            function registerRowSelectionEvents() {
	              if ($scope.grid.options.enableRowSelection && $scope.grid.options.enableFullRowSelection && !$elm.hasClass('ui-grid-row-header-cell')) {
	                $elm.addClass('ui-grid-disable-selection');
	                $elm.on('touchstart', touchStart);
	                $elm.on('touchend', touchEnd);
	                $elm.on('click', selectCells);
	
	                $scope.registered = true;
	              }
	            }
	
	            function deregisterRowSelectionEvents() {
	              if ($scope.registered) {
	                $elm.removeClass('ui-grid-disable-selection');
	
	                $elm.off('touchstart', touchStart);
	                $elm.off('touchend', touchEnd);
	                $elm.off('click', selectCells);
	
	                $scope.registered = false;
	              }
	            }
	
	            registerRowSelectionEvents();
	            // register a dataChange callback so that we can change the selection configuration dynamically
	            // if the user changes the options
	            var dataChangeDereg = $scope.grid.registerDataChangeCallback(function () {
	              if ($scope.grid.options.enableRowSelection && $scope.grid.options.enableFullRowSelection &&
	                !$scope.registered) {
	                registerRowSelectionEvents();
	              } else if ((!$scope.grid.options.enableRowSelection || !$scope.grid.options.enableFullRowSelection) &&
	                $scope.registered) {
	                deregisterRowSelectionEvents();
	              }
	            }, [uiGridConstants.dataChange.OPTIONS]);
	
	            $elm.on('$destroy', dataChangeDereg);
	          }
	        };
	      }]);
	
	  module.directive('uiGridGridFooter', ['$compile', 'uiGridConstants', 'gridUtil', function ($compile, uiGridConstants, gridUtil) {
	    return {
	      restrict: 'EA',
	      replace: true,
	      priority: -1000,
	      require: '^uiGrid',
	      scope: true,
	      compile: function ($elm, $attrs) {
	        return {
	          pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	
	            if (!uiGridCtrl.grid.options.showGridFooter) {
	              return;
	            }
	
	
	            gridUtil.getTemplate('ui-grid/gridFooterSelectedItems')
	              .then(function (contents) {
	                var template = angular.element(contents);
	
	                var newElm = $compile(template)($scope);
	
	                angular.element($elm[0].getElementsByClassName('ui-grid-grid-footer')[0]).append(newElm);
	              });
	          },
	
	          post: function ($scope, $elm, $attrs, controllers) {
	
	          }
	        };
	      }
	    };
	  }]);
	
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.treeBase
	   * @description
	   *
	   * # ui.grid.treeBase
	   *
	   * <div class="alert alert-warning" role="alert"><strong>Beta</strong> This feature is ready for testing, but it either hasn't seen a lot of use or has some known bugs.</div>
	   *
	   * This module provides base tree handling functions that are shared by other features, notably grouping
	   * and treeView.  It provides a tree view of the data, with nodes in that
	   * tree and leaves.
	   *
	   * Design information:
	   * -------------------
	   *
	   * The raw data that is provided must come with a $$treeLevel on any non-leaf node.  Grouping will create
	   * these on all the group header rows, treeView will expect these to be set in the raw data by the user.
	   * TreeBase will run a rowsProcessor that:
	   *  - builds `treeBase.tree` out of the provided rows
	   *  - permits a recursive sort of the tree
	   *  - maintains the expand/collapse state of each node
	   *  - provides the expand/collapse all button and the expand/collapse buttons
	   *  - maintains the count of children for each node
	   *
	   * Each row is updated with a link to the tree node that represents it.  Refer {@link ui.grid.treeBase.grid:treeBase.tree tree documentation}
	   * for information.
	   *
	   *  TreeBase adds information to the rows
	   *  - treeLevel: if present and > -1 tells us the level (level 0 is the top level)
	   *  - treeNode: pointer to the node in the grid.treeBase.tree that refers
	   *    to this row, allowing us to manipulate the state
	   *
	   * Since the logic is baked into the rowsProcessors, it should get triggered whenever
	   * row order or filtering or anything like that is changed.  We recall the expanded state
	   * across invocations of the rowsProcessors by the reference to the treeNode on the individual
	   * rows.  We rebuild the tree itself quite frequently, when we do this we use the saved treeNodes to
	   * get the state, but we overwrite the other data in that treeNode.
	   *
	   * By default rows are collapsed, which means all data rows have their visible property
	   * set to false, and only level 0 group rows are set to visible.
	   *
	   * We rely on the rowsProcessors to do the actual expanding and collapsing, so we set the flags we want into
	   * grid.treeBase.tree, then call refresh.  This is because we can't easily change the visible
	   * row cache without calling the processors, and once we've built the logic into the rowProcessors we may as
	   * well use it all the time.
	   *
	   * Tree base provides sorting (on non-grouped columns).
	   *
	   * Sorting works in two passes.  The standard sorting is performed for any columns that are important to building
	   * the tree (for example, any grouped columns).  Then after the tree is built, a recursive tree sort is performed
	   * for the remaining sort columns (including the original sort) - these columns are sorted within each tree level
	   * (so all the level 1 nodes are sorted, then all the level 2 nodes within each level 1 node etc).
	   *
	   * To achieve this we make use of the `ignoreSort` property on the sort configuration.  The parent feature (treeView or grouping)
	   * must provide a rowsProcessor that runs with very low priority (typically in the 60-65 range), and that sets
	   * the `ignoreSort`on any sort that it wants to run on the tree.  TreeBase will clear the ignoreSort on all sorts - so it
	   * will turn on any sorts that haven't run.  It will then call a recursive sort on the tree.
	   *
	   * Tree base provides treeAggregation.  It checks the treeAggregation configuration on each column, and aggregates based on
	   * the logic provided as it builds the tree. Footer aggregation from the uiGrid core should not be used with treeBase aggregation,
	   * since it operates on all visible rows, as opposed to to leaf nodes only. Setting `showColumnFooter: true` will show the
	   * treeAggregations in the column footer.  Aggregation information will be collected in the format:
	   *
	   * ```
	   *   {
	   *     type: 'count',
	   *     value: 4,
	   *     label: 'count: ',
	   *     rendered: 'count: 4'
	   *   }
	   * ```
	   *
	   * A callback is provided to format the value once it is finalised (aka a valueFilter).
	   *
	   * <br/>
	   * <br/>
	   *
	   * <div doc-module-components="ui.grid.treeBase"></div>
	   */
	
	  var module = angular.module('ui.grid.treeBase', ['ui.grid']);
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.treeBase.constant:uiGridTreeBaseConstants
	   *
	   *  @description constants available in treeBase module.
	   *
	   *  These constants are manually copied into grouping and treeView,
	   *  as I haven't found a way to simply include them, and it's not worth
	   *  investing time in for something that changes very infrequently.
	   *
	   */
	  module.constant('uiGridTreeBaseConstants', {
	    featureName: "treeBase",
	    rowHeaderColName: 'treeBaseRowHeaderCol',
	    EXPANDED: 'expanded',
	    COLLAPSED: 'collapsed',
	    aggregation: {
	      COUNT: 'count',
	      SUM: 'sum',
	      MAX: 'max',
	      MIN: 'min',
	      AVG: 'avg'
	    }
	  });
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.treeBase.service:uiGridTreeBaseService
	   *
	   *  @description Services for treeBase feature
	   */
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.treeBase.api:ColumnDef
	   *
	   *  @description ColumnDef for tree feature, these are available to be
	   *  set using the ui-grid {@link ui.grid.class:GridOptions.columnDef gridOptions.columnDefs}
	   */
	
	  module.service('uiGridTreeBaseService', ['$q', 'uiGridTreeBaseConstants', 'gridUtil', 'GridRow', 'gridClassFactory', 'i18nService', 'uiGridConstants', 'rowSorter',
	  function ($q, uiGridTreeBaseConstants, gridUtil, GridRow, gridClassFactory, i18nService, uiGridConstants, rowSorter) {
	
	    var service = {
	
	      initializeGrid: function (grid, $scope) {
	
	        //add feature namespace and any properties to grid for needed
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.treeBase.grid:treeBase
	         *
	         *  @description Grid properties and functions added for treeBase
	         */
	        grid.treeBase = {};
	
	        /**
	         *  @ngdoc property
	         *  @propertyOf ui.grid.treeBase.grid:treeBase
	         *  @name numberLevels
	         *
	         *  @description Total number of tree levels currently used, calculated by the rowsProcessor by
	         *  retaining the highest tree level it sees
	         */
	        grid.treeBase.numberLevels = 0;
	
	        /**
	         *  @ngdoc property
	         *  @propertyOf ui.grid.treeBase.grid:treeBase
	         *  @name expandAll
	         *
	         *  @description Whether or not the expandAll box is selected
	         */
	        grid.treeBase.expandAll = false;
	
	        /**
	         *  @ngdoc property
	         *  @propertyOf ui.grid.treeBase.grid:treeBase
	         *  @name tree
	         *
	         *  @description Tree represented as a nested array that holds the state of each node, along with a
	         *  pointer to the row.  The array order is material - we will display the children in the order
	         *  they are stored in the array
	         *
	         *  Each node stores:
	         *
	         *    - the state of this node
	         *    - an array of children of this node
	         *    - a pointer to the parent of this node (reverse pointer, allowing us to walk up the tree)
	         *    - the number of children of this node
	         *    - aggregation information calculated from the nodes
	         *
	         *  ```
	         *    [{
	         *      state: 'expanded',
	         *      row: <reference to row>,
	         *      parentRow: null,
	         *      aggregations: [{
	         *        type: 'count',
	         *        col: <gridCol>,
	         *        value: 2,
	         *        label: 'count: ',
	         *        rendered: 'count: 2'
	         *      }],
	         *      children: [
	         *        {
	         *          state: 'expanded',
	         *          row: <reference to row>,
	         *          parentRow: <reference to row>,
	         *          aggregations: [{
	         *            type: 'count',
	         *            col: '<gridCol>,
	         *            value: 4,
	         *            label: 'count: ',
	         *            rendered: 'count: 4'
	         *          }],
	         *          children: [
	         *            { state: 'expanded', row: <reference to row>, parentRow: <reference to row> },
	         *            { state: 'collapsed', row: <reference to row>, parentRow: <reference to row> },
	         *            { state: 'expanded', row: <reference to row>, parentRow: <reference to row> },
	         *            { state: 'collapsed', row: <reference to row>, parentRow: <reference to row> }
	         *          ]
	         *        },
	         *        {
	         *          state: 'collapsed',
	         *          row: <reference to row>,
	         *          parentRow: <reference to row>,
	         *          aggregations: [{
	         *            type: 'count',
	         *            col: <gridCol>,
	         *            value: 3,
	         *            label: 'count: ',
	         *            rendered: 'count: 3'
	         *          }],
	         *          children: [
	         *            { state: 'expanded', row: <reference to row>, parentRow: <reference to row> },
	         *            { state: 'collapsed', row: <reference to row>, parentRow: <reference to row> },
	         *            { state: 'expanded', row: <reference to row>, parentRow: <reference to row> }
	         *          ]
	         *        }
	         *      ]
	         *    }, {<another level 0 node maybe>} ]
	         *  ```
	         *  Missing state values are false - meaning they aren't expanded.
	         *
	         *  This is used because the rowProcessors run every time the grid is refreshed, so
	         *  we'd lose the expanded state every time the grid was refreshed.  This instead gives
	         *  us a reliable lookup that persists across rowProcessors.
	         *
	         *  This tree is rebuilt every time we run the rowsProcessors.  Since each row holds a pointer
	         *  to it's tree node we can persist expand/collapse state across calls to rowsProcessor, we discard
	         *  all transient information on the tree (children, childCount) and recalculate it
	         *
	         */
	        grid.treeBase.tree = [];
	
	        service.defaultGridOptions(grid.options);
	
	        grid.registerRowsProcessor(service.treeRows, 410);
	
	        grid.registerColumnBuilder( service.treeBaseColumnBuilder );
	
	        service.createRowHeader( grid );
	
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.treeBase.api:PublicApi
	         *
	         *  @description Public Api for treeBase feature
	         */
	        var publicApi = {
	          events: {
	            treeBase: {
	              /**
	               * @ngdoc event
	               * @eventOf ui.grid.treeBase.api:PublicApi
	               * @name rowExpanded
	               * @description raised whenever a row is expanded.  If you are dynamically
	               * rendering your tree you can listen to this event, and then retrieve
	               * the children of this row and load them into the grid data.
	               *
	               * When the data is loaded the grid will automatically refresh to show these new rows
	               *
	               * <pre>
	               *      gridApi.treeBase.on.rowExpanded(scope,function(row){})
	               * </pre>
	               * @param {gridRow} row the row that was expanded.  You can also
	               * retrieve the grid from this row with row.grid
	               */
	              rowExpanded: {},
	
	              /**
	               * @ngdoc event
	               * @eventOf ui.grid.treeBase.api:PublicApi
	               * @name rowCollapsed
	               * @description raised whenever a row is collapsed.  Doesn't really have
	               * a purpose at the moment, included for symmetry
	               *
	               * <pre>
	               *      gridApi.treeBase.on.rowCollapsed(scope,function(row){})
	               * </pre>
	               * @param {gridRow} row the row that was collapsed.  You can also
	               * retrieve the grid from this row with row.grid
	               */
	              rowCollapsed: {}
	            }
	          },
	
	          methods: {
	            treeBase: {
	              /**
	               * @ngdoc function
	               * @name expandAllRows
	               * @methodOf  ui.grid.treeBase.api:PublicApi
	               * @description Expands all tree rows
	               */
	              expandAllRows: function () {
	                service.expandAllRows(grid);
	              },
	
	              /**
	               * @ngdoc function
	               * @name collapseAllRows
	               * @methodOf  ui.grid.treeBase.api:PublicApi
	               * @description collapse all tree rows
	               */
	              collapseAllRows: function () {
	                service.collapseAllRows(grid);
	              },
	
	              /**
	               * @ngdoc function
	               * @name toggleRowTreeState
	               * @methodOf  ui.grid.treeBase.api:PublicApi
	               * @description  call expand if the row is collapsed, collapse if it is expanded
	               * @param {gridRow} row the row you wish to toggle
	               */
	              toggleRowTreeState: function (row) {
	                service.toggleRowTreeState(grid, row);
	              },
	
	              /**
	               * @ngdoc function
	               * @name expandRow
	               * @methodOf  ui.grid.treeBase.api:PublicApi
	               * @description expand the immediate children of the specified row
	               * @param {gridRow} row the row you wish to expand
	               * @param {boolean} recursive true if you wish to expand the row's ancients
	               */
	              expandRow: function (row, recursive) {
	                service.expandRow(grid, row, recursive);
	              },
	
	              /**
	               * @ngdoc function
	               * @name expandRowChildren
	               * @methodOf  ui.grid.treeBase.api:PublicApi
	               * @description expand all children of the specified row
	               * @param {gridRow} row the row you wish to expand
	               */
	              expandRowChildren: function (row) {
	                service.expandRowChildren(grid, row);
	              },
	
	              /**
	               * @ngdoc function
	               * @name collapseRow
	               * @methodOf  ui.grid.treeBase.api:PublicApi
	               * @description collapse  the specified row.  When
	               * you expand the row again, all grandchildren will retain their state
	               * @param {gridRow} row the row you wish to collapse
	               */
	              collapseRow: function ( row ) {
	                service.collapseRow(grid, row);
	              },
	
	              /**
	               * @ngdoc function
	               * @name collapseRowChildren
	               * @methodOf  ui.grid.treeBase.api:PublicApi
	               * @description collapse all children of the specified row.  When
	               * you expand the row again, all grandchildren will be collapsed
	               * @param {gridRow} row the row you wish to collapse children for
	               */
	              collapseRowChildren: function ( row ) {
	                service.collapseRowChildren(grid, row);
	              },
	
	              /**
	               * @ngdoc function
	               * @name getTreeState
	               * @methodOf  ui.grid.treeBase.api:PublicApi
	               * @description Get the tree state for this grid,
	               * used by the saveState feature
	               * Returned treeState as an object
	               *   `{ expandedState: { uid: 'expanded', uid: 'collapsed' } }`
	               * where expandedState is a hash of row uid and the current expanded state
	               *
	               * @returns {object} tree state
	               *
	               * TODO - this needs work - we need an identifier that persists across instantiations,
	               * not uid.  This really means we need a row identity defined, but that won't work for
	               * grouping.  Perhaps this needs to be moved up to treeView and grouping, rather than
	               * being in base.
	               */
	              getTreeExpandedState: function () {
	                return { expandedState: service.getTreeState(grid) };
	              },
	
	              /**
	               * @ngdoc function
	               * @name setTreeState
	               * @methodOf  ui.grid.treeBase.api:PublicApi
	               * @description Set the expanded states of the tree
	               * @param {object} config the config you want to apply, in the format
	               * provided by getTreeState
	               */
	              setTreeState: function ( config ) {
	                service.setTreeState( grid, config );
	              },
	
	              /**
	               * @ngdoc function
	               * @name getRowChildren
	               * @methodOf  ui.grid.treeBase.api:PublicApi
	               * @description Get the children of the specified row
	               * @param {GridRow} row the row you want the children of
	               * @returns {Array} array of children of this row, the children
	               * are all gridRows
	               */
	              getRowChildren: function ( row ){
	                return row.treeNode.children.map( function( childNode ){
	                  return childNode.row;
	                });
	              }
	            }
	          }
	        };
	
	        grid.api.registerEventsFromObject(publicApi.events);
	
	        grid.api.registerMethodsFromObject(publicApi.methods);
	      },
	
	
	      defaultGridOptions: function (gridOptions) {
	        //default option to true unless it was explicitly set to false
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.treeBase.api:GridOptions
	         *
	         *  @description GridOptions for treeBase feature, these are available to be
	         *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	         */
	
	        /**
	         *  @ngdoc object
	         *  @name treeRowHeaderBaseWidth
	         *  @propertyOf  ui.grid.treeBase.api:GridOptions
	         *  @description Base width of the tree header, provides for a single level of tree.  This
	         *  is incremented by `treeIndent` for each extra level
	         *  <br/>Defaults to 30
	         */
	        gridOptions.treeRowHeaderBaseWidth = gridOptions.treeRowHeaderBaseWidth || 30;
	
	        /**
	         *  @ngdoc object
	         *  @name treeIndent
	         *  @propertyOf  ui.grid.treeBase.api:GridOptions
	         *  @description Number of pixels of indent for the icon at each tree level, wider indents are visually more pleasing,
	         *  but will make the tree row header wider
	         *  <br/>Defaults to 10
	         */
	        gridOptions.treeIndent = gridOptions.treeIndent || 10;
	
	        /**
	         *  @ngdoc object
	         *  @name showTreeRowHeader
	         *  @propertyOf  ui.grid.treeBase.api:GridOptions
	         *  @description If set to false, don't create the row header.  You'll need to programmatically control the expand
	         *  states
	         *  <br/>Defaults to true
	         */
	        gridOptions.showTreeRowHeader = gridOptions.showTreeRowHeader !== false;
	
	        /**
	         *  @ngdoc object
	         *  @name showTreeExpandNoChildren
	         *  @propertyOf  ui.grid.treeBase.api:GridOptions
	         *  @description If set to true, show the expand/collapse button even if there are no
	         *  children of a node.  You'd use this if you're planning to dynamically load the children
	         *
	         *  <br/>Defaults to true, grouping overrides to false
	         */
	        gridOptions.showTreeExpandNoChildren = gridOptions.showTreeExpandNoChildren !== false;
	
	        /**
	         *  @ngdoc object
	         *  @name treeRowHeaderAlwaysVisible
	         *  @propertyOf  ui.grid.treeBase.api:GridOptions
	         *  @description If set to true, row header even if there are no tree nodes
	         *
	         *  <br/>Defaults to true
	         */
	        gridOptions.treeRowHeaderAlwaysVisible = gridOptions.treeRowHeaderAlwaysVisible !== false;
	
	        /**
	         *  @ngdoc object
	         *  @name treeCustomAggregations
	         *  @propertyOf  ui.grid.treeBase.api:GridOptions
	         *  @description Define custom aggregation functions. The properties of this object will be
	         *  aggregation types available for use on columnDef with {@link ui.grid.treeBase.api:ColumnDef treeAggregationType} or through the column menu.
	         *  If a function defined here uses the same name as one of the native aggregations, this one will take precedence.
	         *  The object format is:
	         *
	         *  <pre>
	         *    {
	         *      aggregationName: {
	         *        label: (optional) string,
	         *        aggregationFn: function( aggregation, fieldValue, numValue, row ){...},
	         *        finalizerFn: (optional) function( aggregation ){...}
	         *      },
	         *      mean: {
	         *        label: 'mean',
	         *        aggregationFn: function( aggregation, fieldValue, numValue ){
	         *          aggregation.count = (aggregation.count || 1) + 1;
	         *          aggregation.sum = (aggregation.sum || 0) + numValue;
	         *        },
	         *        finalizerFn: function( aggregation ){
	         *          aggregation.value = aggregation.sum / aggregation.count
	         *        }
	         *      }
	         *    }
	         *  </pre>
	         *
	         *  <br/>The `finalizerFn` may be used to manipulate the value before rendering, or to
	         *  apply a custom rendered value. If `aggregation.rendered` is left undefined, the value will be
	         *  rendered. Note that the native aggregation functions use an `finalizerFn` to concatenate
	         *  the label and the value.
	         *
	         *  <br/>Defaults to {}
	         */
	        gridOptions.treeCustomAggregations = gridOptions.treeCustomAggregations || {};
	
	        /**
	         *  @ngdoc object
	         *  @name enableExpandAll
	         *  @propertyOf  ui.grid.treeBase.api:GridOptions
	         *  @description Enable the expand all button at the top of the row header
	         *
	         *  <br/>Defaults to true
	         */
	        gridOptions.enableExpandAll = gridOptions.enableExpandAll !== false;
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name treeBaseColumnBuilder
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Sets the tree defaults based on the columnDefs
	       *
	       * @param {object} colDef columnDef we're basing on
	       * @param {GridColumn} col the column we're to update
	       * @param {object} gridOptions the options we should use
	       * @returns {promise} promise for the builder - actually we do it all inline so it's immediately resolved
	       */
	      treeBaseColumnBuilder: function (colDef, col, gridOptions) {
	
	
	        /**
	         *  @ngdoc object
	         *  @name customTreeAggregationFn
	         *  @propertyOf  ui.grid.treeBase.api:ColumnDef
	         *  @description A custom function that aggregates rows into some form of
	         *  total.  Aggregations run row-by-row, the function needs to be capable of
	         *  creating a running total.
	         *
	         *  The function will be provided the aggregation item (in which you can store running
	         *  totals), the row value that is to be aggregated, and that same row value converted to
	         *  a number (most aggregations work on numbers)
	         *  @example
	         *  <pre>
	         *    customTreeAggregationFn = function ( aggregation, fieldValue, numValue, row ){
	         *      // calculates the average of the squares of the values
	         *      if ( typeof(aggregation.count) === 'undefined' ){
	         *        aggregation.count = 0;
	         *      }
	         *      aggregation.count++;
	         *
	         *      if ( !isNaN(numValue) ){
	         *        if ( typeof(aggregation.total) === 'undefined' ){
	         *          aggregation.total = 0;
	         *        }
	         *        aggregation.total = aggregation.total + numValue * numValue;
	         *      }
	         *
	         *      aggregation.value = aggregation.total / aggregation.count;
	         *    }
	         *  </pre>
	         *  <br/>Defaults to undefined. May be overwritten by treeAggregationType, the two options should not be used together.
	         */
	        if ( typeof(colDef.customTreeAggregationFn) !== 'undefined' ){
	          col.treeAggregationFn = colDef.customTreeAggregationFn;
	        }
	
	        /**
	         *  @ngdoc object
	         *  @name treeAggregationType
	         *  @propertyOf  ui.grid.treeBase.api:ColumnDef
	         *  @description Use one of the native or grid-level aggregation methods for calculating aggregations on this column.
	         *  Native method are in the constants file and include: SUM, COUNT, MIN, MAX, AVG. This may also be the property the
	         *  name of an aggregation function defined with {@link ui.grid.treeBase.api:GridOptions treeCustomAggregations}.
	         *
	         *  <pre>
	         *      treeAggregationType = uiGridTreeBaseConstants.aggregation.SUM,
	         *    }
	         *  </pre>
	         *
	         *  If you are using aggregations you should either:
	         *
	         *   - also use grouping, in which case the aggregations are displayed in the group header, OR
	         *   - use treeView, in which case you can set `treeAggregationUpdateEntity: true` in the colDef, and
	         *     treeBase will store the aggregation information in the entity, or you can set `treeAggregationUpdateEntity: false`
	         *     in the colDef, and you need to manual retrieve the calculated aggregations from the row.treeNode.aggregations
	         *
	         *  <br/>Takes precendence over a treeAggregationFn, the two options should not be used together.
	         *  <br/>Defaults to undefined.
	         */
	        if ( typeof(colDef.treeAggregationType) !== 'undefined' ){
	          col.treeAggregation = { type: colDef.treeAggregationType };
	          if ( typeof(gridOptions.treeCustomAggregations[colDef.treeAggregationType]) !== 'undefined' ){
	            col.treeAggregationFn = gridOptions.treeCustomAggregations[colDef.treeAggregationType].aggregationFn;
	            col.treeAggregationFinalizerFn = gridOptions.treeCustomAggregations[colDef.treeAggregationType].finalizerFn;
	            col.treeAggregation.label = gridOptions.treeCustomAggregations[colDef.treeAggregationType].label;
	          } else if ( typeof(service.nativeAggregations()[colDef.treeAggregationType]) !== 'undefined' ){
	            col.treeAggregationFn = service.nativeAggregations()[colDef.treeAggregationType].aggregationFn;
	            col.treeAggregation.label = service.nativeAggregations()[colDef.treeAggregationType].label;
	          }
	        }
	
	         /**
	         *  @ngdoc object
	         *  @name treeAggregationLabel
	         *  @propertyOf  ui.grid.treeBase.api:ColumnDef
	         *  @description A custom label to use for this aggregation. If provided we don't use native i18n.
	         */
	        if ( typeof(colDef.treeAggregationLabel) !== 'undefined' ){
	          if (typeof(col.treeAggregation) === 'undefined' ){
	            col.treeAggregation = {};
	          }
	          col.treeAggregation.label = colDef.treeAggregationLabel;
	        }
	
	        /**
	         *  @ngdoc object
	         *  @name treeAggregationUpdateEntity
	         *  @propertyOf  ui.grid.treeBase.api:ColumnDef
	         *  @description Store calculated aggregations into the entity, allowing them
	         *  to be displayed in the grid using a standard cellTemplate.  This defaults to true,
	         *  if you are using grouping then you shouldn't set it to false, as then the aggregations won't
	         *  display.
	         *
	         *  If you are using treeView in most cases you'll want to set this to true.  This will result in
	         *  getCellValue returning the aggregation rather than whatever was stored in the cell attribute on
	         *  the entity.  If you want to render the underlying entity value (and do something else with the aggregation)
	         *  then you could use a custom cellTemplate to display `row.entity.myAttribute`, rather than using getCellValue.
	         *
	         *  <br/>Defaults to true
	         *
	         *  @example
	         *  <pre>
	         *    gridOptions.columns = [{
	         *      name: 'myCol',
	         *      treeAggregation: { type: uiGridTreeBaseConstants.aggregation.SUM },
	         *      treeAggregationUpdateEntity: true
	         *      cellTemplate: '<div>{{row.entity.myCol + " " + row.treeNode.aggregations[0].rendered}}</div>'
	         *    }];
	         * </pre>
	         */
	        col.treeAggregationUpdateEntity = colDef.treeAggregationUpdateEntity !== false;
	
	        /**
	         *  @ngdoc object
	         *  @name customTreeAggregationFinalizerFn
	         *  @propertyOf  ui.grid.treeBase.api:ColumnDef
	         *  @description A custom function that populates aggregation.rendered, this is called when
	         *  a particular aggregation has been fully calculated, and we want to render the value.
	         *
	         *  With the native aggregation options we just concatenate `aggregation.label` and
	         *  `aggregation.value`, but if you wanted to apply a filter or otherwise manipulate the label
	         *  or the value, you can do so with this function. This function will be called after the
	         *  the default `finalizerFn`.
	         *
	         *  @example
	         *  <pre>
	         *    customTreeAggregationFinalizerFn = function ( aggregation ){
	         *      aggregation.rendered = aggregation.label + aggregation.value / 100 + '%';
	         *    }
	         *  </pre>
	         *  <br/>Defaults to undefined.
	         */
	        if ( typeof(col.customTreeAggregationFinalizerFn) === 'undefined' ){
	          col.customTreeAggregationFinalizerFn = colDef.customTreeAggregationFinalizerFn;
	        }
	
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name createRowHeader
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Create the rowHeader.  If treeRowHeaderAlwaysVisible then
	       * set it to visible, otherwise set it to invisible
	       *
	       * @param {Grid} grid grid object
	       */
	      createRowHeader: function( grid ){
	        var rowHeaderColumnDef = {
	          name: uiGridTreeBaseConstants.rowHeaderColName,
	          displayName: '',
	          width:  grid.options.treeRowHeaderBaseWidth,
	          minWidth: 10,
	          cellTemplate: 'ui-grid/treeBaseRowHeader',
	          headerCellTemplate: 'ui-grid/treeBaseHeaderCell',
	          enableColumnResizing: false,
	          enableColumnMenu: false,
	          exporterSuppressExport: true,
	          allowCellFocus: true
	        };
	
	        rowHeaderColumnDef.visible = grid.options.treeRowHeaderAlwaysVisible;
	        grid.addRowHeaderColumn(rowHeaderColumnDef, -100);
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name expandAllRows
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Expands all nodes in the tree
	       *
	       * @param {Grid} grid grid object
	       */
	      expandAllRows: function (grid) {
	        grid.treeBase.tree.forEach( function( node ) {
	          service.setAllNodes( grid, node, uiGridTreeBaseConstants.EXPANDED);
	        });
	        grid.treeBase.expandAll = true;
	        grid.queueGridRefresh();
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name collapseAllRows
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Collapses all nodes in the tree
	       *
	       * @param {Grid} grid grid object
	       */
	      collapseAllRows: function (grid) {
	        grid.treeBase.tree.forEach( function( node ) {
	          service.setAllNodes( grid, node, uiGridTreeBaseConstants.COLLAPSED);
	        });
	        grid.treeBase.expandAll = false;
	        grid.queueGridRefresh();
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name setAllNodes
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Works through a subset of grid.treeBase.rowExpandedStates, setting
	       * all child nodes (and their descendents) of the provided node to the given state.
	       *
	       * Calls itself recursively on all nodes so as to achieve this.
	       *
	       * @param {Grid} grid the grid we're operating on (so we can raise events)
	       * @param {object} treeNode a node in the tree that we want to update
	       * @param {string} targetState the state we want to set it to
	       */
	      setAllNodes: function (grid, treeNode, targetState) {
	        if ( typeof(treeNode.state) !== 'undefined' && treeNode.state !== targetState ){
	          treeNode.state = targetState;
	
	          if ( targetState === uiGridTreeBaseConstants.EXPANDED ){
	            grid.api.treeBase.raise.rowExpanded(treeNode.row);
	          } else {
	            grid.api.treeBase.raise.rowCollapsed(treeNode.row);
	          }
	        }
	
	        // set all child nodes
	        if ( treeNode.children ){
	          treeNode.children.forEach(function( childNode ){
	            service.setAllNodes(grid, childNode, targetState);
	          });
	        }
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name toggleRowTreeState
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Toggles the expand or collapse state of this grouped row, if
	       * it's a parent row
	       *
	       * @param {Grid} grid grid object
	       * @param {GridRow} row the row we want to toggle
	       */
	      toggleRowTreeState: function ( grid, row ){
	        if ( typeof(row.treeLevel) === 'undefined' || row.treeLevel === null || row.treeLevel < 0 ){
	          return;
	        }
	
	        if (row.treeNode.state === uiGridTreeBaseConstants.EXPANDED){
	          service.collapseRow(grid, row);
	        } else {
	          service.expandRow(grid, row, false);
	        }
	
	        grid.queueGridRefresh();
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name expandRow
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Expands this specific row, showing only immediate children.
	       *
	       * @param {Grid} grid grid object
	       * @param {GridRow} row the row we want to expand
	       * @param {boolean} recursive true if you wish to expand the row's ancients
	       */
	      expandRow: function ( grid, row, recursive ){
	        if ( recursive ){
	          var parents = [];
	          while ( row && typeof(row.treeLevel) !== 'undefined' && row.treeLevel !== null && row.treeLevel >= 0 && row.treeNode.state !== uiGridTreeBaseConstants.EXPANDED ){
	            parents.push(row);
	            row = row.treeNode.parentRow;
	          }
	
	          if ( parents.length > 0 ){
	            row = parents.pop();
	            while ( row ){
	                row.treeNode.state = uiGridTreeBaseConstants.EXPANDED;
	                grid.api.treeBase.raise.rowExpanded(row);
	                row = parents.pop();
	            }
	
	            grid.treeBase.expandAll = service.allExpanded(grid.treeBase.tree);
	            grid.queueGridRefresh();
	          }
	        } else {
	          if ( typeof(row.treeLevel) === 'undefined' || row.treeLevel === null || row.treeLevel < 0 ){
	            return;
	          }
	
	          if ( row.treeNode.state !== uiGridTreeBaseConstants.EXPANDED ){
	            row.treeNode.state = uiGridTreeBaseConstants.EXPANDED;
	            grid.api.treeBase.raise.rowExpanded(row);
	            grid.treeBase.expandAll = service.allExpanded(grid.treeBase.tree);
	            grid.queueGridRefresh();
	          }
	        }
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name expandRowChildren
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Expands this specific row, showing all children.
	       *
	       * @param {Grid} grid grid object
	       * @param {GridRow} row the row we want to expand
	       */
	      expandRowChildren: function ( grid, row ){
	        if ( typeof(row.treeLevel) === 'undefined' || row.treeLevel === null || row.treeLevel < 0 ){
	          return;
	        }
	
	        service.setAllNodes(grid, row.treeNode, uiGridTreeBaseConstants.EXPANDED);
	        grid.treeBase.expandAll = service.allExpanded(grid.treeBase.tree);
	        grid.queueGridRefresh();
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name collapseRow
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Collapses this specific row
	       *
	       * @param {Grid} grid grid object
	       * @param {GridRow} row the row we want to collapse
	       */
	      collapseRow: function( grid, row ){
	        if ( typeof(row.treeLevel) === 'undefined' || row.treeLevel === null || row.treeLevel < 0 ){
	          return;
	        }
	
	        if ( row.treeNode.state !== uiGridTreeBaseConstants.COLLAPSED ){
	          row.treeNode.state = uiGridTreeBaseConstants.COLLAPSED;
	          grid.treeBase.expandAll = false;
	          grid.api.treeBase.raise.rowCollapsed(row);
	          grid.queueGridRefresh();
	        }
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name collapseRowChildren
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Collapses this specific row and all children
	       *
	       * @param {Grid} grid grid object
	       * @param {GridRow} row the row we want to collapse
	       */
	      collapseRowChildren: function( grid, row ){
	        if ( typeof(row.treeLevel) === 'undefined' || row.treeLevel === null || row.treeLevel < 0 ){
	          return;
	        }
	
	        service.setAllNodes(grid, row.treeNode, uiGridTreeBaseConstants.COLLAPSED);
	        grid.treeBase.expandAll = false;
	        grid.queueGridRefresh();
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name allExpanded
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Returns true if all rows are expanded, false
	       * if they're not.  Walks the tree to determine this.  Used
	       * to set the expandAll state.
	       *
	       * If the node has no children, then return true (it's immaterial
	       * whether it is expanded).  If the node has children, then return
	       * false if this node is collapsed, or if any child node is not all expanded
	       *
	       * @param {object} tree the grid to check
	       * @returns {boolean} whether or not the tree is all expanded
	       */
	      allExpanded: function( tree ){
	        var allExpanded = true;
	        tree.forEach( function( node ){
	          if ( !service.allExpandedInternal( node ) ){
	            allExpanded = false;
	          }
	        });
	        return allExpanded;
	      },
	
	      allExpandedInternal: function( treeNode ){
	        if ( treeNode.children && treeNode.children.length > 0 ){
	          if ( treeNode.state === uiGridTreeBaseConstants.COLLAPSED ){
	            return false;
	          }
	          var allExpanded = true;
	          treeNode.children.forEach( function( node ){
	            if ( !service.allExpandedInternal( node ) ){
	              allExpanded = false;
	            }
	          });
	          return allExpanded;
	        } else {
	          return true;
	        }
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name treeRows
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description The rowProcessor that adds the nodes to the tree, and sets the visible
	       * state of each row based on it's parent state
	       *
	       * Assumes it is always called after the sorting processor, and the grouping processor if there is one.
	       * Performs any tree sorts itself after having built the tree
	       *
	       * Processes all the rows in order, setting the group level based on the $$treeLevel in the associated
	       * entity, and setting the visible state based on the parent's state.
	       *
	       * Calculates the deepest level of tree whilst it goes, and updates that so that the header column can be correctly
	       * sized.
	       *
	       * Aggregates if necessary along the way.
	       *
	       * @param {array} renderableRows the rows we want to process, usually the output from the previous rowProcessor
	       * @returns {array} the updated rows
	       */
	      treeRows: function( renderableRows ) {
	        if (renderableRows.length === 0){
	          return renderableRows;
	        }
	
	        var grid = this;
	
	        grid.treeBase.tree = service.createTree( grid, renderableRows );
	        service.updateRowHeaderWidth( grid );
	
	        service.sortTree( grid );
	        service.fixFilter( grid );
	
	        return service.renderTree( grid.treeBase.tree );
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name createOrUpdateRowHeaderWidth
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Calculates the rowHeader width.
	       *
	       * If rowHeader is always present, updates the width.
	       *
	       * If rowHeader is only sometimes present (`treeRowHeaderAlwaysVisible: false`), determines whether there
	       * should be one, then creates or removes it as appropriate, with the created rowHeader having the
	       * right width.
	       *
	       * If there's never a rowHeader then never creates one: `showTreeRowHeader: false`
	       *
	       * @param {Grid} grid the grid we want to set the row header on
	       */
	      updateRowHeaderWidth: function( grid ){
	        var rowHeader = grid.getColumn(uiGridTreeBaseConstants.rowHeaderColName);
	
	        var newWidth = grid.options.treeRowHeaderBaseWidth + grid.options.treeIndent * Math.max(grid.treeBase.numberLevels - 1, 0);
	        if ( rowHeader && newWidth !== rowHeader.width ){
	          rowHeader.width = newWidth;
	          grid.queueRefresh();
	        }
	
	        var newVisibility = true;
	        if ( grid.options.showTreeRowHeader === false ){
	          newVisibility = false;
	        }
	        if ( grid.options.treeRowHeaderAlwaysVisible === false && grid.treeBase.numberLevels <= 0 ){
	          newVisibility = false;
	        }
	        if ( rowHeader  && rowHeader.visible !== newVisibility ) {
	          rowHeader.visible = newVisibility;
	          rowHeader.colDef.visible = newVisibility;
	          grid.queueGridRefresh();
	        }
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name renderTree
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Creates an array of rows based on the tree, exporting only
	       * the visible nodes and leaves
	       *
	       * @param {array} nodeList The list of nodes - can be grid.treeBase.tree, or can be node.children when
	       * we're calling recursively
	       * @returns {array} renderable rows
	       */
	      renderTree: function( nodeList ){
	        var renderableRows = [];
	
	        nodeList.forEach( function ( node ){
	          if ( node.row.visible ){
	            renderableRows.push( node.row );
	          }
	          if ( node.state === uiGridTreeBaseConstants.EXPANDED && node.children && node.children.length > 0 ){
	            renderableRows = renderableRows.concat( service.renderTree( node.children ) );
	          }
	        });
	        return renderableRows;
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name createTree
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Creates a tree from the renderableRows
	       *
	       * @param {Grid} grid The grid
	       * @param {array} renderableRows The rows we want to create a tree from
	       * @returns {object} The tree we've build
	       */
	      createTree: function( grid, renderableRows ) {
	        var currentLevel = -1;
	        var parents = [];
	        var currentState;
	        grid.treeBase.tree = [];
	        grid.treeBase.numberLevels = 0;
	        var aggregations = service.getAggregations( grid );
	
	        var createNode = function( row ){
	          if ( typeof(row.entity.$$treeLevel) !== 'undefined' && row.treeLevel !== row.entity.$$treeLevel ){
	            row.treeLevel = row.entity.$$treeLevel;
	          }
	
	          if ( row.treeLevel <= currentLevel ){
	            // pop any levels that aren't parents of this level, formatting the aggregation at the same time
	            while ( row.treeLevel <= currentLevel ){
	              var lastParent = parents.pop();
	              service.finaliseAggregations( lastParent );
	              currentLevel--;
	            }
	
	            // reset our current state based on the new parent, set to expanded if this is a level 0 node
	            if ( parents.length > 0 ){
	              currentState = service.setCurrentState(parents);
	            } else {
	              currentState = uiGridTreeBaseConstants.EXPANDED;
	            }
	          }
	
	          // aggregate if this is a leaf node
	          if ( ( typeof(row.treeLevel) === 'undefined' || row.treeLevel === null || row.treeLevel < 0 ) && row.visible  ){
	            service.aggregate( grid, row, parents );
	          }
	
	          // add this node to the tree
	          service.addOrUseNode(grid, row, parents, aggregations);
	
	          if ( typeof(row.treeLevel) !== 'undefined' && row.treeLevel !== null && row.treeLevel >= 0 ){
	            parents.push(row);
	            currentLevel++;
	            currentState = service.setCurrentState(parents);
	          }
	
	          // update the tree number of levels, so we can set header width if we need to
	          if ( grid.treeBase.numberLevels < row.treeLevel + 1){
	            grid.treeBase.numberLevels = row.treeLevel + 1;
	          }
	        };
	
	        renderableRows.forEach( createNode );
	
	        // finalise remaining aggregations
	        while ( parents.length > 0 ){
	          var lastParent = parents.pop();
	          service.finaliseAggregations( lastParent );
	        }
	
	        return grid.treeBase.tree;
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name addOrUseNode
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Creates a tree node for this row.  If this row already has a treeNode
	       * recorded against it, preserves the state, but otherwise overwrites the data.
	       *
	       * @param {grid} grid The grid we're operating on
	       * @param {gridRow} row The row we want to set
	       * @param {array} parents An array of the parents this row should have
	       * @param {array} aggregationBase Empty aggregation information
	       * @returns {undefined} Updates the parents array, updates the row to have a treeNode, and updates the
	       * grid.treeBase.tree
	       */
	      addOrUseNode: function( grid, row, parents, aggregationBase ){
	        var newAggregations = [];
	        aggregationBase.forEach( function(aggregation){
	          newAggregations.push(service.buildAggregationObject(aggregation.col));
	        });
	
	        var newNode = { state: uiGridTreeBaseConstants.COLLAPSED, row: row, parentRow: null, aggregations: newAggregations, children: [] };
	        if ( row.treeNode ){
	          newNode.state = row.treeNode.state;
	        }
	        if ( parents.length > 0 ){
	          newNode.parentRow = parents[parents.length - 1];
	        }
	        row.treeNode = newNode;
	
	        if ( parents.length === 0 ){
	          grid.treeBase.tree.push( newNode );
	        } else {
	          parents[parents.length - 1].treeNode.children.push( newNode );
	        }
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name setCurrentState
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Looks at the parents array to determine our current state.
	       * If any node in the hierarchy is collapsed, then return collapsed, otherwise return
	       * expanded.
	       *
	       * @param {array} parents An array of the parents this row should have
	       * @returns {string} The state we should be setting to any nodes we see
	       */
	      setCurrentState: function( parents ){
	        var currentState = uiGridTreeBaseConstants.EXPANDED;
	        parents.forEach( function(parent){
	          if ( parent.treeNode.state === uiGridTreeBaseConstants.COLLAPSED ){
	            currentState = uiGridTreeBaseConstants.COLLAPSED;
	          }
	        });
	        return currentState;
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name sortTree
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Performs a recursive sort on the tree nodes, sorting the
	       * children of each node and putting them back into the children array.
	       *
	       * Before doing this it turns back on all the sortIgnore - things that were previously
	       * ignored we process now.  Since we're sorting within the nodes, presumably anything
	       * that was already sorted is how we derived the nodes, we can keep those sorts too.
	       *
	       * We only sort tree nodes that are expanded - no point in wasting effort sorting collapsed
	       * nodes
	       *
	       * @param {Grid} grid The grid to get the aggregation information from
	       * @returns {array} The aggregation information
	       */
	      sortTree: function( grid ){
	        grid.columns.forEach( function( column ) {
	          if ( column.sort && column.sort.ignoreSort ){
	            delete column.sort.ignoreSort;
	          }
	        });
	
	        grid.treeBase.tree = service.sortInternal( grid, grid.treeBase.tree );
	      },
	
	      sortInternal: function( grid, treeList ){
	        var rows = treeList.map( function( node ){
	          return node.row;
	        });
	
	        rows = rowSorter.sort( grid, rows, grid.columns );
	
	        var treeNodes = rows.map( function( row ){
	          return row.treeNode;
	        });
	
	        treeNodes.forEach( function( node ){
	          if ( node.state === uiGridTreeBaseConstants.EXPANDED && node.children && node.children.length > 0 ){
	            node.children = service.sortInternal( grid, node.children );
	          }
	        });
	
	        return treeNodes;
	      },
	
	      /**
	       * @ngdoc function
	       * @name fixFilter
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description After filtering has run, we need to go back through the tree
	       * and make sure the parent rows are always visible if any of the child rows
	       * are visible (filtering may make a child visible, but the parent may not
	       * match the filter criteria)
	       *
	       * This has a risk of being computationally expensive, we do it by walking
	       * the tree and remembering whether there are any invisible nodes on the
	       * way down.
	       *
	       * @param {Grid} grid the grid to fix filters on
	       */
	      fixFilter: function( grid ){
	        var parentsVisible;
	
	        grid.treeBase.tree.forEach( function( node ){
	          if ( node.children && node.children.length > 0 ){
	            parentsVisible = node.row.visible;
	            service.fixFilterInternal( node.children, parentsVisible );
	          }
	        });
	      },
	
	      fixFilterInternal: function( nodes, parentsVisible) {
	        nodes.forEach( function( node ){
	          if ( node.row.visible && !parentsVisible ){
	            service.setParentsVisible( node );
	            parentsVisible = true;
	          }
	
	          if ( node.children && node.children.length > 0 ){
	            if ( service.fixFilterInternal( node.children, ( parentsVisible && node.row.visible ) ) ) {
	              parentsVisible = true;
	            }
	          }
	        });
	
	        return parentsVisible;
	      },
	
	      setParentsVisible: function( node ){
	        while ( node.parentRow ){
	          node.parentRow.visible = true;
	          node = node.parentRow.treeNode;
	        }
	      },
	
	      /**
	       * @ngdoc function
	       * @name buildAggregationObject
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Build the object which is stored on the column for holding meta-data about the aggregation.
	       * This method should only be called with columns which have an aggregation.
	       *
	       * @param {GridColumn} column The column which this object relates to
	       * @returns {object} {col: GridColumn object, label: string, type: string (optional)}
	       */
	      buildAggregationObject: function( column ){
	        var newAggregation = { col: column };
	
	        if ( column.treeAggregation && column.treeAggregation.type ){
	          newAggregation.type = column.treeAggregation.type;
	        }
	
	        if ( column.treeAggregation && column.treeAggregation.label ){
	          newAggregation.label = column.treeAggregation.label;
	        }
	
	        return newAggregation;
	      },
	
	      /**
	       * @ngdoc function
	       * @name getAggregations
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Looks through the grid columns to find those with aggregations,
	       * and collates the aggregation information into an array, returns that array
	       *
	       * @param {Grid} grid the grid to get the aggregation information from
	       * @returns {array} the aggregation information
	       */
	      getAggregations: function( grid ){
	        var aggregateArray = [];
	
	        grid.columns.forEach( function(column){
	          if ( typeof(column.treeAggregationFn) !== 'undefined' ){
	            aggregateArray.push( service.buildAggregationObject(column) );
	
	            if ( grid.options.showColumnFooter && typeof(column.colDef.aggregationType) === 'undefined' && column.treeAggregation ){
	              // Add aggregation object for footer
	              column.treeFooterAggregation = service.buildAggregationObject(column);
	              column.aggregationType = service.treeFooterAggregationType;
	            }
	          }
	        });
	        return aggregateArray;
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name aggregate
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Accumulate the data from this row onto the aggregations for each parent
	       *
	       * Iterate over the parents, then iterate over the aggregations for each of those parents,
	       * and perform the aggregation for each individual aggregation
	       *
	       * @param {Grid} grid grid object
	       * @param {GridRow} row the row we want to set grouping visibility on
	       * @param {array} parents the parents that we would want to aggregate onto
	       */
	      aggregate: function( grid, row, parents ){
	        if ( parents.length === 0 && row.treeNode && row.treeNode.aggregations ){
	          row.treeNode.aggregations.forEach(function(aggregation){
	            // Calculate aggregations for footer even if there are no grouped rows
	            if ( typeof(aggregation.col.treeFooterAggregation) !== 'undefined' ) {
	              var fieldValue = grid.getCellValue(row, aggregation.col);
	              var numValue = Number(fieldValue);
	              aggregation.col.treeAggregationFn(aggregation.col.treeFooterAggregation, fieldValue, numValue, row);
	            }
	          });
	        }
	
	        parents.forEach( function( parent, index ){
	          if ( parent.treeNode.aggregations ){
	            parent.treeNode.aggregations.forEach( function( aggregation ){
	              var fieldValue = grid.getCellValue(row, aggregation.col);
	              var numValue = Number(fieldValue);
	              aggregation.col.treeAggregationFn(aggregation, fieldValue, numValue, row);
	
	              if ( index === 0 && typeof(aggregation.col.treeFooterAggregation) !== 'undefined' ){
	                aggregation.col.treeAggregationFn(aggregation.col.treeFooterAggregation, fieldValue, numValue, row);
	              }
	            });
	          }
	        });
	      },
	
	
	      // Aggregation routines - no doco needed as self evident
	      nativeAggregations: function() {
	        var nativeAggregations = {
	          count: {
	            label: i18nService.get().aggregation.count,
	            menuTitle: i18nService.get().grouping.aggregate_count,
	            aggregationFn: function (aggregation, fieldValue, numValue) {
	              if (typeof(aggregation.value) === 'undefined') {
	                aggregation.value = 1;
	              } else {
	                aggregation.value++;
	              }
	            }
	          },
	
	          sum: {
	            label: i18nService.get().aggregation.sum,
	            menuTitle: i18nService.get().grouping.aggregate_sum,
	            aggregationFn: function( aggregation, fieldValue, numValue ) {
	              if (!isNaN(numValue)) {
	                if (typeof(aggregation.value) === 'undefined') {
	                  aggregation.value = numValue;
	                } else {
	                  aggregation.value += numValue;
	                }
	              }
	            }
	          },
	
	          min: {
	            label: i18nService.get().aggregation.min,
	            menuTitle: i18nService.get().grouping.aggregate_min,
	            aggregationFn: function( aggregation, fieldValue, numValue ) {
	              if (typeof(aggregation.value) === 'undefined') {
	                aggregation.value = fieldValue;
	              } else {
	                if (typeof(fieldValue) !== 'undefined' && fieldValue !== null && (fieldValue < aggregation.value || aggregation.value === null)) {
	                  aggregation.value = fieldValue;
	                }
	              }
	            }
	          },
	
	          max: {
	            label: i18nService.get().aggregation.max,
	            menuTitle: i18nService.get().grouping.aggregate_max,
	            aggregationFn: function( aggregation, fieldValue, numValue ){
	              if ( typeof(aggregation.value) === 'undefined' ){
	                aggregation.value = fieldValue;
	              } else {
	                if ( typeof(fieldValue) !== 'undefined' && fieldValue !== null && (fieldValue > aggregation.value || aggregation.value === null)){
	                  aggregation.value = fieldValue;
	                }
	              }
	            }
	          },
	
	          avg: {
	            label: i18nService.get().aggregation.avg,
	            menuTitle: i18nService.get().grouping.aggregate_avg,
	            aggregationFn: function( aggregation, fieldValue, numValue ){
	              if ( typeof(aggregation.count) === 'undefined' ){
	                aggregation.count = 1;
	              } else {
	                aggregation.count++;
	              }
	
	              if ( isNaN(numValue) ){
	                return;
	              }
	
	              if ( typeof(aggregation.value) === 'undefined' || typeof(aggregation.sum) === 'undefined' ){
	                aggregation.value = numValue;
	                aggregation.sum = numValue;
	              } else {
	                aggregation.sum += numValue;
	                aggregation.value = aggregation.sum / aggregation.count;
	              }
	            }
	          }
	        };
	        return nativeAggregations;
	      },
	
	      /**
	       * @ngdoc function
	       * @name finaliseAggregation
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Helper function used to finalize aggregation nodes and footer cells
	       *
	       * @param {gridRow} row The parent we're finalising
	       * @param {aggregation} aggregation The aggregation object manipulated by the aggregationFn
	       */
	      finaliseAggregation: function(row, aggregation){
	        if ( aggregation.col.treeAggregationUpdateEntity && typeof(row) !== 'undefined' && typeof(row.entity[ '$$' + aggregation.col.uid ]) !== 'undefined' ){
	          angular.extend( aggregation, row.entity[ '$$' + aggregation.col.uid ]);
	        }
	
	        if ( typeof(aggregation.col.treeAggregationFinalizerFn) === 'function' ){
	          aggregation.col.treeAggregationFinalizerFn( aggregation );
	        }
	        if ( typeof(aggregation.col.customTreeAggregationFinalizerFn) === 'function' ){
	          aggregation.col.customTreeAggregationFinalizerFn( aggregation );
	        }
	        if ( typeof(aggregation.rendered) === 'undefined' ){
	          aggregation.rendered = aggregation.label ? aggregation.label + aggregation.value : aggregation.value;
	        }
	      },
	
	      /**
	       * @ngdoc function
	       * @name finaliseAggregations
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Format the data from the aggregation into the rendered text
	       * e.g. if we had label: 'sum: ' and value: 25, we'd create 'sum: 25'.
	       *
	       * As part of this we call any formatting callback routines we've been provided.
	       *
	       * We write our aggregation out to the row.entity if treeAggregationUpdateEntity is
	       * set on the column - we don't overwrite any information that's already there, we append
	       * to it so that grouping can have set the groupVal beforehand without us overwriting it.
	       *
	       * We need to copy the data from the row.entity first before we finalise the aggregation,
	       * we need that information for the finaliserFn
	       *
	       * @param {gridRow} row the parent we're finalising
	       */
	      finaliseAggregations: function( row ){
	        if ( row == null || typeof(row.treeNode.aggregations) === 'undefined' ){
	          return;
	        }
	
	        row.treeNode.aggregations.forEach( function( aggregation ) {
	          service.finaliseAggregation(row, aggregation);
	
	          if ( aggregation.col.treeAggregationUpdateEntity ){
	            var aggregationCopy = {};
	            angular.forEach( aggregation, function( value, key ){
	              if ( aggregation.hasOwnProperty(key) && key !== 'col' ){
	                aggregationCopy[key] = value;
	              }
	            });
	
	            row.entity[ '$$' + aggregation.col.uid ] = aggregationCopy;
	          }
	        });
	      },
	
	      /**
	       * @ngdoc function
	       * @name treeFooterAggregationType
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Uses the tree aggregation functions and finalizers to set the
	       * column footer aggregations.
	       *
	       * @param {rows} rows The visible rows. not used, but accepted to match signature of GridColumn.aggregationType
	       * @param {GridColumn} column The column we are finalizing
	       */
	      treeFooterAggregationType: function( rows, column ) {
	        service.finaliseAggregation(undefined, column.treeFooterAggregation);
	        if ( typeof(column.treeFooterAggregation.value) === 'undefined' || column.treeFooterAggregation.rendered === null ){
	          // The was apparently no aggregation performed (perhaps this is a grouped column
	          return '';
	        }
	        return column.treeFooterAggregation.rendered;
	      }
	    };
	
	    return service;
	
	  }]);
	
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.treeBase.directive:uiGridTreeRowHeaderButtons
	   *  @element div
	   *
	   *  @description Provides the expand/collapse button on rows
	   */
	  module.directive('uiGridTreeBaseRowHeaderButtons', ['$templateCache', 'uiGridTreeBaseService',
	  function ($templateCache, uiGridTreeBaseService) {
	    return {
	      replace: true,
	      restrict: 'E',
	      template: $templateCache.get('ui-grid/treeBaseRowHeaderButtons'),
	      scope: true,
	      require: '^uiGrid',
	      link: function($scope, $elm, $attrs, uiGridCtrl) {
	        var self = uiGridCtrl.grid;
	        $scope.treeButtonClick = function(row, evt) {
	          evt.stopPropagation();
	          uiGridTreeBaseService.toggleRowTreeState(self, row, evt);
	        };
	      }
	    };
	  }]);
	
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.treeBase.directive:uiGridTreeBaseExpandAllButtons
	   *  @element div
	   *
	   *  @description Provides the expand/collapse all button
	   */
	  module.directive('uiGridTreeBaseExpandAllButtons', ['$templateCache', 'uiGridTreeBaseService',
	  function ($templateCache, uiGridTreeBaseService) {
	    return {
	      replace: true,
	      restrict: 'E',
	      template: $templateCache.get('ui-grid/treeBaseExpandAllButtons'),
	      scope: false,
	      link: function($scope, $elm, $attrs, uiGridCtrl) {
	        var self = $scope.col.grid;
	
	        $scope.headerButtonClick = function(row, evt) {
	          if ( self.treeBase.expandAll ){
	            uiGridTreeBaseService.collapseAllRows(self, evt);
	          } else {
	            uiGridTreeBaseService.expandAllRows(self, evt);
	          }
	        };
	      }
	    };
	  }]);
	
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.treeBase.directive:uiGridViewport
	   *  @element div
	   *
	   *  @description Stacks on top of ui.grid.uiGridViewport to set formatting on a tree header row
	   */
	  module.directive('uiGridViewport',
	  ['$compile', 'uiGridConstants', 'gridUtil', '$parse',
	    function ($compile, uiGridConstants, gridUtil, $parse) {
	      return {
	        priority: -200, // run after default  directive
	        scope: false,
	        compile: function ($elm, $attrs) {
	          var rowRepeatDiv = angular.element($elm.children().children()[0]);
	
	          var existingNgClass = rowRepeatDiv.attr("ng-class");
	          var newNgClass = '';
	          if ( existingNgClass ) {
	            newNgClass = existingNgClass.slice(0, -1) + ",'ui-grid-tree-header-row': row.treeLevel > -1}";
	          } else {
	            newNgClass = "{'ui-grid-tree-header-row': row.treeLevel > -1}";
	          }
	          rowRepeatDiv.attr("ng-class", newNgClass);
	
	          return {
	            pre: function ($scope, $elm, $attrs, controllers) {
	
	            },
	            post: function ($scope, $elm, $attrs, controllers) {
	            }
	          };
	        }
	      };
	    }]);
	})();
	
	(function () {
	  'use strict';
	
	  /**
	   * @ngdoc overview
	   * @name ui.grid.treeView
	   * @description
	   *
	   * # ui.grid.treeView
	   *
	   * <div class="alert alert-warning" role="alert"><strong>Beta</strong> This feature is ready for testing, but it either hasn't seen a lot of use or has some known bugs.</div>
	   *
	   * This module provides a tree view of the data that it is provided, with nodes in that
	   * tree and leaves.  Unlike grouping, the tree is an inherent property of the data and must
	   * be provided with your data array.
	   *
	   * Design information:
	   * -------------------
	   *
	   * TreeView uses treeBase for the underlying functionality, and is a very thin wrapper around
	   * that logic.  Most of the design information has now moved to treebase.
	   * <br/>
	   * <br/>
	   *
	   * <div doc-module-components="ui.grid.treeView"></div>
	   */
	
	  var module = angular.module('ui.grid.treeView', ['ui.grid', 'ui.grid.treeBase']);
	
	  /**
	   *  @ngdoc object
	   *  @name ui.grid.treeView.constant:uiGridTreeViewConstants
	   *
	   *  @description constants available in treeView module, this includes
	   *  all the constants declared in the treeBase module (these are manually copied
	   *  as there isn't an easy way to include constants in another constants file, and
	   *  we don't want to make users include treeBase)
	   *
	   */
	  module.constant('uiGridTreeViewConstants', {
	    featureName: "treeView",
	    rowHeaderColName: 'treeBaseRowHeaderCol',
	    EXPANDED: 'expanded',
	    COLLAPSED: 'collapsed',
	    aggregation: {
	      COUNT: 'count',
	      SUM: 'sum',
	      MAX: 'max',
	      MIN: 'min',
	      AVG: 'avg'
	    }
	  });
	
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.treeView.service:uiGridTreeViewService
	   *
	   *  @description Services for treeView features
	   */
	  module.service('uiGridTreeViewService', ['$q', 'uiGridTreeViewConstants', 'uiGridTreeBaseConstants', 'uiGridTreeBaseService', 'gridUtil', 'GridRow', 'gridClassFactory', 'i18nService', 'uiGridConstants',
	  function ($q, uiGridTreeViewConstants, uiGridTreeBaseConstants, uiGridTreeBaseService, gridUtil, GridRow, gridClassFactory, i18nService, uiGridConstants) {
	
	    var service = {
	
	      initializeGrid: function (grid, $scope) {
	        uiGridTreeBaseService.initializeGrid( grid, $scope );
	
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.treeView.grid:treeView
	         *
	         *  @description Grid properties and functions added for treeView
	         */
	        grid.treeView = {};
	
	        grid.registerRowsProcessor(service.adjustSorting, 60);
	
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.treeView.api:PublicApi
	         *
	         *  @description Public Api for treeView feature
	         */
	        var publicApi = {
	          events: {
	            treeView: {
	            }
	          },
	          methods: {
	            treeView: {
	            }
	          }
	        };
	
	        grid.api.registerEventsFromObject(publicApi.events);
	
	        grid.api.registerMethodsFromObject(publicApi.methods);
	
	      },
	
	      defaultGridOptions: function (gridOptions) {
	        //default option to true unless it was explicitly set to false
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.treeView.api:GridOptions
	         *
	         *  @description GridOptions for treeView feature, these are available to be
	         *  set using the ui-grid {@link ui.grid.class:GridOptions gridOptions}
	         *
	         *  Many tree options are set on treeBase, make sure to look at that feature in
	         *  conjunction with these options.
	         */
	
	        /**
	         *  @ngdoc object
	         *  @name enableTreeView
	         *  @propertyOf  ui.grid.treeView.api:GridOptions
	         *  @description Enable row tree view for entire grid.
	         *  <br/>Defaults to true
	         */
	        gridOptions.enableTreeView = gridOptions.enableTreeView !== false;
	
	      },
	
	
	      /**
	       * @ngdoc function
	       * @name adjustSorting
	       * @methodOf  ui.grid.treeBase.service:uiGridTreeBaseService
	       * @description Trees cannot be sorted the same as flat lists of rows -
	       * trees are sorted recursively within each level - so the children of each
	       * node are sorted, but not the full set of rows.
	       *
	       * To achieve this, we suppress the normal sorting by setting ignoreSort on
	       * each of the sort columns.  When the treeBase rowsProcessor runs it will then
	       * unignore these, and will perform a recursive sort against the tree that it builds.
	       *
	       * @param {array} renderableRows the rows that we need to pass on through
	       * @returns {array} renderableRows that we passed on through
	       */
	      adjustSorting: function( renderableRows ) {
	        var grid = this;
	
	        grid.columns.forEach( function( column ){
	          if ( column.sort ){
	            column.sort.ignoreSort = true;
	          }
	        });
	
	        return renderableRows;
	      }
	
	    };
	
	    return service;
	
	  }]);
	
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.treeView.directive:uiGridTreeView
	   *  @element div
	   *  @restrict A
	   *
	   *  @description Adds treeView features to grid
	   *
	   *  @example
	   <example module="app">
	   <file name="app.js">
	   var app = angular.module('app', ['ui.grid', 'ui.grid.treeView']);
	
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	      $scope.data = [
	        { name: 'Bob', title: 'CEO' },
	            { name: 'Frank', title: 'Lowly Developer' }
	      ];
	
	      $scope.columnDefs = [
	        {name: 'name', enableCellEdit: true},
	        {name: 'title', enableCellEdit: true}
	      ];
	
	      $scope.gridOptions = { columnDefs: $scope.columnDefs, data: $scope.data };
	    }]);
	   </file>
	   <file name="index.html">
	   <div ng-controller="MainCtrl">
	   <div ui-grid="gridOptions" ui-grid-tree-view></div>
	   </div>
	   </file>
	   </example>
	   */
	  module.directive('uiGridTreeView', ['uiGridTreeViewConstants', 'uiGridTreeViewService', '$templateCache',
	  function (uiGridTreeViewConstants, uiGridTreeViewService, $templateCache) {
	    return {
	      replace: true,
	      priority: 0,
	      require: '^uiGrid',
	      scope: false,
	      compile: function () {
	        return {
	          pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	            if (uiGridCtrl.grid.options.enableTreeView !== false){
	              uiGridTreeViewService.initializeGrid(uiGridCtrl.grid, $scope);
	            }
	          },
	          post: function ($scope, $elm, $attrs, uiGridCtrl) {
	
	          }
	        };
	      }
	    };
	  }]);
	})();
	
	(function () {
	  'use strict';
	  
	  /**
	   * @ngdoc overview
	   * @name ui.grid.validate
	   * @description
	   *
	   * # ui.grid.validate
	   *
	   * <div class="alert alert-warning" role="alert"><strong>Alpha</strong> This feature is in development. There will almost certainly be breaking api changes, or there are major outstanding bugs.</div>
	   *
	   * This module provides the ability to validate cells upon change.
	   *
	   * Design information:
	   * -------------------
	   *
	   * Validation is not based on angularjs validation, since it would work only when editing the field.
	   * 
	   * Instead it adds custom properties to any field considered as invalid.
	   *
	   * <br/>
	   * <br/>
	   *
	   * <div doc-module-components="ui.grid.expandable"></div>
	   */
	
	  var module = angular.module('ui.grid.validate', ['ui.grid']);
	  
	  
	  /**
	   *  @ngdoc service
	   *  @name ui.grid.validate.service:uiGridValidateService
	   *
	   *  @description Services for validation features
	   */
	  module.service('uiGridValidateService', ['$sce', '$q', '$http', 'i18nService', 'uiGridConstants', function ($sce, $q, $http, i18nService, uiGridConstants) {
	
	    var service = {
	      
	      /**
	       *  @ngdoc object
	       *  @name validatorFactories
	       *  @propertyOf ui.grid.validate.service:uiGridValidateService
	       *  @description object containing all the factories used to validate data.<br/>
	       *  These factories will be in the form <br/>
	       *  ```
	       *  {
	       *    validatorFactory: function(argument) {
	       *                        return function(newValue, oldValue, rowEntity, colDef) {
	       *                          return true || false || promise
	       *                        }
	       *                      },
	       *    messageFunction: function(argument) {
	       *                       return string
	       *                     }
	       *  }
	       *  ```
	       *
	       * Promises should return true or false as result according to the result of validation.
	       */
	      validatorFactories: {},
	
	      
	      /**
	       * @ngdoc service
	       * @name setExternalFactoryFunction
	       * @methodOf ui.grid.validate.service:uiGridValidateService
	       * @description Adds a way to retrieve validators from an external service
	       * <p>Validators from this external service have a higher priority than default
	       * ones
	       * @param {function} externalFactoryFunction a function that accepts name and argument to pass to a
	       * validator factory and that returns an object with the same properties as 
	       * you can see in {@link ui.grid.validate.service:uiGridValidateService#properties_validatorFactories validatorFactories}
	       */
	      setExternalFactoryFunction: function(externalFactoryFunction) {
	        service.externalFactoryFunction = externalFactoryFunction;
	      },
	      
	      /**
	       * @ngdoc service
	       * @name clearExternalFactory
	       * @methodOf ui.grid.validate.service:uiGridValidateService
	       * @description Removes any link to external factory from this service
	       */
	      clearExternalFactory: function() {
	        delete service.externalFactoryFunction;
	      },
	
	      /**
	       * @ngdoc service
	       * @name getValidatorFromExternalFactory
	       * @methodOf ui.grid.validate.service:uiGridValidateService
	       * @description Retrieves a validator by executing a validatorFactory
	       * stored in an external service.
	       * @param {string} name the name of the validator to retrieve
	       * @param {object} argument an argument to pass to the validator factory
	       */
	      getValidatorFromExternalFactory: function(name, argument) {
	        return service.externalFactoryFunction(name, argument).validatorFactory(argument);
	      },
	      
	      /**
	       * @ngdoc service
	       * @name getMessageFromExternalFactory
	       * @methodOf ui.grid.validate.service:uiGridValidateService
	       * @description Retrieves a message stored in an external service.
	       * @param {string} name the name of the validator
	       * @param {object} argument an argument to pass to the message function
	       */
	      getMessageFromExternalFactory: function(name, argument) {
	        return service.externalFactoryFunction(name, argument).messageFunction(argument);
	      },
	      
	      /**
	       * @ngdoc service
	       * @name setValidator
	       * @methodOf ui.grid.validate.service:uiGridValidateService
	       * @description  Adds a new validator to the service
	       * @param {string} name the name of the validator, must be unique
	       * @param {function} validatorFactory a factory that return a validatorFunction
	       * @param {function} messageFunction a function that return the error message
	       */
	      setValidator: function(name, validatorFactory, messageFunction) {
	        service.validatorFactories[name] = {
	          validatorFactory: validatorFactory,
	          messageFunction: messageFunction
	        };
	      },
	
	      /**
	       * @ngdoc service
	       * @name getValidator
	       * @methodOf ui.grid.validate.service:uiGridValidateService
	       * @description Returns a validator registered to the service
	       * or retrieved from the external factory
	       * @param {string} name the name of the validator to retrieve
	       * @param {object} argument an argument to pass to the validator factory
	       * @returns {object} the validator function
	       */
	      getValidator: function(name, argument) {
	        if (service.externalFactoryFunction) {
	          var validator = service.getValidatorFromExternalFactory(name, argument);
	          if (validator) {
	            return validator;
	          }
	        }
	        if (!service.validatorFactories[name]) {
	          throw ("Invalid validator name: " + name);
	        }
	        return service.validatorFactories[name].validatorFactory(argument);
	      },
	
	      /**
	       * @ngdoc service
	       * @name getMessage
	       * @methodOf ui.grid.validate.service:uiGridValidateService
	       * @description Returns the error message related to the validator 
	       * @param {string} name the name of the validator
	       * @param {object} argument an argument to pass to the message function
	       * @returns {string} the error message related to the validator
	       */
	      getMessage: function(name, argument) {
	        if (service.externalFactoryFunction) {
	          var message = service.getMessageFromExternalFactory(name, argument);
	          if (message) {
	            return message;
	          }
	        }
	        return service.validatorFactories[name].messageFunction(argument);
	      },
	
	      /**
	       * @ngdoc service
	       * @name isInvalid
	       * @methodOf ui.grid.validate.service:uiGridValidateService
	       * @description Returns true if the cell (identified by rowEntity, colDef) is invalid 
	       * @param {object} rowEntity the row entity of the cell
	       * @param {object} colDef the colDef of the cell
	       * @returns {boolean} true if the cell is invalid
	       */
	      isInvalid: function (rowEntity, colDef) {
	        return rowEntity['$$invalid'+colDef.name];
	      },
	
	      /**
	       * @ngdoc service
	       * @name setInvalid
	       * @methodOf ui.grid.validate.service:uiGridValidateService
	       * @description Makes the cell invalid by adding the proper field to the entity
	       * @param {object} rowEntity the row entity of the cell
	       * @param {object} colDef the colDef of the cell
	       */
	      setInvalid: function (rowEntity, colDef) {
	        rowEntity['$$invalid'+colDef.name] = true;
	      },
	    
	      /**
	       * @ngdoc service
	       * @name setValid
	       * @methodOf ui.grid.validate.service:uiGridValidateService
	       * @description Makes the cell valid by removing the proper error field from the entity
	       * @param {object} rowEntity the row entity of the cell
	       * @param {object} colDef the colDef of the cell
	       */
	      setValid: function (rowEntity, colDef) {
	        delete rowEntity['$$invalid'+colDef.name];
	      },
	
	      /**
	       * @ngdoc service
	       * @name setError
	       * @methodOf ui.grid.validate.service:uiGridValidateService
	       * @description Adds the proper error to the entity errors field
	       * @param {object} rowEntity the row entity of the cell
	       * @param {object} colDef the colDef of the cell
	       * @param {string} validatorName the name of the validator that is failing
	       */
	      setError: function(rowEntity, colDef, validatorName) {
	        if (!rowEntity['$$errors'+colDef.name]) {
	          rowEntity['$$errors'+colDef.name] = {};
	        }
	        rowEntity['$$errors'+colDef.name][validatorName] = true;
	      },
	
	      /**
	       * @ngdoc service
	       * @name clearError
	       * @methodOf ui.grid.validate.service:uiGridValidateService
	       * @description Removes the proper error from the entity errors field
	       * @param {object} rowEntity the row entity of the cell
	       * @param {object} colDef the colDef of the cell
	       * @param {string} validatorName the name of the validator that is failing
	       */
	      clearError: function(rowEntity, colDef, validatorName) {
	        if (!rowEntity['$$errors'+colDef.name]) {
	          return;
	        }
	        if (validatorName in rowEntity['$$errors'+colDef.name]) {
	            delete rowEntity['$$errors'+colDef.name][validatorName];
	        }
	      },
	      
	      /**
	       * @ngdoc function
	       * @name getErrorMessages
	       * @methodOf ui.grid.validate.service:uiGridValidateService
	       * @description returns an array of i18n-ed error messages.
	       * @param {object} rowEntity gridOptions.data[] array instance whose errors we are looking for
	       * @param {object} colDef the column whose errors we are looking for
	       * @returns {array} An array of strings containing all the error messages for the cell
	       */
	      getErrorMessages: function(rowEntity, colDef) {
	        var errors = [];
	
	        if (!rowEntity['$$errors'+colDef.name] || Object.keys(rowEntity['$$errors'+colDef.name]).length === 0) {
	          return errors;
	        }
	
	        Object.keys(rowEntity['$$errors'+colDef.name]).sort().forEach(function(validatorName) {
	          errors.push(service.getMessage(validatorName, colDef.validators[validatorName]));
	        });
	        
	        return errors;
	      },
	      
	      /**
	       * @ngdoc function
	       * @name getFormattedErrors
	       * @methodOf  ui.grid.validate.service:uiGridValidateService
	       * @description returns the error i18n-ed and formatted in html to be shown inside the page.
	       * @param {object} rowEntity gridOptions.data[] array instance whose errors we are looking for
	       * @param {object} colDef the column whose errors we are looking for
	       * @returns {object} An object that can be used in a template (like a cellTemplate) to display the
	       * message inside the page (i.e. inside a div)
	       */
	      getFormattedErrors: function(rowEntity, colDef) {
	
	        var msgString = "";
	
	        var errors = service.getErrorMessages(rowEntity, colDef);
	        
	        if (!errors.length) {
	          return;
	        }
	        
	        errors.forEach(function(errorMsg) {
	          msgString += errorMsg + "<br/>";
	        });
	
	        return $sce.trustAsHtml('<p><b>' + i18nService.getSafeText('validate.error') + '</b></p>' + msgString );
	      },
	
	      /**
	       * @ngdoc function
	       * @name getTitleFormattedErrors
	       * @methodOf ui.grid.validate.service:uiGridValidateService
	       * @description returns the error i18n-ed and formatted in javaScript to be shown inside an html 
	       * title attribute.
	       * @param {object} rowEntity gridOptions.data[] array instance whose errors we are looking for
	       * @param {object} colDef the column whose errors we are looking for
	       * @returns {object} An object that can be used in a template (like a cellTemplate) to display the
	       * message inside an html title attribute
	       */
	      getTitleFormattedErrors: function(rowEntity, colDef) {
	
	        var newLine = "\n";
	
	        var msgString = "";
	        
	        var errors = service.getErrorMessages(rowEntity, colDef);
	        
	        if (!errors.length) {
	          return;
	        }
	        
	        errors.forEach(function(errorMsg) {
	          msgString += errorMsg + newLine;
	        });
	
	        return $sce.trustAsHtml(i18nService.getSafeText('validate.error') + newLine + msgString);
	      },
	
	      /**
	       * @ngdoc function
	       * @name getTitleFormattedErrors
	       * @methodOf ui.grid.validate.service:uiGridValidateService
	       * @description Executes all validators on a cell (identified by row entity and column definition) and sets or clears errors
	       * @param {object} rowEntity the row entity of the cell we want to run the validators on
	       * @param {object} colDef the column definition of the cell we want to run the validators on
	       * @param {object} newValue the value the user just entered
	       * @param {object} oldValue the value the field had before
	       */
	      runValidators: function(rowEntity, colDef, newValue, oldValue, grid) {
	        
	        if (newValue === oldValue) {
	          // If the value has not changed we perform no validation
	          return;
	        }
	        
	        if (typeof(colDef.name) === 'undefined' || !colDef.name) {
	          throw new Error('colDef.name is required to perform validation');
	        }
	        
	        service.setValid(rowEntity, colDef);
	        
	        var validateClosureFactory = function(rowEntity, colDef, validatorName) {
	          return function(value) {
	            if (!value) {
	              service.setInvalid(rowEntity, colDef);
	              service.setError(rowEntity, colDef, validatorName);
	              if (grid) {
	                grid.api.validate.raise.validationFailed(rowEntity, colDef, newValue, oldValue);
	              }
	            }
	          };
	        };
	
	        var promises = [];
	
	        for (var validatorName in colDef.validators) {
	          service.clearError(rowEntity, colDef, validatorName);
	          var msg;
	          var validatorFunction = service.getValidator(validatorName, colDef.validators[validatorName]);
	          // We pass the arguments as oldValue, newValue so they are in the same order 
	          // as ng-model validators (modelValue, viewValue)
	          var promise = $q
	                        .when(validatorFunction(oldValue, newValue, rowEntity, colDef))
	                        .then(validateClosureFactory(rowEntity, colDef, validatorName));
	          promises.push(promise);
	        }
	        
	        return $q.all(promises);
	      },
	
	      /**
	       * @ngdoc function
	       * @name createDefaultValidators
	       * @methodOf ui.grid.validate.service:uiGridValidateService
	       * @description adds the basic validators to the list of service validators
	       */
	      createDefaultValidators: function() {
	        service.setValidator('minLength',
	                             function (argument) {
	                               return function (oldValue, newValue, rowEntity, colDef) {
	                                 if (newValue === undefined || newValue === null || newValue === '') {
	                                   return true;
	                                 }
	                                 return newValue.length >= argument;
	                               };
	                             },
	                               function(argument) {
	                                 return i18nService.getSafeText('validate.minLength').replace('THRESHOLD', argument);
	                               });
	        
	        service.setValidator('maxLength',
	                             function (argument) {
	                               return function (oldValue, newValue, rowEntity, colDef) {
	                                 if (newValue === undefined || newValue === null || newValue === '') {
	                                   return true;
	                                 }
	                                 return newValue.length <= argument;
	                               };
	                             },
	                             function(threshold) {
	                               return i18nService.getSafeText('validate.maxLength').replace('THRESHOLD', threshold);
	                             });
	        
	        service.setValidator('required',
	                             function (argument) {
	                               return function (oldValue, newValue, rowEntity, colDef) {
	                                 if (argument) {
	                                   return !(newValue === undefined || newValue === null || newValue === '');
	                                 }
	                                 return true;
	                               };
	                             },
	                             function(argument) {
	                               return i18nService.getSafeText('validate.required');
	                             });
	      },
	
	      initializeGrid: function (scope, grid) {
	        grid.validate = {
	        
	          isInvalid: service.isInvalid,
	
	          getFormattedErrors: service.getFormattedErrors,
	         
	          getTitleFormattedErrors: service.getTitleFormattedErrors,
	
	          runValidators: service.runValidators
	        };
	        
	        /**
	         *  @ngdoc object
	         *  @name ui.grid.validate.api:PublicApi
	         *
	         *  @description Public Api for validation feature
	         */
	        var publicApi = {
	          events: {
	            validate: {
	              /**
	               * @ngdoc event
	               * @name validationFailed
	               * @eventOf  ui.grid.validate.api:PublicApi
	               * @description raised when one or more failure happened during validation 
	               * <pre>
	               *      gridApi.validate.on.validationFailed(scope, function(rowEntity, colDef, newValue, oldValue){...})
	               * </pre>
	               * @param {object} rowEntity the options.data element whose validation failed
	               * @param {object} colDef the column whose validation failed
	               * @param {object} newValue new value
	               * @param {object} oldValue old value
	               */
	              validationFailed: function (rowEntity, colDef, newValue, oldValue) {
	              }
	            }
	          },
	          methods: {
	            validate: {
	              /**
	               * @ngdoc function
	               * @name isInvalid
	               * @methodOf  ui.grid.validate.api:PublicApi
	               * @description checks if a cell (identified by rowEntity, colDef) is invalid
	               * @param {object} rowEntity gridOptions.data[] array instance we want to check
	               * @param {object} colDef the column whose errors we want to check
	               * @returns {boolean} true if the cell value is not valid
	               */
	              isInvalid: function(rowEntity, colDef) {
	                return grid.validate.isInvalid(rowEntity, colDef);
	              },
	              /**
	               * @ngdoc function
	               * @name getErrorMessages
	               * @methodOf  ui.grid.validate.api:PublicApi
	               * @description returns an array of i18n-ed error messages.
	               * @param {object} rowEntity gridOptions.data[] array instance whose errors we are looking for
	               * @param {object} colDef the column whose errors we are looking for
	               * @returns {array} An array of strings containing all the error messages for the cell
	               */
	              getErrorMessages: function (rowEntity, colDef) {
	                return grid.validate.getErrorMessages(rowEntity, colDef);
	              },
	              /**
	               * @ngdoc function
	               * @name getFormattedErrors
	               * @methodOf  ui.grid.validate.api:PublicApi
	               * @description returns the error i18n-ed and formatted in html to be shown inside the page.
	               * @param {object} rowEntity gridOptions.data[] array instance whose errors we are looking for
	               * @param {object} colDef the column whose errors we are looking for
	               * @returns {object} An object that can be used in a template (like a cellTemplate) to display the
	               * message inside the page (i.e. inside a div)
	               */
	              getFormattedErrors: function (rowEntity, colDef) {
	                return grid.validate.getFormattedErrors(rowEntity, colDef);
	              },
	              /**
	               * @ngdoc function
	               * @name getTitleFormattedErrors
	               * @methodOf  ui.grid.validate.api:PublicApi
	               * @description returns the error i18n-ed and formatted in javaScript to be shown inside an html 
	               * title attribute.
	               * @param {object} rowEntity gridOptions.data[] array instance whose errors we are looking for
	               * @param {object} colDef the column whose errors we are looking for
	               * @returns {object} An object that can be used in a template (like a cellTemplate) to display the
	               * message inside an html title attribute
	               */
	              getTitleFormattedErrors: function (rowEntity, colDef) {
	                return grid.validate.getTitleFormattedErrors(rowEntity, colDef);
	              }
	            } 
	          }
	        };
	        
	        grid.api.registerEventsFromObject(publicApi.events);
	        grid.api.registerMethodsFromObject(publicApi.methods);
	
	        if (grid.edit) {
	          grid.api.edit.on.afterCellEdit(scope, function(rowEntity, colDef, newValue, oldValue) {
	            grid.validate.runValidators(rowEntity, colDef, newValue, oldValue, grid);
	          });
	        }
	
	        service.createDefaultValidators();
	      }
	      
	    };
	  
	    return service;
	  }]);
	  
	  
	  /**
	   *  @ngdoc directive
	   *  @name ui.grid.validate.directive:uiGridValidate
	   *  @element div
	   *  @restrict A
	   *  @description Adds validating features to the ui-grid directive.
	   *  @example
	   <example module="app">
	   <file name="app.js">
	   var app = angular.module('app', ['ui.grid', 'ui.grid.edit', 'ui.grid.validate']);
	
	   app.controller('MainCtrl', ['$scope', function ($scope) {
	      $scope.data = [
	        { name: 'Bob', title: 'CEO' },
	            { name: 'Frank', title: 'Lowly Developer' }
	      ];
	
	      $scope.columnDefs = [
	        {name: 'name', enableCellEdit: true, validators: {minLength: 3, maxLength: 9}, cellTemplate: 'ui-grid/cellTitleValidator'},
	        {name: 'title', enableCellEdit: true, validators: {required: true}, cellTemplate: 'ui-grid/cellTitleValidator'}
	      ];
	    }]);
	   </file>
	   <file name="index.html">
	   <div ng-controller="MainCtrl">
	   <div ui-grid="{ data: data, columnDefs: columnDefs }" ui-grid-edit ui-grid-validate></div>
	   </div>
	   </file>
	   </example>
	   */
	
	  module.directive('uiGridValidate', ['gridUtil', 'uiGridValidateService', function (gridUtil, uiGridValidateService) {
	    return {
	      priority: 0,
	      replace: true,
	      require: '^uiGrid',
	      scope: false,
	      compile: function () {
	        return {
	          pre: function ($scope, $elm, $attrs, uiGridCtrl) {
	            uiGridValidateService.initializeGrid($scope, uiGridCtrl.grid);
	          },
	          post: function ($scope, $elm, $attrs, uiGridCtrl) {
	          }
	        };
	      }
	    };
	  }]);
	})();
	
	angular.module('ui.grid').run(['$templateCache', function($templateCache) {
	  'use strict';
	
	  $templateCache.put('ui-grid/ui-grid-filter',
	    "<div class=\"ui-grid-filter-container\" ng-style=\"col.extraStyle\" ng-repeat=\"colFilter in col.filters\" ng-class=\"{'ui-grid-filter-cancel-button-hidden' : colFilter.disableCancelFilterButton === true }\"><div ng-if=\"colFilter.type !== 'select'\"><input type=\"text\" class=\"ui-grid-filter-input ui-grid-filter-input-{{$index}}\" ng-model=\"colFilter.term\" ng-attr-placeholder=\"{{colFilter.placeholder || ''}}\" aria-label=\"{{colFilter.ariaLabel || aria.defaultFilterLabel}}\"><div role=\"button\" class=\"ui-grid-filter-button\" ng-click=\"removeFilter(colFilter, $index)\" ng-if=\"!colFilter.disableCancelFilterButton\" ng-disabled=\"colFilter.term === undefined || colFilter.term === null || colFilter.term === ''\" ng-show=\"colFilter.term !== undefined && colFilter.term !== null && colFilter.term !== ''\"><i class=\"ui-grid-icon-cancel\" ui-grid-one-bind-aria-label=\"aria.removeFilter\">&nbsp;</i></div></div><div ng-if=\"colFilter.type === 'select'\"><select class=\"ui-grid-filter-select ui-grid-filter-input-{{$index}}\" ng-model=\"colFilter.term\" ng-show=\"colFilter.selectOptions.length > 0\" ng-attr-placeholder=\"{{colFilter.placeholder || aria.defaultFilterLabel}}\" aria-label=\"{{colFilter.ariaLabel || ''}}\" ng-options=\"option.value as option.label for option in colFilter.selectOptions\"><option value=\"\"></option></select><div role=\"button\" class=\"ui-grid-filter-button-select\" ng-click=\"removeFilter(colFilter, $index)\" ng-if=\"!colFilter.disableCancelFilterButton\" ng-disabled=\"colFilter.term === undefined || colFilter.term === null || colFilter.term === ''\" ng-show=\"colFilter.term !== undefined && colFilter.term != null\"><i class=\"ui-grid-icon-cancel\" ui-grid-one-bind-aria-label=\"aria.removeFilter\">&nbsp;</i></div></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/ui-grid-footer',
	    "<div class=\"ui-grid-footer-panel ui-grid-footer-aggregates-row\"><!-- tfooter --><div class=\"ui-grid-footer ui-grid-footer-viewport\"><div class=\"ui-grid-footer-canvas\"><div class=\"ui-grid-footer-cell-wrapper\" ng-style=\"colContainer.headerCellWrapperStyle()\"><div role=\"row\" class=\"ui-grid-footer-cell-row\"><div ui-grid-footer-cell role=\"gridcell\" ng-repeat=\"col in colContainer.renderedColumns track by col.uid\" col=\"col\" render-index=\"$index\" class=\"ui-grid-footer-cell ui-grid-clearfix\"></div></div></div></div></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/ui-grid-grid-footer',
	    "<div class=\"ui-grid-footer-info ui-grid-grid-footer\"><span>{{'search.totalItems' | t}} {{grid.rows.length}}</span> <span ng-if=\"grid.renderContainers.body.visibleRowCache.length !== grid.rows.length\" class=\"ngLabel\">({{\"search.showingItems\" | t}} {{grid.renderContainers.body.visibleRowCache.length}})</span></div>"
	  );
	
	
	  $templateCache.put('ui-grid/ui-grid-header',
	    "<div role=\"rowgroup\" class=\"ui-grid-header\"><!-- theader --><div class=\"ui-grid-top-panel\"><div class=\"ui-grid-header-viewport\"><div class=\"ui-grid-header-canvas\"><div class=\"ui-grid-header-cell-wrapper\" ng-style=\"colContainer.headerCellWrapperStyle()\"><div role=\"row\" class=\"ui-grid-header-cell-row\"><div class=\"ui-grid-header-cell ui-grid-clearfix\" ng-repeat=\"col in colContainer.renderedColumns track by col.uid\" ui-grid-header-cell col=\"col\" render-index=\"$index\"></div></div></div></div></div></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/ui-grid-menu-button',
	    "<div class=\"ui-grid-menu-button\"><div role=\"button\" ui-grid-one-bind-id-grid=\"'grid-menu'\" class=\"ui-grid-icon-container\" ng-click=\"toggleMenu()\" aria-haspopup=\"true\"><i class=\"ui-grid-icon-menu\" ui-grid-one-bind-aria-label=\"i18n.aria.buttonLabel\">&nbsp;</i></div><div ui-grid-menu menu-items=\"menuItems\"></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/ui-grid-no-header',
	    "<div class=\"ui-grid-top-panel\"></div>"
	  );
	
	
	  $templateCache.put('ui-grid/ui-grid-row',
	    "<div ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\" ui-grid-one-bind-id-grid=\"rowRenderIndex + '-' + col.uid + '-cell'\" class=\"ui-grid-cell\" ng-class=\"{ 'ui-grid-row-header-cell': col.isRowHeader }\" role=\"{{col.isRowHeader ? 'rowheader' : 'gridcell'}}\" ui-grid-cell></div>"
	  );
	
	
	  $templateCache.put('ui-grid/ui-grid',
	    "<div ui-i18n=\"en\" class=\"ui-grid\"><!-- TODO (c0bra): add \"scoped\" attr here, eventually? --><style ui-grid-style>.grid{{ grid.id }} {\n" +
	    "      /* Styles for the grid */\n" +
	    "    }\n" +
	    "\n" +
	    "    .grid{{ grid.id }} .ui-grid-row, .grid{{ grid.id }} .ui-grid-cell, .grid{{ grid.id }} .ui-grid-cell .ui-grid-vertical-bar {\n" +
	    "      height: {{ grid.options.rowHeight }}px;\n" +
	    "    }\n" +
	    "\n" +
	    "    .grid{{ grid.id }} .ui-grid-row:last-child .ui-grid-cell {\n" +
	    "      border-bottom-width: {{ (((grid.getVisibleRowCount() * grid.options.rowHeight) < grid.getViewportHeight()) && '1') || '0' }}px;\n" +
	    "    }\n" +
	    "\n" +
	    "    {{ grid.verticalScrollbarStyles }}\n" +
	    "    {{ grid.horizontalScrollbarStyles }}\n" +
	    "\n" +
	    "    /*\n" +
	    "    .ui-grid[dir=rtl] .ui-grid-viewport {\n" +
	    "      padding-left: {{ grid.verticalScrollbarWidth }}px;\n" +
	    "    }\n" +
	    "    */\n" +
	    "\n" +
	    "    {{ grid.customStyles }}</style><div class=\"ui-grid-contents-wrapper\" role=\"grid\"><div ui-grid-menu-button ng-if=\"grid.options.enableGridMenu\"></div><div ng-if=\"grid.hasLeftContainer()\" style=\"width: 0\" ui-grid-pinned-container=\"'left'\"></div><div ui-grid-render-container container-id=\"'body'\" col-container-name=\"'body'\" row-container-name=\"'body'\" bind-scroll-horizontal=\"true\" bind-scroll-vertical=\"true\" enable-horizontal-scrollbar=\"grid.options.enableHorizontalScrollbar\" enable-vertical-scrollbar=\"grid.options.enableVerticalScrollbar\"></div><div ng-if=\"grid.hasRightContainer()\" style=\"width: 0\" ui-grid-pinned-container=\"'right'\"></div><div ui-grid-grid-footer ng-if=\"grid.options.showGridFooter\"></div><div ui-grid-column-menu ng-if=\"grid.options.enableColumnMenus\"></div><div ng-transclude></div></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/uiGridCell',
	    "<div class=\"ui-grid-cell-contents\" title=\"TOOLTIP\">{{COL_FIELD CUSTOM_FILTERS}}</div>"
	  );
	
	
	  $templateCache.put('ui-grid/uiGridColumnMenu',
	    "<div class=\"ui-grid-column-menu\"><div ui-grid-menu menu-items=\"menuItems\"><!-- <div class=\"ui-grid-column-menu\">\n" +
	    "    <div class=\"inner\" ng-show=\"menuShown\">\n" +
	    "      <ul>\n" +
	    "        <div ng-show=\"grid.options.enableSorting\">\n" +
	    "          <li ng-click=\"sortColumn($event, asc)\" ng-class=\"{ 'selected' : col.sort.direction == asc }\"><i class=\"ui-grid-icon-sort-alt-up\"></i> Sort Ascending</li>\n" +
	    "          <li ng-click=\"sortColumn($event, desc)\" ng-class=\"{ 'selected' : col.sort.direction == desc }\"><i class=\"ui-grid-icon-sort-alt-down\"></i> Sort Descending</li>\n" +
	    "          <li ng-show=\"col.sort.direction\" ng-click=\"unsortColumn()\"><i class=\"ui-grid-icon-cancel\"></i> Remove Sort</li>\n" +
	    "        </div>\n" +
	    "      </ul>\n" +
	    "    </div>\n" +
	    "  </div> --></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/uiGridFooterCell',
	    "<div class=\"ui-grid-cell-contents\" col-index=\"renderIndex\"><div>{{ col.getAggregationText() + ( col.getAggregationValue() CUSTOM_FILTERS ) }}</div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/uiGridHeaderCell',
	    "<div role=\"columnheader\" ng-class=\"{ 'sortable': sortable, 'ui-grid-header-cell-last-col': isLastCol }\" ui-grid-one-bind-aria-labelledby-grid=\"col.uid + '-header-text ' + col.uid + '-sortdir-text'\" aria-sort=\"{{col.sort.direction == asc ? 'ascending' : ( col.sort.direction == desc ? 'descending' : (!col.sort.direction ? 'none' : 'other'))}}\"><div role=\"button\" tabindex=\"0\" ng-keydown=\"handleKeyDown($event)\" class=\"ui-grid-cell-contents ui-grid-header-cell-primary-focus\" col-index=\"renderIndex\" title=\"TOOLTIP\"><span class=\"ui-grid-header-cell-label\" ui-grid-one-bind-id-grid=\"col.uid + '-header-text'\">{{ col.displayName CUSTOM_FILTERS }}</span> <span ui-grid-one-bind-id-grid=\"col.uid + '-sortdir-text'\" ui-grid-visible=\"col.sort.direction\" aria-label=\"{{getSortDirectionAriaLabel()}}\"><i ng-class=\"{ 'ui-grid-icon-up-dir': col.sort.direction == asc, 'ui-grid-icon-down-dir': col.sort.direction == desc, 'ui-grid-icon-blank': !col.sort.direction }\" title=\"{{isSortPriorityVisible() ? i18n.headerCell.priority + ' ' + ( col.sort.priority + 1 )  : null}}\" aria-hidden=\"true\"></i> <sub ui-grid-visible=\"isSortPriorityVisible()\" class=\"ui-grid-sort-priority-number\">{{col.sort.priority + 1}}</sub></span></div><div role=\"button\" tabindex=\"0\" ui-grid-one-bind-id-grid=\"col.uid + '-menu-button'\" class=\"ui-grid-column-menu-button\" ng-if=\"grid.options.enableColumnMenus && !col.isRowHeader  && col.colDef.enableColumnMenu !== false\" ng-click=\"toggleMenu($event)\" ng-keydown=\"headerCellArrowKeyDown($event)\" ui-grid-one-bind-aria-label=\"i18n.headerCell.aria.columnMenuButtonLabel\" aria-haspopup=\"true\"><i class=\"ui-grid-icon-angle-down\" aria-hidden=\"true\">&nbsp;</i></div><div ui-grid-filter></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/uiGridMenu',
	    "<div class=\"ui-grid-menu\" ng-show=\"shown\"><style ui-grid-style>{{dynamicStyles}}</style><div class=\"ui-grid-menu-mid\" ng-show=\"shownMid\"><div class=\"ui-grid-menu-inner\" ng-if=\"shown\"><ul role=\"menu\" class=\"ui-grid-menu-items\"><li ng-repeat=\"item in menuItems\" role=\"menuitem\" ui-grid-menu-item ui-grid-one-bind-id=\"'menuitem-'+$index\" action=\"item.action\" name=\"item.title\" active=\"item.active\" icon=\"item.icon\" shown=\"item.shown\" context=\"item.context\" template-url=\"item.templateUrl\" leave-open=\"item.leaveOpen\" screen-reader-only=\"item.screenReaderOnly\"></li></ul></div></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/uiGridMenuItem',
	    "<button type=\"button\" class=\"ui-grid-menu-item\" ng-click=\"itemAction($event, title)\" ng-show=\"itemShown()\" ng-class=\"{ 'ui-grid-menu-item-active': active(), 'ui-grid-sr-only': (!focus && screenReaderOnly) }\" aria-pressed=\"{{active()}}\" tabindex=\"0\" ng-focus=\"focus=true\" ng-blur=\"focus=false\"><i ng-class=\"icon\" aria-hidden=\"true\">&nbsp;</i> {{ label() }}</button>"
	  );
	
	
	  $templateCache.put('ui-grid/uiGridRenderContainer',
	    "<div role=\"presentation\" ui-grid-one-bind-id-grid=\"'grid-container'\" class=\"ui-grid-render-container\" ng-style=\"{ 'margin-left': colContainer.getMargin('left') + 'px', 'margin-right': colContainer.getMargin('right') + 'px' }\"><!-- All of these dom elements are replaced in place --><div ui-grid-header></div><div ui-grid-viewport></div><div ng-if=\"colContainer.needsHScrollbarPlaceholder()\" class=\"ui-grid-scrollbar-placeholder\" ng-style=\"{height:colContainer.grid.scrollbarHeight + 'px'}\"></div><ui-grid-footer ng-if=\"grid.options.showColumnFooter\"></ui-grid-footer></div>"
	  );
	
	
	  $templateCache.put('ui-grid/uiGridViewport',
	    "<div role=\"rowgroup\" class=\"ui-grid-viewport\" ng-style=\"colContainer.getViewportStyle()\"><!-- tbody --><div class=\"ui-grid-canvas\"><div ng-repeat=\"(rowRenderIndex, row) in rowContainer.renderedRows track by $index\" class=\"ui-grid-row\" ng-style=\"Viewport.rowStyle(rowRenderIndex)\"><div role=\"row\" ui-grid-row=\"row\" row-render-index=\"rowRenderIndex\"></div></div></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/cellEditor',
	    "<div><form name=\"inputForm\"><input type=\"INPUT_TYPE\" ng-class=\"'colt' + col.uid\" ui-grid-editor ng-model=\"MODEL_COL_FIELD\"></form></div>"
	  );
	
	
	  $templateCache.put('ui-grid/dropdownEditor',
	    "<div><form name=\"inputForm\"><select ng-class=\"'colt' + col.uid\" ui-grid-edit-dropdown ng-model=\"MODEL_COL_FIELD\" ng-options=\"field[editDropdownIdLabel] as field[editDropdownValueLabel] CUSTOM_FILTERS for field in editDropdownOptionsArray\"></select></form></div>"
	  );
	
	
	  $templateCache.put('ui-grid/fileChooserEditor',
	    "<div><form name=\"inputForm\"><input ng-class=\"'colt' + col.uid\" ui-grid-edit-file-chooser type=\"file\" id=\"files\" name=\"files[]\" ng-model=\"MODEL_COL_FIELD\"></form></div>"
	  );
	
	
	  $templateCache.put('ui-grid/emptyBaseLayerContainer',
	    "<div class=\"ui-grid-empty-base-layer-container ui-grid-canvas\"><div class=\"ui-grid-row\" ng-repeat=\"(rowRenderIndex, row) in grid.baseLayer.emptyRows track by $index\" ng-style=\"Viewport.rowStyle(rowRenderIndex)\"><div><div><div ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name\" class=\"ui-grid-cell {{ col.getColClass(false) }}\"></div></div></div></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/expandableRow',
	    "<div ui-grid-expandable-row ng-if=\"expandableRow.shouldRenderExpand()\" class=\"expandableRow\" style=\"float:left; margin-top: 1px; margin-bottom: 1px\" ng-style=\"{width: (grid.renderContainers.body.getCanvasWidth()) + 'px', height: row.expandedRowHeight + 'px'}\"></div>"
	  );
	
	
	  $templateCache.put('ui-grid/expandableRowHeader',
	    "<div class=\"ui-grid-row-header-cell ui-grid-expandable-buttons-cell\"><div class=\"ui-grid-cell-contents\"><i ng-if=\"!(row.groupHeader==true || row.entity.subGridOptions.disableRowExpandable)\" ng-class=\"{ 'ui-grid-icon-plus-squared' : !row.isExpanded, 'ui-grid-icon-minus-squared' : row.isExpanded }\" ng-click=\"grid.api.expandable.toggleRowExpansion(row.entity)\"></i></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/expandableScrollFiller',
	    "<div ng-if=\"expandableRow.shouldRenderFiller()\" ng-class=\"{scrollFiller:true, scrollFillerClass:(colContainer.name === 'body')}\" ng-style=\"{ width: (grid.getViewportWidth()) + 'px', height: row.expandedRowHeight + 2 + 'px', 'margin-left': grid.options.rowHeader.rowHeaderWidth + 'px' }\"><i class=\"ui-grid-icon-spin5 ui-grid-animate-spin\" ng-style=\"{'margin-top': ( row.expandedRowHeight/2 - 5) + 'px', 'margin-left' : ((grid.getViewportWidth() - grid.options.rowHeader.rowHeaderWidth)/2 - 5) + 'px'}\"></i></div>"
	  );
	
	
	  $templateCache.put('ui-grid/expandableTopRowHeader',
	    "<div class=\"ui-grid-row-header-cell ui-grid-expandable-buttons-cell\"><div class=\"ui-grid-cell-contents\"><span class=\"ui-grid-cell-empty\" ng-if=\"!grid.options.showExpandAllButton\"></span> <button type=\"button\" class=\"ui-grid-icon-button\" ng-if=\"grid.options.showExpandAllButton\" ng-class=\"{ 'ui-grid-icon-plus-squared' : !grid.expandable.expandedAll, 'ui-grid-icon-minus-squared' : grid.expandable.expandedAll }\" ng-click=\"grid.api.expandable.toggleAllRows()\"></button></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/csvLink',
	    "<span class=\"ui-grid-exporter-csv-link-span\"><a href=\"data:text/csv;charset=UTF-8,CSV_CONTENT\" download=\"FILE_NAME\">LINK_LABEL</a></span>"
	  );
	
	
	  $templateCache.put('ui-grid/importerMenuItem',
	    "<li class=\"ui-grid-menu-item\"><form><input class=\"ui-grid-importer-file-chooser\" type=\"file\" id=\"files\" name=\"files[]\"></form></li>"
	  );
	
	
	  $templateCache.put('ui-grid/importerMenuItemContainer',
	    "<div ui-grid-importer-menu-item></div>"
	  );
	
	
	  $templateCache.put('ui-grid/pagination',
	    "<div class=\"ui-grid-pager-panel\" ui-grid-pager ng-show=\"grid.options.enablePaginationControls\"><div role=\"navigation\" class=\"ui-grid-pager-container\"><div class=\"ui-grid-pager-control\"><button type=\"button\" class=\"ui-grid-pager-first\" ui-grid-one-bind-title=\"aria.pageToFirst\" ui-grid-one-bind-aria-label=\"aria.pageToFirst\" ng-click=\"pageFirstPageClick()\" ng-disabled=\"cantPageBackward()\"><div ng-class=\"grid.isRTL() ? 'last-triangle' : 'first-triangle'\"><div ng-class=\"grid.isRTL() ? 'last-bar-rtl' : 'first-bar'\"></div></div></button> <button type=\"button\" class=\"ui-grid-pager-previous\" ui-grid-one-bind-title=\"aria.pageBack\" ui-grid-one-bind-aria-label=\"aria.pageBack\" ng-click=\"pagePreviousPageClick()\" ng-disabled=\"cantPageBackward()\"><div ng-class=\"grid.isRTL() ? 'last-triangle prev-triangle' : 'first-triangle prev-triangle'\"></div></button> <input type=\"number\" ui-grid-one-bind-title=\"aria.pageSelected\" ui-grid-one-bind-aria-label=\"aria.pageSelected\" class=\"ui-grid-pager-control-input\" ng-model=\"grid.options.paginationCurrentPage\" min=\"1\" max=\"{{ paginationApi.getTotalPages() }}\" step=\"1\" required> <span class=\"ui-grid-pager-max-pages-number\" ng-show=\"paginationApi.getTotalPages() > 0\"><abbr ui-grid-one-bind-title=\"paginationOf\">/</abbr> {{ paginationApi.getTotalPages() }}</span> <button type=\"button\" class=\"ui-grid-pager-next\" ui-grid-one-bind-title=\"aria.pageForward\" ui-grid-one-bind-aria-label=\"aria.pageForward\" ng-click=\"pageNextPageClick()\" ng-disabled=\"cantPageForward()\"><div ng-class=\"grid.isRTL() ? 'first-triangle next-triangle' : 'last-triangle next-triangle'\"></div></button> <button type=\"button\" class=\"ui-grid-pager-last\" ui-grid-one-bind-title=\"aria.pageToLast\" ui-grid-one-bind-aria-label=\"aria.pageToLast\" ng-click=\"pageLastPageClick()\" ng-disabled=\"cantPageToLast()\"><div ng-class=\"grid.isRTL() ? 'first-triangle' : 'last-triangle'\"><div ng-class=\"grid.isRTL() ? 'first-bar-rtl' : 'last-bar'\"></div></div></button></div><div class=\"ui-grid-pager-row-count-picker\" ng-if=\"grid.options.paginationPageSizes.length > 1 && !grid.options.useCustomPagination\"><select ui-grid-one-bind-aria-labelledby-grid=\"'items-per-page-label'\" ng-model=\"grid.options.paginationPageSize\" ng-options=\"o as o for o in grid.options.paginationPageSizes\"></select><span ui-grid-one-bind-id-grid=\"'items-per-page-label'\" class=\"ui-grid-pager-row-count-label\">&nbsp;{{sizesLabel}}</span></div><span ng-if=\"grid.options.paginationPageSizes.length <= 1\" class=\"ui-grid-pager-row-count-label\">{{grid.options.paginationPageSize}}&nbsp;{{sizesLabel}}</span></div><div class=\"ui-grid-pager-count-container\"><div class=\"ui-grid-pager-count\"><span ng-show=\"grid.options.totalItems > 0\">{{ 1 + paginationApi.getFirstRowIndex() }} <abbr ui-grid-one-bind-title=\"paginationThrough\">-</abbr> {{ 1 + paginationApi.getLastRowIndex() }} {{paginationOf}} {{grid.options.totalItems}} {{totalItemsLabel}}</span></div></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/columnResizer',
	    "<div ui-grid-column-resizer ng-if=\"grid.options.enableColumnResizing\" class=\"ui-grid-column-resizer\" col=\"col\" position=\"right\" render-index=\"renderIndex\" unselectable=\"on\"></div>"
	  );
	
	
	  $templateCache.put('ui-grid/gridFooterSelectedItems',
	    "<span ng-if=\"grid.selection.selectedCount !== 0 && grid.options.enableFooterTotalSelected\">({{\"search.selectedItems\" | t}} {{grid.selection.selectedCount}})</span>"
	  );
	
	
	  $templateCache.put('ui-grid/selectionHeaderCell',
	    "<div><!-- <div class=\"ui-grid-vertical-bar\">&nbsp;</div> --><div class=\"ui-grid-cell-contents\" col-index=\"renderIndex\"><ui-grid-selection-select-all-buttons ng-if=\"grid.options.enableSelectAll\" role=\"checkbox\" ng-model=\"grid.selection.selectAll\"></ui-grid-selection-select-all-buttons></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/selectionRowHeader',
	    "<div class=\"ui-grid-cell-contents ui-grid-disable-selection\"><ui-grid-selection-row-header-buttons></ui-grid-selection-row-header-buttons></div>"
	  );
	
	
	  $templateCache.put('ui-grid/selectionRowHeaderButtons',
	    "<div class=\"ui-grid-selection-row-header-buttons ui-grid-icon-ok\" ng-class=\"{'ui-grid-row-selected': row.isSelected}\" ng-click=\"selectButtonClick(row, $event)\" ng-keydown=\"selectButtonKeyDown(row, $event)\" role=\"checkbox\" ng-model=\"row.isSelected\">&nbsp;</div>"
	  );
	
	
	  $templateCache.put('ui-grid/selectionSelectAllButtons',
	    "<div role=\"button\" class=\"ui-grid-selection-row-header-buttons ui-grid-icon-ok\" ng-class=\"{'ui-grid-all-selected': grid.selection.selectAll}\" ng-click=\"headerButtonClick($event)\" ng-keydown=\"headerButtonKeyDown($event)\"></div>"
	  );
	
	
	  $templateCache.put('ui-grid/treeBaseExpandAllButtons',
	    "<div class=\"ui-grid-tree-base-row-header-buttons\" ng-class=\"{'ui-grid-icon-minus-squared': grid.treeBase.numberLevels > 0 && grid.treeBase.expandAll, 'ui-grid-icon-plus-squared': grid.treeBase.numberLevels > 0 && !grid.treeBase.expandAll}\" ng-click=\"headerButtonClick($event)\"></div>"
	  );
	
	
	  $templateCache.put('ui-grid/treeBaseHeaderCell',
	    "<div><div class=\"ui-grid-cell-contents\" col-index=\"renderIndex\"><ui-grid-tree-base-expand-all-buttons ng-if=\"grid.options.enableExpandAll\"></ui-grid-tree-base-expand-all-buttons></div></div>"
	  );
	
	
	  $templateCache.put('ui-grid/treeBaseRowHeader',
	    "<div class=\"ui-grid-cell-contents\"><ui-grid-tree-base-row-header-buttons></ui-grid-tree-base-row-header-buttons></div>"
	  );
	
	
	  $templateCache.put('ui-grid/treeBaseRowHeaderButtons',
	    "<div class=\"ui-grid-tree-base-row-header-buttons\" ng-class=\"{'ui-grid-tree-base-header': row.treeLevel > -1 }\" ng-click=\"treeButtonClick(row, $event)\"><i ng-class=\"{'ui-grid-icon-minus-squared': ( ( grid.options.showTreeExpandNoChildren && row.treeLevel > -1 ) || ( row.treeNode.children && row.treeNode.children.length > 0 ) ) && row.treeNode.state === 'expanded', 'ui-grid-icon-plus-squared': ( ( grid.options.showTreeExpandNoChildren && row.treeLevel > -1 ) || ( row.treeNode.children && row.treeNode.children.length > 0 ) ) && row.treeNode.state === 'collapsed'}\" ng-style=\"{'padding-left': grid.options.treeIndent * row.treeLevel + 'px'}\"></i> &nbsp;</div>"
	  );
	
	
	  $templateCache.put('ui-grid/cellTitleValidator',
	    "<div class=\"ui-grid-cell-contents\" ng-class=\"{invalid:grid.validate.isInvalid(row.entity,col.colDef)}\" title=\"{{grid.validate.getTitleFormattedErrors(row.entity,col.colDef)}}\">{{COL_FIELD CUSTOM_FILTERS}}</div>"
	  );
	
	
	  $templateCache.put('ui-grid/cellTooltipValidator',
	    "<div class=\"ui-grid-cell-contents\" ng-class=\"{invalid:grid.validate.isInvalid(row.entity,col.colDef)}\" tooltip-html-unsafe=\"{{grid.validate.getFormattedErrors(row.entity,col.colDef)}}\" tooltip-enable=\"grid.validate.isInvalid(row.entity,col.colDef)\" tooltip-append-to-body=\"true\" tooltip-placement=\"top\" title=\"TOOLTIP\">{{COL_FIELD CUSTOM_FILTERS}}</div>"
	  );
	
	}]);


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.29.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks() {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback(callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return (
	            input instanceof Array ||
	            Object.prototype.toString.call(input) === '[object Array]'
	        );
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return (
	            input != null &&
	            Object.prototype.toString.call(input) === '[object Object]'
	        );
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return Object.getOwnPropertyNames(obj).length === 0;
	        } else {
	            var k;
	            for (k in obj) {
	                if (hasOwnProp(obj, k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return (
	            typeof input === 'number' ||
	            Object.prototype.toString.call(input) === '[object Number]'
	        );
	    }
	
	    function isDate(input) {
	        return (
	            input instanceof Date ||
	            Object.prototype.toString.call(input) === '[object Date]'
	        );
	    }
	
	    function map(arr, fn) {
	        var res = [],
	            i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty: false,
	            unusedTokens: [],
	            unusedInput: [],
	            overflow: -2,
	            charsLeftOver: 0,
	            nullInput: false,
	            invalidEra: null,
	            invalidMonth: null,
	            invalidFormat: false,
	            userInvalidated: false,
	            iso: false,
	            parsedDateParts: [],
	            era: null,
	            meridiem: null,
	            rfc2822: false,
	            weekdayMismatch: false,
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this),
	                len = t.length >>> 0,
	                i;
	
	            for (i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m),
	                parsedParts = some.call(flags.parsedDateParts, function (i) {
	                    return i != null;
	                }),
	                isNowValid =
	                    !isNaN(m._d.getTime()) &&
	                    flags.overflow < 0 &&
	                    !flags.empty &&
	                    !flags.invalidEra &&
	                    !flags.invalidMonth &&
	                    !flags.invalidWeekday &&
	                    !flags.weekdayMismatch &&
	                    !flags.nullInput &&
	                    !flags.invalidFormat &&
	                    !flags.userInvalidated &&
	                    (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid =
	                    isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            } else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid(flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        } else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = (hooks.momentProperties = []),
	        updateInProgress = false;
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment(obj) {
	        return (
	            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
	        );
	    }
	
	    function warn(msg) {
	        if (
	            hooks.suppressDeprecationWarnings === false &&
	            typeof console !== 'undefined' &&
	            console.warn
	        ) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [],
	                    arg,
	                    i,
	                    key;
	                for (i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (key in arguments[0]) {
	                            if (hasOwnProp(arguments[0], key)) {
	                                arg += key + ': ' + arguments[0][key] + ', ';
	                            }
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(
	                    msg +
	                        '\nArguments: ' +
	                        Array.prototype.slice.call(args).join('') +
	                        '\n' +
	                        new Error().stack
	                );
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    function set(config) {
	        var prop, i;
	        for (i in config) {
	            if (hasOwnProp(config, i)) {
	                prop = config[i];
	                if (isFunction(prop)) {
	                    this[i] = prop;
	                } else {
	                    this['_' + i] = prop;
	                }
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' +
	                /\d{1,2}/.source
	        );
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig),
	            prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (
	                hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])
	            ) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i,
	                res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L',
	    };
	
	    function calendar(key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (
	            (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
	            absNumber
	        );
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
	        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
	        formatFunctions = {},
	        formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken(token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(
	                    func.apply(this, arguments),
	                    token
	                );
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens),
	            i,
	            length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '',
	                i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i])
	                    ? array[i].call(mom, format)
	                    : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] =
	            formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(
	                localFormattingTokens,
	                replaceLongDateFormatTokens
	            );
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var defaultLongDateFormat = {
	        LTS: 'h:mm:ss A',
	        LT: 'h:mm A',
	        L: 'MM/DD/YYYY',
	        LL: 'MMMM D, YYYY',
	        LLL: 'MMMM D, YYYY h:mm A',
	        LLLL: 'dddd, MMMM D, YYYY h:mm A',
	    };
	
	    function longDateFormat(key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper
	            .match(formattingTokens)
	            .map(function (tok) {
	                if (
	                    tok === 'MMMM' ||
	                    tok === 'MM' ||
	                    tok === 'DD' ||
	                    tok === 'dddd'
	                ) {
	                    return tok.slice(1);
	                }
	                return tok;
	            })
	            .join('');
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate() {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d',
	        defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal(number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        w: 'a week',
	        ww: '%d weeks',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years',
	    };
	
	    function relativeTime(number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return isFunction(output)
	            ? output(number, withoutSuffix, string, isFuture)
	            : output.replace(/%d/i, number);
	    }
	
	    function pastFuture(diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias(unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string'
	            ? aliases[units] || aliases[units.toLowerCase()]
	            : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [],
	            u;
	        for (u in unitsObj) {
	            if (hasOwnProp(unitsObj, u)) {
	                units.push({ unit: u, priority: priorities[u] });
	            }
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    function absFloor(number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    function makeGetSet(unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get(mom, unit) {
	        return mom.isValid()
	            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
	            : NaN;
	    }
	
	    function set$1(mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (
	                unit === 'FullYear' &&
	                isLeapYear(mom.year()) &&
	                mom.month() === 1 &&
	                mom.date() === 29
	            ) {
	                value = toInt(value);
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
	                    value,
	                    mom.month(),
	                    daysInMonth(value, mom.month())
	                );
	            } else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet(units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	    function stringSet(units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units),
	                i;
	            for (i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    var match1 = /\d/, //       0 - 9
	        match2 = /\d\d/, //      00 - 99
	        match3 = /\d{3}/, //     000 - 999
	        match4 = /\d{4}/, //    0000 - 9999
	        match6 = /[+-]?\d{6}/, // -999999 - 999999
	        match1to2 = /\d\d?/, //       0 - 99
	        match3to4 = /\d\d\d\d?/, //     999 - 9999
	        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
	        match1to3 = /\d{1,3}/, //       0 - 999
	        match1to4 = /\d{1,4}/, //       0 - 9999
	        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
	        matchUnsigned = /\d+/, //       0 - inf
	        matchSigned = /[+-]?\d+/, //    -inf - inf
	        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
	        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
	        // any word (or two) characters or numbers including two/three word month in arabic.
	        // includes scottish gaelic two word and hyphenated months
	        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
	        regexes;
	
	    regexes = {};
	
	    function addRegexToken(token, regex, strictRegex) {
	        regexes[token] = isFunction(regex)
	            ? regex
	            : function (isStrict, localeData) {
	                  return isStrict && strictRegex ? strictRegex : regex;
	              };
	    }
	
	    function getParseRegexForToken(token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(
	            s
	                .replace('\\', '')
	                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
	                    matched,
	                    p1,
	                    p2,
	                    p3,
	                    p4
	                ) {
	                    return p1 || p2 || p3 || p4;
	                })
	        );
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken(token, callback) {
	        var i,
	            func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken(token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0,
	        MONTH = 1,
	        DATE = 2,
	        HOUR = 3,
	        MINUTE = 4,
	        SECOND = 5,
	        MILLISECOND = 6,
	        WEEK = 7,
	        WEEKDAY = 8;
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1
	            ? isLeapYear(year)
	                ? 29
	                : 28
	            : 31 - ((modMonth % 7) % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M', match1to2);
	    addRegexToken('MM', match1to2, match2);
	    addRegexToken('MMM', function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
	            '_'
	        ),
	        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
	        defaultMonthsShortRegex = matchWord,
	        defaultMonthsRegex = matchWord;
	
	    function localeMonths(m, format) {
	        if (!m) {
	            return isArray(this._months)
	                ? this._months
	                : this._months['standalone'];
	        }
	        return isArray(this._months)
	            ? this._months[m.month()]
	            : this._months[
	                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
	                      ? 'format'
	                      : 'standalone'
	              ][m.month()];
	    }
	
	    function localeMonthsShort(m, format) {
	        if (!m) {
	            return isArray(this._monthsShort)
	                ? this._monthsShort
	                : this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort)
	            ? this._monthsShort[m.month()]
	            : this._monthsShort[
	                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
	              ][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse(monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp(
	                    '^' + this.months(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	                this._shortMonthsParse[i] = new RegExp(
	                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex =
	                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'MMMM' &&
	                this._longMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'MMM' &&
	                this._shortMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth(mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth(value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth() {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    function monthsShortRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict
	                ? this._monthsShortStrictRegex
	                : this._monthsShortRegex;
	        }
	    }
	
	    function monthsRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict
	                ? this._monthsStrictRegex
	                : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._monthsShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY', 4], 0, 'year');
	    addFormatToken(0, ['YYYYY', 5], 0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y', matchSigned);
	    addRegexToken('YY', match1to2, match2);
	    addRegexToken('YYYY', match1to4, match4);
	    addRegexToken('YYYYY', match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] =
	            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear() {
	        return isLeapYear(this.year());
	    }
	
	    function createDate(y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate(y) {
	        var date, args;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear,
	            resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear,
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek,
	            resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear,
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w', match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W', match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
	        input,
	        week,
	        config,
	        token
	    ) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek(mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek() {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear() {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek(input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek(input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d', match1to2);
	    addRegexToken('e', match1to2);
	    addRegexToken('E', match1to2);
	    addRegexToken('dd', function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd', function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd', function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays(ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        defaultWeekdaysRegex = matchWord,
	        defaultWeekdaysShortRegex = matchWord,
	        defaultWeekdaysMinRegex = matchWord;
	
	    function localeWeekdays(m, format) {
	        var weekdays = isArray(this._weekdays)
	            ? this._weekdays
	            : this._weekdays[
	                  m && m !== true && this._weekdays.isFormat.test(format)
	                      ? 'format'
	                      : 'standalone'
	              ];
	        return m === true
	            ? shiftWeekdays(weekdays, this._week.dow)
	            : m
	            ? weekdays[m.day()]
	            : weekdays;
	    }
	
	    function localeWeekdaysShort(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : m
	            ? this._weekdaysShort[m.day()]
	            : this._weekdaysShort;
	    }
	
	    function localeWeekdaysMin(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : m
	            ? this._weekdaysMin[m.day()]
	            : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse(weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._shortWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._minWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	            }
	            if (!this._weekdaysParse[i]) {
	                regex =
	                    '^' +
	                    this.weekdays(mom, '') +
	                    '|^' +
	                    this.weekdaysShort(mom, '') +
	                    '|^' +
	                    this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'dddd' &&
	                this._fullWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'ddd' &&
	                this._shortWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'dd' &&
	                this._minWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    function weekdaysRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict
	                ? this._weekdaysStrictRegex
	                : this._weekdaysRegex;
	        }
	    }
	
	    function weekdaysShortRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict
	                ? this._weekdaysShortStrictRegex
	                : this._weekdaysShortRegex;
	        }
	    }
	
	    function weekdaysMinRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict
	                ? this._weekdaysMinStrictRegex
	                : this._weekdaysMinRegex;
	        }
	    }
	
	    function computeWeekdaysParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [],
	            shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            minp,
	            shortp,
	            longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = regexEscape(this.weekdaysMin(mom, ''));
	            shortp = regexEscape(this.weekdaysShort(mom, ''));
	            longp = regexEscape(this.weekdays(mom, ''));
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysMinStrictRegex = new RegExp(
	            '^(' + minPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return (
	            '' +
	            hFormat.apply(this) +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return (
	            '' +
	            this.hours() +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    function meridiem(token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(
	                this.hours(),
	                this.minutes(),
	                lowercase
	            );
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem(isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a', matchMeridiem);
	    addRegexToken('A', matchMeridiem);
	    addRegexToken('H', match1to2);
	    addRegexToken('h', match1to2);
	    addRegexToken('k', match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM(input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return (input + '').toLowerCase().charAt(0) === 'p';
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
	        // Setting the hour should keep the time, because the user explicitly
	        // specified which hour they want. So trying to maintain the same hour (in
	        // a new timezone) makes sense. Adding/subtracting hours does not follow
	        // this rule.
	        getSetHour = makeGetSet('Hours', true);
	
	    function localeMeridiem(hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse,
	    };
	
	    // internal storage for locale config files
	    var locales = {},
	        localeFamilies = {},
	        globalLocale;
	
	    function commonPrefix(arr1, arr2) {
	        var i,
	            minl = Math.min(arr1.length, arr2.length);
	        for (i = 0; i < minl; i += 1) {
	            if (arr1[i] !== arr2[i]) {
	                return i;
	            }
	        }
	        return minl;
	    }
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0,
	            j,
	            next,
	            locale,
	            split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (
	                    next &&
	                    next.length >= j &&
	                    commonPrefix(split, next) >= j - 1
	                ) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null,
	            aliasedRequire;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (
	            locales[name] === undefined &&
	            typeof module !== 'undefined' &&
	            module &&
	            module.exports
	        ) {
	            try {
	                oldLocale = globalLocale._abbr;
	                aliasedRequire = require;
	                __webpack_require__(20)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {
	                // mark as not found to avoid repeating expensive file require call causing high CPU
	                // when trying to find en-US, en_US, en-us for every format call
	                locales[name] = null; // null means not found
	            }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale(key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            } else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            } else {
	                if (typeof console !== 'undefined' && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn(
	                        'Locale ' + key + ' not found. Did you forget to load it?'
	                    );
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale(name, config) {
	        if (config !== null) {
	            var locale,
	                parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple(
	                    'defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
	                );
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config,
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale,
	                tmpLocale,
	                parentConfig = baseConfig;
	
	            if (locales[name] != null && locales[name].parentLocale != null) {
	                // Update existing child locale in-place to avoid memory-leaks
	                locales[name].set(mergeConfigs(locales[name]._config, config));
	            } else {
	                // MERGE
	                tmpLocale = loadLocale(name);
	                if (tmpLocale != null) {
	                    parentConfig = tmpLocale._config;
	                }
	                config = mergeConfigs(parentConfig, config);
	                if (tmpLocale == null) {
	                    // updateLocale is called for creating a new locale
	                    // Set abbr so it will have a name (getters return
	                    // undefined otherwise).
	                    config.abbr = name;
	                }
	                locale = new Locale(config);
	                locale.parentLocale = locales[name];
	                locales[name] = locale;
	            }
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                    if (name === getSetGlobalLocale()) {
	                        getSetGlobalLocale(name);
	                    }
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale(key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow(m) {
	        var overflow,
	            a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH] < 0 || a[MONTH] > 11
	                    ? MONTH
	                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
	                    ? DATE
	                    : a[HOUR] < 0 ||
	                      a[HOUR] > 24 ||
	                      (a[HOUR] === 24 &&
	                          (a[MINUTE] !== 0 ||
	                              a[SECOND] !== 0 ||
	                              a[MILLISECOND] !== 0))
	                    ? HOUR
	                    : a[MINUTE] < 0 || a[MINUTE] > 59
	                    ? MINUTE
	                    : a[SECOND] < 0 || a[SECOND] > 59
	                    ? SECOND
	                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
	                    ? MILLISECOND
	                    : -1;
	
	            if (
	                getParsingFlags(m)._overflowDayOfYear &&
	                (overflow < YEAR || overflow > DATE)
	            ) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
	        isoDates = [
	            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	            ['YYYY-DDD', /\d{4}-\d{3}/],
	            ['YYYY-MM', /\d{4}-\d\d/, false],
	            ['YYYYYYMMDD', /[+-]\d{10}/],
	            ['YYYYMMDD', /\d{8}/],
	            ['GGGG[W]WWE', /\d{4}W\d{3}/],
	            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	            ['YYYYDDD', /\d{7}/],
	            ['YYYYMM', /\d{6}/, false],
	            ['YYYY', /\d{4}/, false],
	        ],
	        // iso time formats and regexes
	        isoTimes = [
	            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	            ['HH:mm', /\d\d:\d\d/],
	            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	            ['HHmmss', /\d\d\d\d\d\d/],
	            ['HHmm', /\d\d\d\d/],
	            ['HH', /\d\d/],
	        ],
	        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
	        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
	        obsOffsets = {
	            UT: 0,
	            GMT: 0,
	            EDT: -4 * 60,
	            EST: -5 * 60,
	            CDT: -5 * 60,
	            CST: -6 * 60,
	            MDT: -6 * 60,
	            MST: -7 * 60,
	            PDT: -7 * 60,
	            PST: -8 * 60,
	        };
	
	    // date from iso format
	    function configFromISO(config) {
	        var i,
	            l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime,
	            dateFormat,
	            timeFormat,
	            tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    function extractFromRFC2822Strings(
	        yearStr,
	        monthStr,
	        dayStr,
	        hourStr,
	        minuteStr,
	        secondStr
	    ) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10),
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s
	            .replace(/\([^)]*\)|[\n\t]/g, ' ')
	            .replace(/(\s\s+)/g, ' ')
	            .replace(/^\s\s*/, '')
	            .replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(
	                    parsedInput[0],
	                    parsedInput[1],
	                    parsedInput[2]
	                ).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10),
	                m = hm % 100,
	                h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i)),
	            parsedArray;
	        if (match) {
	            parsedArray = extractFromRFC2822Strings(
	                match[4],
	                match[3],
	                match[2],
	                match[5],
	                match[6],
	                match[7]
	            );
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        if (config._strict) {
	            config._isValid = false;
	        } else {
	            // Final attempt, use Input Fallback
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [
	                nowValue.getUTCFullYear(),
	                nowValue.getUTCMonth(),
	                nowValue.getUTCDate(),
	            ];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray(config) {
	        var i,
	            date,
	            input = [],
	            currentDate,
	            expectedWeekday,
	            yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (
	                config._dayOfYear > daysInYear(yearToUse) ||
	                config._dayOfYear === 0
	            ) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] =
	                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (
	            config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0
	        ) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(
	            null,
	            input
	        );
	        expectedWeekday = config._useUTC
	            ? config._d.getUTCDay()
	            : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (
	            config._w &&
	            typeof config._w.d !== 'undefined' &&
	            config._w.d !== expectedWeekday
	        ) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(
	                w.GG,
	                config._a[YEAR],
	                weekOfYear(createLocal(), 1, 4).year
	            );
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i,
	            parsedInput,
	            tokens,
	            token,
	            skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0,
	            era;
	
	        tokens =
	            expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
	                [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(
	                    string.indexOf(parsedInput) + parsedInput.length
	                );
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                } else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            } else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver =
	            stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (
	            config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0
	        ) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(
	            config._locale,
	            config._a[HOUR],
	            config._meridiem
	        );
	
	        // handle era
	        era = getParsingFlags(config).era;
	        if (era !== null) {
	            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
	        }
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	    function meridiemFixWrap(locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	            scoreToBeat,
	            i,
	            currentScore,
	            validFormatFound,
	            bestFormatIsValid = false;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            validFormatFound = false;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (isValid(tempConfig)) {
	                validFormatFound = true;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (!bestFormatIsValid) {
	                if (
	                    scoreToBeat == null ||
	                    currentScore < scoreToBeat ||
	                    validFormatFound
	                ) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                    if (validFormatFound) {
	                        bestFormatIsValid = true;
	                    }
	                }
	            } else {
	                if (currentScore < scoreToBeat) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                }
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i),
	            dayOrDate = i.day === undefined ? i.date : i.day;
	        config._a = map(
	            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
	            function (obj) {
	                return obj && parseInt(obj, 10);
	            }
	        );
	
	        configFromArray(config);
	    }
	
	    function createFromConfig(config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig(config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({ nullInput: true });
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC(input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (format === true || format === false) {
	            strict = format;
	            format = undefined;
	        }
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if (
	            (isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)
	        ) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other < this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        ),
	        prototypeMax = deprecate(
	            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other > this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +new Date();
	    };
	
	    var ordering = [
	        'year',
	        'quarter',
	        'month',
	        'week',
	        'day',
	        'hour',
	        'minute',
	        'second',
	        'millisecond',
	    ];
	
	    function isDurationValid(m) {
	        var key,
	            unitHasDecimal = false,
	            i;
	        for (key in m) {
	            if (
	                hasOwnProp(m, key) &&
	                !(
	                    indexOf.call(ordering, key) !== -1 &&
	                    (m[key] == null || !isNaN(m[key]))
	                )
	            ) {
	                return false;
	            }
	        }
	
	        for (i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration(duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds =
	            +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days + weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months + quarters * 3 + years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration(obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound(number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if (
	                (dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
	            ) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    // FORMATTING
	
	    function offset(token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset(),
	                sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return (
	                sign +
	                zeroFill(~~(offset / 60), 2) +
	                separator +
	                zeroFill(~~offset % 60, 2)
	            );
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z', matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher),
	            chunk,
	            parts,
	            minutes;
	
	        if (matches === null) {
	            return null;
	        }
	
	        chunk = matches[matches.length - 1] || [];
	        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff =
	                (isMoment(input) || isDate(input)
	                    ? input.valueOf()
	                    : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset(m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset());
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset(input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(
	                        this,
	                        createDuration(input - offset, 'm'),
	                        1,
	                        false
	                    );
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone(input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC(keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal(keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset() {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            } else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset(input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime() {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted() {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {},
	            other;
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted =
	                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal() {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset() {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc() {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
	        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	        // and further modified to allow for strings containing both week and day
	        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration(input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms: input._milliseconds,
	                d: input._days,
	                M: input._months,
	            };
	        } else if (isNumber(input) || !isNaN(+input)) {
	            duration = {};
	            if (key) {
	                duration[key] = +input;
	            } else {
	                duration.milliseconds = +input;
	            }
	        } else if ((match = aspNetRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: 0,
	                d: toInt(match[DATE]) * sign,
	                h: toInt(match[HOUR]) * sign,
	                m: toInt(match[MINUTE]) * sign,
	                s: toInt(match[SECOND]) * sign,
	                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
	            };
	        } else if ((match = isoRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: parseIso(match[2], sign),
	                M: parseIso(match[3], sign),
	                w: parseIso(match[4], sign),
	                d: parseIso(match[5], sign),
	                h: parseIso(match[6], sign),
	                m: parseIso(match[7], sign),
	                s: parseIso(match[8], sign),
	            };
	        } else if (duration == null) {
	            // checks for null or undefined
	            duration = {};
	        } else if (
	            typeof duration === 'object' &&
	            ('from' in duration || 'to' in duration)
	        ) {
	            diffRes = momentsDifference(
	                createLocal(duration.from),
	                createLocal(duration.to)
	            );
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
	            ret._isValid = input._isValid;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso(inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months =
	            other.month() - base.month() + (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +base.clone().add(res.months, 'M');
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return { milliseconds: 0, months: 0 };
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(
	                    name,
	                    'moment().' +
	                        name +
	                        '(period, number) is deprecated. Please use moment().' +
	                        name +
	                        '(number, period). ' +
	                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
	                );
	                tmp = val;
	                val = period;
	                period = tmp;
	            }
	
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract(mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add = createAdder(1, 'add'),
	        subtract = createAdder(-1, 'subtract');
	
	    function isString(input) {
	        return typeof input === 'string' || input instanceof String;
	    }
	
	    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
	    function isMomentInput(input) {
	        return (
	            isMoment(input) ||
	            isDate(input) ||
	            isString(input) ||
	            isNumber(input) ||
	            isNumberOrStringArray(input) ||
	            isMomentInputObject(input) ||
	            input === null ||
	            input === undefined
	        );
	    }
	
	    function isMomentInputObject(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'years',
	                'year',
	                'y',
	                'months',
	                'month',
	                'M',
	                'days',
	                'day',
	                'd',
	                'dates',
	                'date',
	                'D',
	                'hours',
	                'hour',
	                'h',
	                'minutes',
	                'minute',
	                'm',
	                'seconds',
	                'second',
	                's',
	                'milliseconds',
	                'millisecond',
	                'ms',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function isNumberOrStringArray(input) {
	        var arrayTest = isArray(input),
	            dataTypeTest = false;
	        if (arrayTest) {
	            dataTypeTest =
	                input.filter(function (item) {
	                    return !isNumber(item) && isString(input);
	                }).length === 0;
	        }
	        return arrayTest && dataTypeTest;
	    }
	
	    function isCalendarSpec(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'sameDay',
	                'nextDay',
	                'lastDay',
	                'nextWeek',
	                'lastWeek',
	                'sameElse',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6
	            ? 'sameElse'
	            : diff < -1
	            ? 'lastWeek'
	            : diff < 0
	            ? 'lastDay'
	            : diff < 1
	            ? 'sameDay'
	            : diff < 2
	            ? 'nextDay'
	            : diff < 7
	            ? 'nextWeek'
	            : 'sameElse';
	    }
	
	    function calendar$1(time, formats) {
	        // Support for single parameter, formats only overload to the calendar function
	        if (arguments.length === 1) {
	            if (!arguments[0]) {
	                time = undefined;
	                formats = undefined;
	            } else if (isMomentInput(arguments[0])) {
	                time = arguments[0];
	                formats = undefined;
	            } else if (isCalendarSpec(arguments[0])) {
	                formats = arguments[0];
	                time = undefined;
	            }
	        }
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse',
	            output =
	                formats &&
	                (isFunction(formats[format])
	                    ? formats[format].call(this, now)
	                    : formats[format]);
	
	        return this.format(
	            output || this.localeData().calendar(format, this, createLocal(now))
	        );
	    }
	
	    function clone() {
	        return new Moment(this);
	    }
	
	    function isAfter(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween(from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (
	            (inclusivity[0] === '('
	                ? this.isAfter(localFrom, units)
	                : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')'
	                ? this.isBefore(localTo, units)
	                : !this.isAfter(localTo, units))
	        );
	    }
	
	    function isSame(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return (
	                this.clone().startOf(units).valueOf() <= inputMs &&
	                inputMs <= this.clone().endOf(units).valueOf()
	            );
	        }
	    }
	
	    function isSameOrAfter(input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore(input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff(input, units, asFloat) {
	        var that, zoneDelta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year':
	                output = monthDiff(this, that) / 12;
	                break;
	            case 'month':
	                output = monthDiff(this, that);
	                break;
	            case 'quarter':
	                output = monthDiff(this, that) / 3;
	                break;
	            case 'second':
	                output = (this - that) / 1e3;
	                break; // 1000
	            case 'minute':
	                output = (this - that) / 6e4;
	                break; // 1000 * 60
	            case 'hour':
	                output = (this - that) / 36e5;
	                break; // 1000 * 60 * 60
	            case 'day':
	                output = (this - that - zoneDelta) / 864e5;
	                break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week':
	                output = (this - that - zoneDelta) / 6048e5;
	                break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default:
	                output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff(a, b) {
	        if (a.date() < b.date()) {
	            // end-of-month calculations work correct when the start month has more
	            // days than the end month.
	            return -monthDiff(b, a);
	        }
	        // difference in months
	        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2,
	            adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString() {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true,
	            m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(
	                m,
	                utc
	                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
	                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
	            );
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
	                    .toISOString()
	                    .replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(
	            m,
	            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
	        );
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect() {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment',
	            zone = '',
	            prefix,
	            year,
	            datetime,
	            suffix;
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        prefix = '[' + func + '("]';
	        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
	        datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format(inputString) {
	        if (!inputString) {
	            inputString = this.isUtc()
	                ? hooks.defaultFormatUtc
	                : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ to: this, from: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow(withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ from: this, to: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow(withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale(key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData() {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000,
	        MS_PER_MINUTE = 60 * MS_PER_SECOND,
	        MS_PER_HOUR = 60 * MS_PER_MINUTE,
	        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return ((dividend % divisor) + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(
	                    this.year(),
	                    this.month() - (this.month() % 3),
	                    1
	                );
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - this.weekday()
	                );
	                break;
	            case 'isoWeek':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - (this.isoWeekday() - 1)
	                );
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(
	                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                    MS_PER_HOUR
	                );
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month() - (this.month() % 3) + 3,
	                        1
	                    ) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - this.weekday() + 7
	                    ) - 1;
	                break;
	            case 'isoWeek':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - (this.isoWeekday() - 1) + 7
	                    ) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time +=
	                    MS_PER_HOUR -
	                    mod$1(
	                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                        MS_PER_HOUR
	                    ) -
	                    1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf() {
	        return this._d.valueOf() - (this._offset || 0) * 60000;
	    }
	
	    function unix() {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate() {
	        return new Date(this.valueOf());
	    }
	
	    function toArray() {
	        var m = this;
	        return [
	            m.year(),
	            m.month(),
	            m.date(),
	            m.hour(),
	            m.minute(),
	            m.second(),
	            m.millisecond(),
	        ];
	    }
	
	    function toObject() {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds(),
	        };
	    }
	
	    function toJSON() {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2() {
	        return isValid(this);
	    }
	
	    function parsingFlags() {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt() {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict,
	        };
	    }
	
	    addFormatToken('N', 0, 0, 'eraAbbr');
	    addFormatToken('NN', 0, 0, 'eraAbbr');
	    addFormatToken('NNN', 0, 0, 'eraAbbr');
	    addFormatToken('NNNN', 0, 0, 'eraName');
	    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
	
	    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
	    addFormatToken('y', ['yy', 2], 0, 'eraYear');
	    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
	    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
	
	    addRegexToken('N', matchEraAbbr);
	    addRegexToken('NN', matchEraAbbr);
	    addRegexToken('NNN', matchEraAbbr);
	    addRegexToken('NNNN', matchEraName);
	    addRegexToken('NNNNN', matchEraNarrow);
	
	    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
	        input,
	        array,
	        config,
	        token
	    ) {
	        var era = config._locale.erasParse(input, token, config._strict);
	        if (era) {
	            getParsingFlags(config).era = era;
	        } else {
	            getParsingFlags(config).invalidEra = input;
	        }
	    });
	
	    addRegexToken('y', matchUnsigned);
	    addRegexToken('yy', matchUnsigned);
	    addRegexToken('yyy', matchUnsigned);
	    addRegexToken('yyyy', matchUnsigned);
	    addRegexToken('yo', matchEraYearOrdinal);
	
	    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
	    addParseToken(['yo'], function (input, array, config, token) {
	        var match;
	        if (config._locale._eraYearOrdinalRegex) {
	            match = input.match(config._locale._eraYearOrdinalRegex);
	        }
	
	        if (config._locale.eraYearOrdinalParse) {
	            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
	        } else {
	            array[YEAR] = parseInt(input, 10);
	        }
	    });
	
	    function localeEras(m, format) {
	        var i,
	            l,
	            date,
	            eras = this._eras || getLocale('en')._eras;
	        for (i = 0, l = eras.length; i < l; ++i) {
	            switch (typeof eras[i].since) {
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].since).startOf('day');
	                    eras[i].since = date.valueOf();
	                    break;
	            }
	
	            switch (typeof eras[i].until) {
	                case 'undefined':
	                    eras[i].until = +Infinity;
	                    break;
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].until).startOf('day').valueOf();
	                    eras[i].until = date.valueOf();
	                    break;
	            }
	        }
	        return eras;
	    }
	
	    function localeErasParse(eraName, format, strict) {
	        var i,
	            l,
	            eras = this.eras(),
	            name,
	            abbr,
	            narrow;
	        eraName = eraName.toUpperCase();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            name = eras[i].name.toUpperCase();
	            abbr = eras[i].abbr.toUpperCase();
	            narrow = eras[i].narrow.toUpperCase();
	
	            if (strict) {
	                switch (format) {
	                    case 'N':
	                    case 'NN':
	                    case 'NNN':
	                        if (abbr === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNN':
	                        if (name === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNNN':
	                        if (narrow === eraName) {
	                            return eras[i];
	                        }
	                        break;
	                }
	            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
	                return eras[i];
	            }
	        }
	    }
	
	    function localeErasConvertYear(era, year) {
	        var dir = era.since <= era.until ? +1 : -1;
	        if (year === undefined) {
	            return hooks(era.since).year();
	        } else {
	            return hooks(era.since).year() + (year - era.offset) * dir;
	        }
	    }
	
	    function getEraName() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].name;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].name;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraNarrow() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].narrow;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].narrow;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraAbbr() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].abbr;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].abbr;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraYear() {
	        var i,
	            l,
	            dir,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            dir = eras[i].since <= eras[i].until ? +1 : -1;
	
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (
	                (eras[i].since <= val && val <= eras[i].until) ||
	                (eras[i].until <= val && val <= eras[i].since)
	            ) {
	                return (
	                    (this.year() - hooks(eras[i].since).year()) * dir +
	                    eras[i].offset
	                );
	            }
	        }
	
	        return this.year();
	    }
	
	    function erasNameRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNameRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNameRegex : this._erasRegex;
	    }
	
	    function erasAbbrRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasAbbrRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasAbbrRegex : this._erasRegex;
	    }
	
	    function erasNarrowRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNarrowRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNarrowRegex : this._erasRegex;
	    }
	
	    function matchEraAbbr(isStrict, locale) {
	        return locale.erasAbbrRegex(isStrict);
	    }
	
	    function matchEraName(isStrict, locale) {
	        return locale.erasNameRegex(isStrict);
	    }
	
	    function matchEraNarrow(isStrict, locale) {
	        return locale.erasNarrowRegex(isStrict);
	    }
	
	    function matchEraYearOrdinal(isStrict, locale) {
	        return locale._eraYearOrdinalRegex || matchUnsigned;
	    }
	
	    function computeErasParse() {
	        var abbrPieces = [],
	            namePieces = [],
	            narrowPieces = [],
	            mixedPieces = [],
	            i,
	            l,
	            eras = this.eras();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            namePieces.push(regexEscape(eras[i].name));
	            abbrPieces.push(regexEscape(eras[i].abbr));
	            narrowPieces.push(regexEscape(eras[i].narrow));
	
	            mixedPieces.push(regexEscape(eras[i].name));
	            mixedPieces.push(regexEscape(eras[i].abbr));
	            mixedPieces.push(regexEscape(eras[i].narrow));
	        }
	
	        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
	        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
	        this._erasNarrowRegex = new RegExp(
	            '^(' + narrowPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken(token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg', 'weekYear');
	    addWeekYearFormatToken('ggggg', 'weekYear');
	    addWeekYearFormatToken('GGGG', 'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	    // PARSING
	
	    addRegexToken('G', matchSigned);
	    addRegexToken('g', matchSigned);
	    addRegexToken('GG', match1to2, match2);
	    addRegexToken('gg', match1to2, match2);
	    addRegexToken('GGGG', match1to4, match4);
	    addRegexToken('gggg', match1to4, match4);
	    addRegexToken('GGGGG', match1to6, match6);
	    addRegexToken('ggggg', match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
	        input,
	        week,
	        config,
	        token
	    ) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy
	        );
	    }
	
	    function getSetISOWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.isoWeek(),
	            this.isoWeekday(),
	            1,
	            4
	        );
	    }
	
	    function getISOWeeksInYear() {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getISOWeeksInISOWeekYear() {
	        return weeksInYear(this.isoWeekYear(), 1, 4);
	    }
	
	    function getWeeksInYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getWeeksInWeekYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter(input) {
	        return input == null
	            ? Math.ceil((this.month() + 1) / 3)
	            : this.month((input - 1) * 3 + (this.month() % 3));
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D', match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict
	            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
	            : locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD', match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear(input) {
	        var dayOfYear =
	            Math.round(
	                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
	            ) + 1;
	        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m', match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s', match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S', match1to3, match1);
	    addRegexToken('SS', match1to3, match2);
	    addRegexToken('SSS', match1to3, match3);
	
	    var token, getSetMillisecond;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	
	    getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z', 0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr() {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName() {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add = add;
	    proto.calendar = calendar$1;
	    proto.clone = clone;
	    proto.diff = diff;
	    proto.endOf = endOf;
	    proto.format = format;
	    proto.from = from;
	    proto.fromNow = fromNow;
	    proto.to = to;
	    proto.toNow = toNow;
	    proto.get = stringGet;
	    proto.invalidAt = invalidAt;
	    proto.isAfter = isAfter;
	    proto.isBefore = isBefore;
	    proto.isBetween = isBetween;
	    proto.isSame = isSame;
	    proto.isSameOrAfter = isSameOrAfter;
	    proto.isSameOrBefore = isSameOrBefore;
	    proto.isValid = isValid$2;
	    proto.lang = lang;
	    proto.locale = locale;
	    proto.localeData = localeData;
	    proto.max = prototypeMax;
	    proto.min = prototypeMin;
	    proto.parsingFlags = parsingFlags;
	    proto.set = stringSet;
	    proto.startOf = startOf;
	    proto.subtract = subtract;
	    proto.toArray = toArray;
	    proto.toObject = toObject;
	    proto.toDate = toDate;
	    proto.toISOString = toISOString;
	    proto.inspect = inspect;
	    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
	        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
	            return 'Moment<' + this.format() + '>';
	        };
	    }
	    proto.toJSON = toJSON;
	    proto.toString = toString;
	    proto.unix = unix;
	    proto.valueOf = valueOf;
	    proto.creationData = creationData;
	    proto.eraName = getEraName;
	    proto.eraNarrow = getEraNarrow;
	    proto.eraAbbr = getEraAbbr;
	    proto.eraYear = getEraYear;
	    proto.year = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week = proto.weeks = getSetWeek;
	    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
	    proto.weeksInYear = getWeeksInYear;
	    proto.weeksInWeekYear = getWeeksInWeekYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
	    proto.date = getSetDayOfMonth;
	    proto.day = proto.days = getSetDayOfWeek;
	    proto.weekday = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset = getSetOffset;
	    proto.utc = setOffsetToUTC;
	    proto.local = setOffsetToLocal;
	    proto.parseZone = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST = isDaylightSavingTime;
	    proto.isLocal = isLocal;
	    proto.isUtcOffset = isUtcOffset;
	    proto.isUtc = isUtc;
	    proto.isUTC = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates = deprecate(
	        'dates accessor is deprecated. Use date instead.',
	        getSetDayOfMonth
	    );
	    proto.months = deprecate(
	        'months accessor is deprecated. Use month instead',
	        getSetMonth
	    );
	    proto.years = deprecate(
	        'years accessor is deprecated. Use year instead',
	        getSetYear
	    );
	    proto.zone = deprecate(
	        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
	        getSetZone
	    );
	    proto.isDSTShifted = deprecate(
	        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
	        isDaylightSavingTimeShifted
	    );
	
	    function createUnix(input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone() {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat(string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar = calendar;
	    proto$1.longDateFormat = longDateFormat;
	    proto$1.invalidDate = invalidDate;
	    proto$1.ordinal = ordinal;
	    proto$1.preparse = preParsePostFormat;
	    proto$1.postformat = preParsePostFormat;
	    proto$1.relativeTime = relativeTime;
	    proto$1.pastFuture = pastFuture;
	    proto$1.set = set;
	    proto$1.eras = localeEras;
	    proto$1.erasParse = localeErasParse;
	    proto$1.erasConvertYear = localeErasConvertYear;
	    proto$1.erasAbbrRegex = erasAbbrRegex;
	    proto$1.erasNameRegex = erasNameRegex;
	    proto$1.erasNarrowRegex = erasNarrowRegex;
	
	    proto$1.months = localeMonths;
	    proto$1.monthsShort = localeMonthsShort;
	    proto$1.monthsParse = localeMonthsParse;
	    proto$1.monthsRegex = monthsRegex;
	    proto$1.monthsShortRegex = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays = localeWeekdays;
	    proto$1.weekdaysMin = localeWeekdaysMin;
	    proto$1.weekdaysShort = localeWeekdaysShort;
	    proto$1.weekdaysParse = localeWeekdaysParse;
	
	    proto$1.weekdaysRegex = weekdaysRegex;
	    proto$1.weekdaysShortRegex = weekdaysShortRegex;
	    proto$1.weekdaysMinRegex = weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1(format, index, field, setter) {
	        var locale = getLocale(),
	            utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl(format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i,
	            out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl(localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0,
	            i,
	            out = [];
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths(format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort(format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        eras: [
	            {
	                since: '0001-01-01',
	                until: +Infinity,
	                offset: 1,
	                name: 'Anno Domini',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: 'Before Christ',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    toInt((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate(
	        'moment.lang is deprecated. Use moment.locale instead.',
	        getSetGlobalLocale
	    );
	    hooks.langData = deprecate(
	        'moment.langData is deprecated. Use moment.localeData instead.',
	        getLocale
	    );
	
	    var mathAbs = Math.abs;
	
	    function abs() {
	        var data = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days = mathAbs(this._days);
	        this._months = mathAbs(this._months);
	
	        data.milliseconds = mathAbs(data.milliseconds);
	        data.seconds = mathAbs(data.seconds);
	        data.minutes = mathAbs(data.minutes);
	        data.hours = mathAbs(data.hours);
	        data.months = mathAbs(data.months);
	        data.years = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1(duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days += direction * other._days;
	        duration._months += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1(input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1(input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil(number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble() {
	        var milliseconds = this._milliseconds,
	            days = this._days,
	            months = this._months,
	            data = this._data,
	            seconds,
	            minutes,
	            hours,
	            years,
	            monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (
	            !(
	                (milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0)
	            )
	        ) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds = absFloor(milliseconds / 1000);
	        data.seconds = seconds % 60;
	
	        minutes = absFloor(seconds / 60);
	        data.minutes = minutes % 60;
	
	        hours = absFloor(minutes / 60);
	        data.hours = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days = days;
	        data.months = months;
	        data.years = years;
	
	        return this;
	    }
	
	    function daysToMonths(days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return (days * 4800) / 146097;
	    }
	
	    function monthsToDays(months) {
	        // the reverse of daysToMonths
	        return (months * 146097) / 4800;
	    }
	
	    function as(units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days,
	            months,
	            milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':
	                    return months;
	                case 'quarter':
	                    return months / 3;
	                case 'year':
	                    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week':
	                    return days / 7 + milliseconds / 6048e5;
	                case 'day':
	                    return days + milliseconds / 864e5;
	                case 'hour':
	                    return days * 24 + milliseconds / 36e5;
	                case 'minute':
	                    return days * 1440 + milliseconds / 6e4;
	                case 'second':
	                    return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond':
	                    return Math.floor(days * 864e5) + milliseconds;
	                default:
	                    throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1() {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs(alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms'),
	        asSeconds = makeAs('s'),
	        asMinutes = makeAs('m'),
	        asHours = makeAs('h'),
	        asDays = makeAs('d'),
	        asWeeks = makeAs('w'),
	        asMonths = makeAs('M'),
	        asQuarters = makeAs('Q'),
	        asYears = makeAs('y');
	
	    function clone$1() {
	        return createDuration(this);
	    }
	
	    function get$2(units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds'),
	        seconds = makeGetter('seconds'),
	        minutes = makeGetter('minutes'),
	        hours = makeGetter('hours'),
	        days = makeGetter('days'),
	        months = makeGetter('months'),
	        years = makeGetter('years');
	
	    function weeks() {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round,
	        thresholds = {
	            ss: 44, // a few seconds to seconds
	            s: 45, // seconds to minute
	            m: 45, // minutes to hour
	            h: 22, // hours to day
	            d: 26, // days to month/week
	            w: null, // weeks to month
	            M: 11, // months to year
	        };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
	        var duration = createDuration(posNegDuration).abs(),
	            seconds = round(duration.as('s')),
	            minutes = round(duration.as('m')),
	            hours = round(duration.as('h')),
	            days = round(duration.as('d')),
	            months = round(duration.as('M')),
	            weeks = round(duration.as('w')),
	            years = round(duration.as('y')),
	            a =
	                (seconds <= thresholds.ss && ['s', seconds]) ||
	                (seconds < thresholds.s && ['ss', seconds]) ||
	                (minutes <= 1 && ['m']) ||
	                (minutes < thresholds.m && ['mm', minutes]) ||
	                (hours <= 1 && ['h']) ||
	                (hours < thresholds.h && ['hh', hours]) ||
	                (days <= 1 && ['d']) ||
	                (days < thresholds.d && ['dd', days]);
	
	        if (thresholds.w != null) {
	            a =
	                a ||
	                (weeks <= 1 && ['w']) ||
	                (weeks < thresholds.w && ['ww', weeks]);
	        }
	        a = a ||
	            (months <= 1 && ['M']) ||
	            (months < thresholds.M && ['MM', months]) ||
	            (years <= 1 && ['y']) || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding(roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof roundingFunction === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold(threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize(argWithSuffix, argThresholds) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var withSuffix = false,
	            th = thresholds,
	            locale,
	            output;
	
	        if (typeof argWithSuffix === 'object') {
	            argThresholds = argWithSuffix;
	            argWithSuffix = false;
	        }
	        if (typeof argWithSuffix === 'boolean') {
	            withSuffix = argWithSuffix;
	        }
	        if (typeof argThresholds === 'object') {
	            th = Object.assign({}, thresholds, argThresholds);
	            if (argThresholds.s != null && argThresholds.ss == null) {
	                th.ss = argThresholds.s - 1;
	            }
	        }
	
	        locale = this.localeData();
	        output = relativeTime$1(this, !withSuffix, th, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return (x > 0) - (x < 0) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000,
	            days = abs$1(this._days),
	            months = abs$1(this._months),
	            minutes,
	            hours,
	            years,
	            s,
	            total = this.asSeconds(),
	            totalSign,
	            ymSign,
	            daysSign,
	            hmsSign;
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes = absFloor(seconds / 60);
	        hours = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	
	        totalSign = total < 0 ? '-' : '';
	        ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return (
	            totalSign +
	            'P' +
	            (years ? ymSign + years + 'Y' : '') +
	            (months ? ymSign + months + 'M' : '') +
	            (days ? daysSign + days + 'D' : '') +
	            (hours || minutes || seconds ? 'T' : '') +
	            (hours ? hmsSign + hours + 'H' : '') +
	            (minutes ? hmsSign + minutes + 'M' : '') +
	            (seconds ? hmsSign + s + 'S' : '')
	        );
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid = isValid$1;
	    proto$2.abs = abs;
	    proto$2.add = add$1;
	    proto$2.subtract = subtract$1;
	    proto$2.as = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds = asSeconds;
	    proto$2.asMinutes = asMinutes;
	    proto$2.asHours = asHours;
	    proto$2.asDays = asDays;
	    proto$2.asWeeks = asWeeks;
	    proto$2.asMonths = asMonths;
	    proto$2.asQuarters = asQuarters;
	    proto$2.asYears = asYears;
	    proto$2.valueOf = valueOf$1;
	    proto$2._bubble = bubble;
	    proto$2.clone = clone$1;
	    proto$2.get = get$2;
	    proto$2.milliseconds = milliseconds;
	    proto$2.seconds = seconds;
	    proto$2.minutes = minutes;
	    proto$2.hours = hours;
	    proto$2.days = days;
	    proto$2.weeks = weeks;
	    proto$2.months = months;
	    proto$2.years = years;
	    proto$2.humanize = humanize;
	    proto$2.toISOString = toISOString$1;
	    proto$2.toString = toISOString$1;
	    proto$2.toJSON = toISOString$1;
	    proto$2.locale = locale;
	    proto$2.localeData = localeData;
	
	    proto$2.toIsoString = deprecate(
	        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
	        toISOString$1
	    );
	    proto$2.lang = lang;
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    //! moment.js
	
	    hooks.version = '2.29.1';
	
	    setHookCallback(createLocal);
	
	    hooks.fn = proto;
	    hooks.min = min;
	    hooks.max = max;
	    hooks.now = now;
	    hooks.utc = createUTC;
	    hooks.unix = createUnix;
	    hooks.months = listMonths;
	    hooks.isDate = isDate;
	    hooks.locale = getSetGlobalLocale;
	    hooks.invalid = createInvalid;
	    hooks.duration = createDuration;
	    hooks.isMoment = isMoment;
	    hooks.weekdays = listWeekdays;
	    hooks.parseZone = createInZone;
	    hooks.localeData = getLocale;
	    hooks.isDuration = isDuration;
	    hooks.monthsShort = listMonthsShort;
	    hooks.weekdaysMin = listWeekdaysMin;
	    hooks.defineLocale = defineLocale;
	    hooks.updateLocale = updateLocale;
	    hooks.locales = listLocales;
	    hooks.weekdaysShort = listWeekdaysShort;
	    hooks.normalizeUnits = normalizeUnits;
	    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat = getCalendarFormat;
	    hooks.prototype = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD', // <input type="date" />
	        TIME: 'HH:mm', // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW', // <input type="week" />
	        MONTH: 'YYYY-MM', // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)(module)))

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 21,
		"./af.js": 21,
		"./ar": 22,
		"./ar-dz": 23,
		"./ar-dz.js": 23,
		"./ar-kw": 24,
		"./ar-kw.js": 24,
		"./ar-ly": 25,
		"./ar-ly.js": 25,
		"./ar-ma": 26,
		"./ar-ma.js": 26,
		"./ar-sa": 27,
		"./ar-sa.js": 27,
		"./ar-tn": 28,
		"./ar-tn.js": 28,
		"./ar.js": 22,
		"./az": 29,
		"./az.js": 29,
		"./be": 30,
		"./be.js": 30,
		"./bg": 31,
		"./bg.js": 31,
		"./bm": 32,
		"./bm.js": 32,
		"./bn": 33,
		"./bn-bd": 34,
		"./bn-bd.js": 34,
		"./bn.js": 33,
		"./bo": 35,
		"./bo.js": 35,
		"./br": 36,
		"./br.js": 36,
		"./bs": 37,
		"./bs.js": 37,
		"./ca": 38,
		"./ca.js": 38,
		"./cs": 39,
		"./cs.js": 39,
		"./cv": 40,
		"./cv.js": 40,
		"./cy": 41,
		"./cy.js": 41,
		"./da": 42,
		"./da.js": 42,
		"./de": 43,
		"./de-at": 44,
		"./de-at.js": 44,
		"./de-ch": 45,
		"./de-ch.js": 45,
		"./de.js": 43,
		"./dv": 46,
		"./dv.js": 46,
		"./el": 47,
		"./el.js": 47,
		"./en-au": 48,
		"./en-au.js": 48,
		"./en-ca": 49,
		"./en-ca.js": 49,
		"./en-gb": 50,
		"./en-gb.js": 50,
		"./en-ie": 51,
		"./en-ie.js": 51,
		"./en-il": 52,
		"./en-il.js": 52,
		"./en-in": 53,
		"./en-in.js": 53,
		"./en-nz": 54,
		"./en-nz.js": 54,
		"./en-sg": 55,
		"./en-sg.js": 55,
		"./eo": 56,
		"./eo.js": 56,
		"./es": 57,
		"./es-do": 58,
		"./es-do.js": 58,
		"./es-mx": 59,
		"./es-mx.js": 59,
		"./es-us": 60,
		"./es-us.js": 60,
		"./es.js": 57,
		"./et": 61,
		"./et.js": 61,
		"./eu": 62,
		"./eu.js": 62,
		"./fa": 63,
		"./fa.js": 63,
		"./fi": 64,
		"./fi.js": 64,
		"./fil": 65,
		"./fil.js": 65,
		"./fo": 66,
		"./fo.js": 66,
		"./fr": 67,
		"./fr-ca": 68,
		"./fr-ca.js": 68,
		"./fr-ch": 69,
		"./fr-ch.js": 69,
		"./fr.js": 67,
		"./fy": 70,
		"./fy.js": 70,
		"./ga": 71,
		"./ga.js": 71,
		"./gd": 72,
		"./gd.js": 72,
		"./gl": 73,
		"./gl.js": 73,
		"./gom-deva": 74,
		"./gom-deva.js": 74,
		"./gom-latn": 75,
		"./gom-latn.js": 75,
		"./gu": 76,
		"./gu.js": 76,
		"./he": 77,
		"./he.js": 77,
		"./hi": 78,
		"./hi.js": 78,
		"./hr": 79,
		"./hr.js": 79,
		"./hu": 80,
		"./hu.js": 80,
		"./hy-am": 81,
		"./hy-am.js": 81,
		"./id": 82,
		"./id.js": 82,
		"./is": 83,
		"./is.js": 83,
		"./it": 84,
		"./it-ch": 85,
		"./it-ch.js": 85,
		"./it.js": 84,
		"./ja": 86,
		"./ja.js": 86,
		"./jv": 87,
		"./jv.js": 87,
		"./ka": 88,
		"./ka.js": 88,
		"./kk": 89,
		"./kk.js": 89,
		"./km": 90,
		"./km.js": 90,
		"./kn": 91,
		"./kn.js": 91,
		"./ko": 92,
		"./ko.js": 92,
		"./ku": 93,
		"./ku.js": 93,
		"./ky": 94,
		"./ky.js": 94,
		"./lb": 95,
		"./lb.js": 95,
		"./lo": 96,
		"./lo.js": 96,
		"./lt": 97,
		"./lt.js": 97,
		"./lv": 98,
		"./lv.js": 98,
		"./me": 99,
		"./me.js": 99,
		"./mi": 100,
		"./mi.js": 100,
		"./mk": 101,
		"./mk.js": 101,
		"./ml": 102,
		"./ml.js": 102,
		"./mn": 103,
		"./mn.js": 103,
		"./mr": 104,
		"./mr.js": 104,
		"./ms": 105,
		"./ms-my": 106,
		"./ms-my.js": 106,
		"./ms.js": 105,
		"./mt": 107,
		"./mt.js": 107,
		"./my": 108,
		"./my.js": 108,
		"./nb": 109,
		"./nb.js": 109,
		"./ne": 110,
		"./ne.js": 110,
		"./nl": 111,
		"./nl-be": 112,
		"./nl-be.js": 112,
		"./nl.js": 111,
		"./nn": 113,
		"./nn.js": 113,
		"./oc-lnc": 114,
		"./oc-lnc.js": 114,
		"./pa-in": 115,
		"./pa-in.js": 115,
		"./pl": 116,
		"./pl.js": 116,
		"./pt": 117,
		"./pt-br": 118,
		"./pt-br.js": 118,
		"./pt.js": 117,
		"./ro": 119,
		"./ro.js": 119,
		"./ru": 120,
		"./ru.js": 120,
		"./sd": 121,
		"./sd.js": 121,
		"./se": 122,
		"./se.js": 122,
		"./si": 123,
		"./si.js": 123,
		"./sk": 124,
		"./sk.js": 124,
		"./sl": 125,
		"./sl.js": 125,
		"./sq": 126,
		"./sq.js": 126,
		"./sr": 127,
		"./sr-cyrl": 128,
		"./sr-cyrl.js": 128,
		"./sr.js": 127,
		"./ss": 129,
		"./ss.js": 129,
		"./sv": 130,
		"./sv.js": 130,
		"./sw": 131,
		"./sw.js": 131,
		"./ta": 132,
		"./ta.js": 132,
		"./te": 133,
		"./te.js": 133,
		"./tet": 134,
		"./tet.js": 134,
		"./tg": 135,
		"./tg.js": 135,
		"./th": 136,
		"./th.js": 136,
		"./tk": 137,
		"./tk.js": 137,
		"./tl-ph": 138,
		"./tl-ph.js": 138,
		"./tlh": 139,
		"./tlh.js": 139,
		"./tr": 140,
		"./tr.js": 140,
		"./tzl": 141,
		"./tzl.js": 141,
		"./tzm": 142,
		"./tzm-latn": 143,
		"./tzm-latn.js": 143,
		"./tzm.js": 142,
		"./ug-cn": 144,
		"./ug-cn.js": 144,
		"./uk": 145,
		"./uk.js": 145,
		"./ur": 146,
		"./ur.js": 146,
		"./uz": 147,
		"./uz-latn": 148,
		"./uz-latn.js": 148,
		"./uz.js": 147,
		"./vi": 149,
		"./vi.js": 149,
		"./x-pseudo": 150,
		"./x-pseudo.js": 150,
		"./yo": 151,
		"./yo.js": 151,
		"./zh-cn": 152,
		"./zh-cn.js": 152,
		"./zh-hk": 153,
		"./zh-hk.js": 153,
		"./zh-mo": 154,
		"./zh-mo.js": 154,
		"./zh-tw": 155,
		"./zh-tw.js": 155
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 20;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var af = moment.defineLocale('af', {
	        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM: function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Vandag om] LT',
	            nextDay: '[Môre om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[Gister om] LT',
	            lastWeek: '[Laas] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oor %s',
	            past: '%s gelede',
	            s: "'n paar sekondes",
	            ss: '%d sekondes',
	            m: "'n minuut",
	            mm: '%d minute',
	            h: "'n uur",
	            hh: '%d ure',
	            d: "'n dag",
	            dd: '%d dae',
	            M: "'n maand",
	            MM: '%d maande',
	            y: "'n jaar",
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            ); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week: {
	            dow: 1, // Maandag is die eerste dag van die week.
	            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        },
	    });
	
	    return af;
	
	})));


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var ar = moment.defineLocale('ar', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ar;
	
	})));


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Amine Roukh: https://github.com/Amine27
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'جانفي',
	            'فيفري',
	            'مارس',
	            'أفريل',
	            'ماي',
	            'جوان',
	            'جويلية',
	            'أوت',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arDz;
	
	})));


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arKw;
	
	})));


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '1',
	            2: '2',
	            3: '3',
	            4: '4',
	            5: '5',
	            6: '6',
	            7: '7',
	            8: '8',
	            9: '9',
	            0: '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arLy;
	
	})));


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arMa;
	
	})));


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return arSa;
	
	})));


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arTn;
	
	})));


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı',
	    };
	
	    var az = moment.defineLocale('az', {
	        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays: 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
	            '_'
	        ),
	        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[sabah saat] LT',
	            nextWeek: '[gələn həftə] dddd [saat] LT',
	            lastDay: '[dünən] LT',
	            lastWeek: '[keçən həftə] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s əvvəl',
	            s: 'bir neçə saniyə',
	            ss: '%d saniyə',
	            m: 'bir dəqiqə',
	            mm: '%d dəqiqə',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir il',
	            yy: '%d il',
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM: function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal: function (number) {
	            if (number === 0) {
	                // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = (number % 100) - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return az;
	
	})));


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            dd: 'дзень_дні_дзён',
	            MM: 'месяц_месяцы_месяцаў',
	            yy: 'год_гады_гадоў',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months: {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
	                '_'
	            ),
	            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split(
	            '_'
	        ),
	        weekdays: {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
	                '_'
	            ),
	            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
	                '_'
	            ),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
	        },
	        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
	        },
	        calendar: {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'праз %s',
	            past: '%s таму',
	            s: 'некалькі секунд',
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithPlural,
	            hh: relativeTimeWithPlural,
	            d: 'дзень',
	            dd: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM: function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) &&
	                        number % 100 !== 12 &&
	                        number % 100 !== 13
	                        ? number + '-і'
	                        : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return be;
	
	})));


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bg = moment.defineLocale('bg', {
	        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Днес в] LT',
	            nextDay: '[Утре в] LT',
	            nextWeek: 'dddd [в] LT',
	            lastDay: '[Вчера в] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Миналата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Миналия] dddd [в] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'след %s',
	            past: 'преди %s',
	            s: 'няколко секунди',
	            ss: '%d секунди',
	            m: 'минута',
	            mm: '%d минути',
	            h: 'час',
	            hh: '%d часа',
	            d: 'ден',
	            dd: '%d дена',
	            w: 'седмица',
	            ww: '%d седмици',
	            M: 'месец',
	            MM: '%d месеца',
	            y: 'година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bg;
	
	})));


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bambara [bm]
	//! author : Estelle Comment : https://github.com/estellecomment
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bm = moment.defineLocale('bm', {
	        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
	            '_'
	        ),
	        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'MMMM [tile] D [san] YYYY',
	            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bi lɛrɛ] LT',
	            nextDay: '[Sini lɛrɛ] LT',
	            nextWeek: 'dddd [don lɛrɛ] LT',
	            lastDay: '[Kunu lɛrɛ] LT',
	            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s kɔnɔ',
	            past: 'a bɛ %s bɔ',
	            s: 'sanga dama dama',
	            ss: 'sekondi %d',
	            m: 'miniti kelen',
	            mm: 'miniti %d',
	            h: 'lɛrɛ kelen',
	            hh: 'lɛrɛ %d',
	            d: 'tile kelen',
	            dd: 'tile %d',
	            M: 'kalo kelen',
	            MM: 'kalo %d',
	            y: 'san kelen',
	            yy: 'san %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return bm;
	
	})));


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bn = moment.defineLocale('bn', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort: 'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	            '_'
	        ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bn;
	
	})));


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali (Bangladesh) [bn-bd]
	//! author : Asraf Hossain Patoary : https://github.com/ashwoolford
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bnBd = moment.defineLocale('bn-bd', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort: 'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	            '_'
	        ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	
	        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'রাত') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ভোর') {
	                return hour;
	            } else if (meridiem === 'সকাল') {
	                return hour;
	            } else if (meridiem === 'দুপুর') {
	                return hour >= 3 ? hour : hour + 12;
	            } else if (meridiem === 'বিকাল') {
	                return hour + 12;
	            } else if (meridiem === 'সন্ধ্যা') {
	                return hour + 12;
	            }
	        },
	
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 6) {
	                return 'ভোর';
	            } else if (hour < 12) {
	                return 'সকাল';
	            } else if (hour < 15) {
	                return 'দুপুর';
	            } else if (hour < 18) {
	                return 'বিকাল';
	            } else if (hour < 20) {
	                return 'সন্ধ্যা';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bnBd;
	
	})));


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '༡',
	            2: '༢',
	            3: '༣',
	            4: '༤',
	            5: '༥',
	            6: '༦',
	            7: '༧',
	            8: '༨',
	            9: '༩',
	            0: '༠',
	        },
	        numberMap = {
	            '༡': '1',
	            '༢': '2',
	            '༣': '3',
	            '༤': '4',
	            '༥': '5',
	            '༦': '6',
	            '༧': '7',
	            '༨': '8',
	            '༩': '9',
	            '༠': '0',
	        };
	
	    var bo = moment.defineLocale('bo', {
	        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
	            '_'
	        ),
	        monthsShort: 'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
	            '_'
	        ),
	        monthsShortRegex: /^(ཟླ་\d{1,2})/,
	        monthsParseExact: true,
	        weekdays: 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
	            '_'
	        ),
	        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
	            '_'
	        ),
	        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[དི་རིང] LT',
	            nextDay: '[སང་ཉིན] LT',
	            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay: '[ཁ་སང] LT',
	            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ལ་',
	            past: '%s སྔན་ལ',
	            s: 'ལམ་སང',
	            ss: '%d སྐར་ཆ།',
	            m: 'སྐར་མ་གཅིག',
	            mm: '%d སྐར་མ',
	            h: 'ཆུ་ཚོད་གཅིག',
	            hh: '%d ཆུ་ཚོད',
	            d: 'ཉིན་གཅིག',
	            dd: '%d ཉིན་',
	            M: 'ཟླ་བ་གཅིག',
	            MM: '%d ཟླ་བ',
	            y: 'ལོ་གཅིག',
	            yy: '%d ལོ',
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bo;
	
	})));


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            mm: 'munutenn',
	            MM: 'miz',
	            dd: 'devezh',
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            m: 'v',
	            b: 'v',
	            d: 'z',
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var monthsParse = [
	            /^gen/i,
	            /^c[ʼ\']hwe/i,
	            /^meu/i,
	            /^ebr/i,
	            /^mae/i,
	            /^(mez|eve)/i,
	            /^gou/i,
	            /^eos/i,
	            /^gwe/i,
	            /^her/i,
	            /^du/i,
	            /^ker/i,
	        ],
	        monthsRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        monthsStrictRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
	        monthsShortStrictRegex = /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        fullWeekdaysParse = [
	            /^sul/i,
	            /^lun/i,
	            /^meurzh/i,
	            /^merc[ʼ\']her/i,
	            /^yaou/i,
	            /^gwener/i,
	            /^sadorn/i,
	        ],
	        shortWeekdaysParse = [
	            /^Sul/i,
	            /^Lun/i,
	            /^Meu/i,
	            /^Mer/i,
	            /^Yao/i,
	            /^Gwe/i,
	            /^Sad/i,
	        ],
	        minWeekdaysParse = [
	            /^Su/i,
	            /^Lu/i,
	            /^Me([^r]|$)/i,
	            /^Mer/i,
	            /^Ya/i,
	            /^Gw/i,
	            /^Sa/i,
	        ];
	
	    var br = moment.defineLocale('br', {
	        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
	            '_'
	        ),
	        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParse: minWeekdaysParse,
	        fullWeekdaysParse: fullWeekdaysParse,
	        shortWeekdaysParse: shortWeekdaysParse,
	        minWeekdaysParse: minWeekdaysParse,
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [a viz] MMMM YYYY',
	            LLL: 'D [a viz] MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hiziv da] LT',
	            nextDay: '[Warcʼhoazh da] LT',
	            nextWeek: 'dddd [da] LT',
	            lastDay: '[Decʼh da] LT',
	            lastWeek: 'dddd [paset da] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'a-benn %s',
	            past: '%s ʼzo',
	            s: 'un nebeud segondennoù',
	            ss: '%d eilenn',
	            m: 'ur vunutenn',
	            mm: relativeTimeWithMutation,
	            h: 'un eur',
	            hh: '%d eur',
	            d: 'un devezh',
	            dd: relativeTimeWithMutation,
	            M: 'ur miz',
	            MM: relativeTimeWithMutation,
	            y: 'ur bloaz',
	            yy: specialMutationForYears,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'añ' : 'vet';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
	        isPM: function (token) {
	            return token === 'g.m.';
	        },
	        meridiem: function (hour, minute, isLower) {
	            return hour < 12 ? 'a.m.' : 'g.m.';
	        },
	    });
	
	    return br;
	
	})));


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bs;
	
	})));


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ca = moment.defineLocale('ca', {
	        months: {
	            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
	                '_'
	            ),
	            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort: 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
	            '_'
	        ),
	        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a les] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextDay: function () {
	                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastDay: function () {
	                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [passat a ' +
	                    (this.hours() !== 1 ? 'les' : 'la') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'uns segons',
	            ss: '%d segons',
	            m: 'un minut',
	            mm: '%d minuts',
	            h: 'una hora',
	            hh: '%d hores',
	            d: 'un dia',
	            dd: '%d dies',
	            M: 'un mes',
	            MM: '%d mesos',
	            y: 'un any',
	            yy: '%d anys',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                    ? 'n'
	                    : number === 3
	                    ? 'r'
	                    : number === 4
	                    ? 't'
	                    : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ca;
	
	})));


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
	            '_'
	        ),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
	        monthsParse = [
	            /^led/i,
	            /^úno/i,
	            /^bře/i,
	            /^dub/i,
	            /^kvě/i,
	            /^(čvn|červen$|června)/i,
	            /^(čvc|červenec|července)/i,
	            /^srp/i,
	            /^zář/i,
	            /^říj/i,
	            /^lis/i,
	            /^pro/i,
	        ],
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsRegex = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
	
	    function plural(n) {
	        return n > 1 && n < 5 && ~~(n / 10) !== 1;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsStrictRegex: /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	        monthsShortStrictRegex: /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	            l: 'D. M. YYYY',
	        },
	        calendar: {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'před %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cs;
	
	})));


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cv = moment.defineLocale('cv', {
	        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
	            '_'
	        ),
	        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays: 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
	            '_'
	        ),
	        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        },
	        calendar: {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (output) {
	                var affix = /сехет$/i.exec(output)
	                    ? 'рен'
	                    : /ҫул$/i.exec(output)
	                    ? 'тан'
	                    : 'ран';
	                return output + affix;
	            },
	            past: '%s каялла',
	            s: 'пӗр-ик ҫеккунт',
	            ss: '%d ҫеккунт',
	            m: 'пӗр минут',
	            mm: '%d минут',
	            h: 'пӗр сехет',
	            hh: '%d сехет',
	            d: 'пӗр кун',
	            dd: '%d кун',
	            M: 'пӗр уйӑх',
	            MM: '%d уйӑх',
	            y: 'пӗр ҫул',
	            yy: '%d ҫул',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal: '%d-мӗш',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return cv;
	
	})));


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
	            '_'
	        ),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
	            '_'
	        ),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact: true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '',
	                    'af',
	                    'il',
	                    'ydd',
	                    'ydd',
	                    'ed',
	                    'ed',
	                    'ed',
	                    'fed',
	                    'fed',
	                    'fed', // 1af to 10fed
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'fed', // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cy;
	
	})));


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var da = moment.defineLocale('da', {
	        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'på dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[i] dddd[s kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'få sekunder',
	            ss: '%d sekunder',
	            m: 'et minut',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dage',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'et år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return da;
	
	})));


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	            '_'
	        ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return de;
	
	})));


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	            '_'
	        ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deAt;
	
	})));


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	            '_'
	        ),
	        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deCh;
	
	})));


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'ޖެނުއަރީ',
	            'ފެބްރުއަރީ',
	            'މާރިޗު',
	            'އޭޕްރީލު',
	            'މޭ',
	            'ޖޫން',
	            'ޖުލައި',
	            'އޯގަސްޓު',
	            'ސެޕްޓެމްބަރު',
	            'އޮކްޓޯބަރު',
	            'ނޮވެމްބަރު',
	            'ޑިސެމްބަރު',
	        ],
	        weekdays = [
	            'އާދިއްތަ',
	            'ހޯމަ',
	            'އަންގާރަ',
	            'ބުދަ',
	            'ބުރާސްފަތި',
	            'ހުކުރު',
	            'ހޮނިހިރު',
	        ];
	
	    var dv = moment.defineLocale('dv', {
	        months: months,
	        monthsShort: months,
	        weekdays: weekdays,
	        weekdaysShort: weekdays,
	        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/M/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM: function (input) {
	            return 'މފ' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar: {
	            sameDay: '[މިއަދު] LT',
	            nextDay: '[މާދަމާ] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[އިއްޔެ] LT',
	            lastWeek: '[ފާއިތުވި] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ތެރޭގައި %s',
	            past: 'ކުރިން %s',
	            s: 'ސިކުންތުކޮޅެއް',
	            ss: 'd% ސިކުންތު',
	            m: 'މިނިޓެއް',
	            mm: 'މިނިޓު %d',
	            h: 'ގަޑިއިރެއް',
	            hh: 'ގަޑިއިރު %d',
	            d: 'ދުވަހެއް',
	            dd: 'ދުވަސް %d',
	            M: 'މަހެއް',
	            MM: 'މަސް %d',
	            y: 'އަހަރެއް',
	            yy: 'އަހަރު %d',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 7, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return dv;
	
	})));


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl: 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
	            '_'
	        ),
	        monthsGenitiveEl: 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
	            '_'
	        ),
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (
	                typeof format === 'string' &&
	                /D/.test(format.substring(0, format.indexOf('MMMM')))
	            ) {
	                // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
	            '_'
	        ),
	        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM: function (input) {
	            return (input + '').toLowerCase()[0] === 'μ';
	        },
	        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendarEl: {
	            sameDay: '[Σήμερα {}] LT',
	            nextDay: '[Αύριο {}] LT',
	            nextWeek: 'dddd [{}] LT',
	            lastDay: '[Χθες {}] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        calendar: function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
	        },
	        relativeTime: {
	            future: 'σε %s',
	            past: '%s πριν',
	            s: 'λίγα δευτερόλεπτα',
	            ss: '%d δευτερόλεπτα',
	            m: 'ένα λεπτό',
	            mm: '%d λεπτά',
	            h: 'μία ώρα',
	            hh: '%d ώρες',
	            d: 'μία μέρα',
	            dd: '%d μέρες',
	            M: 'ένας μήνας',
	            MM: '%d μήνες',
	            y: 'ένας χρόνος',
	            yy: '%d χρόνια',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4st is the first week of the year.
	        },
	    });
	
	    return el;
	
	})));


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enAu = moment.defineLocale('en-au', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enAu;
	
	})));


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enCa = moment.defineLocale('en-ca', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'YYYY-MM-DD',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY h:mm A',
	            LLLL: 'dddd, MMMM D, YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enCa;
	
	})));


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enGb = moment.defineLocale('en-gb', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enGb;
	
	})));


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIe = moment.defineLocale('en-ie', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enIe;
	
	})));


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Israel) [en-il]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIl = moment.defineLocale('en-il', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enIl;
	
	})));


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (India) [en-in]
	//! author : Jatin Agrawal : https://github.com/jatinag22
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIn = moment.defineLocale('en-in', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return enIn;
	
	})));


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enNz = moment.defineLocale('en-nz', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enNz;
	
	})));


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Singapore) [en-sg]
	//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enSg = moment.defineLocale('en-sg', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enSg;
	
	})));


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	//! comment : Vivakvo corrected the translation by colindean and miestasmia
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eo = moment.defineLocale('eo', {
	        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
	        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: '[la] D[-an de] MMMM, YYYY',
	            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
	            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
	            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar: {
	            sameDay: '[Hodiaŭ je] LT',
	            nextDay: '[Morgaŭ je] LT',
	            nextWeek: 'dddd[n je] LT',
	            lastDay: '[Hieraŭ je] LT',
	            lastWeek: '[pasintan] dddd[n je] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'post %s',
	            past: 'antaŭ %s',
	            s: 'kelkaj sekundoj',
	            ss: '%d sekundoj',
	            m: 'unu minuto',
	            mm: '%d minutoj',
	            h: 'unu horo',
	            hh: '%d horoj',
	            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
	            dd: '%d tagoj',
	            M: 'unu monato',
	            MM: '%d monatoj',
	            y: 'unu jaro',
	            yy: '%d jaroj',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal: '%da',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eo;
	
	})));


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return es;
	
	})));


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return esDo;
	
	})));


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Mexico) [es-mx]
	//! author : JC Franco : https://github.com/jcfranco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esMx = moment.defineLocale('es-mx', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return esMx;
	
	})));


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (United States) [es-us]
	//! author : bustta : https://github.com/bustta
	//! author : chrisrodz : https://github.com/chrisrodz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esUs = moment.defineLocale('es-us', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'MM/DD/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return esUs;
	
	})));


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            ss: [number + 'sekundi', number + 'sekundit'],
	            m: ['ühe minuti', 'üks minut'],
	            mm: [number + ' minuti', number + ' minutit'],
	            h: ['ühe tunni', 'tund aega', 'üks tund'],
	            hh: [number + ' tunni', number + ' tundi'],
	            d: ['ühe päeva', 'üks päev'],
	            M: ['kuu aja', 'kuu aega', 'üks kuu'],
	            MM: [number + ' kuu', number + ' kuud'],
	            y: ['ühe aasta', 'aasta', 'üks aasta'],
	            yy: [number + ' aasta', number + ' aastat'],
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
	            '_'
	        ),
	        monthsShort: 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split(
	            '_'
	        ),
	        weekdays: 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
	            '_'
	        ),
	        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Täna,] LT',
	            nextDay: '[Homme,] LT',
	            nextWeek: '[Järgmine] dddd LT',
	            lastDay: '[Eile,] LT',
	            lastWeek: '[Eelmine] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s pärast',
	            past: '%s tagasi',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: '%d päeva',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return et;
	
	})));


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eu = moment.defineLocale('eu', {
	        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
	            '_'
	        ),
	        monthsShort: 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
	            '_'
	        ),
	        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY[ko] MMMM[ren] D[a]',
	            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l: 'YYYY-M-D',
	            ll: 'YYYY[ko] MMM D[a]',
	            lll: 'YYYY[ko] MMM D[a] HH:mm',
	            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
	        },
	        calendar: {
	            sameDay: '[gaur] LT[etan]',
	            nextDay: '[bihar] LT[etan]',
	            nextWeek: 'dddd LT[etan]',
	            lastDay: '[atzo] LT[etan]',
	            lastWeek: '[aurreko] dddd LT[etan]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s barru',
	            past: 'duela %s',
	            s: 'segundo batzuk',
	            ss: '%d segundo',
	            m: 'minutu bat',
	            mm: '%d minutu',
	            h: 'ordu bat',
	            hh: '%d ordu',
	            d: 'egun bat',
	            dd: '%d egun',
	            M: 'hilabete bat',
	            MM: '%d hilabete',
	            y: 'urte bat',
	            yy: '%d urte',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eu;
	
	})));


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '۱',
	            2: '۲',
	            3: '۳',
	            4: '۴',
	            5: '۵',
	            6: '۶',
	            7: '۷',
	            8: '۸',
	            9: '۹',
	            0: '۰',
	        },
	        numberMap = {
	            '۱': '1',
	            '۲': '2',
	            '۳': '3',
	            '۴': '4',
	            '۵': '5',
	            '۶': '6',
	            '۷': '7',
	            '۸': '8',
	            '۹': '9',
	            '۰': '0',
	        };
	
	    var fa = moment.defineLocale('fa', {
	        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	            '_'
	        ),
	        monthsShort: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	            '_'
	        ),
	        weekdays: 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	            '_'
	        ),
	        weekdaysShort: 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	            '_'
	        ),
	        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar: {
	            sameDay: '[امروز ساعت] LT',
	            nextDay: '[فردا ساعت] LT',
	            nextWeek: 'dddd [ساعت] LT',
	            lastDay: '[دیروز ساعت] LT',
	            lastWeek: 'dddd [پیش] [ساعت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'در %s',
	            past: '%s پیش',
	            s: 'چند ثانیه',
	            ss: '%d ثانیه',
	            m: 'یک دقیقه',
	            mm: '%d دقیقه',
	            h: 'یک ساعت',
	            hh: '%d ساعت',
	            d: 'یک روز',
	            dd: '%d روز',
	            M: 'یک ماه',
	            MM: '%d ماه',
	            y: 'یک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[۰-۹]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal: '%dم',
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return fa;
	
	})));


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
	            ' '
	        ),
	        numbersFuture = [
	            'nolla',
	            'yhden',
	            'kahden',
	            'kolmen',
	            'neljän',
	            'viiden',
	            'kuuden',
	            numbersPast[7],
	            numbersPast[8],
	            numbersPast[9],
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                result = isFuture ? 'sekunnin' : 'sekuntia';
	                break;
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10
	            ? isFuture
	                ? numbersFuture[number]
	                : numbersPast[number]
	            : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
	            '_'
	        ),
	        monthsShort: 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
	            '_'
	        ),
	        weekdays: 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
	            '_'
	        ),
	        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM[ta] YYYY',
	            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l: 'D.M.YYYY',
	            ll: 'Do MMM YYYY',
	            lll: 'Do MMM YYYY, [klo] HH.mm',
	            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
	        },
	        calendar: {
	            sameDay: '[tänään] [klo] LT',
	            nextDay: '[huomenna] [klo] LT',
	            nextWeek: 'dddd [klo] LT',
	            lastDay: '[eilen] [klo] LT',
	            lastWeek: '[viime] dddd[na] [klo] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s päästä',
	            past: '%s sitten',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fi;
	
	})));


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Filipino [fil]
	//! author : Dan Hagman : https://github.com/hagmandan
	//! author : Matthew Co : https://github.com/matthewdeeco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fil = moment.defineLocale('fil', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fil;
	
	})));


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	//! author : Kristian Sakarisson : https://github.com/sakarisson
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fo = moment.defineLocale('fo', {
	        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays: 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
	            '_'
	        ),
	        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D. MMMM, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Í dag kl.] LT',
	            nextDay: '[Í morgin kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[Í gjár kl.] LT',
	            lastWeek: '[síðstu] dddd [kl] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'um %s',
	            past: '%s síðani',
	            s: 'fá sekund',
	            ss: '%d sekundir',
	            m: 'ein minuttur',
	            mm: '%d minuttir',
	            h: 'ein tími',
	            hh: '%d tímar',
	            d: 'ein dagur',
	            dd: '%d dagar',
	            M: 'ein mánaður',
	            MM: '%d mánaðir',
	            y: 'eitt ár',
	            yy: '%d ár',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fo;
	
	})));


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsStrictRegex = /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsShortStrictRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
	        monthsRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsParse = [
	            /^janv/i,
	            /^févr/i,
	            /^mars/i,
	            /^avr/i,
	            /^mai/i,
	            /^juin/i,
	            /^juil/i,
	            /^août/i,
	            /^sept/i,
	            /^oct/i,
	            /^nov/i,
	            /^déc/i,
	        ];
	
	    var fr = moment.defineLocale('fr', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	            '_'
	        ),
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            w: 'une semaine',
	            ww: '%d semaines',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fr;
	
	})));


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	    });
	
	    return frCa;
	
	})));


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return frCh;
	
	})));


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split(
	            '_'
	        ),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split(
	            '_'
	        );
	
	    var fy = moment.defineLocale('fy', {
	        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact: true,
	        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
	            '_'
	        ),
	        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oer %s',
	            past: '%s lyn',
	            s: 'in pear sekonden',
	            ss: '%d sekonden',
	            m: 'ien minút',
	            mm: '%d minuten',
	            h: 'ien oere',
	            hh: '%d oeren',
	            d: 'ien dei',
	            dd: '%d dagen',
	            M: 'ien moanne',
	            MM: '%d moannen',
	            y: 'ien jier',
	            yy: '%d jierren',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fy;
	
	})));


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Irish or Irish Gaelic [ga]
	//! author : André Silva : https://github.com/askpt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Eanáir',
	            'Feabhra',
	            'Márta',
	            'Aibreán',
	            'Bealtaine',
	            'Meitheamh',
	            'Iúil',
	            'Lúnasa',
	            'Meán Fómhair',
	            'Deireadh Fómhair',
	            'Samhain',
	            'Nollaig',
	        ],
	        monthsShort = [
	            'Ean',
	            'Feabh',
	            'Márt',
	            'Aib',
	            'Beal',
	            'Meith',
	            'Iúil',
	            'Lún',
	            'M.F.',
	            'D.F.',
	            'Samh',
	            'Noll',
	        ],
	        weekdays = [
	            'Dé Domhnaigh',
	            'Dé Luain',
	            'Dé Máirt',
	            'Dé Céadaoin',
	            'Déardaoin',
	            'Dé hAoine',
	            'Dé Sathairn',
	        ],
	        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
	        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];
	
	    var ga = moment.defineLocale('ga', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Inniu ag] LT',
	            nextDay: '[Amárach ag] LT',
	            nextWeek: 'dddd [ag] LT',
	            lastDay: '[Inné ag] LT',
	            lastWeek: 'dddd [seo caite] [ag] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i %s',
	            past: '%s ó shin',
	            s: 'cúpla soicind',
	            ss: '%d soicind',
	            m: 'nóiméad',
	            mm: '%d nóiméad',
	            h: 'uair an chloig',
	            hh: '%d uair an chloig',
	            d: 'lá',
	            dd: '%d lá',
	            M: 'mí',
	            MM: '%d míonna',
	            y: 'bliain',
	            yy: '%d bliain',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ga;
	
	})));


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Am Faoilleach',
	            'An Gearran',
	            'Am Màrt',
	            'An Giblean',
	            'An Cèitean',
	            'An t-Ògmhios',
	            'An t-Iuchar',
	            'An Lùnastal',
	            'An t-Sultain',
	            'An Dàmhair',
	            'An t-Samhain',
	            'An Dùbhlachd',
	        ],
	        monthsShort = [
	            'Faoi',
	            'Gear',
	            'Màrt',
	            'Gibl',
	            'Cèit',
	            'Ògmh',
	            'Iuch',
	            'Lùn',
	            'Sult',
	            'Dàmh',
	            'Samh',
	            'Dùbh',
	        ],
	        weekdays = [
	            'Didòmhnaich',
	            'Diluain',
	            'Dimàirt',
	            'Diciadain',
	            'Diardaoin',
	            'Dihaoine',
	            'Disathairne',
	        ],
	        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
	        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[An-diugh aig] LT',
	            nextDay: '[A-màireach aig] LT',
	            nextWeek: 'dddd [aig] LT',
	            lastDay: '[An-dè aig] LT',
	            lastWeek: 'dddd [seo chaidh] [aig] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ann an %s',
	            past: 'bho chionn %s',
	            s: 'beagan diogan',
	            ss: '%d diogan',
	            m: 'mionaid',
	            mm: '%d mionaidean',
	            h: 'uair',
	            hh: '%d uairean',
	            d: 'latha',
	            dd: '%d latha',
	            M: 'mìos',
	            MM: '%d mìosan',
	            y: 'bliadhna',
	            yy: '%d bliadhna',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gd;
	
	})));


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var gl = moment.defineLocale('gl', {
	        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort: 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
	            },
	            lastDay: function () {
	                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past: 'hai %s',
	            s: 'uns segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'unha hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gl;
	
	})));


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Devanagari script [gom-deva]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
	            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
	            m: ['एका मिणटान', 'एक मिनूट'],
	            mm: [number + ' मिणटांनी', number + ' मिणटां'],
	            h: ['एका वरान', 'एक वर'],
	            hh: [number + ' वरांनी', number + ' वरां'],
	            d: ['एका दिसान', 'एक दीस'],
	            dd: [number + ' दिसांनी', number + ' दीस'],
	            M: ['एका म्हयन्यान', 'एक म्हयनो'],
	            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
	            y: ['एका वर्सान', 'एक वर्स'],
	            yy: [number + ' वर्सांनी', number + ' वर्सां'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomDeva = moment.defineLocale('gom-deva', {
	        months: {
	            standalone: 'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	                '_'
	            ),
	            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort: 'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
	        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
	        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [वाजतां]',
	            LTS: 'A h:mm:ss [वाजतां]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
	            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
	        },
	        calendar: {
	            sameDay: '[आयज] LT',
	            nextDay: '[फाल्यां] LT',
	            nextWeek: '[फुडलो] dddd[,] LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[फाटलो] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s आदीं',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'वेर' only applies to day of the month
	                case 'D':
	                    return number + 'वेर';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राती') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळीं') {
	                return hour;
	            } else if (meridiem === 'दनपारां') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'सांजे') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'राती';
	            } else if (hour < 12) {
	                return 'सकाळीं';
	            } else if (hour < 16) {
	                return 'दनपारां';
	            } else if (hour < 20) {
	                return 'सांजे';
	            } else {
	                return 'राती';
	            }
	        },
	    });
	
	    return gomDeva;
	
	})));


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['thoddea sekondamni', 'thodde sekond'],
	            ss: [number + ' sekondamni', number + ' sekond'],
	            m: ['eka mintan', 'ek minut'],
	            mm: [number + ' mintamni', number + ' mintam'],
	            h: ['eka voran', 'ek vor'],
	            hh: [number + ' voramni', number + ' voram'],
	            d: ['eka disan', 'ek dis'],
	            dd: [number + ' disamni', number + ' dis'],
	            M: ['eka mhoinean', 'ek mhoino'],
	            MM: [number + ' mhoineamni', number + ' mhoine'],
	            y: ['eka vorsan', 'ek voros'],
	            yy: [number + ' vorsamni', number + ' vorsam'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months: {
	            standalone: 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
	                '_'
	            ),
	            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort: 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
	        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [vazta]',
	            LTS: 'A h:mm:ss [vazta]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [vazta]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
	        },
	        calendar: {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Fuddlo] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fattlo] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s adim',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /rati|sokallim|donparam|sanje/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokallim') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokallim';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        },
	    });
	
	    return gomLatn;
	
	})));


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Gujarati [gu]
	//! author : Kaushik Thanki : https://github.com/Kaushik1987
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '૧',
	            2: '૨',
	            3: '૩',
	            4: '૪',
	            5: '૫',
	            6: '૬',
	            7: '૭',
	            8: '૮',
	            9: '૯',
	            0: '૦',
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0',
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
	            '_'
	        ),
	        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
	            '_'
	        ),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પહેલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ',
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return gu;
	
	})));


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var he = moment.defineLocale('he', {
	        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
	            '_'
	        ),
	        monthsShort: 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split(
	            '_'
	        ),
	        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [ב]MMMM YYYY',
	            LLL: 'D [ב]MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[היום ב־]LT',
	            nextDay: '[מחר ב־]LT',
	            nextWeek: 'dddd [בשעה] LT',
	            lastDay: '[אתמול ב־]LT',
	            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'בעוד %s',
	            past: 'לפני %s',
	            s: 'מספר שניות',
	            ss: '%d שניות',
	            m: 'דקה',
	            mm: '%d דקות',
	            h: 'שעה',
	            hh: function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d: 'יום',
	            dd: function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M: 'חודש',
	            MM: function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y: 'שנה',
	            yy: function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            },
	        },
	        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM: function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        },
	    });
	
	    return he;
	
	})));


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        },
	        monthsParse = [
	            /^जन/i,
	            /^फ़र|फर/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सितं|सित/i,
	            /^अक्टू/i,
	            /^नव|नवं/i,
	            /^दिसं|दिस/i,
	        ],
	        shortMonthsParse = [
	            /^जन/i,
	            /^फ़र/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सित/i,
	            /^अक्टू/i,
	            /^नव/i,
	            /^दिस/i,
	        ];
	
	    var hi = moment.defineLocale('hi', {
	        months: {
	            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
	                '_'
	            ),
	            standalone: 'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split(
	            '_'
	        ),
	        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm बजे',
	            LTS: 'A h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
	        },
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: shortMonthsParse,
	
	        monthsRegex: /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsShortRegex: /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsStrictRegex: /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,
	
	        monthsShortStrictRegex: /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,
	
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[कल] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[कल] LT',
	            lastWeek: '[पिछले] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s में',
	            past: '%s पहले',
	            s: 'कुछ ही क्षण',
	            ss: '%d सेकंड',
	            m: 'एक मिनट',
	            mm: '%d मिनट',
	            h: 'एक घंटा',
	            hh: '%d घंटे',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महीने',
	            MM: '%d महीने',
	            y: 'एक वर्ष',
	            yy: '%d वर्ष',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return hi;
	
	})));


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months: {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
	                '_'
	            ),
	            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM YYYY',
	            LLL: 'Do MMMM YYYY H:mm',
	            LLLL: 'dddd, Do MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prošlu] [nedjelju] [u] LT';
	                    case 3:
	                        return '[prošlu] [srijedu] [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hr;
	
	})));


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	//! author : Peter Viszt  : https://github.com/passatgt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(
	        ' '
	    );
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return isFuture || withoutSuffix
	                    ? 'néhány másodperc'
	                    : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix)
	                    ? ' másodperc'
	                    : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (
	            (isFuture ? '' : '[múlt] ') +
	            '[' +
	            weekEndings[this.day()] +
	            '] LT[-kor]'
	        );
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY. MMMM D.',
	            LLL: 'YYYY. MMMM D. H:mm',
	            LLLL: 'YYYY. MMMM D., dddd H:mm',
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar: {
	            sameDay: '[ma] LT[-kor]',
	            nextDay: '[holnap] LT[-kor]',
	            nextWeek: function () {
	                return week.call(this, true);
	            },
	            lastDay: '[tegnap] LT[-kor]',
	            lastWeek: function () {
	                return week.call(this, false);
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s múlva',
	            past: '%s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return hu;
	
	})));


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months: {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
	                '_'
	            ),
	            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays: 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
	            '_'
	        ),
	        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY թ.',
	            LLL: 'D MMMM YYYY թ., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
	        },
	        calendar: {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s հետո',
	            past: '%s առաջ',
	            s: 'մի քանի վայրկյան',
	            ss: '%d վայրկյան',
	            m: 'րոպե',
	            mm: '%d րոպե',
	            h: 'ժամ',
	            hh: '%d ժամ',
	            d: 'օր',
	            dd: '%d օր',
	            M: 'ամիս',
	            MM: '%d ամիս',
	            y: 'տարի',
	            yy: '%d տարի',
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem: function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hyAm;
	
	})));


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var id = moment.defineLocale('id', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Besok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kemarin pukul] LT',
	            lastWeek: 'dddd [lalu pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lalu',
	            s: 'beberapa detik',
	            ss: '%d detik',
	            m: 'semenit',
	            mm: '%d menit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return id;
	
	})));


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nokkrar sekúndur'
	                    : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
	                    );
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return (
	                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
	                    );
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture
	                            ? 'klukkustundir'
	                            : 'klukkustundum')
	                    );
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays: 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
	            '_'
	        ),
	        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
	        },
	        calendar: {
	            sameDay: '[í dag kl.] LT',
	            nextDay: '[á morgun kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[í gær kl.] LT',
	            lastWeek: '[síðasta] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'eftir %s',
	            past: 'fyrir %s síðan',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: 'klukkustund',
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return is;
	
	})));


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	//! author: Marco : https://github.com/Manfre98
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var it = moment.defineLocale('it', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return (
	                    '[Oggi a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextDay: function () {
	                return (
	                    '[Domani a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextWeek: function () {
	                return (
	                    'dddd [a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastDay: function () {
	                return (
	                    '[Ieri a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return (
	                            '[La scorsa] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                ? ' '
	                                : "ll'") +
	                            ']LT'
	                        );
	                    default:
	                        return (
	                            '[Lo scorso] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                ? ' '
	                                : "ll'") +
	                            ']LT'
	                        );
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'tra %s',
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            w: 'una settimana',
	            ww: '%d settimane',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return it;
	
	})));


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian (Switzerland) [it-ch]
	//! author : xfh : https://github.com/xfh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var itCh = moment.defineLocale('it-ch', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return itCh;
	
	})));


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ja = moment.defineLocale('ja', {
	        eras: [
	            {
	                since: '2019-05-01',
	                offset: 1,
	                name: '令和',
	                narrow: '㋿',
	                abbr: 'R',
	            },
	            {
	                since: '1989-01-08',
	                until: '2019-04-30',
	                offset: 1,
	                name: '平成',
	                narrow: '㍻',
	                abbr: 'H',
	            },
	            {
	                since: '1926-12-25',
	                until: '1989-01-07',
	                offset: 1,
	                name: '昭和',
	                narrow: '㍼',
	                abbr: 'S',
	            },
	            {
	                since: '1912-07-30',
	                until: '1926-12-24',
	                offset: 1,
	                name: '大正',
	                narrow: '㍽',
	                abbr: 'T',
	            },
	            {
	                since: '1873-01-01',
	                until: '1912-07-29',
	                offset: 6,
	                name: '明治',
	                narrow: '㍾',
	                abbr: 'M',
	            },
	            {
	                since: '0001-01-01',
	                until: '1873-12-31',
	                offset: 1,
	                name: '西暦',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: '紀元前',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        eraYearOrdinalRegex: /(元|\d+)年/,
	        eraYearOrdinalParse: function (input, match) {
	            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
	        },
	        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日 dddd HH:mm',
	            l: 'YYYY/MM/DD',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日(ddd) HH:mm',
	        },
	        meridiemParse: /午前|午後/i,
	        isPM: function (input) {
	            return input === '午後';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar: {
	            sameDay: '[今日] LT',
	            nextDay: '[明日] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay: '[昨日] LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}日/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'y':
	                    return number === 1 ? '元年' : number + '年';
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '数秒',
	            ss: '%d秒',
	            m: '1分',
	            mm: '%d分',
	            h: '1時間',
	            hh: '%d時間',
	            d: '1日',
	            dd: '%d日',
	            M: '1ヶ月',
	            MM: '%dヶ月',
	            y: '1年',
	            yy: '%d年',
	        },
	    });
	
	    return ja;
	
	})));


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var jv = moment.defineLocale('jv', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar: {
	            sameDay: '[Dinten puniko pukul] LT',
	            nextDay: '[Mbenjang pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kala wingi pukul] LT',
	            lastWeek: 'dddd [kepengker pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'wonten ing %s',
	            past: '%s ingkang kepengker',
	            s: 'sawetawis detik',
	            ss: '%d detik',
	            m: 'setunggal menit',
	            mm: '%d menit',
	            h: 'setunggal jam',
	            hh: '%d jam',
	            d: 'sedinten',
	            dd: '%d dinten',
	            M: 'sewulan',
	            MM: '%d wulan',
	            y: 'setaun',
	            yy: '%d taun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return jv;
	
	})));


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/IrakliJani
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ka = moment.defineLocale('ka', {
	        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
	            '_'
	        ),
	        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays: {
	            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
	                '_'
	            ),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
	                '_'
	            ),
	            isFormat: /(წინა|შემდეგ)/,
	        },
	        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[დღეს] LT[-ზე]',
	            nextDay: '[ხვალ] LT[-ზე]',
	            lastDay: '[გუშინ] LT[-ზე]',
	            nextWeek: '[შემდეგ] dddd LT[-ზე]',
	            lastWeek: '[წინა] dddd LT-ზე',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return s.replace(/(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/, function (
	                    $0,
	                    $1,
	                    $2
	                ) {
	                    return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
	                });
	            },
	            past: function (s) {
	                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if (/წელი/.test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	                return s;
	            },
	            s: 'რამდენიმე წამი',
	            ss: '%d წამი',
	            m: 'წუთი',
	            mm: '%d წუთი',
	            h: 'საათი',
	            hh: '%d საათი',
	            d: 'დღე',
	            dd: '%d დღე',
	            M: 'თვე',
	            MM: '%d თვე',
	            y: 'წელი',
	            yy: '%d წელი',
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal: function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if (
	                number < 20 ||
	                (number <= 100 && number % 20 === 0) ||
	                number % 100 === 0
	            ) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week: {
	            dow: 1,
	            doy: 7,
	        },
	    });
	
	    return ka;
	
	})));


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші',
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
	            '_'
	        ),
	        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
	            '_'
	        ),
	        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгін сағат] LT',
	            nextDay: '[Ертең сағат] LT',
	            nextWeek: 'dddd [сағат] LT',
	            lastDay: '[Кеше сағат] LT',
	            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ішінде',
	            past: '%s бұрын',
	            s: 'бірнеше секунд',
	            ss: '%d секунд',
	            m: 'бір минут',
	            mm: '%d минут',
	            h: 'бір сағат',
	            hh: '%d сағат',
	            d: 'бір күн',
	            dd: '%d күн',
	            M: 'бір ай',
	            MM: '%d ай',
	            y: 'бір жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return kk;
	
	})));


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '១',
	            2: '២',
	            3: '៣',
	            4: '៤',
	            5: '៥',
	            6: '៦',
	            7: '៧',
	            8: '៨',
	            9: '៩',
	            0: '០',
	        },
	        numberMap = {
	            '១': '1',
	            '២': '2',
	            '៣': '3',
	            '៤': '4',
	            '៥': '5',
	            '៦': '6',
	            '៧': '7',
	            '៨': '8',
	            '៩': '9',
	            '០': '0',
	        };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ',
	        },
	        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
	        ordinal: 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return km;
	
	})));


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '೧',
	            2: '೨',
	            3: '೩',
	            4: '೪',
	            5: '೫',
	            6: '೬',
	            7: '೭',
	            8: '೮',
	            9: '೯',
	            0: '೦',
	        },
	        numberMap = {
	            '೧': '1',
	            '೨': '2',
	            '೩': '3',
	            '೪': '4',
	            '೫': '5',
	            '೬': '6',
	            '೭': '7',
	            '೮': '8',
	            '೯': '9',
	            '೦': '0',
	        };
	
	    var kn = moment.defineLocale('kn', {
	        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
	            '_'
	        ),
	        monthsShort: 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[ಇಂದು] LT',
	            nextDay: '[ನಾಳೆ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ನಿನ್ನೆ] LT',
	            lastWeek: '[ಕೊನೆಯ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ನಂತರ',
	            past: '%s ಹಿಂದೆ',
	            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss: '%d ಸೆಕೆಂಡುಗಳು',
	            m: 'ಒಂದು ನಿಮಿಷ',
	            mm: '%d ನಿಮಿಷ',
	            h: 'ಒಂದು ಗಂಟೆ',
	            hh: '%d ಗಂಟೆ',
	            d: 'ಒಂದು ದಿನ',
	            dd: '%d ದಿನ',
	            M: 'ಒಂದು ತಿಂಗಳು',
	            MM: '%d ತಿಂಗಳು',
	            y: 'ಒಂದು ವರ್ಷ',
	            yy: '%d ವರ್ಷ',
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal: function (number) {
	            return number + 'ನೇ';
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return kn;
	
	})));


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ko = moment.defineLocale('ko', {
	        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
	            '_'
	        ),
	        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY년 MMMM D일',
	            LLL: 'YYYY년 MMMM D일 A h:mm',
	            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
	            l: 'YYYY.MM.DD.',
	            ll: 'YYYY년 MMMM D일',
	            lll: 'YYYY년 MMMM D일 A h:mm',
	            llll: 'YYYY년 MMMM D일 dddd A h:mm',
	        },
	        calendar: {
	            sameDay: '오늘 LT',
	            nextDay: '내일 LT',
	            nextWeek: 'dddd LT',
	            lastDay: '어제 LT',
	            lastWeek: '지난주 dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s 후',
	            past: '%s 전',
	            s: '몇 초',
	            ss: '%d초',
	            m: '1분',
	            mm: '%d분',
	            h: '한 시간',
	            hh: '%d시간',
	            d: '하루',
	            dd: '%d일',
	            M: '한 달',
	            MM: '%d달',
	            y: '일 년',
	            yy: '%d년',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse: /오전|오후/,
	        isPM: function (token) {
	            return token === '오후';
	        },
	        meridiem: function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        },
	    });
	
	    return ko;
	
	})));


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kurdish [ku]
	//! author : Shahram Mebashar : https://github.com/ShahramMebashar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        months = [
	            'کانونی دووەم',
	            'شوبات',
	            'ئازار',
	            'نیسان',
	            'ئایار',
	            'حوزەیران',
	            'تەمموز',
	            'ئاب',
	            'ئەیلوول',
	            'تشرینی یەكەم',
	            'تشرینی دووەم',
	            'كانونی یەکەم',
	        ];
	
	    var ku = moment.defineLocale('ku', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
	            '_'
	        ),
	        weekdaysShort: 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split(
	            '_'
	        ),
	        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ئێواره‌|به‌یانی/,
	        isPM: function (input) {
	            return /ئێواره‌/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'به‌یانی';
	            } else {
	                return 'ئێواره‌';
	            }
	        },
	        calendar: {
	            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
	            nextDay: '[به‌یانی كاتژمێر] LT',
	            nextWeek: 'dddd [كاتژمێر] LT',
	            lastDay: '[دوێنێ كاتژمێر] LT',
	            lastWeek: 'dddd [كاتژمێر] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'له‌ %s',
	            past: '%s',
	            s: 'چه‌ند چركه‌یه‌ك',
	            ss: 'چركه‌ %d',
	            m: 'یه‌ك خوله‌ك',
	            mm: '%d خوله‌ك',
	            h: 'یه‌ك كاتژمێر',
	            hh: '%d كاتژمێر',
	            d: 'یه‌ك ڕۆژ',
	            dd: '%d ڕۆژ',
	            M: 'یه‌ك مانگ',
	            MM: '%d مانگ',
	            y: 'یه‌ك ساڵ',
	            yy: '%d ساڵ',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ku;
	
	})));


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү',
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
	            '_'
	        ),
	        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
	            '_'
	        ),
	        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгүн саат] LT',
	            nextDay: '[Эртең саат] LT',
	            nextWeek: 'dddd [саат] LT',
	            lastDay: '[Кечээ саат] LT',
	            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ичинде',
	            past: '%s мурун',
	            s: 'бирнече секунд',
	            ss: '%d секунд',
	            m: 'бир мүнөт',
	            mm: '%d мүнөт',
	            h: 'бир саат',
	            hh: '%d саат',
	            d: 'бир күн',
	            dd: '%d күн',
	            M: 'бир ай',
	            MM: '%d ай',
	            y: 'бир жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ky;
	
	})));


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eng Minutt', 'enger Minutt'],
	            h: ['eng Stonn', 'enger Stonn'],
	            d: ['een Dag', 'engem Dag'],
	            M: ['ee Mount', 'engem Mount'],
	            y: ['ee Joer', 'engem Joer'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10,
	                firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
	            '_'
	        ),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            },
	        },
	        relativeTime: {
	            future: processFutureTime,
	            past: processPastTime,
	            s: 'e puer Sekonnen',
	            ss: '%d Sekonnen',
	            m: processRelativeTime,
	            mm: '%d Minutten',
	            h: processRelativeTime,
	            hh: '%d Stonnen',
	            d: processRelativeTime,
	            dd: '%d Deeg',
	            M: processRelativeTime,
	            MM: '%d Méint',
	            y: processRelativeTime,
	            yy: '%d Joer',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lb;
	
	})));


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var lo = moment.defineLocale('lo', {
	        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	            '_'
	        ),
	        monthsShort: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	            '_'
	        ),
	        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar: {
	            sameDay: '[ມື້ນີ້ເວລາ] LT',
	            nextDay: '[ມື້ອື່ນເວລາ] LT',
	            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ອີກ %s',
	            past: '%sຜ່ານມາ',
	            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss: '%d ວິນາທີ',
	            m: '1 ນາທີ',
	            mm: '%d ນາທີ',
	            h: '1 ຊົ່ວໂມງ',
	            hh: '%d ຊົ່ວໂມງ',
	            d: '1 ມື້',
	            dd: '%d ມື້',
	            M: '1 ເດືອນ',
	            MM: '%d ເດືອນ',
	            y: '1 ປີ',
	            yy: '%d ປີ',
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal: function (number) {
	            return 'ທີ່' + number;
	        },
	    });
	
	    return lo;
	
	})));


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundė_sekundžių_sekundes',
	        m: 'minutė_minutės_minutę',
	        mm: 'minutės_minučių_minutes',
	        h: 'valanda_valandos_valandą',
	        hh: 'valandos_valandų_valandas',
	        d: 'diena_dienos_dieną',
	        dd: 'dienos_dienų_dienas',
	        M: 'mėnuo_mėnesio_mėnesį',
	        MM: 'mėnesiai_mėnesių_mėnesius',
	        y: 'metai_metų_metus',
	        yy: 'metai_metų_metus',
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix
	            ? forms(key)[0]
	            : isFuture
	            ? forms(key)[1]
	            : forms(key)[2];
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return (
	                result + translateSingular(number, withoutSuffix, key[0], isFuture)
	            );
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months: {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
	                '_'
	            ),
	            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
	        },
	        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays: {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
	                '_'
	            ),
	            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
	                '_'
	            ),
	            isFormat: /dddd HH:mm/,
	        },
	        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY [m.] MMMM D [d.]',
	            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l: 'YYYY-MM-DD',
	            ll: 'YYYY [m.] MMMM D [d.]',
	            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
	        },
	        calendar: {
	            sameDay: '[Šiandien] LT',
	            nextDay: '[Rytoj] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[Vakar] LT',
	            lastWeek: '[Praėjusį] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'po %s',
	            past: 'prieš %s',
	            s: translateSeconds,
	            ss: translate,
	            m: translateSingular,
	            mm: translate,
	            h: translateSingular,
	            hh: translate,
	            d: translateSingular,
	            dd: translate,
	            M: translateSingular,
	            MM: translate,
	            y: translateSingular,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal: function (number) {
	            return number + '-oji';
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lt;
	
	})));


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        h: 'stundas_stundām_stunda_stundas'.split('_'),
	        hh: 'stundas_stundām_stunda_stundas'.split('_'),
	        d: 'dienas_dienām_diena_dienas'.split('_'),
	        dd: 'dienas_dienām_diena_dienas'.split('_'),
	        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        y: 'gada_gadiem_gads_gadi'.split('_'),
	        yy: 'gada_gadiem_gads_gadi'.split('_'),
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY.',
	            LL: 'YYYY. [gada] D. MMMM',
	            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
	        },
	        calendar: {
	            sameDay: '[Šodien pulksten] LT',
	            nextDay: '[Rīt pulksten] LT',
	            nextWeek: 'dddd [pulksten] LT',
	            lastDay: '[Vakar pulksten] LT',
	            lastWeek: '[Pagājušā] dddd [pulksten] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'pēc %s',
	            past: 'pirms %s',
	            s: relativeSeconds,
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithSingular,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithSingular,
	            hh: relativeTimeWithPlural,
	            d: relativeTimeWithSingular,
	            dd: relativeTimeWithPlural,
	            M: relativeTimeWithSingular,
	            MM: relativeTimeWithPlural,
	            y: relativeTimeWithSingular,
	            yy: relativeTimeWithPlural,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lv;
	
	})));


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mjesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return me;
	
	})));


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
	            '_'
	        ),
	        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
	            '_'
	        ),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mi;
	
	})));


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	//! author : Sashko Todorov : https://github.com/bkyceh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mk = moment.defineLocale('mk', {
	        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Денес во] LT',
	            nextDay: '[Утре во] LT',
	            nextWeek: '[Во] dddd [во] LT',
	            lastDay: '[Вчера во] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пред %s',
	            s: 'неколку секунди',
	            ss: '%d секунди',
	            m: 'една минута',
	            mm: '%d минути',
	            h: 'еден час',
	            hh: '%d часа',
	            d: 'еден ден',
	            dd: '%d дена',
	            M: 'еден месец',
	            MM: '%d месеци',
	            y: 'една година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return mk;
	
	})));


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ml = moment.defineLocale('ml', {
	        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
	            '_'
	        ),
	        monthsShort: 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
	            '_'
	        ),
	        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm -നു',
	            LTS: 'A h:mm:ss -നു',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm -നു',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
	        },
	        calendar: {
	            sameDay: '[ഇന്ന്] LT',
	            nextDay: '[നാളെ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ഇന്നലെ] LT',
	            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s കഴിഞ്ഞ്',
	            past: '%s മുൻപ്',
	            s: 'അൽപ നിമിഷങ്ങൾ',
	            ss: '%d സെക്കൻഡ്',
	            m: 'ഒരു മിനിറ്റ്',
	            mm: '%d മിനിറ്റ്',
	            h: 'ഒരു മണിക്കൂർ',
	            hh: '%d മണിക്കൂർ',
	            d: 'ഒരു ദിവസം',
	            dd: '%d ദിവസം',
	            M: 'ഒരു മാസം',
	            MM: '%d മാസം',
	            y: 'ഒരു വർഷം',
	            yy: '%d വർഷം',
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        },
	    });
	
	    return ml;
	
	})));


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Mongolian [mn]
	//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
	            '_'
	        ),
	        monthsShort: '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY оны MMMMын D',
	            LLL: 'YYYY оны MMMMын D HH:mm',
	            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM: function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar: {
	            sameDay: '[Өнөөдөр] LT',
	            nextDay: '[Маргааш] LT',
	            nextWeek: '[Ирэх] dddd LT',
	            lastDay: '[Өчигдөр] LT',
	            lastWeek: '[Өнгөрсөн] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s дараа',
	            past: '%s өмнө',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        },
	    });
	
	    return mn;
	
	})));


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंद';
	                    break;
	                case 'ss':
	                    output = '%d सेकंद';
	                    break;
	                case 'm':
	                    output = 'एक मिनिट';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटे';
	                    break;
	                case 'h':
	                    output = 'एक तास';
	                    break;
	                case 'hh':
	                    output = '%d तास';
	                    break;
	                case 'd':
	                    output = 'एक दिवस';
	                    break;
	                case 'dd':
	                    output = '%d दिवस';
	                    break;
	                case 'M':
	                    output = 'एक महिना';
	                    break;
	                case 'MM':
	                    output = '%d महिने';
	                    break;
	                case 'y':
	                    output = 'एक वर्ष';
	                    break;
	                case 'yy':
	                    output = '%d वर्षे';
	                    break;
	            }
	        } else {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंदां';
	                    break;
	                case 'ss':
	                    output = '%d सेकंदां';
	                    break;
	                case 'm':
	                    output = 'एका मिनिटा';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटां';
	                    break;
	                case 'h':
	                    output = 'एका तासा';
	                    break;
	                case 'hh':
	                    output = '%d तासां';
	                    break;
	                case 'd':
	                    output = 'एका दिवसा';
	                    break;
	                case 'dd':
	                    output = '%d दिवसां';
	                    break;
	                case 'M':
	                    output = 'एका महिन्या';
	                    break;
	                case 'MM':
	                    output = '%d महिन्यां';
	                    break;
	                case 'y':
	                    output = 'एका वर्षा';
	                    break;
	                case 'yy':
	                    output = '%d वर्षां';
	                    break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	            '_'
	        ),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm वाजता',
	            LTS: 'A h:mm:ss वाजता',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm वाजता',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[उद्या] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr,
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
	                return hour;
	            } else if (
	                meridiem === 'दुपारी' ||
	                meridiem === 'सायंकाळी' ||
	                meridiem === 'रात्री'
	            ) {
	                return hour >= 12 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour >= 0 && hour < 6) {
	                return 'पहाटे';
	            } else if (hour < 12) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return mr;
	
	})));


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ms = moment.defineLocale('ms', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ms;
	
	})));


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var msMy = moment.defineLocale('ms-my', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return msMy;
	
	})));


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maltese (Malta) [mt]
	//! author : Alessandro Maruccia : https://github.com/alesma
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mt = moment.defineLocale('mt', {
	        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays: 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
	            '_'
	        ),
	        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Illum fil-]LT',
	            nextDay: '[Għada fil-]LT',
	            nextWeek: 'dddd [fil-]LT',
	            lastDay: '[Il-bieraħ fil-]LT',
	            lastWeek: 'dddd [li għadda] [fil-]LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'f’ %s',
	            past: '%s ilu',
	            s: 'ftit sekondi',
	            ss: '%d sekondi',
	            m: 'minuta',
	            mm: '%d minuti',
	            h: 'siegħa',
	            hh: '%d siegħat',
	            d: 'ġurnata',
	            dd: '%d ġranet',
	            M: 'xahar',
	            MM: '%d xhur',
	            y: 'sena',
	            yy: '%d sni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mt;
	
	})));


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '၁',
	            2: '၂',
	            3: '၃',
	            4: '၄',
	            5: '၅',
	            6: '၆',
	            7: '၇',
	            8: '၈',
	            9: '၉',
	            0: '၀',
	        },
	        numberMap = {
	            '၁': '1',
	            '၂': '2',
	            '၃': '3',
	            '၄': '4',
	            '၅': '5',
	            '၆': '6',
	            '၇': '7',
	            '၈': '8',
	            '၉': '9',
	            '၀': '0',
	        };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
	            '_'
	        ),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
	            '_'
	        ),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss: '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်',
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return my;
	
	})));


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nb = moment.defineLocale('nb', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'noen sekunder',
	            ss: '%d sekunder',
	            m: 'ett minutt',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dager',
	            w: 'en uke',
	            ww: '%d uker',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nb;
	
	})));


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    var ne = moment.defineLocale('ne', {
	        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
	            '_'
	        ),
	        monthsShort: 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
	            '_'
	        ),
	        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'Aको h:mm बजे',
	            LTS: 'Aको h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[भोलि] LT',
	            nextWeek: '[आउँदो] dddd[,] LT',
	            lastDay: '[हिजो] LT',
	            lastWeek: '[गएको] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमा',
	            past: '%s अगाडि',
	            s: 'केही क्षण',
	            ss: '%d सेकेण्ड',
	            m: 'एक मिनेट',
	            mm: '%d मिनेट',
	            h: 'एक घण्टा',
	            hh: '%d घण्टा',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महिना',
	            MM: '%d महिना',
	            y: 'एक बर्ष',
	            yy: '%d बर्ष',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ne;
	
	})));


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split(
	            '_'
	        ),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            w: 'één week',
	            ww: '%d weken',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nl;
	
	})));


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split(
	            '_'
	        ),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nlBe;
	
	})));


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! authors : https://github.com/mechuwind
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nn = moment.defineLocale('nn', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
	        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s sidan',
	            s: 'nokre sekund',
	            ss: '%d sekund',
	            m: 'eit minutt',
	            mm: '%d minutt',
	            h: 'ein time',
	            hh: '%d timar',
	            d: 'ein dag',
	            dd: '%d dagar',
	            w: 'ei veke',
	            ww: '%d veker',
	            M: 'ein månad',
	            MM: '%d månader',
	            y: 'eit år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nn;
	
	})));


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Occitan, lengadocian dialecte [oc-lnc]
	//! author : Quentin PAGÈS : https://github.com/Quenty31
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ocLnc = moment.defineLocale('oc-lnc', {
	        months: {
	            standalone: 'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
	                '_'
	            ),
	            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort: 'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
	            '_'
	        ),
	        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: '[uèi a] LT',
	            nextDay: '[deman a] LT',
	            nextWeek: 'dddd [a] LT',
	            lastDay: '[ièr a] LT',
	            lastWeek: 'dddd [passat a] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'unas segondas',
	            ss: '%d segondas',
	            m: 'una minuta',
	            mm: '%d minutas',
	            h: 'una ora',
	            hh: '%d oras',
	            d: 'un jorn',
	            dd: '%d jorns',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                    ? 'n'
	                    : number === 3
	                    ? 'r'
	                    : number === 4
	                    ? 't'
	                    : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4,
	        },
	    });
	
	    return ocLnc;
	
	})));


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '੧',
	            2: '੨',
	            3: '੩',
	            4: '੪',
	            5: '੫',
	            6: '੬',
	            7: '੭',
	            8: '੮',
	            9: '੯',
	            0: '੦',
	        },
	        numberMap = {
	            '੧': '1',
	            '੨': '2',
	            '੩': '3',
	            '੪': '4',
	            '੫': '5',
	            '੬': '6',
	            '੭': '7',
	            '੮': '8',
	            '੯': '9',
	            '੦': '0',
	        };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	            '_'
	        ),
	        monthsShort: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	            '_'
	        ),
	        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm ਵਜੇ',
	            LTS: 'A h:mm:ss ਵਜੇ',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
	        },
	        calendar: {
	            sameDay: '[ਅਜ] LT',
	            nextDay: '[ਕਲ] LT',
	            nextWeek: '[ਅਗਲਾ] dddd, LT',
	            lastDay: '[ਕਲ] LT',
	            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ਵਿੱਚ',
	            past: '%s ਪਿਛਲੇ',
	            s: 'ਕੁਝ ਸਕਿੰਟ',
	            ss: '%d ਸਕਿੰਟ',
	            m: 'ਇਕ ਮਿੰਟ',
	            mm: '%d ਮਿੰਟ',
	            h: 'ਇੱਕ ਘੰਟਾ',
	            hh: '%d ਘੰਟੇ',
	            d: 'ਇੱਕ ਦਿਨ',
	            dd: '%d ਦਿਨ',
	            M: 'ਇੱਕ ਮਹੀਨਾ',
	            MM: '%d ਮਹੀਨੇ',
	            y: 'ਇੱਕ ਸਾਲ',
	            yy: '%d ਸਾਲ',
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return paIn;
	
	})));


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
	            '_'
	        ),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
	            '_'
	        ),
	        monthsParse = [
	            /^sty/i,
	            /^lut/i,
	            /^mar/i,
	            /^kwi/i,
	            /^maj/i,
	            /^cze/i,
	            /^lip/i,
	            /^sie/i,
	            /^wrz/i,
	            /^paź/i,
	            /^lis/i,
	            /^gru/i,
	        ];
	    function plural(n) {
	        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix ? 'godzina' : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'ww':
	                return result + (plural(number) ? 'tygodnie' : 'tygodni');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: '%s temu',
	            s: 'kilka sekund',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: '1 dzień',
	            dd: '%d dni',
	            w: 'tydzień',
	            ww: translate,
	            M: 'miesiąc',
	            MM: translate,
	            y: 'rok',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pl;
	
	})));


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pt = moment.defineLocale('pt', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays: 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            w: 'uma semana',
	            ww: '%d semanas',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pt;
	
	})));


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays: 'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
	        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'poucos segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        invalidDate: 'Data inválida',
	    });
	
	    return ptBr;
	
	})));


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	//! author : Emanuel Cepoi : https://github.com/cepem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                ss: 'secunde',
	                mm: 'minute',
	                hh: 'ore',
	                dd: 'zile',
	                ww: 'săptămâni',
	                MM: 'luni',
	                yy: 'ani',
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
	            '_'
	        ),
	        monthsShort: 'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'peste %s',
	            past: '%s în urmă',
	            s: 'câteva secunde',
	            ss: relativeTimeWithPlural,
	            m: 'un minut',
	            mm: relativeTimeWithPlural,
	            h: 'o oră',
	            hh: relativeTimeWithPlural,
	            d: 'o zi',
	            dd: relativeTimeWithPlural,
	            w: 'o săptămână',
	            ww: relativeTimeWithPlural,
	            M: 'o lună',
	            MM: relativeTimeWithPlural,
	            y: 'un an',
	            yy: relativeTimeWithPlural,
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ro;
	
	})));


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            hh: 'час_часа_часов',
	            dd: 'день_дня_дней',
	            ww: 'неделя_недели_недель',
	            MM: 'месяц_месяца_месяцев',
	            yy: 'год_года_лет',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [
	        /^янв/i,
	        /^фев/i,
	        /^мар/i,
	        /^апр/i,
	        /^ма[йя]/i,
	        /^июн/i,
	        /^июл/i,
	        /^авг/i,
	        /^сен/i,
	        /^окт/i,
	        /^ноя/i,
	        /^дек/i,
	    ];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months: {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
	                '_'
	            ),
	            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	                '_'
	            ),
	        },
	        monthsShort: {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
	                '_'
	            ),
	            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
	                '_'
	            ),
	        },
	        weekdays: {
	            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
	                '_'
	            ),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
	                '_'
	            ),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
	        },
	        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соответствует только сокращённым формам
	        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., H:mm',
	            LLLL: 'dddd, D MMMM YYYY г., H:mm',
	        },
	        calendar: {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'через %s',
	            past: '%s назад',
	            s: 'несколько секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'час',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            w: 'неделя',
	            ww: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM: function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ru;
	
	})));


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوري',
	            'فيبروري',
	            'مارچ',
	            'اپريل',
	            'مئي',
	            'جون',
	            'جولاءِ',
	            'آگسٽ',
	            'سيپٽمبر',
	            'آڪٽوبر',
	            'نومبر',
	            'ڊسمبر',
	        ],
	        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];
	
	    var sd = moment.defineLocale('sd', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[اڄ] LT',
	            nextDay: '[سڀاڻي] LT',
	            nextWeek: 'dddd [اڳين هفتي تي] LT',
	            lastDay: '[ڪالهه] LT',
	            lastWeek: '[گزريل هفتي] dddd [تي] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s پوء',
	            past: '%s اڳ',
	            s: 'چند سيڪنڊ',
	            ss: '%d سيڪنڊ',
	            m: 'هڪ منٽ',
	            mm: '%d منٽ',
	            h: 'هڪ ڪلاڪ',
	            hh: '%d ڪلاڪ',
	            d: 'هڪ ڏينهن',
	            dd: '%d ڏينهن',
	            M: 'هڪ مهينو',
	            MM: '%d مهينا',
	            y: 'هڪ سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sd;
	
	})));


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var se = moment.defineLocale('se', {
	        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
	            '_'
	        ),
	        monthsShort: 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split(
	            '_'
	        ),
	        weekdays: 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
	            '_'
	        ),
	        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'MMMM D. [b.] YYYY',
	            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s geažes',
	            past: 'maŋit %s',
	            s: 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m: 'okta minuhta',
	            mm: '%d minuhtat',
	            h: 'okta diimmu',
	            hh: '%d diimmut',
	            d: 'okta beaivi',
	            dd: '%d beaivvit',
	            M: 'okta mánnu',
	            MM: '%d mánut',
	            y: 'okta jahki',
	            yy: '%d jagit',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return se;
	
	})));


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
	            '_'
	        ),
	        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
	            '_'
	        ),
	        weekdays: 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
	            '_'
	        ),
	        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'a h:mm',
	            LTS: 'a h:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY MMMM D',
	            LLL: 'YYYY MMMM D, a h:mm',
	            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
	        },
	        calendar: {
	            sameDay: '[අද] LT[ට]',
	            nextDay: '[හෙට] LT[ට]',
	            nextWeek: 'dddd LT[ට]',
	            lastDay: '[ඊයේ] LT[ට]',
	            lastWeek: '[පසුගිය] dddd LT[ට]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sකින්',
	            past: '%sකට පෙර',
	            s: 'තත්පර කිහිපය',
	            ss: 'තත්පර %d',
	            m: 'මිනිත්තුව',
	            mm: 'මිනිත්තු %d',
	            h: 'පැය',
	            hh: 'පැය %d',
	            d: 'දිනය',
	            dd: 'දින %d',
	            M: 'මාසය',
	            MM: 'මාස %d',
	            y: 'වසර',
	            yy: 'වසර %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal: function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM: function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        },
	    });
	
	    return si;
	
	})));


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
	            '_'
	        ),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return n > 1 && n < 5;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months: months,
	        monthsShort: monthsShort,
	        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pred %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sk;
	
	})));


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nekaj sekund'
	                    : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danes ob] LT',
	            nextDay: '[jutri ob] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay: '[včeraj ob] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'čez %s',
	            past: 'pred %s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sl;
	
	})));


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sq = moment.defineLocale('sq', {
	        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
	            '_'
	        ),
	        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Sot në] LT',
	            nextDay: '[Nesër në] LT',
	            nextWeek: 'dddd [në] LT',
	            lastDay: '[Dje në] LT',
	            lastWeek: 'dddd [e kaluar në] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'në %s',
	            past: '%s më parë',
	            s: 'disa sekonda',
	            ss: '%d sekonda',
	            m: 'një minutë',
	            mm: '%d minuta',
	            h: 'një orë',
	            hh: '%d orë',
	            d: 'një ditë',
	            dd: '%d ditë',
	            M: 'një muaj',
	            MM: '%d muaj',
	            y: 'një vit',
	            yy: '%d vite',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sq;
	
	})));


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pre %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sr;
	
	})));


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
	            '_'
	        ),
	        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay: '[јуче у] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пре %s',
	            s: 'неколико секунди',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'дан',
	            dd: translator.translate,
	            M: 'месец',
	            MM: translator.translate,
	            y: 'годину',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return srCyrl;
	
	})));


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ss = moment.defineLocale('ss', {
	        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
	            '_'
	        ),
	        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays: 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Namuhla nga] LT',
	            nextDay: '[Kusasa nga] LT',
	            nextWeek: 'dddd [nga] LT',
	            lastDay: '[Itolo nga] LT',
	            lastWeek: 'dddd [leliphelile] [nga] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'nga %s',
	            past: 'wenteka nga %s',
	            s: 'emizuzwana lomcane',
	            ss: '%d mzuzwana',
	            m: 'umzuzu',
	            mm: '%d emizuzu',
	            h: 'lihora',
	            hh: '%d emahora',
	            d: 'lilanga',
	            dd: '%d emalanga',
	            M: 'inyanga',
	            MM: '%d tinyanga',
	            y: 'umnyaka',
	            yy: '%d iminyaka',
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: '%d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ss;
	
	})));


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sv = moment.defineLocale('sv', {
	        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: 'för %s sedan',
	            s: 'några sekunder',
	            ss: '%d sekunder',
	            m: 'en minut',
	            mm: '%d minuter',
	            h: 'en timme',
	            hh: '%d timmar',
	            d: 'en dag',
	            dd: '%d dagar',
	            M: 'en månad',
	            MM: '%d månader',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? ':e'
	                        : b === 1
	                        ? ':a'
	                        : b === 2
	                        ? ':a'
	                        : b === 3
	                        ? ':e'
	                        : ':e';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sv;
	
	})));


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sw = moment.defineLocale('sw', {
	        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
	            '_'
	        ),
	        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'hh:mm A',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[leo saa] LT',
	            nextDay: '[kesho saa] LT',
	            nextWeek: '[wiki ijayo] dddd [saat] LT',
	            lastDay: '[jana] LT',
	            lastWeek: '[wiki iliyopita] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s baadaye',
	            past: 'tokea %s',
	            s: 'hivi punde',
	            ss: 'sekunde %d',
	            m: 'dakika moja',
	            mm: 'dakika %d',
	            h: 'saa limoja',
	            hh: 'masaa %d',
	            d: 'siku moja',
	            dd: 'siku %d',
	            M: 'mwezi mmoja',
	            MM: 'miezi %d',
	            y: 'mwaka mmoja',
	            yy: 'miaka %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sw;
	
	})));


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '௧',
	            2: '௨',
	            3: '௩',
	            4: '௪',
	            5: '௫',
	            6: '௬',
	            7: '௭',
	            8: '௮',
	            9: '௯',
	            0: '௦',
	        },
	        numberMap = {
	            '௧': '1',
	            '௨': '2',
	            '௩': '3',
	            '௪': '4',
	            '௫': '5',
	            '௬': '6',
	            '௭': '7',
	            '௮': '8',
	            '௯': '9',
	            '௦': '0',
	        };
	
	    var ta = moment.defineLocale('ta', {
	        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	            '_'
	        ),
	        monthsShort: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	            '_'
	        ),
	        weekdays: 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
	            '_'
	        ),
	        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
	            '_'
	        ),
	        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, HH:mm',
	            LLLL: 'dddd, D MMMM YYYY, HH:mm',
	        },
	        calendar: {
	            sameDay: '[இன்று] LT',
	            nextDay: '[நாளை] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[நேற்று] LT',
	            lastWeek: '[கடந்த வாரம்] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s இல்',
	            past: '%s முன்',
	            s: 'ஒரு சில விநாடிகள்',
	            ss: '%d விநாடிகள்',
	            m: 'ஒரு நிமிடம்',
	            mm: '%d நிமிடங்கள்',
	            h: 'ஒரு மணி நேரம்',
	            hh: '%d மணி நேரம்',
	            d: 'ஒரு நாள்',
	            dd: '%d நாட்கள்',
	            M: 'ஒரு மாதம்',
	            MM: '%d மாதங்கள்',
	            y: 'ஒரு வருடம்',
	            yy: '%d ஆண்டுகள்',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal: function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை'; // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ta;
	
	})));


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var te = moment.defineLocale('te', {
	        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
	            '_'
	        ),
	        monthsShort: 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
	            '_'
	        ),
	        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[నేడు] LT',
	            nextDay: '[రేపు] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[నిన్న] LT',
	            lastWeek: '[గత] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s లో',
	            past: '%s క్రితం',
	            s: 'కొన్ని క్షణాలు',
	            ss: '%d సెకన్లు',
	            m: 'ఒక నిమిషం',
	            mm: '%d నిమిషాలు',
	            h: 'ఒక గంట',
	            hh: '%d గంటలు',
	            d: 'ఒక రోజు',
	            dd: '%d రోజులు',
	            M: 'ఒక నెల',
	            MM: '%d నెలలు',
	            y: 'ఒక సంవత్సరం',
	            yy: '%d సంవత్సరాలు',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}వ/,
	        ordinal: '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return te;
	
	})));


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	//! author : Sonia Simoes : https://github.com/soniasimoes
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tet = moment.defineLocale('tet', {
	        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'iha %s',
	            past: '%s liuba',
	            s: 'segundu balun',
	            ss: 'segundu %d',
	            m: 'minutu ida',
	            mm: 'minutu %d',
	            h: 'oras ida',
	            hh: 'oras %d',
	            d: 'loron ida',
	            dd: 'loron %d',
	            M: 'fulan ida',
	            MM: 'fulan %d',
	            y: 'tinan ida',
	            yy: 'tinan %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tet;
	
	})));


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tajik [tg]
	//! author : Orif N. Jr. : https://github.com/orif-jr
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум',
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months: {
	            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
	                '_'
	            ),
	            standalone: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
	            '_'
	        ),
	        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Имрӯз соати] LT',
	            nextDay: '[Фардо соати] LT',
	            lastDay: '[Дирӯз соати] LT',
	            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'баъди %s',
	            past: '%s пеш',
	            s: 'якчанд сония',
	            m: 'як дақиқа',
	            mm: '%d дақиқа',
	            h: 'як соат',
	            hh: '%d соат',
	            d: 'як рӯз',
	            dd: '%d рӯз',
	            M: 'як моҳ',
	            MM: '%d моҳ',
	            y: 'як сол',
	            yy: '%d сол',
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1th is the first week of the year.
	        },
	    });
	
	    return tg;
	
	})));


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var th = moment.defineLocale('th', {
	        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
	            '_'
	        ),
	        monthsShort: 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY เวลา H:mm',
	            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar: {
	            sameDay: '[วันนี้ เวลา] LT',
	            nextDay: '[พรุ่งนี้ เวลา] LT',
	            nextWeek: 'dddd[หน้า เวลา] LT',
	            lastDay: '[เมื่อวานนี้ เวลา] LT',
	            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'อีก %s',
	            past: '%sที่แล้ว',
	            s: 'ไม่กี่วินาที',
	            ss: '%d วินาที',
	            m: '1 นาที',
	            mm: '%d นาที',
	            h: '1 ชั่วโมง',
	            hh: '%d ชั่วโมง',
	            d: '1 วัน',
	            dd: '%d วัน',
	            w: '1 สัปดาห์',
	            ww: '%d สัปดาห์',
	            M: '1 เดือน',
	            MM: '%d เดือน',
	            y: '1 ปี',
	            yy: '%d ปี',
	        },
	    });
	
	    return th;
	
	})));


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkmen [tk]
	//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inji",
	        5: "'inji",
	        8: "'inji",
	        70: "'inji",
	        80: "'inji",
	        2: "'nji",
	        7: "'nji",
	        20: "'nji",
	        50: "'nji",
	        3: "'ünji",
	        4: "'ünji",
	        100: "'ünji",
	        6: "'njy",
	        9: "'unjy",
	        10: "'unjy",
	        30: "'unjy",
	        60: "'ynjy",
	        90: "'ynjy",
	    };
	
	    var tk = moment.defineLocale('tk', {
	        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
	        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
	            '_'
	        ),
	        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
	        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün sagat] LT',
	            nextDay: '[ertir sagat] LT',
	            nextWeek: '[indiki] dddd [sagat] LT',
	            lastDay: '[düýn] LT',
	            lastWeek: '[geçen] dddd [sagat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s soň',
	            past: '%s öň',
	            s: 'birnäçe sekunt',
	            m: 'bir minut',
	            mm: '%d minut',
	            h: 'bir sagat',
	            hh: '%d sagat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir aý',
	            MM: '%d aý',
	            y: 'bir ýyl',
	            yy: '%d ýyl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'unjy";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tk;
	
	})));


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlPh;
	
	})));


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'leS'
	                : output.indexOf('jar') !== -1
	                ? time.slice(0, -3) + 'waQ'
	                : output.indexOf('DIS') !== -1
	                ? time.slice(0, -3) + 'nem'
	                : time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'Hu’'
	                : output.indexOf('jar') !== -1
	                ? time.slice(0, -3) + 'wen'
	                : output.indexOf('DIS') !== -1
	                ? time.slice(0, -3) + 'ben'
	                : time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	            ten = Math.floor((number % 100) / 10),
	            one = number % 10,
	            word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[one];
	        }
	        return word === '' ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
	            '_'
	        ),
	        monthsShort: 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        weekdaysShort: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        weekdaysMin: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: translateFuture,
	            past: translatePast,
	            s: 'puS lup',
	            ss: translate,
	            m: 'wa’ tup',
	            mm: translate,
	            h: 'wa’ rep',
	            hh: translate,
	            d: 'wa’ jaj',
	            dd: translate,
	            M: 'wa’ jar',
	            MM: translate,
	            y: 'wa’ DIS',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlh;
	
	})));


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inci",
	        5: "'inci",
	        8: "'inci",
	        70: "'inci",
	        80: "'inci",
	        2: "'nci",
	        7: "'nci",
	        20: "'nci",
	        50: "'nci",
	        3: "'üncü",
	        4: "'üncü",
	        100: "'üncü",
	        6: "'ncı",
	        9: "'uncu",
	        10: "'uncu",
	        30: "'uncu",
	        60: "'ıncı",
	        90: "'ıncı",
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
	            '_'
	        ),
	        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
	            '_'
	        ),
	        weekdaysShort: 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'öö' : 'ÖÖ';
	            } else {
	                return isLower ? 'ös' : 'ÖS';
	            }
	        },
	        meridiemParse: /öö|ÖÖ|ös|ÖS/,
	        isPM: function (input) {
	            return input === 'ös' || input === 'ÖS';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[yarın saat] LT',
	            nextWeek: '[gelecek] dddd [saat] LT',
	            lastDay: '[dün] LT',
	            lastWeek: '[geçen] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s önce',
	            s: 'birkaç saniye',
	            ss: '%d saniye',
	            m: 'bir dakika',
	            mm: '%d dakika',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            w: 'bir hafta',
	            ww: '%d hafta',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir yıl',
	            yy: '%d yıl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'ıncı";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tr;
	
	})));


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM [dallas] YYYY',
	            LLL: 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM: function (input) {
	            return "d'o" === input.toLowerCase();
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? "d'o" : "D'O";
	            } else {
	                return isLower ? "d'a" : "D'A";
	            }
	        },
	        calendar: {
	            sameDay: '[oxhi à] LT',
	            nextDay: '[demà à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[ieiri à] LT',
	            lastWeek: '[sür el] dddd [lasteu à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'osprei %s',
	            past: 'ja%s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['viensas secunds', "'iensas secunds"],
	            ss: [number + ' secunds', '' + number + ' secunds'],
	            m: ["'n míut", "'iens míut"],
	            mm: [number + ' míuts', '' + number + ' míuts'],
	            h: ["'n þora", "'iensa þora"],
	            hh: [number + ' þoras', '' + number + ' þoras'],
	            d: ["'n ziua", "'iensa ziua"],
	            dd: [number + ' ziuas', '' + number + ' ziuas'],
	            M: ["'n mes", "'iens mes"],
	            MM: [number + ' mesen', '' + number + ' mesen'],
	            y: ["'n ar", "'iens ar"],
	            yy: [number + ' ars', '' + number + ' ars'],
	        };
	        return isFuture
	            ? format[key][0]
	            : withoutSuffix
	            ? format[key][0]
	            : format[key][1];
	    }
	
	    return tzl;
	
	})));


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzm = moment.defineLocale('tzm', {
	        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	            '_'
	        ),
	        monthsShort: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	            '_'
	        ),
	        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past: 'ⵢⴰⵏ %s',
	            s: 'ⵉⵎⵉⴽ',
	            ss: '%d ⵉⵎⵉⴽ',
	            m: 'ⵎⵉⵏⵓⴺ',
	            mm: '%d ⵎⵉⵏⵓⴺ',
	            h: 'ⵙⴰⵄⴰ',
	            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d: 'ⴰⵙⵙ',
	            dd: '%d oⵙⵙⴰⵏ',
	            M: 'ⴰⵢoⵓⵔ',
	            MM: '%d ⵉⵢⵢⵉⵔⵏ',
	            y: 'ⴰⵙⴳⴰⵙ',
	            yy: '%d ⵉⵙⴳⴰⵙⵏ',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzm;
	
	})));


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	            '_'
	        ),
	        monthsShort: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	            '_'
	        ),
	        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dadkh s yan %s',
	            past: 'yan %s',
	            s: 'imik',
	            ss: '%d imik',
	            m: 'minuḍ',
	            mm: '%d minuḍ',
	            h: 'saɛa',
	            hh: '%d tassaɛin',
	            d: 'ass',
	            dd: '%d ossan',
	            M: 'ayowr',
	            MM: '%d iyyirn',
	            y: 'asgas',
	            yy: '%d isgasn',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzmLatn;
	
	})));


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uyghur (China) [ug-cn]
	//! author: boyaq : https://github.com/boyaq
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل',
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return ugCn;
	
	})));


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            dd: 'день_дні_днів',
	            MM: 'місяць_місяці_місяців',
	            yy: 'рік_роки_років',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	                nominative: 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
	                    '_'
	                ),
	                accusative: 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
	                    '_'
	                ),
	                genitive: 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
	                    '_'
	                ),
	            },
	            nounCase;
	
	        if (m === true) {
	            return weekdays['nominative']
	                .slice(1, 7)
	                .concat(weekdays['nominative'].slice(0, 1));
	        }
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
	            ? 'accusative'
	            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
	            ? 'genitive'
	            : 'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months: {
	            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
	                '_'
	            ),
	            standalone: 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
	            '_'
	        ),
	        weekdays: weekdaysCaseReplace,
	        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY р.',
	            LLL: 'D MMMM YYYY р., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
	        },
	        calendar: {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: '%s тому',
	            s: 'декілька секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'годину',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            M: 'місяць',
	            MM: relativeTimeWithPlural,
	            y: 'рік',
	            yy: relativeTimeWithPlural,
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uk;
	
	})));


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوری',
	            'فروری',
	            'مارچ',
	            'اپریل',
	            'مئی',
	            'جون',
	            'جولائی',
	            'اگست',
	            'ستمبر',
	            'اکتوبر',
	            'نومبر',
	            'دسمبر',
	        ],
	        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];
	
	    var ur = moment.defineLocale('ur', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[آج بوقت] LT',
	            nextDay: '[کل بوقت] LT',
	            nextWeek: 'dddd [بوقت] LT',
	            lastDay: '[گذشتہ روز بوقت] LT',
	            lastWeek: '[گذشتہ] dddd [بوقت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s بعد',
	            past: '%s قبل',
	            s: 'چند سیکنڈ',
	            ss: '%d سیکنڈ',
	            m: 'ایک منٹ',
	            mm: '%d منٹ',
	            h: 'ایک گھنٹہ',
	            hh: '%d گھنٹے',
	            d: 'ایک دن',
	            dd: '%d دن',
	            M: 'ایک ماہ',
	            MM: '%d ماہ',
	            y: 'ایک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ur;
	
	})));


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uz = moment.defineLocale('uz', {
	        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бугун соат] LT [да]',
	            nextDay: '[Эртага] LT [да]',
	            nextWeek: 'dddd [куни соат] LT [да]',
	            lastDay: '[Кеча соат] LT [да]',
	            lastWeek: '[Утган] dddd [куни соат] LT [да]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Якин %s ичида',
	            past: 'Бир неча %s олдин',
	            s: 'фурсат',
	            ss: '%d фурсат',
	            m: 'бир дакика',
	            mm: '%d дакика',
	            h: 'бир соат',
	            hh: '%d соат',
	            d: 'бир кун',
	            dd: '%d кун',
	            M: 'бир ой',
	            MM: '%d ой',
	            y: 'бир йил',
	            yy: '%d йил',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return uz;
	
	})));


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays: 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
	            '_'
	        ),
	        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bugun soat] LT [da]',
	            nextDay: '[Ertaga] LT [da]',
	            nextWeek: 'dddd [kuni soat] LT [da]',
	            lastDay: '[Kecha soat] LT [da]',
	            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Yaqin %s ichida',
	            past: 'Bir necha %s oldin',
	            s: 'soniya',
	            ss: '%d soniya',
	            m: 'bir daqiqa',
	            mm: '%d daqiqa',
	            h: 'bir soat',
	            hh: '%d soat',
	            d: 'bir kun',
	            dd: '%d kun',
	            M: 'bir oy',
	            MM: '%d oy',
	            y: 'bir yil',
	            yy: '%d yil',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uzLatn;
	
	})));


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	//! author : Chien Kira : https://github.com/chienkira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var vi = moment.defineLocale('vi', {
	        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
	            '_'
	        ),
	        monthsShort: 'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
	            '_'
	        ),
	        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /sa|ch/i,
	        isPM: function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [năm] YYYY',
	            LLL: 'D MMMM [năm] YYYY HH:mm',
	            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
	            l: 'DD/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần trước lúc] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s tới',
	            past: '%s trước',
	            s: 'vài giây',
	            ss: '%d giây',
	            m: 'một phút',
	            mm: '%d phút',
	            h: 'một giờ',
	            hh: '%d giờ',
	            d: 'một ngày',
	            dd: '%d ngày',
	            w: 'một tuần',
	            ww: '%d tuần',
	            M: 'một tháng',
	            MM: '%d tháng',
	            y: 'một năm',
	            yy: '%d năm',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return vi;
	
	})));


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
	            '_'
	        ),
	        monthsShort: 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
	            '_'
	        ),
	        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[T~ódá~ý át] LT',
	            nextDay: '[T~ómó~rró~w át] LT',
	            nextWeek: 'dddd [át] LT',
	            lastDay: '[Ý~ést~érdá~ý át] LT',
	            lastWeek: '[L~ást] dddd [át] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'í~ñ %s',
	            past: '%s á~gó',
	            s: 'á ~féw ~sécó~ñds',
	            ss: '%d s~écóñ~ds',
	            m: 'á ~míñ~úté',
	            mm: '%d m~íñú~tés',
	            h: 'á~ñ hó~úr',
	            hh: '%d h~óúrs',
	            d: 'á ~dáý',
	            dd: '%d d~áýs',
	            M: 'á ~móñ~th',
	            MM: '%d m~óñt~hs',
	            y: 'á ~ýéár',
	            yy: '%d ý~éárs',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return xPseudo;
	
	})));


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var yo = moment.defineLocale('yo', {
	        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
	            '_'
	        ),
	        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Ònì ni] LT',
	            nextDay: '[Ọ̀la ni] LT',
	            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
	            lastDay: '[Àna ni] LT',
	            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ní %s',
	            past: '%s kọjá',
	            s: 'ìsẹjú aayá die',
	            ss: 'aayá %d',
	            m: 'ìsẹjú kan',
	            mm: 'ìsẹjú %d',
	            h: 'wákati kan',
	            hh: 'wákati %d',
	            d: 'ọjọ́ kan',
	            dd: 'ọjọ́ %d',
	            M: 'osù kan',
	            MM: 'osù %d',
	            y: 'ọdún kan',
	            yy: 'ọdún %d',
	        },
	        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
	        ordinal: 'ọjọ́ %d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return yo;
	
	})));


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	//! author : uu109 : https://github.com/uu109
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日Ah点mm分',
	            LLLL: 'YYYY年M月D日ddddAh点mm分',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[下]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            lastDay: '[昨天]LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[上]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s后',
	            past: '%s前',
	            s: '几秒',
	            ss: '%d 秒',
	            m: '1 分钟',
	            mm: '%d 分钟',
	            h: '1 小时',
	            hh: '%d 小时',
	            d: '1 天',
	            dd: '%d 天',
	            w: '1 周',
	            ww: '%d 周',
	            M: '1 个月',
	            MM: '%d 个月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return zhCn;
	
	})));


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	//! author : Anthony : https://github.com/anthonylau
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1200) {
	                return '上午';
	            } else if (hm === 1200) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: '[下]ddddLT',
	            lastDay: '[昨天]LT',
	            lastWeek: '[上]ddddLT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhHk;
	
	})));


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Macau) [zh-mo]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Tan Yuanhong : https://github.com/le0tan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhMo = moment.defineLocale('zh-mo', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s內',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhMo;
	
	})));


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(18)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhTw;
	
	})));


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! Moment Duration Format v2.2.2
	 *  https://github.com/jsmreese/moment-duration-format
	 *  Date: 2018-02-16
	 *
	 *  Duration format plugin function for the Moment.js library
	 *  http://momentjs.com/
	 *
	 *  Copyright 2018 John Madhavan-Reese
	 *  Released under the MIT license
	 */
	
	(function (root, factory) {
	    if (true) {
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(18)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        // Node. Does not work with strict CommonJS, but only CommonJS-like
	        // enviroments that support module.exports, like Node.
	        try {
	            module.exports = factory(require('moment'));
	        } catch (e) {
	            // If moment is not available, leave the setup up to the user.
	            // Like when using moment-timezone or similar moment-based package.
	            module.exports = factory;
	        }
	    }
	
	    if (root) {
	        // Globals.
	        root.momentDurationFormatSetup = root.moment ? factory(root.moment) : factory;
	    }
	})(this, function (moment) {
	    // `Number#tolocaleString` is tested on plugin initialization.
	    // If the feature test passes, `toLocaleStringWorks` will be set to `true` and the
	    // native function will be used to generate formatted output. If the feature
	    // test fails, the fallback format function internal to this plugin will be
	    // used.
	    var toLocaleStringWorks = false;
	
	    // `Number#toLocaleString` rounds incorrectly for select numbers in Microsoft
	    // environments (Edge, IE11, Windows Phone) and possibly other environments.
	    // If the rounding test fails and `toLocaleString` will be used for formatting,
	    // the plugin will "pre-round" number values using the fallback number format
	    // function before passing them to `toLocaleString` for final formatting.
	    var toLocaleStringRoundingWorks = false;
	
	    // `Intl.NumberFormat#format` is tested on plugin initialization.
	    // If the feature test passes, `intlNumberFormatRoundingWorks` will be set to
	    // `true` and the native function will be used to generate formatted output.
	    // If the feature test fails, either `Number#tolocaleString` (if
	    // `toLocaleStringWorks` is `true`), or the fallback format function internal
	    //  to this plugin will be used.
	    var intlNumberFormatWorks = false;
	
	    // `Intl.NumberFormat#format` rounds incorrectly for select numbers in Microsoft
	    // environments (Edge, IE11, Windows Phone) and possibly other environments.
	    // If the rounding test fails and `Intl.NumberFormat#format` will be used for
	    // formatting, the plugin will "pre-round" number values using the fallback number
	    // format function before passing them to `Intl.NumberFormat#format` for final
	    // formatting.
	    var intlNumberFormatRoundingWorks = false;
	
	    // Token type names in order of descending magnitude.
	    var types = "escape years months weeks days hours minutes seconds milliseconds general".split(" ");
	
	    var bubbles = [
	        {
	            type: "seconds",
	            targets: [
	                { type: "minutes", value: 60 },
	                { type: "hours", value: 3600 },
	                { type: "days", value: 86400 },
	                { type: "weeks", value: 604800 },
	                { type: "months", value: 2678400 },
	                { type: "years", value: 31536000 }
	            ]
	        },
	        {
	            type: "minutes",
	            targets: [
	                { type: "hours", value: 60 },
	                { type: "days", value: 1440 },
	                { type: "weeks", value: 10080 },
	                { type: "months", value: 44640 },
	                { type: "years", value: 525600 }
	            ]
	        },
	        {
	            type: "hours",
	            targets: [
	                { type: "days", value: 24 },
	                { type: "weeks", value: 168 },
	                { type: "months", value: 744 },
	                { type: "years", value: 8760 }
	            ]
	        },
	        {
	            type: "days",
	            targets: [
	                { type: "weeks", value: 7 },
	                { type: "months", value: 31 },
	                { type: "years", value: 365 }
	            ]
	        },
	        {
	            type: "months",
	            targets: [
	                { type: "years", value: 12 }
	            ]
	        }
	    ];
	
	    // stringIncludes
	    function stringIncludes(str, search) {
	        if (search.length > str.length) {
	          return false;
	        }
	
	        return str.indexOf(search) !== -1;
	    }
	
	    // repeatZero(qty)
	    // Returns "0" repeated `qty` times.
	    // `qty` must be a integer >= 0.
	    function repeatZero(qty) {
	        var result = "";
	
	        while (qty) {
	            result += "0";
	            qty -= 1;
	        }
	
	        return result;
	    }
	
	    function stringRound(digits) {
	        var digitsArray = digits.split("").reverse();
	        var i = 0;
	        var carry = true;
	
	        while (carry && i < digitsArray.length) {
	            if (i) {
	                if (digitsArray[i] === "9") {
	                    digitsArray[i] = "0";
	                } else {
	                    digitsArray[i] = (parseInt(digitsArray[i], 10) + 1).toString();
	                    carry = false;
	                }
	            } else {
	                if (parseInt(digitsArray[i], 10) < 5) {
	                    carry = false;
	                }
	
	                digitsArray[i] = "0";
	            }
	
	            i += 1;
	        }
	
	        if (carry) {
	            digitsArray.push("1");
	        }
	
	        return digitsArray.reverse().join("");
	    }
	
	    // cachedNumberFormat
	    // Returns an `Intl.NumberFormat` instance for the given locale and configuration.
	    // On first use of a particular configuration, the instance is cached for fast
	    // repeat access.
	    function cachedNumberFormat(locale, options) {
	        // Create a sorted, stringified version of `options`
	        // for use as part of the cache key
	        var optionsString = map(
	            keys(options).sort(),
	            function(key) {
	                return key + ':' + options[key];
	            }
	        ).join(',');
	
	        // Set our cache key
	        var cacheKey = locale + '+' + optionsString;
	
	        // If we don't have this configuration cached, configure and cache it
	        if (!cachedNumberFormat.cache[cacheKey]) {
	            cachedNumberFormat.cache[cacheKey] = Intl.NumberFormat(locale, options);
	        }
	
	        // Return the cached version of this configuration
	        return cachedNumberFormat.cache[cacheKey];
	    }
	    cachedNumberFormat.cache = {};
	
	    // formatNumber
	    // Formats any number greater than or equal to zero using these options:
	    // - userLocale
	    // - useToLocaleString
	    // - useGrouping
	    // - grouping
	    // - maximumSignificantDigits
	    // - minimumIntegerDigits
	    // - fractionDigits
	    // - groupingSeparator
	    // - decimalSeparator
	    //
	    // `useToLocaleString` will use `Intl.NumberFormat` or `toLocaleString` for formatting.
	    // `userLocale` option is passed through to the formatting function.
	    // `fractionDigits` is passed through to `maximumFractionDigits` and `minimumFractionDigits`
	    // Using `maximumSignificantDigits` will override `minimumIntegerDigits` and `fractionDigits`.
	    function formatNumber(number, options, userLocale) {
	        var useToLocaleString = options.useToLocaleString;
	        var useGrouping = options.useGrouping;
	        var grouping = useGrouping && options.grouping.slice();
	        var maximumSignificantDigits = options.maximumSignificantDigits;
	        var minimumIntegerDigits = options.minimumIntegerDigits || 1;
	        var fractionDigits = options.fractionDigits || 0;
	        var groupingSeparator = options.groupingSeparator;
	        var decimalSeparator = options.decimalSeparator;
	
	        if (useToLocaleString && userLocale) {
	            var localeStringOptions = {
	                minimumIntegerDigits: minimumIntegerDigits,
	                useGrouping: useGrouping
	            };
	
	            if (fractionDigits) {
	                localeStringOptions.maximumFractionDigits = fractionDigits;
	                localeStringOptions.minimumFractionDigits = fractionDigits;
	            }
	
	            // toLocaleString output is "0.0" instead of "0" for HTC browsers
	            // when maximumSignificantDigits is set. See #96.
	            if (maximumSignificantDigits && number > 0) {
	                localeStringOptions.maximumSignificantDigits = maximumSignificantDigits;
	            }
	
	            if (intlNumberFormatWorks) {
	                if (!intlNumberFormatRoundingWorks) {
	                    var roundingOptions = extend({}, options);
	                    roundingOptions.useGrouping = false;
	                    roundingOptions.decimalSeparator = ".";
	                    number = parseFloat(formatNumber(number, roundingOptions), 10);
	                }
	
	                return cachedNumberFormat(userLocale, localeStringOptions).format(number);
	            } else {
	                if (!toLocaleStringRoundingWorks) {
	                    var roundingOptions = extend({}, options);
	                    roundingOptions.useGrouping = false;
	                    roundingOptions.decimalSeparator = ".";
	                    number = parseFloat(formatNumber(number, roundingOptions), 10);
	                }
	
	                return number.toLocaleString(userLocale, localeStringOptions);
	            }
	        }
	
	        var numberString;
	
	        // Add 1 to digit output length for floating point errors workaround. See below.
	        if (maximumSignificantDigits) {
	            numberString = number.toPrecision(maximumSignificantDigits + 1);
	        } else {
	            numberString = number.toFixed(fractionDigits + 1);
	        }
	
	        var integerString;
	        var fractionString;
	        var exponentString;
	
	        var temp = numberString.split("e");
	
	        exponentString = temp[1] || "";
	
	        temp = temp[0].split(".");
	
	        fractionString = temp[1] || "";
	        integerString = temp[0] || "";
	
	        // Workaround for floating point errors in `toFixed` and `toPrecision`.
	        // (3.55).toFixed(1); --> "3.5"
	        // (123.55 - 120).toPrecision(2); --> "3.5"
	        // (123.55 - 120); --> 3.549999999999997
	        // (123.55 - 120).toFixed(2); --> "3.55"
	        // Round by examing the string output of the next digit.
	
	        // *************** Implement String Rounding here ***********************
	        // Check integerString + fractionString length of toPrecision before rounding.
	        // Check length of fractionString from toFixed output before rounding.
	        var integerLength = integerString.length;
	        var fractionLength = fractionString.length;
	        var digitCount = integerLength + fractionLength;
	        var digits = integerString + fractionString;
	
	        if (maximumSignificantDigits && digitCount === (maximumSignificantDigits + 1) || !maximumSignificantDigits && fractionLength === (fractionDigits + 1)) {
	            // Round digits.
	            digits = stringRound(digits);
	
	            if (digits.length === digitCount + 1) {
	                integerLength = integerLength + 1;
	            }
	
	            // Discard final fractionDigit.
	            if (fractionLength) {
	                digits = digits.slice(0, -1);
	            }
	
	            // Separate integer and fraction.
	            integerString = digits.slice(0, integerLength);
	            fractionString = digits.slice(integerLength);
	        }
	
	        // Trim trailing zeroes from fractionString because toPrecision outputs
	        // precision, not significant digits.
	        if (maximumSignificantDigits) {
	            fractionString = fractionString.replace(/0*$/, "");
	        }
	
	        // Handle exponent.
	        var exponent = parseInt(exponentString, 10);
	
	        if (exponent > 0) {
	            if (fractionString.length <= exponent) {
	                fractionString = fractionString + repeatZero(exponent - fractionString.length);
	
	                integerString = integerString + fractionString;
	                fractionString = "";
	            } else {
	                integerString = integerString + fractionString.slice(0, exponent);
	                fractionString = fractionString.slice(exponent);
	            }
	        } else if (exponent < 0) {
	            fractionString = (repeatZero(Math.abs(exponent) - integerString.length) + integerString + fractionString);
	
	            integerString = "0";
	        }
	
	        if (!maximumSignificantDigits) {
	            // Trim or pad fraction when not using maximumSignificantDigits.
	            fractionString = fractionString.slice(0, fractionDigits);
	
	            if (fractionString.length < fractionDigits) {
	                fractionString = fractionString + repeatZero(fractionDigits - fractionString.length);
	            }
	
	            // Pad integer when using minimumIntegerDigits
	            // and not using maximumSignificantDigits.
	            if (integerString.length < minimumIntegerDigits) {
	                integerString = repeatZero(minimumIntegerDigits - integerString.length) + integerString;
	            }
	        }
	
	        var formattedString = "";
	
	        // Handle grouping.
	        if (useGrouping) {
	            temp = integerString;
	            var group;
	
	            while (temp.length) {
	                if (grouping.length) {
	                    group = grouping.shift();
	                }
	
	                if (formattedString) {
	                    formattedString = groupingSeparator + formattedString;
	                }
	
	                formattedString = temp.slice(-group) + formattedString;
	
	                temp = temp.slice(0, -group);
	            }
	        } else {
	            formattedString = integerString;
	        }
	
	        // Add decimalSeparator and fraction.
	        if (fractionString) {
	            formattedString = formattedString + decimalSeparator + fractionString;
	        }
	
	        return formattedString;
	    }
	
	    // durationLabelCompare
	    function durationLabelCompare(a, b) {
	        if (a.label.length > b.label.length) {
	            return -1;
	        }
	
	        if (a.label.length < b.label.length) {
	            return 1;
	        }
	
	        // a must be equal to b
	        return 0;
	    }
	
	    // durationGetLabels
	    function durationGetLabels(token, localeData) {
	        var labels = [];
	
	        each(keys(localeData), function (localeDataKey) {
	            if (localeDataKey.slice(0, 15) !== "_durationLabels") {
	                return;
	            }
	
	            var labelType = localeDataKey.slice(15).toLowerCase();
	
	            each(keys(localeData[localeDataKey]), function (labelKey) {
	                if (labelKey.slice(0, 1) === token) {
	                    labels.push({
	                        type: labelType,
	                        key: labelKey,
	                        label: localeData[localeDataKey][labelKey]
	                    });
	                }
	            });
	        });
	
	        return labels;
	    }
	
	    // durationPluralKey
	    function durationPluralKey(token, integerValue, decimalValue) {
	        // Singular for a value of `1`, but not for `1.0`.
	        if (integerValue === 1 && decimalValue === null) {
	            return token;
	        }
	
	        return token + token;
	    }
	
	    var engLocale = {
	        durationLabelsStandard: {
	            S: 'millisecond',
	            SS: 'milliseconds',
	            s: 'second',
	            ss: 'seconds',
	            m: 'minute',
	            mm: 'minutes',
	            h: 'hour',
	            hh: 'hours',
	            d: 'day',
	            dd: 'days',
	            w: 'week',
	            ww: 'weeks',
	            M: 'month',
	            MM: 'months',
	            y: 'year',
	            yy: 'years'
	        },
	        durationLabelsShort: {
	            S: 'msec',
	            SS: 'msecs',
	            s: 'sec',
	            ss: 'secs',
	            m: 'min',
	            mm: 'mins',
	            h: 'hr',
	            hh: 'hrs',
	            d: 'dy',
	            dd: 'dys',
	            w: 'wk',
	            ww: 'wks',
	            M: 'mo',
	            MM: 'mos',
	            y: 'yr',
	            yy: 'yrs'
	        },
	        durationTimeTemplates: {
	            HMS: 'h:mm:ss',
	            HM: 'h:mm',
	            MS: 'm:ss'
	        },
	        durationLabelTypes: [
	            { type: "standard", string: "__" },
	            { type: "short", string: "_" }
	        ],
	        durationPluralKey: durationPluralKey
	    };
	
	    // isArray
	    function isArray(array) {
	        return Object.prototype.toString.call(array) === "[object Array]";
	    }
	
	    // isObject
	    function isObject(obj) {
	        return Object.prototype.toString.call(obj) === "[object Object]";
	    }
	
	    // findLast
	    function findLast(array, callback) {
	        var index = array.length;
	
	        while (index -= 1) {
	            if (callback(array[index])) { return array[index]; }
	        }
	    }
	
	    // find
	    function find(array, callback) {
	        var index = 0;
	
	        var max = array && array.length || 0;
	
	        var match;
	
	        if (typeof callback !== "function") {
	            match = callback;
	            callback = function (item) {
	                return item === match;
	            };
	        }
	
	        while (index < max) {
	            if (callback(array[index])) { return array[index]; }
	            index += 1;
	        }
	    }
	
	    // each
	    function each(array, callback) {
	        var index = 0,
	            max = array.length;
	
	        if (!array || !max) { return; }
	
	        while (index < max) {
	            if (callback(array[index], index) === false) { return; }
	            index += 1;
	        }
	    }
	
	    // map
	    function map(array, callback) {
	        var index = 0,
	            max = array.length,
	            ret = [];
	
	        if (!array || !max) { return ret; }
	
	        while (index < max) {
	            ret[index] = callback(array[index], index);
	            index += 1;
	        }
	
	        return ret;
	    }
	
	    // pluck
	    function pluck(array, prop) {
	        return map(array, function (item) {
	            return item[prop];
	        });
	    }
	
	    // compact
	    function compact(array) {
	        var ret = [];
	
	        each(array, function (item) {
	            if (item) { ret.push(item); }
	        });
	
	        return ret;
	    }
	
	    // unique
	    function unique(array) {
	        var ret = [];
	
	        each(array, function (_a) {
	            if (!find(ret, _a)) { ret.push(_a); }
	        });
	
	        return ret;
	    }
	
	    // intersection
	    function intersection(a, b) {
	        var ret = [];
	
	        each(a, function (_a) {
	            each(b, function (_b) {
	                if (_a === _b) { ret.push(_a); }
	            });
	        });
	
	        return unique(ret);
	    }
	
	    // rest
	    function rest(array, callback) {
	        var ret = [];
	
	        each(array, function (item, index) {
	            if (!callback(item)) {
	                ret = array.slice(index);
	                return false;
	            }
	        });
	
	        return ret;
	    }
	
	    // initial
	    function initial(array, callback) {
	        var reversed = array.slice().reverse();
	
	        return rest(reversed, callback).reverse();
	    }
	
	    // extend
	    function extend(a, b) {
	        for (var key in b) {
	            if (b.hasOwnProperty(key)) { a[key] = b[key]; }
	        }
	
	        return a;
	    }
	
	    // keys
	    function keys(a) {
	        var ret = [];
	
	        for (var key in a) {
	            if (a.hasOwnProperty(key)) { ret.push(key); }
	        }
	
	        return ret;
	    }
	
	    // any
	    function any(array, callback) {
	        var index = 0,
	            max = array.length;
	
	        if (!array || !max) { return false; }
	
	        while (index < max) {
	            if (callback(array[index], index) === true) { return true; }
	            index += 1;
	        }
	
	        return false;
	    }
	
	    // flatten
	    function flatten(array) {
	        var ret = [];
	
	        each(array, function(child) {
	            ret = ret.concat(child);
	        });
	
	        return ret;
	    }
	
	    function toLocaleStringSupportsLocales() {
	        var number = 0;
	        try {
	            number.toLocaleString('i');
	        } catch (e) {
	            return e.name === 'RangeError';
	        }
	        return false;
	    }
	
	    function featureTestFormatterRounding(formatter) {
	        return formatter(3.55, "en", {
	            useGrouping: false,
	            minimumIntegerDigits: 1,
	            minimumFractionDigits: 1,
	            maximumFractionDigits: 1
	        }) === "3.6";
	    }
	
	    function featureTestFormatter(formatter) {
	        var passed = true;
	
	        // Test minimumIntegerDigits.
	        passed = passed && formatter(1, "en", { minimumIntegerDigits: 1 }) === "1";
	        passed = passed && formatter(1, "en", { minimumIntegerDigits: 2 }) === "01";
	        passed = passed && formatter(1, "en", { minimumIntegerDigits: 3 }) === "001";
	        if (!passed) { return false; }
	
	        // Test maximumFractionDigits and minimumFractionDigits.
	        passed = passed && formatter(99.99, "en", { maximumFractionDigits: 0, minimumFractionDigits: 0 }) === "100";
	        passed = passed && formatter(99.99, "en", { maximumFractionDigits: 1, minimumFractionDigits: 1 }) === "100.0";
	        passed = passed && formatter(99.99, "en", { maximumFractionDigits: 2, minimumFractionDigits: 2 }) === "99.99";
	        passed = passed && formatter(99.99, "en", { maximumFractionDigits: 3, minimumFractionDigits: 3 }) === "99.990";
	        if (!passed) { return false; }
	
	        // Test maximumSignificantDigits.
	        passed = passed && formatter(99.99, "en", { maximumSignificantDigits: 1 }) === "100";
	        passed = passed && formatter(99.99, "en", { maximumSignificantDigits: 2 }) === "100";
	        passed = passed && formatter(99.99, "en", { maximumSignificantDigits: 3 }) === "100";
	        passed = passed && formatter(99.99, "en", { maximumSignificantDigits: 4 }) === "99.99";
	        passed = passed && formatter(99.99, "en", { maximumSignificantDigits: 5 }) === "99.99";
	        if (!passed) { return false; }
	
	        // Test grouping.
	        passed = passed && formatter(1000, "en", { useGrouping: true }) === "1,000";
	        passed = passed && formatter(1000, "en", { useGrouping: false }) === "1000";
	        if (!passed) { return false; }
	
	        return true;
	    }
	
	    // durationsFormat(durations [, template] [, precision] [, settings])
	    function durationsFormat() {
	        var args = [].slice.call(arguments);
	        var settings = {};
	        var durations;
	
	        // Parse arguments.
	        each(args, function (arg, index) {
	            if (!index) {
	                if (!isArray(arg)) {
	                    throw "Expected array as the first argument to durationsFormat.";
	                }
	
	                durations = arg;
	            }
	
	            if (typeof arg === "string" || typeof arg === "function") {
	                settings.template = arg;
	                return;
	            }
	
	            if (typeof arg === "number") {
	                settings.precision = arg;
	                return;
	            }
	
	            if (isObject(arg)) {
	                extend(settings, arg);
	            }
	        });
	
	        if (!durations || !durations.length) {
	            return [];
	        }
	
	        settings.returnMomentTypes = true;
	
	        var formattedDurations = map(durations, function (dur) {
	            return dur.format(settings);
	        });
	
	        // Merge token types from all durations.
	        var outputTypes = intersection(types, unique(pluck(flatten(formattedDurations), "type")));
	
	        var largest = settings.largest;
	
	        if (largest) {
	            outputTypes = outputTypes.slice(0, largest);
	        }
	
	        settings.returnMomentTypes = false;
	        settings.outputTypes = outputTypes;
	
	        return map(durations, function (dur) {
	            return dur.format(settings);
	        });
	    }
	
	    // durationFormat([template] [, precision] [, settings])
	    function durationFormat() {
	
	        var args = [].slice.call(arguments);
	        var settings = extend({}, this.format.defaults);
	
	        // Keep a shadow copy of this moment for calculating remainders.
	        // Perform all calculations on positive duration value, handle negative
	        // sign at the very end.
	        var asMilliseconds = this.asMilliseconds();
	        var asMonths = this.asMonths();
	
	        // Treat invalid durations as having a value of 0 milliseconds.
	        if (typeof this.isValid === "function" && this.isValid() === false) {
	            asMilliseconds = 0;
	            asMonths = 0;
	        }
	
	        var isNegative = asMilliseconds < 0;
	
	        // Two shadow copies are needed because of the way moment.js handles
	        // duration arithmetic for years/months and for weeks/days/hours/minutes/seconds.
	        var remainder = moment.duration(Math.abs(asMilliseconds), "milliseconds");
	        var remainderMonths = moment.duration(Math.abs(asMonths), "months");
	
	        // Parse arguments.
	        each(args, function (arg) {
	            if (typeof arg === "string" || typeof arg === "function") {
	                settings.template = arg;
	                return;
	            }
	
	            if (typeof arg === "number") {
	                settings.precision = arg;
	                return;
	            }
	
	            if (isObject(arg)) {
	                extend(settings, arg);
	            }
	        });
	
	        var momentTokens = {
	            years: "y",
	            months: "M",
	            weeks: "w",
	            days: "d",
	            hours: "h",
	            minutes: "m",
	            seconds: "s",
	            milliseconds: "S"
	        };
	
	        var tokenDefs = {
	            escape: /\[(.+?)\]/,
	            years: /\*?[Yy]+/,
	            months: /\*?M+/,
	            weeks: /\*?[Ww]+/,
	            days: /\*?[Dd]+/,
	            hours: /\*?[Hh]+/,
	            minutes: /\*?m+/,
	            seconds: /\*?s+/,
	            milliseconds: /\*?S+/,
	            general: /.+?/
	        };
	
	        // Types array is available in the template function.
	        settings.types = types;
	
	        var typeMap = function (token) {
	            return find(types, function (type) {
	                return tokenDefs[type].test(token);
	            });
	        };
	
	        var tokenizer = new RegExp(map(types, function (type) {
	            return tokenDefs[type].source;
	        }).join("|"), "g");
	
	        // Current duration object is available in the template function.
	        settings.duration = this;
	
	        // Eval template function and cache template string.
	        var template = typeof settings.template === "function" ? settings.template.apply(settings) : settings.template;
	
	        // outputTypes and returnMomentTypes are settings to support durationsFormat().
	
	        // outputTypes is an array of moment token types that determines
	        // the tokens returned in formatted output. This option overrides
	        // trim, largest, stopTrim, etc.
	        var outputTypes = settings.outputTypes;
	
	        // returnMomentTypes is a boolean that sets durationFormat to return
	        // the processed momentTypes instead of formatted output.
	        var returnMomentTypes = settings.returnMomentTypes;
	
	        var largest = settings.largest;
	
	        // Setup stopTrim array of token types.
	        var stopTrim = [];
	
	        if (!outputTypes) {
	            if (isArray(settings.stopTrim)) {
	                settings.stopTrim = settings.stopTrim.join("");
	            }
	
	            // Parse stopTrim string to create token types array.
	            if (settings.stopTrim) {
	                each(settings.stopTrim.match(tokenizer), function (token) {
	                    var type = typeMap(token);
	
	                    if (type === "escape" || type === "general") {
	                        return;
	                    }
	
	                    stopTrim.push(type);
	                });
	            }
	        }
	
	        // Cache moment's locale data.
	        var localeData = moment.localeData();
	
	        if (!localeData) {
	            localeData = {};
	        }
	
	        // Fall back to this plugin's `eng` extension.
	        each(keys(engLocale), function (key) {
	            if (typeof engLocale[key] === "function") {
	                if (!localeData[key]) {
	                    localeData[key] = engLocale[key];
	                }
	
	                return;
	            }
	
	            if (!localeData["_" + key]) {
	                localeData["_" + key] = engLocale[key];
	            }
	        });
	
	        // Replace Duration Time Template strings.
	        // For locale `eng`: `_HMS_`, `_HM_`, and `_MS_`.
	        each(keys(localeData._durationTimeTemplates), function (item) {
	            template = template.replace("_" + item + "_", localeData._durationTimeTemplates[item]);
	        });
	
	        // Determine user's locale.
	        var userLocale = settings.userLocale || moment.locale();
	
	        var useLeftUnits = settings.useLeftUnits;
	        var usePlural = settings.usePlural;
	        var precision = settings.precision;
	        var forceLength = settings.forceLength;
	        var useGrouping = settings.useGrouping;
	        var trunc = settings.trunc;
	
	        // Use significant digits only when precision is greater than 0.
	        var useSignificantDigits = settings.useSignificantDigits && precision > 0;
	        var significantDigits = useSignificantDigits ? settings.precision : 0;
	        var significantDigitsCache = significantDigits;
	
	        var minValue = settings.minValue;
	        var isMinValue = false;
	
	        var maxValue = settings.maxValue;
	        var isMaxValue = false;
	
	        // formatNumber fallback options.
	        var useToLocaleString = settings.useToLocaleString;
	        var groupingSeparator = settings.groupingSeparator;
	        var decimalSeparator = settings.decimalSeparator;
	        var grouping = settings.grouping;
	
	        useToLocaleString = useToLocaleString && (toLocaleStringWorks || intlNumberFormatWorks);
	
	        // Trim options.
	        var trim = settings.trim;
	
	        if (isArray(trim)) {
	            trim = trim.join(" ");
	        }
	
	        if (trim === null && (largest || maxValue || useSignificantDigits)) {
	            trim = "all";
	        }
	
	        if (trim === null || trim === true || trim === "left" || trim === "right") {
	            trim = "large";
	        }
	
	        if (trim === false) {
	            trim = "";
	        }
	
	        var trimIncludes = function (item) {
	            return item.test(trim);
	        };
	
	        var rLarge = /large/;
	        var rSmall = /small/;
	        var rBoth = /both/;
	        var rMid = /mid/;
	        var rAll = /^all|[^sm]all/;
	        var rFinal = /final/;
	
	        var trimLarge = largest > 0 || any([rLarge, rBoth, rAll], trimIncludes);
	        var trimSmall = any([rSmall, rBoth, rAll], trimIncludes);
	        var trimMid = any([rMid, rAll], trimIncludes);
	        var trimFinal = any([rFinal, rAll], trimIncludes);
	
	        // Parse format string to create raw tokens array.
	        var rawTokens = map(template.match(tokenizer), function (token, index) {
	            var type = typeMap(token);
	
	            if (token.slice(0, 1) === "*") {
	                token = token.slice(1);
	
	                if (type !== "escape" && type !== "general") {
	                    stopTrim.push(type);
	                }
	            }
	
	            return {
	                index: index,
	                length: token.length,
	                text: "",
	
	                // Replace escaped tokens with the non-escaped token text.
	                token: (type === "escape" ? token.replace(tokenDefs.escape, "$1") : token),
	
	                // Ignore type on non-moment tokens.
	                type: ((type === "escape" || type === "general") ? null : type)
	            };
	        });
	
	        // Associate text tokens with moment tokens.
	        var currentToken = {
	            index: 0,
	            length: 0,
	            token: "",
	            text: "",
	            type: null
	        };
	
	        var tokens = [];
	
	        if (useLeftUnits) {
	            rawTokens.reverse();
	        }
	
	        each(rawTokens, function (token) {
	            if (token.type) {
	                if (currentToken.type || currentToken.text) {
	                    tokens.push(currentToken);
	                }
	
	                currentToken = token;
	
	                return;
	            }
	
	            if (useLeftUnits) {
	                currentToken.text = token.token + currentToken.text;
	            } else {
	                currentToken.text += token.token;
	            }
	        });
	
	        if (currentToken.type || currentToken.text) {
	            tokens.push(currentToken);
	        }
	
	        if (useLeftUnits) {
	            tokens.reverse();
	        }
	
	        // Find unique moment token types in the template in order of
	        // descending magnitude.
	        var momentTypes = intersection(types, unique(compact(pluck(tokens, "type"))));
	
	        // Exit early if there are no moment token types.
	        if (!momentTypes.length) {
	            return pluck(tokens, "text").join("");
	        }
	
	        // Calculate values for each moment type in the template.
	        // For processing the settings, values are associated with moment types.
	        // Values will be assigned to tokens at the last step in order to
	        // assume nothing about frequency or order of tokens in the template.
	        momentTypes = map(momentTypes, function (momentType, index) {
	            // Is this the least-magnitude moment token found?
	            var isSmallest = ((index + 1) === momentTypes.length);
	
	            // Is this the greatest-magnitude moment token found?
	            var isLargest = (!index);
	
	            // Get the raw value in the current units.
	            var rawValue;
	
	            if (momentType === "years" || momentType === "months") {
	                rawValue = remainderMonths.as(momentType);
	            } else {
	                rawValue = remainder.as(momentType);
	            }
	
	            var wholeValue = Math.floor(rawValue);
	            var decimalValue = rawValue - wholeValue;
	
	            var token = find(tokens, function (token) {
	                return momentType === token.type;
	            });
	
	            if (isLargest && maxValue && rawValue > maxValue) {
	                isMaxValue = true;
	            }
	
	            if (isSmallest && minValue && Math.abs(settings.duration.as(momentType)) < minValue) {
	                isMinValue = true;
	            }
	
	            // Note the length of the largest-magnitude moment token:
	            // if it is greater than one and forceLength is not set,
	            // then default forceLength to `true`.
	            //
	            // Rationale is this: If the template is "h:mm:ss" and the
	            // moment value is 5 minutes, the user-friendly output is
	            // "5:00", not "05:00". We shouldn't pad the `minutes` token
	            // even though it has length of two if the template is "h:mm:ss";
	            //
	            // If the minutes output should always include the leading zero
	            // even when the hour is trimmed then set `{ forceLength: true }`
	            // to output "05:00". If the template is "hh:mm:ss", the user
	            // clearly wanted everything padded so we should output "05:00";
	            //
	            // If the user wants the full padded output, they can use
	            // template "hh:mm:ss" and set `{ trim: false }` to output
	            // "00:05:00".
	            if (isLargest && forceLength === null && token.length > 1) {
	                forceLength = true;
	            }
	
	            // Update remainder.
	            remainder.subtract(wholeValue, momentType);
	            remainderMonths.subtract(wholeValue, momentType);
	
	            return {
	                rawValue: rawValue,
	                wholeValue: wholeValue,
	                // Decimal value is only retained for the least-magnitude
	                // moment type in the format template.
	                decimalValue: isSmallest ? decimalValue : 0,
	                isSmallest: isSmallest,
	                isLargest: isLargest,
	                type: momentType,
	                // Tokens can appear multiple times in a template string,
	                // but all instances must share the same length.
	                tokenLength: token.length
	            };
	        });
	
	        var truncMethod = trunc ? Math.floor : Math.round;
	        var truncate = function (value, places) {
	            var factor = Math.pow(10, places);
	            return truncMethod(value * factor) / factor;
	        };
	
	        var foundFirst = false;
	        var bubbled = false;
	
	        var formatValue = function (momentType, index) {
	            var formatOptions = {
	                useGrouping: useGrouping,
	                groupingSeparator: groupingSeparator,
	                decimalSeparator: decimalSeparator,
	                grouping: grouping,
	                useToLocaleString: useToLocaleString
	            };
	
	            if (useSignificantDigits) {
	                if (significantDigits <= 0) {
	                    momentType.rawValue = 0;
	                    momentType.wholeValue = 0;
	                    momentType.decimalValue = 0;
	                } else {
	                    formatOptions.maximumSignificantDigits = significantDigits;
	                    momentType.significantDigits = significantDigits;
	                }
	            }
	
	            if (isMaxValue && !bubbled) {
	                if (momentType.isLargest) {
	                    momentType.wholeValue = maxValue;
	                    momentType.decimalValue = 0;
	                } else {
	                    momentType.wholeValue = 0;
	                    momentType.decimalValue = 0;
	                }
	            }
	
	            if (isMinValue && !bubbled) {
	                if (momentType.isSmallest) {
	                    momentType.wholeValue = minValue;
	                    momentType.decimalValue = 0;
	                } else {
	                    momentType.wholeValue = 0;
	                    momentType.decimalValue = 0;
	                }
	            }
	
	            if (momentType.isSmallest || momentType.significantDigits && momentType.significantDigits - momentType.wholeValue.toString().length <= 0) {
	                // Apply precision to least significant token value.
	                if (precision < 0) {
	                    momentType.value = truncate(momentType.wholeValue, precision);
	                } else if (precision === 0) {
	                    momentType.value = truncMethod(momentType.wholeValue + momentType.decimalValue);
	                } else { // precision > 0
	                    if (useSignificantDigits) {
	                        if (trunc) {
	                            momentType.value = truncate(momentType.rawValue, significantDigits - momentType.wholeValue.toString().length);
	                        } else {
	                            momentType.value = momentType.rawValue;
	                        }
	
	                        if (momentType.wholeValue) {
	                            significantDigits -= momentType.wholeValue.toString().length;
	                        }
	                    } else {
	                        formatOptions.fractionDigits = precision;
	
	                        if (trunc) {
	                            momentType.value = momentType.wholeValue + truncate(momentType.decimalValue, precision);
	                        } else {
	                            momentType.value = momentType.wholeValue + momentType.decimalValue;
	                        }
	                    }
	                }
	            } else {
	                if (useSignificantDigits && momentType.wholeValue) {
	                    // Outer Math.round required here to handle floating point errors.
	                    momentType.value = Math.round(truncate(momentType.wholeValue, momentType.significantDigits - momentType.wholeValue.toString().length));
	
	                    significantDigits -= momentType.wholeValue.toString().length;
	                } else {
	                    momentType.value = momentType.wholeValue;
	                }
	            }
	
	            if (momentType.tokenLength > 1 && (forceLength || foundFirst)) {
	                formatOptions.minimumIntegerDigits = momentType.tokenLength;
	
	                if (bubbled && formatOptions.maximumSignificantDigits < momentType.tokenLength) {
	                    delete formatOptions.maximumSignificantDigits;
	                }
	            }
	
	            if (!foundFirst && (momentType.value > 0 || trim === "" /* trim: false */ || find(stopTrim, momentType.type) || find(outputTypes, momentType.type))) {
	                foundFirst = true;
	            }
	
	            momentType.formattedValue = formatNumber(momentType.value, formatOptions, userLocale);
	
	            formatOptions.useGrouping = false;
	            formatOptions.decimalSeparator = ".";
	            momentType.formattedValueEn = formatNumber(momentType.value, formatOptions, "en");
	
	            if (momentType.tokenLength === 2 && momentType.type === "milliseconds") {
	                momentType.formattedValueMS = formatNumber(momentType.value, {
	                    minimumIntegerDigits: 3,
	                    useGrouping: false
	                }, "en").slice(0, 2);
	            }
	
	            return momentType;
	        };
	
	        // Calculate formatted values.
	        momentTypes = map(momentTypes, formatValue);
	        momentTypes = compact(momentTypes);
	
	        // Bubble rounded values.
	        if (momentTypes.length > 1) {
	            var findType = function (type) {
	                return find(momentTypes, function (momentType) {
	                    return momentType.type === type;
	                });
	            };
	
	            var bubbleTypes = function (bubble) {
	                var bubbleMomentType = findType(bubble.type);
	
	                if (!bubbleMomentType) {
	                    return;
	                }
	
	                each(bubble.targets, function (target) {
	                    var targetMomentType = findType(target.type);
	
	                    if (!targetMomentType) {
	                        return;
	                    }
	
	                    if (parseInt(bubbleMomentType.formattedValueEn, 10) === target.value) {
	                        bubbleMomentType.rawValue = 0;
	                        bubbleMomentType.wholeValue = 0;
	                        bubbleMomentType.decimalValue = 0;
	                        targetMomentType.rawValue += 1;
	                        targetMomentType.wholeValue += 1;
	                        targetMomentType.decimalValue = 0;
	                        targetMomentType.formattedValueEn = targetMomentType.wholeValue.toString();
	                        bubbled = true;
	                    }
	                });
	            };
	
	            each(bubbles, bubbleTypes);
	        }
	
	        // Recalculate formatted values.
	        if (bubbled) {
	            foundFirst = false;
	            significantDigits = significantDigitsCache;
	            momentTypes = map(momentTypes, formatValue);
	            momentTypes = compact(momentTypes);
	        }
	
	        if (outputTypes && !(isMaxValue && !settings.trim)) {
	            momentTypes = map(momentTypes, function (momentType) {
	                if (find(outputTypes, function (outputType) {
	                    return momentType.type === outputType;
	                })) {
	                    return momentType;
	                }
	
	                return null;
	            });
	
	            momentTypes = compact(momentTypes);
	        } else {
	            // Trim Large.
	            if (trimLarge) {
	                momentTypes = rest(momentTypes, function (momentType) {
	                    // Stop trimming on:
	                    // - the smallest moment type
	                    // - a type marked for stopTrim
	                    // - a type that has a whole value
	                    return !momentType.isSmallest && !momentType.wholeValue && !find(stopTrim, momentType.type);
	                });
	            }
	
	            // Largest.
	            if (largest && momentTypes.length) {
	                momentTypes = momentTypes.slice(0, largest);
	            }
	
	            // Trim Small.
	            if (trimSmall && momentTypes.length > 1) {
	                momentTypes = initial(momentTypes, function (momentType) {
	                    // Stop trimming on:
	                    // - a type marked for stopTrim
	                    // - a type that has a whole value
	                    // - the largest momentType
	                    return !momentType.wholeValue && !find(stopTrim, momentType.type) && !momentType.isLargest;
	                });
	            }
	
	            // Trim Mid.
	            if (trimMid) {
	                momentTypes = map(momentTypes, function (momentType, index) {
	                    if (index > 0 && index < momentTypes.length - 1 && !momentType.wholeValue) {
	                        return null;
	                    }
	
	                    return momentType;
	                });
	
	                momentTypes = compact(momentTypes);
	            }
	
	            // Trim Final.
	            if (trimFinal && momentTypes.length === 1 && !momentTypes[0].wholeValue && !(!trunc && momentTypes[0].isSmallest && momentTypes[0].rawValue < minValue)) {
	                momentTypes = [];
	            }
	        }
	
	        if (returnMomentTypes) {
	            return momentTypes;
	        }
	
	        // Localize and pluralize unit labels.
	        each(tokens, function (token) {
	            var key = momentTokens[token.type];
	
	            var momentType = find(momentTypes, function (momentType) {
	                return momentType.type === token.type;
	            });
	
	            if (!key || !momentType) {
	                return;
	            }
	
	            var values = momentType.formattedValueEn.split(".");
	
	            values[0] = parseInt(values[0], 10);
	
	            if (values[1]) {
	                values[1] = parseFloat("0." + values[1], 10);
	            } else {
	                values[1] = null;
	            }
	
	            var pluralKey = localeData.durationPluralKey(key, values[0], values[1]);
	
	            var labels = durationGetLabels(key, localeData);
	
	            var autoLocalized = false;
	
	            var pluralizedLabels = {};
	
	            // Auto-Localized unit labels.
	            each(localeData._durationLabelTypes, function (labelType) {
	                var label = find(labels, function (label) {
	                    return label.type === labelType.type && label.key === pluralKey;
	                });
	
	                if (label) {
	                    pluralizedLabels[label.type] = label.label;
	
	                    if (stringIncludes(token.text, labelType.string)) {
	                        token.text = token.text.replace(labelType.string, label.label);
	                        autoLocalized = true;
	                    }
	                }
	            });
	
	            // Auto-pluralized unit labels.
	            if (usePlural && !autoLocalized) {
	                labels.sort(durationLabelCompare);
	
	                each(labels, function (label) {
	                    if (pluralizedLabels[label.type] === label.label) {
	                        if (stringIncludes(token.text, label.label)) {
	                            // Stop checking this token if its label is already
	                            // correctly pluralized.
	                            return false;
	                        }
	
	                        // Skip this label if it is correct, but not present in
	                        // the token's text.
	                        return;
	                    }
	
	                    if (stringIncludes(token.text, label.label)) {
	                        // Replece this token's label and stop checking.
	                        token.text = token.text.replace(label.label, pluralizedLabels[label.type]);
	                        return false;
	                    }
	                });
	            }
	        });
	
	        // Build ouptut.
	        tokens = map(tokens, function (token) {
	            if (!token.type) {
	                return token.text;
	            }
	
	            var momentType = find(momentTypes, function (momentType) {
	                return momentType.type === token.type;
	            });
	
	            if (!momentType) {
	                return "";
	            }
	
	            var out = "";
	
	            if (useLeftUnits) {
	                out += token.text;
	            }
	
	            if (isNegative && isMaxValue || !isNegative && isMinValue) {
	                out += "< ";
	                isMaxValue = false;
	                isMinValue = false;
	            }
	
	            if (isNegative && isMinValue || !isNegative && isMaxValue) {
	                out += "> ";
	                isMaxValue = false;
	                isMinValue = false;
	            }
	
	            if (isNegative && (momentType.value > 0 || trim === "" || find(stopTrim, momentType.type) || find(outputTypes, momentType.type))) {
	                out += "-";
	                isNegative = false;
	            }
	
	            if (token.type === "milliseconds" && momentType.formattedValueMS) {
	                out += momentType.formattedValueMS;
	            } else {
	                out += momentType.formattedValue;
	            }
	
	            if (!useLeftUnits) {
	                out += token.text;
	            }
	
	            return out;
	        });
	
	        // Trim leading and trailing comma, space, colon, and dot.
	        return tokens.join("").replace(/(,| |:|\.)*$/, "").replace(/^(,| |:|\.)*/, "");
	    }
	
	    // defaultFormatTemplate
	    function defaultFormatTemplate() {
	        var dur = this.duration;
	
	        var findType = function findType(type) {
	            return dur._data[type];
	        };
	
	        var firstType = find(this.types, findType);
	
	        var lastType = findLast(this.types, findType);
	
	        // Default template strings for each duration dimension type.
	        switch (firstType) {
	            case "milliseconds":
	                return "S __";
	            case "seconds": // Fallthrough.
	            case "minutes":
	                return "*_MS_";
	            case "hours":
	                return "_HMS_";
	            case "days": // Possible Fallthrough.
	                if (firstType === lastType) {
	                    return "d __";
	                }
	            case "weeks":
	                if (firstType === lastType) {
	                    return "w __";
	                }
	
	                if (this.trim === null) {
	                    this.trim = "both";
	                }
	
	                return "w __, d __, h __";
	            case "months": // Possible Fallthrough.
	                if (firstType === lastType) {
	                    return "M __";
	                }
	            case "years":
	                if (firstType === lastType) {
	                    return "y __";
	                }
	
	                if (this.trim === null) {
	                    this.trim = "both";
	                }
	
	                return "y __, M __, d __";
	            default:
	                if (this.trim === null) {
	                    this.trim = "both";
	                }
	
	                return "y __, d __, h __, m __, s __";
	        }
	    }
	
	    // init
	    function init(context) {
	        if (!context) {
	            throw "Moment Duration Format init cannot find moment instance.";
	        }
	
	        context.duration.format = durationsFormat;
	        context.duration.fn.format = durationFormat;
	
	        context.duration.fn.format.defaults = {
	            // Many options are defaulted to `null` to distinguish between
	            // 'not set' and 'set to `false`'
	
	            // trim
	            // Can be a string, a delimited list of strings, an array of strings,
	            // or a boolean.
	            // "large" - will trim largest-magnitude zero-value tokens until
	            // finding a token with a value, a token identified as 'stopTrim', or
	            // the final token of the format string.
	            // "small" - will trim smallest-magnitude zero-value tokens until
	            // finding a token with a value, a token identified as 'stopTrim', or
	            // the final token of the format string.
	            // "both" - will execute "large" trim then "small" trim.
	            // "mid" - will trim any zero-value tokens that are not the first or
	            // last tokens. Usually used in conjunction with "large" or "both".
	            // e.g. "large mid" or "both mid".
	            // "final" - will trim the final token if it is zero-value. Use this
	            // option with "large" or "both" to output an empty string when
	            // formatting a zero-value duration. e.g. "large final" or "both final".
	            // "all" - Will trim all zero-value tokens. Shorthand for "both mid final".
	            // "left" - maps to "large" to support plugin's version 1 API.
	            // "right" - maps to "large" to support plugin's version 1 API.
	            // `false` - template tokens are not trimmed.
	            // `true` - treated as "large".
	            // `null` - treated as "large".
	            trim: null,
	
	            // stopTrim
	            // A moment token string, a delimited set of moment token strings,
	            // or an array of moment token strings. Trimming will stop when a token
	            // listed in this option is reached. A "*" character in the format
	            // template string will also mark a moment token as stopTrim.
	            // e.g. "d [days] *h:mm:ss" will always stop trimming at the 'hours' token.
	            stopTrim: null,
	
	            // largest
	            // Set to a positive integer to output only the "n" largest-magnitude
	            // moment tokens that have a value. All lesser-magnitude moment tokens
	            // will be ignored. This option takes effect even if `trim` is set
	            // to `false`.
	            largest: null,
	
	            // maxValue
	            // Use `maxValue` to render generalized output for large duration values,
	            // e.g. `"> 60 days"`. `maxValue` must be a positive integer and is
	            /// applied to the greatest-magnitude moment token in the format template.
	            maxValue: null,
	
	            // minValue
	            // Use `minValue` to render generalized output for small duration values,
	            // e.g. `"< 5 minutes"`. `minValue` must be a positive integer and is
	            // applied to the least-magnitude moment token in the format template.
	            minValue: null,
	
	            // precision
	            // If a positive integer, number of decimal fraction digits to render.
	            // If a negative integer, number of integer place digits to truncate to 0.
	            // If `useSignificantDigits` is set to `true` and `precision` is a positive
	            // integer, sets the maximum number of significant digits used in the
	            // formatted output.
	            precision: 0,
	
	            // trunc
	            // Default behavior rounds final token value. Set to `true` to
	            // truncate final token value, which was the default behavior in
	            // version 1 of this plugin.
	            trunc: false,
	
	            // forceLength
	            // Force first moment token with a value to render at full length
	            // even when template is trimmed and first moment token has length of 1.
	            forceLength: null,
	
	            // userLocale
	            // Formatted numerical output is rendered using `toLocaleString`
	            // and the locale of the user's environment. Set this option to render
	            // numerical output using a different locale. Unit names are rendered
	            // and detected using the locale set in moment.js, which can be different
	            // from the locale of user's environment.
	            userLocale: null,
	
	            // usePlural
	            // Will automatically singularize or pluralize unit names when they
	            // appear in the text associated with each moment token. Standard and
	            // short unit labels are singularized and pluralized, based on locale.
	            // e.g. in english, "1 second" or "1 sec" would be rendered instead
	            // of "1 seconds" or "1 secs". The default pluralization function
	            // renders a plural label for a value with decimal precision.
	            // e.g. "1.0 seconds" is never rendered as "1.0 second".
	            // Label types and pluralization function are configurable in the
	            // localeData extensions.
	            usePlural: true,
	
	            // useLeftUnits
	            // The text to the right of each moment token in a format string
	            // is treated as that token's units for the purposes of trimming,
	            // singularizing, and auto-localizing.
	            // e.g. "h [hours], m [minutes], s [seconds]".
	            // To properly singularize or localize a format string such as
	            // "[hours] h, [minutes] m, [seconds] s", where the units appear
	            // to the left of each moment token, set useLeftUnits to `true`.
	            // This plugin is not tested in the context of rtl text.
	            useLeftUnits: false,
	
	            // useGrouping
	            // Enables locale-based digit grouping in the formatted output. See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toLocaleString
	            useGrouping: true,
	
	            // useSignificantDigits
	            // Treat the `precision` option as the maximum significant digits
	            // to be rendered. Precision must be a positive integer. Significant
	            // digits extend across unit types,
	            // e.g. "6 hours 37.5 minutes" represents 4 significant digits.
	            // Enabling this option causes token length to be ignored. See  https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toLocaleString
	            useSignificantDigits: false,
	
	            // template
	            // The template string used to format the duration. May be a function
	            // or a string. Template functions are executed with the `this` binding
	            // of the settings object so that template strings may be dynamically
	            // generated based on the duration object (accessible via `this.duration`)
	            // or any of the other settings. Leading and trailing space, comma,
	            // period, and colon characters are trimmed from the resulting string.
	            template: defaultFormatTemplate,
	
	            // useToLocaleString
	            // Set this option to `false` to ignore the `toLocaleString` feature
	            // test and force the use of the `formatNumber` fallback function
	            // included in this plugin.
	            useToLocaleString: true,
	
	            // formatNumber fallback options.
	            // When `toLocaleString` is detected and passes the feature test, the
	            // following options will have no effect: `toLocaleString` will be used
	            // for formatting and the grouping separator, decimal separator, and
	            // integer digit grouping will be determined by the user locale.
	
	            // groupingSeparator
	            // The integer digit grouping separator used when using the fallback
	            // formatNumber function.
	            groupingSeparator: ",",
	
	            // decimalSeparator
	            // The decimal separator used when using the fallback formatNumber
	            // function.
	            decimalSeparator: ".",
	
	            // grouping
	            // The integer digit grouping used when using the fallback formatNumber
	            // function. Must be an array. The default value of `[3]` gives the
	            // standard 3-digit thousand/million/billion digit groupings for the
	            // "en" locale. Setting this option to `[3, 2]` would generate the
	            // thousand/lakh/crore digit groupings used in the "en-IN" locale.
	            grouping: [3]
	        };
	
	        context.updateLocale('en', engLocale);
	    }
	
	    // Run feature tests for `Number#toLocaleString`.
	    var toLocaleStringFormatter = function(number, locale, options) {
	        return number.toLocaleString(locale, options);
	    };
	
	    toLocaleStringWorks = toLocaleStringSupportsLocales() && featureTestFormatter(toLocaleStringFormatter);
	    toLocaleStringRoundingWorks = toLocaleStringWorks && featureTestFormatterRounding(toLocaleStringFormatter);
	
	    // Run feature tests for `Intl.NumberFormat#format`.
	    var intlNumberFormatFormatter = function(number, locale, options) {
	        if (typeof window !== 'undefined' && window && window.Intl && window.Intl.NumberFormat) {
	            return window.Intl.NumberFormat(locale, options).format(number);
	        }
	    };
	
	    intlNumberFormatWorks = featureTestFormatter(intlNumberFormatFormatter);
	    intlNumberFormatRoundingWorks = intlNumberFormatWorks && featureTestFormatterRounding(intlNumberFormatFormatter);
	
	    // Initialize duration format on the global moment instance.
	    init(moment);
	
	    // Return the init function so that duration format can be
	    // initialized on other moment instances.
	    return init;
	});


/***/ }),
/* 157 */
/***/ (function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	MainCtrl.$inject = ["$scope", "$rootScope", "$window", "arrayOrderingSrv"];
	angular.module('zeppelinWebApp').controller('MainCtrl', MainCtrl);
	
	function MainCtrl($scope, $rootScope, $window, arrayOrderingSrv) {
	  'ngInject';
	
	  $scope.looknfeel = 'default';
	
	  var init = function init() {
	    $scope.asIframe = $window.location.href.indexOf('asIframe') > -1 ? true : false;
	  };
	
	  init();
	
	  $rootScope.$on('setIframe', function (event, data) {
	    if (!event.defaultPrevented) {
	      $scope.asIframe = data;
	      event.preventDefault();
	    }
	  });
	
	  $rootScope.$on('setLookAndFeel', function (event, data) {
	    if (!event.defaultPrevented && data && data !== '' && data !== $scope.looknfeel) {
	      $scope.looknfeel = data;
	      event.preventDefault();
	    }
	  });
	
	  // Set The lookAndFeel to default on every page
	  $rootScope.$on('$routeChangeStart', function (event, next, current) {
	    $rootScope.$broadcast('setLookAndFeel', 'default');
	  });
	
	  $rootScope.noteName = function (note) {
	    if (!_.isEmpty(note)) {
	      return arrayOrderingSrv.getNoteName(note);
	    }
	  };
	
	  BootstrapDialog.defaultOptions.onshown = function () {
	    angular.element('#' + this.id).find('.btn:last').focus();
	  };
	
	  // Remove BootstrapDialog animation
	  BootstrapDialog.configDefaultOptions({ animate: false });
	}

/***/ }),
/* 158 */
/***/ (function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	HomeCtrl.$inject = ["$scope", "noteListFactory", "websocketMsgSrv", "$rootScope", "arrayOrderingSrv", "ngToast", "noteActionService", "TRASH_FOLDER_ID"];
	angular.module('zeppelinWebApp').controller('HomeCtrl', HomeCtrl);
	
	function HomeCtrl($scope, noteListFactory, websocketMsgSrv, $rootScope, arrayOrderingSrv, ngToast, noteActionService, TRASH_FOLDER_ID) {
	  'ngInject';
	
	  ngToast.dismiss();
	  var vm = this;
	  vm.notes = noteListFactory;
	  vm.websocketMsgSrv = websocketMsgSrv;
	  vm.arrayOrderingSrv = arrayOrderingSrv;
	  vm.noteActionService = noteActionService;
	  vm.numberOfNotesDisplayed = window.innerHeight / 20;
	
	  vm.notebookHome = false;
	  vm.noteCustomHome = true;
	  if ($rootScope.ticket !== undefined) {
	    vm.staticHome = false;
	  } else {
	    vm.staticHome = true;
	  }
	
	  $scope.isReloading = false;
	  $scope.TRASH_FOLDER_ID = TRASH_FOLDER_ID;
	  $scope.query = { q: '' };
	  $scope.ssoOnlyParadigm = _.get($rootScope.magpieConfig, 'zeppelin.loginParadigm', 'password') === 'sso';
	
	  $scope.showFirstTimeUser = function () {
	    return !$rootScope.ticket && !$scope.ssoOnlyParadigm;
	  };
	
	  $scope.initHome = function () {
	    websocketMsgSrv.getHomeNote();
	    vm.noteCustomHome = false;
	  };
	
	  $scope.toggleFolderNode = function (node) {
	    node.hidden = !node.hidden;
	  };
	
	  angular.element('#loginModal').on('hidden.bs.modal', function (e) {
	    $rootScope.$broadcast('initLoginValues');
	  });
	
	  angular.element('#sendPasswordResetModal').on('hidden.bs.modal', function (e) {
	    $rootScope.$broadcast('initPasswordResetValues');
	  });
	
	  /*
	   ** $scope.$on functions below
	   */
	
	  $scope.$on('setNoteMenu', function (event, notes) {
	    $scope.isReloadingNotes = false;
	  });
	
	  $scope.$on('setNoteContent', function (event, note) {
	    if (vm.noteCustomHome) {
	      return;
	    }
	
	    if (note) {
	      vm.note = note;
	
	      // initialize look And Feel
	      $rootScope.$broadcast('setLookAndFeel', 'home');
	
	      // make it read only
	      vm.viewOnly = true;
	
	      vm.notebookHome = true;
	      vm.staticHome = false;
	    } else {
	      vm.staticHome = true;
	      vm.notebookHome = false;
	    }
	  });
	
	  $rootScope.$on('magpieConfig', function () {
	    var paradigm = $rootScope.magpieConfig.zeppelin.loginParadigm;
	    if (paradigm === 'sso') {
	      $scope.ssoOnlyParadigm = true;
	    }
	  });
	
	  $scope.loadMoreNotes = function () {
	    vm.numberOfNotesDisplayed += 10;
	  };
	
	  $scope.renameNote = function (nodeId, nodePath) {
	    vm.noteActionService.renameNote(nodeId, nodePath);
	  };
	
	  $scope.moveNoteToTrash = function (noteId) {
	    vm.noteActionService.moveNoteToTrash(noteId, false);
	  };
	
	  $scope.moveFolderToTrash = function (folderId) {
	    vm.noteActionService.moveFolderToTrash(folderId);
	  };
	
	  $scope.restoreNote = function (noteId) {
	    websocketMsgSrv.restoreNote(noteId);
	  };
	
	  $scope.restoreFolder = function (folderId) {
	    websocketMsgSrv.restoreFolder(folderId);
	  };
	
	  $scope.restoreAll = function () {
	    vm.noteActionService.restoreAll();
	  };
	
	  $scope.renameFolder = function (node) {
	    vm.noteActionService.renameFolder(node.id);
	  };
	
	  $scope.removeNote = function (noteId) {
	    vm.noteActionService.removeNote(noteId, false);
	  };
	
	  $scope.removeFolder = function (folderId) {
	    vm.noteActionService.removeFolder(folderId);
	  };
	
	  $scope.emptyTrash = function () {
	    vm.noteActionService.emptyTrash();
	  };
	
	  $scope.clearAllParagraphOutput = function (noteId) {
	    vm.noteActionService.clearAllParagraphOutput(noteId);
	  };
	
	  $scope.isFilterNote = function (note) {
	    if (!$scope.query.q) {
	      return true;
	    }
	
	    var noteName = note.name;
	    if (noteName.toLowerCase().indexOf($scope.query.q.toLowerCase()) > -1) {
	      return true;
	    }
	    return false;
	  };
	
	  $scope.getNoteName = function (note) {
	    return arrayOrderingSrv.getNoteName(note);
	  };
	
	  $scope.noteComparator = function (note1, note2) {
	    return arrayOrderingSrv.noteComparator(note1, note2);
	  };
	}

/***/ }),
/* 159 */
/***/ (function(module, exports) {

	'use strict';
	
	PasswordResetCtrl.$inject = ["$scope", "$route", "$routeParams", "$rootScope", "$http", "$httpParamSerializer", "baseUrlSrv", "$location", "$timeout"];
	angular.module('zeppelinWebApp').controller('PasswordResetCtrl', PasswordResetCtrl);
	
	function PasswordResetCtrl($scope, $route, $routeParams, $rootScope, $http, $httpParamSerializer, baseUrlSrv, $location, $timeout) {
	  'ngInject';
	
	  $scope.updatingPass = false;
	  $scope.passwordResetParams = {};
	
	  $scope.updatePassword = function () {
	    $scope.updatingPass = true;
	    $scope.passwordResetParams.successText = '';
	    $scope.passwordResetParams.errorText = '';
	    if ($scope.passwordResetParams.newPass === $scope.passwordResetParams.confirmNewPass) {
	      $http({
	        method: 'PUT',
	        url: baseUrlSrv.getRestApiBase() + '/magpie/password-reset/' + $routeParams.token,
	        headers: {
	          'Content-Type': 'application/json'
	        },
	        data: JSON.stringify({
	          'newPassword': $scope.passwordResetParams.newPass
	        })
	      }).then(function successCallback(response) {
	        $scope.updatingPass = false;
	        if (!$rootScope.ticket) {
	          $location.path('/');
	          angular.element('#loginModal').modal('toggle');
	          $rootScope.$broadcast('passwordResetSuccess');
	        } else {
	          $scope.passwordResetParams.successText = 'Password successfully updated.';
	        }
	      }, function errorCallback(errorResponse) {
	        $scope.passwordResetParams.errorText = errorResponse.data.message;
	        $scope.updatingPass = false;
	      });
	    } else {
	      $scope.updatingPass = false;
	      $scope.passwordResetParams.errorText = 'Passwords must match';
	    }
	  };
	
	  $scope.initPasswordReset = function () {
	    $scope.passwordResetParams = {
	      containsValidToken: false,
	      hasLoaded: false,
	      newPass: '',
	      confirmNewPass: '',
	      successText: '',
	      errorText: ''
	    };
	
	    console.log('validating password reset token.');
	    $http({
	      method: 'GET',
	      url: baseUrlSrv.getRestApiBase() + '/magpie/password-reset/' + $routeParams.token,
	      headers: {
	        'Content-Type': 'application/json'
	      }
	    }).then(function successCallback(response) {
	      $scope.passwordResetParams.hasLoaded = true;
	      $scope.passwordResetParams.containsValidToken = true;
	    }, function errorCallback(errorResponse) {
	      $scope.passwordResetParams.hasLoaded = true;
	      $scope.passwordResetParams.containsValidToken = false;
	      if (errorResponse && errorResponse.data && errorResponse.data.message) {
	        $scope.passwordResetParams.errorText = errorResponse.data.message;
	      } else {
	        $scope.passwordResetParams.errorText = 'The Magpie password reset service has hit a snag. Please try again.';
	      }
	    });
	  };
	}

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	NotebookCtrl.$inject = ["$scope", "$route", "$routeParams", "$location", "$rootScope", "$http", "websocketMsgSrv", "baseUrlSrv", "$timeout", "saveAsService", "ngToast", "noteActionService", "noteVarShareService", "TRASH_FOLDER_ID", "heliumService"];
	var _moment = __webpack_require__(18);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _paragraph = __webpack_require__(161);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').controller('NotebookCtrl', NotebookCtrl);
	
	function NotebookCtrl($scope, $route, $routeParams, $location, $rootScope, $http, websocketMsgSrv, baseUrlSrv, $timeout, saveAsService, ngToast, noteActionService, noteVarShareService, TRASH_FOLDER_ID, heliumService) {
	  'ngInject';
	
	  ngToast.dismiss();
	
	  $scope.note = null;
	  $scope.actionOnFormSelectionChange = true;
	  $scope.savingPermissions = false;
	  $scope.loadingPermissions = false;
	  $scope.hideForms = false;
	  $scope.disableForms = false;
	  $scope.editorToggled = false;
	  $scope.tableToggled = false;
	  $scope.viewOnly = false;
	  $scope.showSetting = false;
	  $scope.usersAndRoles = [];
	  $scope.showRevisionsComparator = false;
	  $scope.looknfeelOption = ['default', 'simple', 'report'];
	  $scope.noteFormTitle = null;
	  $scope.cronOption = [{ name: 'None', value: undefined }, { name: '1m', value: '0 0/1 * * * ?' }, { name: '5m', value: '0 0/5 * * * ?' }, { name: '1h', value: '0 0 0/1 * * ?' }, { name: '3h', value: '0 0 0/3 * * ?' }, { name: '6h', value: '0 0 0/6 * * ?' }, { name: '12h', value: '0 0 0/12 * * ?' }, { name: '1d', value: '0 0 0 * * ?' }];
	
	  $scope.formatRevisionDate = function (date) {
	    return _moment2.default.unix(date).format('MMMM Do YYYY, h:mm a');
	  };
	
	  $scope.interpreterSettings = [];
	  $scope.interpreterBindings = [];
	  $scope.isNoteDirty = null;
	  $scope.saveTimer = null;
	  $scope.paragraphWarningDialog = {};
	
	  var connectedOnce = false;
	  var isRevisionPath = function isRevisionPath(path) {
	    var pattern = new RegExp('^.*\/notebook\/[a-zA-Z0-9_]*\/revision\/[a-zA-Z0-9_]*');
	    return pattern.test(path);
	  };
	
	  $scope.noteRevisions = [];
	  $scope.currentRevision = 'Head';
	  $scope.revisionView = isRevisionPath($location.path());
	
	  $scope.search = {
	    searchText: '',
	    occurrencesExists: false,
	    needHighlightFirst: false,
	    occurrencesHidden: false,
	    replaceText: '',
	    needToSendNextOccurrenceAfterReplace: false,
	    occurrencesCount: 0,
	    currentOccurrence: 0,
	    searchBoxOpened: false,
	    searchBoxWidth: 350,
	    left: '0px'
	  };
	  var currentSearchParagraph = 0;
	
	  $scope.$watch('note', function (value) {
	    var title = void 0;
	    if (value) {
	      title = value.name.substr(value.name.lastIndexOf('/') + 1, value.name.length);
	      title += ' - Magpie';
	    } else {
	      title = 'Silectis | Magpie';
	    }
	    $rootScope.pageTitle = title;
	  }, true);
	
	  $scope.$on('setConnectedStatus', function (event, param) {
	    if (connectedOnce && param) {
	      initNotebook();
	    }
	    connectedOnce = true;
	  });
	
	  $scope.getCronOptionNameFromValue = function (value) {
	    if (!value) {
	      return '';
	    }
	
	    for (var o in $scope.cronOption) {
	      if ($scope.cronOption[o].value === value) {
	        return $scope.cronOption[o].name;
	      }
	    }
	    return value;
	  };
	
	  $scope.blockAnonUsers = function () {
	    var zeppelinVersion = $rootScope.zeppelinVersion;
	    var url = 'https://zeppelin.apache.org/docs/' + zeppelinVersion + '/security/notebook_authorization.html';
	    var content = 'Only authenticated user can set the permission.' + '<a data-toggle="tooltip" data-placement="top" title="Learn more" target="_blank" href=' + url + '>' + '<i class="icon-question" />' + '</a>';
	    BootstrapDialog.show({
	      closable: false,
	      closeByBackdrop: false,
	      closeByKeyboard: false,
	      title: 'No permission',
	      message: content,
	      buttons: [{
	        label: 'Close',
	        action: function action(dialog) {
	          dialog.close();
	        }
	      }]
	    });
	  };
	
	  /** Init the new controller */
	  var initNotebook = function initNotebook() {
	    if ($routeParams.revisionId) {
	      websocketMsgSrv.getNoteByRevision($routeParams.noteId, $routeParams.revisionId);
	    } else {
	      websocketMsgSrv.getNote($routeParams.noteId);
	    }
	    websocketMsgSrv.listRevisionHistory($routeParams.noteId);
	    var currentRoute = $route.current;
	    if (currentRoute) {
	      setTimeout(function () {
	        var routeParams = currentRoute.params;
	        var $id = angular.element('#' + routeParams.paragraph + '_container');
	
	        if ($id.length > 0) {
	          // adjust for navbar
	          var top = $id.offset().top - 103;
	          angular.element('html, body').scrollTo({ top: top, left: 0 });
	        }
	      }, 1000);
	    }
	  };
	
	  initNotebook();
	
	  $scope.focusParagraphOnClick = function (clickEvent) {
	    if (!$scope.note) {
	      return;
	    }
	    for (var i = 0; i < $scope.note.paragraphs.length; i++) {
	      var paragraphId = $scope.note.paragraphs[i].id;
	      if (jQuery.contains(angular.element('#' + paragraphId + '_container')[0], clickEvent.target)) {
	        $scope.$broadcast('focusParagraph', paragraphId, 0, null, true);
	        break;
	      }
	    }
	  };
	
	  // register mouseevent handler for focus paragraph
	  document.addEventListener('click', $scope.focusParagraphOnClick);
	
	  var keyboardShortcut = function keyboardShortcut(keyEvent) {
	    // handle keyevent
	    if (!$scope.viewOnly && !$scope.revisionView) {
	      $scope.$broadcast('keyEvent', keyEvent);
	    }
	  };
	
	  $scope.keydownEvent = function (keyEvent) {
	    if ((keyEvent.ctrlKey || keyEvent.metaKey) && String.fromCharCode(keyEvent.which).toLowerCase() === 's') {
	      keyEvent.preventDefault();
	    }
	
	    keyboardShortcut(keyEvent);
	  };
	
	  // register mouseevent handler for focus paragraph
	  document.addEventListener('keydown', $scope.keydownEvent);
	
	  $scope.paragraphOnDoubleClick = function (paragraphId) {
	    $scope.$broadcast('doubleClickParagraph', paragraphId);
	  };
	
	  // Move the note to trash and go back to the main page
	  $scope.moveNoteToTrash = function (noteId) {
	    noteActionService.moveNoteToTrash(noteId, true);
	  };
	
	  // Remove the note permanently if it's in the trash
	  $scope.removeNote = function (noteId) {
	    noteActionService.removeNote(noteId, true);
	  };
	
	  $scope.isTrash = function (note) {
	    return note ? note.name.split('/')[0] === TRASH_FOLDER_ID : false;
	  };
	
	  // Export notebook
	  $scope.exportNote = function () {
	    var jsonContent = JSON.stringify($scope.note);
	    saveAsService.saveAs(jsonContent, $scope.note.name, 'json');
	  };
	
	  // Clone note
	  $scope.cloneNote = function (noteId) {
	    BootstrapDialog.confirm({
	      closable: true,
	      title: '',
	      message: 'Do you want to clone this note?',
	      callback: function callback(result) {
	        if (result) {
	          websocketMsgSrv.cloneNote(noteId);
	          $location.path('/');
	        }
	      }
	    });
	  };
	
	  // checkpoint/commit notebook
	  $scope.checkpointNote = function (commitMessage) {
	    BootstrapDialog.confirm({
	      closable: true,
	      title: '',
	      message: 'Commit note to current repository?',
	      callback: function callback(result) {
	        if (result) {
	          websocketMsgSrv.checkpointNote($routeParams.noteId, commitMessage);
	        }
	      }
	    });
	    document.getElementById('note.checkpoint.message').value = '';
	  };
	
	  // set notebook head to given revision
	  $scope.setNoteRevision = function () {
	    BootstrapDialog.confirm({
	      closable: true,
	      title: '',
	      message: 'Set notebook head to current revision?',
	      callback: function callback(result) {
	        if (result) {
	          websocketMsgSrv.setNoteRevision($routeParams.noteId, $routeParams.revisionId);
	        }
	      }
	    });
	  };
	
	  $scope.preVisibleRevisionsComparator = function () {
	    $scope.mergeNoteRevisionsForCompare = null;
	    $scope.firstNoteRevisionForCompare = null;
	    $scope.secondNoteRevisionForCompare = null;
	    $scope.currentFirstRevisionForCompare = 'Choose...';
	    $scope.currentSecondRevisionForCompare = 'Choose...';
	    $scope.$apply();
	  };
	
	  $scope.$on('listRevisionHistory', function (event, data) {
	    console.debug('received list of revisions %o', data);
	    $scope.noteRevisions = data.revisionList;
	    if ($scope.noteRevisions) {
	      if ($scope.noteRevisions.length === 0 || $scope.noteRevisions[0].id !== 'Head') {
	        $scope.noteRevisions.splice(0, 0, {
	          id: 'Head',
	          message: 'Head'
	        });
	      }
	      if ($routeParams.revisionId) {
	        var index = _.findIndex($scope.noteRevisions, { 'id': $routeParams.revisionId });
	        if (index > -1) {
	          $scope.currentRevision = $scope.noteRevisions[index].message;
	        }
	      }
	    }
	  });
	
	  $scope.$on('noteRevision', function (event, data) {
	    console.log('received note revision %o', data);
	    if (data.note) {
	      $scope.note = data.note;
	      initializeLookAndFeel();
	    } else {
	      $location.path('/');
	    }
	  });
	
	  $scope.$on('setNoteRevisionResult', function (event, data) {
	    console.log('received set note revision result %o', data);
	    if (data.status) {
	      $location.path('/notebook/' + $routeParams.noteId);
	    }
	  });
	
	  $scope.visitRevision = function (revision) {
	    if (revision.id) {
	      if (revision.id === 'Head') {
	        $location.path('/notebook/' + $routeParams.noteId);
	      } else {
	        $location.path('/notebook/' + $routeParams.noteId + '/revision/' + revision.id);
	      }
	    } else {
	      ngToast.danger({ content: 'There is a problem with this Revision',
	        verticalPosition: 'top',
	        dismissOnTimeout: false
	      });
	    }
	  };
	
	  $scope.runAllParagraphs = function (noteId) {
	    BootstrapDialog.confirm({
	      closable: true,
	      title: '',
	      message: 'Run all paragraphs?',
	      callback: function callback(result) {
	        if (result) {
	          var paragraphs = $scope.note.paragraphs.map(function (p) {
	            return {
	              id: p.id,
	              title: p.title,
	              paragraph: p.text,
	              config: p.config,
	              params: p.settings.params
	            };
	          });
	          websocketMsgSrv.runAllParagraphs(noteId, paragraphs);
	        }
	      }
	    });
	  };
	
	  $scope.saveNote = function () {
	    if ($scope.note && $scope.note.paragraphs) {
	      _.forEach($scope.note.paragraphs, function (par) {
	        angular.element('#' + par.id + '_paragraphColumn_main').scope().saveParagraph(par);
	      });
	      $scope.isNoteDirty = null;
	    }
	  };
	
	  $scope.clearAllParagraphOutput = function (noteId) {
	    noteActionService.clearAllParagraphOutput(noteId);
	  };
	
	  $scope.toggleAllEditor = function () {
	    if ($scope.editorToggled) {
	      $scope.$broadcast('openEditor');
	    } else {
	      $scope.$broadcast('closeEditor');
	    }
	    $scope.editorToggled = !$scope.editorToggled;
	  };
	
	  $scope.showAllEditor = function () {
	    $scope.$broadcast('openEditor');
	  };
	
	  $scope.hideAllEditor = function () {
	    $scope.$broadcast('closeEditor');
	  };
	
	  $scope.toggleAllTable = function () {
	    if ($scope.tableToggled) {
	      $scope.$broadcast('openTable');
	    } else {
	      $scope.$broadcast('closeTable');
	    }
	    $scope.tableToggled = !$scope.tableToggled;
	  };
	
	  $scope.showAllTable = function () {
	    $scope.$broadcast('openTable');
	  };
	
	  $scope.hideAllTable = function () {
	    $scope.$broadcast('closeTable');
	  };
	
	  /**
	   * @returns {boolean} true if one more paragraphs are running. otherwise return false.
	   */
	  $scope.isNoteRunning = function () {
	    if (!$scope.note) {
	      return false;
	    }
	
	    for (var i = 0; i < $scope.note.paragraphs.length; i++) {
	      if ((0, _paragraph.isParagraphRunning)($scope.note.paragraphs[i])) {
	        return true;
	      }
	    }
	
	    return false;
	  };
	
	  $scope.killSaveTimer = function () {
	    if ($scope.saveTimer) {
	      $timeout.cancel($scope.saveTimer);
	      $scope.saveTimer = null;
	    }
	  };
	
	  $scope.startSaveTimer = function () {
	    $scope.killSaveTimer();
	    $scope.isNoteDirty = true;
	    // console.log('startSaveTimer called ' + $scope.note.id);
	    $scope.saveTimer = $timeout(function () {
	      $scope.saveNote();
	    }, 10000);
	  };
	
	  $scope.setLookAndFeel = function (looknfeel) {
	    $scope.note.config.looknfeel = looknfeel;
	    if ($scope.revisionView === true) {
	      $rootScope.$broadcast('setLookAndFeel', $scope.note.config.looknfeel);
	    } else {
	      $scope.setConfig();
	    }
	  };
	
	  $scope.setNoteFormTitle = function (noteFormTitle) {
	    $scope.note.config.noteFormTitle = noteFormTitle;
	    $scope.setConfig();
	  };
	
	  /** Set cron expression for this note **/
	  $scope.setCronScheduler = function (cronExpr) {
	    if (cronExpr) {
	      if (!$scope.note.config.cronExecutingUser) {
	        $scope.note.config.cronExecutingUser = $rootScope.ticket.principal;
	      }
	      if (!$scope.note.config.cronExecutingRoles) {
	        $scope.note.config.cronExecutingRoles = $rootScope.ticket.roles;
	      }
	    } else {
	      $scope.note.config.cronExecutingUser = '';
	      $scope.note.config.cronExecutingRoles = '';
	    }
	    $scope.note.config.cron = cronExpr;
	    $scope.setConfig();
	  };
	
	  /** Set release resource for this note **/
	  $scope.setReleaseResource = function (value) {
	    $scope.note.config.releaseresource = value;
	    $scope.setConfig();
	  };
	
	  /** Update note config **/
	  $scope.setConfig = function (config) {
	    if (config) {
	      $scope.note.config = config;
	    }
	    websocketMsgSrv.updateNote($scope.note.id, $scope.note.name, $scope.note.config);
	  };
	
	  /** Update the note name */
	  $scope.updateNoteName = function (newName) {
	    var trimmedNewName = newName.trim();
	    if (trimmedNewName.length > 0 && $scope.note.name !== trimmedNewName) {
	      $scope.note.name = trimmedNewName;
	      websocketMsgSrv.renameNote($scope.note.id, $scope.note.name);
	    }
	  };
	
	  var initializeLookAndFeel = function initializeLookAndFeel() {
	    if (!$scope.note.config.looknfeel) {
	      $scope.note.config.looknfeel = 'default';
	    } else {
	      $scope.viewOnly = $scope.note.config.looknfeel === 'report' ? true : false;
	    }
	
	    if ($scope.note.paragraphs && $scope.note.paragraphs[0]) {
	      $scope.note.paragraphs[0].focus = true;
	    }
	    $rootScope.$broadcast('setLookAndFeel', $scope.note.config.looknfeel);
	  };
	
	  var cleanParagraphExcept = function cleanParagraphExcept(paragraphId, note) {
	    var noteCopy = {};
	    noteCopy.id = note.id;
	    noteCopy.name = note.name;
	    noteCopy.config = note.config;
	    noteCopy.info = note.info;
	    noteCopy.paragraphs = [];
	    for (var i = 0; i < note.paragraphs.length; i++) {
	      if (note.paragraphs[i].id === paragraphId) {
	        noteCopy.paragraphs[0] = note.paragraphs[i];
	        if (!noteCopy.paragraphs[0].config) {
	          noteCopy.paragraphs[0].config = {};
	        }
	        noteCopy.paragraphs[0].config.editorHide = true;
	        noteCopy.paragraphs[0].config.tableHide = false;
	        break;
	      }
	    }
	    return noteCopy;
	  };
	
	  var addPara = function addPara(paragraph, index) {
	    $scope.note.paragraphs.splice(index, 0, paragraph);
	    $scope.note.paragraphs.map(function (para) {
	      if (para.id === paragraph.id) {
	        para.focus = true;
	
	        // we need `$timeout` since angular DOM might not be initialized
	        $timeout(function () {
	          $scope.$broadcast('focusParagraph', para.id, 0, null, false);
	        });
	      }
	    });
	  };
	
	  var removePara = function removePara(paragraphId) {
	    var removeIdx = void 0;
	    _.each($scope.note.paragraphs, function (para, idx) {
	      if (para.id === paragraphId) {
	        removeIdx = idx;
	      }
	    });
	    return $scope.note.paragraphs.splice(removeIdx, 1);
	  };
	
	  $scope.$on('addParagraph', function (event, paragraph, index) {
	    if ($scope.paragraphUrl || $scope.revisionView === true) {
	      return;
	    }
	    addPara(paragraph, index);
	  });
	
	  $scope.$on('removeParagraph', function (event, paragraphId) {
	    if ($scope.paragraphUrl || $scope.revisionView === true) {
	      return;
	    }
	    removePara(paragraphId);
	  });
	
	  $scope.$on('moveParagraph', function (event, paragraphId, newIdx) {
	    if ($scope.revisionView === true) {
	      return;
	    }
	    var removedPara = removePara(paragraphId);
	    if (removedPara && removedPara.length === 1) {
	      addPara(removedPara[0], newIdx);
	    }
	  });
	
	  $scope.$on('updateNote', function (event, name, config, info) {
	    /** update Note name */
	    if (name !== $scope.note.name) {
	      console.log('change note name to : %o', $scope.note.name);
	      $scope.note.name = name;
	    }
	    $scope.note.config = config;
	    $scope.note.info = info;
	    initializeLookAndFeel();
	  });
	
	  var getInterpreterBindings = function getInterpreterBindings() {
	    websocketMsgSrv.getInterpreterBindings($scope.note.id);
	  };
	
	  $scope.$on('interpreterBindings', function (event, data) {
	    $scope.interpreterBindings = data.interpreterBindings;
	    $scope.interpreterBindingsOrig = angular.copy($scope.interpreterBindings); // to check dirty
	
	    var selected = false;
	    var key = void 0;
	    var setting = void 0;
	
	    for (key in $scope.interpreterBindings) {
	      if ($scope.interpreterBindings.hasOwnProperty(key)) {
	        setting = $scope.interpreterBindings[key];
	        if (setting.selected) {
	          selected = true;
	          break;
	        }
	      }
	    }
	
	    if (!selected) {
	      // make default selection
	      var selectedIntp = {};
	      for (key in $scope.interpreterBindings) {
	        if ($scope.interpreterBindings.hasOwnProperty(key)) {
	          setting = $scope.interpreterBindings[key];
	          if (!selectedIntp[setting.name]) {
	            setting.selected = true;
	            selectedIntp[setting.name] = true;
	          }
	        }
	      }
	      $scope.showSetting = true;
	    }
	  });
	
	  $scope.interpreterSelectionListeners = {
	    accept: function accept(sourceItemHandleScope, destSortableScope) {
	      return true;
	    },
	    itemMoved: function itemMoved(event) {},
	    orderChanged: function orderChanged(event) {}
	  };
	
	  $scope.closeAdditionalBoards = function () {
	    $scope.closeSetting();
	    $scope.closePermissions();
	    $scope.closeRevisionsComparator();
	  };
	
	  $scope.openSetting = function () {
	    $scope.showSetting = true;
	    getInterpreterBindings();
	  };
	
	  $scope.closeSetting = function () {
	    if (isSettingDirty()) {
	      BootstrapDialog.confirm({
	        closable: true,
	        title: '',
	        message: 'Interpreter setting changes will be discarded.',
	        callback: function callback(result) {
	          if (result) {
	            $scope.$apply(function () {
	              $scope.showSetting = false;
	            });
	          }
	        }
	      });
	    } else {
	      $scope.showSetting = false;
	    }
	  };
	
	  $scope.saveSetting = function () {
	    var selectedSettingIds = [];
	    for (var no in $scope.interpreterBindings) {
	      if ($scope.interpreterBindings.hasOwnProperty(no)) {
	        var setting = $scope.interpreterBindings[no];
	        if (setting.selected) {
	          selectedSettingIds.push(setting.id);
	        }
	      }
	    }
	    websocketMsgSrv.saveInterpreterBindings($scope.note.id, selectedSettingIds);
	    console.log('Interpreter bindings %o saved', selectedSettingIds);
	
	    _.forEach($scope.note.paragraphs, function (n, key) {
	      var regExp = /^\s*%/g;
	      if (n.text && !regExp.exec(n.text)) {
	        $scope.$broadcast('saveInterpreterBindings', n.id);
	      }
	    });
	
	    $scope.showSetting = false;
	  };
	
	  $scope.toggleSetting = function () {
	    if ($scope.showSetting) {
	      $scope.closeSetting();
	    } else {
	      $scope.closeAdditionalBoards();
	      $scope.openSetting();
	      angular.element('html, body').animate({ scrollTop: 0 }, 'slow');
	    }
	  };
	
	  $scope.openRevisionsComparator = function () {
	    $scope.showRevisionsComparator = true;
	  };
	
	  $scope.closeRevisionsComparator = function () {
	    $scope.showRevisionsComparator = false;
	  };
	
	  $scope.toggleRevisionsComparator = function () {
	    if ($scope.showRevisionsComparator) {
	      $scope.closeRevisionsComparator();
	    } else {
	      $scope.closeAdditionalBoards();
	      $scope.openRevisionsComparator();
	      angular.element('html, body').animate({ scrollTop: 0 }, 'slow');
	    }
	  };
	
	  var getUsersAndRoles = function getUsersAndRoles() {
	    $http.get(baseUrlSrv.getRestApiBase() + '/magpie/principals').success(function (data, status, headers, config) {
	      var allUsers = data.users;
	      var allRoles = data.roles;
	      var results = [];
	
	      if (allUsers.length !== 0) {
	        var users = [];
	        for (var i = 0; i < allUsers.length; i++) {
	          users.push({
	            'id': allUsers[i],
	            'text': allUsers[i]
	          });
	        }
	        results.push({
	          'text': 'Users :',
	          'children': users
	        });
	      }
	      if (allRoles.length !== 0) {
	        var roles = [];
	        for (var j = 0; j < allRoles.length; j++) {
	          roles.push({
	            'id': allRoles[j],
	            'text': allRoles[j]
	          });
	        }
	        results.push({
	          'text': 'Roles :',
	          'children': roles
	        });
	        $scope.usersAndRoles = results;
	      }
	    }).error(function (data, status, headers, config) {
	      if (status !== 0) {
	        console.log('Error %o %o', status, data.message);
	      }
	      $scope.usersAndRoles = [];
	    });
	  };
	
	  var getPermissions = function getPermissions(callback) {
	    $http.get(baseUrlSrv.getRestApiBase() + '/notebook/' + $scope.note.id + '/permissions').success(function (data, status, headers, config) {
	      $scope.permissions = data.body;
	      $scope.permissionsOrig = angular.copy($scope.permissions); // to check dirty
	
	      var selectJson = {
	        tokenSeparators: [',', ' '],
	        data: $scope.usersAndRoles,
	        width: ' ',
	        tags: true,
	        minimumInputLength: 1
	      };
	
	      $scope.setIamOwner();
	      angular.element('#selectOwners').select2(selectJson);
	      angular.element('#selectReaders').select2(selectJson);
	      angular.element('#selectRunners').select2(selectJson);
	      angular.element('#selectWriters').select2(selectJson);
	      if (callback) {
	        callback();
	      }
	      $scope.loadingPermissions = false;
	    }).error(function (data, status, headers, config) {
	      if (status !== 0) {
	        console.log('Error %o %o', status, data.message);
	      }
	      $scope.loadingPermissions = false;
	    });
	  };
	
	  $scope.openPermissions = function () {
	    $scope.loadingPermissions = true;
	    $scope.savingPermissions = false;
	    $scope.showPermissions = true;
	    getUsersAndRoles();
	    getPermissions();
	  };
	
	  $scope.closePermissions = function () {
	    if (isPermissionsDirty()) {
	      BootstrapDialog.confirm({
	        closable: true,
	        title: '',
	        message: 'Changes will be discarded.',
	        callback: function callback(result) {
	          if (result) {
	            $scope.$apply(function () {
	              $scope.savingPermissions = false;
	              $scope.showPermissions = false;
	            });
	          }
	        }
	      });
	    } else {
	      $scope.savingPermissions = false;
	      $scope.showPermissions = false;
	    }
	  };
	
	  function convertPermissionsToArray() {
	    $scope.permissions.owners = angular.element('#selectOwners').val();
	    $scope.permissions.readers = angular.element('#selectReaders').val();
	    $scope.permissions.runners = angular.element('#selectRunners').val();
	    $scope.permissions.writers = angular.element('#selectWriters').val();
	    angular.element('.permissionsForm select').find('option:not([is-select2="false"])').remove();
	  }
	
	  $scope.hasMatches = function () {
	    return $scope.search.occurrencesCount > 0;
	  };
	
	  var markAllOccurrences = function markAllOccurrences() {
	    $scope.search.occurrencesCount = 0;
	    $scope.search.occurrencesHidden = false;
	    currentSearchParagraph = 0;
	    $scope.$broadcast('markAllOccurrences', $scope.search.searchText);
	    $scope.search.currentOccurrence = $scope.search.occurrencesCount > 0 ? 1 : 0;
	  };
	
	  $scope.markAllOccurrencesAndHighlightFirst = function () {
	    $scope.search.needHighlightFirst = true;
	    markAllOccurrences();
	  };
	
	  var increaseCurrentOccurence = function increaseCurrentOccurence() {
	    ++$scope.search.currentOccurrence;
	    if ($scope.search.currentOccurrence > $scope.search.occurrencesCount) {
	      $scope.search.currentOccurrence = 1;
	    }
	  };
	
	  var decreaseCurrentOccurence = function decreaseCurrentOccurence() {
	    --$scope.search.currentOccurrence;
	    if ($scope.search.currentOccurrence === 0) {
	      $scope.search.currentOccurrence = $scope.search.occurrencesCount;
	    }
	  };
	
	  var sendNextOccurrenceMessage = function sendNextOccurrenceMessage() {
	    if ($scope.search.occurrencesCount === 0) {
	      markAllOccurrences();
	      if ($scope.search.occurrencesCount === 0) {
	        return;
	      }
	    }
	    if ($scope.search.occurrencesHidden) {
	      markAllOccurrences();
	    }
	    $scope.$broadcast('nextOccurrence', $scope.note.paragraphs[currentSearchParagraph].id);
	  };
	
	  var sendPrevOccurrenceMessage = function sendPrevOccurrenceMessage() {
	    if ($scope.search.occurrencesCount === 0) {
	      markAllOccurrences();
	      if ($scope.search.occurrencesCount === 0) {
	        return;
	      }
	    }
	    if ($scope.search.occurrencesHidden) {
	      markAllOccurrences();
	      currentSearchParagraph = $scope.note.paragraphs.length - 1;
	    }
	    $scope.$broadcast('prevOccurrence', $scope.note.paragraphs[currentSearchParagraph].id);
	  };
	
	  var increaseCurrentSearchParagraph = function increaseCurrentSearchParagraph() {
	    ++currentSearchParagraph;
	    if (currentSearchParagraph >= $scope.note.paragraphs.length) {
	      currentSearchParagraph = 0;
	    }
	  };
	
	  var decreaseCurrentSearchParagraph = function decreaseCurrentSearchParagraph() {
	    --currentSearchParagraph;
	    if (currentSearchParagraph === -1) {
	      currentSearchParagraph = $scope.note.paragraphs.length - 1;
	    }
	  };
	
	  $scope.$on('occurrencesExists', function (event, count) {
	    $scope.search.occurrencesCount += count;
	    if ($scope.search.needHighlightFirst) {
	      sendNextOccurrenceMessage();
	      $scope.search.needHighlightFirst = false;
	    }
	  });
	
	  $scope.nextOccurrence = function () {
	    sendNextOccurrenceMessage();
	    increaseCurrentOccurence();
	  };
	
	  $scope.$on('noNextOccurrence', function (event) {
	    increaseCurrentSearchParagraph();
	    sendNextOccurrenceMessage();
	  });
	
	  $scope.prevOccurrence = function () {
	    sendPrevOccurrenceMessage();
	    decreaseCurrentOccurence();
	  };
	
	  $scope.$on('noPrevOccurrence', function (event) {
	    decreaseCurrentSearchParagraph();
	    sendPrevOccurrenceMessage();
	  });
	
	  $scope.$on('editorClicked', function () {
	    $scope.search.occurrencesHidden = true;
	    $scope.$broadcast('unmarkAll');
	  });
	
	  $scope.replace = function () {
	    if ($scope.search.occurrencesCount === 0) {
	      $scope.markAllOccurrencesAndHighlightFirst();
	      if ($scope.search.occurrencesCount === 0) {
	        return;
	      }
	    }
	    if ($scope.search.occurrencesHidden) {
	      $scope.markAllOccurrencesAndHighlightFirst();
	      return;
	    }
	    $scope.$broadcast('replaceCurrent', $scope.search.searchText, $scope.search.replaceText);
	    if ($scope.search.needToSendNextOccurrenceAfterReplace) {
	      sendNextOccurrenceMessage();
	      $scope.search.needToSendNextOccurrenceAfterReplace = false;
	    }
	  };
	
	  $scope.$on('occurrencesCountChanged', function (event, cnt) {
	    $scope.search.occurrencesCount += cnt;
	    if ($scope.search.occurrencesCount === 0) {
	      $scope.search.currentOccurrence = 0;
	    } else {
	      $scope.search.currentOccurrence += cnt + 1;
	      if ($scope.search.currentOccurrence > $scope.search.occurrencesCount) {
	        $scope.search.currentOccurrence = 1;
	      }
	    }
	  });
	
	  $scope.replaceAll = function () {
	    if ($scope.search.occurrencesCount === 0) {
	      return;
	    }
	    if ($scope.search.occurrencesHidden) {
	      $scope.markAllOccurrencesAndHighlightFirst();
	    }
	    $scope.$broadcast('replaceAll', $scope.search.searchText, $scope.search.replaceText);
	    $scope.markAllOccurrencesAndHighlightFirst();
	  };
	
	  $scope.$on('noNextOccurrenceAfterReplace', function () {
	    $scope.search.occurrencesCount = 0;
	    $scope.search.needHighlightFirst = false;
	    $scope.search.needToSendNextOccurrenceAfterReplace = false;
	    $scope.$broadcast('checkOccurrences');
	    increaseCurrentSearchParagraph();
	    if ($scope.search.occurrencesCount > 0) {
	      $scope.search.needToSendNextOccurrenceAfterReplace = true;
	    }
	  });
	
	  $scope.onPressOnFindInput = function (event) {
	    if (event.keyCode === 13) {
	      $scope.nextOccurrence();
	    }
	  };
	
	  var makeSearchBoxVisible = function makeSearchBoxVisible() {
	    if ($scope.search.searchBoxOpened) {
	      $scope.search.searchBoxOpened = false;
	      console.log('make 0');
	      $scope.search.left = '0px';
	    } else {
	      $scope.search.searchBoxOpened = true;
	      var searchGroupRect = angular.element('#searchGroup')[0].getBoundingClientRect();
	      console.log('make visible');
	      var dropdownRight = searchGroupRect.left + $scope.search.searchBoxWidth;
	      console.log(dropdownRight + ' ' + window.innerWidth);
	      if (dropdownRight + 5 > window.innerWidth) {
	        $scope.search.left = window.innerWidth - dropdownRight - 15 + 'px';
	      }
	    }
	  };
	
	  $scope.searchClicked = function () {
	    makeSearchBoxVisible();
	  };
	
	  $scope.$on('toggleSearchBox', function () {
	    var elem = angular.element('#searchGroup');
	    if ($scope.search.searchBoxOpened) {
	      elem.removeClass('open');
	    } else {
	      elem.addClass('open');
	    }
	    $timeout(makeSearchBoxVisible());
	  });
	
	  $scope.restartInterpreter = function (interpreter) {
	    var thisConfirm = BootstrapDialog.confirm({
	      closable: false,
	      closeByBackdrop: false,
	      closeByKeyboard: false,
	      title: '',
	      message: 'Do you want to restart ' + _.escape(interpreter.name) + ' interpreter?',
	      callback: function callback(result) {
	        if (result) {
	          var payload = {
	            'noteId': $scope.note.id
	          };
	
	          thisConfirm.$modalFooter.find('button').addClass('disabled');
	          thisConfirm.$modalFooter.find('button:contains("OK")').html('<i class="fa fa-circle-o-notch fa-spin"></i> Saving Setting');
	
	          $http.put(baseUrlSrv.getRestApiBase() + '/interpreter/setting/restart/' + interpreter.id, payload).success(function (data, status, headers, config) {
	            var index = _.findIndex($scope.interpreterSettings, { 'id': interpreter.id });
	            $scope.interpreterSettings[index] = data.body;
	            thisConfirm.close();
	          }).error(function (data, status, headers, config) {
	            thisConfirm.close();
	            console.log('Error %o %o', status, data.message);
	            BootstrapDialog.show({
	              title: 'Error restart interpreter.',
	              message: _.escape(data.message)
	            });
	          });
	          return false;
	        }
	      }
	    });
	  };
	
	  $scope.savePermissions = function () {
	    $scope.savingPermissions = true;
	    if ($scope.isAnonymous || $rootScope.ticket.principal.trim().length === 0) {
	      $scope.blockAnonUsers();
	    }
	    convertPermissionsToArray();
	    if ($scope.isOwnerEmpty()) {
	      BootstrapDialog.show({
	        closable: false,
	        title: 'Setting Owners Permissions',
	        message: 'Please fill the [Owners] field. If not, it will set as current user.\n\n' + 'Current user : [ ' + _.escape($rootScope.ticket.principal) + ']',
	        buttons: [{
	          label: 'Set',
	          action: function action(dialog) {
	            dialog.close();
	            $scope.permissions.owners = [$rootScope.ticket.principal];
	            $scope.setPermissions();
	          }
	        }, {
	          label: 'Cancel',
	          action: function action(dialog) {
	            dialog.close();
	            $scope.openPermissions();
	          }
	        }]
	      });
	    } else {
	      $scope.setPermissions();
	    }
	  };
	
	  $scope.setPermissions = function () {
	    $http.put(baseUrlSrv.getRestApiBase() + '/notebook/' + $scope.note.id + '/permissions', $scope.permissions, { withCredentials: true }).success(function (data, status, headers, config) {
	      getPermissions(function () {
	        console.log('Note permissions %o saved', $scope.permissions);
	        $scope.savingPermissions = false;
	        $scope.showPermissions = false;
	      });
	    }).error(function (data, status, headers, config) {
	      console.log('Error %o %o', status, data.message);
	      $scope.savingPermissions = false;
	      BootstrapDialog.show({
	        closable: false,
	        closeByBackdrop: false,
	        closeByKeyboard: false,
	        title: 'Insufficient privileges',
	        message: _.escape(data.message),
	        buttons: [{
	          label: 'Login',
	          action: function action(dialog) {
	            dialog.close();
	            angular.element('#loginModal').modal({
	              show: 'true'
	            });
	          }
	        }, {
	          label: 'Cancel',
	          action: function action(dialog) {
	            dialog.close();
	            $location.path('/');
	          }
	        }]
	      });
	    });
	  };
	
	  $scope.togglePermissions = function () {
	    var principal = $rootScope.ticket.principal;
	    $scope.isAnonymous = principal === 'anonymous' ? true : false;
	    if (!!principal && $scope.isAnonymous) {
	      $scope.blockAnonUsers();
	    } else {
	      if ($scope.showPermissions) {
	        $scope.closePermissions();
	        angular.element('#selectOwners').select2({});
	        angular.element('#selectReaders').select2({});
	        angular.element('#selectRunners').select2({});
	        angular.element('#selectWriters').select2({});
	      } else {
	        $scope.closeAdditionalBoards();
	        $scope.openPermissions();
	      }
	    }
	  };
	
	  $scope.setIamOwner = function () {
	    var owners = $scope.permissions.owners.concat(['notebook_admin']);
	
	    // owner if there are no owners, or the principal is an owner, or any roles intersect
	    $scope.isOwner = owners.length === 0 || _.includes(owners, $rootScope.ticket.principal) || $rootScope.hasAnyRole(owners);
	  };
	
	  $scope.toggleNotePersonalizedMode = function () {
	    var personalizedMode = $scope.note.config.personalizedMode;
	    if ($scope.isOwner) {
	      BootstrapDialog.confirm({
	        closable: true,
	        title: 'Setting the result display',
	        message: function message(dialog) {
	          var modeText = $scope.note.config.personalizedMode === 'true' ? 'collaborate' : 'personalize';
	          return 'Do you want to <span class="text-info">' + modeText + '</span> your analysis?';
	        },
	        callback: function callback(result) {
	          if (result) {
	            if ($scope.note.config.personalizedMode === undefined) {
	              $scope.note.config.personalizedMode = 'false';
	            }
	            $scope.note.config.personalizedMode = personalizedMode === 'true' ? 'false' : 'true';
	            websocketMsgSrv.updatePersonalizedMode($scope.note.id, $scope.note.config.personalizedMode);
	          }
	        }
	      });
	    }
	  };
	
	  var isSettingDirty = function isSettingDirty() {
	    if (angular.equals($scope.interpreterBindings, $scope.interpreterBindingsOrig)) {
	      return false;
	    } else {
	      return true;
	    }
	  };
	
	  var isPermissionsDirty = function isPermissionsDirty() {
	    if (angular.equals($scope.permissions, $scope.permissionsOrig)) {
	      return false;
	    } else {
	      return true;
	    }
	  };
	
	  angular.element(document).click(function () {
	    angular.element('.ace_autocomplete').hide();
	  });
	
	  $scope.isOwnerEmpty = function () {
	    if ($scope.permissions.owners.length > 0) {
	      for (var i = 0; i < $scope.permissions.owners.length; i++) {
	        if ($scope.permissions.owners[i].trim().length > 0) {
	          return false;
	        } else if (i === $scope.permissions.owners.length - 1) {
	          return true;
	        }
	      }
	    } else {
	      return true;
	    }
	  };
	
	  /*
	   ** $scope.$on functions below
	   */
	
	  $scope.$on('runAllAbove', function (event, paragraph, isNeedConfirm) {
	    var allParagraphs = $scope.note.paragraphs;
	    var toRunParagraphs = [];
	
	    for (var i = 0; allParagraphs[i] !== paragraph; i++) {
	      if (i === allParagraphs.length - 1) {
	        return;
	      } // if paragraph not in array of all paragraphs
	      toRunParagraphs.push(allParagraphs[i]);
	    }
	
	    var paragraphs = toRunParagraphs.map(function (p) {
	      return {
	        id: p.id,
	        title: p.title,
	        paragraph: p.text,
	        config: p.config,
	        params: p.settings.params
	      };
	    });
	
	    if (!isNeedConfirm) {
	      websocketMsgSrv.runAllParagraphs($scope.note.id, paragraphs);
	    } else {
	      BootstrapDialog.confirm({
	        closable: true,
	        title: '',
	        message: 'Run all above?',
	        callback: function callback(result) {
	          if (result) {
	            websocketMsgSrv.runAllParagraphs($scope.note.id, paragraphs);
	          }
	        }
	      });
	    }
	
	    $scope.saveCursorPosition(paragraph);
	  });
	
	  $scope.$on('runAllBelowAndCurrent', function (event, paragraph, isNeedConfirm) {
	    var allParagraphs = $scope.note.paragraphs;
	    var toRunParagraphs = [];
	
	    for (var i = allParagraphs.length - 1; allParagraphs[i] !== paragraph; i--) {
	      if (i < 0) {
	        return;
	      } // if paragraph not in array of all paragraphs
	      toRunParagraphs.push(allParagraphs[i]);
	    }
	
	    toRunParagraphs.push(paragraph);
	    toRunParagraphs.reverse();
	
	    var paragraphs = toRunParagraphs.map(function (p) {
	      return {
	        id: p.id,
	        title: p.title,
	        paragraph: p.text,
	        config: p.config,
	        params: p.settings.params
	      };
	    });
	
	    if (!isNeedConfirm) {
	      websocketMsgSrv.runAllParagraphs($scope.note.id, paragraphs);
	    } else {
	      BootstrapDialog.confirm({
	        closable: true,
	        title: '',
	        message: 'Run current and all below?',
	        callback: function callback(result) {
	          if (result) {
	            websocketMsgSrv.runAllParagraphs($scope.note.id, paragraphs);
	          }
	        }
	      });
	    }
	
	    $scope.saveCursorPosition(paragraph);
	  });
	
	  $scope.saveCursorPosition = function (paragraph) {
	    var angParagEditor = angular.element('#' + paragraph.id + '_paragraphColumn_main').scope().editor;
	    var col = angParagEditor.selection.lead.column;
	    var row = angParagEditor.selection.lead.row;
	    $scope.$broadcast('focusParagraph', paragraph.id, row + 1, col);
	  };
	
	  $scope.$on('moveParagraphUp', function (event, paragraph) {
	    var newIndex = -1;
	    for (var i = 0; i < $scope.note.paragraphs.length; i++) {
	      if ($scope.note.paragraphs[i].id === paragraph.id) {
	        newIndex = i - 1;
	        break;
	      }
	    }
	    if (newIndex < 0 || newIndex >= $scope.note.paragraphs.length) {
	      return;
	    }
	    // save dirtyText of moving paragraphs.
	    var prevParagraph = $scope.note.paragraphs[newIndex];
	    angular.element('#' + paragraph.id + '_paragraphColumn_main').scope().saveParagraph(paragraph);
	    angular.element('#' + prevParagraph.id + '_paragraphColumn_main').scope().saveParagraph(prevParagraph);
	    websocketMsgSrv.moveParagraph(paragraph.id, newIndex);
	  });
	
	  $scope.$on('moveParagraphDown', function (event, paragraph) {
	    var newIndex = -1;
	    for (var i = 0; i < $scope.note.paragraphs.length; i++) {
	      if ($scope.note.paragraphs[i].id === paragraph.id) {
	        newIndex = i + 1;
	        break;
	      }
	    }
	
	    if (newIndex < 0 || newIndex >= $scope.note.paragraphs.length) {
	      return;
	    }
	    // save dirtyText of moving paragraphs.
	    var nextParagraph = $scope.note.paragraphs[newIndex];
	    angular.element('#' + paragraph.id + '_paragraphColumn_main').scope().saveParagraph(paragraph);
	    angular.element('#' + nextParagraph.id + '_paragraphColumn_main').scope().saveParagraph(nextParagraph);
	    websocketMsgSrv.moveParagraph(paragraph.id, newIndex);
	  });
	
	  $scope.$on('moveFocusToPreviousParagraph', function (event, currentParagraphId) {
	    var focus = false;
	    for (var i = $scope.note.paragraphs.length - 1; i >= 0; i--) {
	      if (focus === false) {
	        if ($scope.note.paragraphs[i].id === currentParagraphId) {
	          focus = true;
	          continue;
	        }
	      } else {
	        $scope.$broadcast('focusParagraph', $scope.note.paragraphs[i].id, -1);
	        break;
	      }
	    }
	  });
	
	  $scope.$on('moveFocusToNextParagraph', function (event, currentParagraphId) {
	    var focus = false;
	    for (var i = 0; i < $scope.note.paragraphs.length; i++) {
	      if (focus === false) {
	        if ($scope.note.paragraphs[i].id === currentParagraphId) {
	          focus = true;
	          continue;
	        }
	      } else {
	        $scope.$broadcast('focusParagraph', $scope.note.paragraphs[i].id, 0);
	        break;
	      }
	    }
	  });
	
	  $scope.$on('insertParagraph', function (event, paragraphId, position) {
	    if ($scope.revisionView === true) {
	      return;
	    }
	    var newIndex = -1;
	    for (var i = 0; i < $scope.note.paragraphs.length; i++) {
	      if ($scope.note.paragraphs[i].id === paragraphId) {
	        // determine position of where to add new paragraph; default is below
	        if (position === 'above') {
	          newIndex = i;
	        } else {
	          newIndex = i + 1;
	        }
	        break;
	      }
	    }
	
	    if (newIndex < 0 || newIndex > $scope.note.paragraphs.length) {
	      return;
	    }
	    websocketMsgSrv.insertParagraph(newIndex);
	  });
	
	  $scope.$on('setNoteContent', function (event, note) {
	    noteVarShareService.clear();
	    if (note === undefined) {
	      $location.path('/');
	    }
	
	    $scope.note = note;
	
	    $scope.paragraphUrl = $routeParams.paragraphId;
	    $scope.asIframe = $routeParams.asIframe;
	    if ($scope.paragraphUrl) {
	      $scope.note = cleanParagraphExcept($scope.paragraphUrl, $scope.note);
	      $scope.$broadcast('$unBindKeyEvent', $scope.$unBindKeyEvent);
	      $rootScope.$broadcast('setIframe', $scope.asIframe);
	      initializeLookAndFeel();
	      return;
	    }
	
	    initializeLookAndFeel();
	
	    // open interpreter binding setting when there're none selected
	    getInterpreterBindings();
	    getPermissions();
	    var isPersonalized = $scope.note.config.personalizedMode;
	    isPersonalized = isPersonalized === undefined ? 'false' : isPersonalized;
	    $scope.note.config.personalizedMode = isPersonalized;
	  });
	
	  $scope.$on('$routeChangeStart', function (event, next, current) {
	    if (!$scope.note || !$scope.note.paragraphs) {
	      return;
	    }
	    if ($scope.note && $scope.note.paragraphs) {
	      $scope.note.paragraphs.map(function (par) {
	        if ($scope.allowLeave === true) {
	          return;
	        }
	        var thisScope = angular.element('#' + par.id + '_paragraphColumn_main').scope();
	
	        if (thisScope.dirtyText === undefined || thisScope.originalText === undefined || thisScope.dirtyText === thisScope.originalText) {
	          return true;
	        } else {
	          event.preventDefault();
	          $scope.showParagraphWarning(next);
	        }
	      });
	    }
	  });
	
	  $scope.showParagraphWarning = function (next) {
	    if ($scope.paragraphWarningDialog.opened !== true) {
	      $scope.paragraphWarningDialog = BootstrapDialog.show({
	        closable: false,
	        closeByBackdrop: false,
	        closeByKeyboard: false,
	        title: 'Do you want to leave this site?',
	        message: 'Changes that you have made will not be saved.',
	        buttons: [{
	          label: 'Stay',
	          action: function action(dialog) {
	            dialog.close();
	          }
	        }, {
	          label: 'Leave',
	          action: function action(dialog) {
	            dialog.close();
	            var locationToRedirect = next['$$route']['originalPath'];
	            Object.keys(next.pathParams).map(function (key) {
	              locationToRedirect = locationToRedirect.replace(':' + key, next.pathParams[key]);
	            });
	            $scope.allowLeave = true;
	            $location.path(locationToRedirect);
	          }
	        }]
	      });
	    }
	  };
	
	  $scope.$on('saveNoteForms', function (event, data) {
	    $scope.note.noteForms = data.formsData.forms;
	    $scope.note.noteParams = data.formsData.params;
	  });
	
	  $scope.isShowNoteForms = function () {
	    if ($scope.note && !_.isEmpty($scope.note.noteForms) && !$scope.paragraphUrl) {
	      return true;
	    }
	    return false;
	  };
	
	  $scope.saveNoteForms = function () {
	    websocketMsgSrv.saveNoteForms($scope.note);
	  };
	
	  $scope.removeNoteForms = function (formName) {
	    websocketMsgSrv.removeNoteForms($scope.note, formName);
	  };
	
	  $scope.$on('$destroy', function () {
	    angular.element(window).off('beforeunload');
	    $scope.killSaveTimer();
	    $scope.saveNote();
	
	    document.removeEventListener('click', $scope.focusParagraphOnClick);
	    document.removeEventListener('keydown', $scope.keyboardShortcut);
	  });
	
	  $scope.$on('$unBindKeyEvent', function () {
	    document.removeEventListener('click', $scope.focusParagraphOnClick);
	    document.removeEventListener('keydown', $scope.keyboardShortcut);
	  });
	
	  angular.element(window).bind('resize', function () {
	    var actionbarHeight = document.getElementById('actionbar').lastElementChild.clientHeight;
	    angular.element(document.getElementById('content')).css('padding-top', actionbarHeight - 20);
	  });
	}

/***/ }),
/* 161 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isParagraphRunning = isParagraphRunning;
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	var ParagraphStatus = exports.ParagraphStatus = {
	  READY: 'READY',
	  PENDING: 'PENDING',
	  RUNNING: 'RUNNING',
	  FINISHED: 'FINISHED',
	  ABORT: 'ABORT',
	  ERROR: 'ERROR'
	};
	
	function isParagraphRunning(paragraph) {
	  if (!paragraph) {
	    return false;
	  }
	  var status = paragraph.status;
	  if (!status) {
	    return false;
	  }
	
	  return status === ParagraphStatus.PENDING || status === ParagraphStatus.RUNNING;
	}

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dataset = __webpack_require__(163);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * Create table data object from paragraph table type result
	 */
	var TableData = function (_Dataset) {
	  _inherits(TableData, _Dataset);
	
	  function TableData(columns, rows, comment) {
	    _classCallCheck(this, TableData);
	
	    var _this = _possibleConstructorReturn(this, (TableData.__proto__ || Object.getPrototypeOf(TableData)).call(this));
	
	    _this.columns = columns || [];
	    _this.rows = rows || [];
	    _this.comment = comment || '';
	    return _this;
	  }
	
	  _createClass(TableData, [{
	    key: 'loadParagraphResult',
	    value: function loadParagraphResult(paragraphResult) {
	      if (!paragraphResult || paragraphResult.type !== _dataset.DatasetType.TABLE) {
	        console.warn('Can not load paragraph result');
	        return;
	      }
	
	      var columns = [];
	      var rows = [];
	      var textRows = paragraphResult.msg.split('\n');
	      var comment = '';
	      var commentRow = false;
	
	      var hasTypes = false;
	
	      if (textRows.length > 1) {
	        var expected = ['string', 'boolean', 'number', 'date', 'object'];
	        var types = textRows[1].split('\t');
	        hasTypes = _.all(types, function (t) {
	          return _.includes(expected, t);
	        });
	      }
	
	      for (var i = 0; i < textRows.length; i++) {
	        var textRow = textRows[i];
	
	        if (commentRow) {
	          comment += textRow;
	          continue;
	        }
	
	        if (textRow === '' || textRow === '<!--TABLE_COMMENT-->') {
	          if (rows.length > 0) {
	            commentRow = true;
	          }
	          continue;
	        }
	
	        var textCols = textRow.split('\t');
	        var row = [];
	        for (var j = 0; j < textCols.length; j++) {
	          var col = textCols[j];
	          if (i === 0) {
	            columns.push({ name: col, index: j, aggr: 'sum', type: 'string' });
	          } else if (i === 1 && hasTypes) {
	            if (col === 'number') {
	              columns[j].type = 'numberStr';
	            } else {
	              columns[j].type = col;
	            }
	          } else {
	            row.push(col);
	          }
	        }
	
	        if (i > 1 || !hasTypes && i > 0) {
	          rows.push(row);
	        }
	      }
	      this.comment = comment;
	      this.columns = columns;
	      this.rows = rows;
	    }
	  }]);
	
	  return TableData;
	}(_dataset.Dataset);
	
	exports.default = TableData;

/***/ }),
/* 163 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/**
	 * The abstract dataset rapresentation
	 */
	var Dataset = function () {
	  function Dataset() {
	    _classCallCheck(this, Dataset);
	  }
	
	  _createClass(Dataset, [{
	    key: 'loadParagraphResult',
	
	    /**
	     * Load the paragraph result, every Dataset implementation must override this method
	     * where is contained the business rules to convert the paragraphResult object to the related dataset type
	     */
	    value: function loadParagraphResult(paragraphResult) {
	      // override this
	    }
	  }]);
	
	  return Dataset;
	}();
	
	/**
	 * Dataset types
	 */
	
	
	var DatasetType = Object.freeze({
	  NETWORK: 'NETWORK',
	  TABLE: 'TABLE'
	});
	
	exports.Dataset = Dataset;
	exports.DatasetType = DatasetType;

/***/ }),
/* 164 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/**
	 * Base class for visualization
	 */
	var Transformation = function () {
	  function Transformation(config) {
	    _classCallCheck(this, Transformation);
	
	    this.config = config;
	    this._emitter = function () {};
	  }
	
	  /**
	   * return {
	   *   template : angular template string or url (url should end with .html),
	   *   scope : an object to bind to template scope
	   * }
	   */
	
	
	  _createClass(Transformation, [{
	    key: 'getSetting',
	    value: function getSetting() {}
	    // override this
	
	
	    /**
	     * Method will be invoked when tableData or config changes
	     */
	
	  }, {
	    key: 'transform',
	    value: function transform(tableData) {}
	    // override this
	
	
	    /**
	     * render setting
	     */
	
	  }, {
	    key: 'renderSetting',
	    value: function renderSetting(targetEl) {
	      var setting = this.getSetting();
	      if (!setting) {
	        return;
	      }
	
	      // already readered
	      if (this._scope) {
	        var self = this;
	        this._scope.$apply(function () {
	          for (var k in setting.scope) {
	            if (setting.scope.hasOwnProperty(k)) {
	              self._scope[k] = setting.scope[k];
	            }
	          }
	
	          for (var _k in self._prevSettingScope) {
	            if (!setting.scope[_k]) {
	              self._scope[_k] = setting.scope[_k];
	            }
	          }
	        });
	        return;
	      } else {
	        this._prevSettingScope = setting.scope;
	      }
	
	      var scope = this._createNewScope();
	      for (var k in setting.scope) {
	        if (setting.scope.hasOwnProperty(k)) {
	          scope[k] = setting.scope[k];
	        }
	      }
	      var template = setting.template;
	
	      if (template.split('\n').length === 1 && template.endsWith('.html')) {
	        // template is url
	        var _self = this;
	        this._templateRequest(template).then(function (t) {
	          _self._render(targetEl, t, scope);
	        });
	      } else {
	        this._render(targetEl, template, scope);
	      }
	    }
	  }, {
	    key: '_render',
	    value: function _render(targetEl, template, scope) {
	      this._targetEl = targetEl;
	      targetEl.html(template);
	      this._compile(targetEl.contents())(scope);
	      this._scope = scope;
	    }
	  }, {
	    key: 'setConfig',
	    value: function setConfig(config) {
	      this.config = config;
	    }
	
	    /**
	     * Emit config. config will sent to server and saved.
	     */
	
	  }, {
	    key: 'emitConfig',
	    value: function emitConfig(config) {
	      this._emitter(config);
	    }
	  }]);
	
	  return Transformation;
	}();
	
	exports.default = Transformation;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformation = __webpack_require__(164);
	
	var _transformation2 = _interopRequireDefault(_transformation);
	
	var _visualizationUtil = __webpack_require__(166);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	/**
	 * pivot table data and return d3 chart data
	 */
	var PivotTransformation = function (_Transformation) {
	  _inherits(PivotTransformation, _Transformation);
	
	  // eslint-disable-next-line no-useless-constructor
	  function PivotTransformation(config, chartType) {
	    _classCallCheck(this, PivotTransformation);
	
	    var _this = _possibleConstructorReturn(this, (PivotTransformation.__proto__ || Object.getPrototypeOf(PivotTransformation)).call(this, config));
	
	    _this.chartType = chartType;
	    return _this;
	  }
	
	  _createClass(PivotTransformation, [{
	    key: 'getSetting',
	    value: function getSetting() {
	      var self = this;
	
	      var configObj = self.config;
	      console.log('getSetting', configObj);
	      return {
	        template: 'app/tabledata/pivot_settings.html',
	        scope: {
	          config: configObj.common.pivot,
	          tableDataColumns: self.tableDataColumns,
	          chartType: self.chartType,
	          save: function save() {
	            self.emitConfig(configObj);
	          },
	          removeKey: function removeKey(idx) {
	            configObj.common.pivot.keys.splice(idx, 1);
	            self.emitConfig(configObj);
	          },
	          removeGroup: function removeGroup(idx) {
	            configObj.common.pivot.groups.splice(idx, 1);
	            self.emitConfig(configObj);
	          },
	          removeValue: function removeValue(idx) {
	            configObj.common.pivot.values.splice(idx, 1);
	            self.emitConfig(configObj);
	          },
	          setValueAggr: function setValueAggr(idx, aggr) {
	            configObj.common.pivot.values[idx].aggr = aggr;
	            self.emitConfig(configObj);
	          }
	        }
	      };
	    }
	
	    /**
	     * Method will be invoked when tableData or config changes
	     */
	
	  }, {
	    key: 'transform',
	    value: function transform(tableData) {
	      this.tableDataColumns = tableData.columns;
	      this.config.common = this.config.common || {};
	      this.config.common.pivot = this.config.common.pivot || {};
	      var config = this.config.common.pivot;
	      var firstTime = !config.keys && !config.groups && !config.values;
	
	      config.keys = config.keys || [];
	      config.groups = config.groups || [];
	      config.values = config.values || [];
	
	      this.removeUnknown();
	      if (firstTime) {
	        this.selectDefault();
	      }
	      return this.pivot(tableData, config.keys, config.groups, config.values);
	    }
	  }, {
	    key: 'removeUnknown',
	    value: function removeUnknown() {
	      var config = this.config.common.pivot;
	      var tableDataColumns = this.tableDataColumns;
	      var unique = function unique(list) {
	        for (var i = 0; i < list.length; i++) {
	          for (var j = i + 1; j < list.length; j++) {
	            if (angular.equals(list[i], list[j])) {
	              list.splice(j, 1);
	              j--;
	            }
	          }
	        }
	      };
	
	      var removeUnknown = function removeUnknown(list) {
	        for (var i = 0; i < list.length; i++) {
	          // remove non existing column
	          var found = false;
	          for (var j = 0; j < tableDataColumns.length; j++) {
	            var a = list[i];
	            var b = tableDataColumns[j];
	            if (a.index === b.index && a.name === b.name) {
	              found = true;
	              break;
	            }
	          }
	          if (!found) {
	            list.splice(i, 1);
	          }
	        }
	      };
	
	      unique(config.keys);
	      removeUnknown(config.keys);
	      unique(config.groups);
	      removeUnknown(config.groups);
	      removeUnknown(config.values);
	    }
	  }, {
	    key: 'selectDefault',
	    value: function selectDefault() {
	      var config = this.config.common.pivot;
	      if (config.keys.length === 0 && config.groups.length === 0 && config.values.length === 0) {
	        if (config.keys.length === 0 && this.tableDataColumns.length > 0) {
	          config.keys.push(this.tableDataColumns[0]);
	        }
	
	        if (config.values.length === 0 && this.tableDataColumns.length > 1) {
	          config.values.push(this.tableDataColumns[1]);
	        }
	      }
	    }
	  }, {
	    key: 'pivot',
	    value: function pivot(data, keys, groups, values) {
	      var isNumeric = function isNumeric(value) {
	        return _.isNumber(value) && !_.isNaN(value);
	      };
	
	      var toNumeric = function toNumeric(value) {
	        var num = (0, _visualizationUtil.toNumber)(value);
	        // eslint-disable-next-line valid-typeof
	        if (typeof num === 'bigint') {
	          return Number.NaN;
	        } else {
	          return num;
	        }
	      };
	
	      var createAggregateFunction = function createAggregateFunction(aggregate, defaultValue) {
	        return function (a, b) {
	          if (!isNumeric(a) && !isNumeric(b)) {
	            return defaultValue;
	          } else if (!isNumeric(a)) {
	            return b;
	          } else if (!isNumeric(b)) {
	            return a;
	          } else {
	            return aggregate(a, b);
	          }
	        };
	      };
	
	      var aggrFunc = {
	        sum: createAggregateFunction(function (a, b) {
	          return a + b;
	        }, 0),
	        count: function count(a, b) {
	          var varA = isNumeric(a) ? a : 0;
	          var varB = isNumeric(b) ? 1 : 0;
	          return varA + varB;
	        },
	        min: createAggregateFunction(Math.min),
	        max: createAggregateFunction(Math.max),
	        avg: createAggregateFunction(function (a, b) {
	          return a + b;
	        })
	      };
	
	      var schema = {};
	      var rows = {};
	
	      for (var i = 0; i < data.rows.length; i++) {
	        var row = data.rows[i];
	        var s = schema;
	        var p = rows;
	
	        for (var k = 0; k < keys.length; k++) {
	          var key = keys[k];
	
	          // add key to schema
	          if (!s[key.name]) {
	            s[key.name] = {
	              order: k,
	              index: key.index,
	              type: 'key',
	              children: {}
	            };
	          }
	          s = s[key.name].children;
	
	          // add key to row
	          var keyKey = row[key.index];
	          if (!p[keyKey]) {
	            p[keyKey] = {};
	          }
	          p = p[keyKey];
	        }
	
	        for (var g = 0; g < groups.length; g++) {
	          var group = groups[g];
	          var groupKey = row[group.index];
	
	          // add group to schema
	          if (!s[groupKey]) {
	            s[groupKey] = {
	              order: g,
	              index: group.index,
	              type: 'group',
	              children: {}
	            };
	          }
	          s = s[groupKey].children;
	
	          // add key to row
	          if (!p[groupKey]) {
	            p[groupKey] = {};
	          }
	          p = p[groupKey];
	        }
	
	        for (var v = 0; v < values.length; v++) {
	          var value = values[v];
	          var valueKey = value.name + '(' + value.aggr + ')';
	
	          // add value to schema
	          if (!s[valueKey]) {
	            s[valueKey] = {
	              type: 'value',
	              order: v,
	              index: value.index
	            };
	          }
	
	          // add value to row
	          var rowRawValue = row[value.index];
	          var rowValue = isNumeric(rowRawValue) ? rowRawValue : toNumeric(rowRawValue);
	          var currentAggr = p[valueKey] || {
	            value: undefined,
	            count: 0
	          };
	
	          var newAggrValue = aggrFunc[value.aggr](currentAggr.value, rowValue);
	
	          var newAggrCount = void 0;
	          if (value.aggr !== 'avg') {
	            newAggrCount = 1;
	          } else {
	            newAggrCount = aggrFunc.count(currentAggr.count, rowValue);
	          }
	
	          p[valueKey] = {
	            value: newAggrValue,
	            count: newAggrCount
	          };
	        }
	      }
	
	      // console.log('schema=%o, rows=%o', schema, rows);
	      return {
	        keys: keys,
	        groups: groups,
	        values: values,
	        schema: schema,
	        rows: rows
	      };
	    }
	  }]);
	
	  return PivotTransformation;
	}(_transformation2.default);
	
	exports.default = PivotTransformation;

/***/ }),
/* 166 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.isInputWidget = isInputWidget;
	exports.isOptionWidget = isOptionWidget;
	exports.isCheckboxWidget = isCheckboxWidget;
	exports.isTextareaWidget = isTextareaWidget;
	exports.isBtnGroupWidget = isBtnGroupWidget;
	exports.resetTableOptionConfig = resetTableOptionConfig;
	exports.getTableColumnType = getTableColumnType;
	exports.toNumber = toNumber;
	exports.initializeTableConfig = initializeTableConfig;
	exports.parseTableOption = parseTableOption;
	exports.isColumnNameUpdated = isColumnNameUpdated;
	exports.updateColumnTypeState = updateColumnTypeState;
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	var Widget = exports.Widget = {
	  CHECKBOX: 'checkbox',
	  INPUT: 'input',
	  TEXTAREA: 'textarea',
	  OPTION: 'option',
	  BTN_GROUP: 'btn-group'
	};
	
	var ValueType = exports.ValueType = {
	  INT: 'int',
	  FLOAT: 'float',
	  BOOLEAN: 'boolean',
	  STRING: 'string',
	  JSON: 'JSON'
	};
	
	var TableColumnType = exports.TableColumnType = {
	  STRING: 'string',
	  BOOLEAN: 'boolean',
	  NUMBER: 'number',
	  DATE: 'date',
	  OBJECT: 'object',
	  NUMBER_STR: 'numberStr'
	};
	
	function isInputWidget(spec) {
	  return spec.widget === Widget.INPUT;
	}
	function isOptionWidget(spec) {
	  return spec.widget === Widget.OPTION;
	}
	function isCheckboxWidget(spec) {
	  return spec.widget === Widget.CHECKBOX;
	}
	function isTextareaWidget(spec) {
	  return spec.widget === Widget.TEXTAREA;
	}
	function isBtnGroupWidget(spec) {
	  return spec.widget === Widget.BTN_GROUP;
	}
	
	function resetTableOptionConfig(config) {
	  delete config.tableOptionSpecHash;
	  config.tableOptionSpecHash = {};
	  delete config.tableOptionValue;
	  config.tableOptionValue = {};
	  delete config.tableColumnTypeState.names;
	  config.tableColumnTypeState.names = {};
	  config.updated = false;
	  return config;
	}
	
	function getTableColumnType(type) {
	  switch (type) {
	    case TableColumnType.NUMBER_STR:
	      return TableColumnType.NUMBER_STR;
	    case TableColumnType.NUMBER:
	      return TableColumnType.NUMBER;
	    case TableColumnType.DATE:
	      return TableColumnType.DATE;
	    default:
	      // boolean, object, or string
	      return TableColumnType.STRING;
	  }
	}
	
	var isDigit = function isDigit(c) {
	  return c >= '0' && c <= '9' || c === '-';
	};
	
	function toBigInt(v) {
	  if (_.isUndefined(window.BigInt)) {
	    return Number.NaN;
	  } else {
	    // eslint-disable-next-line new-cap
	    return window.BigInt(v);
	  }
	}
	
	function toNumber(v) {
	  if (_.isString(v) && _.all(v, isDigit)) {
	    var int = parseInt(v, 10);
	    if (Number.isSafeInteger(int)) {
	      return int;
	    } else {
	      return toBigInt(v);
	    }
	  } else {
	    return parseFloat(v);
	  }
	}
	
	function initializeTableConfig(config, tableOptionSpecs) {
	  if (typeof config.tableOptionValue === 'undefined') {
	    config.tableOptionValue = {};
	  }
	  if (typeof config.tableGridState === 'undefined') {
	    config.tableGridState = {};
	  }
	  if (typeof config.tableColumnTypeState === 'undefined') {
	    config.tableColumnTypeState = {};
	  }
	
	  // should remove `$$hashKey` using angular.toJson
	  var newSpecHash = JSON.stringify(JSON.parse(angular.toJson(tableOptionSpecs)));
	  var previousSpecHash = config.tableOptionSpecHash;
	
	  // check whether spec is updated or not
	  if (typeof previousSpecHash === 'undefined' || previousSpecHash !== newSpecHash) {
	    resetTableOptionConfig(config);
	
	    config.tableOptionSpecHash = newSpecHash;
	    config.initialized = true;
	
	    // reset all persisted option values if spec is updated
	    for (var i = 0; i < tableOptionSpecs.length; i++) {
	      var option = tableOptionSpecs[i];
	      config.tableOptionValue[option.name] = option.defaultValue;
	    }
	  }
	
	  return config;
	}
	
	function parseTableOption(specs, persistedTableOption) {
	  /** copy original params */
	  var parsed = void 0;
	  try {
	    parsed = JSON.parse(JSON.stringify(persistedTableOption));
	  } catch (e) {
	    // if not able to parse fall back to default values coming from specs
	    parsed = {};
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = specs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var spec = _step.value;
	
	        parsed[spec['name']] = spec['defaultValue'];
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	  }
	
	  for (var i = 0; i < specs.length; i++) {
	    var s = specs[i];
	    var name = s.name;
	
	    if (s.valueType === ValueType.INT && typeof parsed[name] !== 'number') {
	      try {
	        parsed[name] = parseInt(parsed[name]);
	      } catch (error) {
	        parsed[name] = s.defaultValue;
	      }
	    } else if (s.valueType === ValueType.FLOAT && typeof parsed[name] !== 'number') {
	      try {
	        parsed[name] = parseFloat(parsed[name]);
	      } catch (error) {
	        parsed[name] = s.defaultValue;
	      }
	    } else if (s.valueType === ValueType.BOOLEAN) {
	      if (parsed[name] === 'false') {
	        parsed[name] = false;
	      } else if (parsed[name] === 'true') {
	        parsed[name] = true;
	      } else if (typeof parsed[name] !== 'boolean') {
	        parsed[name] = s.defaultValue;
	      }
	    } else if (s.valueType === ValueType.JSON) {
	      if (parsed[name] !== null && _typeof(parsed[name]) !== 'object') {
	        try {
	          parsed[name] = JSON.parse(parsed[name]);
	        } catch (error) {
	          parsed[name] = s.defaultValue;
	        }
	      } else if (parsed[name] === null) {
	        parsed[name] = s.defaultValue;
	      }
	    }
	  }
	
	  return parsed;
	}
	
	function isColumnNameUpdated(prevColumnNames, newColumnNames) {
	  if (typeof prevColumnNames === 'undefined') {
	    return true;
	  }
	
	  var columnNameUpdated = false;
	
	  for (var prevColName in prevColumnNames) {
	    if (!newColumnNames[prevColName]) {
	      return true;
	    }
	  }
	
	  if (!columnNameUpdated) {
	    for (var newColName in newColumnNames) {
	      if (!prevColumnNames[newColName]) {
	        return true;
	      }
	    }
	  }
	
	  return false;
	}
	
	function updateColumnTypeState(columns, config, columnDefs) {
	  var columnTypeState = config.tableColumnTypeState;
	
	  if (!columnTypeState) {
	    return;
	  }
	
	  // compare objects because order might be changed
	  var prevColumnNames = columnTypeState.names || {};
	  var newColumnNames = columns.reduce(function (acc, c, i) {
	    var prevColumnType = prevColumnNames[i];
	
	    // use previous column type if exists
	    if (prevColumnType) {
	      acc[i] = prevColumnType;
	    } else {
	      acc[i] = c.type;
	    }
	    return acc;
	  }, {});
	
	  var columnNameUpdated = isColumnNameUpdated(prevColumnNames, newColumnNames);
	
	  if (columnNameUpdated) {
	    columnTypeState.names = newColumnNames;
	    columnTypeState.updated = true;
	  }
	
	  // update `columnDefs[n].type`
	  for (var i = 0; i < columnDefs.length; i++) {
	    columnDefs[i].type = columnTypeState.names[i];
	  }
	}

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformation = __webpack_require__(164);
	
	var _transformation2 = _interopRequireDefault(_transformation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	/**
	 * passthough the data
	 */
	var PassthroughTransformation = function (_Transformation) {
	  _inherits(PassthroughTransformation, _Transformation);
	
	  // eslint-disable-next-line no-useless-constructor
	  function PassthroughTransformation(config) {
	    _classCallCheck(this, PassthroughTransformation);
	
	    return _possibleConstructorReturn(this, (PassthroughTransformation.__proto__ || Object.getPrototypeOf(PassthroughTransformation)).call(this, config));
	  }
	
	  /**
	   * Method will be invoked when tableData or config changes
	   */
	
	
	  _createClass(PassthroughTransformation, [{
	    key: 'transform',
	    value: function transform(tableData) {
	      return tableData;
	    }
	  }]);
	
	  return PassthroughTransformation;
	}(_transformation2.default);
	
	exports.default = PassthroughTransformation;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformation = __webpack_require__(164);
	
	var _transformation2 = _interopRequireDefault(_transformation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	/**
	 * select columns
	 * - columnSelectorProp
	 *   [
	 *     {
	 *       "name":
	 *       "tooltip":
	 *     },
	 *     ...
	 *   ]
	 */
	var ColumnselectorTransformation = function (_Transformation) {
	  _inherits(ColumnselectorTransformation, _Transformation);
	
	  function ColumnselectorTransformation(config, columnSelectorProp) {
	    _classCallCheck(this, ColumnselectorTransformation);
	
	    var _this = _possibleConstructorReturn(this, (ColumnselectorTransformation.__proto__ || Object.getPrototypeOf(ColumnselectorTransformation)).call(this, config));
	
	    _this.props = columnSelectorProp;
	    return _this;
	  }
	
	  _createClass(ColumnselectorTransformation, [{
	    key: 'getSetting',
	    value: function getSetting() {
	      var self = this;
	      var configObj = self.config;
	      return {
	        template: 'app/tabledata/columnselector_settings.html',
	        scope: {
	          config: self.config,
	          props: self.props,
	          tableDataColumns: self.tableDataColumns,
	          save: function save() {
	            self.emitConfig(configObj);
	          },
	          remove: function remove(selectorName) {
	            configObj[selectorName] = null;
	            self.emitConfig(configObj);
	          }
	        }
	      };
	    }
	
	    /**
	     * Method will be invoked when tableData or config changes
	     */
	
	  }, {
	    key: 'transform',
	    value: function transform(tableData) {
	      this.tableDataColumns = tableData.columns;
	      this.removeUnknown();
	      return tableData;
	    }
	  }, {
	    key: 'removeUnknown',
	    value: function removeUnknown() {
	      var fields = this.config;
	      for (var f in fields) {
	        if (fields[f]) {
	          var found = false;
	          for (var i = 0; i < this.tableDataColumns.length; i++) {
	            var a = fields[f];
	            var b = this.tableDataColumns[i];
	            if (a.index === b.index && a.name === b.name) {
	              found = true;
	              break;
	            }
	          }
	          if (!found && fields[f] instanceof Object && !(fields[f] instanceof Array)) {
	            fields[f] = null;
	          }
	        }
	      }
	    }
	  }]);
	
	  return ColumnselectorTransformation;
	}(_transformation2.default);
	
	exports.default = ColumnselectorTransformation;

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformation = __webpack_require__(164);
	
	var _transformation2 = _interopRequireDefault(_transformation);
	
	var _advancedTransformationUtil = __webpack_require__(170);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var SETTING_TEMPLATE = 'app/tabledata/advanced-transformation-setting.html';
	
	var AdvancedTransformation = function (_Transformation) {
	  _inherits(AdvancedTransformation, _Transformation);
	
	  function AdvancedTransformation(config, spec) {
	    _classCallCheck(this, AdvancedTransformation);
	
	    var _this = _possibleConstructorReturn(this, (AdvancedTransformation.__proto__ || Object.getPrototypeOf(AdvancedTransformation)).call(this, config));
	
	    _this.columns = []; /** [{ name, index, comment }] */
	    _this.props = {};
	    _this.spec = spec;
	
	    (0, _advancedTransformationUtil.initializeConfig)(config, spec);
	    return _this;
	  }
	
	  _createClass(AdvancedTransformation, [{
	    key: 'emitConfigChange',
	    value: function emitConfigChange(conf) {
	      conf.chartChanged = false;
	      conf.parameterChanged = false;
	      this.emitConfig(conf);
	    }
	  }, {
	    key: 'emitChartChange',
	    value: function emitChartChange(conf) {
	      conf.chartChanged = true;
	      conf.parameterChanged = false;
	      this.emitConfig(conf);
	    }
	  }, {
	    key: 'emitParameterChange',
	    value: function emitParameterChange(conf) {
	      conf.chartChanged = false;
	      conf.parameterChanged = true;
	      this.emitConfig(conf);
	    }
	  }, {
	    key: 'getSetting',
	    value: function getSetting() {
	      var self = this; /** for closure */
	      var configInstance = self.config; /** for closure */
	
	      if (self.spec.initialized) {
	        self.spec.initialized = false;
	        self.emitConfig(configInstance);
	      }
	
	      return {
	        template: SETTING_TEMPLATE,
	        scope: {
	          config: configInstance,
	          columns: self.columns,
	          resetAxisConfig: function resetAxisConfig() {
	            (0, _advancedTransformationUtil.resetAxisConfig)(configInstance);
	            self.emitChartChange(configInstance);
	          },
	
	          resetParameterConfig: function resetParameterConfig() {
	            (0, _advancedTransformationUtil.resetParameterConfig)(configInstance);
	            self.emitParameterChange(configInstance);
	          },
	
	          toggleColumnPanel: function toggleColumnPanel() {
	            configInstance.panel.columnPanelOpened = !configInstance.panel.columnPanelOpened;
	            self.emitConfigChange(configInstance);
	          },
	
	          toggleParameterPanel: function toggleParameterPanel() {
	            configInstance.panel.parameterPanelOpened = !configInstance.panel.parameterPanelOpened;
	            self.emitConfigChange(configInstance);
	          },
	
	          getAxisAnnotation: function getAxisAnnotation(axisSpec) {
	            var anno = '' + axisSpec.name;
	            if (axisSpec.valueType) {
	              anno = anno + ' (' + axisSpec.valueType + ')';
	            }
	
	            return anno;
	          },
	
	          getAxisTypeAnnotation: function getAxisTypeAnnotation(axisSpec) {
	            var anno = '';
	
	            var minAxisCount = axisSpec.minAxisCount;
	            var maxAxisCount = axisSpec.maxAxisCount;
	
	            if ((0, _advancedTransformationUtil.isSingleDimensionAxis)(axisSpec)) {
	              maxAxisCount = 1;
	            }
	
	            var comment = '';
	            if (minAxisCount) {
	              comment = 'min: ' + minAxisCount;
	            }
	            if (minAxisCount && maxAxisCount) {
	              comment = comment + ', ';
	            }
	            if (maxAxisCount) {
	              comment = comment + 'max: ' + maxAxisCount;
	            }
	
	            if (comment !== '') {
	              anno = anno + ' (' + comment + ')';
	            }
	
	            return anno;
	          },
	
	          getAxisAnnotationColor: function getAxisAnnotationColor(axisSpec) {
	            if ((0, _advancedTransformationUtil.isAggregatorAxis)(axisSpec)) {
	              return { 'background-color': '#5782bd' };
	            } else if ((0, _advancedTransformationUtil.isGroupAxis)(axisSpec)) {
	              return { 'background-color': '#cd5c5c' };
	            } else if ((0, _advancedTransformationUtil.isKeyAxis)(axisSpec)) {
	              return { 'background-color': '#906ebd' };
	            } else {
	              return { 'background-color': '#62bda9' };
	            }
	          },
	
	          useSharedAxis: function useSharedAxis(chartName) {
	            return (0, _advancedTransformationUtil.useSharedAxis)(configInstance, chartName);
	          },
	          isGroupAxis: function isGroupAxis(axisSpec) {
	            return (0, _advancedTransformationUtil.isGroupAxis)(axisSpec);
	          },
	          isKeyAxis: function isKeyAxis(axisSpec) {
	            return (0, _advancedTransformationUtil.isKeyAxis)(axisSpec);
	          },
	          isAggregatorAxis: function isAggregatorAxis(axisSpec) {
	            return (0, _advancedTransformationUtil.isAggregatorAxis)(axisSpec);
	          },
	          isSingleDimensionAxis: function isSingleDimensionAxis(axisSpec) {
	            return (0, _advancedTransformationUtil.isSingleDimensionAxis)(axisSpec);
	          },
	          getSingleDimensionAxis: function getSingleDimensionAxis(axisSpec) {
	            return (0, _advancedTransformationUtil.getCurrentChartAxis)(configInstance)[axisSpec.name];
	          },
	
	          chartChanged: function chartChanged(selected) {
	            configInstance.chart.current = selected;
	            self.emitChartChange(configInstance);
	          },
	
	          axisChanged: function axisChanged(e, ui, axisSpec) {
	            (0, _advancedTransformationUtil.removeDuplicatedColumnsInMultiDimensionAxis)(configInstance, axisSpec);
	            (0, _advancedTransformationUtil.applyMaxAxisCount)(configInstance, axisSpec);
	
	            self.emitChartChange(configInstance);
	          },
	
	          aggregatorChanged: function aggregatorChanged(colIndex, axisSpec, aggregator) {
	            if ((0, _advancedTransformationUtil.isSingleDimensionAxis)(axisSpec)) {
	              (0, _advancedTransformationUtil.getCurrentChartAxis)(configInstance)[axisSpec.name].aggr = aggregator;
	            } else {
	              (0, _advancedTransformationUtil.getCurrentChartAxis)(configInstance)[axisSpec.name][colIndex].aggr = aggregator;
	              (0, _advancedTransformationUtil.removeDuplicatedColumnsInMultiDimensionAxis)(configInstance, axisSpec);
	            }
	
	            self.emitChartChange(configInstance);
	          },
	
	          removeFromAxis: function removeFromAxis(colIndex, axisSpec) {
	            if ((0, _advancedTransformationUtil.isSingleDimensionAxis)(axisSpec)) {
	              (0, _advancedTransformationUtil.getCurrentChartAxis)(configInstance)[axisSpec.name] = null;
	            } else {
	              (0, _advancedTransformationUtil.getCurrentChartAxis)(configInstance)[axisSpec.name].splice(colIndex, 1);
	            }
	
	            self.emitChartChange(configInstance);
	          },
	
	          isInputWidget: function isInputWidget(paramSpec) {
	            return (0, _advancedTransformationUtil.isInputWidget)(paramSpec);
	          },
	          isCheckboxWidget: function isCheckboxWidget(paramSpec) {
	            return (0, _advancedTransformationUtil.isCheckboxWidget)(paramSpec);
	          },
	          isOptionWidget: function isOptionWidget(paramSpec) {
	            return (0, _advancedTransformationUtil.isOptionWidget)(paramSpec);
	          },
	          isTextareaWidget: function isTextareaWidget(paramSpec) {
	            return (0, _advancedTransformationUtil.isTextareaWidget)(paramSpec);
	          },
	
	          parameterChanged: function parameterChanged(paramSpec) {
	            configInstance.chartChanged = false;
	            configInstance.parameterChanged = true;
	            self.emitParameterChange(configInstance);
	          },
	
	          parameterOnKeyDown: function parameterOnKeyDown(event, paramSpec) {
	            var code = event.keyCode || event.which;
	            if (code === 13 && (0, _advancedTransformationUtil.isInputWidget)(paramSpec)) {
	              self.emitParameterChange(configInstance);
	            } else if (code === 13 && event.shiftKey && (0, _advancedTransformationUtil.isTextareaWidget)(paramSpec)) {
	              self.emitParameterChange(configInstance);
	            }
	
	            event.stopPropagation(); /** avoid to conflict with paragraph shortcuts */
	          }
	
	        }
	      };
	    }
	  }, {
	    key: 'transform',
	    value: function transform(tableData) {
	      this.columns = tableData.columns; /** used in `getSetting` */
	      /** initialize in `transform` instead of `getSetting` because this method is called before */
	      (0, _advancedTransformationUtil.serializeSharedAxes)(this.config);
	
	      var conf = this.config;
	      var chart = (0, _advancedTransformationUtil.getCurrentChart)(conf);
	      var axis = (0, _advancedTransformationUtil.getCurrentChartAxis)(conf);
	      var axisSpecs = (0, _advancedTransformationUtil.getCurrentChartAxisSpecs)(conf);
	      var param = (0, _advancedTransformationUtil.getCurrentChartParam)(conf);
	      var paramSpecs = (0, _advancedTransformationUtil.getCurrentChartParamSpecs)(conf);
	      var parsedParam = (0, _advancedTransformationUtil.parseParameter)(paramSpecs, param);
	
	      var _getTransformer = (0, _advancedTransformationUtil.getTransformer)(conf, tableData.rows, axisSpecs, axis),
	          transformer = _getTransformer.transformer,
	          column = _getTransformer.column;
	
	      return {
	        chartChanged: conf.chartChanged,
	        parameterChanged: conf.parameterChanged,
	
	        chart: chart, /** current chart */
	        axis: axis, /** persisted axis */
	        parameter: parsedParam, /** persisted parameter */
	        column: column,
	
	        transformer: transformer
	      };
	    }
	  }]);
	
	  return AdvancedTransformation;
	}(_transformation2.default);
	
	exports.default = AdvancedTransformation;

/***/ }),
/* 170 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.getCurrentChart = getCurrentChart;
	exports.getCurrentChartTransform = getCurrentChartTransform;
	exports.getCurrentChartAxis = getCurrentChartAxis;
	exports.getCurrentChartParam = getCurrentChartParam;
	exports.getCurrentChartAxisSpecs = getCurrentChartAxisSpecs;
	exports.getCurrentChartParamSpecs = getCurrentChartParamSpecs;
	exports.useSharedAxis = useSharedAxis;
	exports.serializeSharedAxes = serializeSharedAxes;
	exports.isInputWidget = isInputWidget;
	exports.isOptionWidget = isOptionWidget;
	exports.isCheckboxWidget = isCheckboxWidget;
	exports.isTextareaWidget = isTextareaWidget;
	exports.parseParameter = parseParameter;
	exports.isAggregatorAxis = isAggregatorAxis;
	exports.isGroupAxis = isGroupAxis;
	exports.isKeyAxis = isKeyAxis;
	exports.isSingleDimensionAxis = isSingleDimensionAxis;
	exports.getSpecs = getSpecs;
	exports.getAvailableChartNames = getAvailableChartNames;
	exports.applyMaxAxisCount = applyMaxAxisCount;
	exports.removeDuplicatedColumnsInMultiDimensionAxis = removeDuplicatedColumnsInMultiDimensionAxis;
	exports.clearAxisConfig = clearAxisConfig;
	exports.initAxisConfig = initAxisConfig;
	exports.resetAxisConfig = resetAxisConfig;
	exports.clearParameterConfig = clearParameterConfig;
	exports.initParameterConfig = initParameterConfig;
	exports.resetParameterConfig = resetParameterConfig;
	exports.getSpecVersion = getSpecVersion;
	exports.initializeConfig = initializeConfig;
	exports.getColumnsForMultipleAxes = getColumnsForMultipleAxes;
	exports.getColumnsFromAxis = getColumnsFromAxis;
	exports.getTransformer = getTransformer;
	exports.getKGACube = getKGACube;
	exports.getKAGCube = getKAGCube;
	exports.getKKGACube = getKKGACube;
	exports.getSelectorName = getSelectorName;
	exports.getCubeValue = getCubeValue;
	exports.getNameWithIndex = getNameWithIndex;
	exports.getArrayRowsFromKKGACube = getArrayRowsFromKKGACube;
	exports.fillSelectorRows = fillSelectorRows;
	exports.getArrayRowsFromKGACube = getArrayRowsFromKGACube;
	exports.fillArrayRow = fillArrayRow;
	exports.getObjectRowsFromKGACube = getObjectRowsFromKGACube;
	exports.getObjectRow = getObjectRow;
	exports.getDrilldownRowsFromKAGCube = getDrilldownRowsFromKAGCube;
	exports.fillDrillDownRow = fillDrillDownRow;
	exports.sortWithNumberSupport = sortWithNumberSupport;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	function getCurrentChart(config) {
	  return config.chart.current;
	}
	
	function getCurrentChartTransform(config) {
	  return config.spec.charts[getCurrentChart(config)].transform;
	}
	
	function getCurrentChartAxis(config) {
	  return config.axis[getCurrentChart(config)];
	}
	
	function getCurrentChartParam(config) {
	  return config.parameter[getCurrentChart(config)];
	}
	
	function getCurrentChartAxisSpecs(config) {
	  return config.axisSpecs[getCurrentChart(config)];
	}
	
	function getCurrentChartParamSpecs(config) {
	  return config.paramSpecs[getCurrentChart(config)];
	}
	
	function useSharedAxis(config, chart) {
	  return config.spec.charts[chart].sharedAxis;
	}
	
	function serializeSharedAxes(config) {
	  var availableCharts = getAvailableChartNames(config.spec.charts);
	  for (var i = 0; i < availableCharts.length; i++) {
	    var chartName = availableCharts[i];
	    if (useSharedAxis(config, chartName)) {
	      /** use reference :) in case of sharedAxis */
	      config.axis[chartName] = config.sharedAxis;
	    }
	  }
	}
	
	var Widget = exports.Widget = {
	  INPUT: 'input', /** default */
	  OPTION: 'option',
	  CHECKBOX: 'checkbox',
	  TEXTAREA: 'textarea'
	};
	
	function isInputWidget(paramSpec) {
	  return paramSpec && !paramSpec.widget || paramSpec && paramSpec.widget === Widget.INPUT;
	}
	
	function isOptionWidget(paramSpec) {
	  return paramSpec && paramSpec.widget === Widget.OPTION;
	}
	
	function isCheckboxWidget(paramSpec) {
	  return paramSpec && paramSpec.widget === Widget.CHECKBOX;
	}
	
	function isTextareaWidget(paramSpec) {
	  return paramSpec && paramSpec.widget === Widget.TEXTAREA;
	}
	
	var ParameterValueType = exports.ParameterValueType = {
	  INT: 'int',
	  FLOAT: 'float',
	  BOOLEAN: 'boolean',
	  STRING: 'string',
	  JSON: 'JSON'
	};
	
	function parseParameter(paramSpecs, param) {
	  /** copy original params */
	  var parsed = JSON.parse(JSON.stringify(param));
	
	  for (var i = 0; i < paramSpecs.length; i++) {
	    var paramSpec = paramSpecs[i];
	    var name = paramSpec.name;
	
	    if (paramSpec.valueType === ParameterValueType.INT && typeof parsed[name] !== 'number') {
	      try {
	        parsed[name] = parseInt(parsed[name]);
	      } catch (error) {
	        parsed[name] = paramSpec.defaultValue;
	      }
	    } else if (paramSpec.valueType === ParameterValueType.FLOAT && typeof parsed[name] !== 'number') {
	      try {
	        parsed[name] = parseFloat(parsed[name]);
	      } catch (error) {
	        parsed[name] = paramSpec.defaultValue;
	      }
	    } else if (paramSpec.valueType === ParameterValueType.BOOLEAN) {
	      if (parsed[name] === 'false') {
	        parsed[name] = false;
	      } else if (parsed[name] === 'true') {
	        parsed[name] = true;
	      } else if (typeof parsed[name] !== 'boolean') {
	        parsed[name] = paramSpec.defaultValue;
	      }
	    } else if (paramSpec.valueType === ParameterValueType.JSON) {
	      if (parsed[name] !== null && _typeof(parsed[name]) !== 'object') {
	        try {
	          parsed[name] = JSON.parse(parsed[name]);
	        } catch (error) {
	          parsed[name] = paramSpec.defaultValue;
	        }
	      } else if (parsed[name] === null) {
	        parsed[name] = paramSpec.defaultValue;
	      }
	    }
	  }
	
	  return parsed;
	}
	
	var AxisType = exports.AxisType = {
	  AGGREGATOR: 'aggregator',
	  KEY: 'key',
	  GROUP: 'group'
	};
	
	function isAggregatorAxis(axisSpec) {
	  return axisSpec && axisSpec.axisType === AxisType.AGGREGATOR;
	}
	function isGroupAxis(axisSpec) {
	  return axisSpec && axisSpec.axisType === AxisType.GROUP;
	}
	function isKeyAxis(axisSpec) {
	  return axisSpec && axisSpec.axisType === AxisType.KEY;
	}
	function isSingleDimensionAxis(axisSpec) {
	  return axisSpec && axisSpec.dimension === 'single';
	}
	
	/**
	 * before: { name: { ... } }
	 * after: [ { name, ... } ]
	 *
	 * add the `name` field while converting to array to easily manipulate
	 */
	function getSpecs(specObject) {
	  var specs = [];
	  for (var name in specObject) {
	    if (specObject.hasOwnProperty(name)) {
	      var singleSpec = specObject[name];
	      if (!singleSpec) {
	        continue;
	      }
	      singleSpec.name = name;
	      specs.push(singleSpec);
	    }
	  }
	
	  return specs;
	}
	
	function getAvailableChartNames(charts) {
	  var available = [];
	  for (var name in charts) {
	    if (charts.hasOwnProperty(name)) {
	      available.push(name);
	    }
	  }
	
	  return available;
	}
	
	function applyMaxAxisCount(config, axisSpec) {
	  if (isSingleDimensionAxis(axisSpec) || typeof axisSpec.maxAxisCount === 'undefined') {
	    return;
	  }
	
	  var columns = getCurrentChartAxis(config)[axisSpec.name];
	  if (columns.length <= axisSpec.maxAxisCount) {
	    return;
	  }
	
	  var sliced = columns.slice(1);
	  getCurrentChartAxis(config)[axisSpec.name] = sliced;
	}
	
	function removeDuplicatedColumnsInMultiDimensionAxis(config, axisSpec) {
	  if (isSingleDimensionAxis(axisSpec)) {
	    return config;
	  }
	
	  var columns = getCurrentChartAxis(config)[axisSpec.name];
	  var uniqObject = columns.reduce(function (acc, col) {
	    if (!acc[col.name + '(' + col.aggr + ')']) {
	      acc[col.name + '(' + col.aggr + ')'] = col;
	    }
	    return acc;
	  }, {});
	
	  var filtered = [];
	  for (var name in uniqObject) {
	    if (uniqObject.hasOwnProperty(name)) {
	      var col = uniqObject[name];
	      filtered.push(col);
	    }
	  }
	
	  getCurrentChartAxis(config)[axisSpec.name] = filtered;
	  return config;
	}
	
	function clearAxisConfig(config) {
	  delete config.axis; /** Object: persisted axis for each chart */
	  delete config.sharedAxis;
	}
	
	function initAxisConfig(config) {
	  if (!config.axis) {
	    config.axis = {};
	  }
	  if (!config.sharedAxis) {
	    config.sharedAxis = {};
	  }
	
	  var spec = config.spec;
	  var availableCharts = getAvailableChartNames(spec.charts);
	
	  if (!config.axisSpecs) {
	    config.axisSpecs = {};
	  }
	  for (var i = 0; i < availableCharts.length; i++) {
	    var chartName = availableCharts[i];
	
	    if (!config.axis[chartName]) {
	      config.axis[chartName] = {};
	    }
	    var axisSpecs = getSpecs(spec.charts[chartName].axis);
	    if (!config.axisSpecs[chartName]) {
	      config.axisSpecs[chartName] = axisSpecs;
	    }
	
	    /** initialize multi-dimension axes */
	    for (var _i = 0; _i < axisSpecs.length; _i++) {
	      var axisSpec = axisSpecs[_i];
	      if (isSingleDimensionAxis(axisSpec)) {
	        continue;
	      }
	
	      /** intentionally nested if-stmt is used because order of conditions matter here */
	      if (!useSharedAxis(config, chartName)) {
	        if (!Array.isArray(config.axis[chartName][axisSpec.name])) {
	          config.axis[chartName][axisSpec.name] = [];
	        }
	      } else if (useSharedAxis(config, chartName)) {
	        /**
	         * initialize multiple times even if shared axis because it's not that expensive, assuming that
	         * all charts using shared axis have the same axis specs
	         */
	        if (!Array.isArray(config.sharedAxis[axisSpec.name])) {
	          config.sharedAxis[axisSpec.name] = [];
	        }
	      }
	    }
	  }
	
	  /** this function should be called after initializing */
	  serializeSharedAxes(config);
	}
	
	function resetAxisConfig(config) {
	  clearAxisConfig(config);
	  initAxisConfig(config);
	}
	
	function clearParameterConfig(config) {
	  delete config.parameter; /** Object: persisted parameter for each chart */
	}
	
	function initParameterConfig(config) {
	  if (!config.parameter) {
	    config.parameter = {};
	  }
	
	  var spec = config.spec;
	  var availableCharts = getAvailableChartNames(spec.charts);
	
	  if (!config.paramSpecs) {
	    config.paramSpecs = {};
	  }
	  for (var i = 0; i < availableCharts.length; i++) {
	    var chartName = availableCharts[i];
	
	    if (!config.parameter[chartName]) {
	      config.parameter[chartName] = {};
	    }
	    var paramSpecs = getSpecs(spec.charts[chartName].parameter);
	    if (!config.paramSpecs[chartName]) {
	      config.paramSpecs[chartName] = paramSpecs;
	    }
	
	    for (var _i2 = 0; _i2 < paramSpecs.length; _i2++) {
	      var paramSpec = paramSpecs[_i2];
	      if (!config.parameter[chartName][paramSpec.name]) {
	        config.parameter[chartName][paramSpec.name] = paramSpec.defaultValue;
	      }
	    }
	  }
	}
	
	function resetParameterConfig(config) {
	  clearParameterConfig(config);
	  initParameterConfig(config);
	}
	
	function getSpecVersion(availableCharts, spec) {
	  var axisHash = {};
	  var paramHash = {};
	
	  for (var i = 0; i < availableCharts.length; i++) {
	    var chartName = availableCharts[i];
	    var axisSpecs = getSpecs(spec.charts[chartName].axis);
	    axisHash[chartName] = axisSpecs;
	
	    var paramSpecs = getSpecs(spec.charts[chartName].parameter);
	    paramHash[chartName] = paramSpecs;
	  }
	
	  return { axisVersion: JSON.stringify(axisHash), paramVersion: JSON.stringify(paramHash) };
	}
	
	function initializeConfig(config, spec) {
	  config.chartChanged = true;
	  config.parameterChanged = false;
	
	  var updated = false;
	
	  var availableCharts = getAvailableChartNames(spec.charts);
	
	  var _getSpecVersion = getSpecVersion(availableCharts, spec),
	      axisVersion = _getSpecVersion.axisVersion,
	      paramVersion = _getSpecVersion.paramVersion;
	
	  if (!config.spec || !config.spec.version || !config.spec.version.axis || config.spec.version.axis !== axisVersion) {
	    spec.initialized = true;
	    updated = true;
	
	    delete config.chart; /** Object: contains current, available chart */
	    config.panel = { columnPanelOpened: true, parameterPanelOpened: false };
	
	    clearAxisConfig(config);
	    delete config.axisSpecs; /** Object: persisted axisSpecs for each chart */
	  }
	
	  if (!config.spec || !config.spec.version || !config.spec.version.parameter || config.spec.version.parameter !== paramVersion) {
	    updated = true;
	
	    clearParameterConfig(config);
	    delete config.paramSpecs; /** Object: persisted paramSpecs for each chart */
	  }
	
	  if (!spec.version) {
	    spec.version = {};
	  }
	  spec.version.axis = axisVersion;
	  spec.version.parameter = paramVersion;
	
	  if (!config.spec || updated) {
	    config.spec = spec;
	  }
	
	  if (!config.chart) {
	    config.chart = {};
	    config.chart.current = availableCharts[0];
	    config.chart.available = availableCharts;
	  }
	
	  /** initialize config.axis, config.axisSpecs for each chart */
	  initAxisConfig(config);
	
	  /** initialize config.parameter for each chart */
	  initParameterConfig(config);
	  return config;
	}
	
	function getColumnsForMultipleAxes(axisType, axisSpecs, axis) {
	  var axisNames = [];
	  var column = {};
	
	  for (var i = 0; i < axisSpecs.length; i++) {
	    var axisSpec = axisSpecs[i];
	
	    if (axisType === AxisType.KEY && isKeyAxis(axisSpec)) {
	      axisNames.push(axisSpec.name);
	    } else if (axisType === AxisType.GROUP && isGroupAxis(axisSpec)) {
	      axisNames.push(axisSpec.name);
	    } else if (axisType.AGGREGATOR && isAggregatorAxis(axisSpec)) {
	      axisNames.push(axisSpec.name);
	    }
	  }
	
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = axisNames[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var axisName = _step.value;
	
	      var columns = axis[axisName];
	      if (typeof axis[axisName] === 'undefined') {
	        continue;
	      }
	      if (!column[axisName]) {
	        column[axisName] = [];
	      }
	      column[axisName] = column[axisName].concat(columns);
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return column;
	}
	
	function getColumnsFromAxis(axisSpecs, axis) {
	  var keyAxisNames = [];
	  var groupAxisNames = [];
	  var aggrAxisNames = [];
	
	  for (var i = 0; i < axisSpecs.length; i++) {
	    var axisSpec = axisSpecs[i];
	
	    if (isKeyAxis(axisSpec)) {
	      keyAxisNames.push(axisSpec.name);
	    } else if (isGroupAxis(axisSpec)) {
	      groupAxisNames.push(axisSpec.name);
	    } else if (isAggregatorAxis(axisSpec)) {
	      aggrAxisNames.push(axisSpec.name);
	    }
	  }
	
	  var keyColumns = [];
	  var groupColumns = [];
	  var aggregatorColumns = [];
	  var customColumn = {};
	
	  var _loop = function _loop(axisName) {
	    if (axis.hasOwnProperty(axisName)) {
	      var columns = axis[axisName];
	      if (keyAxisNames.includes(axisName)) {
	        keyColumns = keyColumns.concat(columns);
	      } else if (groupAxisNames.includes(axisName)) {
	        groupColumns = groupColumns.concat(columns);
	      } else if (aggrAxisNames.includes(axisName)) {
	        aggregatorColumns = aggregatorColumns.concat(columns);
	      } else {
	        var axisType = axisSpecs.filter(function (s) {
	          return s.name === axisName;
	        })[0].axisType;
	        if (!customColumn[axisType]) {
	          customColumn[axisType] = [];
	        }
	        customColumn[axisType] = customColumn[axisType].concat(columns);
	      }
	    }
	  };
	
	  for (var axisName in axis) {
	    _loop(axisName);
	  }
	
	  return {
	    key: keyColumns,
	    group: groupColumns,
	    aggregator: aggregatorColumns,
	    custom: customColumn
	  };
	}
	
	var Aggregator = exports.Aggregator = {
	  SUM: 'sum',
	  COUNT: 'count',
	  AVG: 'avg',
	  MIN: 'min',
	  MAX: 'max'
	};
	
	var TransformMethod = {
	  /**
	   * `raw` is designed for users who want to get raw (original) rows.
	   */
	  RAW: 'raw',
	  /**
	   * `object` is * designed for serial(line, area) charts.
	   */
	  OBJECT: 'object',
	  /**
	   * `array` is designed for column, pie charts which have categorical `key` values.
	   * But some libraries may require `OBJECT` transform method even if pie, column charts.
	   *
	   * `row.value` will be filled for `keyNames`.
	   * In other words, if you have `keyNames` which is length 4,
	   * every `row.value`'s length will be 4 too.
	   * (DO NOT use this transform method for serial (numerical) x axis charts which have so-oo many keys)
	   */
	  ARRAY: 'array',
	  ARRAY_2_KEY: 'array:2-key',
	  DRILL_DOWN: 'drill-down'
	};
	
	/** return function for lazy computation */
	function getTransformer(conf, rows, axisSpecs, axis) {
	  var transformer = function transformer() {};
	
	  var transformSpec = getCurrentChartTransform(conf);
	  if (!transformSpec) {
	    return transformer;
	  }
	
	  var method = transformSpec.method;
	
	  var columns = getColumnsFromAxis(axisSpecs, axis);
	  var keyColumns = columns.key;
	  var groupColumns = columns.group;
	  var aggregatorColumns = columns.aggregator;
	  var customColumns = columns.custom;
	
	  var column = {
	    key: keyColumns, group: groupColumns, aggregator: aggregatorColumns, custom: customColumns
	  };
	
	  if (method === TransformMethod.RAW) {
	    transformer = function transformer() {
	      return rows;
	    };
	  } else if (method === TransformMethod.OBJECT) {
	    transformer = function transformer() {
	      var _getKGACube = getKGACube(rows, keyColumns, groupColumns, aggregatorColumns),
	          cube = _getKGACube.cube,
	          schema = _getKGACube.schema,
	          keyColumnName = _getKGACube.keyColumnName,
	          keyNames = _getKGACube.keyNames,
	          groupNameSet = _getKGACube.groupNameSet,
	          selectorNameWithIndex = _getKGACube.selectorNameWithIndex;
	
	      var _getObjectRowsFromKGA = getObjectRowsFromKGACube(cube, schema, aggregatorColumns, keyColumnName, keyNames, groupNameSet, selectorNameWithIndex),
	          transformed = _getObjectRowsFromKGA.transformed,
	          groupNames = _getObjectRowsFromKGA.groupNames,
	          sortedSelectors = _getObjectRowsFromKGA.sortedSelectors;
	
	      return {
	        rows: transformed,
	        keyColumnName: keyColumnName,
	        keyNames: keyNames,
	        groupNames: groupNames,
	        selectors: sortedSelectors
	      };
	    };
	  } else if (method === TransformMethod.ARRAY) {
	    transformer = function transformer() {
	      var _getKGACube2 = getKGACube(rows, keyColumns, groupColumns, aggregatorColumns),
	          cube = _getKGACube2.cube,
	          schema = _getKGACube2.schema,
	          keyColumnName = _getKGACube2.keyColumnName,
	          keyNames = _getKGACube2.keyNames,
	          groupNameSet = _getKGACube2.groupNameSet,
	          selectorNameWithIndex = _getKGACube2.selectorNameWithIndex;
	
	      var _getArrayRowsFromKGAC = getArrayRowsFromKGACube(cube, schema, aggregatorColumns, keyColumnName, keyNames, groupNameSet, selectorNameWithIndex),
	          transformed = _getArrayRowsFromKGAC.transformed,
	          groupNames = _getArrayRowsFromKGAC.groupNames,
	          sortedSelectors = _getArrayRowsFromKGAC.sortedSelectors;
	
	      return {
	        rows: transformed,
	        keyColumnName: keyColumnName,
	        keyNames: keyNames,
	        groupNames: groupNames,
	        selectors: sortedSelectors
	      };
	    };
	  } else if (method === TransformMethod.ARRAY_2_KEY) {
	    var keyAxisColumn = getColumnsForMultipleAxes(AxisType.KEY, axisSpecs, axis);
	    column.key = keyAxisColumn;
	
	    var key1Columns = [];
	    var key2Columns = [];
	
	    // since ARRAY_2_KEY :)
	    var i = 0;
	    for (var axisName in keyAxisColumn) {
	      if (i === 2) {
	        break;
	      }
	
	      if (i === 0) {
	        key1Columns = keyAxisColumn[axisName];
	      } else if (i === 1) {
	        key2Columns = keyAxisColumn[axisName];
	      }
	      i++;
	    }
	
	    var _getKKGACube = getKKGACube(rows, key1Columns, key2Columns, groupColumns, aggregatorColumns),
	        cube = _getKKGACube.cube,
	        schema = _getKKGACube.schema,
	        key1ColumnName = _getKKGACube.key1ColumnName,
	        key1Names = _getKKGACube.key1Names,
	        key2ColumnName = _getKKGACube.key2ColumnName,
	        key2Names = _getKKGACube.key2Names,
	        groupNameSet = _getKKGACube.groupNameSet,
	        selectorNameWithIndex = _getKKGACube.selectorNameWithIndex;
	
	    var _getArrayRowsFromKKGA = getArrayRowsFromKKGACube(cube, schema, aggregatorColumns, key1Names, key2Names, groupNameSet, selectorNameWithIndex),
	        transformed = _getArrayRowsFromKKGA.transformed,
	        groupNames = _getArrayRowsFromKKGA.groupNames,
	        sortedSelectors = _getArrayRowsFromKKGA.sortedSelectors,
	        key1NameWithIndex = _getArrayRowsFromKKGA.key1NameWithIndex,
	        key2NameWithIndex = _getArrayRowsFromKKGA.key2NameWithIndex;
	
	    transformer = function transformer() {
	      return {
	        rows: transformed,
	        key1Names: key1Names,
	        key1ColumnName: key1ColumnName,
	        key1NameWithIndex: key1NameWithIndex,
	        key2Names: key2Names,
	        key2ColumnName: key2ColumnName,
	        key2NameWithIndex: key2NameWithIndex,
	        groupNames: groupNames,
	        selectors: sortedSelectors
	      };
	    };
	  } else if (method === TransformMethod.DRILL_DOWN) {
	    transformer = function transformer() {
	      var _getKAGCube = getKAGCube(rows, keyColumns, groupColumns, aggregatorColumns),
	          cube = _getKAGCube.cube,
	          schema = _getKAGCube.schema,
	          keyColumnName = _getKAGCube.keyColumnName,
	          keyNames = _getKAGCube.keyNames,
	          groupNameSet = _getKAGCube.groupNameSet,
	          selectorNameWithIndex = _getKAGCube.selectorNameWithIndex;
	
	      var _getDrilldownRowsFrom = getDrilldownRowsFromKAGCube(cube, schema, aggregatorColumns, keyColumnName, keyNames, groupNameSet, selectorNameWithIndex),
	          transformed = _getDrilldownRowsFrom.transformed,
	          groupNames = _getDrilldownRowsFrom.groupNames,
	          sortedSelectors = _getDrilldownRowsFrom.sortedSelectors;
	
	      return {
	        rows: transformed,
	        keyColumnName: keyColumnName,
	        keyNames: keyNames,
	        groupNames: groupNames,
	        selectors: sortedSelectors
	      };
	    };
	  }
	
	  return { transformer: transformer, column: column };
	}
	
	var AggregatorFunctions = {
	  sum: function sum(a, b) {
	    var varA = a !== undefined ? isNaN(a) ? 1 : parseFloat(a) : 0;
	    var varB = b !== undefined ? isNaN(b) ? 1 : parseFloat(b) : 0;
	    return varA + varB;
	  },
	  count: function count(a, b) {
	    var varA = a !== undefined ? parseInt(a) : 0;
	    var varB = b !== undefined ? 1 : 0;
	    return varA + varB;
	  },
	  min: function min(a, b) {
	    var varA = a !== undefined ? isNaN(a) ? 1 : parseFloat(a) : 0;
	    var varB = b !== undefined ? isNaN(b) ? 1 : parseFloat(b) : 0;
	    return Math.min(varA, varB);
	  },
	  max: function max(a, b) {
	    var varA = a !== undefined ? isNaN(a) ? 1 : parseFloat(a) : 0;
	    var varB = b !== undefined ? isNaN(b) ? 1 : parseFloat(b) : 0;
	    return Math.max(varA, varB);
	  },
	  avg: function avg(a, b, c) {
	    var varA = a !== undefined ? isNaN(a) ? 1 : parseFloat(a) : 0;
	    var varB = b !== undefined ? isNaN(b) ? 1 : parseFloat(b) : 0;
	    return varA + varB;
	  }
	};
	
	var AggregatorFunctionDiv = {
	  sum: false,
	  min: false,
	  max: false,
	  count: false,
	  avg: true
	};
	
	/** nested cube `(key) -> (group) -> aggregator` */
	function getKGACube(rows, keyColumns, groupColumns, aggrColumns) {
	  var schema = {
	    key: keyColumns.length !== 0,
	    group: groupColumns.length !== 0,
	    aggregator: aggrColumns.length !== 0
	  };
	
	  var cube = {};
	  var entry = {};
	
	  var keyColumnName = keyColumns.map(function (c) {
	    return c.name;
	  }).join('.');
	  var groupNameSet = new Set();
	  var keyNameSet = new Set();
	  var selectorNameWithIndex = {}; /** { selectorName: index } */
	  var indexCounter = 0;
	
	  var _loop2 = function _loop2(i) {
	    var row = rows[i];
	    var e = entry;
	    var c = cube;
	
	    // key: add to entry
	    var mergedKeyName = void 0;
	    if (schema.key) {
	      mergedKeyName = keyColumns.map(function (c) {
	        return row[c.index];
	      }).join('.');
	      if (!e[mergedKeyName]) {
	        e[mergedKeyName] = { children: {} };
	      }
	      e = e[mergedKeyName].children;
	      // key: add to row
	      if (!c[mergedKeyName]) {
	        c[mergedKeyName] = {};
	      }
	      c = c[mergedKeyName];
	
	      keyNameSet.add(mergedKeyName);
	    }
	
	    var mergedGroupName = void 0;
	    if (schema.group) {
	      mergedGroupName = groupColumns.map(function (c) {
	        return row[c.index];
	      }).join('.');
	
	      // add group to entry
	      if (!e[mergedGroupName]) {
	        e[mergedGroupName] = { children: {} };
	      }
	      e = e[mergedGroupName].children;
	      // add group to row
	      if (!c[mergedGroupName]) {
	        c[mergedGroupName] = {};
	      }
	      c = c[mergedGroupName];
	      groupNameSet.add(mergedGroupName);
	    }
	
	    for (var a = 0; a < aggrColumns.length; a++) {
	      var aggrColumn = aggrColumns[a];
	      var aggrName = aggrColumn.name + '(' + aggrColumn.aggr + ')';
	
	      // update groupNameSet
	      if (!mergedGroupName) {
	        groupNameSet.add(aggrName); /** aggr column name will be used as group name if group is empty */
	      }
	
	      // update selectorNameWithIndex
	      var selector = getSelectorName(mergedGroupName, aggrColumns.length, aggrName);
	      if (typeof selectorNameWithIndex[selector] === 'undefined' /** value might be 0 */) {
	          selectorNameWithIndex[selector] = indexCounter;
	          indexCounter = indexCounter + 1;
	        }
	
	      // add aggregator to entry
	      if (!e[aggrName]) {
	        e[aggrName] = { type: 'aggregator', order: aggrColumn, index: aggrColumn.index };
	      }
	
	      // add aggregatorName to row
	      if (!c[aggrName]) {
	        c[aggrName] = {
	          aggr: aggrColumn.aggr,
	          value: aggrColumn.aggr !== 'count' ? row[aggrColumn.index] : 1,
	          count: 1
	        };
	      } else {
	        var value = AggregatorFunctions[aggrColumn.aggr](c[aggrName].value, row[aggrColumn.index], c[aggrName].count + 1);
	        var count = AggregatorFunctionDiv[aggrColumn.aggr] ? c[aggrName].count + 1 : c[aggrName].count;
	
	        c[aggrName].value = value;
	        c[aggrName].count = count;
	      }
	    } /** end loop for aggrColumns */
	  };
	
	  for (var i = 0; i < rows.length; i++) {
	    _loop2(i);
	  }
	
	  var keyNames = null;
	  if (!schema.key) {
	    var mergedGroupColumnName = groupColumns.map(function (c) {
	      return c.name;
	    }).join('.');
	    cube = _defineProperty({}, mergedGroupColumnName, cube);
	    keyNames = [mergedGroupColumnName];
	  } else {
	    keyNames = sortWithNumberSupport(Object.keys(cube)); /** keys should be sorted */
	  }
	
	  return {
	    cube: cube,
	    schema: schema,
	    keyColumnName: keyColumnName,
	    keyNames: keyNames,
	    groupNameSet: groupNameSet,
	    selectorNameWithIndex: selectorNameWithIndex
	  };
	}
	
	/** nested cube `(key) -> aggregator -> (group)` for drill-down support */
	function getKAGCube(rows, keyColumns, groupColumns, aggrColumns) {
	  var schema = {
	    key: keyColumns.length !== 0,
	    group: groupColumns.length !== 0,
	    aggregator: aggrColumns.length !== 0
	  };
	
	  var cube = {};
	
	  var keyColumnName = keyColumns.map(function (c) {
	    return c.name;
	  }).join('.');
	  var groupNameSet = new Set();
	  var keyNameSet = new Set();
	  var selectorNameWithIndex = {}; /** { selectorName: index } */
	  var indexCounter = 0;
	
	  var _loop3 = function _loop3(i) {
	    var row = rows[i];
	    var c = cube;
	
	    // key: add to entry
	    var mergedKeyName = void 0;
	    if (schema.key) {
	      mergedKeyName = keyColumns.map(function (c) {
	        return row[c.index];
	      }).join('.');
	      // key: add to row
	      if (!c[mergedKeyName]) {
	        c[mergedKeyName] = {};
	      }
	      c = c[mergedKeyName];
	
	      keyNameSet.add(mergedKeyName);
	    }
	
	    var mergedGroupName = void 0;
	    if (schema.group) {
	      mergedGroupName = groupColumns.map(function (c) {
	        return row[c.index];
	      }).join('.');
	      groupNameSet.add(mergedGroupName);
	    }
	
	    for (var a = 0; a < aggrColumns.length; a++) {
	      var aggrColumn = aggrColumns[a];
	      var aggrName = aggrColumn.name + '(' + aggrColumn.aggr + ')';
	
	      // update groupNameSet
	      if (!mergedGroupName) {
	        groupNameSet.add(aggrName); /** aggr column name will be used as group name if group is empty */
	      }
	
	      // update selectorNameWithIndex
	      var selector = getSelectorName(mergedKeyName, aggrColumns.length, aggrName);
	      if (typeof selectorNameWithIndex[selector] === 'undefined' /** value might be 0 */) {
	          selectorNameWithIndex[selector] = indexCounter;
	          indexCounter = indexCounter + 1;
	        }
	
	      // add aggregatorName to row
	      if (!c[aggrName]) {
	        var value = aggrColumn.aggr !== 'count' ? row[aggrColumn.index] : 1;
	        var count = 1;
	
	        c[aggrName] = { aggr: aggrColumn.aggr, value: value, count: count, children: {} };
	      } else {
	        var _value = AggregatorFunctions[aggrColumn.aggr](c[aggrName].value, row[aggrColumn.index], c[aggrName].count + 1);
	        var _count = AggregatorFunctionDiv[aggrColumn.aggr] ? c[aggrName].count + 1 : c[aggrName].count;
	
	        c[aggrName].value = _value;
	        c[aggrName].count = _count;
	      }
	
	      // add aggregated group (for drill-down) to row iff group is enabled
	      if (mergedGroupName) {
	        if (!c[aggrName].children[mergedGroupName]) {
	          var _value2 = aggrColumn.aggr !== 'count' ? row[aggrColumn.index] : 1;
	          var _count2 = 1;
	
	          c[aggrName].children[mergedGroupName] = { value: _value2, count: _count2 };
	        } else {
	          var drillDownedValue = c[aggrName].children[mergedGroupName].value;
	          var drillDownedCount = c[aggrName].children[mergedGroupName].count;
	          var _value3 = AggregatorFunctions[aggrColumn.aggr](drillDownedValue, row[aggrColumn.index], drillDownedCount + 1);
	          var _count3 = AggregatorFunctionDiv[aggrColumn.aggr] ? drillDownedCount + 1 : drillDownedCount;
	
	          c[aggrName].children[mergedGroupName].value = _value3;
	          c[aggrName].children[mergedGroupName].count = _count3;
	        }
	      }
	    } /** end loop for aggrColumns */
	  };
	
	  for (var i = 0; i < rows.length; i++) {
	    _loop3(i);
	  }
	
	  var keyNames = null;
	  if (!schema.key) {
	    var mergedGroupColumnName = groupColumns.map(function (c) {
	      return c.name;
	    }).join('.');
	    cube = _defineProperty({}, mergedGroupColumnName, cube);
	    keyNames = [mergedGroupColumnName];
	  } else {
	    keyNames = sortWithNumberSupport(Object.keys(cube)); /** keys should be sorted */
	  }
	
	  return {
	    cube: cube,
	    schema: schema,
	    keyColumnName: keyColumnName,
	    keyNames: keyNames,
	    groupNameSet: groupNameSet,
	    selectorNameWithIndex: selectorNameWithIndex
	  };
	}
	/** nested cube `(key1) -> (key2) -> (group) -> aggregator` */
	function getKKGACube(rows, key1Columns, key2Columns, groupColumns, aggrColumns) {
	  var schema = {
	    key1: key1Columns.length !== 0,
	    key2: key2Columns.length !== 0,
	    group: groupColumns.length !== 0,
	    aggregator: aggrColumns.length !== 0
	  };
	
	  var cube = {};
	  var entry = {};
	
	  var key1ColumnName = key1Columns.map(function (c) {
	    return c.name;
	  }).join('.');
	  var key1NameSet = {};
	  var key2ColumnName = key2Columns.map(function (c) {
	    return c.name;
	  }).join('.');
	  var key2NameSet = {};
	  var groupNameSet = new Set();
	  var selectorNameWithIndex = {}; /** { selectorName: index } */
	  var indexCounter = 0;
	
	  var _loop4 = function _loop4(i) {
	    var row = rows[i];
	    var e = entry;
	    var c = cube;
	
	    // key1: add to entry
	    var mergedKey1Name = void 0;
	    if (schema.key1) {
	      mergedKey1Name = key1Columns.map(function (c) {
	        return row[c.index];
	      }).join('.');
	      if (!e[mergedKey1Name]) {
	        e[mergedKey1Name] = { children: {} };
	      }
	      e = e[mergedKey1Name].children;
	      // key1: add to row
	      if (!c[mergedKey1Name]) {
	        c[mergedKey1Name] = {};
	      }
	      c = c[mergedKey1Name];
	
	      if (!key1NameSet[mergedKey1Name]) {
	        key1NameSet[mergedKey1Name] = true;
	      }
	    }
	
	    // key2: add to entry
	    var mergedKey2Name = void 0;
	    if (schema.key2) {
	      mergedKey2Name = key2Columns.map(function (c) {
	        return row[c.index];
	      }).join('.');
	      if (!e[mergedKey2Name]) {
	        e[mergedKey2Name] = { children: {} };
	      }
	      e = e[mergedKey2Name].children;
	      // key2: add to row
	      if (!c[mergedKey2Name]) {
	        c[mergedKey2Name] = {};
	      }
	      c = c[mergedKey2Name];
	
	      if (!key2NameSet[mergedKey2Name]) {
	        key2NameSet[mergedKey2Name] = true;
	      }
	    }
	
	    var mergedGroupName = void 0;
	    if (schema.group) {
	      mergedGroupName = groupColumns.map(function (c) {
	        return row[c.index];
	      }).join('.');
	
	      // add group to entry
	      if (!e[mergedGroupName]) {
	        e[mergedGroupName] = { children: {} };
	      }
	      e = e[mergedGroupName].children;
	      // add group to row
	      if (!c[mergedGroupName]) {
	        c[mergedGroupName] = {};
	      }
	      c = c[mergedGroupName];
	      groupNameSet.add(mergedGroupName);
	    }
	
	    for (var a = 0; a < aggrColumns.length; a++) {
	      var aggrColumn = aggrColumns[a];
	      var aggrName = aggrColumn.name + '(' + aggrColumn.aggr + ')';
	
	      // update groupNameSet
	      if (!mergedGroupName) {
	        groupNameSet.add(aggrName); /** aggr column name will be used as group name if group is empty */
	      }
	
	      // update selectorNameWithIndex
	      var selector = getSelectorName(mergedGroupName, aggrColumns.length, aggrName);
	      if (typeof selectorNameWithIndex[selector] === 'undefined' /** value might be 0 */) {
	          selectorNameWithIndex[selector] = indexCounter;
	          indexCounter = indexCounter + 1;
	        }
	
	      // add aggregator to entry
	      if (!e[aggrName]) {
	        e[aggrName] = { type: 'aggregator', order: aggrColumn, index: aggrColumn.index };
	      }
	
	      // add aggregatorName to row
	      if (!c[aggrName]) {
	        c[aggrName] = {
	          aggr: aggrColumn.aggr,
	          value: aggrColumn.aggr !== 'count' ? row[aggrColumn.index] : 1,
	          count: 1
	        };
	      } else {
	        var value = AggregatorFunctions[aggrColumn.aggr](c[aggrName].value, row[aggrColumn.index], c[aggrName].count + 1);
	        var count = AggregatorFunctionDiv[aggrColumn.aggr] ? c[aggrName].count + 1 : c[aggrName].count;
	
	        c[aggrName].value = value;
	        c[aggrName].count = count;
	      }
	    } /** end loop for aggrColumns */
	  };
	
	  for (var i = 0; i < rows.length; i++) {
	    _loop4(i);
	  }
	
	  var key1Names = sortWithNumberSupport(Object.keys(key1NameSet)); /** keys should be sorted */
	  var key2Names = sortWithNumberSupport(Object.keys(key2NameSet)); /** keys should be sorted */
	
	  return {
	    cube: cube,
	    schema: schema,
	    key1ColumnName: key1ColumnName,
	    key1Names: key1Names,
	    key2ColumnName: key2ColumnName,
	    key2Names: key2Names,
	    groupNameSet: groupNameSet,
	    selectorNameWithIndex: selectorNameWithIndex
	  };
	}
	
	function getSelectorName(mergedGroupName, aggrColumnLength, aggrColumnName) {
	  if (!mergedGroupName) {
	    return aggrColumnName;
	  } else {
	    return aggrColumnLength > 1 ? mergedGroupName + ' / ' + aggrColumnName : mergedGroupName;
	  }
	}
	
	function getCubeValue(obj, aggregator, aggrColumnName) {
	  var value = null; /** default is null */
	  try {
	    /** if AVG or COUNT, calculate it now, previously we can't because we were doing accumulation */
	    if (aggregator === Aggregator.AVG) {
	      value = obj[aggrColumnName].value / obj[aggrColumnName].count;
	    } else if (aggregator === Aggregator.COUNT) {
	      value = obj[aggrColumnName].value;
	    } else {
	      value = obj[aggrColumnName].value;
	    }
	
	    if (typeof value === 'undefined') {
	      value = null;
	    }
	  } catch (error) {/** iognore */}
	
	  return value;
	}
	
	function getNameWithIndex(names) {
	  var nameWithIndex = {};
	
	  for (var i = 0; i < names.length; i++) {
	    var name = names[i];
	    nameWithIndex[name] = i;
	  }
	
	  return nameWithIndex;
	}
	
	function getArrayRowsFromKKGACube(cube, schema, aggregatorColumns, key1Names, key2Names, groupNameSet, selectorNameWithIndex) {
	  var sortedSelectors = sortWithNumberSupport(Object.keys(selectorNameWithIndex));
	  var sortedSelectorNameWithIndex = getNameWithIndex(sortedSelectors);
	
	  var selectorRows = new Array(sortedSelectors.length);
	  var key1NameWithIndex = getNameWithIndex(key1Names);
	  var key2NameWithIndex = getNameWithIndex(key2Names);
	
	  fillSelectorRows(schema, cube, selectorRows, aggregatorColumns, sortedSelectorNameWithIndex, key1Names, key2Names, key1NameWithIndex, key2NameWithIndex);
	
	  return {
	    key1NameWithIndex: key1NameWithIndex,
	    key2NameWithIndex: key2NameWithIndex,
	    transformed: selectorRows,
	    groupNames: sortWithNumberSupport(Array.from(groupNameSet)),
	    sortedSelectors: sortedSelectors
	  };
	}
	
	/** truly mutable style func. will return nothing */
	function fillSelectorRows(schema, cube, selectorRows, aggrColumns, selectorNameWithIndex, key1Names, key2Names) {
	  function fill(grouped, mergedGroupName, key1Name, key2Name) {
	    // should iterate aggrColumns in the most nested loop to utilize memory locality
	    var _iteratorNormalCompletion2 = true;
	    var _didIteratorError2 = false;
	    var _iteratorError2 = undefined;
	
	    try {
	      for (var _iterator2 = aggrColumns[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	        var aggrColumn = _step2.value;
	
	        var aggrName = aggrColumn.name + '(' + aggrColumn.aggr + ')';
	        var value = getCubeValue(grouped, aggrColumn.aggr, aggrName);
	        var selector = getSelectorName(mergedGroupName, aggrColumns.length, aggrName);
	        var selectorIndex = selectorNameWithIndex[selector];
	
	        if (typeof selectorRows[selectorIndex] === 'undefined') {
	          selectorRows[selectorIndex] = { selector: selector, value: [] };
	        }
	
	        var _row = { aggregated: value };
	
	        if (typeof key1Name !== 'undefined') {
	          _row.key1 = key1Name;
	        }
	        if (typeof key2Name !== 'undefined') {
	          _row.key2 = key2Name;
	        }
	
	        selectorRows[selectorIndex].value.push(_row);
	      }
	    } catch (err) {
	      _didIteratorError2 = true;
	      _iteratorError2 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion2 && _iterator2.return) {
	          _iterator2.return();
	        }
	      } finally {
	        if (_didIteratorError2) {
	          throw _iteratorError2;
	        }
	      }
	    }
	  }
	
	  function iterateGroupNames(keyed, key1Name, key2Name) {
	    if (!schema.group) {
	      fill(keyed, undefined, key1Name, key2Name);
	    } else {
	      // assuming sparse distribution (usual case)
	      // otherwise we need to iterate using `groupNameSet`
	      var availableGroupNames = Object.keys(keyed);
	
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = availableGroupNames[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var groupName = _step3.value;
	
	          var grouped = keyed[groupName];
	          fill(grouped, groupName, key1Name, key2Name);
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	    }
	  }
	
	  if (schema.key1 && schema.key2) {
	    var _iteratorNormalCompletion4 = true;
	    var _didIteratorError4 = false;
	    var _iteratorError4 = undefined;
	
	    try {
	      for (var _iterator4 = key1Names[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	        var key1Name = _step4.value;
	
	        var key1ed = cube[key1Name];
	
	        // assuming sparse distribution (usual case)
	        // otherwise we need to iterate using `key2Names`
	        var availableKey2Names = Object.keys(key1ed);
	
	        var _iteratorNormalCompletion5 = true;
	        var _didIteratorError5 = false;
	        var _iteratorError5 = undefined;
	
	        try {
	          for (var _iterator5 = availableKey2Names[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	            var key2Name = _step5.value;
	
	            var keyed = key1ed[key2Name];
	            iterateGroupNames(keyed, key1Name, key2Name);
	          }
	        } catch (err) {
	          _didIteratorError5 = true;
	          _iteratorError5 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion5 && _iterator5.return) {
	              _iterator5.return();
	            }
	          } finally {
	            if (_didIteratorError5) {
	              throw _iteratorError5;
	            }
	          }
	        }
	      }
	    } catch (err) {
	      _didIteratorError4 = true;
	      _iteratorError4 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion4 && _iterator4.return) {
	          _iterator4.return();
	        }
	      } finally {
	        if (_didIteratorError4) {
	          throw _iteratorError4;
	        }
	      }
	    }
	  } else if (schema.key1 && !schema.key2) {
	    var _iteratorNormalCompletion6 = true;
	    var _didIteratorError6 = false;
	    var _iteratorError6 = undefined;
	
	    try {
	      for (var _iterator6 = key1Names[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	        var _key1Name = _step6.value;
	
	        var _keyed = cube[_key1Name];
	        iterateGroupNames(_keyed, _key1Name, undefined);
	      }
	    } catch (err) {
	      _didIteratorError6 = true;
	      _iteratorError6 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion6 && _iterator6.return) {
	          _iterator6.return();
	        }
	      } finally {
	        if (_didIteratorError6) {
	          throw _iteratorError6;
	        }
	      }
	    }
	  } else if (!schema.key1 && schema.key2) {
	    var _iteratorNormalCompletion7 = true;
	    var _didIteratorError7 = false;
	    var _iteratorError7 = undefined;
	
	    try {
	      for (var _iterator7 = key2Names[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
	        var _key2Name = _step7.value;
	
	        var _keyed2 = cube[_key2Name];
	        iterateGroupNames(_keyed2, undefined, _key2Name);
	      }
	    } catch (err) {
	      _didIteratorError7 = true;
	      _iteratorError7 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion7 && _iterator7.return) {
	          _iterator7.return();
	        }
	      } finally {
	        if (_didIteratorError7) {
	          throw _iteratorError7;
	        }
	      }
	    }
	  } else {
	    iterateGroupNames(cube, undefined, undefined);
	  }
	}
	
	function getArrayRowsFromKGACube(cube, schema, aggregatorColumns, keyColumnName, keyNames, groupNameSet, selectorNameWithIndex) {
	  var sortedSelectors = sortWithNumberSupport(Object.keys(selectorNameWithIndex));
	  var sortedSelectorNameWithIndex = getNameWithIndex(sortedSelectors);
	
	  var keyArrowRows = new Array(sortedSelectors.length);
	  var keyNameWithIndex = getNameWithIndex(keyNames);
	
	  for (var i = 0; i < keyNames.length; i++) {
	    var key = keyNames[i];
	
	    var obj = cube[key];
	    fillArrayRow(schema, aggregatorColumns, obj, groupNameSet, sortedSelectorNameWithIndex, key, keyNames, keyArrowRows, keyNameWithIndex);
	  }
	
	  return {
	    transformed: keyArrowRows,
	    groupNames: sortWithNumberSupport(Array.from(groupNameSet)),
	    sortedSelectors: sortedSelectors
	  };
	}
	
	/** truly mutable style func. will return nothing, just modify `keyArrayRows` */
	function fillArrayRow(schema, aggrColumns, obj, groupNameSet, selectorNameWithIndex, keyName, keyNames, keyArrayRows, keyNameWithIndex) {
	  function fill(target, mergedGroupName, aggr, aggrName) {
	    var value = getCubeValue(target, aggr, aggrName);
	    var selector = getSelectorName(mergedGroupName, aggrColumns.length, aggrName);
	    var selectorIndex = selectorNameWithIndex[selector];
	    var keyIndex = keyNameWithIndex[keyName];
	
	    if (typeof keyArrayRows[selectorIndex] === 'undefined') {
	      keyArrayRows[selectorIndex] = {
	        selector: selector, value: new Array(keyNames.length)
	      };
	    }
	    keyArrayRows[selectorIndex].value[keyIndex] = value;
	  }
	
	  /** when group is empty */
	  if (!schema.group) {
	    for (var i = 0; i < aggrColumns.length; i++) {
	      var aggrColumn = aggrColumns[i];
	      var aggrName = aggrColumn.name + '(' + aggrColumn.aggr + ')';
	      fill(obj, undefined, aggrColumn.aggr, aggrName);
	    }
	  } else {
	    for (var _i3 = 0; _i3 < aggrColumns.length; _i3++) {
	      var _aggrColumn = aggrColumns[_i3];
	      var _aggrName = _aggrColumn.name + '(' + _aggrColumn.aggr + ')';
	
	      var _iteratorNormalCompletion8 = true;
	      var _didIteratorError8 = false;
	      var _iteratorError8 = undefined;
	
	      try {
	        for (var _iterator8 = groupNameSet[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
	          var groupName = _step8.value;
	
	          var grouped = obj[groupName];
	          fill(grouped, groupName, _aggrColumn.aggr, _aggrName);
	        }
	      } catch (err) {
	        _didIteratorError8 = true;
	        _iteratorError8 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion8 && _iterator8.return) {
	            _iterator8.return();
	          }
	        } finally {
	          if (_didIteratorError8) {
	            throw _iteratorError8;
	          }
	        }
	      }
	    }
	  }
	}
	
	function getObjectRowsFromKGACube(cube, schema, aggregatorColumns, keyColumnName, keyNames, groupNameSet, selectorNameWithIndex) {
	  var rows = keyNames.reduce(function (acc, key) {
	    var obj = cube[key];
	    var row = getObjectRow(schema, aggregatorColumns, obj, groupNameSet);
	
	    if (schema.key) {
	      row[keyColumnName] = key;
	    }
	    acc.push(row);
	
	    return acc;
	  }, []);
	
	  return {
	    transformed: rows,
	    sortedSelectors: sortWithNumberSupport(Object.keys(selectorNameWithIndex)),
	    groupNames: sortWithNumberSupport(Array.from(groupNameSet))
	  };
	}
	
	function getObjectRow(schema, aggrColumns, obj, groupNameSet) {
	  var row = {};
	
	  function fill(row, target, mergedGroupName, aggr, aggrName) {
	    var value = getCubeValue(target, aggr, aggrName);
	    var selector = getSelectorName(mergedGroupName, aggrColumns.length, aggrName);
	    row[selector] = value;
	  }
	
	  /** when group is empty */
	  if (!schema.group) {
	    for (var i = 0; i < aggrColumns.length; i++) {
	      var aggrColumn = aggrColumns[i];
	      var aggrName = aggrColumn.name + '(' + aggrColumn.aggr + ')';
	
	      fill(row, obj, undefined, aggrColumn.aggr, aggrName);
	    }
	
	    return row;
	  }
	
	  /** when group is specified */
	  for (var _i4 = 0; _i4 < aggrColumns.length; _i4++) {
	    var _aggrColumn2 = aggrColumns[_i4];
	    var _aggrName2 = _aggrColumn2.name + '(' + _aggrColumn2.aggr + ')';
	
	    var _iteratorNormalCompletion9 = true;
	    var _didIteratorError9 = false;
	    var _iteratorError9 = undefined;
	
	    try {
	      for (var _iterator9 = groupNameSet[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
	        var groupName = _step9.value;
	
	        var grouped = obj[groupName];
	
	        if (grouped) {
	          fill(row, grouped, groupName, _aggrColumn2.aggr, _aggrName2);
	        }
	      }
	    } catch (err) {
	      _didIteratorError9 = true;
	      _iteratorError9 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion9 && _iterator9.return) {
	          _iterator9.return();
	        }
	      } finally {
	        if (_didIteratorError9) {
	          throw _iteratorError9;
	        }
	      }
	    }
	  }
	
	  return row;
	}
	
	function getDrilldownRowsFromKAGCube(cube, schema, aggregatorColumns, keyColumnName, keyNames, groupNameSet, selectorNameWithIndex) {
	  var sortedSelectors = sortWithNumberSupport(Object.keys(selectorNameWithIndex));
	  var sortedSelectorNameWithIndex = getNameWithIndex(sortedSelectors);
	
	  var rows = new Array(sortedSelectors.length);
	
	  var groupNames = sortWithNumberSupport(Array.from(groupNameSet));
	
	  keyNames.map(function (key) {
	    var obj = cube[key];
	    fillDrillDownRow(schema, obj, rows, key, sortedSelectorNameWithIndex, aggregatorColumns, groupNames);
	  });
	
	  return {
	    transformed: rows,
	    groupNames: groupNames,
	    sortedSelectors: sortedSelectors,
	    sortedSelectorNameWithIndex: sortedSelectorNameWithIndex
	  };
	}
	
	/** truly mutable style func. will return nothing, just modify `rows` */
	function fillDrillDownRow(schema, obj, rows, key, selectorNameWithIndex, aggrColumns, groupNames) {
	  /** when group is empty */
	  for (var i = 0; i < aggrColumns.length; i++) {
	    var _row2 = {};
	    var aggrColumn = aggrColumns[i];
	    var aggrName = aggrColumn.name + '(' + aggrColumn.aggr + ')';
	
	    var value = getCubeValue(obj, aggrColumn.aggr, aggrName);
	    var selector = getSelectorName(schema.key ? key : undefined, aggrColumns.length, aggrName);
	
	    var selectorIndex = selectorNameWithIndex[selector];
	    _row2.value = value;
	    _row2.drillDown = [];
	    _row2.selector = selector;
	
	    if (schema.group) {
	      _row2.drillDown = [];
	
	      var _iteratorNormalCompletion10 = true;
	      var _didIteratorError10 = false;
	      var _iteratorError10 = undefined;
	
	      try {
	        for (var _iterator10 = groupNames[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
	          var groupName = _step10.value;
	
	          var _value4 = getCubeValue(obj[aggrName].children, aggrColumn.aggr, groupName);
	          _row2.drillDown.push({ group: groupName, value: _value4 });
	        }
	      } catch (err) {
	        _didIteratorError10 = true;
	        _iteratorError10 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion10 && _iterator10.return) {
	            _iterator10.return();
	          }
	        } finally {
	          if (_didIteratorError10) {
	            throw _iteratorError10;
	          }
	        }
	      }
	    }
	
	    rows[selectorIndex] = _row2;
	  }
	}
	
	function sortWithNumberSupport(arr) {
	  var isNumeric = function isNumeric(n) {
	    return !isNaN(parseFloat(n)) && isFinite(n);
	  };
	
	  if (arr.every(isNumeric)) {
	    return arr.sort(function (a, b) {
	      return parseFloat(a) - parseFloat(b);
	    });
	  } else {
	    return arr.sort();
	  }
	}

/***/ }),
/* 171 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/**
	 * Base class for visualization.
	 */
	var Visualization = function () {
	  function Visualization(targetEl, config) {
	    _classCallCheck(this, Visualization);
	
	    this.targetEl = targetEl;
	    this.config = config;
	    this._dirty = false;
	    this._active = false;
	    this._emitter = function () {};
	  }
	
	  /**
	   * Get transformation.
	   * @abstract
	   * @return {Transformation}
	   */
	
	
	  _createClass(Visualization, [{
	    key: 'getTransformation',
	    value: function getTransformation() {
	      // override this
	      throw new TypeError('Visualization.getTransformation() should be overrided');
	    }
	
	    /**
	     * Method will be invoked when data or configuration changed.
	     * @abstract
	     */
	
	  }, {
	    key: 'render',
	    value: function render(tableData) {
	      // override this
	      throw new TypeError('Visualization.render() should be overrided');
	    }
	
	    /**
	     * Refresh visualization.
	     */
	
	  }, {
	    key: 'refresh',
	    value: function refresh() {
	      // override this
	      console.warn('A chart is missing refresh function, it might not work preperly');
	    }
	
	    /**
	     * Method will be invoked when visualization need to be destroyed.
	     * Don't need to destroy this.targetEl.
	     */
	
	  }, {
	    key: 'destroy',
	    value: function destroy() {}
	    // override this
	
	
	    /**
	     * return {
	     *   template : angular template string or url (url should end with .html),
	     *   scope : an object to bind to template scope
	     * }
	     */
	
	  }, {
	    key: 'getSetting',
	    value: function getSetting() {}
	    // override this
	
	
	    /**
	     * Activate. Invoked when visualization is selected.
	     */
	
	  }, {
	    key: 'activate',
	    value: function activate() {
	      if (!this._active || this._dirty) {
	        this.refresh();
	        this._dirty = false;
	      }
	      this._active = true;
	    }
	
	    /**
	     * Deactivate. Invoked when visualization is de selected.
	     */
	
	  }, {
	    key: 'deactivate',
	    value: function deactivate() {
	      this._active = false;
	    }
	
	    /**
	     * Is active.
	     */
	
	  }, {
	    key: 'isActive',
	    value: function isActive() {
	      return this._active;
	    }
	
	    /**
	     * When window or paragraph is resized.
	     */
	
	  }, {
	    key: 'resize',
	    value: function resize() {
	      if (this.isActive()) {
	        this.refresh();
	      } else {
	        this._dirty = true;
	      }
	    }
	
	    /**
	     * Set new config.
	     */
	
	  }, {
	    key: 'setConfig',
	    value: function setConfig(config) {
	      this.config = config;
	      if (this.isActive()) {
	        this.refresh();
	      } else {
	        this._dirty = true;
	      }
	    }
	
	    /**
	     * Emit config. config will sent to server and saved.
	     */
	
	  }, {
	    key: 'emitConfig',
	    value: function emitConfig(config) {
	      this._emitter(config);
	    }
	
	    /**
	     * Render setting.
	     */
	
	  }, {
	    key: 'renderSetting',
	    value: function renderSetting(targetEl) {
	      var _this = this;
	
	      var setting = this.getSetting();
	      if (!setting) {
	        return;
	      }
	
	      // already readered
	      if (this._scope) {
	        var self = this;
	        this._scope.$apply(function () {
	          for (var k in setting.scope) {
	            if (setting.scope.hasOwnProperty(k)) {
	              self._scope[k] = setting.scope[k];
	            }
	          }
	
	          for (var _k in self._prevSettingScope) {
	            if (!setting.scope[_k]) {
	              self._scope[_k] = setting.scope[_k];
	            }
	          }
	        });
	        return;
	      } else {
	        this._prevSettingScope = setting.scope;
	      }
	
	      var scope = this._createNewScope();
	      for (var k in setting.scope) {
	        if (setting.scope.hasOwnProperty(k)) {
	          scope[k] = setting.scope[k];
	        }
	      }
	      var template = setting.template;
	
	      if (template.split('\n').length === 1 && template.endsWith('.html')) {
	        // template is url
	        this._templateRequest(template).then(function (t) {
	          return _renderSetting(_this, targetEl, t, scope);
	        });
	      } else {
	        _renderSetting(this, targetEl, template, scope);
	      }
	    }
	  }]);
	
	  return Visualization;
	}();
	
	exports.default = Visualization;
	
	
	function _renderSetting(instance, targetEl, template, scope) {
	  instance._targetEl = targetEl;
	  targetEl.html(template);
	  instance._compile(targetEl.contents())(scope);
	  instance._scope = scope;
	}

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _visualization = __webpack_require__(171);
	
	var _visualization2 = _interopRequireDefault(_visualization);
	
	var _passthrough = __webpack_require__(167);
	
	var _passthrough2 = _interopRequireDefault(_passthrough);
	
	var _visualizationUtil = __webpack_require__(166);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var SETTING_TEMPLATE = __webpack_require__(173);
	
	var TABLE_OPTION_SPECS = [];
	
	/**
	 * Visualize data in table format
	 */
	
	var TableVisualization = function (_Visualization) {
	  _inherits(TableVisualization, _Visualization);
	
	  function TableVisualization(targetEl, config) {
	    _classCallCheck(this, TableVisualization);
	
	    var _this = _possibleConstructorReturn(this, (TableVisualization.__proto__ || Object.getPrototypeOf(TableVisualization)).call(this, targetEl, config));
	
	    _this.passthrough = new _passthrough2.default(config);
	    _this.emitTimeout = null;
	    _this.isRestoring = false;
	
	    (0, _visualizationUtil.initializeTableConfig)(config, TABLE_OPTION_SPECS);
	    return _this;
	  }
	
	  _createClass(TableVisualization, [{
	    key: 'getColumnMinWidth',
	    value: function getColumnMinWidth(colName) {
	      var width = 150; // default
	      var calculatedWidth = colName.length * 10;
	
	      // use the broad one
	      if (calculatedWidth > width) {
	        width = calculatedWidth;
	      }
	
	      return width;
	    }
	  }, {
	    key: 'getSortedValue',
	    value: function getSortedValue(a, b) {
	      return a > b ? 1 : a === b ? 0 : -1;
	    }
	  }, {
	    key: 'isSortableNumeric',
	    value: function isSortableNumeric(v) {
	      // eslint-disable-next-line valid-typeof
	      return typeof v === 'bigint' || !isNaN(v);
	    }
	  }, {
	    key: 'getNumericSortedValue',
	    value: function getNumericSortedValue(a, b) {
	      if (!this.isSortableNumeric(a) && !this.isSortableNumeric(b)) {
	        return 0;
	      } else if (!this.isSortableNumeric(a)) {
	        return 1;
	      } else if (!this.isSortableNumeric(b)) {
	        return -1;
	      } else {
	        return this.getSortedValue(a, b);
	      }
	    }
	  }, {
	    key: 'createGridOptions',
	    value: function createGridOptions(tableData, onRegisterApiCallback, config) {
	      var _this2 = this;
	
	      var rows = tableData.rows;
	
	      var gridData = rows.map(function (r) {
	        return tableData.columns.reduce(function (acc, col, index) {
	          acc['' + index] = r[index];
	          return acc;
	        }, {});
	      });
	
	      return {
	        data: gridData,
	        enableGridMenu: false,
	        modifierKeysToMultiSelectCells: true,
	        exporterMenuCsv: true,
	        exporterMenuPdf: false,
	        flatEntityAccess: true,
	        fastWatch: false,
	        treeRowHeaderAlwaysVisible: false,
	        exporterExcelFilename: 'myFile.xlsx',
	
	        columnDefs: tableData.columns.map(function (c, i) {
	          var self = _this2;
	          return {
	            displayName: c.name,
	            name: '' + i,
	            type: (0, _visualizationUtil.getTableColumnType)(c.type),
	            enableHiding: false,
	            cellTemplate: '\n            <div ng-if="!grid.getCellValue(row, col).startsWith(\'%html\')"\n                 class="ui-grid-cell-contents">\n              {{grid.getCellValue(row, col)}}\n            </div>\n            <div ng-if="grid.getCellValue(row, col).startsWith(\'%html\')"\n                 ng-bind-html="grid.getCellValue(row, col).split(\'%html\')[1]"\n                 class="ui-grid-cell-contents">\n            </div>\n          ',
	            minWidth: _this2.getColumnMinWidth(c.name),
	            width: '*',
	            sortingAlgorithm: function sortingAlgorithm(a, b, row1, row2, sortType, gridCol) {
	              var colType = gridCol.colDef.type;
	              if (colType === _visualizationUtil.TableColumnType.NUMBER || colType === _visualizationUtil.TableColumnType.NUMBER_STR) {
	                return self.getNumericSortedValue((0, _visualizationUtil.toNumber)(a), (0, _visualizationUtil.toNumber)(b));
	              } else if (colType === _visualizationUtil.TableColumnType.STRING) {
	                return self.getSortedValue(a.toString(), b.toString());
	              } else if (colType === _visualizationUtil.TableColumnType.DATE) {
	                return self.getSortedValue(new Date(a), new Date(b));
	              } else {
	                return self.getSortedValue(a, b);
	              }
	            }
	          };
	        }),
	        rowEditWaitInterval: -1, /** disable saveRow event */
	        enableRowHashing: true,
	        saveFocus: false,
	        saveScroll: false,
	        saveSort: true,
	        savePinning: true,
	        saveGrouping: true,
	        saveGroupingExpandedStates: true,
	        saveOrder: true, // column order
	        saveVisible: true, // column visibility
	        saveTreeView: true,
	        saveFilter: true,
	        saveSelection: false
	      };
	    }
	  }, {
	    key: 'getGridElemId',
	    value: function getGridElemId() {
	      // angular doesn't allow `-` in scope variable name
	      var gridElemId = (this.targetEl[0].id + '_grid').replace('-', '_');
	      return gridElemId;
	    }
	  }, {
	    key: 'getGridApiId',
	    value: function getGridApiId() {
	      // angular doesn't allow `-` in scope variable name
	      var gridApiId = (this.targetEl[0].id + '_gridApi').replace('-', '_');
	      return gridApiId;
	    }
	  }, {
	    key: 'refresh',
	    value: function refresh() {
	      var gridElemId = this.getGridElemId();
	      var gridElem = angular.element('#' + gridElemId);
	
	      if (gridElem) {
	        gridElem.css('height', this.targetEl.height() - 10);
	        var gridApiId = this.getGridApiId();
	        var scope = this.getScope();
	        if (scope !== undefined && scope[gridApiId] !== undefined) {
	          scope[gridApiId].core.handleWindowResize();
	        }
	      }
	    }
	  }, {
	    key: 'refreshGrid',
	    value: function refreshGrid() {
	      var gridElemId = this.getGridElemId();
	      var gridElem = angular.element('#' + gridElemId);
	
	      if (gridElem) {
	        var scope = this.getScope();
	        var gridApiId = this.getGridApiId();
	        scope[gridApiId].core.notifyDataChange(this._uiGridConstants.dataChange.ALL);
	      }
	    }
	  }, {
	    key: 'updateColDefType',
	    value: function updateColDefType(colDef, type) {
	      if (type === colDef.type) {
	        return;
	      }
	
	      colDef.type = type;
	      var colName = colDef.name;
	      var config = this.config;
	      if (config.tableColumnTypeState.names && config.tableColumnTypeState.names[colName]) {
	        config.tableColumnTypeState.names[colName] = type;
	        this.persistConfigWithGridState(this.config);
	      }
	    }
	  }, {
	    key: 'addColumnMenus',
	    value: function addColumnMenus(gridOptions) {
	      if (!gridOptions || !gridOptions.columnDefs) {
	        return;
	      }
	
	      var self = this; // for closure
	
	      // SHOULD use `function() { ... }` syntax for each action to get `this`
	      gridOptions.columnDefs.map(function (colDef) {
	        colDef.menuItems = [{
	          title: 'Type: String',
	          action: function action() {
	            self.updateColDefType(this.context.col.colDef, _visualizationUtil.TableColumnType.STRING);
	          },
	          active: function active() {
	            return this.context.col.colDef.type === _visualizationUtil.TableColumnType.STRING;
	          }
	        }, {
	          title: 'Type: Number',
	          action: function action() {
	            self.updateColDefType(this.context.col.colDef, _visualizationUtil.TableColumnType.NUMBER_STR);
	          },
	          active: function active() {
	            var colType = this.context.col.colDef.type;
	            return colType === _visualizationUtil.TableColumnType.NUMBER_STR || colType === _visualizationUtil.TableColumnType.NUMBER;
	          }
	        }, {
	          title: 'Type: Date',
	          action: function action() {
	            self.updateColDefType(this.context.col.colDef, _visualizationUtil.TableColumnType.DATE);
	          },
	          active: function active() {
	            return this.context.col.colDef.type === _visualizationUtil.TableColumnType.DATE;
	          }
	        }];
	      });
	    }
	  }, {
	    key: 'setDynamicGridOptions',
	    value: function setDynamicGridOptions(gridOptions) {
	      gridOptions.showGridFooter = false;
	      gridOptions.showColumnFooter = false;
	      gridOptions.enableFiltering = false;
	
	      gridOptions.enablePagination = false;
	      gridOptions.enablePaginationControls = false;
	
	      // selection can't be rendered dynamically in ui-grid 4.0.4
	      gridOptions.enableRowSelection = false;
	      gridOptions.enableRowHeaderSelection = false;
	      gridOptions.enableFullRowSelection = false;
	      gridOptions.enableSelectAll = false;
	      gridOptions.enableGroupHeaderSelection = false;
	      gridOptions.enableSelectionBatchEvent = false;
	    }
	  }, {
	    key: 'append',
	    value: function append(row, columns) {
	      var gridOptions = this.getGridOptions();
	      this.setDynamicGridOptions(gridOptions, this.config);
	      // this.refreshGrid()
	      var gridElemId = this.getGridElemId();
	      var gridElem = angular.element('#' + gridElemId);
	
	      if (gridElem) {
	        var scope = this.getScope();
	
	        var columnNames = columns.map(function (c) {
	          return c.name;
	        });
	        var gridData = row.map(function (r) {
	          return columnNames.reduce(function (acc, colName, index) {
	            acc[colName] = r[index];
	            return acc;
	          }, {});
	        });
	        gridData.map(function (data) {
	          scope[gridElemId].data.push(data);
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render(tableData) {
	      var gridElemId = this.getGridElemId();
	      var gridElem = document.getElementById(gridElemId);
	
	      var config = this.config;
	      var self = this; // for closure
	      var scope = this.getScope();
	      // set gridApi for this elem
	      var gridApiId = this.getGridApiId();
	      var gridOptions = this.createGridOptions(tableData, onRegisterApiCallback, config);
	
	      var onRegisterApiCallback = function onRegisterApiCallback(gridApi) {
	        scope[gridApiId] = gridApi;
	        // should restore state before registering APIs
	
	        // register callbacks for change evens
	        // should persist `self.config` instead `config` (closure issue)
	        gridApi.core.on.columnVisibilityChanged(scope, function () {
	          self.persistConfigWithGridState(self.config);
	        });
	        gridApi.core.on.sortChanged(scope, function () {
	          self.persistConfigWithGridState(self.config);
	        });
	        gridApi.colResizable.on.columnSizeChanged(scope, function () {
	          self.persistConfigWithGridState(self.config);
	        });
	
	        gridApi.grid.renderContainers.body.adjustColumns = function adjustColumns(scrollLeft, scrollPercentage) {
	          var self = this;
	
	          var columnCache = self.visibleColumnCache;
	
	          var canvasWidth = self.getCanvasWidth();
	          var viewportWidth = self.getViewportWidth();
	
	          var shouldLimitColumns = columnCache.length > self.grid.options.columnVirtualizationThreshold && canvasWidth > viewportWidth;
	
	          var colIndex = void 0;
	          var newRange = void 0;
	          if (shouldLimitColumns) {
	            // Calculate the scroll percentage according to the scrollLeft location
	            // if no percentage was provided
	            if ((typeof scrollPercentage === 'undefined' || scrollPercentage === null) && scrollLeft) {
	              scrollPercentage = scrollLeft / self.getHorizontalScrollLength();
	            }
	
	            // determine where column rendering should start by canvas width
	            var availableCanvasWidth = canvasWidth - viewportWidth;
	            var startPos = Math.max(availableCanvasWidth * scrollPercentage, 0);
	            var stopPos = Math.min(startPos + viewportWidth, canvasWidth);
	
	            var bounds = _.reduce(columnCache, function (acc, col, i) {
	              var pos = acc[2];
	              if (pos < stopPos) {
	                var colWidth = col.drawnWidth ? col.drawnWidth : 0;
	                // haven't stopped, see if we've started yet
	                if (pos > startPos) {
	                  return [acc[0], i, pos + colWidth];
	                } else {
	                  return [i, i, pos + colWidth];
	                }
	              } else {
	                return acc;
	              }
	            }, [0, 0, 0]);
	
	            var rangeStart = Math.max(0, bounds[0] - self.grid.options.excessColumns);
	            var rangeEnd = Math.min(columnCache.length, bounds[1] + self.grid.options.excessColumns);
	
	            colIndex = bounds[0];
	            newRange = [rangeStart, rangeEnd];
	          } else {
	            colIndex = 0;
	            newRange = [0, columnCache.length];
	          }
	
	          self.updateViewableColumnRange(newRange);
	
	          self.prevColumnScrollIndex = colIndex;
	        };
	      };
	
	      if (!gridElem) {
	        // create, compile and append grid elem
	        gridElem = angular.element('<div id="' + gridElemId + '" ui-grid="' + gridElemId + '"\n              ui-grid-empty-base-layer\n              ui-grid-resize-columns\n              ui-grid-save-state></div>');
	
	        gridElem.css('height', this.targetEl.height() - 10);
	        gridElem = this._compile(gridElem)(scope);
	        this.targetEl.append(gridElem);
	        this.setDynamicGridOptions(gridOptions, config);
	        this.addColumnMenus(gridOptions);
	        scope[gridElemId] = gridOptions;
	        gridOptions.onRegisterApi = onRegisterApiCallback;
	      } else {
	        scope[gridElemId] = gridOptions;
	        this.setDynamicGridOptions(gridOptions, config);
	        this.refreshGrid();
	      }
	
	      var columnDefs = this.getGridOptions().columnDefs;
	      (0, _visualizationUtil.updateColumnTypeState)(tableData.columns, config, columnDefs);
	      // SHOULD restore grid state after columnDefs are updated
	      this.restoreGridState(config.tableGridState);
	    }
	  }, {
	    key: 'restoreGridState',
	    value: function restoreGridState(gridState) {
	      var _this3 = this;
	
	      if (!gridState) {
	        return;
	      }
	
	      // should set isRestoring to avoid that changed* events are triggered while restoring
	      this.isRestoring = true;
	      var gridApi = this.getGridApi();
	
	      // restore grid state when gridApi is available
	      if (!gridApi) {
	        setTimeout(function () {
	          return _this3.restoreGridState(gridState);
	        }, 100);
	      } else {
	        gridApi.saveState.restore(this.getScope(), gridState);
	        this.isRestoring = false;
	      }
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {}
	  }, {
	    key: 'getTransformation',
	    value: function getTransformation() {
	      return this.passthrough;
	    }
	  }, {
	    key: 'getScope',
	    value: function getScope() {
	      var scope = this.targetEl.scope();
	      return scope;
	    }
	  }, {
	    key: 'getGridOptions',
	    value: function getGridOptions() {
	      var scope = this.getScope();
	      var gridElemId = this.getGridElemId();
	      return scope[gridElemId];
	    }
	  }, {
	    key: 'getGridApi',
	    value: function getGridApi() {
	      var scope = this.targetEl.scope();
	      var gridApiId = this.getGridApiId();
	      return scope[gridApiId];
	    }
	  }, {
	    key: 'persistConfigImmediatelyWithGridState',
	    value: function persistConfigImmediatelyWithGridState(config) {
	      this.persistConfigWithGridState(config);
	    }
	  }, {
	    key: 'persistConfigWithGridState',
	    value: function persistConfigWithGridState(config) {
	      if (this.isRestoring) {
	        return;
	      }
	
	      var gridApi = this.getGridApi();
	      config.tableGridState = gridApi.saveState.save();
	      this.emitConfig(config);
	    }
	  }, {
	    key: 'persistConfig',
	    value: function persistConfig(config) {
	      this.emitConfig(config);
	    }
	  }, {
	    key: 'getSetting',
	    value: function getSetting(chart) {
	      var self = this; // for closure in scope
	      var configObj = self.config;
	
	      // emit config if it's updated in `render`
	      if (configObj.initialized) {
	        configObj.initialized = false;
	        this.persistConfig(configObj); // should persist w/o state
	      } else if (configObj.tableColumnTypeState && configObj.tableColumnTypeState.updated) {
	        configObj.tableColumnTypeState.updated = false;
	        this.persistConfig(configObj); // should persist w/o state
	      }
	
	      return {
	        template: SETTING_TEMPLATE,
	        scope: {
	          config: configObj,
	          tableOptionSpecs: TABLE_OPTION_SPECS,
	          isInputWidget: _visualizationUtil.isInputWidget,
	          isOptionWidget: _visualizationUtil.isOptionWidget,
	          isCheckboxWidget: _visualizationUtil.isCheckboxWidget,
	          isTextareaWidget: _visualizationUtil.isTextareaWidget,
	          isBtnGroupWidget: _visualizationUtil.isBtnGroupWidget,
	          tableOptionValueChanged: function tableOptionValueChanged() {
	            self.persistConfigWithGridState(configObj);
	          },
	          saveTableOption: function saveTableOption() {
	            self.persistConfigWithGridState(configObj);
	          },
	          resetTableOption: function resetTableOption() {
	            (0, _visualizationUtil.resetTableOptionConfig)(configObj);
	            (0, _visualizationUtil.initializeTableConfig)(configObj, TABLE_OPTION_SPECS);
	            self.persistConfigWithGridState(configObj);
	          },
	          tableWidgetOnKeyDown: function tableWidgetOnKeyDown(event, optSpec) {
	            var code = event.keyCode || event.which;
	            if (code === 13 && (0, _visualizationUtil.isInputWidget)(optSpec)) {
	              self.persistConfigWithGridState(configObj);
	            } else if (code === 13 && event.shiftKey && (0, _visualizationUtil.isTextareaWidget)(optSpec)) {
	              self.persistConfigWithGridState(configObj);
	            }
	
	            event.stopPropagation(); /** avoid to conflict with paragraph shortcuts */
	          }
	        }
	      };
	    }
	  }]);
	
	  return TableVisualization;
	}(_visualization2.default);
	
	exports.default = TableVisualization;

/***/ }),
/* 173 */
/***/ (function(module, exports) {

	module.exports = "<!--\nLicensed under the Apache License, Version 2.0 (the \"License\");\nyou may not use this file except in compliance with the License.\nYou may obtain a copy of the License at\n\n    http://www.apache.org/licenses/LICENSE-2.0\n\nUnless required by applicable law or agreed to in writing, software\ndistributed under the License is distributed on an \"AS IS\" BASIS,\nWITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\nSee the License for the specific language governing permissions and\nlimitations under the License.\n-->\n\n<div class=\"panel panel-default\" style=\"margin-top: 10px; margin-bottom: 11px;\">\n  <div class=\"panel-heading\" style=\"padding: 6px 12px 6px 12px; font-size: 13px;\">\n    <span style=\"vertical-align: middle; display: inline-block; margin-top: 3px;\">Table Options</span>\n    <span style=\"float: right;\">\n       <div class=\"btn-group\" role=\"group\" aria-label=\"...\">\n         <div type=\"button\" ng-click=\"resetTableOption()\"\n              uib-tooltip=\"Restore the default setting\" tooltip-placement=\"left\"\n              class=\"btn btn-default\" style=\"font-size: 11px; padding: 2px 5px 2px 5px;\">\n           <i class=\"fa fa-undo\" aria-hidden=\"true\"></i>\n         </div>\n       </div>\n    </span>\n    <div style=\"clear: both;\"></div> <!-- to fix previous span which has float: right -->\n  </div>\n\n  <div class=\"panel-body\" style=\"padding: 8px 12px; margin-top: 3px;\">\n    <table class=\"table table-striped\">\n      <tr>\n        <th style=\"font-size: 12px; font-style: italic\">Name</th>\n        <th style=\"font-size: 12px; font-style: italic\">Value</th>\n      </tr>\n      <tr>\n      </tr>\n\n      <tr data-ng-repeat=\"optSpec in tableOptionSpecs\">\n        <td style=\"font-weight: 400; vertical-align: middle;\">\n          <span uib-tooltip=\"{{optSpec.description}}\" tooltip-placement=\"right\">\n            {{optSpec.name}}\n            <i class=\"fa fa-info-circle\" style=\"margin-top: 2px; margin-left: 3px; color: #7b7bbd;\" aria-hidden=\"true\"></i>\n          </span>\n        </td>\n        <td>\n          <div ng-if=\"isInputWidget(optSpec)\"\n               class=\"input-group\">\n            <input type=\"text\" class=\"form-control input-sm\"\n                   style=\"font-weight: 400; font-size: 12px; vertical-align:middle; border-radius: 5px;\"\n                   ng-keydown=\"tableWidgetOnKeyDown($event, optSpec)\"\n                   data-ng-model=\"config.tableOptionValue[optSpec.name]\" />\n          </div>\n          <div class=\"btn-group\"\n               ng-if=\"isOptionWidget(optSpec)\">\n            <select class=\"form-control input-sm\"\n                    ng-change=\"tableOptionValueChanged(optSpec)\"\n                    data-ng-model=\"config.tableOptionValue[optSpec.name]\"\n                    data-ng-options=\"optionValue for optionValue in optSpec.optionValues\"\n                    style=\"font-weight: 400; font-size: 12px;\">\n            </select>\n          </div>\n\n          <div ng-if=\"isCheckboxWidget(optSpec)\">\n            <input type=\"checkbox\"\n                   ng-keydown=\"parameterOnKeyDown($event, optSpec)\"\n                   ng-click=\"tableOptionValueChanged(optSpec)\"\n                   data-ng-model=\"config.tableOptionValue[optSpec.name]\"\n                   data-ng-checked=\"config.tableOptionValue[optSpec.name]\" />\n          </div>\n\n          <div ng-if=\"isTextareaWidget(optSpec)\">\n            <textarea class=\"form-control\" rows=\"3\"\n                      ng-keydown=\"tableWidgetOnKeyDown($event, optSpec)\"\n                      data-ng-model=\"config.tableOptionValue[optSpec.name]\"\n                      style=\"font-weight: 400; font-size: 12px;\">\n            </textarea>\n          </div>\n\n        </td>\n      </tr>\n    </table>\n  </div>\n</div>\n"

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _visualization = __webpack_require__(171);
	
	var _visualization2 = _interopRequireDefault(_visualization);
	
	var _magpieColors = __webpack_require__(175);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	/**
	 * Visualize data in table format
	 */
	var Nvd3ChartVisualization = function (_Visualization) {
	  _inherits(Nvd3ChartVisualization, _Visualization);
	
	  function Nvd3ChartVisualization(targetEl, config) {
	    _classCallCheck(this, Nvd3ChartVisualization);
	
	    var _this = _possibleConstructorReturn(this, (Nvd3ChartVisualization.__proto__ || Object.getPrototypeOf(Nvd3ChartVisualization)).call(this, targetEl, config));
	
	    _this.targetEl.append('<svg></svg>');
	    return _this;
	  }
	
	  _createClass(Nvd3ChartVisualization, [{
	    key: 'refresh',
	    value: function refresh() {
	      if (this.chart) {
	        this.chart.update();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render(data) {
	      var type = this.type();
	      var d3g = data.d3g;
	
	      if (!this.chart) {
	        this.chart = nv.models[type]();
	      }
	
	      this.chart.color((0, _magpieColors.getMagpieChartColors)());
	
	      this.configureChart(this.chart);
	
	      var animationDuration = 300;
	      var numberOfDataThreshold = 150;
	      var height = this.targetEl.height();
	
	      // turn off animation when dataset is too large. (for performance issue)
	      // still, since dataset is large, the chart content sequentially appears like animated
	      try {
	        if (d3g[0].values.length > numberOfDataThreshold) {
	          animationDuration = 0;
	        }
	      } catch (err) {/** ignore */}
	
	      d3.select('#' + this.targetEl[0].id + ' svg').attr('height', height).datum(d3g).transition().duration(animationDuration).call(this.chart);
	      d3.select('#' + this.targetEl[0].id + ' svg').style.height = height + 'px';
	    }
	  }, {
	    key: 'type',
	    value: function type() {
	      // override this and return chart type
	    }
	  }, {
	    key: 'configureChart',
	    value: function configureChart(chart) {
	      // override this to configure chart
	    }
	  }, {
	    key: 'groupedThousandsWith3DigitsFormatter',
	    value: function groupedThousandsWith3DigitsFormatter(x) {
	      return d3.format(',')(d3.round(x, 3));
	    }
	  }, {
	    key: 'customAbbrevFormatter',
	    value: function customAbbrevFormatter(x) {
	      var s = d3.format('.3s')(x);
	      switch (s[s.length - 1]) {
	        case 'G':
	          return s.slice(0, -1) + 'B';
	      }
	      return s;
	    }
	  }, {
	    key: 'defaultY',
	    value: function defaultY() {
	      return 0;
	    }
	  }, {
	    key: 'xAxisTickFormat',
	    value: function xAxisTickFormat(d, xLabels) {
	      if (xLabels[d] && (isNaN(parseFloat(xLabels[d])) || !isFinite(xLabels[d]))) {
	        // to handle string type xlabel
	        return xLabels[d];
	      } else {
	        return d;
	      }
	    }
	  }, {
	    key: 'yAxisTickFormat',
	    value: function yAxisTickFormat(d) {
	      if (Math.abs(d) >= Math.pow(10, 6)) {
	        return this.customAbbrevFormatter(d);
	      }
	      return this.groupedThousandsWith3DigitsFormatter(d);
	    }
	  }, {
	    key: 'd3DataFromPivot',
	    value: function d3DataFromPivot(schema, rows, keys, groups, values, allowTextXAxis, fillMissingValues, multiBarChart, skipUndefined) {
	      var self = this;
	      // construct table data
	      var d3g = [];
	
	      var concat = function concat(o, n) {
	        if (!o) {
	          return n;
	        } else {
	          return o + '.' + n;
	        }
	      };
	
	      var getSchemaUnderKey = function getSchemaUnderKey(key, s) {
	        for (var c in key.children) {
	          if (key.children.hasOwnProperty(c)) {
	            s[c] = {};
	            getSchemaUnderKey(key.children[c], s[c]);
	          }
	        }
	      };
	
	      var traverse = function traverse(sKey, s, rKey, r, func, rowName, rowValue, colName) {
	        // console.log("TRAVERSE sKey=%o, s=%o, rKey=%o, r=%o, rowName=%o, rowValue=%o, colName=%o", sKey, s, rKey, r, rowName, rowValue, colName);
	
	        if (s.type === 'key') {
	          rowName = concat(rowName, sKey);
	          rowValue = concat(rowValue, rKey);
	        } else if (s.type === 'group') {
	          colName = concat(colName, rKey);
	        } else if (s.type === 'value' && sKey === rKey || valueOnly) {
	          colName = concat(colName, rKey);
	          func(rowName, rowValue, colName, r);
	        }
	
	        for (var c in s.children) {
	          if (fillMissingValues && s.children[c].type === 'group' && r[c] === undefined) {
	            var cs = {};
	            getSchemaUnderKey(s.children[c], cs);
	            traverse(c, s.children[c], c, cs, func, rowName, rowValue, colName);
	            continue;
	          }
	
	          for (var j in r) {
	            if (s.children[c].type === 'key' || c === j) {
	              traverse(c, s.children[c], j, r[j], func, rowName, rowValue, colName);
	            }
	          }
	        }
	      };
	
	      var valueOnly = keys.length === 0 && groups.length === 0 && values.length > 0;
	      var noKey = keys.length === 0;
	      var isMultiBarChart = multiBarChart;
	
	      var sKey = Object.keys(schema)[0];
	
	      var rowNameIndex = {};
	      var rowIdx = 0;
	      var colNameIndex = {};
	      var colIdx = 0;
	      var rowIndexValue = {};
	
	      for (var k in rows) {
	        if (rows.hasOwnProperty(k)) {
	          traverse(sKey, schema[sKey], k, rows[k], function (rowName, rowValue, colName, value) {
	            // console.log("RowName=%o, row=%o, col=%o, value=%o", rowName, rowValue, colName, value);
	            if (rowNameIndex[rowValue] === undefined) {
	              rowIndexValue[rowIdx] = rowValue;
	              rowNameIndex[rowValue] = rowIdx++;
	            }
	
	            if (colNameIndex[colName] === undefined) {
	              colNameIndex[colName] = colIdx++;
	            }
	            var i = colNameIndex[colName];
	            if (noKey && isMultiBarChart) {
	              i = 0;
	            }
	
	            if (!d3g[i]) {
	              d3g[i] = {
	                values: [],
	                key: noKey && isMultiBarChart ? 'values' : colName
	              };
	            }
	
	            var xVar = isNaN(rowValue) ? allowTextXAxis ? rowValue : rowNameIndex[rowValue] : parseFloat(rowValue);
	            var yVar = undefined;
	            if (xVar === undefined) {
	              xVar = colName;
	            }
	            if (value !== undefined && !isNaN(value.value)) {
	              yVar = parseFloat(value.value) / parseFloat(value.count);
	            }
	
	            if (!skipUndefined || yVar !== undefined) {
	              d3g[i].values.push({
	                x: xVar,
	                y: yVar || self.defaultY()
	              });
	            }
	          });
	        }
	      }
	
	      // clear aggregation name, if possible
	      var namesWithoutAggr = {};
	      var colName = void 0;
	      var withoutAggr = void 0;
	      // TODO - This part could use som refactoring - Weird if/else with similar actions and variable names
	      for (colName in colNameIndex) {
	        if (colNameIndex.hasOwnProperty(colName)) {
	          withoutAggr = colName.substring(0, colName.lastIndexOf('('));
	          if (!namesWithoutAggr[withoutAggr]) {
	            namesWithoutAggr[withoutAggr] = 1;
	          } else {
	            namesWithoutAggr[withoutAggr]++;
	          }
	        }
	      }
	
	      if (valueOnly) {
	        for (var valueIndex = 0; valueIndex < d3g[0].values.length; valueIndex++) {
	          colName = d3g[0].values[valueIndex].x;
	          if (!colName) {
	            continue;
	          }
	
	          withoutAggr = colName.substring(0, colName.lastIndexOf('('));
	          if (namesWithoutAggr[withoutAggr] <= 1) {
	            d3g[0].values[valueIndex].x = withoutAggr;
	          }
	        }
	      } else {
	        for (var d3gIndex = 0; d3gIndex < d3g.length; d3gIndex++) {
	          colName = d3g[d3gIndex].key;
	          withoutAggr = colName.substring(0, colName.lastIndexOf('('));
	          if (namesWithoutAggr[withoutAggr] <= 1) {
	            d3g[d3gIndex].key = withoutAggr;
	          }
	        }
	
	        // use group name instead of group.value as a column name, if there're only one group and one value selected.
	        if (groups.length === 1 && values.length === 1) {
	          for (var _d3gIndex = 0; _d3gIndex < d3g.length; _d3gIndex++) {
	            colName = d3g[_d3gIndex].key;
	            colName = colName.split('.').slice(0, -1).join('.');
	            d3g[_d3gIndex].key = colName;
	          }
	        }
	      }
	
	      return {
	        xLabels: rowIndexValue,
	        d3g: d3g
	      };
	    }
	
	    /**
	     * method will be invoked when visualization need to be destroyed.
	     * Don't need to destroy this.targetEl.
	     */
	
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      if (this.chart) {
	        d3.selectAll('#' + this.targetEl[0].id + ' svg > *').remove();
	        this.chart = undefined;
	      }
	    }
	  }]);
	
	  return Nvd3ChartVisualization;
	}(_visualization2.default);
	
	exports.default = Nvd3ChartVisualization;

/***/ }),
/* 175 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getMagpieChartColors = getMagpieChartColors;
	exports.getMagpieDonutChartColors = getMagpieDonutChartColors;
	function getMagpieChartColors() {
	  var colors = ['#13406C', '#EDAD08', '#5F4690', '#F7951C', '#8ba1cc', '#e34732', '#73AF48', '#084fd4', '#0F8554', '#994E95', '#CC503E', '#666666'];
	  return colors;
	}
	
	function getMagpieDonutChartColors() {
	  var colors = ['#13406C', '#8ba1cc'];
	  return colors;
	}

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _visualizationNvd3chart = __webpack_require__(174);
	
	var _visualizationNvd3chart2 = _interopRequireDefault(_visualizationNvd3chart);
	
	var _pivot = __webpack_require__(165);
	
	var _pivot2 = _interopRequireDefault(_pivot);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	/**
	 * Visualize data in bar char
	 */
	var BarchartVisualization = function (_Nvd3ChartVisualizati) {
	  _inherits(BarchartVisualization, _Nvd3ChartVisualizati);
	
	  function BarchartVisualization(targetEl, config) {
	    _classCallCheck(this, BarchartVisualization);
	
	    var _this = _possibleConstructorReturn(this, (BarchartVisualization.__proto__ || Object.getPrototypeOf(BarchartVisualization)).call(this, targetEl, config));
	
	    _this.pivot = new _pivot2.default(config, _this.type());
	
	    try {
	      _this.config.rotate = { degree: config.rotate.degree };
	    } catch (e) {
	      _this.config.rotate = { degree: '-45' };
	    }
	    return _this;
	  }
	
	  _createClass(BarchartVisualization, [{
	    key: 'type',
	    value: function type() {
	      return 'multiBarChart';
	    }
	  }, {
	    key: 'getTransformation',
	    value: function getTransformation() {
	      return this.pivot;
	    }
	  }, {
	    key: 'render',
	    value: function render(pivot) {
	      var d3Data = this.d3DataFromPivot(pivot.schema, pivot.rows, pivot.keys, pivot.groups, pivot.values, true, true, true, false);
	
	      _get(BarchartVisualization.prototype.__proto__ || Object.getPrototypeOf(BarchartVisualization.prototype), 'render', this).call(this, d3Data);
	      this.config.changeXLabel(this.config.xLabelStatus);
	    }
	
	    /**
	     * Set new config
	     */
	
	  }, {
	    key: 'setConfig',
	    value: function setConfig(config) {
	      _get(BarchartVisualization.prototype.__proto__ || Object.getPrototypeOf(BarchartVisualization.prototype), 'setConfig', this).call(this, config);
	      this.pivot.setConfig(config);
	    }
	  }, {
	    key: 'configureChart',
	    value: function configureChart(chart) {
	      var self = this;
	      var configObj = self.config;
	
	      chart.yAxis.axisLabelDistance(50);
	      chart.yAxis.tickFormat(function (d) {
	        return self.yAxisTickFormat(d);
	      });
	
	      self.chart.stacked(this.config.stacked);
	
	      self.config.changeXLabel = function (type) {
	        switch (type) {
	          case 'default':
	            self.chart._options['showXAxis'] = true;
	            self.chart._options['margin'] = { bottom: 50 };
	            self.chart.xAxis.rotateLabels(0);
	            configObj.xLabelStatus = 'default';
	            break;
	          case 'rotate':
	            self.chart._options['showXAxis'] = true;
	            self.chart._options['margin'] = { bottom: 140 };
	            self.chart.xAxis.rotateLabels(configObj.rotate.degree);
	            configObj.xLabelStatus = 'rotate';
	            break;
	          case 'hide':
	            self.chart._options['showXAxis'] = false;
	            self.chart._options['margin'] = { bottom: 50 };
	            d3.select('#' + self.targetEl[0].id + '> svg').select('g.nv-axis.nv-x').selectAll('*').remove();
	            configObj.xLabelStatus = 'hide';
	            break;
	        }
	        self.emitConfig(configObj);
	      };
	
	      self.config.isXLabelStatus = function (type) {
	        if (configObj.xLabelStatus === type) {
	          return true;
	        } else {
	          return false;
	        }
	      };
	
	      self.config.setDegree = function (type) {
	        configObj.rotate.degree = type;
	        self.chart.xAxis.rotateLabels(type);
	        self.emitConfig(configObj);
	      };
	
	      this.chart.dispatch.on('stateChange', function (s) {
	        configObj.stacked = s.stacked;
	
	        // give some time to animation finish
	        setTimeout(function () {
	          self.emitConfig(configObj);
	        }, 500);
	      });
	    }
	  }, {
	    key: 'getSetting',
	    value: function getSetting(chart) {
	      var self = this;
	      var configObj = self.config;
	
	      // default to visualize xLabel
	      if (typeof configObj.xLabelStatus === 'undefined') {
	        configObj.changeXLabel('default');
	      }
	
	      if (typeof configObj.rotate.degree === 'undefined' || configObj.rotate.degree === '') {
	        configObj.rotate.degree = '-45';
	        self.emitConfig(configObj);
	      }
	
	      return {
	        template: 'app/visualization/builtins/visualization-displayXAxis.html',
	        scope: {
	          config: configObj
	        }
	      };
	    }
	  }]);
	
	  return BarchartVisualization;
	}(_visualizationNvd3chart2.default);
	
	exports.default = BarchartVisualization;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _visualizationNvd3chart = __webpack_require__(174);
	
	var _visualizationNvd3chart2 = _interopRequireDefault(_visualizationNvd3chart);
	
	var _pivot = __webpack_require__(165);
	
	var _pivot2 = _interopRequireDefault(_pivot);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	/**
	 * Visualize data in pie chart
	 */
	var PiechartVisualization = function (_Nvd3ChartVisualizati) {
	  _inherits(PiechartVisualization, _Nvd3ChartVisualizati);
	
	  function PiechartVisualization(targetEl, config) {
	    _classCallCheck(this, PiechartVisualization);
	
	    var _this = _possibleConstructorReturn(this, (PiechartVisualization.__proto__ || Object.getPrototypeOf(PiechartVisualization)).call(this, targetEl, config));
	
	    _this.pivot = new _pivot2.default(config, _this.type());
	    return _this;
	  }
	
	  _createClass(PiechartVisualization, [{
	    key: 'type',
	    value: function type() {
	      return 'pieChart';
	    }
	  }, {
	    key: 'getTransformation',
	    value: function getTransformation() {
	      return this.pivot;
	    }
	  }, {
	    key: 'render',
	    value: function render(pivot) {
	      // [ZEPPELIN-2253] New chart function will be created each time inside super.render()
	      this.chart = null;
	      var d3Data = this.d3DataFromPivot(pivot.schema, pivot.rows, pivot.keys, pivot.groups, pivot.values, true, false, false, false);
	      var d = d3Data.d3g;
	
	      var generateLabel = void 0;
	      // data is grouped
	      if (pivot.groups && pivot.groups.length > 0) {
	        generateLabel = function generateLabel(suffix, prefix) {
	          return prefix + '.' + suffix;
	        };
	      } else {
	        // data isn't grouped
	        generateLabel = function generateLabel(suffix) {
	          return suffix;
	        };
	      }
	
	      var d3g = d.map(function (group) {
	        return group.values.map(function (row) {
	          return {
	            label: generateLabel(row.x, group.key),
	            value: row.y
	          };
	        });
	      });
	      // the map function returns d3g as a nested array
	      // [].concat flattens it, http://stackoverflow.com/a/10865042/5154397
	      d3g = [].concat.apply([], d3g); // eslint-disable-line prefer-spread
	      _get(PiechartVisualization.prototype.__proto__ || Object.getPrototypeOf(PiechartVisualization.prototype), 'render', this).call(this, { d3g: d3g });
	    }
	
	    /**
	     * Set new config
	     */
	
	  }, {
	    key: 'setConfig',
	    value: function setConfig(config) {
	      _get(PiechartVisualization.prototype.__proto__ || Object.getPrototypeOf(PiechartVisualization.prototype), 'setConfig', this).call(this, config);
	      this.pivot.setConfig(config);
	    }
	  }, {
	    key: 'configureChart',
	    value: function configureChart(chart) {
	      chart.x(function (d) {
	        return d.label;
	      }).y(function (d) {
	        return d.value;
	      }).showLabels(false).showTooltipPercent(true);
	    }
	  }]);
	
	  return PiechartVisualization;
	}(_visualizationNvd3chart2.default);
	
	exports.default = PiechartVisualization;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _visualizationNvd3chart = __webpack_require__(174);
	
	var _visualizationNvd3chart2 = _interopRequireDefault(_visualizationNvd3chart);
	
	var _pivot = __webpack_require__(165);
	
	var _pivot2 = _interopRequireDefault(_pivot);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	/**
	 * Visualize data in area chart
	 */
	var AreachartVisualization = function (_Nvd3ChartVisualizati) {
	  _inherits(AreachartVisualization, _Nvd3ChartVisualizati);
	
	  function AreachartVisualization(targetEl, config) {
	    _classCallCheck(this, AreachartVisualization);
	
	    var _this = _possibleConstructorReturn(this, (AreachartVisualization.__proto__ || Object.getPrototypeOf(AreachartVisualization)).call(this, targetEl, config));
	
	    _this.pivot = new _pivot2.default(config, _this.type());
	
	    try {
	      _this.config.rotate = { degree: config.rotate.degree };
	    } catch (e) {
	      _this.config.rotate = { degree: '-45' };
	    }
	    return _this;
	  }
	
	  _createClass(AreachartVisualization, [{
	    key: 'type',
	    value: function type() {
	      return 'stackedAreaChart';
	    }
	  }, {
	    key: 'getTransformation',
	    value: function getTransformation() {
	      return this.pivot;
	    }
	  }, {
	    key: 'render',
	    value: function render(pivot) {
	      var d3Data = this.d3DataFromPivot(pivot.schema, pivot.rows, pivot.keys, pivot.groups, pivot.values, false, true, false, false);
	
	      this.xLabels = d3Data.xLabels;
	      _get(AreachartVisualization.prototype.__proto__ || Object.getPrototypeOf(AreachartVisualization.prototype), 'render', this).call(this, d3Data);
	      this.config.changeXLabel(this.config.xLabelStatus);
	    }
	
	    /**
	     * Set new config
	     */
	
	  }, {
	    key: 'setConfig',
	    value: function setConfig(config) {
	      _get(AreachartVisualization.prototype.__proto__ || Object.getPrototypeOf(AreachartVisualization.prototype), 'setConfig', this).call(this, config);
	      this.pivot.setConfig(config);
	    }
	  }, {
	    key: 'configureChart',
	    value: function configureChart(chart) {
	      var self = this;
	      var configObj = self.config;
	
	      chart.xAxis.tickFormat(function (d) {
	        return self.xAxisTickFormat(d, self.xLabels);
	      });
	      chart.yAxis.tickFormat(function (d) {
	        return self.yAxisTickFormat(d);
	      });
	      chart.yAxis.axisLabelDistance(50);
	      chart.useInteractiveGuideline(true); // for better UX and performance issue. (https://github.com/novus/nvd3/issues/691)
	
	      self.config.changeXLabel = function (type) {
	        switch (type) {
	          case 'default':
	            self.chart._options['showXAxis'] = true;
	            self.chart._options['margin'] = { bottom: 50 };
	            self.chart.xAxis.rotateLabels(0);
	            configObj.xLabelStatus = 'default';
	            break;
	          case 'rotate':
	            self.chart._options['showXAxis'] = true;
	            self.chart._options['margin'] = { bottom: 140 };
	            self.chart.xAxis.rotateLabels(configObj.rotate.degree);
	            configObj.xLabelStatus = 'rotate';
	            break;
	          case 'hide':
	            self.chart._options['showXAxis'] = false;
	            self.chart._options['margin'] = { bottom: 50 };
	            d3.select('#' + self.targetEl[0].id + '> svg').select('g.nv-axis.nv-x').selectAll('*').remove();
	            configObj.xLabelStatus = 'hide';
	            break;
	        }
	        self.emitConfig(configObj);
	      };
	
	      self.config.isXLabelStatus = function (type) {
	        if (configObj.xLabelStatus === type) {
	          return true;
	        } else {
	          return false;
	        }
	      };
	
	      self.config.setDegree = function (type) {
	        configObj.rotate.degree = type;
	        self.chart.xAxis.rotateLabels(type);
	        self.emitConfig(configObj);
	      };
	
	      self.config.isDegreeEmpty = function () {
	        if (configObj.rotate.degree.length > 0) {
	          return true;
	        } else {
	          configObj.rotate.degree = '-45';
	          self.emitConfig(configObj);
	          return false;
	        }
	      };
	
	      this.chart.style(this.config.style || 'stack');
	
	      this.chart.dispatch.on('stateChange', function (s) {
	        self.config.style = s.style;
	
	        // give some time to animation finish
	        setTimeout(function () {
	          self.emitConfig(self.config);
	        }, 500);
	      });
	    }
	  }, {
	    key: 'getSetting',
	    value: function getSetting(chart) {
	      var self = this;
	      var configObj = self.config;
	
	      // default to visualize xLabel
	      if (typeof configObj.xLabelStatus === 'undefined') {
	        configObj.changeXLabel('default');
	      }
	
	      if (typeof configObj.rotate.degree === 'undefined' || configObj.rotate.degree === '') {
	        configObj.rotate.degree = '-45';
	        self.emitConfig(configObj);
	      }
	
	      return {
	        template: 'app/visualization/builtins/visualization-displayXAxis.html',
	        scope: {
	          config: configObj
	        }
	      };
	    }
	  }]);
	
	  return AreachartVisualization;
	}(_visualizationNvd3chart2.default);
	
	exports.default = AreachartVisualization;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _visualizationNvd3chart = __webpack_require__(174);
	
	var _visualizationNvd3chart2 = _interopRequireDefault(_visualizationNvd3chart);
	
	var _pivot = __webpack_require__(165);
	
	var _pivot2 = _interopRequireDefault(_pivot);
	
	var _moment = __webpack_require__(18);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	/**
	 * Visualize data in line chart
	 */
	var LinechartVisualization = function (_Nvd3ChartVisualizati) {
	  _inherits(LinechartVisualization, _Nvd3ChartVisualizati);
	
	  function LinechartVisualization(targetEl, config) {
	    _classCallCheck(this, LinechartVisualization);
	
	    var _this = _possibleConstructorReturn(this, (LinechartVisualization.__proto__ || Object.getPrototypeOf(LinechartVisualization)).call(this, targetEl, config));
	
	    _this.pivot = new _pivot2.default(config, _this.type());
	
	    try {
	      _this.config.rotate = { degree: config.rotate.degree };
	    } catch (e) {
	      _this.config.rotate = { degree: '-45' };
	    }
	    return _this;
	  }
	
	  _createClass(LinechartVisualization, [{
	    key: 'type',
	    value: function type() {
	      if (this.config.lineWithFocus) {
	        return 'lineWithFocusChart';
	      } else {
	        return 'lineChart';
	      }
	    }
	  }, {
	    key: 'getTransformation',
	    value: function getTransformation() {
	      return this.pivot;
	    }
	  }, {
	    key: 'render',
	    value: function render(pivot) {
	      var d3Data = this.d3DataFromPivot(pivot.schema, pivot.rows, pivot.keys, pivot.groups, pivot.values, false, true, false, true);
	
	      this.xLabels = d3Data.xLabels;
	      _get(LinechartVisualization.prototype.__proto__ || Object.getPrototypeOf(LinechartVisualization.prototype), 'render', this).call(this, d3Data);
	      this.config.changeXLabel(this.config.xLabelStatus);
	    }
	
	    /**
	     * Set new config
	     */
	
	  }, {
	    key: 'setConfig',
	    value: function setConfig(config) {
	      _get(LinechartVisualization.prototype.__proto__ || Object.getPrototypeOf(LinechartVisualization.prototype), 'setConfig', this).call(this, config);
	      this.pivot.setConfig(config);
	
	      // change mode
	      if (this.currentMode !== config.lineWithFocus) {
	        _get(LinechartVisualization.prototype.__proto__ || Object.getPrototypeOf(LinechartVisualization.prototype), 'destroy', this).call(this);
	        this.currentMode = config.lineWithFocus;
	      }
	    }
	  }, {
	    key: 'configureChart',
	    value: function configureChart(chart) {
	      var self = this;
	      var configObj = self.config;
	
	      chart.xAxis.tickFormat(function (d) {
	        if (self.config.isDateFormat) {
	          if (self.config.dateFormat) {
	            return (0, _moment2.default)(new Date(self.xAxisTickFormat(d, self.xLabels))).format(self.config.dateFormat);
	          } else {
	            return (0, _moment2.default)(new Date(self.xAxisTickFormat(d, self.xLabels))).format('YYYY-MM-DD HH:mm:ss');
	          }
	        }
	        return self.xAxisTickFormat(d, self.xLabels);
	      });
	      chart.yAxis.tickFormat(function (d) {
	        if (d === undefined) {
	          return 'N/A';
	        }
	        return self.yAxisTickFormat(d, self.xLabels);
	      });
	      chart.yAxis.axisLabelDistance(50);
	      if (chart.useInteractiveGuideline) {
	        // lineWithFocusChart hasn't got useInteractiveGuideline
	        chart.useInteractiveGuideline(true); // for better UX and performance issue. (https://github.com/novus/nvd3/issues/691)
	      }
	      if (this.config.forceY) {
	        chart.forceY([0]); // force y-axis minimum to 0 for line chart.
	      } else {
	        chart.forceY([]);
	      }
	
	      self.config.changeXLabel = function (type) {
	        switch (type) {
	          case 'default':
	            self.chart._options['showXAxis'] = true;
	            self.chart._options['margin'] = { bottom: 50 };
	            self.chart.xAxis.rotateLabels(0);
	            configObj.xLabelStatus = 'default';
	            break;
	          case 'rotate':
	            self.chart._options['showXAxis'] = true;
	            self.chart._options['margin'] = { bottom: 140 };
	            self.chart.xAxis.rotateLabels(configObj.rotate.degree);
	            configObj.xLabelStatus = 'rotate';
	            break;
	          case 'hide':
	            self.chart._options['showXAxis'] = false;
	            self.chart._options['margin'] = { bottom: 50 };
	            d3.select('#' + self.targetEl[0].id + '> svg').select('g.nv-axis.nv-x').selectAll('*').remove();
	            configObj.xLabelStatus = 'hide';
	            break;
	        }
	        self.emitConfig(configObj);
	      };
	
	      self.config.isXLabelStatus = function (type) {
	        if (configObj.xLabelStatus === type) {
	          return true;
	        } else {
	          return false;
	        }
	      };
	
	      self.config.setDegree = function (type) {
	        configObj.rotate.degree = type;
	        self.chart.xAxis.rotateLabels(type);
	        self.emitConfig(configObj);
	      };
	
	      self.config.setDateFormat = function (format) {
	        configObj.dateFormat = format;
	        self.emitConfig(configObj);
	      };
	    }
	  }, {
	    key: 'getSetting',
	    value: function getSetting(chart) {
	      var self = this;
	      var configObj = self.config;
	
	      // default to visualize xLabel
	      if (typeof configObj.xLabelStatus === 'undefined') {
	        configObj.changeXLabel('default');
	      }
	
	      if (typeof configObj.rotate.degree === 'undefined' || configObj.rotate.degree === '') {
	        configObj.rotate.degree = '-45';
	        self.emitConfig(configObj);
	      }
	
	      return {
	        template: '<div>\n        <label>\n          <input type="checkbox"\n               ng-model="config.forceY"\n               ng-click="save()" />\n          force Y to 0\n        </label>\n        <br/>\n\n        <label>\n          <input type="checkbox"\n               ng-model="config.lineWithFocus"\n               ng-click="save()" />\n          zoom\n        </label>\n        \n        <br/>        \n        <label>\n          <input type="checkbox"\n               ng-model="config.isDateFormat"\n               ng-click="save()" />\n          Date format\n        </label>\n        <span ng-show="config.isDateFormat">\n          <input type="text"\n           placeholder="YYYY-MM-DD HH:mm:ss"\n           ng-model="config.dateFormat"\n           ng-enter="config.setDateFormat(config.dateFormat)"\n           ng-blur="config.setDateFormat(config.dateFormat)"\n            />\n        </span>\n      </div>\n      <ng-include src="\'app/visualization/builtins/visualization-displayXAxis.html\'">\n      </ng-include>',
	        scope: {
	          config: configObj,
	          save: function save() {
	            self.emitConfig(configObj);
	          }
	        }
	      };
	    }
	  }, {
	    key: 'defaultY',
	    value: function defaultY() {
	      return undefined;
	    }
	  }]);
	
	  return LinechartVisualization;
	}(_visualizationNvd3chart2.default);
	
	exports.default = LinechartVisualization;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _visualizationNvd3chart = __webpack_require__(174);
	
	var _visualizationNvd3chart2 = _interopRequireDefault(_visualizationNvd3chart);
	
	var _columnselector = __webpack_require__(168);
	
	var _columnselector2 = _interopRequireDefault(_columnselector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	/**
	 * Visualize data in scatter char
	 */
	var ScatterchartVisualization = function (_Nvd3ChartVisualizati) {
	  _inherits(ScatterchartVisualization, _Nvd3ChartVisualizati);
	
	  function ScatterchartVisualization(targetEl, config) {
	    _classCallCheck(this, ScatterchartVisualization);
	
	    var _this = _possibleConstructorReturn(this, (ScatterchartVisualization.__proto__ || Object.getPrototypeOf(ScatterchartVisualization)).call(this, targetEl, config));
	
	    _this.columnselectorProps = [{
	      name: 'xAxis'
	    }, {
	      name: 'yAxis'
	    }, {
	      name: 'group'
	    }, {
	      name: 'size',
	      tooltip: 'This option is only valid for numeric fields.\n          When data in each axis is discrete, \n          \'number of values in corresponding coordinate\' will be used.\n          Zeppelin considers values as discrete when input values contain a string\n          or the number of distinct values is greater than 5% of the total number of values.\n          This field turns grey when the selected option is invalid.'
	    }];
	    _this.columnselector = new _columnselector2.default(config, _this.columnselectorProps);
	    return _this;
	  }
	
	  _createClass(ScatterchartVisualization, [{
	    key: 'type',
	    value: function type() {
	      return 'scatterChart';
	    }
	  }, {
	    key: 'getTransformation',
	    value: function getTransformation() {
	      return this.columnselector;
	    }
	  }, {
	    key: 'render',
	    value: function render(tableData) {
	      this.tableData = tableData;
	      this.selectDefault();
	      var d3Data = this.setScatterChart(tableData, true);
	      this.xLabels = d3Data.xLabels;
	      this.yLabels = d3Data.yLabels;
	
	      _get(ScatterchartVisualization.prototype.__proto__ || Object.getPrototypeOf(ScatterchartVisualization.prototype), 'render', this).call(this, d3Data);
	    }
	  }, {
	    key: 'configureChart',
	    value: function configureChart(chart) {
	      var self = this;
	
	      chart.xAxis.tickFormat(function (d) {
	        // TODO remove round after bump to nvd3 > 1.8.5
	        return self.xAxisTickFormat(Math.round(d * 1e3) / 1e3, self.xLabels);
	      });
	
	      chart.yAxis.tickFormat(function (d) {
	        // TODO remove round after bump to nvd3 > 1.8.5
	        return self.yAxisTickFormat(Math.round(d * 1e3) / 1e3, self.yLabels);
	      });
	
	      chart.showDistX(true).showDistY(true);
	      // handle the problem of tooltip not showing when muliple points have same value.
	    }
	  }, {
	    key: 'yAxisTickFormat',
	    value: function yAxisTickFormat(d, yLabels) {
	      if (yLabels[d] && (isNaN(parseFloat(yLabels[d])) || !isFinite(yLabels[d]))) {
	        // to handle string type xlabel
	        return yLabels[d];
	      } else {
	        return _get(ScatterchartVisualization.prototype.__proto__ || Object.getPrototypeOf(ScatterchartVisualization.prototype), 'yAxisTickFormat', this).call(this, d);
	      }
	    }
	  }, {
	    key: 'selectDefault',
	    value: function selectDefault() {
	      if (!this.config.xAxis && !this.config.yAxis) {
	        if (this.tableData.columns.length > 1) {
	          this.config.xAxis = this.tableData.columns[0];
	          this.config.yAxis = this.tableData.columns[1];
	        } else if (this.tableData.columns.length === 1) {
	          this.config.xAxis = this.tableData.columns[0];
	        }
	      }
	    }
	  }, {
	    key: 'setScatterChart',
	    value: function setScatterChart(data, refresh) {
	      var xAxis = this.config.xAxis;
	      var yAxis = this.config.yAxis;
	      var group = this.config.group;
	      var size = this.config.size;
	
	      var xValues = [];
	      var yValues = [];
	      var rows = {};
	      var d3g = [];
	
	      var rowNameIndex = {};
	      var colNameIndex = {};
	      var grpNameIndex = {};
	      var rowIndexValue = {};
	      var colIndexValue = {};
	      var grpIndexValue = {};
	      var rowIdx = 0;
	      var colIdx = 0;
	      var grpIdx = 0;
	      var grpName = '';
	
	      var xValue = void 0;
	      var yValue = void 0;
	      var row = void 0;
	
	      if (!xAxis && !yAxis) {
	        return {
	          d3g: []
	        };
	      }
	
	      for (var i = 0; i < data.rows.length; i++) {
	        row = data.rows[i];
	        if (xAxis) {
	          xValue = row[xAxis.index];
	          xValues[i] = xValue;
	        }
	        if (yAxis) {
	          yValue = row[yAxis.index];
	          yValues[i] = yValue;
	        }
	      }
	
	      var isAllDiscrete = xAxis && yAxis && this.isDiscrete(xValues) && this.isDiscrete(yValues) || !xAxis && this.isDiscrete(yValues) || !yAxis && this.isDiscrete(xValues);
	
	      if (isAllDiscrete) {
	        rows = this.setDiscreteScatterData(data);
	      } else {
	        rows = data.rows;
	      }
	
	      if (!group && isAllDiscrete) {
	        grpName = 'count';
	      } else if (!group && !size) {
	        if (xAxis && yAxis) {
	          grpName = '(' + xAxis.name + ', ' + yAxis.name + ')';
	        } else if (xAxis && !yAxis) {
	          grpName = xAxis.name;
	        } else if (!xAxis && yAxis) {
	          grpName = yAxis.name;
	        }
	      } else if (!group && size) {
	        grpName = size.name;
	      }
	
	      var epsilon = 1e-4; // TODO remove after bump to nvd3 > 1.8.5
	
	      for (var _i = 0; _i < rows.length; _i++) {
	        row = rows[_i];
	        if (xAxis) {
	          xValue = row[xAxis.index];
	        }
	        if (yAxis) {
	          yValue = row[yAxis.index];
	        }
	        if (group) {
	          grpName = row[group.index];
	        }
	        var sz = isAllDiscrete ? row[row.length - 1] : size ? row[size.index] : 1;
	
	        if (grpNameIndex[grpName] === undefined) {
	          grpIndexValue[grpIdx] = grpName;
	          grpNameIndex[grpName] = grpIdx++;
	        }
	
	        if (xAxis && rowNameIndex[xValue] === undefined) {
	          rowIndexValue[rowIdx] = xValue;
	          rowNameIndex[xValue] = rowIdx++;
	        }
	
	        if (yAxis && colNameIndex[yValue] === undefined) {
	          colIndexValue[colIdx] = yValue;
	          colNameIndex[yValue] = colIdx++;
	        }
	
	        if (!d3g[grpNameIndex[grpName]]) {
	          d3g[grpNameIndex[grpName]] = {
	            key: grpName,
	            values: []
	          };
	        }
	
	        // TODO remove epsilon jitter after bump to nvd3 > 1.8.5
	        var xval = 0;
	        var yval = 0;
	        if (xAxis) {
	          xval = (isNaN(xValue) ? rowNameIndex[xValue] : parseFloat(xValue)) + Math.random() * epsilon;
	        }
	        if (yAxis) {
	          yval = (isNaN(yValue) ? colNameIndex[yValue] : parseFloat(yValue)) + Math.random() * epsilon;
	        }
	
	        d3g[grpNameIndex[grpName]].values.push({
	          x: xval,
	          y: yval,
	          size: isNaN(parseFloat(sz)) ? 1 : parseFloat(sz)
	        });
	      }
	
	      // TODO remove sort and dedup after bump to nvd3 > 1.8.5
	      var d3gvalues = d3g[grpNameIndex[grpName]].values;
	      d3gvalues.sort(function (a, b) {
	        return a['x'] - b['x'] || a['y'] - b['y'];
	      });
	
	      for (var _i2 = 0; _i2 < d3gvalues.length - 1;) {
	        if (Math.abs(d3gvalues[_i2]['x'] - d3gvalues[_i2 + 1]['x']) < epsilon && Math.abs(d3gvalues[_i2]['y'] - d3gvalues[_i2 + 1]['y']) < epsilon) {
	          d3gvalues.splice(_i2 + 1, 1);
	        } else {
	          _i2++;
	        }
	      }
	
	      return {
	        xLabels: rowIndexValue,
	        yLabels: colIndexValue,
	        d3g: d3g
	      };
	    }
	  }, {
	    key: 'setDiscreteScatterData',
	    value: function setDiscreteScatterData(data) {
	      var xAxis = this.config.xAxis;
	      var yAxis = this.config.yAxis;
	      var group = this.config.group;
	
	      var xValue = void 0;
	      var yValue = void 0;
	      var grp = void 0;
	
	      var rows = {};
	
	      for (var i = 0; i < data.rows.length; i++) {
	        var row = data.rows[i];
	        if (xAxis) {
	          xValue = row[xAxis.index];
	        }
	        if (yAxis) {
	          yValue = row[yAxis.index];
	        }
	        if (group) {
	          grp = row[group.index];
	        }
	
	        var key = xValue + ',' + yValue + ',' + grp;
	
	        if (!rows[key]) {
	          rows[key] = {
	            x: xValue,
	            y: yValue,
	            group: grp,
	            size: 1
	          };
	        } else {
	          rows[key].size++;
	        }
	      }
	
	      // change object into array
	      var newRows = [];
	      for (var r in rows) {
	        if (rows.hasOwnProperty(r)) {
	          var newRow = [];
	          if (xAxis) {
	            newRow[xAxis.index] = rows[r].x;
	          }
	          if (yAxis) {
	            newRow[yAxis.index] = rows[r].y;
	          }
	          if (group) {
	            newRow[group.index] = rows[r].group;
	          }
	          newRow[data.rows[0].length] = rows[r].size;
	          newRows.push(newRow);
	        }
	      }
	      return newRows;
	    }
	  }, {
	    key: 'isDiscrete',
	    value: function isDiscrete(field) {
	      var getUnique = function getUnique(f) {
	        var uniqObj = {};
	        var uniqArr = [];
	        var j = 0;
	        for (var i = 0; i < f.length; i++) {
	          var item = f[i];
	          if (uniqObj[item] !== 1) {
	            uniqObj[item] = 1;
	            uniqArr[j++] = item;
	          }
	        }
	        return uniqArr;
	      };
	
	      for (var i = 0; i < field.length; i++) {
	        if (isNaN(parseFloat(field[i])) && (typeof field[i] === 'string' || field[i] instanceof String)) {
	          return true;
	        }
	      }
	
	      var threshold = 0.05;
	      var unique = getUnique(field);
	      if (unique.length / field.length < threshold) {
	        return true;
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: 'isValidSizeOption',
	    value: function isValidSizeOption(options) {
	      var xValues = [];
	      var yValues = [];
	      var rows = this.tableData.rows;
	
	      for (var i = 0; i < rows.length; i++) {
	        var row = rows[i];
	        var size = row[options.size.index];
	
	        // check if the field is numeric
	        if (isNaN(parseFloat(size)) || !isFinite(size)) {
	          return false;
	        }
	
	        if (options.xAxis) {
	          var x = row[options.xAxis.index];
	          xValues[i] = x;
	        }
	        if (options.yAxis) {
	          var y = row[options.yAxis.index];
	          yValues[i] = y;
	        }
	      }
	
	      // check if all existing fields are discrete
	      var isAllDiscrete = options.xAxis && options.yAxis && this.isDiscrete(xValues) && this.isDiscrete(yValues) || !options.xAxis && this.isDiscrete(yValues) || !options.yAxis && this.isDiscrete(xValues);
	
	      if (isAllDiscrete) {
	        return false;
	      }
	
	      return true;
	    }
	  }]);
	
	  return ScatterchartVisualization;
	}(_visualizationNvd3chart2.default);
	
	exports.default = ScatterchartVisualization;

/***/ }),
/* 181 */
/***/ (function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	AccountController.$inject = ["$rootScope", "$scope", "$http", "$timeout", "baseUrlSrv", "ngToast"];
	angular.module('zeppelinWebApp').controller('AccountCtrl', AccountController);
	
	function AccountController($rootScope, $scope, $http, $timeout, baseUrlSrv, ngToast) {
	  'ngInject';
	
	  $scope.fields = [{
	    'field': 'tokenId',
	    'display': 'Token Id'
	  }, {
	    'field': 'description',
	    'display': 'Description'
	  }, {
	    'field': 'createdAt',
	    'display': 'Creation Date'
	  }, {
	    'field': 'expiresAt',
	    'display': 'Expiration Date'
	  }, {
	    'field': 'disabled',
	    'display': 'Status'
	  }];
	
	  ngToast.dismiss();
	
	  $scope.accessTokens = [];
	
	  $scope.sortField = 'expiresAt';
	  $scope.ascending = true;
	  $scope.token = '';
	  $scope.hasAccessTokenPermission = $rootScope.hasMagpieRole('AccessToken');
	
	  var getAccessTokens = function getAccessTokens() {
	    $http.get(baseUrlSrv.getRestApiBase() + '/magpie/access-token').success(function (data, status, headers, config) {
	      $scope.accessTokens = data;
	
	      console.log('Success %o %o', status, $scope.accessTokens);
	    }).error(function (data, status, headers, config) {
	      if (status === 401) {
	        showToast('You do not have permission on this page', 'danger');
	        setTimeout(function () {
	          window.location = baseUrlSrv.getBase();
	        }, 3000);
	      }
	      console.log('Error %o %o', status, data.message);
	    });
	  };
	
	  $scope.getExpiresWindow = function (date) {
	    var days = Math.floor((Date.parse(date) - new Date()) / 1000 / 60 / 60 / 24);
	
	    if (days < 0) {
	      return 'expired';
	    } else if (days === 1) {
	      return '1 day';
	    } else {
	      return days + ' days';
	    }
	  };
	
	  $scope.addNewToken = function () {
	    $http.post(baseUrlSrv.getRestApiBase() + '/magpie/access-token').success(function (data, status, headers, config) {
	      showToast('Successfully created personal access token.', 'success');
	      $scope.token = data.token;
	      angular.element('#tokenModal').modal('toggle');
	      getAccessTokens();
	      console.log('Success %o %o', status, data.message);
	    }).error(function (data, status, headers, config) {
	      showToast('Error saving personal access token.', 'danger');
	      console.log('Error %o %o', status, data.message);
	    });
	  };
	
	  $scope.copyTokenToClipboard = function () {
	    navigator.clipboard.writeText($scope.token);
	  };
	
	  angular.element('#tokenModal').on('hidden.bs.modal', function (e) {
	    $scope.token = '';
	  });
	
	  $scope.updateTokenStatus = function (tokenId, disabled) {
	    $http.put(baseUrlSrv.getRestApiBase() + '/magpie/access-token/' + tokenId + '/status/' + disabled).success(function (data, status, headers, config) {
	      showToast('Successfully updated personal access token status.', 'success');
	      getAccessTokens();
	      console.log('Success %o %o', status, data.message);
	    }).error(function (data, status, headers, config) {
	      showToast('Error updating personal access token status.', 'danger');
	      console.log('Error %o %o', status, data.message);
	    });
	  };
	
	  $scope.editToken = { tokenId: null, description: null };
	  $scope.openDescriptionModal = function (tokenId, description) {
	    $scope.editToken['description'] = description;
	    $scope.editToken['tokenId'] = tokenId;
	    angular.element('#tokenDescriptionModal').modal('toggle');
	  };
	
	  $scope.updateTokenDescription = function () {
	    $http.put(baseUrlSrv.getRestApiBase() + '/magpie/access-token/' + $scope.editToken.tokenId + '/description', $scope.editToken.description).success(function (data, status, headers, config) {
	      showToast('Successfully updated personal access token description.', 'success');
	      getAccessTokens();
	      console.log('Success %o %o', status, data.message);
	    }).error(function (data, status, headers, config) {
	      showToast('Error updating personal access token description.', 'danger');
	      console.log('Error %o %o', status, data.message);
	    });
	  };
	
	  $scope.deleteToken = function (tokenId) {
	    $http.delete(baseUrlSrv.getRestApiBase() + '/magpie/access-token/' + tokenId).success(function (data, status, headers, config) {
	      showToast('Successfully deleted personal access token.', 'success');
	      getAccessTokens();
	      console.log('Success %o %o', status, data.message);
	    }).error(function (data, status, headers, config) {
	      showToast('Error deleting personal access token.', 'danger');
	      console.log('Error %o %o', status, data.message);
	    });
	  };
	
	  $scope.handleSortClick = function (field) {
	    $timeout(function () {
	      if (field === $scope.sortField) {
	        $scope.ascending = !$scope.ascending;
	      } else {
	        $scope.sortField = field;
	        $scope.ascending = true;
	      }
	    });
	  };
	
	  function showToast(message, type) {
	    var verticalPosition = 'bottom';
	    var timeout = '3000';
	
	    if (type === 'success') {
	      ngToast.success({ content: message, verticalPosition: verticalPosition, timeout: timeout });
	    } else if (type === 'info') {
	      ngToast.info({ content: message, verticalPosition: verticalPosition, timeout: timeout });
	    } else {
	      ngToast.danger({ content: message, verticalPosition: verticalPosition, timeout: timeout });
	    }
	  }
	
	  var init = function init() {
	    getAccessTokens();
	  };
	
	  init();
	}

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	ClusterManagerController.$inject = ["$scope", "ngToast", "ClusterManagerFilter", "ClusterManagerService"];
	__webpack_require__(183);
	
	var _clusterManager = __webpack_require__(187);
	
	var _clusterManager2 = __webpack_require__(188);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /*
	                                                                                                                                                                                                     * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                     * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                     * You may obtain a copy of the License at
	                                                                                                                                                                                                     *
	                                                                                                                                                                                                     *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                     *
	                                                                                                                                                                                                     * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                     * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                     * See the License for the specific language governing permissions and
	                                                                                                                                                                                                     * limitations under the License.
	                                                                                                                                                                                                     */
	
	angular.module('zeppelinWebApp').controller('ClusterManagerCtrl', ClusterManagerController).filter('ClusterManager', _clusterManager.ClusterManagerFilter).service('ClusterManagerService', _clusterManager2.ClusterManagerService);
	
	function ClusterManagerController($scope, ngToast, ClusterManagerFilter, ClusterManagerService) {
	  'ngInject';
	
	  $scope.clustersLoaded = false;
	  $scope.clusters = [];
	  $scope.filteredClusters = $scope.clusters;
	  $scope.filterConfig = {
	    text: '',
	    state: '*',
	    isSortByAsc: true
	  };
	
	  $scope.pagination = {
	    currentPage: 1,
	    itemsPerPage: 10,
	    maxPageCount: 5
	  };
	  $scope.settingCurrentCluster = false;
	
	  ngToast.dismiss();
	
	  /** functions */
	
	  $scope.getClustersInCurrentPage = function (clusters) {
	    var cp = $scope.pagination.currentPage;
	    var itp = $scope.pagination.itemsPerPage;
	    return clusters.slice((cp - 1) * itp, cp * itp);
	  };
	
	  $scope.filterClusters = function (clusters, filterConfig) {
	    // eslint-disable-next-line new-cap
	    $scope.filteredClusters = ClusterManagerFilter(clusters, filterConfig);
	  };
	
	  $scope.stateFilterValueToName = function (filterValue) {
	    if (typeof $scope.states === 'undefined') {
	      return;
	    }
	
	    var index = $scope.states.findIndex(function (state) {
	      return state.value === filterValue;
	    });
	    if (index >= 0 && $scope.states[index]) {
	      return $scope.states[index].name;
	    }
	  };
	
	  $scope.setStateFilterValue = function (filterValue) {
	    $scope.filterConfig.state = filterValue;
	    $scope.filterClusters($scope.clusters, $scope.filterConfig);
	  };
	
	  var onCurrentClusterChange = function onCurrentClusterChange(currentCluster) {
	    $scope.currentCluster = currentCluster;
	    if (currentCluster) {
	      $scope.currentClusterLabel = currentCluster.name;
	    } else {
	      $scope.currentClusterLabel = 'None';
	    }
	  };
	
	  $scope.setCurrentCluster = function (currentCluster) {
	    // construct log messages
	    var confirmationMessage = void 0;
	    var confirmationTitle = void 0;
	    var successMessage = void 0;
	    var currentClusterName = void 0;
	    if (currentCluster) {
	      currentClusterName = currentCluster.name;
	      confirmationTitle = 'Set Current Cluster';
	      confirmationMessage = 'Set your current cluster to ' + currentClusterName + '?';
	      successMessage = 'Set current cluster to: ' + currentClusterName + '.';
	    } else {
	      confirmationTitle = 'Unset Current Cluster';
	      confirmationMessage = 'Unset your current cluster?';
	      successMessage = 'Unset current cluster.';
	    }
	
	    // ask the user to confirm
	    BootstrapDialog.confirm({
	      closable: true,
	      title: confirmationTitle,
	      message: confirmationMessage,
	      callback: function callback(ok) {
	        if (!ok) {
	          // no confirmation, so just return
	          return;
	        }
	
	        // make the request
	        $scope.settingCurrentCluster = true;
	        ClusterManagerService.setCurrentCluster(currentClusterName).then(function () {
	          // success
	          onCurrentClusterChange(currentCluster);
	          ngToast.info(successMessage);
	        }, function (response) {
	          // failure
	          var message = response.data && response.data.message ? response.data.message : 'Server Error';
	          ngToast.danger(message);
	        }).finally(function () {
	          // always unset loading flag after we're done
	          $scope.settingCurrentCluster = false;
	        });
	      }
	    });
	  };
	
	  ClusterManagerService.getClusters().then(function (response) {
	    // parse the response
	    var summary = response.data;
	    var clusters = summary.clusters;
	    var currentClusterId = summary.currentClusterId;
	
	    // determine the current cluster
	    var currentCluster = _.find(clusters, function (c) {
	      return c.clusterId === currentClusterId;
	    });
	    onCurrentClusterChange(currentCluster);
	
	    // set current clusters
	    $scope.clusters = clusters;
	
	    // parse the cluster states
	    var states = $scope.clusters.map(function (j) {
	      return j.state;
	    });
	    states = [].concat(_toConsumableArray(new Set(states))); // remove duplicated states
	
	    $scope.states = [{ name: 'ALL', value: '*' }];
	    for (var i = 0; i < states.length; i++) {
	      $scope.states.push({ name: states[i], value: states[i] });
	    }
	
	    // apply any filters
	    $scope.filterClusters(clusters, $scope.filterConfig);
	
	    // signal that the clusters have been loaded
	    $scope.clustersLoaded = true;
	  }).catch(function (response) {
	    var message = response.data && response.data.message ? response.data.message : 'Error loading clusters';
	    ngToast.danger(message);
	  });
	}

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ClusterModule = exports.ClusterComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	var _moment = __webpack_require__(18);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _cluster = __webpack_require__(184);
	
	var _cluster2 = _interopRequireDefault(_cluster);
	
	__webpack_require__(185);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ClusterController = function () {
	  function ClusterController() {
	    'ngInject';
	
	    _classCallCheck(this, ClusterController);
	
	    if (this.hasHealth()) {
	      var health = this.cluster.health;
	      this.instances = [health.driver].concat(health.workers);
	    } else {
	      this.instances = [];
	    }
	  }
	
	  _createClass(ClusterController, [{
	    key: 'getCluster',
	    value: function getCluster() {
	      return this.cluster;
	    }
	  }, {
	    key: 'getDescription',
	    value: function getDescription() {
	      return this.cluster.description;
	    }
	  }, {
	    key: 'getSparkUiAddress',
	    value: function getSparkUiAddress() {
	      return this.cluster.sparkUiAddress;
	    }
	  }, {
	    key: 'hasWorkers',
	    value: function hasWorkers() {
	      return this.cluster.workerCount > 0;
	    }
	  }, {
	    key: 'hasHealth',
	    value: function hasHealth() {
	      return !_.isUndefined(this.cluster.health);
	    }
	  }, {
	    key: 'getInstances',
	    value: function getInstances() {
	      return this.instances;
	    }
	  }, {
	    key: 'getLastActivity',
	    value: function getLastActivity(timestamp) {
	      if (timestamp) {
	        return _moment2.default.utc(timestamp).fromNow();
	      } else {
	        return 'Never';
	      }
	    }
	  }, {
	    key: 'getFooter',
	    value: function getFooter() {
	      var lastStarted = this.getLastActivity(this.cluster.lastStarted);
	      var lastStopped = this.getLastActivity(this.cluster.lastStopped);
	      return 'Last Started: ' + lastStarted + ', Last Stopped: ' + lastStopped;
	    }
	  }, {
	    key: 'isCurrent',
	    value: function isCurrent() {
	      return this.current;
	    }
	  }, {
	    key: 'isRunning',
	    value: function isRunning() {
	      return this.cluster.state === 'Running';
	    }
	  }, {
	    key: 'setCurrent',
	    value: function setCurrent(current) {
	      if (current) {
	        this.setCurrentCluster(this.cluster);
	      } else {
	        this.setCurrentCluster();
	      }
	    }
	  }, {
	    key: 'isSettingCurrentCluster',
	    value: function isSettingCurrentCluster() {
	      return this.settingCurrentCluster;
	    }
	  }]);
	
	  return ClusterController;
	}();
	
	var ClusterComponent = exports.ClusterComponent = {
	  bindings: {
	    cluster: '<',
	    current: '<',
	    setCurrentCluster: '=',
	    settingCurrentCluster: '<'
	  },
	  template: _cluster2.default,
	  controller: ClusterController
	};
	
	var ClusterModule = exports.ClusterModule = angular.module('zeppelinWebApp').component('cluster', ClusterComponent).name;

/***/ }),
/* 184 */
/***/ (function(module, exports) {

	module.exports = "<!--\nLicensed under the Apache License, Version 2.0 (the \"License\");\nyou may not use this file except in compliance with the License.\nYou may obtain a copy of the License at\n\n    http://www.apache.org/licenses/LICENSE-2.0\n\nUnless required by applicable law or agreed to in writing, software\ndistributed under the License is distributed on an \"AS IS\" BASIS,\nWITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\nSee the License for the specific language governing permissions and\nlimitations under the License.\n-->\n\n<div class=\"cluster\" >\n  <div class=\"cluster-controls\">\n    <a class=\"btn btn-sm btn-default\" data-ng-if=\"$ctrl.getSparkUiAddress()\"\n       data-ng-href=\"{{ $ctrl.getSparkUiAddress() }}\"\n       target=\"_blank\"><span class=\"fa fa-external-link\"></span> View Spark UI</a>\n    <button class=\"btn btn-sm btn-default\"\n            data-ng-if=\"!$ctrl.isCurrent() && $ctrl.isRunning()\"\n            data-ng-disabled=\"$ctrl.isSettingCurrentCluster()\"\n            data-ng-click=\"$ctrl.setCurrent(true)\">Use Cluster</button>\n    <button class=\"btn btn-sm btn-default\"\n            data-ng-if=\"$ctrl.isCurrent()\"\n            data-ng-disabled=\"$ctrl.isSettingCurrentCluster()\"\n            data-ng-click=\"$ctrl.setCurrent()\">Stop Using Cluster</button>\n  </div>\n  <div class=\"cluster-header\">\n    <i class=\"fa fa-check-circle text-info\"\n       data-uib-tooltip=\"Current cluster\"\n       data-tooltip-placement=\"right\"\n       aria-hidden=\"true\"\n       data-ng-if=\"$ctrl.isCurrent()\"></i>\n    <span class=\"name\" data-ng-bind=\"$ctrl.getCluster().name\"></span>\n    <magpie-action-state data-state=\"$ctrl.getCluster().state\"></magpie-action-state>\n    <magpie-health-state data-ng-if=\"$ctrl.hasHealth()\"\n                         data-state=\"$ctrl.getCluster().health\"></magpie-health-state>\n  </div>\n  <div class=\"cluster-description\">\n    <p data-ng-if=\"$ctrl.getDescription()\" data-ng-bind=\"$ctrl.getDescription()\"></p>\n    <div>\n      <span class=\"dt\">Driver Type: </span>\n      <span class=\"dd pre\" data-ng-bind=\"$ctrl.getCluster().driverType.name\"></span>\n    </div>\n    <div data-ng-if=\"$ctrl.hasWorkers()\">\n      <div>\n        <span class=\"dt\">Worker Type: </span>\n        <span class=\"dd\" data-ng-bind=\"$ctrl.getCluster().workerType.name\"></span>\n      </div>\n      <div>\n        <span class=\"dt\">Worker Count: </span>\n        <span class=\"dd\" data-ng-bind=\"$ctrl.getCluster().workerCount\"></span>\n      </div>\n    </div>\n    <div data-ng-if=\"$ctrl.hasHealth()\" class=\"cluster-health\">\n      <magpie-cluster-instances data-instances=\"$ctrl.getInstances()\"></magpie-cluster-instances>\n    </div>\n  </div>\n  <div class=\"cluster-footer\" data-ng-bind=\"$ctrl.getFooter()\"></div>\n</div>\n\n"

/***/ }),
/* 185 */
1,
/* 186 */,
/* 187 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ClusterManagerFilter = ClusterManagerFilter;
	function ClusterManagerFilter() {
	  function filterContext(clusters, filterConfig) {
	    var state = filterConfig.state;
	    var text = filterConfig.text.toLocaleLowerCase();
	
	    var filteredClusters = clusters;
	
	    // filter by text
	    if (text !== '') {
	      filteredClusters = filteredClusters.filter(function (cluster) {
	        return _.any(_.values(cluster), function (v) {
	          return ('' + v).toLocaleLowerCase().contains(text);
	        });
	      });
	    }
	
	    // filter by state
	    if (state !== '*') {
	      filteredClusters = filteredClusters.filter(function (c) {
	        return c.state === state;
	      });
	    }
	
	    // sort by name
	    filteredClusters = filteredClusters.sort(function (cluster) {
	      return cluster.name.toLowerCase();
	    });
	
	    return filteredClusters;
	  }
	  return filterContext;
	}

/***/ }),
/* 188 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	var ClusterManagerService = exports.ClusterManagerService = function () {
	  ClusterManagerService.$inject = ["$http", "$rootScope", "baseUrlSrv"];
	  function ClusterManagerService($http, $rootScope, baseUrlSrv) {
	    'ngInject';
	
	    _classCallCheck(this, ClusterManagerService);
	
	    this.$http = $http;
	    this.$rootScope = $rootScope;
	    this.BaseUrlService = baseUrlSrv;
	  }
	
	  _createClass(ClusterManagerService, [{
	    key: 'setCurrentCluster',
	    value: function setCurrentCluster(clusterName) {
	      var url = this.BaseUrlService.getRestApiBase() + '/magpie/clusters/current';
	      return this.$http({ method: 'POST', url: url, data: { clusterName: clusterName } });
	    }
	  }, {
	    key: 'getClusters',
	    value: function getClusters() {
	      var url = this.BaseUrlService.getRestApiBase() + '/magpie/clusters';
	      return this.$http({ method: 'GET', url: url });
	    }
	  }]);
	
	  return ClusterManagerService;
	}();

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	JobManagerController.$inject = ["$scope", "ngToast", "JobManagerFilter", "JobManagerService"];
	__webpack_require__(190);
	
	var _jobmanager = __webpack_require__(195);
	
	var _jobmanager2 = __webpack_require__(196);
	
	var _jobStatus = __webpack_require__(191);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /*
	                                                                                                                                                                                                     * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                     * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                     * You may obtain a copy of the License at
	                                                                                                                                                                                                     *
	                                                                                                                                                                                                     *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                     *
	                                                                                                                                                                                                     * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                     * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                     * See the License for the specific language governing permissions and
	                                                                                                                                                                                                     * limitations under the License.
	                                                                                                                                                                                                     */
	
	angular.module('zeppelinWebApp').controller('JobManagerCtrl', JobManagerController).filter('JobManager', _jobmanager.JobManagerFilter).service('JobManagerService', _jobmanager2.JobManagerService);
	
	var JobDateSorter = {
	  RECENTLY_UPDATED: 'Recently Update',
	  OLDEST_UPDATED: 'Oldest Updated'
	};
	
	function JobManagerController($scope, ngToast, JobManagerFilter, JobManagerService) {
	  'ngInject';
	
	  $scope.isFilterLoaded = false;
	  $scope.jobs = [];
	  $scope.sorter = {
	    availableDateSorter: Object.keys(JobDateSorter).map(function (key) {
	      return JobDateSorter[key];
	    }),
	    currentDateSorter: JobDateSorter.RECENTLY_UPDATED
	  };
	  $scope.filteredJobs = $scope.jobs;
	  $scope.filterConfig = {
	    isRunningAlwaysTop: true,
	    noteNameFilterValue: '',
	    interpreterFilterValue: '*',
	    isSortByAsc: true
	  };
	
	  $scope.pagination = {
	    currentPage: 1,
	    itemsPerPage: 10,
	    maxPageCount: 5
	  };
	
	  ngToast.dismiss();
	  init();
	
	  /** functions */
	
	  $scope.setJobDateSorter = function (dateSorter) {
	    $scope.sorter.currentDateSorter = dateSorter;
	  };
	
	  $scope.getJobsInCurrentPage = function (jobs) {
	    var cp = $scope.pagination.currentPage;
	    var itp = $scope.pagination.itemsPerPage;
	    return jobs.slice((cp - 1) * itp, cp * itp);
	  };
	
	  var asyncNotebookJobFilter = function asyncNotebookJobFilter(jobs, filterConfig) {
	    return new Promise(function (resolve, reject) {
	      // eslint-disable-next-line new-cap
	      $scope.filteredJobs = JobManagerFilter(jobs, filterConfig);
	      resolve($scope.filteredJobs);
	    });
	  };
	
	  $scope.$watch('sorter.currentDateSorter', function () {
	    $scope.filterConfig.isSortByAsc = $scope.sorter.currentDateSorter === JobDateSorter.OLDEST_UPDATED;
	    asyncNotebookJobFilter($scope.jobs, $scope.filterConfig);
	  });
	
	  $scope.getJobIconByStatus = _jobStatus.getJobIconByStatus;
	  $scope.getJobColorByStatus = _jobStatus.getJobColorByStatus;
	
	  $scope.filterJobs = function (jobs, filterConfig) {
	    asyncNotebookJobFilter(jobs, filterConfig).then(function () {
	      $scope.isFilterLoaded = true;
	    }).catch(function (error) {
	      console.error('Failed to search jobs from server', error);
	    });
	  };
	
	  $scope.filterValueToName = function (filterValue, maxStringLength) {
	    if (typeof $scope.defaultInterpreters === 'undefined') {
	      return;
	    }
	
	    var index = $scope.defaultInterpreters.findIndex(function (intp) {
	      return intp.value === filterValue;
	    });
	    if (typeof $scope.defaultInterpreters[index].name !== 'undefined') {
	      if (typeof maxStringLength !== 'undefined' && maxStringLength > $scope.defaultInterpreters[index].name) {
	        return $scope.defaultInterpreters[index].name.substr(0, maxStringLength - 3) + '...';
	      }
	      return $scope.defaultInterpreters[index].name;
	    } else {
	      return 'NONE';
	    }
	  };
	
	  $scope.setFilterValue = function (filterValue) {
	    $scope.filterConfig.interpreterFilterValue = filterValue;
	    $scope.filterJobs($scope.jobs, $scope.filterConfig);
	  };
	
	  $scope.setJobs = function (jobs) {
	    $scope.jobs = jobs;
	    var interpreters = $scope.jobs.filter(function (j) {
	      return typeof j.interpreter !== 'undefined';
	    }).map(function (j) {
	      return j.interpreter;
	    });
	    interpreters = [].concat(_toConsumableArray(new Set(interpreters))); // remove duplicated interpreters
	
	    $scope.defaultInterpreters = [{ name: 'ALL', value: '*' }];
	    for (var i = 0; i < interpreters.length; i++) {
	      $scope.defaultInterpreters.push({ name: interpreters[i], value: interpreters[i] });
	    }
	  };
	
	  function init() {
	    JobManagerService.getJobs();
	    JobManagerService.subscribeSetJobs($scope, setJobsCallback);
	    JobManagerService.subscribeUpdateJobs($scope, updateJobsCallback);
	
	    $scope.$on('$destroy', function () {
	      JobManagerService.disconnect();
	    });
	  }
	
	  /*
	   ** $scope.$on functions below
	   */
	
	  function setJobsCallback(event, response) {
	    var jobs = response.jobs;
	    $scope.setJobs(jobs);
	    $scope.filterJobs($scope.jobs, $scope.filterConfig);
	  }
	
	  function updateJobsCallback(event, response) {
	    var jobs = $scope.jobs;
	    var jobByNoteId = jobs.reduce(function (acc, j) {
	      var noteId = j.noteId;
	      acc[noteId] = j;
	      return acc;
	    }, {});
	
	    var updatedJobs = response.jobs;
	    updatedJobs.map(function (updatedJob) {
	      if (typeof jobByNoteId[updatedJob.noteId] === 'undefined') {
	        var newItem = angular.copy(updatedJob);
	        jobs.push(newItem);
	        jobByNoteId[updatedJob.noteId] = newItem;
	      } else {
	        var job = jobByNoteId[updatedJob.noteId];
	
	        if (updatedJob.isRemoved === true) {
	          delete jobByNoteId[updatedJob.noteId];
	          var removeIndex = jobs.findIndex(function (j) {
	            return j.noteId === updatedJob.noteId;
	          });
	          if (removeIndex) {
	            jobs.splice(removeIndex, 1);
	          }
	        } else {
	          // update the job
	          job.isRunningJob = updatedJob.isRunningJob;
	          job.noteName = updatedJob.noteName;
	          job.noteType = updatedJob.noteType;
	          job.interpreter = updatedJob.interpreter;
	          job.unixTimeLastRun = updatedJob.unixTimeLastRun;
	          job.paragraphs = updatedJob.paragraphs;
	        }
	      }
	    });
	    $scope.filterJobs(jobs, $scope.filterConfig);
	  }
	}

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.JobModule = exports.JobComponent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	var _moment = __webpack_require__(18);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _paragraph = __webpack_require__(161);
	
	var _jobStatus = __webpack_require__(191);
	
	var _job = __webpack_require__(192);
	
	var _job2 = _interopRequireDefault(_job);
	
	__webpack_require__(193);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var JobController = function () {
	  JobController.$inject = ["$http", "JobManagerService"];
	  function JobController($http, JobManagerService) {
	    'ngInject';
	
	    _classCallCheck(this, JobController);
	
	    this.$http = $http;
	    this.JobManagerService = JobManagerService;
	  }
	
	  _createClass(JobController, [{
	    key: 'isRunning',
	    value: function isRunning() {
	      return this.note.isRunningJob;
	    }
	  }, {
	    key: 'getParagraphs',
	    value: function getParagraphs() {
	      return this.note.paragraphs;
	    }
	  }, {
	    key: 'getNoteId',
	    value: function getNoteId() {
	      return this.note.noteId;
	    }
	  }, {
	    key: 'getNoteName',
	    value: function getNoteName() {
	      return this.note.noteName;
	    }
	  }, {
	    key: 'runJob',
	    value: function runJob() {
	      var _this = this;
	
	      BootstrapDialog.confirm({
	        closable: true,
	        title: 'Job Dialog',
	        message: 'Run all paragraphs?',
	        callback: function callback(clickOk) {
	          if (!clickOk) {
	            return;
	          }
	
	          var noteId = _this.getNoteId();
	          // if the request is handled successfully, the job page will get updated using websocket
	          _this.JobManagerService.sendRunJobRequest(noteId).catch(function (response) {
	            var message = response.data && response.data.message ? response.data.message : 'SERVER ERROR';
	            _this.showErrorDialog('Execution Failure', message);
	          });
	        }
	      });
	    }
	  }, {
	    key: 'stopJob',
	    value: function stopJob() {
	      var _this2 = this;
	
	      BootstrapDialog.confirm({
	        closable: true,
	        title: 'Job Dialog',
	        message: 'Stop all paragraphs?',
	        callback: function callback(clickOk) {
	          if (!clickOk) {
	            return;
	          }
	
	          var noteId = _this2.getNoteId();
	          // if the request is handled successfully, the job page will get updated using websocket
	          _this2.JobManagerService.sendStopJobRequest(noteId).catch(function (response) {
	            var message = response.data && response.data.message ? response.data.message : 'SERVER ERROR';
	            _this2.showErrorDialog('Stop Failure', message);
	          });
	        }
	      });
	    }
	  }, {
	    key: 'showErrorDialog',
	    value: function showErrorDialog(title, errorMessage) {
	      if (!errorMessage) {
	        errorMessage = 'SERVER ERROR';
	      }
	      BootstrapDialog.alert({
	        closable: true,
	        title: title,
	        message: _.escape(errorMessage)
	      });
	    }
	  }, {
	    key: 'lastExecuteTime',
	    value: function lastExecuteTime() {
	      var timestamp = this.note.unixTimeLastRun;
	      return _moment2.default.unix(timestamp / 1000).fromNow();
	    }
	  }, {
	    key: 'getInterpreterName',
	    value: function getInterpreterName() {
	      return typeof this.note.interpreter === 'undefined' ? 'interpreter is not set' : this.note.interpreter;
	    }
	  }, {
	    key: 'getInterpreterNameStyle',
	    value: function getInterpreterNameStyle() {
	      return typeof this.note.interpreter === 'undefined' ? { color: 'gray' } : { color: 'black' };
	    }
	  }, {
	    key: 'getJobTypeIcon',
	    value: function getJobTypeIcon() {
	      var noteType = this.note.noteType;
	      if (noteType === 'normal') {
	        return 'icon-doc';
	      } else if (noteType === 'cron') {
	        return 'icon-clock';
	      } else {
	        return 'icon-question';
	      }
	    }
	  }, {
	    key: 'getJobColorByStatus',
	    value: function getJobColorByStatus(status) {
	      return (0, _jobStatus.getJobColorByStatus)(status);
	    }
	  }, {
	    key: 'getJobIconByStatus',
	    value: function getJobIconByStatus(status) {
	      return (0, _jobStatus.getJobIconByStatus)(status);
	    }
	  }, {
	    key: 'getProgress',
	    value: function getProgress() {
	      var paragraphs = this.getParagraphs();
	      var paragraphStatuses = paragraphs.map(function (p) {
	        return p.status;
	      });
	      var runningOrFinishedParagraphs = paragraphStatuses.filter(function (status) {
	        return status === _paragraph.ParagraphStatus.RUNNING || status === _paragraph.ParagraphStatus.FINISHED;
	      });
	
	      var totalCount = paragraphStatuses.length;
	      var runningCount = runningOrFinishedParagraphs.length;
	      var result = Math.ceil(runningCount / totalCount * 100);
	      result = isNaN(result) ? 0 : result;
	
	      return result + '%';
	    }
	  }, {
	    key: 'showPercentProgressBar',
	    value: function showPercentProgressBar() {
	      return this.getProgress() > 0 && this.getProgress() < 100;
	    }
	  }]);
	
	  return JobController;
	}();
	
	var JobComponent = exports.JobComponent = {
	  bindings: {
	    note: '<'
	  },
	  template: _job2.default,
	  controller: JobController
	};
	
	var JobModule = exports.JobModule = angular.module('zeppelinWebApp').component('job', JobComponent).name;

/***/ }),
/* 191 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getJobIconByStatus = getJobIconByStatus;
	exports.getJobColorByStatus = getJobColorByStatus;
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	var JobStatus = exports.JobStatus = {
	  READY: 'READY',
	  FINISHED: 'FINISHED',
	  ABORT: 'ABORT',
	  ERROR: 'ERROR',
	  PENDING: 'PENDING',
	  RUNNING: 'RUNNING'
	};
	
	function getJobIconByStatus(jobStatus) {
	  if (jobStatus === JobStatus.READY) {
	    return 'fa fa-circle-o';
	  } else if (jobStatus === JobStatus.FINISHED) {
	    return 'fa fa-circle';
	  } else if (jobStatus === JobStatus.ABORT) {
	    return 'fa fa-circle';
	  } else if (jobStatus === JobStatus.ERROR) {
	    return 'fa fa-circle';
	  } else if (jobStatus === JobStatus.PENDING) {
	    return 'fa fa-circle';
	  } else if (jobStatus === JobStatus.RUNNING) {
	    return 'fa fa-spinner';
	  }
	}
	
	function getJobColorByStatus(jobStatus) {
	  if (jobStatus === JobStatus.READY) {
	    return 'green';
	  } else if (jobStatus === JobStatus.FINISHED) {
	    return 'green';
	  } else if (jobStatus === JobStatus.ABORT) {
	    return 'orange';
	  } else if (jobStatus === JobStatus.ERROR) {
	    return 'red';
	  } else if (jobStatus === JobStatus.PENDING) {
	    return 'gray';
	  } else if (jobStatus === JobStatus.RUNNING) {
	    return 'blue';
	  }
	}

/***/ }),
/* 192 */
/***/ (function(module, exports) {

	module.exports = "<!--\nLicensed under the Apache License, Version 2.0 (the \"License\");\nyou may not use this file except in compliance with the License.\nYou may obtain a copy of the License at\n\n    http://www.apache.org/licenses/LICENSE-2.0\n\nUnless required by applicable law or agreed to in writing, software\ndistributed under the License is distributed on an \"AS IS\" BASIS,\nWITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\nSee the License for the specific language governing permissions and\nlimitations under the License.\n-->\n\n<div class=\"job\" >\n  <div>\n    <!-- job control: start -->\n    <div id=\"{{$ctrl.getNoteId()}}_control\" class=\"control\">\n      <span ng-bind=\"$ctrl.lastExecuteTime()\"></span>\n      <span>\n        <span ng-bind=\"$ctrl.isRunning() ? 'RUNNING' : 'READY'\"></span>\n      </span>\n\n      <span ng-if=\"$ctrl.isRunning()\" ng-bind=\"$ctrl.getProgress()\"></span>\n\n      <span\n        class=\"job-control-btn\" tooltip-placement=\"left\"\n        uib-tooltip-html=\"!$ctrl.isRunning() ? 'Start All Paragraphs' : 'Stop All Paragraphs'\"\n        ng-click=\"!$ctrl.isRunning() ? $ctrl.runJob() : $ctrl.stopJob()\"\n        ng-class=\"!$ctrl.isRunning() ? 'icon-control-play' : 'icon-control-pause'\"\n        ng-style=\"{'color': $ctrl.isRunning() ? '#CD5C5C' : '#3071A9'}\">\n      </span>\n    </div>\n    <!-- job control: end -->\n\n    <span class=\"job-types\">\n      <i ng-class=\"$ctrl.getJobTypeIcon()\"></i>\n    </span>\n    <a style=\"text-decoration: none !important;\" ng-href=\"#/notebook/{{$ctrl.getNoteId()}}\">\n      <span ng-bind=\"$ctrl.getNoteName() + ' - '\"></span>\n      <span ng-style=\"$ctrl.getInterpreterNameStyle()\"\n            ng-bind=\"$ctrl.getInterpreterName()\">\n      </span>\n    </a>\n    <!-- job progress bar: start -->\n    <div id=\"{{$ctrl.getNoteId()}}_runControl\" class=\"runControl\">\n      <div id=\"{{$ctrl.getNoteId()}}_progress\" class=\"progress\" ng-if=\"$ctrl.isRunning() === true\">\n        <div class=\"progress-bar\" role=\"progressbar\"\n             ng-style=\"$ctrl.showPercentProgressBar() ? { 'width': $ctrl.getProgress() } : { 'width': '100%' }\"\n             ng-class=\"$ctrl.showPercentProgressBar() ? '' : 'progress-bar-striped active'\">\n        </div>\n      </div>\n    </div>\n    <!-- job progress bar: end -->\n  </div>\n\n  <div>\n    <span ng-repeat=\"paragraph in $ctrl.getParagraphs()\">\n      <a style=\"text-decoration: none !important;\"\n         ng-href=\"#/notebook/{{$ctrl.getNoteId()}}?paragraph={{paragraph.id}}\">\n        <i ng-style=\"{'color': $ctrl.getJobColorByStatus(paragraph.status)}\"\n           ng-class=\"$ctrl.getJobIconByStatus(paragraph.status)\"\n           tooltip-placement=\"top-left\"\n           uib-tooltip=\"{{paragraph.name}} is {{paragraph.status}}\">\n        </i>\n      </a>\n    </span>\n  </div>\n</div>\n\n"

/***/ }),
/* 193 */
1,
/* 194 */,
/* 195 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.JobManagerFilter = JobManagerFilter;
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	function JobManagerFilter() {
	  function filterContext(jobs, filterConfig) {
	    var interpreter = filterConfig.interpreterFilterValue;
	    var noteName = filterConfig.noteNameFilterValue;
	    var isSortByAsc = filterConfig.isSortByAsc;
	    var filteredJobs = jobs;
	
	    if (typeof interpreter === 'undefined') {
	      filteredJobs = filteredJobs.filter(function (jobItem) {
	        return typeof jobItem.interpreter === 'undefined';
	      });
	    } else if (interpreter !== '*') {
	      filteredJobs = filteredJobs.filter(function (j) {
	        return j.interpreter === interpreter;
	      });
	    }
	
	    // filter by note name
	    if (noteName !== '') {
	      filteredJobs = filteredJobs.filter(function (jobItem) {
	        var lowerFilterValue = noteName.toLocaleLowerCase();
	        var lowerNotebookName = jobItem.noteName.toLocaleLowerCase();
	        return lowerNotebookName.match(new RegExp('.*' + lowerFilterValue + '.*'));
	      });
	    }
	
	    // sort by name
	    filteredJobs = filteredJobs.sort(function (jobItem) {
	      return jobItem.noteName.toLowerCase();
	    });
	
	    // sort by timestamp
	    filteredJobs = filteredJobs.sort(function (x, y) {
	      if (isSortByAsc) {
	        return x.unixTimeLastRun - y.unixTimeLastRun;
	      } else {
	        return y.unixTimeLastRun - x.unixTimeLastRun;
	      }
	    });
	
	    return filteredJobs;
	  }
	  return filterContext;
	}

/***/ }),
/* 196 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	var JobManagerService = exports.JobManagerService = function () {
	  JobManagerService.$inject = ["$http", "$rootScope", "baseUrlSrv", "websocketMsgSrv"];
	  function JobManagerService($http, $rootScope, baseUrlSrv, websocketMsgSrv) {
	    'ngInject';
	
	    _classCallCheck(this, JobManagerService);
	
	    this.$http = $http;
	    this.$rootScope = $rootScope;
	    this.BaseUrlService = baseUrlSrv;
	    this.WebsocketMessageService = websocketMsgSrv;
	  }
	
	  _createClass(JobManagerService, [{
	    key: 'sendStopJobRequest',
	    value: function sendStopJobRequest(noteId) {
	      var apiURL = this.BaseUrlService.getRestApiBase() + ('/notebook/job/' + noteId);
	      return this.$http({ method: 'DELETE', url: apiURL });
	    }
	  }, {
	    key: 'sendRunJobRequest',
	    value: function sendRunJobRequest(noteId) {
	      var apiURL = this.BaseUrlService.getRestApiBase() + ('/notebook/job/' + noteId);
	      return this.$http({ method: 'POST', url: apiURL });
	    }
	  }, {
	    key: 'getJobs',
	    value: function getJobs() {
	      this.WebsocketMessageService.getJobs();
	    }
	  }, {
	    key: 'disconnect',
	    value: function disconnect() {
	      this.WebsocketMessageService.disconnectJobEvent();
	    }
	  }, {
	    key: 'subscribeSetJobs',
	    value: function subscribeSetJobs(controllerScope, receiveCallback) {
	      var event = 'jobmanager:set-jobs';
	      console.log('(Event) Subscribed: ' + event);
	      var unsubscribeHandler = this.$rootScope.$on(event, receiveCallback);
	
	      controllerScope.$on('$destroy', function () {
	        console.log('(Event) Unsubscribed: ' + event);
	        unsubscribeHandler();
	      });
	    }
	  }, {
	    key: 'subscribeUpdateJobs',
	    value: function subscribeUpdateJobs(controllerScope, receiveCallback) {
	      var event = 'jobmanager:update-jobs';
	      console.log('(Event) Subscribed: ' + event);
	      var unsubscribeHandler = this.$rootScope.$on(event, receiveCallback);
	
	      controllerScope.$on('$destroy', function () {
	        console.log('(Event) Unsubscribed: ' + event);
	        unsubscribeHandler();
	      });
	    }
	  }]);
	
	  return JobManagerService;
	}();

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	InterpreterCtrl.$inject = ["$rootScope", "$scope", "$http", "baseUrlSrv", "ngToast", "$timeout", "$route"];
	var _paragraph = __webpack_require__(161);
	
	angular.module('zeppelinWebApp').controller('InterpreterCtrl', InterpreterCtrl); /*
	                                                                                  * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                  * you may not use this file except in compliance with the License.
	                                                                                  * You may obtain a copy of the License at
	                                                                                  *
	                                                                                  *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                  *
	                                                                                  * Unless required by applicable law or agreed to in writing, software
	                                                                                  * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                  * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                  * See the License for the specific language governing permissions and
	                                                                                  * limitations under the License.
	                                                                                  */
	
	function InterpreterCtrl($rootScope, $scope, $http, baseUrlSrv, ngToast, $timeout, $route) {
	  'ngInject';
	
	  var interpreterSettingsTmp = [];
	  $scope.interpreterSettings = [];
	  $scope.availableInterpreters = {};
	  $scope.showAddNewSetting = false;
	  $scope.showRepositoryInfo = false;
	  $scope.searchInterpreter = '';
	  $scope._ = _;
	  $scope.interpreterPropertyTypes = [];
	  ngToast.dismiss();
	
	  $scope.openPermissions = function () {
	    $scope.showInterpreterAuth = true;
	  };
	
	  $scope.closePermissions = function () {
	    $scope.showInterpreterAuth = false;
	  };
	
	  var getSelectJson = function getSelectJson() {
	    var selectJson = {
	      tags: true,
	      minimumInputLength: 3,
	      multiple: true,
	      tokenSeparators: [',', ' '],
	      ajax: {
	        url: function url(params) {
	          if (!params.term) {
	            return false;
	          }
	          return baseUrlSrv.getRestApiBase() + '/security/userlist/' + params.term;
	        },
	        delay: 250,
	        processResults: function processResults(data, params) {
	          var results = [];
	
	          if (data.body.users.length !== 0) {
	            var users = [];
	            for (var len = 0; len < data.body.users.length; len++) {
	              users.push({
	                'id': data.body.users[len],
	                'text': data.body.users[len]
	              });
	            }
	            results.push({
	              'text': 'Users :',
	              'children': users
	            });
	          }
	          if (data.body.roles.length !== 0) {
	            var roles = [];
	            for (var _len = 0; _len < data.body.roles.length; _len++) {
	              roles.push({
	                'id': data.body.roles[_len],
	                'text': data.body.roles[_len]
	              });
	            }
	            results.push({
	              'text': 'Roles :',
	              'children': roles
	            });
	          }
	          return {
	            results: results,
	            pagination: {
	              more: false
	            }
	          };
	        },
	        cache: false
	      }
	    };
	    return selectJson;
	  };
	
	  $scope.togglePermissions = function (intpName) {
	    angular.element('#' + intpName + 'Owners').select2(getSelectJson());
	    if ($scope.showInterpreterAuth) {
	      $scope.closePermissions();
	    } else {
	      $scope.openPermissions();
	    }
	  };
	
	  $scope.$on('ngRenderFinished', function (event, data) {
	    for (var setting = 0; setting < $scope.interpreterSettings.length; setting++) {
	      angular.element('#' + $scope.interpreterSettings[setting].name + 'Owners').select2(getSelectJson());
	    }
	  });
	
	  var getInterpreterSettings = function getInterpreterSettings() {
	    $http.get(baseUrlSrv.getRestApiBase() + '/interpreter/setting').then(function (res) {
	      $scope.interpreterSettings = res.data.body;
	      checkDownloadingDependencies();
	    }).catch(function (res) {
	      if (res.status === 401) {
	        ngToast.danger({
	          content: 'You don\'t have permission on this page',
	          verticalPosition: 'bottom',
	          timeout: '3000'
	        });
	        setTimeout(function () {
	          window.location = baseUrlSrv.getBase();
	        }, 3000);
	      }
	      console.log('Error %o %o', res.status, res.data ? res.data.message : '');
	    });
	  };
	
	  var checkDownloadingDependencies = function checkDownloadingDependencies() {
	    var isDownloading = false;
	    for (var index = 0; index < $scope.interpreterSettings.length; index++) {
	      var setting = $scope.interpreterSettings[index];
	      if (setting.status === 'DOWNLOADING_DEPENDENCIES') {
	        isDownloading = true;
	      }
	
	      if (setting.status === _paragraph.ParagraphStatus.ERROR || setting.errorReason) {
	        ngToast.danger({ content: 'Error setting properties for interpreter \'' + setting.group + '.' + setting.name + '\': ' + setting.errorReason,
	          verticalPosition: 'top',
	          dismissOnTimeout: false
	        });
	      }
	    }
	
	    if (isDownloading) {
	      $timeout(function () {
	        if ($route.current.$$route.originalPath === '/interpreter') {
	          getInterpreterSettings();
	        }
	      }, 2000);
	    }
	  };
	
	  var getAvailableInterpreters = function getAvailableInterpreters() {
	    $http.get(baseUrlSrv.getRestApiBase() + '/interpreter').then(function (res) {
	      $scope.availableInterpreters = res.data.body;
	    }).catch(function (res) {
	      console.log('Error %o %o', res.status, res.data ? res.data.message : '');
	    });
	  };
	
	  var getAvailableInterpreterPropertyWidgets = function getAvailableInterpreterPropertyWidgets() {
	    $http.get(baseUrlSrv.getRestApiBase() + '/interpreter/property/types').then(function (res) {
	      $scope.interpreterPropertyTypes = res.data.body;
	    }).catch(function (res) {
	      console.log('Error %o %o', res.status, res.data ? res.data.message : '');
	    });
	  };
	
	  var emptyNewProperty = function emptyNewProperty(object) {
	    angular.extend(object, { propertyValue: '', propertyKey: '', propertyType: $scope.interpreterPropertyTypes[0] });
	  };
	
	  var emptyNewDependency = function emptyNewDependency(object) {
	    angular.extend(object, { depArtifact: '', depExclude: '' });
	  };
	
	  var removeTMPSettings = function removeTMPSettings(index) {
	    interpreterSettingsTmp.splice(index, 1);
	  };
	
	  $scope.copyOriginInterpreterSettingProperties = function (settingId) {
	    var index = _.findIndex($scope.interpreterSettings, { 'id': settingId });
	    interpreterSettingsTmp[index] = angular.copy($scope.interpreterSettings[index]);
	  };
	
	  $scope.setPerNoteOption = function (settingId, sessionOption) {
	    var option = void 0;
	    if (settingId === undefined) {
	      option = $scope.newInterpreterSetting.option;
	    } else {
	      var index = _.findIndex($scope.interpreterSettings, { 'id': settingId });
	      var setting = $scope.interpreterSettings[index];
	      option = setting.option;
	    }
	
	    if (sessionOption === 'isolated') {
	      option.perNote = sessionOption;
	      option.session = false;
	      option.process = true;
	    } else if (sessionOption === 'scoped') {
	      option.perNote = sessionOption;
	      option.session = true;
	      option.process = false;
	    } else {
	      option.perNote = 'shared';
	      option.session = false;
	      option.process = false;
	    }
	  };
	
	  $scope.defaultValueByType = function (setting) {
	    if (setting.propertyType === 'checkbox') {
	      setting.propertyValue = false;
	      return;
	    }
	
	    setting.propertyValue = '';
	  };
	
	  $scope.setPerUserOption = function (settingId, sessionOption) {
	    var option = void 0;
	    if (settingId === undefined) {
	      option = $scope.newInterpreterSetting.option;
	    } else {
	      var index = _.findIndex($scope.interpreterSettings, { 'id': settingId });
	      var setting = $scope.interpreterSettings[index];
	      option = setting.option;
	    }
	
	    if (sessionOption === 'isolated') {
	      option.perUser = sessionOption;
	      option.session = false;
	      option.process = true;
	    } else if (sessionOption === 'scoped') {
	      option.perUser = sessionOption;
	      option.session = true;
	      option.process = false;
	    } else {
	      option.perUser = 'shared';
	      option.session = false;
	      option.process = false;
	    }
	  };
	
	  $scope.getPerNoteOption = function (settingId) {
	    var option = void 0;
	    if (settingId === undefined) {
	      option = $scope.newInterpreterSetting.option;
	    } else {
	      var index = _.findIndex($scope.interpreterSettings, { 'id': settingId });
	      var setting = $scope.interpreterSettings[index];
	      option = setting.option;
	    }
	
	    if (option.perNote === 'scoped') {
	      return 'scoped';
	    } else if (option.perNote === 'isolated') {
	      return 'isolated';
	    } else {
	      return 'shared';
	    }
	  };
	
	  $scope.getPerUserOption = function (settingId) {
	    var option = void 0;
	    if (settingId === undefined) {
	      option = $scope.newInterpreterSetting.option;
	    } else {
	      var index = _.findIndex($scope.interpreterSettings, { 'id': settingId });
	      var setting = $scope.interpreterSettings[index];
	      option = setting.option;
	    }
	
	    if (option.perUser === 'scoped') {
	      return 'scoped';
	    } else if (option.perUser === 'isolated') {
	      return 'isolated';
	    } else {
	      return 'shared';
	    }
	  };
	
	  $scope.getInterpreterRunningOption = function (settingId) {
	    var sharedModeName = 'shared';
	
	    var globallyModeName = 'Globally';
	    var perNoteModeName = 'Per Note';
	    var perUserModeName = 'Per User';
	
	    var option = void 0;
	    if (settingId === undefined) {
	      option = $scope.newInterpreterSetting.option;
	    } else {
	      var index = _.findIndex($scope.interpreterSettings, { 'id': settingId });
	      var setting = $scope.interpreterSettings[index];
	      option = setting.option;
	    }
	
	    var perNote = option.perNote;
	    var perUser = option.perUser;
	
	    // Globally == shared_perNote + shared_perUser
	    if (perNote === sharedModeName && perUser === sharedModeName) {
	      return globallyModeName;
	    }
	
	    if ($rootScope.ticket.ticket === 'anonymous' && $rootScope.ticket.roles === '[]') {
	      if (perNote !== undefined && typeof perNote === 'string' && perNote !== '') {
	        return perNoteModeName;
	      }
	    } else if ($rootScope.ticket.ticket !== 'anonymous') {
	      if (perNote !== undefined && typeof perNote === 'string' && perNote !== '') {
	        if (perUser !== undefined && typeof perUser === 'string' && perUser !== '') {
	          return perUserModeName;
	        }
	        return perNoteModeName;
	      }
	    }
	
	    option.perNote = sharedModeName;
	    option.perUser = sharedModeName;
	    return globallyModeName;
	  };
	
	  $scope.setInterpreterRunningOption = function (settingId, isPerNoteMode, isPerUserMode) {
	    var option = void 0;
	    if (settingId === undefined) {
	      option = $scope.newInterpreterSetting.option;
	    } else {
	      var index = _.findIndex($scope.interpreterSettings, { 'id': settingId });
	      var setting = $scope.interpreterSettings[index];
	      option = setting.option;
	    }
	    option.perNote = isPerNoteMode;
	    option.perUser = isPerUserMode;
	  };
	
	  $scope.updateInterpreterSetting = function (form, settingId) {
	    var thisConfirm = BootstrapDialog.confirm({
	      closable: false,
	      closeByBackdrop: false,
	      closeByKeyboard: false,
	      title: '',
	      message: 'Do you want to update this interpreter and restart with new settings?',
	      callback: function callback(result) {
	        if (result) {
	          var index = _.findIndex($scope.interpreterSettings, { 'id': settingId });
	          var setting = $scope.interpreterSettings[index];
	          if (setting.propertyKey !== '' || setting.propertyKey) {
	            $scope.addNewInterpreterProperty(settingId);
	          }
	          if (setting.depArtifact !== '' || setting.depArtifact) {
	            $scope.addNewInterpreterDependency(settingId);
	          }
	          // add missing field of option
	          if (!setting.option) {
	            setting.option = {};
	          }
	          if (setting.option.isExistingProcess === undefined) {
	            setting.option.isExistingProcess = false;
	          }
	          if (setting.option.setPermission === undefined) {
	            setting.option.setPermission = false;
	          }
	          if (setting.option.isUserImpersonate === undefined) {
	            setting.option.isUserImpersonate = false;
	          }
	          if (!($scope.getInterpreterRunningOption(settingId) === 'Per User' && $scope.getPerUserOption(settingId) === 'isolated')) {
	            setting.option.isUserImpersonate = false;
	          }
	          if (setting.option.remote === undefined) {
	            // remote always true for now
	            setting.option.remote = true;
	          }
	          setting.option.owners = angular.element('#' + setting.name + 'Owners').val();
	          for (var i = 0; i < setting.option.owners.length; i++) {
	            setting.option.owners[i] = setting.option.owners[i].trim();
	          }
	
	          var request = {
	            option: angular.copy(setting.option),
	            properties: angular.copy(setting.properties),
	            dependencies: angular.copy(setting.dependencies)
	          };
	
	          thisConfirm.$modalFooter.find('button').addClass('disabled');
	          thisConfirm.$modalFooter.find('button:contains("OK")').html('<i class="fa fa-circle-o-notch fa-spin"></i> Saving Setting');
	
	          $http.put(baseUrlSrv.getRestApiBase() + '/interpreter/setting/' + settingId, request).then(function (res) {
	            $scope.interpreterSettings[index] = res.data.body;
	            removeTMPSettings(index);
	            checkDownloadingDependencies();
	            thisConfirm.close();
	          }).catch(function (res) {
	            var message = res.data ? res.data.message : 'Could not connect to server.';
	            console.log('Error %o %o', res.status, message);
	            ngToast.danger({ content: message, verticalPosition: 'bottom' });
	            form.$show();
	            thisConfirm.close();
	          });
	          return false;
	        } else {
	          form.$show();
	        }
	      }
	    });
	  };
	
	  $scope.resetInterpreterSetting = function (settingId) {
	    var index = _.findIndex($scope.interpreterSettings, { 'id': settingId });
	
	    // Set the old settings back
	    $scope.interpreterSettings[index] = angular.copy(interpreterSettingsTmp[index]);
	    removeTMPSettings(index);
	  };
	
	  $scope.removeInterpreterSetting = function (settingId) {
	    BootstrapDialog.confirm({
	      closable: true,
	      title: '',
	      message: 'Do you want to delete this interpreter setting?',
	      callback: function callback(result) {
	        if (result) {
	          $http.delete(baseUrlSrv.getRestApiBase() + '/interpreter/setting/' + settingId).then(function (res) {
	            var index = _.findIndex($scope.interpreterSettings, { 'id': settingId });
	            $scope.interpreterSettings.splice(index, 1);
	          }).catch(function (res) {
	            console.log('Error %o %o', res.status, res.data ? res.data.message : '');
	          });
	        }
	      }
	    });
	  };
	
	  $scope.newInterpreterGroupChange = function () {
	    var el = _.pluck(_.filter($scope.availableInterpreters, { 'name': $scope.newInterpreterSetting.group }), 'properties');
	    var properties = {};
	    for (var i = 0; i < el.length; i++) {
	      var intpInfo = el[i];
	      for (var key in intpInfo) {
	        if (intpInfo.hasOwnProperty(key)) {
	          properties[key] = {
	            value: intpInfo[key].defaultValue,
	            description: intpInfo[key].description,
	            type: intpInfo[key].type
	          };
	        }
	      }
	    }
	    $scope.newInterpreterSetting.properties = properties;
	  };
	
	  $scope.restartInterpreterSetting = function (settingId) {
	    BootstrapDialog.confirm({
	      closable: true,
	      title: '',
	      message: 'Do you want to restart this interpreter?',
	      callback: function callback(result) {
	        if (result) {
	          $http.put(baseUrlSrv.getRestApiBase() + '/interpreter/setting/restart/' + settingId).then(function (res) {
	            var index = _.findIndex($scope.interpreterSettings, { 'id': settingId });
	            $scope.interpreterSettings[index] = res.data.body;
	            ngToast.info('Interpreter stopped. Will be lazily started on next run.');
	          }).catch(function (res) {
	            var errorMsg = res.data !== null ? res.data.message : 'Could not connect to server.';
	            console.log('Error %o %o', res.status, errorMsg);
	            ngToast.danger(errorMsg);
	          });
	        }
	      }
	    });
	  };
	
	  $scope.addNewInterpreterSetting = function () {
	    // user input validation on interpreter creation
	    if (!$scope.newInterpreterSetting.name || !$scope.newInterpreterSetting.name.trim() || !$scope.newInterpreterSetting.group) {
	      BootstrapDialog.alert({
	        closable: true,
	        title: 'Add interpreter',
	        message: 'Please fill in interpreter name and choose a group'
	      });
	      return;
	    }
	
	    if ($scope.newInterpreterSetting.name.indexOf('.') >= 0) {
	      BootstrapDialog.alert({
	        closable: true,
	        title: 'Add interpreter',
	        message: '\'.\' is invalid for interpreter name'
	      });
	      return;
	    }
	
	    if (_.findIndex($scope.interpreterSettings, { 'name': $scope.newInterpreterSetting.name }) >= 0) {
	      BootstrapDialog.alert({
	        closable: true,
	        title: 'Add interpreter',
	        message: 'Name ' + _.escape($scope.newInterpreterSetting.name) + ' already exists'
	      });
	      return;
	    }
	
	    var newSetting = $scope.newInterpreterSetting;
	    if (newSetting.propertyKey !== '' || newSetting.propertyKey) {
	      $scope.addNewInterpreterProperty();
	    }
	    if (newSetting.depArtifact !== '' || newSetting.depArtifact) {
	      $scope.addNewInterpreterDependency();
	    }
	    if (newSetting.option.setPermission === undefined) {
	      newSetting.option.setPermission = false;
	    }
	    newSetting.option.owners = angular.element('#newInterpreterOwners').val();
	
	    var request = angular.copy($scope.newInterpreterSetting);
	
	    // Change properties to proper request format
	    var newProperties = {};
	
	    for (var p in newSetting.properties) {
	      if (newSetting.properties.hasOwnProperty(p)) {
	        newProperties[p] = {
	          value: newSetting.properties[p].value,
	          type: newSetting.properties[p].type,
	          name: p
	        };
	      }
	    }
	
	    request.properties = newProperties;
	
	    $http.post(baseUrlSrv.getRestApiBase() + '/interpreter/setting', request).then(function (res) {
	      $scope.resetNewInterpreterSetting();
	      getInterpreterSettings();
	      $scope.showAddNewSetting = false;
	      checkDownloadingDependencies();
	    }).catch(function (res) {
	      var errorMsg = res.data ? res.data.message : 'Could not connect to server.';
	      console.log('Error %o %o', res.status, errorMsg);
	      ngToast.danger({ content: errorMsg, verticalPosition: 'bottom' });
	    });
	  };
	
	  $scope.cancelInterpreterSetting = function () {
	    $scope.showAddNewSetting = false;
	    $scope.resetNewInterpreterSetting();
	  };
	
	  $scope.resetNewInterpreterSetting = function () {
	    $scope.newInterpreterSetting = {
	      name: undefined,
	      group: undefined,
	      properties: {},
	      dependencies: [],
	      option: {
	        remote: true,
	        isExistingProcess: false,
	        setPermission: false,
	        session: false,
	        process: false
	
	      }
	    };
	    emptyNewProperty($scope.newInterpreterSetting);
	  };
	
	  $scope.removeInterpreterProperty = function (key, settingId) {
	    if (settingId === undefined) {
	      delete $scope.newInterpreterSetting.properties[key];
	    } else {
	      var index = _.findIndex($scope.interpreterSettings, { 'id': settingId });
	      delete $scope.interpreterSettings[index].properties[key];
	    }
	  };
	
	  $scope.removeInterpreterDependency = function (artifact, settingId) {
	    if (settingId === undefined) {
	      $scope.newInterpreterSetting.dependencies = _.reject($scope.newInterpreterSetting.dependencies, function (el) {
	        return el.groupArtifactVersion === artifact;
	      });
	    } else {
	      var index = _.findIndex($scope.interpreterSettings, { 'id': settingId });
	      $scope.interpreterSettings[index].dependencies = _.reject($scope.interpreterSettings[index].dependencies, function (el) {
	        return el.groupArtifactVersion === artifact;
	      });
	    }
	  };
	
	  $scope.addNewInterpreterProperty = function (settingId) {
	    if (settingId === undefined) {
	      // Add new property from create form
	      if (!$scope.newInterpreterSetting.propertyKey || $scope.newInterpreterSetting.propertyKey === '') {
	        return;
	      }
	      $scope.newInterpreterSetting.properties[$scope.newInterpreterSetting.propertyKey] = {
	        value: $scope.newInterpreterSetting.propertyValue,
	        type: $scope.newInterpreterSetting.propertyType
	      };
	      emptyNewProperty($scope.newInterpreterSetting);
	    } else {
	      // Add new property from edit form
	      var index = _.findIndex($scope.interpreterSettings, { 'id': settingId });
	      var setting = $scope.interpreterSettings[index];
	
	      if (!setting.propertyKey || setting.propertyKey === '') {
	        return;
	      }
	
	      setting.properties[setting.propertyKey] = { value: setting.propertyValue, type: setting.propertyType };
	
	      emptyNewProperty(setting);
	    }
	  };
	
	  $scope.addNewInterpreterDependency = function (settingId) {
	    if (settingId === undefined) {
	      // Add new dependency from create form
	      if (!$scope.newInterpreterSetting.depArtifact || $scope.newInterpreterSetting.depArtifact === '') {
	        return;
	      }
	
	      // overwrite if artifact already exists
	      var newSetting = $scope.newInterpreterSetting;
	      for (var d in newSetting.dependencies) {
	        if (newSetting.dependencies[d].groupArtifactVersion === newSetting.depArtifact) {
	          newSetting.dependencies[d] = {
	            'groupArtifactVersion': newSetting.depArtifact,
	            'exclusions': newSetting.depExclude
	          };
	          newSetting.dependencies.splice(d, 1);
	        }
	      }
	
	      newSetting.dependencies.push({
	        'groupArtifactVersion': newSetting.depArtifact,
	        'exclusions': newSetting.depExclude === '' ? [] : newSetting.depExclude
	      });
	      emptyNewDependency(newSetting);
	    } else {
	      // Add new dependency from edit form
	      var index = _.findIndex($scope.interpreterSettings, { 'id': settingId });
	      var setting = $scope.interpreterSettings[index];
	      if (!setting.depArtifact || setting.depArtifact === '') {
	        return;
	      }
	
	      // overwrite if artifact already exists
	      for (var dep in setting.dependencies) {
	        if (setting.dependencies[dep].groupArtifactVersion === setting.depArtifact) {
	          setting.dependencies[dep] = {
	            'groupArtifactVersion': setting.depArtifact,
	            'exclusions': setting.depExclude
	          };
	          setting.dependencies.splice(dep, 1);
	        }
	      }
	
	      setting.dependencies.push({
	        'groupArtifactVersion': setting.depArtifact,
	        'exclusions': setting.depExclude === '' ? [] : setting.depExclude
	      });
	      emptyNewDependency(setting);
	    }
	  };
	
	  $scope.resetNewRepositorySetting = function () {
	    $scope.newRepoSetting = {
	      id: '',
	      url: '',
	      snapshot: false,
	      username: '',
	      password: '',
	      proxyProtocol: 'HTTP',
	      proxyHost: '',
	      proxyPort: null,
	      proxyLogin: '',
	      proxyPassword: ''
	    };
	  };
	
	  var getRepositories = function getRepositories() {
	    $http.get(baseUrlSrv.getRestApiBase() + '/interpreter/repository').success(function (data, status, headers, config) {
	      $scope.repositories = data.body;
	    }).error(function (data, status, headers, config) {
	      console.log('Error %o %o', status, data.message);
	    });
	  };
	
	  $scope.addNewRepository = function () {
	    var request = angular.copy($scope.newRepoSetting);
	
	    $http.post(baseUrlSrv.getRestApiBase() + '/interpreter/repository', request).then(function (res) {
	      getRepositories();
	      $scope.resetNewRepositorySetting();
	      angular.element('#repoModal').modal('hide');
	    }).catch(function (res) {
	      console.log('Error %o %o', res.headers, res.config);
	    });
	  };
	
	  $scope.removeRepository = function (repoId) {
	    BootstrapDialog.confirm({
	      closable: true,
	      title: '',
	      message: 'Do you want to delete this repository?',
	      callback: function callback(result) {
	        if (result) {
	          $http.delete(baseUrlSrv.getRestApiBase() + '/interpreter/repository/' + repoId).then(function (res) {
	            var index = _.findIndex($scope.repositories, { 'id': repoId });
	            $scope.repositories.splice(index, 1);
	          }).catch(function (res) {
	            console.log('Error %o %o', res.status, res.data ? res.data.message : '');
	          });
	        }
	      }
	    });
	  };
	
	  $scope.isDefaultRepository = function (repoId) {
	    if (repoId === 'central' || repoId === 'local') {
	      return true;
	    } else {
	      return false;
	    }
	  };
	
	  $scope.showErrorMessage = function (setting) {
	    BootstrapDialog.show({
	      title: 'Error downloading dependencies',
	      message: _.escape(setting.errorReason)
	    });
	  };
	
	  var init = function init() {
	    getAvailableInterpreterPropertyWidgets();
	
	    $scope.resetNewInterpreterSetting();
	    $scope.resetNewRepositorySetting();
	
	    getInterpreterSettings();
	    getAvailableInterpreters();
	    getRepositories();
	  };
	
	  $scope.showSparkUI = function (settingId) {
	    $http.get(baseUrlSrv.getRestApiBase() + '/interpreter/metadata/' + settingId).then(function (res) {
	      if (res.data.body === undefined) {
	        BootstrapDialog.alert({
	          message: 'No spark application running'
	        });
	        return;
	      }
	      if (res.data.body.url) {
	        window.open(res.data.body.url, '_blank');
	      } else {
	        BootstrapDialog.alert({
	          message: _.escape(res.data.body.message)
	        });
	      }
	    }).catch(function (res) {
	      console.log('Error %o %o', res.status, res.data ? res.data.message : '');
	    });
	  };
	
	  $scope.getInterpreterBindingModeDocsLink = function () {
	    var currentVersion = $rootScope.zeppelinVersion;
	    return 'https://zeppelin.apache.org/docs/' + currentVersion + '/usage/interpreter/interpreter_binding_mode.html';
	  };
	
	  init();
	}

/***/ }),
/* 198 */
/***/ (function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').filter('sortByKey', sortByKey);
	
	function sortByKey() {
	  return function (properties) {
	    var sortedKeys = properties ? Object.keys(properties) : [];
	    return sortedKeys.sort();
	  };
	}

/***/ }),
/* 199 */
/***/ (function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	InterpreterItemDirective.$inject = ["$timeout"];
	angular.module('zeppelinWebApp').directive('interpreterItem', InterpreterItemDirective);
	
	function InterpreterItemDirective($timeout) {
	  'ngInject';
	
	  return {
	    restrict: 'A',
	    link: function link(scope, element, attr) {
	      if (scope.$last === true) {
	        $timeout(function () {
	          var id = 'ngRenderFinished';
	          scope.$emit(id);
	        });
	      }
	    }
	  };
	}

/***/ }),
/* 200 */
/***/ (function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').directive('numberWidget', InterpreterNumberDirective);
	
	function InterpreterNumberDirective() {
	  return {
	    require: 'ngModel',
	    link: function link(scope, element, attrs, modelCtrl) {
	      modelCtrl.$parsers.push(function (inputValue) {
	        var transformedInput = inputValue ? inputValue.replace(/[^\d.-]/g, '') : null;
	        if (transformedInput !== inputValue) {
	          modelCtrl.$setViewValue(transformedInput);
	          modelCtrl.$render();
	        }
	        return transformedInput;
	      });
	    }
	  };
	}

/***/ }),
/* 201 */
/***/ (function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	CredentialController.$inject = ["$scope", "$http", "baseUrlSrv", "ngToast"];
	angular.module('zeppelinWebApp').controller('CredentialCtrl', CredentialController);
	
	function CredentialController($scope, $http, baseUrlSrv, ngToast) {
	  'ngInject';
	
	  ngToast.dismiss();
	
	  $scope.credentialInfo = [];
	  $scope.showAddNewCredentialInfo = false;
	  $scope.availableInterpreters = [];
	
	  $scope.entity = '';
	  $scope.password = '';
	  $scope.username = '';
	
	  $scope.hasCredential = function () {
	    return Array.isArray($scope.credentialInfo) && $scope.credentialInfo.length;
	  };
	
	  var getCredentialInfo = function getCredentialInfo() {
	    $http.get(baseUrlSrv.getRestApiBase() + '/credential').success(function (data, status, headers, config) {
	      $scope.credentialInfo.length = 0; // keep the ref while cleaning
	      var returnedCredentials = data.body.userCredentials;
	
	      for (var key in returnedCredentials) {
	        if (returnedCredentials.hasOwnProperty(key)) {
	          var value = returnedCredentials[key];
	          $scope.credentialInfo.push({
	            entity: key,
	            password: value.password,
	            username: value.username
	          });
	        }
	      }
	
	      console.log('Success %o %o', status, $scope.credentialInfo);
	    }).error(function (data, status, headers, config) {
	      if (status === 401) {
	        showToast('You do not have permission on this page', 'danger');
	        setTimeout(function () {
	          window.location = baseUrlSrv.getBase();
	        }, 3000);
	      }
	      console.log('Error %o %o', status, data.message);
	    });
	  };
	
	  $scope.isValidCredential = function () {
	    return $scope.entity.trim() !== '' && $scope.username.trim() !== '';
	  };
	
	  $scope.addNewCredentialInfo = function () {
	    if (!$scope.isValidCredential()) {
	      showToast('Username \\ Entity can not be empty.', 'danger');
	      return;
	    }
	
	    var newCredential = {
	      'entity': $scope.entity,
	      'username': $scope.username,
	      'password': $scope.password
	    };
	
	    $http.put(baseUrlSrv.getRestApiBase() + '/credential', newCredential).success(function (data, status, headers, config) {
	      showToast('Successfully saved credentials.', 'success');
	      $scope.credentialInfo.push(newCredential);
	      resetCredentialInfo();
	      $scope.showAddNewCredentialInfo = false;
	      console.log('Success %o %o', status, data.message);
	    }).error(function (data, status, headers, config) {
	      showToast('Error saving credentials', 'danger');
	      console.log('Error %o %o', status, data.message);
	    });
	  };
	
	  var getAvailableInterpreters = function getAvailableInterpreters() {
	    $http.get(baseUrlSrv.getRestApiBase() + '/interpreter/setting').success(function (data, status, headers, config) {
	      for (var setting = 0; setting < data.body.length; setting++) {
	        $scope.availableInterpreters.push(data.body[setting].group + '.' + data.body[setting].name);
	      }
	      angular.element('#entityname').autocomplete({
	        source: $scope.availableInterpreters,
	        select: function select(event, selected) {
	          $scope.entity = selected.item.value;
	          return false;
	        }
	      });
	    }).error(function (data, status, headers, config) {
	      showToast(data.message, 'danger');
	      console.log('Error %o %o', status, data.message);
	    });
	  };
	
	  $scope.toggleAddNewCredentialInfo = function () {
	    if ($scope.showAddNewCredentialInfo) {
	      $scope.showAddNewCredentialInfo = false;
	    } else {
	      $scope.showAddNewCredentialInfo = true;
	    }
	  };
	
	  $scope.cancelCredentialInfo = function () {
	    $scope.showAddNewCredentialInfo = false;
	    resetCredentialInfo();
	  };
	
	  var resetCredentialInfo = function resetCredentialInfo() {
	    $scope.entity = '';
	    $scope.username = '';
	    $scope.password = '';
	  };
	
	  $scope.copyOriginCredentialsInfo = function () {
	    showToast('Since entity is a unique key, you can edit only username & password', 'info');
	  };
	
	  $scope.updateCredentialInfo = function (form, data, entity) {
	    if (!$scope.isValidCredential()) {
	      showToast('Username \\ Entity can not be empty.', 'danger');
	      return;
	    }
	
	    var credential = {
	      entity: entity,
	      username: data.username,
	      password: data.password
	    };
	
	    $http.put(baseUrlSrv.getRestApiBase() + '/credential/', credential).success(function (data, status, headers, config) {
	      var index = $scope.credentialInfo.findIndex(function (elem) {
	        return elem.entity === entity;
	      });
	      $scope.credentialInfo[index] = credential;
	      return true;
	    }).error(function (data, status, headers, config) {
	      showToast('We could not save the credential', 'danger');
	      console.log('Error %o %o', status, data.message);
	      form.$show();
	    });
	    return false;
	  };
	
	  $scope.removeCredentialInfo = function (entity) {
	    BootstrapDialog.confirm({
	      closable: false,
	      closeByBackdrop: false,
	      closeByKeyboard: false,
	      title: '',
	      message: 'Do you want to delete this credential information?',
	      callback: function callback(result) {
	        if (result) {
	          $http.delete(baseUrlSrv.getRestApiBase() + '/credential/' + entity).success(function (data, status, headers, config) {
	            var index = $scope.credentialInfo.findIndex(function (elem) {
	              return elem.entity === entity;
	            });
	            $scope.credentialInfo.splice(index, 1);
	            console.log('Success %o %o', status, data.message);
	          }).error(function (data, status, headers, config) {
	            showToast(data.message, 'danger');
	            console.log('Error %o %o', status, data.message);
	          });
	        }
	      }
	    });
	  };
	
	  function showToast(message, type) {
	    var verticalPosition = 'bottom';
	    var timeout = '3000';
	
	    if (type === 'success') {
	      ngToast.success({ content: message, verticalPosition: verticalPosition, timeout: timeout });
	    } else if (type === 'info') {
	      ngToast.info({ content: message, verticalPosition: verticalPosition, timeout: timeout });
	    } else {
	      ngToast.danger({ content: message, verticalPosition: verticalPosition, timeout: timeout });
	    }
	  }
	
	  var init = function init() {
	    getAvailableInterpreters();
	    getCredentialInfo();
	  };
	
	  init();
	}

/***/ }),
/* 202 */
/***/ (function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	ConfigurationCtrl.$inject = ["$scope", "$http", "baseUrlSrv", "ngToast"];
	angular.module('zeppelinWebApp').controller('ConfigurationCtrl', ConfigurationCtrl);
	
	function ConfigurationCtrl($scope, $http, baseUrlSrv, ngToast) {
	  'ngInject';
	
	  $scope.configrations = [];
	  ngToast.dismiss();
	
	  var getConfigurations = function getConfigurations() {
	    $http.get(baseUrlSrv.getRestApiBase() + '/configurations/all').success(function (data, status, headers, config) {
	      $scope.configurations = data.body;
	    }).error(function (data, status, headers, config) {
	      if (status === 401) {
	        ngToast.danger({
	          content: 'You don\'t have permission on this page',
	          verticalPosition: 'bottom',
	          timeout: '3000'
	        });
	        setTimeout(function () {
	          window.location = baseUrlSrv.getBase();
	        }, 3000);
	      }
	      console.log('Error %o %o', status, data.message);
	    });
	  };
	
	  var init = function init() {
	    getConfigurations();
	  };
	
	  init();
	}

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	RevisionsComparatorController.$inject = ["$scope", "websocketMsgSrv", "$routeParams"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RevisionsComparatorModule = exports.RevisionsComparatorComponent = undefined;
	
	var _revisionsComparator = __webpack_require__(204);
	
	var _revisionsComparator2 = _interopRequireDefault(_revisionsComparator);
	
	__webpack_require__(205);
	
	var _moment = __webpack_require__(18);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function RevisionsComparatorController($scope, websocketMsgSrv, $routeParams) {
	  'ngInject';
	
	  $scope.firstNoteRevisionForCompare = null;
	  $scope.secondNoteRevisionForCompare = null;
	  $scope.mergeNoteRevisionsForCompare = null;
	  $scope.currentParagraphDiffDisplay = null;
	  $scope.currentFirstRevisionForCompare = 'Choose...';
	  $scope.currentSecondRevisionForCompare = 'Choose...';
	
	  $scope.getNoteRevisionForReview = function (revision, position) {
	    if (position) {
	      if (position === 'first') {
	        $scope.currentFirstRevisionForCompare = revision.message;
	      } else {
	        $scope.currentSecondRevisionForCompare = revision.message;
	      }
	      websocketMsgSrv.getNoteByRevisionForCompare($routeParams.noteId, revision.id, position);
	    }
	  };
	
	  // compare revisions
	  $scope.compareRevisions = function () {
	    if ($scope.firstNoteRevisionForCompare && $scope.secondNoteRevisionForCompare) {
	      var paragraphs1 = $scope.firstNoteRevisionForCompare.note.paragraphs;
	      var paragraphs2 = $scope.secondNoteRevisionForCompare.note.paragraphs;
	      var added = 'added';
	      var deleted = 'deleted';
	      var compared = 'compared';
	      var merge = [];
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = paragraphs1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var p1 = _step.value;
	
	          var p2 = null;
	          var _iteratorNormalCompletion3 = true;
	          var _didIteratorError3 = false;
	          var _iteratorError3 = undefined;
	
	          try {
	            for (var _iterator3 = paragraphs2[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	              var p = _step3.value;
	
	              if (p1.id === p.id) {
	                p2 = p;
	                break;
	              }
	            }
	          } catch (err) {
	            _didIteratorError3 = true;
	            _iteratorError3 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                _iterator3.return();
	              }
	            } finally {
	              if (_didIteratorError3) {
	                throw _iteratorError3;
	              }
	            }
	          }
	
	          if (p2 === null) {
	            merge.push({ paragraph: p1, firstString: (p1.text || '').split('\n')[0], type: deleted });
	          } else {
	            (function () {
	              var colorClass = '';
	              var span = null;
	              var text1 = p1.text || '';
	              var text2 = p2.text || '';
	
	              var diff = window.JsDiff.diffLines(text1, text2);
	              var diffHtml = document.createDocumentFragment();
	              var identical = true;
	              var identicalClass = 'color-black';
	
	              diff.forEach(function (part) {
	                colorClass = part.added ? 'color-green-row' : part.removed ? 'color-red-row' : identicalClass;
	                span = document.createElement('span');
	                span.className = colorClass;
	                if (identical && colorClass !== identicalClass) {
	                  identical = false;
	                }
	
	                var str = part.value;
	
	                if (str[str.length - 1] !== '\n') {
	                  str = str + '\n';
	                }
	
	                span.appendChild(document.createTextNode(str));
	                diffHtml.appendChild(span);
	              });
	
	              var pre = document.createElement('pre');
	              pre.appendChild(diffHtml);
	
	              merge.push({
	                paragraph: p1,
	                diff: pre.innerHTML,
	                identical: identical,
	                firstString: (p1.text || '').split('\n')[0],
	                type: compared
	              });
	            })();
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = paragraphs2[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var p2 = _step2.value;
	
	          var _p = null;
	          var _iteratorNormalCompletion4 = true;
	          var _didIteratorError4 = false;
	          var _iteratorError4 = undefined;
	
	          try {
	            for (var _iterator4 = paragraphs1[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	              var _p2 = _step4.value;
	
	              if (p2.id === _p2.id) {
	                _p = _p2;
	                break;
	              }
	            }
	          } catch (err) {
	            _didIteratorError4 = true;
	            _iteratorError4 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion4 && _iterator4.return) {
	                _iterator4.return();
	              }
	            } finally {
	              if (_didIteratorError4) {
	                throw _iteratorError4;
	              }
	            }
	          }
	
	          if (_p === null) {
	            merge.push({ paragraph: p2, firstString: (p2.text || '').split('\n')[0], type: added });
	          }
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      merge.sort(function (a, b) {
	        if (a.type === added) {
	          return -1;
	        }
	        if (a.type === compared) {
	          return 1;
	        }
	        if (a.type === deleted) {
	          if (b.type === compared) {
	            return -1;
	          } else {
	            return 1;
	          }
	        }
	      });
	
	      $scope.mergeNoteRevisionsForCompare = merge;
	
	      if ($scope.currentParagraphDiffDisplay !== null) {
	        $scope.changeCurrentParagraphDiffDisplay($scope.currentParagraphDiffDisplay.paragraph.id);
	      }
	    }
	  };
	
	  $scope.$on('noteRevisionForCompare', function (event, data) {
	    console.debug('received note revision for compare %o', data);
	    if (data.note && data.position) {
	      if (data.position === 'first') {
	        $scope.firstNoteRevisionForCompare = data;
	      } else {
	        $scope.secondNoteRevisionForCompare = data;
	      }
	
	      if ($scope.firstNoteRevisionForCompare !== null && $scope.secondNoteRevisionForCompare !== null && $scope.firstNoteRevisionForCompare.revisionId !== $scope.secondNoteRevisionForCompare.revisionId) {
	        $scope.compareRevisions();
	      }
	    }
	  });
	
	  $scope.formatRevisionDate = function (date) {
	    return _moment2.default.unix(date).format('MMMM Do YYYY, h:mm:ss a');
	  };
	
	  $scope.changeCurrentParagraphDiffDisplay = function (paragraphId) {
	    var _iteratorNormalCompletion5 = true;
	    var _didIteratorError5 = false;
	    var _iteratorError5 = undefined;
	
	    try {
	      for (var _iterator5 = $scope.mergeNoteRevisionsForCompare[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	        var p = _step5.value;
	
	        if (p.paragraph.id === paragraphId) {
	          $scope.currentParagraphDiffDisplay = p;
	          return;
	        }
	      }
	    } catch (err) {
	      _didIteratorError5 = true;
	      _iteratorError5 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion5 && _iterator5.return) {
	          _iterator5.return();
	        }
	      } finally {
	        if (_didIteratorError5) {
	          throw _iteratorError5;
	        }
	      }
	    }
	
	    $scope.currentParagraphDiffDisplay = null;
	  };
	} /*
	   * Licensed under the Apache License, Version 2.0 (the "License");
	   * you may not use this file except in compliance with the License.
	   * You may obtain a copy of the License at
	   *
	   *     http://www.apache.org/licenses/LICENSE-2.0
	   *
	   * Unless required by applicable law or agreed to in writing, software
	   * distributed under the License is distributed on an "AS IS" BASIS,
	   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   * See the License for the specific language governing permissions and
	   * limitations under the License.
	   */
	
	var RevisionsComparatorComponent = exports.RevisionsComparatorComponent = {
	  template: _revisionsComparator2.default,
	  controller: RevisionsComparatorController,
	  bindings: {
	    noteRevisions: '<'
	  }
	};
	
	var RevisionsComparatorModule = exports.RevisionsComparatorModule = angular.module('zeppelinWebApp').component('revisionsComparator', RevisionsComparatorComponent).name;

/***/ }),
/* 204 */
/***/ (function(module, exports) {

	module.exports = "<!--\nLicensed under the Apache License, Version 2.0 (the \"License\");\nyou may not use this file except in compliance with the License.\nYou may obtain a copy of the License at\n\n    http://www.apache.org/licenses/LICENSE-2.0\n\nUnless required by applicable law or agreed to in writing, software\ndistributed under the License is distributed on an \"AS IS\" BASIS,\nWITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\nSee the License for the specific language governing permissions and\nlimitations under the License.\n-->\n<div class=\"col-md-4\">\n\n  <div class=\"commit-tree\">\n    <table class=\"table\">\n      <thead>\n      <tr>\n        <th>Revision name</th>\n        <th>Date</th>\n      </tr>\n      </thead>\n      <tbody class=\"commit-rows\">\n      <tr ng-repeat=\"revision in $ctrl.noteRevisions | orderBy:'time':true\"\n          ng-class=\"{'cursor-hand': !$last, 'selected-revision': revision.message === currentSecondRevisionForCompare}\"\n          ng-click=\"getNoteRevisionForReview($ctrl.noteRevisions[$index + 1], 'first'); getNoteRevisionForReview(revision, 'second')\">\n        <td>{{revision.message}}</td>\n        <td>{{formatRevisionDate(revision.time)}}</td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n\n  <div class=\"revisions-comparator-bar\">\n    <div class=\"btn-group\">\n      <button type=\"button\" ng-if=\"$ctrl.noteRevisions.length > 0\"\n              class=\"btn btn-default revisions-comparator-dropdown dropdown-toggle\"\n              data-toggle=\"dropdown\" id=\"firstRevisionDropdown\" title=\"{{currentFirstRevisionForCompare}}\">\n        <div class=\"revision-name-for-compare\">{{currentFirstRevisionForCompare}}</div>\n        <span class=\"caret revisions-comparator-caret\"></span>\n      </button>\n      <ul class=\"dropdown-menu dropdown-menu-left\" aria-labelledby=\"firstRevisionDropdown\">\n        <li></li>\n        <li ng-repeat=\"revision in $ctrl.noteRevisions | orderBy:'time':true\" class=\"revision\">\n          <a style=\"cursor:pointer\" ng-click=\"getNoteRevisionForReview(revision, 'first')\">\n          <span style=\"display: block;\">\n            <strong>{{revision.message}}</strong>\n          </span>\n            <span class=\"revisionDate\">\n            <em>{{formatRevisionDate(revision.time)}}</em>\n          </span>\n          </a>\n        </li>\n      </ul>\n    </div>\n    <span>compare with</span>\n    <div class=\"btn-group\">\n      <button type=\"button\" ng-if=\"$ctrl.noteRevisions.length > 0\"\n              class=\"btn btn-default revisions-comparator-dropdown dropdown-toggle\"\n              ng-disabled=\"firstNoteRevisionForCompare === null\"\n              data-toggle=\"dropdown\" id=\"secondRevisionDropdown\" title=\"{{currentSecondRevisionForCompare}}\">\n        <div class=\"revision-name-for-compare\">{{currentSecondRevisionForCompare}}</div>\n        <span class=\"caret revisions-comparator-caret\"></span>\n      </button>\n      <ul class=\"dropdown-menu dropdown-menu-left\" aria-labelledby=\"secondRevisionDropdown\">\n        <li ng-repeat=\"revision in $ctrl.noteRevisions | orderBy:'time':true\" class=\"revision\">\n          <a style=\"cursor:pointer\" ng-click=\"getNoteRevisionForReview(revision, 'second')\">\n          <span style=\"display: block;\">\n            <strong>{{revision.message}}</strong>\n          </span>\n            <span class=\"revisionDate\">\n            <em>{{formatRevisionDate(revision.time)}}</em>\n          </span>\n          </a>\n        </li>\n      </ul>\n    </div>\n  </div>\n\n  <div id=\"diffPanel\">\n    <div class=\"panel-group\" style=\"margin-bottom: 0px\">\n      <div class=\"paragraphs-div\">\n        <div class=\"panel revisions-comparator-panel\" data-ng-repeat=\"p in mergeNoteRevisionsForCompare | orderBy:'time':true\"\n             ng-class=\"{'revisions-comparator-panel-selected' : currentParagraphDiffDisplay.paragraph.id === p.paragraph.id}\">\n          <div class=\"revisions-comparator-panel-heading\"\n               ng-click=\"changeCurrentParagraphDiffDisplay(p.paragraph.id)\">\n            <h4 class=\"panel-title\">\n              {{p.paragraph.id}}<strong style=\"padding: 5px;\" ng-if=\"p.paragraph.title\">({{p.paragraph.title}})</strong>\n              <i ng-if=\"p.type === 'added'\" class=\"revisions-comparator-status color-green\">added</i>\n              <i ng-if=\"p.type === 'deleted'\" class=\"revisions-comparator-status color-red\">deleted</i>\n              <i ng-if=\"p.type === 'compared' && !(p.identical)\" class=\"revisions-comparator-status color-orange\">there\n                are differences</i>\n              <i ng-if=\"p.type === 'compared' && p.identical\" class=\"revisions-comparator-status\">contents are\n                identical</i>\n              <i class=\"revisions-comparator-first-string\">{{p.firstString}}</i>\n            </h4>\n          </div>\n        </div>\n        <div style=\"display: table; width: 100%; height: 100%\"\n             ng-if=\"currentSecondRevisionForCompare === 'Choose...'\">\n          <div class=\"empty-paragraph-message\">\n            Please select a revision\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div id=\"revisions-comparator-code-panel-id center-block\" class=\"panel col-md-8\">\n  <span\n    class=\"revisions-comparator-code-panel-title\">Revision: <strong>{{currentFirstRevisionForCompare}} --> {{currentSecondRevisionForCompare}}</strong></span>\n  <pre ng-if=\"currentParagraphDiffDisplay.type === 'added'\"\n       class=\"revisions-comparator-code-panel color-green-row\">{{currentParagraphDiffDisplay.paragraph.text}}</pre>\n  <pre ng-if=\"currentParagraphDiffDisplay.type === 'deleted'\"\n       class=\"revisions-comparator-code-panel color-red-row\">{{currentParagraphDiffDisplay.paragraph.text}}</pre>\n  <pre ng-if=\"currentParagraphDiffDisplay.type === 'compared'\"\n       class=\"revisions-comparator-code-panel\" ng-bind-html=\"currentParagraphDiffDisplay.diff\"></pre>\n  <pre ng-if=\"currentParagraphDiffDisplay === null\"\n       class=\"revisions-comparator-code-panel empty-code-panel\"><div>Nothing to display</div></pre>\n</div>\n\n<div class=\"clearfix\"></div>\n"

/***/ }),
/* 205 */
1,
/* 206 */,
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	ParagraphCtrl.$inject = ["$scope", "$rootScope", "$route", "$window", "$routeParams", "$location", "$timeout", "$compile", "$http", "$q", "websocketMsgSrv", "baseUrlSrv", "ngToast", "noteVarShareService", "heliumService"];
	var _spell = __webpack_require__(208);
	
	var _paragraph = __webpack_require__(161);
	
	var _moment = __webpack_require__(18);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(156); /*
	                                    * Licensed under the Apache License, Version 2.0 (the "License");
	                                    * you may not use this file except in compliance with the License.
	                                    * You may obtain a copy of the License at
	                                    *
	                                    *     http://www.apache.org/licenses/LICENSE-2.0
	                                    *
	                                    * Unless required by applicable law or agreed to in writing, software
	                                    * distributed under the License is distributed on an "AS IS" BASIS,
	                                    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                    * See the License for the specific language governing permissions and
	                                    * limitations under the License.
	                                    */
	
	var ParagraphExecutor = {
	  SPELL: 'SPELL',
	  INTERPRETER: 'INTERPRETER',
	  NONE: '' /** meaning `DONE` */
	};
	
	angular.module('zeppelinWebApp').controller('ParagraphCtrl', ParagraphCtrl);
	
	function ParagraphCtrl($scope, $rootScope, $route, $window, $routeParams, $location, $timeout, $compile, $http, $q, websocketMsgSrv, baseUrlSrv, ngToast, noteVarShareService, heliumService) {
	  'ngInject';
	
	  var ANGULAR_FUNCTION_OBJECT_NAME_PREFIX = '_Z_ANGULAR_FUNC_';
	  var completionListLength = undefined;
	  $rootScope.keys = Object.keys;
	  $scope.parentNote = null;
	  $scope.paragraph = {};
	  $scope.paragraph.results = {};
	  $scope.paragraph.results.msg = [];
	  $scope.originalText = '';
	  $scope.editor = null;
	
	  // transactional info for spell execution
	  $scope.spellTransaction = {
	    totalResultCount: 0,
	    renderedResultCount: 0,
	    propagated: false,
	    resultsMsg: [],
	    paragraphText: ''
	  };
	
	  var searchRanges = [];
	  var getCurrentRangeDefault = function getCurrentRangeDefault() {
	    return { id: -1, markerId: -1 };
	  };
	  var currentRange = getCurrentRangeDefault();
	
	  var editorSetting = {};
	  // flag that is used to set editor setting on paste percent sign
	  var pastePercentSign = false;
	  // flag that is used to set editor setting on save interpreter bindings
	  var setInterpreterBindings = false;
	  var paragraphScope = $rootScope.$new(true, $rootScope);
	
	  // to keep backward compatibility
	  $scope.compiledScope = paragraphScope;
	
	  paragraphScope.z = {
	    // z.runParagraph('20150213-231621_168813393')
	    runParagraph: function runParagraph(paragraphId) {
	      if (paragraphId) {
	        var filtered = $scope.parentNote.paragraphs.filter(function (x) {
	          return x.id === paragraphId;
	        });
	        if (filtered.length === 1) {
	          var paragraph = filtered[0];
	          websocketMsgSrv.runParagraph(paragraph.id, paragraph.title, paragraph.text, paragraph.config, paragraph.settings.params);
	        } else {
	          ngToast.danger({
	            content: 'Cannot find a paragraph with id \'' + paragraphId + '\'',
	            verticalPosition: 'top',
	            dismissOnTimeout: false
	          });
	        }
	      } else {
	        ngToast.danger({
	          content: 'Please provide a \'paragraphId\' when calling z.runParagraph(paragraphId)',
	          verticalPosition: 'top',
	          dismissOnTimeout: false
	        });
	      }
	    },
	
	    // Example: z.angularBind('my_var', 'Test Value', '20150213-231621_168813393')
	    angularBind: function angularBind(varName, value, paragraphId) {
	      // Only push to server if there paragraphId is defined
	      if (paragraphId) {
	        websocketMsgSrv.clientBindAngularObject($routeParams.noteId, varName, value, paragraphId);
	      } else {
	        ngToast.danger({
	          content: 'Please provide a \'paragraphId\' when calling ' + 'z.angularBind(varName, value, \'PUT_HERE_PARAGRAPH_ID\')',
	          verticalPosition: 'top',
	          dismissOnTimeout: false
	        });
	      }
	    },
	
	    // Example: z.angularUnBind('my_var', '20150213-231621_168813393')
	    angularUnbind: function angularUnbind(varName, paragraphId) {
	      // Only push to server if paragraphId is defined
	      if (paragraphId) {
	        websocketMsgSrv.clientUnbindAngularObject($routeParams.noteId, varName, paragraphId);
	      } else {
	        ngToast.danger({
	          content: 'Please provide a \'paragraphId\' when calling ' + 'z.angularUnbind(varName, \'PUT_HERE_PARAGRAPH_ID\')',
	          verticalPosition: 'top',
	          dismissOnTimeout: false });
	      }
	    }
	  };
	
	  var angularObjectRegistry = {};
	
	  // Controller init
	  $scope.init = function (newParagraph, note) {
	    $scope.paragraph = newParagraph;
	    $scope.parentNote = note;
	    $scope.originalText = angular.copy(newParagraph.text);
	    $scope.chart = {};
	    $scope.baseMapOption = ['Streets', 'Satellite', 'Hybrid', 'Topo', 'Gray', 'Oceans', 'Terrain'];
	    $scope.colWidthOption = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
	    $scope.fontSizeOption = [9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20];
	    $scope.paragraphFocused = false;
	    if (newParagraph.focus) {
	      $scope.paragraphFocused = true;
	    }
	    if (!$scope.paragraph.config) {
	      $scope.paragraph.config = {};
	    }
	
	    // SILECTIS -> enabling line numbers by default
	    $scope.paragraph.config.lineNumbers = true;
	
	    noteVarShareService.put($scope.paragraph.id + '_paragraphScope', paragraphScope);
	
	    initializeDefault($scope.paragraph.config);
	  };
	
	  var initializeDefault = function initializeDefault(config) {
	    var forms = $scope.paragraph.settings.forms;
	
	    if (!config.colWidth) {
	      config.colWidth = 12;
	    }
	
	    if (!config.fontSize) {
	      config.fontSize = 9;
	    }
	
	    if (config.enabled === undefined) {
	      config.enabled = true;
	    }
	
	    for (var idx in forms) {
	      if (forms[idx]) {
	        if (forms[idx].options) {
	          if (config.runOnSelectionChange === undefined) {
	            config.runOnSelectionChange = true;
	          }
	        }
	      }
	    }
	
	    if (!config.results) {
	      config.results = {};
	    }
	
	    if (!config.editorSetting) {
	      config.editorSetting = {};
	    } else if (config.editorSetting.editOnDblClick) {
	      editorSetting.isOutputHidden = config.editorSetting.editOnDblClick;
	    }
	  };
	
	  var isTabCompletion = function isTabCompletion() {
	    var completionKey = $scope.paragraph.config.editorSetting.completionKey;
	    return completionKey === 'TAB';
	  };
	
	  $scope.$on('updateParagraphOutput', function (event, data) {
	    if ($scope.paragraph.id === data.paragraphId) {
	      if (!$scope.paragraph.results) {
	        $scope.paragraph.results = {};
	      }
	      if (!$scope.paragraph.results.msg) {
	        $scope.paragraph.results.msg = [];
	      }
	
	      var update = $scope.paragraph.results.msg[data.index] ? true : false;
	
	      $scope.paragraph.results.msg[data.index] = {
	        data: data.data,
	        type: data.type
	      };
	
	      if (update) {
	        $rootScope.$broadcast('updateResult', $scope.paragraph.results.msg[data.index], $scope.paragraph.config.results[data.index], $scope.paragraph, data.index);
	      }
	    }
	  });
	
	  $scope.getIframeDimensions = function () {
	    if ($scope.asIframe) {
	      var paragraphid = '#' + $routeParams.paragraphId + '_container';
	      var height = angular.element(paragraphid).height();
	      return height;
	    }
	    return 0;
	  };
	
	  $scope.$watch($scope.getIframeDimensions, function (newValue, oldValue) {
	    if ($scope.asIframe && newValue) {
	      var message = {};
	      message.height = newValue;
	      message.url = $location.$$absUrl;
	      $window.parent.postMessage(angular.toJson(message), '*');
	    }
	  });
	
	  $scope.getEditor = function () {
	    return $scope.editor;
	  };
	
	  $scope.$watch($scope.getEditor, function (newValue, oldValue) {
	    if (!$scope.editor) {
	      return;
	    }
	    if (newValue === null || newValue === undefined) {
	      console.log('editor isnt loaded yet, returning');
	      return;
	    }
	    if ($scope.revisionView === true) {
	      $scope.editor.setReadOnly(true);
	    } else {
	      $scope.editor.setReadOnly(false);
	    }
	  });
	
	  var isEmpty = function isEmpty(object) {
	    return !object;
	  };
	
	  $scope.isRunning = function (paragraph) {
	    return (0, _paragraph.isParagraphRunning)(paragraph);
	  };
	
	  $scope.cancelParagraph = function (paragraph) {
	    console.log('Cancel %o', paragraph.id);
	    websocketMsgSrv.cancelParagraphRun(paragraph.id);
	  };
	
	  $scope.propagateSpellResult = function (paragraphId, paragraphTitle, paragraphText, paragraphResults, paragraphStatus, paragraphErrorMessage, paragraphConfig, paragraphSettingsParam, paragraphDateStarted, paragraphDateFinished) {
	    websocketMsgSrv.paragraphExecutedBySpell(paragraphId, paragraphTitle, paragraphText, paragraphResults, paragraphStatus, paragraphErrorMessage, paragraphConfig, paragraphSettingsParam, paragraphDateStarted, paragraphDateFinished);
	  };
	
	  $scope.handleSpellError = function (paragraphText, error, digestRequired, propagated) {
	    var errorMessage = error.stack;
	    $scope.paragraph.status = _paragraph.ParagraphStatus.ERROR;
	    $scope.paragraph.errorMessage = errorMessage;
	    console.error('Failed to execute interpret() in spell\n', error);
	
	    if (!propagated) {
	      $scope.paragraph.dateFinished = $scope.getFormattedParagraphTime();
	    }
	
	    if (!propagated) {
	      $scope.propagateSpellResult($scope.paragraph.id, $scope.paragraph.title, paragraphText, [], $scope.paragraph.status, errorMessage, $scope.paragraph.config, $scope.paragraph.settings.params, $scope.paragraph.dateStarted, $scope.paragraph.dateFinished);
	    }
	  };
	
	  $scope.prepareSpellTransaction = function (resultsMsg, propagated, paragraphText) {
	    $scope.spellTransaction.totalResultCount = resultsMsg.length;
	    $scope.spellTransaction.renderedResultCount = 0;
	    $scope.spellTransaction.propagated = propagated;
	    $scope.spellTransaction.resultsMsg = resultsMsg;
	    $scope.spellTransaction.paragraphText = paragraphText;
	  };
	
	  /**
	   * - update spell transaction count and
	   * - check transaction is finished based on the result count
	   * @returns {boolean}
	   */
	  $scope.increaseSpellTransactionResultCount = function () {
	    $scope.spellTransaction.renderedResultCount += 1;
	
	    var total = $scope.spellTransaction.totalResultCount;
	    var current = $scope.spellTransaction.renderedResultCount;
	    return total === current;
	  };
	
	  $scope.cleanupSpellTransaction = function () {
	    var status = _paragraph.ParagraphStatus.FINISHED;
	    $scope.paragraph.executor = ParagraphExecutor.NONE;
	    $scope.paragraph.status = status;
	    $scope.paragraph.results.code = status;
	
	    var propagated = $scope.spellTransaction.propagated;
	    var resultsMsg = $scope.spellTransaction.resultsMsg;
	    var paragraphText = $scope.spellTransaction.paragraphText;
	
	    if (!propagated) {
	      $scope.paragraph.dateFinished = $scope.getFormattedParagraphTime();
	    }
	
	    if (!propagated) {
	      var propagable = _spell.SpellResult.createPropagable(resultsMsg);
	      $scope.propagateSpellResult($scope.paragraph.id, $scope.paragraph.title, paragraphText, propagable, status, '', $scope.paragraph.config, $scope.paragraph.settings.params, $scope.paragraph.dateStarted, $scope.paragraph.dateFinished);
	    }
	  };
	
	  $scope.runParagraphUsingSpell = function (paragraphText, magic, digestRequired, propagated) {
	    $scope.paragraph.status = 'RUNNING';
	    $scope.paragraph.executor = ParagraphExecutor.SPELL;
	    $scope.paragraph.results = {};
	    $scope.paragraph.errorMessage = '';
	    if (digestRequired) {
	      $scope.$digest();
	    }
	
	    try {
	      // remove magic from paragraphText
	      var splited = paragraphText.split(magic);
	      // remove leading spaces
	      var textWithoutMagic = splited[1].replace(/^\s+/g, '');
	
	      if (!propagated) {
	        $scope.paragraph.dateStarted = $scope.getFormattedParagraphTime();
	      }
	
	      // handle actual result message in promise
	      heliumService.executeSpell(magic, textWithoutMagic).then(function (resultsMsg) {
	        $scope.prepareSpellTransaction(resultsMsg, propagated, paragraphText);
	
	        $scope.paragraph.results.msg = resultsMsg;
	        $scope.paragraph.config.tableHide = false;
	      }).catch(function (error) {
	        $scope.handleSpellError(paragraphText, error, digestRequired, propagated);
	      });
	    } catch (error) {
	      $scope.handleSpellError(paragraphText, error, digestRequired, propagated);
	    }
	  };
	
	  $scope.runParagraphUsingBackendInterpreter = function (paragraphText) {
	    websocketMsgSrv.runParagraph($scope.paragraph.id, $scope.paragraph.title, paragraphText, $scope.paragraph.config, $scope.paragraph.settings.params);
	  };
	
	  $scope.bindBeforeUnload = function () {
	    angular.element(window).off('beforeunload');
	
	    var confirmOnPageExit = function confirmOnPageExit(e) {
	      // If we haven't been passed the event get the window.event
	      e = e || window.event;
	      var message = 'Do you want to reload this site?';
	
	      // For IE6-8 and Firefox prior to version 4
	      if (e) {
	        e.returnValue = message;
	      }
	      // For Chrome, Safari, IE8+ and Opera 12+
	      return message;
	    };
	    angular.element(window).on('beforeunload', confirmOnPageExit);
	  };
	
	  $scope.unBindBeforeUnload = function () {
	    angular.element(window).off('beforeunload');
	  };
	
	  $scope.saveParagraph = function (paragraph) {
	    var dirtyText = paragraph.text;
	    if (dirtyText === undefined || dirtyText === $scope.originalText) {
	      return;
	    }
	
	    $scope.bindBeforeUnload();
	
	    commitParagraph(paragraph).then(function () {
	      $scope.originalText = dirtyText;
	      $scope.dirtyText = undefined;
	      $scope.unBindBeforeUnload();
	    });
	  };
	
	  $scope.toggleEnableDisable = function (paragraph) {
	    paragraph.config.enabled = !paragraph.config.enabled;
	    commitParagraph(paragraph);
	  };
	
	  /**
	   * @param paragraphText to be parsed
	   * @param digestRequired true if calling `$digest` is required
	   * @param propagated true if update request is sent from other client
	   */
	  $scope.runParagraph = function (paragraphText, digestRequired, propagated) {
	    if (!paragraphText || $scope.isRunning($scope.paragraph)) {
	      return;
	    }
	    var magic = _spell.SpellResult.extractMagic(paragraphText);
	
	    if (heliumService.getSpellByMagic(magic)) {
	      $scope.runParagraphUsingSpell(paragraphText, magic, digestRequired, propagated);
	    } else {
	      $scope.runParagraphUsingBackendInterpreter(paragraphText);
	    }
	
	    $scope.originalText = angular.copy(paragraphText);
	    $scope.dirtyText = undefined;
	
	    if ($scope.paragraph.config.editorSetting.editOnDblClick) {
	      closeEditorAndOpenTable($scope.paragraph);
	    } else if (editorSetting.isOutputHidden && !$scope.paragraph.config.editorSetting.editOnDblClick) {
	      // %md/%angular repl make output to be hidden by default after running
	      // so should open output if repl changed from %md/%angular to another
	      openEditorAndOpenTable($scope.paragraph);
	    }
	    editorSetting.isOutputHidden = $scope.paragraph.config.editorSetting.editOnDblClick;
	  };
	
	  $scope.runParagraphFromShortcut = function (paragraphText) {
	    // passing `digestRequired` as true to update view immediately
	    // without this, results cannot be rendered in view more than once
	    $scope.runParagraph(paragraphText, true, false);
	  };
	
	  $scope.runParagraphFromButton = function () {
	    // we come here from the view, so we don't need to call `$digest()`
	    $scope.runParagraph($scope.getEditorValue(), false, false);
	  };
	
	  $scope.runAllToThis = function (paragraph) {
	    $scope.$emit('runAllAbove', paragraph, true);
	  };
	
	  $scope.runAllFromThis = function (paragraph) {
	    $scope.$emit('runAllBelowAndCurrent', paragraph, true);
	  };
	
	  $scope.runAllToOrFromThis = function (paragraph) {
	    BootstrapDialog.show({
	      message: 'Run paragraphs:',
	      title: '',
	      buttons: [{
	        label: 'Close',
	        action: function action(dialog) {
	          dialog.close();
	        }
	      }, {
	        label: 'Run all above',
	        cssClass: 'btn-primary',
	        action: function action(dialog) {
	          $scope.$emit('runAllAbove', paragraph, false);
	          dialog.close();
	        }
	      }, {
	        label: 'Run current and all below',
	        cssClass: 'btn-primary',
	        action: function action(dialog) {
	          $scope.$emit('runAllBelowAndCurrent', paragraph, false);
	          dialog.close();
	        }
	      }]
	    });
	  };
	
	  $scope.turnOnAutoRun = function (paragraph) {
	    paragraph.config.runOnSelectionChange = !paragraph.config.runOnSelectionChange;
	    commitParagraph(paragraph);
	  };
	
	  $scope.moveUp = function (paragraph) {
	    $scope.$emit('moveParagraphUp', paragraph);
	  };
	
	  $scope.moveDown = function (paragraph) {
	    $scope.$emit('moveParagraphDown', paragraph);
	  };
	
	  $scope.insertNew = function (position) {
	    $scope.$emit('insertParagraph', $scope.paragraph.id, position);
	  };
	
	  $scope.copyPara = function (position) {
	    var editorValue = $scope.getEditorValue();
	    if (editorValue) {
	      $scope.copyParagraph(editorValue, position);
	    }
	  };
	
	  $scope.copyParagraph = function (data, position) {
	    var newIndex = -1;
	    for (var i = 0; i < $scope.note.paragraphs.length; i++) {
	      if ($scope.note.paragraphs[i].id === $scope.paragraph.id) {
	        // determine position of where to add new paragraph; default is below
	        if (position === 'above') {
	          newIndex = i;
	        } else {
	          newIndex = i + 1;
	        }
	        break;
	      }
	    }
	
	    if (newIndex < 0 || newIndex > $scope.note.paragraphs.length) {
	      return;
	    }
	
	    var config = angular.copy($scope.paragraph.config);
	    config.editorHide = false;
	
	    websocketMsgSrv.copyParagraph(newIndex, $scope.paragraph.title, data, config, $scope.paragraph.settings.params);
	  };
	
	  $scope.removeParagraph = function (paragraph) {
	    if ($scope.note.paragraphs.length === 1) {
	      BootstrapDialog.alert({
	        closable: true,
	        message: 'All the paragraphs can\'t be deleted.'
	      });
	    } else {
	      BootstrapDialog.confirm({
	        closable: true,
	        title: '',
	        message: 'Do you want to delete this paragraph?',
	        callback: function callback(result) {
	          if (result) {
	            console.log('Remove paragraph');
	            websocketMsgSrv.removeParagraph(paragraph.id);
	            $scope.$emit('moveFocusToNextParagraph', $scope.paragraph.id);
	          }
	        }
	      });
	    }
	  };
	
	  $scope.clearParagraphOutput = function (paragraph) {
	    websocketMsgSrv.clearParagraphOutput(paragraph.id);
	  };
	
	  $scope.toggleEditor = function (paragraph) {
	    if (paragraph.config.editorHide) {
	      $scope.openEditor(paragraph);
	    } else {
	      $scope.closeEditor(paragraph);
	    }
	  };
	
	  $scope.closeEditor = function (paragraph) {
	    console.log('close the note');
	    paragraph.config.editorHide = true;
	    commitParagraph(paragraph);
	  };
	
	  $scope.openEditor = function (paragraph) {
	    console.log('open the note');
	    paragraph.config.editorHide = false;
	    commitParagraph(paragraph);
	  };
	
	  $scope.closeTable = function (paragraph) {
	    console.log('close the output');
	    paragraph.config.tableHide = true;
	    commitParagraph(paragraph);
	  };
	
	  $scope.openTable = function (paragraph) {
	    console.log('open the output');
	    paragraph.config.tableHide = false;
	    commitParagraph(paragraph);
	  };
	
	  var openEditorAndCloseTable = function openEditorAndCloseTable(paragraph) {
	    manageEditorAndTableState(paragraph, false, true);
	  };
	
	  var closeEditorAndOpenTable = function closeEditorAndOpenTable(paragraph) {
	    manageEditorAndTableState(paragraph, true, false);
	  };
	
	  var openEditorAndOpenTable = function openEditorAndOpenTable(paragraph) {
	    manageEditorAndTableState(paragraph, false, false);
	  };
	
	  var manageEditorAndTableState = function manageEditorAndTableState(paragraph, hideEditor, hideTable) {
	    paragraph.config.editorHide = hideEditor;
	    paragraph.config.tableHide = hideTable;
	    commitParagraph(paragraph);
	  };
	
	  $scope.showTitle = function (paragraph) {
	    paragraph.config.title = true;
	    commitParagraph(paragraph);
	  };
	
	  $scope.hideTitle = function (paragraph) {
	    paragraph.config.title = false;
	    commitParagraph(paragraph);
	  };
	
	  $scope.setTitle = function (paragraph) {
	    commitParagraph(paragraph);
	  };
	
	  $scope.showLineNumbers = function (paragraph) {
	    if ($scope.editor) {
	      paragraph.config.lineNumbers = true;
	      $scope.editor.renderer.setShowGutter(true);
	      commitParagraph(paragraph);
	    }
	  };
	
	  $scope.hideLineNumbers = function (paragraph) {
	    if ($scope.editor) {
	      paragraph.config.lineNumbers = false;
	      $scope.editor.renderer.setShowGutter(false);
	      commitParagraph(paragraph);
	    }
	  };
	
	  $scope.columnWidthClass = function (n) {
	    if ($scope.asIframe) {
	      return 'col-md-12';
	    } else {
	      return 'paragraph-col col-md-' + n;
	    }
	  };
	
	  $scope.changeColWidth = function (paragraph, width) {
	    angular.element('.navbar-right.open').removeClass('open');
	    paragraph.config.colWidth = width;
	    $scope.$broadcast('paragraphResized', $scope.paragraph.id);
	    commitParagraph(paragraph);
	  };
	
	  $scope.changeFontSize = function (paragraph, fontSize) {
	    angular.element('.navbar-right.open').removeClass('open');
	    if ($scope.editor) {
	      $scope.editor.setOptions({
	        fontSize: fontSize + 'pt'
	      });
	      autoAdjustEditorHeight($scope.editor);
	      paragraph.config.fontSize = fontSize;
	      commitParagraph(paragraph);
	    }
	  };
	
	  $scope.toggleOutput = function (paragraph) {
	    paragraph.config.tableHide = !paragraph.config.tableHide;
	    commitParagraph(paragraph);
	  };
	
	  $scope.aceChanged = function (_, editor) {
	    var session = editor.getSession();
	    var dirtyText = session.getValue();
	    $scope.dirtyText = dirtyText;
	    if ($scope.dirtyText !== $scope.originalText) {
	      $scope.startSaveTimer();
	    }
	    setParagraphMode(session, dirtyText, editor.getCursorPosition());
	  };
	
	  $scope.aceLoaded = function (_editor) {
	    var langTools = ace.require('ace/ext/language_tools');
	    var Range = ace.require('ace/range').Range;
	
	    _editor.$blockScrolling = Infinity;
	    $scope.editor = _editor;
	    $scope.editor.on('input', $scope.aceChanged);
	    if (_editor.container.id !== '{{paragraph.id}}_editor') {
	      $scope.editor.renderer.setShowGutter($scope.paragraph.config.lineNumbers);
	      $scope.editor.setShowFoldWidgets(false);
	      $scope.editor.setHighlightActiveLine(false);
	      $scope.editor.getSession().setUseWrapMode(true);
	      $scope.editor.setTheme('ace/theme/magpie');
	      $scope.editor.setReadOnly($scope.isRunning($scope.paragraph));
	
	      if ($scope.paragraphFocused) {
	        var prefix = '%' + getInterpreterName($scope.paragraph.text);
	        var paragraphText = $scope.paragraph.text ? $scope.paragraph.text.trim() : '';
	
	        $scope.editor.focus();
	        $scope.goToEnd($scope.editor);
	        if (prefix === paragraphText) {
	          $timeout(function () {
	            $scope.editor.gotoLine(2, 0);
	          }, 0);
	        }
	      }
	
	      autoAdjustEditorHeight(_editor);
	      angular.element(window).resize(function () {
	        autoAdjustEditorHeight(_editor);
	      });
	
	      if (navigator.appVersion.indexOf('Mac') !== -1) {
	        // SILECTIS -> don't apply emacs key bindings to fix the cursor
	        // $scope.editor.setKeyboardHandler('ace/keyboard/emacs');
	        $rootScope.isMac = true;
	      } else if (navigator.appVersion.indexOf('Win') !== -1 || navigator.appVersion.indexOf('X11') !== -1 || navigator.appVersion.indexOf('Linux') !== -1) {
	        $rootScope.isMac = false;
	        // not applying emacs key binding while the binding override Ctrl-v. default behavior of paste text on windows.
	      }
	
	      $scope.$on('completionListLength', function (event, data) {
	        completionListLength = data;
	      });
	
	      $scope.$on('callCompletion', function (event, data) {
	        if ($scope.paragraphFocused) {
	          websocketMsgSrv.completion($scope.paragraph.id, data.buf, data.pos);
	        }
	      });
	
	      var remoteCompleter = {
	        getCompletions: function getCompletions(editor, session, pos, prefix, callback) {
	          if (!editor.isFocused()) {
	            return;
	          }
	
	          pos = session.getTextRange(new Range(0, 0, pos.row, pos.column)).length;
	          var buf = session.getValue();
	
	          $rootScope.$broadcast('callCompletion', { buf: buf, pos: pos });
	
	          $scope.$on('completionList', function (event, data) {
	            var computeCaption = function computeCaption(value, meta) {
	              var metaLength = meta !== undefined ? meta.length : 0;
	              var length = 42;
	              var whitespaceLength = 3;
	              var ellipses = '...';
	              var maxLengthCaption = length - metaLength - whitespaceLength - ellipses.length;
	              if (value !== undefined && value.length > maxLengthCaption) {
	                return value.substr(0, maxLengthCaption) + ellipses;
	              }
	              return value;
	            };
	
	            if (data.completions) {
	              var completions = [];
	              for (var c in data.completions) {
	                if (data.completions.hasOwnProperty(c)) {
	                  var v = data.completions[c];
	                  completions.push({
	                    name: v.name,
	                    value: v.value,
	                    meta: v.meta,
	                    caption: computeCaption(v.name, v.meta),
	                    score: 300
	                  });
	                }
	              }
	              $rootScope.$broadcast('completionListLength', completions.length);
	              callback(null, completions);
	            }
	          });
	        }
	      };
	
	      langTools.setCompleters([remoteCompleter, langTools.snippetCompleter, langTools.textCompleter]);
	
	      $scope.editor.setOptions({
	        fontSize: $scope.paragraph.config.fontSize + 'pt',
	        enableBasicAutocompletion: true,
	        enableSnippets: false,
	        enableLiveAutocompletion: false
	      });
	
	      $scope.editor.on('focus', function () {
	        handleFocus(true);
	      });
	
	      $scope.editor.on('blur', function () {
	        handleFocus(false);
	        $scope.saveParagraph($scope.paragraph);
	      });
	
	      $scope.editor.on('paste', function (e) {
	        if (e.text.indexOf('%') === 0) {
	          pastePercentSign = true;
	        }
	      });
	
	      $scope.editor.getSession().on('change', function (e, editSession) {
	        autoAdjustEditorHeight(_editor);
	      });
	
	      setParagraphMode($scope.editor.getSession(), $scope.editor.getSession().getValue());
	
	      // autocomplete on '.'
	      /*
	       $scope.editor.commands.on("afterExec", function(e, t) {
	       if (e.command.name == "insertstring" && e.args == "." ) {
	       var all = e.editor.completers;
	       //e.editor.completers = [remoteCompleter];
	       e.editor.execCommand("startAutocomplete");
	       //e.editor.completers = all;
	       }
	       });
	       */
	
	      // remove binding
	      $scope.editor.commands.removeCommand('showSettingsMenu');
	      $scope.editor.commands.removeCommand('find');
	      $scope.editor.commands.removeCommand('replace');
	
	      var isOption = $rootScope.isMac ? 'option' : 'alt';
	
	      $scope.editor.commands.bindKey('ctrl-' + isOption + '-n.', null);
	      $scope.editor.commands.bindKey('ctrl-' + isOption + '-l', null);
	      $scope.editor.commands.bindKey('ctrl-' + isOption + '-w', null);
	      $scope.editor.commands.bindKey('ctrl-' + isOption + '-a', null);
	      $scope.editor.commands.bindKey('ctrl-' + isOption + '-k', null);
	      $scope.editor.commands.bindKey('ctrl-' + isOption + '-e', null);
	      $scope.editor.commands.bindKey('ctrl-' + isOption + '-t', null);
	      $scope.editor.commands.bindKey('ctrl-space', null);
	
	      if ($rootScope.isMac) {
	        $scope.editor.commands.bindKey('command-l', null);
	      } else {
	        $scope.editor.commands.bindKey('ctrl-l', null);
	      }
	
	      // autocomplete on 'ctrl+.'
	      $scope.editor.commands.bindKey('ctrl-.', 'startAutocomplete');
	
	      // Show autocomplete on tab
	      $scope.editor.commands.addCommand({
	        name: 'tabAutocomplete',
	        bindKey: {
	          win: 'tab',
	          mac: 'tab',
	          sender: 'editor|cli'
	        },
	        exec: function exec(env, args, request) {
	          var iCursor = $scope.editor.getCursorPosition();
	          var currentLine = $scope.editor.session.getLine(iCursor.row);
	          var isAllTabs = currentLine.substring(0, iCursor.column - 1).split('').every(function (char) {
	            return char === '\t' || char === ' ';
	          });
	
	          // If user has pressed tab on first line char or if isTabCompletion() is false, keep existing behavior
	          // If user has pressed tab anywhere in between and editor mode is not %md, show autocomplete
	          if (!isAllTabs && iCursor.column && isTabCompletion()) {
	            $scope.editor.execCommand('startAutocomplete');
	          } else {
	            ace.config.loadModule('ace/ext/language_tools', function () {
	              $scope.editor.indent();
	            });
	          }
	        }
	      });
	
	      var keyBindingEditorFocusAction = function keyBindingEditorFocusAction(scrollValue) {
	        var numRows = $scope.editor.getSession().getLength();
	        var currentRow = $scope.editor.getCursorPosition().row;
	        if (currentRow === 0 && scrollValue <= 0) {
	          // move focus to previous paragraph
	          $scope.$emit('moveFocusToPreviousParagraph', $scope.paragraph.id);
	        } else if (currentRow === numRows - 1 && scrollValue >= 0) {
	          $scope.$emit('moveFocusToNextParagraph', $scope.paragraph.id);
	        } else {
	          $scope.scrollToCursor($scope.paragraph.id, scrollValue);
	        }
	      };
	
	      // handle cursor moves
	      $scope.editor.keyBinding.origOnCommandKey = $scope.editor.keyBinding.onCommandKey;
	      $scope.editor.keyBinding.onCommandKey = function (e, hashId, keyCode) {
	        if ($scope.editor.completer && $scope.editor.completer.activated) {// if autocompleter is active
	        } else {
	          // fix ace editor focus issue in chrome (textarea element goes to top: -1000px after focused by cursor move)
	          if (parseInt(angular.element('#' + $scope.paragraph.id + '_editor > textarea').css('top').replace('px', '')) < 0) {
	            var position = $scope.editor.getCursorPosition();
	            var cursorPos = $scope.editor.renderer.$cursorLayer.getPixelPosition(position, true);
	            angular.element('#' + $scope.paragraph.id + '_editor > textarea').css('top', cursorPos.top);
	          }
	
	          var ROW_UP = -1;
	          var ROW_DOWN = 1;
	
	          switch (keyCode) {
	            case 38:
	              if (!e.shiftKey) {
	                keyBindingEditorFocusAction(ROW_UP);
	              }
	              break;
	            case 80:
	              if (e.ctrlKey && !e.altKey) {
	                keyBindingEditorFocusAction(ROW_UP);
	              }
	              break;
	            case 40:
	              if (!e.shiftKey) {
	                keyBindingEditorFocusAction(ROW_DOWN);
	              }
	              break;
	            case 78:
	              if (e.ctrlKey && !e.altKey) {
	                keyBindingEditorFocusAction(ROW_DOWN);
	              }
	              break;
	          }
	        }
	        this.origOnCommandKey(e, hashId, keyCode);
	      };
	    }
	  };
	
	  // ref: https://github.com/ajaxorg/ace/blob/5021d0193d9f2bba5a978d0b1d7a4f73d18ce713/lib/ace/autocomplete.js#L454
	  var completionSupportWithoutBackend = function completionSupportWithoutBackend(str) {
	    var self = this; // eslint-disable-line no-invalid-this
	    var matches = void 0;
	    if (str.length > self.filterText && str.lastIndexOf(self.filterText, 0) === 0) {
	      matches = self.filtered;
	    } else {
	      matches = self.all;
	    }
	
	    self.filterText = str;
	    matches = self.filterCompletions(matches, self.filterText);
	    matches = matches.sort(function (a, b) {
	      return b.exactMatch - a.exactMatch || b.score - a.score;
	    });
	    var prev = null;
	
	    matches = matches.filter(function (item) {
	      var caption = item.snippet || item.caption || item.value;
	      if (caption === prev) {
	        return false;
	      }
	      prev = caption;
	      return true;
	    });
	    self.filtered = matches;
	  };
	
	  var completionSupportWithBackend = function completionSupportWithBackend(str) {
	    var self = this; // eslint-disable-line no-invalid-this
	    var matches = void 0;
	    if (str.length > self.filterText && str.lastIndexOf(self.filterText, 0) === 0) {
	      matches = self.filtered;
	    } else {
	      matches = self.all;
	    }
	    self.filterText = str;
	    matches = self.filterCompletions(matches, self.filterText);
	    matches = matches.sort(function (a, b) {
	      return b.exactMatch - a.exactMatch || b.score - a.score;
	    });
	    var prev = null;
	
	    matches = matches.filter(function (item) {
	      if (!_.isEmpty(item.meta)) {
	        if (completionListLength !== 0) {
	          return false;
	        }
	      }
	      var caption = item.snippet || item.caption || item.value;
	      if (caption === prev) {
	        return false;
	      }
	      prev = caption;
	      return true;
	    });
	    self.filtered = matches;
	    completionListLength = undefined;
	  };
	
	  var handleFocus = function handleFocus(focused, isDigestPass) {
	    $scope.paragraphFocused = focused;
	    if (focused) {
	      var filteredList = ace.require('ace/autocomplete').FilteredList;
	      if ($scope.paragraph.config.editorSetting.completionSupport) {
	        filteredList.prototype.setFilter = completionSupportWithBackend;
	      } else {
	        filteredList.prototype.setFilter = completionSupportWithoutBackend;
	      }
	    }
	
	    if ($scope.editor) {
	      $scope.editor.setHighlightActiveLine(focused);
	    }
	
	    if (isDigestPass === false || isDigestPass === undefined) {
	      // Protect against error in case digest is already running
	      $timeout(function () {
	        // Apply changes since they come from 3rd party library
	        $scope.$digest();
	      });
	    }
	  };
	
	  var getEditorSetting = function getEditorSetting(paragraph, interpreterName) {
	    var deferred = $q.defer();
	    if (!$scope.revisionView) {
	      websocketMsgSrv.getEditorSetting(paragraph.id, interpreterName);
	      $timeout($scope.$on('editorSetting', function (event, data) {
	        if (paragraph.id === data.paragraphId) {
	          deferred.resolve(data);
	        }
	      }), 1000);
	    }
	    return deferred.promise;
	  };
	
	  var setEditorLanguage = function setEditorLanguage(session, language) {
	    var mode = 'ace/mode/';
	    mode += language;
	    $scope.paragraph.config.editorMode = mode;
	    session.setMode(mode);
	  };
	
	  var setParagraphMode = function setParagraphMode(session, paragraphText, pos) {
	    // Evaluate the mode only if the the position is undefined
	    // or the first 30 characters of the paragraph have been modified
	    // or cursor position is at beginning of second line.(in case user hit enter after typing %magic)
	    if (typeof pos === 'undefined' || pos.row === 0 && pos.column < 30 || pos.row === 1 && pos.column === 0 || pastePercentSign) {
	      // If paragraph loading, use config value if exists
	      if (typeof pos === 'undefined' && $scope.paragraph.config.editorMode && !setInterpreterBindings) {
	        session.setMode($scope.paragraph.config.editorMode);
	      } else {
	        var magic = getInterpreterName(paragraphText);
	        if (editorSetting.magic !== magic) {
	          editorSetting.magic = magic;
	          getEditorSetting($scope.paragraph, magic).then(function (setting) {
	            setEditorLanguage(session, setting.editor.language);
	            _.merge($scope.paragraph.config.editorSetting, setting.editor);
	          });
	        }
	      }
	    }
	    pastePercentSign = false;
	    setInterpreterBindings = false;
	  };
	
	  var getInterpreterName = function getInterpreterName(paragraphText) {
	    var intpNameRegexp = /^\s*%(.+?)(\s|\()/g;
	    var match = intpNameRegexp.exec(paragraphText);
	    if (match) {
	      return match[1].trim();
	      // get default interpreter name if paragraph text doesn't start with '%'
	      // TODO(mina): dig into the cause what makes interpreterBindings to have no element
	    } else if ($scope.$parent.interpreterBindings && $scope.$parent.interpreterBindings.length !== 0) {
	      return $scope.$parent.interpreterBindings[0].name;
	    }
	    return '';
	  };
	
	  var autoAdjustEditorHeight = function autoAdjustEditorHeight(editor) {
	    var height = editor.getSession().getScreenLength() * editor.renderer.lineHeight;
	
	    angular.element('#' + editor.container.id).height(height.toString() + 'px');
	    editor.resize();
	  };
	
	  $rootScope.$on('scrollToCursor', function (event) {
	    // scroll on 'scrollToCursor' event only when cursor is in the last paragraph
	    var paragraphs = angular.element('div[id$="_paragraphColumn_main"]');
	    if (paragraphs[paragraphs.length - 1].id.indexOf($scope.paragraph.id) === 0) {
	      $scope.scrollToCursor($scope.paragraph.id, 0);
	    }
	  });
	
	  /** scrollToCursor if it is necessary
	   * when cursor touches scrollTriggerEdgeMargin from the top (or bottom) of the screen, it autoscroll to place cursor around 1/3 of screen height from the top (or bottom)
	   * paragraphId : paragraph that has active cursor
	   * lastCursorMove : 1(down), 0, -1(up) last cursor move event
	   **/
	  $scope.scrollToCursor = function (paragraphId, lastCursorMove) {
	    if (!$scope.editor || !$scope.editor.isFocused()) {
	      // only make sense when editor is focused
	      return;
	    }
	    var lineHeight = $scope.editor.renderer.lineHeight;
	    var headerHeight = 103; // menubar, notebook titlebar
	    var scrollTriggerEdgeMargin = 50;
	
	    var documentHeight = angular.element(document).height();
	    var windowHeight = angular.element(window).height(); // actual viewport height
	
	    var scrollPosition = angular.element(document).scrollTop();
	    var editorPosition = angular.element('#' + paragraphId + '_editor').offset();
	    var position = $scope.editor.getCursorPosition();
	    var lastCursorPosition = $scope.editor.renderer.$cursorLayer.getPixelPosition(position, true);
	
	    var calculatedCursorPosition = editorPosition.top + lastCursorPosition.top + lineHeight * lastCursorMove;
	
	    var scrollTargetPos = void 0;
	    if (calculatedCursorPosition < scrollPosition + headerHeight + scrollTriggerEdgeMargin) {
	      scrollTargetPos = calculatedCursorPosition - headerHeight - (windowHeight - headerHeight) / 3;
	      if (scrollTargetPos < 0) {
	        scrollTargetPos = 0;
	      }
	    } else if (calculatedCursorPosition > scrollPosition + scrollTriggerEdgeMargin + windowHeight - headerHeight) {
	      scrollTargetPos = calculatedCursorPosition - headerHeight - (windowHeight - headerHeight) * 2 / 3;
	
	      if (scrollTargetPos > documentHeight) {
	        scrollTargetPos = documentHeight;
	      }
	    }
	
	    // cancel previous scroll animation
	    var bodyEl = angular.element('body');
	    bodyEl.stop();
	    bodyEl.finish();
	
	    // scroll to scrollTargetPos
	    if (scrollTargetPos) {
	      bodyEl.scrollTo(scrollTargetPos, { axis: 'y', interrupt: true, duration: 100 });
	    }
	  };
	
	  $scope.getEditorValue = function () {
	    return !$scope.editor ? $scope.paragraph.text : $scope.editor.getValue();
	  };
	
	  $scope.getProgress = function () {
	    return $scope.currentProgress || 0;
	  };
	
	  $scope.getFormattedParagraphTime = function () {
	    return (0, _moment2.default)().toISOString();
	  };
	
	  $scope.getExecutionTime = function (pdata) {
	    var end = pdata.dateFinished;
	    var start = pdata.dateStarted;
	    var timeMs = Date.parse(end) - Date.parse(start);
	    if (isNaN(timeMs) || timeMs < 0) {
	      if ($scope.isResultOutdated(pdata)) {
	        return 'outdated';
	      }
	      return '';
	    }
	
	    var durationFormat = _moment2.default.duration(timeMs / 1000, 'seconds').format('h [hrs] m [min] s [sec]');
	    var endFormat = (0, _moment2.default)(pdata.dateFinished).format('MMMM DD YYYY, h:mm:ss A');
	
	    var user = pdata.user === undefined || pdata.user === null ? 'anonymous' : pdata.user;
	    var desc = 'Took ' + durationFormat + '. Last updated by ' + user + ' at ' + endFormat + '.';
	
	    if ($scope.isResultOutdated(pdata)) {
	      desc += ' (outdated)';
	    }
	
	    return desc;
	  };
	
	  $scope.getElapsedTime = function (paragraph) {
	    return 'Started ' + (0, _moment2.default)(paragraph.dateStarted).fromNow() + '.';
	  };
	
	  $scope.isResultOutdated = function (pdata) {
	    if (pdata.dateUpdated !== undefined && Date.parse(pdata.dateUpdated) > Date.parse(pdata.dateStarted)) {
	      return true;
	    }
	    return false;
	  };
	
	  $scope.goToEnd = function (editor) {
	    editor.navigateFileEnd();
	  };
	
	  $scope.parseTableCell = function (cell) {
	    if (!isNaN(cell)) {
	      if (cell.length === 0 || Number(cell) > Number.MAX_SAFE_INTEGER || Number(cell) < Number.MIN_SAFE_INTEGER) {
	        return cell;
	      } else {
	        return Number(cell);
	      }
	    }
	    var d = (0, _moment2.default)(cell);
	    if (d.isValid()) {
	      return d;
	    }
	    return cell;
	  };
	
	  var commitParagraph = function commitParagraph(paragraph) {
	    var id = paragraph.id,
	        title = paragraph.title,
	        text = paragraph.text,
	        config = paragraph.config,
	        params = paragraph.settings.params;
	
	
	    return websocketMsgSrv.commitParagraph(id, title, text, config, params, $route.current.pathParams.noteId);
	  };
	
	  /** Utility function */
	  $scope.goToSingleParagraph = function () {
	    var noteId = $route.current.pathParams.noteId;
	    var redirectToUrl = location.protocol + '//' + location.host + location.pathname + '#/notebook/' + noteId + '/paragraph/' + $scope.paragraph.id + '?asIframe';
	    $window.open(redirectToUrl);
	  };
	
	  $scope.showScrollDownIcon = function (id) {
	    var doc = angular.element('#p' + id + '_text');
	    if (doc[0]) {
	      return doc[0].scrollHeight > doc.innerHeight();
	    }
	    return false;
	  };
	
	  $scope.scrollParagraphDown = function (id) {
	    var doc = angular.element('#p' + id + '_text');
	    doc.animate({ scrollTop: doc[0].scrollHeight }, 500);
	    $scope.keepScrollDown = true;
	  };
	
	  $scope.showScrollUpIcon = function (id) {
	    if (angular.element('#p' + id + '_text')[0]) {
	      return angular.element('#p' + id + '_text')[0].scrollTop !== 0;
	    }
	    return false;
	  };
	
	  $scope.scrollParagraphUp = function (id) {
	    var doc = angular.element('#p' + id + '_text');
	    doc.animate({ scrollTop: 0 }, 500);
	    $scope.keepScrollDown = false;
	  };
	
	  $scope.$on('angularObjectUpdate', function (event, data) {
	    var noteId = $route.current.pathParams.noteId;
	    if (!data.noteId || data.noteId === noteId) {
	      var scope = void 0;
	      var registry = void 0;
	
	      if (!data.paragraphId || data.paragraphId === $scope.paragraph.id) {
	        scope = paragraphScope;
	        registry = angularObjectRegistry;
	      } else {
	        return;
	      }
	      var varName = data.angularObject.name;
	
	      if (angular.equals(data.angularObject.object, scope[varName])) {
	        // return when update has no change
	        return;
	      }
	
	      if (!registry[varName]) {
	        registry[varName] = {
	          interpreterGroupId: data.interpreterGroupId,
	          noteId: data.noteId,
	          paragraphId: data.paragraphId
	        };
	      } else {
	        registry[varName].noteId = registry[varName].noteId || data.noteId;
	        registry[varName].paragraphId = registry[varName].paragraphId || data.paragraphId;
	      }
	
	      registry[varName].skipEmit = true;
	
	      if (!registry[varName].clearWatcher) {
	        registry[varName].clearWatcher = scope.$watch(varName, function (newValue, oldValue) {
	          console.log('angular object (paragraph) updated %o %o', varName, registry[varName]);
	          if (registry[varName].skipEmit) {
	            registry[varName].skipEmit = false;
	            return;
	          }
	          websocketMsgSrv.updateAngularObject(registry[varName].noteId, registry[varName].paragraphId, varName, newValue, registry[varName].interpreterGroupId);
	        });
	      }
	      console.log('angular object (paragraph) created %o', varName);
	      scope[varName] = data.angularObject.object;
	
	      // create proxy for AngularFunction
	      if (varName.indexOf(ANGULAR_FUNCTION_OBJECT_NAME_PREFIX) === 0) {
	        var funcName = varName.substring(ANGULAR_FUNCTION_OBJECT_NAME_PREFIX.length);
	        scope[funcName] = function () {
	          // eslint-disable-next-line prefer-rest-params
	          scope[varName] = arguments;
	          // eslint-disable-next-line prefer-rest-params
	          console.log('angular function (paragraph) invoked %o', arguments);
	        };
	
	        console.log('angular function (paragraph) created %o', scope[funcName]);
	      }
	    }
	  });
	
	  $scope.$on('updateParaInfos', function (event, data) {
	    if (data.id === $scope.paragraph.id) {
	      $scope.paragraph.runtimeInfos = data.infos;
	    }
	  });
	
	  $scope.$on('angularObjectRemove', function (event, data) {
	    var noteId = $route.current.pathParams.noteId;
	    if (!data.noteId || data.noteId === noteId) {
	      var scope = void 0;
	      var registry = void 0;
	
	      if (!data.paragraphId || data.paragraphId === $scope.paragraph.id) {
	        scope = paragraphScope;
	        registry = angularObjectRegistry;
	      } else {
	        return;
	      }
	
	      var varName = data.name;
	
	      // clear watcher
	      if (registry[varName]) {
	        registry[varName].clearWatcher();
	        registry[varName] = undefined;
	      }
	
	      // remove scope variable
	      scope[varName] = undefined;
	
	      // remove proxy for AngularFunction
	      if (varName.indexOf(ANGULAR_FUNCTION_OBJECT_NAME_PREFIX) === 0) {
	        var funcName = varName.substring(ANGULAR_FUNCTION_OBJECT_NAME_PREFIX.length);
	        scope[funcName] = undefined;
	      }
	    }
	  });
	
	  /**
	   * @returns {boolean} true if updated is needed
	   */
	  function isUpdateRequired(oldPara, newPara) {
	    return newPara.id === oldPara.id && (newPara.dateCreated !== oldPara.dateCreated || newPara.text !== oldPara.text || newPara.dateFinished !== oldPara.dateFinished || newPara.dateStarted !== oldPara.dateStarted || newPara.dateUpdated !== oldPara.dateUpdated || newPara.status !== oldPara.status || newPara.jobName !== oldPara.jobName || newPara.title !== oldPara.title || isEmpty(newPara.results) !== isEmpty(oldPara.results) || newPara.errorMessage !== oldPara.errorMessage || !angular.equals(newPara.settings, oldPara.settings) || !angular.equals(newPara.config, oldPara.config) || !angular.equals(newPara.runtimeInfos, oldPara.runtimeInfos));
	  }
	
	  $scope.updateAllScopeTexts = function (oldPara, newPara) {
	    if (oldPara.text !== newPara.text) {
	      if ($scope.dirtyText) {
	        // check if editor has local update
	        if ($scope.dirtyText === newPara.text) {
	          // when local update is the same from remote, clear local update
	          $scope.paragraph.text = newPara.text;
	          $scope.dirtyText = undefined;
	          $scope.originalText = angular.copy(newPara.text);
	        } else {
	          // if there're local update, keep it.
	          $scope.paragraph.text = newPara.text;
	        }
	      } else {
	        $scope.paragraph.text = newPara.text;
	        $scope.originalText = angular.copy(newPara.text);
	      }
	    }
	  };
	
	  $scope.updateParagraphObjectWhenUpdated = function (newPara) {
	    // resize col width
	    if ($scope.paragraph.config.colWidth !== newPara.config.colWidth) {
	      $scope.$broadcast('paragraphResized', $scope.paragraph.id);
	    }
	
	    if ($scope.paragraph.config.fontSize !== newPara.config.fontSize) {
	      $rootScope.$broadcast('fontSizeChanged', newPara.config.fontSize);
	    }
	
	    /** push the rest */
	    $scope.paragraph.aborted = newPara.aborted;
	    $scope.paragraph.user = newPara.user;
	    $scope.paragraph.dateUpdated = newPara.dateUpdated;
	    $scope.paragraph.dateCreated = newPara.dateCreated;
	    $scope.paragraph.dateFinished = newPara.dateFinished;
	    $scope.paragraph.dateStarted = newPara.dateStarted;
	    $scope.paragraph.errorMessage = newPara.errorMessage;
	    $scope.paragraph.jobName = newPara.jobName;
	    $scope.paragraph.title = newPara.title;
	    $scope.paragraph.lineNumbers = newPara.lineNumbers;
	    $scope.paragraph.status = newPara.status;
	    $scope.paragraph.fontSize = newPara.fontSize;
	    if (newPara.status !== _paragraph.ParagraphStatus.RUNNING) {
	      $scope.paragraph.results = newPara.results;
	    }
	    $scope.paragraph.settings = newPara.settings;
	    $scope.paragraph.runtimeInfos = newPara.runtimeInfos;
	    if ($scope.editor) {
	      $scope.editor.setReadOnly($scope.isRunning(newPara));
	    }
	
	    if (!$scope.asIframe) {
	      $scope.paragraph.config = newPara.config;
	      initializeDefault(newPara.config);
	    } else {
	      newPara.config.editorHide = true;
	      newPara.config.tableHide = false;
	      $scope.paragraph.config = newPara.config;
	    }
	  };
	
	  $scope.updateParagraph = function (oldPara, newPara, updateCallback) {
	    // 1. can't update on revision view
	    if ($scope.revisionView === true) {
	      return;
	    }
	
	    // 2. get status, refreshed
	    var statusChanged = newPara.status !== oldPara.status;
	    var resultRefreshed = newPara.dateFinished !== oldPara.dateFinished || isEmpty(newPara.results) !== isEmpty(oldPara.results) || newPara.status === _paragraph.ParagraphStatus.ERROR || newPara.status === _paragraph.ParagraphStatus.FINISHED && statusChanged;
	
	    // 3. update texts managed by $scope
	    $scope.updateAllScopeTexts(oldPara, newPara);
	
	    // 4. execute callback to update result
	    updateCallback();
	
	    // 5. update remaining paragraph objects
	    $scope.updateParagraphObjectWhenUpdated(newPara);
	
	    // 6. handle scroll down by key properly if new paragraph is added
	    if (statusChanged || resultRefreshed) {
	      // when last paragraph runs, zeppelin automatically appends new paragraph.
	      // this broadcast will focus to the newly inserted paragraph
	      var paragraphs = angular.element('div[id$="_paragraphColumn_main"]');
	      if (paragraphs.length >= 2 && paragraphs[paragraphs.length - 2].id.indexOf($scope.paragraph.id) === 0) {
	        // rendering output can took some time. So delay scrolling event firing for sometime.
	        setTimeout(function () {
	          $rootScope.$broadcast('scrollToCursor');
	        }, 500);
	      }
	    }
	  };
	
	  /** $scope.$on */
	
	  $scope.$on('runParagraphUsingSpell', function (event, data) {
	    var oldPara = $scope.paragraph;
	    var newPara = data.paragraph;
	    var updateCallback = function updateCallback() {
	      $scope.runParagraph(newPara.text, true, true);
	    };
	
	    if (!isUpdateRequired(oldPara, newPara)) {
	      return;
	    }
	
	    $scope.updateParagraph(oldPara, newPara, updateCallback);
	  });
	
	  $scope.$on('updateParagraph', function (event, data) {
	    var oldPara = $scope.paragraph;
	    var newPara = data.paragraph;
	
	    if (!isUpdateRequired(oldPara, newPara)) {
	      return;
	    }
	
	    var updateCallback = function updateCallback() {
	      // broadcast `updateResult` message to trigger result update
	      if (newPara.results && newPara.results.msg) {
	        for (var i in newPara.results.msg) {
	          if (newPara.results.msg.hasOwnProperty(i)) {
	            var newResult = newPara.results.msg ? newPara.results.msg[i] : {};
	            var oldResult = oldPara.results && oldPara.results.msg ? oldPara.results.msg[i] : {};
	            var newConfig = newPara.config.results ? newPara.config.results[i] : {};
	            var oldConfig = oldPara.config.results ? oldPara.config.results[i] : {};
	            if (!angular.equals(newResult, oldResult) || !angular.equals(newConfig, oldConfig)) {
	              $rootScope.$broadcast('updateResult', newResult, newConfig, newPara, parseInt(i));
	            }
	          }
	        }
	      }
	    };
	
	    $scope.updateParagraph(oldPara, newPara, updateCallback);
	  });
	
	  $scope.$on('updateProgress', function (event, data) {
	    if (data.id === $scope.paragraph.id) {
	      $scope.currentProgress = data.progress;
	    }
	  });
	
	  $scope.$on('appendParagraphOutput', function (event, data) {
	    if (data.paragraphId === $scope.paragraph.id) {
	      if (!$scope.paragraph.results) {
	        $scope.paragraph.results = {};
	
	        if (!$scope.paragraph.results.msg) {
	          $scope.paragraph.results.msg = [];
	        }
	
	        $scope.paragraph.results.msg[data.index] = {
	          data: data.data,
	          type: data.type
	        };
	
	        $rootScope.$broadcast('updateResult', $scope.paragraph.results.msg[data.index], $scope.paragraph.config.results[data.index], $scope.paragraph, data.index);
	      }
	    }
	  });
	
	  $scope.$on('keyEvent', function (event, keyEvent) {
	    if ($scope.paragraphFocused) {
	      var paragraphId = $scope.paragraph.id;
	      var keyCode = keyEvent.keyCode;
	      var noShortcutDefined = false;
	      var editorHide = $scope.paragraph.config.editorHide;
	
	      if (editorHide && (keyCode === 38 || keyCode === 80 && keyEvent.ctrlKey && !keyEvent.altKey)) {
	        // up
	        // move focus to previous paragraph
	        $scope.$emit('moveFocusToPreviousParagraph', paragraphId);
	      } else if (editorHide && (keyCode === 40 || keyCode === 78 && keyEvent.ctrlKey && !keyEvent.altKey)) {
	        // down
	        // move focus to next paragraph
	        // $timeout stops chaining effect of focus propogation
	        $timeout(function () {
	          return $scope.$emit('moveFocusToNextParagraph', paragraphId);
	        });
	      } else if (!keyEvent.ctrlKey && keyEvent.shiftKey && keyCode === 13) {
	        // Shift + Enter
	        $scope.runParagraphFromShortcut($scope.getEditorValue());
	      } else if (keyEvent.ctrlKey && keyEvent.shiftKey && keyCode === 13) {
	        // Ctrl + Shift + Enter
	        $scope.runAllToOrFromThis($scope.paragraph);
	      } else if (keyEvent.ctrlKey && keyEvent.altKey && keyCode === 67) {
	        // Ctrl + Alt + c
	        $scope.cancelParagraph($scope.paragraph);
	      } else if (keyEvent.ctrlKey && keyEvent.altKey && keyCode === 68) {
	        // Ctrl + Alt + d
	        $scope.removeParagraph($scope.paragraph);
	      } else if (keyEvent.ctrlKey && keyEvent.altKey && keyCode === 75) {
	        // Ctrl + Alt + k
	        $scope.moveUp($scope.paragraph);
	      } else if (keyEvent.ctrlKey && keyEvent.altKey && keyCode === 74) {
	        // Ctrl + Alt + j
	        $scope.moveDown($scope.paragraph);
	      } else if (keyEvent.ctrlKey && keyEvent.altKey && keyCode === 65) {
	        // Ctrl + Alt + a
	        $scope.insertNew('above');
	      } else if (keyEvent.ctrlKey && keyEvent.altKey && keyCode === 66) {
	        // Ctrl + Alt + b
	        $scope.insertNew('below');
	      } else if (keyEvent.ctrlKey && keyEvent.altKey && keyCode === 79) {
	        // Ctrl + Alt + o
	        $scope.toggleOutput($scope.paragraph);
	      } else if (keyEvent.ctrlKey && keyEvent.altKey && keyCode === 82) {
	        // Ctrl + Alt + r
	        $scope.toggleEnableDisable($scope.paragraph);
	      } else if (keyEvent.ctrlKey && keyEvent.altKey && keyCode === 69) {
	        // Ctrl + Alt + e
	        $scope.toggleEditor($scope.paragraph);
	      } else if (keyEvent.ctrlKey && keyEvent.altKey && keyCode === 77) {
	        // Ctrl + Alt + m
	        if ($scope.paragraph.config.lineNumbers) {
	          $scope.hideLineNumbers($scope.paragraph);
	        } else {
	          $scope.showLineNumbers($scope.paragraph);
	        }
	      } else if (keyEvent.ctrlKey && keyEvent.shiftKey && keyCode === 189) {
	        // Ctrl + Shift + -
	        $scope.changeColWidth($scope.paragraph, Math.max(1, $scope.paragraph.config.colWidth - 1));
	      } else if (keyEvent.ctrlKey && keyEvent.shiftKey && keyCode === 187) {
	        // Ctrl + Shift + =
	        $scope.changeColWidth($scope.paragraph, Math.min(12, $scope.paragraph.config.colWidth + 1));
	      } else if (keyEvent.ctrlKey && keyEvent.altKey && keyCode === 84) {
	        // Ctrl + Alt + t
	        if ($scope.paragraph.config.title) {
	          $scope.hideTitle($scope.paragraph);
	        } else {
	          $scope.showTitle($scope.paragraph);
	        }
	      } else if (keyEvent.ctrlKey && keyEvent.shiftKey && keyCode === 67) {
	        // Ctrl + Alt + c
	        $scope.copyPara('below');
	      } else if (keyEvent.ctrlKey && keyEvent.altKey && keyCode === 76) {
	        // Ctrl + Alt + l
	        $scope.clearParagraphOutput($scope.paragraph);
	      } else if (keyEvent.ctrlKey && keyEvent.altKey && keyCode === 87) {
	        // Ctrl + Alt + w
	        $scope.goToSingleParagraph();
	      } else if (keyEvent.ctrlKey && keyEvent.altKey && keyCode === 70) {
	        // Ctrl + f
	        $scope.$emit('toggleSearchBox');
	      } else {
	        noShortcutDefined = true;
	      }
	
	      if (!noShortcutDefined) {
	        keyEvent.preventDefault();
	      }
	    }
	  });
	
	  $scope.$on('focusParagraph', function (event, paragraphId, cursorPosRow, cursorPosCol, mouseEvent) {
	    if (cursorPosCol === null || cursorPosCol === undefined) {
	      cursorPosCol = 0;
	    }
	    if ($scope.paragraph.id === paragraphId) {
	      // focus editor
	      if (!$scope.paragraph.config.editorHide) {
	        if (!mouseEvent) {
	          $scope.editor.focus();
	          // move cursor to the first row (or the last row)
	          var row = void 0;
	          if (cursorPosRow >= 0) {
	            row = cursorPosRow;
	            $scope.editor.gotoLine(row, cursorPosCol);
	          } else {
	            row = $scope.editor.session.getLength();
	            $scope.editor.gotoLine(row, cursorPosCol);
	          }
	          $scope.scrollToCursor($scope.paragraph.id, cursorPosCol);
	        }
	      }
	      handleFocus(true);
	    } else {
	      if ($scope.editor !== undefined && $scope.editor !== null) {
	        $scope.editor.blur();
	      }
	      var isDigestPass = true;
	      handleFocus(false, isDigestPass);
	    }
	  });
	
	  $scope.$on('saveInterpreterBindings', function (event, paragraphId) {
	    if ($scope.paragraph.id === paragraphId && $scope.editor) {
	      setInterpreterBindings = true;
	      setParagraphMode($scope.editor.getSession(), $scope.editor.getSession().getValue());
	    }
	  });
	
	  $scope.$on('doubleClickParagraph', function (event, paragraphId) {
	    if ($scope.paragraph.id === paragraphId && $scope.paragraph.config.editorHide && $scope.paragraph.config.editorSetting.editOnDblClick && $scope.revisionView !== true) {
	      var deferred = $q.defer();
	      openEditorAndCloseTable($scope.paragraph);
	      $timeout($scope.$on('updateParagraph', function (event, data) {
	        deferred.resolve(data);
	      }), 1000);
	
	      deferred.promise.then(function (data) {
	        if ($scope.editor) {
	          $scope.editor.focus();
	          $scope.goToEnd($scope.editor);
	        }
	      });
	    }
	  });
	
	  $scope.$on('openEditor', function (event) {
	    $scope.openEditor($scope.paragraph);
	  });
	
	  $scope.$on('closeEditor', function (event) {
	    $scope.closeEditor($scope.paragraph);
	  });
	
	  $scope.$on('openTable', function (event) {
	    $scope.openTable($scope.paragraph);
	  });
	
	  $scope.$on('closeTable', function (event) {
	    $scope.closeTable($scope.paragraph);
	  });
	
	  $scope.$on('resultRendered', function (event, paragraphId) {
	    if ($scope.paragraph.id !== paragraphId) {
	      return;
	    }
	
	    /** increase spell result count and return if not finished */
	    if (!$scope.increaseSpellTransactionResultCount()) {
	      return;
	    }
	
	    $scope.cleanupSpellTransaction();
	  });
	
	  $scope.$on('fontSizeChanged', function (event, fontSize) {
	    if ($scope.editor) {
	      $scope.editor.setOptions({
	        fontSize: fontSize + 'pt'
	      });
	    }
	  });
	
	  var clearSearchSelection = function clearSearchSelection() {
	    for (var i = 0; i < searchRanges.length; ++i) {
	      $scope.editor.session.removeMarker(searchRanges[i].markerId);
	    }
	    searchRanges = [];
	    if (currentRange.id !== -1) {
	      $scope.editor.session.removeMarker(currentRange.markerId);
	    }
	    currentRange = getCurrentRangeDefault();
	  };
	
	  $scope.onEditorClick = function () {
	    $scope.$emit('editorClicked');
	  };
	
	  $scope.$on('unmarkAll', function () {
	    clearSearchSelection();
	  });
	
	  var markAllOccurrences = function markAllOccurrences(text) {
	    clearSearchSelection();
	    if (text === '') {
	      return;
	    }
	    if ($scope.editor.findAll(text) === 0) {
	      return;
	    }
	    var ranges = $scope.editor.selection.getAllRanges();
	    $scope.editor.selection.toSingleRange();
	    $scope.editor.selection.clearSelection();
	    for (var i = 0; i < ranges.length; ++i) {
	      var id = $scope.editor.session.addMarker(ranges[i], 'ace_selected-word', 'text');
	      searchRanges.push({ markerId: id, range: ranges[i] });
	    }
	  };
	
	  $scope.$on('markAllOccurrences', function (event, text) {
	    markAllOccurrences(text);
	    if (searchRanges.length > 0) {
	      $scope.$emit('occurrencesExists', searchRanges.length);
	    }
	  });
	
	  $scope.$on('nextOccurrence', function (event, paragraphId) {
	    if ($scope.paragraph.id !== paragraphId) {
	      return;
	    }
	    var highlightedRangeExists = currentRange.id !== -1;
	    if (highlightedRangeExists) {
	      $scope.editor.session.removeMarker(currentRange.markerId);
	      currentRange.markerId = -1;
	    }
	    ++currentRange.id;
	    if (currentRange.id >= searchRanges.length) {
	      currentRange.id = -1;
	      $scope.$emit('noNextOccurrence');
	      return;
	    }
	    currentRange.markerId = $scope.editor.session.addMarker(searchRanges[currentRange.id].range, 'ace_selection', 'text');
	  });
	
	  $scope.$on('prevOccurrence', function (event, paragraphId) {
	    if ($scope.paragraph.id !== paragraphId) {
	      return;
	    }
	    var highlightedRangeExists = currentRange.id !== -1;
	    if (highlightedRangeExists) {
	      $scope.editor.session.removeMarker(currentRange.markerId);
	      currentRange.markerId = -1;
	    }
	    if (currentRange.id === -1) {
	      currentRange.id = searchRanges.length;
	    }
	    --currentRange.id;
	    if (currentRange.id === -1) {
	      $scope.$emit('noPrevOccurrence');
	      return;
	    }
	    currentRange.markerId = $scope.editor.session.addMarker(searchRanges[currentRange.id].range, 'ace_selection', 'text');
	  });
	
	  $scope.$on('replaceCurrent', function (event, from, to) {
	    if (currentRange.id === -1) {
	      return;
	    }
	    var indexFromEnd = searchRanges.length - currentRange.id - 1;
	    var prevId = currentRange.id;
	    $scope.editor.session.removeMarker(currentRange.markerId);
	    $scope.editor.session.replace(searchRanges[currentRange.id].range, to);
	    markAllOccurrences(from);
	    var currentIndex = searchRanges.length - indexFromEnd;
	    $scope.$emit('occurrencesCountChanged', currentIndex - prevId - 1);
	    currentRange.id = currentIndex;
	    if (currentRange.id === searchRanges.length) {
	      currentRange.id = -1;
	      $scope.$emit('noNextOccurrenceAfterReplace');
	    } else {
	      currentRange.markerId = $scope.editor.session.addMarker(searchRanges[currentRange.id].range, 'ace_selection', 'text');
	    }
	  });
	
	  $scope.$on('replaceAll', function (event, from, to) {
	    clearSearchSelection();
	    $scope.editor.replaceAll(to, { needle: from });
	  });
	
	  $scope.$on('checkOccurrences', function () {
	    if (searchRanges.length > 0) {
	      $scope.$emit('occurrencesExists', searchRanges.length);
	    }
	  });
	}

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _spellResult = __webpack_require__(209);
	
	Object.defineProperty(exports, 'DefaultDisplayType', {
	  enumerable: true,
	  get: function get() {
	    return _spellResult.DefaultDisplayType;
	  }
	});
	Object.defineProperty(exports, 'SpellResult', {
	  enumerable: true,
	  get: function get() {
	    return _spellResult.SpellResult;
	  }
	});
	
	var _spellBase = __webpack_require__(210);
	
	Object.defineProperty(exports, 'SpellBase', {
	  enumerable: true,
	  get: function get() {
	    return _spellBase.SpellBase;
	  }
	});

/***/ }),
/* 209 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*
	 * Licensed to the Apache Software Foundation (ASF) under one or more
	 * contributor license agreements.  See the NOTICE file distributed with
	 * this work for additional information regarding copyright ownership.
	 * The ASF licenses this file to You under the Apache License, Version 2.0
	 * (the "License"); you may not use this file except in compliance with
	 * the License.  You may obtain a copy of the License at
	 *
	 *    http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	var DefaultDisplayType = exports.DefaultDisplayType = {
	  ELEMENT: 'ELEMENT',
	  TABLE: 'TABLE',
	  HTML: 'HTML',
	  ANGULAR: 'ANGULAR',
	  TEXT: 'TEXT',
	  NETWORK: 'NETWORK'
	};
	
	var DefaultDisplayMagic = exports.DefaultDisplayMagic = {
	  '%element': DefaultDisplayType.ELEMENT,
	  '%table': DefaultDisplayType.TABLE,
	  '%html': DefaultDisplayType.HTML,
	  '%angular': DefaultDisplayType.ANGULAR,
	  '%text': DefaultDisplayType.TEXT,
	  '%network': DefaultDisplayType.NETWORK
	};
	
	var DataWithType = exports.DataWithType = function () {
	  function DataWithType(data, type, magic, text) {
	    _classCallCheck(this, DataWithType);
	
	    this.data = data;
	    this.type = type;
	
	    /**
	     * keep for `DefaultDisplayType.ELEMENT` (function data type)
	     * to propagate a result to other client.
	     *
	     * otherwise we will send function as `data` and it will not work
	     * since they don't have context where they are created.
	     */
	
	    this.magic = magic;
	    this.text = text;
	  }
	
	  _createClass(DataWithType, [{
	    key: 'getData',
	
	
	    /**
	     * `data` can be promise, function or just object
	     * - if data is an object, it will be used directly.
	     * - if data is a function, it will be called with DOM element id
	     *   where the final output is rendered.
	     * - if data is a promise, the post processing logic
	     *   will be called in `then()` of this promise.
	     * @returns {*} `data` which can be object, function or promise.
	     */
	    value: function getData() {
	      return this.data;
	    }
	
	    /**
	     * Value of `type` might be empty which means
	     * data can be separated into multiples
	     * by `SpellResult.parseStringData()`
	     * @returns {string}
	     */
	
	  }, {
	    key: 'getType',
	    value: function getType() {
	      return this.type;
	    }
	  }, {
	    key: 'getMagic',
	    value: function getMagic() {
	      return this.magic;
	    }
	  }, {
	    key: 'getText',
	    value: function getText() {
	      return this.text;
	    }
	  }], [{
	    key: 'handleDefaultMagic',
	    value: function handleDefaultMagic(m) {
	      // let's use default display type instead of magic in case of default
	      // to keep consistency with backend interpreter
	      if (DefaultDisplayMagic[m]) {
	        return DefaultDisplayMagic[m];
	      } else {
	        return m;
	      }
	    }
	  }, {
	    key: 'createPropagable',
	    value: function createPropagable(dataWithType) {
	      if (!SpellResult.isFunction(dataWithType.data)) {
	        return dataWithType;
	      }
	
	      var data = dataWithType.getText();
	      var type = dataWithType.getMagic();
	
	      return new DataWithType(data, type);
	    }
	
	    /**
	     * consume 1 data and produce multiple
	     * @param data {string}
	     * @param customDisplayType
	     * @return {Array<DataWithType>}
	     */
	
	  }, {
	    key: 'parseStringData',
	    value: function parseStringData(data, customDisplayMagic) {
	      function availableMagic(magic) {
	        return magic && (DefaultDisplayMagic[magic] || customDisplayMagic[magic]);
	      }
	
	      var splited = data.split('\n');
	
	      var gensWithTypes = [];
	      var mergedGens = [];
	      var previousMagic = DefaultDisplayType.TEXT;
	
	      // create `DataWithType` whenever see available display type.
	      for (var i = 0; i < splited.length; i++) {
	        var g = splited[i];
	        var magic = SpellResult.extractMagic(g);
	
	        // create `DataWithType` only if see new magic
	        if (availableMagic(magic) && mergedGens.length > 0) {
	          gensWithTypes.push(new DataWithType(mergedGens.join(''), previousMagic));
	          mergedGens = [];
	        }
	
	        // accumulate `data` to mergedGens
	        if (availableMagic(magic)) {
	          var withoutMagic = g.split(magic)[1];
	          mergedGens.push(withoutMagic + '\n');
	          previousMagic = DataWithType.handleDefaultMagic(magic);
	        } else {
	          mergedGens.push(g + '\n');
	        }
	      }
	
	      // cleanup the last `DataWithType`
	      if (mergedGens.length > 0) {
	        previousMagic = DataWithType.handleDefaultMagic(previousMagic);
	        gensWithTypes.push(new DataWithType(mergedGens.join(''), previousMagic));
	      }
	
	      return gensWithTypes;
	    }
	
	    /**
	     * get 1 `DataWithType` and produce multiples using available displays
	     * return an wrapped with a promise to generalize result output which can be
	     * object, function or promise
	     * @param dataWithType {DataWithType}
	     * @param availableDisplays {Object} Map for available displays
	     * @param magic
	     * @param textWithoutMagic
	     * @return {Promise<Array<DataWithType>>}
	     */
	
	  }, {
	    key: 'produceMultipleData',
	    value: function produceMultipleData(dataWithType, customDisplayType, magic, textWithoutMagic) {
	      var data = dataWithType.getData();
	      var type = dataWithType.getType();
	
	      // if the type is specified, just return it
	      // handle non-specified dataWithTypes only
	      if (type) {
	        return new Promise(function (resolve) {
	          resolve([dataWithType]);
	        });
	      }
	
	      var wrapped = void 0;
	
	      if (SpellResult.isFunction(data)) {
	        // if data is a function, we consider it as ELEMENT type.
	        wrapped = new Promise(function (resolve) {
	          var dt = new DataWithType(data, DefaultDisplayType.ELEMENT, magic, textWithoutMagic);
	          var result = [dt];
	          return resolve(result);
	        });
	      } else if (SpellResult.isPromise(data)) {
	        // if data is a promise,
	        wrapped = data.then(function (generated) {
	          var result = DataWithType.parseStringData(generated, customDisplayType);
	          return result;
	        });
	      } else {
	        // if data is a object, parse it to multiples
	        wrapped = new Promise(function (resolve) {
	          var result = DataWithType.parseStringData(data, customDisplayType);
	          return resolve(result);
	        });
	      }
	
	      return wrapped;
	    }
	  }]);
	
	  return DataWithType;
	}();
	
	var SpellResult = exports.SpellResult = function () {
	  function SpellResult(resultData, resultType) {
	    _classCallCheck(this, SpellResult);
	
	    this.dataWithTypes = [];
	    this.add(resultData, resultType);
	  }
	
	  _createClass(SpellResult, [{
	    key: 'add',
	    value: function add(resultData, resultType) {
	      if (resultData) {
	        this.dataWithTypes.push(new DataWithType(resultData, resultType));
	      }
	
	      return this;
	    }
	
	    /**
	     * @param customDisplayType
	     * @param textWithoutMagic
	     * @return {Promise<Array<DataWithType>>}
	     */
	
	  }, {
	    key: 'getAllParsedDataWithTypes',
	    value: function getAllParsedDataWithTypes(customDisplayType, magic, textWithoutMagic) {
	      var promises = this.dataWithTypes.map(function (dt) {
	        return DataWithType.produceMultipleData(dt, customDisplayType, magic, textWithoutMagic);
	      });
	
	      // some promises can include an array so we need to flatten them
	      var flatten = Promise.all(promises).then(function (values) {
	        return values.reduce(function (acc, cur) {
	          if (Array.isArray(cur)) {
	            return acc.concat(cur);
	          } else {
	            return acc.concat([cur]);
	          }
	        });
	      });
	
	      return flatten;
	    }
	  }], [{
	    key: 'isFunction',
	    value: function isFunction(data) {
	      return data && typeof data === 'function';
	    }
	  }, {
	    key: 'isPromise',
	    value: function isPromise(data) {
	      return data && typeof data.then === 'function';
	    }
	  }, {
	    key: 'isObject',
	    value: function isObject(data) {
	      return data && !SpellResult.isFunction(data) && !SpellResult.isPromise(data);
	    }
	  }, {
	    key: 'extractMagic',
	    value: function extractMagic(allParagraphText) {
	      var pattern = /^\s*%(\S+)\s*/g;
	      try {
	        var match = pattern.exec(allParagraphText);
	        if (match) {
	          return '%' + match[1].trim();
	        }
	      } catch (error) {
	        // failed to parse, ignore
	      }
	
	      return undefined;
	    }
	  }, {
	    key: 'createPropagable',
	    value: function createPropagable(resultMsg) {
	      return resultMsg.map(function (dt) {
	        return DataWithType.createPropagable(dt);
	      });
	    }
	  }]);

	  return SpellResult;
	}();

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SpellBase = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed to the Apache Software Foundation (ASF) under one or more
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * contributor license agreements.  See the NOTICE file distributed with
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * this work for additional information regarding copyright ownership.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * The ASF licenses this file to You under the Apache License, Version 2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * (the "License"); you may not use this file except in compliance with
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * the License.  You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *    http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	/* eslint-disable no-unused-vars */
	
	
	var _spellResult = __webpack_require__(209);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/* eslint-enable no-unused-vars */
	
	var SpellBase = exports.SpellBase = function () {
	  function SpellBase(magic) {
	    _classCallCheck(this, SpellBase);
	
	    this.magic = magic;
	  }
	
	  /**
	   * Consumes text and return `SpellResult`.
	   *
	   * @param paragraphText {string} which doesn't include magic
	   * @param config {Object}
	   * @return {SpellResult}
	   */
	
	
	  _createClass(SpellBase, [{
	    key: 'interpret',
	    value: function interpret(paragraphText, config) {
	      throw new Error('SpellBase.interpret() should be overrided');
	    }
	
	    /**
	     * return magic for this spell.
	     * (e.g `%flowchart`)
	     * @return {string}
	     */
	
	  }, {
	    key: 'getMagic',
	    value: function getMagic() {
	      return this.magic;
	    }
	  }]);

	  return SpellBase;
	}();

/***/ }),
/* 211 */
/***/ (function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	ClipboardController.$inject = ["$scope"];
	angular.module('zeppelinWebApp').controller('clipboardCtrl', ClipboardController);
	
	function ClipboardController($scope) {
	  'ngInject';
	
	  $scope.complete = function (e) {
	    $scope.copied = true;
	    $scope.tooltip = 'Copied!';
	    setTimeout(function () {
	      $scope.tooltip = 'Copy to clipboard';
	    }, 400);
	  };
	  $scope.$watch('input', function () {
	    $scope.copied = false;
	    $scope.tooltip = 'Copy to clipboard';
	  });
	  $scope.clipError = function (e) {
	    console.log('Error: ' + e.name + ' - ' + e.message);
	    $scope.tooltip = 'Not supported browser';
	  };
	}

/***/ }),
/* 212 */
/***/ (function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').directive('resizable', ResizableDirective);
	
	function ResizableDirective() {
	  var resizableConfig = {
	    autoHide: true,
	    handles: 'se',
	    helper: 'resizable-helper',
	    stop: function stop() {
	      angular.element(this).css({ 'width': '100%', 'height': '100%' });
	    }
	  };
	
	  return {
	    restrict: 'A',
	    scope: {
	      callback: '&onResize'
	    },
	    link: function postLink(scope, elem, attrs) {
	      attrs.$observe('resize', function (resize) {
	        var resetResize = function resetResize(elem, resize) {
	          var colStep = window.innerWidth / 12;
	          elem.off('resizestop');
	          var conf = angular.copy(resizableConfig);
	          if (resize.graphType === 'TABLE' || resize.graphType === 'NETWORK' || resize.graphType === 'TEXT') {
	            conf.grid = [colStep, 10];
	            conf.minHeight = 100;
	          } else {
	            conf.grid = [colStep, 10000];
	            conf.minHeight = 0;
	          }
	          conf.maxWidth = window.innerWidth;
	
	          elem.resizable(conf);
	          elem.on('resizestop', function () {
	            if (scope.callback) {
	              var height = elem.height();
	              if (height < 50) {
	                height = 300;
	              }
	              scope.callback({ width: Math.ceil(elem.width() / colStep), height: height });
	            }
	          });
	        };
	
	        resize = JSON.parse(resize);
	        if (resize.allowresize === 'true') {
	          resetResize(elem, resize);
	          angular.element(window).resize(function () {
	            resetResize(elem, resize);
	          });
	        }
	      });
	    }
	  };
	}

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	ResultCtrl.$inject = ["$scope", "$rootScope", "$route", "$window", "$routeParams", "$location", "$timeout", "$compile", "$http", "$q", "$templateCache", "$templateRequest", "$sce", "websocketMsgSrv", "baseUrlSrv", "ngToast", "saveAsService", "noteVarShareService", "heliumService", "uiGridConstants"];
	var _moment = __webpack_require__(18);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _datasetfactory = __webpack_require__(214);
	
	var _datasetfactory2 = _interopRequireDefault(_datasetfactory);
	
	var _visualizationTable = __webpack_require__(172);
	
	var _visualizationTable2 = _interopRequireDefault(_visualizationTable);
	
	var _visualizationBarchart = __webpack_require__(176);
	
	var _visualizationBarchart2 = _interopRequireDefault(_visualizationBarchart);
	
	var _visualizationPiechart = __webpack_require__(177);
	
	var _visualizationPiechart2 = _interopRequireDefault(_visualizationPiechart);
	
	var _visualizationAreachart = __webpack_require__(178);
	
	var _visualizationAreachart2 = _interopRequireDefault(_visualizationAreachart);
	
	var _visualizationLinechart = __webpack_require__(179);
	
	var _visualizationLinechart2 = _interopRequireDefault(_visualizationLinechart);
	
	var _visualizationScatterchart = __webpack_require__(180);
	
	var _visualizationScatterchart2 = _interopRequireDefault(_visualizationScatterchart);
	
	var _visualizationD3network = __webpack_require__(216);
	
	var _visualizationD3network2 = _interopRequireDefault(_visualizationD3network);
	
	var _spell = __webpack_require__(208);
	
	var _paragraph = __webpack_require__(161);
	
	var _result = __webpack_require__(218);
	
	var _result2 = _interopRequireDefault(_result);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	var AnsiUp = __webpack_require__(219);
	var AnsiUpConverter = new AnsiUp.default(); // eslint-disable-line new-parens,new-cap
	var TableGridFilterTemplate = __webpack_require__(220);
	
	angular.module('zeppelinWebApp').controller('ResultCtrl', ResultCtrl);
	
	function ResultCtrl($scope, $rootScope, $route, $window, $routeParams, $location, $timeout, $compile, $http, $q, $templateCache, $templateRequest, $sce, websocketMsgSrv, baseUrlSrv, ngToast, saveAsService, noteVarShareService, heliumService, uiGridConstants) {
	  'ngInject';
	
	  /**
	   * Built-in visualizations
	   */
	
	  $scope.builtInTableDataVisualizationList = [{
	    id: 'table', // paragraph.config.graph.mode
	    name: 'Table', // human readable name. tooltip
	    icon: '<i class="fa fa-table"></i>',
	    supports: [_spell.DefaultDisplayType.TABLE, _spell.DefaultDisplayType.NETWORK]
	  }, {
	    id: 'multiBarChart',
	    name: 'Bar Chart',
	    icon: '<i class="fa fa-bar-chart"></i>',
	    transformation: 'pivot',
	    supports: [_spell.DefaultDisplayType.TABLE, _spell.DefaultDisplayType.NETWORK]
	  }, {
	    id: 'pieChart',
	    name: 'Pie Chart',
	    icon: '<i class="fa fa-pie-chart"></i>',
	    transformation: 'pivot',
	    supports: [_spell.DefaultDisplayType.TABLE, _spell.DefaultDisplayType.NETWORK]
	  }, {
	    id: 'stackedAreaChart',
	    name: 'Area Chart',
	    icon: '<i class="fa fa-area-chart"></i>',
	    transformation: 'pivot',
	    supports: [_spell.DefaultDisplayType.TABLE, _spell.DefaultDisplayType.NETWORK]
	  }, {
	    id: 'lineChart',
	    name: 'Line Chart',
	    icon: '<i class="fa fa-line-chart"></i>',
	    transformation: 'pivot',
	    supports: [_spell.DefaultDisplayType.TABLE, _spell.DefaultDisplayType.NETWORK]
	  }, {
	    id: 'scatterChart',
	    name: 'Scatter Chart',
	    icon: '<i class="cf cf-scatter-chart"></i>',
	    supports: [_spell.DefaultDisplayType.TABLE, _spell.DefaultDisplayType.NETWORK]
	  }, {
	    id: 'network',
	    name: 'Network',
	    icon: '<i class="fa fa-share-alt"></i>',
	    supports: [_spell.DefaultDisplayType.NETWORK]
	  }];
	
	  /**
	   * Holds class and actual runtime instance and related infos of built-in visualizations
	   */
	  var builtInVisualizations = {
	    'table': {
	      class: _visualizationTable2.default,
	      instance: undefined // created from setGraphMode()
	    },
	    'multiBarChart': {
	      class: _visualizationBarchart2.default,
	      instance: undefined
	    },
	    'pieChart': {
	      class: _visualizationPiechart2.default,
	      instance: undefined
	    },
	    'stackedAreaChart': {
	      class: _visualizationAreachart2.default,
	      instance: undefined
	    },
	    'lineChart': {
	      class: _visualizationLinechart2.default,
	      instance: undefined
	    },
	    'scatterChart': {
	      class: _visualizationScatterchart2.default,
	      instance: undefined
	    },
	    'network': {
	      class: _visualizationD3network2.default,
	      instance: undefined
	    }
	  };
	
	  // type
	  $scope.type = null;
	
	  // Data of the result
	  var data = void 0;
	
	  // config
	  $scope.config = null;
	
	  // resultId = paragraph.id + index
	  $scope.id = null;
	
	  // referece to paragraph
	  var paragraph = void 0;
	
	  // index of the result
	  var resultIndex = void 0;
	
	  // TableData instance
	  var tableData = void 0;
	
	  // available columns in tabledata
	  $scope.tableDataColumns = [];
	
	  // enable helium
	  var enableHelium = false;
	
	  // graphMode
	  $scope.graphMode = null;
	
	  // image data
	  $scope.imageData = null;
	
	  // queue for append output
	  var textResultQueueForAppend = [];
	
	  // prevent body area scrollbar from blocking due to scroll in paragraph results
	  $scope.mouseOver = false;
	  $scope.onMouseOver = function () {
	    $scope.mouseOver = true;
	  };
	  $scope.onMouseOut = function () {
	    $scope.mouseOver = false;
	  };
	  $scope.getPointerEvent = function () {
	    return $scope.mouseOver ? { 'pointer-events': 'auto' } : { 'pointer-events': 'none' };
	  };
	
	  $scope.init = function (result, config, paragraph, index) {
	    // register helium plugin vis packages
	    var visPackages = heliumService.getVisualizationCachedPackages();
	    var visPackageOrder = heliumService.getVisualizationCachedPackageOrder();
	
	    // push the helium vis packages following the order
	    visPackageOrder.map(function (visName) {
	      visPackages.map(function (vis) {
	        if (vis.name !== visName) {
	          return;
	        }
	        $scope.builtInTableDataVisualizationList.push({
	          id: vis.id,
	          name: vis.name,
	          icon: $sce.trustAsHtml(vis.icon),
	          supports: [_spell.DefaultDisplayType.TABLE, _spell.DefaultDisplayType.NETWORK]
	        });
	        builtInVisualizations[vis.id] = {
	          class: vis.class
	        };
	      });
	    });
	
	    updateData(result, config, paragraph, index);
	    renderResult($scope.type);
	  };
	
	  function isDOMLoaded(targetElemId) {
	    var elem = angular.element('#' + targetElemId);
	    return elem.length;
	  }
	
	  function retryUntilElemIsLoaded(targetElemId, callback) {
	    function retry() {
	      if (!isDOMLoaded(targetElemId)) {
	        $timeout(retry, 10);
	        return;
	      }
	
	      var elem = angular.element('#' + targetElemId);
	      callback(elem);
	    }
	
	    $timeout(retry);
	  }
	
	  $scope.$on('updateResult', function (event, result, newConfig, paragraphRef, index) {
	    if (paragraph.id !== paragraphRef.id || index !== resultIndex) {
	      return;
	    }
	
	    var refresh = !angular.equals(newConfig, $scope.config) || !angular.equals(result.type, $scope.type) || !angular.equals(result.data, data);
	
	    updateData(result, newConfig, paragraph, resultIndex);
	    renderResult($scope.type, refresh);
	  });
	
	  $scope.$on('appendParagraphOutput', function (event, data) {
	    /* It has been observed that append events
	     * can be errorneously called even if paragraph
	     * execution has ended, and in that case, no append
	     * should be made. Also, it was observed that between PENDING
	     * and RUNNING states, append-events can be called and we can't
	     * miss those, else during the length of paragraph run, few
	     * initial output line/s will be missing.
	     */
	    if (paragraph.id === data.paragraphId && resultIndex === data.index && (paragraph.status === _paragraph.ParagraphStatus.PENDING || paragraph.status === _paragraph.ParagraphStatus.RUNNING)) {
	      // Check if result type is eiter TEXT or TABLE, if not then treat it like TEXT
	      if ([_spell.DefaultDisplayType.TEXT, _spell.DefaultDisplayType.TABLE].indexOf($scope.type) < 0) {
	        $scope.type = _spell.DefaultDisplayType.TEXT;
	      }
	      if ($scope.type === _spell.DefaultDisplayType.TEXT) {
	        appendTextOutput(data.data);
	      } else if ($scope.type === _spell.DefaultDisplayType.TABLE) {
	        appendTableOutput(data);
	      }
	    }
	    if (paragraph.id === data.paragraphId && resultIndex === data.index && paragraph.status === _paragraph.ParagraphStatus.FINISHED) {
	      if ($scope.type === _spell.DefaultDisplayType.TABLE) {
	        appendTableOutput(data);
	      }
	    }
	  });
	
	  var updateData = function updateData(result, config, paragraphRef, index) {
	    data = result.data;
	    paragraph = paragraphRef;
	    resultIndex = parseInt(index);
	
	    $scope.id = paragraph.id + '_' + index;
	    $scope.type = result.type;
	    config = config ? config : {};
	
	    // initialize default config values
	    if (!config.graph) {
	      config.graph = {};
	    }
	
	    if (!config.graph.mode) {
	      config.graph.mode = 'table';
	    }
	
	    if (!config.graph.height) {
	      config.graph.height = 300;
	    }
	
	    if (!config.graph.optionOpen) {
	      config.graph.optionOpen = false;
	    }
	
	    $scope.graphMode = config.graph.mode;
	    $scope.config = angular.copy(config);
	
	    // enable only when it is last result
	    enableHelium = index === paragraphRef.results.msg.length - 1;
	
	    if ($scope.type === 'TABLE' || $scope.type === 'NETWORK') {
	      tableData = new _datasetfactory2.default().createDataset($scope.type);
	      tableData.loadParagraphResult({ type: $scope.type, msg: data });
	      if (tableData.rows.length === 0) {
	        // result not loaded yet
	        tableData = undefined;
	        return;
	      }
	      $scope.tableDataColumns = tableData.columns;
	      $scope.tableDataComment = tableData.comment;
	      if ($scope.type === 'NETWORK') {
	        $scope.networkNodes = tableData.networkNodes;
	        $scope.networkRelationships = tableData.networkRelationships;
	        $scope.networkProperties = tableData.networkProperties;
	      }
	    } else if ($scope.type === 'IMG') {
	      $scope.imageData = data;
	    }
	  };
	
	  $scope.createDisplayDOMId = function (baseDOMId, type) {
	    if (type === _spell.DefaultDisplayType.TABLE || type === _spell.DefaultDisplayType.NETWORK) {
	      return baseDOMId + '_graph';
	    } else if (type === _spell.DefaultDisplayType.HTML) {
	      return baseDOMId + '_html';
	    } else if (type === _spell.DefaultDisplayType.ANGULAR) {
	      return baseDOMId + '_angular';
	    } else if (type === _spell.DefaultDisplayType.TEXT) {
	      return baseDOMId + '_text';
	    } else if (type === _spell.DefaultDisplayType.ELEMENT) {
	      return baseDOMId + '_elem';
	    } else {
	      console.error('Cannot create display DOM Id due to unknown display type: ' + type);
	    }
	  };
	
	  $scope.renderDefaultDisplay = function (targetElemId, type, data, refresh) {
	    var afterLoaded = function afterLoaded() {
	      if (type === _spell.DefaultDisplayType.TABLE || type === _spell.DefaultDisplayType.NETWORK) {
	        renderGraph(targetElemId, $scope.graphMode, refresh);
	      } else if (type === _spell.DefaultDisplayType.HTML) {
	        renderHtml(targetElemId, data);
	      } else if (type === _spell.DefaultDisplayType.ANGULAR) {
	        renderAngular(targetElemId, data);
	      } else if (type === _spell.DefaultDisplayType.TEXT) {
	        renderText(targetElemId, data, refresh);
	      } else if (type === _spell.DefaultDisplayType.ELEMENT) {
	        renderElem(targetElemId, data);
	      } else {
	        console.error('Unknown Display Type: ' + type);
	      }
	    };
	
	    retryUntilElemIsLoaded(targetElemId, afterLoaded);
	
	    // send message to parent that this result is rendered
	    var paragraphId = $scope.$parent.paragraph.id;
	    $scope.$emit('resultRendered', paragraphId);
	  };
	
	  var renderResult = function renderResult(type, refresh) {
	    var activeApp = void 0;
	    if (enableHelium) {
	      getSuggestions();
	      getApplicationStates();
	      activeApp = _.get($scope.config, 'helium.activeApp');
	    }
	
	    if (activeApp) {
	      var appState = _.find($scope.apps, { id: activeApp });
	      renderApp('p' + appState.id, appState);
	    } else {
	      if (!_spell.DefaultDisplayType[type]) {
	        $scope.renderCustomDisplay(type, data);
	      } else {
	        var targetElemId = $scope.createDisplayDOMId('p' + $scope.id, type);
	        $scope.renderDefaultDisplay(targetElemId, type, data, refresh);
	      }
	    }
	  };
	
	  $scope.isDefaultDisplay = function () {
	    return _spell.DefaultDisplayType[$scope.type];
	  };
	
	  /**
	   * Render multiple sub results for custom display
	   */
	  $scope.renderCustomDisplay = function (type, data) {
	    // get result from intp
	    if (!heliumService.getSpellByMagic(type)) {
	      console.error('Can\'t execute spell due to unknown display type: ' + type);
	      return;
	    }
	
	    // custom display result can include multiple subset results
	    heliumService.executeSpellAsDisplaySystem(type, data).then(function (dataWithTypes) {
	      var containerDOMId = 'p' + $scope.id + '_custom';
	      var afterLoaded = function afterLoaded() {
	        var containerDOM = angular.element('#' + containerDOMId);
	        // Spell.interpret() can create multiple outputs
	        for (var i = 0; i < dataWithTypes.length; i++) {
	          var dt = dataWithTypes[i];
	          var _data = dt.data;
	          var _type = dt.type;
	
	          // prepare each DOM to be filled
	          var subResultDOMId = $scope.createDisplayDOMId('p' + $scope.id + '_custom_' + i, _type);
	          var subResultDOM = document.createElement('div');
	          containerDOM.append(subResultDOM);
	          subResultDOM.setAttribute('id', subResultDOMId);
	
	          $scope.renderDefaultDisplay(subResultDOMId, _type, _data, true);
	        }
	      };
	
	      retryUntilElemIsLoaded(containerDOMId, afterLoaded);
	    }).catch(function (error) {
	      console.error('Failed to render custom display: ' + $scope.type + '\n' + error);
	    });
	  };
	
	  /**
	   * generates actually object which will be consumed from `data` property
	   * feed it to the success callback.
	   * if error occurs, the error is passed to the failure callback
	   *
	   * @param data {Object or Function}
	   * @param type {string} Display Type
	   * @param successCallback
	   * @param failureCallback
	   */
	  var handleData = function handleData(data, type, successCallback, failureCallback) {
	    if (_spell.SpellResult.isFunction(data)) {
	      try {
	        successCallback(data());
	      } catch (error) {
	        failureCallback(error);
	        console.error('Failed to handle ' + type + ' type, function data\n', error);
	      }
	    } else if (_spell.SpellResult.isObject(data)) {
	      try {
	        successCallback(data);
	      } catch (error) {
	        console.error('Failed to handle ' + type + ' type, object data\n', error);
	      }
	    }
	  };
	
	  var renderElem = function renderElem(targetElemId, data) {
	    var elem = angular.element('#' + targetElemId);
	    handleData(function () {
	      data(targetElemId);
	    }, _spell.DefaultDisplayType.ELEMENT, function () {}, /** HTML element will be filled with data. thus pass empty success callback */
	    function (error) {
	      elem.html('' + error.stack);
	    });
	  };
	
	  var renderHtml = function renderHtml(targetElemId, data) {
	    var elem = angular.element('#' + targetElemId);
	    handleData(data, _spell.DefaultDisplayType.HTML, function (generated) {
	      elem.html(generated);
	      elem.find('pre code').each(function (i, e) {
	        hljs.highlightBlock(e);
	      });
	      /* eslint new-cap: [2, {"capIsNewExceptions": ["MathJax.Hub.Queue"]}] */
	      MathJax.Hub.Queue(['Typeset', MathJax.Hub, elem[0]]);
	    }, function (error) {
	      elem.html('' + error.stack);
	    });
	  };
	
	  var renderAngular = function renderAngular(targetElemId, data) {
	    var elem = angular.element('#' + targetElemId);
	    var paragraphScope = noteVarShareService.get(paragraph.id + '_paragraphScope');
	    handleData(data, _spell.DefaultDisplayType.ANGULAR, function (generated) {
	      elem.html(generated);
	      $compile(elem.contents())(paragraphScope);
	    }, function (error) {
	      elem.html('' + error.stack);
	    });
	  };
	
	  var getTextResultElemId = function getTextResultElemId(resultId) {
	    return 'p' + resultId + '_text';
	  };
	
	  var checkAndReplaceCarriageReturn = function checkAndReplaceCarriageReturn(str) {
	    return new _result2.default(str).checkAndReplaceCarriageReturn();
	  };
	
	  var renderText = function renderText(targetElemId, data, refresh) {
	    var elem = angular.element('#' + targetElemId);
	    handleData(data, _spell.DefaultDisplayType.TEXT, function (generated) {
	      // clear all lines before render
	      removeChildrenDOM(targetElemId);
	
	      if (generated) {
	        generated = checkAndReplaceCarriageReturn(generated);
	        var escaped = AnsiUpConverter.ansi_to_html(generated);
	        var divDOM = angular.element('<div></div>').innerHTML = escaped;
	        if (refresh) {
	          elem.html(divDOM);
	        } else {
	          elem.append(divDOM);
	        }
	      } else if (refresh) {
	        elem.html('');
	      }
	
	      elem.bind('mousewheel', function (e) {
	        $scope.keepScrollDown = false;
	      });
	    }, function (error) {
	      elem.html('' + error.stack);
	    });
	  };
	
	  var removeChildrenDOM = function removeChildrenDOM(targetElemId) {
	    var elem = angular.element('#' + targetElemId);
	    if (elem.length) {
	      elem.children().remove();
	    }
	  };
	
	  function appendTableOutput(data) {
	    if (_paragraph.ParagraphStatus.FINISHED !== paragraph.status) {
	      if (!$scope.$parent.result.data) {
	        $scope.$parent.result.data = [];
	        tableData = undefined;
	      }
	      if (!$scope.$parent.result.data[data.index]) {
	        $scope.$parent.result.data[data.index] = '';
	      }
	      if (tableData) {
	        var textRows = data.data.split('\n');
	        for (var i = 0; i < textRows.length; i++) {
	          if (textRows[i] !== '') {
	            var row = textRows[i].split('\t');
	            tableData.rows.push(row);
	            var builtInViz = builtInVisualizations['table'];
	            if (builtInViz.instance !== undefined) {
	              builtInViz.instance.append([row], tableData.columns);
	            }
	          }
	        }
	      }
	      if (!tableData || !builtInVisualizations[$scope.graphMode].instance.append) {
	        $scope.$parent.result.data[data.index] = $scope.$parent.result.data[data.index].concat(data.data);
	        $rootScope.$broadcast('updateResult', { 'data': $scope.$parent.result.data[data.index], 'type': 'TABLE' }, $scope.config, paragraph, data.index);
	        var elemId = 'p' + $scope.id + '_' + $scope.graphMode;
	        renderGraph(elemId, $scope.graphMode, true);
	      }
	    }
	  }
	
	  function appendTextOutput(data) {
	    var elemId = getTextResultElemId($scope.id);
	    textResultQueueForAppend.push(data);
	
	    // if DOM is not loaded, just push data and return
	    if (!isDOMLoaded(elemId)) {
	      return;
	    }
	
	    var elem = angular.element('#' + elemId);
	
	    // pop all stacked data and append to the DOM
	    while (textResultQueueForAppend.length > 0) {
	      var line = elem.html() + AnsiUpConverter.ansi_to_html(textResultQueueForAppend.pop());
	      elem.html(checkAndReplaceCarriageReturn(line));
	      if ($scope.keepScrollDown) {
	        var doc = angular.element('#' + elemId);
	        doc[0].scrollTop = doc[0].scrollHeight;
	      }
	    }
	  }
	
	  var getTrSettingElem = function getTrSettingElem(scopeId, graphMode) {
	    return angular.element('#trsetting' + scopeId + '_' + graphMode);
	  };
	
	  var getVizSettingElem = function getVizSettingElem(scopeId, graphMode) {
	    return angular.element('#vizsetting' + scopeId + '_' + graphMode);
	  };
	
	  var renderGraph = function renderGraph(graphElemId, graphMode, refresh) {
	    // set graph height
	    var height = $scope.config.graph.height;
	    var graphElem = angular.element('#' + graphElemId);
	    graphElem.height(height);
	
	    if (!graphMode) {
	      graphMode = 'table';
	    }
	
	    var builtInViz = builtInVisualizations[graphMode];
	    if (!builtInViz) {
	      /** helium package is not available, fallback to table vis */
	      graphMode = 'table';
	      $scope.graphMode = graphMode; /** html depends on this scope value */
	      builtInViz = builtInVisualizations[graphMode];
	    }
	
	    // deactive previsouly active visualization
	    for (var t in builtInVisualizations) {
	      if (builtInVisualizations.hasOwnProperty(t)) {
	        var v = builtInVisualizations[t].instance;
	
	        if (t !== graphMode && v && v.isActive()) {
	          v.deactivate();
	          break;
	        }
	      }
	    }
	
	    var afterLoaded = function afterLoaded() {/** will be overwritten */};
	
	    if (!builtInViz.instance) {
	      // not instantiated yet
	      // render when targetEl is available
	      afterLoaded = function afterLoaded(loadedElem) {
	        try {
	          var transformationSettingTargetEl = getTrSettingElem($scope.id, graphMode);
	          var visualizationSettingTargetEl = getVizSettingElem($scope.id, graphMode);
	          // set height
	          loadedElem.height(height);
	
	          // instantiate visualization
	          var config = getVizConfig(graphMode);
	          var Visualization = builtInViz.class;
	          builtInViz.instance = new Visualization(loadedElem, config);
	
	          // inject emitter, $templateRequest
	          var emitter = function emitter(graphSetting) {
	            commitVizConfigChange(graphSetting, graphMode);
	          };
	          builtInViz.instance._emitter = emitter;
	          builtInViz.instance._compile = $compile;
	
	          // ui-grid related
	          $templateCache.put('ui-grid/ui-grid-filter', TableGridFilterTemplate);
	          builtInViz.instance._uiGridConstants = uiGridConstants;
	          builtInViz.instance._timeout = $timeout;
	
	          builtInViz.instance._createNewScope = createNewScope;
	          builtInViz.instance._templateRequest = $templateRequest;
	          var transformation = builtInViz.instance.getTransformation();
	          transformation._emitter = emitter;
	          transformation._templateRequest = $templateRequest;
	          transformation._compile = $compile;
	          transformation._createNewScope = createNewScope;
	
	          // render if table data is defined
	          if (tableData) {
	            var transformed = transformation.transform(tableData);
	            transformation.renderSetting(transformationSettingTargetEl);
	            builtInViz.instance.render(transformed);
	            builtInViz.instance.renderSetting(visualizationSettingTargetEl);
	            builtInViz.instance.activate();
	            angular.element(window).resize(function () {
	              builtInViz.instance.resize();
	            });
	          }
	        } catch (err) {
	          console.error('Graph drawing error %o', err);
	        }
	      };
	    } else if (refresh) {
	      // when graph options or data are changed
	      console.log('Refresh data %o', tableData);
	
	      afterLoaded = function afterLoaded(loadedElem) {
	        var transformationSettingTargetEl = getTrSettingElem($scope.id, graphMode);
	        var visualizationSettingTargetEl = getVizSettingElem($scope.id, graphMode);
	        var config = getVizConfig(graphMode);
	        loadedElem.height(height);
	        var transformation = builtInViz.instance.getTransformation();
	        transformation.setConfig(config);
	
	        // render if table data is defined
	        if (tableData) {
	          var transformed = transformation.transform(tableData);
	          transformation.renderSetting(transformationSettingTargetEl);
	          builtInViz.instance.setConfig(config);
	          builtInViz.instance.render(transformed);
	          builtInViz.instance.renderSetting(visualizationSettingTargetEl);
	          builtInViz.instance.activate();
	        }
	      };
	    } else {
	      afterLoaded = function afterLoaded(loadedElem) {
	        loadedElem.height(height);
	        builtInViz.instance.activate();
	      };
	    }
	
	    var tableElemId = 'p' + $scope.id + '_' + graphMode;
	    retryUntilElemIsLoaded(tableElemId, afterLoaded);
	  };
	
	  $scope.switchViz = function (newMode) {
	    var newConfig = angular.copy($scope.config);
	    var newParams = angular.copy(paragraph.settings.params);
	
	    // graph options
	    newConfig.graph.mode = newMode;
	
	    // see switchApp()
	    _.set(newConfig, 'helium.activeApp', undefined);
	
	    commitParagraphResult(paragraph.title, paragraph.text, newConfig, newParams);
	  };
	
	  var createNewScope = function createNewScope() {
	    return $rootScope.$new(true);
	  };
	
	  var commitParagraphResult = function commitParagraphResult(title, text, config, params) {
	    var newParagraphConfig = angular.copy(paragraph.config);
	    newParagraphConfig.results = newParagraphConfig.results || [];
	
	    var oldConfig = newParagraphConfig.results[resultIndex];
	    var isObjWithFn = function isObjWithFn(o) {
	      return _.isObject(o) && _.functions(o).length > 0;
	    };
	    var eqNoFunctions = function eqNoFunctions(v, o) {
	      if (isObjWithFn(v) || isObjWithFn(o)) {
	        return _.eq(_.omit(v, _.isFunction), _.omit(o, _.isFunction), eqNoFunctions);
	      }
	    };
	    var configsEq = _.eq(oldConfig, config, eqNoFunctions);
	
	    newParagraphConfig.results[resultIndex] = config;
	
	    if (!configsEq) {
	      if ($scope.revisionView === true) {
	        // local update without commit
	        updateData({
	          type: $scope.type,
	          data: data
	        }, newParagraphConfig.results[resultIndex], paragraph, resultIndex);
	        renderResult($scope.type, true);
	      } else {
	        return websocketMsgSrv.commitParagraph(paragraph.id, title, text, newParagraphConfig, params);
	      }
	    }
	  };
	
	  $scope.toggleGraphSetting = function () {
	    var newConfig = angular.copy($scope.config);
	    if (newConfig.graph.optionOpen) {
	      newConfig.graph.optionOpen = false;
	    } else {
	      newConfig.graph.optionOpen = true;
	    }
	
	    var newParams = angular.copy(paragraph.settings.params);
	    commitParagraphResult(paragraph.title, paragraph.text, newConfig, newParams);
	  };
	
	  var getVizConfig = function getVizConfig(vizId) {
	    var config = void 0;
	    var graph = $scope.config.graph;
	    if (graph) {
	      // copy setting for vizId
	      if (graph.setting) {
	        config = angular.copy(graph.setting[vizId]);
	      }
	
	      if (!config) {
	        config = {};
	      }
	
	      // copy common setting
	      config.common = angular.copy(graph.commonSetting) || {};
	
	      // copy pivot setting
	      if (graph.keys) {
	        config.common.pivot = {
	          keys: angular.copy(graph.keys),
	          groups: angular.copy(graph.groups),
	          values: angular.copy(graph.values)
	        };
	      }
	    }
	    console.debug('getVizConfig', config);
	    return config;
	  };
	
	  var commitVizConfigChange = function commitVizConfigChange(config, vizId) {
	    if ([_paragraph.ParagraphStatus.RUNNING, _paragraph.ParagraphStatus.PENDING].indexOf(paragraph.status) < 0) {
	      var newConfig = angular.copy($scope.config);
	      if (!newConfig.graph) {
	        newConfig.graph = {};
	      }
	      // copy setting for vizId
	      if (!newConfig.graph.setting) {
	        newConfig.graph.setting = {};
	      }
	      newConfig.graph.setting[vizId] = angular.copy(config);
	      // copy common setting
	      if (newConfig.graph.setting[vizId]) {
	        newConfig.graph.commonSetting = newConfig.graph.setting[vizId].common;
	        delete newConfig.graph.setting[vizId].common;
	      }
	      // copy pivot setting
	      if (newConfig.graph.commonSetting && newConfig.graph.commonSetting.pivot) {
	        newConfig.graph.keys = newConfig.graph.commonSetting.pivot.keys;
	        newConfig.graph.groups = newConfig.graph.commonSetting.pivot.groups;
	        newConfig.graph.values = newConfig.graph.commonSetting.pivot.values;
	        delete newConfig.graph.commonSetting.pivot;
	      }
	      if (angular.equals($scope.config, newConfig)) {
	        return;
	      }
	      console.debug('committVizConfig', newConfig);
	      var newParams = angular.copy(paragraph.settings.params);
	      commitParagraphResult(paragraph.title, paragraph.text, newConfig, newParams);
	    }
	  };
	
	  $scope.$on('paragraphResized', function (event, paragraphId) {
	    // paragraph col width changed
	    if (paragraphId === paragraph.id) {
	      var builtInViz = builtInVisualizations[$scope.graphMode];
	      if (builtInViz && builtInViz.instance) {
	        $timeout(function () {
	          return builtInViz.instance.resize();
	        }, 200);
	      }
	    }
	  });
	
	  $scope.resize = function (width, height) {
	    $timeout(function () {
	      changeHeight(width, height);
	    }, 200);
	  };
	
	  var changeHeight = function changeHeight(width, height) {
	    var newParams = angular.copy(paragraph.settings.params);
	    var newConfig = angular.copy($scope.config);
	
	    newConfig.graph.height = height;
	    paragraph.config.colWidth = width;
	
	    commitParagraphResult(paragraph.title, paragraph.text, newConfig, newParams);
	  };
	
	  function buildDsvData(delimiter) {
	    var dsv = '';
	    for (var titleIndex in tableData.columns) {
	      if (tableData.columns.hasOwnProperty(titleIndex)) {
	        dsv += tableData.columns[titleIndex].name + delimiter;
	      }
	    }
	    dsv = dsv.substring(0, dsv.length - 1) + '\n';
	    for (var r in tableData.rows) {
	      if (tableData.rows.hasOwnProperty(r)) {
	        var row = tableData.rows[r];
	        var dsvRow = '';
	        for (var index in row) {
	          if (row.hasOwnProperty(index)) {
	            var stringValue = row[index].toString();
	            if (stringValue.indexOf(delimiter) > -1 || stringValue.indexOf('\n') > -1 || stringValue.indexOf('\r') > -1 || stringValue.indexOf('"') > -1) {
	              dsvRow += '"' + stringValue.replace(/"/g, '""') + '"' + delimiter;
	            } else {
	              dsvRow += row[index] + delimiter;
	            }
	          }
	        }
	        dsv += dsvRow.substring(0, dsvRow.length - 1) + '\n';
	      }
	    }
	
	    var extension = '';
	    if (delimiter === '\t') {
	      extension = 'tsv';
	    } else if (delimiter === ',') {
	      extension = 'csv';
	    }
	
	    return {
	      data: dsv,
	      extension: extension
	    };
	  }
	
	  $scope.exportToDSV = function (delimiter) {
	    var dateFinished = (0, _moment2.default)(paragraph.dateFinished).format('YYYY-MM-DD hh:mm:ss A');
	
	    var exportedFileName = paragraph.title ? paragraph.title + '_' + dateFinished : 'data_' + dateFinished;
	
	    var result = buildDsvData(delimiter);
	
	    saveAsService.saveAs(result.data, exportedFileName, result.extension);
	  };
	
	  $scope.loadMap = function () {
	    var data = buildDsvData(',').data;
	
	    var objectUrl = URL.createObjectURL(new Blob([data]));
	
	    var url = 'map/#/' + encodeURIComponent(objectUrl);
	
	    angular.element('body').append('<a id="loadMap"></a>');
	    var link = angular.element('body > a#loadMap');
	    link.attr('href', url);
	    link.attr('target', '_blank');
	    link[0].click();
	    link.remove();
	  };
	
	  $scope.getBase64ImageSrc = function (base64Data) {
	    return 'data:image/png;base64,' + base64Data;
	  };
	
	  // Helium ----------------
	  var ANGULAR_FUNCTION_OBJECT_NAME_PREFIX = '_Z_ANGULAR_FUNC_';
	
	  // app states
	  $scope.apps = [];
	
	  // suggested apps
	  $scope.suggestion = {};
	
	  $scope.switchApp = function (appId) {
	    var newConfig = angular.copy($scope.config);
	    var newParams = angular.copy(paragraph.settings.params);
	
	    // 'helium.activeApp' can be cleared by switchViz()
	    _.set(newConfig, 'helium.activeApp', appId);
	
	    commitConfig(newConfig, newParams);
	  };
	
	  $scope.loadApp = function (heliumPackage) {
	    var noteId = $route.current.pathParams.noteId;
	    $http.post(baseUrlSrv.getRestApiBase() + '/helium/load/' + noteId + '/' + paragraph.id, heliumPackage).success(function (data, status, headers, config) {
	      console.log('Load app %o', data);
	    }).error(function (err, status, headers, config) {
	      console.log('Error %o', err);
	    });
	  };
	
	  var commitConfig = function commitConfig(config, params) {
	    commitParagraphResult(paragraph.title, paragraph.text, config, params);
	  };
	
	  var getApplicationStates = function getApplicationStates() {
	    var appStates = [];
	
	    // Display ApplicationState
	    if (paragraph.apps) {
	      _.forEach(paragraph.apps, function (app) {
	        appStates.push({
	          id: app.id,
	          pkg: app.pkg,
	          status: app.status,
	          output: app.output
	        });
	      });
	    }
	
	    // update or remove app states no longer exists
	    _.forEach($scope.apps, function (currentAppState, idx) {
	      var newAppState = _.find(appStates, { id: currentAppState.id });
	      if (newAppState) {
	        angular.extend($scope.apps[idx], newAppState);
	      } else {
	        $scope.apps.splice(idx, 1);
	      }
	    });
	
	    // add new app states
	    _.forEach(appStates, function (app, idx) {
	      if ($scope.apps.length <= idx || $scope.apps[idx].id !== app.id) {
	        $scope.apps.splice(idx, 0, app);
	      }
	    });
	  };
	
	  var getSuggestions = function getSuggestions() {
	    // Get suggested apps
	    var noteId = $route.current.pathParams.noteId;
	    if (!noteId) {
	      return;
	    }
	    $http.get(baseUrlSrv.getRestApiBase() + '/helium/suggest/' + noteId + '/' + paragraph.id).success(function (data, status, headers, config) {
	      $scope.suggestion = data.body;
	    }).error(function (err, status, headers, config) {
	      console.log('Error %o', err);
	    });
	  };
	
	  var renderApp = function renderApp(targetElemId, appState) {
	    var afterLoaded = function afterLoaded(loadedElem) {
	      try {
	        console.log('renderApp %o', appState);
	        loadedElem.html(appState.output);
	        $compile(loadedElem.contents())(getAppScope(appState));
	      } catch (err) {
	        console.log('App rendering error %o', err);
	      }
	    };
	    retryUntilElemIsLoaded(targetElemId, afterLoaded);
	  };
	
	  /*
	   ** $scope.$on functions below
	   */
	  $scope.$on('appendAppOutput', function (event, data) {
	    if (paragraph.id === data.paragraphId) {
	      var app = _.find($scope.apps, { id: data.appId });
	      if (app) {
	        app.output += data.data;
	
	        var paragraphAppState = _.find(paragraph.apps, { id: data.appId });
	        paragraphAppState.output = app.output;
	
	        var targetEl = angular.element(document.getElementById('p' + app.id));
	        targetEl.html(app.output);
	        $compile(targetEl.contents())(getAppScope(app));
	        console.log('append app output %o', $scope.apps);
	      }
	    }
	  });
	
	  $scope.$on('updateAppOutput', function (event, data) {
	    if (paragraph.id === data.paragraphId) {
	      var app = _.find($scope.apps, { id: data.appId });
	      if (app) {
	        app.output = data.data;
	
	        var paragraphAppState = _.find(paragraph.apps, { id: data.appId });
	        paragraphAppState.output = app.output;
	
	        var targetEl = angular.element(document.getElementById('p' + app.id));
	        targetEl.html(app.output);
	        $compile(targetEl.contents())(getAppScope(app));
	        console.log('append app output');
	      }
	    }
	  });
	
	  $scope.$on('appLoad', function (event, data) {
	    if (paragraph.id === data.paragraphId) {
	      var app = _.find($scope.apps, { id: data.appId });
	      if (!app) {
	        app = {
	          id: data.appId,
	          pkg: data.pkg,
	          status: 'UNLOADED',
	          output: ''
	        };
	
	        $scope.apps.push(app);
	        paragraph.apps.push(app);
	        $scope.switchApp(app.id);
	      }
	    }
	  });
	
	  $scope.$on('appStatusChange', function (event, data) {
	    if (paragraph.id === data.paragraphId) {
	      var app = _.find($scope.apps, { id: data.appId });
	      if (app) {
	        app.status = data.status;
	        var paragraphAppState = _.find(paragraph.apps, { id: data.appId });
	        paragraphAppState.status = app.status;
	      }
	    }
	  });
	
	  var getAppRegistry = function getAppRegistry(appState) {
	    if (!appState.registry) {
	      appState.registry = {};
	    }
	
	    return appState.registry;
	  };
	
	  var getAppScope = function getAppScope(appState) {
	    if (!appState.scope) {
	      appState.scope = $rootScope.$new(true, $rootScope);
	    }
	    return appState.scope;
	  };
	
	  $scope.$on('angularObjectUpdate', function (event, data) {
	    var noteId = $route.current.pathParams.noteId;
	    if (!data.noteId || data.noteId === noteId) {
	      var scope = void 0;
	      var registry = void 0;
	
	      var app = _.find($scope.apps, { id: data.paragraphId });
	      if (app) {
	        scope = getAppScope(app);
	        registry = getAppRegistry(app);
	      } else {
	        // no matching app in this paragraph
	        return;
	      }
	
	      var varName = data.angularObject.name;
	
	      if (angular.equals(data.angularObject.object, scope[varName])) {
	        // return when update has no change
	        return;
	      }
	
	      if (!registry[varName]) {
	        registry[varName] = {
	          interpreterGroupId: data.interpreterGroupId,
	          noteId: data.noteId,
	          paragraphId: data.paragraphId
	        };
	      } else {
	        registry[varName].noteId = registry[varName].noteId || data.noteId;
	        registry[varName].paragraphId = registry[varName].paragraphId || data.paragraphId;
	      }
	
	      registry[varName].skipEmit = true;
	
	      if (!registry[varName].clearWatcher) {
	        registry[varName].clearWatcher = scope.$watch(varName, function (newValue, oldValue) {
	          console.log('angular object (paragraph) updated %o %o', varName, registry[varName]);
	          if (registry[varName].skipEmit) {
	            registry[varName].skipEmit = false;
	            return;
	          }
	          websocketMsgSrv.updateAngularObject(registry[varName].noteId, registry[varName].paragraphId, varName, newValue, registry[varName].interpreterGroupId);
	        });
	      }
	      console.log('angular object (paragraph) created %o', varName);
	      scope[varName] = data.angularObject.object;
	
	      // create proxy for AngularFunction
	      if (varName.indexOf(ANGULAR_FUNCTION_OBJECT_NAME_PREFIX) === 0) {
	        var funcName = varName.substring(ANGULAR_FUNCTION_OBJECT_NAME_PREFIX.length);
	        scope[funcName] = function () {
	          // eslint-disable-next-line prefer-rest-params
	          scope[varName] = arguments;
	          // eslint-disable-next-line prefer-rest-params
	          console.log('angular function (paragraph) invoked %o', arguments);
	        };
	
	        console.log('angular function (paragraph) created %o', scope[funcName]);
	      }
	    }
	  });
	
	  $scope.$on('angularObjectRemove', function (event, data) {
	    var noteId = $route.current.pathParams.noteId;
	    if (!data.noteId || data.noteId === noteId) {
	      var scope = void 0;
	      var registry = void 0;
	
	      var app = _.find($scope.apps, { id: data.paragraphId });
	      if (app) {
	        scope = getAppScope(app);
	        registry = getAppRegistry(app);
	      } else {
	        // no matching app in this paragraph
	        return;
	      }
	
	      var varName = data.name;
	
	      // clear watcher
	      if (registry[varName]) {
	        registry[varName].clearWatcher();
	        registry[varName] = undefined;
	      }
	
	      // remove scope variable
	      scope[varName] = undefined;
	
	      // remove proxy for AngularFunction
	      if (varName.indexOf(ANGULAR_FUNCTION_OBJECT_NAME_PREFIX) === 0) {
	        var funcName = varName.substring(ANGULAR_FUNCTION_OBJECT_NAME_PREFIX.length);
	        scope[funcName] = undefined;
	      }
	    }
	  });
	}

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	var _tabledata = __webpack_require__(162);
	
	var _tabledata2 = _interopRequireDefault(_tabledata);
	
	var _networkdata = __webpack_require__(215);
	
	var _networkdata2 = _interopRequireDefault(_networkdata);
	
	var _dataset = __webpack_require__(163);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Create table data object from paragraph table type result
	 */
	var DatasetFactory = function () {
	  function DatasetFactory() {
	    _classCallCheck(this, DatasetFactory);
	  }
	
	  _createClass(DatasetFactory, [{
	    key: 'createDataset',
	    value: function createDataset(datasetType) {
	      switch (datasetType) {
	        case _dataset.DatasetType.NETWORK:
	          return new _networkdata2.default();
	        case _dataset.DatasetType.TABLE:
	          return new _tabledata2.default();
	        default:
	          throw new Error('Dataset type not found');
	      }
	    }
	  }]);
	
	  return DatasetFactory;
	}();
	
	exports.default = DatasetFactory;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _tabledata = __webpack_require__(162);
	
	var _tabledata2 = _interopRequireDefault(_tabledata);
	
	var _dataset = __webpack_require__(163);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	/**
	 * Create network data object from paragraph graph type result
	 */
	var NetworkData = function (_TableData) {
	  _inherits(NetworkData, _TableData);
	
	  function NetworkData(graph) {
	    _classCallCheck(this, NetworkData);
	
	    var _this = _possibleConstructorReturn(this, (NetworkData.__proto__ || Object.getPrototypeOf(NetworkData)).call(this));
	
	    _this.graph = graph || {};
	    if (_this.graph.nodes) {
	      _this.loadParagraphResult({ msg: JSON.stringify(graph), type: _dataset.DatasetType.NETWORK });
	    }
	    return _this;
	  }
	
	  _createClass(NetworkData, [{
	    key: 'loadParagraphResult',
	    value: function loadParagraphResult(paragraphResult) {
	      if (!paragraphResult || paragraphResult.type !== _dataset.DatasetType.NETWORK) {
	        console.log('Can not load paragraph result');
	        return;
	      }
	
	      this.graph = JSON.parse(paragraphResult.msg.trim() || '{}');
	
	      if (!this.graph.nodes) {
	        console.log('Graph result is empty');
	        return;
	      }
	
	      this.graph.edges = this.graph.edges || [];
	      this.networkNodes = angular.equals({}, this.graph.labels || {}) ? null : { count: this.graph.nodes.length, labels: this.graph.labels };
	      this.networkRelationships = angular.equals([], this.graph.types || []) ? null : { count: this.graph.edges.length, types: this.graph.types };
	
	      var rows = [];
	      var comment = '';
	      var entities = this.graph.nodes.concat(this.graph.edges);
	      var baseColumnNames = [{ name: 'id', index: 0, aggr: 'sum' }];
	      var containsLabelField = _.find(entities, function (entity) {
	        return 'label' in entity;
	      }) !== undefined;
	      if (this.graph.labels || this.graph.types || containsLabelField) {
	        baseColumnNames.push({ name: 'label', index: 1, aggr: 'sum' });
	      }
	      var internalFieldsToJump = ['count', 'size', 'totalCount', 'data', 'x', 'y', 'labels', 'source', 'target'];
	      var baseCols = _.map(baseColumnNames, function (col) {
	        return col.name;
	      });
	      var keys = _.map(entities, function (elem) {
	        return Object.keys(elem.data || {});
	      });
	      keys = _.flatten(keys);
	      keys = _.uniq(keys).filter(function (key) {
	        return baseCols.indexOf(key) === -1;
	      });
	      var entityColumnNames = _.map(keys, function (elem, i) {
	        return { name: elem, index: i + baseColumnNames.length, aggr: 'sum' };
	      });
	      var columnNames = baseColumnNames.concat(entityColumnNames);
	      for (var i = 0; i < entities.length; i++) {
	        var entity = entities[i];
	        var col = [];
	        entity.data = entity.data || {};
	        for (var j = 0; j < columnNames.length; j++) {
	          var name = columnNames[j].name;
	          var value = name in entity && internalFieldsToJump.indexOf(name) === -1 ? entity[name] : entity.data[name];
	          var parsedValue = value === null || value === undefined ? '' : value;
	          col.push(parsedValue);
	        }
	        rows.push(col);
	      }
	
	      this.comment = comment;
	      this.columns = columnNames;
	      this.rows = rows;
	    }
	  }]);
	
	  return NetworkData;
	}(_tabledata2.default);
	
	exports.default = NetworkData;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _visualization = __webpack_require__(171);
	
	var _visualization2 = _interopRequireDefault(_visualization);
	
	var _network = __webpack_require__(217);
	
	var _network2 = _interopRequireDefault(_network);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Apache License, Version 2.0 (the 'License');
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed under the License is distributed on an 'AS IS' BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	/**
	 * Visualize data in network format
	 */
	var NetworkVisualization = function (_Visualization) {
	  _inherits(NetworkVisualization, _Visualization);
	
	  function NetworkVisualization(targetEl, config) {
	    _classCallCheck(this, NetworkVisualization);
	
	    var _this = _possibleConstructorReturn(this, (NetworkVisualization.__proto__ || Object.getPrototypeOf(NetworkVisualization)).call(this, targetEl, config));
	
	    console.log('Init network viz');
	    if (!config.properties) {
	      config.properties = {};
	    }
	    if (!config.d3Graph) {
	      config.d3Graph = {
	        forceLayout: {
	          timeout: 10000,
	          charge: -120,
	          linkDistance: 80
	        },
	        zoom: {
	          minScale: 1.3
	        }
	      };
	    }
	    _this.targetEl.addClass('network');
	    _this.containerId = _this.targetEl.prop('id');
	    _this.force = null;
	    _this.svg = null;
	    _this.$timeout = angular.injector(['ng']).get('$timeout');
	    _this.$interpolate = angular.injector(['ng']).get('$interpolate');
	    _this.transformation = new _network2.default(config);
	    return _this;
	  }
	
	  _createClass(NetworkVisualization, [{
	    key: 'refresh',
	    value: function refresh() {
	      console.log('refresh');
	    }
	  }, {
	    key: 'render',
	    value: function render(networkData) {
	      var _this2 = this;
	
	      if (!('graph' in networkData)) {
	        console.log('graph not found');
	        return;
	      }
	      if (!networkData.isRendered) {
	        networkData.isRendered = true;
	      } else {
	        return;
	      }
	      console.log('Rendering the graph');
	
	      if (networkData.graph.edges.length && !networkData.isDefaultSet) {
	        networkData.isDefaultSet = true;
	        this._setEdgesDefaults(networkData.graph);
	      }
	
	      var transformationConfig = this.transformation.getSetting().scope.config;
	      console.log('cfg', transformationConfig);
	      if (transformationConfig && angular.equals({}, transformationConfig.properties)) {
	        transformationConfig.properties = this.getNetworkProperties(networkData.graph);
	      }
	
	      this.targetEl.empty().append('<svg></svg>');
	
	      var width = this.targetEl.width();
	      var height = this.targetEl.height();
	      var self = this;
	      var defaultOpacity = 0;
	      var nodeSize = 10;
	      var textOffset = 3;
	      var linkSize = 10;
	
	      var arcPath = function arcPath(leftHand, d) {
	        var start = leftHand ? d.source : d.target;
	        var end = leftHand ? d.target : d.source;
	        var dx = end.x - start.x;
	        var dy = end.y - start.y;
	        var dr = d.totalCount === 1 ? 0 : Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2)) / (1 + 1 / d.totalCount * (d.count - 1));
	        var sweep = leftHand ? 0 : 1;
	        return 'M' + start.x + ',' + start.y + 'A' + dr + ',' + dr + ' 0 0,' + sweep + ' ' + end.x + ',' + end.y;
	      };
	      // Use elliptical arc path segments to doubly-encode directionality.
	      var tick = function tick() {
	        // Links
	        linkPath.attr('d', function (d) {
	          return arcPath(true, d);
	        });
	        textPath.attr('d', function (d) {
	          return arcPath(d.source.x < d.target.x, d);
	        });
	        // Nodes
	        circle.attr('transform', function (d) {
	          return 'translate(' + d.x + ',' + d.y + ')';
	        });
	        text.attr('transform', function (d) {
	          return 'translate(' + d.x + ',' + d.y + ')';
	        });
	      };
	
	      var setOpacity = function setOpacity(scale) {
	        var opacity = scale >= +transformationConfig.d3Graph.zoom.minScale ? 1 : 0;
	        _this2.svg.selectAll('.nodeLabel').style('opacity', opacity);
	        _this2.svg.selectAll('textPath').style('opacity', opacity);
	      };
	
	      var zoom = d3.behavior.zoom().scaleExtent([1, 10]).on('zoom', function () {
	        console.log('zoom');
	        setOpacity(d3.event.scale);
	        container.attr('transform', 'translate(' + d3.event.translate + ')scale(' + d3.event.scale + ')');
	      });
	
	      this.svg = d3.select('#' + this.containerId + ' svg').attr('width', width).attr('height', height).call(zoom);
	
	      this.force = d3.layout.force().charge(transformationConfig.d3Graph.forceLayout.charge).linkDistance(transformationConfig.d3Graph.forceLayout.linkDistance).on('tick', tick).nodes(networkData.graph.nodes).links(networkData.graph.edges).size([width, height]).on('start', function () {
	        console.log('force layout start');
	        _this2.$timeout(function () {
	          _this2.force.stop();
	        }, transformationConfig.d3Graph.forceLayout.timeout);
	      }).on('end', function () {
	        console.log('force layout stop');
	        setOpacity(zoom.scale());
	      }).start();
	
	      var renderFooterOnClick = function renderFooterOnClick(entity, type) {
	        var footerId = _this2.containerId + '_footer';
	        var obj = { id: entity.id, label: entity.defaultLabel || entity.label, type: type };
	        var html = ['<li><b>' + obj.type + '_id:</b>&nbsp' + obj.id + '</li>'];
	        if (obj.label) {
	          html.push('<li><b>' + obj.type + '_type:</b>&nbsp' + obj.label + '</li>');
	        }
	        html = html.concat(_.map(entity.data, function (v, k) {
	          return '<li><b>' + k + ':</b>&nbsp' + v + '</li>';
	        }));
	        angular.element('#' + footerId).find('.list-inline').empty().append(html.join(''));
	      };
	
	      var drag = d3.behavior.drag().origin(function (d) {
	        return d;
	      }).on('dragstart', function (d) {
	        console.log('dragstart');
	        d3.event.sourceEvent.stopPropagation();
	        d3.select(this).classed('dragging', true); // eslint-disable-line no-invalid-this
	        self.force.stop();
	      }).on('drag', function (d) {
	        console.log('drag');
	        d.px += d3.event.dx;
	        d.py += d3.event.dy;
	        d.x += d3.event.dx;
	        d.y += d3.event.dy;
	      }).on('dragend', function (d) {
	        console.log('dragend');
	        d.fixed = true;
	        d3.select(this).classed('dragging', false); // eslint-disable-line no-invalid-this
	        self.force.resume();
	      });
	
	      var container = this.svg.append('g');
	      if (networkData.graph.directed) {
	        container.append('svg:defs').selectAll('marker').data(['arrowMarker-' + this.containerId]).enter().append('svg:marker').attr('id', String).attr('viewBox', '0 -5 10 10').attr('refX', 16).attr('refY', 0).attr('markerWidth', 4).attr('markerHeight', 4).attr('orient', 'auto').append('svg:path').attr('d', 'M0,-5L10,0L0,5');
	      }
	      // Links
	      var link = container.append('svg:g').on('click', function () {
	        renderFooterOnClick(d3.select(d3.event.target).datum(), 'edge');
	      }).selectAll('g.link').data(self.force.links()).enter().append('g');
	      var getPathId = function getPathId(d) {
	        return _this2.containerId + '_' + d.source.index + '_' + d.target.index + '_' + d.count;
	      };
	      var showLabel = function showLabel(d) {
	        return _this2._showNodeLabel(d);
	      };
	      var linkPath = link.append('svg:path').attr('class', 'link').attr('size', linkSize).attr('marker-end', 'url(#arrowMarker-' + this.containerId + ')');
	      var textPath = link.append('svg:path').attr('id', getPathId).attr('class', 'textpath');
	      container.append('svg:g').selectAll('.pathLabel').data(self.force.links()).enter().append('svg:text').attr('class', 'pathLabel').append('svg:textPath').attr('startOffset', '50%').attr('text-anchor', 'middle').attr('xlink:href', function (d) {
	        return '#' + getPathId(d);
	      }).text(function (d) {
	        return d.label;
	      }).style('opacity', defaultOpacity);
	      // Nodes
	      var circle = container.append('svg:g').on('click', function () {
	        renderFooterOnClick(d3.select(d3.event.target).datum(), 'node');
	      }).selectAll('circle').data(self.force.nodes()).enter().append('svg:circle').attr('r', function (d) {
	        return nodeSize;
	      }).attr('fill', function (d) {
	        return networkData.graph.labels && d.label in networkData.graph.labels ? networkData.graph.labels[d.label] : '#000000';
	      }).call(drag);
	      var text = container.append('svg:g').selectAll('g').data(self.force.nodes()).enter().append('svg:g');
	      text.append('svg:text').attr('x', function (d) {
	        return nodeSize + textOffset;
	      }).attr('size', nodeSize).attr('y', '.31em').attr('class', function (d) {
	        return 'nodeLabel shadow label-' + d.label;
	      }).text(showLabel).style('opacity', defaultOpacity);
	      text.append('svg:text').attr('x', function (d) {
	        return nodeSize + textOffset;
	      }).attr('size', nodeSize).attr('y', '.31em').attr('class', function (d) {
	        return 'nodeLabel label-' + d.label;
	      }).text(showLabel).style('opacity', defaultOpacity);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {}
	  }, {
	    key: '_showNodeLabel',
	    value: function _showNodeLabel(d) {
	      var transformationConfig = this.transformation.getSetting().scope.config;
	      var selectedLabel = (transformationConfig.properties[d.label] || { selected: 'label' }).selected;
	      return d.data[selectedLabel] || d[selectedLabel];
	    }
	  }, {
	    key: 'getTransformation',
	    value: function getTransformation() {
	      return this.transformation;
	    }
	  }, {
	    key: 'setNodesDefaults',
	    value: function setNodesDefaults() {}
	  }, {
	    key: '_setEdgesDefaults',
	    value: function _setEdgesDefaults(graph) {
	      graph.edges.sort(function (a, b) {
	        if (a.source > b.source) {
	          return 1;
	        } else if (a.source < b.source) {
	          return -1;
	        } else if (a.target > b.target) {
	          return 1;
	        } else if (a.target < b.target) {
	          return -1;
	        } else {
	          return 0;
	        }
	      });
	      graph.edges.forEach(function (edge, index) {
	        var prevEdge = graph.edges[index - 1];
	        edge.count = (index > 0 && +edge.source === +prevEdge.source && +edge.target === +prevEdge.target ? prevEdge.count : 0) + 1;
	        edge.totalCount = graph.edges.filter(function (innerEdge) {
	          return +edge.source === +innerEdge.source && +edge.target === +innerEdge.target;
	        }).length;
	      });
	      graph.edges.forEach(function (edge) {
	        if (typeof +edge.source === 'number') {
	          // edge.source = graph.nodes.filter((node) => +edge.source === +node.id)[0] || null
	          edge.source = _.find(graph.nodes, function (node) {
	            return +edge.source === +node.id;
	          });
	        }
	        if (typeof +edge.target === 'number') {
	          // edge.target = graph.nodes.filter((node) => +edge.target === +node.id)[0] || null
	          edge.target = _.find(graph.nodes, function (node) {
	            return +edge.target === +node.id;
	          });
	        }
	      });
	    }
	  }, {
	    key: 'getNetworkProperties',
	    value: function getNetworkProperties(graph) {
	      var baseCols = ['id', 'label'];
	      var properties = {};
	      graph.nodes.forEach(function (node) {
	        var hasLabel = 'label' in node && node.label !== '';
	        if (!hasLabel) {
	          return;
	        }
	        var label = node.label;
	        var hasKey = hasLabel && label in properties;
	        var keys = _.uniq(Object.keys(node.data || {}).concat(hasKey ? properties[label].keys : baseCols));
	        if (!hasKey) {
	          properties[label] = { selected: 'label' };
	        }
	        properties[label].keys = keys;
	      });
	      return properties;
	    }
	  }]);
	
	  return NetworkVisualization;
	}(_visualization2.default);
	
	exports.default = NetworkVisualization;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformation = __webpack_require__(164);
	
	var _transformation2 = _interopRequireDefault(_transformation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	/**
	 * trasformation settings for network visualization
	 */
	var NetworkTransformation = function (_Transformation) {
	  _inherits(NetworkTransformation, _Transformation);
	
	  function NetworkTransformation() {
	    _classCallCheck(this, NetworkTransformation);
	
	    return _possibleConstructorReturn(this, (NetworkTransformation.__proto__ || Object.getPrototypeOf(NetworkTransformation)).apply(this, arguments));
	  }
	
	  _createClass(NetworkTransformation, [{
	    key: 'getSetting',
	    value: function getSetting() {
	      var self = this;
	      var configObj = self.config;
	      return {
	        template: 'app/tabledata/network_settings.html',
	        scope: {
	          config: configObj,
	          isEmptyObject: function isEmptyObject(obj) {
	            obj = obj || {};
	            return angular.equals(obj, {});
	          },
	          setNetworkLabel: function setNetworkLabel(label, value) {
	            configObj.properties[label].selected = value;
	          },
	          saveConfig: function saveConfig() {
	            self.emitConfig(configObj);
	          }
	        }
	      };
	    }
	  }, {
	    key: 'setConfig',
	    value: function setConfig(config) {}
	  }, {
	    key: 'transform',
	    value: function transform(networkData) {
	      return networkData;
	    }
	  }]);
	
	  return NetworkTransformation;
	}(_transformation2.default);
	
	exports.default = NetworkTransformation;

/***/ }),
/* 218 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Result = function () {
	  function Result(data) {
	    _classCallCheck(this, Result);
	
	    this.data = data;
	  }
	
	  _createClass(Result, [{
	    key: 'checkAndReplaceCarriageReturn',
	    value: function checkAndReplaceCarriageReturn() {
	      var str = this.data.replace(/\r\n/g, '\n');
	      if (/\r/.test(str)) {
	        var newGenerated = '';
	        var strArr = str.split('\n');
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = strArr[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var _str = _step.value;
	
	            if (/\r/.test(_str)) {
	              var splitCR = _str.split('\r');
	              newGenerated += splitCR[splitCR.length - 1] + '\n';
	            } else {
	              newGenerated += _str + '\n';
	            }
	          }
	          // remove last "\n" character
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        return newGenerated.slice(0, -1);
	      } else {
	        return str;
	      }
	    }
	  }]);
	
	  return Result;
	}();
	
	exports.default = Result;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*  ansi_up.js
	 *  author : Dru Nelson
	 *  license : MIT
	 *  http://github.com/drudru/ansi_up
	 */
	(function (root, factory) {
	    if (true) {
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object' && typeof exports.nodeName !== 'string') {
	        // CommonJS
	        factory(exports);
	    } else {
	        // Browser globals
	        var exp = {};
	        factory(exp);
	        root.AnsiUp = exp.default;
	    }
	}(this, function (exports) {
	"use strict";
	function rgx(tmplObj) {
	    var subst = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        subst[_i - 1] = arguments[_i];
	    }
	    var regexText = tmplObj.raw[0];
	    var wsrgx = /^\s+|\s+\n|\s+#[\s\S]+?\n/gm;
	    var txt2 = regexText.replace(wsrgx, '');
	    return new RegExp(txt2, 'm');
	}
	var AnsiUp = (function () {
	    function AnsiUp() {
	        this.VERSION = "2.0.2";
	        this.ansi_colors = [
	            [
	                { rgb: [0, 0, 0], class_name: "ansi-black" },
	                { rgb: [187, 0, 0], class_name: "ansi-red" },
	                { rgb: [0, 187, 0], class_name: "ansi-green" },
	                { rgb: [187, 187, 0], class_name: "ansi-yellow" },
	                { rgb: [0, 0, 187], class_name: "ansi-blue" },
	                { rgb: [187, 0, 187], class_name: "ansi-magenta" },
	                { rgb: [0, 187, 187], class_name: "ansi-cyan" },
	                { rgb: [255, 255, 255], class_name: "ansi-white" }
	            ],
	            [
	                { rgb: [85, 85, 85], class_name: "ansi-bright-black" },
	                { rgb: [255, 85, 85], class_name: "ansi-bright-red" },
	                { rgb: [0, 255, 0], class_name: "ansi-bright-green" },
	                { rgb: [255, 255, 85], class_name: "ansi-bright-yellow" },
	                { rgb: [85, 85, 255], class_name: "ansi-bright-blue" },
	                { rgb: [255, 85, 255], class_name: "ansi-bright-magenta" },
	                { rgb: [85, 255, 255], class_name: "ansi-bright-cyan" },
	                { rgb: [255, 255, 255], class_name: "ansi-bright-white" }
	            ]
	        ];
	        this.htmlFormatter = {
	            transform: function (fragment, instance) {
	                var txt = fragment.text;
	                if (txt.length === 0)
	                    return txt;
	                if (instance._escape_for_html)
	                    txt = instance.old_escape_for_html(txt);
	                if (!fragment.bright && fragment.fg === null && fragment.bg === null)
	                    return txt;
	                var styles = [];
	                var classes = [];
	                var fg = fragment.fg;
	                var bg = fragment.bg;
	                if (fg === null && fragment.bright)
	                    fg = instance.ansi_colors[1][7];
	                if (!instance._use_classes) {
	                    if (fg)
	                        styles.push("color:rgb(" + fg.rgb.join(',') + ")");
	                    if (bg)
	                        styles.push("background-color:rgb(" + bg.rgb + ")");
	                }
	                else {
	                    if (fg) {
	                        if (fg.class_name !== 'truecolor') {
	                            classes.push(fg.class_name + "-fg");
	                        }
	                        else {
	                            styles.push("color:rgb(" + fg.rgb.join(',') + ")");
	                        }
	                    }
	                    if (bg) {
	                        if (bg.class_name !== 'truecolor') {
	                            classes.push(bg.class_name + "-bg");
	                        }
	                        else {
	                            styles.push("background-color:rgb(" + bg.rgb.join(',') + ")");
	                        }
	                    }
	                }
	                var class_string = '';
	                var style_string = '';
	                if (classes.length)
	                    class_string = " class=\"" + classes.join(' ') + "\"";
	                if (styles.length)
	                    style_string = " style=\"" + styles.join(';') + "\"";
	                return "<span" + class_string + style_string + ">" + txt + "</span>";
	            },
	            compose: function (segments, instance) {
	                return segments.join("");
	            }
	        };
	        this.textFormatter = {
	            transform: function (fragment, instance) {
	                return fragment.text;
	            },
	            compose: function (segments, instance) {
	                return segments.join("");
	            }
	        };
	        this.setup_256_palette();
	        this._use_classes = false;
	        this._escape_for_html = true;
	        this.bright = false;
	        this.fg = this.bg = null;
	        this._buffer = '';
	    }
	    Object.defineProperty(AnsiUp.prototype, "use_classes", {
	        get: function () {
	            return this._use_classes;
	        },
	        set: function (arg) {
	            this._use_classes = arg;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AnsiUp.prototype, "escape_for_html", {
	        get: function () {
	            return this._escape_for_html;
	        },
	        set: function (arg) {
	            this._escape_for_html = arg;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    AnsiUp.prototype.setup_256_palette = function () {
	        var _this = this;
	        this.palette_256 = [];
	        this.ansi_colors.forEach(function (palette) {
	            palette.forEach(function (rec) {
	                _this.palette_256.push(rec);
	            });
	        });
	        var levels = [0, 95, 135, 175, 215, 255];
	        for (var r = 0; r < 6; ++r) {
	            for (var g = 0; g < 6; ++g) {
	                for (var b = 0; b < 6; ++b) {
	                    var col = { rgb: [levels[r], levels[g], levels[b]], class_name: 'truecolor' };
	                    this.palette_256.push(col);
	                }
	            }
	        }
	        var grey_level = 8;
	        for (var i = 0; i < 24; ++i, grey_level += 10) {
	            var gry = { rgb: [grey_level, grey_level, grey_level], class_name: 'truecolor' };
	            this.palette_256.push(gry);
	        }
	    };
	    AnsiUp.prototype.old_escape_for_html = function (txt) {
	        return txt.replace(/[&<>]/gm, function (str) {
	            if (str === "&")
	                return "&amp;";
	            if (str === "<")
	                return "&lt;";
	            if (str === ">")
	                return "&gt;";
	        });
	    };
	    AnsiUp.prototype.old_linkify = function (txt) {
	        return txt.replace(/(https?:\/\/[^\s]+)/gm, function (str) {
	            return "<a href=\"" + str + "\">" + str + "</a>";
	        });
	    };
	    AnsiUp.prototype.detect_incomplete_ansi = function (txt) {
	        return !(/.*?[\x40-\x7e]/.test(txt));
	    };
	    AnsiUp.prototype.detect_incomplete_link = function (txt) {
	        var found = false;
	        for (var i = txt.length - 1; i > 0; i--) {
	            if (/\s|\x1B/.test(txt[i])) {
	                found = true;
	                break;
	            }
	        }
	        if (!found) {
	            if (/(https?:\/\/[^\s]+)/.test(txt))
	                return 0;
	            else
	                return -1;
	        }
	        var prefix = txt.substr(i + 1, 4);
	        if (prefix.length === 0)
	            return -1;
	        if ("http".indexOf(prefix) === 0)
	            return (i + 1);
	    };
	    AnsiUp.prototype.ansi_to = function (txt, formatter) {
	        var pkt = this._buffer + txt;
	        this._buffer = '';
	        var raw_text_pkts = pkt.split(/\x1B\[/);
	        if (raw_text_pkts.length === 1)
	            raw_text_pkts.push('');
	        this.handle_incomplete_sequences(raw_text_pkts);
	        var first_chunk = this.with_state(raw_text_pkts.shift());
	        var blocks = new Array(raw_text_pkts.length);
	        for (var i = 0, len = raw_text_pkts.length; i < len; ++i) {
	            blocks[i] = (formatter.transform(this.process_ansi(raw_text_pkts[i]), this));
	        }
	        if (first_chunk.text.length > 0)
	            blocks.unshift(formatter.transform(first_chunk, this));
	        return formatter.compose(blocks, this);
	    };
	    AnsiUp.prototype.ansi_to_html = function (txt) {
	        return this.ansi_to(txt, this.htmlFormatter);
	    };
	    AnsiUp.prototype.ansi_to_text = function (txt) {
	        return this.ansi_to(txt, this.textFormatter);
	    };
	    AnsiUp.prototype.with_state = function (text) {
	        return { bright: this.bright, fg: this.fg, bg: this.bg, text: text };
	    };
	    AnsiUp.prototype.handle_incomplete_sequences = function (chunks) {
	        var last_chunk = chunks[chunks.length - 1];
	        if ((last_chunk.length > 0) && this.detect_incomplete_ansi(last_chunk)) {
	            this._buffer = "\x1B[" + last_chunk;
	            chunks.pop();
	            chunks.push('');
	        }
	        else {
	            if (last_chunk.slice(-1) === "\x1B") {
	                this._buffer = "\x1B";
	                console.log("raw", chunks);
	                chunks.pop();
	                chunks.push(last_chunk.substr(0, last_chunk.length - 1));
	                console.log(chunks);
	                console.log(last_chunk);
	            }
	            if (chunks.length === 2 &&
	                chunks[1] === "" &&
	                chunks[0].slice(-1) === "\x1B") {
	                this._buffer = "\x1B";
	                last_chunk = chunks.shift();
	                chunks.unshift(last_chunk.substr(0, last_chunk.length - 1));
	            }
	        }
	    };
	    AnsiUp.prototype.process_ansi = function (block) {
	        if (!this._sgr_regex) {
	            this._sgr_regex = (_a = ["\n            ^                           # beginning of line\n            ([!<-?]?)             # a private-mode char (!, <, =, >, ?)\n            ([d;]*)                    # any digits or semicolons\n            ([ -/]?               # an intermediate modifier\n            [@-~])                # the command\n            ([sS]*)                   # any text following this CSI sequence\n          "], _a.raw = ["\n            ^                           # beginning of line\n            ([!\\x3c-\\x3f]?)             # a private-mode char (!, <, =, >, ?)\n            ([\\d;]*)                    # any digits or semicolons\n            ([\\x20-\\x2f]?               # an intermediate modifier\n            [\\x40-\\x7e])                # the command\n            ([\\s\\S]*)                   # any text following this CSI sequence\n          "], rgx(_a));
	        }
	        var matches = block.match(this._sgr_regex);
	        if (!matches) {
	            return this.with_state(block);
	        }
	        var orig_txt = matches[4];
	        if (matches[1] !== '' || matches[3] !== 'm') {
	            return this.with_state(orig_txt);
	        }
	        var sgr_cmds = matches[2].split(';');
	        while (sgr_cmds.length > 0) {
	            var sgr_cmd_str = sgr_cmds.shift();
	            var num = parseInt(sgr_cmd_str, 10);
	            if (isNaN(num) || num === 0) {
	                this.fg = this.bg = null;
	                this.bright = false;
	            }
	            else if (num === 1) {
	                this.bright = true;
	            }
	            else if (num === 22) {
	                this.bright = false;
	            }
	            else if (num === 39) {
	                this.fg = null;
	            }
	            else if (num === 49) {
	                this.bg = null;
	            }
	            else if ((num >= 30) && (num < 38)) {
	                var bidx = this.bright ? 1 : 0;
	                this.fg = this.ansi_colors[bidx][(num - 30)];
	            }
	            else if ((num >= 90) && (num < 98)) {
	                this.fg = this.ansi_colors[1][(num - 90)];
	            }
	            else if ((num >= 40) && (num < 48)) {
	                this.bg = this.ansi_colors[0][(num - 40)];
	            }
	            else if ((num >= 100) && (num < 108)) {
	                this.bg = this.ansi_colors[1][(num - 100)];
	            }
	            else if (num === 38 || num === 48) {
	                if (sgr_cmds.length > 0) {
	                    var is_foreground = (num === 38);
	                    var mode_cmd = sgr_cmds.shift();
	                    if (mode_cmd === '5' && sgr_cmds.length > 0) {
	                        var palette_index = parseInt(sgr_cmds.shift(), 10);
	                        if (palette_index >= 0 && palette_index <= 255) {
	                            if (is_foreground)
	                                this.fg = this.palette_256[palette_index];
	                            else
	                                this.bg = this.palette_256[palette_index];
	                        }
	                    }
	                    if (mode_cmd === '2' && sgr_cmds.length > 2) {
	                        var r = parseInt(sgr_cmds.shift(), 10);
	                        var g = parseInt(sgr_cmds.shift(), 10);
	                        var b = parseInt(sgr_cmds.shift(), 10);
	                        if ((r >= 0 && r <= 255) && (g >= 0 && g <= 255) && (b >= 0 && b <= 255)) {
	                            var c = { rgb: [r, g, b], class_name: 'truecolor' };
	                            if (is_foreground)
	                                this.fg = c;
	                            else
	                                this.bg = c;
	                        }
	                    }
	                }
	            }
	        }
	        return this.with_state(orig_txt);
	        var _a;
	    };
	    return AnsiUp;
	}());
	//# sourceMappingURL=ansi_up.js.map
	    Object.defineProperty(exports, "__esModule", { value: true });
	    exports.default = AnsiUp;
	}));


/***/ }),
/* 220 */
/***/ (function(module, exports) {

	module.exports = "<!--\nLicensed under the Apache License, Version 2.0 (the \"License\");\nyou may not use this file except in compliance with the License.\nYou may obtain a copy of the License at\n\n    http://www.apache.org/licenses/LICENSE-2.0\n\nUnless required by applicable law or agreed to in writing, software\ndistributed under the License is distributed on an \"AS IS\" BASIS,\nWITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\nSee the License for the specific language governing permissions and\nlimitations under the License.\n-->\n\n<div class=\"ui-grid-filter-container\"\n     ng-repeat=\"colFilter in col.filters\"\n     ng-class=\"{'ui-grid-filter-cancel-button-hidden' : colFilter.disableCancelFilterButton === true }\">\n  <div ng-if=\"colFilter.type !== 'select'\">\n    <input type=\"text\" class=\"input-sm form-control\"\n           style=\"font-size: 14px; font-weight: 500\"\n\n           ng-model=\"colFilter.term\"\n           ng-model-options=\"{ debounce : { 'default' : 300, 'blur' : 0 }}\"\n           ng-attr-placeholder=\"{{colFilter.placeholder || ''}}\"\n           aria-label=\"{{colFilter.ariaLabel || aria.defaultFilterLabel}}\" />\n  </div>\n</div>\n"

/***/ }),
/* 221 */
/***/ (function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	CodeEditorDirective.$inject = ["$templateRequest", "$compile"];
	angular.module('zeppelinWebApp').directive('codeEditor', CodeEditorDirective);
	
	function CodeEditorDirective($templateRequest, $compile) {
	  return {
	    restrict: 'AE',
	    scope: {
	      paragraphId: '=paragraphId',
	      paragraph: '=paragraphContext',
	      dirtyText: '=dirtyText',
	      originalText: '=originalText',
	      onLoad: '=onLoad',
	      revisionView: '=revisionView'
	    },
	    link: function link(scope, element, attrs, controller) {
	      $templateRequest('app/notebook/paragraph/code-editor/code-editor.directive.html').then(function (editorHtml) {
	        var editor = angular.element(editorHtml);
	        editor.attr('id', scope.paragraphId + '_editor');
	        element.append(editor);
	        $compile(editor)(scope);
	        console.debug('codeEditor directive revision view is ' + scope.revisionView);
	      });
	    }
	  };
	}

/***/ }),
/* 222 */
/***/ (function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	SaveAsService.$inject = ["browserDetectService"];
	angular.module('zeppelinWebApp').service('saveAsService', SaveAsService);
	
	function SaveAsService(browserDetectService) {
	  'ngInject';
	
	  this.saveAs = function (content, filename, extension) {
	    var BOM = '\uFEFF';
	    if (browserDetectService.detectIE()) {
	      angular.element('body').append('<iframe id="SaveAsId" style="display: none"></iframe>');
	      var frameSaveAs = angular.element('body > iframe#SaveAsId')[0].contentWindow;
	      content = BOM + content;
	      frameSaveAs.document.open('text/json', 'replace');
	      frameSaveAs.document.write(content);
	      frameSaveAs.document.close();
	      frameSaveAs.focus();
	      var t1 = Date.now();
	      frameSaveAs.document.execCommand('SaveAs', false, filename + '.' + extension);
	      var t2 = Date.now();
	
	      // This means, this version of IE dosen't support auto download of a file with extension provided in param
	      // falling back to ".txt"
	      if (t1 === t2) {
	        frameSaveAs.document.execCommand('SaveAs', true, filename + '.txt');
	      }
	      angular.element('body > iframe#SaveAsId').remove();
	    } else {
	      var fileName = filename + '.' + extension;
	      var binaryData = [];
	      binaryData.push(BOM);
	      binaryData.push(content);
	      var blob = new Blob(binaryData, { type: 'octet/stream' });
	      var url = window.URL.createObjectURL(blob);
	      var a = document.createElement('a');
	      document.body.appendChild(a);
	      a.style = 'display: none';
	      a.href = url;
	      a.download = fileName;
	      a.click();
	      window.URL.revokeObjectURL(url);
	    }
	  };
	}

/***/ }),
/* 223 */
/***/ (function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').service('browserDetectService', BrowserDetectService);
	
	function BrowserDetectService() {
	  this.detectIE = function () {
	    var ua = window.navigator.userAgent;
	    var msie = ua.indexOf('MSIE ');
	    if (msie > 0) {
	      // IE 10 or older => return version number
	      return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
	    }
	    var trident = ua.indexOf('Trident/');
	    if (trident > 0) {
	      // IE 11 => return version number
	      var rv = ua.indexOf('rv:');
	      return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
	    }
	    var edge = ua.indexOf('Edge/');
	    if (edge > 0) {
	      // IE 12 (aka Edge) => return version number
	      return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
	    }
	    // other browser
	    return false;
	  };
	}

/***/ }),
/* 224 */
/***/ (function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').controller('ElasticInputCtrl', ElasticInputCtrl);
	
	function ElasticInputCtrl() {
	  var vm = this;
	  vm.showEditor = false;
	  vm.value = '';
	}

/***/ }),
/* 225 */
/***/ (function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').directive('dropdownInput', dropdownInputDirective);
	
	function dropdownInputDirective() {
	  return {
	    restrict: 'A',
	    link: function link(scope, element) {
	      element.bind('click', function (event) {
	        event.stopPropagation();
	      });
	    }
	  };
	}

/***/ }),
/* 226 */
/***/ (function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').service('noteVarShareService', NoteVarShareService);
	
	function NoteVarShareService() {
	  'ngInject';
	
	  var store = {};
	
	  this.clear = function () {
	    store = {};
	  };
	
	  this.put = function (key, value) {
	    store[key] = value;
	  };
	
	  this.get = function (key) {
	    return store[key];
	  };
	
	  this.del = function (key) {
	    var v = store[key];
	    delete store[key];
	    return v;
	  };
	}

/***/ }),
/* 227 */
/***/ (function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	NotebookRepositoryCtrl.$inject = ["$scope", "$http", "$timeout", "websocketMsgSrv", "baseUrlSrv", "ngToast"];
	angular.module('zeppelinWebApp').controller('NotebookRepositoryCtrl', NotebookRepositoryCtrl);
	
	function NotebookRepositoryCtrl($scope, $http, $timeout, websocketMsgSrv, baseUrlSrv, ngToast) {
	  'ngInject';
	
	  var vm = this;
	  vm.revisionControlConfig = {
	    remoteUrl: '',
	    userName: '',
	    accessToken: ''
	  };
	  vm.savingConfig = false;
	  vm.isConfigured = false;
	  vm.isConfiguring = false;
	  vm.startConfiguring = startConfiguring;
	  vm.clearAccessToken = clearAccessToken;
	  vm.starAccessToken = starAccessToken;
	  vm.saveRevisionControlConfig = saveRevisionControlConfig;
	  vm.removeRevisionControlConfig = removeRevisionControlConfig;
	  vm.successText = '';
	  vm.errorText = '';
	  vm.isError = false;
	  getRevisionControlConfig();
	
	  $scope.callAtTimeout = function () {
	    if (vm.isConfiguring) {
	      vm.isError = true;
	      vm.errorText = 'The revision control configuration request may have experienced a timeout.' + ' For exceptionally large notebook repositories, this request may still be syncing.' + ' Please try again or contact support@silect.is for further assistance.';
	      vm.isConfiguring = false;
	      getRevisionControlConfig();
	      vm.savingConfig = false;
	    }
	  };
	
	  $scope.$on('repoSyncSuccess', function (event, param) {
	    vm.isConfiguring = false;
	    vm.savingConfig = false;
	    if (vm.isError) {
	      console.log('Revision control config cleared and synced.');
	    } else {
	      vm.errorText = '';
	      vm.successText = 'Change to revision control configuration was successfully applied.';
	    }
	  });
	
	  $scope.$on('repoSyncError', function (event, param) {
	    vm.successText = '';
	    vm.errorText = 'There was an error applying the given revision control configuration. ' + 'Please validate the configuration provided or contact support@silect.is for further assistance.';
	    vm.isError = true;
	    deleteRevisionControlConfig();
	  });
	
	  function startConfiguring() {
	    vm.errorText = '';
	    vm.successText = '';
	    vm.isConfiguring = true;
	  }
	
	  function resetNotebooks() {
	    websocketMsgSrv.reloadAllNotesFromRepo();
	  }
	
	  function clearAccessToken() {
	    vm.revisionControlConfig.accessToken = '';
	  }
	
	  function starAccessToken() {
	    vm.revisionControlConfig.accessToken = '********';
	  }
	
	  function getRevisionControlConfig() {
	    $http.get(baseUrlSrv.getRestApiBase() + '/magpie/revision-control').success(function (data) {
	      if (data.config) {
	        vm.revisionControlConfig = data.config;
	        vm.isConfigured = true;
	      } else {
	        vm.isConfigured = false;
	      }
	    }).error(function (data, status, headers, config) {
	      if (status !== 0) {
	        console.log('Error %o %o', status, data.message);
	      }
	      ngToast.danger({
	        content: 'We couldn\'t get the revision control configuration for this notebook!',
	        verticalPosition: 'bottom',
	        timeout: '3000'
	      });
	    });
	  }
	
	  function saveRevisionControlConfig(valueform, configData) {
	    vm.isError = false;
	    vm.savingConfig = true;
	    $http.post(baseUrlSrv.getRestApiBase() + '/magpie/revision-control', JSON.stringify(configData)).success(function (data) {
	      $timeout($scope.callAtTimeout, 300000);
	      resetNotebooks(true);
	      getRevisionControlConfig();
	    }).error(function (data, status, headers, config) {
	      getRevisionControlConfig();
	      if (status !== 0) {
	        console.log('Error %o %o', status, data.message);
	      }
	      ngToast.danger({
	        content: 'We couldn\'t save the revision control configuration for this notebook.' + ' Please try again.',
	        verticalPosition: 'bottom',
	        timeout: '6000'
	      });
	      vm.isConfiguring = false;
	      vm.savingConfig = false;
	    });
	  }
	
	  function deleteRevisionControlConfig() {
	    vm.savingConfig = true;
	    $http.post(baseUrlSrv.getRestApiBase() + '/magpie/revision-control', '').success(function (data) {
	      resetNotebooks();
	      vm.isConfigured = false;
	      vm.revisionControlConfig = {
	        remoteUrl: '',
	        userName: '',
	        accessToken: ''
	      };
	    }).error(function (data, status, headers, config) {
	      if (status !== 0) {
	        console.log('Error %o %o', status, data.message);
	      }
	      ngToast.danger({
	        content: 'We couldn\'t remove the revision control configuration for this notebook.' + ' Please try again.',
	        verticalPosition: 'bottom',
	        timeout: '6000'
	      });
	    });
	  }
	
	  function removeRevisionControlConfig() {
	    vm.isError = false;
	    BootstrapDialog.confirm({
	      closable: true,
	      title: '',
	      message: 'Do you want to delete this revision control config?',
	      callback: function callback(result) {
	        if (result) {
	          console.log('Remove config');
	          deleteRevisionControlConfig();
	        }
	      }
	    });
	  }
	}

/***/ }),
/* 228 */
/***/ (function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the 'License');
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an 'AS IS' BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	SearchResultCtrl.$inject = ["$scope", "$routeParams", "searchService"];
	angular.module('zeppelinWebApp').controller('SearchResultCtrl', SearchResultCtrl);
	
	function SearchResultCtrl($scope, $routeParams, searchService) {
	  'ngInject';
	
	  $scope.isResult = true;
	  $scope.searchTerm = $routeParams.searchTerm;
	  var results = searchService.search({ 'q': $routeParams.searchTerm }).query();
	
	  results.$promise.then(function (result) {
	    $scope.notes = result.body.map(function (note) {
	      // redirect to notebook when search result is a notebook itself,
	      // not a paragraph
	      if (!/\/paragraph\//.test(note.id)) {
	        return note;
	      }
	
	      note.id = note.id.replace('paragraph/', '?paragraph=') + '&term=' + $routeParams.searchTerm;
	
	      return note;
	    });
	    if ($scope.notes.length === 0) {
	      $scope.isResult = false;
	    } else {
	      $scope.isResult = true;
	    }
	
	    $scope.$on('$routeChangeStart', function (event, next, current) {
	      if (next.originalPath !== '/search/:searchTerm') {
	        searchService.searchTerm = '';
	      }
	    });
	  });
	
	  $scope.page = 0;
	  $scope.allResults = false;
	
	  $scope.highlightSearchResults = function (note) {
	    return function (_editor) {
	      function getEditorMode(text) {
	        var editorModes = {
	          'ace/mode/scala': /^%(\w*\.)?spark/,
	          'ace/mode/python': /^%(\w*\.)?(pyspark|python)/,
	          'ace/mode/r': /^%(\w*\.)?(r|sparkr|knitr)/,
	          'ace/mode/sql': /^%(\w*\.)?\wql/,
	          'ace/mode/markdown': /^%md/,
	          'ace/mode/sh': /^%sh/
	        };
	
	        return Object.keys(editorModes).reduce(function (res, mode) {
	          return editorModes[mode].test(text) ? mode : res;
	        }, 'ace/mode/scala');
	      }
	
	      var Range = ace.require('ace/range').Range;
	
	      _editor.setOption('highlightActiveLine', false);
	      _editor.$blockScrolling = Infinity;
	      _editor.setReadOnly(true);
	      _editor.renderer.setShowGutter(false);
	      _editor.setTheme('ace/theme/tomorrow');
	      _editor.getSession().setMode(getEditorMode(note.text));
	
	      function getIndeces(term) {
	        return function (str) {
	          var indeces = [];
	          var i = -1;
	          while ((i = str.indexOf(term, i + 1)) >= 0) {
	            indeces.push(i);
	          }
	          return indeces;
	        };
	      }
	
	      var result = '';
	      if (note.header !== '') {
	        result = note.header + '\n\n' + note.snippet;
	      } else {
	        result = note.snippet;
	      }
	
	      var lines = result.split('\n').map(function (line, row) {
	        var match = line.match(/<B>(.+?)<\/B>/);
	
	        // return early if nothing to highlight
	        if (!match) {
	          return line;
	        }
	
	        var term = match[1];
	        var __line = line.replace(/<B>/g, '').replace(/<\/B>/g, '');
	
	        var indeces = getIndeces(term)(__line);
	
	        indeces.forEach(function (start) {
	          var end = start + term.length;
	          if (note.header !== '' && row === 0) {
	            _editor.getSession().addMarker(new Range(row, 0, row, line.length), 'search-results-highlight-header', 'background');
	            _editor.getSession().addMarker(new Range(row, start, row, end), 'search-results-highlight', 'line');
	          } else {
	            _editor.getSession().addMarker(new Range(row, start, row, end), 'search-results-highlight', 'line');
	          }
	        });
	        return __line;
	      });
	
	      // resize editor based on content length
	      _editor.setOption('maxLines', lines.reduce(function (len, line) {
	        return len + line.length;
	      }, 0));
	
	      _editor.getSession().setValue(lines.join('\n'));
	      note.searchResult = lines;
	    };
	  };
	}

/***/ }),
/* 229 */
/***/ (function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	SearchService.$inject = ["$resource", "baseUrlSrv"];
	angular.module('zeppelinWebApp').service('searchService', SearchService);
	
	function SearchService($resource, baseUrlSrv) {
	  'ngInject';
	
	  this.search = function (term) {
	    this.searchTerm = term.q;
	    console.log('Searching for: %o', term.q);
	    if (!term.q) {
	      // TODO(bzz): empty string check
	      return;
	    }
	    var encQuery = window.encodeURIComponent(term.q);
	    return $resource(baseUrlSrv.getRestApiBase() + '/notebook/search?q=' + encQuery, {}, {
	      query: { method: 'GET' }
	    });
	  };
	
	  this.searchTerm = '';
	}

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _helium = __webpack_require__(231);
	
	var _helium2 = _interopRequireDefault(_helium);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	angular.module('zeppelinWebApp').controller('HeliumCtrl', _helium2.default); /*
	                                                                              * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                              * you may not use this file except in compliance with the License.
	                                                                              * You may obtain a copy of the License at
	                                                                              *
	                                                                              *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                              *
	                                                                              * Unless required by applicable law or agreed to in writing, software
	                                                                              * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                              * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                              * See the License for the specific language governing permissions and
	                                                                              * limitations under the License.
	                                                                              */

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	HeliumCtrl.$inject = ["$scope", "$rootScope", "$sce", "baseUrlSrv", "ngToast", "heliumService"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = HeliumCtrl;
	
	var _heliumType = __webpack_require__(232);
	
	function HeliumCtrl($scope, $rootScope, $sce, baseUrlSrv, ngToast, heliumService) {
	  'ngInject';
	
	  $scope.pkgSearchResults = {};
	  $scope.defaultPackages = {};
	  $scope.showVersions = {};
	  $scope.bundleOrder = [];
	  $scope.bundleOrderChanged = false;
	  $scope.vizTypePkg = {};
	  $scope.spellTypePkg = {};
	  $scope.intpTypePkg = {};
	  $scope.appTypePkg = {};
	  $scope.numberOfEachPackageByType = {};
	  $scope.allPackageTypes = [_heliumType.HeliumType][0];
	  $scope.pkgListByType = 'VISUALIZATION';
	  $scope.defaultPackageConfigs = {}; // { pkgName, [{name, type, desc, value, defaultValue}] }
	  $scope.intpDefaultIcon = $sce.trustAsHtml('<img src="../assets/images/maven_default_icon.png" style="width: 12px"/>');
	
	  function init() {
	    // get all package info and set config
	    heliumService.getAllPackageInfoAndDefaultPackages().then(function (_ref) {
	      var pkgSearchResults = _ref.pkgSearchResults,
	          defaultPackages = _ref.defaultPackages;
	
	      // pagination
	      $scope.itemsPerPage = 10;
	      $scope.currentPage = 1;
	      $scope.maxSize = 5;
	
	      $scope.pkgSearchResults = pkgSearchResults;
	      $scope.defaultPackages = defaultPackages;
	      classifyPkgType($scope.defaultPackages);
	
	      return heliumService.getAllPackageConfigs();
	    }).then(function (defaultPackageConfigs) {
	      $scope.defaultPackageConfigs = defaultPackageConfigs;
	      return heliumService.getVisualizationPackageOrder();
	    }).then(function (visPackageOrder) {
	      setVisPackageOrder(visPackageOrder);
	    });
	  }
	
	  var setVisPackageOrder = function setVisPackageOrder(visPackageOrder) {
	    $scope.bundleOrder = visPackageOrder;
	    $scope.bundleOrderChanged = false;
	  };
	
	  var orderPackageByPubDate = function orderPackageByPubDate(a, b) {
	    if (!a.pkg.published) {
	      // Because local registry pkgs don't have 'published' field, put current time instead to show them first
	      a.pkg.published = new Date().getTime();
	    }
	
	    return new Date(a.pkg.published).getTime() - new Date(b.pkg.published).getTime();
	  };
	
	  var classifyPkgType = function classifyPkgType(packageInfo) {
	    var allTypesOfPkg = {};
	    var vizTypePkg = [];
	    var spellTypePkg = [];
	    var intpTypePkg = [];
	    var appTypePkg = [];
	
	    var packageInfoArr = Object.keys(packageInfo).map(function (key) {
	      return packageInfo[key];
	    });
	    packageInfoArr = packageInfoArr.sort(orderPackageByPubDate).reverse();
	
	    for (var name in packageInfoArr) {
	      if (packageInfoArr.hasOwnProperty(name)) {
	        var pkgs = packageInfoArr[name];
	        var pkgType = pkgs.pkg.type;
	
	        switch (pkgType) {
	          case _heliumType.HeliumType.VISUALIZATION:
	            vizTypePkg.push(pkgs);
	            break;
	          case _heliumType.HeliumType.SPELL:
	            spellTypePkg.push(pkgs);
	            break;
	          case _heliumType.HeliumType.INTERPRETER:
	            intpTypePkg.push(pkgs);
	            break;
	          case _heliumType.HeliumType.APPLICATION:
	            appTypePkg.push(pkgs);
	            break;
	        }
	      }
	    }
	
	    var pkgsArr = [vizTypePkg, spellTypePkg, intpTypePkg, appTypePkg];
	    for (var idx in _.keys(_heliumType.HeliumType)) {
	      if (_.keys(_heliumType.HeliumType).hasOwnProperty(idx)) {
	        allTypesOfPkg[_.keys(_heliumType.HeliumType)[idx]] = pkgsArr[idx];
	      }
	    }
	
	    $scope.allTypesOfPkg = allTypesOfPkg;
	  };
	
	  $scope.bundleOrderListeners = {
	    accept: function accept(sourceItemHandleScope, destSortableScope) {
	      return true;
	    },
	    itemMoved: function itemMoved(event) {},
	    orderChanged: function orderChanged(event) {
	      $scope.bundleOrderChanged = true;
	    }
	  };
	
	  $scope.saveBundleOrder = function () {
	    var confirm = BootstrapDialog.confirm({
	      closable: false,
	      closeByBackdrop: false,
	      closeByKeyboard: false,
	      title: '',
	      message: 'Save changes?',
	      callback: function callback(result) {
	        if (result) {
	          confirm.$modalFooter.find('button').addClass('disabled');
	          confirm.$modalFooter.find('button:contains("OK")').html('<i class="fa fa-circle-o-notch fa-spin"></i> Enabling');
	          heliumService.setVisualizationPackageOrder($scope.bundleOrder).success(function (data, status) {
	            setVisPackageOrder($scope.bundleOrder);
	            confirm.close();
	          }).error(function (data, status) {
	            confirm.close();
	            console.log('Failed to save order');
	            BootstrapDialog.show({
	              title: 'Error on saving order ',
	              message: _.escape(data.message)
	            });
	          });
	          return false;
	        }
	      }
	    });
	  };
	
	  var getLicense = function getLicense(name, artifact) {
	    var filteredPkgSearchResults = _.filter($scope.defaultPackages[name], function (p) {
	      return p.artifact === artifact;
	    });
	
	    var license = void 0;
	    if (filteredPkgSearchResults.length === 0) {
	      filteredPkgSearchResults = _.filter($scope.pkgSearchResults[name], function (p) {
	        return p.pkg.artifact === artifact;
	      });
	
	      if (filteredPkgSearchResults.length > 0) {
	        license = filteredPkgSearchResults[0].pkg.license;
	      }
	    } else {
	      license = filteredPkgSearchResults[0].license;
	    }
	
	    if (!license) {
	      license = 'Unknown';
	    }
	    return license;
	  };
	
	  var getHeliumTypeText = function getHeliumTypeText(type) {
	    if (type === _heliumType.HeliumType.VISUALIZATION) {
	      return '<a target="_blank" href="https://zeppelin.apache.org/docs/' + $rootScope.zeppelinVersion + '/development/helium/writing_visualization.html">' + type + '</a>'; // eslint-disable-line max-len
	    } else if (type === _heliumType.HeliumType.SPELL) {
	      return '<a target="_blank" href="https://zeppelin.apache.org/docs/' + $rootScope.zeppelinVersion + '/development/helium/writing_spell.html">' + type + '</a>'; // eslint-disable-line max-len
	    } else {
	      return type;
	    }
	  };
	
	  $scope.enable = function (name, artifact, type, groupId, description) {
	    var license = getLicense(name, artifact);
	    var mavenArtifactInfoToHTML = groupId + ':' + artifact.split('@')[0] + ':' + artifact.split('@')[1];
	    var zeppelinVersion = $rootScope.zeppelinVersion;
	    var url = 'https://zeppelin.apache.org/docs/' + zeppelinVersion + '/manual/interpreterinstallation.html';
	
	    var confirm = '';
	    if (type === _heliumType.HeliumType.INTERPRETER) {
	      confirm = BootstrapDialog.show({
	        title: '',
	        message: '<p>Below command will download maven artifact ' + '<code style="font-size: 11.5px; background-color: #f5f5f5; color: #0a0a0a">' + mavenArtifactInfoToHTML + '</code>' + ' and all of its transitive dependencies into interpreter/interpreter-name directory.<p>' + '<div class="highlight"><pre><code class="text language-text" data-lang="text" style="font-size: 11.5px">' + './bin/install-interpreter.sh --name "interpreter-name" --artifact ' + mavenArtifactInfoToHTML + ' </code></pre>' + '<p>After restart Zeppelin, create interpreter setting and bind it with your note. ' + 'For more detailed information, see <a target="_blank" href=' + url + '>Interpreter Installation.</a></p>'
	      });
	    } else {
	      confirm = BootstrapDialog.confirm({
	        closable: false,
	        closeByBackdrop: false,
	        closeByKeyboard: false,
	        title: '<div style="font-weight: 300;">Do you want to enable Helium Package?</div>',
	        message: '<div style="font-size: 14px; margin-top: 5px;">Artifact</div>' + ('<div style="color:gray">' + artifact + '</div>') + '<hr style="margin-top: 10px; margin-bottom: 10px;" />' + '<div style="font-size: 14px; margin-bottom: 2px;">Type</div>' + ('<div style="color:gray">' + getHeliumTypeText(type) + '</div>') + '<hr style="margin-top: 10px; margin-bottom: 10px;" />' + '<div style="font-size: 14px;">Description</div>' + ('<div style="color:gray">' + description + '</div>') + '<hr style="margin-top: 10px; margin-bottom: 10px;" />' + '<div style="font-size: 14px;">License</div>' + ('<div style="color:gray">' + license + '</div>'),
	        callback: function callback(result) {
	          if (result) {
	            confirm.$modalFooter.find('button').addClass('disabled');
	            confirm.$modalFooter.find('button:contains("OK")').html('<i class="fa fa-circle-o-notch fa-spin"></i> Enabling');
	            heliumService.enable(name, artifact, type).success(function (data, status) {
	              init();
	              confirm.close();
	            }).error(function (data, status) {
	              confirm.close();
	              console.log('Failed to enable package %o %o. %o', name, artifact, data);
	              BootstrapDialog.show({
	                title: 'Error on enabling ' + _.escape(name),
	                message: _.escape(data.message)
	              });
	            });
	            return false;
	          }
	        }
	      });
	    }
	  };
	
	  $scope.disable = function (name, artifact) {
	    var confirm = BootstrapDialog.confirm({
	      closable: false,
	      closeByBackdrop: false,
	      closeByKeyboard: false,
	      title: '<div style="font-weight: 300;">Do you want to disable Helium Package?</div>',
	      message: _.escape(artifact),
	      callback: function callback(result) {
	        if (result) {
	          confirm.$modalFooter.find('button').addClass('disabled');
	          confirm.$modalFooter.find('button:contains("OK")').html('<i class="fa fa-circle-o-notch fa-spin"></i> Disabling');
	          heliumService.disable(name).success(function (data, status) {
	            init();
	            confirm.close();
	          }).error(function (data, status) {
	            confirm.close();
	            console.log('Failed to disable package %o. %o', name, data);
	            BootstrapDialog.show({
	              title: 'Error on disabling ' + _.escape(name),
	              message: _.escape(data.message)
	            });
	          });
	          return false;
	        }
	      }
	    });
	  };
	
	  $scope.toggleVersions = function (pkgName) {
	    if ($scope.showVersions[pkgName]) {
	      $scope.showVersions[pkgName] = false;
	    } else {
	      $scope.showVersions[pkgName] = true;
	    }
	  };
	
	  $scope.isLocalPackage = function (pkgSearchResult) {
	    var pkg = pkgSearchResult.pkg;
	    return pkg.artifact && !pkg.artifact.includes('@');
	  };
	
	  $scope.hasNpmLink = function (pkgSearchResult) {
	    var pkg = pkgSearchResult.pkg;
	    return (pkg.type === _heliumType.HeliumType.SPELL || pkg.type === _heliumType.HeliumType.VISUALIZATION) && !$scope.isLocalPackage(pkgSearchResult);
	  };
	
	  $scope.hasMavenLink = function (pkgSearchResult) {
	    var pkg = pkgSearchResult.pkg;
	    return (pkg.type === _heliumType.HeliumType.APPLICATION || pkg.type === _heliumType.HeliumType.INTERPRETER) && !$scope.isLocalPackage(pkgSearchResult);
	  };
	
	  $scope.getPackageSize = function (pkgSearchResult, targetPkgType) {
	    var result = [];
	    _.map(pkgSearchResult, function (pkg) {
	      result.push(_.find(pkg, { type: targetPkgType }));
	    });
	    return _.compact(result).length;
	  };
	
	  $scope.configExists = function (pkgSearchResult) {
	    // helium package config is persisted per version
	    return pkgSearchResult.pkg.config && pkgSearchResult.pkg.artifact;
	  };
	
	  $scope.configOpened = function (pkgSearchResult) {
	    return pkgSearchResult.configOpened && !pkgSearchResult.configFetching;
	  };
	
	  $scope.getConfigButtonClass = function (pkgSearchResult) {
	    return pkgSearchResult.configOpened && pkgSearchResult.configFetching ? 'disabled' : '';
	  };
	
	  $scope.toggleConfigButton = function (pkgSearchResult) {
	    if (pkgSearchResult.configOpened) {
	      pkgSearchResult.configOpened = false;
	      return;
	    }
	
	    var pkg = pkgSearchResult.pkg;
	    var pkgName = pkg.name;
	    pkgSearchResult.configFetching = true;
	    pkgSearchResult.configOpened = true;
	
	    heliumService.getSinglePackageConfigs(pkg).then(function (confs) {
	      $scope.defaultPackageConfigs[pkgName] = confs;
	      pkgSearchResult.configFetching = false;
	    });
	  };
	
	  $scope.saveConfig = function (pkgSearchResult) {
	    var pkgName = pkgSearchResult.pkg.name;
	    var currentConf = $scope.defaultPackageConfigs[pkgName];
	
	    heliumService.saveConfig(pkgSearchResult.pkg, currentConf, function () {
	      // close after config is saved
	      pkgSearchResult.configOpened = false;
	    });
	  };
	
	  $scope.getDescriptionText = function (pkgSearchResult) {
	    return $sce.trustAsHtml(pkgSearchResult.pkg.description);
	  };
	
	  init();
	} /*
	   * Licensed under the Apache License, Version 2.0 (the "License");
	   * you may not use this file except in compliance with the License.
	   * You may obtain a copy of the License at
	   *
	   *     http://www.apache.org/licenses/LICENSE-2.0
	   *
	   * Unless required by applicable law or agreed to in writing, software
	   * distributed under the License is distributed on an "AS IS" BASIS,
	   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   * See the License for the specific language governing permissions and
	   * limitations under the License.
	   */

/***/ }),
/* 232 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	var HeliumType = exports.HeliumType = {
	  VISUALIZATION: 'VISUALIZATION',
	  SPELL: 'SPELL',
	  INTERPRETER: 'INTERPRETER',
	  APPLICATION: 'APPLICATION'
	};

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	HeliumService.$inject = ["$http", "$sce", "baseUrlSrv"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = HeliumService;
	
	var _heliumType = __webpack_require__(232);
	
	var _heliumConf = __webpack_require__(234);
	
	var _heliumPackage = __webpack_require__(235);
	
	angular.module('zeppelinWebApp').service('heliumService', HeliumService); /*
	                                                                           * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                           * you may not use this file except in compliance with the License.
	                                                                           * You may obtain a copy of the License at
	                                                                           *
	                                                                           *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                           *
	                                                                           * Unless required by applicable law or agreed to in writing, software
	                                                                           * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                           * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                           * See the License for the specific language governing permissions and
	                                                                           * limitations under the License.
	                                                                           */
	
	function HeliumService($http, $sce, baseUrlSrv) {
	  'ngInject';
	
	  var _this3 = this;
	
	  var visualizationBundles = [];
	  var visualizationPackageOrder = [];
	  // name `heliumBundles` should be same as `HeliumBundleFactory.HELIUM_BUNDLES_VAR`
	  var heliumBundles = [];
	  // map for `{ magic: interpreter }`
	  var spellPerMagic = {};
	  // map for `{ magic: package-name }`
	  var pkgNamePerMagic = {};
	
	  /**
	   * @param magic {string} e.g `%flowchart`
	   * @returns {SpellBase} undefined if magic is not registered
	   */
	  this.getSpellByMagic = function (magic) {
	    return spellPerMagic[magic];
	  };
	
	  this.executeSpell = function (magic, textWithoutMagic) {
	    var _this = this;
	
	    var promisedConf = this.getSinglePackageConfigUsingMagic(magic).then(function (confs) {
	      return (0, _heliumConf.createPersistableConfig)(confs);
	    });
	
	    return promisedConf.then(function (conf) {
	      var spell = _this.getSpellByMagic(magic);
	      var spellResult = spell.interpret(textWithoutMagic, conf);
	      var parsed = spellResult.getAllParsedDataWithTypes(spellPerMagic, magic, textWithoutMagic);
	
	      return parsed;
	    });
	  };
	
	  this.executeSpellAsDisplaySystem = function (magic, textWithoutMagic) {
	    var _this2 = this;
	
	    var promisedConf = this.getSinglePackageConfigUsingMagic(magic).then(function (confs) {
	      return (0, _heliumConf.createPersistableConfig)(confs);
	    });
	
	    return promisedConf.then(function (conf) {
	      var spell = _this2.getSpellByMagic(magic);
	      var spellResult = spell.interpret(textWithoutMagic.trim(), conf);
	      var parsed = spellResult.getAllParsedDataWithTypes(spellPerMagic);
	
	      return parsed;
	    });
	  };
	
	  this.getVisualizationCachedPackages = function () {
	    return visualizationBundles;
	  };
	
	  this.getVisualizationCachedPackageOrder = function () {
	    return visualizationPackageOrder;
	  };
	
	  /**
	   * @returns {Promise} which returns bundleOrder and cache it in `visualizationPackageOrder`
	   */
	  this.getVisualizationPackageOrder = function () {
	    return $http.get(baseUrlSrv.getRestApiBase() + '/helium/order/visualization').then(function (response, status) {
	      var order = response.data.body;
	      visualizationPackageOrder = order;
	      return order;
	    }).catch(function (error) {
	      console.error('Can not get bundle order', error);
	    });
	  };
	
	  this.setVisualizationPackageOrder = function (list) {
	    return $http.post(baseUrlSrv.getRestApiBase() + '/helium/order/visualization', list);
	  };
	
	  this.enable = function (name, artifact) {
	    return $http.post(baseUrlSrv.getRestApiBase() + '/helium/enable/' + name, artifact);
	  };
	
	  this.disable = function (name) {
	    return $http.post(baseUrlSrv.getRestApiBase() + '/helium/disable/' + name);
	  };
	
	  this.saveConfig = function (pkg, defaultPackageConfig, closeConfigPanelCallback) {
	    // in case of local package, it will include `/`
	    var pkgArtifact = encodeURIComponent(pkg.artifact);
	    var pkgName = pkg.name;
	    var filtered = (0, _heliumConf.createPersistableConfig)(defaultPackageConfig);
	
	    if (!pkgName || !pkgArtifact || !filtered) {
	      console.error('Can\'t save config for helium package \'' + pkgArtifact + '\'', filtered);
	      return;
	    }
	
	    var url = baseUrlSrv.getRestApiBase() + '/helium/config/' + pkgName + '/' + pkgArtifact;
	    return $http.post(url, filtered).then(function () {
	      if (closeConfigPanelCallback) {
	        closeConfigPanelCallback();
	      }
	    }).catch(function (error) {
	      console.error('Failed to save config for ' + pkgArtifact, error);
	    });
	  };
	
	  /**
	   * @returns {Promise<Object>} which including {name, Array<package info for artifact>}
	   */
	  this.getAllPackageInfo = function () {
	    return $http.get(baseUrlSrv.getRestApiBase() + '/helium/package').then(function (response, status) {
	      return response.data.body;
	    }).catch(function (error) {
	      console.error('Failed to get all package infos', error);
	    });
	  };
	
	  this.getAllEnabledPackages = function () {
	    return $http.get(baseUrlSrv.getRestApiBase() + '/helium/enabledPackage').then(function (response, status) {
	      return response.data.body;
	    }).catch(function (error) {
	      console.error('Failed to get all enabled package infos', error);
	    });
	  };
	
	  this.getSingleBundle = function (pkgName) {
	    var url = baseUrlSrv.getRestApiBase() + '/helium/bundle/load/' + pkgName;
	    if ((undefined)) {
	      url = url + '?refresh=true';
	    }
	
	    return $http.get(url).then(function (response, status) {
	      var bundle = response.data;
	      if (bundle.substring(0, 'ERROR:'.length) === 'ERROR:') {
	        console.error('Failed to get bundle: ' + pkgName, bundle);
	        return ''; // empty bundle will be filtered later
	      }
	
	      return bundle;
	    }).catch(function (error) {
	      console.error('Failed to get single bundle: ' + pkgName, error);
	    });
	  };
	
	  this.getDefaultPackages = function () {
	    return this.getAllPackageInfo().then(function (pkgSearchResults) {
	      return (0, _heliumPackage.createDefaultPackages)(pkgSearchResults, $sce);
	    });
	  };
	
	  this.getAllPackageInfoAndDefaultPackages = function () {
	    return this.getAllPackageInfo().then(function (pkgSearchResults) {
	      return {
	        pkgSearchResults: pkgSearchResults,
	        defaultPackages: (0, _heliumPackage.createDefaultPackages)(pkgSearchResults, $sce)
	      };
	    });
	  };
	
	  /**
	   * get all package configs.
	   * @return { Promise<{name, Array<Object>}> }
	   */
	  this.getAllPackageConfigs = function () {
	    var promisedDefaultPackages = this.getDefaultPackages();
	    var promisedPersistedConfs = $http.get(baseUrlSrv.getRestApiBase() + '/helium/config').then(function (response, status) {
	      return response.data.body;
	    });
	
	    return Promise.all([promisedDefaultPackages, promisedPersistedConfs]).then(function (values) {
	      var defaultPackages = values[0];
	      var persistedConfs = values[1];
	
	      return (0, _heliumConf.createAllPackageConfigs)(defaultPackages, persistedConfs);
	    }).catch(function (error) {
	      console.error('Failed to get all package configs', error);
	    });
	  };
	
	  /**
	   * get the package config which is persisted in server.
	   * @return { Promise<Array<Object>> }
	   */
	  this.getSinglePackageConfigs = function (pkg) {
	    var pkgName = pkg.name;
	    // in case of local package, it will include `/`
	    var pkgArtifact = encodeURIComponent(pkg.artifact);
	
	    if (!pkgName || !pkgArtifact) {
	      console.error('Failed to fetch config for\n', pkg);
	      return Promise.resolve([]);
	    }
	
	    var confUrl = baseUrlSrv.getRestApiBase() + '/helium/config/' + pkgName + '/' + pkgArtifact;
	    var promisedConf = $http.get(confUrl).then(function (response, status) {
	      return response.data.body;
	    });
	
	    return promisedConf.then(function (_ref) {
	      var confSpec = _ref.confSpec,
	          confPersisted = _ref.confPersisted;
	
	      var merged = (0, _heliumConf.mergePersistedConfWithSpec)(confPersisted, confSpec);
	      return merged;
	    });
	  };
	
	  this.getSinglePackageConfigUsingMagic = function (magic) {
	    var pkgName = pkgNamePerMagic[magic];
	
	    var confUrl = baseUrlSrv.getRestApiBase() + '/helium/spell/config/' + pkgName;
	    var promisedConf = $http.get(confUrl).then(function (response, status) {
	      return response.data.body;
	    });
	
	    return promisedConf.then(function (_ref2) {
	      var confSpec = _ref2.confSpec,
	          confPersisted = _ref2.confPersisted;
	
	      var merged = (0, _heliumConf.mergePersistedConfWithSpec)(confPersisted, confSpec);
	      return merged;
	    });
	  };
	
	  var p = this.getAllEnabledPackages().then(function (enabledPackageSearchResults) {
	    var promises = enabledPackageSearchResults.map(function (packageSearchResult) {
	      var pkgName = packageSearchResult.pkg.name;
	      return _this3.getSingleBundle(pkgName);
	    });
	
	    return Promise.all(promises);
	  }).then(function (bundles) {
	    return bundles.reduce(function (acc, b) {
	      // filter out empty bundle
	      if (b === '') {
	        return acc;
	      }
	      acc.push(b);
	      return acc;
	    }, []);
	  });
	
	  // load should be promise
	  this.load = p.then(function (availableBundles) {
	    // evaluate bundles
	    availableBundles.map(function (b) {
	      // eslint-disable-next-line no-eval
	      eval(b);
	    });
	
	    // extract bundles by type
	    heliumBundles.map(function (b) {
	      if (b.type === _heliumType.HeliumType.SPELL) {
	        var spell = new b.class(); // eslint-disable-line new-cap
	        var pkgName = b.id;
	        spellPerMagic[spell.getMagic()] = spell;
	        pkgNamePerMagic[spell.getMagic()] = pkgName;
	      } else if (b.type === _heliumType.HeliumType.VISUALIZATION) {
	        visualizationBundles.push(b);
	      }
	    });
	  });
	
	  this.init = function () {
	    this.getVisualizationPackageOrder();
	  };
	
	  // init
	  this.init();
	}

/***/ }),
/* 234 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mergePersistedConfWithSpec = mergePersistedConfWithSpec;
	exports.createAllPackageConfigs = createAllPackageConfigs;
	exports.parseConfigValue = parseConfigValue;
	exports.createPersistableConfig = createPersistableConfig;
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	var HeliumConfFieldType = exports.HeliumConfFieldType = {
	  NUMBER: 'number',
	  JSON: 'json',
	  STRING: 'string'
	};
	
	/**
	 * @param persisted <Object> including `type`, `description`, `defaultValue` for each conf key
	 * @param spec <Object> including `value` for each conf key
	 */
	function mergePersistedConfWithSpec(persisted, spec) {
	  var confs = [];
	
	  for (var name in spec) {
	    if (spec.hasOwnProperty(name)) {
	      var specField = spec[name];
	      var persistedValue = persisted[name];
	
	      var value = persistedValue ? persistedValue : specField.defaultValue;
	      var merged = {
	        name: name,
	        type: specField.type,
	        description: specField.description,
	        value: value,
	        defaultValue: specField.defaultValue
	      };
	
	      confs.push(merged);
	    }
	  }
	
	  return confs;
	}
	
	function createAllPackageConfigs(defaultPackages, persistedConfs) {
	  var packageConfs = {};
	
	  for (var name in defaultPackages) {
	    if (defaultPackages.hasOwnProperty(name)) {
	      var pkgSearchResult = defaultPackages[name];
	
	      var spec = pkgSearchResult.pkg.config;
	      if (!spec) {
	        continue;
	      }
	
	      var artifact = pkgSearchResult.pkg.artifact;
	      if (!artifact) {
	        continue;
	      }
	
	      var persistedConf = {};
	      if (persistedConfs[artifact]) {
	        persistedConf = persistedConfs[artifact];
	      }
	
	      var confs = mergePersistedConfWithSpec(persistedConf, spec);
	      packageConfs[name] = confs;
	    }
	  }
	
	  return packageConfs;
	}
	
	function parseConfigValue(type, stringified) {
	  var value = stringified;
	
	  try {
	    if (HeliumConfFieldType.NUMBER === type) {
	      value = parseFloat(stringified);
	    } else if (HeliumConfFieldType.JSON === type) {
	      value = JSON.parse(stringified);
	    }
	  } catch (error) {
	    // return just the stringified one
	    console.error('Failed to parse conf type ' + type + ', value ' + value);
	  }
	
	  return value;
	}
	
	/**
	 * persist key-value only
	 * since other info (e.g type, desc) can be provided by default config
	 */
	function createPersistableConfig(currentConfs) {
	  var filtered = currentConfs.reduce(function (acc, c) {
	    acc[c.name] = parseConfigValue(c.type, c.value);
	    return acc;
	  }, {});
	
	  return filtered;
	}

/***/ }),
/* 235 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createDefaultPackage = createDefaultPackage;
	exports.createDefaultPackages = createDefaultPackages;
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	function createDefaultPackage(pkgSearchResult, sce) {
	  for (var pkgIdx in pkgSearchResult) {
	    if (pkgSearchResult.hasOwnProperty(pkgIdx)) {
	      var pkg = pkgSearchResult[pkgIdx];
	      pkg.pkg.icon = sce.trustAsHtml(pkg.pkg.icon);
	      if (pkg.enabled) {
	        pkgSearchResult.splice(pkgIdx, 1);
	        return pkg;
	      }
	    }
	  }
	
	  // show first available version if package is not enabled
	  var result = pkgSearchResult[0];
	  pkgSearchResult.splice(0, 1);
	  return result;
	}
	
	/**
	 * create default packages based on `enabled` field and `latest` version.
	 *
	 * @param pkgSearchResults
	 * @param sce angular `$sce` object
	 * @returns {Object} including {name, pkgInfo}
	 */
	function createDefaultPackages(pkgSearchResults, sce) {
	  var defaultPackages = {};
	  // show enabled version if any version of package is enabled
	  for (var name in pkgSearchResults) {
	    if (pkgSearchResults.hasOwnProperty(name)) {
	      var pkgSearchResult = pkgSearchResults[name];
	      defaultPackages[name] = createDefaultPackage(pkgSearchResult, sce);
	    }
	  }
	
	  return defaultPackages;
	}

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	DynamicFormDirective.$inject = ["$templateRequest", "$compile"];
	__webpack_require__(237);
	
	angular.module('zeppelinWebApp').directive('dynamicForms', DynamicFormDirective); /*
	                                                                                   * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                   * you may not use this file except in compliance with the License.
	                                                                                   * You may obtain a copy of the License at
	                                                                                   *
	                                                                                   *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                   *
	                                                                                   * Unless required by applicable law or agreed to in writing, software
	                                                                                   * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                   * See the License for the specific language governing permissions and
	                                                                                   * limitations under the License.
	                                                                                   */
	
	function DynamicFormDirective($templateRequest, $compile) {
	  return {
	    restrict: 'AE',
	    scope: {
	      id: '=id',
	      hide: '=hide',
	      disable: '=disable',
	      actiononchange: '=actiononchange',
	      forms: '=forms',
	      params: '=params',
	      action: '=action',
	      removeaction: '=removeaction'
	    },
	
	    link: function link(scope, element, attrs, controller) {
	      scope.loadForm = this.loadForm;
	      scope.toggleCheckbox = this.toggleCheckbox;
	      $templateRequest('app/notebook/dynamic-forms/dynamic-forms.directive.html').then(function (formsHtml) {
	        var forms = angular.element(formsHtml);
	        element.append(forms);
	        $compile(forms)(scope);
	      });
	    },
	
	    loadForm: function loadForm(formulaire, params) {
	      var value = formulaire.defaultValue;
	      if (params[formulaire.name]) {
	        value = params[formulaire.name];
	      }
	
	      params[formulaire.name] = value;
	    },
	
	    toggleCheckbox: function toggleCheckbox(formulaire, option, params) {
	      var idx = params[formulaire.name].indexOf(option.value);
	      if (idx > -1) {
	        params[formulaire.name].splice(idx, 1);
	      } else {
	        params[formulaire.name].push(option.value);
	      }
	    }
	
	  };
	}

/***/ }),
/* 237 */
1,
/* 238 */,
/* 239 */
/***/ (function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	ArrayOrderingService.$inject = ["TRASH_FOLDER_ID"];
	angular.module('zeppelinWebApp').service('arrayOrderingSrv', ArrayOrderingService);
	
	function ArrayOrderingService(TRASH_FOLDER_ID) {
	  'ngInject';
	
	  var arrayOrderingSrv = this;
	
	  this.noteListOrdering = function (note) {
	    if (note.id === TRASH_FOLDER_ID) {
	      return '\uFFFF';
	    }
	    return arrayOrderingSrv.getNoteName(note);
	  };
	
	  this.getNoteName = function (note) {
	    if (note.name === undefined || note.name.trim() === '') {
	      return 'Note ' + note.id;
	    } else {
	      return note.name;
	    }
	  };
	
	  this.noteComparator = function (v1, v2) {
	    var note1 = v1.value || v1;
	    var note2 = v2.value || v2;
	
	    if (note1.id === TRASH_FOLDER_ID) {
	      return 1;
	    }
	
	    if (note2.id === TRASH_FOLDER_ID) {
	      return -1;
	    }
	
	    if (note1.children === undefined && note2.children !== undefined) {
	      return 1;
	    }
	
	    if (note1.children !== undefined && note2.children === undefined) {
	      return -1;
	    }
	
	    var noteName1 = arrayOrderingSrv.getNoteName(note1);
	    var noteName2 = arrayOrderingSrv.getNoteName(note2);
	
	    return noteName1.localeCompare(noteName2);
	  };
	}

/***/ }),
/* 240 */
/***/ (function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	NavCtrl.$inject = ["$scope", "$rootScope", "$http", "$routeParams", "$location", "noteListFactory", "baseUrlSrv", "websocketMsgSrv", "arrayOrderingSrv", "searchService", "TRASH_FOLDER_ID"];
	angular.module('zeppelinWebApp').controller('NavCtrl', NavCtrl);
	
	function NavCtrl($scope, $rootScope, $http, $routeParams, $location, noteListFactory, baseUrlSrv, websocketMsgSrv, arrayOrderingSrv, searchService, TRASH_FOLDER_ID) {
	  'ngInject';
	
	  var vm = this;
	  vm.arrayOrderingSrv = arrayOrderingSrv;
	  vm.connected = websocketMsgSrv.isConnected();
	  vm.isActive = isActive;
	  vm.logout = logout;
	  vm.notes = noteListFactory;
	  vm.search = search;
	  vm.searchForm = searchService;
	  vm.showLoginWindow = showLoginWindow;
	  vm.showPasswordResetWindow = showPasswordResetWindow;
	  vm.TRASH_FOLDER_ID = TRASH_FOLDER_ID;
	  vm.isFilterNote = isFilterNote;
	  vm.numberOfNotesDisplayed = 10;
	  $rootScope.revisionSupported = false;
	  listConfigurations();
	
	  $scope.query = { q: '' };
	
	  vm.magpieCliUrl = baseUrlSrv.getRestApiBase() + '/magpie/cli';
	
	  initController();
	
	  function getZeppelinVersion() {
	    $http.get(baseUrlSrv.getRestApiBase() + '/magpie/version').success(function (data, status, headers, config) {
	      $rootScope.zeppelinVersion = data.version;
	    }).error(function (data, status, headers, config) {
	      console.log('Error %o %o', status, data.message);
	    });
	  }
	
	  function initController() {
	    $scope.isDrawNavbarNoteList = false;
	    angular.element('#notebook-list').perfectScrollbar({ suppressScrollX: true });
	
	    angular.element(document).click(function () {
	      $scope.query.q = '';
	    });
	
	    getZeppelinVersion();
	    loadNotes();
	  }
	
	  function isFilterNote(note) {
	    if (!$scope.query.q) {
	      return true;
	    }
	
	    var noteName = note.name;
	    if (noteName.toLowerCase().indexOf($scope.query.q.toLowerCase()) > -1) {
	      return true;
	    }
	    return false;
	  }
	
	  function isActive(noteId) {
	    return $routeParams.noteId === noteId;
	  }
	
	  function listConfigurations() {
	    websocketMsgSrv.listConfigurations();
	  }
	
	  function loadNotes() {
	    websocketMsgSrv.getNoteList();
	  }
	
	  function getHomeNote() {
	    websocketMsgSrv.getHomeNote();
	  }
	
	  function logout() {
	    var logoutURL = baseUrlSrv.getRestApiBase() + '/login/logout';
	
	    $http.post(logoutURL).then(function () {}, function (response) {
	      if (response.data) {
	        var res = angular.fromJson(response.data).body;
	        if (res['redirectURL']) {
	          if (res['isLogoutAPI'] === 'true') {
	            $http.get(res['redirectURL']).then(function () {}, function () {
	              window.location = baseUrlSrv.getBase();
	            });
	          } else {
	            window.location.href = res['redirectURL'] + window.location.href;
	          }
	          return undefined;
	        }
	      }
	
	      // force authcBasic (if configured) to logout
	      if (detectIE()) {
	        var outcome = void 0;
	        try {
	          outcome = document.execCommand('ClearAuthenticationCache');
	        } catch (e) {
	          console.log(e);
	        }
	        if (!outcome) {
	          // Let's create an xmlhttp object
	          outcome = function (x) {
	            if (x) {
	              // the reason we use "random" value for password is
	              // that browsers cache requests. changing
	              // password effectively behaves like cache-busing.
	              x.open('HEAD', location.href, true, 'logout', new Date().getTime().toString());
	              x.send('');
	              // x.abort()
	              return 1; // this is **speculative** "We are done."
	            } else {
	              // eslint-disable-next-line no-useless-return
	              return;
	            }
	          }(window.XMLHttpRequest ? new window.XMLHttpRequest()
	          // eslint-disable-next-line no-undef
	          : window.ActiveXObject ? new ActiveXObject('Microsoft.XMLHTTP') : u);
	        }
	        if (!outcome) {
	          var m = 'Your browser is too old or too weird to support log out functionality. Close all windows and ' + 'restart the browser.';
	          alert(m);
	        }
	      } else {
	        // for firefox and safari
	        logoutURL = logoutURL.replace('//', '//false:false@');
	      }
	
	      $http.post(logoutURL).error(function () {
	        $rootScope.userName = '';
	        $rootScope.ticket.principal = '';
	        $rootScope.ticket.screenUsername = '';
	        $rootScope.ticket.ticket = '';
	        $rootScope.ticket.roles = '';
	        BootstrapDialog.show({
	          message: 'Logout Success'
	        });
	        setTimeout(function () {
	          window.location = baseUrlSrv.getBase();
	        }, 1000);
	      });
	    });
	  }
	
	  function detectIE() {
	    var ua = window.navigator.userAgent;
	
	    var msie = ua.indexOf('MSIE ');
	    if (msie > 0) {
	      // IE 10 or older => return version number
	      return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
	    }
	
	    var trident = ua.indexOf('Trident/');
	    if (trident > 0) {
	      // IE 11 => return version number
	      var rv = ua.indexOf('rv:');
	      return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
	    }
	
	    var edge = ua.indexOf('Edge/');
	    if (edge > 0) {
	      // Edge (IE 12+) => return version number
	      return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
	    }
	
	    // other browser
	    return false;
	  }
	
	  function search(searchTerm) {
	    $location.path('/search/' + searchTerm);
	  }
	
	  function showLoginWindow() {
	    setTimeout(function () {
	      angular.element('#userName').focus();
	    }, 500);
	  }
	
	  function showPasswordResetWindow() {
	    setTimeout(function () {
	      angular.element('#userName').focus();
	    }, 500);
	  }
	
	  /*
	   ** $scope.$on functions below
	   */
	
	  $scope.$on('setNoteMenu', function (event, notes) {
	    noteListFactory.setNotes(notes);
	    initNotebookListEventListener();
	  });
	
	  $scope.$on('setConnectedStatus', function (event, param) {
	    vm.connected = param;
	  });
	
	  $scope.$on('loginSuccess', function (event, param) {
	    $rootScope.ticket.screenUsername = $rootScope.ticket.principal;
	    listConfigurations();
	    loadNotes();
	    getHomeNote();
	  });
	
	  /*
	   ** Performance optimization for Browser Render.
	   */
	  function initNotebookListEventListener() {
	    angular.element(document).ready(function () {
	      angular.element('.notebook-list-dropdown').on('show.bs.dropdown', function () {
	        $scope.isDrawNavbarNoteList = true;
	      });
	
	      angular.element('.notebook-list-dropdown').on('hide.bs.dropdown', function () {
	        $scope.isDrawNavbarNoteList = false;
	      });
	    });
	  }
	
	  $scope.loadMoreNotes = function () {
	    vm.numberOfNotesDisplayed += 10;
	  };
	
	  $scope.calculateTooltipPlacement = function (note) {
	    if (note !== undefined && note.name !== undefined) {
	      var length = note.name.length;
	      if (length < 2) {
	        return 'top-left';
	      } else if (length > 7) {
	        return 'top-right';
	      }
	    }
	    return 'top';
	  };
	
	  $scope.$on('configurationsInfo', function (scope, event) {
	    // Server send this parameter is String
	    if (event.configurations['isRevisionSupported'] === 'true') {
	      $rootScope.revisionSupported = true;
	    }
	  });
	}

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(242);
	
	angular.module('zeppelinWebApp').directive('expandCollapse', expandCollapseDirective); /*
	                                                                                        * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                        * you may not use this file except in compliance with the License.
	                                                                                        * You may obtain a copy of the License at
	                                                                                        *
	                                                                                        *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                        *
	                                                                                        * Unless required by applicable law or agreed to in writing, software
	                                                                                        * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                        * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                        * See the License for the specific language governing permissions and
	                                                                                        * limitations under the License.
	                                                                                        */
	
	function expandCollapseDirective() {
	  return {
	    restrict: 'EA',
	    link: function link(scope, element, attrs) {
	      angular.element(element).click(function (event) {
	        if (angular.element(element).next('.expandable:visible').length > 1) {
	          angular.element(element).next('.expandable:visible').slideUp('slow');
	          angular.element(element).find('i.fa-folder-open').toggleClass('fa-folder fa-folder-open');
	        } else {
	          angular.element(element).next('.expandable').first().slideToggle('200', function () {
	            // do not toggle trash folder
	            if (angular.element(element).find('.fa-trash-o').length === 0) {
	              angular.element(element).find('i').first().toggleClass('fa-folder fa-folder-open');
	            }
	          });
	        }
	
	        var target = event.target;
	
	        // add note
	        if (target.classList !== undefined && target.classList.contains('fa-plus') && target.tagName.toLowerCase() === 'i') {
	          return;
	        }
	
	        event.stopPropagation();
	      });
	    }
	  };
	}

/***/ }),
/* 242 */
1,
/* 243 */,
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	NoteCreateCtrl.$inject = ["$scope", "noteListFactory", "$routeParams", "websocketMsgSrv"];
	__webpack_require__(245);
	
	angular.module('zeppelinWebApp').controller('NoteCreateCtrl', NoteCreateCtrl); /*
	                                                                                * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                * you may not use this file except in compliance with the License.
	                                                                                * You may obtain a copy of the License at
	                                                                                *
	                                                                                *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                *
	                                                                                * Unless required by applicable law or agreed to in writing, software
	                                                                                * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                * See the License for the specific language governing permissions and
	                                                                                * limitations under the License.
	                                                                                */
	
	function NoteCreateCtrl($scope, noteListFactory, $routeParams, websocketMsgSrv) {
	  'ngInject';
	
	  var vm = this;
	  vm.clone = false;
	  vm.notes = noteListFactory;
	  vm.websocketMsgSrv = websocketMsgSrv;
	  $scope.note = {};
	  $scope.interpreterSettings = {};
	  $scope.note.defaultInterpreter = null;
	
	  vm.createNote = function () {
	    if (!vm.clone) {
	      var defaultInterpreterId = '';
	      if ($scope.note.defaultInterpreter !== null) {
	        defaultInterpreterId = $scope.note.defaultInterpreter.id;
	      }
	      vm.websocketMsgSrv.createNotebook($scope.note.notename, defaultInterpreterId);
	      $scope.note.defaultInterpreter = $scope.interpreterSettings[0];
	    } else {
	      var noteId = $routeParams.noteId;
	      vm.websocketMsgSrv.cloneNote(noteId, $scope.note.notename);
	    }
	  };
	
	  vm.handleNameEnter = function () {
	    angular.element('#noteCreateModal').modal('toggle');
	    vm.createNote();
	  };
	
	  vm.preVisible = function (clone, sourceNoteName, path) {
	    vm.clone = clone;
	    vm.sourceNoteName = sourceNoteName;
	    $scope.note.notename = vm.clone ? vm.cloneNoteName() : vm.newNoteName(path);
	    $scope.$apply();
	  };
	
	  vm.newNoteName = function (path) {
	    var newCount = 1;
	    angular.forEach(vm.notes.flatList, function (noteName) {
	      noteName = noteName.name;
	      if (noteName.match(/^Untitled Note [0-9]*$/)) {
	        var lastCount = noteName.substr(14) * 1;
	        if (newCount <= lastCount) {
	          newCount = lastCount + 1;
	        }
	      }
	    });
	    return (path ? path + '/' : '') + 'Untitled Note ' + newCount;
	  };
	
	  vm.cloneNoteName = function () {
	    var copyCount = 1;
	    var newCloneName = '';
	    var lastIndex = vm.sourceNoteName.lastIndexOf(' ');
	    var endsWithNumber = !!vm.sourceNoteName.match('^.+?\\s\\d$');
	    var noteNamePrefix = endsWithNumber ? vm.sourceNoteName.substr(0, lastIndex) : vm.sourceNoteName;
	    var regexp = new RegExp('^' + noteNamePrefix + ' .+');
	
	    angular.forEach(vm.notes.flatList, function (noteName) {
	      noteName = noteName.name;
	      if (noteName.match(regexp)) {
	        var lastCopyCount = noteName.substr(lastIndex).trim();
	        newCloneName = noteNamePrefix;
	        lastCopyCount = parseInt(lastCopyCount);
	        if (copyCount <= lastCopyCount) {
	          copyCount = lastCopyCount + 1;
	        }
	      }
	    });
	
	    if (!newCloneName) {
	      newCloneName = vm.sourceNoteName;
	    }
	    return newCloneName + ' ' + copyCount;
	  };
	
	  vm.getInterpreterSettings = function () {
	    vm.websocketMsgSrv.getInterpreterSettings();
	  };
	
	  $scope.$on('interpreterSettings', function (event, data) {
	    $scope.interpreterSettings = data.interpreterSettings;
	
	    // initialize default interpreter with Spark interpreter
	    $scope.note.defaultInterpreter = data.interpreterSettings[0];
	  });
	}

/***/ }),
/* 245 */
1,
/* 246 */,
/* 247 */
/***/ (function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').directive('modalvisible', modalvisible);
	
	function modalvisible() {
	  return {
	    restrict: 'A',
	    scope: {
	      preVisibleCallback: '&previsiblecallback',
	      postVisibleCallback: '&postvisiblecallback',
	      targetinput: '@targetinput'
	    },
	    link: function link(scope, element, attrs) {
	      // Add some listeners
	      var previsibleMethod = scope.preVisibleCallback;
	      var postVisibleMethod = scope.postVisibleCallback;
	      element.on('show.bs.modal', function (e) {
	        var relatedTarget = angular.element(e.relatedTarget);
	        var clone = relatedTarget.data('clone');
	        var sourceNoteName = relatedTarget.data('source-note-name');
	        var path = relatedTarget.data('path');
	        var cloneNote = clone ? true : false;
	        previsibleMethod()(cloneNote, sourceNoteName, path);
	      });
	      element.on('shown.bs.modal', function (e) {
	        if (scope.targetinput) {
	          angular.element(e.target).find('input#' + scope.targetinput).select();
	        }
	        postVisibleMethod();
	      });
	    }
	  };
	}

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	NoteImportCtrl.$inject = ["$scope", "$timeout", "websocketMsgSrv"];
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*
	                                                                                                                                                                                                                                                                               * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                               * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                               * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                               *
	                                                                                                                                                                                                                                                                               *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                               *
	                                                                                                                                                                                                                                                                               * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                               * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                               * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                               * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                               * limitations under the License.
	                                                                                                                                                                                                                                                                               */
	
	__webpack_require__(249);
	
	angular.module('zeppelinWebApp').controller('NoteImportCtrl', NoteImportCtrl);
	
	function NoteImportCtrl($scope, $timeout, websocketMsgSrv) {
	  'ngInject';
	
	  var vm = this;
	  $scope.note = {};
	  $scope.note.step1 = true;
	  $scope.note.step2 = false;
	  $scope.maxLimit = '';
	  var limit = 0;
	
	  websocketMsgSrv.listConfigurations();
	  $scope.$on('configurationsInfo', function (scope, event) {
	    limit = event.configurations['zeppelin.websocket.max.text.message.size'];
	    $scope.maxLimit = Math.round(limit / 1048576);
	  });
	
	  vm.resetFlags = function () {
	    $scope.note = {};
	    $scope.note.step1 = true;
	    $scope.note.step2 = false;
	    angular.element('#noteImportFile').val('');
	  };
	
	  $scope.uploadFile = function () {
	    angular.element('#noteImportFile').click();
	  };
	
	  $scope.importFile = function (element) {
	    $scope.note.errorText = '';
	    $scope.note.importFile = element.files[0];
	    var file = $scope.note.importFile;
	    var reader = new FileReader();
	
	    if (file.size > limit) {
	      $scope.note.errorText = 'File size limit Exceeded!';
	      $scope.$apply();
	      return;
	    }
	
	    reader.onloadend = function () {
	      vm.processImportJson(reader.result);
	    };
	
	    if (file) {
	      reader.readAsText(file);
	    }
	  };
	
	  $scope.uploadURL = function () {
	    $scope.note.errorText = '';
	    $scope.note.step1 = false;
	    $timeout(function () {
	      $scope.note.step2 = true;
	    }, 400);
	  };
	
	  vm.importBack = function () {
	    $scope.note.errorText = '';
	    $timeout(function () {
	      $scope.note.step1 = true;
	    }, 400);
	    $scope.note.step2 = false;
	  };
	
	  vm.importNote = function () {
	    $scope.note.errorText = '';
	    if ($scope.note.importUrl) {
	      jQuery.ajax({
	        url: $scope.note.importUrl,
	        type: 'GET',
	        dataType: 'json',
	        jsonp: false,
	        xhrFields: {
	          withCredentials: false
	        },
	        error: function error(xhr, ajaxOptions, thrownError) {
	          $scope.note.errorText = 'Unable to Fetch URL';
	          $scope.$apply();
	        } }).done(function (data) {
	        vm.processImportJson(data);
	      });
	    } else {
	      $scope.note.errorText = 'Enter URL';
	      $scope.$apply();
	    }
	  };
	
	  vm.processImportJson = function (result) {
	    if ((typeof result === 'undefined' ? 'undefined' : _typeof(result)) !== 'object') {
	      try {
	        result = JSON.parse(result);
	      } catch (e) {
	        $scope.note.errorText = 'JSON parse exception';
	        $scope.$apply();
	        return;
	      }
	    }
	    if (result.paragraphs && result.paragraphs.length > 0) {
	      if (!$scope.note.noteImportName) {
	        $scope.note.noteImportName = result.name;
	      } else {
	        result.name = $scope.note.noteImportName;
	      }
	      websocketMsgSrv.importNote(result);
	      // angular.element('#noteImportModal').modal('hide');
	    } else {
	      $scope.note.errorText = 'Invalid JSON';
	    }
	    $scope.$apply();
	  };
	
	  /*
	   ** $scope.$on functions below
	   */
	
	  $scope.$on('setNoteMenu', function (event, notes) {
	    vm.resetFlags();
	    angular.element('#noteImportModal').modal('hide');
	  });
	}

/***/ }),
/* 249 */
1,
/* 250 */,
/* 251 */
/***/ (function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').directive('ngEnter', NgEnterDirective);
	
	function NgEnterDirective() {
	  return function (scope, element, attrs) {
	    element.bind('keydown keypress', function (event) {
	      if (event.which === 13) {
	        if (!event.shiftKey) {
	          scope.$apply(function () {
	            scope.$eval(attrs.ngEnter);
	          });
	        }
	        event.preventDefault();
	      }
	    });
	  };
	}

/***/ }),
/* 252 */
/***/ (function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').directive('ngEscape', NgEscapeDirective);
	
	function NgEscapeDirective() {
	  return function (scope, element, attrs) {
	    element.bind('keydown keyup', function (event) {
	      if (event.which === 27) {
	        scope.$apply(function () {
	          scope.$eval(attrs.ngEscape);
	        });
	        event.preventDefault();
	      }
	    });
	  };
	}

/***/ }),
/* 253 */
/***/ (function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	WebsocketMessageService.$inject = ["$rootScope", "websocketEvents"];
	angular.module('zeppelinWebApp').service('websocketMsgSrv', WebsocketMessageService);
	
	function WebsocketMessageService($rootScope, websocketEvents) {
	  'ngInject';
	
	  return {
	
	    getHomeNote: function getHomeNote() {
	      websocketEvents.sendNewEvent({ op: 'GET_HOME_NOTE' });
	    },
	
	    createNotebook: function createNotebook(noteName, defaultInterpreterId) {
	      websocketEvents.sendNewEvent({
	        op: 'NEW_NOTE',
	        data: {
	          name: noteName,
	          defaultInterpreterId: defaultInterpreterId
	        }
	      });
	    },
	
	    moveNoteToTrash: function moveNoteToTrash(noteId) {
	      websocketEvents.sendNewEvent({ op: 'MOVE_NOTE_TO_TRASH', data: { id: noteId } });
	    },
	
	    moveFolderToTrash: function moveFolderToTrash(folderId) {
	      websocketEvents.sendNewEvent({ op: 'MOVE_FOLDER_TO_TRASH', data: { id: folderId } });
	    },
	
	    restoreNote: function restoreNote(noteId) {
	      websocketEvents.sendNewEvent({ op: 'RESTORE_NOTE', data: { id: noteId } });
	    },
	
	    restoreFolder: function restoreFolder(folderId) {
	      websocketEvents.sendNewEvent({ op: 'RESTORE_FOLDER', data: { id: folderId } });
	    },
	
	    restoreAll: function restoreAll() {
	      websocketEvents.sendNewEvent({ op: 'RESTORE_ALL' });
	    },
	
	    deleteNote: function deleteNote(noteId) {
	      websocketEvents.sendNewEvent({ op: 'DEL_NOTE', data: { id: noteId } });
	    },
	
	    removeFolder: function removeFolder(folderId) {
	      websocketEvents.sendNewEvent({ op: 'REMOVE_FOLDER', data: { id: folderId } });
	    },
	
	    emptyTrash: function emptyTrash() {
	      websocketEvents.sendNewEvent({ op: 'EMPTY_TRASH' });
	    },
	
	    cloneNote: function cloneNote(noteIdToClone, newNoteName) {
	      websocketEvents.sendNewEvent({ op: 'CLONE_NOTE', data: { id: noteIdToClone, name: newNoteName } });
	    },
	
	    getNoteList: function getNoteList() {
	      websocketEvents.sendNewEvent({ op: 'LIST_NOTES' });
	    },
	
	    reloadAllNotesFromRepo: function reloadAllNotesFromRepo() {
	      websocketEvents.sendNewEvent({ op: 'RELOAD_NOTES_FROM_REPO' });
	    },
	
	    getNote: function getNote(noteId) {
	      websocketEvents.sendNewEvent({ op: 'GET_NOTE', data: { id: noteId } });
	    },
	
	    updateNote: function updateNote(noteId, noteName, noteConfig) {
	      websocketEvents.sendNewEvent({ op: 'NOTE_UPDATE', data: { id: noteId, name: noteName, config: noteConfig } });
	    },
	
	    updatePersonalizedMode: function updatePersonalizedMode(noteId, modeValue) {
	      websocketEvents.sendNewEvent({ op: 'UPDATE_PERSONALIZED_MODE', data: { id: noteId, personalized: modeValue } });
	    },
	
	    renameNote: function renameNote(noteId, noteName) {
	      websocketEvents.sendNewEvent({ op: 'NOTE_RENAME', data: { id: noteId, name: noteName } });
	    },
	
	    renameFolder: function renameFolder(folderId, folderName) {
	      websocketEvents.sendNewEvent({ op: 'FOLDER_RENAME', data: { id: folderId, name: folderName } });
	    },
	
	    moveParagraph: function moveParagraph(paragraphId, newIndex) {
	      websocketEvents.sendNewEvent({ op: 'MOVE_PARAGRAPH', data: { id: paragraphId, index: newIndex } });
	    },
	
	    insertParagraph: function insertParagraph(newIndex) {
	      websocketEvents.sendNewEvent({ op: 'INSERT_PARAGRAPH', data: { index: newIndex } });
	    },
	
	    copyParagraph: function copyParagraph(newIndex, paragraphTitle, paragraphData, paragraphConfig, paragraphParams) {
	      websocketEvents.sendNewEvent({
	        op: 'COPY_PARAGRAPH',
	        data: {
	          index: newIndex,
	          title: paragraphTitle,
	          paragraph: paragraphData,
	          config: paragraphConfig,
	          params: paragraphParams
	        }
	      });
	    },
	
	    updateAngularObject: function updateAngularObject(noteId, paragraphId, name, value, interpreterGroupId) {
	      websocketEvents.sendNewEvent({
	        op: 'ANGULAR_OBJECT_UPDATED',
	        data: {
	          noteId: noteId,
	          paragraphId: paragraphId,
	          name: name,
	          value: value,
	          interpreterGroupId: interpreterGroupId
	        }
	      });
	    },
	
	    clientBindAngularObject: function clientBindAngularObject(noteId, name, value, paragraphId) {
	      websocketEvents.sendNewEvent({
	        op: 'ANGULAR_OBJECT_CLIENT_BIND',
	        data: {
	          noteId: noteId,
	          name: name,
	          value: value,
	          paragraphId: paragraphId
	        }
	      });
	    },
	
	    clientUnbindAngularObject: function clientUnbindAngularObject(noteId, name, paragraphId) {
	      websocketEvents.sendNewEvent({
	        op: 'ANGULAR_OBJECT_CLIENT_UNBIND',
	        data: {
	          noteId: noteId,
	          name: name,
	          paragraphId: paragraphId
	        }
	      });
	    },
	
	    cancelParagraphRun: function cancelParagraphRun(paragraphId) {
	      websocketEvents.sendNewEvent({ op: 'CANCEL_PARAGRAPH', data: { id: paragraphId } });
	    },
	
	    paragraphExecutedBySpell: function paragraphExecutedBySpell(paragraphId, paragraphTitle, paragraphText, paragraphResultsMsg, paragraphStatus, paragraphErrorMessage, paragraphConfig, paragraphParams, paragraphDateStarted, paragraphDateFinished) {
	      websocketEvents.sendNewEvent({
	        op: 'PARAGRAPH_EXECUTED_BY_SPELL',
	        data: {
	          id: paragraphId,
	          title: paragraphTitle,
	          paragraph: paragraphText,
	          results: {
	            code: paragraphStatus,
	            msg: paragraphResultsMsg.map(function (dataWithType) {
	              var serializedData = dataWithType.data;
	              return { type: dataWithType.type, data: serializedData };
	            })
	          },
	          status: paragraphStatus,
	          errorMessage: paragraphErrorMessage,
	          config: paragraphConfig,
	          params: paragraphParams,
	          dateStarted: paragraphDateStarted,
	          dateFinished: paragraphDateFinished
	        }
	      });
	    },
	
	    runParagraph: function runParagraph(paragraphId, paragraphTitle, paragraphData, paragraphConfig, paragraphParams) {
	      websocketEvents.sendNewEvent({
	        op: 'RUN_PARAGRAPH',
	        data: {
	          id: paragraphId,
	          title: paragraphTitle,
	          paragraph: paragraphData,
	          config: paragraphConfig,
	          params: paragraphParams
	        }
	      });
	    },
	
	    runAllParagraphs: function runAllParagraphs(noteId, paragraphs) {
	      websocketEvents.sendNewEvent({
	        op: 'RUN_ALL_PARAGRAPHS',
	        data: {
	          noteId: noteId,
	          paragraphs: JSON.stringify(paragraphs)
	        }
	      });
	    },
	
	    removeParagraph: function removeParagraph(paragraphId) {
	      websocketEvents.sendNewEvent({ op: 'PARAGRAPH_REMOVE', data: { id: paragraphId } });
	    },
	
	    clearParagraphOutput: function clearParagraphOutput(paragraphId) {
	      websocketEvents.sendNewEvent({ op: 'PARAGRAPH_CLEAR_OUTPUT', data: { id: paragraphId } });
	    },
	
	    clearAllParagraphOutput: function clearAllParagraphOutput(noteId) {
	      websocketEvents.sendNewEvent({ op: 'PARAGRAPH_CLEAR_ALL_OUTPUT', data: { id: noteId } });
	    },
	
	    completion: function completion(paragraphId, buf, cursor) {
	      websocketEvents.sendNewEvent({
	        op: 'COMPLETION',
	        data: {
	          id: paragraphId,
	          buf: buf,
	          cursor: cursor
	        }
	      });
	    },
	
	    commitParagraph: function commitParagraph(paragraphId, paragraphTitle, paragraphData, paragraphConfig, paragraphParams, noteId) {
	      return websocketEvents.sendNewEvent({
	        op: 'COMMIT_PARAGRAPH',
	        data: {
	          id: paragraphId,
	          noteId: noteId,
	          title: paragraphTitle,
	          paragraph: paragraphData,
	          config: paragraphConfig,
	          params: paragraphParams
	        }
	      });
	    },
	
	    importNote: function importNote(note) {
	      websocketEvents.sendNewEvent({
	        op: 'IMPORT_NOTE',
	        data: {
	          note: note
	        }
	      });
	    },
	
	    checkpointNote: function checkpointNote(noteId, commitMessage) {
	      websocketEvents.sendNewEvent({
	        op: 'CHECKPOINT_NOTE',
	        data: {
	          noteId: noteId,
	          commitMessage: commitMessage
	        }
	      });
	    },
	
	    setNoteRevision: function setNoteRevision(noteId, revisionId) {
	      websocketEvents.sendNewEvent({
	        op: 'SET_NOTE_REVISION',
	        data: {
	          noteId: noteId,
	          revisionId: revisionId
	        }
	      });
	    },
	
	    listRevisionHistory: function listRevisionHistory(noteId) {
	      websocketEvents.sendNewEvent({
	        op: 'LIST_REVISION_HISTORY',
	        data: {
	          noteId: noteId
	        }
	      });
	    },
	
	    getNoteByRevision: function getNoteByRevision(noteId, revisionId) {
	      websocketEvents.sendNewEvent({
	        op: 'NOTE_REVISION',
	        data: {
	          noteId: noteId,
	          revisionId: revisionId
	        }
	      });
	    },
	
	    getNoteByRevisionForCompare: function getNoteByRevisionForCompare(noteId, revisionId, position) {
	      websocketEvents.sendNewEvent({
	        op: 'NOTE_REVISION_FOR_COMPARE',
	        data: {
	          noteId: noteId,
	          revisionId: revisionId,
	          position: position
	        }
	      });
	    },
	
	    getEditorSetting: function getEditorSetting(paragraphId, replName) {
	      websocketEvents.sendNewEvent({
	        op: 'EDITOR_SETTING',
	        data: {
	          paragraphId: paragraphId,
	          magic: replName
	        }
	      });
	    },
	
	    isConnected: function isConnected() {
	      return websocketEvents.isConnected();
	    },
	
	    getJobs: function getJobs() {
	      websocketEvents.sendNewEvent({ op: 'LIST_NOTE_JOBS' });
	    },
	
	    disconnectJobEvent: function disconnectJobEvent() {
	      websocketEvents.sendNewEvent({ op: 'UNSUBSCRIBE_UPDATE_NOTE_JOBS' });
	    },
	
	    getUpdateNoteJobsList: function getUpdateNoteJobsList(lastUpdateServerUnixTime) {
	      websocketEvents.sendNewEvent({ op: 'LIST_UPDATE_NOTE_JOBS', data: { lastUpdateUnixTime: lastUpdateServerUnixTime * 1 } });
	    },
	
	    getInterpreterBindings: function getInterpreterBindings(noteId) {
	      websocketEvents.sendNewEvent({ op: 'GET_INTERPRETER_BINDINGS', data: { noteId: noteId } });
	    },
	
	    saveInterpreterBindings: function saveInterpreterBindings(noteId, selectedSettingIds) {
	      websocketEvents.sendNewEvent({ op: 'SAVE_INTERPRETER_BINDINGS',
	        data: { noteId: noteId, selectedSettingIds: selectedSettingIds } });
	    },
	
	    listConfigurations: function listConfigurations() {
	      websocketEvents.sendNewEvent({ op: 'LIST_CONFIGURATIONS' });
	    },
	
	    getInterpreterSettings: function getInterpreterSettings() {
	      websocketEvents.sendNewEvent({ op: 'GET_INTERPRETER_SETTINGS' });
	    },
	
	    saveNoteForms: function saveNoteForms(note) {
	      websocketEvents.sendNewEvent({ op: 'SAVE_NOTE_FORMS',
	        data: {
	          noteId: note.id,
	          noteParams: note.noteParams
	        }
	      });
	    },
	
	    removeNoteForms: function removeNoteForms(note, formName) {
	      websocketEvents.sendNewEvent({ op: 'REMOVE_NOTE_FORMS',
	        data: {
	          noteId: note.id,
	          formName: formName
	        }
	      });
	    }
	
	  };
	}

/***/ }),
/* 254 */
/***/ (function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	WebsocketEventFactory.$inject = ["$rootScope", "$websocket", "$location", "baseUrlSrv", "ngToast"];
	angular.module('zeppelinWebApp').factory('websocketEvents', WebsocketEventFactory);
	
	function WebsocketEventFactory($rootScope, $websocket, $location, baseUrlSrv, ngToast) {
	  'ngInject';
	
	  var websocketCalls = {};
	  var pingIntervalId = void 0;
	
	  websocketCalls.ws = $websocket(baseUrlSrv.getWebsocketUrl());
	  websocketCalls.ws.reconnectIfNotNormalClose = true;
	
	  websocketCalls.ws.onOpen(function () {
	    console.log('Websocket created');
	    $rootScope.$broadcast('setConnectedStatus', true);
	    pingIntervalId = setInterval(function () {
	      websocketCalls.sendNewEvent({ op: 'PING' });
	    }, 10000);
	  });
	
	  websocketCalls.sendNewEvent = function (data) {
	    if ($rootScope.ticket !== undefined) {
	      data.principal = $rootScope.ticket.principal;
	      data.ticket = $rootScope.ticket.ticket;
	      data.roles = $rootScope.ticket.roles;
	    } else {
	      data.principal = '';
	      data.ticket = '';
	      data.roles = '';
	    }
	    console.log('Send >> %o, %o, %o, %o, %o', data.op, data.principal, data.ticket, data.roles, data);
	    return websocketCalls.ws.send(JSON.stringify(data));
	  };
	
	  websocketCalls.isConnected = function () {
	    return websocketCalls.ws.socket.readyState === 1;
	  };
	
	  websocketCalls.ws.onMessage(function (event) {
	    var payload = void 0;
	    if (event.data) {
	      payload = angular.fromJson(event.data);
	    }
	
	    console.log('Receive << %o, %o', payload.op, payload);
	
	    var op = payload.op;
	    var data = payload.data;
	    if (op === 'NOTE') {
	      $rootScope.$broadcast('setNoteContent', data.note);
	    } else if (op === 'NEW_NOTE') {
	      $location.path('/notebook/' + data.note.id);
	    } else if (op === 'NOTES_INFO') {
	      $rootScope.$broadcast('setNoteMenu', data.notes);
	    } else if (op === 'LIST_NOTE_JOBS') {
	      $rootScope.$emit('jobmanager:set-jobs', data.noteJobs);
	    } else if (op === 'LIST_UPDATE_NOTE_JOBS') {
	      $rootScope.$emit('jobmanager:update-jobs', data.noteRunningJobs);
	    } else if (op === 'AUTH_INFO') {
	      var btn = [];
	      if ($rootScope.ticket.roles === '[]') {
	        btn = [{
	          label: 'Close',
	          action: function action(dialog) {
	            dialog.close();
	          }
	        }];
	      } else {
	        btn = [{
	          label: 'Login',
	          action: function action(dialog) {
	            dialog.close();
	            angular.element('#loginModal').modal({
	              show: 'true'
	            });
	          }
	        }, {
	          label: 'Cancel',
	          action: function action(dialog) {
	            dialog.close();
	            // using $rootScope.apply to trigger angular digest cycle
	            // changing $location.path inside bootstrap modal wont trigger digest
	            $rootScope.$apply(function () {
	              $location.path('/');
	            });
	          }
	        }];
	      }
	
	      BootstrapDialog.show({
	        closable: false,
	        closeByBackdrop: false,
	        closeByKeyboard: false,
	        title: 'Insufficient privileges',
	        message: _.escape(data.info.toString()),
	        buttons: btn
	      });
	    } else if (op === 'PARAGRAPH') {
	      $rootScope.$broadcast('updateParagraph', data);
	    } else if (op === 'RUN_PARAGRAPH_USING_SPELL') {
	      $rootScope.$broadcast('runParagraphUsingSpell', data);
	    } else if (op === 'PARAGRAPH_APPEND_OUTPUT') {
	      $rootScope.$broadcast('appendParagraphOutput', data);
	    } else if (op === 'PARAGRAPH_UPDATE_OUTPUT') {
	      $rootScope.$broadcast('updateParagraphOutput', data);
	    } else if (op === 'PROGRESS') {
	      $rootScope.$broadcast('updateProgress', data);
	    } else if (op === 'COMPLETION_LIST') {
	      $rootScope.$broadcast('completionList', data);
	    } else if (op === 'EDITOR_SETTING') {
	      $rootScope.$broadcast('editorSetting', data);
	    } else if (op === 'ANGULAR_OBJECT_UPDATE') {
	      $rootScope.$broadcast('angularObjectUpdate', data);
	    } else if (op === 'ANGULAR_OBJECT_REMOVE') {
	      $rootScope.$broadcast('angularObjectRemove', data);
	    } else if (op === 'APP_APPEND_OUTPUT') {
	      $rootScope.$broadcast('appendAppOutput', data);
	    } else if (op === 'APP_UPDATE_OUTPUT') {
	      $rootScope.$broadcast('updateAppOutput', data);
	    } else if (op === 'APP_LOAD') {
	      $rootScope.$broadcast('appLoad', data);
	    } else if (op === 'APP_STATUS_CHANGE') {
	      $rootScope.$broadcast('appStatusChange', data);
	    } else if (op === 'LIST_REVISION_HISTORY') {
	      $rootScope.$broadcast('listRevisionHistory', data);
	    } else if (op === 'NOTE_REVISION') {
	      $rootScope.$broadcast('noteRevision', data);
	    } else if (op === 'NOTE_REVISION_FOR_COMPARE') {
	      $rootScope.$broadcast('noteRevisionForCompare', data);
	    } else if (op === 'INTERPRETER_BINDINGS') {
	      $rootScope.$broadcast('interpreterBindings', data);
	    } else if (op === 'SAVE_NOTE_FORMS') {
	      $rootScope.$broadcast('saveNoteForms', data);
	    } else if (op === 'ERROR_INFO') {
	      BootstrapDialog.show({
	        closable: false,
	        closeByBackdrop: false,
	        closeByKeyboard: false,
	        title: 'Details',
	        message: _.escape(data.info.toString()),
	        buttons: [{
	          // close all the dialogs when there are error on running all paragraphs
	          label: 'Close',
	          action: function action() {
	            BootstrapDialog.closeAll();
	          }
	        }]
	      });
	    } else if (op === 'SESSION_LOGOUT') {
	      $rootScope.$broadcast('session_logout', data);
	    } else if (op === 'CONFIGURATIONS_INFO') {
	      $rootScope.$broadcast('configurationsInfo', data);
	    } else if (op === 'INTERPRETER_SETTINGS') {
	      $rootScope.$broadcast('interpreterSettings', data);
	    } else if (op === 'PARAGRAPH_ADDED') {
	      $rootScope.$broadcast('addParagraph', data.paragraph, data.index);
	    } else if (op === 'PARAGRAPH_REMOVED') {
	      $rootScope.$broadcast('removeParagraph', data.id);
	    } else if (op === 'PARAGRAPH_MOVED') {
	      $rootScope.$broadcast('moveParagraph', data.id, data.index);
	    } else if (op === 'NOTE_UPDATED') {
	      $rootScope.$broadcast('updateNote', data.name, data.config, data.info);
	    } else if (op === 'SET_NOTE_REVISION') {
	      $rootScope.$broadcast('setNoteRevisionResult', data);
	    } else if (op === 'PARAS_INFO') {
	      $rootScope.$broadcast('updateParaInfos', data);
	    } else if (op === 'NOTICE') {
	      ngToast.info(data.notice);
	    } else if (op === 'REPO_SYNC_SUCCESS') {
	      $rootScope.$broadcast('repoSyncSuccess', data);
	    } else if (op === 'REPO_SYNC_ERROR') {
	      $rootScope.$broadcast('repoSyncError', data);
	    } else {
	      console.error('unknown websocket op: ' + op);
	    }
	  });
	
	  websocketCalls.ws.onError(function (event) {
	    console.log('error message: ', event);
	    $rootScope.$broadcast('setConnectedStatus', false);
	  });
	
	  websocketCalls.ws.onClose(function (event) {
	    console.log('close message: ', event);
	    if (pingIntervalId !== undefined) {
	      clearInterval(pingIntervalId);
	      pingIntervalId = undefined;
	    }
	    $rootScope.$broadcast('setConnectedStatus', false);
	  });
	
	  return websocketCalls;
	}

/***/ }),
/* 255 */
/***/ (function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	NoteListFactory.$inject = ["arrayOrderingSrv", "TRASH_FOLDER_ID"];
	angular.module('zeppelinWebApp').factory('noteListFactory', NoteListFactory);
	
	function NoteListFactory(arrayOrderingSrv, TRASH_FOLDER_ID) {
	  'ngInject';
	
	  var notes = {
	    root: { children: [] },
	    flatList: [],
	    flatFolderMap: {},
	
	    setNotes: function setNotes(notesList) {
	      // a flat list to boost searching
	      notes.flatList = _.map(notesList, function (note) {
	        note.isTrash = note.name ? note.name.split('/')[0] === TRASH_FOLDER_ID : false;
	        return note;
	      });
	
	      // construct the folder-based tree
	      notes.root = { children: [] };
	      notes.flatFolderMap = {};
	      _.reduce(notesList, function (root, note) {
	        var noteName = note.name || note.id;
	        var nodes = noteName.match(/([^\/][^\/]*)/g);
	
	        // recursively add nodes
	        addNode(root, nodes, note.id);
	
	        return root;
	      }, notes.root);
	      notes.root.children.sort(arrayOrderingSrv.noteComparator);
	    }
	  };
	
	  var addNode = function addNode(curDir, nodes, noteId) {
	    if (nodes.length === 1) {
	      // the leaf
	      curDir.children.push({
	        name: nodes[0],
	        id: noteId,
	        path: curDir.id ? curDir.id + '/' + nodes[0] : nodes[0],
	        isTrash: curDir.id ? curDir.id.split('/')[0] === TRASH_FOLDER_ID : false
	      });
	    } else {
	      // a folder node
	      var node = nodes.shift();
	      var dir = _.find(curDir.children, function (c) {
	        return c.name === node && c.children !== undefined;
	      });
	      if (dir !== undefined) {
	        // found an existing dir
	        addNode(dir, nodes, noteId);
	      } else {
	        var newDir = {
	          id: curDir.id ? curDir.id + '/' + node : node,
	          name: node,
	          hidden: true,
	          children: [],
	          isTrash: curDir.id ? curDir.id.split('/')[0] === TRASH_FOLDER_ID : false
	        };
	
	        // add the folder to flat folder map
	        notes.flatFolderMap[newDir.id] = newDir;
	
	        curDir.children.push(newDir);
	        addNode(newDir, nodes, noteId);
	      }
	    }
	  };
	
	  return notes;
	}

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').service('baseUrlSrv', BaseUrlService);
	
	function BaseUrlService() {
	  this.getPort = function () {
	    var port = Number(location.port);
	    if (!port) {
	      port = 80;
	      if (location.protocol === 'https:') {
	        port = 443;
	      }
	    }
	    // Exception for when running locally via grunt
	    if (port === (9000)) {
	      port = (8080);
	    }
	    return port;
	  };
	
	  this.getWebsocketUrl = function () {
	    var wsProtocol = location.protocol === 'https:' ? 'wss:' : 'ws:';
	    return wsProtocol + '//' + location.hostname + ':' + this.getPort() + skipTrailingSlash(location.pathname) + '/ws';
	  };
	
	  this.getBase = function () {
	    return location.protocol + '//' + location.hostname + ':' + this.getPort() + location.pathname;
	  };
	
	  this.getRestApiBase = function () {
	    return skipTrailingSlash(this.getBase()) + '/api';
	  };
	
	  var skipTrailingSlash = function skipTrailingSlash(path) {
	    return path.replace(/\/$/, '');
	  };
	}

/***/ }),
/* 257 */
/***/ (function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').service('loaderSrv', LoaderService);
	
	function LoaderService() {
	  'ngInject';
	
	  this.showLoader = function () {
	    angular.element('#pre-loader').fadeIn();
	  };
	
	  this.hideLoader = function () {
	    angular.element('#pre-loader').fadeOut();
	  };
	}

/***/ }),
/* 258 */
/***/ (function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	LoginCtrl.$inject = ["$scope", "$rootScope", "$http", "$httpParamSerializer", "baseUrlSrv", "$location", "$timeout"];
	angular.module('zeppelinWebApp').controller('LoginCtrl', LoginCtrl);
	
	function LoginCtrl($scope, $rootScope, $http, $httpParamSerializer, baseUrlSrv, $location, $timeout) {
	  'ngInject';
	
	  $scope.loginParadigm = 'sso';
	  $scope.showParadigmSwitch = false;
	  $scope.SigningIn = false;
	  $scope.loginParams = {
	    userName: localStorage.getItem('magpie-username') === null ? '' : localStorage.getItem('magpie-username'),
	    password: ''
	  };
	  $scope.passwordResetSuccessText = '';
	
	  $scope.login = function () {
	    localStorage.setItem('magpie-username', $scope.loginParams.userName);
	    if ($scope.loginParadigm === 'password') {
	      $scope.loginPassword();
	    } else {
	      $scope.loginSSO();
	    }
	  };
	
	  $scope.loginPassword = function () {
	    $scope.SigningIn = true;
	    $http({
	      method: 'POST',
	      url: baseUrlSrv.getRestApiBase() + '/login',
	      headers: {
	        'Content-Type': 'application/x-www-form-urlencoded'
	      },
	      data: $httpParamSerializer({
	        'userName': $scope.loginParams.userName,
	        'password': $scope.loginParams.password
	      })
	    }).then(function successCallback(response) {
	      $scope.passwordResetSuccessText = '';
	      $rootScope.ticket = response.data.body;
	      angular.element('#loginModal').modal('toggle');
	      $rootScope.$broadcast('loginSuccess', true);
	      $rootScope.userName = $scope.loginParams.userName;
	      $scope.SigningIn = false;
	
	      // redirect to the page from where the user originally was
	      if ($location.search() && $location.search()['ref']) {
	        $timeout(function () {
	          var redirectLocation = $location.search()['ref'];
	          $location.$$search = {};
	          $location.path(redirectLocation);
	        }, 100);
	      } else {
	        // redirect to home page
	        $location.path('/');
	      }
	    }, function errorCallback(errorResponse) {
	      $scope.passwordResetSuccessText = '';
	      $scope.loginParams.errorText = 'The username and password that you entered don\'t match.';
	      $scope.SigningIn = false;
	    });
	  };
	
	  $scope.openPasswordReset = function () {
	    angular.element('#loginModal').modal('toggle');
	    angular.element('#sendPasswordResetModal').modal('toggle');
	  };
	
	  var initValues = function initValues() {
	    $scope.loginParams = {
	      userName: localStorage.getItem('magpie-username') === null ? '' : localStorage.getItem('magpie-username'),
	      password: ''
	    };
	  };
	
	  // handle session logout message received from WebSocket
	  $rootScope.$on('session_logout', function (event, data) {
	    if ($rootScope.userName !== '') {
	      $rootScope.userName = '';
	      $rootScope.ticket = undefined;
	
	      setTimeout(function () {
	        $scope.loginParams = {
	          userName: localStorage.getItem('magpie-username') === null ? '' : localStorage.getItem('magpie-username'),
	          password: ''
	        };
	        $scope.loginParams.errorText = data.info;
	        angular.element('.nav-login-btn').click();
	      }, 1000);
	      var locationPath = $location.path();
	      $location.path('/').search('ref', locationPath);
	    }
	  });
	
	  $rootScope.$on('passwordResetSuccess', function () {
	    $scope.passwordResetSuccessText = 'Password successfully updated.';
	  });
	
	  $rootScope.$on('magpieConfig', function () {
	    var paradigm = $rootScope.magpieConfig.zeppelin.loginParadigm;
	    if (paradigm === 'both') {
	      $scope.showParadigmSwitch = true;
	      $scope.loginParadigm = 'sso'; // this will be the initial choice showing
	    } else if (paradigm === 'sso') {
	      $scope.loginParadigm = 'sso';
	      $scope.showParadigmSwitch = false;
	    } else {
	      $scope.loginParadigm = 'password';
	      $scope.showParadigmSwitch = false;
	    }
	  });
	  /*
	   ** $scope.$on functions below
	   */
	  $scope.$on('initLoginValues', function () {
	    initValues();
	  });
	
	  $scope.loginSSO = function () {
	    var ref = $location.$$absUrl;
	    if ($location.$$url !== '/') {
	      ref = ref.replace($location.$$url, '');
	    }
	
	    var domain = $scope.loginParams.userName.split('@')[1];
	    if ($location.search() && $location.search()['ref']) {
	      ref += $location.search()['ref'];
	    }
	
	    var url = baseUrlSrv.getRestApiBase() + '/login/sso?domain=' + domain + '&email=' + $scope.loginParams.userName + '&useHttps=' + $rootScope.magpieConfig.zeppelin.https + '&ref=' + encodeURIComponent(ref);
	
	    window.location.href = url;
	  };
	
	  $scope.changeParadigm = function (p) {
	    $scope.loginParadigm = p;
	  };
	}

/***/ }),
/* 259 */
/***/ (function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	SendPasswordResetCtrl.$inject = ["$scope", "$rootScope", "$http", "$httpParamSerializer", "baseUrlSrv", "$location", "$timeout"];
	angular.module('zeppelinWebApp').controller('SendPasswordResetCtrl', SendPasswordResetCtrl);
	
	function SendPasswordResetCtrl($scope, $rootScope, $http, $httpParamSerializer, baseUrlSrv, $location, $timeout) {
	  'ngInject';
	
	  $scope.sendingEmail = false;
	  $scope.passwordResetSent = false;
	  $scope.passwordResetParams = {};
	  $scope.sendPasswordReset = function () {
	    $scope.sendingEmail = true;
	    $scope.passwordResetParams.successText = '';
	    $scope.passwordResetParams.errorText = '';
	    $http({
	      method: 'POST',
	      url: baseUrlSrv.getRestApiBase() + '/magpie/password-reset',
	      headers: {
	        'Content-Type': 'application/json'
	      },
	      data: JSON.stringify({
	        'username': $scope.passwordResetParams.userName
	      })
	    }).then(function successCallback(response) {
	      $scope.passwordResetParams.successText = 'If an active user exists with that email, ' + 'we have sent a password reset link';
	      $scope.sendingEmail = false;
	      $scope.passwordResetSent = true;
	    }, function errorCallback(errorResponse) {
	      $scope.passwordResetParams.errorText = errorResponse.data.message;
	      $scope.sendingEmail = false;
	      $scope.passwordResetSent = false;
	    });
	  };
	
	  /*
	   ** $scope.$on functions below
	   */
	  $scope.$on('initPasswordResetValues', function () {
	    $scope.passwordResetParams = {
	      userName: '',
	      errorText: '',
	      successText: ''
	    };
	    $scope.passwordResetSent = false;
	  });
	}

/***/ }),
/* 260 */
/***/ (function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	noteActionService.$inject = ["websocketMsgSrv", "$location", "noteRenameService", "noteListFactory"];
	angular.module('zeppelinWebApp').service('noteActionService', noteActionService);
	
	function noteActionService(websocketMsgSrv, $location, noteRenameService, noteListFactory) {
	  'ngInject';
	
	  var self = this; // eslint-disable-line no-invalid-this
	
	  self.moveNoteToTrash = function (noteId, redirectToHome) {
	    BootstrapDialog.confirm({
	      closable: true,
	      title: 'Move this note to trash?',
	      message: 'This note will be moved to <strong>trash</strong>.',
	      callback: function callback(result) {
	        if (result) {
	          websocketMsgSrv.moveNoteToTrash(noteId);
	          if (redirectToHome) {
	            $location.path('/');
	          }
	        }
	      }
	    });
	  };
	
	  self.moveFolderToTrash = function (folderId) {
	    BootstrapDialog.confirm({
	      closable: true,
	      title: 'Move this folder to trash?',
	      message: 'This folder will be moved to <strong>trash</strong>.',
	      callback: function callback(result) {
	        if (result) {
	          websocketMsgSrv.moveFolderToTrash(folderId);
	        }
	      }
	    });
	  };
	
	  self.removeNote = function (noteId, redirectToHome) {
	    BootstrapDialog.confirm({
	      type: BootstrapDialog.TYPE_WARNING,
	      closable: true,
	      title: 'WARNING! This note will be removed permanently',
	      message: 'This cannot be undone. Are you sure?',
	      callback: function callback(result) {
	        if (result) {
	          websocketMsgSrv.deleteNote(noteId);
	          if (redirectToHome) {
	            $location.path('/');
	          }
	        }
	      }
	    });
	  };
	
	  self.removeFolder = function (folderId) {
	    BootstrapDialog.confirm({
	      type: BootstrapDialog.TYPE_WARNING,
	      closable: true,
	      title: 'WARNING! This folder will be removed permanently',
	      message: 'This cannot be undone. Are you sure?',
	      callback: function callback(result) {
	        if (result) {
	          websocketMsgSrv.removeFolder(folderId);
	        }
	      }
	    });
	  };
	
	  self.restoreAll = function () {
	    BootstrapDialog.confirm({
	      closable: true,
	      title: 'Are you sure want to restore all notes in the trash?',
	      message: 'Folders and notes in the trash will be ' + '<strong>merged</strong> into their original position.',
	      callback: function callback(result) {
	        if (result) {
	          websocketMsgSrv.restoreAll();
	        }
	      }
	    });
	  };
	
	  self.emptyTrash = function () {
	    BootstrapDialog.confirm({
	      type: BootstrapDialog.TYPE_WARNING,
	      closable: true,
	      title: 'WARNING! Notes under trash will be removed permanently',
	      message: 'This cannot be undone. Are you sure?',
	      callback: function callback(result) {
	        if (result) {
	          websocketMsgSrv.emptyTrash();
	        }
	      }
	    });
	  };
	
	  self.clearAllParagraphOutput = function (noteId) {
	    BootstrapDialog.confirm({
	      closable: true,
	      title: '',
	      message: 'Do you want to clear all output?',
	      callback: function callback(result) {
	        if (result) {
	          websocketMsgSrv.clearAllParagraphOutput(noteId);
	        }
	      }
	    });
	  };
	
	  self.renameNote = function (noteId, notePath) {
	    noteRenameService.openRenameModal({
	      title: 'Rename note',
	      oldName: notePath,
	      callback: function callback(newName) {
	        websocketMsgSrv.renameNote(noteId, newName);
	      }
	    });
	  };
	
	  self.renameFolder = function (folderId) {
	    noteRenameService.openRenameModal({
	      title: 'Rename folder',
	      oldName: folderId,
	      callback: function callback(newName) {
	        var newFolderId = normalizeFolderId(newName);
	        if (_.has(noteListFactory.flatFolderMap, newFolderId)) {
	          BootstrapDialog.confirm({
	            type: BootstrapDialog.TYPE_WARNING,
	            closable: true,
	            title: 'WARNING! The folder will be MERGED',
	            message: 'The folder will be merged into <strong>' + _.escape(newFolderId) + '</strong>. Are you sure?',
	            callback: function callback(result) {
	              if (result) {
	                websocketMsgSrv.renameFolder(folderId, newFolderId);
	              }
	            }
	          });
	        } else {
	          websocketMsgSrv.renameFolder(folderId, newFolderId);
	        }
	      }
	    });
	  };
	
	  function normalizeFolderId(folderId) {
	    folderId = folderId.trim();
	
	    while (folderId.indexOf('\\') > -1) {
	      folderId = folderId.replace('\\', '/');
	    }
	
	    while (folderId.indexOf('///') > -1) {
	      folderId = folderId.replace('///', '/');
	    }
	
	    folderId = folderId.replace('//', '/');
	
	    if (folderId === '/') {
	      return '/';
	    }
	
	    if (folderId[0] === '/') {
	      folderId = folderId.substring(1);
	    }
	
	    if (folderId.slice(-1) === '/') {
	      folderId = folderId.slice(0, -1);
	    }
	
	    return folderId;
	  }
	}

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	NoteRenameController.$inject = ["$scope"];
	__webpack_require__(262);
	
	angular.module('zeppelinWebApp').controller('NoteRenameCtrl', NoteRenameController); /*
	                                                                                      * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                      * you may not use this file except in compliance with the License.
	                                                                                      * You may obtain a copy of the License at
	                                                                                      *
	                                                                                      *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                      *
	                                                                                      * Unless required by applicable law or agreed to in writing, software
	                                                                                      * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                      * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                      * See the License for the specific language governing permissions and
	                                                                                      * limitations under the License.
	                                                                                      */
	
	function NoteRenameController($scope) {
	  'ngInject';
	
	  var self = this;
	
	  $scope.params = { newName: '' };
	  $scope.isValid = true;
	
	  $scope.rename = function () {
	    angular.element('#noteRenameModal').modal('hide');
	    self.callback($scope.params.newName);
	  };
	
	  $scope.$on('openRenameModal', function (event, options) {
	    self.validator = options.validator || defaultValidator;
	    self.callback = options.callback || function () {};
	
	    $scope.title = options.title || 'Rename';
	    $scope.params.newName = options.oldName || '';
	    $scope.validate = function () {
	      $scope.isValid = self.validator($scope.params.newName);
	    };
	
	    angular.element('#noteRenameModal').modal('show');
	  });
	
	  function defaultValidator(str) {
	    return !!str.trim();
	  }
	}

/***/ }),
/* 262 */
1,
/* 263 */,
/* 264 */
/***/ (function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	NoteRenameService.$inject = ["$rootScope"];
	angular.module('zeppelinWebApp').service('noteRenameService', NoteRenameService);
	
	function NoteRenameService($rootScope) {
	  'ngInject';
	
	  var self = this;
	
	  /**
	   * <options schema>
	   * title: string - Modal title
	   * oldName: string - name to initialize input
	   * callback: (newName: string)=>void - callback onButtonClick
	   * validator: (str: string)=>boolean - input validator
	   */
	  self.openRenameModal = function (options) {
	    $rootScope.$broadcast('openRenameModal', options);
	  };
	}

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(266);
	
	__webpack_require__(267);
	
	__webpack_require__(268);
	
	__webpack_require__(269);
	
	__webpack_require__(270);
	
	__webpack_require__(271);
	
	__webpack_require__(272);
	
	__webpack_require__(273);
	
	__webpack_require__(274);
	
	__webpack_require__(275);
	
	__webpack_require__(276);
	
	__webpack_require__(277);
	
	/**
	 * Created by dkotsiko on 11/6/16.
	 */
	
	angular.module('magpieDisplay', ['ngRoute', 'ngAnimate', 'ngTouch', 'magpieUtil', 'magpieStructure', 'magpieFlow', 'magpieSecurity', 'magpieProfiling', 'magpieLineage', 'magpieInference', 'magpieResults', 'magpieClusters', 'magpieValidation', 'magpieExportedDataSourceFile', 'magpieFileUpload']).directive('magpieInfo', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      info: '='
	    },
	    templateUrl: 'components/magpie-display/info.html'
	  };
	}).directive('magpieHelp', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      message: '='
	    },
	    templateUrl: 'components/magpie-display/help.html'
	  };
	});

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _moment = __webpack_require__(18);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _magpieColors = __webpack_require__(175);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ANIMATION_DURATION = 1200;
	
	function getChartSelector(element) {
	  return '#' + element.find('.chart').attr('id') + ' > svg';
	}
	
	function registerResizeListener($scope, $window, update) {
	  angular.element($window).on('resize', update);
	  $scope.$on('$destroy', function () {
	    angular.element($window).off('resize', update);
	  });
	}
	
	function calcMinMax(data) {
	  return _.reduce(data, function (result, v) {
	    return {
	      min: Math.min(result.min, v),
	      max: Math.max(result.max, v)
	    };
	  }, {
	    min: Number.POSITIVE_INFINITY,
	    max: Number.NEGATIVE_INFINITY
	  });
	}
	
	var historicalBarChartMargin = {
	  top: 10,
	  right: 10,
	  bottom: 50,
	  left: 70
	};
	
	angular.module('magpieUtil', []).filter('prettyJSON', function () {
	  return function prettyPrintJson(json) {
	    if (_.isString(json)) {
	      try {
	        json = JSON.parse(json);
	      } catch (e) {
	        // ignore it, must not be a json string
	      }
	    }
	    return JSON.stringify(angular.copy(json), null, '  ');
	  };
	}).filter('nonEmpty', ['$filter', function ($filter) {
	  return function nonEmpty(obj) {
	    return _.size(obj) > 0;
	  };
	}]).filter('unspaceCurlyBraces', ['$filter', function ($filter) {
	  return function unspaceCurlyBraces(str) {
	    return str.replace('}    }', '}}');
	  };
	}]).filter('score', ['$filter', function ($filter) {
	  return function printScore(v) {
	    return $filter('number')(v * 100, 0);
	  };
	}]).filter('percent', ['$filter', function ($filter) {
	  return function printPercent(v) {
	    return $filter('score')(v) + '%';
	  };
	}]).filter('timestamp', ['$filter', function ($filter) {
	  return function printTimestamp(timestamp) {
	    return $filter('date')(timestamp, 'yyyy-MM-dd HH:mm:ss Z');
	  };
	}]).filter('utcTimestamp', function () {
	  return function printUtcTimestamp(timestamp) {
	    if (timestamp) {
	      return _moment2.default.utc(timestamp).format('YYYY-MM-DD HH:mm:ss');
	    } else {
	      return timestamp;
	    }
	  };
	}).filter('elapsedTime', function () {
	  return function (action) {
	    if (action) {
	      var start = (0, _moment2.default)(action.startTime || action.timestamp);
	      var end = (0, _moment2.default)(action.endTime || action.timestamp);
	      return end.diff(start) / 1000.0;
	    }
	  };
	}).filter('prettyDuration', function () {
	  return function (time) {
	    var includeSeconds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (time !== undefined) {
	      var twoDigits = new Intl.NumberFormat('en-US', { minimumIntegerDigits: 2 });
	      var threeDigits = new Intl.NumberFormat('en-US', { minimumIntegerDigits: 3 });
	
	      var duration = _moment2.default.duration(time, 'seconds');
	
	      var dayPart = Math.floor(duration.asDays()) ? Math.floor(duration.asDays()) + 'd ' : '';
	      var hourPart = twoDigits.format(duration.hours()) + 'h ';
	      var minPart = twoDigits.format(duration.minutes()) + 'm ';
	      var secPart = includeSeconds ? twoDigits.format(duration.seconds()) + '.' + threeDigits.format(duration.milliseconds()) + 's' : '';
	
	      return dayPart + hourPart + minPart + secPart;
	    }
	  };
	}).filter('msToDuration', function () {
	  return function (millis) {
	    var milliseconds = millis % 1000;
	    var seconds = Math.floor(millis / 1000);
	    var minute = Math.floor(seconds / 60);
	    seconds = seconds % 60;
	    var hour = Math.floor(minute / 60);
	    minute = minute % 60;
	    var day = Math.floor(hour / 24);
	    hour = hour % 24;
	
	    var timeoutText = '';
	    if (day > 0) {
	      timeoutText = timeoutText + day + ' days ';
	    }if (hour > 0) {
	      timeoutText = timeoutText + hour + ' hours ';
	    }if (minute > 0) {
	      timeoutText = timeoutText + minute + ' minutes ';
	    }if (seconds > 0) {
	      timeoutText = timeoutText + seconds + ' seconds ';
	    }if (milliseconds > 0) {
	      timeoutText = timeoutText + milliseconds + ' milliseconds ';
	    }
	    return timeoutText;
	  };
	}).filter('bytesToGibibytes', function () {
	  return function (bytes) {
	    return bytes / (1024 * 1024 * 1024);
	  };
	}).filter('withUnit', function () {
	  return function (value, unit) {
	    return value + ' ' + unit;
	  };
	}).filter('prettyInlineList', function () {
	  return function (values) {
	    return values.join(', ');
	  };
	}).filter('itemGetter', function () {
	  return function (values, key) {
	    return values.map(function (v) {
	      return v[key];
	    });
	  };
	}).directive('magpieActionState', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      state: '='
	    },
	    templateUrl: 'components/magpie-display/util/action-state.html',
	    controller: ["$scope", function controller($scope) {
	      function getType(state) {
	        switch (state) {
	          case 'Succeeded':
	          case 'Running':
	          case 'Finished':
	            return 'success';
	          case 'Failed':
	            return 'danger';
	          case 'Preparing':
	          case 'InProgress':
	          case 'Provisioning':
	          case 'Bootstrapping':
	          case 'Stopping':
	            return 'info';
	          default:
	            return 'default';
	        }
	      }
	
	      $scope.label = _.startCase($scope.state);
	      $scope.type = getType($scope.state);
	    }]
	  };
	}).directive('magpieHealthState', ['$filter', function ($filter) {
	  return {
	    restrict: 'E',
	    scope: {
	      state: '='
	    },
	    templateUrl: 'components/magpie-display/util/health-state.html',
	    controller: ["$scope", function controller($scope) {
	      function getType(state) {
	        switch (state) {
	          case 'Healthy':
	            return 'success';
	          case 'Unhealthy':
	            return 'danger';
	          case 'Degraded':
	            return 'warning';
	          default:
	            return 'default';
	        }
	      }
	
	      $scope.label = _.startCase($scope.state.state);
	      $scope.type = getType($scope.state.state);
	      var lastChanged = $filter('timestamp')($scope.state.lastChanged);
	      $scope.tooltip = 'Since ' + lastChanged;
	    }]
	  };
	}]).filter('exceptionDetails', function () {
	  return function renderExceptionDetails(details) {
	    if (details.stackTrace) {
	      return details.stackTrace;
	    } else if (details.message) {
	      return details.exceptionType + ': ' + details.message;
	    } else {
	      return details.exceptionType;
	    }
	  };
	}).directive('magpieGaugeChart', ['$timeout', '$window', function ($timeout, $window) {
	  return {
	    restrict: 'E',
	    scope: {
	      value: '=',
	      total: '=',
	      title: '=',
	      id: '=',
	      type: '='
	    },
	    templateUrl: 'components/magpie-display/util/gauge-chart-template.html',
	    compile: function compile() {
	      return function linkFunction($scope, element) {
	        var chart = nv.models.pieChart().x(function (d) {
	          return d.label;
	        }).y(function (d) {
	          return d.value;
	        })
	        // we want this to be a half donut
	        .startAngle(function (d) {
	          return d.startAngle / 2.0 - Math.PI / 2.0;
	        }).endAngle(function (d) {
	          return d.endAngle / 2.0 - Math.PI / 2.0;
	        }).donut(true).donutRatio(0.35).showLegend(false).showLabels(false).margin({
	          top: 0,
	          right: 10,
	          bottom: -70,
	          left: 10
	        }).title($scope.title + ' Values').titleOffset(15).showTooltipPercent(true).color((0, _magpieColors.getMagpieDonutChartColors)());
	
	        $timeout(function () {
	          var selector = getChartSelector(element);
	
	          // build the chart
	          d3.select(selector).datum([{
	            label: $scope.title,
	            value: $scope.value
	          }, {
	            label: 'Not ' + $scope.title,
	            value: $scope.total - $scope.value
	          }]).transition().duration(ANIMATION_DURATION).call(chart);
	
	          var svg = angular.element(selector);
	
	          function update() {
	            chart.update();
	
	            // set the text elements to black
	            svg.find('text').css({
	              'font-size': '14px',
	              'fill': 'black'
	            });
	          }
	
	          update();
	          registerResizeListener($scope, $window, update);
	        });
	      };
	    }
	  };
	}]).directive('magpiePieChart', ['$timeout', '$window', function ($timeout, $window) {
	  return {
	    restrict: 'E',
	    scope: {
	      id: '=',
	      type: '=',
	      chartData: '=',
	      title: '=',
	      width: '=',
	      height: '='
	    },
	    templateUrl: 'components/magpie-display/util/pie-chart-template.html',
	    compile: function compile() {
	      return function linkFunction($scope, element) {
	        var chart = nv.models.pieChart().x(function (d) {
	          return d.label;
	        }).y(function (d) {
	          return d.value;
	        }).donut(true).donutRatio(0.4).showLegend(false).showLabels(false).title($scope.title).showTooltipPercent(true).color((0, _magpieColors.getMagpieChartColors)());
	
	        $timeout(function () {
	          var selector = getChartSelector(element);
	
	          // build the chart
	          d3.select(selector).datum($scope.chartData).transition().duration(ANIMATION_DURATION).call(chart);
	
	          // set the text elements to black
	          angular.element(selector).find('text').css({
	            'fill': 'black'
	          });
	
	          registerResizeListener($scope, $window, chart.update);
	        });
	      };
	    }
	  };
	}]).directive('magpieHistogram', ['$timeout', '$window', '$filter', function ($timeout, $window, $filter) {
	  return {
	    restrict: 'E',
	    scope: {
	      id: '=',
	      histogram: '='
	    },
	    templateUrl: 'components/magpie-display/util/histogram-template.html',
	    compile: function compile() {
	      return function linkFunction($scope, element) {
	        var chart = nv.models.historicalBarChart().margin(historicalBarChartMargin).useInteractiveGuideline(true).color((0, _magpieColors.getMagpieChartColors)());
	
	        var xTickFormat = d3.format(',');
	
	        chart.xAxis.showMaxMin(false).tickFormat(xTickFormat);
	
	        chart.yAxis.showMaxMin(false).tickFormat(d3.format(',.0f'));
	
	        $timeout(function () {
	          var selector = getChartSelector(element);
	
	          var counts = $scope.histogram.counts;
	          var bins = $scope.histogram.bins;
	
	          var values = _.map(counts, function (count, i) {
	            var x0 = bins[i];
	            var x1 = bins[i + 1];
	            return {
	              x0: x0,
	              x1: x1,
	              x: (x1 + x0) / 2,
	              y: count
	            };
	          });
	
	          var valuesByX = _.indexBy(values, function (v) {
	            return xTickFormat(v.x);
	          });
	
	          var data = [{
	            values: values
	          }];
	
	          var minMax = calcMinMax(bins);
	
	          chart.forceX([minMax.min, minMax.max]).interactiveLayer.tooltip.headerFormatter(function (d) {
	            var format = $filter('number');
	            var v = valuesByX[d];
	            return format(v.x0) + ' - ' + format(v.x1);
	          });
	
	          d3.select(selector).datum(data).transition().duration(ANIMATION_DURATION).call(chart);
	
	          registerResizeListener($scope, $window, chart.update);
	        });
	      };
	    }
	  };
	}]).directive('magpieBarChart', ['$timeout', '$window', function ($timeout, $window) {
	  return {
	    restrict: 'E',
	    scope: {
	      id: '=',
	      type: '=',
	      chartData: '=',
	      title: '=',
	      min: '=?',
	      max: '=?',
	      xAxisFormatter: '=?',
	      headerFormatter: '=?'
	    },
	    templateUrl: 'components/magpie-display/util/bar-chart-template.html',
	    compile: function compile() {
	      return function linkFunction($scope, element) {
	        var chart = nv.models.historicalBarChart().margin(historicalBarChartMargin).useInteractiveGuideline(true);
	
	        chart.xAxis.showMaxMin(false);
	
	        chart.yAxis.showMaxMin(false).tickFormat(d3.format(',.0f'));
	
	        chart.color((0, _magpieColors.getMagpieChartColors)());
	
	        $timeout(function () {
	          var selector = getChartSelector(element);
	
	          var minMax = void 0;
	          if (_.isUndefined($scope.min) || _.isUndefined($scope.max)) {
	            minMax = calcMinMax(_.map($scope.chartData, 'value'));
	          } else {
	            minMax = $scope;
	          }
	          var min = minMax.min;
	          var max = minMax.max;
	
	          var ticks = Math.min(max - min + 1, 6);
	
	          var countsByValue = _.mapValues(_.indexBy($scope.chartData, 'value'), 'count');
	
	          var values = [];
	          for (var x = min; x <= max; x++) {
	            var count = countsByValue[x];
	            values.push({
	              x: x,
	              y: count || 0
	            });
	          }
	
	          var data = [{
	            values: values
	          }];
	
	          chart.forceX([min - 0.5, max + 0.5]).xAxis.ticks(ticks);
	
	          if (!_.isUndefined($scope.xAxisFormatter)) {
	            chart.xAxis.tickFormat($scope.xAxisFormatter);
	          }
	
	          if (!_.isUndefined($scope.headerFormatter)) {
	            chart.interactiveLayer.tooltip.headerFormatter($scope.headerFormatter);
	          }
	
	          d3.select(selector).datum(data).transition().duration(ANIMATION_DURATION).call(chart);
	
	          registerResizeListener($scope, $window, chart.update);
	        });
	      };
	    }
	  };
	}]).directive('magpieDiscreteBarChart', ['$timeout', '$window', function ($timeout, $window) {
	  return {
	    restrict: 'E',
	    scope: {
	      id: '=',
	      type: '=',
	      chartData: '=',
	      title: '=?'
	    },
	    templateUrl: 'components/magpie-display/util/bar-chart-template.html',
	    compile: function compile() {
	      return function linkFunction($scope, element) {
	        var valueFormat = d3.format(',.0f');
	
	        // make minimum left margin 40
	        var maxValue = 10000;
	        for (var i = 0; i < $scope.chartData.length; i++) {
	          if (maxValue < $scope.chartData[i].value) {
	            maxValue = $scope.chartData[i].value;
	          }
	        }
	        // set leftMargin based on number of digits in the max value shown
	        var leftMargin = maxValue.toString().length * 8;
	
	        var chart = nv.models.discreteBarChart().margin({
	          top: 10,
	          right: 10,
	          bottom: 50,
	          left: leftMargin
	        }).x(function (d) {
	          return d.label;
	        }).y(function (d) {
	          return d.value;
	        }).showValues(true).showXAxis(false).valueFormat(valueFormat);
	
	        chart.yAxis.showMaxMin(false).tickFormat(valueFormat);
	
	        chart.color((0, _magpieColors.getMagpieChartColors)());
	
	        $timeout(function () {
	          var selector = getChartSelector(element);
	
	          var data = [{
	            values: $scope.chartData
	          }];
	
	          var total = _($scope.chartData).map('value').sum();
	
	          chart.tooltip.valueFormatter(function (d) {
	            var value = valueFormat(d);
	            var percent = valueFormat(d * 100.0 / total);
	            return '<span class="tooltip-value">' + value + ' </span>&nbsp;' + '<span class="tooltip-percent">(' + percent + '%)</span>';
	          });
	
	          d3.select(selector).datum(data).transition().duration(ANIMATION_DURATION).call(chart);
	
	          registerResizeListener($scope, $window, chart.update);
	        });
	      };
	    }
	  };
	}]).directive('magpieError', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      exception: '=',
	      level: '@'
	    },
	    templateUrl: 'components/magpie-display/util/magpie-error.html',
	    controller: ["$scope", function controller($scope) {
	      $scope.isCollapsed = true;
	    }]
	  };
	}).directive('magpieProportionChart', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      passValue: '=',
	      nullValue: '=',
	      failValue: '='
	    },
	    templateUrl: 'components/magpie-display/util/proportion-chart.html'
	  };
	}).controller('MagpieExpandableRowCtrl', ["$scope", "$element", "$timeout", function ($scope, $element, $timeout) {
	  var detailsEl = $element.find('.collapse').collapse();
	  $scope.open = false;
	  $scope.toggleDetails = function () {
	    $scope.open = !$scope.open;
	    $timeout(function () {
	      if ($scope.open) {
	        detailsEl.collapse('show');
	      } else {
	        detailsEl.collapse('hide');
	      }
	    });
	  };
	}]);

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _moment = __webpack_require__(18);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fieldTypeToName(fieldType) {
	  if (_.isString(fieldType)) {
	    return _.capitalize(fieldType);
	  } else if (_.isObject(fieldType)) {
	    switch (fieldType.dataType) {
	      case 'array':
	        return 'Array(' + fieldTypeToName(fieldType.elementType) + ')';
	      default:
	        return _.capitalize(fieldType.dataType);
	    }
	  } else {
	    return undefined;
	  }
	}
	
	angular.module('magpieStructure', ['ui.bootstrap', 'magpieProfiling', 'magpieLineage', 'magpieInference', 'magpieUtil']).directive('magpieTable', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      lineage: '@?',
	      table: '=?',
	      profile: '@?',
	      relationships: '@?',
	      description: '@?',
	      userPermissions: '=?'
	    },
	    templateUrl: 'components/magpie-display/structure/table.html',
	    controller: ["$scope", function controller($scope) {
	      if ($scope.description) {
	        var description = JSON.parse($scope.description);
	
	        $scope.hasLineage = description.lineage && description.lineage.createAction;
	        if ($scope.hasLineage) {
	          $scope.hasLineageGraph = $scope.hasLineage && description.lineage.lineageGraph;
	          if ($scope.hasLineageGraph) {
	            $scope.lineageGraph = JSON.stringify(description.lineage.lineageGraph);
	            delete description.lineage.lineageGraph;
	          }
	        }
	        $scope.lineage = description.lineage;
	        $scope.table = description.table;
	        $scope.relationships = JSON.stringify(description.relationships);
	        $scope.profile = JSON.stringify(description.profile);
	        $scope.userPermissions = description.userPermissions;
	      }
	      $scope.hasRelationships = $scope.relationships && (
	      // we are not an array--parse as JSON then check length
	      _.isString($scope.relationships) && JSON.parse($scope.relationships).length > 0 ||
	      // we are an array--check length directly
	      _.isArray($scope.relationships) && $scope.relationships.length > 0);
	    }]
	  };
	}).directive('magpieTableLineageGraph', ["$timeout", function ($timeout) {
	  return {
	    restrict: 'E',
	    scope: true,
	    templateUrl: 'components/magpie-display/structure/table-lineage-graph.html',
	    compile: function compile() {
	      return function linkFunction($scope, element) {
	        var maxEdges = 100;
	        var DataSet = vis.DataSet; // eslint-disable-line no-undef
	        var Network = vis.Network; // eslint-disable-line no-undef
	
	        $scope.fitted = false;
	        $scope.stabilized = false;
	        $scope.currentNode = {};
	        $scope.queryFlavors = {
	          CLI: 'CLI',
	          Zeppelin: 'notebook',
	          ThriftServer: 'JDBC session'
	        };
	
	        var lineageGraph = JSON.parse($scope.lineageGraph);
	
	        var smooth = void 0;
	        var fixed = void 0;
	        if (lineageGraph.edges.length >= maxEdges) {
	          // too many edges, don't smooth and fix the nodes
	          smooth = false;
	          fixed = true;
	        } else {
	          // manageable number of edges, smooth and don't fix the nodes
	          smooth = {
	            type: 'cubicBezier',
	            forceDirection: 'horizontal',
	            roundness: 0.4
	          };
	          fixed = false;
	        }
	
	        var nodes = lineageGraph.nodes.map(function (obj) {
	          var label = obj.name;
	
	          if (obj.parentObjectName) {
	            label = obj.parentObjectName + '.' + label;
	          }
	
	          // collapsed operations show their execution count on the node itself
	          if (obj.nodeType === 'Operation' && obj.actionCount > 1) {
	            label = label + ' ×' + obj.actionCount;
	          }
	
	          var node = {
	            id: obj.id,
	            label: label,
	            name: obj.name,
	            nodeType: obj.nodeType,
	            createAction: obj.createAction,
	            action: obj.action,
	            operationType: obj.operationType,
	            actionCount: obj.actionCount,
	            firstStartTime: obj.firstStartTime,
	            origin: obj.origin,
	            lastWriteAction: obj.lastWriteAction,
	            objectSubType: obj.objectSubType,
	            parentObjectName: obj.parentObjectName,
	            url: obj.url
	          };
	
	          if (fixed) {
	            node.fixed = {
	              x: true,
	              y: true
	            };
	          }
	
	          if (obj.objectType) {
	            node.nodeType = obj.objectType;
	          }
	
	          if (obj.lineage && obj.lineage.createAction) {
	            node.createAction = obj.lineage.createAction;
	          }
	
	          if (obj.objectSubType) {
	            node.group = obj.objectSubType;
	          } else if (obj.objectType) {
	            node.group = obj.objectType;
	          } else {
	            node.group = obj.nodeType;
	          }
	
	          return node;
	        });
	
	        var nodesById = _.indexBy(nodes, 'id');
	
	        var edges = new DataSet(lineageGraph.edges);
	
	        // create a network
	        var container = element.find('.network')[0];
	
	        var data = {
	          nodes: new DataSet(nodes),
	          edges: edges
	        };
	
	        var options = {
	          edges: {
	            smooth: smooth,
	            arrows: {
	              to: true
	            },
	            color: {
	              color: '#888',
	              opacity: 1.0
	            },
	            arrowStrikethrough: false
	          },
	          nodes: {
	            shape: 'box'
	          },
	          interaction: {
	            dragNodes: true,
	            dragView: true,
	            hideEdgesOnDrag: false,
	            hideNodesOnDrag: false,
	            hover: false,
	            keyboard: {
	              enabled: true,
	              bindToWindow: false
	            },
	            multiselect: false,
	            navigationButtons: true,
	            selectable: true,
	            selectConnectedEdges: false,
	            hoverConnectedEdges: false,
	            zoomView: false
	          },
	          layout: {
	            hierarchical: {
	              enabled: true,
	              sortMethod: 'directed',
	              levelSeparation: 230,
	              direction: 'LR'
	            }
	          },
	          physics: true,
	          autoResize: true,
	          height: '450px',
	          width: '100%',
	          groups: {
	            useDefaultGroups: true,
	            Table: {
	              shape: 'image',
	              image: '/assets/images/structure/table.svg',
	              background: 'white'
	            },
	            Stream: {
	              shape: 'image',
	              image: '/assets/images/structure/stream.svg'
	            },
	            Url: {
	              shape: 'image',
	              image: '/assets/images/structure/globe.svg'
	            },
	            Result: {
	              shape: 'image',
	              image: '/assets/images/structure/code.svg'
	            },
	            Operation: {
	              shape: 'image',
	              image: '/assets/images/structure/operation.svg'
	            },
	            DataSource: {
	              shape: 'image',
	              image: '/assets/images/structure/generic_source.svg'
	            },
	            kafka: {
	              shape: 'image',
	              image: '/assets/images/structure/kafka.svg'
	            },
	            hdfs: {
	              shape: 'image',
	              image: '/assets/images/structure/file_system.svg',
	              background: 'white'
	            },
	            local: {
	              shape: 'image',
	              image: '/assets/images/structure/file_system.svg',
	              background: 'white'
	            },
	            jdbc: {
	              shape: 'image',
	              image: '/assets/images/structure/database.svg'
	            },
	            postgres: {
	              shape: 'image',
	              image: '/assets/images/structure/database.svg'
	            },
	            snowflake: {
	              shape: 'image',
	              image: '/assets/images/structure/big_data_db.svg'
	            },
	            bigquery: {
	              shape: 'image',
	              image: '/assets/images/structure/big_data_db.svg'
	            },
	            redshift: {
	              shape: 'image',
	              image: '/assets/images/structure/big_data_db.svg',
	              background: 'white'
	            }
	          }
	        };
	
	        $timeout(function () {
	          var network = new Network(container, data, options);
	
	          network.on('click', function (args) {
	            $timeout(function () {
	              var id = args.nodes[0];
	              $scope.currentNode = nodesById[id];
	            });
	          });
	
	          network.on('stabilizationIterationsDone', function () {
	            $timeout(function () {
	              $scope.network = network;
	              $scope.stabilized = true;
	              // if we haven't fixed the nodes, turn off physics
	              if (!fixed) {
	                network.setOptions({
	                  physics: false
	                });
	              }
	            });
	          });
	
	          network.on('afterDrawing', function () {
	            if (!$scope.fitted) {
	              network.fit();
	              $scope.fitted = true;
	            }
	          });
	        });
	      };
	    }
	  };
	}]).directive('magpieTableDetails', function () {
	  return {
	    restrict: 'E',
	    scope: true,
	    templateUrl: 'components/magpie-display/structure/table-details.html',
	    controller: ["$scope", function controller($scope) {
	      $scope.getDatabaseExpressionLabel = function (expr) {
	        if (_.isString(expr.tableName)) {
	          return 'Table Name:';
	        } else {
	          return 'Query:';
	        }
	      };
	
	      $scope.getDatabaseExpressionValue = function (expr) {
	        if (_.isString(expr.schemaName)) {
	          return expr.schemaName + '.' + expr.tableName;
	        } else if (_.isString(expr.tableName)) {
	          return expr.tableName;
	        } else {
	          return expr.query;
	        }
	      };
	
	      $scope.getBigQueryExpressionLabel = function (expr) {
	        if (_.isString(expr.tableId)) {
	          return 'Table:';
	        } else {
	          return 'Query:';
	        }
	      };
	
	      $scope.getBigQueryExpressionValue = function (expr) {
	        if (_.isString(expr.tableId)) {
	          return expr.datasetId + '.' + expr.tableId;
	        } else {
	          return expr.query;
	        }
	      };
	
	      $scope.formatOffsets = function (offsets) {
	        if (_.isString(offsets)) {
	          return _.capitalize(offsets);
	        } else {
	          return JSON.stringify(offsets);
	        }
	      };
	
	      $scope.getSubscriptionLabel = function (subscriptionType) {
	        if (subscriptionType === 'TopicPartition') {
	          return 'Partitions';
	        } else {
	          return subscriptionType;
	        }
	      };
	
	      $scope.getSubscriptionValue = function (subscription) {
	        switch (subscription.subscriptionType) {
	          case 'Topic':
	            return subscription.topic;
	          case 'Topics':
	            return subscription.topics.join(', ');
	          case 'Pattern':
	            return subscription.pattern;
	          case 'TopicPartition':
	            return JSON.stringify(subscription.partitions);
	        }
	      };
	    }]
	  };
	}).directive('magpieTableState', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      name: '@',
	      state: '='
	    },
	    templateUrl: 'components/magpie-display/structure/table-state.html'
	  };
	}).directive('magpieTableStateDetails', function () {
	  return {
	    restrict: 'E',
	    scope: true,
	    templateUrl: 'components/magpie-display/structure/table-state-details.html'
	  };
	}).directive('magpieStream', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      lineage: '=?',
	      stream: '=?',
	      state: '=?',
	      sinks: '=?',
	      description: '=?',
	      userPermissions: '=?'
	    },
	    templateUrl: 'components/magpie-display/structure/stream.html',
	    controller: ["$scope", function controller($scope) {
	      if ($scope.description) {
	        $scope.stream = $scope.description.stream;
	        $scope.state = $scope.description.state;
	        $scope.lineage = $scope.description.lineage;
	        $scope.sinks = $scope.description.sinks;
	        $scope.history = $scope.description.history;
	        $scope.userPermissions = $scope.description.userPermissions;
	      }
	    }]
	  };
	}).directive('magpieStreamDetails', function () {
	  return {
	    restrict: 'E',
	    scope: true,
	    templateUrl: 'components/magpie-display/structure/stream-details.html'
	  };
	}).directive('magpieStreamState', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      name: '@',
	      state: '='
	    },
	    templateUrl: 'components/magpie-display/structure/stream-state.html'
	  };
	}).directive('magpieStreamStateDetails', function () {
	  return {
	    restrict: 'E',
	    scope: true,
	    templateUrl: 'components/magpie-display/structure/stream-state-details.html',
	    controller: ["$scope", function controller($scope) {
	      $scope.getState = function (state) {
	        if (state.activeSinks.length > 0) {
	          return 'In Use';
	        } else {
	          return 'Not In Use';
	        }
	      };
	
	      $scope.isResolved = function (sink) {
	        return _.isUndefined(sink.userName);
	      };
	    }]
	  };
	}).directive('magpieField', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      field: '=?',
	      description: '=?'
	    },
	    templateUrl: 'components/magpie-display/structure/field.html',
	    controller: ["$scope", function controller($scope) {
	      if ($scope.description) {
	        $scope.field = $scope.description.field;
	      }
	      $scope.fieldTypeToName = fieldTypeToName;
	    }]
	  };
	}).directive('magpieFields', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      fields: '='
	    },
	    templateUrl: 'components/magpie-display/structure/fields.html',
	    controller: ["$scope", function controller($scope) {
	      _.forEach($scope.fields, function (field) {
	        field.fieldTypeName = fieldTypeToName(field.fieldType);
	      });
	    }]
	  };
	}).directive('magpieFile', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      file: '=?',
	      description: '@?'
	    },
	    templateUrl: 'components/magpie-display/structure/file.html',
	    controller: ["$scope", function controller($scope) {
	      // Helper function to format file size
	      $scope.formatFileSize = function (bytes) {
	        if (bytes === 0 || bytes === undefined) {
	          return '0 Bytes';
	        }
	        var k = 1024;
	        var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
	        var i = Math.floor(Math.log(bytes) / Math.log(k));
	        return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
	      };
	
	      // Handle description attribute (for describe command)
	      if ($scope.description) {
	        var description = JSON.parse($scope.description);
	        $scope.file = description;
	        $scope.isFileMetadata = true;
	      } else {
	        $scope.isFileMetadata = false;
	      }
	
	      // Set flags for file format configuration (backward compatibility)
	      if ($scope.file) {
	        $scope.isDelimited = $scope.file.format === 'DelimitedText';
	        $scope.isJson = $scope.file.format === 'JSON';
	        $scope.hasCompression = !_.isUndefined($scope.file.compression);
	        $scope.displaySpecialChar = function (value) {
	          return JSON.stringify(value).slice(1, -1);
	        };
	
	        // Format file size for display
	        if ($scope.file.sizeBytes !== undefined) {
	          $scope.formattedSize = $scope.formatFileSize($scope.file.sizeBytes);
	        }
	      }
	    }]
	  };
	}).directive('magpieFieldMapping', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      mapping: '='
	    },
	    templateUrl: 'components/magpie-display/structure/field-mapping.html',
	    controller: ["$scope", function controller($scope) {
	      $scope.isDirectMap = _.every($scope.mapping, function (m) {
	        return m.sourceField === m.targetField;
	      });
	    }]
	  };
	}).directive('magpieSink', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      sink: '=?',
	      state: '=?',
	      description: '=?'
	    },
	    templateUrl: 'components/magpie-display/structure/sink.html',
	    controller: ["$scope", function controller($scope) {
	      if ($scope.description) {
	        $scope.sink = $scope.description.sink;
	        $scope.state = $scope.description.state;
	        $scope.history = $scope.description.history;
	      }
	    }]
	  };
	}).directive('magpieSinkDetails', function () {
	  return {
	    restrict: 'E',
	    scope: true,
	    templateUrl: 'components/magpie-display/structure/sink-details.html'
	  };
	}).directive('magpieSinkState', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      name: '@',
	      state: '='
	    },
	    templateUrl: 'components/magpie-display/structure/sink-state.html'
	  };
	}).directive('magpieSinkStateDetails', function () {
	  return {
	    restrict: 'E',
	    scope: true,
	    templateUrl: 'components/magpie-display/structure/sink-state-details.html'
	  };
	}).directive('magpieSinkHistory', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      label: '@',
	      sinkHistory: '=',
	      timestamp: '@?'
	    },
	    templateUrl: 'components/magpie-display/structure/sink-history.html'
	  };
	}).directive('magpieSinkHistoryDetails', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      sinkHistory: '='
	    },
	    templateUrl: 'components/magpie-display/structure/sink-history-details.html'
	  };
	}).directive('magpieSinkRun', function () {
	  return {
	    restrict: 'AE',
	    scope: {
	      sinkRun: '=',
	      timestamp: '='
	    },
	    templateUrl: 'components/magpie-display/structure/sink-run.html',
	    controller: ["$scope", "$element", "$timeout", "$controller", function controller($scope, $element, $timeout, $controller) {
	      angular.extend(this, $controller('MagpieExpandableRowCtrl', {
	        $scope: $scope,
	        $element: $element,
	        $timeout: $timeout
	      }));
	
	      _.defaults($scope.sinkRun, {
	        timestamp: (0, _moment2.default)($scope.timestamp)
	      });
	    }]
	  };
	}).directive('magpieSchema', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      schema: '=?',
	      lineage: '=?',
	      profile: '@?',
	      description: '@?',
	      userPermissions: '=?'
	    },
	    templateUrl: 'components/magpie-display/structure/schema.html',
	    controller: ["$scope", function controller($scope) {
	      if ($scope.description) {
	        var description = JSON.parse($scope.description);
	        $scope.schema = description.schema;
	        $scope.lineage = description.lineage;
	        $scope.tables = description.tables;
	        $scope.streams = description.streams;
	        $scope.profile = JSON.stringify(description.profile);
	        $scope.history = description.history;
	        $scope.userPermissions = description.userPermissions;
	      } else if ($scope.schema) {
	        $scope.tables = $scope.schema.tables;
	      }
	    }]
	  };
	}).directive('magpieHdfsCredentials', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      credentials: '='
	    },
	    templateUrl: 'components/magpie-display/structure/hdfs-credentials.html'
	  };
	}).directive('magpieDataSource', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      dataSource: '=?',
	      lineage: '=?',
	      description: '=?',
	      userPermissions: '=?'
	    },
	    templateUrl: 'components/magpie-display/structure/data-source.html',
	    controller: ["$scope", function controller($scope) {
	      if ($scope.description) {
	        $scope.dataSource = $scope.description.source;
	        $scope.lineage = $scope.description.lineage;
	        $scope.userPermissions = $scope.description.userPermissions;
	      }
	    }]
	  };
	}).directive('magpieRepository', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      repository: '=?',
	      lineage: '=?',
	      description: '=?',
	      userPermissions: '=?'
	    },
	    templateUrl: 'components/magpie-display/structure/repository.html',
	    controller: ["$scope", function controller($scope) {
	      var findName = function findName(objects, id) {
	        if (id) {
	          return _.result(_.find(objects, 'id', id), 'name');
	        }
	      };
	
	      if ($scope.description) {
	        $scope.repository = $scope.description.repository;
	        $scope.dataSources = $scope.description.dataSources;
	        $scope.defaultDataSourceName = findName($scope.dataSources, $scope.repository.defaultDataSourceId);
	        $scope.projects = $scope.description.projects;
	        $scope.defaultProjectName = findName($scope.projects, $scope.repository.defaultProjectId);
	        $scope.schemas = $scope.description.schemas;
	        $scope.defaultSchemaName = findName($scope.schemas, $scope.repository.defaultSchemaId);
	        $scope.lineage = $scope.description.lineage;
	        $scope.userPermissions = $scope.description.userPermissions;
	      } else if ($scope.repository) {
	        $scope.dataSources = $scope.repository.dataSources;
	        $scope.defaultDataSourceName = $scope.repository.defaultDataSourceName;
	        $scope.projects = $scope.repository.projects;
	        $scope.defaultProjectName = $scope.repository.defaultProjectName;
	        $scope.schemas = $scope.repository.schemas;
	        $scope.defaultSchemaName = $scope.repository.defaultSchemaName;
	      }
	    }]
	  };
	}).directive('magpieObjectUserPermissions', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      userPermissions: '='
	    },
	    templateUrl: 'components/magpie-display/structure/object-user-permissions.html'
	  };
	});

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _moment = __webpack_require__(18);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	angular.module('magpieFlow', ['ui.bootstrap', 'magpieLineage', 'magpieUtil']).directive('magpieJobDetails', function () {
	  return {
	    restrict: 'E',
	    scope: true,
	    templateUrl: 'components/magpie-display/flow/job-details.html',
	    controller: ["$scope", function controller($scope) {
	      $scope.tasks = $scope.tasks || [];
	      $scope.tasks.forEach(function (task) {
	        var predList = $scope.tasks.filter(function (t) {
	          return t.taskId === task.predecessor;
	        });
	
	        if (predList.length > 0) {
	          task.predecessorName = predList[0].name;
	        }
	
	        task.successorNames = task.successors.map(function (tId) {
	          var tList = $scope.tasks.filter(function (t) {
	            return t.taskId === tId;
	          });
	          return tList.length > 0 ? tList[0].name : null;
	        });
	      });
	
	      $scope.regularTasks = $scope.tasks.filter(function (t) {
	        return !t.isFinalizer;
	      });
	      $scope.finalizerTasks = $scope.tasks.filter(function (t) {
	        return t.isFinalizer;
	      });
	
	      var startTask = _.find($scope.tasks, function (t) {
	        return t.taskId === $scope.job.startTask;
	      });
	
	      if (startTask) {
	        $scope.startTask = startTask.name;
	      }
	    }]
	  };
	}).directive('magpieTask', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      description: '=?',
	      task: '=?'
	    },
	    templateUrl: 'components/magpie-display/flow/task.html',
	    controller: ["$scope", function controller($scope) {
	      if ($scope.description) {
	        $scope.task = $scope.description.task;
	        $scope.executionHistory = $scope.description.history;
	      }
	    }]
	  };
	}).directive('magpieTaskDetails', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      task: '=',
	      containsNestedJobGraph: '=?',
	      openNestedJob: '&?'
	    },
	    templateUrl: 'components/magpie-display/flow/task-details.html'
	  };
	}).directive('magpieJob', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      lineage: '=?',
	      job: '=?',
	      tasks: '=?',
	      schedules: '=?',
	      description: '@?',
	      userPermissions: '=?'
	    },
	    templateUrl: 'components/magpie-display/flow/job.html',
	    controller: ["$scope", function controller($scope) {
	      if ($scope.description) {
	        var description = JSON.parse($scope.description);
	
	        $scope.hasJobGraph = description.graph && description.graph.nodes && description.graph.nodes.length > 0;
	
	        if ($scope.hasJobGraph) {
	          $scope.jobGraph = JSON.stringify(description.graph);
	          $scope.active = 0;
	        }
	
	        $scope.job = description.job;
	        $scope.lineage = description.lineage;
	        $scope.executionHistory = description.history;
	        $scope.tasks = description.tasks;
	        $scope.schedules = description.schedules;
	        $scope.userPermissions = description.userPermissions;
	      }
	    }]
	  };
	}).directive('magpieJobGraph', ["$timeout", function ($timeout) {
	  return {
	    restrict: 'E',
	    scope: true,
	    templateUrl: 'components/magpie-display/flow/job-graph.html',
	    compile: function compile() {
	      return function linkFunction($scope, element) {
	        var DataSet = vis.DataSet; // eslint-disable-line no-undef
	        var Network = vis.Network; // eslint-disable-line no-undef
	
	        $scope.crumbs = [];
	
	        $scope.fitted = false;
	        $scope.stabilized = false;
	        $scope.currentNode = {};
	
	        $scope.jobGraph = JSON.parse($scope.jobGraph);
	        $scope.currentProject = '';
	        $scope.currentJob = '';
	
	        $scope.getJobExecutionData = function (projectName, jobName) {
	          var matchingNodes = $scope.jobGraph.nodes.filter(function (obj) {
	            return obj.projectName === projectName && obj.jobName === jobName;
	          });
	
	          var nodes = new DataSet(matchingNodes.map(function (obj) {
	            var node = {
	              id: obj.id,
	              label: obj.name
	            };
	
	            if (obj.task && obj.task.taskType) {
	              node.group = obj.task.taskType;
	            } else {
	              if (obj.objectType) {
	                node.group = obj.objectType;
	              } else {
	                node.group = obj.nodeType;
	              }
	            }
	            return node;
	          }));
	
	          var jobNode = matchingNodes.find(function (obj) {
	            return obj.nodeType === 'Job' || obj.objectType === 'Job';
	          });
	
	          var edges = new DataSet($scope.jobGraph.edges);
	          $scope.currentProject = projectName;
	          $scope.currentJob = jobName;
	          $scope.currentFinalizerTaskName = jobNode ? jobNode.finalizerTaskName : null;
	          console.log('[finalizer debug]', 'project:', projectName, 'job:', jobName, 'matchingNodes:', matchingNodes.length, 'jobNode:', jobNode, 'currentFinalizerTaskName:', $scope.currentFinalizerTaskName);
	          return { nodes: nodes, edges: edges };
	        };
	
	        var nodesById = _.indexBy($scope.jobGraph.nodes, 'id');
	
	        // create a network
	        var container = element.find('.network')[0];
	
	        // use rootNodeId to create initial job execution graph
	        var rootProject = $scope.jobGraph.rootNodeId.split('.')[0];
	        var rootJob = $scope.jobGraph.rootNodeId.split('.')[1];
	        var data = $scope.getJobExecutionData(rootProject, rootJob);
	
	        var options = {
	          edges: {
	            smooth: {
	              type: 'cubicBezier',
	              forceDirection: 'horizontal',
	              roundness: 0.4
	            },
	            arrows: {
	              to: true
	            },
	            arrowStrikethrough: false,
	            color: {
	              color: '#888',
	              opacity: 1.0
	            }
	          },
	          nodes: {
	            shape: 'box'
	          },
	          interaction: {
	            dragNodes: true,
	            dragView: true,
	            hideEdgesOnDrag: false,
	            hideNodesOnDrag: false,
	            hover: false,
	            keyboard: {
	              enabled: true,
	              bindToWindow: false
	            },
	            multiselect: false,
	            navigationButtons: true,
	            selectable: true,
	            selectConnectedEdges: false,
	            hoverConnectedEdges: false,
	            zoomView: false
	          },
	          layout: {
	            hierarchical: {
	              enabled: true,
	              sortMethod: 'directed',
	              levelSeparation: 230,
	              direction: 'LR'
	            }
	          },
	          autoResize: true,
	          height: '450px',
	          width: '100%',
	          groups: {
	            useDefaultGroups: true,
	            Job: {
	              shape: 'image',
	              image: '/assets/images/flow/job.svg'
	            },
	            Task: {
	              shape: 'image',
	              image: '/assets/images/flow/flow_code.svg'
	            },
	            Script: {
	              shape: 'image',
	              image: '/assets/images/flow/flow_code.svg'
	            },
	            NestedJob: {
	              shape: 'image',
	              image: '/assets/images/flow/nested_job.svg'
	            },
	            SqlMapper: {
	              shape: 'image',
	              image: '/assets/images/flow/sql.svg'
	            }
	          }
	        };
	
	        $timeout(function () {
	          var network = new Network(container, data, options);
	
	          var onClick = function onClick(args, open) {
	            $timeout(function () {
	              var id = args.nodes[0];
	              $scope.currentNode = nodesById[id];
	              if ($scope.currentNode.objectType) {
	                $scope.currentNode.nodeType = $scope.currentNode.objectType;
	              }
	              if ($scope.currentNode.task && $scope.currentNode.task.nestedJobReference) {
	                var nestedRef = $scope.currentNode.task.nestedJobReference;
	                var downStream = $scope.jobGraph.nodes.filter(function (obj) {
	                  return obj.projectName === nestedRef.projectName && obj.jobName === nestedRef.jobName && (obj.objectType === 'Job' || obj.nodeType === 'Job');
	                });
	                $scope.containsNestedJobGraph = downStream.length > 0;
	                if (open && $scope.containsNestedJobGraph) {
	                  $scope.openNewJob($scope.currentNode);
	                }
	              }
	            });
	          };
	
	          $scope.initNetwork = function (network) {
	            network.on('click', function (args) {
	              onClick(args);
	            });
	
	            network.on('doubleClick', function (args) {
	              onClick(args, true);
	            });
	
	            network.on('stabilizationIterationsDone', function () {
	              $timeout(function () {
	                $scope.network = network;
	                $scope.stabilized = true;
	                network.setOptions({
	                  physics: false
	                });
	              });
	            });
	
	            network.on('afterDrawing', function () {
	              if (!$scope.fitted) {
	                network.fit();
	                $scope.fitted = true;
	              }
	            });
	          };
	
	          $scope.initNetwork(network);
	
	          // use nested job reference to open nested job graph
	          $scope.openNewJob = function (node) {
	            var newData = $scope.getJobExecutionData(node.task.nestedJobReference.projectName, node.task.nestedJobReference.jobName);
	            var newNetwork = new Network(container, newData, options);
	            $scope.initNetwork(newNetwork);
	            $scope.currentNode = {};
	            $scope.crumbs.push({ 'projectName': node.projectName, 'jobName': node.jobName });
	          };
	
	          // open job graph from qualified job name in bread crumb
	          $scope.openJobFromCrumb = function (crumb) {
	            var newData = $scope.getJobExecutionData(crumb.projectName, crumb.jobName);
	            var newNetwork = new Network(container, newData, options);
	
	            var i = void 0;
	            var crumbIndex = 0;
	            for (i = 0; i < $scope.crumbs.length; i++) {
	              if ($scope.crumbs[i] === crumb) {
	                crumbIndex = i;
	              }
	            }
	            $scope.crumbs = $scope.crumbs.slice(0, crumbIndex);
	            $scope.currentNode = {};
	
	            $scope.initNetwork(newNetwork);
	          };
	        });
	      };
	    }
	  };
	}]).directive('magpieProject', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      lineage: '=?',
	      project: '=?',
	      description: '=?',
	      userPermissions: '=?'
	    },
	    templateUrl: 'components/magpie-display/flow/project.html',
	    controller: ["$scope", function controller($scope) {
	      if ($scope.description) {
	        $scope.project = $scope.description.project;
	        $scope.lineage = $scope.description.lineage;
	        $scope.jobs = $scope.description.jobs;
	        $scope.executionHistory = $scope.description.history;
	        $scope.userPermissions = $scope.description.userPermissions;
	      } else if ($scope.project) {
	        $scope.jobs = $scope.project.jobs;
	      }
	      $scope.sortedJobs = _.sortBy($scope.jobs, 'name');
	    }]
	  };
	}).directive('magpieJobScheduleDetails', function () {
	  return {
	    restrict: 'E',
	    scope: true,
	    templateUrl: 'components/magpie-display/flow/job-schedule-details.html',
	    controller: ["$scope", function controller($scope) {
	      if (!$scope.schedule) {
	        $scope.schedule = $scope.description.schedule;
	        $scope.user = $scope.description.user;
	      }
	    }]
	  };
	}).directive('magpieJobSchedule', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      schedule: '=?',
	      subscriptions: '=?',
	      description: '=?'
	    },
	    templateUrl: 'components/magpie-display/flow/job-schedule.html',
	    controller: ["$scope", function controller($scope) {
	      if ($scope.description) {
	        $scope.schedule = $scope.description.schedule;
	        $scope.user = $scope.description.user;
	        $scope.executionHistory = $scope.description.history;
	        $scope.subscriptions = $scope.description.subscriptions;
	      }
	    }]
	  };
	}).directive('magpieJobSchedules', function () {
	  return {
	    restrict: 'E',
	    scope: true,
	    templateUrl: 'components/magpie-display/flow/job-schedules.html'
	  };
	}).directive('magpieJobScheduleSubscription', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      subscription: '=?',
	      description: '=?'
	    },
	    templateUrl: 'components/magpie-display/flow/job-schedule-subscription.html',
	    controller: ["$scope", function controller($scope) {
	      if ($scope.description) {
	        $scope.subscription = $scope.description.subscription;
	      }
	    }]
	  };
	}).directive('magpieJobScheduleSubscriptionDetails', function () {
	  return {
	    restrict: 'E',
	    scope: true,
	    templateUrl: 'components/magpie-display/flow/job-schedule-subscription-details.html'
	  };
	}).directive('magpieJobScheduleSubscriptions', function () {
	  return {
	    restrict: 'E',
	    scope: true,
	    templateUrl: 'components/magpie-display/flow/job-schedule-subscriptions.html'
	  };
	}).directive('magpieJobMetrics', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      jobMetrics: '=',
	      isOpen: '=?'
	    },
	    templateUrl: 'components/magpie-display/flow/job-metrics.html'
	  };
	}).directive('magpieJobHistory', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      label: '@',
	      jobHistory: '=',
	      timestamp: '@?'
	    },
	    templateUrl: 'components/magpie-display/flow/job-history.html',
	    controller: ["$scope", function controller($scope) {
	      $scope.executionHistory = _.sortBy($scope.jobHistory, function (h) {
	        return -(0, _moment2.default)(h.startTime);
	      });
	    }]
	  };
	}).directive('magpieJobHistoryDetails', function () {
	  return {
	    restrict: 'E',
	    scope: true,
	    templateUrl: 'components/magpie-display/flow/job-history-details.html',
	    controller: ["$scope", function controller($scope) {
	      $scope.records = _.sortBy($scope.executionHistory, function (h) {
	        return -(0, _moment2.default)(h.startTime);
	      });
	    }]
	  };
	}).directive('magpieJobRunTaskSummary', function () {
	  return {
	    restrict: 'AE',
	    scope: {
	      run: '=',
	      logs: '=',
	      timestamp: '@?'
	    },
	    templateUrl: 'components/magpie-display/flow/job-run-task-summary.html',
	    controller: ["$scope", "$element", "$timeout", "$controller", function controller($scope, $element, $timeout, $controller) {
	      angular.extend(this, $controller('MagpieExpandableRowCtrl', {
	        $scope: $scope,
	        $element: $element,
	        $timeout: $timeout
	      }));
	
	      _.defaults($scope.jobRun, {
	        timestamp: (0, _moment2.default)($scope.timestamp)
	      });
	
	      $scope.taskLogs = _.filter($scope.logs, function (l) {
	        return l.taskRunId === $scope.run.taskRunId;
	      });
	    }]
	  };
	}).directive('magpieTaskHistory', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      label: '@',
	      taskHistory: '=',
	      timestamp: '@?'
	    },
	    templateUrl: 'components/magpie-display/flow/task-history.html',
	    controller: ["$scope", function controller($scope) {
	      $scope.executionHistory = _.sortBy($scope.taskHistory, function (h) {
	        return -(0, _moment2.default)(h.startTime);
	      });
	    }]
	  };
	}).directive('magpieTaskHistoryDetails', function () {
	  return {
	    restrict: 'E',
	    scope: true,
	    templateUrl: 'components/magpie-display/flow/task-history-details.html',
	    controller: ["$scope", function controller($scope) {
	      $scope.startTimeComparator = function (v1, v2) {
	        return (0, _moment2.default)(v1.value).diff((0, _moment2.default)(v2.value)) < 0 ? -1 : 1;
	      };
	    }]
	  };
	}).directive('magpieJobRun', function () {
	  return {
	    restrict: 'AE',
	    scope: {
	      jobRun: '=',
	      taskRuns: '=',
	      logs: '=',
	      timestamp: '='
	    },
	    templateUrl: 'components/magpie-display/flow/job-run.html',
	    controller: ["$scope", "$element", "$timeout", "$controller", function controller($scope, $element, $timeout, $controller) {
	      angular.extend(this, $controller('MagpieExpandableRowCtrl', {
	        $scope: $scope,
	        $element: $element,
	        $timeout: $timeout
	      }));
	
	      $scope.getDisplayStackTrace = function () {
	        var res = $scope.jobRun.result;
	        if (!res) {
	          return '';
	        }
	        if ($scope.expanded) {
	          if (res.stackTrace) {
	            return res.stackTrace;
	          } else if (res.message) {
	            return res.exceptionType + ': ' + res.message;
	          } else {
	            return res.exceptionType;
	          }
	        } else {
	          if (res.stackTrace) {
	            return res.stackTrace.substring(0, 100);
	          } else if (res.message) {
	            return (res.exceptionType + ': ' + res.message).substring(0, 100);
	          } else {
	            return res.exceptionType.substring(0, 100);
	          }
	        }
	      };
	
	      $scope.shouldShowExpand = function () {
	        return !$scope.expanded && $scope.jobRun.result && ($scope.jobRun.result.stackTrace && $scope.jobRun.result.stackTrace.length > 200 || $scope.jobRun.result.message && $scope.jobRun.result.message.length > 200);
	      };
	
	      $scope.expanded = false;
	      $scope.toggleExpand = function () {
	        $scope.expanded = !$scope.expanded;
	      };
	
	      _.defaults($scope.jobRun, {
	        timestamp: (0, _moment2.default)($scope.timestamp)
	      });
	    }]
	  };
	}).directive('magpieTaskRunSummary', function () {
	  return {
	    restrict: 'AE',
	    scope: {
	      run: '=',
	      timestamp: '='
	    },
	    templateUrl: 'components/magpie-display/flow/task-run-summary.html',
	    controller: ["$scope", function controller($scope) {
	      _.defaults($scope.run, {
	        timestamp: (0, _moment2.default)($scope.timestamp)
	      });
	    }]
	  };
	}).directive('magpieTaskRun', function () {
	  return {
	    restrict: 'AE',
	    scope: {
	      run: '=',
	      logs: '=',
	      timestamp: '='
	    },
	    templateUrl: 'components/magpie-display/flow/task-run.html',
	    controller: ["$scope", "$element", "$timeout", "$controller", function controller($scope, $element, $timeout, $controller) {
	      angular.extend(this, $controller('MagpieExpandableRowCtrl', {
	        $scope: $scope,
	        $element: $element,
	        $timeout: $timeout
	      }));
	
	      _.defaults($scope.run, {
	        timestamp: (0, _moment2.default)($scope.timestamp)
	      });
	    }]
	  };
	}).controller('MagpieJobLogCtrl', ["$scope", function ($scope) {
	  _.defaults($scope.log, {
	    eventTime: (0, _moment2.default)($scope.timestamp)
	  });
	
	  $scope.expanded = false;
	  $scope.exceptionExpanded = false;
	  $scope.toggleExpand = function (column) {
	    if (column === 'stackTrace') {
	      $scope.exceptionExpanded = !$scope.exceptionExpanded;
	    } else if (column === 'message') {
	      $scope.expanded = !$scope.expanded;
	    }
	  };
	
	  $scope.isCodeMessage = $scope.log.eventType === 'TaskExecutionLog' || $scope.log.eventType === 'TaskOutput';
	
	  // Helper for message display
	  $scope.getDisplayMessage = function () {
	    var msg = ($scope.log.message || '').trim();
	    if ($scope.expanded || msg.length <= 200) {
	      return $scope.$parent.$eval('log.message | unspaceCurlyBraces');
	    } else {
	      return $scope.$parent.$eval('log.message | unspaceCurlyBraces | limitTo: 100');
	    }
	  };
	
	  // Helper for exception details display
	  $scope.getDisplayException = function () {
	    var details = $scope.log.exceptionDetails;
	    if (!details) {
	      return '';
	    }
	    if ($scope.exceptionExpanded) {
	      if (details.stackTrace) {
	        return details.stackTrace;
	      } else if (details.message) {
	        return details.exceptionType + ': ' + details.message;
	      } else {
	        return details.exceptionType;
	      }
	    } else {
	      if (details.stackTrace) {
	        return details.stackTrace.substring(0, 100);
	      } else if (details.message) {
	        return (details.exceptionType + ': ' + details.message).substring(0, 100);
	      } else {
	        return details.exceptionType.substring(0, 100);
	      }
	    }
	  };
	
	  $scope.shouldHideFullException = function () {
	    return !$scope.exceptionExpanded && $scope.log.exceptionDetails && ($scope.log.exceptionDetails.stackTrace && $scope.log.exceptionDetails.stackTrace.length > 200 || $scope.log.exceptionDetails.message && $scope.log.exceptionDetails.message.length > 200);
	  };
	}]).directive('magpieTaskLog', function () {
	  return {
	    restrict: 'AE',
	    scope: {
	      log: '=',
	      timestamp: '='
	    },
	    templateUrl: 'components/magpie-display/flow/task-log.html',
	    controller: 'MagpieJobLogCtrl'
	  };
	}).directive('magpieJobLog', function () {
	  return {
	    restrict: 'AE',
	    scope: {
	      log: '=',
	      timestamp: '='
	    },
	    templateUrl: 'components/magpie-display/flow/job-log.html',
	    controller: 'MagpieJobLogCtrl'
	  };
	}).directive('magpieJobLogEventType', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      eventType: '='
	    },
	    templateUrl: 'components/magpie-display/flow/job-log-event-type.html',
	    controller: ["$scope", function controller($scope) {
	      function getType(state) {
	        switch (state) {
	          case 'JobFinish':
	          case 'TaskFinish':
	            return 'success';
	          case 'JobFailed':
	          case 'TaskFailed':
	          case 'MetadataError':
	          case 'ExecutionError':
	            return 'danger';
	          case 'JobStart':
	          case 'TaskStart':
	            return 'info';
	          default:
	            return 'default';
	        }
	      }
	
	      $scope.label = _.startCase($scope.eventType);
	      $scope.type = getType($scope.eventType);
	    }]
	  };
	});

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _moment = __webpack_require__(18);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	angular.module('magpieSecurity', ['ui.bootstrap', 'magpieUtil']).directive('magpieCustomer', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      customer: '=?',
	      description: '=?'
	    },
	    templateUrl: 'components/magpie-display/security/customer.html',
	    controller: ["$scope", function controller($scope) {
	      if ($scope.description) {
	        $scope.customer = $scope.description.customer;
	        $scope.organizations = $scope.description.organizations;
	      }
	    }]
	  };
	}).directive('magpieOrganization', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      organization: '=?',
	      description: '=?',
	      userPermissions: '=?'
	    },
	    templateUrl: 'components/magpie-display/security/organization.html',
	    controller: ["$scope", function controller($scope) {
	      if ($scope.description) {
	        $scope.organization = $scope.description.organization;
	        $scope.defaultRepository = $scope.description.defaultRepository;
	        $scope.permissions = $scope.description.permissions;
	        if ($scope.organization) {
	          $scope.clusterLimits = $scope.organization.clusterLimits;
	        }
	        $scope.userPermissions = $scope.description.userPermissions;
	      }
	    }]
	  };
	}).directive('magpieUser', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      user: '@?',
	      description: '@?'
	    },
	    templateUrl: 'components/magpie-display/security/user.html',
	    controller: ["$scope", function controller($scope) {
	      if ($scope.description) {
	        var description = JSON.parse($scope.description);
	        $scope.user = description.user;
	        $scope.roles = description.roles;
	        $scope.permissions = description.permissions;
	        $scope.inheritedPermissions = description.inheritedPermissions;
	      } else if ($scope.user) {
	        $scope.user = JSON.parse($scope.user);
	        $scope.roles = $scope.user.roles;
	        $scope.permissions = $scope.user.permissions;
	      }
	    }]
	  };
	}).directive('magpieRole', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      role: '=?',
	      permissions: '=?',
	      users: '=?',
	      description: '=?'
	    },
	    templateUrl: 'components/magpie-display/security/role.html',
	    controller: ["$scope", function controller($scope) {
	      if ($scope.description) {
	        $scope.role = $scope.description.role;
	        $scope.users = $scope.description.users;
	        $scope.permissions = $scope.description.permissions;
	      }
	    }]
	  };
	}).directive('magpiePermissions', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      permissions: '=',
	      inheritedPermissions: '=?'
	    },
	    templateUrl: 'components/magpie-display/security/permissions.html'
	  };
	}).directive('magpieActivityHistory', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      label: '@',
	      activityHistory: '=',
	      timestamp: '@?'
	    },
	    templateUrl: 'components/magpie-display/security/activity-history.html'
	  };
	}).directive('magpieActivityHistoryDetails', function () {
	  return {
	    restrict: 'E',
	    scope: true,
	    templateUrl: 'components/magpie-display/security/activity-history-details.html'
	  };
	}).directive('magpieActivityHistoryRecord', function () {
	  return {
	    restrict: 'AE',
	    scope: {
	      record: '=',
	      timestamp: '='
	    },
	    templateUrl: 'components/magpie-display/security/activity-history-record.html',
	    controller: ["$scope", "$element", "$timeout", "$controller", function controller($scope, $element, $timeout, $controller) {
	      angular.extend(this, $controller('MagpieExpandableRowCtrl', {
	        $scope: $scope,
	        $element: $element,
	        $timeout: $timeout
	      }));
	
	      _.defaults($scope.record, {
	        timestamp: (0, _moment2.default)($scope.timestamp)
	      });
	    }]
	  };
	}).directive('magpieUsageEvent', function () {
	  return {
	    restrict: 'AE',
	    scope: {
	      event: '='
	    },
	    templateUrl: 'components/magpie-display/security/usage-event.html',
	    controller: ["$scope", function controller($scope) {
	      $scope.getObjectType = function (event) {
	        switch (event.eventType) {
	          case 'Metadata':
	            return event.objectType;
	          default:
	            return event.eventType;
	        }
	      };
	
	      $scope.getPermissionType = function (event) {
	        switch (event.eventType) {
	          case 'GlobalRole':
	            return event.role;
	          case 'Result':
	            return 'Read';
	          default:
	            return event.permissionType;
	        }
	      };
	
	      $scope.getState = function (event) {
	        if (_.isUndefined(event.isSuccess) || event.isSuccess) {
	          return 'Succeeded';
	        } else {
	          return 'Failed';
	        }
	      };
	
	      $scope.getObjectReference = function (event) {
	        var names = [event.dataSourceName, event.schemaName, event.projectName, event.structureName, event.jobName];
	
	        return _.filter(names).join('.');
	      };
	    }]
	  };
	}).directive('magpieSecret', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      description: '=',
	      userPermissions: '=?'
	    },
	    templateUrl: 'components/magpie-display/security/secret.html',
	    controller: ["$scope", function controller($scope) {
	      $scope.secret = $scope.description.secret;
	      $scope.lineage = $scope.description.lineage;
	      $scope.userPermissions = $scope.description.userPermissions;
	    }]
	  };
	}).directive('magpieIdentityProvider', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      description: '=?',
	      organization: '=?'
	    },
	    templateUrl: 'components/magpie-display/security/identity-provider.html',
	    controller: ["$scope", function controller($scope) {
	      if ($scope.description) {
	        $scope.provider = $scope.description.provider;
	        $scope.organization = $scope.description.organization;
	      }
	    }]
	  };
	});

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _moment = __webpack_require__(18);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function populateProfileFields($scope, profile) {
	  $scope.tableName = profile.tableName;
	  $scope.query = profile.query;
	  $scope.rowCount = profile.rowCount;
	}
	
	angular.module('magpieProfiling', ['ui.bootstrap', 'magpieUtil']).directive('magpieSchemaProfile', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      profile: '@'
	    },
	    templateUrl: 'components/magpie-display/profiling/schema-profile.html',
	    controller: ["$scope", "$timeout", function controller($scope, $timeout) {
	      $scope.ready = false;
	      $timeout(function () {
	        var profile = JSON.parse($scope.profile);
	        $scope.schemaName = profile.schemaName;
	
	        if (profile.tableSummaries.length > 50) {
	          $timeout(function () {
	            $scope.ready = true;
	          }, 100);
	        } else {
	          $scope.ready = true;
	        }
	      });
	    }]
	  };
	}).directive('magpieSchemaProfileDetails', function () {
	  return {
	    restrict: 'E',
	    scope: true,
	    templateUrl: 'components/magpie-display/profiling/schema-profile-details.html',
	    controller: ["$scope", "$timeout", function controller($scope, $timeout) {
	      $timeout(function () {
	        $scope.profile = JSON.parse($scope.profile);
	        $scope.profileTimestamp = (0, _moment2.default)($scope.profile.createdAt).format('MMMM DD YYYY, h:mm:ss A');
	      });
	    }]
	  };
	}).directive('magpieDataSetProfile', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      profile: '@'
	    },
	    templateUrl: 'components/magpie-display/profiling/data-set-profile.html',
	    controller: ["$scope", "$timeout", function controller($scope, $timeout) {
	      $scope.ready = false;
	      $timeout(function () {
	        var profile = JSON.parse($scope.profile);
	        populateProfileFields($scope, profile);
	
	        if (profile.fieldProfiles.length > 50) {
	          $timeout(function () {
	            $scope.ready = true;
	          }, 100);
	        } else {
	          $scope.ready = true;
	        }
	      });
	    }]
	  };
	}).directive('magpieDataSetProfileDetails', function () {
	  return {
	    restrict: 'E',
	    scope: true,
	    templateUrl: 'components/magpie-display/profiling/data-set-profile-details.html',
	    controller: ["$scope", "$timeout", "$filter", "ngToast", function controller($scope, $timeout, $filter, ngToast) {
	      var fields = [{
	        'field': 'fieldName',
	        'display': 'Name',
	        'search': { text: undefined, operator: '=v' }
	      }, {
	        'field': 'inferredProfileType',
	        'display': 'Profile Type',
	        'search': {
	          text: undefined,
	          operator: '=v'
	        }
	      }, {
	        'field': 'nullCount',
	        'display': 'Null Values',
	        'search': { text: undefined, operator: '<%' }
	      }, {
	        'field': 'distinctValueCount',
	        'display': 'Distinct Values',
	        'search': { text: undefined, operator: '=v' }
	      }];
	
	      $timeout(function () {
	        $scope.fields = fields;
	
	        $scope.profile = JSON.parse($scope.profile);
	        $scope.fieldProfiles = $filter('filter')($scope.profile.fieldProfiles, $scope.searchText);
	        $scope.ascending = true;
	        $scope.sortField = 'fieldIndex';
	
	        $scope.profileTimestamp = (0, _moment2.default)($scope.profile.createdAt).format('MMMM DD YYYY, h:mm:ss A');
	      });
	
	      $scope.generate_sql = function () {
	        var filtered = handleFilter();
	        var sql = 'SELECT\n\t' + filtered.map(function (f) {
	          return f.fieldName;
	        }).join('\n\t, ') + '\nFROM\n\t' + $scope.profile.tableName;
	        navigator.clipboard.writeText(sql).then(function (r) {
	          return ngToast.create('Copied query to clipboard.');
	        });
	      };
	
	      var handleFilter = function handleFilter() {
	        return $filter('filter')($scope.profile.fieldProfiles, $scope.filter_expression);
	      };
	
	      $scope.handle_clear_filters = function () {
	        $scope.ascending = true;
	        $scope.sortField = 'fieldIndex';
	        $scope.fields.forEach(function (f) {
	          return f.search.text = undefined;
	        });
	      };
	
	      $scope.handleSortClick = function (field) {
	        $timeout(function () {
	          if (field === $scope.sortField) {
	            $scope.ascending = !$scope.ascending;
	          } else {
	            $scope.sortField = field;
	            $scope.ascending = true;
	          }
	        });
	      };
	
	      $scope.filter_expression = function (value, index, array) {
	        return compareText(value) && compareField('fieldName', value) && compareField('inferredProfileType', value) && compareField('nullCount', value) && compareField('distinctValueCount', value);
	      };
	
	      function compareText(value) {
	        if ($scope.searchText === undefined) {
	          return true;
	        }
	
	        if (Object.keys(value).length === 0) {
	          return false;
	        }
	
	        return Object.keys(value).map(function (key) {
	          if (_typeof(value[key]) === 'object') {
	            return compareText(value[key]);
	          } else {
	            return value[key].toString().toLowerCase().contains($scope.searchText.toLowerCase());
	          }
	        }).reduce(function (a, b) {
	          return a || b;
	        });
	      }
	
	      function compareField(fieldName, value) {
	        var field = $scope.fields.find(function (f) {
	          return f.field === fieldName;
	        });
	        var v = value[field.field];
	        if (field.search.operator.contains('%')) {
	          v = 100 * v / $scope.profile.rowCount;
	        }
	
	        if (field.search.text === undefined || field.search.text === null) {
	          return true;
	        } else if (typeof value[field.field] === 'number' && field.search.operator.contains('=')) {
	          return field.search.text === v;
	        } else if (typeof value[field.field] === 'number' && field.search.operator.contains('<')) {
	          return v < field.search.text;
	        } else if (typeof value[field.field] === 'number' && field.search.operator.contains('>')) {
	          return v > field.search.text;
	        } else {
	          return value[field.field].toString().toLowerCase().contains(field.search.text.toString().toLowerCase());
	        }
	      }
	    }]
	  };
	}).directive('magpieFieldProfile', function () {
	  return {
	    restrict: 'AE',
	    scope: {
	      profile: '<',
	      rowCount: '<'
	    },
	    templateUrl: 'components/magpie-display/profiling/field-profile.html',
	    controller: 'MagpieExpandableRowCtrl'
	  };
	}).directive('magpieTopValues', function () {
	  return {
	    restrict: 'E',
	    scope: true,
	    templateUrl: 'components/magpie-display/profiling/top-values.html',
	    controller: ["$scope", function controller($scope) {
	      var topValueCount = _($scope.profile.topValues).map('count').sum();
	
	      var data = _.map($scope.profile.topValues, function (v) {
	        return {
	          label: v.value,
	          value: v.count,
	          percent: v.count / $scope.rowCount
	        };
	      });
	
	      if ($scope.rowCount > topValueCount) {
	        var otherCount = $scope.rowCount - topValueCount - $scope.profile.nullCount;
	        if (otherCount > 0) {
	          data.push({
	            label: 'Other',
	            value: otherCount,
	            percent: otherCount / $scope.rowCount
	          });
	        }
	        if ($scope.profile.nullCount > 0) {
	          data.push({
	            label: 'Null',
	            value: $scope.profile.nullCount,
	            percent: $scope.profile.nullCount / $scope.rowCount
	          });
	        }
	      }
	
	      $scope.chartData = data;
	    }]
	  };
	}).directive('magpieNumericalFieldProfile', function () {
	  return {
	    restrict: 'E',
	    scope: true,
	    templateUrl: 'components/magpie-display/profiling/numerical-field-profile.html'
	  };
	}).directive('magpieDateFieldProfile', function () {
	  return {
	    restrict: 'E',
	    scope: true,
	    templateUrl: 'components/magpie-display/profiling/date-field-profile.html'
	  };
	}).directive('magpieTimestampFieldProfile', function () {
	  return {
	    restrict: 'E',
	    scope: true,
	    templateUrl: 'components/magpie-display/profiling/timestamp-field-profile.html'
	  };
	}).directive('magpieDayOfYearChart', function () {
	  return {
	    restrict: 'E',
	    scope: true,
	    templateUrl: 'components/magpie-display/profiling/time/day-of-year-chart.html',
	    controller: ["$scope", function controller($scope) {
	      // use a known leap year so we get February 29th
	      var byValue = _.indexBy($scope.profile.countByDayOfYear, 'value');
	      var m = _moment2.default.utc([2000]);
	      // convert the data to integer day of year (in a leap year)
	      var data = [];
	      for (var i = 1; i <= 366; i++) {
	        var value = m.dayOfYear(i).format('--MM-DD');
	        var record = byValue[value];
	        if (!_.isUndefined(record)) {
	          data.push({
	            value: i,
	            count: record.count
	          });
	        }
	      }
	
	      $scope.countByDayOfYear = data;
	
	      function formatDayOfYear(d, format) {
	        return _moment2.default.utc([2000]).dayOfYear(d).format(format);
	      }
	
	      $scope.formatter = function (d) {
	        return formatDayOfYear(d, 'D MMM');
	      };
	    }]
	  };
	}).directive('magpieYearChart', function () {
	  return {
	    restrict: 'E',
	    scope: true,
	    templateUrl: 'components/magpie-display/profiling/time/year-chart.html'
	  };
	}).directive('magpieMonthChart', function () {
	  return {
	    restrict: 'E',
	    scope: true,
	    templateUrl: 'components/magpie-display/profiling/time/month-chart.html',
	    controller: ["$scope", function controller($scope) {
	      function formatMonth(d, format) {
	        if (_.isNumber(d)) {
	          d -= 1;
	        }
	        return _moment2.default.utc(0).month(d).format(format);
	      }
	
	      $scope.shortFormatter = function (d) {
	        return formatMonth(d, 'MMM');
	      };
	      $scope.longFormatter = function (d) {
	        return formatMonth(d, 'MMMM');
	      };
	    }]
	  };
	}).directive('magpieDayOfMonthChart', function () {
	  return {
	    restrict: 'E',
	    scope: true,
	    templateUrl: 'components/magpie-display/profiling/time/day-of-month-chart.html'
	  };
	}).directive('magpieDayOfWeekChart', function () {
	  return {
	    restrict: 'E',
	    scope: true,
	    templateUrl: 'components/magpie-display/profiling/time/day-of-week-chart.html',
	    controller: ["$scope", function controller($scope) {
	      function formatDayOfWeek(d, format) {
	        return _moment2.default.utc(0).isoWeekday(d).format(format);
	      }
	
	      $scope.shortFormatter = function (d) {
	        return formatDayOfWeek(d, 'ddd');
	      };
	      $scope.longFormatter = function (d) {
	        return formatDayOfWeek(d, 'dddd');
	      };
	    }]
	  };
	}).directive('magpieHourOfDayChart', function () {
	  return {
	    restrict: 'E',
	    scope: true,
	    templateUrl: 'components/magpie-display/profiling/time/hour-of-day-chart.html'
	  };
	}).directive('magpieMinuteOfHourChart', function () {
	  return {
	    restrict: 'E',
	    scope: true,
	    templateUrl: 'components/magpie-display/profiling/time/minute-of-hour-chart.html'
	  };
	});

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _moment = __webpack_require__(18);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	angular.module('magpieLineage', ['ui.bootstrap', 'magpieUtil']).directive('magpieGenericLineage', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      lineage: '='
	    },
	    templateUrl: 'components/magpie-display/lineage/lineage.html'
	  };
	}).directive('magpieLineageActionDetails', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      lineageActions: '='
	    },
	    templateUrl: 'components/magpie-display/lineage/lineage-action-details.html'
	  };
	}).directive('magpieLineageActionRecord', function () {
	  return {
	    restrict: 'AE',
	    scope: {
	      record: '=',
	      timestamp: '='
	    },
	    templateUrl: 'components/magpie-display/lineage/lineage-action-record.html',
	    controller: ["$scope", "$element", "$timeout", "$controller", function controller($scope, $element, $timeout, $controller) {
	      angular.extend(this, $controller('MagpieExpandableRowCtrl', {
	        $scope: $scope,
	        $element: $element,
	        $timeout: $timeout
	      }));
	
	      _.defaults($scope.record, {
	        timestamp: (0, _moment2.default)($scope.timestamp)
	      });
	    }]
	  };
	});

/***/ }),
/* 272 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('magpieInference', ['ui.bootstrap', 'magpieUtil']).controller('MagpieTableRelationshipsCtrl', ["$scope", function ($scope) {
	  $scope.fieldRelationships = _(JSON.parse($scope.relationships)).map(function (tableRelationship) {
	    return tableRelationship.fieldRelationships.map(function (fieldRelationship) {
	      var fromFieldNames = [];
	      var toFieldNames = [];
	
	      var addFieldPair = function addFieldPair(pair) {
	        fromFieldNames.push(pair.fromFieldName);
	        toFieldNames.push(pair.toFieldName);
	      };
	
	      if (fieldRelationship.relationshipType === 'Simple') {
	        addFieldPair(fieldRelationship);
	      } else {
	        fieldRelationship.fieldPairs.forEach(addFieldPair);
	      }
	
	      return {
	        fromSchemaName: tableRelationship.fromSchemaName,
	        fromTableName: tableRelationship.fromTableName,
	        fromFieldNames: fromFieldNames,
	        fromCardinality: fieldRelationship.fromCardinality,
	        toSchemaName: tableRelationship.toSchemaName,
	        toTableName: tableRelationship.toTableName,
	        toFieldNames: toFieldNames,
	        toCardinality: fieldRelationship.toCardinality,
	        score: fieldRelationship.score
	      };
	    });
	  }).flatten().map(function (r) {
	    var organize = $scope.organizeRelationships && r.fromSchemaName === r.toSchemaName && ($scope.from === $scope.to || $scope.fromTableName === $scope.toTableName);
	
	    if (organize && (r.fromCardinality === 'Many' && r.toCardinality !== 'Many' || r.fromCardinality === 'ZeroOrOne' && r.toCardinality === 'One')) {
	      return {
	        fromSchemaName: r.toSchemaName,
	        fromTableName: r.toTableName,
	        fromFieldNames: r.toFieldNames,
	        fromCardinality: r.toCardinality,
	        toSchemaName: r.fromSchemaName,
	        toTableName: r.fromTableName,
	        toFieldNames: r.fromFieldNames,
	        toCardinality: r.fromCardinality,
	        score: r.score
	      };
	    } else {
	      return r;
	    }
	  }).map(function (r) {
	    if (r.fromCardinality && r.toCardinality) {
	      return _.assign({}, r, {
	        cardinality: _.startCase(r.fromCardinality) + ' to ' + _.startCase(r.toCardinality)
	      });
	    } else {
	      return r;
	    }
	  }).sortByOrder(['score', 'fromSchemaName', 'fromTableName', 'fromFieldNames', 'toSchemaName', 'toTableName', 'toFieldNames'], [false, true, true, true, true, true, true]).value();
	}]).directive('magpieTableRelationships', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      relationships: '@',
	      from: '@',
	      to: '@'
	    },
	    templateUrl: 'components/magpie-display/inference/table-relationships.html',
	    controller: ["$scope", function controller($scope) {
	      $scope.organizeRelationships = true;
	    }]
	  };
	}).directive('magpieTableRelationshipDetails', function () {
	  return {
	    restrict: 'E',
	    scope: true,
	    templateUrl: 'components/magpie-display/inference/table-relationship-details.html',
	    controller: 'MagpieTableRelationshipsCtrl'
	  };
	}).directive('magpieSingleTableRelationshipDetails', function () {
	  return {
	    restrict: 'E',
	    scope: true,
	    templateUrl: 'components/magpie-display/inference/single-table-relationship-details.html',
	    controller: 'MagpieTableRelationshipsCtrl'
	  };
	}).directive('magpieTableRelationshipScore', function () {
	  return {
	    restrict: 'E',
	    scope: true,
	    templateUrl: 'components/magpie-display/inference/table-relationship-score.html',
	    controller: ["$scope", function controller($scope) {
	      $scope.rating = function (score) {
	        if (score > 0.8) {
	          return 'success';
	        } else if (score > 0.65) {
	          return 'warning';
	        } else {
	          return 'danger';
	        }
	      };
	    }]
	  };
	});

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _moment = __webpack_require__(18);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	angular.module('magpieResults', ['ui.bootstrap', 'magpieUtil']).controller('MagpieExportedResultsCtrl', ["$scope", "$http", "baseUrlSrv", function ($scope, $http, baseUrlSrv) {
	  var defaultError = 'Error downloading exported result.';
	
	  $scope.loading = false;
	
	  $scope.canSendToMap = $scope.result.format === 'DelimitedText';
	
	  if (!$scope.canSendToMap) {
	    $scope.mapTooltip = 'Send to Map is only supported for CSV Files';
	  }
	
	  function requestFile(onSuccess) {
	    $scope.loading = true;
	
	    var url = baseUrlSrv.getRestApiBase() + '/magpie/result/' + $scope.result.resultId;
	
	    $http.head(url).then(function (response) {
	      onSuccess(url, response);
	      $scope.loading = false;
	    }, function () {
	      $http.get(url).then(function () {
	        // success, but HEAD had an error?
	        $scope.error = defaultError;
	      }, function (response) {
	        $scope.error = _.get(response, 'data.message', defaultError);
	      }).finally(function () {
	        $scope.loading = false;
	      });
	    });
	  }
	
	  function clickLink(url, download) {
	    angular.element('body').append('<a id="exportedResult"></a>');
	    var link = angular.element('body > a#exportedResult');
	    link.attr('href', url);
	    if (download) {
	      link.attr('download', download);
	    }
	    link.attr('target', '_blank');
	    link[0].click();
	    link.remove();
	  }
	
	  $scope.sendResultToMap = function () {
	    requestFile(function (url) {
	      return clickLink('map/#/' + encodeURIComponent(url));
	    });
	  };
	
	  $scope.downloadResult = function () {
	    requestFile(function (url, response) {
	      var fileSuffix = '';
	      if (!_.isUndefined($scope.result.createTimestamp)) {
	        var timestamp = _moment2.default.utc($scope.result.createTimestamp);
	        if (timestamp.isValid()) {
	          fileSuffix = '_' + timestamp.format('YYYYMMDD_HHmmss');
	        }
	      }
	
	      var contentType = response.headers('Content-Type');
	
	      var extension = void 0;
	      if (contentType && contentType.startsWith('text/csv')) {
	        extension = 'csv';
	      } else if (contentType && contentType.startsWith('application/json')) {
	        extension = 'json';
	      } else {
	        extension = 'txt';
	      }
	
	      clickLink(url, 'magpie_export' + fileSuffix + '.' + extension);
	    });
	  };
	}]).directive('magpieExportedResult', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      result: '='
	    },
	    templateUrl: 'components/magpie-display/results/exported-result.html',
	    controller: 'MagpieExportedResultsCtrl'
	  };
	});

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _moment = __webpack_require__(18);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	angular.module('magpieClusters', ['ui.bootstrap', 'magpieLineage', 'magpieUtil']).directive('magpieCluster', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      cluster: '=?',
	      state: '=?',
	      lineage: '=?',
	      history: '=?',
	      timestamp: '@?',
	      description: '=?',
	      schedules: '=?',
	      userPermissions: '=?'
	    },
	    templateUrl: 'components/magpie-display/clusters/cluster.html',
	    controller: ["$scope", function controller($scope) {
	      if ($scope.description) {
	        console.debug('Cluster description:', $scope.description);
	        $scope.cluster = $scope.description.cluster;
	        $scope.state = $scope.description.state;
	        $scope.subscriptions = $scope.description.subscriptions;
	        $scope.health = $scope.description.health;
	        $scope.schedules = $scope.description.schedules;
	        $scope.history = $scope.description.history;
	        $scope.files = $scope.description.files;
	        $scope.lineage = $scope.description.lineage;
	        $scope.hiveThriftServerPath = $scope.description.hiveThriftServerPath;
	        $scope.sparkUiAddress = $scope.description.sparkUiAddress;
	        $scope.userPermissions = $scope.description.userPermissions;
	      }
	    }]
	  };
	}).directive('magpieClusterDetails', function () {
	  return {
	    restrict: 'E',
	    scope: true,
	    templateUrl: 'components/magpie-display/clusters/cluster-details.html'
	  };
	}).directive('magpieClusterState', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      name: '@',
	      state: '='
	    },
	    templateUrl: 'components/magpie-display/clusters/cluster-state.html'
	  };
	}).directive('magpieClusterStateDetails', function () {
	  return {
	    restrict: 'E',
	    scope: true,
	    templateUrl: 'components/magpie-display/clusters/cluster-state-details.html'
	  };
	}).directive('magpieClusterHealthDetails', function () {
	  return {
	    restrict: 'E',
	    scope: true,
	    templateUrl: 'components/magpie-display/clusters/cluster-health-details.html',
	    controller: ["$scope", function controller($scope) {
	      if ($scope.health) {
	        $scope.instances = [$scope.health.driver].concat($scope.health.workers);
	      } else {
	        $scope.instances = [];
	      }
	    }]
	  };
	}).directive('magpieClusterInstances', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      instances: '='
	    },
	    templateUrl: 'components/magpie-display/clusters/cluster-instances.html'
	  };
	}).directive('magpieClusterHistory', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      label: '@',
	      history: '=',
	      timestamp: '@?'
	    },
	    templateUrl: 'components/magpie-display/clusters/cluster-history.html'
	  };
	}).directive('magpieClusterSubscription', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      description: '='
	    },
	    templateUrl: 'components/magpie-display/clusters/cluster-subscription.html',
	    controller: ["$scope", function controller($scope) {
	      $scope.subscription = $scope.description.subscription;
	    }]
	  };
	}).directive('magpieClusterSubscriptionDetails', function () {
	  return {
	    restrict: 'E',
	    scope: true,
	    templateUrl: 'components/magpie-display/clusters/cluster-subscription-details.html'
	  };
	}).directive('magpieClusterSubscriptions', function () {
	  return {
	    restrict: 'E',
	    scope: true,
	    templateUrl: 'components/magpie-display/clusters/cluster-subscriptions.html'
	  };
	}).directive('magpieClusterHistoryDetails', function () {
	  return {
	    restrict: 'E',
	    scope: true,
	    templateUrl: 'components/magpie-display/clusters/cluster-history-details.html',
	    controller: ["$scope", function controller($scope) {
	      $scope.records = _.sortBy($scope.history, function (h) {
	        return -(0, _moment2.default)(h.run.startTime);
	      });
	    }]
	  };
	}).directive('magpieClusterUsage', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      label: '@',
	      usage: '=',
	      timestamp: '@?'
	    },
	    templateUrl: 'components/magpie-display/clusters/cluster-usage.html'
	  };
	}).directive('magpieClusterRun', function () {
	  return {
	    restrict: 'AE',
	    scope: {
	      run: '=',
	      stages: '=',
	      logs: '=',
	      logLimit: '=?',
	      timestamp: '='
	    },
	    templateUrl: 'components/magpie-display/clusters/cluster-run.html',
	    controller: ["$scope", "$element", "$timeout", "$controller", function controller($scope, $element, $timeout, $controller) {
	      angular.extend(this, $controller('MagpieExpandableRowCtrl', {
	        $scope: $scope,
	        $element: $element,
	        $timeout: $timeout
	      }));
	
	      _.defaults($scope.run, {
	        timestamp: (0, _moment2.default)($scope.timestamp)
	      });
	    }]
	  };
	}).directive('magpieClusterRunStage', function () {
	  return {
	    restrict: 'AE',
	    scope: {
	      stage: '=',
	      timestamp: '='
	    },
	    templateUrl: 'components/magpie-display/clusters/cluster-run-stage.html',
	    controller: ["$scope", function controller($scope) {
	      _.defaults($scope.stage, {
	        timestamp: (0, _moment2.default)($scope.timestamp)
	      });
	    }]
	  };
	}).directive('magpieClusterScheduleDetails', function () {
	  return {
	    restrict: 'E',
	    scope: true,
	    templateUrl: 'components/magpie-display/clusters/cluster-schedule-details.html'
	  };
	}).directive('magpieClusterSchedule', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      schedule: '=?',
	      subscriptions: '=?',
	      description: '=?'
	    },
	    templateUrl: 'components/magpie-display/clusters/cluster-schedule.html',
	    controller: ["$scope", function controller($scope) {
	      if ($scope.description) {
	        $scope.schedule = $scope.description.schedule;
	        $scope.user = $scope.description.user;
	        $scope.subscriptions = $scope.description.subscriptions;
	        $scope.records = $scope.description.history;
	      }
	    }]
	  };
	}).directive('magpieClusterSchedules', function () {
	  return {
	    restrict: 'E',
	    scope: true,
	    templateUrl: 'components/magpie-display/clusters/cluster-schedules.html'
	  };
	}).directive('magpieClusterScheduleHistory', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      label: '@',
	      history: '=',
	      timestamp: '@?'
	    },
	    templateUrl: 'components/magpie-display/clusters/cluster-history.html'
	  };
	}).directive('magpieClusterLog', function () {
	  return {
	    restrict: 'AE',
	    scope: {
	      log: '=',
	      timestamp: '='
	    },
	    templateUrl: 'components/magpie-display/clusters/cluster-log.html',
	    controller: ["$scope", function controller($scope) {
	      $scope.startCase = function (v) {
	        return _.startCase(v);
	      };
	      $scope.isCodeMessage = $scope.log.eventType === 'BootstrapLog';
	    }]
	  };
	}).directive('magpieClusterLogEventType', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      eventType: '='
	    },
	    templateUrl: 'components/magpie-display/clusters/cluster-log-event-type.html',
	    controller: ["$scope", function controller($scope) {
	      function getType(state) {
	        if (state === 'StageStarted' || state === 'InstanceBootstrappingStarted') {
	          return 'default';
	        } else if (state.endsWith('Finished') || state.endsWith('Started') || state.endsWith('Stopped')) {
	          return 'success';
	        } else if (state.endsWith('Failed')) {
	          return 'danger';
	        } else {
	          return 'default';
	        }
	      }
	
	      $scope.label = _.startCase($scope.eventType);
	      $scope.type = getType($scope.eventType);
	    }]
	  };
	}).directive('magpieInstanceType', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      instanceType: '=?',
	      description: '=?'
	    },
	    templateUrl: 'components/magpie-display/clusters/instance-type.html',
	    controller: ["$scope", function controller($scope) {
	      if ($scope.description) {
	        $scope.instanceType = $scope.description.instanceType;
	      }
	    }]
	  };
	}).directive('magpieFileClusterAssociations', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      associations: '=',
	      nameLabel: '@',
	      nameField: '@'
	    },
	    templateUrl: 'components/magpie-display/clusters/file-cluster-associations.html',
	    controller: ["$scope", function controller($scope) {
	      $scope.actionLabel = function (action) {
	        return _.startCase(action);
	      };
	    }]
	  };
	}).directive('magpiePrivateKey', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      privateKey: '=?',
	      description: '=?',
	      lineage: '=?',
	      userPermissions: '=?'
	    },
	    templateUrl: 'components/magpie-display/clusters/private-key.html',
	    controller: ["$scope", function controller($scope) {
	      if ($scope.description) {
	        $scope.privateKey = $scope.description.privateKey;
	        $scope.lineage = $scope.description.lineage;
	        $scope.userPermissions = $scope.description.userPermissions;
	      }
	    }]
	  };
	});

/***/ }),
/* 275 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('magpieValidation', ['ui.bootstrap', 'magpieLineage', 'magpieUtil']).directive('magpieValidationSuite', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      lineage: '=?',
	      suite: '=?',
	      validators: '=?',
	      description: '@?',
	      userPermissions: '=?'
	    },
	    templateUrl: 'components/magpie-display/validation/validation-suite.html',
	    controller: ["$scope", function controller($scope) {
	      if ($scope.description) {
	        var description = JSON.parse($scope.description);
	
	        $scope.lineage = description.lineage;
	        $scope.suite = description.validationSuite;
	        $scope.validators = description.validators;
	        $scope.userPermissions = description.userPermissions;
	      }
	    }]
	  };
	}).directive('magpieValidationSuiteDetails', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      suite: '=',
	      validators: '='
	    },
	    templateUrl: 'components/magpie-display/validation/validation-suite-details.html'
	  };
	}).directive('magpieValidatorList', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      validators: '='
	    },
	    templateUrl: 'components/magpie-display/validation/validator-list.html'
	  };
	}).directive('magpieValidator', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      description: '=?',
	      validator: '=?'
	    },
	    templateUrl: 'components/magpie-display/validation/validator.html',
	    controller: ["$scope", function controller($scope) {
	      if ($scope.description) {
	        $scope.validator = $scope.description.validator;
	      }
	    }]
	  };
	}).directive('magpieValidatorDetails', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      validator: '='
	    },
	    templateUrl: 'components/magpie-display/validation/validator-details.html',
	    controller: ["$scope", function controller($scope) {
	      $scope.isNumber = function (v) {
	        return typeof v === 'number';
	      };
	    }]
	  };
	}).directive('magpieTableValidation', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      validation: '@?',
	      suiteRun: '=?',
	      validators: '=?',
	      validatorRuns: '=?'
	    },
	    templateUrl: 'components/magpie-display/validation/table-validation.html',
	    controller: ["$scope", function controller($scope) {
	      if ($scope.validation) {
	        var validation = JSON.parse($scope.validation);
	
	        $scope.validators = validation.validators || [];
	        $scope.suiteRun = validation;
	        $scope.validatorRuns = validation.validatorRuns || [];
	      }
	    }]
	  };
	}).directive('magpieSchemaValidation', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      validation: '@?',
	      validations: '=?'
	    },
	    templateUrl: 'components/magpie-display/validation/schema-validation.html',
	    controller: ["$scope", function controller($scope) {
	      if ($scope.validation) {
	        $scope.validations = JSON.parse($scope.validation);
	      }
	    }]
	  };
	}).directive('magpieValidatedTables', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      validations: '='
	    },
	    templateUrl: 'components/magpie-display/validation/validated-tables.html'
	  };
	}).directive('magpieValidatedTableRecord', function () {
	  return {
	    restrict: 'AE',
	    scope: {
	      validation: '=',
	      suiteRun: '=?',
	      validators: '=?',
	      validatorRuns: '=?'
	    },
	    templateUrl: 'components/magpie-display/validation/validated-table-record.html',
	    controller: ["$scope", "$element", "$timeout", "$controller", function controller($scope, $element, $timeout, $controller) {
	      angular.extend(this, $controller('MagpieExpandableRowCtrl', {
	        $scope: $scope,
	        $element: $element,
	        $timeout: $timeout
	      }));
	
	      $scope.validators = $scope.validation.validators || [];
	      $scope.suiteRun = $scope.validation;
	      $scope.validatorRuns = $scope.validation.validatorRuns || [];
	    }]
	  };
	}).directive('magpieValidationSuiteRun', function () {
	  return {
	    restrict: 'E',
	    scope: true,
	    templateUrl: 'components/magpie-display/validation/validation-suite-run.html'
	  };
	}).directive('magpieValidationSuiteRunDetails', function () {
	  return {
	    restrict: 'E',
	    scope: true,
	    templateUrl: 'components/magpie-display/validation/validation-suite-run-details.html'
	  };
	}).directive('magpieValidatorRun', function () {
	  return {
	    restrict: 'AE',
	    scope: {
	      run: '='
	    },
	    templateUrl: 'components/magpie-display/validation/validator-run.html',
	    controller: ["$scope", "$element", "$timeout", "$controller", function controller($scope, $element, $timeout, $controller) {
	      angular.extend(this, $controller('MagpieExpandableRowCtrl', {
	        $scope: $scope,
	        $element: $element,
	        $timeout: $timeout
	      }));
	
	      $scope.run.total = $scope.run.passedValidationRowCount + $scope.run.failedValidationRowCount + $scope.run.nullValidationRowCount;
	      $scope.run.passRatio = 100 * $scope.run.passedValidationRowCount / $scope.run.total;
	      $scope.run.failRatio = 100 * $scope.run.failedValidationRowCount / $scope.run.total;
	      $scope.run.nullRatio = 100 * $scope.run.nullValidationRowCount / $scope.run.total;
	    }]
	  };
	}).directive('magpieFieldSelector', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      fieldSelector: '='
	    },
	    templateUrl: 'components/magpie-display/validation/field-selector.html'
	  };
	});

/***/ }),
/* 276 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('magpieExportedDataSourceFile', ['ui.bootstrap', 'magpieUtil']).controller('MagpieExportedDatasourceFileCtrl', ["$scope", "$http", "baseUrlSrv", function ($scope, $http, baseUrlSrv) {
	  $scope.downloadResult = function () {
	    $http.post(baseUrlSrv.getRestApiBase() + '/magpie/file', $scope.result, { responseType: 'arraybuffer' }).then(function (response) {
	      return new Blob([new Uint8Array(response.data)], { type: 'application/octet-stream' });
	    }).then(function (blob) {
	      var url = window.URL.createObjectURL(blob);
	      angular.element('body').append('<a id="exportedResult"></a>');
	      var link = angular.element('body > a#exportedResult');
	      link.attr('href', url);
	
	      var fileName = $scope.result.file;
	
	      if (fileName.indexOf('/') >= 0) {
	        var fileNameArray = fileName.split('/');
	        fileName = fileNameArray[fileNameArray.length - 1];
	      }
	
	      link.attr('download', fileName);
	      link.attr('target', '_blank');
	      link[0].click();
	      link.remove();
	      window.URL.revokeObjectURL(url);
	    }).catch(function (error) {
	      $scope.error = error;
	    });
	  };
	}]).directive('magpieExportedDataSourceFile', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      result: '='
	    },
	    templateUrl: 'components/magpie-display/exports/exported-data-source-file.html',
	    controller: 'MagpieExportedDatasourceFileCtrl'
	  };
	});

/***/ }),
/* 277 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('magpieFileUpload', ['ui.bootstrap']).controller('MagpieFileUploadCtrl', ["$scope", "$http", "baseUrlSrv", function ($scope, $http, baseUrlSrv) {
	  var envelope = JSON.parse($scope.fileMetadata);
	  $scope.metadata = envelope.fileMetadata;
	
	  $scope.selectedFile = null;
	  $scope.uploading = false;
	  $scope.uploaded = false;
	  $scope.error = null;
	
	  $scope.onFileSelected = function (element) {
	    $scope.$apply(function () {
	      $scope.selectedFile = element.files[0] || null;
	      $scope.error = null;
	    });
	  };
	
	  $scope.upload = function () {
	    if (!$scope.selectedFile) {
	      return;
	    }
	
	    $scope.uploading = true;
	    $scope.error = null;
	
	    var reader = new FileReader();
	    reader.onload = function () {
	      var base64Content = btoa(new Uint8Array(reader.result).reduce(function (data, byte) {
	        return data + String.fromCharCode(byte);
	      }, ''));
	
	      var uploadPath = '/magpie/files/' + $scope.metadata.id;
	      $http.post(baseUrlSrv.getRestApiBase() + uploadPath, {
	        details: {
	          name: $scope.metadata.name,
	          extension: $scope.metadata.extension,
	          description: $scope.metadata.description || null,
	          mimeType: $scope.metadata.mimeType || null,
	          installedFileName: $scope.metadata.installedFileName || $scope.selectedFile.name
	        },
	        base64Content: base64Content
	      }).then(function () {
	        $scope.uploading = false;
	        $scope.uploaded = true;
	      }).catch(function (response) {
	        $scope.uploading = false;
	        $scope.error = _.get(response, 'data.message', 'Upload failed. Please try again.');
	      });
	    };
	    reader.onerror = function () {
	      $scope.$apply(function () {
	        $scope.uploading = false;
	        $scope.error = 'Failed to read the selected file.';
	      });
	    };
	    reader.readAsArrayBuffer($scope.selectedFile);
	  };
	}]).directive('magpieFileUpload', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      fileMetadata: '@'
	    },
	    templateUrl: 'components/magpie-display/file-upload/file-upload.html',
	    controller: 'MagpieFileUploadCtrl'
	  };
	});

/***/ }),
/* 278 */
/***/ (function(module, exports) {

	'use strict';
	
	ace.define('ace/mode/magpie_highlight_rules', function (require, exports) {
	  var oop = require('../lib/oop');
	  var TextHighlightRules = require('./text_highlight_rules').TextHighlightRules;
	
	  var MagpieHighlightRules = function MagpieHighlightRules() {
	    var syntax = ['create', 'describe', 'list', 'alter', 'add', 'drop', 'delete', 'remove', 'with', 'save', 'set', 'in', 'exists', 'from', 'use', 'between', 'about', 'help', 'copy', 'recursive', 'script', 'by', 'at'];
	
	    var flow = ['job', 'project', 'task', 'schedule', 'jobs', 'projects', 'tasks', 'schedules', 'metrics', 'history', 'predecessor', 'start', 'exec', 'execute', 'execution', 'cancel', 'state', 'none', 'notification', 'subscription', 'subscriptions'];
	
	    var profiling = ['profile'];
	
	    var inference = ['discover', 'relationships'];
	
	    var metadata = ['temp', 'temporary', 'repository', 'schema', 'table', 'stream', 'sink', 'field', 'data', 'source', 'secret', 'repositories', 'schemas', 'tables', 'streams', 'sinks', 'fields', 'sources', 'secrets', 'cascade', 'start', 'stop', 'variables', 'validation', 'suites', 'suite', 'validator', 'validators', 'private', 'keys'];
	
	    var runtime = ['result', 'show', 'blocking', 'cache', 'uncache', 'print', 'export', 'partition', 'partitions'];
	
	    var security = ['organization', 'user', 'organizations', 'users', 'password', 'reset', 'role', 'roles', 'grant', 'revoke', 'usage', 'activity', 'identity', 'provider', 'providers'];
	
	    var sql = ['sql', 'select', 'insert', 'update', 'delete', 'from', 'where', 'and', 'or', 'group', 'by', 'order', 'limit', 'offset', 'having', 'as', 'case', 'then', 'when', 'else', 'end', 'type', 'left', 'right', 'join', 'on', 'outer', 'desc', 'asc', 'union', 'table', 'primary', 'key', 'if', 'foreign', 'not', 'references', 'default', 'null', 'inner', 'cross', 'semi', 'anti', 'natural', 'database', 'using'];
	
	    var sources = ['file', 'files', 'path', 'url'];
	
	    var clusters = ['cluster', 'clusters', 'bootstrap', 'instance', 'instances', 'type', 'types', 'force', 'stopped', 'started'];
	
	    var keywords = _.union(syntax, flow, profiling, inference, metadata, runtime, security, sql, sources, clusters).join('|');
	
	    var builtinConstants = 'true|false';
	
	    var builtinFunctions = 'avg|count|first|last|max|min|sum|ucase|lcase|mid|len|round|rank|now|format|' + 'coalesce|ifnull|isnull|nvl|regexp_replace|convert|cast';
	
	    var dataTypes = 'int|numeric|decimal|date|varchar|char|bigint|float|double|bit|binary|text|set|timestamp|' + 'real|number|integer';
	
	    var keywordMapper = this.createKeywordMapper({
	      'support.function': builtinFunctions,
	      'keyword': keywords,
	      'constant.language': builtinConstants,
	      'storage.type': dataTypes
	    }, 'identifier', true);
	
	    this.$rules = {
	      'start': [{
	        token: 'comment',
	        regex: '//.*$'
	      }, {
	        token: 'comment',
	        start: '/\\*',
	        end: '\\*/'
	      }, {
	        token: 'string', // ' string
	        regex: '\'.*?\''
	      }, {
	        token: 'string', // " string
	        regex: '".*?"'
	      }, {
	        token: 'constant.numeric', // float
	        regex: '[+-]?\\d+(?:(?:\\.\\d*)?(?:[eE][+-]?\\d+)?)?\\b'
	      }, {
	        token: keywordMapper,
	        regex: '[a-zA-Z_$][a-zA-Z0-9_$]*\\b'
	      }, {
	        token: 'keyword.operator',
	        regex: '\\+|\\-|\\/|\\/\\/|%|<@>|@>|<@|&|\\^|~|<|>|<=|=>|==|!=|<>|=|\\*'
	      }, {
	        token: 'paren.lparen',
	        regex: '[\\({]'
	      }, {
	        token: 'paren.rparen',
	        regex: '[\\)}]'
	      }, {
	        token: 'text',
	        regex: '\\s+'
	      }],
	      'comment': [{
	        token: 'comment', // closing comment
	        regex: '.*?\\*\\/',
	        next: 'start'
	      }, {
	        token: 'comment', // comment spanning whole line
	        regex: '.+'
	      }]
	    };
	    this.normalizeRules();
	  };
	
	  oop.inherits(MagpieHighlightRules, TextHighlightRules);
	
	  exports.MagpieHighlightRules = MagpieHighlightRules;
	});
	
	ace.define('ace/mode/magpie', function (require, exports) {
	  var oop = require('../lib/oop');
	  var TextMode = require('./text').Mode;
	  var MagpieHighlightRules = require('./magpie_highlight_rules').MagpieHighlightRules;
	
	  var Mode = function Mode() {
	    this.HighlightRules = MagpieHighlightRules;
	  };
	
	  oop.inherits(Mode, TextMode);
	
	  (function () {
	    this.lineCommentStart = '//';
	
	    this.$id = 'ace/mode/magpie';
	  }).call(Mode.prototype);
	
	  exports.Mode = Mode;
	});

/***/ }),
/* 279 */
/***/ (function(module, exports) {

	'use strict';
	
	ace.define('ace/theme/magpie', ['require', 'exports', 'module', 'ace/lib/dom'], function (require, exports, module) {
	  exports.isDark = false;
	  exports.cssClass = 'ace-tomorrow';
	  exports.cssText = '.ace-tomorrow .ace_gutter {' + 'background: #f6f6f6;' + 'color: #929292' + '}' + '.ace-tomorrow .ace_print-margin {' + 'width: 1px;' + 'background: #f6f6f6' + '}' + '.ace-tomorrow {' + 'background-color: #FFFFFF;' + 'color: #4D4D4C' + '}' + '.ace-tomorrow .ace_cursor {' + 'color: #AEAFAD' + '}' + '.ace-tomorrow .ace_marker-layer .ace_selection {' + 'background: #D6D6D6' + '}' + '.ace-tomorrow.ace_multiselect .ace_selection.ace_start {' + 'box-shadow: 0 0 3px 0px #FFFFFF;' + 'border-radius: 2px' + '}' + '.ace-tomorrow .ace_marker-layer .ace_step {' + 'background: rgb(255, 255, 0)' + '}' + '.ace-tomorrow .ace_marker-layer .ace_bracket {' + 'margin: -1px 0 0 -1px;' + 'border: 1px solid #D1D1D1' + '}' + '.ace-tomorrow .ace_marker-layer .ace_active-line {' + 'background: #EFEFEF' + '}' + '.ace-tomorrow .ace_gutter-active-line {' + 'background-color : #dcdcdc' + '}' + '.ace-tomorrow .ace_marker-layer .ace_selected-word {' + 'border: 1px solid #D6D6D6' + '}' + '.ace-tomorrow .ace_invisible {' + 'color: #D1D1D1' + '}' + '.ace-tomorrow .ace_keyword,' + '.ace-tomorrow .ace_meta,' + '.ace-tomorrow .ace_storage,' + '.ace-tomorrow .ace_storage.ace_type,' + '.ace-tomorrow .ace_support.ace_type {' + 'color: #4271AE' + '}' + '.ace-tomorrow .ace_keyword.ace_operator {' + 'color: #3E999F' + '}' + '.ace-tomorrow .ace_constant.ace_character,' + '.ace-tomorrow .ace_constant.ace_language,' + '.ace-tomorrow .ace_constant.ace_numeric,' + '.ace-tomorrow .ace_keyword.ace_other.ace_unit,' + '.ace-tomorrow .ace_support.ace_constant,' + '.ace-tomorrow .ace_variable.ace_parameter {' + 'color: #F5871F' + '}' + '.ace-tomorrow .ace_constant.ace_other {' + 'color: #666969' + '}' + '.ace-tomorrow .ace_invalid {' + 'color: #FFFFFF;' + 'background-color: #C82829' + '}' + '.ace-tomorrow .ace_invalid.ace_deprecated {' + 'color: #FFFFFF;' + 'background-color: #8959A8' + '}' + '.ace-tomorrow .ace_fold {' + 'background-color: #4271AE;' + 'border-color: #4D4D4C' + '}' + '.ace-tomorrow .ace_entity.ace_name.ace_function,' + '.ace-tomorrow .ace_support.ace_function,' + '.ace-tomorrow .ace_variable {' + 'color: #8959A8' + '}' + '.ace-tomorrow .ace_support.ace_class,' + '.ace-tomorrow .ace_support.ace_type {' + 'color: #C99E00' + '}' + '.ace-tomorrow .ace_heading,' + '.ace-tomorrow .ace_markup.ace_heading,' + '.ace-tomorrow .ace_string {' + 'color: #718C00' + '}' + '.ace-tomorrow .ace_entity.ace_name.ace_tag,' + '.ace-tomorrow .ace_entity.ace_other.ace_attribute-name,' + '.ace-tomorrow .ace_meta.ace_tag,' + '.ace-tomorrow .ace_string.ace_regexp,' + '.ace-tomorrow .ace_variable {' + 'color: #C82829' + '}' + '.ace-tomorrow .ace_comment {' + 'color: #8E908C' + '}' + '.ace-tomorrow .ace_indent-guide {' + 'background: url(data:image/png;base64,' + 'iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAE0lEQVQImWP4////f4bdu3f/BwAlfgctduB85QAAAABJRU5ErkJggg==) ' + 'right repeat-y' + '}';
	
	  var dom = require('../lib/dom');
	  dom.importCssString(exports.cssText, exports.cssClass);
	});

/***/ })
/******/ ])));


// WEBPACK FOOTER //
// app.d50211df9bcd4948f062.js